// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/materialdesignicons-webfont.eot?v=5.9.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/materialdesignicons-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/materialdesignicons-webfont.woff2?v=5.9.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/materialdesignicons-webfont.woff?v=5.9.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/materialdesignicons-webfont.ttf?v=5.9.55", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/fa-brands-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/fa-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/fa-brands-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/fa-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/fa-brands-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/fa-regular-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/fa-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/fa-regular-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/fa-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/fa-regular-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/fa-solid-900.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/fa-solid-900.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/fa-solid-900.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/dripicons-v2.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/dripicons-v2.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/dripicons-v2.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/dripicons-v2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/remixicon.eot?t=1587359857360", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/remixicon.woff2?t=1587359857360", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/remixicon.woff?t=1587359857360", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/remixicon.ttf?t=1587359857360", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/remixicon.svg?t=1587359857360", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23252b3b%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23bdbcad%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28255, 172.5, 175%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%231cbb8c%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23ff3d60%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23ff3d60%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23662426%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ff9c9f%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../fonts/inter-light.woff2?v=3.13", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../fonts/inter-light.woff?v=3.13", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../fonts/inter-regular.woff2?v=3.13", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../fonts/inter-regular.woff?v=3.13", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../fonts/inter-medium.woff2?v=3.13", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../fonts/inter-medium.woff?v=3.13", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../fonts/inter-bold.woff2?v=3.13", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../fonts/inter-bold.woff?v=3.13", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../images/LoginPageVector.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("../images/comingsoon-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;600&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix&v=5.9.55" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#fontawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___, { hash: "#dripicons-v2" });
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___, { hash: "#remixicon" });
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Template Name: Nazox -  Admin & Dashboard Template
Author: Themesdesign
Version: 2.3.0
Contact: themesdesign.in@gmail.com
File: Icons Css File
*/
/* MaterialDesignIcons.com */
@font-face {
  font-family: "Material Design Icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
.mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.mdi-ab-testing::before {
  content: "\\f01c9";
}

.mdi-abacus::before {
  content: "\\f16e0";
}

.mdi-abjad-arabic::before {
  content: "\\f1328";
}

.mdi-abjad-hebrew::before {
  content: "\\f1329";
}

.mdi-abugida-devanagari::before {
  content: "\\f132a";
}

.mdi-abugida-thai::before {
  content: "\\f132b";
}

.mdi-access-point::before {
  content: "\\f0003";
}

.mdi-access-point-check::before {
  content: "\\f1538";
}

.mdi-access-point-minus::before {
  content: "\\f1539";
}

.mdi-access-point-network::before {
  content: "\\f0002";
}

.mdi-access-point-network-off::before {
  content: "\\f0be1";
}

.mdi-access-point-off::before {
  content: "\\f1511";
}

.mdi-access-point-plus::before {
  content: "\\f153a";
}

.mdi-access-point-remove::before {
  content: "\\f153b";
}

.mdi-account::before {
  content: "\\f0004";
}

.mdi-account-alert::before {
  content: "\\f0005";
}

.mdi-account-alert-outline::before {
  content: "\\f0b50";
}

.mdi-account-arrow-left::before {
  content: "\\f0b51";
}

.mdi-account-arrow-left-outline::before {
  content: "\\f0b52";
}

.mdi-account-arrow-right::before {
  content: "\\f0b53";
}

.mdi-account-arrow-right-outline::before {
  content: "\\f0b54";
}

.mdi-account-box::before {
  content: "\\f0006";
}

.mdi-account-box-multiple::before {
  content: "\\f0934";
}

.mdi-account-box-multiple-outline::before {
  content: "\\f100a";
}

.mdi-account-box-outline::before {
  content: "\\f0007";
}

.mdi-account-cancel::before {
  content: "\\f12df";
}

.mdi-account-cancel-outline::before {
  content: "\\f12e0";
}

.mdi-account-cash::before {
  content: "\\f1097";
}

.mdi-account-cash-outline::before {
  content: "\\f1098";
}

.mdi-account-check::before {
  content: "\\f0008";
}

.mdi-account-check-outline::before {
  content: "\\f0be2";
}

.mdi-account-child::before {
  content: "\\f0a89";
}

.mdi-account-child-circle::before {
  content: "\\f0a8a";
}

.mdi-account-child-outline::before {
  content: "\\f10c8";
}

.mdi-account-circle::before {
  content: "\\f0009";
}

.mdi-account-circle-outline::before {
  content: "\\f0b55";
}

.mdi-account-clock::before {
  content: "\\f0b56";
}

.mdi-account-clock-outline::before {
  content: "\\f0b57";
}

.mdi-account-cog::before {
  content: "\\f1370";
}

.mdi-account-cog-outline::before {
  content: "\\f1371";
}

.mdi-account-convert::before {
  content: "\\f000a";
}

.mdi-account-convert-outline::before {
  content: "\\f1301";
}

.mdi-account-cowboy-hat::before {
  content: "\\f0e9b";
}

.mdi-account-details::before {
  content: "\\f0631";
}

.mdi-account-details-outline::before {
  content: "\\f1372";
}

.mdi-account-edit::before {
  content: "\\f06bc";
}

.mdi-account-edit-outline::before {
  content: "\\f0ffb";
}

.mdi-account-group::before {
  content: "\\f0849";
}

.mdi-account-group-outline::before {
  content: "\\f0b58";
}

.mdi-account-hard-hat::before {
  content: "\\f05b5";
}

.mdi-account-heart::before {
  content: "\\f0899";
}

.mdi-account-heart-outline::before {
  content: "\\f0be3";
}

.mdi-account-key::before {
  content: "\\f000b";
}

.mdi-account-key-outline::before {
  content: "\\f0be4";
}

.mdi-account-lock::before {
  content: "\\f115e";
}

.mdi-account-lock-outline::before {
  content: "\\f115f";
}

.mdi-account-minus::before {
  content: "\\f000d";
}

.mdi-account-minus-outline::before {
  content: "\\f0aec";
}

.mdi-account-multiple::before {
  content: "\\f000e";
}

.mdi-account-multiple-check::before {
  content: "\\f08c5";
}

.mdi-account-multiple-check-outline::before {
  content: "\\f11fe";
}

.mdi-account-multiple-minus::before {
  content: "\\f05d3";
}

.mdi-account-multiple-minus-outline::before {
  content: "\\f0be5";
}

.mdi-account-multiple-outline::before {
  content: "\\f000f";
}

.mdi-account-multiple-plus::before {
  content: "\\f0010";
}

.mdi-account-multiple-plus-outline::before {
  content: "\\f0800";
}

.mdi-account-multiple-remove::before {
  content: "\\f120a";
}

.mdi-account-multiple-remove-outline::before {
  content: "\\f120b";
}

.mdi-account-music::before {
  content: "\\f0803";
}

.mdi-account-music-outline::before {
  content: "\\f0ce9";
}

.mdi-account-network::before {
  content: "\\f0011";
}

.mdi-account-network-outline::before {
  content: "\\f0be6";
}

.mdi-account-off::before {
  content: "\\f0012";
}

.mdi-account-off-outline::before {
  content: "\\f0be7";
}

.mdi-account-outline::before {
  content: "\\f0013";
}

.mdi-account-plus::before {
  content: "\\f0014";
}

.mdi-account-plus-outline::before {
  content: "\\f0801";
}

.mdi-account-question::before {
  content: "\\f0b59";
}

.mdi-account-question-outline::before {
  content: "\\f0b5a";
}

.mdi-account-reactivate::before {
  content: "\\f152b";
}

.mdi-account-reactivate-outline::before {
  content: "\\f152c";
}

.mdi-account-remove::before {
  content: "\\f0015";
}

.mdi-account-remove-outline::before {
  content: "\\f0aed";
}

.mdi-account-search::before {
  content: "\\f0016";
}

.mdi-account-search-outline::before {
  content: "\\f0935";
}

.mdi-account-settings::before {
  content: "\\f0630";
}

.mdi-account-settings-outline::before {
  content: "\\f10c9";
}

.mdi-account-star::before {
  content: "\\f0017";
}

.mdi-account-star-outline::before {
  content: "\\f0be8";
}

.mdi-account-supervisor::before {
  content: "\\f0a8b";
}

.mdi-account-supervisor-circle::before {
  content: "\\f0a8c";
}

.mdi-account-supervisor-circle-outline::before {
  content: "\\f14ec";
}

.mdi-account-supervisor-outline::before {
  content: "\\f112d";
}

.mdi-account-switch::before {
  content: "\\f0019";
}

.mdi-account-switch-outline::before {
  content: "\\f04cb";
}

.mdi-account-tie::before {
  content: "\\f0ce3";
}

.mdi-account-tie-outline::before {
  content: "\\f10ca";
}

.mdi-account-tie-voice::before {
  content: "\\f1308";
}

.mdi-account-tie-voice-off::before {
  content: "\\f130a";
}

.mdi-account-tie-voice-off-outline::before {
  content: "\\f130b";
}

.mdi-account-tie-voice-outline::before {
  content: "\\f1309";
}

.mdi-account-voice::before {
  content: "\\f05cb";
}

.mdi-adjust::before {
  content: "\\f001a";
}

.mdi-adobe::before {
  content: "\\f0936";
}

.mdi-adobe-acrobat::before {
  content: "\\f0f9d";
}

.mdi-air-conditioner::before {
  content: "\\f001b";
}

.mdi-air-filter::before {
  content: "\\f0d43";
}

.mdi-air-horn::before {
  content: "\\f0dac";
}

.mdi-air-humidifier::before {
  content: "\\f1099";
}

.mdi-air-humidifier-off::before {
  content: "\\f1466";
}

.mdi-air-purifier::before {
  content: "\\f0d44";
}

.mdi-airbag::before {
  content: "\\f0be9";
}

.mdi-airballoon::before {
  content: "\\f001c";
}

.mdi-airballoon-outline::before {
  content: "\\f100b";
}

.mdi-airplane::before {
  content: "\\f001d";
}

.mdi-airplane-landing::before {
  content: "\\f05d4";
}

.mdi-airplane-off::before {
  content: "\\f001e";
}

.mdi-airplane-takeoff::before {
  content: "\\f05d5";
}

.mdi-airport::before {
  content: "\\f084b";
}

.mdi-alarm::before {
  content: "\\f0020";
}

.mdi-alarm-bell::before {
  content: "\\f078e";
}

.mdi-alarm-check::before {
  content: "\\f0021";
}

.mdi-alarm-light::before {
  content: "\\f078f";
}

.mdi-alarm-light-off::before {
  content: "\\f171e";
}

.mdi-alarm-light-off-outline::before {
  content: "\\f171f";
}

.mdi-alarm-light-outline::before {
  content: "\\f0bea";
}

.mdi-alarm-multiple::before {
  content: "\\f0022";
}

.mdi-alarm-note::before {
  content: "\\f0e71";
}

.mdi-alarm-note-off::before {
  content: "\\f0e72";
}

.mdi-alarm-off::before {
  content: "\\f0023";
}

.mdi-alarm-panel::before {
  content: "\\f15c4";
}

.mdi-alarm-panel-outline::before {
  content: "\\f15c5";
}

.mdi-alarm-plus::before {
  content: "\\f0024";
}

.mdi-alarm-snooze::before {
  content: "\\f068e";
}

.mdi-album::before {
  content: "\\f0025";
}

.mdi-alert::before {
  content: "\\f0026";
}

.mdi-alert-box::before {
  content: "\\f0027";
}

.mdi-alert-box-outline::before {
  content: "\\f0ce4";
}

.mdi-alert-circle::before {
  content: "\\f0028";
}

.mdi-alert-circle-check::before {
  content: "\\f11ed";
}

.mdi-alert-circle-check-outline::before {
  content: "\\f11ee";
}

.mdi-alert-circle-outline::before {
  content: "\\f05d6";
}

.mdi-alert-decagram::before {
  content: "\\f06bd";
}

.mdi-alert-decagram-outline::before {
  content: "\\f0ce5";
}

.mdi-alert-minus::before {
  content: "\\f14bb";
}

.mdi-alert-minus-outline::before {
  content: "\\f14be";
}

.mdi-alert-octagon::before {
  content: "\\f0029";
}

.mdi-alert-octagon-outline::before {
  content: "\\f0ce6";
}

.mdi-alert-octagram::before {
  content: "\\f0767";
}

.mdi-alert-octagram-outline::before {
  content: "\\f0ce7";
}

.mdi-alert-outline::before {
  content: "\\f002a";
}

.mdi-alert-plus::before {
  content: "\\f14ba";
}

.mdi-alert-plus-outline::before {
  content: "\\f14bd";
}

.mdi-alert-remove::before {
  content: "\\f14bc";
}

.mdi-alert-remove-outline::before {
  content: "\\f14bf";
}

.mdi-alert-rhombus::before {
  content: "\\f11ce";
}

.mdi-alert-rhombus-outline::before {
  content: "\\f11cf";
}

.mdi-alien::before {
  content: "\\f089a";
}

.mdi-alien-outline::before {
  content: "\\f10cb";
}

.mdi-align-horizontal-center::before {
  content: "\\f11c3";
}

.mdi-align-horizontal-left::before {
  content: "\\f11c2";
}

.mdi-align-horizontal-right::before {
  content: "\\f11c4";
}

.mdi-align-vertical-bottom::before {
  content: "\\f11c5";
}

.mdi-align-vertical-center::before {
  content: "\\f11c6";
}

.mdi-align-vertical-top::before {
  content: "\\f11c7";
}

.mdi-all-inclusive::before {
  content: "\\f06be";
}

.mdi-allergy::before {
  content: "\\f1258";
}

.mdi-alpha::before {
  content: "\\f002b";
}

.mdi-alpha-a::before {
  content: "\\f0aee";
}

.mdi-alpha-a-box::before {
  content: "\\f0b08";
}

.mdi-alpha-a-box-outline::before {
  content: "\\f0beb";
}

.mdi-alpha-a-circle::before {
  content: "\\f0bec";
}

.mdi-alpha-a-circle-outline::before {
  content: "\\f0bed";
}

.mdi-alpha-b::before {
  content: "\\f0aef";
}

.mdi-alpha-b-box::before {
  content: "\\f0b09";
}

.mdi-alpha-b-box-outline::before {
  content: "\\f0bee";
}

.mdi-alpha-b-circle::before {
  content: "\\f0bef";
}

.mdi-alpha-b-circle-outline::before {
  content: "\\f0bf0";
}

.mdi-alpha-c::before {
  content: "\\f0af0";
}

.mdi-alpha-c-box::before {
  content: "\\f0b0a";
}

.mdi-alpha-c-box-outline::before {
  content: "\\f0bf1";
}

.mdi-alpha-c-circle::before {
  content: "\\f0bf2";
}

.mdi-alpha-c-circle-outline::before {
  content: "\\f0bf3";
}

.mdi-alpha-d::before {
  content: "\\f0af1";
}

.mdi-alpha-d-box::before {
  content: "\\f0b0b";
}

.mdi-alpha-d-box-outline::before {
  content: "\\f0bf4";
}

.mdi-alpha-d-circle::before {
  content: "\\f0bf5";
}

.mdi-alpha-d-circle-outline::before {
  content: "\\f0bf6";
}

.mdi-alpha-e::before {
  content: "\\f0af2";
}

.mdi-alpha-e-box::before {
  content: "\\f0b0c";
}

.mdi-alpha-e-box-outline::before {
  content: "\\f0bf7";
}

.mdi-alpha-e-circle::before {
  content: "\\f0bf8";
}

.mdi-alpha-e-circle-outline::before {
  content: "\\f0bf9";
}

.mdi-alpha-f::before {
  content: "\\f0af3";
}

.mdi-alpha-f-box::before {
  content: "\\f0b0d";
}

.mdi-alpha-f-box-outline::before {
  content: "\\f0bfa";
}

.mdi-alpha-f-circle::before {
  content: "\\f0bfb";
}

.mdi-alpha-f-circle-outline::before {
  content: "\\f0bfc";
}

.mdi-alpha-g::before {
  content: "\\f0af4";
}

.mdi-alpha-g-box::before {
  content: "\\f0b0e";
}

.mdi-alpha-g-box-outline::before {
  content: "\\f0bfd";
}

.mdi-alpha-g-circle::before {
  content: "\\f0bfe";
}

.mdi-alpha-g-circle-outline::before {
  content: "\\f0bff";
}

.mdi-alpha-h::before {
  content: "\\f0af5";
}

.mdi-alpha-h-box::before {
  content: "\\f0b0f";
}

.mdi-alpha-h-box-outline::before {
  content: "\\f0c00";
}

.mdi-alpha-h-circle::before {
  content: "\\f0c01";
}

.mdi-alpha-h-circle-outline::before {
  content: "\\f0c02";
}

.mdi-alpha-i::before {
  content: "\\f0af6";
}

.mdi-alpha-i-box::before {
  content: "\\f0b10";
}

.mdi-alpha-i-box-outline::before {
  content: "\\f0c03";
}

.mdi-alpha-i-circle::before {
  content: "\\f0c04";
}

.mdi-alpha-i-circle-outline::before {
  content: "\\f0c05";
}

.mdi-alpha-j::before {
  content: "\\f0af7";
}

.mdi-alpha-j-box::before {
  content: "\\f0b11";
}

.mdi-alpha-j-box-outline::before {
  content: "\\f0c06";
}

.mdi-alpha-j-circle::before {
  content: "\\f0c07";
}

.mdi-alpha-j-circle-outline::before {
  content: "\\f0c08";
}

.mdi-alpha-k::before {
  content: "\\f0af8";
}

.mdi-alpha-k-box::before {
  content: "\\f0b12";
}

.mdi-alpha-k-box-outline::before {
  content: "\\f0c09";
}

.mdi-alpha-k-circle::before {
  content: "\\f0c0a";
}

.mdi-alpha-k-circle-outline::before {
  content: "\\f0c0b";
}

.mdi-alpha-l::before {
  content: "\\f0af9";
}

.mdi-alpha-l-box::before {
  content: "\\f0b13";
}

.mdi-alpha-l-box-outline::before {
  content: "\\f0c0c";
}

.mdi-alpha-l-circle::before {
  content: "\\f0c0d";
}

.mdi-alpha-l-circle-outline::before {
  content: "\\f0c0e";
}

.mdi-alpha-m::before {
  content: "\\f0afa";
}

.mdi-alpha-m-box::before {
  content: "\\f0b14";
}

.mdi-alpha-m-box-outline::before {
  content: "\\f0c0f";
}

.mdi-alpha-m-circle::before {
  content: "\\f0c10";
}

.mdi-alpha-m-circle-outline::before {
  content: "\\f0c11";
}

.mdi-alpha-n::before {
  content: "\\f0afb";
}

.mdi-alpha-n-box::before {
  content: "\\f0b15";
}

.mdi-alpha-n-box-outline::before {
  content: "\\f0c12";
}

.mdi-alpha-n-circle::before {
  content: "\\f0c13";
}

.mdi-alpha-n-circle-outline::before {
  content: "\\f0c14";
}

.mdi-alpha-o::before {
  content: "\\f0afc";
}

.mdi-alpha-o-box::before {
  content: "\\f0b16";
}

.mdi-alpha-o-box-outline::before {
  content: "\\f0c15";
}

.mdi-alpha-o-circle::before {
  content: "\\f0c16";
}

.mdi-alpha-o-circle-outline::before {
  content: "\\f0c17";
}

.mdi-alpha-p::before {
  content: "\\f0afd";
}

.mdi-alpha-p-box::before {
  content: "\\f0b17";
}

.mdi-alpha-p-box-outline::before {
  content: "\\f0c18";
}

.mdi-alpha-p-circle::before {
  content: "\\f0c19";
}

.mdi-alpha-p-circle-outline::before {
  content: "\\f0c1a";
}

.mdi-alpha-q::before {
  content: "\\f0afe";
}

.mdi-alpha-q-box::before {
  content: "\\f0b18";
}

.mdi-alpha-q-box-outline::before {
  content: "\\f0c1b";
}

.mdi-alpha-q-circle::before {
  content: "\\f0c1c";
}

.mdi-alpha-q-circle-outline::before {
  content: "\\f0c1d";
}

.mdi-alpha-r::before {
  content: "\\f0aff";
}

.mdi-alpha-r-box::before {
  content: "\\f0b19";
}

.mdi-alpha-r-box-outline::before {
  content: "\\f0c1e";
}

.mdi-alpha-r-circle::before {
  content: "\\f0c1f";
}

.mdi-alpha-r-circle-outline::before {
  content: "\\f0c20";
}

.mdi-alpha-s::before {
  content: "\\f0b00";
}

.mdi-alpha-s-box::before {
  content: "\\f0b1a";
}

.mdi-alpha-s-box-outline::before {
  content: "\\f0c21";
}

.mdi-alpha-s-circle::before {
  content: "\\f0c22";
}

.mdi-alpha-s-circle-outline::before {
  content: "\\f0c23";
}

.mdi-alpha-t::before {
  content: "\\f0b01";
}

.mdi-alpha-t-box::before {
  content: "\\f0b1b";
}

.mdi-alpha-t-box-outline::before {
  content: "\\f0c24";
}

.mdi-alpha-t-circle::before {
  content: "\\f0c25";
}

.mdi-alpha-t-circle-outline::before {
  content: "\\f0c26";
}

.mdi-alpha-u::before {
  content: "\\f0b02";
}

.mdi-alpha-u-box::before {
  content: "\\f0b1c";
}

.mdi-alpha-u-box-outline::before {
  content: "\\f0c27";
}

.mdi-alpha-u-circle::before {
  content: "\\f0c28";
}

.mdi-alpha-u-circle-outline::before {
  content: "\\f0c29";
}

.mdi-alpha-v::before {
  content: "\\f0b03";
}

.mdi-alpha-v-box::before {
  content: "\\f0b1d";
}

.mdi-alpha-v-box-outline::before {
  content: "\\f0c2a";
}

.mdi-alpha-v-circle::before {
  content: "\\f0c2b";
}

.mdi-alpha-v-circle-outline::before {
  content: "\\f0c2c";
}

.mdi-alpha-w::before {
  content: "\\f0b04";
}

.mdi-alpha-w-box::before {
  content: "\\f0b1e";
}

.mdi-alpha-w-box-outline::before {
  content: "\\f0c2d";
}

.mdi-alpha-w-circle::before {
  content: "\\f0c2e";
}

.mdi-alpha-w-circle-outline::before {
  content: "\\f0c2f";
}

.mdi-alpha-x::before {
  content: "\\f0b05";
}

.mdi-alpha-x-box::before {
  content: "\\f0b1f";
}

.mdi-alpha-x-box-outline::before {
  content: "\\f0c30";
}

.mdi-alpha-x-circle::before {
  content: "\\f0c31";
}

.mdi-alpha-x-circle-outline::before {
  content: "\\f0c32";
}

.mdi-alpha-y::before {
  content: "\\f0b06";
}

.mdi-alpha-y-box::before {
  content: "\\f0b20";
}

.mdi-alpha-y-box-outline::before {
  content: "\\f0c33";
}

.mdi-alpha-y-circle::before {
  content: "\\f0c34";
}

.mdi-alpha-y-circle-outline::before {
  content: "\\f0c35";
}

.mdi-alpha-z::before {
  content: "\\f0b07";
}

.mdi-alpha-z-box::before {
  content: "\\f0b21";
}

.mdi-alpha-z-box-outline::before {
  content: "\\f0c36";
}

.mdi-alpha-z-circle::before {
  content: "\\f0c37";
}

.mdi-alpha-z-circle-outline::before {
  content: "\\f0c38";
}

.mdi-alphabet-aurebesh::before {
  content: "\\f132c";
}

.mdi-alphabet-cyrillic::before {
  content: "\\f132d";
}

.mdi-alphabet-greek::before {
  content: "\\f132e";
}

.mdi-alphabet-latin::before {
  content: "\\f132f";
}

.mdi-alphabet-piqad::before {
  content: "\\f1330";
}

.mdi-alphabet-tengwar::before {
  content: "\\f1337";
}

.mdi-alphabetical::before {
  content: "\\f002c";
}

.mdi-alphabetical-off::before {
  content: "\\f100c";
}

.mdi-alphabetical-variant::before {
  content: "\\f100d";
}

.mdi-alphabetical-variant-off::before {
  content: "\\f100e";
}

.mdi-altimeter::before {
  content: "\\f05d7";
}

.mdi-amazon::before {
  content: "\\f002d";
}

.mdi-amazon-alexa::before {
  content: "\\f08c6";
}

.mdi-ambulance::before {
  content: "\\f002f";
}

.mdi-ammunition::before {
  content: "\\f0ce8";
}

.mdi-ampersand::before {
  content: "\\f0a8d";
}

.mdi-amplifier::before {
  content: "\\f0030";
}

.mdi-amplifier-off::before {
  content: "\\f11b5";
}

.mdi-anchor::before {
  content: "\\f0031";
}

.mdi-android::before {
  content: "\\f0032";
}

.mdi-android-auto::before {
  content: "\\f0a8e";
}

.mdi-android-debug-bridge::before {
  content: "\\f0033";
}

.mdi-android-messages::before {
  content: "\\f0d45";
}

.mdi-android-studio::before {
  content: "\\f0034";
}

.mdi-angle-acute::before {
  content: "\\f0937";
}

.mdi-angle-obtuse::before {
  content: "\\f0938";
}

.mdi-angle-right::before {
  content: "\\f0939";
}

.mdi-angular::before {
  content: "\\f06b2";
}

.mdi-angularjs::before {
  content: "\\f06bf";
}

.mdi-animation::before {
  content: "\\f05d8";
}

.mdi-animation-outline::before {
  content: "\\f0a8f";
}

.mdi-animation-play::before {
  content: "\\f093a";
}

.mdi-animation-play-outline::before {
  content: "\\f0a90";
}

.mdi-ansible::before {
  content: "\\f109a";
}

.mdi-antenna::before {
  content: "\\f1119";
}

.mdi-anvil::before {
  content: "\\f089b";
}

.mdi-apache-kafka::before {
  content: "\\f100f";
}

.mdi-api::before {
  content: "\\f109b";
}

.mdi-api-off::before {
  content: "\\f1257";
}

.mdi-apple::before {
  content: "\\f0035";
}

.mdi-apple-airplay::before {
  content: "\\f001f";
}

.mdi-apple-finder::before {
  content: "\\f0036";
}

.mdi-apple-icloud::before {
  content: "\\f0038";
}

.mdi-apple-ios::before {
  content: "\\f0037";
}

.mdi-apple-keyboard-caps::before {
  content: "\\f0632";
}

.mdi-apple-keyboard-command::before {
  content: "\\f0633";
}

.mdi-apple-keyboard-control::before {
  content: "\\f0634";
}

.mdi-apple-keyboard-option::before {
  content: "\\f0635";
}

.mdi-apple-keyboard-shift::before {
  content: "\\f0636";
}

.mdi-apple-safari::before {
  content: "\\f0039";
}

.mdi-application::before {
  content: "\\f0614";
}

.mdi-application-cog::before {
  content: "\\f1577";
}

.mdi-application-export::before {
  content: "\\f0dad";
}

.mdi-application-import::before {
  content: "\\f0dae";
}

.mdi-application-settings::before {
  content: "\\f1555";
}

.mdi-approximately-equal::before {
  content: "\\f0f9e";
}

.mdi-approximately-equal-box::before {
  content: "\\f0f9f";
}

.mdi-apps::before {
  content: "\\f003b";
}

.mdi-apps-box::before {
  content: "\\f0d46";
}

.mdi-arch::before {
  content: "\\f08c7";
}

.mdi-archive::before {
  content: "\\f003c";
}

.mdi-archive-alert::before {
  content: "\\f14fd";
}

.mdi-archive-alert-outline::before {
  content: "\\f14fe";
}

.mdi-archive-arrow-down::before {
  content: "\\f1259";
}

.mdi-archive-arrow-down-outline::before {
  content: "\\f125a";
}

.mdi-archive-arrow-up::before {
  content: "\\f125b";
}

.mdi-archive-arrow-up-outline::before {
  content: "\\f125c";
}

.mdi-archive-outline::before {
  content: "\\f120e";
}

.mdi-arm-flex::before {
  content: "\\f0fd7";
}

.mdi-arm-flex-outline::before {
  content: "\\f0fd6";
}

.mdi-arrange-bring-forward::before {
  content: "\\f003d";
}

.mdi-arrange-bring-to-front::before {
  content: "\\f003e";
}

.mdi-arrange-send-backward::before {
  content: "\\f003f";
}

.mdi-arrange-send-to-back::before {
  content: "\\f0040";
}

.mdi-arrow-all::before {
  content: "\\f0041";
}

.mdi-arrow-bottom-left::before {
  content: "\\f0042";
}

.mdi-arrow-bottom-left-bold-outline::before {
  content: "\\f09b7";
}

.mdi-arrow-bottom-left-thick::before {
  content: "\\f09b8";
}

.mdi-arrow-bottom-left-thin-circle-outline::before {
  content: "\\f1596";
}

.mdi-arrow-bottom-right::before {
  content: "\\f0043";
}

.mdi-arrow-bottom-right-bold-outline::before {
  content: "\\f09b9";
}

.mdi-arrow-bottom-right-thick::before {
  content: "\\f09ba";
}

.mdi-arrow-bottom-right-thin-circle-outline::before {
  content: "\\f1595";
}

.mdi-arrow-collapse::before {
  content: "\\f0615";
}

.mdi-arrow-collapse-all::before {
  content: "\\f0044";
}

.mdi-arrow-collapse-down::before {
  content: "\\f0792";
}

.mdi-arrow-collapse-horizontal::before {
  content: "\\f084c";
}

.mdi-arrow-collapse-left::before {
  content: "\\f0793";
}

.mdi-arrow-collapse-right::before {
  content: "\\f0794";
}

.mdi-arrow-collapse-up::before {
  content: "\\f0795";
}

.mdi-arrow-collapse-vertical::before {
  content: "\\f084d";
}

.mdi-arrow-decision::before {
  content: "\\f09bb";
}

.mdi-arrow-decision-auto::before {
  content: "\\f09bc";
}

.mdi-arrow-decision-auto-outline::before {
  content: "\\f09bd";
}

.mdi-arrow-decision-outline::before {
  content: "\\f09be";
}

.mdi-arrow-down::before {
  content: "\\f0045";
}

.mdi-arrow-down-bold::before {
  content: "\\f072e";
}

.mdi-arrow-down-bold-box::before {
  content: "\\f072f";
}

.mdi-arrow-down-bold-box-outline::before {
  content: "\\f0730";
}

.mdi-arrow-down-bold-circle::before {
  content: "\\f0047";
}

.mdi-arrow-down-bold-circle-outline::before {
  content: "\\f0048";
}

.mdi-arrow-down-bold-hexagon-outline::before {
  content: "\\f0049";
}

.mdi-arrow-down-bold-outline::before {
  content: "\\f09bf";
}

.mdi-arrow-down-box::before {
  content: "\\f06c0";
}

.mdi-arrow-down-circle::before {
  content: "\\f0cdb";
}

.mdi-arrow-down-circle-outline::before {
  content: "\\f0cdc";
}

.mdi-arrow-down-drop-circle::before {
  content: "\\f004a";
}

.mdi-arrow-down-drop-circle-outline::before {
  content: "\\f004b";
}

.mdi-arrow-down-thick::before {
  content: "\\f0046";
}

.mdi-arrow-down-thin-circle-outline::before {
  content: "\\f1599";
}

.mdi-arrow-expand::before {
  content: "\\f0616";
}

.mdi-arrow-expand-all::before {
  content: "\\f004c";
}

.mdi-arrow-expand-down::before {
  content: "\\f0796";
}

.mdi-arrow-expand-horizontal::before {
  content: "\\f084e";
}

.mdi-arrow-expand-left::before {
  content: "\\f0797";
}

.mdi-arrow-expand-right::before {
  content: "\\f0798";
}

.mdi-arrow-expand-up::before {
  content: "\\f0799";
}

.mdi-arrow-expand-vertical::before {
  content: "\\f084f";
}

.mdi-arrow-horizontal-lock::before {
  content: "\\f115b";
}

.mdi-arrow-left::before {
  content: "\\f004d";
}

.mdi-arrow-left-bold::before {
  content: "\\f0731";
}

.mdi-arrow-left-bold-box::before {
  content: "\\f0732";
}

.mdi-arrow-left-bold-box-outline::before {
  content: "\\f0733";
}

.mdi-arrow-left-bold-circle::before {
  content: "\\f004f";
}

.mdi-arrow-left-bold-circle-outline::before {
  content: "\\f0050";
}

.mdi-arrow-left-bold-hexagon-outline::before {
  content: "\\f0051";
}

.mdi-arrow-left-bold-outline::before {
  content: "\\f09c0";
}

.mdi-arrow-left-box::before {
  content: "\\f06c1";
}

.mdi-arrow-left-circle::before {
  content: "\\f0cdd";
}

.mdi-arrow-left-circle-outline::before {
  content: "\\f0cde";
}

.mdi-arrow-left-drop-circle::before {
  content: "\\f0052";
}

.mdi-arrow-left-drop-circle-outline::before {
  content: "\\f0053";
}

.mdi-arrow-left-right::before {
  content: "\\f0e73";
}

.mdi-arrow-left-right-bold::before {
  content: "\\f0e74";
}

.mdi-arrow-left-right-bold-outline::before {
  content: "\\f09c1";
}

.mdi-arrow-left-thick::before {
  content: "\\f004e";
}

.mdi-arrow-left-thin-circle-outline::before {
  content: "\\f159a";
}

.mdi-arrow-right::before {
  content: "\\f0054";
}

.mdi-arrow-right-bold::before {
  content: "\\f0734";
}

.mdi-arrow-right-bold-box::before {
  content: "\\f0735";
}

.mdi-arrow-right-bold-box-outline::before {
  content: "\\f0736";
}

.mdi-arrow-right-bold-circle::before {
  content: "\\f0056";
}

.mdi-arrow-right-bold-circle-outline::before {
  content: "\\f0057";
}

.mdi-arrow-right-bold-hexagon-outline::before {
  content: "\\f0058";
}

.mdi-arrow-right-bold-outline::before {
  content: "\\f09c2";
}

.mdi-arrow-right-box::before {
  content: "\\f06c2";
}

.mdi-arrow-right-circle::before {
  content: "\\f0cdf";
}

.mdi-arrow-right-circle-outline::before {
  content: "\\f0ce0";
}

.mdi-arrow-right-drop-circle::before {
  content: "\\f0059";
}

.mdi-arrow-right-drop-circle-outline::before {
  content: "\\f005a";
}

.mdi-arrow-right-thick::before {
  content: "\\f0055";
}

.mdi-arrow-right-thin-circle-outline::before {
  content: "\\f1598";
}

.mdi-arrow-split-horizontal::before {
  content: "\\f093b";
}

.mdi-arrow-split-vertical::before {
  content: "\\f093c";
}

.mdi-arrow-top-left::before {
  content: "\\f005b";
}

.mdi-arrow-top-left-bold-outline::before {
  content: "\\f09c3";
}

.mdi-arrow-top-left-bottom-right::before {
  content: "\\f0e75";
}

.mdi-arrow-top-left-bottom-right-bold::before {
  content: "\\f0e76";
}

.mdi-arrow-top-left-thick::before {
  content: "\\f09c4";
}

.mdi-arrow-top-left-thin-circle-outline::before {
  content: "\\f1593";
}

.mdi-arrow-top-right::before {
  content: "\\f005c";
}

.mdi-arrow-top-right-bold-outline::before {
  content: "\\f09c5";
}

.mdi-arrow-top-right-bottom-left::before {
  content: "\\f0e77";
}

.mdi-arrow-top-right-bottom-left-bold::before {
  content: "\\f0e78";
}

.mdi-arrow-top-right-thick::before {
  content: "\\f09c6";
}

.mdi-arrow-top-right-thin-circle-outline::before {
  content: "\\f1594";
}

.mdi-arrow-up::before {
  content: "\\f005d";
}

.mdi-arrow-up-bold::before {
  content: "\\f0737";
}

.mdi-arrow-up-bold-box::before {
  content: "\\f0738";
}

.mdi-arrow-up-bold-box-outline::before {
  content: "\\f0739";
}

.mdi-arrow-up-bold-circle::before {
  content: "\\f005f";
}

.mdi-arrow-up-bold-circle-outline::before {
  content: "\\f0060";
}

.mdi-arrow-up-bold-hexagon-outline::before {
  content: "\\f0061";
}

.mdi-arrow-up-bold-outline::before {
  content: "\\f09c7";
}

.mdi-arrow-up-box::before {
  content: "\\f06c3";
}

.mdi-arrow-up-circle::before {
  content: "\\f0ce1";
}

.mdi-arrow-up-circle-outline::before {
  content: "\\f0ce2";
}

.mdi-arrow-up-down::before {
  content: "\\f0e79";
}

.mdi-arrow-up-down-bold::before {
  content: "\\f0e7a";
}

.mdi-arrow-up-down-bold-outline::before {
  content: "\\f09c8";
}

.mdi-arrow-up-drop-circle::before {
  content: "\\f0062";
}

.mdi-arrow-up-drop-circle-outline::before {
  content: "\\f0063";
}

.mdi-arrow-up-thick::before {
  content: "\\f005e";
}

.mdi-arrow-up-thin-circle-outline::before {
  content: "\\f1597";
}

.mdi-arrow-vertical-lock::before {
  content: "\\f115c";
}

.mdi-artstation::before {
  content: "\\f0b5b";
}

.mdi-aspect-ratio::before {
  content: "\\f0a24";
}

.mdi-assistant::before {
  content: "\\f0064";
}

.mdi-asterisk::before {
  content: "\\f06c4";
}

.mdi-at::before {
  content: "\\f0065";
}

.mdi-atlassian::before {
  content: "\\f0804";
}

.mdi-atm::before {
  content: "\\f0d47";
}

.mdi-atom::before {
  content: "\\f0768";
}

.mdi-atom-variant::before {
  content: "\\f0e7b";
}

.mdi-attachment::before {
  content: "\\f0066";
}

.mdi-audio-video::before {
  content: "\\f093d";
}

.mdi-audio-video-off::before {
  content: "\\f11b6";
}

.mdi-augmented-reality::before {
  content: "\\f0850";
}

.mdi-auto-download::before {
  content: "\\f137e";
}

.mdi-auto-fix::before {
  content: "\\f0068";
}

.mdi-auto-upload::before {
  content: "\\f0069";
}

.mdi-autorenew::before {
  content: "\\f006a";
}

.mdi-av-timer::before {
  content: "\\f006b";
}

.mdi-aws::before {
  content: "\\f0e0f";
}

.mdi-axe::before {
  content: "\\f08c8";
}

.mdi-axis::before {
  content: "\\f0d48";
}

.mdi-axis-arrow::before {
  content: "\\f0d49";
}

.mdi-axis-arrow-info::before {
  content: "\\f140e";
}

.mdi-axis-arrow-lock::before {
  content: "\\f0d4a";
}

.mdi-axis-lock::before {
  content: "\\f0d4b";
}

.mdi-axis-x-arrow::before {
  content: "\\f0d4c";
}

.mdi-axis-x-arrow-lock::before {
  content: "\\f0d4d";
}

.mdi-axis-x-rotate-clockwise::before {
  content: "\\f0d4e";
}

.mdi-axis-x-rotate-counterclockwise::before {
  content: "\\f0d4f";
}

.mdi-axis-x-y-arrow-lock::before {
  content: "\\f0d50";
}

.mdi-axis-y-arrow::before {
  content: "\\f0d51";
}

.mdi-axis-y-arrow-lock::before {
  content: "\\f0d52";
}

.mdi-axis-y-rotate-clockwise::before {
  content: "\\f0d53";
}

.mdi-axis-y-rotate-counterclockwise::before {
  content: "\\f0d54";
}

.mdi-axis-z-arrow::before {
  content: "\\f0d55";
}

.mdi-axis-z-arrow-lock::before {
  content: "\\f0d56";
}

.mdi-axis-z-rotate-clockwise::before {
  content: "\\f0d57";
}

.mdi-axis-z-rotate-counterclockwise::before {
  content: "\\f0d58";
}

.mdi-babel::before {
  content: "\\f0a25";
}

.mdi-baby::before {
  content: "\\f006c";
}

.mdi-baby-bottle::before {
  content: "\\f0f39";
}

.mdi-baby-bottle-outline::before {
  content: "\\f0f3a";
}

.mdi-baby-buggy::before {
  content: "\\f13e0";
}

.mdi-baby-carriage::before {
  content: "\\f068f";
}

.mdi-baby-carriage-off::before {
  content: "\\f0fa0";
}

.mdi-baby-face::before {
  content: "\\f0e7c";
}

.mdi-baby-face-outline::before {
  content: "\\f0e7d";
}

.mdi-backburger::before {
  content: "\\f006d";
}

.mdi-backspace::before {
  content: "\\f006e";
}

.mdi-backspace-outline::before {
  content: "\\f0b5c";
}

.mdi-backspace-reverse::before {
  content: "\\f0e7e";
}

.mdi-backspace-reverse-outline::before {
  content: "\\f0e7f";
}

.mdi-backup-restore::before {
  content: "\\f006f";
}

.mdi-bacteria::before {
  content: "\\f0ed5";
}

.mdi-bacteria-outline::before {
  content: "\\f0ed6";
}

.mdi-badge-account::before {
  content: "\\f0da7";
}

.mdi-badge-account-alert::before {
  content: "\\f0da8";
}

.mdi-badge-account-alert-outline::before {
  content: "\\f0da9";
}

.mdi-badge-account-horizontal::before {
  content: "\\f0e0d";
}

.mdi-badge-account-horizontal-outline::before {
  content: "\\f0e0e";
}

.mdi-badge-account-outline::before {
  content: "\\f0daa";
}

.mdi-badminton::before {
  content: "\\f0851";
}

.mdi-bag-carry-on::before {
  content: "\\f0f3b";
}

.mdi-bag-carry-on-check::before {
  content: "\\f0d65";
}

.mdi-bag-carry-on-off::before {
  content: "\\f0f3c";
}

.mdi-bag-checked::before {
  content: "\\f0f3d";
}

.mdi-bag-personal::before {
  content: "\\f0e10";
}

.mdi-bag-personal-off::before {
  content: "\\f0e11";
}

.mdi-bag-personal-off-outline::before {
  content: "\\f0e12";
}

.mdi-bag-personal-outline::before {
  content: "\\f0e13";
}

.mdi-bag-suitcase::before {
  content: "\\f158b";
}

.mdi-bag-suitcase-off::before {
  content: "\\f158d";
}

.mdi-bag-suitcase-off-outline::before {
  content: "\\f158e";
}

.mdi-bag-suitcase-outline::before {
  content: "\\f158c";
}

.mdi-baguette::before {
  content: "\\f0f3e";
}

.mdi-balloon::before {
  content: "\\f0a26";
}

.mdi-ballot::before {
  content: "\\f09c9";
}

.mdi-ballot-outline::before {
  content: "\\f09ca";
}

.mdi-ballot-recount::before {
  content: "\\f0c39";
}

.mdi-ballot-recount-outline::before {
  content: "\\f0c3a";
}

.mdi-bandage::before {
  content: "\\f0daf";
}

.mdi-bandcamp::before {
  content: "\\f0675";
}

.mdi-bank::before {
  content: "\\f0070";
}

.mdi-bank-check::before {
  content: "\\f1655";
}

.mdi-bank-minus::before {
  content: "\\f0db0";
}

.mdi-bank-off::before {
  content: "\\f1656";
}

.mdi-bank-off-outline::before {
  content: "\\f1657";
}

.mdi-bank-outline::before {
  content: "\\f0e80";
}

.mdi-bank-plus::before {
  content: "\\f0db1";
}

.mdi-bank-remove::before {
  content: "\\f0db2";
}

.mdi-bank-transfer::before {
  content: "\\f0a27";
}

.mdi-bank-transfer-in::before {
  content: "\\f0a28";
}

.mdi-bank-transfer-out::before {
  content: "\\f0a29";
}

.mdi-barcode::before {
  content: "\\f0071";
}

.mdi-barcode-off::before {
  content: "\\f1236";
}

.mdi-barcode-scan::before {
  content: "\\f0072";
}

.mdi-barley::before {
  content: "\\f0073";
}

.mdi-barley-off::before {
  content: "\\f0b5d";
}

.mdi-barn::before {
  content: "\\f0b5e";
}

.mdi-barrel::before {
  content: "\\f0074";
}

.mdi-baseball::before {
  content: "\\f0852";
}

.mdi-baseball-bat::before {
  content: "\\f0853";
}

.mdi-baseball-diamond::before {
  content: "\\f15ec";
}

.mdi-baseball-diamond-outline::before {
  content: "\\f15ed";
}

.mdi-bash::before {
  content: "\\f1183";
}

.mdi-basket::before {
  content: "\\f0076";
}

.mdi-basket-fill::before {
  content: "\\f0077";
}

.mdi-basket-minus::before {
  content: "\\f1523";
}

.mdi-basket-minus-outline::before {
  content: "\\f1524";
}

.mdi-basket-off::before {
  content: "\\f1525";
}

.mdi-basket-off-outline::before {
  content: "\\f1526";
}

.mdi-basket-outline::before {
  content: "\\f1181";
}

.mdi-basket-plus::before {
  content: "\\f1527";
}

.mdi-basket-plus-outline::before {
  content: "\\f1528";
}

.mdi-basket-remove::before {
  content: "\\f1529";
}

.mdi-basket-remove-outline::before {
  content: "\\f152a";
}

.mdi-basket-unfill::before {
  content: "\\f0078";
}

.mdi-basketball::before {
  content: "\\f0806";
}

.mdi-basketball-hoop::before {
  content: "\\f0c3b";
}

.mdi-basketball-hoop-outline::before {
  content: "\\f0c3c";
}

.mdi-bat::before {
  content: "\\f0b5f";
}

.mdi-battery::before {
  content: "\\f0079";
}

.mdi-battery-10::before {
  content: "\\f007a";
}

.mdi-battery-10-bluetooth::before {
  content: "\\f093e";
}

.mdi-battery-20::before {
  content: "\\f007b";
}

.mdi-battery-20-bluetooth::before {
  content: "\\f093f";
}

.mdi-battery-30::before {
  content: "\\f007c";
}

.mdi-battery-30-bluetooth::before {
  content: "\\f0940";
}

.mdi-battery-40::before {
  content: "\\f007d";
}

.mdi-battery-40-bluetooth::before {
  content: "\\f0941";
}

.mdi-battery-50::before {
  content: "\\f007e";
}

.mdi-battery-50-bluetooth::before {
  content: "\\f0942";
}

.mdi-battery-60::before {
  content: "\\f007f";
}

.mdi-battery-60-bluetooth::before {
  content: "\\f0943";
}

.mdi-battery-70::before {
  content: "\\f0080";
}

.mdi-battery-70-bluetooth::before {
  content: "\\f0944";
}

.mdi-battery-80::before {
  content: "\\f0081";
}

.mdi-battery-80-bluetooth::before {
  content: "\\f0945";
}

.mdi-battery-90::before {
  content: "\\f0082";
}

.mdi-battery-90-bluetooth::before {
  content: "\\f0946";
}

.mdi-battery-alert::before {
  content: "\\f0083";
}

.mdi-battery-alert-bluetooth::before {
  content: "\\f0947";
}

.mdi-battery-alert-variant::before {
  content: "\\f10cc";
}

.mdi-battery-alert-variant-outline::before {
  content: "\\f10cd";
}

.mdi-battery-bluetooth::before {
  content: "\\f0948";
}

.mdi-battery-bluetooth-variant::before {
  content: "\\f0949";
}

.mdi-battery-charging::before {
  content: "\\f0084";
}

.mdi-battery-charging-10::before {
  content: "\\f089c";
}

.mdi-battery-charging-100::before {
  content: "\\f0085";
}

.mdi-battery-charging-20::before {
  content: "\\f0086";
}

.mdi-battery-charging-30::before {
  content: "\\f0087";
}

.mdi-battery-charging-40::before {
  content: "\\f0088";
}

.mdi-battery-charging-50::before {
  content: "\\f089d";
}

.mdi-battery-charging-60::before {
  content: "\\f0089";
}

.mdi-battery-charging-70::before {
  content: "\\f089e";
}

.mdi-battery-charging-80::before {
  content: "\\f008a";
}

.mdi-battery-charging-90::before {
  content: "\\f008b";
}

.mdi-battery-charging-high::before {
  content: "\\f12a6";
}

.mdi-battery-charging-low::before {
  content: "\\f12a4";
}

.mdi-battery-charging-medium::before {
  content: "\\f12a5";
}

.mdi-battery-charging-outline::before {
  content: "\\f089f";
}

.mdi-battery-charging-wireless::before {
  content: "\\f0807";
}

.mdi-battery-charging-wireless-10::before {
  content: "\\f0808";
}

.mdi-battery-charging-wireless-20::before {
  content: "\\f0809";
}

.mdi-battery-charging-wireless-30::before {
  content: "\\f080a";
}

.mdi-battery-charging-wireless-40::before {
  content: "\\f080b";
}

.mdi-battery-charging-wireless-50::before {
  content: "\\f080c";
}

.mdi-battery-charging-wireless-60::before {
  content: "\\f080d";
}

.mdi-battery-charging-wireless-70::before {
  content: "\\f080e";
}

.mdi-battery-charging-wireless-80::before {
  content: "\\f080f";
}

.mdi-battery-charging-wireless-90::before {
  content: "\\f0810";
}

.mdi-battery-charging-wireless-alert::before {
  content: "\\f0811";
}

.mdi-battery-charging-wireless-outline::before {
  content: "\\f0812";
}

.mdi-battery-heart::before {
  content: "\\f120f";
}

.mdi-battery-heart-outline::before {
  content: "\\f1210";
}

.mdi-battery-heart-variant::before {
  content: "\\f1211";
}

.mdi-battery-high::before {
  content: "\\f12a3";
}

.mdi-battery-low::before {
  content: "\\f12a1";
}

.mdi-battery-medium::before {
  content: "\\f12a2";
}

.mdi-battery-minus::before {
  content: "\\f008c";
}

.mdi-battery-negative::before {
  content: "\\f008d";
}

.mdi-battery-off::before {
  content: "\\f125d";
}

.mdi-battery-off-outline::before {
  content: "\\f125e";
}

.mdi-battery-outline::before {
  content: "\\f008e";
}

.mdi-battery-plus::before {
  content: "\\f008f";
}

.mdi-battery-positive::before {
  content: "\\f0090";
}

.mdi-battery-unknown::before {
  content: "\\f0091";
}

.mdi-battery-unknown-bluetooth::before {
  content: "\\f094a";
}

.mdi-battlenet::before {
  content: "\\f0b60";
}

.mdi-beach::before {
  content: "\\f0092";
}

.mdi-beaker::before {
  content: "\\f0cea";
}

.mdi-beaker-alert::before {
  content: "\\f1229";
}

.mdi-beaker-alert-outline::before {
  content: "\\f122a";
}

.mdi-beaker-check::before {
  content: "\\f122b";
}

.mdi-beaker-check-outline::before {
  content: "\\f122c";
}

.mdi-beaker-minus::before {
  content: "\\f122d";
}

.mdi-beaker-minus-outline::before {
  content: "\\f122e";
}

.mdi-beaker-outline::before {
  content: "\\f0690";
}

.mdi-beaker-plus::before {
  content: "\\f122f";
}

.mdi-beaker-plus-outline::before {
  content: "\\f1230";
}

.mdi-beaker-question::before {
  content: "\\f1231";
}

.mdi-beaker-question-outline::before {
  content: "\\f1232";
}

.mdi-beaker-remove::before {
  content: "\\f1233";
}

.mdi-beaker-remove-outline::before {
  content: "\\f1234";
}

.mdi-bed::before {
  content: "\\f02e3";
}

.mdi-bed-double::before {
  content: "\\f0fd4";
}

.mdi-bed-double-outline::before {
  content: "\\f0fd3";
}

.mdi-bed-empty::before {
  content: "\\f08a0";
}

.mdi-bed-king::before {
  content: "\\f0fd2";
}

.mdi-bed-king-outline::before {
  content: "\\f0fd1";
}

.mdi-bed-outline::before {
  content: "\\f0099";
}

.mdi-bed-queen::before {
  content: "\\f0fd0";
}

.mdi-bed-queen-outline::before {
  content: "\\f0fdb";
}

.mdi-bed-single::before {
  content: "\\f106d";
}

.mdi-bed-single-outline::before {
  content: "\\f106e";
}

.mdi-bee::before {
  content: "\\f0fa1";
}

.mdi-bee-flower::before {
  content: "\\f0fa2";
}

.mdi-beehive-off-outline::before {
  content: "\\f13ed";
}

.mdi-beehive-outline::before {
  content: "\\f10ce";
}

.mdi-beekeeper::before {
  content: "\\f14e2";
}

.mdi-beer::before {
  content: "\\f0098";
}

.mdi-beer-outline::before {
  content: "\\f130c";
}

.mdi-bell::before {
  content: "\\f009a";
}

.mdi-bell-alert::before {
  content: "\\f0d59";
}

.mdi-bell-alert-outline::before {
  content: "\\f0e81";
}

.mdi-bell-cancel::before {
  content: "\\f13e7";
}

.mdi-bell-cancel-outline::before {
  content: "\\f13e8";
}

.mdi-bell-check::before {
  content: "\\f11e5";
}

.mdi-bell-check-outline::before {
  content: "\\f11e6";
}

.mdi-bell-circle::before {
  content: "\\f0d5a";
}

.mdi-bell-circle-outline::before {
  content: "\\f0d5b";
}

.mdi-bell-minus::before {
  content: "\\f13e9";
}

.mdi-bell-minus-outline::before {
  content: "\\f13ea";
}

.mdi-bell-off::before {
  content: "\\f009b";
}

.mdi-bell-off-outline::before {
  content: "\\f0a91";
}

.mdi-bell-outline::before {
  content: "\\f009c";
}

.mdi-bell-plus::before {
  content: "\\f009d";
}

.mdi-bell-plus-outline::before {
  content: "\\f0a92";
}

.mdi-bell-remove::before {
  content: "\\f13eb";
}

.mdi-bell-remove-outline::before {
  content: "\\f13ec";
}

.mdi-bell-ring::before {
  content: "\\f009e";
}

.mdi-bell-ring-outline::before {
  content: "\\f009f";
}

.mdi-bell-sleep::before {
  content: "\\f00a0";
}

.mdi-bell-sleep-outline::before {
  content: "\\f0a93";
}

.mdi-beta::before {
  content: "\\f00a1";
}

.mdi-betamax::before {
  content: "\\f09cb";
}

.mdi-biathlon::before {
  content: "\\f0e14";
}

.mdi-bicycle::before {
  content: "\\f109c";
}

.mdi-bicycle-basket::before {
  content: "\\f1235";
}

.mdi-bicycle-electric::before {
  content: "\\f15b4";
}

.mdi-bicycle-penny-farthing::before {
  content: "\\f15e9";
}

.mdi-bike::before {
  content: "\\f00a3";
}

.mdi-bike-fast::before {
  content: "\\f111f";
}

.mdi-billboard::before {
  content: "\\f1010";
}

.mdi-billiards::before {
  content: "\\f0b61";
}

.mdi-billiards-rack::before {
  content: "\\f0b62";
}

.mdi-binoculars::before {
  content: "\\f00a5";
}

.mdi-bio::before {
  content: "\\f00a6";
}

.mdi-biohazard::before {
  content: "\\f00a7";
}

.mdi-bird::before {
  content: "\\f15c6";
}

.mdi-bitbucket::before {
  content: "\\f00a8";
}

.mdi-bitcoin::before {
  content: "\\f0813";
}

.mdi-black-mesa::before {
  content: "\\f00a9";
}

.mdi-blender::before {
  content: "\\f0ceb";
}

.mdi-blender-software::before {
  content: "\\f00ab";
}

.mdi-blinds::before {
  content: "\\f00ac";
}

.mdi-blinds-open::before {
  content: "\\f1011";
}

.mdi-block-helper::before {
  content: "\\f00ad";
}

.mdi-blogger::before {
  content: "\\f00ae";
}

.mdi-blood-bag::before {
  content: "\\f0cec";
}

.mdi-bluetooth::before {
  content: "\\f00af";
}

.mdi-bluetooth-audio::before {
  content: "\\f00b0";
}

.mdi-bluetooth-connect::before {
  content: "\\f00b1";
}

.mdi-bluetooth-off::before {
  content: "\\f00b2";
}

.mdi-bluetooth-settings::before {
  content: "\\f00b3";
}

.mdi-bluetooth-transfer::before {
  content: "\\f00b4";
}

.mdi-blur::before {
  content: "\\f00b5";
}

.mdi-blur-linear::before {
  content: "\\f00b6";
}

.mdi-blur-off::before {
  content: "\\f00b7";
}

.mdi-blur-radial::before {
  content: "\\f00b8";
}

.mdi-bolnisi-cross::before {
  content: "\\f0ced";
}

.mdi-bolt::before {
  content: "\\f0db3";
}

.mdi-bomb::before {
  content: "\\f0691";
}

.mdi-bomb-off::before {
  content: "\\f06c5";
}

.mdi-bone::before {
  content: "\\f00b9";
}

.mdi-book::before {
  content: "\\f00ba";
}

.mdi-book-account::before {
  content: "\\f13ad";
}

.mdi-book-account-outline::before {
  content: "\\f13ae";
}

.mdi-book-alert::before {
  content: "\\f167c";
}

.mdi-book-alert-outline::before {
  content: "\\f167d";
}

.mdi-book-alphabet::before {
  content: "\\f061d";
}

.mdi-book-arrow-down::before {
  content: "\\f167e";
}

.mdi-book-arrow-down-outline::before {
  content: "\\f167f";
}

.mdi-book-arrow-left::before {
  content: "\\f1680";
}

.mdi-book-arrow-left-outline::before {
  content: "\\f1681";
}

.mdi-book-arrow-right::before {
  content: "\\f1682";
}

.mdi-book-arrow-right-outline::before {
  content: "\\f1683";
}

.mdi-book-arrow-up::before {
  content: "\\f1684";
}

.mdi-book-arrow-up-outline::before {
  content: "\\f1685";
}

.mdi-book-cancel::before {
  content: "\\f1686";
}

.mdi-book-cancel-outline::before {
  content: "\\f1687";
}

.mdi-book-check::before {
  content: "\\f14f3";
}

.mdi-book-check-outline::before {
  content: "\\f14f4";
}

.mdi-book-clock::before {
  content: "\\f1688";
}

.mdi-book-clock-outline::before {
  content: "\\f1689";
}

.mdi-book-cog::before {
  content: "\\f168a";
}

.mdi-book-cog-outline::before {
  content: "\\f168b";
}

.mdi-book-cross::before {
  content: "\\f00a2";
}

.mdi-book-edit::before {
  content: "\\f168c";
}

.mdi-book-edit-outline::before {
  content: "\\f168d";
}

.mdi-book-education::before {
  content: "\\f16c9";
}

.mdi-book-education-outline::before {
  content: "\\f16ca";
}

.mdi-book-information-variant::before {
  content: "\\f106f";
}

.mdi-book-lock::before {
  content: "\\f079a";
}

.mdi-book-lock-open::before {
  content: "\\f079b";
}

.mdi-book-lock-open-outline::before {
  content: "\\f168e";
}

.mdi-book-lock-outline::before {
  content: "\\f168f";
}

.mdi-book-marker::before {
  content: "\\f1690";
}

.mdi-book-marker-outline::before {
  content: "\\f1691";
}

.mdi-book-minus::before {
  content: "\\f05d9";
}

.mdi-book-minus-multiple::before {
  content: "\\f0a94";
}

.mdi-book-minus-multiple-outline::before {
  content: "\\f090b";
}

.mdi-book-minus-outline::before {
  content: "\\f1692";
}

.mdi-book-multiple::before {
  content: "\\f00bb";
}

.mdi-book-multiple-outline::before {
  content: "\\f0436";
}

.mdi-book-music::before {
  content: "\\f0067";
}

.mdi-book-music-outline::before {
  content: "\\f1693";
}

.mdi-book-off::before {
  content: "\\f1694";
}

.mdi-book-off-outline::before {
  content: "\\f1695";
}

.mdi-book-open::before {
  content: "\\f00bd";
}

.mdi-book-open-blank-variant::before {
  content: "\\f00be";
}

.mdi-book-open-outline::before {
  content: "\\f0b63";
}

.mdi-book-open-page-variant::before {
  content: "\\f05da";
}

.mdi-book-open-page-variant-outline::before {
  content: "\\f15d6";
}

.mdi-book-open-variant::before {
  content: "\\f14f7";
}

.mdi-book-outline::before {
  content: "\\f0b64";
}

.mdi-book-play::before {
  content: "\\f0e82";
}

.mdi-book-play-outline::before {
  content: "\\f0e83";
}

.mdi-book-plus::before {
  content: "\\f05db";
}

.mdi-book-plus-multiple::before {
  content: "\\f0a95";
}

.mdi-book-plus-multiple-outline::before {
  content: "\\f0ade";
}

.mdi-book-plus-outline::before {
  content: "\\f1696";
}

.mdi-book-refresh::before {
  content: "\\f1697";
}

.mdi-book-refresh-outline::before {
  content: "\\f1698";
}

.mdi-book-remove::before {
  content: "\\f0a97";
}

.mdi-book-remove-multiple::before {
  content: "\\f0a96";
}

.mdi-book-remove-multiple-outline::before {
  content: "\\f04ca";
}

.mdi-book-remove-outline::before {
  content: "\\f1699";
}

.mdi-book-search::before {
  content: "\\f0e84";
}

.mdi-book-search-outline::before {
  content: "\\f0e85";
}

.mdi-book-settings::before {
  content: "\\f169a";
}

.mdi-book-settings-outline::before {
  content: "\\f169b";
}

.mdi-book-sync::before {
  content: "\\f169c";
}

.mdi-book-sync-outline::before {
  content: "\\f16c8";
}

.mdi-book-variant::before {
  content: "\\f00bf";
}

.mdi-book-variant-multiple::before {
  content: "\\f00bc";
}

.mdi-bookmark::before {
  content: "\\f00c0";
}

.mdi-bookmark-check::before {
  content: "\\f00c1";
}

.mdi-bookmark-check-outline::before {
  content: "\\f137b";
}

.mdi-bookmark-minus::before {
  content: "\\f09cc";
}

.mdi-bookmark-minus-outline::before {
  content: "\\f09cd";
}

.mdi-bookmark-multiple::before {
  content: "\\f0e15";
}

.mdi-bookmark-multiple-outline::before {
  content: "\\f0e16";
}

.mdi-bookmark-music::before {
  content: "\\f00c2";
}

.mdi-bookmark-music-outline::before {
  content: "\\f1379";
}

.mdi-bookmark-off::before {
  content: "\\f09ce";
}

.mdi-bookmark-off-outline::before {
  content: "\\f09cf";
}

.mdi-bookmark-outline::before {
  content: "\\f00c3";
}

.mdi-bookmark-plus::before {
  content: "\\f00c5";
}

.mdi-bookmark-plus-outline::before {
  content: "\\f00c4";
}

.mdi-bookmark-remove::before {
  content: "\\f00c6";
}

.mdi-bookmark-remove-outline::before {
  content: "\\f137a";
}

.mdi-bookshelf::before {
  content: "\\f125f";
}

.mdi-boom-gate::before {
  content: "\\f0e86";
}

.mdi-boom-gate-alert::before {
  content: "\\f0e87";
}

.mdi-boom-gate-alert-outline::before {
  content: "\\f0e88";
}

.mdi-boom-gate-down::before {
  content: "\\f0e89";
}

.mdi-boom-gate-down-outline::before {
  content: "\\f0e8a";
}

.mdi-boom-gate-outline::before {
  content: "\\f0e8b";
}

.mdi-boom-gate-up::before {
  content: "\\f0e8c";
}

.mdi-boom-gate-up-outline::before {
  content: "\\f0e8d";
}

.mdi-boombox::before {
  content: "\\f05dc";
}

.mdi-boomerang::before {
  content: "\\f10cf";
}

.mdi-bootstrap::before {
  content: "\\f06c6";
}

.mdi-border-all::before {
  content: "\\f00c7";
}

.mdi-border-all-variant::before {
  content: "\\f08a1";
}

.mdi-border-bottom::before {
  content: "\\f00c8";
}

.mdi-border-bottom-variant::before {
  content: "\\f08a2";
}

.mdi-border-color::before {
  content: "\\f00c9";
}

.mdi-border-horizontal::before {
  content: "\\f00ca";
}

.mdi-border-inside::before {
  content: "\\f00cb";
}

.mdi-border-left::before {
  content: "\\f00cc";
}

.mdi-border-left-variant::before {
  content: "\\f08a3";
}

.mdi-border-none::before {
  content: "\\f00cd";
}

.mdi-border-none-variant::before {
  content: "\\f08a4";
}

.mdi-border-outside::before {
  content: "\\f00ce";
}

.mdi-border-right::before {
  content: "\\f00cf";
}

.mdi-border-right-variant::before {
  content: "\\f08a5";
}

.mdi-border-style::before {
  content: "\\f00d0";
}

.mdi-border-top::before {
  content: "\\f00d1";
}

.mdi-border-top-variant::before {
  content: "\\f08a6";
}

.mdi-border-vertical::before {
  content: "\\f00d2";
}

.mdi-bottle-soda::before {
  content: "\\f1070";
}

.mdi-bottle-soda-classic::before {
  content: "\\f1071";
}

.mdi-bottle-soda-classic-outline::before {
  content: "\\f1363";
}

.mdi-bottle-soda-outline::before {
  content: "\\f1072";
}

.mdi-bottle-tonic::before {
  content: "\\f112e";
}

.mdi-bottle-tonic-outline::before {
  content: "\\f112f";
}

.mdi-bottle-tonic-plus::before {
  content: "\\f1130";
}

.mdi-bottle-tonic-plus-outline::before {
  content: "\\f1131";
}

.mdi-bottle-tonic-skull::before {
  content: "\\f1132";
}

.mdi-bottle-tonic-skull-outline::before {
  content: "\\f1133";
}

.mdi-bottle-wine::before {
  content: "\\f0854";
}

.mdi-bottle-wine-outline::before {
  content: "\\f1310";
}

.mdi-bow-tie::before {
  content: "\\f0678";
}

.mdi-bowl::before {
  content: "\\f028e";
}

.mdi-bowl-mix::before {
  content: "\\f0617";
}

.mdi-bowl-mix-outline::before {
  content: "\\f02e4";
}

.mdi-bowl-outline::before {
  content: "\\f02a9";
}

.mdi-bowling::before {
  content: "\\f00d3";
}

.mdi-box::before {
  content: "\\f00d4";
}

.mdi-box-cutter::before {
  content: "\\f00d5";
}

.mdi-box-cutter-off::before {
  content: "\\f0b4a";
}

.mdi-box-shadow::before {
  content: "\\f0637";
}

.mdi-boxing-glove::before {
  content: "\\f0b65";
}

.mdi-braille::before {
  content: "\\f09d0";
}

.mdi-brain::before {
  content: "\\f09d1";
}

.mdi-bread-slice::before {
  content: "\\f0cee";
}

.mdi-bread-slice-outline::before {
  content: "\\f0cef";
}

.mdi-bridge::before {
  content: "\\f0618";
}

.mdi-briefcase::before {
  content: "\\f00d6";
}

.mdi-briefcase-account::before {
  content: "\\f0cf0";
}

.mdi-briefcase-account-outline::before {
  content: "\\f0cf1";
}

.mdi-briefcase-check::before {
  content: "\\f00d7";
}

.mdi-briefcase-check-outline::before {
  content: "\\f131e";
}

.mdi-briefcase-clock::before {
  content: "\\f10d0";
}

.mdi-briefcase-clock-outline::before {
  content: "\\f10d1";
}

.mdi-briefcase-download::before {
  content: "\\f00d8";
}

.mdi-briefcase-download-outline::before {
  content: "\\f0c3d";
}

.mdi-briefcase-edit::before {
  content: "\\f0a98";
}

.mdi-briefcase-edit-outline::before {
  content: "\\f0c3e";
}

.mdi-briefcase-minus::before {
  content: "\\f0a2a";
}

.mdi-briefcase-minus-outline::before {
  content: "\\f0c3f";
}

.mdi-briefcase-off::before {
  content: "\\f1658";
}

.mdi-briefcase-off-outline::before {
  content: "\\f1659";
}

.mdi-briefcase-outline::before {
  content: "\\f0814";
}

.mdi-briefcase-plus::before {
  content: "\\f0a2b";
}

.mdi-briefcase-plus-outline::before {
  content: "\\f0c40";
}

.mdi-briefcase-remove::before {
  content: "\\f0a2c";
}

.mdi-briefcase-remove-outline::before {
  content: "\\f0c41";
}

.mdi-briefcase-search::before {
  content: "\\f0a2d";
}

.mdi-briefcase-search-outline::before {
  content: "\\f0c42";
}

.mdi-briefcase-upload::before {
  content: "\\f00d9";
}

.mdi-briefcase-upload-outline::before {
  content: "\\f0c43";
}

.mdi-briefcase-variant::before {
  content: "\\f1494";
}

.mdi-briefcase-variant-off::before {
  content: "\\f165a";
}

.mdi-briefcase-variant-off-outline::before {
  content: "\\f165b";
}

.mdi-briefcase-variant-outline::before {
  content: "\\f1495";
}

.mdi-brightness-1::before {
  content: "\\f00da";
}

.mdi-brightness-2::before {
  content: "\\f00db";
}

.mdi-brightness-3::before {
  content: "\\f00dc";
}

.mdi-brightness-4::before {
  content: "\\f00dd";
}

.mdi-brightness-5::before {
  content: "\\f00de";
}

.mdi-brightness-6::before {
  content: "\\f00df";
}

.mdi-brightness-7::before {
  content: "\\f00e0";
}

.mdi-brightness-auto::before {
  content: "\\f00e1";
}

.mdi-brightness-percent::before {
  content: "\\f0cf2";
}

.mdi-broadcast::before {
  content: "\\f1720";
}

.mdi-broadcast-off::before {
  content: "\\f1721";
}

.mdi-broom::before {
  content: "\\f00e2";
}

.mdi-brush::before {
  content: "\\f00e3";
}

.mdi-bucket::before {
  content: "\\f1415";
}

.mdi-bucket-outline::before {
  content: "\\f1416";
}

.mdi-buddhism::before {
  content: "\\f094b";
}

.mdi-buffer::before {
  content: "\\f0619";
}

.mdi-buffet::before {
  content: "\\f0578";
}

.mdi-bug::before {
  content: "\\f00e4";
}

.mdi-bug-check::before {
  content: "\\f0a2e";
}

.mdi-bug-check-outline::before {
  content: "\\f0a2f";
}

.mdi-bug-outline::before {
  content: "\\f0a30";
}

.mdi-bugle::before {
  content: "\\f0db4";
}

.mdi-bulldozer::before {
  content: "\\f0b22";
}

.mdi-bullet::before {
  content: "\\f0cf3";
}

.mdi-bulletin-board::before {
  content: "\\f00e5";
}

.mdi-bullhorn::before {
  content: "\\f00e6";
}

.mdi-bullhorn-outline::before {
  content: "\\f0b23";
}

.mdi-bullseye::before {
  content: "\\f05dd";
}

.mdi-bullseye-arrow::before {
  content: "\\f08c9";
}

.mdi-bulma::before {
  content: "\\f12e7";
}

.mdi-bunk-bed::before {
  content: "\\f1302";
}

.mdi-bunk-bed-outline::before {
  content: "\\f0097";
}

.mdi-bus::before {
  content: "\\f00e7";
}

.mdi-bus-alert::before {
  content: "\\f0a99";
}

.mdi-bus-articulated-end::before {
  content: "\\f079c";
}

.mdi-bus-articulated-front::before {
  content: "\\f079d";
}

.mdi-bus-clock::before {
  content: "\\f08ca";
}

.mdi-bus-double-decker::before {
  content: "\\f079e";
}

.mdi-bus-marker::before {
  content: "\\f1212";
}

.mdi-bus-multiple::before {
  content: "\\f0f3f";
}

.mdi-bus-school::before {
  content: "\\f079f";
}

.mdi-bus-side::before {
  content: "\\f07a0";
}

.mdi-bus-stop::before {
  content: "\\f1012";
}

.mdi-bus-stop-covered::before {
  content: "\\f1013";
}

.mdi-bus-stop-uncovered::before {
  content: "\\f1014";
}

.mdi-butterfly::before {
  content: "\\f1589";
}

.mdi-butterfly-outline::before {
  content: "\\f158a";
}

.mdi-cable-data::before {
  content: "\\f1394";
}

.mdi-cached::before {
  content: "\\f00e8";
}

.mdi-cactus::before {
  content: "\\f0db5";
}

.mdi-cake::before {
  content: "\\f00e9";
}

.mdi-cake-layered::before {
  content: "\\f00ea";
}

.mdi-cake-variant::before {
  content: "\\f00eb";
}

.mdi-calculator::before {
  content: "\\f00ec";
}

.mdi-calculator-variant::before {
  content: "\\f0a9a";
}

.mdi-calculator-variant-outline::before {
  content: "\\f15a6";
}

.mdi-calendar::before {
  content: "\\f00ed";
}

.mdi-calendar-account::before {
  content: "\\f0ed7";
}

.mdi-calendar-account-outline::before {
  content: "\\f0ed8";
}

.mdi-calendar-alert::before {
  content: "\\f0a31";
}

.mdi-calendar-arrow-left::before {
  content: "\\f1134";
}

.mdi-calendar-arrow-right::before {
  content: "\\f1135";
}

.mdi-calendar-blank::before {
  content: "\\f00ee";
}

.mdi-calendar-blank-multiple::before {
  content: "\\f1073";
}

.mdi-calendar-blank-outline::before {
  content: "\\f0b66";
}

.mdi-calendar-check::before {
  content: "\\f00ef";
}

.mdi-calendar-check-outline::before {
  content: "\\f0c44";
}

.mdi-calendar-clock::before {
  content: "\\f00f0";
}

.mdi-calendar-clock-outline::before {
  content: "\\f16e1";
}

.mdi-calendar-cursor::before {
  content: "\\f157b";
}

.mdi-calendar-edit::before {
  content: "\\f08a7";
}

.mdi-calendar-end::before {
  content: "\\f166c";
}

.mdi-calendar-export::before {
  content: "\\f0b24";
}

.mdi-calendar-heart::before {
  content: "\\f09d2";
}

.mdi-calendar-import::before {
  content: "\\f0b25";
}

.mdi-calendar-lock::before {
  content: "\\f1641";
}

.mdi-calendar-lock-outline::before {
  content: "\\f1642";
}

.mdi-calendar-minus::before {
  content: "\\f0d5c";
}

.mdi-calendar-month::before {
  content: "\\f0e17";
}

.mdi-calendar-month-outline::before {
  content: "\\f0e18";
}

.mdi-calendar-multiple::before {
  content: "\\f00f1";
}

.mdi-calendar-multiple-check::before {
  content: "\\f00f2";
}

.mdi-calendar-multiselect::before {
  content: "\\f0a32";
}

.mdi-calendar-outline::before {
  content: "\\f0b67";
}

.mdi-calendar-plus::before {
  content: "\\f00f3";
}

.mdi-calendar-question::before {
  content: "\\f0692";
}

.mdi-calendar-range::before {
  content: "\\f0679";
}

.mdi-calendar-range-outline::before {
  content: "\\f0b68";
}

.mdi-calendar-refresh::before {
  content: "\\f01e1";
}

.mdi-calendar-refresh-outline::before {
  content: "\\f0203";
}

.mdi-calendar-remove::before {
  content: "\\f00f4";
}

.mdi-calendar-remove-outline::before {
  content: "\\f0c45";
}

.mdi-calendar-search::before {
  content: "\\f094c";
}

.mdi-calendar-star::before {
  content: "\\f09d3";
}

.mdi-calendar-start::before {
  content: "\\f166d";
}

.mdi-calendar-sync::before {
  content: "\\f0e8e";
}

.mdi-calendar-sync-outline::before {
  content: "\\f0e8f";
}

.mdi-calendar-text::before {
  content: "\\f00f5";
}

.mdi-calendar-text-outline::before {
  content: "\\f0c46";
}

.mdi-calendar-today::before {
  content: "\\f00f6";
}

.mdi-calendar-week::before {
  content: "\\f0a33";
}

.mdi-calendar-week-begin::before {
  content: "\\f0a34";
}

.mdi-calendar-weekend::before {
  content: "\\f0ed9";
}

.mdi-calendar-weekend-outline::before {
  content: "\\f0eda";
}

.mdi-call-made::before {
  content: "\\f00f7";
}

.mdi-call-merge::before {
  content: "\\f00f8";
}

.mdi-call-missed::before {
  content: "\\f00f9";
}

.mdi-call-received::before {
  content: "\\f00fa";
}

.mdi-call-split::before {
  content: "\\f00fb";
}

.mdi-camcorder::before {
  content: "\\f00fc";
}

.mdi-camcorder-off::before {
  content: "\\f00ff";
}

.mdi-camera::before {
  content: "\\f0100";
}

.mdi-camera-account::before {
  content: "\\f08cb";
}

.mdi-camera-burst::before {
  content: "\\f0693";
}

.mdi-camera-control::before {
  content: "\\f0b69";
}

.mdi-camera-enhance::before {
  content: "\\f0101";
}

.mdi-camera-enhance-outline::before {
  content: "\\f0b6a";
}

.mdi-camera-flip::before {
  content: "\\f15d9";
}

.mdi-camera-flip-outline::before {
  content: "\\f15da";
}

.mdi-camera-front::before {
  content: "\\f0102";
}

.mdi-camera-front-variant::before {
  content: "\\f0103";
}

.mdi-camera-gopro::before {
  content: "\\f07a1";
}

.mdi-camera-image::before {
  content: "\\f08cc";
}

.mdi-camera-iris::before {
  content: "\\f0104";
}

.mdi-camera-metering-center::before {
  content: "\\f07a2";
}

.mdi-camera-metering-matrix::before {
  content: "\\f07a3";
}

.mdi-camera-metering-partial::before {
  content: "\\f07a4";
}

.mdi-camera-metering-spot::before {
  content: "\\f07a5";
}

.mdi-camera-off::before {
  content: "\\f05df";
}

.mdi-camera-outline::before {
  content: "\\f0d5d";
}

.mdi-camera-party-mode::before {
  content: "\\f0105";
}

.mdi-camera-plus::before {
  content: "\\f0edb";
}

.mdi-camera-plus-outline::before {
  content: "\\f0edc";
}

.mdi-camera-rear::before {
  content: "\\f0106";
}

.mdi-camera-rear-variant::before {
  content: "\\f0107";
}

.mdi-camera-retake::before {
  content: "\\f0e19";
}

.mdi-camera-retake-outline::before {
  content: "\\f0e1a";
}

.mdi-camera-switch::before {
  content: "\\f0108";
}

.mdi-camera-switch-outline::before {
  content: "\\f084a";
}

.mdi-camera-timer::before {
  content: "\\f0109";
}

.mdi-camera-wireless::before {
  content: "\\f0db6";
}

.mdi-camera-wireless-outline::before {
  content: "\\f0db7";
}

.mdi-campfire::before {
  content: "\\f0edd";
}

.mdi-cancel::before {
  content: "\\f073a";
}

.mdi-candle::before {
  content: "\\f05e2";
}

.mdi-candycane::before {
  content: "\\f010a";
}

.mdi-cannabis::before {
  content: "\\f07a6";
}

.mdi-cannabis-off::before {
  content: "\\f166e";
}

.mdi-caps-lock::before {
  content: "\\f0a9b";
}

.mdi-car::before {
  content: "\\f010b";
}

.mdi-car-2-plus::before {
  content: "\\f1015";
}

.mdi-car-3-plus::before {
  content: "\\f1016";
}

.mdi-car-arrow-left::before {
  content: "\\f13b2";
}

.mdi-car-arrow-right::before {
  content: "\\f13b3";
}

.mdi-car-back::before {
  content: "\\f0e1b";
}

.mdi-car-battery::before {
  content: "\\f010c";
}

.mdi-car-brake-abs::before {
  content: "\\f0c47";
}

.mdi-car-brake-alert::before {
  content: "\\f0c48";
}

.mdi-car-brake-hold::before {
  content: "\\f0d5e";
}

.mdi-car-brake-parking::before {
  content: "\\f0d5f";
}

.mdi-car-brake-retarder::before {
  content: "\\f1017";
}

.mdi-car-child-seat::before {
  content: "\\f0fa3";
}

.mdi-car-clutch::before {
  content: "\\f1018";
}

.mdi-car-cog::before {
  content: "\\f13cc";
}

.mdi-car-connected::before {
  content: "\\f010d";
}

.mdi-car-convertible::before {
  content: "\\f07a7";
}

.mdi-car-coolant-level::before {
  content: "\\f1019";
}

.mdi-car-cruise-control::before {
  content: "\\f0d60";
}

.mdi-car-defrost-front::before {
  content: "\\f0d61";
}

.mdi-car-defrost-rear::before {
  content: "\\f0d62";
}

.mdi-car-door::before {
  content: "\\f0b6b";
}

.mdi-car-door-lock::before {
  content: "\\f109d";
}

.mdi-car-electric::before {
  content: "\\f0b6c";
}

.mdi-car-electric-outline::before {
  content: "\\f15b5";
}

.mdi-car-emergency::before {
  content: "\\f160f";
}

.mdi-car-esp::before {
  content: "\\f0c49";
}

.mdi-car-estate::before {
  content: "\\f07a8";
}

.mdi-car-hatchback::before {
  content: "\\f07a9";
}

.mdi-car-info::before {
  content: "\\f11be";
}

.mdi-car-key::before {
  content: "\\f0b6d";
}

.mdi-car-lifted-pickup::before {
  content: "\\f152d";
}

.mdi-car-light-dimmed::before {
  content: "\\f0c4a";
}

.mdi-car-light-fog::before {
  content: "\\f0c4b";
}

.mdi-car-light-high::before {
  content: "\\f0c4c";
}

.mdi-car-limousine::before {
  content: "\\f08cd";
}

.mdi-car-multiple::before {
  content: "\\f0b6e";
}

.mdi-car-off::before {
  content: "\\f0e1c";
}

.mdi-car-outline::before {
  content: "\\f14ed";
}

.mdi-car-parking-lights::before {
  content: "\\f0d63";
}

.mdi-car-pickup::before {
  content: "\\f07aa";
}

.mdi-car-seat::before {
  content: "\\f0fa4";
}

.mdi-car-seat-cooler::before {
  content: "\\f0fa5";
}

.mdi-car-seat-heater::before {
  content: "\\f0fa6";
}

.mdi-car-settings::before {
  content: "\\f13cd";
}

.mdi-car-shift-pattern::before {
  content: "\\f0f40";
}

.mdi-car-side::before {
  content: "\\f07ab";
}

.mdi-car-sports::before {
  content: "\\f07ac";
}

.mdi-car-tire-alert::before {
  content: "\\f0c4d";
}

.mdi-car-traction-control::before {
  content: "\\f0d64";
}

.mdi-car-turbocharger::before {
  content: "\\f101a";
}

.mdi-car-wash::before {
  content: "\\f010e";
}

.mdi-car-windshield::before {
  content: "\\f101b";
}

.mdi-car-windshield-outline::before {
  content: "\\f101c";
}

.mdi-carabiner::before {
  content: "\\f14c0";
}

.mdi-caravan::before {
  content: "\\f07ad";
}

.mdi-card::before {
  content: "\\f0b6f";
}

.mdi-card-account-details::before {
  content: "\\f05d2";
}

.mdi-card-account-details-outline::before {
  content: "\\f0dab";
}

.mdi-card-account-details-star::before {
  content: "\\f02a3";
}

.mdi-card-account-details-star-outline::before {
  content: "\\f06db";
}

.mdi-card-account-mail::before {
  content: "\\f018e";
}

.mdi-card-account-mail-outline::before {
  content: "\\f0e98";
}

.mdi-card-account-phone::before {
  content: "\\f0e99";
}

.mdi-card-account-phone-outline::before {
  content: "\\f0e9a";
}

.mdi-card-bulleted::before {
  content: "\\f0b70";
}

.mdi-card-bulleted-off::before {
  content: "\\f0b71";
}

.mdi-card-bulleted-off-outline::before {
  content: "\\f0b72";
}

.mdi-card-bulleted-outline::before {
  content: "\\f0b73";
}

.mdi-card-bulleted-settings::before {
  content: "\\f0b74";
}

.mdi-card-bulleted-settings-outline::before {
  content: "\\f0b75";
}

.mdi-card-minus::before {
  content: "\\f1600";
}

.mdi-card-minus-outline::before {
  content: "\\f1601";
}

.mdi-card-off::before {
  content: "\\f1602";
}

.mdi-card-off-outline::before {
  content: "\\f1603";
}

.mdi-card-outline::before {
  content: "\\f0b76";
}

.mdi-card-plus::before {
  content: "\\f11ff";
}

.mdi-card-plus-outline::before {
  content: "\\f1200";
}

.mdi-card-remove::before {
  content: "\\f1604";
}

.mdi-card-remove-outline::before {
  content: "\\f1605";
}

.mdi-card-search::before {
  content: "\\f1074";
}

.mdi-card-search-outline::before {
  content: "\\f1075";
}

.mdi-card-text::before {
  content: "\\f0b77";
}

.mdi-card-text-outline::before {
  content: "\\f0b78";
}

.mdi-cards::before {
  content: "\\f0638";
}

.mdi-cards-club::before {
  content: "\\f08ce";
}

.mdi-cards-diamond::before {
  content: "\\f08cf";
}

.mdi-cards-diamond-outline::before {
  content: "\\f101d";
}

.mdi-cards-heart::before {
  content: "\\f08d0";
}

.mdi-cards-outline::before {
  content: "\\f0639";
}

.mdi-cards-playing-outline::before {
  content: "\\f063a";
}

.mdi-cards-spade::before {
  content: "\\f08d1";
}

.mdi-cards-variant::before {
  content: "\\f06c7";
}

.mdi-carrot::before {
  content: "\\f010f";
}

.mdi-cart::before {
  content: "\\f0110";
}

.mdi-cart-arrow-down::before {
  content: "\\f0d66";
}

.mdi-cart-arrow-right::before {
  content: "\\f0c4e";
}

.mdi-cart-arrow-up::before {
  content: "\\f0d67";
}

.mdi-cart-check::before {
  content: "\\f15ea";
}

.mdi-cart-minus::before {
  content: "\\f0d68";
}

.mdi-cart-off::before {
  content: "\\f066b";
}

.mdi-cart-outline::before {
  content: "\\f0111";
}

.mdi-cart-plus::before {
  content: "\\f0112";
}

.mdi-cart-remove::before {
  content: "\\f0d69";
}

.mdi-cart-variant::before {
  content: "\\f15eb";
}

.mdi-case-sensitive-alt::before {
  content: "\\f0113";
}

.mdi-cash::before {
  content: "\\f0114";
}

.mdi-cash-100::before {
  content: "\\f0115";
}

.mdi-cash-check::before {
  content: "\\f14ee";
}

.mdi-cash-lock::before {
  content: "\\f14ea";
}

.mdi-cash-lock-open::before {
  content: "\\f14eb";
}

.mdi-cash-marker::before {
  content: "\\f0db8";
}

.mdi-cash-minus::before {
  content: "\\f1260";
}

.mdi-cash-multiple::before {
  content: "\\f0116";
}

.mdi-cash-plus::before {
  content: "\\f1261";
}

.mdi-cash-refund::before {
  content: "\\f0a9c";
}

.mdi-cash-register::before {
  content: "\\f0cf4";
}

.mdi-cash-remove::before {
  content: "\\f1262";
}

.mdi-cash-usd::before {
  content: "\\f1176";
}

.mdi-cash-usd-outline::before {
  content: "\\f0117";
}

.mdi-cassette::before {
  content: "\\f09d4";
}

.mdi-cast::before {
  content: "\\f0118";
}

.mdi-cast-audio::before {
  content: "\\f101e";
}

.mdi-cast-connected::before {
  content: "\\f0119";
}

.mdi-cast-education::before {
  content: "\\f0e1d";
}

.mdi-cast-off::before {
  content: "\\f078a";
}

.mdi-castle::before {
  content: "\\f011a";
}

.mdi-cat::before {
  content: "\\f011b";
}

.mdi-cctv::before {
  content: "\\f07ae";
}

.mdi-ceiling-light::before {
  content: "\\f0769";
}

.mdi-cellphone::before {
  content: "\\f011c";
}

.mdi-cellphone-android::before {
  content: "\\f011d";
}

.mdi-cellphone-arrow-down::before {
  content: "\\f09d5";
}

.mdi-cellphone-basic::before {
  content: "\\f011e";
}

.mdi-cellphone-charging::before {
  content: "\\f1397";
}

.mdi-cellphone-cog::before {
  content: "\\f0951";
}

.mdi-cellphone-dock::before {
  content: "\\f011f";
}

.mdi-cellphone-erase::before {
  content: "\\f094d";
}

.mdi-cellphone-information::before {
  content: "\\f0f41";
}

.mdi-cellphone-iphone::before {
  content: "\\f0120";
}

.mdi-cellphone-key::before {
  content: "\\f094e";
}

.mdi-cellphone-link::before {
  content: "\\f0121";
}

.mdi-cellphone-link-off::before {
  content: "\\f0122";
}

.mdi-cellphone-lock::before {
  content: "\\f094f";
}

.mdi-cellphone-message::before {
  content: "\\f08d3";
}

.mdi-cellphone-message-off::before {
  content: "\\f10d2";
}

.mdi-cellphone-nfc::before {
  content: "\\f0e90";
}

.mdi-cellphone-nfc-off::before {
  content: "\\f12d8";
}

.mdi-cellphone-off::before {
  content: "\\f0950";
}

.mdi-cellphone-play::before {
  content: "\\f101f";
}

.mdi-cellphone-screenshot::before {
  content: "\\f0a35";
}

.mdi-cellphone-settings::before {
  content: "\\f0123";
}

.mdi-cellphone-sound::before {
  content: "\\f0952";
}

.mdi-cellphone-text::before {
  content: "\\f08d2";
}

.mdi-cellphone-wireless::before {
  content: "\\f0815";
}

.mdi-celtic-cross::before {
  content: "\\f0cf5";
}

.mdi-centos::before {
  content: "\\f111a";
}

.mdi-certificate::before {
  content: "\\f0124";
}

.mdi-certificate-outline::before {
  content: "\\f1188";
}

.mdi-chair-rolling::before {
  content: "\\f0f48";
}

.mdi-chair-school::before {
  content: "\\f0125";
}

.mdi-charity::before {
  content: "\\f0c4f";
}

.mdi-chart-arc::before {
  content: "\\f0126";
}

.mdi-chart-areaspline::before {
  content: "\\f0127";
}

.mdi-chart-areaspline-variant::before {
  content: "\\f0e91";
}

.mdi-chart-bar::before {
  content: "\\f0128";
}

.mdi-chart-bar-stacked::before {
  content: "\\f076a";
}

.mdi-chart-bell-curve::before {
  content: "\\f0c50";
}

.mdi-chart-bell-curve-cumulative::before {
  content: "\\f0fa7";
}

.mdi-chart-box::before {
  content: "\\f154d";
}

.mdi-chart-box-outline::before {
  content: "\\f154e";
}

.mdi-chart-box-plus-outline::before {
  content: "\\f154f";
}

.mdi-chart-bubble::before {
  content: "\\f05e3";
}

.mdi-chart-donut::before {
  content: "\\f07af";
}

.mdi-chart-donut-variant::before {
  content: "\\f07b0";
}

.mdi-chart-gantt::before {
  content: "\\f066c";
}

.mdi-chart-histogram::before {
  content: "\\f0129";
}

.mdi-chart-line::before {
  content: "\\f012a";
}

.mdi-chart-line-stacked::before {
  content: "\\f076b";
}

.mdi-chart-line-variant::before {
  content: "\\f07b1";
}

.mdi-chart-multiline::before {
  content: "\\f08d4";
}

.mdi-chart-multiple::before {
  content: "\\f1213";
}

.mdi-chart-pie::before {
  content: "\\f012b";
}

.mdi-chart-ppf::before {
  content: "\\f1380";
}

.mdi-chart-sankey::before {
  content: "\\f11df";
}

.mdi-chart-sankey-variant::before {
  content: "\\f11e0";
}

.mdi-chart-scatter-plot::before {
  content: "\\f0e92";
}

.mdi-chart-scatter-plot-hexbin::before {
  content: "\\f066d";
}

.mdi-chart-timeline::before {
  content: "\\f066e";
}

.mdi-chart-timeline-variant::before {
  content: "\\f0e93";
}

.mdi-chart-timeline-variant-shimmer::before {
  content: "\\f15b6";
}

.mdi-chart-tree::before {
  content: "\\f0e94";
}

.mdi-chat::before {
  content: "\\f0b79";
}

.mdi-chat-alert::before {
  content: "\\f0b7a";
}

.mdi-chat-alert-outline::before {
  content: "\\f12c9";
}

.mdi-chat-minus::before {
  content: "\\f1410";
}

.mdi-chat-minus-outline::before {
  content: "\\f1413";
}

.mdi-chat-outline::before {
  content: "\\f0ede";
}

.mdi-chat-plus::before {
  content: "\\f140f";
}

.mdi-chat-plus-outline::before {
  content: "\\f1412";
}

.mdi-chat-processing::before {
  content: "\\f0b7b";
}

.mdi-chat-processing-outline::before {
  content: "\\f12ca";
}

.mdi-chat-question::before {
  content: "\\f1738";
}

.mdi-chat-question-outline::before {
  content: "\\f1739";
}

.mdi-chat-remove::before {
  content: "\\f1411";
}

.mdi-chat-remove-outline::before {
  content: "\\f1414";
}

.mdi-chat-sleep::before {
  content: "\\f12d1";
}

.mdi-chat-sleep-outline::before {
  content: "\\f12d2";
}

.mdi-check::before {
  content: "\\f012c";
}

.mdi-check-all::before {
  content: "\\f012d";
}

.mdi-check-bold::before {
  content: "\\f0e1e";
}

.mdi-check-box-multiple-outline::before {
  content: "\\f0c51";
}

.mdi-check-box-outline::before {
  content: "\\f0c52";
}

.mdi-check-circle::before {
  content: "\\f05e0";
}

.mdi-check-circle-outline::before {
  content: "\\f05e1";
}

.mdi-check-decagram::before {
  content: "\\f0791";
}

.mdi-check-decagram-outline::before {
  content: "\\f1740";
}

.mdi-check-network::before {
  content: "\\f0c53";
}

.mdi-check-network-outline::before {
  content: "\\f0c54";
}

.mdi-check-outline::before {
  content: "\\f0855";
}

.mdi-check-underline::before {
  content: "\\f0e1f";
}

.mdi-check-underline-circle::before {
  content: "\\f0e20";
}

.mdi-check-underline-circle-outline::before {
  content: "\\f0e21";
}

.mdi-checkbook::before {
  content: "\\f0a9d";
}

.mdi-checkbox-blank::before {
  content: "\\f012e";
}

.mdi-checkbox-blank-circle::before {
  content: "\\f012f";
}

.mdi-checkbox-blank-circle-outline::before {
  content: "\\f0130";
}

.mdi-checkbox-blank-off::before {
  content: "\\f12ec";
}

.mdi-checkbox-blank-off-outline::before {
  content: "\\f12ed";
}

.mdi-checkbox-blank-outline::before {
  content: "\\f0131";
}

.mdi-checkbox-intermediate::before {
  content: "\\f0856";
}

.mdi-checkbox-marked::before {
  content: "\\f0132";
}

.mdi-checkbox-marked-circle::before {
  content: "\\f0133";
}

.mdi-checkbox-marked-circle-outline::before {
  content: "\\f0134";
}

.mdi-checkbox-marked-outline::before {
  content: "\\f0135";
}

.mdi-checkbox-multiple-blank::before {
  content: "\\f0136";
}

.mdi-checkbox-multiple-blank-circle::before {
  content: "\\f063b";
}

.mdi-checkbox-multiple-blank-circle-outline::before {
  content: "\\f063c";
}

.mdi-checkbox-multiple-blank-outline::before {
  content: "\\f0137";
}

.mdi-checkbox-multiple-marked::before {
  content: "\\f0138";
}

.mdi-checkbox-multiple-marked-circle::before {
  content: "\\f063d";
}

.mdi-checkbox-multiple-marked-circle-outline::before {
  content: "\\f063e";
}

.mdi-checkbox-multiple-marked-outline::before {
  content: "\\f0139";
}

.mdi-checkerboard::before {
  content: "\\f013a";
}

.mdi-checkerboard-minus::before {
  content: "\\f1202";
}

.mdi-checkerboard-plus::before {
  content: "\\f1201";
}

.mdi-checkerboard-remove::before {
  content: "\\f1203";
}

.mdi-cheese::before {
  content: "\\f12b9";
}

.mdi-cheese-off::before {
  content: "\\f13ee";
}

.mdi-chef-hat::before {
  content: "\\f0b7c";
}

.mdi-chemical-weapon::before {
  content: "\\f013b";
}

.mdi-chess-bishop::before {
  content: "\\f085c";
}

.mdi-chess-king::before {
  content: "\\f0857";
}

.mdi-chess-knight::before {
  content: "\\f0858";
}

.mdi-chess-pawn::before {
  content: "\\f0859";
}

.mdi-chess-queen::before {
  content: "\\f085a";
}

.mdi-chess-rook::before {
  content: "\\f085b";
}

.mdi-chevron-double-down::before {
  content: "\\f013c";
}

.mdi-chevron-double-left::before {
  content: "\\f013d";
}

.mdi-chevron-double-right::before {
  content: "\\f013e";
}

.mdi-chevron-double-up::before {
  content: "\\f013f";
}

.mdi-chevron-down::before {
  content: "\\f0140";
}

.mdi-chevron-down-box::before {
  content: "\\f09d6";
}

.mdi-chevron-down-box-outline::before {
  content: "\\f09d7";
}

.mdi-chevron-down-circle::before {
  content: "\\f0b26";
}

.mdi-chevron-down-circle-outline::before {
  content: "\\f0b27";
}

.mdi-chevron-left::before {
  content: "\\f0141";
}

.mdi-chevron-left-box::before {
  content: "\\f09d8";
}

.mdi-chevron-left-box-outline::before {
  content: "\\f09d9";
}

.mdi-chevron-left-circle::before {
  content: "\\f0b28";
}

.mdi-chevron-left-circle-outline::before {
  content: "\\f0b29";
}

.mdi-chevron-right::before {
  content: "\\f0142";
}

.mdi-chevron-right-box::before {
  content: "\\f09da";
}

.mdi-chevron-right-box-outline::before {
  content: "\\f09db";
}

.mdi-chevron-right-circle::before {
  content: "\\f0b2a";
}

.mdi-chevron-right-circle-outline::before {
  content: "\\f0b2b";
}

.mdi-chevron-triple-down::before {
  content: "\\f0db9";
}

.mdi-chevron-triple-left::before {
  content: "\\f0dba";
}

.mdi-chevron-triple-right::before {
  content: "\\f0dbb";
}

.mdi-chevron-triple-up::before {
  content: "\\f0dbc";
}

.mdi-chevron-up::before {
  content: "\\f0143";
}

.mdi-chevron-up-box::before {
  content: "\\f09dc";
}

.mdi-chevron-up-box-outline::before {
  content: "\\f09dd";
}

.mdi-chevron-up-circle::before {
  content: "\\f0b2c";
}

.mdi-chevron-up-circle-outline::before {
  content: "\\f0b2d";
}

.mdi-chili-hot::before {
  content: "\\f07b2";
}

.mdi-chili-medium::before {
  content: "\\f07b3";
}

.mdi-chili-mild::before {
  content: "\\f07b4";
}

.mdi-chili-off::before {
  content: "\\f1467";
}

.mdi-chip::before {
  content: "\\f061a";
}

.mdi-christianity::before {
  content: "\\f0953";
}

.mdi-christianity-outline::before {
  content: "\\f0cf6";
}

.mdi-church::before {
  content: "\\f0144";
}

.mdi-cigar::before {
  content: "\\f1189";
}

.mdi-cigar-off::before {
  content: "\\f141b";
}

.mdi-circle::before {
  content: "\\f0765";
}

.mdi-circle-box::before {
  content: "\\f15dc";
}

.mdi-circle-box-outline::before {
  content: "\\f15dd";
}

.mdi-circle-double::before {
  content: "\\f0e95";
}

.mdi-circle-edit-outline::before {
  content: "\\f08d5";
}

.mdi-circle-expand::before {
  content: "\\f0e96";
}

.mdi-circle-half::before {
  content: "\\f1395";
}

.mdi-circle-half-full::before {
  content: "\\f1396";
}

.mdi-circle-medium::before {
  content: "\\f09de";
}

.mdi-circle-multiple::before {
  content: "\\f0b38";
}

.mdi-circle-multiple-outline::before {
  content: "\\f0695";
}

.mdi-circle-off-outline::before {
  content: "\\f10d3";
}

.mdi-circle-outline::before {
  content: "\\f0766";
}

.mdi-circle-slice-1::before {
  content: "\\f0a9e";
}

.mdi-circle-slice-2::before {
  content: "\\f0a9f";
}

.mdi-circle-slice-3::before {
  content: "\\f0aa0";
}

.mdi-circle-slice-4::before {
  content: "\\f0aa1";
}

.mdi-circle-slice-5::before {
  content: "\\f0aa2";
}

.mdi-circle-slice-6::before {
  content: "\\f0aa3";
}

.mdi-circle-slice-7::before {
  content: "\\f0aa4";
}

.mdi-circle-slice-8::before {
  content: "\\f0aa5";
}

.mdi-circle-small::before {
  content: "\\f09df";
}

.mdi-circular-saw::before {
  content: "\\f0e22";
}

.mdi-city::before {
  content: "\\f0146";
}

.mdi-city-variant::before {
  content: "\\f0a36";
}

.mdi-city-variant-outline::before {
  content: "\\f0a37";
}

.mdi-clipboard::before {
  content: "\\f0147";
}

.mdi-clipboard-account::before {
  content: "\\f0148";
}

.mdi-clipboard-account-outline::before {
  content: "\\f0c55";
}

.mdi-clipboard-alert::before {
  content: "\\f0149";
}

.mdi-clipboard-alert-outline::before {
  content: "\\f0cf7";
}

.mdi-clipboard-arrow-down::before {
  content: "\\f014a";
}

.mdi-clipboard-arrow-down-outline::before {
  content: "\\f0c56";
}

.mdi-clipboard-arrow-left::before {
  content: "\\f014b";
}

.mdi-clipboard-arrow-left-outline::before {
  content: "\\f0cf8";
}

.mdi-clipboard-arrow-right::before {
  content: "\\f0cf9";
}

.mdi-clipboard-arrow-right-outline::before {
  content: "\\f0cfa";
}

.mdi-clipboard-arrow-up::before {
  content: "\\f0c57";
}

.mdi-clipboard-arrow-up-outline::before {
  content: "\\f0c58";
}

.mdi-clipboard-check::before {
  content: "\\f014e";
}

.mdi-clipboard-check-multiple::before {
  content: "\\f1263";
}

.mdi-clipboard-check-multiple-outline::before {
  content: "\\f1264";
}

.mdi-clipboard-check-outline::before {
  content: "\\f08a8";
}

.mdi-clipboard-clock::before {
  content: "\\f16e2";
}

.mdi-clipboard-clock-outline::before {
  content: "\\f16e3";
}

.mdi-clipboard-edit::before {
  content: "\\f14e5";
}

.mdi-clipboard-edit-outline::before {
  content: "\\f14e6";
}

.mdi-clipboard-file::before {
  content: "\\f1265";
}

.mdi-clipboard-file-outline::before {
  content: "\\f1266";
}

.mdi-clipboard-flow::before {
  content: "\\f06c8";
}

.mdi-clipboard-flow-outline::before {
  content: "\\f1117";
}

.mdi-clipboard-list::before {
  content: "\\f10d4";
}

.mdi-clipboard-list-outline::before {
  content: "\\f10d5";
}

.mdi-clipboard-minus::before {
  content: "\\f1618";
}

.mdi-clipboard-minus-outline::before {
  content: "\\f1619";
}

.mdi-clipboard-multiple::before {
  content: "\\f1267";
}

.mdi-clipboard-multiple-outline::before {
  content: "\\f1268";
}

.mdi-clipboard-off::before {
  content: "\\f161a";
}

.mdi-clipboard-off-outline::before {
  content: "\\f161b";
}

.mdi-clipboard-outline::before {
  content: "\\f014c";
}

.mdi-clipboard-play::before {
  content: "\\f0c59";
}

.mdi-clipboard-play-multiple::before {
  content: "\\f1269";
}

.mdi-clipboard-play-multiple-outline::before {
  content: "\\f126a";
}

.mdi-clipboard-play-outline::before {
  content: "\\f0c5a";
}

.mdi-clipboard-plus::before {
  content: "\\f0751";
}

.mdi-clipboard-plus-outline::before {
  content: "\\f131f";
}

.mdi-clipboard-pulse::before {
  content: "\\f085d";
}

.mdi-clipboard-pulse-outline::before {
  content: "\\f085e";
}

.mdi-clipboard-remove::before {
  content: "\\f161c";
}

.mdi-clipboard-remove-outline::before {
  content: "\\f161d";
}

.mdi-clipboard-search::before {
  content: "\\f161e";
}

.mdi-clipboard-search-outline::before {
  content: "\\f161f";
}

.mdi-clipboard-text::before {
  content: "\\f014d";
}

.mdi-clipboard-text-multiple::before {
  content: "\\f126b";
}

.mdi-clipboard-text-multiple-outline::before {
  content: "\\f126c";
}

.mdi-clipboard-text-off::before {
  content: "\\f1620";
}

.mdi-clipboard-text-off-outline::before {
  content: "\\f1621";
}

.mdi-clipboard-text-outline::before {
  content: "\\f0a38";
}

.mdi-clipboard-text-play::before {
  content: "\\f0c5b";
}

.mdi-clipboard-text-play-outline::before {
  content: "\\f0c5c";
}

.mdi-clipboard-text-search::before {
  content: "\\f1622";
}

.mdi-clipboard-text-search-outline::before {
  content: "\\f1623";
}

.mdi-clippy::before {
  content: "\\f014f";
}

.mdi-clock::before {
  content: "\\f0954";
}

.mdi-clock-alert::before {
  content: "\\f0955";
}

.mdi-clock-alert-outline::before {
  content: "\\f05ce";
}

.mdi-clock-check::before {
  content: "\\f0fa8";
}

.mdi-clock-check-outline::before {
  content: "\\f0fa9";
}

.mdi-clock-digital::before {
  content: "\\f0e97";
}

.mdi-clock-end::before {
  content: "\\f0151";
}

.mdi-clock-fast::before {
  content: "\\f0152";
}

.mdi-clock-in::before {
  content: "\\f0153";
}

.mdi-clock-out::before {
  content: "\\f0154";
}

.mdi-clock-outline::before {
  content: "\\f0150";
}

.mdi-clock-start::before {
  content: "\\f0155";
}

.mdi-clock-time-eight::before {
  content: "\\f1446";
}

.mdi-clock-time-eight-outline::before {
  content: "\\f1452";
}

.mdi-clock-time-eleven::before {
  content: "\\f1449";
}

.mdi-clock-time-eleven-outline::before {
  content: "\\f1455";
}

.mdi-clock-time-five::before {
  content: "\\f1443";
}

.mdi-clock-time-five-outline::before {
  content: "\\f144f";
}

.mdi-clock-time-four::before {
  content: "\\f1442";
}

.mdi-clock-time-four-outline::before {
  content: "\\f144e";
}

.mdi-clock-time-nine::before {
  content: "\\f1447";
}

.mdi-clock-time-nine-outline::before {
  content: "\\f1453";
}

.mdi-clock-time-one::before {
  content: "\\f143f";
}

.mdi-clock-time-one-outline::before {
  content: "\\f144b";
}

.mdi-clock-time-seven::before {
  content: "\\f1445";
}

.mdi-clock-time-seven-outline::before {
  content: "\\f1451";
}

.mdi-clock-time-six::before {
  content: "\\f1444";
}

.mdi-clock-time-six-outline::before {
  content: "\\f1450";
}

.mdi-clock-time-ten::before {
  content: "\\f1448";
}

.mdi-clock-time-ten-outline::before {
  content: "\\f1454";
}

.mdi-clock-time-three::before {
  content: "\\f1441";
}

.mdi-clock-time-three-outline::before {
  content: "\\f144d";
}

.mdi-clock-time-twelve::before {
  content: "\\f144a";
}

.mdi-clock-time-twelve-outline::before {
  content: "\\f1456";
}

.mdi-clock-time-two::before {
  content: "\\f1440";
}

.mdi-clock-time-two-outline::before {
  content: "\\f144c";
}

.mdi-close::before {
  content: "\\f0156";
}

.mdi-close-box::before {
  content: "\\f0157";
}

.mdi-close-box-multiple::before {
  content: "\\f0c5d";
}

.mdi-close-box-multiple-outline::before {
  content: "\\f0c5e";
}

.mdi-close-box-outline::before {
  content: "\\f0158";
}

.mdi-close-circle::before {
  content: "\\f0159";
}

.mdi-close-circle-multiple::before {
  content: "\\f062a";
}

.mdi-close-circle-multiple-outline::before {
  content: "\\f0883";
}

.mdi-close-circle-outline::before {
  content: "\\f015a";
}

.mdi-close-network::before {
  content: "\\f015b";
}

.mdi-close-network-outline::before {
  content: "\\f0c5f";
}

.mdi-close-octagon::before {
  content: "\\f015c";
}

.mdi-close-octagon-outline::before {
  content: "\\f015d";
}

.mdi-close-outline::before {
  content: "\\f06c9";
}

.mdi-close-thick::before {
  content: "\\f1398";
}

.mdi-closed-caption::before {
  content: "\\f015e";
}

.mdi-closed-caption-outline::before {
  content: "\\f0dbd";
}

.mdi-cloud::before {
  content: "\\f015f";
}

.mdi-cloud-alert::before {
  content: "\\f09e0";
}

.mdi-cloud-braces::before {
  content: "\\f07b5";
}

.mdi-cloud-check::before {
  content: "\\f0160";
}

.mdi-cloud-check-outline::before {
  content: "\\f12cc";
}

.mdi-cloud-circle::before {
  content: "\\f0161";
}

.mdi-cloud-download::before {
  content: "\\f0162";
}

.mdi-cloud-download-outline::before {
  content: "\\f0b7d";
}

.mdi-cloud-lock::before {
  content: "\\f11f1";
}

.mdi-cloud-lock-outline::before {
  content: "\\f11f2";
}

.mdi-cloud-off-outline::before {
  content: "\\f0164";
}

.mdi-cloud-outline::before {
  content: "\\f0163";
}

.mdi-cloud-print::before {
  content: "\\f0165";
}

.mdi-cloud-print-outline::before {
  content: "\\f0166";
}

.mdi-cloud-question::before {
  content: "\\f0a39";
}

.mdi-cloud-refresh::before {
  content: "\\f052a";
}

.mdi-cloud-search::before {
  content: "\\f0956";
}

.mdi-cloud-search-outline::before {
  content: "\\f0957";
}

.mdi-cloud-sync::before {
  content: "\\f063f";
}

.mdi-cloud-sync-outline::before {
  content: "\\f12d6";
}

.mdi-cloud-tags::before {
  content: "\\f07b6";
}

.mdi-cloud-upload::before {
  content: "\\f0167";
}

.mdi-cloud-upload-outline::before {
  content: "\\f0b7e";
}

.mdi-clover::before {
  content: "\\f0816";
}

.mdi-coach-lamp::before {
  content: "\\f1020";
}

.mdi-coat-rack::before {
  content: "\\f109e";
}

.mdi-code-array::before {
  content: "\\f0168";
}

.mdi-code-braces::before {
  content: "\\f0169";
}

.mdi-code-braces-box::before {
  content: "\\f10d6";
}

.mdi-code-brackets::before {
  content: "\\f016a";
}

.mdi-code-equal::before {
  content: "\\f016b";
}

.mdi-code-greater-than::before {
  content: "\\f016c";
}

.mdi-code-greater-than-or-equal::before {
  content: "\\f016d";
}

.mdi-code-json::before {
  content: "\\f0626";
}

.mdi-code-less-than::before {
  content: "\\f016e";
}

.mdi-code-less-than-or-equal::before {
  content: "\\f016f";
}

.mdi-code-not-equal::before {
  content: "\\f0170";
}

.mdi-code-not-equal-variant::before {
  content: "\\f0171";
}

.mdi-code-parentheses::before {
  content: "\\f0172";
}

.mdi-code-parentheses-box::before {
  content: "\\f10d7";
}

.mdi-code-string::before {
  content: "\\f0173";
}

.mdi-code-tags::before {
  content: "\\f0174";
}

.mdi-code-tags-check::before {
  content: "\\f0694";
}

.mdi-codepen::before {
  content: "\\f0175";
}

.mdi-coffee::before {
  content: "\\f0176";
}

.mdi-coffee-maker::before {
  content: "\\f109f";
}

.mdi-coffee-off::before {
  content: "\\f0faa";
}

.mdi-coffee-off-outline::before {
  content: "\\f0fab";
}

.mdi-coffee-outline::before {
  content: "\\f06ca";
}

.mdi-coffee-to-go::before {
  content: "\\f0177";
}

.mdi-coffee-to-go-outline::before {
  content: "\\f130e";
}

.mdi-coffin::before {
  content: "\\f0b7f";
}

.mdi-cog::before {
  content: "\\f0493";
}

.mdi-cog-box::before {
  content: "\\f0494";
}

.mdi-cog-clockwise::before {
  content: "\\f11dd";
}

.mdi-cog-counterclockwise::before {
  content: "\\f11de";
}

.mdi-cog-off::before {
  content: "\\f13ce";
}

.mdi-cog-off-outline::before {
  content: "\\f13cf";
}

.mdi-cog-outline::before {
  content: "\\f08bb";
}

.mdi-cog-refresh::before {
  content: "\\f145e";
}

.mdi-cog-refresh-outline::before {
  content: "\\f145f";
}

.mdi-cog-sync::before {
  content: "\\f1460";
}

.mdi-cog-sync-outline::before {
  content: "\\f1461";
}

.mdi-cog-transfer::before {
  content: "\\f105b";
}

.mdi-cog-transfer-outline::before {
  content: "\\f105c";
}

.mdi-cogs::before {
  content: "\\f08d6";
}

.mdi-collage::before {
  content: "\\f0640";
}

.mdi-collapse-all::before {
  content: "\\f0aa6";
}

.mdi-collapse-all-outline::before {
  content: "\\f0aa7";
}

.mdi-color-helper::before {
  content: "\\f0179";
}

.mdi-comma::before {
  content: "\\f0e23";
}

.mdi-comma-box::before {
  content: "\\f0e2b";
}

.mdi-comma-box-outline::before {
  content: "\\f0e24";
}

.mdi-comma-circle::before {
  content: "\\f0e25";
}

.mdi-comma-circle-outline::before {
  content: "\\f0e26";
}

.mdi-comment::before {
  content: "\\f017a";
}

.mdi-comment-account::before {
  content: "\\f017b";
}

.mdi-comment-account-outline::before {
  content: "\\f017c";
}

.mdi-comment-alert::before {
  content: "\\f017d";
}

.mdi-comment-alert-outline::before {
  content: "\\f017e";
}

.mdi-comment-arrow-left::before {
  content: "\\f09e1";
}

.mdi-comment-arrow-left-outline::before {
  content: "\\f09e2";
}

.mdi-comment-arrow-right::before {
  content: "\\f09e3";
}

.mdi-comment-arrow-right-outline::before {
  content: "\\f09e4";
}

.mdi-comment-bookmark::before {
  content: "\\f15ae";
}

.mdi-comment-bookmark-outline::before {
  content: "\\f15af";
}

.mdi-comment-check::before {
  content: "\\f017f";
}

.mdi-comment-check-outline::before {
  content: "\\f0180";
}

.mdi-comment-edit::before {
  content: "\\f11bf";
}

.mdi-comment-edit-outline::before {
  content: "\\f12c4";
}

.mdi-comment-eye::before {
  content: "\\f0a3a";
}

.mdi-comment-eye-outline::before {
  content: "\\f0a3b";
}

.mdi-comment-flash::before {
  content: "\\f15b0";
}

.mdi-comment-flash-outline::before {
  content: "\\f15b1";
}

.mdi-comment-minus::before {
  content: "\\f15df";
}

.mdi-comment-minus-outline::before {
  content: "\\f15e0";
}

.mdi-comment-multiple::before {
  content: "\\f085f";
}

.mdi-comment-multiple-outline::before {
  content: "\\f0181";
}

.mdi-comment-off::before {
  content: "\\f15e1";
}

.mdi-comment-off-outline::before {
  content: "\\f15e2";
}

.mdi-comment-outline::before {
  content: "\\f0182";
}

.mdi-comment-plus::before {
  content: "\\f09e5";
}

.mdi-comment-plus-outline::before {
  content: "\\f0183";
}

.mdi-comment-processing::before {
  content: "\\f0184";
}

.mdi-comment-processing-outline::before {
  content: "\\f0185";
}

.mdi-comment-question::before {
  content: "\\f0817";
}

.mdi-comment-question-outline::before {
  content: "\\f0186";
}

.mdi-comment-quote::before {
  content: "\\f1021";
}

.mdi-comment-quote-outline::before {
  content: "\\f1022";
}

.mdi-comment-remove::before {
  content: "\\f05de";
}

.mdi-comment-remove-outline::before {
  content: "\\f0187";
}

.mdi-comment-search::before {
  content: "\\f0a3c";
}

.mdi-comment-search-outline::before {
  content: "\\f0a3d";
}

.mdi-comment-text::before {
  content: "\\f0188";
}

.mdi-comment-text-multiple::before {
  content: "\\f0860";
}

.mdi-comment-text-multiple-outline::before {
  content: "\\f0861";
}

.mdi-comment-text-outline::before {
  content: "\\f0189";
}

.mdi-compare::before {
  content: "\\f018a";
}

.mdi-compare-horizontal::before {
  content: "\\f1492";
}

.mdi-compare-vertical::before {
  content: "\\f1493";
}

.mdi-compass::before {
  content: "\\f018b";
}

.mdi-compass-off::before {
  content: "\\f0b80";
}

.mdi-compass-off-outline::before {
  content: "\\f0b81";
}

.mdi-compass-outline::before {
  content: "\\f018c";
}

.mdi-compass-rose::before {
  content: "\\f1382";
}

.mdi-concourse-ci::before {
  content: "\\f10a0";
}

.mdi-connection::before {
  content: "\\f1616";
}

.mdi-console::before {
  content: "\\f018d";
}

.mdi-console-line::before {
  content: "\\f07b7";
}

.mdi-console-network::before {
  content: "\\f08a9";
}

.mdi-console-network-outline::before {
  content: "\\f0c60";
}

.mdi-consolidate::before {
  content: "\\f10d8";
}

.mdi-contactless-payment::before {
  content: "\\f0d6a";
}

.mdi-contactless-payment-circle::before {
  content: "\\f0321";
}

.mdi-contactless-payment-circle-outline::before {
  content: "\\f0408";
}

.mdi-contacts::before {
  content: "\\f06cb";
}

.mdi-contacts-outline::before {
  content: "\\f05b8";
}

.mdi-contain::before {
  content: "\\f0a3e";
}

.mdi-contain-end::before {
  content: "\\f0a3f";
}

.mdi-contain-start::before {
  content: "\\f0a40";
}

.mdi-content-copy::before {
  content: "\\f018f";
}

.mdi-content-cut::before {
  content: "\\f0190";
}

.mdi-content-duplicate::before {
  content: "\\f0191";
}

.mdi-content-paste::before {
  content: "\\f0192";
}

.mdi-content-save::before {
  content: "\\f0193";
}

.mdi-content-save-alert::before {
  content: "\\f0f42";
}

.mdi-content-save-alert-outline::before {
  content: "\\f0f43";
}

.mdi-content-save-all::before {
  content: "\\f0194";
}

.mdi-content-save-all-outline::before {
  content: "\\f0f44";
}

.mdi-content-save-cog::before {
  content: "\\f145b";
}

.mdi-content-save-cog-outline::before {
  content: "\\f145c";
}

.mdi-content-save-edit::before {
  content: "\\f0cfb";
}

.mdi-content-save-edit-outline::before {
  content: "\\f0cfc";
}

.mdi-content-save-move::before {
  content: "\\f0e27";
}

.mdi-content-save-move-outline::before {
  content: "\\f0e28";
}

.mdi-content-save-off::before {
  content: "\\f1643";
}

.mdi-content-save-off-outline::before {
  content: "\\f1644";
}

.mdi-content-save-outline::before {
  content: "\\f0818";
}

.mdi-content-save-settings::before {
  content: "\\f061b";
}

.mdi-content-save-settings-outline::before {
  content: "\\f0b2e";
}

.mdi-contrast::before {
  content: "\\f0195";
}

.mdi-contrast-box::before {
  content: "\\f0196";
}

.mdi-contrast-circle::before {
  content: "\\f0197";
}

.mdi-controller-classic::before {
  content: "\\f0b82";
}

.mdi-controller-classic-outline::before {
  content: "\\f0b83";
}

.mdi-cookie::before {
  content: "\\f0198";
}

.mdi-cookie-alert::before {
  content: "\\f16d0";
}

.mdi-cookie-alert-outline::before {
  content: "\\f16d1";
}

.mdi-cookie-check::before {
  content: "\\f16d2";
}

.mdi-cookie-check-outline::before {
  content: "\\f16d3";
}

.mdi-cookie-clock::before {
  content: "\\f16e4";
}

.mdi-cookie-clock-outline::before {
  content: "\\f16e5";
}

.mdi-cookie-cog::before {
  content: "\\f16d4";
}

.mdi-cookie-cog-outline::before {
  content: "\\f16d5";
}

.mdi-cookie-edit::before {
  content: "\\f16e6";
}

.mdi-cookie-edit-outline::before {
  content: "\\f16e7";
}

.mdi-cookie-lock::before {
  content: "\\f16e8";
}

.mdi-cookie-lock-outline::before {
  content: "\\f16e9";
}

.mdi-cookie-minus::before {
  content: "\\f16da";
}

.mdi-cookie-minus-outline::before {
  content: "\\f16db";
}

.mdi-cookie-off::before {
  content: "\\f16ea";
}

.mdi-cookie-off-outline::before {
  content: "\\f16eb";
}

.mdi-cookie-outline::before {
  content: "\\f16de";
}

.mdi-cookie-plus::before {
  content: "\\f16d6";
}

.mdi-cookie-plus-outline::before {
  content: "\\f16d7";
}

.mdi-cookie-refresh::before {
  content: "\\f16ec";
}

.mdi-cookie-refresh-outline::before {
  content: "\\f16ed";
}

.mdi-cookie-remove::before {
  content: "\\f16d8";
}

.mdi-cookie-remove-outline::before {
  content: "\\f16d9";
}

.mdi-cookie-settings::before {
  content: "\\f16dc";
}

.mdi-cookie-settings-outline::before {
  content: "\\f16dd";
}

.mdi-coolant-temperature::before {
  content: "\\f03c8";
}

.mdi-copyright::before {
  content: "\\f05e6";
}

.mdi-cordova::before {
  content: "\\f0958";
}

.mdi-corn::before {
  content: "\\f07b8";
}

.mdi-corn-off::before {
  content: "\\f13ef";
}

.mdi-cosine-wave::before {
  content: "\\f1479";
}

.mdi-counter::before {
  content: "\\f0199";
}

.mdi-cow::before {
  content: "\\f019a";
}

.mdi-cpu-32-bit::before {
  content: "\\f0edf";
}

.mdi-cpu-64-bit::before {
  content: "\\f0ee0";
}

.mdi-crane::before {
  content: "\\f0862";
}

.mdi-creation::before {
  content: "\\f0674";
}

.mdi-creative-commons::before {
  content: "\\f0d6b";
}

.mdi-credit-card::before {
  content: "\\f0fef";
}

.mdi-credit-card-check::before {
  content: "\\f13d0";
}

.mdi-credit-card-check-outline::before {
  content: "\\f13d1";
}

.mdi-credit-card-clock::before {
  content: "\\f0ee1";
}

.mdi-credit-card-clock-outline::before {
  content: "\\f0ee2";
}

.mdi-credit-card-marker::before {
  content: "\\f06a8";
}

.mdi-credit-card-marker-outline::before {
  content: "\\f0dbe";
}

.mdi-credit-card-minus::before {
  content: "\\f0fac";
}

.mdi-credit-card-minus-outline::before {
  content: "\\f0fad";
}

.mdi-credit-card-multiple::before {
  content: "\\f0ff0";
}

.mdi-credit-card-multiple-outline::before {
  content: "\\f019c";
}

.mdi-credit-card-off::before {
  content: "\\f0ff1";
}

.mdi-credit-card-off-outline::before {
  content: "\\f05e4";
}

.mdi-credit-card-outline::before {
  content: "\\f019b";
}

.mdi-credit-card-plus::before {
  content: "\\f0ff2";
}

.mdi-credit-card-plus-outline::before {
  content: "\\f0676";
}

.mdi-credit-card-refresh::before {
  content: "\\f1645";
}

.mdi-credit-card-refresh-outline::before {
  content: "\\f1646";
}

.mdi-credit-card-refund::before {
  content: "\\f0ff3";
}

.mdi-credit-card-refund-outline::before {
  content: "\\f0aa8";
}

.mdi-credit-card-remove::before {
  content: "\\f0fae";
}

.mdi-credit-card-remove-outline::before {
  content: "\\f0faf";
}

.mdi-credit-card-scan::before {
  content: "\\f0ff4";
}

.mdi-credit-card-scan-outline::before {
  content: "\\f019d";
}

.mdi-credit-card-search::before {
  content: "\\f1647";
}

.mdi-credit-card-search-outline::before {
  content: "\\f1648";
}

.mdi-credit-card-settings::before {
  content: "\\f0ff5";
}

.mdi-credit-card-settings-outline::before {
  content: "\\f08d7";
}

.mdi-credit-card-sync::before {
  content: "\\f1649";
}

.mdi-credit-card-sync-outline::before {
  content: "\\f164a";
}

.mdi-credit-card-wireless::before {
  content: "\\f0802";
}

.mdi-credit-card-wireless-off::before {
  content: "\\f057a";
}

.mdi-credit-card-wireless-off-outline::before {
  content: "\\f057b";
}

.mdi-credit-card-wireless-outline::before {
  content: "\\f0d6c";
}

.mdi-cricket::before {
  content: "\\f0d6d";
}

.mdi-crop::before {
  content: "\\f019e";
}

.mdi-crop-free::before {
  content: "\\f019f";
}

.mdi-crop-landscape::before {
  content: "\\f01a0";
}

.mdi-crop-portrait::before {
  content: "\\f01a1";
}

.mdi-crop-rotate::before {
  content: "\\f0696";
}

.mdi-crop-square::before {
  content: "\\f01a2";
}

.mdi-crosshairs::before {
  content: "\\f01a3";
}

.mdi-crosshairs-gps::before {
  content: "\\f01a4";
}

.mdi-crosshairs-off::before {
  content: "\\f0f45";
}

.mdi-crosshairs-question::before {
  content: "\\f1136";
}

.mdi-crown::before {
  content: "\\f01a5";
}

.mdi-crown-outline::before {
  content: "\\f11d0";
}

.mdi-cryengine::before {
  content: "\\f0959";
}

.mdi-crystal-ball::before {
  content: "\\f0b2f";
}

.mdi-cube::before {
  content: "\\f01a6";
}

.mdi-cube-off::before {
  content: "\\f141c";
}

.mdi-cube-off-outline::before {
  content: "\\f141d";
}

.mdi-cube-outline::before {
  content: "\\f01a7";
}

.mdi-cube-scan::before {
  content: "\\f0b84";
}

.mdi-cube-send::before {
  content: "\\f01a8";
}

.mdi-cube-unfolded::before {
  content: "\\f01a9";
}

.mdi-cup::before {
  content: "\\f01aa";
}

.mdi-cup-off::before {
  content: "\\f05e5";
}

.mdi-cup-off-outline::before {
  content: "\\f137d";
}

.mdi-cup-outline::before {
  content: "\\f130f";
}

.mdi-cup-water::before {
  content: "\\f01ab";
}

.mdi-cupboard::before {
  content: "\\f0f46";
}

.mdi-cupboard-outline::before {
  content: "\\f0f47";
}

.mdi-cupcake::before {
  content: "\\f095a";
}

.mdi-curling::before {
  content: "\\f0863";
}

.mdi-currency-bdt::before {
  content: "\\f0864";
}

.mdi-currency-brl::before {
  content: "\\f0b85";
}

.mdi-currency-btc::before {
  content: "\\f01ac";
}

.mdi-currency-cny::before {
  content: "\\f07ba";
}

.mdi-currency-eth::before {
  content: "\\f07bb";
}

.mdi-currency-eur::before {
  content: "\\f01ad";
}

.mdi-currency-eur-off::before {
  content: "\\f1315";
}

.mdi-currency-gbp::before {
  content: "\\f01ae";
}

.mdi-currency-ils::before {
  content: "\\f0c61";
}

.mdi-currency-inr::before {
  content: "\\f01af";
}

.mdi-currency-jpy::before {
  content: "\\f07bc";
}

.mdi-currency-krw::before {
  content: "\\f07bd";
}

.mdi-currency-kzt::before {
  content: "\\f0865";
}

.mdi-currency-mnt::before {
  content: "\\f1512";
}

.mdi-currency-ngn::before {
  content: "\\f01b0";
}

.mdi-currency-php::before {
  content: "\\f09e6";
}

.mdi-currency-rial::before {
  content: "\\f0e9c";
}

.mdi-currency-rub::before {
  content: "\\f01b1";
}

.mdi-currency-sign::before {
  content: "\\f07be";
}

.mdi-currency-try::before {
  content: "\\f01b2";
}

.mdi-currency-twd::before {
  content: "\\f07bf";
}

.mdi-currency-usd::before {
  content: "\\f01c1";
}

.mdi-currency-usd-circle::before {
  content: "\\f116b";
}

.mdi-currency-usd-circle-outline::before {
  content: "\\f0178";
}

.mdi-currency-usd-off::before {
  content: "\\f067a";
}

.mdi-current-ac::before {
  content: "\\f1480";
}

.mdi-current-dc::before {
  content: "\\f095c";
}

.mdi-cursor-default::before {
  content: "\\f01c0";
}

.mdi-cursor-default-click::before {
  content: "\\f0cfd";
}

.mdi-cursor-default-click-outline::before {
  content: "\\f0cfe";
}

.mdi-cursor-default-gesture::before {
  content: "\\f1127";
}

.mdi-cursor-default-gesture-outline::before {
  content: "\\f1128";
}

.mdi-cursor-default-outline::before {
  content: "\\f01bf";
}

.mdi-cursor-move::before {
  content: "\\f01be";
}

.mdi-cursor-pointer::before {
  content: "\\f01bd";
}

.mdi-cursor-text::before {
  content: "\\f05e7";
}

.mdi-dance-ballroom::before {
  content: "\\f15fb";
}

.mdi-dance-pole::before {
  content: "\\f1578";
}

.mdi-data-matrix::before {
  content: "\\f153c";
}

.mdi-data-matrix-edit::before {
  content: "\\f153d";
}

.mdi-data-matrix-minus::before {
  content: "\\f153e";
}

.mdi-data-matrix-plus::before {
  content: "\\f153f";
}

.mdi-data-matrix-remove::before {
  content: "\\f1540";
}

.mdi-data-matrix-scan::before {
  content: "\\f1541";
}

.mdi-database::before {
  content: "\\f01bc";
}

.mdi-database-alert::before {
  content: "\\f163a";
}

.mdi-database-alert-outline::before {
  content: "\\f1624";
}

.mdi-database-arrow-down::before {
  content: "\\f163b";
}

.mdi-database-arrow-down-outline::before {
  content: "\\f1625";
}

.mdi-database-arrow-left::before {
  content: "\\f163c";
}

.mdi-database-arrow-left-outline::before {
  content: "\\f1626";
}

.mdi-database-arrow-right::before {
  content: "\\f163d";
}

.mdi-database-arrow-right-outline::before {
  content: "\\f1627";
}

.mdi-database-arrow-up::before {
  content: "\\f163e";
}

.mdi-database-arrow-up-outline::before {
  content: "\\f1628";
}

.mdi-database-check::before {
  content: "\\f0aa9";
}

.mdi-database-check-outline::before {
  content: "\\f1629";
}

.mdi-database-clock::before {
  content: "\\f163f";
}

.mdi-database-clock-outline::before {
  content: "\\f162a";
}

.mdi-database-cog::before {
  content: "\\f164b";
}

.mdi-database-cog-outline::before {
  content: "\\f164c";
}

.mdi-database-edit::before {
  content: "\\f0b86";
}

.mdi-database-edit-outline::before {
  content: "\\f162b";
}

.mdi-database-export::before {
  content: "\\f095e";
}

.mdi-database-export-outline::before {
  content: "\\f162c";
}

.mdi-database-import::before {
  content: "\\f095d";
}

.mdi-database-import-outline::before {
  content: "\\f162d";
}

.mdi-database-lock::before {
  content: "\\f0aaa";
}

.mdi-database-lock-outline::before {
  content: "\\f162e";
}

.mdi-database-marker::before {
  content: "\\f12f6";
}

.mdi-database-marker-outline::before {
  content: "\\f162f";
}

.mdi-database-minus::before {
  content: "\\f01bb";
}

.mdi-database-minus-outline::before {
  content: "\\f1630";
}

.mdi-database-off::before {
  content: "\\f1640";
}

.mdi-database-off-outline::before {
  content: "\\f1631";
}

.mdi-database-outline::before {
  content: "\\f1632";
}

.mdi-database-plus::before {
  content: "\\f01ba";
}

.mdi-database-plus-outline::before {
  content: "\\f1633";
}

.mdi-database-refresh::before {
  content: "\\f05c2";
}

.mdi-database-refresh-outline::before {
  content: "\\f1634";
}

.mdi-database-remove::before {
  content: "\\f0d00";
}

.mdi-database-remove-outline::before {
  content: "\\f1635";
}

.mdi-database-search::before {
  content: "\\f0866";
}

.mdi-database-search-outline::before {
  content: "\\f1636";
}

.mdi-database-settings::before {
  content: "\\f0d01";
}

.mdi-database-settings-outline::before {
  content: "\\f1637";
}

.mdi-database-sync::before {
  content: "\\f0cff";
}

.mdi-database-sync-outline::before {
  content: "\\f1638";
}

.mdi-death-star::before {
  content: "\\f08d8";
}

.mdi-death-star-variant::before {
  content: "\\f08d9";
}

.mdi-deathly-hallows::before {
  content: "\\f0b87";
}

.mdi-debian::before {
  content: "\\f08da";
}

.mdi-debug-step-into::before {
  content: "\\f01b9";
}

.mdi-debug-step-out::before {
  content: "\\f01b8";
}

.mdi-debug-step-over::before {
  content: "\\f01b7";
}

.mdi-decagram::before {
  content: "\\f076c";
}

.mdi-decagram-outline::before {
  content: "\\f076d";
}

.mdi-decimal::before {
  content: "\\f10a1";
}

.mdi-decimal-comma::before {
  content: "\\f10a2";
}

.mdi-decimal-comma-decrease::before {
  content: "\\f10a3";
}

.mdi-decimal-comma-increase::before {
  content: "\\f10a4";
}

.mdi-decimal-decrease::before {
  content: "\\f01b6";
}

.mdi-decimal-increase::before {
  content: "\\f01b5";
}

.mdi-delete::before {
  content: "\\f01b4";
}

.mdi-delete-alert::before {
  content: "\\f10a5";
}

.mdi-delete-alert-outline::before {
  content: "\\f10a6";
}

.mdi-delete-circle::before {
  content: "\\f0683";
}

.mdi-delete-circle-outline::before {
  content: "\\f0b88";
}

.mdi-delete-clock::before {
  content: "\\f1556";
}

.mdi-delete-clock-outline::before {
  content: "\\f1557";
}

.mdi-delete-empty::before {
  content: "\\f06cc";
}

.mdi-delete-empty-outline::before {
  content: "\\f0e9d";
}

.mdi-delete-forever::before {
  content: "\\f05e8";
}

.mdi-delete-forever-outline::before {
  content: "\\f0b89";
}

.mdi-delete-off::before {
  content: "\\f10a7";
}

.mdi-delete-off-outline::before {
  content: "\\f10a8";
}

.mdi-delete-outline::before {
  content: "\\f09e7";
}

.mdi-delete-restore::before {
  content: "\\f0819";
}

.mdi-delete-sweep::before {
  content: "\\f05e9";
}

.mdi-delete-sweep-outline::before {
  content: "\\f0c62";
}

.mdi-delete-variant::before {
  content: "\\f01b3";
}

.mdi-delta::before {
  content: "\\f01c2";
}

.mdi-desk::before {
  content: "\\f1239";
}

.mdi-desk-lamp::before {
  content: "\\f095f";
}

.mdi-deskphone::before {
  content: "\\f01c3";
}

.mdi-desktop-classic::before {
  content: "\\f07c0";
}

.mdi-desktop-mac::before {
  content: "\\f01c4";
}

.mdi-desktop-mac-dashboard::before {
  content: "\\f09e8";
}

.mdi-desktop-tower::before {
  content: "\\f01c5";
}

.mdi-desktop-tower-monitor::before {
  content: "\\f0aab";
}

.mdi-details::before {
  content: "\\f01c6";
}

.mdi-dev-to::before {
  content: "\\f0d6e";
}

.mdi-developer-board::before {
  content: "\\f0697";
}

.mdi-deviantart::before {
  content: "\\f01c7";
}

.mdi-devices::before {
  content: "\\f0fb0";
}

.mdi-diabetes::before {
  content: "\\f1126";
}

.mdi-dialpad::before {
  content: "\\f061c";
}

.mdi-diameter::before {
  content: "\\f0c63";
}

.mdi-diameter-outline::before {
  content: "\\f0c64";
}

.mdi-diameter-variant::before {
  content: "\\f0c65";
}

.mdi-diamond::before {
  content: "\\f0b8a";
}

.mdi-diamond-outline::before {
  content: "\\f0b8b";
}

.mdi-diamond-stone::before {
  content: "\\f01c8";
}

.mdi-dice-1::before {
  content: "\\f01ca";
}

.mdi-dice-1-outline::before {
  content: "\\f114a";
}

.mdi-dice-2::before {
  content: "\\f01cb";
}

.mdi-dice-2-outline::before {
  content: "\\f114b";
}

.mdi-dice-3::before {
  content: "\\f01cc";
}

.mdi-dice-3-outline::before {
  content: "\\f114c";
}

.mdi-dice-4::before {
  content: "\\f01cd";
}

.mdi-dice-4-outline::before {
  content: "\\f114d";
}

.mdi-dice-5::before {
  content: "\\f01ce";
}

.mdi-dice-5-outline::before {
  content: "\\f114e";
}

.mdi-dice-6::before {
  content: "\\f01cf";
}

.mdi-dice-6-outline::before {
  content: "\\f114f";
}

.mdi-dice-d10::before {
  content: "\\f1153";
}

.mdi-dice-d10-outline::before {
  content: "\\f076f";
}

.mdi-dice-d12::before {
  content: "\\f1154";
}

.mdi-dice-d12-outline::before {
  content: "\\f0867";
}

.mdi-dice-d20::before {
  content: "\\f1155";
}

.mdi-dice-d20-outline::before {
  content: "\\f05ea";
}

.mdi-dice-d4::before {
  content: "\\f1150";
}

.mdi-dice-d4-outline::before {
  content: "\\f05eb";
}

.mdi-dice-d6::before {
  content: "\\f1151";
}

.mdi-dice-d6-outline::before {
  content: "\\f05ed";
}

.mdi-dice-d8::before {
  content: "\\f1152";
}

.mdi-dice-d8-outline::before {
  content: "\\f05ec";
}

.mdi-dice-multiple::before {
  content: "\\f076e";
}

.mdi-dice-multiple-outline::before {
  content: "\\f1156";
}

.mdi-digital-ocean::before {
  content: "\\f1237";
}

.mdi-dip-switch::before {
  content: "\\f07c1";
}

.mdi-directions::before {
  content: "\\f01d0";
}

.mdi-directions-fork::before {
  content: "\\f0641";
}

.mdi-disc::before {
  content: "\\f05ee";
}

.mdi-disc-alert::before {
  content: "\\f01d1";
}

.mdi-disc-player::before {
  content: "\\f0960";
}

.mdi-discord::before {
  content: "\\f066f";
}

.mdi-dishwasher::before {
  content: "\\f0aac";
}

.mdi-dishwasher-alert::before {
  content: "\\f11b8";
}

.mdi-dishwasher-off::before {
  content: "\\f11b9";
}

.mdi-disqus::before {
  content: "\\f01d2";
}

.mdi-distribute-horizontal-center::before {
  content: "\\f11c9";
}

.mdi-distribute-horizontal-left::before {
  content: "\\f11c8";
}

.mdi-distribute-horizontal-right::before {
  content: "\\f11ca";
}

.mdi-distribute-vertical-bottom::before {
  content: "\\f11cb";
}

.mdi-distribute-vertical-center::before {
  content: "\\f11cc";
}

.mdi-distribute-vertical-top::before {
  content: "\\f11cd";
}

.mdi-diving-flippers::before {
  content: "\\f0dbf";
}

.mdi-diving-helmet::before {
  content: "\\f0dc0";
}

.mdi-diving-scuba::before {
  content: "\\f0dc1";
}

.mdi-diving-scuba-flag::before {
  content: "\\f0dc2";
}

.mdi-diving-scuba-tank::before {
  content: "\\f0dc3";
}

.mdi-diving-scuba-tank-multiple::before {
  content: "\\f0dc4";
}

.mdi-diving-snorkel::before {
  content: "\\f0dc5";
}

.mdi-division::before {
  content: "\\f01d4";
}

.mdi-division-box::before {
  content: "\\f01d5";
}

.mdi-dlna::before {
  content: "\\f0a41";
}

.mdi-dna::before {
  content: "\\f0684";
}

.mdi-dns::before {
  content: "\\f01d6";
}

.mdi-dns-outline::before {
  content: "\\f0b8c";
}

.mdi-do-not-disturb::before {
  content: "\\f0698";
}

.mdi-do-not-disturb-off::before {
  content: "\\f0699";
}

.mdi-dock-bottom::before {
  content: "\\f10a9";
}

.mdi-dock-left::before {
  content: "\\f10aa";
}

.mdi-dock-right::before {
  content: "\\f10ab";
}

.mdi-dock-top::before {
  content: "\\f1513";
}

.mdi-dock-window::before {
  content: "\\f10ac";
}

.mdi-docker::before {
  content: "\\f0868";
}

.mdi-doctor::before {
  content: "\\f0a42";
}

.mdi-dog::before {
  content: "\\f0a43";
}

.mdi-dog-service::before {
  content: "\\f0aad";
}

.mdi-dog-side::before {
  content: "\\f0a44";
}

.mdi-dog-side-off::before {
  content: "\\f16ee";
}

.mdi-dolby::before {
  content: "\\f06b3";
}

.mdi-dolly::before {
  content: "\\f0e9e";
}

.mdi-domain::before {
  content: "\\f01d7";
}

.mdi-domain-off::before {
  content: "\\f0d6f";
}

.mdi-domain-plus::before {
  content: "\\f10ad";
}

.mdi-domain-remove::before {
  content: "\\f10ae";
}

.mdi-dome-light::before {
  content: "\\f141e";
}

.mdi-domino-mask::before {
  content: "\\f1023";
}

.mdi-donkey::before {
  content: "\\f07c2";
}

.mdi-door::before {
  content: "\\f081a";
}

.mdi-door-closed::before {
  content: "\\f081b";
}

.mdi-door-closed-lock::before {
  content: "\\f10af";
}

.mdi-door-open::before {
  content: "\\f081c";
}

.mdi-doorbell::before {
  content: "\\f12e6";
}

.mdi-doorbell-video::before {
  content: "\\f0869";
}

.mdi-dot-net::before {
  content: "\\f0aae";
}

.mdi-dots-grid::before {
  content: "\\f15fc";
}

.mdi-dots-hexagon::before {
  content: "\\f15ff";
}

.mdi-dots-horizontal::before {
  content: "\\f01d8";
}

.mdi-dots-horizontal-circle::before {
  content: "\\f07c3";
}

.mdi-dots-horizontal-circle-outline::before {
  content: "\\f0b8d";
}

.mdi-dots-square::before {
  content: "\\f15fd";
}

.mdi-dots-triangle::before {
  content: "\\f15fe";
}

.mdi-dots-vertical::before {
  content: "\\f01d9";
}

.mdi-dots-vertical-circle::before {
  content: "\\f07c4";
}

.mdi-dots-vertical-circle-outline::before {
  content: "\\f0b8e";
}

.mdi-douban::before {
  content: "\\f069a";
}

.mdi-download::before {
  content: "\\f01da";
}

.mdi-download-box::before {
  content: "\\f1462";
}

.mdi-download-box-outline::before {
  content: "\\f1463";
}

.mdi-download-circle::before {
  content: "\\f1464";
}

.mdi-download-circle-outline::before {
  content: "\\f1465";
}

.mdi-download-lock::before {
  content: "\\f1320";
}

.mdi-download-lock-outline::before {
  content: "\\f1321";
}

.mdi-download-multiple::before {
  content: "\\f09e9";
}

.mdi-download-network::before {
  content: "\\f06f4";
}

.mdi-download-network-outline::before {
  content: "\\f0c66";
}

.mdi-download-off::before {
  content: "\\f10b0";
}

.mdi-download-off-outline::before {
  content: "\\f10b1";
}

.mdi-download-outline::before {
  content: "\\f0b8f";
}

.mdi-drag::before {
  content: "\\f01db";
}

.mdi-drag-horizontal::before {
  content: "\\f01dc";
}

.mdi-drag-horizontal-variant::before {
  content: "\\f12f0";
}

.mdi-drag-variant::before {
  content: "\\f0b90";
}

.mdi-drag-vertical::before {
  content: "\\f01dd";
}

.mdi-drag-vertical-variant::before {
  content: "\\f12f1";
}

.mdi-drama-masks::before {
  content: "\\f0d02";
}

.mdi-draw::before {
  content: "\\f0f49";
}

.mdi-drawing::before {
  content: "\\f01de";
}

.mdi-drawing-box::before {
  content: "\\f01df";
}

.mdi-dresser::before {
  content: "\\f0f4a";
}

.mdi-dresser-outline::before {
  content: "\\f0f4b";
}

.mdi-drone::before {
  content: "\\f01e2";
}

.mdi-dropbox::before {
  content: "\\f01e3";
}

.mdi-drupal::before {
  content: "\\f01e4";
}

.mdi-duck::before {
  content: "\\f01e5";
}

.mdi-dumbbell::before {
  content: "\\f01e6";
}

.mdi-dump-truck::before {
  content: "\\f0c67";
}

.mdi-ear-hearing::before {
  content: "\\f07c5";
}

.mdi-ear-hearing-off::before {
  content: "\\f0a45";
}

.mdi-earth::before {
  content: "\\f01e7";
}

.mdi-earth-arrow-right::before {
  content: "\\f1311";
}

.mdi-earth-box::before {
  content: "\\f06cd";
}

.mdi-earth-box-minus::before {
  content: "\\f1407";
}

.mdi-earth-box-off::before {
  content: "\\f06ce";
}

.mdi-earth-box-plus::before {
  content: "\\f1406";
}

.mdi-earth-box-remove::before {
  content: "\\f1408";
}

.mdi-earth-minus::before {
  content: "\\f1404";
}

.mdi-earth-off::before {
  content: "\\f01e8";
}

.mdi-earth-plus::before {
  content: "\\f1403";
}

.mdi-earth-remove::before {
  content: "\\f1405";
}

.mdi-egg::before {
  content: "\\f0aaf";
}

.mdi-egg-easter::before {
  content: "\\f0ab0";
}

.mdi-egg-off::before {
  content: "\\f13f0";
}

.mdi-egg-off-outline::before {
  content: "\\f13f1";
}

.mdi-egg-outline::before {
  content: "\\f13f2";
}

.mdi-eiffel-tower::before {
  content: "\\f156b";
}

.mdi-eight-track::before {
  content: "\\f09ea";
}

.mdi-eject::before {
  content: "\\f01ea";
}

.mdi-eject-outline::before {
  content: "\\f0b91";
}

.mdi-electric-switch::before {
  content: "\\f0e9f";
}

.mdi-electric-switch-closed::before {
  content: "\\f10d9";
}

.mdi-electron-framework::before {
  content: "\\f1024";
}

.mdi-elephant::before {
  content: "\\f07c6";
}

.mdi-elevation-decline::before {
  content: "\\f01eb";
}

.mdi-elevation-rise::before {
  content: "\\f01ec";
}

.mdi-elevator::before {
  content: "\\f01ed";
}

.mdi-elevator-down::before {
  content: "\\f12c2";
}

.mdi-elevator-passenger::before {
  content: "\\f1381";
}

.mdi-elevator-up::before {
  content: "\\f12c1";
}

.mdi-ellipse::before {
  content: "\\f0ea0";
}

.mdi-ellipse-outline::before {
  content: "\\f0ea1";
}

.mdi-email::before {
  content: "\\f01ee";
}

.mdi-email-alert::before {
  content: "\\f06cf";
}

.mdi-email-alert-outline::before {
  content: "\\f0d42";
}

.mdi-email-box::before {
  content: "\\f0d03";
}

.mdi-email-check::before {
  content: "\\f0ab1";
}

.mdi-email-check-outline::before {
  content: "\\f0ab2";
}

.mdi-email-edit::before {
  content: "\\f0ee3";
}

.mdi-email-edit-outline::before {
  content: "\\f0ee4";
}

.mdi-email-lock::before {
  content: "\\f01f1";
}

.mdi-email-mark-as-unread::before {
  content: "\\f0b92";
}

.mdi-email-minus::before {
  content: "\\f0ee5";
}

.mdi-email-minus-outline::before {
  content: "\\f0ee6";
}

.mdi-email-multiple::before {
  content: "\\f0ee7";
}

.mdi-email-multiple-outline::before {
  content: "\\f0ee8";
}

.mdi-email-newsletter::before {
  content: "\\f0fb1";
}

.mdi-email-off::before {
  content: "\\f13e3";
}

.mdi-email-off-outline::before {
  content: "\\f13e4";
}

.mdi-email-open::before {
  content: "\\f01ef";
}

.mdi-email-open-multiple::before {
  content: "\\f0ee9";
}

.mdi-email-open-multiple-outline::before {
  content: "\\f0eea";
}

.mdi-email-open-outline::before {
  content: "\\f05ef";
}

.mdi-email-outline::before {
  content: "\\f01f0";
}

.mdi-email-plus::before {
  content: "\\f09eb";
}

.mdi-email-plus-outline::before {
  content: "\\f09ec";
}

.mdi-email-receive::before {
  content: "\\f10da";
}

.mdi-email-receive-outline::before {
  content: "\\f10db";
}

.mdi-email-remove::before {
  content: "\\f1661";
}

.mdi-email-remove-outline::before {
  content: "\\f1662";
}

.mdi-email-search::before {
  content: "\\f0961";
}

.mdi-email-search-outline::before {
  content: "\\f0962";
}

.mdi-email-send::before {
  content: "\\f10dc";
}

.mdi-email-send-outline::before {
  content: "\\f10dd";
}

.mdi-email-sync::before {
  content: "\\f12c7";
}

.mdi-email-sync-outline::before {
  content: "\\f12c8";
}

.mdi-email-variant::before {
  content: "\\f05f0";
}

.mdi-ember::before {
  content: "\\f0b30";
}

.mdi-emby::before {
  content: "\\f06b4";
}

.mdi-emoticon::before {
  content: "\\f0c68";
}

.mdi-emoticon-angry::before {
  content: "\\f0c69";
}

.mdi-emoticon-angry-outline::before {
  content: "\\f0c6a";
}

.mdi-emoticon-confused::before {
  content: "\\f10de";
}

.mdi-emoticon-confused-outline::before {
  content: "\\f10df";
}

.mdi-emoticon-cool::before {
  content: "\\f0c6b";
}

.mdi-emoticon-cool-outline::before {
  content: "\\f01f3";
}

.mdi-emoticon-cry::before {
  content: "\\f0c6c";
}

.mdi-emoticon-cry-outline::before {
  content: "\\f0c6d";
}

.mdi-emoticon-dead::before {
  content: "\\f0c6e";
}

.mdi-emoticon-dead-outline::before {
  content: "\\f069b";
}

.mdi-emoticon-devil::before {
  content: "\\f0c6f";
}

.mdi-emoticon-devil-outline::before {
  content: "\\f01f4";
}

.mdi-emoticon-excited::before {
  content: "\\f0c70";
}

.mdi-emoticon-excited-outline::before {
  content: "\\f069c";
}

.mdi-emoticon-frown::before {
  content: "\\f0f4c";
}

.mdi-emoticon-frown-outline::before {
  content: "\\f0f4d";
}

.mdi-emoticon-happy::before {
  content: "\\f0c71";
}

.mdi-emoticon-happy-outline::before {
  content: "\\f01f5";
}

.mdi-emoticon-kiss::before {
  content: "\\f0c72";
}

.mdi-emoticon-kiss-outline::before {
  content: "\\f0c73";
}

.mdi-emoticon-lol::before {
  content: "\\f1214";
}

.mdi-emoticon-lol-outline::before {
  content: "\\f1215";
}

.mdi-emoticon-neutral::before {
  content: "\\f0c74";
}

.mdi-emoticon-neutral-outline::before {
  content: "\\f01f6";
}

.mdi-emoticon-outline::before {
  content: "\\f01f2";
}

.mdi-emoticon-poop::before {
  content: "\\f01f7";
}

.mdi-emoticon-poop-outline::before {
  content: "\\f0c75";
}

.mdi-emoticon-sad::before {
  content: "\\f0c76";
}

.mdi-emoticon-sad-outline::before {
  content: "\\f01f8";
}

.mdi-emoticon-sick::before {
  content: "\\f157c";
}

.mdi-emoticon-sick-outline::before {
  content: "\\f157d";
}

.mdi-emoticon-tongue::before {
  content: "\\f01f9";
}

.mdi-emoticon-tongue-outline::before {
  content: "\\f0c77";
}

.mdi-emoticon-wink::before {
  content: "\\f0c78";
}

.mdi-emoticon-wink-outline::before {
  content: "\\f0c79";
}

.mdi-engine::before {
  content: "\\f01fa";
}

.mdi-engine-off::before {
  content: "\\f0a46";
}

.mdi-engine-off-outline::before {
  content: "\\f0a47";
}

.mdi-engine-outline::before {
  content: "\\f01fb";
}

.mdi-epsilon::before {
  content: "\\f10e0";
}

.mdi-equal::before {
  content: "\\f01fc";
}

.mdi-equal-box::before {
  content: "\\f01fd";
}

.mdi-equalizer::before {
  content: "\\f0ea2";
}

.mdi-equalizer-outline::before {
  content: "\\f0ea3";
}

.mdi-eraser::before {
  content: "\\f01fe";
}

.mdi-eraser-variant::before {
  content: "\\f0642";
}

.mdi-escalator::before {
  content: "\\f01ff";
}

.mdi-escalator-box::before {
  content: "\\f1399";
}

.mdi-escalator-down::before {
  content: "\\f12c0";
}

.mdi-escalator-up::before {
  content: "\\f12bf";
}

.mdi-eslint::before {
  content: "\\f0c7a";
}

.mdi-et::before {
  content: "\\f0ab3";
}

.mdi-ethereum::before {
  content: "\\f086a";
}

.mdi-ethernet::before {
  content: "\\f0200";
}

.mdi-ethernet-cable::before {
  content: "\\f0201";
}

.mdi-ethernet-cable-off::before {
  content: "\\f0202";
}

.mdi-ev-plug-ccs1::before {
  content: "\\f1519";
}

.mdi-ev-plug-ccs2::before {
  content: "\\f151a";
}

.mdi-ev-plug-chademo::before {
  content: "\\f151b";
}

.mdi-ev-plug-tesla::before {
  content: "\\f151c";
}

.mdi-ev-plug-type1::before {
  content: "\\f151d";
}

.mdi-ev-plug-type2::before {
  content: "\\f151e";
}

.mdi-ev-station::before {
  content: "\\f05f1";
}

.mdi-evernote::before {
  content: "\\f0204";
}

.mdi-excavator::before {
  content: "\\f1025";
}

.mdi-exclamation::before {
  content: "\\f0205";
}

.mdi-exclamation-thick::before {
  content: "\\f1238";
}

.mdi-exit-run::before {
  content: "\\f0a48";
}

.mdi-exit-to-app::before {
  content: "\\f0206";
}

.mdi-expand-all::before {
  content: "\\f0ab4";
}

.mdi-expand-all-outline::before {
  content: "\\f0ab5";
}

.mdi-expansion-card::before {
  content: "\\f08ae";
}

.mdi-expansion-card-variant::before {
  content: "\\f0fb2";
}

.mdi-exponent::before {
  content: "\\f0963";
}

.mdi-exponent-box::before {
  content: "\\f0964";
}

.mdi-export::before {
  content: "\\f0207";
}

.mdi-export-variant::before {
  content: "\\f0b93";
}

.mdi-eye::before {
  content: "\\f0208";
}

.mdi-eye-check::before {
  content: "\\f0d04";
}

.mdi-eye-check-outline::before {
  content: "\\f0d05";
}

.mdi-eye-circle::before {
  content: "\\f0b94";
}

.mdi-eye-circle-outline::before {
  content: "\\f0b95";
}

.mdi-eye-minus::before {
  content: "\\f1026";
}

.mdi-eye-minus-outline::before {
  content: "\\f1027";
}

.mdi-eye-off::before {
  content: "\\f0209";
}

.mdi-eye-off-outline::before {
  content: "\\f06d1";
}

.mdi-eye-outline::before {
  content: "\\f06d0";
}

.mdi-eye-plus::before {
  content: "\\f086b";
}

.mdi-eye-plus-outline::before {
  content: "\\f086c";
}

.mdi-eye-remove::before {
  content: "\\f15e3";
}

.mdi-eye-remove-outline::before {
  content: "\\f15e4";
}

.mdi-eye-settings::before {
  content: "\\f086d";
}

.mdi-eye-settings-outline::before {
  content: "\\f086e";
}

.mdi-eyedropper::before {
  content: "\\f020a";
}

.mdi-eyedropper-minus::before {
  content: "\\f13dd";
}

.mdi-eyedropper-off::before {
  content: "\\f13df";
}

.mdi-eyedropper-plus::before {
  content: "\\f13dc";
}

.mdi-eyedropper-remove::before {
  content: "\\f13de";
}

.mdi-eyedropper-variant::before {
  content: "\\f020b";
}

.mdi-face::before {
  content: "\\f0643";
}

.mdi-face-agent::before {
  content: "\\f0d70";
}

.mdi-face-mask::before {
  content: "\\f1586";
}

.mdi-face-mask-outline::before {
  content: "\\f1587";
}

.mdi-face-outline::before {
  content: "\\f0b96";
}

.mdi-face-profile::before {
  content: "\\f0644";
}

.mdi-face-profile-woman::before {
  content: "\\f1076";
}

.mdi-face-recognition::before {
  content: "\\f0c7b";
}

.mdi-face-shimmer::before {
  content: "\\f15cc";
}

.mdi-face-shimmer-outline::before {
  content: "\\f15cd";
}

.mdi-face-woman::before {
  content: "\\f1077";
}

.mdi-face-woman-outline::before {
  content: "\\f1078";
}

.mdi-face-woman-shimmer::before {
  content: "\\f15ce";
}

.mdi-face-woman-shimmer-outline::before {
  content: "\\f15cf";
}

.mdi-facebook::before {
  content: "\\f020c";
}

.mdi-facebook-gaming::before {
  content: "\\f07dd";
}

.mdi-facebook-messenger::before {
  content: "\\f020e";
}

.mdi-facebook-workplace::before {
  content: "\\f0b31";
}

.mdi-factory::before {
  content: "\\f020f";
}

.mdi-family-tree::before {
  content: "\\f160e";
}

.mdi-fan::before {
  content: "\\f0210";
}

.mdi-fan-alert::before {
  content: "\\f146c";
}

.mdi-fan-auto::before {
  content: "\\f171d";
}

.mdi-fan-chevron-down::before {
  content: "\\f146d";
}

.mdi-fan-chevron-up::before {
  content: "\\f146e";
}

.mdi-fan-minus::before {
  content: "\\f1470";
}

.mdi-fan-off::before {
  content: "\\f081d";
}

.mdi-fan-plus::before {
  content: "\\f146f";
}

.mdi-fan-remove::before {
  content: "\\f1471";
}

.mdi-fan-speed-1::before {
  content: "\\f1472";
}

.mdi-fan-speed-2::before {
  content: "\\f1473";
}

.mdi-fan-speed-3::before {
  content: "\\f1474";
}

.mdi-fast-forward::before {
  content: "\\f0211";
}

.mdi-fast-forward-10::before {
  content: "\\f0d71";
}

.mdi-fast-forward-30::before {
  content: "\\f0d06";
}

.mdi-fast-forward-5::before {
  content: "\\f11f8";
}

.mdi-fast-forward-60::before {
  content: "\\f160b";
}

.mdi-fast-forward-outline::before {
  content: "\\f06d2";
}

.mdi-fax::before {
  content: "\\f0212";
}

.mdi-feather::before {
  content: "\\f06d3";
}

.mdi-feature-search::before {
  content: "\\f0a49";
}

.mdi-feature-search-outline::before {
  content: "\\f0a4a";
}

.mdi-fedora::before {
  content: "\\f08db";
}

.mdi-fencing::before {
  content: "\\f14c1";
}

.mdi-ferris-wheel::before {
  content: "\\f0ea4";
}

.mdi-ferry::before {
  content: "\\f0213";
}

.mdi-file::before {
  content: "\\f0214";
}

.mdi-file-account::before {
  content: "\\f073b";
}

.mdi-file-account-outline::before {
  content: "\\f1028";
}

.mdi-file-alert::before {
  content: "\\f0a4b";
}

.mdi-file-alert-outline::before {
  content: "\\f0a4c";
}

.mdi-file-cabinet::before {
  content: "\\f0ab6";
}

.mdi-file-cad::before {
  content: "\\f0eeb";
}

.mdi-file-cad-box::before {
  content: "\\f0eec";
}

.mdi-file-cancel::before {
  content: "\\f0dc6";
}

.mdi-file-cancel-outline::before {
  content: "\\f0dc7";
}

.mdi-file-certificate::before {
  content: "\\f1186";
}

.mdi-file-certificate-outline::before {
  content: "\\f1187";
}

.mdi-file-chart::before {
  content: "\\f0215";
}

.mdi-file-chart-outline::before {
  content: "\\f1029";
}

.mdi-file-check::before {
  content: "\\f0216";
}

.mdi-file-check-outline::before {
  content: "\\f0e29";
}

.mdi-file-clock::before {
  content: "\\f12e1";
}

.mdi-file-clock-outline::before {
  content: "\\f12e2";
}

.mdi-file-cloud::before {
  content: "\\f0217";
}

.mdi-file-cloud-outline::before {
  content: "\\f102a";
}

.mdi-file-code::before {
  content: "\\f022e";
}

.mdi-file-code-outline::before {
  content: "\\f102b";
}

.mdi-file-cog::before {
  content: "\\f107b";
}

.mdi-file-cog-outline::before {
  content: "\\f107c";
}

.mdi-file-compare::before {
  content: "\\f08aa";
}

.mdi-file-delimited::before {
  content: "\\f0218";
}

.mdi-file-delimited-outline::before {
  content: "\\f0ea5";
}

.mdi-file-document::before {
  content: "\\f0219";
}

.mdi-file-document-edit::before {
  content: "\\f0dc8";
}

.mdi-file-document-edit-outline::before {
  content: "\\f0dc9";
}

.mdi-file-document-multiple::before {
  content: "\\f1517";
}

.mdi-file-document-multiple-outline::before {
  content: "\\f1518";
}

.mdi-file-document-outline::before {
  content: "\\f09ee";
}

.mdi-file-download::before {
  content: "\\f0965";
}

.mdi-file-download-outline::before {
  content: "\\f0966";
}

.mdi-file-edit::before {
  content: "\\f11e7";
}

.mdi-file-edit-outline::before {
  content: "\\f11e8";
}

.mdi-file-excel::before {
  content: "\\f021b";
}

.mdi-file-excel-box::before {
  content: "\\f021c";
}

.mdi-file-excel-box-outline::before {
  content: "\\f102c";
}

.mdi-file-excel-outline::before {
  content: "\\f102d";
}

.mdi-file-export::before {
  content: "\\f021d";
}

.mdi-file-export-outline::before {
  content: "\\f102e";
}

.mdi-file-eye::before {
  content: "\\f0dca";
}

.mdi-file-eye-outline::before {
  content: "\\f0dcb";
}

.mdi-file-find::before {
  content: "\\f021e";
}

.mdi-file-find-outline::before {
  content: "\\f0b97";
}

.mdi-file-hidden::before {
  content: "\\f0613";
}

.mdi-file-image::before {
  content: "\\f021f";
}

.mdi-file-image-outline::before {
  content: "\\f0eb0";
}

.mdi-file-import::before {
  content: "\\f0220";
}

.mdi-file-import-outline::before {
  content: "\\f102f";
}

.mdi-file-key::before {
  content: "\\f1184";
}

.mdi-file-key-outline::before {
  content: "\\f1185";
}

.mdi-file-link::before {
  content: "\\f1177";
}

.mdi-file-link-outline::before {
  content: "\\f1178";
}

.mdi-file-lock::before {
  content: "\\f0221";
}

.mdi-file-lock-outline::before {
  content: "\\f1030";
}

.mdi-file-move::before {
  content: "\\f0ab9";
}

.mdi-file-move-outline::before {
  content: "\\f1031";
}

.mdi-file-multiple::before {
  content: "\\f0222";
}

.mdi-file-multiple-outline::before {
  content: "\\f1032";
}

.mdi-file-music::before {
  content: "\\f0223";
}

.mdi-file-music-outline::before {
  content: "\\f0e2a";
}

.mdi-file-outline::before {
  content: "\\f0224";
}

.mdi-file-pdf::before {
  content: "\\f0225";
}

.mdi-file-pdf-box::before {
  content: "\\f0226";
}

.mdi-file-pdf-box-outline::before {
  content: "\\f0fb3";
}

.mdi-file-pdf-outline::before {
  content: "\\f0e2d";
}

.mdi-file-percent::before {
  content: "\\f081e";
}

.mdi-file-percent-outline::before {
  content: "\\f1033";
}

.mdi-file-phone::before {
  content: "\\f1179";
}

.mdi-file-phone-outline::before {
  content: "\\f117a";
}

.mdi-file-plus::before {
  content: "\\f0752";
}

.mdi-file-plus-outline::before {
  content: "\\f0eed";
}

.mdi-file-powerpoint::before {
  content: "\\f0227";
}

.mdi-file-powerpoint-box::before {
  content: "\\f0228";
}

.mdi-file-powerpoint-box-outline::before {
  content: "\\f1034";
}

.mdi-file-powerpoint-outline::before {
  content: "\\f1035";
}

.mdi-file-presentation-box::before {
  content: "\\f0229";
}

.mdi-file-question::before {
  content: "\\f086f";
}

.mdi-file-question-outline::before {
  content: "\\f1036";
}

.mdi-file-refresh::before {
  content: "\\f0918";
}

.mdi-file-refresh-outline::before {
  content: "\\f0541";
}

.mdi-file-remove::before {
  content: "\\f0b98";
}

.mdi-file-remove-outline::before {
  content: "\\f1037";
}

.mdi-file-replace::before {
  content: "\\f0b32";
}

.mdi-file-replace-outline::before {
  content: "\\f0b33";
}

.mdi-file-restore::before {
  content: "\\f0670";
}

.mdi-file-restore-outline::before {
  content: "\\f1038";
}

.mdi-file-search::before {
  content: "\\f0c7c";
}

.mdi-file-search-outline::before {
  content: "\\f0c7d";
}

.mdi-file-send::before {
  content: "\\f022a";
}

.mdi-file-send-outline::before {
  content: "\\f1039";
}

.mdi-file-settings::before {
  content: "\\f1079";
}

.mdi-file-settings-outline::before {
  content: "\\f107a";
}

.mdi-file-star::before {
  content: "\\f103a";
}

.mdi-file-star-outline::before {
  content: "\\f103b";
}

.mdi-file-swap::before {
  content: "\\f0fb4";
}

.mdi-file-swap-outline::before {
  content: "\\f0fb5";
}

.mdi-file-sync::before {
  content: "\\f1216";
}

.mdi-file-sync-outline::before {
  content: "\\f1217";
}

.mdi-file-table::before {
  content: "\\f0c7e";
}

.mdi-file-table-box::before {
  content: "\\f10e1";
}

.mdi-file-table-box-multiple::before {
  content: "\\f10e2";
}

.mdi-file-table-box-multiple-outline::before {
  content: "\\f10e3";
}

.mdi-file-table-box-outline::before {
  content: "\\f10e4";
}

.mdi-file-table-outline::before {
  content: "\\f0c7f";
}

.mdi-file-tree::before {
  content: "\\f0645";
}

.mdi-file-tree-outline::before {
  content: "\\f13d2";
}

.mdi-file-undo::before {
  content: "\\f08dc";
}

.mdi-file-undo-outline::before {
  content: "\\f103c";
}

.mdi-file-upload::before {
  content: "\\f0a4d";
}

.mdi-file-upload-outline::before {
  content: "\\f0a4e";
}

.mdi-file-video::before {
  content: "\\f022b";
}

.mdi-file-video-outline::before {
  content: "\\f0e2c";
}

.mdi-file-word::before {
  content: "\\f022c";
}

.mdi-file-word-box::before {
  content: "\\f022d";
}

.mdi-file-word-box-outline::before {
  content: "\\f103d";
}

.mdi-file-word-outline::before {
  content: "\\f103e";
}

.mdi-film::before {
  content: "\\f022f";
}

.mdi-filmstrip::before {
  content: "\\f0230";
}

.mdi-filmstrip-box::before {
  content: "\\f0332";
}

.mdi-filmstrip-box-multiple::before {
  content: "\\f0d18";
}

.mdi-filmstrip-off::before {
  content: "\\f0231";
}

.mdi-filter::before {
  content: "\\f0232";
}

.mdi-filter-menu::before {
  content: "\\f10e5";
}

.mdi-filter-menu-outline::before {
  content: "\\f10e6";
}

.mdi-filter-minus::before {
  content: "\\f0eee";
}

.mdi-filter-minus-outline::before {
  content: "\\f0eef";
}

.mdi-filter-off::before {
  content: "\\f14ef";
}

.mdi-filter-off-outline::before {
  content: "\\f14f0";
}

.mdi-filter-outline::before {
  content: "\\f0233";
}

.mdi-filter-plus::before {
  content: "\\f0ef0";
}

.mdi-filter-plus-outline::before {
  content: "\\f0ef1";
}

.mdi-filter-remove::before {
  content: "\\f0234";
}

.mdi-filter-remove-outline::before {
  content: "\\f0235";
}

.mdi-filter-variant::before {
  content: "\\f0236";
}

.mdi-filter-variant-minus::before {
  content: "\\f1112";
}

.mdi-filter-variant-plus::before {
  content: "\\f1113";
}

.mdi-filter-variant-remove::before {
  content: "\\f103f";
}

.mdi-finance::before {
  content: "\\f081f";
}

.mdi-find-replace::before {
  content: "\\f06d4";
}

.mdi-fingerprint::before {
  content: "\\f0237";
}

.mdi-fingerprint-off::before {
  content: "\\f0eb1";
}

.mdi-fire::before {
  content: "\\f0238";
}

.mdi-fire-alert::before {
  content: "\\f15d7";
}

.mdi-fire-extinguisher::before {
  content: "\\f0ef2";
}

.mdi-fire-hydrant::before {
  content: "\\f1137";
}

.mdi-fire-hydrant-alert::before {
  content: "\\f1138";
}

.mdi-fire-hydrant-off::before {
  content: "\\f1139";
}

.mdi-fire-off::before {
  content: "\\f1722";
}

.mdi-fire-truck::before {
  content: "\\f08ab";
}

.mdi-firebase::before {
  content: "\\f0967";
}

.mdi-firefox::before {
  content: "\\f0239";
}

.mdi-fireplace::before {
  content: "\\f0e2e";
}

.mdi-fireplace-off::before {
  content: "\\f0e2f";
}

.mdi-firework::before {
  content: "\\f0e30";
}

.mdi-firework-off::before {
  content: "\\f1723";
}

.mdi-fish::before {
  content: "\\f023a";
}

.mdi-fish-off::before {
  content: "\\f13f3";
}

.mdi-fishbowl::before {
  content: "\\f0ef3";
}

.mdi-fishbowl-outline::before {
  content: "\\f0ef4";
}

.mdi-fit-to-page::before {
  content: "\\f0ef5";
}

.mdi-fit-to-page-outline::before {
  content: "\\f0ef6";
}

.mdi-flag::before {
  content: "\\f023b";
}

.mdi-flag-checkered::before {
  content: "\\f023c";
}

.mdi-flag-minus::before {
  content: "\\f0b99";
}

.mdi-flag-minus-outline::before {
  content: "\\f10b2";
}

.mdi-flag-outline::before {
  content: "\\f023d";
}

.mdi-flag-plus::before {
  content: "\\f0b9a";
}

.mdi-flag-plus-outline::before {
  content: "\\f10b3";
}

.mdi-flag-remove::before {
  content: "\\f0b9b";
}

.mdi-flag-remove-outline::before {
  content: "\\f10b4";
}

.mdi-flag-triangle::before {
  content: "\\f023f";
}

.mdi-flag-variant::before {
  content: "\\f0240";
}

.mdi-flag-variant-outline::before {
  content: "\\f023e";
}

.mdi-flare::before {
  content: "\\f0d72";
}

.mdi-flash::before {
  content: "\\f0241";
}

.mdi-flash-alert::before {
  content: "\\f0ef7";
}

.mdi-flash-alert-outline::before {
  content: "\\f0ef8";
}

.mdi-flash-auto::before {
  content: "\\f0242";
}

.mdi-flash-circle::before {
  content: "\\f0820";
}

.mdi-flash-off::before {
  content: "\\f0243";
}

.mdi-flash-outline::before {
  content: "\\f06d5";
}

.mdi-flash-red-eye::before {
  content: "\\f067b";
}

.mdi-flashlight::before {
  content: "\\f0244";
}

.mdi-flashlight-off::before {
  content: "\\f0245";
}

.mdi-flask::before {
  content: "\\f0093";
}

.mdi-flask-empty::before {
  content: "\\f0094";
}

.mdi-flask-empty-minus::before {
  content: "\\f123a";
}

.mdi-flask-empty-minus-outline::before {
  content: "\\f123b";
}

.mdi-flask-empty-off::before {
  content: "\\f13f4";
}

.mdi-flask-empty-off-outline::before {
  content: "\\f13f5";
}

.mdi-flask-empty-outline::before {
  content: "\\f0095";
}

.mdi-flask-empty-plus::before {
  content: "\\f123c";
}

.mdi-flask-empty-plus-outline::before {
  content: "\\f123d";
}

.mdi-flask-empty-remove::before {
  content: "\\f123e";
}

.mdi-flask-empty-remove-outline::before {
  content: "\\f123f";
}

.mdi-flask-minus::before {
  content: "\\f1240";
}

.mdi-flask-minus-outline::before {
  content: "\\f1241";
}

.mdi-flask-off::before {
  content: "\\f13f6";
}

.mdi-flask-off-outline::before {
  content: "\\f13f7";
}

.mdi-flask-outline::before {
  content: "\\f0096";
}

.mdi-flask-plus::before {
  content: "\\f1242";
}

.mdi-flask-plus-outline::before {
  content: "\\f1243";
}

.mdi-flask-remove::before {
  content: "\\f1244";
}

.mdi-flask-remove-outline::before {
  content: "\\f1245";
}

.mdi-flask-round-bottom::before {
  content: "\\f124b";
}

.mdi-flask-round-bottom-empty::before {
  content: "\\f124c";
}

.mdi-flask-round-bottom-empty-outline::before {
  content: "\\f124d";
}

.mdi-flask-round-bottom-outline::before {
  content: "\\f124e";
}

.mdi-fleur-de-lis::before {
  content: "\\f1303";
}

.mdi-flip-horizontal::before {
  content: "\\f10e7";
}

.mdi-flip-to-back::before {
  content: "\\f0247";
}

.mdi-flip-to-front::before {
  content: "\\f0248";
}

.mdi-flip-vertical::before {
  content: "\\f10e8";
}

.mdi-floor-lamp::before {
  content: "\\f08dd";
}

.mdi-floor-lamp-dual::before {
  content: "\\f1040";
}

.mdi-floor-lamp-variant::before {
  content: "\\f1041";
}

.mdi-floor-plan::before {
  content: "\\f0821";
}

.mdi-floppy::before {
  content: "\\f0249";
}

.mdi-floppy-variant::before {
  content: "\\f09ef";
}

.mdi-flower::before {
  content: "\\f024a";
}

.mdi-flower-outline::before {
  content: "\\f09f0";
}

.mdi-flower-poppy::before {
  content: "\\f0d08";
}

.mdi-flower-tulip::before {
  content: "\\f09f1";
}

.mdi-flower-tulip-outline::before {
  content: "\\f09f2";
}

.mdi-focus-auto::before {
  content: "\\f0f4e";
}

.mdi-focus-field::before {
  content: "\\f0f4f";
}

.mdi-focus-field-horizontal::before {
  content: "\\f0f50";
}

.mdi-focus-field-vertical::before {
  content: "\\f0f51";
}

.mdi-folder::before {
  content: "\\f024b";
}

.mdi-folder-account::before {
  content: "\\f024c";
}

.mdi-folder-account-outline::before {
  content: "\\f0b9c";
}

.mdi-folder-alert::before {
  content: "\\f0dcc";
}

.mdi-folder-alert-outline::before {
  content: "\\f0dcd";
}

.mdi-folder-clock::before {
  content: "\\f0aba";
}

.mdi-folder-clock-outline::before {
  content: "\\f0abb";
}

.mdi-folder-cog::before {
  content: "\\f107f";
}

.mdi-folder-cog-outline::before {
  content: "\\f1080";
}

.mdi-folder-download::before {
  content: "\\f024d";
}

.mdi-folder-download-outline::before {
  content: "\\f10e9";
}

.mdi-folder-edit::before {
  content: "\\f08de";
}

.mdi-folder-edit-outline::before {
  content: "\\f0dce";
}

.mdi-folder-google-drive::before {
  content: "\\f024e";
}

.mdi-folder-heart::before {
  content: "\\f10ea";
}

.mdi-folder-heart-outline::before {
  content: "\\f10eb";
}

.mdi-folder-home::before {
  content: "\\f10b5";
}

.mdi-folder-home-outline::before {
  content: "\\f10b6";
}

.mdi-folder-image::before {
  content: "\\f024f";
}

.mdi-folder-information::before {
  content: "\\f10b7";
}

.mdi-folder-information-outline::before {
  content: "\\f10b8";
}

.mdi-folder-key::before {
  content: "\\f08ac";
}

.mdi-folder-key-network::before {
  content: "\\f08ad";
}

.mdi-folder-key-network-outline::before {
  content: "\\f0c80";
}

.mdi-folder-key-outline::before {
  content: "\\f10ec";
}

.mdi-folder-lock::before {
  content: "\\f0250";
}

.mdi-folder-lock-open::before {
  content: "\\f0251";
}

.mdi-folder-marker::before {
  content: "\\f126d";
}

.mdi-folder-marker-outline::before {
  content: "\\f126e";
}

.mdi-folder-move::before {
  content: "\\f0252";
}

.mdi-folder-move-outline::before {
  content: "\\f1246";
}

.mdi-folder-multiple::before {
  content: "\\f0253";
}

.mdi-folder-multiple-image::before {
  content: "\\f0254";
}

.mdi-folder-multiple-outline::before {
  content: "\\f0255";
}

.mdi-folder-multiple-plus::before {
  content: "\\f147e";
}

.mdi-folder-multiple-plus-outline::before {
  content: "\\f147f";
}

.mdi-folder-music::before {
  content: "\\f1359";
}

.mdi-folder-music-outline::before {
  content: "\\f135a";
}

.mdi-folder-network::before {
  content: "\\f0870";
}

.mdi-folder-network-outline::before {
  content: "\\f0c81";
}

.mdi-folder-open::before {
  content: "\\f0770";
}

.mdi-folder-open-outline::before {
  content: "\\f0dcf";
}

.mdi-folder-outline::before {
  content: "\\f0256";
}

.mdi-folder-plus::before {
  content: "\\f0257";
}

.mdi-folder-plus-outline::before {
  content: "\\f0b9d";
}

.mdi-folder-pound::before {
  content: "\\f0d09";
}

.mdi-folder-pound-outline::before {
  content: "\\f0d0a";
}

.mdi-folder-refresh::before {
  content: "\\f0749";
}

.mdi-folder-refresh-outline::before {
  content: "\\f0542";
}

.mdi-folder-remove::before {
  content: "\\f0258";
}

.mdi-folder-remove-outline::before {
  content: "\\f0b9e";
}

.mdi-folder-search::before {
  content: "\\f0968";
}

.mdi-folder-search-outline::before {
  content: "\\f0969";
}

.mdi-folder-settings::before {
  content: "\\f107d";
}

.mdi-folder-settings-outline::before {
  content: "\\f107e";
}

.mdi-folder-star::before {
  content: "\\f069d";
}

.mdi-folder-star-multiple::before {
  content: "\\f13d3";
}

.mdi-folder-star-multiple-outline::before {
  content: "\\f13d4";
}

.mdi-folder-star-outline::before {
  content: "\\f0b9f";
}

.mdi-folder-swap::before {
  content: "\\f0fb6";
}

.mdi-folder-swap-outline::before {
  content: "\\f0fb7";
}

.mdi-folder-sync::before {
  content: "\\f0d0b";
}

.mdi-folder-sync-outline::before {
  content: "\\f0d0c";
}

.mdi-folder-table::before {
  content: "\\f12e3";
}

.mdi-folder-table-outline::before {
  content: "\\f12e4";
}

.mdi-folder-text::before {
  content: "\\f0c82";
}

.mdi-folder-text-outline::before {
  content: "\\f0c83";
}

.mdi-folder-upload::before {
  content: "\\f0259";
}

.mdi-folder-upload-outline::before {
  content: "\\f10ed";
}

.mdi-folder-zip::before {
  content: "\\f06eb";
}

.mdi-folder-zip-outline::before {
  content: "\\f07b9";
}

.mdi-font-awesome::before {
  content: "\\f003a";
}

.mdi-food::before {
  content: "\\f025a";
}

.mdi-food-apple::before {
  content: "\\f025b";
}

.mdi-food-apple-outline::before {
  content: "\\f0c84";
}

.mdi-food-croissant::before {
  content: "\\f07c8";
}

.mdi-food-drumstick::before {
  content: "\\f141f";
}

.mdi-food-drumstick-off::before {
  content: "\\f1468";
}

.mdi-food-drumstick-off-outline::before {
  content: "\\f1469";
}

.mdi-food-drumstick-outline::before {
  content: "\\f1420";
}

.mdi-food-fork-drink::before {
  content: "\\f05f2";
}

.mdi-food-halal::before {
  content: "\\f1572";
}

.mdi-food-kosher::before {
  content: "\\f1573";
}

.mdi-food-off::before {
  content: "\\f05f3";
}

.mdi-food-steak::before {
  content: "\\f146a";
}

.mdi-food-steak-off::before {
  content: "\\f146b";
}

.mdi-food-turkey::before {
  content: "\\f171c";
}

.mdi-food-variant::before {
  content: "\\f025c";
}

.mdi-food-variant-off::before {
  content: "\\f13e5";
}

.mdi-foot-print::before {
  content: "\\f0f52";
}

.mdi-football::before {
  content: "\\f025d";
}

.mdi-football-australian::before {
  content: "\\f025e";
}

.mdi-football-helmet::before {
  content: "\\f025f";
}

.mdi-forklift::before {
  content: "\\f07c9";
}

.mdi-form-dropdown::before {
  content: "\\f1400";
}

.mdi-form-select::before {
  content: "\\f1401";
}

.mdi-form-textarea::before {
  content: "\\f1095";
}

.mdi-form-textbox::before {
  content: "\\f060e";
}

.mdi-form-textbox-lock::before {
  content: "\\f135d";
}

.mdi-form-textbox-password::before {
  content: "\\f07f5";
}

.mdi-format-align-bottom::before {
  content: "\\f0753";
}

.mdi-format-align-center::before {
  content: "\\f0260";
}

.mdi-format-align-justify::before {
  content: "\\f0261";
}

.mdi-format-align-left::before {
  content: "\\f0262";
}

.mdi-format-align-middle::before {
  content: "\\f0754";
}

.mdi-format-align-right::before {
  content: "\\f0263";
}

.mdi-format-align-top::before {
  content: "\\f0755";
}

.mdi-format-annotation-minus::before {
  content: "\\f0abc";
}

.mdi-format-annotation-plus::before {
  content: "\\f0646";
}

.mdi-format-bold::before {
  content: "\\f0264";
}

.mdi-format-clear::before {
  content: "\\f0265";
}

.mdi-format-color-fill::before {
  content: "\\f0266";
}

.mdi-format-color-highlight::before {
  content: "\\f0e31";
}

.mdi-format-color-marker-cancel::before {
  content: "\\f1313";
}

.mdi-format-color-text::before {
  content: "\\f069e";
}

.mdi-format-columns::before {
  content: "\\f08df";
}

.mdi-format-float-center::before {
  content: "\\f0267";
}

.mdi-format-float-left::before {
  content: "\\f0268";
}

.mdi-format-float-none::before {
  content: "\\f0269";
}

.mdi-format-float-right::before {
  content: "\\f026a";
}

.mdi-format-font::before {
  content: "\\f06d6";
}

.mdi-format-font-size-decrease::before {
  content: "\\f09f3";
}

.mdi-format-font-size-increase::before {
  content: "\\f09f4";
}

.mdi-format-header-1::before {
  content: "\\f026b";
}

.mdi-format-header-2::before {
  content: "\\f026c";
}

.mdi-format-header-3::before {
  content: "\\f026d";
}

.mdi-format-header-4::before {
  content: "\\f026e";
}

.mdi-format-header-5::before {
  content: "\\f026f";
}

.mdi-format-header-6::before {
  content: "\\f0270";
}

.mdi-format-header-decrease::before {
  content: "\\f0271";
}

.mdi-format-header-equal::before {
  content: "\\f0272";
}

.mdi-format-header-increase::before {
  content: "\\f0273";
}

.mdi-format-header-pound::before {
  content: "\\f0274";
}

.mdi-format-horizontal-align-center::before {
  content: "\\f061e";
}

.mdi-format-horizontal-align-left::before {
  content: "\\f061f";
}

.mdi-format-horizontal-align-right::before {
  content: "\\f0620";
}

.mdi-format-indent-decrease::before {
  content: "\\f0275";
}

.mdi-format-indent-increase::before {
  content: "\\f0276";
}

.mdi-format-italic::before {
  content: "\\f0277";
}

.mdi-format-letter-case::before {
  content: "\\f0b34";
}

.mdi-format-letter-case-lower::before {
  content: "\\f0b35";
}

.mdi-format-letter-case-upper::before {
  content: "\\f0b36";
}

.mdi-format-letter-ends-with::before {
  content: "\\f0fb8";
}

.mdi-format-letter-matches::before {
  content: "\\f0fb9";
}

.mdi-format-letter-starts-with::before {
  content: "\\f0fba";
}

.mdi-format-line-spacing::before {
  content: "\\f0278";
}

.mdi-format-line-style::before {
  content: "\\f05c8";
}

.mdi-format-line-weight::before {
  content: "\\f05c9";
}

.mdi-format-list-bulleted::before {
  content: "\\f0279";
}

.mdi-format-list-bulleted-square::before {
  content: "\\f0dd0";
}

.mdi-format-list-bulleted-triangle::before {
  content: "\\f0eb2";
}

.mdi-format-list-bulleted-type::before {
  content: "\\f027a";
}

.mdi-format-list-checkbox::before {
  content: "\\f096a";
}

.mdi-format-list-checks::before {
  content: "\\f0756";
}

.mdi-format-list-numbered::before {
  content: "\\f027b";
}

.mdi-format-list-numbered-rtl::before {
  content: "\\f0d0d";
}

.mdi-format-list-text::before {
  content: "\\f126f";
}

.mdi-format-overline::before {
  content: "\\f0eb3";
}

.mdi-format-page-break::before {
  content: "\\f06d7";
}

.mdi-format-paint::before {
  content: "\\f027c";
}

.mdi-format-paragraph::before {
  content: "\\f027d";
}

.mdi-format-pilcrow::before {
  content: "\\f06d8";
}

.mdi-format-quote-close::before {
  content: "\\f027e";
}

.mdi-format-quote-close-outline::before {
  content: "\\f11a8";
}

.mdi-format-quote-open::before {
  content: "\\f0757";
}

.mdi-format-quote-open-outline::before {
  content: "\\f11a7";
}

.mdi-format-rotate-90::before {
  content: "\\f06aa";
}

.mdi-format-section::before {
  content: "\\f069f";
}

.mdi-format-size::before {
  content: "\\f027f";
}

.mdi-format-strikethrough::before {
  content: "\\f0280";
}

.mdi-format-strikethrough-variant::before {
  content: "\\f0281";
}

.mdi-format-subscript::before {
  content: "\\f0282";
}

.mdi-format-superscript::before {
  content: "\\f0283";
}

.mdi-format-text::before {
  content: "\\f0284";
}

.mdi-format-text-rotation-angle-down::before {
  content: "\\f0fbb";
}

.mdi-format-text-rotation-angle-up::before {
  content: "\\f0fbc";
}

.mdi-format-text-rotation-down::before {
  content: "\\f0d73";
}

.mdi-format-text-rotation-down-vertical::before {
  content: "\\f0fbd";
}

.mdi-format-text-rotation-none::before {
  content: "\\f0d74";
}

.mdi-format-text-rotation-up::before {
  content: "\\f0fbe";
}

.mdi-format-text-rotation-vertical::before {
  content: "\\f0fbf";
}

.mdi-format-text-variant::before {
  content: "\\f0e32";
}

.mdi-format-text-variant-outline::before {
  content: "\\f150f";
}

.mdi-format-text-wrapping-clip::before {
  content: "\\f0d0e";
}

.mdi-format-text-wrapping-overflow::before {
  content: "\\f0d0f";
}

.mdi-format-text-wrapping-wrap::before {
  content: "\\f0d10";
}

.mdi-format-textbox::before {
  content: "\\f0d11";
}

.mdi-format-textdirection-l-to-r::before {
  content: "\\f0285";
}

.mdi-format-textdirection-r-to-l::before {
  content: "\\f0286";
}

.mdi-format-title::before {
  content: "\\f05f4";
}

.mdi-format-underline::before {
  content: "\\f0287";
}

.mdi-format-vertical-align-bottom::before {
  content: "\\f0621";
}

.mdi-format-vertical-align-center::before {
  content: "\\f0622";
}

.mdi-format-vertical-align-top::before {
  content: "\\f0623";
}

.mdi-format-wrap-inline::before {
  content: "\\f0288";
}

.mdi-format-wrap-square::before {
  content: "\\f0289";
}

.mdi-format-wrap-tight::before {
  content: "\\f028a";
}

.mdi-format-wrap-top-bottom::before {
  content: "\\f028b";
}

.mdi-forum::before {
  content: "\\f028c";
}

.mdi-forum-outline::before {
  content: "\\f0822";
}

.mdi-forward::before {
  content: "\\f028d";
}

.mdi-forwardburger::before {
  content: "\\f0d75";
}

.mdi-fountain::before {
  content: "\\f096b";
}

.mdi-fountain-pen::before {
  content: "\\f0d12";
}

.mdi-fountain-pen-tip::before {
  content: "\\f0d13";
}

.mdi-freebsd::before {
  content: "\\f08e0";
}

.mdi-frequently-asked-questions::before {
  content: "\\f0eb4";
}

.mdi-fridge::before {
  content: "\\f0290";
}

.mdi-fridge-alert::before {
  content: "\\f11b1";
}

.mdi-fridge-alert-outline::before {
  content: "\\f11b2";
}

.mdi-fridge-bottom::before {
  content: "\\f0292";
}

.mdi-fridge-industrial::before {
  content: "\\f15ee";
}

.mdi-fridge-industrial-alert::before {
  content: "\\f15ef";
}

.mdi-fridge-industrial-alert-outline::before {
  content: "\\f15f0";
}

.mdi-fridge-industrial-off::before {
  content: "\\f15f1";
}

.mdi-fridge-industrial-off-outline::before {
  content: "\\f15f2";
}

.mdi-fridge-industrial-outline::before {
  content: "\\f15f3";
}

.mdi-fridge-off::before {
  content: "\\f11af";
}

.mdi-fridge-off-outline::before {
  content: "\\f11b0";
}

.mdi-fridge-outline::before {
  content: "\\f028f";
}

.mdi-fridge-top::before {
  content: "\\f0291";
}

.mdi-fridge-variant::before {
  content: "\\f15f4";
}

.mdi-fridge-variant-alert::before {
  content: "\\f15f5";
}

.mdi-fridge-variant-alert-outline::before {
  content: "\\f15f6";
}

.mdi-fridge-variant-off::before {
  content: "\\f15f7";
}

.mdi-fridge-variant-off-outline::before {
  content: "\\f15f8";
}

.mdi-fridge-variant-outline::before {
  content: "\\f15f9";
}

.mdi-fruit-cherries::before {
  content: "\\f1042";
}

.mdi-fruit-cherries-off::before {
  content: "\\f13f8";
}

.mdi-fruit-citrus::before {
  content: "\\f1043";
}

.mdi-fruit-citrus-off::before {
  content: "\\f13f9";
}

.mdi-fruit-grapes::before {
  content: "\\f1044";
}

.mdi-fruit-grapes-outline::before {
  content: "\\f1045";
}

.mdi-fruit-pineapple::before {
  content: "\\f1046";
}

.mdi-fruit-watermelon::before {
  content: "\\f1047";
}

.mdi-fuel::before {
  content: "\\f07ca";
}

.mdi-fullscreen::before {
  content: "\\f0293";
}

.mdi-fullscreen-exit::before {
  content: "\\f0294";
}

.mdi-function::before {
  content: "\\f0295";
}

.mdi-function-variant::before {
  content: "\\f0871";
}

.mdi-furigana-horizontal::before {
  content: "\\f1081";
}

.mdi-furigana-vertical::before {
  content: "\\f1082";
}

.mdi-fuse::before {
  content: "\\f0c85";
}

.mdi-fuse-alert::before {
  content: "\\f142d";
}

.mdi-fuse-blade::before {
  content: "\\f0c86";
}

.mdi-fuse-off::before {
  content: "\\f142c";
}

.mdi-gamepad::before {
  content: "\\f0296";
}

.mdi-gamepad-circle::before {
  content: "\\f0e33";
}

.mdi-gamepad-circle-down::before {
  content: "\\f0e34";
}

.mdi-gamepad-circle-left::before {
  content: "\\f0e35";
}

.mdi-gamepad-circle-outline::before {
  content: "\\f0e36";
}

.mdi-gamepad-circle-right::before {
  content: "\\f0e37";
}

.mdi-gamepad-circle-up::before {
  content: "\\f0e38";
}

.mdi-gamepad-down::before {
  content: "\\f0e39";
}

.mdi-gamepad-left::before {
  content: "\\f0e3a";
}

.mdi-gamepad-right::before {
  content: "\\f0e3b";
}

.mdi-gamepad-round::before {
  content: "\\f0e3c";
}

.mdi-gamepad-round-down::before {
  content: "\\f0e3d";
}

.mdi-gamepad-round-left::before {
  content: "\\f0e3e";
}

.mdi-gamepad-round-outline::before {
  content: "\\f0e3f";
}

.mdi-gamepad-round-right::before {
  content: "\\f0e40";
}

.mdi-gamepad-round-up::before {
  content: "\\f0e41";
}

.mdi-gamepad-square::before {
  content: "\\f0eb5";
}

.mdi-gamepad-square-outline::before {
  content: "\\f0eb6";
}

.mdi-gamepad-up::before {
  content: "\\f0e42";
}

.mdi-gamepad-variant::before {
  content: "\\f0297";
}

.mdi-gamepad-variant-outline::before {
  content: "\\f0eb7";
}

.mdi-gamma::before {
  content: "\\f10ee";
}

.mdi-gantry-crane::before {
  content: "\\f0dd1";
}

.mdi-garage::before {
  content: "\\f06d9";
}

.mdi-garage-alert::before {
  content: "\\f0872";
}

.mdi-garage-alert-variant::before {
  content: "\\f12d5";
}

.mdi-garage-open::before {
  content: "\\f06da";
}

.mdi-garage-open-variant::before {
  content: "\\f12d4";
}

.mdi-garage-variant::before {
  content: "\\f12d3";
}

.mdi-gas-cylinder::before {
  content: "\\f0647";
}

.mdi-gas-station::before {
  content: "\\f0298";
}

.mdi-gas-station-off::before {
  content: "\\f1409";
}

.mdi-gas-station-off-outline::before {
  content: "\\f140a";
}

.mdi-gas-station-outline::before {
  content: "\\f0eb8";
}

.mdi-gate::before {
  content: "\\f0299";
}

.mdi-gate-and::before {
  content: "\\f08e1";
}

.mdi-gate-arrow-right::before {
  content: "\\f1169";
}

.mdi-gate-nand::before {
  content: "\\f08e2";
}

.mdi-gate-nor::before {
  content: "\\f08e3";
}

.mdi-gate-not::before {
  content: "\\f08e4";
}

.mdi-gate-open::before {
  content: "\\f116a";
}

.mdi-gate-or::before {
  content: "\\f08e5";
}

.mdi-gate-xnor::before {
  content: "\\f08e6";
}

.mdi-gate-xor::before {
  content: "\\f08e7";
}

.mdi-gatsby::before {
  content: "\\f0e43";
}

.mdi-gauge::before {
  content: "\\f029a";
}

.mdi-gauge-empty::before {
  content: "\\f0873";
}

.mdi-gauge-full::before {
  content: "\\f0874";
}

.mdi-gauge-low::before {
  content: "\\f0875";
}

.mdi-gavel::before {
  content: "\\f029b";
}

.mdi-gender-female::before {
  content: "\\f029c";
}

.mdi-gender-male::before {
  content: "\\f029d";
}

.mdi-gender-male-female::before {
  content: "\\f029e";
}

.mdi-gender-male-female-variant::before {
  content: "\\f113f";
}

.mdi-gender-non-binary::before {
  content: "\\f1140";
}

.mdi-gender-transgender::before {
  content: "\\f029f";
}

.mdi-gentoo::before {
  content: "\\f08e8";
}

.mdi-gesture::before {
  content: "\\f07cb";
}

.mdi-gesture-double-tap::before {
  content: "\\f073c";
}

.mdi-gesture-pinch::before {
  content: "\\f0abd";
}

.mdi-gesture-spread::before {
  content: "\\f0abe";
}

.mdi-gesture-swipe::before {
  content: "\\f0d76";
}

.mdi-gesture-swipe-down::before {
  content: "\\f073d";
}

.mdi-gesture-swipe-horizontal::before {
  content: "\\f0abf";
}

.mdi-gesture-swipe-left::before {
  content: "\\f073e";
}

.mdi-gesture-swipe-right::before {
  content: "\\f073f";
}

.mdi-gesture-swipe-up::before {
  content: "\\f0740";
}

.mdi-gesture-swipe-vertical::before {
  content: "\\f0ac0";
}

.mdi-gesture-tap::before {
  content: "\\f0741";
}

.mdi-gesture-tap-box::before {
  content: "\\f12a9";
}

.mdi-gesture-tap-button::before {
  content: "\\f12a8";
}

.mdi-gesture-tap-hold::before {
  content: "\\f0d77";
}

.mdi-gesture-two-double-tap::before {
  content: "\\f0742";
}

.mdi-gesture-two-tap::before {
  content: "\\f0743";
}

.mdi-ghost::before {
  content: "\\f02a0";
}

.mdi-ghost-off::before {
  content: "\\f09f5";
}

.mdi-ghost-off-outline::before {
  content: "\\f165c";
}

.mdi-ghost-outline::before {
  content: "\\f165d";
}

.mdi-gif::before {
  content: "\\f0d78";
}

.mdi-gift::before {
  content: "\\f0e44";
}

.mdi-gift-off::before {
  content: "\\f16ef";
}

.mdi-gift-off-outline::before {
  content: "\\f16f0";
}

.mdi-gift-open::before {
  content: "\\f16f1";
}

.mdi-gift-open-outline::before {
  content: "\\f16f2";
}

.mdi-gift-outline::before {
  content: "\\f02a1";
}

.mdi-git::before {
  content: "\\f02a2";
}

.mdi-github::before {
  content: "\\f02a4";
}

.mdi-gitlab::before {
  content: "\\f0ba0";
}

.mdi-glass-cocktail::before {
  content: "\\f0356";
}

.mdi-glass-cocktail-off::before {
  content: "\\f15e6";
}

.mdi-glass-flute::before {
  content: "\\f02a5";
}

.mdi-glass-mug::before {
  content: "\\f02a6";
}

.mdi-glass-mug-off::before {
  content: "\\f15e7";
}

.mdi-glass-mug-variant::before {
  content: "\\f1116";
}

.mdi-glass-mug-variant-off::before {
  content: "\\f15e8";
}

.mdi-glass-pint-outline::before {
  content: "\\f130d";
}

.mdi-glass-stange::before {
  content: "\\f02a7";
}

.mdi-glass-tulip::before {
  content: "\\f02a8";
}

.mdi-glass-wine::before {
  content: "\\f0876";
}

.mdi-glasses::before {
  content: "\\f02aa";
}

.mdi-globe-light::before {
  content: "\\f12d7";
}

.mdi-globe-model::before {
  content: "\\f08e9";
}

.mdi-gmail::before {
  content: "\\f02ab";
}

.mdi-gnome::before {
  content: "\\f02ac";
}

.mdi-go-kart::before {
  content: "\\f0d79";
}

.mdi-go-kart-track::before {
  content: "\\f0d7a";
}

.mdi-gog::before {
  content: "\\f0ba1";
}

.mdi-gold::before {
  content: "\\f124f";
}

.mdi-golf::before {
  content: "\\f0823";
}

.mdi-golf-cart::before {
  content: "\\f11a4";
}

.mdi-golf-tee::before {
  content: "\\f1083";
}

.mdi-gondola::before {
  content: "\\f0686";
}

.mdi-goodreads::before {
  content: "\\f0d7b";
}

.mdi-google::before {
  content: "\\f02ad";
}

.mdi-google-ads::before {
  content: "\\f0c87";
}

.mdi-google-analytics::before {
  content: "\\f07cc";
}

.mdi-google-assistant::before {
  content: "\\f07cd";
}

.mdi-google-cardboard::before {
  content: "\\f02ae";
}

.mdi-google-chrome::before {
  content: "\\f02af";
}

.mdi-google-circles::before {
  content: "\\f02b0";
}

.mdi-google-circles-communities::before {
  content: "\\f02b1";
}

.mdi-google-circles-extended::before {
  content: "\\f02b2";
}

.mdi-google-circles-group::before {
  content: "\\f02b3";
}

.mdi-google-classroom::before {
  content: "\\f02c0";
}

.mdi-google-cloud::before {
  content: "\\f11f6";
}

.mdi-google-controller::before {
  content: "\\f02b4";
}

.mdi-google-controller-off::before {
  content: "\\f02b5";
}

.mdi-google-downasaur::before {
  content: "\\f1362";
}

.mdi-google-drive::before {
  content: "\\f02b6";
}

.mdi-google-earth::before {
  content: "\\f02b7";
}

.mdi-google-fit::before {
  content: "\\f096c";
}

.mdi-google-glass::before {
  content: "\\f02b8";
}

.mdi-google-hangouts::before {
  content: "\\f02c9";
}

.mdi-google-home::before {
  content: "\\f0824";
}

.mdi-google-keep::before {
  content: "\\f06dc";
}

.mdi-google-lens::before {
  content: "\\f09f6";
}

.mdi-google-maps::before {
  content: "\\f05f5";
}

.mdi-google-my-business::before {
  content: "\\f1048";
}

.mdi-google-nearby::before {
  content: "\\f02b9";
}

.mdi-google-photos::before {
  content: "\\f06dd";
}

.mdi-google-play::before {
  content: "\\f02bc";
}

.mdi-google-plus::before {
  content: "\\f02bd";
}

.mdi-google-podcast::before {
  content: "\\f0eb9";
}

.mdi-google-spreadsheet::before {
  content: "\\f09f7";
}

.mdi-google-street-view::before {
  content: "\\f0c88";
}

.mdi-google-translate::before {
  content: "\\f02bf";
}

.mdi-gradient::before {
  content: "\\f06a0";
}

.mdi-grain::before {
  content: "\\f0d7c";
}

.mdi-graph::before {
  content: "\\f1049";
}

.mdi-graph-outline::before {
  content: "\\f104a";
}

.mdi-graphql::before {
  content: "\\f0877";
}

.mdi-grass::before {
  content: "\\f1510";
}

.mdi-grave-stone::before {
  content: "\\f0ba2";
}

.mdi-grease-pencil::before {
  content: "\\f0648";
}

.mdi-greater-than::before {
  content: "\\f096d";
}

.mdi-greater-than-or-equal::before {
  content: "\\f096e";
}

.mdi-grid::before {
  content: "\\f02c1";
}

.mdi-grid-large::before {
  content: "\\f0758";
}

.mdi-grid-off::before {
  content: "\\f02c2";
}

.mdi-grill::before {
  content: "\\f0e45";
}

.mdi-grill-outline::before {
  content: "\\f118a";
}

.mdi-group::before {
  content: "\\f02c3";
}

.mdi-guitar-acoustic::before {
  content: "\\f0771";
}

.mdi-guitar-electric::before {
  content: "\\f02c4";
}

.mdi-guitar-pick::before {
  content: "\\f02c5";
}

.mdi-guitar-pick-outline::before {
  content: "\\f02c6";
}

.mdi-guy-fawkes-mask::before {
  content: "\\f0825";
}

.mdi-hail::before {
  content: "\\f0ac1";
}

.mdi-hair-dryer::before {
  content: "\\f10ef";
}

.mdi-hair-dryer-outline::before {
  content: "\\f10f0";
}

.mdi-halloween::before {
  content: "\\f0ba3";
}

.mdi-hamburger::before {
  content: "\\f0685";
}

.mdi-hammer::before {
  content: "\\f08ea";
}

.mdi-hammer-screwdriver::before {
  content: "\\f1322";
}

.mdi-hammer-wrench::before {
  content: "\\f1323";
}

.mdi-hand::before {
  content: "\\f0a4f";
}

.mdi-hand-heart::before {
  content: "\\f10f1";
}

.mdi-hand-heart-outline::before {
  content: "\\f157e";
}

.mdi-hand-left::before {
  content: "\\f0e46";
}

.mdi-hand-okay::before {
  content: "\\f0a50";
}

.mdi-hand-peace::before {
  content: "\\f0a51";
}

.mdi-hand-peace-variant::before {
  content: "\\f0a52";
}

.mdi-hand-pointing-down::before {
  content: "\\f0a53";
}

.mdi-hand-pointing-left::before {
  content: "\\f0a54";
}

.mdi-hand-pointing-right::before {
  content: "\\f02c7";
}

.mdi-hand-pointing-up::before {
  content: "\\f0a55";
}

.mdi-hand-right::before {
  content: "\\f0e47";
}

.mdi-hand-saw::before {
  content: "\\f0e48";
}

.mdi-hand-wash::before {
  content: "\\f157f";
}

.mdi-hand-wash-outline::before {
  content: "\\f1580";
}

.mdi-hand-water::before {
  content: "\\f139f";
}

.mdi-handball::before {
  content: "\\f0f53";
}

.mdi-handcuffs::before {
  content: "\\f113e";
}

.mdi-handshake::before {
  content: "\\f1218";
}

.mdi-handshake-outline::before {
  content: "\\f15a1";
}

.mdi-hanger::before {
  content: "\\f02c8";
}

.mdi-hard-hat::before {
  content: "\\f096f";
}

.mdi-harddisk::before {
  content: "\\f02ca";
}

.mdi-harddisk-plus::before {
  content: "\\f104b";
}

.mdi-harddisk-remove::before {
  content: "\\f104c";
}

.mdi-hat-fedora::before {
  content: "\\f0ba4";
}

.mdi-hazard-lights::before {
  content: "\\f0c89";
}

.mdi-hdr::before {
  content: "\\f0d7d";
}

.mdi-hdr-off::before {
  content: "\\f0d7e";
}

.mdi-head::before {
  content: "\\f135e";
}

.mdi-head-alert::before {
  content: "\\f1338";
}

.mdi-head-alert-outline::before {
  content: "\\f1339";
}

.mdi-head-check::before {
  content: "\\f133a";
}

.mdi-head-check-outline::before {
  content: "\\f133b";
}

.mdi-head-cog::before {
  content: "\\f133c";
}

.mdi-head-cog-outline::before {
  content: "\\f133d";
}

.mdi-head-dots-horizontal::before {
  content: "\\f133e";
}

.mdi-head-dots-horizontal-outline::before {
  content: "\\f133f";
}

.mdi-head-flash::before {
  content: "\\f1340";
}

.mdi-head-flash-outline::before {
  content: "\\f1341";
}

.mdi-head-heart::before {
  content: "\\f1342";
}

.mdi-head-heart-outline::before {
  content: "\\f1343";
}

.mdi-head-lightbulb::before {
  content: "\\f1344";
}

.mdi-head-lightbulb-outline::before {
  content: "\\f1345";
}

.mdi-head-minus::before {
  content: "\\f1346";
}

.mdi-head-minus-outline::before {
  content: "\\f1347";
}

.mdi-head-outline::before {
  content: "\\f135f";
}

.mdi-head-plus::before {
  content: "\\f1348";
}

.mdi-head-plus-outline::before {
  content: "\\f1349";
}

.mdi-head-question::before {
  content: "\\f134a";
}

.mdi-head-question-outline::before {
  content: "\\f134b";
}

.mdi-head-remove::before {
  content: "\\f134c";
}

.mdi-head-remove-outline::before {
  content: "\\f134d";
}

.mdi-head-snowflake::before {
  content: "\\f134e";
}

.mdi-head-snowflake-outline::before {
  content: "\\f134f";
}

.mdi-head-sync::before {
  content: "\\f1350";
}

.mdi-head-sync-outline::before {
  content: "\\f1351";
}

.mdi-headphones::before {
  content: "\\f02cb";
}

.mdi-headphones-bluetooth::before {
  content: "\\f0970";
}

.mdi-headphones-box::before {
  content: "\\f02cc";
}

.mdi-headphones-off::before {
  content: "\\f07ce";
}

.mdi-headphones-settings::before {
  content: "\\f02cd";
}

.mdi-headset::before {
  content: "\\f02ce";
}

.mdi-headset-dock::before {
  content: "\\f02cf";
}

.mdi-headset-off::before {
  content: "\\f02d0";
}

.mdi-heart::before {
  content: "\\f02d1";
}

.mdi-heart-box::before {
  content: "\\f02d2";
}

.mdi-heart-box-outline::before {
  content: "\\f02d3";
}

.mdi-heart-broken::before {
  content: "\\f02d4";
}

.mdi-heart-broken-outline::before {
  content: "\\f0d14";
}

.mdi-heart-circle::before {
  content: "\\f0971";
}

.mdi-heart-circle-outline::before {
  content: "\\f0972";
}

.mdi-heart-cog::before {
  content: "\\f1663";
}

.mdi-heart-cog-outline::before {
  content: "\\f1664";
}

.mdi-heart-flash::before {
  content: "\\f0ef9";
}

.mdi-heart-half::before {
  content: "\\f06df";
}

.mdi-heart-half-full::before {
  content: "\\f06de";
}

.mdi-heart-half-outline::before {
  content: "\\f06e0";
}

.mdi-heart-minus::before {
  content: "\\f142f";
}

.mdi-heart-minus-outline::before {
  content: "\\f1432";
}

.mdi-heart-multiple::before {
  content: "\\f0a56";
}

.mdi-heart-multiple-outline::before {
  content: "\\f0a57";
}

.mdi-heart-off::before {
  content: "\\f0759";
}

.mdi-heart-off-outline::before {
  content: "\\f1434";
}

.mdi-heart-outline::before {
  content: "\\f02d5";
}

.mdi-heart-plus::before {
  content: "\\f142e";
}

.mdi-heart-plus-outline::before {
  content: "\\f1431";
}

.mdi-heart-pulse::before {
  content: "\\f05f6";
}

.mdi-heart-remove::before {
  content: "\\f1430";
}

.mdi-heart-remove-outline::before {
  content: "\\f1433";
}

.mdi-heart-settings::before {
  content: "\\f1665";
}

.mdi-heart-settings-outline::before {
  content: "\\f1666";
}

.mdi-helicopter::before {
  content: "\\f0ac2";
}

.mdi-help::before {
  content: "\\f02d6";
}

.mdi-help-box::before {
  content: "\\f078b";
}

.mdi-help-circle::before {
  content: "\\f02d7";
}

.mdi-help-circle-outline::before {
  content: "\\f0625";
}

.mdi-help-network::before {
  content: "\\f06f5";
}

.mdi-help-network-outline::before {
  content: "\\f0c8a";
}

.mdi-help-rhombus::before {
  content: "\\f0ba5";
}

.mdi-help-rhombus-outline::before {
  content: "\\f0ba6";
}

.mdi-hexadecimal::before {
  content: "\\f12a7";
}

.mdi-hexagon::before {
  content: "\\f02d8";
}

.mdi-hexagon-multiple::before {
  content: "\\f06e1";
}

.mdi-hexagon-multiple-outline::before {
  content: "\\f10f2";
}

.mdi-hexagon-outline::before {
  content: "\\f02d9";
}

.mdi-hexagon-slice-1::before {
  content: "\\f0ac3";
}

.mdi-hexagon-slice-2::before {
  content: "\\f0ac4";
}

.mdi-hexagon-slice-3::before {
  content: "\\f0ac5";
}

.mdi-hexagon-slice-4::before {
  content: "\\f0ac6";
}

.mdi-hexagon-slice-5::before {
  content: "\\f0ac7";
}

.mdi-hexagon-slice-6::before {
  content: "\\f0ac8";
}

.mdi-hexagram::before {
  content: "\\f0ac9";
}

.mdi-hexagram-outline::before {
  content: "\\f0aca";
}

.mdi-high-definition::before {
  content: "\\f07cf";
}

.mdi-high-definition-box::before {
  content: "\\f0878";
}

.mdi-highway::before {
  content: "\\f05f7";
}

.mdi-hiking::before {
  content: "\\f0d7f";
}

.mdi-hinduism::before {
  content: "\\f0973";
}

.mdi-history::before {
  content: "\\f02da";
}

.mdi-hockey-puck::before {
  content: "\\f0879";
}

.mdi-hockey-sticks::before {
  content: "\\f087a";
}

.mdi-hololens::before {
  content: "\\f02db";
}

.mdi-home::before {
  content: "\\f02dc";
}

.mdi-home-account::before {
  content: "\\f0826";
}

.mdi-home-alert::before {
  content: "\\f087b";
}

.mdi-home-alert-outline::before {
  content: "\\f15d0";
}

.mdi-home-analytics::before {
  content: "\\f0eba";
}

.mdi-home-assistant::before {
  content: "\\f07d0";
}

.mdi-home-automation::before {
  content: "\\f07d1";
}

.mdi-home-circle::before {
  content: "\\f07d2";
}

.mdi-home-circle-outline::before {
  content: "\\f104d";
}

.mdi-home-city::before {
  content: "\\f0d15";
}

.mdi-home-city-outline::before {
  content: "\\f0d16";
}

.mdi-home-currency-usd::before {
  content: "\\f08af";
}

.mdi-home-edit::before {
  content: "\\f1159";
}

.mdi-home-edit-outline::before {
  content: "\\f115a";
}

.mdi-home-export-outline::before {
  content: "\\f0f9b";
}

.mdi-home-flood::before {
  content: "\\f0efa";
}

.mdi-home-floor-0::before {
  content: "\\f0dd2";
}

.mdi-home-floor-1::before {
  content: "\\f0d80";
}

.mdi-home-floor-2::before {
  content: "\\f0d81";
}

.mdi-home-floor-3::before {
  content: "\\f0d82";
}

.mdi-home-floor-a::before {
  content: "\\f0d83";
}

.mdi-home-floor-b::before {
  content: "\\f0d84";
}

.mdi-home-floor-g::before {
  content: "\\f0d85";
}

.mdi-home-floor-l::before {
  content: "\\f0d86";
}

.mdi-home-floor-negative-1::before {
  content: "\\f0dd3";
}

.mdi-home-group::before {
  content: "\\f0dd4";
}

.mdi-home-heart::before {
  content: "\\f0827";
}

.mdi-home-import-outline::before {
  content: "\\f0f9c";
}

.mdi-home-lightbulb::before {
  content: "\\f1251";
}

.mdi-home-lightbulb-outline::before {
  content: "\\f1252";
}

.mdi-home-lock::before {
  content: "\\f08eb";
}

.mdi-home-lock-open::before {
  content: "\\f08ec";
}

.mdi-home-map-marker::before {
  content: "\\f05f8";
}

.mdi-home-minus::before {
  content: "\\f0974";
}

.mdi-home-minus-outline::before {
  content: "\\f13d5";
}

.mdi-home-modern::before {
  content: "\\f02dd";
}

.mdi-home-outline::before {
  content: "\\f06a1";
}

.mdi-home-plus::before {
  content: "\\f0975";
}

.mdi-home-plus-outline::before {
  content: "\\f13d6";
}

.mdi-home-remove::before {
  content: "\\f1247";
}

.mdi-home-remove-outline::before {
  content: "\\f13d7";
}

.mdi-home-roof::before {
  content: "\\f112b";
}

.mdi-home-search::before {
  content: "\\f13b0";
}

.mdi-home-search-outline::before {
  content: "\\f13b1";
}

.mdi-home-thermometer::before {
  content: "\\f0f54";
}

.mdi-home-thermometer-outline::before {
  content: "\\f0f55";
}

.mdi-home-variant::before {
  content: "\\f02de";
}

.mdi-home-variant-outline::before {
  content: "\\f0ba7";
}

.mdi-hook::before {
  content: "\\f06e2";
}

.mdi-hook-off::before {
  content: "\\f06e3";
}

.mdi-hops::before {
  content: "\\f02df";
}

.mdi-horizontal-rotate-clockwise::before {
  content: "\\f10f3";
}

.mdi-horizontal-rotate-counterclockwise::before {
  content: "\\f10f4";
}

.mdi-horse::before {
  content: "\\f15bf";
}

.mdi-horse-human::before {
  content: "\\f15c0";
}

.mdi-horse-variant::before {
  content: "\\f15c1";
}

.mdi-horseshoe::before {
  content: "\\f0a58";
}

.mdi-hospital::before {
  content: "\\f0ff6";
}

.mdi-hospital-box::before {
  content: "\\f02e0";
}

.mdi-hospital-box-outline::before {
  content: "\\f0ff7";
}

.mdi-hospital-building::before {
  content: "\\f02e1";
}

.mdi-hospital-marker::before {
  content: "\\f02e2";
}

.mdi-hot-tub::before {
  content: "\\f0828";
}

.mdi-hours-24::before {
  content: "\\f1478";
}

.mdi-hubspot::before {
  content: "\\f0d17";
}

.mdi-hulu::before {
  content: "\\f0829";
}

.mdi-human::before {
  content: "\\f02e6";
}

.mdi-human-baby-changing-table::before {
  content: "\\f138b";
}

.mdi-human-cane::before {
  content: "\\f1581";
}

.mdi-human-capacity-decrease::before {
  content: "\\f159b";
}

.mdi-human-capacity-increase::before {
  content: "\\f159c";
}

.mdi-human-child::before {
  content: "\\f02e7";
}

.mdi-human-edit::before {
  content: "\\f14e8";
}

.mdi-human-female::before {
  content: "\\f0649";
}

.mdi-human-female-boy::before {
  content: "\\f0a59";
}

.mdi-human-female-dance::before {
  content: "\\f15c9";
}

.mdi-human-female-female::before {
  content: "\\f0a5a";
}

.mdi-human-female-girl::before {
  content: "\\f0a5b";
}

.mdi-human-greeting::before {
  content: "\\f064a";
}

.mdi-human-greeting-proximity::before {
  content: "\\f159d";
}

.mdi-human-handsdown::before {
  content: "\\f064b";
}

.mdi-human-handsup::before {
  content: "\\f064c";
}

.mdi-human-male::before {
  content: "\\f064d";
}

.mdi-human-male-boy::before {
  content: "\\f0a5c";
}

.mdi-human-male-child::before {
  content: "\\f138c";
}

.mdi-human-male-female::before {
  content: "\\f02e8";
}

.mdi-human-male-girl::before {
  content: "\\f0a5d";
}

.mdi-human-male-height::before {
  content: "\\f0efb";
}

.mdi-human-male-height-variant::before {
  content: "\\f0efc";
}

.mdi-human-male-male::before {
  content: "\\f0a5e";
}

.mdi-human-pregnant::before {
  content: "\\f05cf";
}

.mdi-human-queue::before {
  content: "\\f1571";
}

.mdi-human-scooter::before {
  content: "\\f11e9";
}

.mdi-human-wheelchair::before {
  content: "\\f138d";
}

.mdi-humble-bundle::before {
  content: "\\f0744";
}

.mdi-hvac::before {
  content: "\\f1352";
}

.mdi-hvac-off::before {
  content: "\\f159e";
}

.mdi-hydraulic-oil-level::before {
  content: "\\f1324";
}

.mdi-hydraulic-oil-temperature::before {
  content: "\\f1325";
}

.mdi-hydro-power::before {
  content: "\\f12e5";
}

.mdi-ice-cream::before {
  content: "\\f082a";
}

.mdi-ice-cream-off::before {
  content: "\\f0e52";
}

.mdi-ice-pop::before {
  content: "\\f0efd";
}

.mdi-id-card::before {
  content: "\\f0fc0";
}

.mdi-identifier::before {
  content: "\\f0efe";
}

.mdi-ideogram-cjk::before {
  content: "\\f1331";
}

.mdi-ideogram-cjk-variant::before {
  content: "\\f1332";
}

.mdi-iframe::before {
  content: "\\f0c8b";
}

.mdi-iframe-array::before {
  content: "\\f10f5";
}

.mdi-iframe-array-outline::before {
  content: "\\f10f6";
}

.mdi-iframe-braces::before {
  content: "\\f10f7";
}

.mdi-iframe-braces-outline::before {
  content: "\\f10f8";
}

.mdi-iframe-outline::before {
  content: "\\f0c8c";
}

.mdi-iframe-parentheses::before {
  content: "\\f10f9";
}

.mdi-iframe-parentheses-outline::before {
  content: "\\f10fa";
}

.mdi-iframe-variable::before {
  content: "\\f10fb";
}

.mdi-iframe-variable-outline::before {
  content: "\\f10fc";
}

.mdi-image::before {
  content: "\\f02e9";
}

.mdi-image-album::before {
  content: "\\f02ea";
}

.mdi-image-area::before {
  content: "\\f02eb";
}

.mdi-image-area-close::before {
  content: "\\f02ec";
}

.mdi-image-auto-adjust::before {
  content: "\\f0fc1";
}

.mdi-image-broken::before {
  content: "\\f02ed";
}

.mdi-image-broken-variant::before {
  content: "\\f02ee";
}

.mdi-image-edit::before {
  content: "\\f11e3";
}

.mdi-image-edit-outline::before {
  content: "\\f11e4";
}

.mdi-image-filter-black-white::before {
  content: "\\f02f0";
}

.mdi-image-filter-center-focus::before {
  content: "\\f02f1";
}

.mdi-image-filter-center-focus-strong::before {
  content: "\\f0eff";
}

.mdi-image-filter-center-focus-strong-outline::before {
  content: "\\f0f00";
}

.mdi-image-filter-center-focus-weak::before {
  content: "\\f02f2";
}

.mdi-image-filter-drama::before {
  content: "\\f02f3";
}

.mdi-image-filter-frames::before {
  content: "\\f02f4";
}

.mdi-image-filter-hdr::before {
  content: "\\f02f5";
}

.mdi-image-filter-none::before {
  content: "\\f02f6";
}

.mdi-image-filter-tilt-shift::before {
  content: "\\f02f7";
}

.mdi-image-filter-vintage::before {
  content: "\\f02f8";
}

.mdi-image-frame::before {
  content: "\\f0e49";
}

.mdi-image-minus::before {
  content: "\\f1419";
}

.mdi-image-move::before {
  content: "\\f09f8";
}

.mdi-image-multiple::before {
  content: "\\f02f9";
}

.mdi-image-multiple-outline::before {
  content: "\\f02ef";
}

.mdi-image-off::before {
  content: "\\f082b";
}

.mdi-image-off-outline::before {
  content: "\\f11d1";
}

.mdi-image-outline::before {
  content: "\\f0976";
}

.mdi-image-plus::before {
  content: "\\f087c";
}

.mdi-image-remove::before {
  content: "\\f1418";
}

.mdi-image-search::before {
  content: "\\f0977";
}

.mdi-image-search-outline::before {
  content: "\\f0978";
}

.mdi-image-size-select-actual::before {
  content: "\\f0c8d";
}

.mdi-image-size-select-large::before {
  content: "\\f0c8e";
}

.mdi-image-size-select-small::before {
  content: "\\f0c8f";
}

.mdi-image-text::before {
  content: "\\f160d";
}

.mdi-import::before {
  content: "\\f02fa";
}

.mdi-inbox::before {
  content: "\\f0687";
}

.mdi-inbox-arrow-down::before {
  content: "\\f02fb";
}

.mdi-inbox-arrow-down-outline::before {
  content: "\\f1270";
}

.mdi-inbox-arrow-up::before {
  content: "\\f03d1";
}

.mdi-inbox-arrow-up-outline::before {
  content: "\\f1271";
}

.mdi-inbox-full::before {
  content: "\\f1272";
}

.mdi-inbox-full-outline::before {
  content: "\\f1273";
}

.mdi-inbox-multiple::before {
  content: "\\f08b0";
}

.mdi-inbox-multiple-outline::before {
  content: "\\f0ba8";
}

.mdi-inbox-outline::before {
  content: "\\f1274";
}

.mdi-inbox-remove::before {
  content: "\\f159f";
}

.mdi-inbox-remove-outline::before {
  content: "\\f15a0";
}

.mdi-incognito::before {
  content: "\\f05f9";
}

.mdi-incognito-circle::before {
  content: "\\f1421";
}

.mdi-incognito-circle-off::before {
  content: "\\f1422";
}

.mdi-incognito-off::before {
  content: "\\f0075";
}

.mdi-infinity::before {
  content: "\\f06e4";
}

.mdi-information::before {
  content: "\\f02fc";
}

.mdi-information-outline::before {
  content: "\\f02fd";
}

.mdi-information-variant::before {
  content: "\\f064e";
}

.mdi-instagram::before {
  content: "\\f02fe";
}

.mdi-instrument-triangle::before {
  content: "\\f104e";
}

.mdi-invert-colors::before {
  content: "\\f0301";
}

.mdi-invert-colors-off::before {
  content: "\\f0e4a";
}

.mdi-iobroker::before {
  content: "\\f12e8";
}

.mdi-ip::before {
  content: "\\f0a5f";
}

.mdi-ip-network::before {
  content: "\\f0a60";
}

.mdi-ip-network-outline::before {
  content: "\\f0c90";
}

.mdi-ipod::before {
  content: "\\f0c91";
}

.mdi-islam::before {
  content: "\\f0979";
}

.mdi-island::before {
  content: "\\f104f";
}

.mdi-iv-bag::before {
  content: "\\f10b9";
}

.mdi-jabber::before {
  content: "\\f0dd5";
}

.mdi-jeepney::before {
  content: "\\f0302";
}

.mdi-jellyfish::before {
  content: "\\f0f01";
}

.mdi-jellyfish-outline::before {
  content: "\\f0f02";
}

.mdi-jira::before {
  content: "\\f0303";
}

.mdi-jquery::before {
  content: "\\f087d";
}

.mdi-jsfiddle::before {
  content: "\\f0304";
}

.mdi-judaism::before {
  content: "\\f097a";
}

.mdi-jump-rope::before {
  content: "\\f12ff";
}

.mdi-kabaddi::before {
  content: "\\f0d87";
}

.mdi-kangaroo::before {
  content: "\\f1558";
}

.mdi-karate::before {
  content: "\\f082c";
}

.mdi-keg::before {
  content: "\\f0305";
}

.mdi-kettle::before {
  content: "\\f05fa";
}

.mdi-kettle-alert::before {
  content: "\\f1317";
}

.mdi-kettle-alert-outline::before {
  content: "\\f1318";
}

.mdi-kettle-off::before {
  content: "\\f131b";
}

.mdi-kettle-off-outline::before {
  content: "\\f131c";
}

.mdi-kettle-outline::before {
  content: "\\f0f56";
}

.mdi-kettle-pour-over::before {
  content: "\\f173c";
}

.mdi-kettle-steam::before {
  content: "\\f1319";
}

.mdi-kettle-steam-outline::before {
  content: "\\f131a";
}

.mdi-kettlebell::before {
  content: "\\f1300";
}

.mdi-key::before {
  content: "\\f0306";
}

.mdi-key-arrow-right::before {
  content: "\\f1312";
}

.mdi-key-chain::before {
  content: "\\f1574";
}

.mdi-key-chain-variant::before {
  content: "\\f1575";
}

.mdi-key-change::before {
  content: "\\f0307";
}

.mdi-key-link::before {
  content: "\\f119f";
}

.mdi-key-minus::before {
  content: "\\f0308";
}

.mdi-key-outline::before {
  content: "\\f0dd6";
}

.mdi-key-plus::before {
  content: "\\f0309";
}

.mdi-key-remove::before {
  content: "\\f030a";
}

.mdi-key-star::before {
  content: "\\f119e";
}

.mdi-key-variant::before {
  content: "\\f030b";
}

.mdi-key-wireless::before {
  content: "\\f0fc2";
}

.mdi-keyboard::before {
  content: "\\f030c";
}

.mdi-keyboard-backspace::before {
  content: "\\f030d";
}

.mdi-keyboard-caps::before {
  content: "\\f030e";
}

.mdi-keyboard-close::before {
  content: "\\f030f";
}

.mdi-keyboard-esc::before {
  content: "\\f12b7";
}

.mdi-keyboard-f1::before {
  content: "\\f12ab";
}

.mdi-keyboard-f10::before {
  content: "\\f12b4";
}

.mdi-keyboard-f11::before {
  content: "\\f12b5";
}

.mdi-keyboard-f12::before {
  content: "\\f12b6";
}

.mdi-keyboard-f2::before {
  content: "\\f12ac";
}

.mdi-keyboard-f3::before {
  content: "\\f12ad";
}

.mdi-keyboard-f4::before {
  content: "\\f12ae";
}

.mdi-keyboard-f5::before {
  content: "\\f12af";
}

.mdi-keyboard-f6::before {
  content: "\\f12b0";
}

.mdi-keyboard-f7::before {
  content: "\\f12b1";
}

.mdi-keyboard-f8::before {
  content: "\\f12b2";
}

.mdi-keyboard-f9::before {
  content: "\\f12b3";
}

.mdi-keyboard-off::before {
  content: "\\f0310";
}

.mdi-keyboard-off-outline::before {
  content: "\\f0e4b";
}

.mdi-keyboard-outline::before {
  content: "\\f097b";
}

.mdi-keyboard-return::before {
  content: "\\f0311";
}

.mdi-keyboard-settings::before {
  content: "\\f09f9";
}

.mdi-keyboard-settings-outline::before {
  content: "\\f09fa";
}

.mdi-keyboard-space::before {
  content: "\\f1050";
}

.mdi-keyboard-tab::before {
  content: "\\f0312";
}

.mdi-keyboard-variant::before {
  content: "\\f0313";
}

.mdi-khanda::before {
  content: "\\f10fd";
}

.mdi-kickstarter::before {
  content: "\\f0745";
}

.mdi-klingon::before {
  content: "\\f135b";
}

.mdi-knife::before {
  content: "\\f09fb";
}

.mdi-knife-military::before {
  content: "\\f09fc";
}

.mdi-koala::before {
  content: "\\f173f";
}

.mdi-kodi::before {
  content: "\\f0314";
}

.mdi-kubernetes::before {
  content: "\\f10fe";
}

.mdi-label::before {
  content: "\\f0315";
}

.mdi-label-multiple::before {
  content: "\\f1375";
}

.mdi-label-multiple-outline::before {
  content: "\\f1376";
}

.mdi-label-off::before {
  content: "\\f0acb";
}

.mdi-label-off-outline::before {
  content: "\\f0acc";
}

.mdi-label-outline::before {
  content: "\\f0316";
}

.mdi-label-percent::before {
  content: "\\f12ea";
}

.mdi-label-percent-outline::before {
  content: "\\f12eb";
}

.mdi-label-variant::before {
  content: "\\f0acd";
}

.mdi-label-variant-outline::before {
  content: "\\f0ace";
}

.mdi-ladder::before {
  content: "\\f15a2";
}

.mdi-ladybug::before {
  content: "\\f082d";
}

.mdi-lambda::before {
  content: "\\f0627";
}

.mdi-lamp::before {
  content: "\\f06b5";
}

.mdi-lamps::before {
  content: "\\f1576";
}

.mdi-lan::before {
  content: "\\f0317";
}

.mdi-lan-check::before {
  content: "\\f12aa";
}

.mdi-lan-connect::before {
  content: "\\f0318";
}

.mdi-lan-disconnect::before {
  content: "\\f0319";
}

.mdi-lan-pending::before {
  content: "\\f031a";
}

.mdi-language-c::before {
  content: "\\f0671";
}

.mdi-language-cpp::before {
  content: "\\f0672";
}

.mdi-language-csharp::before {
  content: "\\f031b";
}

.mdi-language-css3::before {
  content: "\\f031c";
}

.mdi-language-fortran::before {
  content: "\\f121a";
}

.mdi-language-go::before {
  content: "\\f07d3";
}

.mdi-language-haskell::before {
  content: "\\f0c92";
}

.mdi-language-html5::before {
  content: "\\f031d";
}

.mdi-language-java::before {
  content: "\\f0b37";
}

.mdi-language-javascript::before {
  content: "\\f031e";
}

.mdi-language-kotlin::before {
  content: "\\f1219";
}

.mdi-language-lua::before {
  content: "\\f08b1";
}

.mdi-language-markdown::before {
  content: "\\f0354";
}

.mdi-language-markdown-outline::before {
  content: "\\f0f5b";
}

.mdi-language-php::before {
  content: "\\f031f";
}

.mdi-language-python::before {
  content: "\\f0320";
}

.mdi-language-r::before {
  content: "\\f07d4";
}

.mdi-language-ruby::before {
  content: "\\f0d2d";
}

.mdi-language-ruby-on-rails::before {
  content: "\\f0acf";
}

.mdi-language-rust::before {
  content: "\\f1617";
}

.mdi-language-swift::before {
  content: "\\f06e5";
}

.mdi-language-typescript::before {
  content: "\\f06e6";
}

.mdi-language-xaml::before {
  content: "\\f0673";
}

.mdi-laptop::before {
  content: "\\f0322";
}

.mdi-laptop-chromebook::before {
  content: "\\f0323";
}

.mdi-laptop-mac::before {
  content: "\\f0324";
}

.mdi-laptop-off::before {
  content: "\\f06e7";
}

.mdi-laptop-windows::before {
  content: "\\f0325";
}

.mdi-laravel::before {
  content: "\\f0ad0";
}

.mdi-laser-pointer::before {
  content: "\\f1484";
}

.mdi-lasso::before {
  content: "\\f0f03";
}

.mdi-lastpass::before {
  content: "\\f0446";
}

.mdi-latitude::before {
  content: "\\f0f57";
}

.mdi-launch::before {
  content: "\\f0327";
}

.mdi-lava-lamp::before {
  content: "\\f07d5";
}

.mdi-layers::before {
  content: "\\f0328";
}

.mdi-layers-minus::before {
  content: "\\f0e4c";
}

.mdi-layers-off::before {
  content: "\\f0329";
}

.mdi-layers-off-outline::before {
  content: "\\f09fd";
}

.mdi-layers-outline::before {
  content: "\\f09fe";
}

.mdi-layers-plus::before {
  content: "\\f0e4d";
}

.mdi-layers-remove::before {
  content: "\\f0e4e";
}

.mdi-layers-search::before {
  content: "\\f1206";
}

.mdi-layers-search-outline::before {
  content: "\\f1207";
}

.mdi-layers-triple::before {
  content: "\\f0f58";
}

.mdi-layers-triple-outline::before {
  content: "\\f0f59";
}

.mdi-lead-pencil::before {
  content: "\\f064f";
}

.mdi-leaf::before {
  content: "\\f032a";
}

.mdi-leaf-maple::before {
  content: "\\f0c93";
}

.mdi-leaf-maple-off::before {
  content: "\\f12da";
}

.mdi-leaf-off::before {
  content: "\\f12d9";
}

.mdi-leak::before {
  content: "\\f0dd7";
}

.mdi-leak-off::before {
  content: "\\f0dd8";
}

.mdi-led-off::before {
  content: "\\f032b";
}

.mdi-led-on::before {
  content: "\\f032c";
}

.mdi-led-outline::before {
  content: "\\f032d";
}

.mdi-led-strip::before {
  content: "\\f07d6";
}

.mdi-led-strip-variant::before {
  content: "\\f1051";
}

.mdi-led-variant-off::before {
  content: "\\f032e";
}

.mdi-led-variant-on::before {
  content: "\\f032f";
}

.mdi-led-variant-outline::before {
  content: "\\f0330";
}

.mdi-leek::before {
  content: "\\f117d";
}

.mdi-less-than::before {
  content: "\\f097c";
}

.mdi-less-than-or-equal::before {
  content: "\\f097d";
}

.mdi-library::before {
  content: "\\f0331";
}

.mdi-library-shelves::before {
  content: "\\f0ba9";
}

.mdi-license::before {
  content: "\\f0fc3";
}

.mdi-lifebuoy::before {
  content: "\\f087e";
}

.mdi-light-switch::before {
  content: "\\f097e";
}

.mdi-lightbulb::before {
  content: "\\f0335";
}

.mdi-lightbulb-cfl::before {
  content: "\\f1208";
}

.mdi-lightbulb-cfl-off::before {
  content: "\\f1209";
}

.mdi-lightbulb-cfl-spiral::before {
  content: "\\f1275";
}

.mdi-lightbulb-cfl-spiral-off::before {
  content: "\\f12c3";
}

.mdi-lightbulb-group::before {
  content: "\\f1253";
}

.mdi-lightbulb-group-off::before {
  content: "\\f12cd";
}

.mdi-lightbulb-group-off-outline::before {
  content: "\\f12ce";
}

.mdi-lightbulb-group-outline::before {
  content: "\\f1254";
}

.mdi-lightbulb-multiple::before {
  content: "\\f1255";
}

.mdi-lightbulb-multiple-off::before {
  content: "\\f12cf";
}

.mdi-lightbulb-multiple-off-outline::before {
  content: "\\f12d0";
}

.mdi-lightbulb-multiple-outline::before {
  content: "\\f1256";
}

.mdi-lightbulb-off::before {
  content: "\\f0e4f";
}

.mdi-lightbulb-off-outline::before {
  content: "\\f0e50";
}

.mdi-lightbulb-on::before {
  content: "\\f06e8";
}

.mdi-lightbulb-on-outline::before {
  content: "\\f06e9";
}

.mdi-lightbulb-outline::before {
  content: "\\f0336";
}

.mdi-lighthouse::before {
  content: "\\f09ff";
}

.mdi-lighthouse-on::before {
  content: "\\f0a00";
}

.mdi-lightning-bolt::before {
  content: "\\f140b";
}

.mdi-lightning-bolt-outline::before {
  content: "\\f140c";
}

.mdi-lingerie::before {
  content: "\\f1476";
}

.mdi-link::before {
  content: "\\f0337";
}

.mdi-link-box::before {
  content: "\\f0d1a";
}

.mdi-link-box-outline::before {
  content: "\\f0d1b";
}

.mdi-link-box-variant::before {
  content: "\\f0d1c";
}

.mdi-link-box-variant-outline::before {
  content: "\\f0d1d";
}

.mdi-link-lock::before {
  content: "\\f10ba";
}

.mdi-link-off::before {
  content: "\\f0338";
}

.mdi-link-plus::before {
  content: "\\f0c94";
}

.mdi-link-variant::before {
  content: "\\f0339";
}

.mdi-link-variant-minus::before {
  content: "\\f10ff";
}

.mdi-link-variant-off::before {
  content: "\\f033a";
}

.mdi-link-variant-plus::before {
  content: "\\f1100";
}

.mdi-link-variant-remove::before {
  content: "\\f1101";
}

.mdi-linkedin::before {
  content: "\\f033b";
}

.mdi-linux::before {
  content: "\\f033d";
}

.mdi-linux-mint::before {
  content: "\\f08ed";
}

.mdi-lipstick::before {
  content: "\\f13b5";
}

.mdi-list-status::before {
  content: "\\f15ab";
}

.mdi-litecoin::before {
  content: "\\f0a61";
}

.mdi-loading::before {
  content: "\\f0772";
}

.mdi-location-enter::before {
  content: "\\f0fc4";
}

.mdi-location-exit::before {
  content: "\\f0fc5";
}

.mdi-lock::before {
  content: "\\f033e";
}

.mdi-lock-alert::before {
  content: "\\f08ee";
}

.mdi-lock-alert-outline::before {
  content: "\\f15d1";
}

.mdi-lock-check::before {
  content: "\\f139a";
}

.mdi-lock-check-outline::before {
  content: "\\f16a8";
}

.mdi-lock-clock::before {
  content: "\\f097f";
}

.mdi-lock-minus::before {
  content: "\\f16a9";
}

.mdi-lock-minus-outline::before {
  content: "\\f16aa";
}

.mdi-lock-off::before {
  content: "\\f1671";
}

.mdi-lock-off-outline::before {
  content: "\\f1672";
}

.mdi-lock-open::before {
  content: "\\f033f";
}

.mdi-lock-open-alert::before {
  content: "\\f139b";
}

.mdi-lock-open-alert-outline::before {
  content: "\\f15d2";
}

.mdi-lock-open-check::before {
  content: "\\f139c";
}

.mdi-lock-open-check-outline::before {
  content: "\\f16ab";
}

.mdi-lock-open-minus::before {
  content: "\\f16ac";
}

.mdi-lock-open-minus-outline::before {
  content: "\\f16ad";
}

.mdi-lock-open-outline::before {
  content: "\\f0340";
}

.mdi-lock-open-plus::before {
  content: "\\f16ae";
}

.mdi-lock-open-plus-outline::before {
  content: "\\f16af";
}

.mdi-lock-open-remove::before {
  content: "\\f16b0";
}

.mdi-lock-open-remove-outline::before {
  content: "\\f16b1";
}

.mdi-lock-open-variant::before {
  content: "\\f0fc6";
}

.mdi-lock-open-variant-outline::before {
  content: "\\f0fc7";
}

.mdi-lock-outline::before {
  content: "\\f0341";
}

.mdi-lock-pattern::before {
  content: "\\f06ea";
}

.mdi-lock-plus::before {
  content: "\\f05fb";
}

.mdi-lock-plus-outline::before {
  content: "\\f16b2";
}

.mdi-lock-question::before {
  content: "\\f08ef";
}

.mdi-lock-remove::before {
  content: "\\f16b3";
}

.mdi-lock-remove-outline::before {
  content: "\\f16b4";
}

.mdi-lock-reset::before {
  content: "\\f0773";
}

.mdi-lock-smart::before {
  content: "\\f08b2";
}

.mdi-locker::before {
  content: "\\f07d7";
}

.mdi-locker-multiple::before {
  content: "\\f07d8";
}

.mdi-login::before {
  content: "\\f0342";
}

.mdi-login-variant::before {
  content: "\\f05fc";
}

.mdi-logout::before {
  content: "\\f0343";
}

.mdi-logout-variant::before {
  content: "\\f05fd";
}

.mdi-longitude::before {
  content: "\\f0f5a";
}

.mdi-looks::before {
  content: "\\f0344";
}

.mdi-lotion::before {
  content: "\\f1582";
}

.mdi-lotion-outline::before {
  content: "\\f1583";
}

.mdi-lotion-plus::before {
  content: "\\f1584";
}

.mdi-lotion-plus-outline::before {
  content: "\\f1585";
}

.mdi-loupe::before {
  content: "\\f0345";
}

.mdi-lumx::before {
  content: "\\f0346";
}

.mdi-lungs::before {
  content: "\\f1084";
}

.mdi-magnet::before {
  content: "\\f0347";
}

.mdi-magnet-on::before {
  content: "\\f0348";
}

.mdi-magnify::before {
  content: "\\f0349";
}

.mdi-magnify-close::before {
  content: "\\f0980";
}

.mdi-magnify-minus::before {
  content: "\\f034a";
}

.mdi-magnify-minus-cursor::before {
  content: "\\f0a62";
}

.mdi-magnify-minus-outline::before {
  content: "\\f06ec";
}

.mdi-magnify-plus::before {
  content: "\\f034b";
}

.mdi-magnify-plus-cursor::before {
  content: "\\f0a63";
}

.mdi-magnify-plus-outline::before {
  content: "\\f06ed";
}

.mdi-magnify-remove-cursor::before {
  content: "\\f120c";
}

.mdi-magnify-remove-outline::before {
  content: "\\f120d";
}

.mdi-magnify-scan::before {
  content: "\\f1276";
}

.mdi-mail::before {
  content: "\\f0ebb";
}

.mdi-mailbox::before {
  content: "\\f06ee";
}

.mdi-mailbox-open::before {
  content: "\\f0d88";
}

.mdi-mailbox-open-outline::before {
  content: "\\f0d89";
}

.mdi-mailbox-open-up::before {
  content: "\\f0d8a";
}

.mdi-mailbox-open-up-outline::before {
  content: "\\f0d8b";
}

.mdi-mailbox-outline::before {
  content: "\\f0d8c";
}

.mdi-mailbox-up::before {
  content: "\\f0d8d";
}

.mdi-mailbox-up-outline::before {
  content: "\\f0d8e";
}

.mdi-manjaro::before {
  content: "\\f160a";
}

.mdi-map::before {
  content: "\\f034d";
}

.mdi-map-check::before {
  content: "\\f0ebc";
}

.mdi-map-check-outline::before {
  content: "\\f0ebd";
}

.mdi-map-clock::before {
  content: "\\f0d1e";
}

.mdi-map-clock-outline::before {
  content: "\\f0d1f";
}

.mdi-map-legend::before {
  content: "\\f0a01";
}

.mdi-map-marker::before {
  content: "\\f034e";
}

.mdi-map-marker-alert::before {
  content: "\\f0f05";
}

.mdi-map-marker-alert-outline::before {
  content: "\\f0f06";
}

.mdi-map-marker-check::before {
  content: "\\f0c95";
}

.mdi-map-marker-check-outline::before {
  content: "\\f12fb";
}

.mdi-map-marker-circle::before {
  content: "\\f034f";
}

.mdi-map-marker-distance::before {
  content: "\\f08f0";
}

.mdi-map-marker-down::before {
  content: "\\f1102";
}

.mdi-map-marker-left::before {
  content: "\\f12db";
}

.mdi-map-marker-left-outline::before {
  content: "\\f12dd";
}

.mdi-map-marker-minus::before {
  content: "\\f0650";
}

.mdi-map-marker-minus-outline::before {
  content: "\\f12f9";
}

.mdi-map-marker-multiple::before {
  content: "\\f0350";
}

.mdi-map-marker-multiple-outline::before {
  content: "\\f1277";
}

.mdi-map-marker-off::before {
  content: "\\f0351";
}

.mdi-map-marker-off-outline::before {
  content: "\\f12fd";
}

.mdi-map-marker-outline::before {
  content: "\\f07d9";
}

.mdi-map-marker-path::before {
  content: "\\f0d20";
}

.mdi-map-marker-plus::before {
  content: "\\f0651";
}

.mdi-map-marker-plus-outline::before {
  content: "\\f12f8";
}

.mdi-map-marker-question::before {
  content: "\\f0f07";
}

.mdi-map-marker-question-outline::before {
  content: "\\f0f08";
}

.mdi-map-marker-radius::before {
  content: "\\f0352";
}

.mdi-map-marker-radius-outline::before {
  content: "\\f12fc";
}

.mdi-map-marker-remove::before {
  content: "\\f0f09";
}

.mdi-map-marker-remove-outline::before {
  content: "\\f12fa";
}

.mdi-map-marker-remove-variant::before {
  content: "\\f0f0a";
}

.mdi-map-marker-right::before {
  content: "\\f12dc";
}

.mdi-map-marker-right-outline::before {
  content: "\\f12de";
}

.mdi-map-marker-star::before {
  content: "\\f1608";
}

.mdi-map-marker-star-outline::before {
  content: "\\f1609";
}

.mdi-map-marker-up::before {
  content: "\\f1103";
}

.mdi-map-minus::before {
  content: "\\f0981";
}

.mdi-map-outline::before {
  content: "\\f0982";
}

.mdi-map-plus::before {
  content: "\\f0983";
}

.mdi-map-search::before {
  content: "\\f0984";
}

.mdi-map-search-outline::before {
  content: "\\f0985";
}

.mdi-mapbox::before {
  content: "\\f0baa";
}

.mdi-margin::before {
  content: "\\f0353";
}

.mdi-marker::before {
  content: "\\f0652";
}

.mdi-marker-cancel::before {
  content: "\\f0dd9";
}

.mdi-marker-check::before {
  content: "\\f0355";
}

.mdi-mastodon::before {
  content: "\\f0ad1";
}

.mdi-material-design::before {
  content: "\\f0986";
}

.mdi-material-ui::before {
  content: "\\f0357";
}

.mdi-math-compass::before {
  content: "\\f0358";
}

.mdi-math-cos::before {
  content: "\\f0c96";
}

.mdi-math-integral::before {
  content: "\\f0fc8";
}

.mdi-math-integral-box::before {
  content: "\\f0fc9";
}

.mdi-math-log::before {
  content: "\\f1085";
}

.mdi-math-norm::before {
  content: "\\f0fca";
}

.mdi-math-norm-box::before {
  content: "\\f0fcb";
}

.mdi-math-sin::before {
  content: "\\f0c97";
}

.mdi-math-tan::before {
  content: "\\f0c98";
}

.mdi-matrix::before {
  content: "\\f0628";
}

.mdi-medal::before {
  content: "\\f0987";
}

.mdi-medal-outline::before {
  content: "\\f1326";
}

.mdi-medical-bag::before {
  content: "\\f06ef";
}

.mdi-meditation::before {
  content: "\\f117b";
}

.mdi-memory::before {
  content: "\\f035b";
}

.mdi-menu::before {
  content: "\\f035c";
}

.mdi-menu-down::before {
  content: "\\f035d";
}

.mdi-menu-down-outline::before {
  content: "\\f06b6";
}

.mdi-menu-left::before {
  content: "\\f035e";
}

.mdi-menu-left-outline::before {
  content: "\\f0a02";
}

.mdi-menu-open::before {
  content: "\\f0bab";
}

.mdi-menu-right::before {
  content: "\\f035f";
}

.mdi-menu-right-outline::before {
  content: "\\f0a03";
}

.mdi-menu-swap::before {
  content: "\\f0a64";
}

.mdi-menu-swap-outline::before {
  content: "\\f0a65";
}

.mdi-menu-up::before {
  content: "\\f0360";
}

.mdi-menu-up-outline::before {
  content: "\\f06b7";
}

.mdi-merge::before {
  content: "\\f0f5c";
}

.mdi-message::before {
  content: "\\f0361";
}

.mdi-message-alert::before {
  content: "\\f0362";
}

.mdi-message-alert-outline::before {
  content: "\\f0a04";
}

.mdi-message-arrow-left::before {
  content: "\\f12f2";
}

.mdi-message-arrow-left-outline::before {
  content: "\\f12f3";
}

.mdi-message-arrow-right::before {
  content: "\\f12f4";
}

.mdi-message-arrow-right-outline::before {
  content: "\\f12f5";
}

.mdi-message-bookmark::before {
  content: "\\f15ac";
}

.mdi-message-bookmark-outline::before {
  content: "\\f15ad";
}

.mdi-message-bulleted::before {
  content: "\\f06a2";
}

.mdi-message-bulleted-off::before {
  content: "\\f06a3";
}

.mdi-message-cog::before {
  content: "\\f06f1";
}

.mdi-message-cog-outline::before {
  content: "\\f1172";
}

.mdi-message-draw::before {
  content: "\\f0363";
}

.mdi-message-flash::before {
  content: "\\f15a9";
}

.mdi-message-flash-outline::before {
  content: "\\f15aa";
}

.mdi-message-image::before {
  content: "\\f0364";
}

.mdi-message-image-outline::before {
  content: "\\f116c";
}

.mdi-message-lock::before {
  content: "\\f0fcc";
}

.mdi-message-lock-outline::before {
  content: "\\f116d";
}

.mdi-message-minus::before {
  content: "\\f116e";
}

.mdi-message-minus-outline::before {
  content: "\\f116f";
}

.mdi-message-off::before {
  content: "\\f164d";
}

.mdi-message-off-outline::before {
  content: "\\f164e";
}

.mdi-message-outline::before {
  content: "\\f0365";
}

.mdi-message-plus::before {
  content: "\\f0653";
}

.mdi-message-plus-outline::before {
  content: "\\f10bb";
}

.mdi-message-processing::before {
  content: "\\f0366";
}

.mdi-message-processing-outline::before {
  content: "\\f1170";
}

.mdi-message-question::before {
  content: "\\f173a";
}

.mdi-message-question-outline::before {
  content: "\\f173b";
}

.mdi-message-reply::before {
  content: "\\f0367";
}

.mdi-message-reply-outline::before {
  content: "\\f173d";
}

.mdi-message-reply-text::before {
  content: "\\f0368";
}

.mdi-message-reply-text-outline::before {
  content: "\\f173e";
}

.mdi-message-settings::before {
  content: "\\f06f0";
}

.mdi-message-settings-outline::before {
  content: "\\f1171";
}

.mdi-message-text::before {
  content: "\\f0369";
}

.mdi-message-text-clock::before {
  content: "\\f1173";
}

.mdi-message-text-clock-outline::before {
  content: "\\f1174";
}

.mdi-message-text-lock::before {
  content: "\\f0fcd";
}

.mdi-message-text-lock-outline::before {
  content: "\\f1175";
}

.mdi-message-text-outline::before {
  content: "\\f036a";
}

.mdi-message-video::before {
  content: "\\f036b";
}

.mdi-meteor::before {
  content: "\\f0629";
}

.mdi-metronome::before {
  content: "\\f07da";
}

.mdi-metronome-tick::before {
  content: "\\f07db";
}

.mdi-micro-sd::before {
  content: "\\f07dc";
}

.mdi-microphone::before {
  content: "\\f036c";
}

.mdi-microphone-minus::before {
  content: "\\f08b3";
}

.mdi-microphone-off::before {
  content: "\\f036d";
}

.mdi-microphone-outline::before {
  content: "\\f036e";
}

.mdi-microphone-plus::before {
  content: "\\f08b4";
}

.mdi-microphone-settings::before {
  content: "\\f036f";
}

.mdi-microphone-variant::before {
  content: "\\f0370";
}

.mdi-microphone-variant-off::before {
  content: "\\f0371";
}

.mdi-microscope::before {
  content: "\\f0654";
}

.mdi-microsoft::before {
  content: "\\f0372";
}

.mdi-microsoft-access::before {
  content: "\\f138e";
}

.mdi-microsoft-azure::before {
  content: "\\f0805";
}

.mdi-microsoft-azure-devops::before {
  content: "\\f0fd5";
}

.mdi-microsoft-bing::before {
  content: "\\f00a4";
}

.mdi-microsoft-dynamics-365::before {
  content: "\\f0988";
}

.mdi-microsoft-edge::before {
  content: "\\f01e9";
}

.mdi-microsoft-edge-legacy::before {
  content: "\\f1250";
}

.mdi-microsoft-excel::before {
  content: "\\f138f";
}

.mdi-microsoft-internet-explorer::before {
  content: "\\f0300";
}

.mdi-microsoft-office::before {
  content: "\\f03c6";
}

.mdi-microsoft-onedrive::before {
  content: "\\f03ca";
}

.mdi-microsoft-onenote::before {
  content: "\\f0747";
}

.mdi-microsoft-outlook::before {
  content: "\\f0d22";
}

.mdi-microsoft-powerpoint::before {
  content: "\\f1390";
}

.mdi-microsoft-sharepoint::before {
  content: "\\f1391";
}

.mdi-microsoft-teams::before {
  content: "\\f02bb";
}

.mdi-microsoft-visual-studio::before {
  content: "\\f0610";
}

.mdi-microsoft-visual-studio-code::before {
  content: "\\f0a1e";
}

.mdi-microsoft-windows::before {
  content: "\\f05b3";
}

.mdi-microsoft-windows-classic::before {
  content: "\\f0a21";
}

.mdi-microsoft-word::before {
  content: "\\f1392";
}

.mdi-microsoft-xbox::before {
  content: "\\f05b9";
}

.mdi-microsoft-xbox-controller::before {
  content: "\\f05ba";
}

.mdi-microsoft-xbox-controller-battery-alert::before {
  content: "\\f074b";
}

.mdi-microsoft-xbox-controller-battery-charging::before {
  content: "\\f0a22";
}

.mdi-microsoft-xbox-controller-battery-empty::before {
  content: "\\f074c";
}

.mdi-microsoft-xbox-controller-battery-full::before {
  content: "\\f074d";
}

.mdi-microsoft-xbox-controller-battery-low::before {
  content: "\\f074e";
}

.mdi-microsoft-xbox-controller-battery-medium::before {
  content: "\\f074f";
}

.mdi-microsoft-xbox-controller-battery-unknown::before {
  content: "\\f0750";
}

.mdi-microsoft-xbox-controller-menu::before {
  content: "\\f0e6f";
}

.mdi-microsoft-xbox-controller-off::before {
  content: "\\f05bb";
}

.mdi-microsoft-xbox-controller-view::before {
  content: "\\f0e70";
}

.mdi-microsoft-yammer::before {
  content: "\\f0789";
}

.mdi-microwave::before {
  content: "\\f0c99";
}

.mdi-microwave-off::before {
  content: "\\f1423";
}

.mdi-middleware::before {
  content: "\\f0f5d";
}

.mdi-middleware-outline::before {
  content: "\\f0f5e";
}

.mdi-midi::before {
  content: "\\f08f1";
}

.mdi-midi-port::before {
  content: "\\f08f2";
}

.mdi-mine::before {
  content: "\\f0dda";
}

.mdi-minecraft::before {
  content: "\\f0373";
}

.mdi-mini-sd::before {
  content: "\\f0a05";
}

.mdi-minidisc::before {
  content: "\\f0a06";
}

.mdi-minus::before {
  content: "\\f0374";
}

.mdi-minus-box::before {
  content: "\\f0375";
}

.mdi-minus-box-multiple::before {
  content: "\\f1141";
}

.mdi-minus-box-multiple-outline::before {
  content: "\\f1142";
}

.mdi-minus-box-outline::before {
  content: "\\f06f2";
}

.mdi-minus-circle::before {
  content: "\\f0376";
}

.mdi-minus-circle-multiple::before {
  content: "\\f035a";
}

.mdi-minus-circle-multiple-outline::before {
  content: "\\f0ad3";
}

.mdi-minus-circle-off::before {
  content: "\\f1459";
}

.mdi-minus-circle-off-outline::before {
  content: "\\f145a";
}

.mdi-minus-circle-outline::before {
  content: "\\f0377";
}

.mdi-minus-network::before {
  content: "\\f0378";
}

.mdi-minus-network-outline::before {
  content: "\\f0c9a";
}

.mdi-minus-thick::before {
  content: "\\f1639";
}

.mdi-mirror::before {
  content: "\\f11fd";
}

.mdi-mixed-martial-arts::before {
  content: "\\f0d8f";
}

.mdi-mixed-reality::before {
  content: "\\f087f";
}

.mdi-molecule::before {
  content: "\\f0bac";
}

.mdi-molecule-co::before {
  content: "\\f12fe";
}

.mdi-molecule-co2::before {
  content: "\\f07e4";
}

.mdi-monitor::before {
  content: "\\f0379";
}

.mdi-monitor-cellphone::before {
  content: "\\f0989";
}

.mdi-monitor-cellphone-star::before {
  content: "\\f098a";
}

.mdi-monitor-clean::before {
  content: "\\f1104";
}

.mdi-monitor-dashboard::before {
  content: "\\f0a07";
}

.mdi-monitor-edit::before {
  content: "\\f12c6";
}

.mdi-monitor-eye::before {
  content: "\\f13b4";
}

.mdi-monitor-lock::before {
  content: "\\f0ddb";
}

.mdi-monitor-multiple::before {
  content: "\\f037a";
}

.mdi-monitor-off::before {
  content: "\\f0d90";
}

.mdi-monitor-screenshot::before {
  content: "\\f0e51";
}

.mdi-monitor-share::before {
  content: "\\f1483";
}

.mdi-monitor-speaker::before {
  content: "\\f0f5f";
}

.mdi-monitor-speaker-off::before {
  content: "\\f0f60";
}

.mdi-monitor-star::before {
  content: "\\f0ddc";
}

.mdi-moon-first-quarter::before {
  content: "\\f0f61";
}

.mdi-moon-full::before {
  content: "\\f0f62";
}

.mdi-moon-last-quarter::before {
  content: "\\f0f63";
}

.mdi-moon-new::before {
  content: "\\f0f64";
}

.mdi-moon-waning-crescent::before {
  content: "\\f0f65";
}

.mdi-moon-waning-gibbous::before {
  content: "\\f0f66";
}

.mdi-moon-waxing-crescent::before {
  content: "\\f0f67";
}

.mdi-moon-waxing-gibbous::before {
  content: "\\f0f68";
}

.mdi-moped::before {
  content: "\\f1086";
}

.mdi-moped-electric::before {
  content: "\\f15b7";
}

.mdi-moped-electric-outline::before {
  content: "\\f15b8";
}

.mdi-moped-outline::before {
  content: "\\f15b9";
}

.mdi-more::before {
  content: "\\f037b";
}

.mdi-mother-heart::before {
  content: "\\f1314";
}

.mdi-mother-nurse::before {
  content: "\\f0d21";
}

.mdi-motion::before {
  content: "\\f15b2";
}

.mdi-motion-outline::before {
  content: "\\f15b3";
}

.mdi-motion-pause::before {
  content: "\\f1590";
}

.mdi-motion-pause-outline::before {
  content: "\\f1592";
}

.mdi-motion-play::before {
  content: "\\f158f";
}

.mdi-motion-play-outline::before {
  content: "\\f1591";
}

.mdi-motion-sensor::before {
  content: "\\f0d91";
}

.mdi-motion-sensor-off::before {
  content: "\\f1435";
}

.mdi-motorbike::before {
  content: "\\f037c";
}

.mdi-motorbike-electric::before {
  content: "\\f15ba";
}

.mdi-mouse::before {
  content: "\\f037d";
}

.mdi-mouse-bluetooth::before {
  content: "\\f098b";
}

.mdi-mouse-move-down::before {
  content: "\\f1550";
}

.mdi-mouse-move-up::before {
  content: "\\f1551";
}

.mdi-mouse-move-vertical::before {
  content: "\\f1552";
}

.mdi-mouse-off::before {
  content: "\\f037e";
}

.mdi-mouse-variant::before {
  content: "\\f037f";
}

.mdi-mouse-variant-off::before {
  content: "\\f0380";
}

.mdi-move-resize::before {
  content: "\\f0655";
}

.mdi-move-resize-variant::before {
  content: "\\f0656";
}

.mdi-movie::before {
  content: "\\f0381";
}

.mdi-movie-check::before {
  content: "\\f16f3";
}

.mdi-movie-check-outline::before {
  content: "\\f16f4";
}

.mdi-movie-cog::before {
  content: "\\f16f5";
}

.mdi-movie-cog-outline::before {
  content: "\\f16f6";
}

.mdi-movie-edit::before {
  content: "\\f1122";
}

.mdi-movie-edit-outline::before {
  content: "\\f1123";
}

.mdi-movie-filter::before {
  content: "\\f1124";
}

.mdi-movie-filter-outline::before {
  content: "\\f1125";
}

.mdi-movie-minus::before {
  content: "\\f16f7";
}

.mdi-movie-minus-outline::before {
  content: "\\f16f8";
}

.mdi-movie-off::before {
  content: "\\f16f9";
}

.mdi-movie-off-outline::before {
  content: "\\f16fa";
}

.mdi-movie-open::before {
  content: "\\f0fce";
}

.mdi-movie-open-check::before {
  content: "\\f16fb";
}

.mdi-movie-open-check-outline::before {
  content: "\\f16fc";
}

.mdi-movie-open-cog::before {
  content: "\\f16fd";
}

.mdi-movie-open-cog-outline::before {
  content: "\\f16fe";
}

.mdi-movie-open-edit::before {
  content: "\\f16ff";
}

.mdi-movie-open-edit-outline::before {
  content: "\\f1700";
}

.mdi-movie-open-minus::before {
  content: "\\f1701";
}

.mdi-movie-open-minus-outline::before {
  content: "\\f1702";
}

.mdi-movie-open-off::before {
  content: "\\f1703";
}

.mdi-movie-open-off-outline::before {
  content: "\\f1704";
}

.mdi-movie-open-outline::before {
  content: "\\f0fcf";
}

.mdi-movie-open-play::before {
  content: "\\f1705";
}

.mdi-movie-open-play-outline::before {
  content: "\\f1706";
}

.mdi-movie-open-plus::before {
  content: "\\f1707";
}

.mdi-movie-open-plus-outline::before {
  content: "\\f1708";
}

.mdi-movie-open-remove::before {
  content: "\\f1709";
}

.mdi-movie-open-remove-outline::before {
  content: "\\f170a";
}

.mdi-movie-open-settings::before {
  content: "\\f170b";
}

.mdi-movie-open-settings-outline::before {
  content: "\\f170c";
}

.mdi-movie-open-star::before {
  content: "\\f170d";
}

.mdi-movie-open-star-outline::before {
  content: "\\f170e";
}

.mdi-movie-outline::before {
  content: "\\f0ddd";
}

.mdi-movie-play::before {
  content: "\\f170f";
}

.mdi-movie-play-outline::before {
  content: "\\f1710";
}

.mdi-movie-plus::before {
  content: "\\f1711";
}

.mdi-movie-plus-outline::before {
  content: "\\f1712";
}

.mdi-movie-remove::before {
  content: "\\f1713";
}

.mdi-movie-remove-outline::before {
  content: "\\f1714";
}

.mdi-movie-roll::before {
  content: "\\f07de";
}

.mdi-movie-search::before {
  content: "\\f11d2";
}

.mdi-movie-search-outline::before {
  content: "\\f11d3";
}

.mdi-movie-settings::before {
  content: "\\f1715";
}

.mdi-movie-settings-outline::before {
  content: "\\f1716";
}

.mdi-movie-star::before {
  content: "\\f1717";
}

.mdi-movie-star-outline::before {
  content: "\\f1718";
}

.mdi-mower::before {
  content: "\\f166f";
}

.mdi-mower-bag::before {
  content: "\\f1670";
}

.mdi-muffin::before {
  content: "\\f098c";
}

.mdi-multiplication::before {
  content: "\\f0382";
}

.mdi-multiplication-box::before {
  content: "\\f0383";
}

.mdi-mushroom::before {
  content: "\\f07df";
}

.mdi-mushroom-off::before {
  content: "\\f13fa";
}

.mdi-mushroom-off-outline::before {
  content: "\\f13fb";
}

.mdi-mushroom-outline::before {
  content: "\\f07e0";
}

.mdi-music::before {
  content: "\\f075a";
}

.mdi-music-accidental-double-flat::before {
  content: "\\f0f69";
}

.mdi-music-accidental-double-sharp::before {
  content: "\\f0f6a";
}

.mdi-music-accidental-flat::before {
  content: "\\f0f6b";
}

.mdi-music-accidental-natural::before {
  content: "\\f0f6c";
}

.mdi-music-accidental-sharp::before {
  content: "\\f0f6d";
}

.mdi-music-box::before {
  content: "\\f0384";
}

.mdi-music-box-multiple::before {
  content: "\\f0333";
}

.mdi-music-box-multiple-outline::before {
  content: "\\f0f04";
}

.mdi-music-box-outline::before {
  content: "\\f0385";
}

.mdi-music-circle::before {
  content: "\\f0386";
}

.mdi-music-circle-outline::before {
  content: "\\f0ad4";
}

.mdi-music-clef-alto::before {
  content: "\\f0f6e";
}

.mdi-music-clef-bass::before {
  content: "\\f0f6f";
}

.mdi-music-clef-treble::before {
  content: "\\f0f70";
}

.mdi-music-note::before {
  content: "\\f0387";
}

.mdi-music-note-bluetooth::before {
  content: "\\f05fe";
}

.mdi-music-note-bluetooth-off::before {
  content: "\\f05ff";
}

.mdi-music-note-eighth::before {
  content: "\\f0388";
}

.mdi-music-note-eighth-dotted::before {
  content: "\\f0f71";
}

.mdi-music-note-half::before {
  content: "\\f0389";
}

.mdi-music-note-half-dotted::before {
  content: "\\f0f72";
}

.mdi-music-note-off::before {
  content: "\\f038a";
}

.mdi-music-note-off-outline::before {
  content: "\\f0f73";
}

.mdi-music-note-outline::before {
  content: "\\f0f74";
}

.mdi-music-note-plus::before {
  content: "\\f0dde";
}

.mdi-music-note-quarter::before {
  content: "\\f038b";
}

.mdi-music-note-quarter-dotted::before {
  content: "\\f0f75";
}

.mdi-music-note-sixteenth::before {
  content: "\\f038c";
}

.mdi-music-note-sixteenth-dotted::before {
  content: "\\f0f76";
}

.mdi-music-note-whole::before {
  content: "\\f038d";
}

.mdi-music-note-whole-dotted::before {
  content: "\\f0f77";
}

.mdi-music-off::before {
  content: "\\f075b";
}

.mdi-music-rest-eighth::before {
  content: "\\f0f78";
}

.mdi-music-rest-half::before {
  content: "\\f0f79";
}

.mdi-music-rest-quarter::before {
  content: "\\f0f7a";
}

.mdi-music-rest-sixteenth::before {
  content: "\\f0f7b";
}

.mdi-music-rest-whole::before {
  content: "\\f0f7c";
}

.mdi-mustache::before {
  content: "\\f15de";
}

.mdi-nail::before {
  content: "\\f0ddf";
}

.mdi-nas::before {
  content: "\\f08f3";
}

.mdi-nativescript::before {
  content: "\\f0880";
}

.mdi-nature::before {
  content: "\\f038e";
}

.mdi-nature-people::before {
  content: "\\f038f";
}

.mdi-navigation::before {
  content: "\\f0390";
}

.mdi-navigation-outline::before {
  content: "\\f1607";
}

.mdi-near-me::before {
  content: "\\f05cd";
}

.mdi-necklace::before {
  content: "\\f0f0b";
}

.mdi-needle::before {
  content: "\\f0391";
}

.mdi-netflix::before {
  content: "\\f0746";
}

.mdi-network::before {
  content: "\\f06f3";
}

.mdi-network-off::before {
  content: "\\f0c9b";
}

.mdi-network-off-outline::before {
  content: "\\f0c9c";
}

.mdi-network-outline::before {
  content: "\\f0c9d";
}

.mdi-network-strength-1::before {
  content: "\\f08f4";
}

.mdi-network-strength-1-alert::before {
  content: "\\f08f5";
}

.mdi-network-strength-2::before {
  content: "\\f08f6";
}

.mdi-network-strength-2-alert::before {
  content: "\\f08f7";
}

.mdi-network-strength-3::before {
  content: "\\f08f8";
}

.mdi-network-strength-3-alert::before {
  content: "\\f08f9";
}

.mdi-network-strength-4::before {
  content: "\\f08fa";
}

.mdi-network-strength-4-alert::before {
  content: "\\f08fb";
}

.mdi-network-strength-off::before {
  content: "\\f08fc";
}

.mdi-network-strength-off-outline::before {
  content: "\\f08fd";
}

.mdi-network-strength-outline::before {
  content: "\\f08fe";
}

.mdi-new-box::before {
  content: "\\f0394";
}

.mdi-newspaper::before {
  content: "\\f0395";
}

.mdi-newspaper-minus::before {
  content: "\\f0f0c";
}

.mdi-newspaper-plus::before {
  content: "\\f0f0d";
}

.mdi-newspaper-variant::before {
  content: "\\f1001";
}

.mdi-newspaper-variant-multiple::before {
  content: "\\f1002";
}

.mdi-newspaper-variant-multiple-outline::before {
  content: "\\f1003";
}

.mdi-newspaper-variant-outline::before {
  content: "\\f1004";
}

.mdi-nfc::before {
  content: "\\f0396";
}

.mdi-nfc-search-variant::before {
  content: "\\f0e53";
}

.mdi-nfc-tap::before {
  content: "\\f0397";
}

.mdi-nfc-variant::before {
  content: "\\f0398";
}

.mdi-nfc-variant-off::before {
  content: "\\f0e54";
}

.mdi-ninja::before {
  content: "\\f0774";
}

.mdi-nintendo-game-boy::before {
  content: "\\f1393";
}

.mdi-nintendo-switch::before {
  content: "\\f07e1";
}

.mdi-nintendo-wii::before {
  content: "\\f05ab";
}

.mdi-nintendo-wiiu::before {
  content: "\\f072d";
}

.mdi-nix::before {
  content: "\\f1105";
}

.mdi-nodejs::before {
  content: "\\f0399";
}

.mdi-noodles::before {
  content: "\\f117e";
}

.mdi-not-equal::before {
  content: "\\f098d";
}

.mdi-not-equal-variant::before {
  content: "\\f098e";
}

.mdi-note::before {
  content: "\\f039a";
}

.mdi-note-minus::before {
  content: "\\f164f";
}

.mdi-note-minus-outline::before {
  content: "\\f1650";
}

.mdi-note-multiple::before {
  content: "\\f06b8";
}

.mdi-note-multiple-outline::before {
  content: "\\f06b9";
}

.mdi-note-outline::before {
  content: "\\f039b";
}

.mdi-note-plus::before {
  content: "\\f039c";
}

.mdi-note-plus-outline::before {
  content: "\\f039d";
}

.mdi-note-remove::before {
  content: "\\f1651";
}

.mdi-note-remove-outline::before {
  content: "\\f1652";
}

.mdi-note-search::before {
  content: "\\f1653";
}

.mdi-note-search-outline::before {
  content: "\\f1654";
}

.mdi-note-text::before {
  content: "\\f039e";
}

.mdi-note-text-outline::before {
  content: "\\f11d7";
}

.mdi-notebook::before {
  content: "\\f082e";
}

.mdi-notebook-check::before {
  content: "\\f14f5";
}

.mdi-notebook-check-outline::before {
  content: "\\f14f6";
}

.mdi-notebook-edit::before {
  content: "\\f14e7";
}

.mdi-notebook-edit-outline::before {
  content: "\\f14e9";
}

.mdi-notebook-minus::before {
  content: "\\f1610";
}

.mdi-notebook-minus-outline::before {
  content: "\\f1611";
}

.mdi-notebook-multiple::before {
  content: "\\f0e55";
}

.mdi-notebook-outline::before {
  content: "\\f0ebf";
}

.mdi-notebook-plus::before {
  content: "\\f1612";
}

.mdi-notebook-plus-outline::before {
  content: "\\f1613";
}

.mdi-notebook-remove::before {
  content: "\\f1614";
}

.mdi-notebook-remove-outline::before {
  content: "\\f1615";
}

.mdi-notification-clear-all::before {
  content: "\\f039f";
}

.mdi-npm::before {
  content: "\\f06f7";
}

.mdi-nuke::before {
  content: "\\f06a4";
}

.mdi-null::before {
  content: "\\f07e2";
}

.mdi-numeric::before {
  content: "\\f03a0";
}

.mdi-numeric-0::before {
  content: "\\f0b39";
}

.mdi-numeric-0-box::before {
  content: "\\f03a1";
}

.mdi-numeric-0-box-multiple::before {
  content: "\\f0f0e";
}

.mdi-numeric-0-box-multiple-outline::before {
  content: "\\f03a2";
}

.mdi-numeric-0-box-outline::before {
  content: "\\f03a3";
}

.mdi-numeric-0-circle::before {
  content: "\\f0c9e";
}

.mdi-numeric-0-circle-outline::before {
  content: "\\f0c9f";
}

.mdi-numeric-1::before {
  content: "\\f0b3a";
}

.mdi-numeric-1-box::before {
  content: "\\f03a4";
}

.mdi-numeric-1-box-multiple::before {
  content: "\\f0f0f";
}

.mdi-numeric-1-box-multiple-outline::before {
  content: "\\f03a5";
}

.mdi-numeric-1-box-outline::before {
  content: "\\f03a6";
}

.mdi-numeric-1-circle::before {
  content: "\\f0ca0";
}

.mdi-numeric-1-circle-outline::before {
  content: "\\f0ca1";
}

.mdi-numeric-10::before {
  content: "\\f0fe9";
}

.mdi-numeric-10-box::before {
  content: "\\f0f7d";
}

.mdi-numeric-10-box-multiple::before {
  content: "\\f0fea";
}

.mdi-numeric-10-box-multiple-outline::before {
  content: "\\f0feb";
}

.mdi-numeric-10-box-outline::before {
  content: "\\f0f7e";
}

.mdi-numeric-10-circle::before {
  content: "\\f0fec";
}

.mdi-numeric-10-circle-outline::before {
  content: "\\f0fed";
}

.mdi-numeric-2::before {
  content: "\\f0b3b";
}

.mdi-numeric-2-box::before {
  content: "\\f03a7";
}

.mdi-numeric-2-box-multiple::before {
  content: "\\f0f10";
}

.mdi-numeric-2-box-multiple-outline::before {
  content: "\\f03a8";
}

.mdi-numeric-2-box-outline::before {
  content: "\\f03a9";
}

.mdi-numeric-2-circle::before {
  content: "\\f0ca2";
}

.mdi-numeric-2-circle-outline::before {
  content: "\\f0ca3";
}

.mdi-numeric-3::before {
  content: "\\f0b3c";
}

.mdi-numeric-3-box::before {
  content: "\\f03aa";
}

.mdi-numeric-3-box-multiple::before {
  content: "\\f0f11";
}

.mdi-numeric-3-box-multiple-outline::before {
  content: "\\f03ab";
}

.mdi-numeric-3-box-outline::before {
  content: "\\f03ac";
}

.mdi-numeric-3-circle::before {
  content: "\\f0ca4";
}

.mdi-numeric-3-circle-outline::before {
  content: "\\f0ca5";
}

.mdi-numeric-4::before {
  content: "\\f0b3d";
}

.mdi-numeric-4-box::before {
  content: "\\f03ad";
}

.mdi-numeric-4-box-multiple::before {
  content: "\\f0f12";
}

.mdi-numeric-4-box-multiple-outline::before {
  content: "\\f03b2";
}

.mdi-numeric-4-box-outline::before {
  content: "\\f03ae";
}

.mdi-numeric-4-circle::before {
  content: "\\f0ca6";
}

.mdi-numeric-4-circle-outline::before {
  content: "\\f0ca7";
}

.mdi-numeric-5::before {
  content: "\\f0b3e";
}

.mdi-numeric-5-box::before {
  content: "\\f03b1";
}

.mdi-numeric-5-box-multiple::before {
  content: "\\f0f13";
}

.mdi-numeric-5-box-multiple-outline::before {
  content: "\\f03af";
}

.mdi-numeric-5-box-outline::before {
  content: "\\f03b0";
}

.mdi-numeric-5-circle::before {
  content: "\\f0ca8";
}

.mdi-numeric-5-circle-outline::before {
  content: "\\f0ca9";
}

.mdi-numeric-6::before {
  content: "\\f0b3f";
}

.mdi-numeric-6-box::before {
  content: "\\f03b3";
}

.mdi-numeric-6-box-multiple::before {
  content: "\\f0f14";
}

.mdi-numeric-6-box-multiple-outline::before {
  content: "\\f03b4";
}

.mdi-numeric-6-box-outline::before {
  content: "\\f03b5";
}

.mdi-numeric-6-circle::before {
  content: "\\f0caa";
}

.mdi-numeric-6-circle-outline::before {
  content: "\\f0cab";
}

.mdi-numeric-7::before {
  content: "\\f0b40";
}

.mdi-numeric-7-box::before {
  content: "\\f03b6";
}

.mdi-numeric-7-box-multiple::before {
  content: "\\f0f15";
}

.mdi-numeric-7-box-multiple-outline::before {
  content: "\\f03b7";
}

.mdi-numeric-7-box-outline::before {
  content: "\\f03b8";
}

.mdi-numeric-7-circle::before {
  content: "\\f0cac";
}

.mdi-numeric-7-circle-outline::before {
  content: "\\f0cad";
}

.mdi-numeric-8::before {
  content: "\\f0b41";
}

.mdi-numeric-8-box::before {
  content: "\\f03b9";
}

.mdi-numeric-8-box-multiple::before {
  content: "\\f0f16";
}

.mdi-numeric-8-box-multiple-outline::before {
  content: "\\f03ba";
}

.mdi-numeric-8-box-outline::before {
  content: "\\f03bb";
}

.mdi-numeric-8-circle::before {
  content: "\\f0cae";
}

.mdi-numeric-8-circle-outline::before {
  content: "\\f0caf";
}

.mdi-numeric-9::before {
  content: "\\f0b42";
}

.mdi-numeric-9-box::before {
  content: "\\f03bc";
}

.mdi-numeric-9-box-multiple::before {
  content: "\\f0f17";
}

.mdi-numeric-9-box-multiple-outline::before {
  content: "\\f03bd";
}

.mdi-numeric-9-box-outline::before {
  content: "\\f03be";
}

.mdi-numeric-9-circle::before {
  content: "\\f0cb0";
}

.mdi-numeric-9-circle-outline::before {
  content: "\\f0cb1";
}

.mdi-numeric-9-plus::before {
  content: "\\f0fee";
}

.mdi-numeric-9-plus-box::before {
  content: "\\f03bf";
}

.mdi-numeric-9-plus-box-multiple::before {
  content: "\\f0f18";
}

.mdi-numeric-9-plus-box-multiple-outline::before {
  content: "\\f03c0";
}

.mdi-numeric-9-plus-box-outline::before {
  content: "\\f03c1";
}

.mdi-numeric-9-plus-circle::before {
  content: "\\f0cb2";
}

.mdi-numeric-9-plus-circle-outline::before {
  content: "\\f0cb3";
}

.mdi-numeric-negative-1::before {
  content: "\\f1052";
}

.mdi-numeric-positive-1::before {
  content: "\\f15cb";
}

.mdi-nut::before {
  content: "\\f06f8";
}

.mdi-nutrition::before {
  content: "\\f03c2";
}

.mdi-nuxt::before {
  content: "\\f1106";
}

.mdi-oar::before {
  content: "\\f067c";
}

.mdi-ocarina::before {
  content: "\\f0de0";
}

.mdi-oci::before {
  content: "\\f12e9";
}

.mdi-ocr::before {
  content: "\\f113a";
}

.mdi-octagon::before {
  content: "\\f03c3";
}

.mdi-octagon-outline::before {
  content: "\\f03c4";
}

.mdi-octagram::before {
  content: "\\f06f9";
}

.mdi-octagram-outline::before {
  content: "\\f0775";
}

.mdi-odnoklassniki::before {
  content: "\\f03c5";
}

.mdi-offer::before {
  content: "\\f121b";
}

.mdi-office-building::before {
  content: "\\f0991";
}

.mdi-office-building-marker::before {
  content: "\\f1520";
}

.mdi-office-building-marker-outline::before {
  content: "\\f1521";
}

.mdi-office-building-outline::before {
  content: "\\f151f";
}

.mdi-oil::before {
  content: "\\f03c7";
}

.mdi-oil-lamp::before {
  content: "\\f0f19";
}

.mdi-oil-level::before {
  content: "\\f1053";
}

.mdi-oil-temperature::before {
  content: "\\f0ff8";
}

.mdi-omega::before {
  content: "\\f03c9";
}

.mdi-one-up::before {
  content: "\\f0bad";
}

.mdi-onepassword::before {
  content: "\\f0881";
}

.mdi-opacity::before {
  content: "\\f05cc";
}

.mdi-open-in-app::before {
  content: "\\f03cb";
}

.mdi-open-in-new::before {
  content: "\\f03cc";
}

.mdi-open-source-initiative::before {
  content: "\\f0bae";
}

.mdi-openid::before {
  content: "\\f03cd";
}

.mdi-opera::before {
  content: "\\f03ce";
}

.mdi-orbit::before {
  content: "\\f0018";
}

.mdi-orbit-variant::before {
  content: "\\f15db";
}

.mdi-order-alphabetical-ascending::before {
  content: "\\f020d";
}

.mdi-order-alphabetical-descending::before {
  content: "\\f0d07";
}

.mdi-order-bool-ascending::before {
  content: "\\f02be";
}

.mdi-order-bool-ascending-variant::before {
  content: "\\f098f";
}

.mdi-order-bool-descending::before {
  content: "\\f1384";
}

.mdi-order-bool-descending-variant::before {
  content: "\\f0990";
}

.mdi-order-numeric-ascending::before {
  content: "\\f0545";
}

.mdi-order-numeric-descending::before {
  content: "\\f0546";
}

.mdi-origin::before {
  content: "\\f0b43";
}

.mdi-ornament::before {
  content: "\\f03cf";
}

.mdi-ornament-variant::before {
  content: "\\f03d0";
}

.mdi-outdoor-lamp::before {
  content: "\\f1054";
}

.mdi-overscan::before {
  content: "\\f1005";
}

.mdi-owl::before {
  content: "\\f03d2";
}

.mdi-pac-man::before {
  content: "\\f0baf";
}

.mdi-package::before {
  content: "\\f03d3";
}

.mdi-package-down::before {
  content: "\\f03d4";
}

.mdi-package-up::before {
  content: "\\f03d5";
}

.mdi-package-variant::before {
  content: "\\f03d6";
}

.mdi-package-variant-closed::before {
  content: "\\f03d7";
}

.mdi-page-first::before {
  content: "\\f0600";
}

.mdi-page-last::before {
  content: "\\f0601";
}

.mdi-page-layout-body::before {
  content: "\\f06fa";
}

.mdi-page-layout-footer::before {
  content: "\\f06fb";
}

.mdi-page-layout-header::before {
  content: "\\f06fc";
}

.mdi-page-layout-header-footer::before {
  content: "\\f0f7f";
}

.mdi-page-layout-sidebar-left::before {
  content: "\\f06fd";
}

.mdi-page-layout-sidebar-right::before {
  content: "\\f06fe";
}

.mdi-page-next::before {
  content: "\\f0bb0";
}

.mdi-page-next-outline::before {
  content: "\\f0bb1";
}

.mdi-page-previous::before {
  content: "\\f0bb2";
}

.mdi-page-previous-outline::before {
  content: "\\f0bb3";
}

.mdi-pail::before {
  content: "\\f1417";
}

.mdi-pail-minus::before {
  content: "\\f1437";
}

.mdi-pail-minus-outline::before {
  content: "\\f143c";
}

.mdi-pail-off::before {
  content: "\\f1439";
}

.mdi-pail-off-outline::before {
  content: "\\f143e";
}

.mdi-pail-outline::before {
  content: "\\f143a";
}

.mdi-pail-plus::before {
  content: "\\f1436";
}

.mdi-pail-plus-outline::before {
  content: "\\f143b";
}

.mdi-pail-remove::before {
  content: "\\f1438";
}

.mdi-pail-remove-outline::before {
  content: "\\f143d";
}

.mdi-palette::before {
  content: "\\f03d8";
}

.mdi-palette-advanced::before {
  content: "\\f03d9";
}

.mdi-palette-outline::before {
  content: "\\f0e0c";
}

.mdi-palette-swatch::before {
  content: "\\f08b5";
}

.mdi-palette-swatch-outline::before {
  content: "\\f135c";
}

.mdi-palm-tree::before {
  content: "\\f1055";
}

.mdi-pan::before {
  content: "\\f0bb4";
}

.mdi-pan-bottom-left::before {
  content: "\\f0bb5";
}

.mdi-pan-bottom-right::before {
  content: "\\f0bb6";
}

.mdi-pan-down::before {
  content: "\\f0bb7";
}

.mdi-pan-horizontal::before {
  content: "\\f0bb8";
}

.mdi-pan-left::before {
  content: "\\f0bb9";
}

.mdi-pan-right::before {
  content: "\\f0bba";
}

.mdi-pan-top-left::before {
  content: "\\f0bbb";
}

.mdi-pan-top-right::before {
  content: "\\f0bbc";
}

.mdi-pan-up::before {
  content: "\\f0bbd";
}

.mdi-pan-vertical::before {
  content: "\\f0bbe";
}

.mdi-panda::before {
  content: "\\f03da";
}

.mdi-pandora::before {
  content: "\\f03db";
}

.mdi-panorama::before {
  content: "\\f03dc";
}

.mdi-panorama-fisheye::before {
  content: "\\f03dd";
}

.mdi-panorama-horizontal::before {
  content: "\\f03de";
}

.mdi-panorama-vertical::before {
  content: "\\f03df";
}

.mdi-panorama-wide-angle::before {
  content: "\\f03e0";
}

.mdi-paper-cut-vertical::before {
  content: "\\f03e1";
}

.mdi-paper-roll::before {
  content: "\\f1157";
}

.mdi-paper-roll-outline::before {
  content: "\\f1158";
}

.mdi-paperclip::before {
  content: "\\f03e2";
}

.mdi-parachute::before {
  content: "\\f0cb4";
}

.mdi-parachute-outline::before {
  content: "\\f0cb5";
}

.mdi-parking::before {
  content: "\\f03e3";
}

.mdi-party-popper::before {
  content: "\\f1056";
}

.mdi-passport::before {
  content: "\\f07e3";
}

.mdi-passport-biometric::before {
  content: "\\f0de1";
}

.mdi-pasta::before {
  content: "\\f1160";
}

.mdi-patio-heater::before {
  content: "\\f0f80";
}

.mdi-patreon::before {
  content: "\\f0882";
}

.mdi-pause::before {
  content: "\\f03e4";
}

.mdi-pause-circle::before {
  content: "\\f03e5";
}

.mdi-pause-circle-outline::before {
  content: "\\f03e6";
}

.mdi-pause-octagon::before {
  content: "\\f03e7";
}

.mdi-pause-octagon-outline::before {
  content: "\\f03e8";
}

.mdi-paw::before {
  content: "\\f03e9";
}

.mdi-paw-off::before {
  content: "\\f0657";
}

.mdi-paw-off-outline::before {
  content: "\\f1676";
}

.mdi-paw-outline::before {
  content: "\\f1675";
}

.mdi-pdf-box::before {
  content: "\\f0e56";
}

.mdi-peace::before {
  content: "\\f0884";
}

.mdi-peanut::before {
  content: "\\f0ffc";
}

.mdi-peanut-off::before {
  content: "\\f0ffd";
}

.mdi-peanut-off-outline::before {
  content: "\\f0fff";
}

.mdi-peanut-outline::before {
  content: "\\f0ffe";
}

.mdi-pen::before {
  content: "\\f03ea";
}

.mdi-pen-lock::before {
  content: "\\f0de2";
}

.mdi-pen-minus::before {
  content: "\\f0de3";
}

.mdi-pen-off::before {
  content: "\\f0de4";
}

.mdi-pen-plus::before {
  content: "\\f0de5";
}

.mdi-pen-remove::before {
  content: "\\f0de6";
}

.mdi-pencil::before {
  content: "\\f03eb";
}

.mdi-pencil-box::before {
  content: "\\f03ec";
}

.mdi-pencil-box-multiple::before {
  content: "\\f1144";
}

.mdi-pencil-box-multiple-outline::before {
  content: "\\f1145";
}

.mdi-pencil-box-outline::before {
  content: "\\f03ed";
}

.mdi-pencil-circle::before {
  content: "\\f06ff";
}

.mdi-pencil-circle-outline::before {
  content: "\\f0776";
}

.mdi-pencil-lock::before {
  content: "\\f03ee";
}

.mdi-pencil-lock-outline::before {
  content: "\\f0de7";
}

.mdi-pencil-minus::before {
  content: "\\f0de8";
}

.mdi-pencil-minus-outline::before {
  content: "\\f0de9";
}

.mdi-pencil-off::before {
  content: "\\f03ef";
}

.mdi-pencil-off-outline::before {
  content: "\\f0dea";
}

.mdi-pencil-outline::before {
  content: "\\f0cb6";
}

.mdi-pencil-plus::before {
  content: "\\f0deb";
}

.mdi-pencil-plus-outline::before {
  content: "\\f0dec";
}

.mdi-pencil-remove::before {
  content: "\\f0ded";
}

.mdi-pencil-remove-outline::before {
  content: "\\f0dee";
}

.mdi-pencil-ruler::before {
  content: "\\f1353";
}

.mdi-penguin::before {
  content: "\\f0ec0";
}

.mdi-pentagon::before {
  content: "\\f0701";
}

.mdi-pentagon-outline::before {
  content: "\\f0700";
}

.mdi-pentagram::before {
  content: "\\f1667";
}

.mdi-percent::before {
  content: "\\f03f0";
}

.mdi-percent-outline::before {
  content: "\\f1278";
}

.mdi-periodic-table::before {
  content: "\\f08b6";
}

.mdi-perspective-less::before {
  content: "\\f0d23";
}

.mdi-perspective-more::before {
  content: "\\f0d24";
}

.mdi-pharmacy::before {
  content: "\\f03f1";
}

.mdi-phone::before {
  content: "\\f03f2";
}

.mdi-phone-alert::before {
  content: "\\f0f1a";
}

.mdi-phone-alert-outline::before {
  content: "\\f118e";
}

.mdi-phone-bluetooth::before {
  content: "\\f03f3";
}

.mdi-phone-bluetooth-outline::before {
  content: "\\f118f";
}

.mdi-phone-cancel::before {
  content: "\\f10bc";
}

.mdi-phone-cancel-outline::before {
  content: "\\f1190";
}

.mdi-phone-check::before {
  content: "\\f11a9";
}

.mdi-phone-check-outline::before {
  content: "\\f11aa";
}

.mdi-phone-classic::before {
  content: "\\f0602";
}

.mdi-phone-classic-off::before {
  content: "\\f1279";
}

.mdi-phone-dial::before {
  content: "\\f1559";
}

.mdi-phone-dial-outline::before {
  content: "\\f155a";
}

.mdi-phone-forward::before {
  content: "\\f03f4";
}

.mdi-phone-forward-outline::before {
  content: "\\f1191";
}

.mdi-phone-hangup::before {
  content: "\\f03f5";
}

.mdi-phone-hangup-outline::before {
  content: "\\f1192";
}

.mdi-phone-in-talk::before {
  content: "\\f03f6";
}

.mdi-phone-in-talk-outline::before {
  content: "\\f1182";
}

.mdi-phone-incoming::before {
  content: "\\f03f7";
}

.mdi-phone-incoming-outline::before {
  content: "\\f1193";
}

.mdi-phone-lock::before {
  content: "\\f03f8";
}

.mdi-phone-lock-outline::before {
  content: "\\f1194";
}

.mdi-phone-log::before {
  content: "\\f03f9";
}

.mdi-phone-log-outline::before {
  content: "\\f1195";
}

.mdi-phone-message::before {
  content: "\\f1196";
}

.mdi-phone-message-outline::before {
  content: "\\f1197";
}

.mdi-phone-minus::before {
  content: "\\f0658";
}

.mdi-phone-minus-outline::before {
  content: "\\f1198";
}

.mdi-phone-missed::before {
  content: "\\f03fa";
}

.mdi-phone-missed-outline::before {
  content: "\\f11a5";
}

.mdi-phone-off::before {
  content: "\\f0def";
}

.mdi-phone-off-outline::before {
  content: "\\f11a6";
}

.mdi-phone-outgoing::before {
  content: "\\f03fb";
}

.mdi-phone-outgoing-outline::before {
  content: "\\f1199";
}

.mdi-phone-outline::before {
  content: "\\f0df0";
}

.mdi-phone-paused::before {
  content: "\\f03fc";
}

.mdi-phone-paused-outline::before {
  content: "\\f119a";
}

.mdi-phone-plus::before {
  content: "\\f0659";
}

.mdi-phone-plus-outline::before {
  content: "\\f119b";
}

.mdi-phone-remove::before {
  content: "\\f152f";
}

.mdi-phone-remove-outline::before {
  content: "\\f1530";
}

.mdi-phone-return::before {
  content: "\\f082f";
}

.mdi-phone-return-outline::before {
  content: "\\f119c";
}

.mdi-phone-ring::before {
  content: "\\f11ab";
}

.mdi-phone-ring-outline::before {
  content: "\\f11ac";
}

.mdi-phone-rotate-landscape::before {
  content: "\\f0885";
}

.mdi-phone-rotate-portrait::before {
  content: "\\f0886";
}

.mdi-phone-settings::before {
  content: "\\f03fd";
}

.mdi-phone-settings-outline::before {
  content: "\\f119d";
}

.mdi-phone-voip::before {
  content: "\\f03fe";
}

.mdi-pi::before {
  content: "\\f03ff";
}

.mdi-pi-box::before {
  content: "\\f0400";
}

.mdi-pi-hole::before {
  content: "\\f0df1";
}

.mdi-piano::before {
  content: "\\f067d";
}

.mdi-pickaxe::before {
  content: "\\f08b7";
}

.mdi-picture-in-picture-bottom-right::before {
  content: "\\f0e57";
}

.mdi-picture-in-picture-bottom-right-outline::before {
  content: "\\f0e58";
}

.mdi-picture-in-picture-top-right::before {
  content: "\\f0e59";
}

.mdi-picture-in-picture-top-right-outline::before {
  content: "\\f0e5a";
}

.mdi-pier::before {
  content: "\\f0887";
}

.mdi-pier-crane::before {
  content: "\\f0888";
}

.mdi-pig::before {
  content: "\\f0401";
}

.mdi-pig-variant::before {
  content: "\\f1006";
}

.mdi-pig-variant-outline::before {
  content: "\\f1678";
}

.mdi-piggy-bank::before {
  content: "\\f1007";
}

.mdi-piggy-bank-outline::before {
  content: "\\f1679";
}

.mdi-pill::before {
  content: "\\f0402";
}

.mdi-pillar::before {
  content: "\\f0702";
}

.mdi-pin::before {
  content: "\\f0403";
}

.mdi-pin-off::before {
  content: "\\f0404";
}

.mdi-pin-off-outline::before {
  content: "\\f0930";
}

.mdi-pin-outline::before {
  content: "\\f0931";
}

.mdi-pine-tree::before {
  content: "\\f0405";
}

.mdi-pine-tree-box::before {
  content: "\\f0406";
}

.mdi-pine-tree-fire::before {
  content: "\\f141a";
}

.mdi-pinterest::before {
  content: "\\f0407";
}

.mdi-pinwheel::before {
  content: "\\f0ad5";
}

.mdi-pinwheel-outline::before {
  content: "\\f0ad6";
}

.mdi-pipe::before {
  content: "\\f07e5";
}

.mdi-pipe-disconnected::before {
  content: "\\f07e6";
}

.mdi-pipe-leak::before {
  content: "\\f0889";
}

.mdi-pipe-wrench::before {
  content: "\\f1354";
}

.mdi-pirate::before {
  content: "\\f0a08";
}

.mdi-pistol::before {
  content: "\\f0703";
}

.mdi-piston::before {
  content: "\\f088a";
}

.mdi-pitchfork::before {
  content: "\\f1553";
}

.mdi-pizza::before {
  content: "\\f0409";
}

.mdi-play::before {
  content: "\\f040a";
}

.mdi-play-box::before {
  content: "\\f127a";
}

.mdi-play-box-multiple::before {
  content: "\\f0d19";
}

.mdi-play-box-multiple-outline::before {
  content: "\\f13e6";
}

.mdi-play-box-outline::before {
  content: "\\f040b";
}

.mdi-play-circle::before {
  content: "\\f040c";
}

.mdi-play-circle-outline::before {
  content: "\\f040d";
}

.mdi-play-network::before {
  content: "\\f088b";
}

.mdi-play-network-outline::before {
  content: "\\f0cb7";
}

.mdi-play-outline::before {
  content: "\\f0f1b";
}

.mdi-play-pause::before {
  content: "\\f040e";
}

.mdi-play-protected-content::before {
  content: "\\f040f";
}

.mdi-play-speed::before {
  content: "\\f08ff";
}

.mdi-playlist-check::before {
  content: "\\f05c7";
}

.mdi-playlist-edit::before {
  content: "\\f0900";
}

.mdi-playlist-minus::before {
  content: "\\f0410";
}

.mdi-playlist-music::before {
  content: "\\f0cb8";
}

.mdi-playlist-music-outline::before {
  content: "\\f0cb9";
}

.mdi-playlist-play::before {
  content: "\\f0411";
}

.mdi-playlist-plus::before {
  content: "\\f0412";
}

.mdi-playlist-remove::before {
  content: "\\f0413";
}

.mdi-playlist-star::before {
  content: "\\f0df2";
}

.mdi-plex::before {
  content: "\\f06ba";
}

.mdi-plus::before {
  content: "\\f0415";
}

.mdi-plus-box::before {
  content: "\\f0416";
}

.mdi-plus-box-multiple::before {
  content: "\\f0334";
}

.mdi-plus-box-multiple-outline::before {
  content: "\\f1143";
}

.mdi-plus-box-outline::before {
  content: "\\f0704";
}

.mdi-plus-circle::before {
  content: "\\f0417";
}

.mdi-plus-circle-multiple::before {
  content: "\\f034c";
}

.mdi-plus-circle-multiple-outline::before {
  content: "\\f0418";
}

.mdi-plus-circle-outline::before {
  content: "\\f0419";
}

.mdi-plus-minus::before {
  content: "\\f0992";
}

.mdi-plus-minus-box::before {
  content: "\\f0993";
}

.mdi-plus-minus-variant::before {
  content: "\\f14c9";
}

.mdi-plus-network::before {
  content: "\\f041a";
}

.mdi-plus-network-outline::before {
  content: "\\f0cba";
}

.mdi-plus-one::before {
  content: "\\f041b";
}

.mdi-plus-outline::before {
  content: "\\f0705";
}

.mdi-plus-thick::before {
  content: "\\f11ec";
}

.mdi-podcast::before {
  content: "\\f0994";
}

.mdi-podium::before {
  content: "\\f0d25";
}

.mdi-podium-bronze::before {
  content: "\\f0d26";
}

.mdi-podium-gold::before {
  content: "\\f0d27";
}

.mdi-podium-silver::before {
  content: "\\f0d28";
}

.mdi-point-of-sale::before {
  content: "\\f0d92";
}

.mdi-pokeball::before {
  content: "\\f041d";
}

.mdi-pokemon-go::before {
  content: "\\f0a09";
}

.mdi-poker-chip::before {
  content: "\\f0830";
}

.mdi-polaroid::before {
  content: "\\f041e";
}

.mdi-police-badge::before {
  content: "\\f1167";
}

.mdi-police-badge-outline::before {
  content: "\\f1168";
}

.mdi-poll::before {
  content: "\\f041f";
}

.mdi-poll-box::before {
  content: "\\f0420";
}

.mdi-poll-box-outline::before {
  content: "\\f127b";
}

.mdi-polo::before {
  content: "\\f14c3";
}

.mdi-polymer::before {
  content: "\\f0421";
}

.mdi-pool::before {
  content: "\\f0606";
}

.mdi-popcorn::before {
  content: "\\f0422";
}

.mdi-post::before {
  content: "\\f1008";
}

.mdi-post-outline::before {
  content: "\\f1009";
}

.mdi-postage-stamp::before {
  content: "\\f0cbb";
}

.mdi-pot::before {
  content: "\\f02e5";
}

.mdi-pot-mix::before {
  content: "\\f065b";
}

.mdi-pot-mix-outline::before {
  content: "\\f0677";
}

.mdi-pot-outline::before {
  content: "\\f02ff";
}

.mdi-pot-steam::before {
  content: "\\f065a";
}

.mdi-pot-steam-outline::before {
  content: "\\f0326";
}

.mdi-pound::before {
  content: "\\f0423";
}

.mdi-pound-box::before {
  content: "\\f0424";
}

.mdi-pound-box-outline::before {
  content: "\\f117f";
}

.mdi-power::before {
  content: "\\f0425";
}

.mdi-power-cycle::before {
  content: "\\f0901";
}

.mdi-power-off::before {
  content: "\\f0902";
}

.mdi-power-on::before {
  content: "\\f0903";
}

.mdi-power-plug::before {
  content: "\\f06a5";
}

.mdi-power-plug-off::before {
  content: "\\f06a6";
}

.mdi-power-plug-off-outline::before {
  content: "\\f1424";
}

.mdi-power-plug-outline::before {
  content: "\\f1425";
}

.mdi-power-settings::before {
  content: "\\f0426";
}

.mdi-power-sleep::before {
  content: "\\f0904";
}

.mdi-power-socket::before {
  content: "\\f0427";
}

.mdi-power-socket-au::before {
  content: "\\f0905";
}

.mdi-power-socket-de::before {
  content: "\\f1107";
}

.mdi-power-socket-eu::before {
  content: "\\f07e7";
}

.mdi-power-socket-fr::before {
  content: "\\f1108";
}

.mdi-power-socket-it::before {
  content: "\\f14ff";
}

.mdi-power-socket-jp::before {
  content: "\\f1109";
}

.mdi-power-socket-uk::before {
  content: "\\f07e8";
}

.mdi-power-socket-us::before {
  content: "\\f07e9";
}

.mdi-power-standby::before {
  content: "\\f0906";
}

.mdi-powershell::before {
  content: "\\f0a0a";
}

.mdi-prescription::before {
  content: "\\f0706";
}

.mdi-presentation::before {
  content: "\\f0428";
}

.mdi-presentation-play::before {
  content: "\\f0429";
}

.mdi-pretzel::before {
  content: "\\f1562";
}

.mdi-printer::before {
  content: "\\f042a";
}

.mdi-printer-3d::before {
  content: "\\f042b";
}

.mdi-printer-3d-nozzle::before {
  content: "\\f0e5b";
}

.mdi-printer-3d-nozzle-alert::before {
  content: "\\f11c0";
}

.mdi-printer-3d-nozzle-alert-outline::before {
  content: "\\f11c1";
}

.mdi-printer-3d-nozzle-outline::before {
  content: "\\f0e5c";
}

.mdi-printer-alert::before {
  content: "\\f042c";
}

.mdi-printer-check::before {
  content: "\\f1146";
}

.mdi-printer-eye::before {
  content: "\\f1458";
}

.mdi-printer-off::before {
  content: "\\f0e5d";
}

.mdi-printer-pos::before {
  content: "\\f1057";
}

.mdi-printer-search::before {
  content: "\\f1457";
}

.mdi-printer-settings::before {
  content: "\\f0707";
}

.mdi-printer-wireless::before {
  content: "\\f0a0b";
}

.mdi-priority-high::before {
  content: "\\f0603";
}

.mdi-priority-low::before {
  content: "\\f0604";
}

.mdi-professional-hexagon::before {
  content: "\\f042d";
}

.mdi-progress-alert::before {
  content: "\\f0cbc";
}

.mdi-progress-check::before {
  content: "\\f0995";
}

.mdi-progress-clock::before {
  content: "\\f0996";
}

.mdi-progress-close::before {
  content: "\\f110a";
}

.mdi-progress-download::before {
  content: "\\f0997";
}

.mdi-progress-question::before {
  content: "\\f1522";
}

.mdi-progress-upload::before {
  content: "\\f0998";
}

.mdi-progress-wrench::before {
  content: "\\f0cbd";
}

.mdi-projector::before {
  content: "\\f042e";
}

.mdi-projector-screen::before {
  content: "\\f042f";
}

.mdi-projector-screen-outline::before {
  content: "\\f1724";
}

.mdi-propane-tank::before {
  content: "\\f1357";
}

.mdi-propane-tank-outline::before {
  content: "\\f1358";
}

.mdi-protocol::before {
  content: "\\f0fd8";
}

.mdi-publish::before {
  content: "\\f06a7";
}

.mdi-pulse::before {
  content: "\\f0430";
}

.mdi-pump::before {
  content: "\\f1402";
}

.mdi-pumpkin::before {
  content: "\\f0bbf";
}

.mdi-purse::before {
  content: "\\f0f1c";
}

.mdi-purse-outline::before {
  content: "\\f0f1d";
}

.mdi-puzzle::before {
  content: "\\f0431";
}

.mdi-puzzle-check::before {
  content: "\\f1426";
}

.mdi-puzzle-check-outline::before {
  content: "\\f1427";
}

.mdi-puzzle-edit::before {
  content: "\\f14d3";
}

.mdi-puzzle-edit-outline::before {
  content: "\\f14d9";
}

.mdi-puzzle-heart::before {
  content: "\\f14d4";
}

.mdi-puzzle-heart-outline::before {
  content: "\\f14da";
}

.mdi-puzzle-minus::before {
  content: "\\f14d1";
}

.mdi-puzzle-minus-outline::before {
  content: "\\f14d7";
}

.mdi-puzzle-outline::before {
  content: "\\f0a66";
}

.mdi-puzzle-plus::before {
  content: "\\f14d0";
}

.mdi-puzzle-plus-outline::before {
  content: "\\f14d6";
}

.mdi-puzzle-remove::before {
  content: "\\f14d2";
}

.mdi-puzzle-remove-outline::before {
  content: "\\f14d8";
}

.mdi-puzzle-star::before {
  content: "\\f14d5";
}

.mdi-puzzle-star-outline::before {
  content: "\\f14db";
}

.mdi-qi::before {
  content: "\\f0999";
}

.mdi-qqchat::before {
  content: "\\f0605";
}

.mdi-qrcode::before {
  content: "\\f0432";
}

.mdi-qrcode-edit::before {
  content: "\\f08b8";
}

.mdi-qrcode-minus::before {
  content: "\\f118c";
}

.mdi-qrcode-plus::before {
  content: "\\f118b";
}

.mdi-qrcode-remove::before {
  content: "\\f118d";
}

.mdi-qrcode-scan::before {
  content: "\\f0433";
}

.mdi-quadcopter::before {
  content: "\\f0434";
}

.mdi-quality-high::before {
  content: "\\f0435";
}

.mdi-quality-low::before {
  content: "\\f0a0c";
}

.mdi-quality-medium::before {
  content: "\\f0a0d";
}

.mdi-quora::before {
  content: "\\f0d29";
}

.mdi-rabbit::before {
  content: "\\f0907";
}

.mdi-racing-helmet::before {
  content: "\\f0d93";
}

.mdi-racquetball::before {
  content: "\\f0d94";
}

.mdi-radar::before {
  content: "\\f0437";
}

.mdi-radiator::before {
  content: "\\f0438";
}

.mdi-radiator-disabled::before {
  content: "\\f0ad7";
}

.mdi-radiator-off::before {
  content: "\\f0ad8";
}

.mdi-radio::before {
  content: "\\f0439";
}

.mdi-radio-am::before {
  content: "\\f0cbe";
}

.mdi-radio-fm::before {
  content: "\\f0cbf";
}

.mdi-radio-handheld::before {
  content: "\\f043a";
}

.mdi-radio-off::before {
  content: "\\f121c";
}

.mdi-radio-tower::before {
  content: "\\f043b";
}

.mdi-radioactive::before {
  content: "\\f043c";
}

.mdi-radioactive-off::before {
  content: "\\f0ec1";
}

.mdi-radiobox-blank::before {
  content: "\\f043d";
}

.mdi-radiobox-marked::before {
  content: "\\f043e";
}

.mdi-radiology-box::before {
  content: "\\f14c5";
}

.mdi-radiology-box-outline::before {
  content: "\\f14c6";
}

.mdi-radius::before {
  content: "\\f0cc0";
}

.mdi-radius-outline::before {
  content: "\\f0cc1";
}

.mdi-railroad-light::before {
  content: "\\f0f1e";
}

.mdi-rake::before {
  content: "\\f1544";
}

.mdi-raspberry-pi::before {
  content: "\\f043f";
}

.mdi-ray-end::before {
  content: "\\f0440";
}

.mdi-ray-end-arrow::before {
  content: "\\f0441";
}

.mdi-ray-start::before {
  content: "\\f0442";
}

.mdi-ray-start-arrow::before {
  content: "\\f0443";
}

.mdi-ray-start-end::before {
  content: "\\f0444";
}

.mdi-ray-start-vertex-end::before {
  content: "\\f15d8";
}

.mdi-ray-vertex::before {
  content: "\\f0445";
}

.mdi-react::before {
  content: "\\f0708";
}

.mdi-read::before {
  content: "\\f0447";
}

.mdi-receipt::before {
  content: "\\f0449";
}

.mdi-record::before {
  content: "\\f044a";
}

.mdi-record-circle::before {
  content: "\\f0ec2";
}

.mdi-record-circle-outline::before {
  content: "\\f0ec3";
}

.mdi-record-player::before {
  content: "\\f099a";
}

.mdi-record-rec::before {
  content: "\\f044b";
}

.mdi-rectangle::before {
  content: "\\f0e5e";
}

.mdi-rectangle-outline::before {
  content: "\\f0e5f";
}

.mdi-recycle::before {
  content: "\\f044c";
}

.mdi-recycle-variant::before {
  content: "\\f139d";
}

.mdi-reddit::before {
  content: "\\f044d";
}

.mdi-redhat::before {
  content: "\\f111b";
}

.mdi-redo::before {
  content: "\\f044e";
}

.mdi-redo-variant::before {
  content: "\\f044f";
}

.mdi-reflect-horizontal::before {
  content: "\\f0a0e";
}

.mdi-reflect-vertical::before {
  content: "\\f0a0f";
}

.mdi-refresh::before {
  content: "\\f0450";
}

.mdi-refresh-circle::before {
  content: "\\f1377";
}

.mdi-regex::before {
  content: "\\f0451";
}

.mdi-registered-trademark::before {
  content: "\\f0a67";
}

.mdi-reiterate::before {
  content: "\\f1588";
}

.mdi-relation-many-to-many::before {
  content: "\\f1496";
}

.mdi-relation-many-to-one::before {
  content: "\\f1497";
}

.mdi-relation-many-to-one-or-many::before {
  content: "\\f1498";
}

.mdi-relation-many-to-only-one::before {
  content: "\\f1499";
}

.mdi-relation-many-to-zero-or-many::before {
  content: "\\f149a";
}

.mdi-relation-many-to-zero-or-one::before {
  content: "\\f149b";
}

.mdi-relation-one-or-many-to-many::before {
  content: "\\f149c";
}

.mdi-relation-one-or-many-to-one::before {
  content: "\\f149d";
}

.mdi-relation-one-or-many-to-one-or-many::before {
  content: "\\f149e";
}

.mdi-relation-one-or-many-to-only-one::before {
  content: "\\f149f";
}

.mdi-relation-one-or-many-to-zero-or-many::before {
  content: "\\f14a0";
}

.mdi-relation-one-or-many-to-zero-or-one::before {
  content: "\\f14a1";
}

.mdi-relation-one-to-many::before {
  content: "\\f14a2";
}

.mdi-relation-one-to-one::before {
  content: "\\f14a3";
}

.mdi-relation-one-to-one-or-many::before {
  content: "\\f14a4";
}

.mdi-relation-one-to-only-one::before {
  content: "\\f14a5";
}

.mdi-relation-one-to-zero-or-many::before {
  content: "\\f14a6";
}

.mdi-relation-one-to-zero-or-one::before {
  content: "\\f14a7";
}

.mdi-relation-only-one-to-many::before {
  content: "\\f14a8";
}

.mdi-relation-only-one-to-one::before {
  content: "\\f14a9";
}

.mdi-relation-only-one-to-one-or-many::before {
  content: "\\f14aa";
}

.mdi-relation-only-one-to-only-one::before {
  content: "\\f14ab";
}

.mdi-relation-only-one-to-zero-or-many::before {
  content: "\\f14ac";
}

.mdi-relation-only-one-to-zero-or-one::before {
  content: "\\f14ad";
}

.mdi-relation-zero-or-many-to-many::before {
  content: "\\f14ae";
}

.mdi-relation-zero-or-many-to-one::before {
  content: "\\f14af";
}

.mdi-relation-zero-or-many-to-one-or-many::before {
  content: "\\f14b0";
}

.mdi-relation-zero-or-many-to-only-one::before {
  content: "\\f14b1";
}

.mdi-relation-zero-or-many-to-zero-or-many::before {
  content: "\\f14b2";
}

.mdi-relation-zero-or-many-to-zero-or-one::before {
  content: "\\f14b3";
}

.mdi-relation-zero-or-one-to-many::before {
  content: "\\f14b4";
}

.mdi-relation-zero-or-one-to-one::before {
  content: "\\f14b5";
}

.mdi-relation-zero-or-one-to-one-or-many::before {
  content: "\\f14b6";
}

.mdi-relation-zero-or-one-to-only-one::before {
  content: "\\f14b7";
}

.mdi-relation-zero-or-one-to-zero-or-many::before {
  content: "\\f14b8";
}

.mdi-relation-zero-or-one-to-zero-or-one::before {
  content: "\\f14b9";
}

.mdi-relative-scale::before {
  content: "\\f0452";
}

.mdi-reload::before {
  content: "\\f0453";
}

.mdi-reload-alert::before {
  content: "\\f110b";
}

.mdi-reminder::before {
  content: "\\f088c";
}

.mdi-remote::before {
  content: "\\f0454";
}

.mdi-remote-desktop::before {
  content: "\\f08b9";
}

.mdi-remote-off::before {
  content: "\\f0ec4";
}

.mdi-remote-tv::before {
  content: "\\f0ec5";
}

.mdi-remote-tv-off::before {
  content: "\\f0ec6";
}

.mdi-rename-box::before {
  content: "\\f0455";
}

.mdi-reorder-horizontal::before {
  content: "\\f0688";
}

.mdi-reorder-vertical::before {
  content: "\\f0689";
}

.mdi-repeat::before {
  content: "\\f0456";
}

.mdi-repeat-off::before {
  content: "\\f0457";
}

.mdi-repeat-once::before {
  content: "\\f0458";
}

.mdi-replay::before {
  content: "\\f0459";
}

.mdi-reply::before {
  content: "\\f045a";
}

.mdi-reply-all::before {
  content: "\\f045b";
}

.mdi-reply-all-outline::before {
  content: "\\f0f1f";
}

.mdi-reply-circle::before {
  content: "\\f11ae";
}

.mdi-reply-outline::before {
  content: "\\f0f20";
}

.mdi-reproduction::before {
  content: "\\f045c";
}

.mdi-resistor::before {
  content: "\\f0b44";
}

.mdi-resistor-nodes::before {
  content: "\\f0b45";
}

.mdi-resize::before {
  content: "\\f0a68";
}

.mdi-resize-bottom-right::before {
  content: "\\f045d";
}

.mdi-responsive::before {
  content: "\\f045e";
}

.mdi-restart::before {
  content: "\\f0709";
}

.mdi-restart-alert::before {
  content: "\\f110c";
}

.mdi-restart-off::before {
  content: "\\f0d95";
}

.mdi-restore::before {
  content: "\\f099b";
}

.mdi-restore-alert::before {
  content: "\\f110d";
}

.mdi-rewind::before {
  content: "\\f045f";
}

.mdi-rewind-10::before {
  content: "\\f0d2a";
}

.mdi-rewind-30::before {
  content: "\\f0d96";
}

.mdi-rewind-5::before {
  content: "\\f11f9";
}

.mdi-rewind-60::before {
  content: "\\f160c";
}

.mdi-rewind-outline::before {
  content: "\\f070a";
}

.mdi-rhombus::before {
  content: "\\f070b";
}

.mdi-rhombus-medium::before {
  content: "\\f0a10";
}

.mdi-rhombus-medium-outline::before {
  content: "\\f14dc";
}

.mdi-rhombus-outline::before {
  content: "\\f070c";
}

.mdi-rhombus-split::before {
  content: "\\f0a11";
}

.mdi-rhombus-split-outline::before {
  content: "\\f14dd";
}

.mdi-ribbon::before {
  content: "\\f0460";
}

.mdi-rice::before {
  content: "\\f07ea";
}

.mdi-rickshaw::before {
  content: "\\f15bb";
}

.mdi-rickshaw-electric::before {
  content: "\\f15bc";
}

.mdi-ring::before {
  content: "\\f07eb";
}

.mdi-rivet::before {
  content: "\\f0e60";
}

.mdi-road::before {
  content: "\\f0461";
}

.mdi-road-variant::before {
  content: "\\f0462";
}

.mdi-robber::before {
  content: "\\f1058";
}

.mdi-robot::before {
  content: "\\f06a9";
}

.mdi-robot-angry::before {
  content: "\\f169d";
}

.mdi-robot-angry-outline::before {
  content: "\\f169e";
}

.mdi-robot-confused::before {
  content: "\\f169f";
}

.mdi-robot-confused-outline::before {
  content: "\\f16a0";
}

.mdi-robot-dead::before {
  content: "\\f16a1";
}

.mdi-robot-dead-outline::before {
  content: "\\f16a2";
}

.mdi-robot-excited::before {
  content: "\\f16a3";
}

.mdi-robot-excited-outline::before {
  content: "\\f16a4";
}

.mdi-robot-happy::before {
  content: "\\f1719";
}

.mdi-robot-happy-outline::before {
  content: "\\f171a";
}

.mdi-robot-industrial::before {
  content: "\\f0b46";
}

.mdi-robot-love::before {
  content: "\\f16a5";
}

.mdi-robot-love-outline::before {
  content: "\\f16a6";
}

.mdi-robot-mower::before {
  content: "\\f11f7";
}

.mdi-robot-mower-outline::before {
  content: "\\f11f3";
}

.mdi-robot-off::before {
  content: "\\f16a7";
}

.mdi-robot-off-outline::before {
  content: "\\f167b";
}

.mdi-robot-outline::before {
  content: "\\f167a";
}

.mdi-robot-vacuum::before {
  content: "\\f070d";
}

.mdi-robot-vacuum-variant::before {
  content: "\\f0908";
}

.mdi-rocket::before {
  content: "\\f0463";
}

.mdi-rocket-launch::before {
  content: "\\f14de";
}

.mdi-rocket-launch-outline::before {
  content: "\\f14df";
}

.mdi-rocket-outline::before {
  content: "\\f13af";
}

.mdi-rodent::before {
  content: "\\f1327";
}

.mdi-roller-skate::before {
  content: "\\f0d2b";
}

.mdi-roller-skate-off::before {
  content: "\\f0145";
}

.mdi-rollerblade::before {
  content: "\\f0d2c";
}

.mdi-rollerblade-off::before {
  content: "\\f002e";
}

.mdi-rollupjs::before {
  content: "\\f0bc0";
}

.mdi-roman-numeral-1::before {
  content: "\\f1088";
}

.mdi-roman-numeral-10::before {
  content: "\\f1091";
}

.mdi-roman-numeral-2::before {
  content: "\\f1089";
}

.mdi-roman-numeral-3::before {
  content: "\\f108a";
}

.mdi-roman-numeral-4::before {
  content: "\\f108b";
}

.mdi-roman-numeral-5::before {
  content: "\\f108c";
}

.mdi-roman-numeral-6::before {
  content: "\\f108d";
}

.mdi-roman-numeral-7::before {
  content: "\\f108e";
}

.mdi-roman-numeral-8::before {
  content: "\\f108f";
}

.mdi-roman-numeral-9::before {
  content: "\\f1090";
}

.mdi-room-service::before {
  content: "\\f088d";
}

.mdi-room-service-outline::before {
  content: "\\f0d97";
}

.mdi-rotate-3d::before {
  content: "\\f0ec7";
}

.mdi-rotate-3d-variant::before {
  content: "\\f0464";
}

.mdi-rotate-left::before {
  content: "\\f0465";
}

.mdi-rotate-left-variant::before {
  content: "\\f0466";
}

.mdi-rotate-orbit::before {
  content: "\\f0d98";
}

.mdi-rotate-right::before {
  content: "\\f0467";
}

.mdi-rotate-right-variant::before {
  content: "\\f0468";
}

.mdi-rounded-corner::before {
  content: "\\f0607";
}

.mdi-router::before {
  content: "\\f11e2";
}

.mdi-router-network::before {
  content: "\\f1087";
}

.mdi-router-wireless::before {
  content: "\\f0469";
}

.mdi-router-wireless-off::before {
  content: "\\f15a3";
}

.mdi-router-wireless-settings::before {
  content: "\\f0a69";
}

.mdi-routes::before {
  content: "\\f046a";
}

.mdi-routes-clock::before {
  content: "\\f1059";
}

.mdi-rowing::before {
  content: "\\f0608";
}

.mdi-rss::before {
  content: "\\f046b";
}

.mdi-rss-box::before {
  content: "\\f046c";
}

.mdi-rss-off::before {
  content: "\\f0f21";
}

.mdi-rug::before {
  content: "\\f1475";
}

.mdi-rugby::before {
  content: "\\f0d99";
}

.mdi-ruler::before {
  content: "\\f046d";
}

.mdi-ruler-square::before {
  content: "\\f0cc2";
}

.mdi-ruler-square-compass::before {
  content: "\\f0ebe";
}

.mdi-run::before {
  content: "\\f070e";
}

.mdi-run-fast::before {
  content: "\\f046e";
}

.mdi-rv-truck::before {
  content: "\\f11d4";
}

.mdi-sack::before {
  content: "\\f0d2e";
}

.mdi-sack-percent::before {
  content: "\\f0d2f";
}

.mdi-safe::before {
  content: "\\f0a6a";
}

.mdi-safe-square::before {
  content: "\\f127c";
}

.mdi-safe-square-outline::before {
  content: "\\f127d";
}

.mdi-safety-goggles::before {
  content: "\\f0d30";
}

.mdi-sail-boat::before {
  content: "\\f0ec8";
}

.mdi-sale::before {
  content: "\\f046f";
}

.mdi-salesforce::before {
  content: "\\f088e";
}

.mdi-sass::before {
  content: "\\f07ec";
}

.mdi-satellite::before {
  content: "\\f0470";
}

.mdi-satellite-uplink::before {
  content: "\\f0909";
}

.mdi-satellite-variant::before {
  content: "\\f0471";
}

.mdi-sausage::before {
  content: "\\f08ba";
}

.mdi-saw-blade::before {
  content: "\\f0e61";
}

.mdi-sawtooth-wave::before {
  content: "\\f147a";
}

.mdi-saxophone::before {
  content: "\\f0609";
}

.mdi-scale::before {
  content: "\\f0472";
}

.mdi-scale-balance::before {
  content: "\\f05d1";
}

.mdi-scale-bathroom::before {
  content: "\\f0473";
}

.mdi-scale-off::before {
  content: "\\f105a";
}

.mdi-scan-helper::before {
  content: "\\f13d8";
}

.mdi-scanner::before {
  content: "\\f06ab";
}

.mdi-scanner-off::before {
  content: "\\f090a";
}

.mdi-scatter-plot::before {
  content: "\\f0ec9";
}

.mdi-scatter-plot-outline::before {
  content: "\\f0eca";
}

.mdi-school::before {
  content: "\\f0474";
}

.mdi-school-outline::before {
  content: "\\f1180";
}

.mdi-scissors-cutting::before {
  content: "\\f0a6b";
}

.mdi-scooter::before {
  content: "\\f15bd";
}

.mdi-scooter-electric::before {
  content: "\\f15be";
}

.mdi-scoreboard::before {
  content: "\\f127e";
}

.mdi-scoreboard-outline::before {
  content: "\\f127f";
}

.mdi-screen-rotation::before {
  content: "\\f0475";
}

.mdi-screen-rotation-lock::before {
  content: "\\f0478";
}

.mdi-screw-flat-top::before {
  content: "\\f0df3";
}

.mdi-screw-lag::before {
  content: "\\f0df4";
}

.mdi-screw-machine-flat-top::before {
  content: "\\f0df5";
}

.mdi-screw-machine-round-top::before {
  content: "\\f0df6";
}

.mdi-screw-round-top::before {
  content: "\\f0df7";
}

.mdi-screwdriver::before {
  content: "\\f0476";
}

.mdi-script::before {
  content: "\\f0bc1";
}

.mdi-script-outline::before {
  content: "\\f0477";
}

.mdi-script-text::before {
  content: "\\f0bc2";
}

.mdi-script-text-key::before {
  content: "\\f1725";
}

.mdi-script-text-key-outline::before {
  content: "\\f1726";
}

.mdi-script-text-outline::before {
  content: "\\f0bc3";
}

.mdi-script-text-play::before {
  content: "\\f1727";
}

.mdi-script-text-play-outline::before {
  content: "\\f1728";
}

.mdi-sd::before {
  content: "\\f0479";
}

.mdi-seal::before {
  content: "\\f047a";
}

.mdi-seal-variant::before {
  content: "\\f0fd9";
}

.mdi-search-web::before {
  content: "\\f070f";
}

.mdi-seat::before {
  content: "\\f0cc3";
}

.mdi-seat-flat::before {
  content: "\\f047b";
}

.mdi-seat-flat-angled::before {
  content: "\\f047c";
}

.mdi-seat-individual-suite::before {
  content: "\\f047d";
}

.mdi-seat-legroom-extra::before {
  content: "\\f047e";
}

.mdi-seat-legroom-normal::before {
  content: "\\f047f";
}

.mdi-seat-legroom-reduced::before {
  content: "\\f0480";
}

.mdi-seat-outline::before {
  content: "\\f0cc4";
}

.mdi-seat-passenger::before {
  content: "\\f1249";
}

.mdi-seat-recline-extra::before {
  content: "\\f0481";
}

.mdi-seat-recline-normal::before {
  content: "\\f0482";
}

.mdi-seatbelt::before {
  content: "\\f0cc5";
}

.mdi-security::before {
  content: "\\f0483";
}

.mdi-security-network::before {
  content: "\\f0484";
}

.mdi-seed::before {
  content: "\\f0e62";
}

.mdi-seed-off::before {
  content: "\\f13fd";
}

.mdi-seed-off-outline::before {
  content: "\\f13fe";
}

.mdi-seed-outline::before {
  content: "\\f0e63";
}

.mdi-seesaw::before {
  content: "\\f15a4";
}

.mdi-segment::before {
  content: "\\f0ecb";
}

.mdi-select::before {
  content: "\\f0485";
}

.mdi-select-all::before {
  content: "\\f0486";
}

.mdi-select-color::before {
  content: "\\f0d31";
}

.mdi-select-compare::before {
  content: "\\f0ad9";
}

.mdi-select-drag::before {
  content: "\\f0a6c";
}

.mdi-select-group::before {
  content: "\\f0f82";
}

.mdi-select-inverse::before {
  content: "\\f0487";
}

.mdi-select-marker::before {
  content: "\\f1280";
}

.mdi-select-multiple::before {
  content: "\\f1281";
}

.mdi-select-multiple-marker::before {
  content: "\\f1282";
}

.mdi-select-off::before {
  content: "\\f0488";
}

.mdi-select-place::before {
  content: "\\f0fda";
}

.mdi-select-search::before {
  content: "\\f1204";
}

.mdi-selection::before {
  content: "\\f0489";
}

.mdi-selection-drag::before {
  content: "\\f0a6d";
}

.mdi-selection-ellipse::before {
  content: "\\f0d32";
}

.mdi-selection-ellipse-arrow-inside::before {
  content: "\\f0f22";
}

.mdi-selection-marker::before {
  content: "\\f1283";
}

.mdi-selection-multiple::before {
  content: "\\f1285";
}

.mdi-selection-multiple-marker::before {
  content: "\\f1284";
}

.mdi-selection-off::before {
  content: "\\f0777";
}

.mdi-selection-search::before {
  content: "\\f1205";
}

.mdi-semantic-web::before {
  content: "\\f1316";
}

.mdi-send::before {
  content: "\\f048a";
}

.mdi-send-check::before {
  content: "\\f1161";
}

.mdi-send-check-outline::before {
  content: "\\f1162";
}

.mdi-send-circle::before {
  content: "\\f0df8";
}

.mdi-send-circle-outline::before {
  content: "\\f0df9";
}

.mdi-send-clock::before {
  content: "\\f1163";
}

.mdi-send-clock-outline::before {
  content: "\\f1164";
}

.mdi-send-lock::before {
  content: "\\f07ed";
}

.mdi-send-lock-outline::before {
  content: "\\f1166";
}

.mdi-send-outline::before {
  content: "\\f1165";
}

.mdi-serial-port::before {
  content: "\\f065c";
}

.mdi-server::before {
  content: "\\f048b";
}

.mdi-server-minus::before {
  content: "\\f048c";
}

.mdi-server-network::before {
  content: "\\f048d";
}

.mdi-server-network-off::before {
  content: "\\f048e";
}

.mdi-server-off::before {
  content: "\\f048f";
}

.mdi-server-plus::before {
  content: "\\f0490";
}

.mdi-server-remove::before {
  content: "\\f0491";
}

.mdi-server-security::before {
  content: "\\f0492";
}

.mdi-set-all::before {
  content: "\\f0778";
}

.mdi-set-center::before {
  content: "\\f0779";
}

.mdi-set-center-right::before {
  content: "\\f077a";
}

.mdi-set-left::before {
  content: "\\f077b";
}

.mdi-set-left-center::before {
  content: "\\f077c";
}

.mdi-set-left-right::before {
  content: "\\f077d";
}

.mdi-set-merge::before {
  content: "\\f14e0";
}

.mdi-set-none::before {
  content: "\\f077e";
}

.mdi-set-right::before {
  content: "\\f077f";
}

.mdi-set-split::before {
  content: "\\f14e1";
}

.mdi-set-square::before {
  content: "\\f145d";
}

.mdi-set-top-box::before {
  content: "\\f099f";
}

.mdi-settings-helper::before {
  content: "\\f0a6e";
}

.mdi-shaker::before {
  content: "\\f110e";
}

.mdi-shaker-outline::before {
  content: "\\f110f";
}

.mdi-shape::before {
  content: "\\f0831";
}

.mdi-shape-circle-plus::before {
  content: "\\f065d";
}

.mdi-shape-outline::before {
  content: "\\f0832";
}

.mdi-shape-oval-plus::before {
  content: "\\f11fa";
}

.mdi-shape-plus::before {
  content: "\\f0495";
}

.mdi-shape-polygon-plus::before {
  content: "\\f065e";
}

.mdi-shape-rectangle-plus::before {
  content: "\\f065f";
}

.mdi-shape-square-plus::before {
  content: "\\f0660";
}

.mdi-shape-square-rounded-plus::before {
  content: "\\f14fa";
}

.mdi-share::before {
  content: "\\f0496";
}

.mdi-share-all::before {
  content: "\\f11f4";
}

.mdi-share-all-outline::before {
  content: "\\f11f5";
}

.mdi-share-circle::before {
  content: "\\f11ad";
}

.mdi-share-off::before {
  content: "\\f0f23";
}

.mdi-share-off-outline::before {
  content: "\\f0f24";
}

.mdi-share-outline::before {
  content: "\\f0932";
}

.mdi-share-variant::before {
  content: "\\f0497";
}

.mdi-share-variant-outline::before {
  content: "\\f1514";
}

.mdi-shark-fin::before {
  content: "\\f1673";
}

.mdi-shark-fin-outline::before {
  content: "\\f1674";
}

.mdi-sheep::before {
  content: "\\f0cc6";
}

.mdi-shield::before {
  content: "\\f0498";
}

.mdi-shield-account::before {
  content: "\\f088f";
}

.mdi-shield-account-outline::before {
  content: "\\f0a12";
}

.mdi-shield-account-variant::before {
  content: "\\f15a7";
}

.mdi-shield-account-variant-outline::before {
  content: "\\f15a8";
}

.mdi-shield-airplane::before {
  content: "\\f06bb";
}

.mdi-shield-airplane-outline::before {
  content: "\\f0cc7";
}

.mdi-shield-alert::before {
  content: "\\f0ecc";
}

.mdi-shield-alert-outline::before {
  content: "\\f0ecd";
}

.mdi-shield-bug::before {
  content: "\\f13da";
}

.mdi-shield-bug-outline::before {
  content: "\\f13db";
}

.mdi-shield-car::before {
  content: "\\f0f83";
}

.mdi-shield-check::before {
  content: "\\f0565";
}

.mdi-shield-check-outline::before {
  content: "\\f0cc8";
}

.mdi-shield-cross::before {
  content: "\\f0cc9";
}

.mdi-shield-cross-outline::before {
  content: "\\f0cca";
}

.mdi-shield-edit::before {
  content: "\\f11a0";
}

.mdi-shield-edit-outline::before {
  content: "\\f11a1";
}

.mdi-shield-half::before {
  content: "\\f1360";
}

.mdi-shield-half-full::before {
  content: "\\f0780";
}

.mdi-shield-home::before {
  content: "\\f068a";
}

.mdi-shield-home-outline::before {
  content: "\\f0ccb";
}

.mdi-shield-key::before {
  content: "\\f0bc4";
}

.mdi-shield-key-outline::before {
  content: "\\f0bc5";
}

.mdi-shield-link-variant::before {
  content: "\\f0d33";
}

.mdi-shield-link-variant-outline::before {
  content: "\\f0d34";
}

.mdi-shield-lock::before {
  content: "\\f099d";
}

.mdi-shield-lock-outline::before {
  content: "\\f0ccc";
}

.mdi-shield-off::before {
  content: "\\f099e";
}

.mdi-shield-off-outline::before {
  content: "\\f099c";
}

.mdi-shield-outline::before {
  content: "\\f0499";
}

.mdi-shield-plus::before {
  content: "\\f0ada";
}

.mdi-shield-plus-outline::before {
  content: "\\f0adb";
}

.mdi-shield-refresh::before {
  content: "\\f00aa";
}

.mdi-shield-refresh-outline::before {
  content: "\\f01e0";
}

.mdi-shield-remove::before {
  content: "\\f0adc";
}

.mdi-shield-remove-outline::before {
  content: "\\f0add";
}

.mdi-shield-search::before {
  content: "\\f0d9a";
}

.mdi-shield-star::before {
  content: "\\f113b";
}

.mdi-shield-star-outline::before {
  content: "\\f113c";
}

.mdi-shield-sun::before {
  content: "\\f105d";
}

.mdi-shield-sun-outline::before {
  content: "\\f105e";
}

.mdi-shield-sync::before {
  content: "\\f11a2";
}

.mdi-shield-sync-outline::before {
  content: "\\f11a3";
}

.mdi-ship-wheel::before {
  content: "\\f0833";
}

.mdi-shoe-ballet::before {
  content: "\\f15ca";
}

.mdi-shoe-cleat::before {
  content: "\\f15c7";
}

.mdi-shoe-formal::before {
  content: "\\f0b47";
}

.mdi-shoe-heel::before {
  content: "\\f0b48";
}

.mdi-shoe-print::before {
  content: "\\f0dfa";
}

.mdi-shoe-sneaker::before {
  content: "\\f15c8";
}

.mdi-shopping::before {
  content: "\\f049a";
}

.mdi-shopping-music::before {
  content: "\\f049b";
}

.mdi-shopping-outline::before {
  content: "\\f11d5";
}

.mdi-shopping-search::before {
  content: "\\f0f84";
}

.mdi-shore::before {
  content: "\\f14f9";
}

.mdi-shovel::before {
  content: "\\f0710";
}

.mdi-shovel-off::before {
  content: "\\f0711";
}

.mdi-shower::before {
  content: "\\f09a0";
}

.mdi-shower-head::before {
  content: "\\f09a1";
}

.mdi-shredder::before {
  content: "\\f049c";
}

.mdi-shuffle::before {
  content: "\\f049d";
}

.mdi-shuffle-disabled::before {
  content: "\\f049e";
}

.mdi-shuffle-variant::before {
  content: "\\f049f";
}

.mdi-shuriken::before {
  content: "\\f137f";
}

.mdi-sigma::before {
  content: "\\f04a0";
}

.mdi-sigma-lower::before {
  content: "\\f062b";
}

.mdi-sign-caution::before {
  content: "\\f04a1";
}

.mdi-sign-direction::before {
  content: "\\f0781";
}

.mdi-sign-direction-minus::before {
  content: "\\f1000";
}

.mdi-sign-direction-plus::before {
  content: "\\f0fdc";
}

.mdi-sign-direction-remove::before {
  content: "\\f0fdd";
}

.mdi-sign-pole::before {
  content: "\\f14f8";
}

.mdi-sign-real-estate::before {
  content: "\\f1118";
}

.mdi-sign-text::before {
  content: "\\f0782";
}

.mdi-signal::before {
  content: "\\f04a2";
}

.mdi-signal-2g::before {
  content: "\\f0712";
}

.mdi-signal-3g::before {
  content: "\\f0713";
}

.mdi-signal-4g::before {
  content: "\\f0714";
}

.mdi-signal-5g::before {
  content: "\\f0a6f";
}

.mdi-signal-cellular-1::before {
  content: "\\f08bc";
}

.mdi-signal-cellular-2::before {
  content: "\\f08bd";
}

.mdi-signal-cellular-3::before {
  content: "\\f08be";
}

.mdi-signal-cellular-outline::before {
  content: "\\f08bf";
}

.mdi-signal-distance-variant::before {
  content: "\\f0e64";
}

.mdi-signal-hspa::before {
  content: "\\f0715";
}

.mdi-signal-hspa-plus::before {
  content: "\\f0716";
}

.mdi-signal-off::before {
  content: "\\f0783";
}

.mdi-signal-variant::before {
  content: "\\f060a";
}

.mdi-signature::before {
  content: "\\f0dfb";
}

.mdi-signature-freehand::before {
  content: "\\f0dfc";
}

.mdi-signature-image::before {
  content: "\\f0dfd";
}

.mdi-signature-text::before {
  content: "\\f0dfe";
}

.mdi-silo::before {
  content: "\\f0b49";
}

.mdi-silverware::before {
  content: "\\f04a3";
}

.mdi-silverware-clean::before {
  content: "\\f0fde";
}

.mdi-silverware-fork::before {
  content: "\\f04a4";
}

.mdi-silverware-fork-knife::before {
  content: "\\f0a70";
}

.mdi-silverware-spoon::before {
  content: "\\f04a5";
}

.mdi-silverware-variant::before {
  content: "\\f04a6";
}

.mdi-sim::before {
  content: "\\f04a7";
}

.mdi-sim-alert::before {
  content: "\\f04a8";
}

.mdi-sim-alert-outline::before {
  content: "\\f15d3";
}

.mdi-sim-off::before {
  content: "\\f04a9";
}

.mdi-sim-off-outline::before {
  content: "\\f15d4";
}

.mdi-sim-outline::before {
  content: "\\f15d5";
}

.mdi-simple-icons::before {
  content: "\\f131d";
}

.mdi-sina-weibo::before {
  content: "\\f0adf";
}

.mdi-sine-wave::before {
  content: "\\f095b";
}

.mdi-sitemap::before {
  content: "\\f04aa";
}

.mdi-size-l::before {
  content: "\\f13a6";
}

.mdi-size-m::before {
  content: "\\f13a5";
}

.mdi-size-s::before {
  content: "\\f13a4";
}

.mdi-size-xl::before {
  content: "\\f13a7";
}

.mdi-size-xs::before {
  content: "\\f13a3";
}

.mdi-size-xxl::before {
  content: "\\f13a8";
}

.mdi-size-xxs::before {
  content: "\\f13a2";
}

.mdi-size-xxxl::before {
  content: "\\f13a9";
}

.mdi-skate::before {
  content: "\\f0d35";
}

.mdi-skateboard::before {
  content: "\\f14c2";
}

.mdi-skew-less::before {
  content: "\\f0d36";
}

.mdi-skew-more::before {
  content: "\\f0d37";
}

.mdi-ski::before {
  content: "\\f1304";
}

.mdi-ski-cross-country::before {
  content: "\\f1305";
}

.mdi-ski-water::before {
  content: "\\f1306";
}

.mdi-skip-backward::before {
  content: "\\f04ab";
}

.mdi-skip-backward-outline::before {
  content: "\\f0f25";
}

.mdi-skip-forward::before {
  content: "\\f04ac";
}

.mdi-skip-forward-outline::before {
  content: "\\f0f26";
}

.mdi-skip-next::before {
  content: "\\f04ad";
}

.mdi-skip-next-circle::before {
  content: "\\f0661";
}

.mdi-skip-next-circle-outline::before {
  content: "\\f0662";
}

.mdi-skip-next-outline::before {
  content: "\\f0f27";
}

.mdi-skip-previous::before {
  content: "\\f04ae";
}

.mdi-skip-previous-circle::before {
  content: "\\f0663";
}

.mdi-skip-previous-circle-outline::before {
  content: "\\f0664";
}

.mdi-skip-previous-outline::before {
  content: "\\f0f28";
}

.mdi-skull::before {
  content: "\\f068c";
}

.mdi-skull-crossbones::before {
  content: "\\f0bc6";
}

.mdi-skull-crossbones-outline::before {
  content: "\\f0bc7";
}

.mdi-skull-outline::before {
  content: "\\f0bc8";
}

.mdi-skull-scan::before {
  content: "\\f14c7";
}

.mdi-skull-scan-outline::before {
  content: "\\f14c8";
}

.mdi-skype::before {
  content: "\\f04af";
}

.mdi-skype-business::before {
  content: "\\f04b0";
}

.mdi-slack::before {
  content: "\\f04b1";
}

.mdi-slash-forward::before {
  content: "\\f0fdf";
}

.mdi-slash-forward-box::before {
  content: "\\f0fe0";
}

.mdi-sleep::before {
  content: "\\f04b2";
}

.mdi-sleep-off::before {
  content: "\\f04b3";
}

.mdi-slide::before {
  content: "\\f15a5";
}

.mdi-slope-downhill::before {
  content: "\\f0dff";
}

.mdi-slope-uphill::before {
  content: "\\f0e00";
}

.mdi-slot-machine::before {
  content: "\\f1114";
}

.mdi-slot-machine-outline::before {
  content: "\\f1115";
}

.mdi-smart-card::before {
  content: "\\f10bd";
}

.mdi-smart-card-outline::before {
  content: "\\f10be";
}

.mdi-smart-card-reader::before {
  content: "\\f10bf";
}

.mdi-smart-card-reader-outline::before {
  content: "\\f10c0";
}

.mdi-smog::before {
  content: "\\f0a71";
}

.mdi-smoke-detector::before {
  content: "\\f0392";
}

.mdi-smoking::before {
  content: "\\f04b4";
}

.mdi-smoking-off::before {
  content: "\\f04b5";
}

.mdi-smoking-pipe::before {
  content: "\\f140d";
}

.mdi-smoking-pipe-off::before {
  content: "\\f1428";
}

.mdi-snail::before {
  content: "\\f1677";
}

.mdi-snake::before {
  content: "\\f150e";
}

.mdi-snapchat::before {
  content: "\\f04b6";
}

.mdi-snowboard::before {
  content: "\\f1307";
}

.mdi-snowflake::before {
  content: "\\f0717";
}

.mdi-snowflake-alert::before {
  content: "\\f0f29";
}

.mdi-snowflake-melt::before {
  content: "\\f12cb";
}

.mdi-snowflake-off::before {
  content: "\\f14e3";
}

.mdi-snowflake-variant::before {
  content: "\\f0f2a";
}

.mdi-snowman::before {
  content: "\\f04b7";
}

.mdi-soccer::before {
  content: "\\f04b8";
}

.mdi-soccer-field::before {
  content: "\\f0834";
}

.mdi-social-distance-2-meters::before {
  content: "\\f1579";
}

.mdi-social-distance-6-feet::before {
  content: "\\f157a";
}

.mdi-sofa::before {
  content: "\\f04b9";
}

.mdi-sofa-outline::before {
  content: "\\f156d";
}

.mdi-sofa-single::before {
  content: "\\f156e";
}

.mdi-sofa-single-outline::before {
  content: "\\f156f";
}

.mdi-solar-panel::before {
  content: "\\f0d9b";
}

.mdi-solar-panel-large::before {
  content: "\\f0d9c";
}

.mdi-solar-power::before {
  content: "\\f0a72";
}

.mdi-soldering-iron::before {
  content: "\\f1092";
}

.mdi-solid::before {
  content: "\\f068d";
}

.mdi-sony-playstation::before {
  content: "\\f0414";
}

.mdi-sort::before {
  content: "\\f04ba";
}

.mdi-sort-alphabetical-ascending::before {
  content: "\\f05bd";
}

.mdi-sort-alphabetical-ascending-variant::before {
  content: "\\f1148";
}

.mdi-sort-alphabetical-descending::before {
  content: "\\f05bf";
}

.mdi-sort-alphabetical-descending-variant::before {
  content: "\\f1149";
}

.mdi-sort-alphabetical-variant::before {
  content: "\\f04bb";
}

.mdi-sort-ascending::before {
  content: "\\f04bc";
}

.mdi-sort-bool-ascending::before {
  content: "\\f1385";
}

.mdi-sort-bool-ascending-variant::before {
  content: "\\f1386";
}

.mdi-sort-bool-descending::before {
  content: "\\f1387";
}

.mdi-sort-bool-descending-variant::before {
  content: "\\f1388";
}

.mdi-sort-calendar-ascending::before {
  content: "\\f1547";
}

.mdi-sort-calendar-descending::before {
  content: "\\f1548";
}

.mdi-sort-clock-ascending::before {
  content: "\\f1549";
}

.mdi-sort-clock-ascending-outline::before {
  content: "\\f154a";
}

.mdi-sort-clock-descending::before {
  content: "\\f154b";
}

.mdi-sort-clock-descending-outline::before {
  content: "\\f154c";
}

.mdi-sort-descending::before {
  content: "\\f04bd";
}

.mdi-sort-numeric-ascending::before {
  content: "\\f1389";
}

.mdi-sort-numeric-ascending-variant::before {
  content: "\\f090d";
}

.mdi-sort-numeric-descending::before {
  content: "\\f138a";
}

.mdi-sort-numeric-descending-variant::before {
  content: "\\f0ad2";
}

.mdi-sort-numeric-variant::before {
  content: "\\f04be";
}

.mdi-sort-reverse-variant::before {
  content: "\\f033c";
}

.mdi-sort-variant::before {
  content: "\\f04bf";
}

.mdi-sort-variant-lock::before {
  content: "\\f0ccd";
}

.mdi-sort-variant-lock-open::before {
  content: "\\f0cce";
}

.mdi-sort-variant-remove::before {
  content: "\\f1147";
}

.mdi-soundcloud::before {
  content: "\\f04c0";
}

.mdi-source-branch::before {
  content: "\\f062c";
}

.mdi-source-branch-check::before {
  content: "\\f14cf";
}

.mdi-source-branch-minus::before {
  content: "\\f14cb";
}

.mdi-source-branch-plus::before {
  content: "\\f14ca";
}

.mdi-source-branch-refresh::before {
  content: "\\f14cd";
}

.mdi-source-branch-remove::before {
  content: "\\f14cc";
}

.mdi-source-branch-sync::before {
  content: "\\f14ce";
}

.mdi-source-commit::before {
  content: "\\f0718";
}

.mdi-source-commit-end::before {
  content: "\\f0719";
}

.mdi-source-commit-end-local::before {
  content: "\\f071a";
}

.mdi-source-commit-local::before {
  content: "\\f071b";
}

.mdi-source-commit-next-local::before {
  content: "\\f071c";
}

.mdi-source-commit-start::before {
  content: "\\f071d";
}

.mdi-source-commit-start-next-local::before {
  content: "\\f071e";
}

.mdi-source-fork::before {
  content: "\\f04c1";
}

.mdi-source-merge::before {
  content: "\\f062d";
}

.mdi-source-pull::before {
  content: "\\f04c2";
}

.mdi-source-repository::before {
  content: "\\f0ccf";
}

.mdi-source-repository-multiple::before {
  content: "\\f0cd0";
}

.mdi-soy-sauce::before {
  content: "\\f07ee";
}

.mdi-soy-sauce-off::before {
  content: "\\f13fc";
}

.mdi-spa::before {
  content: "\\f0cd1";
}

.mdi-spa-outline::before {
  content: "\\f0cd2";
}

.mdi-space-invaders::before {
  content: "\\f0bc9";
}

.mdi-space-station::before {
  content: "\\f1383";
}

.mdi-spade::before {
  content: "\\f0e65";
}

.mdi-sparkles::before {
  content: "\\f1545";
}

.mdi-speaker::before {
  content: "\\f04c3";
}

.mdi-speaker-bluetooth::before {
  content: "\\f09a2";
}

.mdi-speaker-multiple::before {
  content: "\\f0d38";
}

.mdi-speaker-off::before {
  content: "\\f04c4";
}

.mdi-speaker-wireless::before {
  content: "\\f071f";
}

.mdi-speedometer::before {
  content: "\\f04c5";
}

.mdi-speedometer-medium::before {
  content: "\\f0f85";
}

.mdi-speedometer-slow::before {
  content: "\\f0f86";
}

.mdi-spellcheck::before {
  content: "\\f04c6";
}

.mdi-spider::before {
  content: "\\f11ea";
}

.mdi-spider-thread::before {
  content: "\\f11eb";
}

.mdi-spider-web::before {
  content: "\\f0bca";
}

.mdi-spirit-level::before {
  content: "\\f14f1";
}

.mdi-spoon-sugar::before {
  content: "\\f1429";
}

.mdi-spotify::before {
  content: "\\f04c7";
}

.mdi-spotlight::before {
  content: "\\f04c8";
}

.mdi-spotlight-beam::before {
  content: "\\f04c9";
}

.mdi-spray::before {
  content: "\\f0665";
}

.mdi-spray-bottle::before {
  content: "\\f0ae0";
}

.mdi-sprinkler::before {
  content: "\\f105f";
}

.mdi-sprinkler-variant::before {
  content: "\\f1060";
}

.mdi-sprout::before {
  content: "\\f0e66";
}

.mdi-sprout-outline::before {
  content: "\\f0e67";
}

.mdi-square::before {
  content: "\\f0764";
}

.mdi-square-circle::before {
  content: "\\f1500";
}

.mdi-square-edit-outline::before {
  content: "\\f090c";
}

.mdi-square-medium::before {
  content: "\\f0a13";
}

.mdi-square-medium-outline::before {
  content: "\\f0a14";
}

.mdi-square-off::before {
  content: "\\f12ee";
}

.mdi-square-off-outline::before {
  content: "\\f12ef";
}

.mdi-square-outline::before {
  content: "\\f0763";
}

.mdi-square-root::before {
  content: "\\f0784";
}

.mdi-square-root-box::before {
  content: "\\f09a3";
}

.mdi-square-rounded::before {
  content: "\\f14fb";
}

.mdi-square-rounded-outline::before {
  content: "\\f14fc";
}

.mdi-square-small::before {
  content: "\\f0a15";
}

.mdi-square-wave::before {
  content: "\\f147b";
}

.mdi-squeegee::before {
  content: "\\f0ae1";
}

.mdi-ssh::before {
  content: "\\f08c0";
}

.mdi-stack-exchange::before {
  content: "\\f060b";
}

.mdi-stack-overflow::before {
  content: "\\f04cc";
}

.mdi-stackpath::before {
  content: "\\f0359";
}

.mdi-stadium::before {
  content: "\\f0ff9";
}

.mdi-stadium-variant::before {
  content: "\\f0720";
}

.mdi-stairs::before {
  content: "\\f04cd";
}

.mdi-stairs-box::before {
  content: "\\f139e";
}

.mdi-stairs-down::before {
  content: "\\f12be";
}

.mdi-stairs-up::before {
  content: "\\f12bd";
}

.mdi-stamper::before {
  content: "\\f0d39";
}

.mdi-standard-definition::before {
  content: "\\f07ef";
}

.mdi-star::before {
  content: "\\f04ce";
}

.mdi-star-box::before {
  content: "\\f0a73";
}

.mdi-star-box-multiple::before {
  content: "\\f1286";
}

.mdi-star-box-multiple-outline::before {
  content: "\\f1287";
}

.mdi-star-box-outline::before {
  content: "\\f0a74";
}

.mdi-star-check::before {
  content: "\\f1566";
}

.mdi-star-check-outline::before {
  content: "\\f156a";
}

.mdi-star-circle::before {
  content: "\\f04cf";
}

.mdi-star-circle-outline::before {
  content: "\\f09a4";
}

.mdi-star-cog::before {
  content: "\\f1668";
}

.mdi-star-cog-outline::before {
  content: "\\f1669";
}

.mdi-star-face::before {
  content: "\\f09a5";
}

.mdi-star-four-points::before {
  content: "\\f0ae2";
}

.mdi-star-four-points-outline::before {
  content: "\\f0ae3";
}

.mdi-star-half::before {
  content: "\\f0246";
}

.mdi-star-half-full::before {
  content: "\\f04d0";
}

.mdi-star-minus::before {
  content: "\\f1564";
}

.mdi-star-minus-outline::before {
  content: "\\f1568";
}

.mdi-star-off::before {
  content: "\\f04d1";
}

.mdi-star-off-outline::before {
  content: "\\f155b";
}

.mdi-star-outline::before {
  content: "\\f04d2";
}

.mdi-star-plus::before {
  content: "\\f1563";
}

.mdi-star-plus-outline::before {
  content: "\\f1567";
}

.mdi-star-remove::before {
  content: "\\f1565";
}

.mdi-star-remove-outline::before {
  content: "\\f1569";
}

.mdi-star-settings::before {
  content: "\\f166a";
}

.mdi-star-settings-outline::before {
  content: "\\f166b";
}

.mdi-star-shooting::before {
  content: "\\f1741";
}

.mdi-star-shooting-outline::before {
  content: "\\f1742";
}

.mdi-star-three-points::before {
  content: "\\f0ae4";
}

.mdi-star-three-points-outline::before {
  content: "\\f0ae5";
}

.mdi-state-machine::before {
  content: "\\f11ef";
}

.mdi-steam::before {
  content: "\\f04d3";
}

.mdi-steering::before {
  content: "\\f04d4";
}

.mdi-steering-off::before {
  content: "\\f090e";
}

.mdi-step-backward::before {
  content: "\\f04d5";
}

.mdi-step-backward-2::before {
  content: "\\f04d6";
}

.mdi-step-forward::before {
  content: "\\f04d7";
}

.mdi-step-forward-2::before {
  content: "\\f04d8";
}

.mdi-stethoscope::before {
  content: "\\f04d9";
}

.mdi-sticker::before {
  content: "\\f1364";
}

.mdi-sticker-alert::before {
  content: "\\f1365";
}

.mdi-sticker-alert-outline::before {
  content: "\\f1366";
}

.mdi-sticker-check::before {
  content: "\\f1367";
}

.mdi-sticker-check-outline::before {
  content: "\\f1368";
}

.mdi-sticker-circle-outline::before {
  content: "\\f05d0";
}

.mdi-sticker-emoji::before {
  content: "\\f0785";
}

.mdi-sticker-minus::before {
  content: "\\f1369";
}

.mdi-sticker-minus-outline::before {
  content: "\\f136a";
}

.mdi-sticker-outline::before {
  content: "\\f136b";
}

.mdi-sticker-plus::before {
  content: "\\f136c";
}

.mdi-sticker-plus-outline::before {
  content: "\\f136d";
}

.mdi-sticker-remove::before {
  content: "\\f136e";
}

.mdi-sticker-remove-outline::before {
  content: "\\f136f";
}

.mdi-stocking::before {
  content: "\\f04da";
}

.mdi-stomach::before {
  content: "\\f1093";
}

.mdi-stop::before {
  content: "\\f04db";
}

.mdi-stop-circle::before {
  content: "\\f0666";
}

.mdi-stop-circle-outline::before {
  content: "\\f0667";
}

.mdi-store::before {
  content: "\\f04dc";
}

.mdi-store-24-hour::before {
  content: "\\f04dd";
}

.mdi-store-minus::before {
  content: "\\f165e";
}

.mdi-store-outline::before {
  content: "\\f1361";
}

.mdi-store-plus::before {
  content: "\\f165f";
}

.mdi-store-remove::before {
  content: "\\f1660";
}

.mdi-storefront::before {
  content: "\\f07c7";
}

.mdi-storefront-outline::before {
  content: "\\f10c1";
}

.mdi-stove::before {
  content: "\\f04de";
}

.mdi-strategy::before {
  content: "\\f11d6";
}

.mdi-stretch-to-page::before {
  content: "\\f0f2b";
}

.mdi-stretch-to-page-outline::before {
  content: "\\f0f2c";
}

.mdi-string-lights::before {
  content: "\\f12ba";
}

.mdi-string-lights-off::before {
  content: "\\f12bb";
}

.mdi-subdirectory-arrow-left::before {
  content: "\\f060c";
}

.mdi-subdirectory-arrow-right::before {
  content: "\\f060d";
}

.mdi-submarine::before {
  content: "\\f156c";
}

.mdi-subtitles::before {
  content: "\\f0a16";
}

.mdi-subtitles-outline::before {
  content: "\\f0a17";
}

.mdi-subway::before {
  content: "\\f06ac";
}

.mdi-subway-alert-variant::before {
  content: "\\f0d9d";
}

.mdi-subway-variant::before {
  content: "\\f04df";
}

.mdi-summit::before {
  content: "\\f0786";
}

.mdi-sunglasses::before {
  content: "\\f04e0";
}

.mdi-surround-sound::before {
  content: "\\f05c5";
}

.mdi-surround-sound-2-0::before {
  content: "\\f07f0";
}

.mdi-surround-sound-2-1::before {
  content: "\\f1729";
}

.mdi-surround-sound-3-1::before {
  content: "\\f07f1";
}

.mdi-surround-sound-5-1::before {
  content: "\\f07f2";
}

.mdi-surround-sound-5-1-2::before {
  content: "\\f172a";
}

.mdi-surround-sound-7-1::before {
  content: "\\f07f3";
}

.mdi-svg::before {
  content: "\\f0721";
}

.mdi-swap-horizontal::before {
  content: "\\f04e1";
}

.mdi-swap-horizontal-bold::before {
  content: "\\f0bcd";
}

.mdi-swap-horizontal-circle::before {
  content: "\\f0fe1";
}

.mdi-swap-horizontal-circle-outline::before {
  content: "\\f0fe2";
}

.mdi-swap-horizontal-variant::before {
  content: "\\f08c1";
}

.mdi-swap-vertical::before {
  content: "\\f04e2";
}

.mdi-swap-vertical-bold::before {
  content: "\\f0bce";
}

.mdi-swap-vertical-circle::before {
  content: "\\f0fe3";
}

.mdi-swap-vertical-circle-outline::before {
  content: "\\f0fe4";
}

.mdi-swap-vertical-variant::before {
  content: "\\f08c2";
}

.mdi-swim::before {
  content: "\\f04e3";
}

.mdi-switch::before {
  content: "\\f04e4";
}

.mdi-sword::before {
  content: "\\f04e5";
}

.mdi-sword-cross::before {
  content: "\\f0787";
}

.mdi-syllabary-hangul::before {
  content: "\\f1333";
}

.mdi-syllabary-hiragana::before {
  content: "\\f1334";
}

.mdi-syllabary-katakana::before {
  content: "\\f1335";
}

.mdi-syllabary-katakana-halfwidth::before {
  content: "\\f1336";
}

.mdi-symbol::before {
  content: "\\f1501";
}

.mdi-symfony::before {
  content: "\\f0ae6";
}

.mdi-sync::before {
  content: "\\f04e6";
}

.mdi-sync-alert::before {
  content: "\\f04e7";
}

.mdi-sync-circle::before {
  content: "\\f1378";
}

.mdi-sync-off::before {
  content: "\\f04e8";
}

.mdi-tab::before {
  content: "\\f04e9";
}

.mdi-tab-minus::before {
  content: "\\f0b4b";
}

.mdi-tab-plus::before {
  content: "\\f075c";
}

.mdi-tab-remove::before {
  content: "\\f0b4c";
}

.mdi-tab-unselected::before {
  content: "\\f04ea";
}

.mdi-table::before {
  content: "\\f04eb";
}

.mdi-table-account::before {
  content: "\\f13b9";
}

.mdi-table-alert::before {
  content: "\\f13ba";
}

.mdi-table-arrow-down::before {
  content: "\\f13bb";
}

.mdi-table-arrow-left::before {
  content: "\\f13bc";
}

.mdi-table-arrow-right::before {
  content: "\\f13bd";
}

.mdi-table-arrow-up::before {
  content: "\\f13be";
}

.mdi-table-border::before {
  content: "\\f0a18";
}

.mdi-table-cancel::before {
  content: "\\f13bf";
}

.mdi-table-chair::before {
  content: "\\f1061";
}

.mdi-table-check::before {
  content: "\\f13c0";
}

.mdi-table-clock::before {
  content: "\\f13c1";
}

.mdi-table-cog::before {
  content: "\\f13c2";
}

.mdi-table-column::before {
  content: "\\f0835";
}

.mdi-table-column-plus-after::before {
  content: "\\f04ec";
}

.mdi-table-column-plus-before::before {
  content: "\\f04ed";
}

.mdi-table-column-remove::before {
  content: "\\f04ee";
}

.mdi-table-column-width::before {
  content: "\\f04ef";
}

.mdi-table-edit::before {
  content: "\\f04f0";
}

.mdi-table-eye::before {
  content: "\\f1094";
}

.mdi-table-eye-off::before {
  content: "\\f13c3";
}

.mdi-table-furniture::before {
  content: "\\f05bc";
}

.mdi-table-headers-eye::before {
  content: "\\f121d";
}

.mdi-table-headers-eye-off::before {
  content: "\\f121e";
}

.mdi-table-heart::before {
  content: "\\f13c4";
}

.mdi-table-key::before {
  content: "\\f13c5";
}

.mdi-table-large::before {
  content: "\\f04f1";
}

.mdi-table-large-plus::before {
  content: "\\f0f87";
}

.mdi-table-large-remove::before {
  content: "\\f0f88";
}

.mdi-table-lock::before {
  content: "\\f13c6";
}

.mdi-table-merge-cells::before {
  content: "\\f09a6";
}

.mdi-table-minus::before {
  content: "\\f13c7";
}

.mdi-table-multiple::before {
  content: "\\f13c8";
}

.mdi-table-network::before {
  content: "\\f13c9";
}

.mdi-table-of-contents::before {
  content: "\\f0836";
}

.mdi-table-off::before {
  content: "\\f13ca";
}

.mdi-table-picnic::before {
  content: "\\f1743";
}

.mdi-table-plus::before {
  content: "\\f0a75";
}

.mdi-table-refresh::before {
  content: "\\f13a0";
}

.mdi-table-remove::before {
  content: "\\f0a76";
}

.mdi-table-row::before {
  content: "\\f0837";
}

.mdi-table-row-height::before {
  content: "\\f04f2";
}

.mdi-table-row-plus-after::before {
  content: "\\f04f3";
}

.mdi-table-row-plus-before::before {
  content: "\\f04f4";
}

.mdi-table-row-remove::before {
  content: "\\f04f5";
}

.mdi-table-search::before {
  content: "\\f090f";
}

.mdi-table-settings::before {
  content: "\\f0838";
}

.mdi-table-split-cell::before {
  content: "\\f142a";
}

.mdi-table-star::before {
  content: "\\f13cb";
}

.mdi-table-sync::before {
  content: "\\f13a1";
}

.mdi-table-tennis::before {
  content: "\\f0e68";
}

.mdi-tablet::before {
  content: "\\f04f6";
}

.mdi-tablet-android::before {
  content: "\\f04f7";
}

.mdi-tablet-cellphone::before {
  content: "\\f09a7";
}

.mdi-tablet-dashboard::before {
  content: "\\f0ece";
}

.mdi-tablet-ipad::before {
  content: "\\f04f8";
}

.mdi-taco::before {
  content: "\\f0762";
}

.mdi-tag::before {
  content: "\\f04f9";
}

.mdi-tag-arrow-down::before {
  content: "\\f172b";
}

.mdi-tag-arrow-down-outline::before {
  content: "\\f172c";
}

.mdi-tag-arrow-left::before {
  content: "\\f172d";
}

.mdi-tag-arrow-left-outline::before {
  content: "\\f172e";
}

.mdi-tag-arrow-right::before {
  content: "\\f172f";
}

.mdi-tag-arrow-right-outline::before {
  content: "\\f1730";
}

.mdi-tag-arrow-up::before {
  content: "\\f1731";
}

.mdi-tag-arrow-up-outline::before {
  content: "\\f1732";
}

.mdi-tag-faces::before {
  content: "\\f04fa";
}

.mdi-tag-heart::before {
  content: "\\f068b";
}

.mdi-tag-heart-outline::before {
  content: "\\f0bcf";
}

.mdi-tag-minus::before {
  content: "\\f0910";
}

.mdi-tag-minus-outline::before {
  content: "\\f121f";
}

.mdi-tag-multiple::before {
  content: "\\f04fb";
}

.mdi-tag-multiple-outline::before {
  content: "\\f12f7";
}

.mdi-tag-off::before {
  content: "\\f1220";
}

.mdi-tag-off-outline::before {
  content: "\\f1221";
}

.mdi-tag-outline::before {
  content: "\\f04fc";
}

.mdi-tag-plus::before {
  content: "\\f0722";
}

.mdi-tag-plus-outline::before {
  content: "\\f1222";
}

.mdi-tag-remove::before {
  content: "\\f0723";
}

.mdi-tag-remove-outline::before {
  content: "\\f1223";
}

.mdi-tag-text::before {
  content: "\\f1224";
}

.mdi-tag-text-outline::before {
  content: "\\f04fd";
}

.mdi-tailwind::before {
  content: "\\f13ff";
}

.mdi-tank::before {
  content: "\\f0d3a";
}

.mdi-tanker-truck::before {
  content: "\\f0fe5";
}

.mdi-tape-drive::before {
  content: "\\f16df";
}

.mdi-tape-measure::before {
  content: "\\f0b4d";
}

.mdi-target::before {
  content: "\\f04fe";
}

.mdi-target-account::before {
  content: "\\f0bd0";
}

.mdi-target-variant::before {
  content: "\\f0a77";
}

.mdi-taxi::before {
  content: "\\f04ff";
}

.mdi-tea::before {
  content: "\\f0d9e";
}

.mdi-tea-outline::before {
  content: "\\f0d9f";
}

.mdi-teach::before {
  content: "\\f0890";
}

.mdi-teamviewer::before {
  content: "\\f0500";
}

.mdi-telegram::before {
  content: "\\f0501";
}

.mdi-telescope::before {
  content: "\\f0b4e";
}

.mdi-television::before {
  content: "\\f0502";
}

.mdi-television-ambient-light::before {
  content: "\\f1356";
}

.mdi-television-box::before {
  content: "\\f0839";
}

.mdi-television-classic::before {
  content: "\\f07f4";
}

.mdi-television-classic-off::before {
  content: "\\f083a";
}

.mdi-television-clean::before {
  content: "\\f1110";
}

.mdi-television-guide::before {
  content: "\\f0503";
}

.mdi-television-off::before {
  content: "\\f083b";
}

.mdi-television-pause::before {
  content: "\\f0f89";
}

.mdi-television-play::before {
  content: "\\f0ecf";
}

.mdi-television-stop::before {
  content: "\\f0f8a";
}

.mdi-temperature-celsius::before {
  content: "\\f0504";
}

.mdi-temperature-fahrenheit::before {
  content: "\\f0505";
}

.mdi-temperature-kelvin::before {
  content: "\\f0506";
}

.mdi-tennis::before {
  content: "\\f0da0";
}

.mdi-tennis-ball::before {
  content: "\\f0507";
}

.mdi-tent::before {
  content: "\\f0508";
}

.mdi-terraform::before {
  content: "\\f1062";
}

.mdi-terrain::before {
  content: "\\f0509";
}

.mdi-test-tube::before {
  content: "\\f0668";
}

.mdi-test-tube-empty::before {
  content: "\\f0911";
}

.mdi-test-tube-off::before {
  content: "\\f0912";
}

.mdi-text::before {
  content: "\\f09a8";
}

.mdi-text-account::before {
  content: "\\f1570";
}

.mdi-text-box::before {
  content: "\\f021a";
}

.mdi-text-box-check::before {
  content: "\\f0ea6";
}

.mdi-text-box-check-outline::before {
  content: "\\f0ea7";
}

.mdi-text-box-minus::before {
  content: "\\f0ea8";
}

.mdi-text-box-minus-outline::before {
  content: "\\f0ea9";
}

.mdi-text-box-multiple::before {
  content: "\\f0ab7";
}

.mdi-text-box-multiple-outline::before {
  content: "\\f0ab8";
}

.mdi-text-box-outline::before {
  content: "\\f09ed";
}

.mdi-text-box-plus::before {
  content: "\\f0eaa";
}

.mdi-text-box-plus-outline::before {
  content: "\\f0eab";
}

.mdi-text-box-remove::before {
  content: "\\f0eac";
}

.mdi-text-box-remove-outline::before {
  content: "\\f0ead";
}

.mdi-text-box-search::before {
  content: "\\f0eae";
}

.mdi-text-box-search-outline::before {
  content: "\\f0eaf";
}

.mdi-text-recognition::before {
  content: "\\f113d";
}

.mdi-text-search::before {
  content: "\\f13b8";
}

.mdi-text-shadow::before {
  content: "\\f0669";
}

.mdi-text-short::before {
  content: "\\f09a9";
}

.mdi-text-subject::before {
  content: "\\f09aa";
}

.mdi-text-to-speech::before {
  content: "\\f050a";
}

.mdi-text-to-speech-off::before {
  content: "\\f050b";
}

.mdi-texture::before {
  content: "\\f050c";
}

.mdi-texture-box::before {
  content: "\\f0fe6";
}

.mdi-theater::before {
  content: "\\f050d";
}

.mdi-theme-light-dark::before {
  content: "\\f050e";
}

.mdi-thermometer::before {
  content: "\\f050f";
}

.mdi-thermometer-alert::before {
  content: "\\f0e01";
}

.mdi-thermometer-chevron-down::before {
  content: "\\f0e02";
}

.mdi-thermometer-chevron-up::before {
  content: "\\f0e03";
}

.mdi-thermometer-high::before {
  content: "\\f10c2";
}

.mdi-thermometer-lines::before {
  content: "\\f0510";
}

.mdi-thermometer-low::before {
  content: "\\f10c3";
}

.mdi-thermometer-minus::before {
  content: "\\f0e04";
}

.mdi-thermometer-off::before {
  content: "\\f1531";
}

.mdi-thermometer-plus::before {
  content: "\\f0e05";
}

.mdi-thermostat::before {
  content: "\\f0393";
}

.mdi-thermostat-box::before {
  content: "\\f0891";
}

.mdi-thought-bubble::before {
  content: "\\f07f6";
}

.mdi-thought-bubble-outline::before {
  content: "\\f07f7";
}

.mdi-thumb-down::before {
  content: "\\f0511";
}

.mdi-thumb-down-outline::before {
  content: "\\f0512";
}

.mdi-thumb-up::before {
  content: "\\f0513";
}

.mdi-thumb-up-outline::before {
  content: "\\f0514";
}

.mdi-thumbs-up-down::before {
  content: "\\f0515";
}

.mdi-ticket::before {
  content: "\\f0516";
}

.mdi-ticket-account::before {
  content: "\\f0517";
}

.mdi-ticket-confirmation::before {
  content: "\\f0518";
}

.mdi-ticket-confirmation-outline::before {
  content: "\\f13aa";
}

.mdi-ticket-outline::before {
  content: "\\f0913";
}

.mdi-ticket-percent::before {
  content: "\\f0724";
}

.mdi-ticket-percent-outline::before {
  content: "\\f142b";
}

.mdi-tie::before {
  content: "\\f0519";
}

.mdi-tilde::before {
  content: "\\f0725";
}

.mdi-timelapse::before {
  content: "\\f051a";
}

.mdi-timeline::before {
  content: "\\f0bd1";
}

.mdi-timeline-alert::before {
  content: "\\f0f95";
}

.mdi-timeline-alert-outline::before {
  content: "\\f0f98";
}

.mdi-timeline-check::before {
  content: "\\f1532";
}

.mdi-timeline-check-outline::before {
  content: "\\f1533";
}

.mdi-timeline-clock::before {
  content: "\\f11fb";
}

.mdi-timeline-clock-outline::before {
  content: "\\f11fc";
}

.mdi-timeline-help::before {
  content: "\\f0f99";
}

.mdi-timeline-help-outline::before {
  content: "\\f0f9a";
}

.mdi-timeline-minus::before {
  content: "\\f1534";
}

.mdi-timeline-minus-outline::before {
  content: "\\f1535";
}

.mdi-timeline-outline::before {
  content: "\\f0bd2";
}

.mdi-timeline-plus::before {
  content: "\\f0f96";
}

.mdi-timeline-plus-outline::before {
  content: "\\f0f97";
}

.mdi-timeline-remove::before {
  content: "\\f1536";
}

.mdi-timeline-remove-outline::before {
  content: "\\f1537";
}

.mdi-timeline-text::before {
  content: "\\f0bd3";
}

.mdi-timeline-text-outline::before {
  content: "\\f0bd4";
}

.mdi-timer::before {
  content: "\\f13ab";
}

.mdi-timer-10::before {
  content: "\\f051c";
}

.mdi-timer-3::before {
  content: "\\f051d";
}

.mdi-timer-off::before {
  content: "\\f13ac";
}

.mdi-timer-off-outline::before {
  content: "\\f051e";
}

.mdi-timer-outline::before {
  content: "\\f051b";
}

.mdi-timer-sand::before {
  content: "\\f051f";
}

.mdi-timer-sand-empty::before {
  content: "\\f06ad";
}

.mdi-timer-sand-full::before {
  content: "\\f078c";
}

.mdi-timetable::before {
  content: "\\f0520";
}

.mdi-toaster::before {
  content: "\\f1063";
}

.mdi-toaster-off::before {
  content: "\\f11b7";
}

.mdi-toaster-oven::before {
  content: "\\f0cd3";
}

.mdi-toggle-switch::before {
  content: "\\f0521";
}

.mdi-toggle-switch-off::before {
  content: "\\f0522";
}

.mdi-toggle-switch-off-outline::before {
  content: "\\f0a19";
}

.mdi-toggle-switch-outline::before {
  content: "\\f0a1a";
}

.mdi-toilet::before {
  content: "\\f09ab";
}

.mdi-toolbox::before {
  content: "\\f09ac";
}

.mdi-toolbox-outline::before {
  content: "\\f09ad";
}

.mdi-tools::before {
  content: "\\f1064";
}

.mdi-tooltip::before {
  content: "\\f0523";
}

.mdi-tooltip-account::before {
  content: "\\f000c";
}

.mdi-tooltip-check::before {
  content: "\\f155c";
}

.mdi-tooltip-check-outline::before {
  content: "\\f155d";
}

.mdi-tooltip-edit::before {
  content: "\\f0524";
}

.mdi-tooltip-edit-outline::before {
  content: "\\f12c5";
}

.mdi-tooltip-image::before {
  content: "\\f0525";
}

.mdi-tooltip-image-outline::before {
  content: "\\f0bd5";
}

.mdi-tooltip-minus::before {
  content: "\\f155e";
}

.mdi-tooltip-minus-outline::before {
  content: "\\f155f";
}

.mdi-tooltip-outline::before {
  content: "\\f0526";
}

.mdi-tooltip-plus::before {
  content: "\\f0bd6";
}

.mdi-tooltip-plus-outline::before {
  content: "\\f0527";
}

.mdi-tooltip-remove::before {
  content: "\\f1560";
}

.mdi-tooltip-remove-outline::before {
  content: "\\f1561";
}

.mdi-tooltip-text::before {
  content: "\\f0528";
}

.mdi-tooltip-text-outline::before {
  content: "\\f0bd7";
}

.mdi-tooth::before {
  content: "\\f08c3";
}

.mdi-tooth-outline::before {
  content: "\\f0529";
}

.mdi-toothbrush::before {
  content: "\\f1129";
}

.mdi-toothbrush-electric::before {
  content: "\\f112c";
}

.mdi-toothbrush-paste::before {
  content: "\\f112a";
}

.mdi-torch::before {
  content: "\\f1606";
}

.mdi-tortoise::before {
  content: "\\f0d3b";
}

.mdi-toslink::before {
  content: "\\f12b8";
}

.mdi-tournament::before {
  content: "\\f09ae";
}

.mdi-tow-truck::before {
  content: "\\f083c";
}

.mdi-tower-beach::before {
  content: "\\f0681";
}

.mdi-tower-fire::before {
  content: "\\f0682";
}

.mdi-toy-brick::before {
  content: "\\f1288";
}

.mdi-toy-brick-marker::before {
  content: "\\f1289";
}

.mdi-toy-brick-marker-outline::before {
  content: "\\f128a";
}

.mdi-toy-brick-minus::before {
  content: "\\f128b";
}

.mdi-toy-brick-minus-outline::before {
  content: "\\f128c";
}

.mdi-toy-brick-outline::before {
  content: "\\f128d";
}

.mdi-toy-brick-plus::before {
  content: "\\f128e";
}

.mdi-toy-brick-plus-outline::before {
  content: "\\f128f";
}

.mdi-toy-brick-remove::before {
  content: "\\f1290";
}

.mdi-toy-brick-remove-outline::before {
  content: "\\f1291";
}

.mdi-toy-brick-search::before {
  content: "\\f1292";
}

.mdi-toy-brick-search-outline::before {
  content: "\\f1293";
}

.mdi-track-light::before {
  content: "\\f0914";
}

.mdi-trackpad::before {
  content: "\\f07f8";
}

.mdi-trackpad-lock::before {
  content: "\\f0933";
}

.mdi-tractor::before {
  content: "\\f0892";
}

.mdi-tractor-variant::before {
  content: "\\f14c4";
}

.mdi-trademark::before {
  content: "\\f0a78";
}

.mdi-traffic-cone::before {
  content: "\\f137c";
}

.mdi-traffic-light::before {
  content: "\\f052b";
}

.mdi-train::before {
  content: "\\f052c";
}

.mdi-train-car::before {
  content: "\\f0bd8";
}

.mdi-train-car-passenger::before {
  content: "\\f1733";
}

.mdi-train-car-passenger-door::before {
  content: "\\f1734";
}

.mdi-train-car-passenger-door-open::before {
  content: "\\f1735";
}

.mdi-train-car-passenger-variant::before {
  content: "\\f1736";
}

.mdi-train-variant::before {
  content: "\\f08c4";
}

.mdi-tram::before {
  content: "\\f052d";
}

.mdi-tram-side::before {
  content: "\\f0fe7";
}

.mdi-transcribe::before {
  content: "\\f052e";
}

.mdi-transcribe-close::before {
  content: "\\f052f";
}

.mdi-transfer::before {
  content: "\\f1065";
}

.mdi-transfer-down::before {
  content: "\\f0da1";
}

.mdi-transfer-left::before {
  content: "\\f0da2";
}

.mdi-transfer-right::before {
  content: "\\f0530";
}

.mdi-transfer-up::before {
  content: "\\f0da3";
}

.mdi-transit-connection::before {
  content: "\\f0d3c";
}

.mdi-transit-connection-horizontal::before {
  content: "\\f1546";
}

.mdi-transit-connection-variant::before {
  content: "\\f0d3d";
}

.mdi-transit-detour::before {
  content: "\\f0f8b";
}

.mdi-transit-skip::before {
  content: "\\f1515";
}

.mdi-transit-transfer::before {
  content: "\\f06ae";
}

.mdi-transition::before {
  content: "\\f0915";
}

.mdi-transition-masked::before {
  content: "\\f0916";
}

.mdi-translate::before {
  content: "\\f05ca";
}

.mdi-translate-off::before {
  content: "\\f0e06";
}

.mdi-transmission-tower::before {
  content: "\\f0d3e";
}

.mdi-trash-can::before {
  content: "\\f0a79";
}

.mdi-trash-can-outline::before {
  content: "\\f0a7a";
}

.mdi-tray::before {
  content: "\\f1294";
}

.mdi-tray-alert::before {
  content: "\\f1295";
}

.mdi-tray-full::before {
  content: "\\f1296";
}

.mdi-tray-minus::before {
  content: "\\f1297";
}

.mdi-tray-plus::before {
  content: "\\f1298";
}

.mdi-tray-remove::before {
  content: "\\f1299";
}

.mdi-treasure-chest::before {
  content: "\\f0726";
}

.mdi-tree::before {
  content: "\\f0531";
}

.mdi-tree-outline::before {
  content: "\\f0e69";
}

.mdi-trello::before {
  content: "\\f0532";
}

.mdi-trending-down::before {
  content: "\\f0533";
}

.mdi-trending-neutral::before {
  content: "\\f0534";
}

.mdi-trending-up::before {
  content: "\\f0535";
}

.mdi-triangle::before {
  content: "\\f0536";
}

.mdi-triangle-outline::before {
  content: "\\f0537";
}

.mdi-triangle-wave::before {
  content: "\\f147c";
}

.mdi-triforce::before {
  content: "\\f0bd9";
}

.mdi-trophy::before {
  content: "\\f0538";
}

.mdi-trophy-award::before {
  content: "\\f0539";
}

.mdi-trophy-broken::before {
  content: "\\f0da4";
}

.mdi-trophy-outline::before {
  content: "\\f053a";
}

.mdi-trophy-variant::before {
  content: "\\f053b";
}

.mdi-trophy-variant-outline::before {
  content: "\\f053c";
}

.mdi-truck::before {
  content: "\\f053d";
}

.mdi-truck-check::before {
  content: "\\f0cd4";
}

.mdi-truck-check-outline::before {
  content: "\\f129a";
}

.mdi-truck-delivery::before {
  content: "\\f053e";
}

.mdi-truck-delivery-outline::before {
  content: "\\f129b";
}

.mdi-truck-fast::before {
  content: "\\f0788";
}

.mdi-truck-fast-outline::before {
  content: "\\f129c";
}

.mdi-truck-outline::before {
  content: "\\f129d";
}

.mdi-truck-trailer::before {
  content: "\\f0727";
}

.mdi-trumpet::before {
  content: "\\f1096";
}

.mdi-tshirt-crew::before {
  content: "\\f0a7b";
}

.mdi-tshirt-crew-outline::before {
  content: "\\f053f";
}

.mdi-tshirt-v::before {
  content: "\\f0a7c";
}

.mdi-tshirt-v-outline::before {
  content: "\\f0540";
}

.mdi-tumble-dryer::before {
  content: "\\f0917";
}

.mdi-tumble-dryer-alert::before {
  content: "\\f11ba";
}

.mdi-tumble-dryer-off::before {
  content: "\\f11bb";
}

.mdi-tune::before {
  content: "\\f062e";
}

.mdi-tune-variant::before {
  content: "\\f1542";
}

.mdi-tune-vertical::before {
  content: "\\f066a";
}

.mdi-tune-vertical-variant::before {
  content: "\\f1543";
}

.mdi-turkey::before {
  content: "\\f171b";
}

.mdi-turnstile::before {
  content: "\\f0cd5";
}

.mdi-turnstile-outline::before {
  content: "\\f0cd6";
}

.mdi-turtle::before {
  content: "\\f0cd7";
}

.mdi-twitch::before {
  content: "\\f0543";
}

.mdi-twitter::before {
  content: "\\f0544";
}

.mdi-twitter-retweet::before {
  content: "\\f0547";
}

.mdi-two-factor-authentication::before {
  content: "\\f09af";
}

.mdi-typewriter::before {
  content: "\\f0f2d";
}

.mdi-ubisoft::before {
  content: "\\f0bda";
}

.mdi-ubuntu::before {
  content: "\\f0548";
}

.mdi-ufo::before {
  content: "\\f10c4";
}

.mdi-ufo-outline::before {
  content: "\\f10c5";
}

.mdi-ultra-high-definition::before {
  content: "\\f07f9";
}

.mdi-umbraco::before {
  content: "\\f0549";
}

.mdi-umbrella::before {
  content: "\\f054a";
}

.mdi-umbrella-closed::before {
  content: "\\f09b0";
}

.mdi-umbrella-closed-outline::before {
  content: "\\f13e2";
}

.mdi-umbrella-closed-variant::before {
  content: "\\f13e1";
}

.mdi-umbrella-outline::before {
  content: "\\f054b";
}

.mdi-undo::before {
  content: "\\f054c";
}

.mdi-undo-variant::before {
  content: "\\f054d";
}

.mdi-unfold-less-horizontal::before {
  content: "\\f054e";
}

.mdi-unfold-less-vertical::before {
  content: "\\f0760";
}

.mdi-unfold-more-horizontal::before {
  content: "\\f054f";
}

.mdi-unfold-more-vertical::before {
  content: "\\f0761";
}

.mdi-ungroup::before {
  content: "\\f0550";
}

.mdi-unicode::before {
  content: "\\f0ed0";
}

.mdi-unicorn::before {
  content: "\\f15c2";
}

.mdi-unicorn-variant::before {
  content: "\\f15c3";
}

.mdi-unicycle::before {
  content: "\\f15e5";
}

.mdi-unity::before {
  content: "\\f06af";
}

.mdi-unreal::before {
  content: "\\f09b1";
}

.mdi-untappd::before {
  content: "\\f0551";
}

.mdi-update::before {
  content: "\\f06b0";
}

.mdi-upload::before {
  content: "\\f0552";
}

.mdi-upload-lock::before {
  content: "\\f1373";
}

.mdi-upload-lock-outline::before {
  content: "\\f1374";
}

.mdi-upload-multiple::before {
  content: "\\f083d";
}

.mdi-upload-network::before {
  content: "\\f06f6";
}

.mdi-upload-network-outline::before {
  content: "\\f0cd8";
}

.mdi-upload-off::before {
  content: "\\f10c6";
}

.mdi-upload-off-outline::before {
  content: "\\f10c7";
}

.mdi-upload-outline::before {
  content: "\\f0e07";
}

.mdi-usb::before {
  content: "\\f0553";
}

.mdi-usb-flash-drive::before {
  content: "\\f129e";
}

.mdi-usb-flash-drive-outline::before {
  content: "\\f129f";
}

.mdi-usb-port::before {
  content: "\\f11f0";
}

.mdi-valve::before {
  content: "\\f1066";
}

.mdi-valve-closed::before {
  content: "\\f1067";
}

.mdi-valve-open::before {
  content: "\\f1068";
}

.mdi-van-passenger::before {
  content: "\\f07fa";
}

.mdi-van-utility::before {
  content: "\\f07fb";
}

.mdi-vanish::before {
  content: "\\f07fc";
}

.mdi-vanish-quarter::before {
  content: "\\f1554";
}

.mdi-vanity-light::before {
  content: "\\f11e1";
}

.mdi-variable::before {
  content: "\\f0ae7";
}

.mdi-variable-box::before {
  content: "\\f1111";
}

.mdi-vector-arrange-above::before {
  content: "\\f0554";
}

.mdi-vector-arrange-below::before {
  content: "\\f0555";
}

.mdi-vector-bezier::before {
  content: "\\f0ae8";
}

.mdi-vector-circle::before {
  content: "\\f0556";
}

.mdi-vector-circle-variant::before {
  content: "\\f0557";
}

.mdi-vector-combine::before {
  content: "\\f0558";
}

.mdi-vector-curve::before {
  content: "\\f0559";
}

.mdi-vector-difference::before {
  content: "\\f055a";
}

.mdi-vector-difference-ab::before {
  content: "\\f055b";
}

.mdi-vector-difference-ba::before {
  content: "\\f055c";
}

.mdi-vector-ellipse::before {
  content: "\\f0893";
}

.mdi-vector-intersection::before {
  content: "\\f055d";
}

.mdi-vector-line::before {
  content: "\\f055e";
}

.mdi-vector-link::before {
  content: "\\f0fe8";
}

.mdi-vector-point::before {
  content: "\\f055f";
}

.mdi-vector-polygon::before {
  content: "\\f0560";
}

.mdi-vector-polyline::before {
  content: "\\f0561";
}

.mdi-vector-polyline-edit::before {
  content: "\\f1225";
}

.mdi-vector-polyline-minus::before {
  content: "\\f1226";
}

.mdi-vector-polyline-plus::before {
  content: "\\f1227";
}

.mdi-vector-polyline-remove::before {
  content: "\\f1228";
}

.mdi-vector-radius::before {
  content: "\\f074a";
}

.mdi-vector-rectangle::before {
  content: "\\f05c6";
}

.mdi-vector-selection::before {
  content: "\\f0562";
}

.mdi-vector-square::before {
  content: "\\f0001";
}

.mdi-vector-triangle::before {
  content: "\\f0563";
}

.mdi-vector-union::before {
  content: "\\f0564";
}

.mdi-vhs::before {
  content: "\\f0a1b";
}

.mdi-vibrate::before {
  content: "\\f0566";
}

.mdi-vibrate-off::before {
  content: "\\f0cd9";
}

.mdi-video::before {
  content: "\\f0567";
}

.mdi-video-3d::before {
  content: "\\f07fd";
}

.mdi-video-3d-off::before {
  content: "\\f13d9";
}

.mdi-video-3d-variant::before {
  content: "\\f0ed1";
}

.mdi-video-4k-box::before {
  content: "\\f083e";
}

.mdi-video-account::before {
  content: "\\f0919";
}

.mdi-video-box::before {
  content: "\\f00fd";
}

.mdi-video-box-off::before {
  content: "\\f00fe";
}

.mdi-video-check::before {
  content: "\\f1069";
}

.mdi-video-check-outline::before {
  content: "\\f106a";
}

.mdi-video-high-definition::before {
  content: "\\f152e";
}

.mdi-video-image::before {
  content: "\\f091a";
}

.mdi-video-input-antenna::before {
  content: "\\f083f";
}

.mdi-video-input-component::before {
  content: "\\f0840";
}

.mdi-video-input-hdmi::before {
  content: "\\f0841";
}

.mdi-video-input-scart::before {
  content: "\\f0f8c";
}

.mdi-video-input-svideo::before {
  content: "\\f0842";
}

.mdi-video-minus::before {
  content: "\\f09b2";
}

.mdi-video-minus-outline::before {
  content: "\\f02ba";
}

.mdi-video-off::before {
  content: "\\f0568";
}

.mdi-video-off-outline::before {
  content: "\\f0bdb";
}

.mdi-video-outline::before {
  content: "\\f0bdc";
}

.mdi-video-plus::before {
  content: "\\f09b3";
}

.mdi-video-plus-outline::before {
  content: "\\f01d3";
}

.mdi-video-stabilization::before {
  content: "\\f091b";
}

.mdi-video-switch::before {
  content: "\\f0569";
}

.mdi-video-switch-outline::before {
  content: "\\f0790";
}

.mdi-video-vintage::before {
  content: "\\f0a1c";
}

.mdi-video-wireless::before {
  content: "\\f0ed2";
}

.mdi-video-wireless-outline::before {
  content: "\\f0ed3";
}

.mdi-view-agenda::before {
  content: "\\f056a";
}

.mdi-view-agenda-outline::before {
  content: "\\f11d8";
}

.mdi-view-array::before {
  content: "\\f056b";
}

.mdi-view-array-outline::before {
  content: "\\f1485";
}

.mdi-view-carousel::before {
  content: "\\f056c";
}

.mdi-view-carousel-outline::before {
  content: "\\f1486";
}

.mdi-view-column::before {
  content: "\\f056d";
}

.mdi-view-column-outline::before {
  content: "\\f1487";
}

.mdi-view-comfy::before {
  content: "\\f0e6a";
}

.mdi-view-comfy-outline::before {
  content: "\\f1488";
}

.mdi-view-compact::before {
  content: "\\f0e6b";
}

.mdi-view-compact-outline::before {
  content: "\\f0e6c";
}

.mdi-view-dashboard::before {
  content: "\\f056e";
}

.mdi-view-dashboard-outline::before {
  content: "\\f0a1d";
}

.mdi-view-dashboard-variant::before {
  content: "\\f0843";
}

.mdi-view-dashboard-variant-outline::before {
  content: "\\f1489";
}

.mdi-view-day::before {
  content: "\\f056f";
}

.mdi-view-day-outline::before {
  content: "\\f148a";
}

.mdi-view-grid::before {
  content: "\\f0570";
}

.mdi-view-grid-outline::before {
  content: "\\f11d9";
}

.mdi-view-grid-plus::before {
  content: "\\f0f8d";
}

.mdi-view-grid-plus-outline::before {
  content: "\\f11da";
}

.mdi-view-headline::before {
  content: "\\f0571";
}

.mdi-view-list::before {
  content: "\\f0572";
}

.mdi-view-list-outline::before {
  content: "\\f148b";
}

.mdi-view-module::before {
  content: "\\f0573";
}

.mdi-view-module-outline::before {
  content: "\\f148c";
}

.mdi-view-parallel::before {
  content: "\\f0728";
}

.mdi-view-parallel-outline::before {
  content: "\\f148d";
}

.mdi-view-quilt::before {
  content: "\\f0574";
}

.mdi-view-quilt-outline::before {
  content: "\\f148e";
}

.mdi-view-sequential::before {
  content: "\\f0729";
}

.mdi-view-sequential-outline::before {
  content: "\\f148f";
}

.mdi-view-split-horizontal::before {
  content: "\\f0bcb";
}

.mdi-view-split-vertical::before {
  content: "\\f0bcc";
}

.mdi-view-stream::before {
  content: "\\f0575";
}

.mdi-view-stream-outline::before {
  content: "\\f1490";
}

.mdi-view-week::before {
  content: "\\f0576";
}

.mdi-view-week-outline::before {
  content: "\\f1491";
}

.mdi-vimeo::before {
  content: "\\f0577";
}

.mdi-violin::before {
  content: "\\f060f";
}

.mdi-virtual-reality::before {
  content: "\\f0894";
}

.mdi-virus::before {
  content: "\\f13b6";
}

.mdi-virus-outline::before {
  content: "\\f13b7";
}

.mdi-vk::before {
  content: "\\f0579";
}

.mdi-vlc::before {
  content: "\\f057c";
}

.mdi-voice-off::before {
  content: "\\f0ed4";
}

.mdi-voicemail::before {
  content: "\\f057d";
}

.mdi-volleyball::before {
  content: "\\f09b4";
}

.mdi-volume-high::before {
  content: "\\f057e";
}

.mdi-volume-low::before {
  content: "\\f057f";
}

.mdi-volume-medium::before {
  content: "\\f0580";
}

.mdi-volume-minus::before {
  content: "\\f075e";
}

.mdi-volume-mute::before {
  content: "\\f075f";
}

.mdi-volume-off::before {
  content: "\\f0581";
}

.mdi-volume-plus::before {
  content: "\\f075d";
}

.mdi-volume-source::before {
  content: "\\f1120";
}

.mdi-volume-variant-off::before {
  content: "\\f0e08";
}

.mdi-volume-vibrate::before {
  content: "\\f1121";
}

.mdi-vote::before {
  content: "\\f0a1f";
}

.mdi-vote-outline::before {
  content: "\\f0a20";
}

.mdi-vpn::before {
  content: "\\f0582";
}

.mdi-vuejs::before {
  content: "\\f0844";
}

.mdi-vuetify::before {
  content: "\\f0e6d";
}

.mdi-walk::before {
  content: "\\f0583";
}

.mdi-wall::before {
  content: "\\f07fe";
}

.mdi-wall-sconce::before {
  content: "\\f091c";
}

.mdi-wall-sconce-flat::before {
  content: "\\f091d";
}

.mdi-wall-sconce-flat-variant::before {
  content: "\\f041c";
}

.mdi-wall-sconce-round::before {
  content: "\\f0748";
}

.mdi-wall-sconce-round-variant::before {
  content: "\\f091e";
}

.mdi-wallet::before {
  content: "\\f0584";
}

.mdi-wallet-giftcard::before {
  content: "\\f0585";
}

.mdi-wallet-membership::before {
  content: "\\f0586";
}

.mdi-wallet-outline::before {
  content: "\\f0bdd";
}

.mdi-wallet-plus::before {
  content: "\\f0f8e";
}

.mdi-wallet-plus-outline::before {
  content: "\\f0f8f";
}

.mdi-wallet-travel::before {
  content: "\\f0587";
}

.mdi-wallpaper::before {
  content: "\\f0e09";
}

.mdi-wan::before {
  content: "\\f0588";
}

.mdi-wardrobe::before {
  content: "\\f0f90";
}

.mdi-wardrobe-outline::before {
  content: "\\f0f91";
}

.mdi-warehouse::before {
  content: "\\f0f81";
}

.mdi-washing-machine::before {
  content: "\\f072a";
}

.mdi-washing-machine-alert::before {
  content: "\\f11bc";
}

.mdi-washing-machine-off::before {
  content: "\\f11bd";
}

.mdi-watch::before {
  content: "\\f0589";
}

.mdi-watch-export::before {
  content: "\\f058a";
}

.mdi-watch-export-variant::before {
  content: "\\f0895";
}

.mdi-watch-import::before {
  content: "\\f058b";
}

.mdi-watch-import-variant::before {
  content: "\\f0896";
}

.mdi-watch-variant::before {
  content: "\\f0897";
}

.mdi-watch-vibrate::before {
  content: "\\f06b1";
}

.mdi-watch-vibrate-off::before {
  content: "\\f0cda";
}

.mdi-water::before {
  content: "\\f058c";
}

.mdi-water-alert::before {
  content: "\\f1502";
}

.mdi-water-alert-outline::before {
  content: "\\f1503";
}

.mdi-water-boiler::before {
  content: "\\f0f92";
}

.mdi-water-boiler-alert::before {
  content: "\\f11b3";
}

.mdi-water-boiler-off::before {
  content: "\\f11b4";
}

.mdi-water-check::before {
  content: "\\f1504";
}

.mdi-water-check-outline::before {
  content: "\\f1505";
}

.mdi-water-minus::before {
  content: "\\f1506";
}

.mdi-water-minus-outline::before {
  content: "\\f1507";
}

.mdi-water-off::before {
  content: "\\f058d";
}

.mdi-water-off-outline::before {
  content: "\\f1508";
}

.mdi-water-outline::before {
  content: "\\f0e0a";
}

.mdi-water-percent::before {
  content: "\\f058e";
}

.mdi-water-percent-alert::before {
  content: "\\f1509";
}

.mdi-water-plus::before {
  content: "\\f150a";
}

.mdi-water-plus-outline::before {
  content: "\\f150b";
}

.mdi-water-polo::before {
  content: "\\f12a0";
}

.mdi-water-pump::before {
  content: "\\f058f";
}

.mdi-water-pump-off::before {
  content: "\\f0f93";
}

.mdi-water-remove::before {
  content: "\\f150c";
}

.mdi-water-remove-outline::before {
  content: "\\f150d";
}

.mdi-water-well::before {
  content: "\\f106b";
}

.mdi-water-well-outline::before {
  content: "\\f106c";
}

.mdi-watering-can::before {
  content: "\\f1481";
}

.mdi-watering-can-outline::before {
  content: "\\f1482";
}

.mdi-watermark::before {
  content: "\\f0612";
}

.mdi-wave::before {
  content: "\\f0f2e";
}

.mdi-waveform::before {
  content: "\\f147d";
}

.mdi-waves::before {
  content: "\\f078d";
}

.mdi-waze::before {
  content: "\\f0bde";
}

.mdi-weather-cloudy::before {
  content: "\\f0590";
}

.mdi-weather-cloudy-alert::before {
  content: "\\f0f2f";
}

.mdi-weather-cloudy-arrow-right::before {
  content: "\\f0e6e";
}

.mdi-weather-fog::before {
  content: "\\f0591";
}

.mdi-weather-hail::before {
  content: "\\f0592";
}

.mdi-weather-hazy::before {
  content: "\\f0f30";
}

.mdi-weather-hurricane::before {
  content: "\\f0898";
}

.mdi-weather-lightning::before {
  content: "\\f0593";
}

.mdi-weather-lightning-rainy::before {
  content: "\\f067e";
}

.mdi-weather-night::before {
  content: "\\f0594";
}

.mdi-weather-night-partly-cloudy::before {
  content: "\\f0f31";
}

.mdi-weather-partly-cloudy::before {
  content: "\\f0595";
}

.mdi-weather-partly-lightning::before {
  content: "\\f0f32";
}

.mdi-weather-partly-rainy::before {
  content: "\\f0f33";
}

.mdi-weather-partly-snowy::before {
  content: "\\f0f34";
}

.mdi-weather-partly-snowy-rainy::before {
  content: "\\f0f35";
}

.mdi-weather-pouring::before {
  content: "\\f0596";
}

.mdi-weather-rainy::before {
  content: "\\f0597";
}

.mdi-weather-snowy::before {
  content: "\\f0598";
}

.mdi-weather-snowy-heavy::before {
  content: "\\f0f36";
}

.mdi-weather-snowy-rainy::before {
  content: "\\f067f";
}

.mdi-weather-sunny::before {
  content: "\\f0599";
}

.mdi-weather-sunny-alert::before {
  content: "\\f0f37";
}

.mdi-weather-sunny-off::before {
  content: "\\f14e4";
}

.mdi-weather-sunset::before {
  content: "\\f059a";
}

.mdi-weather-sunset-down::before {
  content: "\\f059b";
}

.mdi-weather-sunset-up::before {
  content: "\\f059c";
}

.mdi-weather-tornado::before {
  content: "\\f0f38";
}

.mdi-weather-windy::before {
  content: "\\f059d";
}

.mdi-weather-windy-variant::before {
  content: "\\f059e";
}

.mdi-web::before {
  content: "\\f059f";
}

.mdi-web-box::before {
  content: "\\f0f94";
}

.mdi-web-clock::before {
  content: "\\f124a";
}

.mdi-webcam::before {
  content: "\\f05a0";
}

.mdi-webcam-off::before {
  content: "\\f1737";
}

.mdi-webhook::before {
  content: "\\f062f";
}

.mdi-webpack::before {
  content: "\\f072b";
}

.mdi-webrtc::before {
  content: "\\f1248";
}

.mdi-wechat::before {
  content: "\\f0611";
}

.mdi-weight::before {
  content: "\\f05a1";
}

.mdi-weight-gram::before {
  content: "\\f0d3f";
}

.mdi-weight-kilogram::before {
  content: "\\f05a2";
}

.mdi-weight-lifter::before {
  content: "\\f115d";
}

.mdi-weight-pound::before {
  content: "\\f09b5";
}

.mdi-whatsapp::before {
  content: "\\f05a3";
}

.mdi-wheel-barrow::before {
  content: "\\f14f2";
}

.mdi-wheelchair-accessibility::before {
  content: "\\f05a4";
}

.mdi-whistle::before {
  content: "\\f09b6";
}

.mdi-whistle-outline::before {
  content: "\\f12bc";
}

.mdi-white-balance-auto::before {
  content: "\\f05a5";
}

.mdi-white-balance-incandescent::before {
  content: "\\f05a6";
}

.mdi-white-balance-iridescent::before {
  content: "\\f05a7";
}

.mdi-white-balance-sunny::before {
  content: "\\f05a8";
}

.mdi-widgets::before {
  content: "\\f072c";
}

.mdi-widgets-outline::before {
  content: "\\f1355";
}

.mdi-wifi::before {
  content: "\\f05a9";
}

.mdi-wifi-alert::before {
  content: "\\f16b5";
}

.mdi-wifi-arrow-down::before {
  content: "\\f16b6";
}

.mdi-wifi-arrow-left::before {
  content: "\\f16b7";
}

.mdi-wifi-arrow-left-right::before {
  content: "\\f16b8";
}

.mdi-wifi-arrow-right::before {
  content: "\\f16b9";
}

.mdi-wifi-arrow-up::before {
  content: "\\f16ba";
}

.mdi-wifi-arrow-up-down::before {
  content: "\\f16bb";
}

.mdi-wifi-cancel::before {
  content: "\\f16bc";
}

.mdi-wifi-check::before {
  content: "\\f16bd";
}

.mdi-wifi-cog::before {
  content: "\\f16be";
}

.mdi-wifi-lock::before {
  content: "\\f16bf";
}

.mdi-wifi-lock-open::before {
  content: "\\f16c0";
}

.mdi-wifi-marker::before {
  content: "\\f16c1";
}

.mdi-wifi-minus::before {
  content: "\\f16c2";
}

.mdi-wifi-off::before {
  content: "\\f05aa";
}

.mdi-wifi-plus::before {
  content: "\\f16c3";
}

.mdi-wifi-refresh::before {
  content: "\\f16c4";
}

.mdi-wifi-remove::before {
  content: "\\f16c5";
}

.mdi-wifi-settings::before {
  content: "\\f16c6";
}

.mdi-wifi-star::before {
  content: "\\f0e0b";
}

.mdi-wifi-strength-1::before {
  content: "\\f091f";
}

.mdi-wifi-strength-1-alert::before {
  content: "\\f0920";
}

.mdi-wifi-strength-1-lock::before {
  content: "\\f0921";
}

.mdi-wifi-strength-1-lock-open::before {
  content: "\\f16cb";
}

.mdi-wifi-strength-2::before {
  content: "\\f0922";
}

.mdi-wifi-strength-2-alert::before {
  content: "\\f0923";
}

.mdi-wifi-strength-2-lock::before {
  content: "\\f0924";
}

.mdi-wifi-strength-2-lock-open::before {
  content: "\\f16cc";
}

.mdi-wifi-strength-3::before {
  content: "\\f0925";
}

.mdi-wifi-strength-3-alert::before {
  content: "\\f0926";
}

.mdi-wifi-strength-3-lock::before {
  content: "\\f0927";
}

.mdi-wifi-strength-3-lock-open::before {
  content: "\\f16cd";
}

.mdi-wifi-strength-4::before {
  content: "\\f0928";
}

.mdi-wifi-strength-4-alert::before {
  content: "\\f0929";
}

.mdi-wifi-strength-4-lock::before {
  content: "\\f092a";
}

.mdi-wifi-strength-4-lock-open::before {
  content: "\\f16ce";
}

.mdi-wifi-strength-alert-outline::before {
  content: "\\f092b";
}

.mdi-wifi-strength-lock-open-outline::before {
  content: "\\f16cf";
}

.mdi-wifi-strength-lock-outline::before {
  content: "\\f092c";
}

.mdi-wifi-strength-off::before {
  content: "\\f092d";
}

.mdi-wifi-strength-off-outline::before {
  content: "\\f092e";
}

.mdi-wifi-strength-outline::before {
  content: "\\f092f";
}

.mdi-wifi-sync::before {
  content: "\\f16c7";
}

.mdi-wikipedia::before {
  content: "\\f05ac";
}

.mdi-wind-turbine::before {
  content: "\\f0da5";
}

.mdi-window-close::before {
  content: "\\f05ad";
}

.mdi-window-closed::before {
  content: "\\f05ae";
}

.mdi-window-closed-variant::before {
  content: "\\f11db";
}

.mdi-window-maximize::before {
  content: "\\f05af";
}

.mdi-window-minimize::before {
  content: "\\f05b0";
}

.mdi-window-open::before {
  content: "\\f05b1";
}

.mdi-window-open-variant::before {
  content: "\\f11dc";
}

.mdi-window-restore::before {
  content: "\\f05b2";
}

.mdi-window-shutter::before {
  content: "\\f111c";
}

.mdi-window-shutter-alert::before {
  content: "\\f111d";
}

.mdi-window-shutter-open::before {
  content: "\\f111e";
}

.mdi-windsock::before {
  content: "\\f15fa";
}

.mdi-wiper::before {
  content: "\\f0ae9";
}

.mdi-wiper-wash::before {
  content: "\\f0da6";
}

.mdi-wizard-hat::before {
  content: "\\f1477";
}

.mdi-wordpress::before {
  content: "\\f05b4";
}

.mdi-wrap::before {
  content: "\\f05b6";
}

.mdi-wrap-disabled::before {
  content: "\\f0bdf";
}

.mdi-wrench::before {
  content: "\\f05b7";
}

.mdi-wrench-outline::before {
  content: "\\f0be0";
}

.mdi-xamarin::before {
  content: "\\f0845";
}

.mdi-xamarin-outline::before {
  content: "\\f0846";
}

.mdi-xing::before {
  content: "\\f05be";
}

.mdi-xml::before {
  content: "\\f05c0";
}

.mdi-xmpp::before {
  content: "\\f07ff";
}

.mdi-y-combinator::before {
  content: "\\f0624";
}

.mdi-yahoo::before {
  content: "\\f0b4f";
}

.mdi-yeast::before {
  content: "\\f05c1";
}

.mdi-yin-yang::before {
  content: "\\f0680";
}

.mdi-yoga::before {
  content: "\\f117c";
}

.mdi-youtube::before {
  content: "\\f05c3";
}

.mdi-youtube-gaming::before {
  content: "\\f0848";
}

.mdi-youtube-studio::before {
  content: "\\f0847";
}

.mdi-youtube-subscription::before {
  content: "\\f0d40";
}

.mdi-youtube-tv::before {
  content: "\\f0448";
}

.mdi-yurt::before {
  content: "\\f1516";
}

.mdi-z-wave::before {
  content: "\\f0aea";
}

.mdi-zend::before {
  content: "\\f0aeb";
}

.mdi-zigbee::before {
  content: "\\f0d41";
}

.mdi-zip-box::before {
  content: "\\f05c4";
}

.mdi-zip-box-outline::before {
  content: "\\f0ffa";
}

.mdi-zip-disk::before {
  content: "\\f0a23";
}

.mdi-zodiac-aquarius::before {
  content: "\\f0a7d";
}

.mdi-zodiac-aries::before {
  content: "\\f0a7e";
}

.mdi-zodiac-cancer::before {
  content: "\\f0a7f";
}

.mdi-zodiac-capricorn::before {
  content: "\\f0a80";
}

.mdi-zodiac-gemini::before {
  content: "\\f0a81";
}

.mdi-zodiac-leo::before {
  content: "\\f0a82";
}

.mdi-zodiac-libra::before {
  content: "\\f0a83";
}

.mdi-zodiac-pisces::before {
  content: "\\f0a84";
}

.mdi-zodiac-sagittarius::before {
  content: "\\f0a85";
}

.mdi-zodiac-scorpio::before {
  content: "\\f0a86";
}

.mdi-zodiac-taurus::before {
  content: "\\f0a87";
}

.mdi-zodiac-virgo::before {
  content: "\\f0a88";
}

.mdi-blank::before {
  content: "\\f68c";
  visibility: hidden;
}

.mdi-18px.mdi-set, .mdi-18px.mdi:before {
  font-size: 18px;
}

.mdi-24px.mdi-set, .mdi-24px.mdi:before {
  font-size: 24px;
}

.mdi-36px.mdi-set, .mdi-36px.mdi:before {
  font-size: 36px;
}

.mdi-48px.mdi-set, .mdi-48px.mdi:before {
  font-size: 48px;
}

.mdi-dark:before {
  color: rgba(0, 0, 0, 0.54);
}

.mdi-dark.mdi-inactive:before {
  color: rgba(0, 0, 0, 0.26);
}

.mdi-light:before {
  color: white;
}

.mdi-light.mdi-inactive:before {
  color: rgba(255, 255, 255, 0.3);
}

.mdi-rotate-45 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(45deg);
            transform: scaleX(-1) rotate(45deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: scaleY(-1) rotate(45deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-45:before {
  transform: rotate(45deg);
}

.mdi-rotate-90 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(90deg);
            transform: scaleX(-1) rotate(90deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(90deg);
            -ms-transform: rotate(90deg);
            transform: scaleY(-1) rotate(90deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-90:before {
  transform: rotate(90deg);
}

.mdi-rotate-135 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(135deg);
            transform: scaleX(-1) rotate(135deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(135deg);
            -ms-transform: rotate(135deg);
            transform: scaleY(-1) rotate(135deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-135:before {
  transform: rotate(135deg);
}

.mdi-rotate-180 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(180deg);
            transform: scaleX(-1) rotate(180deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(180deg);
            -ms-transform: rotate(180deg);
            transform: scaleY(-1) rotate(180deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-180:before {
  transform: rotate(180deg);
}

.mdi-rotate-225 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(225deg);
            transform: scaleX(-1) rotate(225deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(225deg);
            -ms-transform: rotate(225deg);
            transform: scaleY(-1) rotate(225deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-225:before {
  transform: rotate(225deg);
}

.mdi-rotate-270 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(270deg);
            transform: scaleX(-1) rotate(270deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(270deg);
            -ms-transform: rotate(270deg);
            transform: scaleY(-1) rotate(270deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-270:before {
  transform: rotate(270deg);
}

.mdi-rotate-315 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(315deg);
            transform: scaleX(-1) rotate(315deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(315deg);
            -ms-transform: rotate(315deg);
            transform: scaleY(-1) rotate(315deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-315:before {
  transform: rotate(315deg);
}

.mdi-flip-h:before {
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}

.mdi-flip-v:before {
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV";
}

.mdi-spin:before {
  animation: mdi-spin 2s infinite linear;
}
@keyframes mdi-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}

/*!
 * Font Awesome Free 5.13.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
.fa,
.fas,
.far,
.fal,
.fad,
.fab {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

.fa-lg {
  font-size: 1.33333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.fa-xs {
  font-size: 0.75em;
}

.fa-sm {
  font-size: 0.875em;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: 2.5em;
  padding-left: 0;
}

.fa-ul > li {
  position: relative;
}

.fa-li {
  left: -2em;
  position: absolute;
  text-align: center;
  width: 2em;
  line-height: inherit;
}

.fa-border {
  border: solid 0.08em #eee;
  border-radius: 0.1em;
  padding: 0.2em 0.25em 0.15em;
}

.fa-pull-left {
  float: left;
}

.fa-pull-right {
  float: right;
}

.fa.fa-pull-left,
.fas.fa-pull-left,
.far.fa-pull-left,
.fal.fa-pull-left,
.fab.fa-pull-left {
  margin-right: 0.3em;
}

.fa.fa-pull-right,
.fas.fa-pull-right,
.far.fa-pull-right,
.fal.fa-pull-right,
.fab.fa-pull-right {
  margin-left: 0.3em;
}

.fa-spin {
  animation: fa-spin 2s infinite linear;
}

.fa-pulse {
  animation: fa-spin 1s infinite steps(8);
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  transform: rotate(90deg);
}

.fa-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  transform: rotate(180deg);
}

.fa-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(1, -1);
}

.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(-1, -1);
}

:root .fa-rotate-90,
:root .fa-rotate-180,
:root .fa-rotate-270,
:root .fa-flip-horizontal,
:root .fa-flip-vertical,
:root .fa-flip-both {
  filter: none;
}

.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
  font-size: 2em;
}

.fa-inverse {
  color: #fff;
}

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.fa-500px:before {
  content: "\\f26e";
}

.fa-accessible-icon:before {
  content: "\\f368";
}

.fa-accusoft:before {
  content: "\\f369";
}

.fa-acquisitions-incorporated:before {
  content: "\\f6af";
}

.fa-ad:before {
  content: "\\f641";
}

.fa-address-book:before {
  content: "\\f2b9";
}

.fa-address-card:before {
  content: "\\f2bb";
}

.fa-adjust:before {
  content: "\\f042";
}

.fa-adn:before {
  content: "\\f170";
}

.fa-adobe:before {
  content: "\\f778";
}

.fa-adversal:before {
  content: "\\f36a";
}

.fa-affiliatetheme:before {
  content: "\\f36b";
}

.fa-air-freshener:before {
  content: "\\f5d0";
}

.fa-airbnb:before {
  content: "\\f834";
}

.fa-algolia:before {
  content: "\\f36c";
}

.fa-align-center:before {
  content: "\\f037";
}

.fa-align-justify:before {
  content: "\\f039";
}

.fa-align-left:before {
  content: "\\f036";
}

.fa-align-right:before {
  content: "\\f038";
}

.fa-alipay:before {
  content: "\\f642";
}

.fa-allergies:before {
  content: "\\f461";
}

.fa-amazon:before {
  content: "\\f270";
}

.fa-amazon-pay:before {
  content: "\\f42c";
}

.fa-ambulance:before {
  content: "\\f0f9";
}

.fa-american-sign-language-interpreting:before {
  content: "\\f2a3";
}

.fa-amilia:before {
  content: "\\f36d";
}

.fa-anchor:before {
  content: "\\f13d";
}

.fa-android:before {
  content: "\\f17b";
}

.fa-angellist:before {
  content: "\\f209";
}

.fa-angle-double-down:before {
  content: "\\f103";
}

.fa-angle-double-left:before {
  content: "\\f100";
}

.fa-angle-double-right:before {
  content: "\\f101";
}

.fa-angle-double-up:before {
  content: "\\f102";
}

.fa-angle-down:before {
  content: "\\f107";
}

.fa-angle-left:before {
  content: "\\f104";
}

.fa-angle-right:before {
  content: "\\f105";
}

.fa-angle-up:before {
  content: "\\f106";
}

.fa-angry:before {
  content: "\\f556";
}

.fa-angrycreative:before {
  content: "\\f36e";
}

.fa-angular:before {
  content: "\\f420";
}

.fa-ankh:before {
  content: "\\f644";
}

.fa-app-store:before {
  content: "\\f36f";
}

.fa-app-store-ios:before {
  content: "\\f370";
}

.fa-apper:before {
  content: "\\f371";
}

.fa-apple:before {
  content: "\\f179";
}

.fa-apple-alt:before {
  content: "\\f5d1";
}

.fa-apple-pay:before {
  content: "\\f415";
}

.fa-archive:before {
  content: "\\f187";
}

.fa-archway:before {
  content: "\\f557";
}

.fa-arrow-alt-circle-down:before {
  content: "\\f358";
}

.fa-arrow-alt-circle-left:before {
  content: "\\f359";
}

.fa-arrow-alt-circle-right:before {
  content: "\\f35a";
}

.fa-arrow-alt-circle-up:before {
  content: "\\f35b";
}

.fa-arrow-circle-down:before {
  content: "\\f0ab";
}

.fa-arrow-circle-left:before {
  content: "\\f0a8";
}

.fa-arrow-circle-right:before {
  content: "\\f0a9";
}

.fa-arrow-circle-up:before {
  content: "\\f0aa";
}

.fa-arrow-down:before {
  content: "\\f063";
}

.fa-arrow-left:before {
  content: "\\f060";
}

.fa-arrow-right:before {
  content: "\\f061";
}

.fa-arrow-up:before {
  content: "\\f062";
}

.fa-arrows-alt:before {
  content: "\\f0b2";
}

.fa-arrows-alt-h:before {
  content: "\\f337";
}

.fa-arrows-alt-v:before {
  content: "\\f338";
}

.fa-artstation:before {
  content: "\\f77a";
}

.fa-assistive-listening-systems:before {
  content: "\\f2a2";
}

.fa-asterisk:before {
  content: "\\f069";
}

.fa-asymmetrik:before {
  content: "\\f372";
}

.fa-at:before {
  content: "\\f1fa";
}

.fa-atlas:before {
  content: "\\f558";
}

.fa-atlassian:before {
  content: "\\f77b";
}

.fa-atom:before {
  content: "\\f5d2";
}

.fa-audible:before {
  content: "\\f373";
}

.fa-audio-description:before {
  content: "\\f29e";
}

.fa-autoprefixer:before {
  content: "\\f41c";
}

.fa-avianex:before {
  content: "\\f374";
}

.fa-aviato:before {
  content: "\\f421";
}

.fa-award:before {
  content: "\\f559";
}

.fa-aws:before {
  content: "\\f375";
}

.fa-baby:before {
  content: "\\f77c";
}

.fa-baby-carriage:before {
  content: "\\f77d";
}

.fa-backspace:before {
  content: "\\f55a";
}

.fa-backward:before {
  content: "\\f04a";
}

.fa-bacon:before {
  content: "\\f7e5";
}

.fa-bahai:before {
  content: "\\f666";
}

.fa-balance-scale:before {
  content: "\\f24e";
}

.fa-balance-scale-left:before {
  content: "\\f515";
}

.fa-balance-scale-right:before {
  content: "\\f516";
}

.fa-ban:before {
  content: "\\f05e";
}

.fa-band-aid:before {
  content: "\\f462";
}

.fa-bandcamp:before {
  content: "\\f2d5";
}

.fa-barcode:before {
  content: "\\f02a";
}

.fa-bars:before {
  content: "\\f0c9";
}

.fa-baseball-ball:before {
  content: "\\f433";
}

.fa-basketball-ball:before {
  content: "\\f434";
}

.fa-bath:before {
  content: "\\f2cd";
}

.fa-battery-empty:before {
  content: "\\f244";
}

.fa-battery-full:before {
  content: "\\f240";
}

.fa-battery-half:before {
  content: "\\f242";
}

.fa-battery-quarter:before {
  content: "\\f243";
}

.fa-battery-three-quarters:before {
  content: "\\f241";
}

.fa-battle-net:before {
  content: "\\f835";
}

.fa-bed:before {
  content: "\\f236";
}

.fa-beer:before {
  content: "\\f0fc";
}

.fa-behance:before {
  content: "\\f1b4";
}

.fa-behance-square:before {
  content: "\\f1b5";
}

.fa-bell:before {
  content: "\\f0f3";
}

.fa-bell-slash:before {
  content: "\\f1f6";
}

.fa-bezier-curve:before {
  content: "\\f55b";
}

.fa-bible:before {
  content: "\\f647";
}

.fa-bicycle:before {
  content: "\\f206";
}

.fa-biking:before {
  content: "\\f84a";
}

.fa-bimobject:before {
  content: "\\f378";
}

.fa-binoculars:before {
  content: "\\f1e5";
}

.fa-biohazard:before {
  content: "\\f780";
}

.fa-birthday-cake:before {
  content: "\\f1fd";
}

.fa-bitbucket:before {
  content: "\\f171";
}

.fa-bitcoin:before {
  content: "\\f379";
}

.fa-bity:before {
  content: "\\f37a";
}

.fa-black-tie:before {
  content: "\\f27e";
}

.fa-blackberry:before {
  content: "\\f37b";
}

.fa-blender:before {
  content: "\\f517";
}

.fa-blender-phone:before {
  content: "\\f6b6";
}

.fa-blind:before {
  content: "\\f29d";
}

.fa-blog:before {
  content: "\\f781";
}

.fa-blogger:before {
  content: "\\f37c";
}

.fa-blogger-b:before {
  content: "\\f37d";
}

.fa-bluetooth:before {
  content: "\\f293";
}

.fa-bluetooth-b:before {
  content: "\\f294";
}

.fa-bold:before {
  content: "\\f032";
}

.fa-bolt:before {
  content: "\\f0e7";
}

.fa-bomb:before {
  content: "\\f1e2";
}

.fa-bone:before {
  content: "\\f5d7";
}

.fa-bong:before {
  content: "\\f55c";
}

.fa-book:before {
  content: "\\f02d";
}

.fa-book-dead:before {
  content: "\\f6b7";
}

.fa-book-medical:before {
  content: "\\f7e6";
}

.fa-book-open:before {
  content: "\\f518";
}

.fa-book-reader:before {
  content: "\\f5da";
}

.fa-bookmark:before {
  content: "\\f02e";
}

.fa-bootstrap:before {
  content: "\\f836";
}

.fa-border-all:before {
  content: "\\f84c";
}

.fa-border-none:before {
  content: "\\f850";
}

.fa-border-style:before {
  content: "\\f853";
}

.fa-bowling-ball:before {
  content: "\\f436";
}

.fa-box:before {
  content: "\\f466";
}

.fa-box-open:before {
  content: "\\f49e";
}

.fa-box-tissue:before {
  content: "拏";
}

.fa-boxes:before {
  content: "\\f468";
}

.fa-braille:before {
  content: "\\f2a1";
}

.fa-brain:before {
  content: "\\f5dc";
}

.fa-bread-slice:before {
  content: "\\f7ec";
}

.fa-briefcase:before {
  content: "\\f0b1";
}

.fa-briefcase-medical:before {
  content: "\\f469";
}

.fa-broadcast-tower:before {
  content: "\\f519";
}

.fa-broom:before {
  content: "\\f51a";
}

.fa-brush:before {
  content: "\\f55d";
}

.fa-btc:before {
  content: "\\f15a";
}

.fa-buffer:before {
  content: "\\f837";
}

.fa-bug:before {
  content: "\\f188";
}

.fa-building:before {
  content: "\\f1ad";
}

.fa-bullhorn:before {
  content: "\\f0a1";
}

.fa-bullseye:before {
  content: "\\f140";
}

.fa-burn:before {
  content: "\\f46a";
}

.fa-buromobelexperte:before {
  content: "\\f37f";
}

.fa-bus:before {
  content: "\\f207";
}

.fa-bus-alt:before {
  content: "\\f55e";
}

.fa-business-time:before {
  content: "\\f64a";
}

.fa-buy-n-large:before {
  content: "\\f8a6";
}

.fa-buysellads:before {
  content: "\\f20d";
}

.fa-calculator:before {
  content: "\\f1ec";
}

.fa-calendar:before {
  content: "\\f133";
}

.fa-calendar-alt:before {
  content: "\\f073";
}

.fa-calendar-check:before {
  content: "\\f274";
}

.fa-calendar-day:before {
  content: "\\f783";
}

.fa-calendar-minus:before {
  content: "\\f272";
}

.fa-calendar-plus:before {
  content: "\\f271";
}

.fa-calendar-times:before {
  content: "\\f273";
}

.fa-calendar-week:before {
  content: "\\f784";
}

.fa-camera:before {
  content: "\\f030";
}

.fa-camera-retro:before {
  content: "\\f083";
}

.fa-campground:before {
  content: "\\f6bb";
}

.fa-canadian-maple-leaf:before {
  content: "\\f785";
}

.fa-candy-cane:before {
  content: "\\f786";
}

.fa-cannabis:before {
  content: "\\f55f";
}

.fa-capsules:before {
  content: "\\f46b";
}

.fa-car:before {
  content: "\\f1b9";
}

.fa-car-alt:before {
  content: "\\f5de";
}

.fa-car-battery:before {
  content: "\\f5df";
}

.fa-car-crash:before {
  content: "\\f5e1";
}

.fa-car-side:before {
  content: "\\f5e4";
}

.fa-caravan:before {
  content: "\\f8ff";
}

.fa-caret-down:before {
  content: "\\f0d7";
}

.fa-caret-left:before {
  content: "\\f0d9";
}

.fa-caret-right:before {
  content: "\\f0da";
}

.fa-caret-square-down:before {
  content: "\\f150";
}

.fa-caret-square-left:before {
  content: "\\f191";
}

.fa-caret-square-right:before {
  content: "\\f152";
}

.fa-caret-square-up:before {
  content: "\\f151";
}

.fa-caret-up:before {
  content: "\\f0d8";
}

.fa-carrot:before {
  content: "\\f787";
}

.fa-cart-arrow-down:before {
  content: "\\f218";
}

.fa-cart-plus:before {
  content: "\\f217";
}

.fa-cash-register:before {
  content: "\\f788";
}

.fa-cat:before {
  content: "\\f6be";
}

.fa-cc-amazon-pay:before {
  content: "\\f42d";
}

.fa-cc-amex:before {
  content: "\\f1f3";
}

.fa-cc-apple-pay:before {
  content: "\\f416";
}

.fa-cc-diners-club:before {
  content: "\\f24c";
}

.fa-cc-discover:before {
  content: "\\f1f2";
}

.fa-cc-jcb:before {
  content: "\\f24b";
}

.fa-cc-mastercard:before {
  content: "\\f1f1";
}

.fa-cc-paypal:before {
  content: "\\f1f4";
}

.fa-cc-stripe:before {
  content: "\\f1f5";
}

.fa-cc-visa:before {
  content: "\\f1f0";
}

.fa-centercode:before {
  content: "\\f380";
}

.fa-centos:before {
  content: "\\f789";
}

.fa-certificate:before {
  content: "\\f0a3";
}

.fa-chair:before {
  content: "\\f6c0";
}

.fa-chalkboard:before {
  content: "\\f51b";
}

.fa-chalkboard-teacher:before {
  content: "\\f51c";
}

.fa-charging-station:before {
  content: "\\f5e7";
}

.fa-chart-area:before {
  content: "\\f1fe";
}

.fa-chart-bar:before {
  content: "\\f080";
}

.fa-chart-line:before {
  content: "\\f201";
}

.fa-chart-pie:before {
  content: "\\f200";
}

.fa-check:before {
  content: "\\f00c";
}

.fa-check-circle:before {
  content: "\\f058";
}

.fa-check-double:before {
  content: "\\f560";
}

.fa-check-square:before {
  content: "\\f14a";
}

.fa-cheese:before {
  content: "\\f7ef";
}

.fa-chess:before {
  content: "\\f439";
}

.fa-chess-bishop:before {
  content: "\\f43a";
}

.fa-chess-board:before {
  content: "\\f43c";
}

.fa-chess-king:before {
  content: "\\f43f";
}

.fa-chess-knight:before {
  content: "\\f441";
}

.fa-chess-pawn:before {
  content: "\\f443";
}

.fa-chess-queen:before {
  content: "\\f445";
}

.fa-chess-rook:before {
  content: "\\f447";
}

.fa-chevron-circle-down:before {
  content: "\\f13a";
}

.fa-chevron-circle-left:before {
  content: "\\f137";
}

.fa-chevron-circle-right:before {
  content: "\\f138";
}

.fa-chevron-circle-up:before {
  content: "\\f139";
}

.fa-chevron-down:before {
  content: "\\f078";
}

.fa-chevron-left:before {
  content: "\\f053";
}

.fa-chevron-right:before {
  content: "\\f054";
}

.fa-chevron-up:before {
  content: "\\f077";
}

.fa-child:before {
  content: "\\f1ae";
}

.fa-chrome:before {
  content: "\\f268";
}

.fa-chromecast:before {
  content: "\\f838";
}

.fa-church:before {
  content: "\\f51d";
}

.fa-circle:before {
  content: "\\f111";
}

.fa-circle-notch:before {
  content: "\\f1ce";
}

.fa-city:before {
  content: "\\f64f";
}

.fa-clinic-medical:before {
  content: "\\f7f2";
}

.fa-clipboard:before {
  content: "\\f328";
}

.fa-clipboard-check:before {
  content: "\\f46c";
}

.fa-clipboard-list:before {
  content: "\\f46d";
}

.fa-clock:before {
  content: "\\f017";
}

.fa-clone:before {
  content: "\\f24d";
}

.fa-closed-captioning:before {
  content: "\\f20a";
}

.fa-cloud:before {
  content: "\\f0c2";
}

.fa-cloud-download-alt:before {
  content: "\\f381";
}

.fa-cloud-meatball:before {
  content: "\\f73b";
}

.fa-cloud-moon:before {
  content: "\\f6c3";
}

.fa-cloud-moon-rain:before {
  content: "\\f73c";
}

.fa-cloud-rain:before {
  content: "\\f73d";
}

.fa-cloud-showers-heavy:before {
  content: "\\f740";
}

.fa-cloud-sun:before {
  content: "\\f6c4";
}

.fa-cloud-sun-rain:before {
  content: "\\f743";
}

.fa-cloud-upload-alt:before {
  content: "\\f382";
}

.fa-cloudscale:before {
  content: "\\f383";
}

.fa-cloudsmith:before {
  content: "\\f384";
}

.fa-cloudversify:before {
  content: "\\f385";
}

.fa-cocktail:before {
  content: "\\f561";
}

.fa-code:before {
  content: "\\f121";
}

.fa-code-branch:before {
  content: "\\f126";
}

.fa-codepen:before {
  content: "\\f1cb";
}

.fa-codiepie:before {
  content: "\\f284";
}

.fa-coffee:before {
  content: "\\f0f4";
}

.fa-cog:before {
  content: "\\f013";
}

.fa-cogs:before {
  content: "\\f085";
}

.fa-coins:before {
  content: "\\f51e";
}

.fa-columns:before {
  content: "\\f0db";
}

.fa-comment:before {
  content: "\\f075";
}

.fa-comment-alt:before {
  content: "\\f27a";
}

.fa-comment-dollar:before {
  content: "\\f651";
}

.fa-comment-dots:before {
  content: "\\f4ad";
}

.fa-comment-medical:before {
  content: "\\f7f5";
}

.fa-comment-slash:before {
  content: "\\f4b3";
}

.fa-comments:before {
  content: "\\f086";
}

.fa-comments-dollar:before {
  content: "\\f653";
}

.fa-compact-disc:before {
  content: "\\f51f";
}

.fa-compass:before {
  content: "\\f14e";
}

.fa-compress:before {
  content: "\\f066";
}

.fa-compress-alt:before {
  content: "\\f422";
}

.fa-compress-arrows-alt:before {
  content: "\\f78c";
}

.fa-concierge-bell:before {
  content: "\\f562";
}

.fa-confluence:before {
  content: "\\f78d";
}

.fa-connectdevelop:before {
  content: "\\f20e";
}

.fa-contao:before {
  content: "\\f26d";
}

.fa-cookie:before {
  content: "\\f563";
}

.fa-cookie-bite:before {
  content: "\\f564";
}

.fa-copy:before {
  content: "\\f0c5";
}

.fa-copyright:before {
  content: "\\f1f9";
}

.fa-cotton-bureau:before {
  content: "\\f89e";
}

.fa-couch:before {
  content: "\\f4b8";
}

.fa-cpanel:before {
  content: "\\f388";
}

.fa-creative-commons:before {
  content: "\\f25e";
}

.fa-creative-commons-by:before {
  content: "\\f4e7";
}

.fa-creative-commons-nc:before {
  content: "\\f4e8";
}

.fa-creative-commons-nc-eu:before {
  content: "\\f4e9";
}

.fa-creative-commons-nc-jp:before {
  content: "\\f4ea";
}

.fa-creative-commons-nd:before {
  content: "\\f4eb";
}

.fa-creative-commons-pd:before {
  content: "\\f4ec";
}

.fa-creative-commons-pd-alt:before {
  content: "\\f4ed";
}

.fa-creative-commons-remix:before {
  content: "\\f4ee";
}

.fa-creative-commons-sa:before {
  content: "\\f4ef";
}

.fa-creative-commons-sampling:before {
  content: "\\f4f0";
}

.fa-creative-commons-sampling-plus:before {
  content: "\\f4f1";
}

.fa-creative-commons-share:before {
  content: "\\f4f2";
}

.fa-creative-commons-zero:before {
  content: "\\f4f3";
}

.fa-credit-card:before {
  content: "\\f09d";
}

.fa-critical-role:before {
  content: "\\f6c9";
}

.fa-crop:before {
  content: "\\f125";
}

.fa-crop-alt:before {
  content: "\\f565";
}

.fa-cross:before {
  content: "\\f654";
}

.fa-crosshairs:before {
  content: "\\f05b";
}

.fa-crow:before {
  content: "\\f520";
}

.fa-crown:before {
  content: "\\f521";
}

.fa-crutch:before {
  content: "\\f7f7";
}

.fa-css3:before {
  content: "\\f13c";
}

.fa-css3-alt:before {
  content: "\\f38b";
}

.fa-cube:before {
  content: "\\f1b2";
}

.fa-cubes:before {
  content: "\\f1b3";
}

.fa-cut:before {
  content: "\\f0c4";
}

.fa-cuttlefish:before {
  content: "\\f38c";
}

.fa-d-and-d:before {
  content: "\\f38d";
}

.fa-d-and-d-beyond:before {
  content: "\\f6ca";
}

.fa-dailymotion:before {
  content: "勒";
}

.fa-dashcube:before {
  content: "\\f210";
}

.fa-database:before {
  content: "\\f1c0";
}

.fa-deaf:before {
  content: "\\f2a4";
}

.fa-delicious:before {
  content: "\\f1a5";
}

.fa-democrat:before {
  content: "\\f747";
}

.fa-deploydog:before {
  content: "\\f38e";
}

.fa-deskpro:before {
  content: "\\f38f";
}

.fa-desktop:before {
  content: "\\f108";
}

.fa-dev:before {
  content: "\\f6cc";
}

.fa-deviantart:before {
  content: "\\f1bd";
}

.fa-dharmachakra:before {
  content: "\\f655";
}

.fa-dhl:before {
  content: "\\f790";
}

.fa-diagnoses:before {
  content: "\\f470";
}

.fa-diaspora:before {
  content: "\\f791";
}

.fa-dice:before {
  content: "\\f522";
}

.fa-dice-d20:before {
  content: "\\f6cf";
}

.fa-dice-d6:before {
  content: "\\f6d1";
}

.fa-dice-five:before {
  content: "\\f523";
}

.fa-dice-four:before {
  content: "\\f524";
}

.fa-dice-one:before {
  content: "\\f525";
}

.fa-dice-six:before {
  content: "\\f526";
}

.fa-dice-three:before {
  content: "\\f527";
}

.fa-dice-two:before {
  content: "\\f528";
}

.fa-digg:before {
  content: "\\f1a6";
}

.fa-digital-ocean:before {
  content: "\\f391";
}

.fa-digital-tachograph:before {
  content: "\\f566";
}

.fa-directions:before {
  content: "\\f5eb";
}

.fa-discord:before {
  content: "\\f392";
}

.fa-discourse:before {
  content: "\\f393";
}

.fa-disease:before {
  content: "\\f7fa";
}

.fa-divide:before {
  content: "\\f529";
}

.fa-dizzy:before {
  content: "\\f567";
}

.fa-dna:before {
  content: "\\f471";
}

.fa-dochub:before {
  content: "\\f394";
}

.fa-docker:before {
  content: "\\f395";
}

.fa-dog:before {
  content: "\\f6d3";
}

.fa-dollar-sign:before {
  content: "\\f155";
}

.fa-dolly:before {
  content: "\\f472";
}

.fa-dolly-flatbed:before {
  content: "\\f474";
}

.fa-donate:before {
  content: "\\f4b9";
}

.fa-door-closed:before {
  content: "\\f52a";
}

.fa-door-open:before {
  content: "\\f52b";
}

.fa-dot-circle:before {
  content: "\\f192";
}

.fa-dove:before {
  content: "\\f4ba";
}

.fa-download:before {
  content: "\\f019";
}

.fa-draft2digital:before {
  content: "\\f396";
}

.fa-drafting-compass:before {
  content: "\\f568";
}

.fa-dragon:before {
  content: "\\f6d5";
}

.fa-draw-polygon:before {
  content: "\\f5ee";
}

.fa-dribbble:before {
  content: "\\f17d";
}

.fa-dribbble-square:before {
  content: "\\f397";
}

.fa-dropbox:before {
  content: "\\f16b";
}

.fa-drum:before {
  content: "\\f569";
}

.fa-drum-steelpan:before {
  content: "\\f56a";
}

.fa-drumstick-bite:before {
  content: "\\f6d7";
}

.fa-drupal:before {
  content: "\\f1a9";
}

.fa-dumbbell:before {
  content: "\\f44b";
}

.fa-dumpster:before {
  content: "\\f793";
}

.fa-dumpster-fire:before {
  content: "\\f794";
}

.fa-dungeon:before {
  content: "\\f6d9";
}

.fa-dyalog:before {
  content: "\\f399";
}

.fa-earlybirds:before {
  content: "\\f39a";
}

.fa-ebay:before {
  content: "\\f4f4";
}

.fa-edge:before {
  content: "\\f282";
}

.fa-edit:before {
  content: "\\f044";
}

.fa-egg:before {
  content: "\\f7fb";
}

.fa-eject:before {
  content: "\\f052";
}

.fa-elementor:before {
  content: "\\f430";
}

.fa-ellipsis-h:before {
  content: "\\f141";
}

.fa-ellipsis-v:before {
  content: "\\f142";
}

.fa-ello:before {
  content: "\\f5f1";
}

.fa-ember:before {
  content: "\\f423";
}

.fa-empire:before {
  content: "\\f1d1";
}

.fa-envelope:before {
  content: "\\f0e0";
}

.fa-envelope-open:before {
  content: "\\f2b6";
}

.fa-envelope-open-text:before {
  content: "\\f658";
}

.fa-envelope-square:before {
  content: "\\f199";
}

.fa-envira:before {
  content: "\\f299";
}

.fa-equals:before {
  content: "\\f52c";
}

.fa-eraser:before {
  content: "\\f12d";
}

.fa-erlang:before {
  content: "\\f39d";
}

.fa-ethereum:before {
  content: "\\f42e";
}

.fa-ethernet:before {
  content: "\\f796";
}

.fa-etsy:before {
  content: "\\f2d7";
}

.fa-euro-sign:before {
  content: "\\f153";
}

.fa-evernote:before {
  content: "\\f839";
}

.fa-exchange-alt:before {
  content: "\\f362";
}

.fa-exclamation:before {
  content: "\\f12a";
}

.fa-exclamation-circle:before {
  content: "\\f06a";
}

.fa-exclamation-triangle:before {
  content: "\\f071";
}

.fa-expand:before {
  content: "\\f065";
}

.fa-expand-alt:before {
  content: "\\f424";
}

.fa-expand-arrows-alt:before {
  content: "\\f31e";
}

.fa-expeditedssl:before {
  content: "\\f23e";
}

.fa-external-link-alt:before {
  content: "\\f35d";
}

.fa-external-link-square-alt:before {
  content: "\\f360";
}

.fa-eye:before {
  content: "\\f06e";
}

.fa-eye-dropper:before {
  content: "\\f1fb";
}

.fa-eye-slash:before {
  content: "\\f070";
}

.fa-facebook:before {
  content: "\\f09a";
}

.fa-facebook-f:before {
  content: "\\f39e";
}

.fa-facebook-messenger:before {
  content: "\\f39f";
}

.fa-facebook-square:before {
  content: "\\f082";
}

.fa-fan:before {
  content: "\\f863";
}

.fa-fantasy-flight-games:before {
  content: "\\f6dc";
}

.fa-fast-backward:before {
  content: "\\f049";
}

.fa-fast-forward:before {
  content: "\\f050";
}

.fa-faucet:before {
  content: "串";
}

.fa-fax:before {
  content: "\\f1ac";
}

.fa-feather:before {
  content: "\\f52d";
}

.fa-feather-alt:before {
  content: "\\f56b";
}

.fa-fedex:before {
  content: "\\f797";
}

.fa-fedora:before {
  content: "\\f798";
}

.fa-female:before {
  content: "\\f182";
}

.fa-fighter-jet:before {
  content: "\\f0fb";
}

.fa-figma:before {
  content: "\\f799";
}

.fa-file:before {
  content: "\\f15b";
}

.fa-file-alt:before {
  content: "\\f15c";
}

.fa-file-archive:before {
  content: "\\f1c6";
}

.fa-file-audio:before {
  content: "\\f1c7";
}

.fa-file-code:before {
  content: "\\f1c9";
}

.fa-file-contract:before {
  content: "\\f56c";
}

.fa-file-csv:before {
  content: "\\f6dd";
}

.fa-file-download:before {
  content: "\\f56d";
}

.fa-file-excel:before {
  content: "\\f1c3";
}

.fa-file-export:before {
  content: "\\f56e";
}

.fa-file-image:before {
  content: "\\f1c5";
}

.fa-file-import:before {
  content: "\\f56f";
}

.fa-file-invoice:before {
  content: "\\f570";
}

.fa-file-invoice-dollar:before {
  content: "\\f571";
}

.fa-file-medical:before {
  content: "\\f477";
}

.fa-file-medical-alt:before {
  content: "\\f478";
}

.fa-file-pdf:before {
  content: "\\f1c1";
}

.fa-file-powerpoint:before {
  content: "\\f1c4";
}

.fa-file-prescription:before {
  content: "\\f572";
}

.fa-file-signature:before {
  content: "\\f573";
}

.fa-file-upload:before {
  content: "\\f574";
}

.fa-file-video:before {
  content: "\\f1c8";
}

.fa-file-word:before {
  content: "\\f1c2";
}

.fa-fill:before {
  content: "\\f575";
}

.fa-fill-drip:before {
  content: "\\f576";
}

.fa-film:before {
  content: "\\f008";
}

.fa-filter:before {
  content: "\\f0b0";
}

.fa-fingerprint:before {
  content: "\\f577";
}

.fa-fire:before {
  content: "\\f06d";
}

.fa-fire-alt:before {
  content: "\\f7e4";
}

.fa-fire-extinguisher:before {
  content: "\\f134";
}

.fa-firefox:before {
  content: "\\f269";
}

.fa-firefox-browser:before {
  content: "龜";
}

.fa-first-aid:before {
  content: "\\f479";
}

.fa-first-order:before {
  content: "\\f2b0";
}

.fa-first-order-alt:before {
  content: "\\f50a";
}

.fa-firstdraft:before {
  content: "\\f3a1";
}

.fa-fish:before {
  content: "\\f578";
}

.fa-fist-raised:before {
  content: "\\f6de";
}

.fa-flag:before {
  content: "\\f024";
}

.fa-flag-checkered:before {
  content: "\\f11e";
}

.fa-flag-usa:before {
  content: "\\f74d";
}

.fa-flask:before {
  content: "\\f0c3";
}

.fa-flickr:before {
  content: "\\f16e";
}

.fa-flipboard:before {
  content: "\\f44d";
}

.fa-flushed:before {
  content: "\\f579";
}

.fa-fly:before {
  content: "\\f417";
}

.fa-folder:before {
  content: "\\f07b";
}

.fa-folder-minus:before {
  content: "\\f65d";
}

.fa-folder-open:before {
  content: "\\f07c";
}

.fa-folder-plus:before {
  content: "\\f65e";
}

.fa-font:before {
  content: "\\f031";
}

.fa-font-awesome:before {
  content: "\\f2b4";
}

.fa-font-awesome-alt:before {
  content: "\\f35c";
}

.fa-font-awesome-flag:before {
  content: "\\f425";
}

.fa-font-awesome-logo-full:before {
  content: "\\f4e6";
}

.fa-fonticons:before {
  content: "\\f280";
}

.fa-fonticons-fi:before {
  content: "\\f3a2";
}

.fa-football-ball:before {
  content: "\\f44e";
}

.fa-fort-awesome:before {
  content: "\\f286";
}

.fa-fort-awesome-alt:before {
  content: "\\f3a3";
}

.fa-forumbee:before {
  content: "\\f211";
}

.fa-forward:before {
  content: "\\f04e";
}

.fa-foursquare:before {
  content: "\\f180";
}

.fa-free-code-camp:before {
  content: "\\f2c5";
}

.fa-freebsd:before {
  content: "\\f3a4";
}

.fa-frog:before {
  content: "\\f52e";
}

.fa-frown:before {
  content: "\\f119";
}

.fa-frown-open:before {
  content: "\\f57a";
}

.fa-fulcrum:before {
  content: "\\f50b";
}

.fa-funnel-dollar:before {
  content: "\\f662";
}

.fa-futbol:before {
  content: "\\f1e3";
}

.fa-galactic-republic:before {
  content: "\\f50c";
}

.fa-galactic-senate:before {
  content: "\\f50d";
}

.fa-gamepad:before {
  content: "\\f11b";
}

.fa-gas-pump:before {
  content: "\\f52f";
}

.fa-gavel:before {
  content: "\\f0e3";
}

.fa-gem:before {
  content: "\\f3a5";
}

.fa-genderless:before {
  content: "\\f22d";
}

.fa-get-pocket:before {
  content: "\\f265";
}

.fa-gg:before {
  content: "\\f260";
}

.fa-gg-circle:before {
  content: "\\f261";
}

.fa-ghost:before {
  content: "\\f6e2";
}

.fa-gift:before {
  content: "\\f06b";
}

.fa-gifts:before {
  content: "\\f79c";
}

.fa-git:before {
  content: "\\f1d3";
}

.fa-git-alt:before {
  content: "\\f841";
}

.fa-git-square:before {
  content: "\\f1d2";
}

.fa-github:before {
  content: "\\f09b";
}

.fa-github-alt:before {
  content: "\\f113";
}

.fa-github-square:before {
  content: "\\f092";
}

.fa-gitkraken:before {
  content: "\\f3a6";
}

.fa-gitlab:before {
  content: "\\f296";
}

.fa-gitter:before {
  content: "\\f426";
}

.fa-glass-cheers:before {
  content: "\\f79f";
}

.fa-glass-martini:before {
  content: "\\f000";
}

.fa-glass-martini-alt:before {
  content: "\\f57b";
}

.fa-glass-whiskey:before {
  content: "\\f7a0";
}

.fa-glasses:before {
  content: "\\f530";
}

.fa-glide:before {
  content: "\\f2a5";
}

.fa-glide-g:before {
  content: "\\f2a6";
}

.fa-globe:before {
  content: "\\f0ac";
}

.fa-globe-africa:before {
  content: "\\f57c";
}

.fa-globe-americas:before {
  content: "\\f57d";
}

.fa-globe-asia:before {
  content: "\\f57e";
}

.fa-globe-europe:before {
  content: "\\f7a2";
}

.fa-gofore:before {
  content: "\\f3a7";
}

.fa-golf-ball:before {
  content: "\\f450";
}

.fa-goodreads:before {
  content: "\\f3a8";
}

.fa-goodreads-g:before {
  content: "\\f3a9";
}

.fa-google:before {
  content: "\\f1a0";
}

.fa-google-drive:before {
  content: "\\f3aa";
}

.fa-google-play:before {
  content: "\\f3ab";
}

.fa-google-plus:before {
  content: "\\f2b3";
}

.fa-google-plus-g:before {
  content: "\\f0d5";
}

.fa-google-plus-square:before {
  content: "\\f0d4";
}

.fa-google-wallet:before {
  content: "\\f1ee";
}

.fa-gopuram:before {
  content: "\\f664";
}

.fa-graduation-cap:before {
  content: "\\f19d";
}

.fa-gratipay:before {
  content: "\\f184";
}

.fa-grav:before {
  content: "\\f2d6";
}

.fa-greater-than:before {
  content: "\\f531";
}

.fa-greater-than-equal:before {
  content: "\\f532";
}

.fa-grimace:before {
  content: "\\f57f";
}

.fa-grin:before {
  content: "\\f580";
}

.fa-grin-alt:before {
  content: "\\f581";
}

.fa-grin-beam:before {
  content: "\\f582";
}

.fa-grin-beam-sweat:before {
  content: "\\f583";
}

.fa-grin-hearts:before {
  content: "\\f584";
}

.fa-grin-squint:before {
  content: "\\f585";
}

.fa-grin-squint-tears:before {
  content: "\\f586";
}

.fa-grin-stars:before {
  content: "\\f587";
}

.fa-grin-tears:before {
  content: "\\f588";
}

.fa-grin-tongue:before {
  content: "\\f589";
}

.fa-grin-tongue-squint:before {
  content: "\\f58a";
}

.fa-grin-tongue-wink:before {
  content: "\\f58b";
}

.fa-grin-wink:before {
  content: "\\f58c";
}

.fa-grip-horizontal:before {
  content: "\\f58d";
}

.fa-grip-lines:before {
  content: "\\f7a4";
}

.fa-grip-lines-vertical:before {
  content: "\\f7a5";
}

.fa-grip-vertical:before {
  content: "\\f58e";
}

.fa-gripfire:before {
  content: "\\f3ac";
}

.fa-grunt:before {
  content: "\\f3ad";
}

.fa-guitar:before {
  content: "\\f7a6";
}

.fa-gulp:before {
  content: "\\f3ae";
}

.fa-h-square:before {
  content: "\\f0fd";
}

.fa-hacker-news:before {
  content: "\\f1d4";
}

.fa-hacker-news-square:before {
  content: "\\f3af";
}

.fa-hackerrank:before {
  content: "\\f5f7";
}

.fa-hamburger:before {
  content: "\\f805";
}

.fa-hammer:before {
  content: "\\f6e3";
}

.fa-hamsa:before {
  content: "\\f665";
}

.fa-hand-holding:before {
  content: "\\f4bd";
}

.fa-hand-holding-heart:before {
  content: "\\f4be";
}

.fa-hand-holding-medical:before {
  content: "樂";
}

.fa-hand-holding-usd:before {
  content: "\\f4c0";
}

.fa-hand-holding-water:before {
  content: "\\f4c1";
}

.fa-hand-lizard:before {
  content: "\\f258";
}

.fa-hand-middle-finger:before {
  content: "\\f806";
}

.fa-hand-paper:before {
  content: "\\f256";
}

.fa-hand-peace:before {
  content: "\\f25b";
}

.fa-hand-point-down:before {
  content: "\\f0a7";
}

.fa-hand-point-left:before {
  content: "\\f0a5";
}

.fa-hand-point-right:before {
  content: "\\f0a4";
}

.fa-hand-point-up:before {
  content: "\\f0a6";
}

.fa-hand-pointer:before {
  content: "\\f25a";
}

.fa-hand-rock:before {
  content: "\\f255";
}

.fa-hand-scissors:before {
  content: "\\f257";
}

.fa-hand-sparkles:before {
  content: "諾";
}

.fa-hand-spock:before {
  content: "\\f259";
}

.fa-hands:before {
  content: "\\f4c2";
}

.fa-hands-helping:before {
  content: "\\f4c4";
}

.fa-hands-wash:before {
  content: "丹";
}

.fa-handshake:before {
  content: "\\f2b5";
}

.fa-handshake-alt-slash:before {
  content: "寧";
}

.fa-handshake-slash:before {
  content: "怒";
}

.fa-hanukiah:before {
  content: "\\f6e6";
}

.fa-hard-hat:before {
  content: "\\f807";
}

.fa-hashtag:before {
  content: "\\f292";
}

.fa-hat-cowboy:before {
  content: "\\f8c0";
}

.fa-hat-cowboy-side:before {
  content: "\\f8c1";
}

.fa-hat-wizard:before {
  content: "\\f6e8";
}

.fa-hdd:before {
  content: "\\f0a0";
}

.fa-head-side-cough:before {
  content: "率";
}

.fa-head-side-cough-slash:before {
  content: "異";
}

.fa-head-side-mask:before {
  content: "北";
}

.fa-head-side-virus:before {
  content: "磻";
}

.fa-heading:before {
  content: "\\f1dc";
}

.fa-headphones:before {
  content: "\\f025";
}

.fa-headphones-alt:before {
  content: "\\f58f";
}

.fa-headset:before {
  content: "\\f590";
}

.fa-heart:before {
  content: "\\f004";
}

.fa-heart-broken:before {
  content: "\\f7a9";
}

.fa-heartbeat:before {
  content: "\\f21e";
}

.fa-helicopter:before {
  content: "\\f533";
}

.fa-highlighter:before {
  content: "\\f591";
}

.fa-hiking:before {
  content: "\\f6ec";
}

.fa-hippo:before {
  content: "\\f6ed";
}

.fa-hips:before {
  content: "\\f452";
}

.fa-hire-a-helper:before {
  content: "\\f3b0";
}

.fa-history:before {
  content: "\\f1da";
}

.fa-hockey-puck:before {
  content: "\\f453";
}

.fa-holly-berry:before {
  content: "\\f7aa";
}

.fa-home:before {
  content: "\\f015";
}

.fa-hooli:before {
  content: "\\f427";
}

.fa-hornbill:before {
  content: "\\f592";
}

.fa-horse:before {
  content: "\\f6f0";
}

.fa-horse-head:before {
  content: "\\f7ab";
}

.fa-hospital:before {
  content: "\\f0f8";
}

.fa-hospital-alt:before {
  content: "\\f47d";
}

.fa-hospital-symbol:before {
  content: "\\f47e";
}

.fa-hospital-user:before {
  content: "\\f80d";
}

.fa-hot-tub:before {
  content: "\\f593";
}

.fa-hotdog:before {
  content: "\\f80f";
}

.fa-hotel:before {
  content: "\\f594";
}

.fa-hotjar:before {
  content: "\\f3b1";
}

.fa-hourglass:before {
  content: "\\f254";
}

.fa-hourglass-end:before {
  content: "\\f253";
}

.fa-hourglass-half:before {
  content: "\\f252";
}

.fa-hourglass-start:before {
  content: "\\f251";
}

.fa-house-damage:before {
  content: "\\f6f1";
}

.fa-house-user:before {
  content: "便";
}

.fa-houzz:before {
  content: "\\f27c";
}

.fa-hryvnia:before {
  content: "\\f6f2";
}

.fa-html5:before {
  content: "\\f13b";
}

.fa-hubspot:before {
  content: "\\f3b2";
}

.fa-i-cursor:before {
  content: "\\f246";
}

.fa-ice-cream:before {
  content: "\\f810";
}

.fa-icicles:before {
  content: "\\f7ad";
}

.fa-icons:before {
  content: "\\f86d";
}

.fa-id-badge:before {
  content: "\\f2c1";
}

.fa-id-card:before {
  content: "\\f2c2";
}

.fa-id-card-alt:before {
  content: "\\f47f";
}

.fa-ideal:before {
  content: "邏";
}

.fa-igloo:before {
  content: "\\f7ae";
}

.fa-image:before {
  content: "\\f03e";
}

.fa-images:before {
  content: "\\f302";
}

.fa-imdb:before {
  content: "\\f2d8";
}

.fa-inbox:before {
  content: "\\f01c";
}

.fa-indent:before {
  content: "\\f03c";
}

.fa-industry:before {
  content: "\\f275";
}

.fa-infinity:before {
  content: "\\f534";
}

.fa-info:before {
  content: "\\f129";
}

.fa-info-circle:before {
  content: "\\f05a";
}

.fa-instagram:before {
  content: "\\f16d";
}

.fa-instagram-square:before {
  content: "凌";
}

.fa-intercom:before {
  content: "\\f7af";
}

.fa-internet-explorer:before {
  content: "\\f26b";
}

.fa-invision:before {
  content: "\\f7b0";
}

.fa-ioxhost:before {
  content: "\\f208";
}

.fa-italic:before {
  content: "\\f033";
}

.fa-itch-io:before {
  content: "\\f83a";
}

.fa-itunes:before {
  content: "\\f3b4";
}

.fa-itunes-note:before {
  content: "\\f3b5";
}

.fa-java:before {
  content: "\\f4e4";
}

.fa-jedi:before {
  content: "\\f669";
}

.fa-jedi-order:before {
  content: "\\f50e";
}

.fa-jenkins:before {
  content: "\\f3b6";
}

.fa-jira:before {
  content: "\\f7b1";
}

.fa-joget:before {
  content: "\\f3b7";
}

.fa-joint:before {
  content: "\\f595";
}

.fa-joomla:before {
  content: "\\f1aa";
}

.fa-journal-whills:before {
  content: "\\f66a";
}

.fa-js:before {
  content: "\\f3b8";
}

.fa-js-square:before {
  content: "\\f3b9";
}

.fa-jsfiddle:before {
  content: "\\f1cc";
}

.fa-kaaba:before {
  content: "\\f66b";
}

.fa-kaggle:before {
  content: "\\f5fa";
}

.fa-key:before {
  content: "\\f084";
}

.fa-keybase:before {
  content: "\\f4f5";
}

.fa-keyboard:before {
  content: "\\f11c";
}

.fa-keycdn:before {
  content: "\\f3ba";
}

.fa-khanda:before {
  content: "\\f66d";
}

.fa-kickstarter:before {
  content: "\\f3bb";
}

.fa-kickstarter-k:before {
  content: "\\f3bc";
}

.fa-kiss:before {
  content: "\\f596";
}

.fa-kiss-beam:before {
  content: "\\f597";
}

.fa-kiss-wink-heart:before {
  content: "\\f598";
}

.fa-kiwi-bird:before {
  content: "\\f535";
}

.fa-korvue:before {
  content: "\\f42f";
}

.fa-landmark:before {
  content: "\\f66f";
}

.fa-language:before {
  content: "\\f1ab";
}

.fa-laptop:before {
  content: "\\f109";
}

.fa-laptop-code:before {
  content: "\\f5fc";
}

.fa-laptop-house:before {
  content: "復";
}

.fa-laptop-medical:before {
  content: "\\f812";
}

.fa-laravel:before {
  content: "\\f3bd";
}

.fa-lastfm:before {
  content: "\\f202";
}

.fa-lastfm-square:before {
  content: "\\f203";
}

.fa-laugh:before {
  content: "\\f599";
}

.fa-laugh-beam:before {
  content: "\\f59a";
}

.fa-laugh-squint:before {
  content: "\\f59b";
}

.fa-laugh-wink:before {
  content: "\\f59c";
}

.fa-layer-group:before {
  content: "\\f5fd";
}

.fa-leaf:before {
  content: "\\f06c";
}

.fa-leanpub:before {
  content: "\\f212";
}

.fa-lemon:before {
  content: "\\f094";
}

.fa-less:before {
  content: "\\f41d";
}

.fa-less-than:before {
  content: "\\f536";
}

.fa-less-than-equal:before {
  content: "\\f537";
}

.fa-level-down-alt:before {
  content: "\\f3be";
}

.fa-level-up-alt:before {
  content: "\\f3bf";
}

.fa-life-ring:before {
  content: "\\f1cd";
}

.fa-lightbulb:before {
  content: "\\f0eb";
}

.fa-line:before {
  content: "\\f3c0";
}

.fa-link:before {
  content: "\\f0c1";
}

.fa-linkedin:before {
  content: "\\f08c";
}

.fa-linkedin-in:before {
  content: "\\f0e1";
}

.fa-linode:before {
  content: "\\f2b8";
}

.fa-linux:before {
  content: "\\f17c";
}

.fa-lira-sign:before {
  content: "\\f195";
}

.fa-list:before {
  content: "\\f03a";
}

.fa-list-alt:before {
  content: "\\f022";
}

.fa-list-ol:before {
  content: "\\f0cb";
}

.fa-list-ul:before {
  content: "\\f0ca";
}

.fa-location-arrow:before {
  content: "\\f124";
}

.fa-lock:before {
  content: "\\f023";
}

.fa-lock-open:before {
  content: "\\f3c1";
}

.fa-long-arrow-alt-down:before {
  content: "\\f309";
}

.fa-long-arrow-alt-left:before {
  content: "\\f30a";
}

.fa-long-arrow-alt-right:before {
  content: "\\f30b";
}

.fa-long-arrow-alt-up:before {
  content: "\\f30c";
}

.fa-low-vision:before {
  content: "\\f2a8";
}

.fa-luggage-cart:before {
  content: "\\f59d";
}

.fa-lungs:before {
  content: "\\f604";
}

.fa-lungs-virus:before {
  content: "不";
}

.fa-lyft:before {
  content: "\\f3c3";
}

.fa-magento:before {
  content: "\\f3c4";
}

.fa-magic:before {
  content: "\\f0d0";
}

.fa-magnet:before {
  content: "\\f076";
}

.fa-mail-bulk:before {
  content: "\\f674";
}

.fa-mailchimp:before {
  content: "\\f59e";
}

.fa-male:before {
  content: "\\f183";
}

.fa-mandalorian:before {
  content: "\\f50f";
}

.fa-map:before {
  content: "\\f279";
}

.fa-map-marked:before {
  content: "\\f59f";
}

.fa-map-marked-alt:before {
  content: "\\f5a0";
}

.fa-map-marker:before {
  content: "\\f041";
}

.fa-map-marker-alt:before {
  content: "\\f3c5";
}

.fa-map-pin:before {
  content: "\\f276";
}

.fa-map-signs:before {
  content: "\\f277";
}

.fa-markdown:before {
  content: "\\f60f";
}

.fa-marker:before {
  content: "\\f5a1";
}

.fa-mars:before {
  content: "\\f222";
}

.fa-mars-double:before {
  content: "\\f227";
}

.fa-mars-stroke:before {
  content: "\\f229";
}

.fa-mars-stroke-h:before {
  content: "\\f22b";
}

.fa-mars-stroke-v:before {
  content: "\\f22a";
}

.fa-mask:before {
  content: "\\f6fa";
}

.fa-mastodon:before {
  content: "\\f4f6";
}

.fa-maxcdn:before {
  content: "\\f136";
}

.fa-mdb:before {
  content: "\\f8ca";
}

.fa-medal:before {
  content: "\\f5a2";
}

.fa-medapps:before {
  content: "\\f3c6";
}

.fa-medium:before {
  content: "\\f23a";
}

.fa-medium-m:before {
  content: "\\f3c7";
}

.fa-medkit:before {
  content: "\\f0fa";
}

.fa-medrt:before {
  content: "\\f3c8";
}

.fa-meetup:before {
  content: "\\f2e0";
}

.fa-megaport:before {
  content: "\\f5a3";
}

.fa-meh:before {
  content: "\\f11a";
}

.fa-meh-blank:before {
  content: "\\f5a4";
}

.fa-meh-rolling-eyes:before {
  content: "\\f5a5";
}

.fa-memory:before {
  content: "\\f538";
}

.fa-mendeley:before {
  content: "\\f7b3";
}

.fa-menorah:before {
  content: "\\f676";
}

.fa-mercury:before {
  content: "\\f223";
}

.fa-meteor:before {
  content: "\\f753";
}

.fa-microblog:before {
  content: "駱";
}

.fa-microchip:before {
  content: "\\f2db";
}

.fa-microphone:before {
  content: "\\f130";
}

.fa-microphone-alt:before {
  content: "\\f3c9";
}

.fa-microphone-alt-slash:before {
  content: "\\f539";
}

.fa-microphone-slash:before {
  content: "\\f131";
}

.fa-microscope:before {
  content: "\\f610";
}

.fa-microsoft:before {
  content: "\\f3ca";
}

.fa-minus:before {
  content: "\\f068";
}

.fa-minus-circle:before {
  content: "\\f056";
}

.fa-minus-square:before {
  content: "\\f146";
}

.fa-mitten:before {
  content: "\\f7b5";
}

.fa-mix:before {
  content: "\\f3cb";
}

.fa-mixcloud:before {
  content: "\\f289";
}

.fa-mixer:before {
  content: "稜";
}

.fa-mizuni:before {
  content: "\\f3cc";
}

.fa-mobile:before {
  content: "\\f10b";
}

.fa-mobile-alt:before {
  content: "\\f3cd";
}

.fa-modx:before {
  content: "\\f285";
}

.fa-monero:before {
  content: "\\f3d0";
}

.fa-money-bill:before {
  content: "\\f0d6";
}

.fa-money-bill-alt:before {
  content: "\\f3d1";
}

.fa-money-bill-wave:before {
  content: "\\f53a";
}

.fa-money-bill-wave-alt:before {
  content: "\\f53b";
}

.fa-money-check:before {
  content: "\\f53c";
}

.fa-money-check-alt:before {
  content: "\\f53d";
}

.fa-monument:before {
  content: "\\f5a6";
}

.fa-moon:before {
  content: "\\f186";
}

.fa-mortar-pestle:before {
  content: "\\f5a7";
}

.fa-mosque:before {
  content: "\\f678";
}

.fa-motorcycle:before {
  content: "\\f21c";
}

.fa-mountain:before {
  content: "\\f6fc";
}

.fa-mouse:before {
  content: "\\f8cc";
}

.fa-mouse-pointer:before {
  content: "\\f245";
}

.fa-mug-hot:before {
  content: "\\f7b6";
}

.fa-music:before {
  content: "\\f001";
}

.fa-napster:before {
  content: "\\f3d2";
}

.fa-neos:before {
  content: "\\f612";
}

.fa-network-wired:before {
  content: "\\f6ff";
}

.fa-neuter:before {
  content: "\\f22c";
}

.fa-newspaper:before {
  content: "\\f1ea";
}

.fa-nimblr:before {
  content: "\\f5a8";
}

.fa-node:before {
  content: "\\f419";
}

.fa-node-js:before {
  content: "\\f3d3";
}

.fa-not-equal:before {
  content: "\\f53e";
}

.fa-notes-medical:before {
  content: "\\f481";
}

.fa-npm:before {
  content: "\\f3d4";
}

.fa-ns8:before {
  content: "\\f3d5";
}

.fa-nutritionix:before {
  content: "\\f3d6";
}

.fa-object-group:before {
  content: "\\f247";
}

.fa-object-ungroup:before {
  content: "\\f248";
}

.fa-odnoklassniki:before {
  content: "\\f263";
}

.fa-odnoklassniki-square:before {
  content: "\\f264";
}

.fa-oil-can:before {
  content: "\\f613";
}

.fa-old-republic:before {
  content: "\\f510";
}

.fa-om:before {
  content: "\\f679";
}

.fa-opencart:before {
  content: "\\f23d";
}

.fa-openid:before {
  content: "\\f19b";
}

.fa-opera:before {
  content: "\\f26a";
}

.fa-optin-monster:before {
  content: "\\f23c";
}

.fa-orcid:before {
  content: "\\f8d2";
}

.fa-osi:before {
  content: "\\f41a";
}

.fa-otter:before {
  content: "\\f700";
}

.fa-outdent:before {
  content: "\\f03b";
}

.fa-page4:before {
  content: "\\f3d7";
}

.fa-pagelines:before {
  content: "\\f18c";
}

.fa-pager:before {
  content: "\\f815";
}

.fa-paint-brush:before {
  content: "\\f1fc";
}

.fa-paint-roller:before {
  content: "\\f5aa";
}

.fa-palette:before {
  content: "\\f53f";
}

.fa-palfed:before {
  content: "\\f3d8";
}

.fa-pallet:before {
  content: "\\f482";
}

.fa-paper-plane:before {
  content: "\\f1d8";
}

.fa-paperclip:before {
  content: "\\f0c6";
}

.fa-parachute-box:before {
  content: "\\f4cd";
}

.fa-paragraph:before {
  content: "\\f1dd";
}

.fa-parking:before {
  content: "\\f540";
}

.fa-passport:before {
  content: "\\f5ab";
}

.fa-pastafarianism:before {
  content: "\\f67b";
}

.fa-paste:before {
  content: "\\f0ea";
}

.fa-patreon:before {
  content: "\\f3d9";
}

.fa-pause:before {
  content: "\\f04c";
}

.fa-pause-circle:before {
  content: "\\f28b";
}

.fa-paw:before {
  content: "\\f1b0";
}

.fa-paypal:before {
  content: "\\f1ed";
}

.fa-peace:before {
  content: "\\f67c";
}

.fa-pen:before {
  content: "\\f304";
}

.fa-pen-alt:before {
  content: "\\f305";
}

.fa-pen-fancy:before {
  content: "\\f5ac";
}

.fa-pen-nib:before {
  content: "\\f5ad";
}

.fa-pen-square:before {
  content: "\\f14b";
}

.fa-pencil-alt:before {
  content: "\\f303";
}

.fa-pencil-ruler:before {
  content: "\\f5ae";
}

.fa-penny-arcade:before {
  content: "\\f704";
}

.fa-people-arrows:before {
  content: "泌";
}

.fa-people-carry:before {
  content: "\\f4ce";
}

.fa-pepper-hot:before {
  content: "\\f816";
}

.fa-percent:before {
  content: "\\f295";
}

.fa-percentage:before {
  content: "\\f541";
}

.fa-periscope:before {
  content: "\\f3da";
}

.fa-person-booth:before {
  content: "\\f756";
}

.fa-phabricator:before {
  content: "\\f3db";
}

.fa-phoenix-framework:before {
  content: "\\f3dc";
}

.fa-phoenix-squadron:before {
  content: "\\f511";
}

.fa-phone:before {
  content: "\\f095";
}

.fa-phone-alt:before {
  content: "\\f879";
}

.fa-phone-slash:before {
  content: "\\f3dd";
}

.fa-phone-square:before {
  content: "\\f098";
}

.fa-phone-square-alt:before {
  content: "\\f87b";
}

.fa-phone-volume:before {
  content: "\\f2a0";
}

.fa-photo-video:before {
  content: "\\f87c";
}

.fa-php:before {
  content: "\\f457";
}

.fa-pied-piper:before {
  content: "\\f2ae";
}

.fa-pied-piper-alt:before {
  content: "\\f1a8";
}

.fa-pied-piper-hat:before {
  content: "\\f4e5";
}

.fa-pied-piper-pp:before {
  content: "\\f1a7";
}

.fa-pied-piper-square:before {
  content: "爛";
}

.fa-piggy-bank:before {
  content: "\\f4d3";
}

.fa-pills:before {
  content: "\\f484";
}

.fa-pinterest:before {
  content: "\\f0d2";
}

.fa-pinterest-p:before {
  content: "\\f231";
}

.fa-pinterest-square:before {
  content: "\\f0d3";
}

.fa-pizza-slice:before {
  content: "\\f818";
}

.fa-place-of-worship:before {
  content: "\\f67f";
}

.fa-plane:before {
  content: "\\f072";
}

.fa-plane-arrival:before {
  content: "\\f5af";
}

.fa-plane-departure:before {
  content: "\\f5b0";
}

.fa-plane-slash:before {
  content: "數";
}

.fa-play:before {
  content: "\\f04b";
}

.fa-play-circle:before {
  content: "\\f144";
}

.fa-playstation:before {
  content: "\\f3df";
}

.fa-plug:before {
  content: "\\f1e6";
}

.fa-plus:before {
  content: "\\f067";
}

.fa-plus-circle:before {
  content: "\\f055";
}

.fa-plus-square:before {
  content: "\\f0fe";
}

.fa-podcast:before {
  content: "\\f2ce";
}

.fa-poll:before {
  content: "\\f681";
}

.fa-poll-h:before {
  content: "\\f682";
}

.fa-poo:before {
  content: "\\f2fe";
}

.fa-poo-storm:before {
  content: "\\f75a";
}

.fa-poop:before {
  content: "\\f619";
}

.fa-portrait:before {
  content: "\\f3e0";
}

.fa-pound-sign:before {
  content: "\\f154";
}

.fa-power-off:before {
  content: "\\f011";
}

.fa-pray:before {
  content: "\\f683";
}

.fa-praying-hands:before {
  content: "\\f684";
}

.fa-prescription:before {
  content: "\\f5b1";
}

.fa-prescription-bottle:before {
  content: "\\f485";
}

.fa-prescription-bottle-alt:before {
  content: "\\f486";
}

.fa-print:before {
  content: "\\f02f";
}

.fa-procedures:before {
  content: "\\f487";
}

.fa-product-hunt:before {
  content: "\\f288";
}

.fa-project-diagram:before {
  content: "\\f542";
}

.fa-pump-medical:before {
  content: "索";
}

.fa-pump-soap:before {
  content: "參";
}

.fa-pushed:before {
  content: "\\f3e1";
}

.fa-puzzle-piece:before {
  content: "\\f12e";
}

.fa-python:before {
  content: "\\f3e2";
}

.fa-qq:before {
  content: "\\f1d6";
}

.fa-qrcode:before {
  content: "\\f029";
}

.fa-question:before {
  content: "\\f128";
}

.fa-question-circle:before {
  content: "\\f059";
}

.fa-quidditch:before {
  content: "\\f458";
}

.fa-quinscape:before {
  content: "\\f459";
}

.fa-quora:before {
  content: "\\f2c4";
}

.fa-quote-left:before {
  content: "\\f10d";
}

.fa-quote-right:before {
  content: "\\f10e";
}

.fa-quran:before {
  content: "\\f687";
}

.fa-r-project:before {
  content: "\\f4f7";
}

.fa-radiation:before {
  content: "\\f7b9";
}

.fa-radiation-alt:before {
  content: "\\f7ba";
}

.fa-rainbow:before {
  content: "\\f75b";
}

.fa-random:before {
  content: "\\f074";
}

.fa-raspberry-pi:before {
  content: "\\f7bb";
}

.fa-ravelry:before {
  content: "\\f2d9";
}

.fa-react:before {
  content: "\\f41b";
}

.fa-reacteurope:before {
  content: "\\f75d";
}

.fa-readme:before {
  content: "\\f4d5";
}

.fa-rebel:before {
  content: "\\f1d0";
}

.fa-receipt:before {
  content: "\\f543";
}

.fa-record-vinyl:before {
  content: "\\f8d9";
}

.fa-recycle:before {
  content: "\\f1b8";
}

.fa-red-river:before {
  content: "\\f3e3";
}

.fa-reddit:before {
  content: "\\f1a1";
}

.fa-reddit-alien:before {
  content: "\\f281";
}

.fa-reddit-square:before {
  content: "\\f1a2";
}

.fa-redhat:before {
  content: "\\f7bc";
}

.fa-redo:before {
  content: "\\f01e";
}

.fa-redo-alt:before {
  content: "\\f2f9";
}

.fa-registered:before {
  content: "\\f25d";
}

.fa-remove-format:before {
  content: "\\f87d";
}

.fa-renren:before {
  content: "\\f18b";
}

.fa-reply:before {
  content: "\\f3e5";
}

.fa-reply-all:before {
  content: "\\f122";
}

.fa-replyd:before {
  content: "\\f3e6";
}

.fa-republican:before {
  content: "\\f75e";
}

.fa-researchgate:before {
  content: "\\f4f8";
}

.fa-resolving:before {
  content: "\\f3e7";
}

.fa-restroom:before {
  content: "\\f7bd";
}

.fa-retweet:before {
  content: "\\f079";
}

.fa-rev:before {
  content: "\\f5b2";
}

.fa-ribbon:before {
  content: "\\f4d6";
}

.fa-ring:before {
  content: "\\f70b";
}

.fa-road:before {
  content: "\\f018";
}

.fa-robot:before {
  content: "\\f544";
}

.fa-rocket:before {
  content: "\\f135";
}

.fa-rocketchat:before {
  content: "\\f3e8";
}

.fa-rockrms:before {
  content: "\\f3e9";
}

.fa-route:before {
  content: "\\f4d7";
}

.fa-rss:before {
  content: "\\f09e";
}

.fa-rss-square:before {
  content: "\\f143";
}

.fa-ruble-sign:before {
  content: "\\f158";
}

.fa-ruler:before {
  content: "\\f545";
}

.fa-ruler-combined:before {
  content: "\\f546";
}

.fa-ruler-horizontal:before {
  content: "\\f547";
}

.fa-ruler-vertical:before {
  content: "\\f548";
}

.fa-running:before {
  content: "\\f70c";
}

.fa-rupee-sign:before {
  content: "\\f156";
}

.fa-sad-cry:before {
  content: "\\f5b3";
}

.fa-sad-tear:before {
  content: "\\f5b4";
}

.fa-safari:before {
  content: "\\f267";
}

.fa-salesforce:before {
  content: "\\f83b";
}

.fa-sass:before {
  content: "\\f41e";
}

.fa-satellite:before {
  content: "\\f7bf";
}

.fa-satellite-dish:before {
  content: "\\f7c0";
}

.fa-save:before {
  content: "\\f0c7";
}

.fa-schlix:before {
  content: "\\f3ea";
}

.fa-school:before {
  content: "\\f549";
}

.fa-screwdriver:before {
  content: "\\f54a";
}

.fa-scribd:before {
  content: "\\f28a";
}

.fa-scroll:before {
  content: "\\f70e";
}

.fa-sd-card:before {
  content: "\\f7c2";
}

.fa-search:before {
  content: "\\f002";
}

.fa-search-dollar:before {
  content: "\\f688";
}

.fa-search-location:before {
  content: "\\f689";
}

.fa-search-minus:before {
  content: "\\f010";
}

.fa-search-plus:before {
  content: "\\f00e";
}

.fa-searchengin:before {
  content: "\\f3eb";
}

.fa-seedling:before {
  content: "\\f4d8";
}

.fa-sellcast:before {
  content: "\\f2da";
}

.fa-sellsy:before {
  content: "\\f213";
}

.fa-server:before {
  content: "\\f233";
}

.fa-servicestack:before {
  content: "\\f3ec";
}

.fa-shapes:before {
  content: "\\f61f";
}

.fa-share:before {
  content: "\\f064";
}

.fa-share-alt:before {
  content: "\\f1e0";
}

.fa-share-alt-square:before {
  content: "\\f1e1";
}

.fa-share-square:before {
  content: "\\f14d";
}

.fa-shekel-sign:before {
  content: "\\f20b";
}

.fa-shield-alt:before {
  content: "\\f3ed";
}

.fa-shield-virus:before {
  content: "塞";
}

.fa-ship:before {
  content: "\\f21a";
}

.fa-shipping-fast:before {
  content: "\\f48b";
}

.fa-shirtsinbulk:before {
  content: "\\f214";
}

.fa-shoe-prints:before {
  content: "\\f54b";
}

.fa-shopify:before {
  content: "綾";
}

.fa-shopping-bag:before {
  content: "\\f290";
}

.fa-shopping-basket:before {
  content: "\\f291";
}

.fa-shopping-cart:before {
  content: "\\f07a";
}

.fa-shopware:before {
  content: "\\f5b5";
}

.fa-shower:before {
  content: "\\f2cc";
}

.fa-shuttle-van:before {
  content: "\\f5b6";
}

.fa-sign:before {
  content: "\\f4d9";
}

.fa-sign-in-alt:before {
  content: "\\f2f6";
}

.fa-sign-language:before {
  content: "\\f2a7";
}

.fa-sign-out-alt:before {
  content: "\\f2f5";
}

.fa-signal:before {
  content: "\\f012";
}

.fa-signature:before {
  content: "\\f5b7";
}

.fa-sim-card:before {
  content: "\\f7c4";
}

.fa-simplybuilt:before {
  content: "\\f215";
}

.fa-sistrix:before {
  content: "\\f3ee";
}

.fa-sitemap:before {
  content: "\\f0e8";
}

.fa-sith:before {
  content: "\\f512";
}

.fa-skating:before {
  content: "\\f7c5";
}

.fa-sketch:before {
  content: "\\f7c6";
}

.fa-skiing:before {
  content: "\\f7c9";
}

.fa-skiing-nordic:before {
  content: "\\f7ca";
}

.fa-skull:before {
  content: "\\f54c";
}

.fa-skull-crossbones:before {
  content: "\\f714";
}

.fa-skyatlas:before {
  content: "\\f216";
}

.fa-skype:before {
  content: "\\f17e";
}

.fa-slack:before {
  content: "\\f198";
}

.fa-slack-hash:before {
  content: "\\f3ef";
}

.fa-slash:before {
  content: "\\f715";
}

.fa-sleigh:before {
  content: "\\f7cc";
}

.fa-sliders-h:before {
  content: "\\f1de";
}

.fa-slideshare:before {
  content: "\\f1e7";
}

.fa-smile:before {
  content: "\\f118";
}

.fa-smile-beam:before {
  content: "\\f5b8";
}

.fa-smile-wink:before {
  content: "\\f4da";
}

.fa-smog:before {
  content: "\\f75f";
}

.fa-smoking:before {
  content: "\\f48d";
}

.fa-smoking-ban:before {
  content: "\\f54d";
}

.fa-sms:before {
  content: "\\f7cd";
}

.fa-snapchat:before {
  content: "\\f2ab";
}

.fa-snapchat-ghost:before {
  content: "\\f2ac";
}

.fa-snapchat-square:before {
  content: "\\f2ad";
}

.fa-snowboarding:before {
  content: "\\f7ce";
}

.fa-snowflake:before {
  content: "\\f2dc";
}

.fa-snowman:before {
  content: "\\f7d0";
}

.fa-snowplow:before {
  content: "\\f7d2";
}

.fa-soap:before {
  content: "葉";
}

.fa-socks:before {
  content: "\\f696";
}

.fa-solar-panel:before {
  content: "\\f5ba";
}

.fa-sort:before {
  content: "\\f0dc";
}

.fa-sort-alpha-down:before {
  content: "\\f15d";
}

.fa-sort-alpha-down-alt:before {
  content: "\\f881";
}

.fa-sort-alpha-up:before {
  content: "\\f15e";
}

.fa-sort-alpha-up-alt:before {
  content: "\\f882";
}

.fa-sort-amount-down:before {
  content: "\\f160";
}

.fa-sort-amount-down-alt:before {
  content: "\\f884";
}

.fa-sort-amount-up:before {
  content: "\\f161";
}

.fa-sort-amount-up-alt:before {
  content: "\\f885";
}

.fa-sort-down:before {
  content: "\\f0dd";
}

.fa-sort-numeric-down:before {
  content: "\\f162";
}

.fa-sort-numeric-down-alt:before {
  content: "\\f886";
}

.fa-sort-numeric-up:before {
  content: "\\f163";
}

.fa-sort-numeric-up-alt:before {
  content: "\\f887";
}

.fa-sort-up:before {
  content: "\\f0de";
}

.fa-soundcloud:before {
  content: "\\f1be";
}

.fa-sourcetree:before {
  content: "\\f7d3";
}

.fa-spa:before {
  content: "\\f5bb";
}

.fa-space-shuttle:before {
  content: "\\f197";
}

.fa-speakap:before {
  content: "\\f3f3";
}

.fa-speaker-deck:before {
  content: "\\f83c";
}

.fa-spell-check:before {
  content: "\\f891";
}

.fa-spider:before {
  content: "\\f717";
}

.fa-spinner:before {
  content: "\\f110";
}

.fa-splotch:before {
  content: "\\f5bc";
}

.fa-spotify:before {
  content: "\\f1bc";
}

.fa-spray-can:before {
  content: "\\f5bd";
}

.fa-square:before {
  content: "\\f0c8";
}

.fa-square-full:before {
  content: "\\f45c";
}

.fa-square-root-alt:before {
  content: "\\f698";
}

.fa-squarespace:before {
  content: "\\f5be";
}

.fa-stack-exchange:before {
  content: "\\f18d";
}

.fa-stack-overflow:before {
  content: "\\f16c";
}

.fa-stackpath:before {
  content: "\\f842";
}

.fa-stamp:before {
  content: "\\f5bf";
}

.fa-star:before {
  content: "\\f005";
}

.fa-star-and-crescent:before {
  content: "\\f699";
}

.fa-star-half:before {
  content: "\\f089";
}

.fa-star-half-alt:before {
  content: "\\f5c0";
}

.fa-star-of-david:before {
  content: "\\f69a";
}

.fa-star-of-life:before {
  content: "\\f621";
}

.fa-staylinked:before {
  content: "\\f3f5";
}

.fa-steam:before {
  content: "\\f1b6";
}

.fa-steam-square:before {
  content: "\\f1b7";
}

.fa-steam-symbol:before {
  content: "\\f3f6";
}

.fa-step-backward:before {
  content: "\\f048";
}

.fa-step-forward:before {
  content: "\\f051";
}

.fa-stethoscope:before {
  content: "\\f0f1";
}

.fa-sticker-mule:before {
  content: "\\f3f7";
}

.fa-sticky-note:before {
  content: "\\f249";
}

.fa-stop:before {
  content: "\\f04d";
}

.fa-stop-circle:before {
  content: "\\f28d";
}

.fa-stopwatch:before {
  content: "\\f2f2";
}

.fa-stopwatch-20:before {
  content: "說";
}

.fa-store:before {
  content: "\\f54e";
}

.fa-store-alt:before {
  content: "\\f54f";
}

.fa-store-alt-slash:before {
  content: "殺";
}

.fa-store-slash:before {
  content: "辰";
}

.fa-strava:before {
  content: "\\f428";
}

.fa-stream:before {
  content: "\\f550";
}

.fa-street-view:before {
  content: "\\f21d";
}

.fa-strikethrough:before {
  content: "\\f0cc";
}

.fa-stripe:before {
  content: "\\f429";
}

.fa-stripe-s:before {
  content: "\\f42a";
}

.fa-stroopwafel:before {
  content: "\\f551";
}

.fa-studiovinari:before {
  content: "\\f3f8";
}

.fa-stumbleupon:before {
  content: "\\f1a4";
}

.fa-stumbleupon-circle:before {
  content: "\\f1a3";
}

.fa-subscript:before {
  content: "\\f12c";
}

.fa-subway:before {
  content: "\\f239";
}

.fa-suitcase:before {
  content: "\\f0f2";
}

.fa-suitcase-rolling:before {
  content: "\\f5c1";
}

.fa-sun:before {
  content: "\\f185";
}

.fa-superpowers:before {
  content: "\\f2dd";
}

.fa-superscript:before {
  content: "\\f12b";
}

.fa-supple:before {
  content: "\\f3f9";
}

.fa-surprise:before {
  content: "\\f5c2";
}

.fa-suse:before {
  content: "\\f7d6";
}

.fa-swatchbook:before {
  content: "\\f5c3";
}

.fa-swift:before {
  content: "\\f8e1";
}

.fa-swimmer:before {
  content: "\\f5c4";
}

.fa-swimming-pool:before {
  content: "\\f5c5";
}

.fa-symfony:before {
  content: "\\f83d";
}

.fa-synagogue:before {
  content: "\\f69b";
}

.fa-sync:before {
  content: "\\f021";
}

.fa-sync-alt:before {
  content: "\\f2f1";
}

.fa-syringe:before {
  content: "\\f48e";
}

.fa-table:before {
  content: "\\f0ce";
}

.fa-table-tennis:before {
  content: "\\f45d";
}

.fa-tablet:before {
  content: "\\f10a";
}

.fa-tablet-alt:before {
  content: "\\f3fa";
}

.fa-tablets:before {
  content: "\\f490";
}

.fa-tachometer-alt:before {
  content: "\\f3fd";
}

.fa-tag:before {
  content: "\\f02b";
}

.fa-tags:before {
  content: "\\f02c";
}

.fa-tape:before {
  content: "\\f4db";
}

.fa-tasks:before {
  content: "\\f0ae";
}

.fa-taxi:before {
  content: "\\f1ba";
}

.fa-teamspeak:before {
  content: "\\f4f9";
}

.fa-teeth:before {
  content: "\\f62e";
}

.fa-teeth-open:before {
  content: "\\f62f";
}

.fa-telegram:before {
  content: "\\f2c6";
}

.fa-telegram-plane:before {
  content: "\\f3fe";
}

.fa-temperature-high:before {
  content: "\\f769";
}

.fa-temperature-low:before {
  content: "\\f76b";
}

.fa-tencent-weibo:before {
  content: "\\f1d5";
}

.fa-tenge:before {
  content: "\\f7d7";
}

.fa-terminal:before {
  content: "\\f120";
}

.fa-text-height:before {
  content: "\\f034";
}

.fa-text-width:before {
  content: "\\f035";
}

.fa-th:before {
  content: "\\f00a";
}

.fa-th-large:before {
  content: "\\f009";
}

.fa-th-list:before {
  content: "\\f00b";
}

.fa-the-red-yeti:before {
  content: "\\f69d";
}

.fa-theater-masks:before {
  content: "\\f630";
}

.fa-themeco:before {
  content: "\\f5c6";
}

.fa-themeisle:before {
  content: "\\f2b2";
}

.fa-thermometer:before {
  content: "\\f491";
}

.fa-thermometer-empty:before {
  content: "\\f2cb";
}

.fa-thermometer-full:before {
  content: "\\f2c7";
}

.fa-thermometer-half:before {
  content: "\\f2c9";
}

.fa-thermometer-quarter:before {
  content: "\\f2ca";
}

.fa-thermometer-three-quarters:before {
  content: "\\f2c8";
}

.fa-think-peaks:before {
  content: "\\f731";
}

.fa-thumbs-down:before {
  content: "\\f165";
}

.fa-thumbs-up:before {
  content: "\\f164";
}

.fa-thumbtack:before {
  content: "\\f08d";
}

.fa-ticket-alt:before {
  content: "\\f3ff";
}

.fa-times:before {
  content: "\\f00d";
}

.fa-times-circle:before {
  content: "\\f057";
}

.fa-tint:before {
  content: "\\f043";
}

.fa-tint-slash:before {
  content: "\\f5c7";
}

.fa-tired:before {
  content: "\\f5c8";
}

.fa-toggle-off:before {
  content: "\\f204";
}

.fa-toggle-on:before {
  content: "\\f205";
}

.fa-toilet:before {
  content: "\\f7d8";
}

.fa-toilet-paper:before {
  content: "\\f71e";
}

.fa-toilet-paper-slash:before {
  content: "沈";
}

.fa-toolbox:before {
  content: "\\f552";
}

.fa-tools:before {
  content: "\\f7d9";
}

.fa-tooth:before {
  content: "\\f5c9";
}

.fa-torah:before {
  content: "\\f6a0";
}

.fa-torii-gate:before {
  content: "\\f6a1";
}

.fa-tractor:before {
  content: "\\f722";
}

.fa-trade-federation:before {
  content: "\\f513";
}

.fa-trademark:before {
  content: "\\f25c";
}

.fa-traffic-light:before {
  content: "\\f637";
}

.fa-trailer:before {
  content: "論";
}

.fa-train:before {
  content: "\\f238";
}

.fa-tram:before {
  content: "\\f7da";
}

.fa-transgender:before {
  content: "\\f224";
}

.fa-transgender-alt:before {
  content: "\\f225";
}

.fa-trash:before {
  content: "\\f1f8";
}

.fa-trash-alt:before {
  content: "\\f2ed";
}

.fa-trash-restore:before {
  content: "\\f829";
}

.fa-trash-restore-alt:before {
  content: "\\f82a";
}

.fa-tree:before {
  content: "\\f1bb";
}

.fa-trello:before {
  content: "\\f181";
}

.fa-tripadvisor:before {
  content: "\\f262";
}

.fa-trophy:before {
  content: "\\f091";
}

.fa-truck:before {
  content: "\\f0d1";
}

.fa-truck-loading:before {
  content: "\\f4de";
}

.fa-truck-monster:before {
  content: "\\f63b";
}

.fa-truck-moving:before {
  content: "\\f4df";
}

.fa-truck-pickup:before {
  content: "\\f63c";
}

.fa-tshirt:before {
  content: "\\f553";
}

.fa-tty:before {
  content: "\\f1e4";
}

.fa-tumblr:before {
  content: "\\f173";
}

.fa-tumblr-square:before {
  content: "\\f174";
}

.fa-tv:before {
  content: "\\f26c";
}

.fa-twitch:before {
  content: "\\f1e8";
}

.fa-twitter:before {
  content: "\\f099";
}

.fa-twitter-square:before {
  content: "\\f081";
}

.fa-typo3:before {
  content: "\\f42b";
}

.fa-uber:before {
  content: "\\f402";
}

.fa-ubuntu:before {
  content: "\\f7df";
}

.fa-uikit:before {
  content: "\\f403";
}

.fa-umbraco:before {
  content: "\\f8e8";
}

.fa-umbrella:before {
  content: "\\f0e9";
}

.fa-umbrella-beach:before {
  content: "\\f5ca";
}

.fa-underline:before {
  content: "\\f0cd";
}

.fa-undo:before {
  content: "\\f0e2";
}

.fa-undo-alt:before {
  content: "\\f2ea";
}

.fa-uniregistry:before {
  content: "\\f404";
}

.fa-unity:before {
  content: "雷";
}

.fa-universal-access:before {
  content: "\\f29a";
}

.fa-university:before {
  content: "\\f19c";
}

.fa-unlink:before {
  content: "\\f127";
}

.fa-unlock:before {
  content: "\\f09c";
}

.fa-unlock-alt:before {
  content: "\\f13e";
}

.fa-untappd:before {
  content: "\\f405";
}

.fa-upload:before {
  content: "\\f093";
}

.fa-ups:before {
  content: "\\f7e0";
}

.fa-usb:before {
  content: "\\f287";
}

.fa-user:before {
  content: "\\f007";
}

.fa-user-alt:before {
  content: "\\f406";
}

.fa-user-alt-slash:before {
  content: "\\f4fa";
}

.fa-user-astronaut:before {
  content: "\\f4fb";
}

.fa-user-check:before {
  content: "\\f4fc";
}

.fa-user-circle:before {
  content: "\\f2bd";
}

.fa-user-clock:before {
  content: "\\f4fd";
}

.fa-user-cog:before {
  content: "\\f4fe";
}

.fa-user-edit:before {
  content: "\\f4ff";
}

.fa-user-friends:before {
  content: "\\f500";
}

.fa-user-graduate:before {
  content: "\\f501";
}

.fa-user-injured:before {
  content: "\\f728";
}

.fa-user-lock:before {
  content: "\\f502";
}

.fa-user-md:before {
  content: "\\f0f0";
}

.fa-user-minus:before {
  content: "\\f503";
}

.fa-user-ninja:before {
  content: "\\f504";
}

.fa-user-nurse:before {
  content: "\\f82f";
}

.fa-user-plus:before {
  content: "\\f234";
}

.fa-user-secret:before {
  content: "\\f21b";
}

.fa-user-shield:before {
  content: "\\f505";
}

.fa-user-slash:before {
  content: "\\f506";
}

.fa-user-tag:before {
  content: "\\f507";
}

.fa-user-tie:before {
  content: "\\f508";
}

.fa-user-times:before {
  content: "\\f235";
}

.fa-users:before {
  content: "\\f0c0";
}

.fa-users-cog:before {
  content: "\\f509";
}

.fa-usps:before {
  content: "\\f7e1";
}

.fa-ussunnah:before {
  content: "\\f407";
}

.fa-utensil-spoon:before {
  content: "\\f2e5";
}

.fa-utensils:before {
  content: "\\f2e7";
}

.fa-vaadin:before {
  content: "\\f408";
}

.fa-vector-square:before {
  content: "\\f5cb";
}

.fa-venus:before {
  content: "\\f221";
}

.fa-venus-double:before {
  content: "\\f226";
}

.fa-venus-mars:before {
  content: "\\f228";
}

.fa-viacoin:before {
  content: "\\f237";
}

.fa-viadeo:before {
  content: "\\f2a9";
}

.fa-viadeo-square:before {
  content: "\\f2aa";
}

.fa-vial:before {
  content: "\\f492";
}

.fa-vials:before {
  content: "\\f493";
}

.fa-viber:before {
  content: "\\f409";
}

.fa-video:before {
  content: "\\f03d";
}

.fa-video-slash:before {
  content: "\\f4e2";
}

.fa-vihara:before {
  content: "\\f6a7";
}

.fa-vimeo:before {
  content: "\\f40a";
}

.fa-vimeo-square:before {
  content: "\\f194";
}

.fa-vimeo-v:before {
  content: "\\f27d";
}

.fa-vine:before {
  content: "\\f1ca";
}

.fa-virus:before {
  content: "若";
}

.fa-virus-slash:before {
  content: "掠";
}

.fa-viruses:before {
  content: "略";
}

.fa-vk:before {
  content: "\\f189";
}

.fa-vnv:before {
  content: "\\f40b";
}

.fa-voicemail:before {
  content: "\\f897";
}

.fa-volleyball-ball:before {
  content: "\\f45f";
}

.fa-volume-down:before {
  content: "\\f027";
}

.fa-volume-mute:before {
  content: "\\f6a9";
}

.fa-volume-off:before {
  content: "\\f026";
}

.fa-volume-up:before {
  content: "\\f028";
}

.fa-vote-yea:before {
  content: "\\f772";
}

.fa-vr-cardboard:before {
  content: "\\f729";
}

.fa-vuejs:before {
  content: "\\f41f";
}

.fa-walking:before {
  content: "\\f554";
}

.fa-wallet:before {
  content: "\\f555";
}

.fa-warehouse:before {
  content: "\\f494";
}

.fa-water:before {
  content: "\\f773";
}

.fa-wave-square:before {
  content: "\\f83e";
}

.fa-waze:before {
  content: "\\f83f";
}

.fa-weebly:before {
  content: "\\f5cc";
}

.fa-weibo:before {
  content: "\\f18a";
}

.fa-weight:before {
  content: "\\f496";
}

.fa-weight-hanging:before {
  content: "\\f5cd";
}

.fa-weixin:before {
  content: "\\f1d7";
}

.fa-whatsapp:before {
  content: "\\f232";
}

.fa-whatsapp-square:before {
  content: "\\f40c";
}

.fa-wheelchair:before {
  content: "\\f193";
}

.fa-whmcs:before {
  content: "\\f40d";
}

.fa-wifi:before {
  content: "\\f1eb";
}

.fa-wikipedia-w:before {
  content: "\\f266";
}

.fa-wind:before {
  content: "\\f72e";
}

.fa-window-close:before {
  content: "\\f410";
}

.fa-window-maximize:before {
  content: "\\f2d0";
}

.fa-window-minimize:before {
  content: "\\f2d1";
}

.fa-window-restore:before {
  content: "\\f2d2";
}

.fa-windows:before {
  content: "\\f17a";
}

.fa-wine-bottle:before {
  content: "\\f72f";
}

.fa-wine-glass:before {
  content: "\\f4e3";
}

.fa-wine-glass-alt:before {
  content: "\\f5ce";
}

.fa-wix:before {
  content: "\\f5cf";
}

.fa-wizards-of-the-coast:before {
  content: "\\f730";
}

.fa-wolf-pack-battalion:before {
  content: "\\f514";
}

.fa-won-sign:before {
  content: "\\f159";
}

.fa-wordpress:before {
  content: "\\f19a";
}

.fa-wordpress-simple:before {
  content: "\\f411";
}

.fa-wpbeginner:before {
  content: "\\f297";
}

.fa-wpexplorer:before {
  content: "\\f2de";
}

.fa-wpforms:before {
  content: "\\f298";
}

.fa-wpressr:before {
  content: "\\f3e4";
}

.fa-wrench:before {
  content: "\\f0ad";
}

.fa-x-ray:before {
  content: "\\f497";
}

.fa-xbox:before {
  content: "\\f412";
}

.fa-xing:before {
  content: "\\f168";
}

.fa-xing-square:before {
  content: "\\f169";
}

.fa-y-combinator:before {
  content: "\\f23b";
}

.fa-yahoo:before {
  content: "\\f19e";
}

.fa-yammer:before {
  content: "\\f840";
}

.fa-yandex:before {
  content: "\\f413";
}

.fa-yandex-international:before {
  content: "\\f414";
}

.fa-yarn:before {
  content: "\\f7e3";
}

.fa-yelp:before {
  content: "\\f1e9";
}

.fa-yen-sign:before {
  content: "\\f157";
}

.fa-yin-yang:before {
  content: "\\f6ad";
}

.fa-yoast:before {
  content: "\\f2b1";
}

.fa-youtube:before {
  content: "\\f167";
}

.fa-youtube-square:before {
  content: "\\f431";
}

.fa-zhihu:before {
  content: "\\f63f";
}

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
}

@font-face {
  font-family: "Font Awesome 5 Brands";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("svg");
}
.fab {
  font-family: "Font Awesome 5 Brands";
  font-weight: 400;
}

@font-face {
  font-family: "Font Awesome 5 Free";
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("svg");
}
.far {
  font-family: "Font Awesome 5 Free";
  font-weight: 400;
}

@font-face {
  font-family: "Font Awesome 5 Free";
  font-style: normal;
  font-weight: 900;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("svg");
}
.fa,
.fas {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}

@font-face {
  font-family: "dripicons-v2";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
[data-icon]:before {
  font-family: "dripicons-v2" !important;
  content: attr(data-icon);
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

[class^=dripicons-]:before,
[class*=" dripicons-"]:before {
  font-family: "dripicons-v2" !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.dripicons-alarm:before {
  content: "a";
}

.dripicons-align-center:before {
  content: "b";
}

.dripicons-align-justify:before {
  content: "c";
}

.dripicons-align-left:before {
  content: "d";
}

.dripicons-align-right:before {
  content: "e";
}

.dripicons-anchor:before {
  content: "f";
}

.dripicons-archive:before {
  content: "g";
}

.dripicons-arrow-down:before {
  content: "h";
}

.dripicons-arrow-left:before {
  content: "i";
}

.dripicons-arrow-right:before {
  content: "j";
}

.dripicons-arrow-thin-down:before {
  content: "k";
}

.dripicons-arrow-thin-left:before {
  content: "l";
}

.dripicons-arrow-thin-right:before {
  content: "m";
}

.dripicons-arrow-thin-up:before {
  content: "n";
}

.dripicons-arrow-up:before {
  content: "o";
}

.dripicons-article:before {
  content: "p";
}

.dripicons-backspace:before {
  content: "q";
}

.dripicons-basket:before {
  content: "r";
}

.dripicons-basketball:before {
  content: "s";
}

.dripicons-battery-empty:before {
  content: "t";
}

.dripicons-battery-full:before {
  content: "u";
}

.dripicons-battery-low:before {
  content: "v";
}

.dripicons-battery-medium:before {
  content: "w";
}

.dripicons-bell:before {
  content: "x";
}

.dripicons-blog:before {
  content: "y";
}

.dripicons-bluetooth:before {
  content: "z";
}

.dripicons-bold:before {
  content: "A";
}

.dripicons-bookmark:before {
  content: "B";
}

.dripicons-bookmarks:before {
  content: "C";
}

.dripicons-box:before {
  content: "D";
}

.dripicons-briefcase:before {
  content: "E";
}

.dripicons-brightness-low:before {
  content: "F";
}

.dripicons-brightness-max:before {
  content: "G";
}

.dripicons-brightness-medium:before {
  content: "H";
}

.dripicons-broadcast:before {
  content: "I";
}

.dripicons-browser:before {
  content: "J";
}

.dripicons-browser-upload:before {
  content: "K";
}

.dripicons-brush:before {
  content: "L";
}

.dripicons-calendar:before {
  content: "M";
}

.dripicons-camcorder:before {
  content: "N";
}

.dripicons-camera:before {
  content: "O";
}

.dripicons-card:before {
  content: "P";
}

.dripicons-cart:before {
  content: "Q";
}

.dripicons-checklist:before {
  content: "R";
}

.dripicons-checkmark:before {
  content: "S";
}

.dripicons-chevron-down:before {
  content: "T";
}

.dripicons-chevron-left:before {
  content: "U";
}

.dripicons-chevron-right:before {
  content: "V";
}

.dripicons-chevron-up:before {
  content: "W";
}

.dripicons-clipboard:before {
  content: "X";
}

.dripicons-clock:before {
  content: "Y";
}

.dripicons-clockwise:before {
  content: "Z";
}

.dripicons-cloud:before {
  content: "0";
}

.dripicons-cloud-download:before {
  content: "1";
}

.dripicons-cloud-upload:before {
  content: "2";
}

.dripicons-code:before {
  content: "3";
}

.dripicons-contract:before {
  content: "4";
}

.dripicons-contract-2:before {
  content: "5";
}

.dripicons-conversation:before {
  content: "6";
}

.dripicons-copy:before {
  content: "7";
}

.dripicons-crop:before {
  content: "8";
}

.dripicons-cross:before {
  content: "9";
}

.dripicons-crosshair:before {
  content: "!";
}

.dripicons-cutlery:before {
  content: '"';
}

.dripicons-device-desktop:before {
  content: "#";
}

.dripicons-device-mobile:before {
  content: "\$";
}

.dripicons-device-tablet:before {
  content: "%";
}

.dripicons-direction:before {
  content: "&";
}

.dripicons-disc:before {
  content: "'";
}

.dripicons-document:before {
  content: "(";
}

.dripicons-document-delete:before {
  content: ")";
}

.dripicons-document-edit:before {
  content: "*";
}

.dripicons-document-new:before {
  content: "+";
}

.dripicons-document-remove:before {
  content: ",";
}

.dripicons-dot:before {
  content: "-";
}

.dripicons-dots-2:before {
  content: ".";
}

.dripicons-dots-3:before {
  content: "/";
}

.dripicons-download:before {
  content: ":";
}

.dripicons-duplicate:before {
  content: ";";
}

.dripicons-enter:before {
  content: "<";
}

.dripicons-exit:before {
  content: "=";
}

.dripicons-expand:before {
  content: ">";
}

.dripicons-expand-2:before {
  content: "?";
}

.dripicons-experiment:before {
  content: "@";
}

.dripicons-export:before {
  content: "[";
}

.dripicons-feed:before {
  content: "]";
}

.dripicons-flag:before {
  content: "^";
}

.dripicons-flashlight:before {
  content: "_";
}

.dripicons-folder:before {
  content: "\`";
}

.dripicons-folder-open:before {
  content: "{";
}

.dripicons-forward:before {
  content: "|";
}

.dripicons-gaming:before {
  content: "}";
}

.dripicons-gear:before {
  content: "~";
}

.dripicons-graduation:before {
  content: "\\\\";
}

.dripicons-graph-bar:before {
  content: "\\e000";
}

.dripicons-graph-line:before {
  content: "\\e001";
}

.dripicons-graph-pie:before {
  content: "\\e002";
}

.dripicons-headset:before {
  content: "\\e003";
}

.dripicons-heart:before {
  content: "\\e004";
}

.dripicons-help:before {
  content: "\\e005";
}

.dripicons-home:before {
  content: "\\e006";
}

.dripicons-hourglass:before {
  content: "\\e007";
}

.dripicons-inbox:before {
  content: "\\e008";
}

.dripicons-information:before {
  content: "\\e009";
}

.dripicons-italic:before {
  content: "\\e00a";
}

.dripicons-jewel:before {
  content: "\\e00b";
}

.dripicons-lifting:before {
  content: "\\e00c";
}

.dripicons-lightbulb:before {
  content: "\\e00d";
}

.dripicons-link:before {
  content: "\\e00e";
}

.dripicons-link-broken:before {
  content: "\\e00f";
}

.dripicons-list:before {
  content: "\\e010";
}

.dripicons-loading:before {
  content: "\\e011";
}

.dripicons-location:before {
  content: "\\e012";
}

.dripicons-lock:before {
  content: "\\e013";
}

.dripicons-lock-open:before {
  content: "\\e014";
}

.dripicons-mail:before {
  content: "\\e015";
}

.dripicons-map:before {
  content: "\\e016";
}

.dripicons-media-loop:before {
  content: "\\e017";
}

.dripicons-media-next:before {
  content: "\\e018";
}

.dripicons-media-pause:before {
  content: "\\e019";
}

.dripicons-media-play:before {
  content: "\\e01a";
}

.dripicons-media-previous:before {
  content: "\\e01b";
}

.dripicons-media-record:before {
  content: "\\e01c";
}

.dripicons-media-shuffle:before {
  content: "\\e01d";
}

.dripicons-media-stop:before {
  content: "\\e01e";
}

.dripicons-medical:before {
  content: "\\e01f";
}

.dripicons-menu:before {
  content: "\\e020";
}

.dripicons-message:before {
  content: "\\e021";
}

.dripicons-meter:before {
  content: "\\e022";
}

.dripicons-microphone:before {
  content: "\\e023";
}

.dripicons-minus:before {
  content: "\\e024";
}

.dripicons-monitor:before {
  content: "\\e025";
}

.dripicons-move:before {
  content: "\\e026";
}

.dripicons-music:before {
  content: "\\e027";
}

.dripicons-network-1:before {
  content: "\\e028";
}

.dripicons-network-2:before {
  content: "\\e029";
}

.dripicons-network-3:before {
  content: "\\e02a";
}

.dripicons-network-4:before {
  content: "\\e02b";
}

.dripicons-network-5:before {
  content: "\\e02c";
}

.dripicons-pamphlet:before {
  content: "\\e02d";
}

.dripicons-paperclip:before {
  content: "\\e02e";
}

.dripicons-pencil:before {
  content: "\\e02f";
}

.dripicons-phone:before {
  content: "\\e030";
}

.dripicons-photo:before {
  content: "\\e031";
}

.dripicons-photo-group:before {
  content: "\\e032";
}

.dripicons-pill:before {
  content: "\\e033";
}

.dripicons-pin:before {
  content: "\\e034";
}

.dripicons-plus:before {
  content: "\\e035";
}

.dripicons-power:before {
  content: "\\e036";
}

.dripicons-preview:before {
  content: "\\e037";
}

.dripicons-print:before {
  content: "\\e038";
}

.dripicons-pulse:before {
  content: "\\e039";
}

.dripicons-question:before {
  content: "\\e03a";
}

.dripicons-reply:before {
  content: "\\e03b";
}

.dripicons-reply-all:before {
  content: "\\e03c";
}

.dripicons-return:before {
  content: "\\e03d";
}

.dripicons-retweet:before {
  content: "\\e03e";
}

.dripicons-rocket:before {
  content: "\\e03f";
}

.dripicons-scale:before {
  content: "\\e040";
}

.dripicons-search:before {
  content: "\\e041";
}

.dripicons-shopping-bag:before {
  content: "\\e042";
}

.dripicons-skip:before {
  content: "\\e043";
}

.dripicons-stack:before {
  content: "\\e044";
}

.dripicons-star:before {
  content: "\\e045";
}

.dripicons-stopwatch:before {
  content: "\\e046";
}

.dripicons-store:before {
  content: "\\e047";
}

.dripicons-suitcase:before {
  content: "\\e048";
}

.dripicons-swap:before {
  content: "\\e049";
}

.dripicons-tag:before {
  content: "\\e04a";
}

.dripicons-tag-delete:before {
  content: "\\e04b";
}

.dripicons-tags:before {
  content: "\\e04c";
}

.dripicons-thumbs-down:before {
  content: "\\e04d";
}

.dripicons-thumbs-up:before {
  content: "\\e04e";
}

.dripicons-ticket:before {
  content: "\\e04f";
}

.dripicons-time-reverse:before {
  content: "\\e050";
}

.dripicons-to-do:before {
  content: "\\e051";
}

.dripicons-toggles:before {
  content: "\\e052";
}

.dripicons-trash:before {
  content: "\\e053";
}

.dripicons-trophy:before {
  content: "\\e054";
}

.dripicons-upload:before {
  content: "\\e055";
}

.dripicons-user:before {
  content: "\\e056";
}

.dripicons-user-group:before {
  content: "\\e057";
}

.dripicons-user-id:before {
  content: "\\e058";
}

.dripicons-vibrate:before {
  content: "\\e059";
}

.dripicons-view-apps:before {
  content: "\\e05a";
}

.dripicons-view-list:before {
  content: "\\e05b";
}

.dripicons-view-list-large:before {
  content: "\\e05c";
}

.dripicons-view-thumb:before {
  content: "\\e05d";
}

.dripicons-volume-full:before {
  content: "\\e05e";
}

.dripicons-volume-low:before {
  content: "\\e05f";
}

.dripicons-volume-medium:before {
  content: "\\e060";
}

.dripicons-volume-off:before {
  content: "\\e061";
}

.dripicons-wallet:before {
  content: "\\e062";
}

.dripicons-warning:before {
  content: "\\e063";
}

.dripicons-web:before {
  content: "\\e064";
}

.dripicons-weight:before {
  content: "\\e065";
}

.dripicons-wifi:before {
  content: "\\e066";
}

.dripicons-wrong:before {
  content: "\\e067";
}

.dripicons-zoom-in:before {
  content: "\\e068";
}

.dripicons-zoom-out:before {
  content: "\\e069";
}

/*
* Remix Icon v2.4.0
* https://remixicon.com
* https://github.com/Remix-Design/RemixIcon
*
* Copyright RemixIcon.com
* Released under the Apache License Version 2.0
*
* Date: 2020-04-20
*/
@font-face {
  font-family: "remixicon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___}); /* IE9*/
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("svg"); /* iOS 4.1- */
  font-display: swap;
}
[class^=ri-], [class*=" ri-"] {
  font-family: "remixicon" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ri-lg {
  font-size: 1.3333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.ri-xl {
  font-size: 1.5em;
  line-height: 0.6666em;
  vertical-align: -0.075em;
}

.ri-xxs {
  font-size: 0.5em;
}

.ri-xs {
  font-size: 0.75em;
}

.ri-sm {
  font-size: 0.875em;
}

.ri-1x {
  font-size: 1em;
}

.ri-2x {
  font-size: 2em;
}

.ri-3x {
  font-size: 3em;
}

.ri-4x {
  font-size: 4em;
}

.ri-5x {
  font-size: 5em;
}

.ri-6x {
  font-size: 6em;
}

.ri-7x {
  font-size: 7em;
}

.ri-8x {
  font-size: 8em;
}

.ri-9x {
  font-size: 9em;
}

.ri-10x {
  font-size: 10em;
}

.ri-fw {
  text-align: center;
  width: 1.25em;
}

.ri-4k-fill:before {
  content: "\\ea01";
}

.ri-4k-line:before {
  content: "\\ea02";
}

.ri-a-b:before {
  content: "\\ea03";
}

.ri-account-box-fill:before {
  content: "\\ea04";
}

.ri-account-box-line:before {
  content: "\\ea05";
}

.ri-account-circle-fill:before {
  content: "\\ea06";
}

.ri-account-circle-line:before {
  content: "\\ea07";
}

.ri-account-pin-box-fill:before {
  content: "\\ea08";
}

.ri-account-pin-box-line:before {
  content: "\\ea09";
}

.ri-account-pin-circle-fill:before {
  content: "\\ea0a";
}

.ri-account-pin-circle-line:before {
  content: "\\ea0b";
}

.ri-add-box-fill:before {
  content: "\\ea0c";
}

.ri-add-box-line:before {
  content: "\\ea0d";
}

.ri-add-circle-fill:before {
  content: "\\ea0e";
}

.ri-add-circle-line:before {
  content: "\\ea0f";
}

.ri-add-fill:before {
  content: "\\ea10";
}

.ri-add-line:before {
  content: "\\ea11";
}

.ri-admin-fill:before {
  content: "\\ea12";
}

.ri-admin-line:before {
  content: "\\ea13";
}

.ri-advertisement-fill:before {
  content: "\\ea14";
}

.ri-advertisement-line:before {
  content: "\\ea15";
}

.ri-airplay-fill:before {
  content: "\\ea16";
}

.ri-airplay-line:before {
  content: "\\ea17";
}

.ri-alarm-fill:before {
  content: "\\ea18";
}

.ri-alarm-line:before {
  content: "\\ea19";
}

.ri-alarm-warning-fill:before {
  content: "\\ea1a";
}

.ri-alarm-warning-line:before {
  content: "\\ea1b";
}

.ri-album-fill:before {
  content: "\\ea1c";
}

.ri-album-line:before {
  content: "\\ea1d";
}

.ri-alert-fill:before {
  content: "\\ea1e";
}

.ri-alert-line:before {
  content: "\\ea1f";
}

.ri-aliens-fill:before {
  content: "\\ea20";
}

.ri-aliens-line:before {
  content: "\\ea21";
}

.ri-align-bottom:before {
  content: "\\ea22";
}

.ri-align-center:before {
  content: "\\ea23";
}

.ri-align-justify:before {
  content: "\\ea24";
}

.ri-align-left:before {
  content: "\\ea25";
}

.ri-align-right:before {
  content: "\\ea26";
}

.ri-align-top:before {
  content: "\\ea27";
}

.ri-align-vertically:before {
  content: "\\ea28";
}

.ri-alipay-fill:before {
  content: "\\ea29";
}

.ri-alipay-line:before {
  content: "\\ea2a";
}

.ri-amazon-fill:before {
  content: "\\ea2b";
}

.ri-amazon-line:before {
  content: "\\ea2c";
}

.ri-anchor-fill:before {
  content: "\\ea2d";
}

.ri-anchor-line:before {
  content: "\\ea2e";
}

.ri-ancient-gate-fill:before {
  content: "\\ea2f";
}

.ri-ancient-gate-line:before {
  content: "\\ea30";
}

.ri-ancient-pavilion-fill:before {
  content: "\\ea31";
}

.ri-ancient-pavilion-line:before {
  content: "\\ea32";
}

.ri-android-fill:before {
  content: "\\ea33";
}

.ri-android-line:before {
  content: "\\ea34";
}

.ri-angularjs-fill:before {
  content: "\\ea35";
}

.ri-angularjs-line:before {
  content: "\\ea36";
}

.ri-anticlockwise-2-fill:before {
  content: "\\ea37";
}

.ri-anticlockwise-2-line:before {
  content: "\\ea38";
}

.ri-anticlockwise-fill:before {
  content: "\\ea39";
}

.ri-anticlockwise-line:before {
  content: "\\ea3a";
}

.ri-app-store-fill:before {
  content: "\\ea3b";
}

.ri-app-store-line:before {
  content: "\\ea3c";
}

.ri-apple-fill:before {
  content: "\\ea3d";
}

.ri-apple-line:before {
  content: "\\ea3e";
}

.ri-apps-2-fill:before {
  content: "\\ea3f";
}

.ri-apps-2-line:before {
  content: "\\ea40";
}

.ri-apps-fill:before {
  content: "\\ea41";
}

.ri-apps-line:before {
  content: "\\ea42";
}

.ri-archive-drawer-fill:before {
  content: "\\ea43";
}

.ri-archive-drawer-line:before {
  content: "\\ea44";
}

.ri-archive-fill:before {
  content: "\\ea45";
}

.ri-archive-line:before {
  content: "\\ea46";
}

.ri-arrow-down-circle-fill:before {
  content: "\\ea47";
}

.ri-arrow-down-circle-line:before {
  content: "\\ea48";
}

.ri-arrow-down-fill:before {
  content: "\\ea49";
}

.ri-arrow-down-line:before {
  content: "\\ea4a";
}

.ri-arrow-down-s-fill:before {
  content: "\\ea4b";
}

.ri-arrow-down-s-line:before {
  content: "\\ea4c";
}

.ri-arrow-drop-down-fill:before {
  content: "\\ea4d";
}

.ri-arrow-drop-down-line:before {
  content: "\\ea4e";
}

.ri-arrow-drop-left-fill:before {
  content: "\\ea4f";
}

.ri-arrow-drop-left-line:before {
  content: "\\ea50";
}

.ri-arrow-drop-right-fill:before {
  content: "\\ea51";
}

.ri-arrow-drop-right-line:before {
  content: "\\ea52";
}

.ri-arrow-drop-up-fill:before {
  content: "\\ea53";
}

.ri-arrow-drop-up-line:before {
  content: "\\ea54";
}

.ri-arrow-go-back-fill:before {
  content: "\\ea55";
}

.ri-arrow-go-back-line:before {
  content: "\\ea56";
}

.ri-arrow-go-forward-fill:before {
  content: "\\ea57";
}

.ri-arrow-go-forward-line:before {
  content: "\\ea58";
}

.ri-arrow-left-circle-fill:before {
  content: "\\ea59";
}

.ri-arrow-left-circle-line:before {
  content: "\\ea5a";
}

.ri-arrow-left-down-fill:before {
  content: "\\ea5b";
}

.ri-arrow-left-down-line:before {
  content: "\\ea5c";
}

.ri-arrow-left-fill:before {
  content: "\\ea5d";
}

.ri-arrow-left-line:before {
  content: "\\ea5e";
}

.ri-arrow-left-right-fill:before {
  content: "\\ea5f";
}

.ri-arrow-left-right-line:before {
  content: "\\ea60";
}

.ri-arrow-left-s-fill:before {
  content: "\\ea61";
}

.ri-arrow-left-s-line:before {
  content: "\\ea62";
}

.ri-arrow-left-up-fill:before {
  content: "\\ea63";
}

.ri-arrow-left-up-line:before {
  content: "\\ea64";
}

.ri-arrow-right-circle-fill:before {
  content: "\\ea65";
}

.ri-arrow-right-circle-line:before {
  content: "\\ea66";
}

.ri-arrow-right-down-fill:before {
  content: "\\ea67";
}

.ri-arrow-right-down-line:before {
  content: "\\ea68";
}

.ri-arrow-right-fill:before {
  content: "\\ea69";
}

.ri-arrow-right-line:before {
  content: "\\ea6a";
}

.ri-arrow-right-s-fill:before {
  content: "\\ea6b";
}

.ri-arrow-right-s-line:before {
  content: "\\ea6c";
}

.ri-arrow-right-up-fill:before {
  content: "\\ea6d";
}

.ri-arrow-right-up-line:before {
  content: "\\ea6e";
}

.ri-arrow-up-circle-fill:before {
  content: "\\ea6f";
}

.ri-arrow-up-circle-line:before {
  content: "\\ea70";
}

.ri-arrow-up-down-fill:before {
  content: "\\ea71";
}

.ri-arrow-up-down-line:before {
  content: "\\ea72";
}

.ri-arrow-up-fill:before {
  content: "\\ea73";
}

.ri-arrow-up-line:before {
  content: "\\ea74";
}

.ri-arrow-up-s-fill:before {
  content: "\\ea75";
}

.ri-arrow-up-s-line:before {
  content: "\\ea76";
}

.ri-artboard-2-fill:before {
  content: "\\ea77";
}

.ri-artboard-2-line:before {
  content: "\\ea78";
}

.ri-artboard-fill:before {
  content: "\\ea79";
}

.ri-artboard-line:before {
  content: "\\ea7a";
}

.ri-article-fill:before {
  content: "\\ea7b";
}

.ri-article-line:before {
  content: "\\ea7c";
}

.ri-aspect-ratio-fill:before {
  content: "\\ea7d";
}

.ri-aspect-ratio-line:before {
  content: "\\ea7e";
}

.ri-asterisk:before {
  content: "\\ea7f";
}

.ri-at-fill:before {
  content: "\\ea80";
}

.ri-at-line:before {
  content: "\\ea81";
}

.ri-attachment-2:before {
  content: "\\ea82";
}

.ri-attachment-fill:before {
  content: "\\ea83";
}

.ri-attachment-line:before {
  content: "\\ea84";
}

.ri-auction-fill:before {
  content: "\\ea85";
}

.ri-auction-line:before {
  content: "\\ea86";
}

.ri-award-fill:before {
  content: "\\ea87";
}

.ri-award-line:before {
  content: "\\ea88";
}

.ri-baidu-fill:before {
  content: "\\ea89";
}

.ri-baidu-line:before {
  content: "\\ea8a";
}

.ri-ball-pen-fill:before {
  content: "\\ea8b";
}

.ri-ball-pen-line:before {
  content: "\\ea8c";
}

.ri-bank-card-2-fill:before {
  content: "\\ea8d";
}

.ri-bank-card-2-line:before {
  content: "\\ea8e";
}

.ri-bank-card-fill:before {
  content: "\\ea8f";
}

.ri-bank-card-line:before {
  content: "\\ea90";
}

.ri-bank-fill:before {
  content: "\\ea91";
}

.ri-bank-line:before {
  content: "\\ea92";
}

.ri-bar-chart-2-fill:before {
  content: "\\ea93";
}

.ri-bar-chart-2-line:before {
  content: "\\ea94";
}

.ri-bar-chart-box-fill:before {
  content: "\\ea95";
}

.ri-bar-chart-box-line:before {
  content: "\\ea96";
}

.ri-bar-chart-fill:before {
  content: "\\ea97";
}

.ri-bar-chart-grouped-fill:before {
  content: "\\ea98";
}

.ri-bar-chart-grouped-line:before {
  content: "\\ea99";
}

.ri-bar-chart-horizontal-fill:before {
  content: "\\ea9a";
}

.ri-bar-chart-horizontal-line:before {
  content: "\\ea9b";
}

.ri-bar-chart-line:before {
  content: "\\ea9c";
}

.ri-barcode-box-fill:before {
  content: "\\ea9d";
}

.ri-barcode-box-line:before {
  content: "\\ea9e";
}

.ri-barcode-fill:before {
  content: "\\ea9f";
}

.ri-barcode-line:before {
  content: "\\eaa0";
}

.ri-barricade-fill:before {
  content: "\\eaa1";
}

.ri-barricade-line:before {
  content: "\\eaa2";
}

.ri-base-station-fill:before {
  content: "\\eaa3";
}

.ri-base-station-line:before {
  content: "\\eaa4";
}

.ri-basketball-fill:before {
  content: "\\eaa5";
}

.ri-basketball-line:before {
  content: "\\eaa6";
}

.ri-battery-2-charge-fill:before {
  content: "\\eaa7";
}

.ri-battery-2-charge-line:before {
  content: "\\eaa8";
}

.ri-battery-2-fill:before {
  content: "\\eaa9";
}

.ri-battery-2-line:before {
  content: "\\eaaa";
}

.ri-battery-charge-fill:before {
  content: "\\eaab";
}

.ri-battery-charge-line:before {
  content: "\\eaac";
}

.ri-battery-fill:before {
  content: "\\eaad";
}

.ri-battery-line:before {
  content: "\\eaae";
}

.ri-battery-low-fill:before {
  content: "\\eaaf";
}

.ri-battery-low-line:before {
  content: "\\eab0";
}

.ri-battery-saver-fill:before {
  content: "\\eab1";
}

.ri-battery-saver-line:before {
  content: "\\eab2";
}

.ri-battery-share-fill:before {
  content: "\\eab3";
}

.ri-battery-share-line:before {
  content: "\\eab4";
}

.ri-bear-smile-fill:before {
  content: "\\eab5";
}

.ri-bear-smile-line:before {
  content: "\\eab6";
}

.ri-behance-fill:before {
  content: "\\eab7";
}

.ri-behance-line:before {
  content: "\\eab8";
}

.ri-bell-fill:before {
  content: "\\eab9";
}

.ri-bell-line:before {
  content: "\\eaba";
}

.ri-bike-fill:before {
  content: "\\eabb";
}

.ri-bike-line:before {
  content: "\\eabc";
}

.ri-bilibili-fill:before {
  content: "\\eabd";
}

.ri-bilibili-line:before {
  content: "\\eabe";
}

.ri-bill-fill:before {
  content: "\\eabf";
}

.ri-bill-line:before {
  content: "\\eac0";
}

.ri-billiards-fill:before {
  content: "\\eac1";
}

.ri-billiards-line:before {
  content: "\\eac2";
}

.ri-bit-coin-fill:before {
  content: "\\eac3";
}

.ri-bit-coin-line:before {
  content: "\\eac4";
}

.ri-blaze-fill:before {
  content: "\\eac5";
}

.ri-blaze-line:before {
  content: "\\eac6";
}

.ri-bluetooth-connect-fill:before {
  content: "\\eac7";
}

.ri-bluetooth-connect-line:before {
  content: "\\eac8";
}

.ri-bluetooth-fill:before {
  content: "\\eac9";
}

.ri-bluetooth-line:before {
  content: "\\eaca";
}

.ri-blur-off-fill:before {
  content: "\\eacb";
}

.ri-blur-off-line:before {
  content: "\\eacc";
}

.ri-body-scan-fill:before {
  content: "\\eacd";
}

.ri-body-scan-line:before {
  content: "\\eace";
}

.ri-bold:before {
  content: "\\eacf";
}

.ri-book-2-fill:before {
  content: "\\ead0";
}

.ri-book-2-line:before {
  content: "\\ead1";
}

.ri-book-3-fill:before {
  content: "\\ead2";
}

.ri-book-3-line:before {
  content: "\\ead3";
}

.ri-book-fill:before {
  content: "\\ead4";
}

.ri-book-line:before {
  content: "\\ead5";
}

.ri-book-mark-fill:before {
  content: "\\ead6";
}

.ri-book-mark-line:before {
  content: "\\ead7";
}

.ri-book-open-fill:before {
  content: "\\ead8";
}

.ri-book-open-line:before {
  content: "\\ead9";
}

.ri-book-read-fill:before {
  content: "\\eada";
}

.ri-book-read-line:before {
  content: "\\eadb";
}

.ri-booklet-fill:before {
  content: "\\eadc";
}

.ri-booklet-line:before {
  content: "\\eadd";
}

.ri-bookmark-2-fill:before {
  content: "\\eade";
}

.ri-bookmark-2-line:before {
  content: "\\eadf";
}

.ri-bookmark-3-fill:before {
  content: "\\eae0";
}

.ri-bookmark-3-line:before {
  content: "\\eae1";
}

.ri-bookmark-fill:before {
  content: "\\eae2";
}

.ri-bookmark-line:before {
  content: "\\eae3";
}

.ri-boxing-fill:before {
  content: "\\eae4";
}

.ri-boxing-line:before {
  content: "\\eae5";
}

.ri-braces-fill:before {
  content: "\\eae6";
}

.ri-braces-line:before {
  content: "\\eae7";
}

.ri-brackets-fill:before {
  content: "\\eae8";
}

.ri-brackets-line:before {
  content: "\\eae9";
}

.ri-briefcase-2-fill:before {
  content: "\\eaea";
}

.ri-briefcase-2-line:before {
  content: "\\eaeb";
}

.ri-briefcase-3-fill:before {
  content: "\\eaec";
}

.ri-briefcase-3-line:before {
  content: "\\eaed";
}

.ri-briefcase-4-fill:before {
  content: "\\eaee";
}

.ri-briefcase-4-line:before {
  content: "\\eaef";
}

.ri-briefcase-5-fill:before {
  content: "\\eaf0";
}

.ri-briefcase-5-line:before {
  content: "\\eaf1";
}

.ri-briefcase-fill:before {
  content: "\\eaf2";
}

.ri-briefcase-line:before {
  content: "\\eaf3";
}

.ri-bring-forward:before {
  content: "\\eaf4";
}

.ri-bring-to-front:before {
  content: "\\eaf5";
}

.ri-broadcast-fill:before {
  content: "\\eaf6";
}

.ri-broadcast-line:before {
  content: "\\eaf7";
}

.ri-brush-2-fill:before {
  content: "\\eaf8";
}

.ri-brush-2-line:before {
  content: "\\eaf9";
}

.ri-brush-3-fill:before {
  content: "\\eafa";
}

.ri-brush-3-line:before {
  content: "\\eafb";
}

.ri-brush-4-fill:before {
  content: "\\eafc";
}

.ri-brush-4-line:before {
  content: "\\eafd";
}

.ri-brush-fill:before {
  content: "\\eafe";
}

.ri-brush-line:before {
  content: "\\eaff";
}

.ri-bubble-chart-fill:before {
  content: "\\eb00";
}

.ri-bubble-chart-line:before {
  content: "\\eb01";
}

.ri-bug-2-fill:before {
  content: "\\eb02";
}

.ri-bug-2-line:before {
  content: "\\eb03";
}

.ri-bug-fill:before {
  content: "\\eb04";
}

.ri-bug-line:before {
  content: "\\eb05";
}

.ri-building-2-fill:before {
  content: "\\eb06";
}

.ri-building-2-line:before {
  content: "\\eb07";
}

.ri-building-3-fill:before {
  content: "\\eb08";
}

.ri-building-3-line:before {
  content: "\\eb09";
}

.ri-building-4-fill:before {
  content: "\\eb0a";
}

.ri-building-4-line:before {
  content: "\\eb0b";
}

.ri-building-fill:before {
  content: "\\eb0c";
}

.ri-building-line:before {
  content: "\\eb0d";
}

.ri-bus-2-fill:before {
  content: "\\eb0e";
}

.ri-bus-2-line:before {
  content: "\\eb0f";
}

.ri-bus-fill:before {
  content: "\\eb10";
}

.ri-bus-line:before {
  content: "\\eb11";
}

.ri-bus-wifi-fill:before {
  content: "\\eb12";
}

.ri-bus-wifi-line:before {
  content: "\\eb13";
}

.ri-cake-2-fill:before {
  content: "\\eb14";
}

.ri-cake-2-line:before {
  content: "\\eb15";
}

.ri-cake-3-fill:before {
  content: "\\eb16";
}

.ri-cake-3-line:before {
  content: "\\eb17";
}

.ri-cake-fill:before {
  content: "\\eb18";
}

.ri-cake-line:before {
  content: "\\eb19";
}

.ri-calculator-fill:before {
  content: "\\eb1a";
}

.ri-calculator-line:before {
  content: "\\eb1b";
}

.ri-calendar-2-fill:before {
  content: "\\eb1c";
}

.ri-calendar-2-line:before {
  content: "\\eb1d";
}

.ri-calendar-check-fill:before {
  content: "\\eb1e";
}

.ri-calendar-check-line:before {
  content: "\\eb1f";
}

.ri-calendar-event-fill:before {
  content: "\\eb20";
}

.ri-calendar-event-line:before {
  content: "\\eb21";
}

.ri-calendar-fill:before {
  content: "\\eb22";
}

.ri-calendar-line:before {
  content: "\\eb23";
}

.ri-calendar-todo-fill:before {
  content: "\\eb24";
}

.ri-calendar-todo-line:before {
  content: "\\eb25";
}

.ri-camera-2-fill:before {
  content: "\\eb26";
}

.ri-camera-2-line:before {
  content: "\\eb27";
}

.ri-camera-3-fill:before {
  content: "\\eb28";
}

.ri-camera-3-line:before {
  content: "\\eb29";
}

.ri-camera-fill:before {
  content: "\\eb2a";
}

.ri-camera-lens-fill:before {
  content: "\\eb2b";
}

.ri-camera-lens-line:before {
  content: "\\eb2c";
}

.ri-camera-line:before {
  content: "\\eb2d";
}

.ri-camera-off-fill:before {
  content: "\\eb2e";
}

.ri-camera-off-line:before {
  content: "\\eb2f";
}

.ri-camera-switch-fill:before {
  content: "\\eb30";
}

.ri-camera-switch-line:before {
  content: "\\eb31";
}

.ri-car-fill:before {
  content: "\\eb32";
}

.ri-car-line:before {
  content: "\\eb33";
}

.ri-car-washing-fill:before {
  content: "\\eb34";
}

.ri-car-washing-line:before {
  content: "\\eb35";
}

.ri-caravan-fill:before {
  content: "\\eb36";
}

.ri-caravan-line:before {
  content: "\\eb37";
}

.ri-cast-fill:before {
  content: "\\eb38";
}

.ri-cast-line:before {
  content: "\\eb39";
}

.ri-cellphone-fill:before {
  content: "\\eb3a";
}

.ri-cellphone-line:before {
  content: "\\eb3b";
}

.ri-celsius-fill:before {
  content: "\\eb3c";
}

.ri-celsius-line:before {
  content: "\\eb3d";
}

.ri-centos-fill:before {
  content: "\\eb3e";
}

.ri-centos-line:before {
  content: "\\eb3f";
}

.ri-character-recognition-fill:before {
  content: "\\eb40";
}

.ri-character-recognition-line:before {
  content: "\\eb41";
}

.ri-charging-pile-2-fill:before {
  content: "\\eb42";
}

.ri-charging-pile-2-line:before {
  content: "\\eb43";
}

.ri-charging-pile-fill:before {
  content: "\\eb44";
}

.ri-charging-pile-line:before {
  content: "\\eb45";
}

.ri-chat-1-fill:before {
  content: "\\eb46";
}

.ri-chat-1-line:before {
  content: "\\eb47";
}

.ri-chat-2-fill:before {
  content: "\\eb48";
}

.ri-chat-2-line:before {
  content: "\\eb49";
}

.ri-chat-3-fill:before {
  content: "\\eb4a";
}

.ri-chat-3-line:before {
  content: "\\eb4b";
}

.ri-chat-4-fill:before {
  content: "\\eb4c";
}

.ri-chat-4-line:before {
  content: "\\eb4d";
}

.ri-chat-check-fill:before {
  content: "\\eb4e";
}

.ri-chat-check-line:before {
  content: "\\eb4f";
}

.ri-chat-delete-fill:before {
  content: "\\eb50";
}

.ri-chat-delete-line:before {
  content: "\\eb51";
}

.ri-chat-download-fill:before {
  content: "\\eb52";
}

.ri-chat-download-line:before {
  content: "\\eb53";
}

.ri-chat-follow-up-fill:before {
  content: "\\eb54";
}

.ri-chat-follow-up-line:before {
  content: "\\eb55";
}

.ri-chat-forward-fill:before {
  content: "\\eb56";
}

.ri-chat-forward-line:before {
  content: "\\eb57";
}

.ri-chat-heart-fill:before {
  content: "\\eb58";
}

.ri-chat-heart-line:before {
  content: "\\eb59";
}

.ri-chat-history-fill:before {
  content: "\\eb5a";
}

.ri-chat-history-line:before {
  content: "\\eb5b";
}

.ri-chat-new-fill:before {
  content: "\\eb5c";
}

.ri-chat-new-line:before {
  content: "\\eb5d";
}

.ri-chat-off-fill:before {
  content: "\\eb5e";
}

.ri-chat-off-line:before {
  content: "\\eb5f";
}

.ri-chat-poll-fill:before {
  content: "\\eb60";
}

.ri-chat-poll-line:before {
  content: "\\eb61";
}

.ri-chat-private-fill:before {
  content: "\\eb62";
}

.ri-chat-private-line:before {
  content: "\\eb63";
}

.ri-chat-quote-fill:before {
  content: "\\eb64";
}

.ri-chat-quote-line:before {
  content: "\\eb65";
}

.ri-chat-settings-fill:before {
  content: "\\eb66";
}

.ri-chat-settings-line:before {
  content: "\\eb67";
}

.ri-chat-smile-2-fill:before {
  content: "\\eb68";
}

.ri-chat-smile-2-line:before {
  content: "\\eb69";
}

.ri-chat-smile-3-fill:before {
  content: "\\eb6a";
}

.ri-chat-smile-3-line:before {
  content: "\\eb6b";
}

.ri-chat-smile-fill:before {
  content: "\\eb6c";
}

.ri-chat-smile-line:before {
  content: "\\eb6d";
}

.ri-chat-upload-fill:before {
  content: "\\eb6e";
}

.ri-chat-upload-line:before {
  content: "\\eb6f";
}

.ri-chat-voice-fill:before {
  content: "\\eb70";
}

.ri-chat-voice-line:before {
  content: "\\eb71";
}

.ri-check-double-fill:before {
  content: "\\eb72";
}

.ri-check-double-line:before {
  content: "\\eb73";
}

.ri-check-fill:before {
  content: "\\eb74";
}

.ri-check-line:before {
  content: "\\eb75";
}

.ri-checkbox-blank-circle-fill:before {
  content: "\\eb76";
}

.ri-checkbox-blank-circle-line:before {
  content: "\\eb77";
}

.ri-checkbox-blank-fill:before {
  content: "\\eb78";
}

.ri-checkbox-blank-line:before {
  content: "\\eb79";
}

.ri-checkbox-circle-fill:before {
  content: "\\eb7a";
}

.ri-checkbox-circle-line:before {
  content: "\\eb7b";
}

.ri-checkbox-fill:before {
  content: "\\eb7c";
}

.ri-checkbox-indeterminate-fill:before {
  content: "\\eb7d";
}

.ri-checkbox-indeterminate-line:before {
  content: "\\eb7e";
}

.ri-checkbox-line:before {
  content: "\\eb7f";
}

.ri-checkbox-multiple-blank-fill:before {
  content: "\\eb80";
}

.ri-checkbox-multiple-blank-line:before {
  content: "\\eb81";
}

.ri-checkbox-multiple-fill:before {
  content: "\\eb82";
}

.ri-checkbox-multiple-line:before {
  content: "\\eb83";
}

.ri-china-railway-fill:before {
  content: "\\eb84";
}

.ri-china-railway-line:before {
  content: "\\eb85";
}

.ri-chrome-fill:before {
  content: "\\eb86";
}

.ri-chrome-line:before {
  content: "\\eb87";
}

.ri-clapperboard-fill:before {
  content: "\\eb88";
}

.ri-clapperboard-line:before {
  content: "\\eb89";
}

.ri-clipboard-fill:before {
  content: "\\eb8a";
}

.ri-clipboard-line:before {
  content: "\\eb8b";
}

.ri-clockwise-2-fill:before {
  content: "\\eb8c";
}

.ri-clockwise-2-line:before {
  content: "\\eb8d";
}

.ri-clockwise-fill:before {
  content: "\\eb8e";
}

.ri-clockwise-line:before {
  content: "\\eb8f";
}

.ri-close-circle-fill:before {
  content: "\\eb90";
}

.ri-close-circle-line:before {
  content: "\\eb91";
}

.ri-close-fill:before {
  content: "\\eb92";
}

.ri-close-line:before {
  content: "\\eb93";
}

.ri-cloud-fill:before {
  content: "\\eb94";
}

.ri-cloud-line:before {
  content: "\\eb95";
}

.ri-cloud-off-fill:before {
  content: "\\eb96";
}

.ri-cloud-off-line:before {
  content: "\\eb97";
}

.ri-cloud-windy-fill:before {
  content: "\\eb98";
}

.ri-cloud-windy-line:before {
  content: "\\eb99";
}

.ri-cloudy-2-fill:before {
  content: "\\eb9a";
}

.ri-cloudy-2-line:before {
  content: "\\eb9b";
}

.ri-cloudy-fill:before {
  content: "\\eb9c";
}

.ri-cloudy-line:before {
  content: "\\eb9d";
}

.ri-code-box-fill:before {
  content: "\\eb9e";
}

.ri-code-box-line:before {
  content: "\\eb9f";
}

.ri-code-fill:before {
  content: "\\eba0";
}

.ri-code-line:before {
  content: "\\eba1";
}

.ri-code-s-fill:before {
  content: "\\eba2";
}

.ri-code-s-line:before {
  content: "\\eba3";
}

.ri-code-s-slash-fill:before {
  content: "\\eba4";
}

.ri-code-s-slash-line:before {
  content: "\\eba5";
}

.ri-code-view:before {
  content: "\\eba6";
}

.ri-codepen-fill:before {
  content: "\\eba7";
}

.ri-codepen-line:before {
  content: "\\eba8";
}

.ri-coin-fill:before {
  content: "\\eba9";
}

.ri-coin-line:before {
  content: "\\ebaa";
}

.ri-coins-fill:before {
  content: "\\ebab";
}

.ri-coins-line:before {
  content: "\\ebac";
}

.ri-command-fill:before {
  content: "\\ebad";
}

.ri-command-line:before {
  content: "\\ebae";
}

.ri-community-fill:before {
  content: "\\ebaf";
}

.ri-community-line:before {
  content: "\\ebb0";
}

.ri-compass-2-fill:before {
  content: "\\ebb1";
}

.ri-compass-2-line:before {
  content: "\\ebb2";
}

.ri-compass-3-fill:before {
  content: "\\ebb3";
}

.ri-compass-3-line:before {
  content: "\\ebb4";
}

.ri-compass-4-fill:before {
  content: "\\ebb5";
}

.ri-compass-4-line:before {
  content: "\\ebb6";
}

.ri-compass-discover-fill:before {
  content: "\\ebb7";
}

.ri-compass-discover-line:before {
  content: "\\ebb8";
}

.ri-compass-fill:before {
  content: "\\ebb9";
}

.ri-compass-line:before {
  content: "\\ebba";
}

.ri-compasses-2-fill:before {
  content: "\\ebbb";
}

.ri-compasses-2-line:before {
  content: "\\ebbc";
}

.ri-compasses-fill:before {
  content: "\\ebbd";
}

.ri-compasses-line:before {
  content: "\\ebbe";
}

.ri-computer-fill:before {
  content: "\\ebbf";
}

.ri-computer-line:before {
  content: "\\ebc0";
}

.ri-contacts-book-2-fill:before {
  content: "\\ebc1";
}

.ri-contacts-book-2-line:before {
  content: "\\ebc2";
}

.ri-contacts-book-fill:before {
  content: "\\ebc3";
}

.ri-contacts-book-line:before {
  content: "\\ebc4";
}

.ri-contacts-book-upload-fill:before {
  content: "\\ebc5";
}

.ri-contacts-book-upload-line:before {
  content: "\\ebc6";
}

.ri-contacts-fill:before {
  content: "\\ebc7";
}

.ri-contacts-line:before {
  content: "\\ebc8";
}

.ri-contrast-2-fill:before {
  content: "\\ebc9";
}

.ri-contrast-2-line:before {
  content: "\\ebca";
}

.ri-contrast-drop-2-fill:before {
  content: "\\ebcb";
}

.ri-contrast-drop-2-line:before {
  content: "\\ebcc";
}

.ri-contrast-drop-fill:before {
  content: "\\ebcd";
}

.ri-contrast-drop-line:before {
  content: "\\ebce";
}

.ri-contrast-fill:before {
  content: "\\ebcf";
}

.ri-contrast-line:before {
  content: "\\ebd0";
}

.ri-copper-coin-fill:before {
  content: "\\ebd1";
}

.ri-copper-coin-line:before {
  content: "\\ebd2";
}

.ri-copper-diamond-fill:before {
  content: "\\ebd3";
}

.ri-copper-diamond-line:before {
  content: "\\ebd4";
}

.ri-copyright-fill:before {
  content: "\\ebd5";
}

.ri-copyright-line:before {
  content: "\\ebd6";
}

.ri-coreos-fill:before {
  content: "\\ebd7";
}

.ri-coreos-line:before {
  content: "\\ebd8";
}

.ri-coupon-2-fill:before {
  content: "\\ebd9";
}

.ri-coupon-2-line:before {
  content: "\\ebda";
}

.ri-coupon-3-fill:before {
  content: "\\ebdb";
}

.ri-coupon-3-line:before {
  content: "\\ebdc";
}

.ri-coupon-4-fill:before {
  content: "\\ebdd";
}

.ri-coupon-4-line:before {
  content: "\\ebde";
}

.ri-coupon-5-fill:before {
  content: "\\ebdf";
}

.ri-coupon-5-line:before {
  content: "\\ebe0";
}

.ri-coupon-fill:before {
  content: "\\ebe1";
}

.ri-coupon-line:before {
  content: "\\ebe2";
}

.ri-cpu-fill:before {
  content: "\\ebe3";
}

.ri-cpu-line:before {
  content: "\\ebe4";
}

.ri-creative-commons-by-fill:before {
  content: "\\ebe5";
}

.ri-creative-commons-by-line:before {
  content: "\\ebe6";
}

.ri-creative-commons-fill:before {
  content: "\\ebe7";
}

.ri-creative-commons-line:before {
  content: "\\ebe8";
}

.ri-creative-commons-nc-fill:before {
  content: "\\ebe9";
}

.ri-creative-commons-nc-line:before {
  content: "\\ebea";
}

.ri-creative-commons-nd-fill:before {
  content: "\\ebeb";
}

.ri-creative-commons-nd-line:before {
  content: "\\ebec";
}

.ri-creative-commons-sa-fill:before {
  content: "\\ebed";
}

.ri-creative-commons-sa-line:before {
  content: "\\ebee";
}

.ri-creative-commons-zero-fill:before {
  content: "\\ebef";
}

.ri-creative-commons-zero-line:before {
  content: "\\ebf0";
}

.ri-criminal-fill:before {
  content: "\\ebf1";
}

.ri-criminal-line:before {
  content: "\\ebf2";
}

.ri-crop-2-fill:before {
  content: "\\ebf3";
}

.ri-crop-2-line:before {
  content: "\\ebf4";
}

.ri-crop-fill:before {
  content: "\\ebf5";
}

.ri-crop-line:before {
  content: "\\ebf6";
}

.ri-css3-fill:before {
  content: "\\ebf7";
}

.ri-css3-line:before {
  content: "\\ebf8";
}

.ri-cup-fill:before {
  content: "\\ebf9";
}

.ri-cup-line:before {
  content: "\\ebfa";
}

.ri-currency-fill:before {
  content: "\\ebfb";
}

.ri-currency-line:before {
  content: "\\ebfc";
}

.ri-cursor-fill:before {
  content: "\\ebfd";
}

.ri-cursor-line:before {
  content: "\\ebfe";
}

.ri-customer-service-2-fill:before {
  content: "\\ebff";
}

.ri-customer-service-2-line:before {
  content: "\\ec00";
}

.ri-customer-service-fill:before {
  content: "\\ec01";
}

.ri-customer-service-line:before {
  content: "\\ec02";
}

.ri-dashboard-fill:before {
  content: "\\ec03";
}

.ri-dashboard-line:before {
  content: "\\ec04";
}

.ri-database-2-fill:before {
  content: "\\ec05";
}

.ri-database-2-line:before {
  content: "\\ec06";
}

.ri-database-fill:before {
  content: "\\ec07";
}

.ri-database-line:before {
  content: "\\ec08";
}

.ri-delete-back-2-fill:before {
  content: "\\ec09";
}

.ri-delete-back-2-line:before {
  content: "\\ec0a";
}

.ri-delete-back-fill:before {
  content: "\\ec0b";
}

.ri-delete-back-line:before {
  content: "\\ec0c";
}

.ri-delete-bin-2-fill:before {
  content: "\\ec0d";
}

.ri-delete-bin-2-line:before {
  content: "\\ec0e";
}

.ri-delete-bin-3-fill:before {
  content: "\\ec0f";
}

.ri-delete-bin-3-line:before {
  content: "\\ec10";
}

.ri-delete-bin-4-fill:before {
  content: "\\ec11";
}

.ri-delete-bin-4-line:before {
  content: "\\ec12";
}

.ri-delete-bin-5-fill:before {
  content: "\\ec13";
}

.ri-delete-bin-5-line:before {
  content: "\\ec14";
}

.ri-delete-bin-6-fill:before {
  content: "\\ec15";
}

.ri-delete-bin-6-line:before {
  content: "\\ec16";
}

.ri-delete-bin-7-fill:before {
  content: "\\ec17";
}

.ri-delete-bin-7-line:before {
  content: "\\ec18";
}

.ri-delete-bin-fill:before {
  content: "\\ec19";
}

.ri-delete-bin-line:before {
  content: "\\ec1a";
}

.ri-device-fill:before {
  content: "\\ec1b";
}

.ri-device-line:before {
  content: "\\ec1c";
}

.ri-device-recover-fill:before {
  content: "\\ec1d";
}

.ri-device-recover-line:before {
  content: "\\ec1e";
}

.ri-dingding-fill:before {
  content: "\\ec1f";
}

.ri-dingding-line:before {
  content: "\\ec20";
}

.ri-direction-fill:before {
  content: "\\ec21";
}

.ri-direction-line:before {
  content: "\\ec22";
}

.ri-disc-fill:before {
  content: "\\ec23";
}

.ri-disc-line:before {
  content: "\\ec24";
}

.ri-discord-fill:before {
  content: "\\ec25";
}

.ri-discord-line:before {
  content: "\\ec26";
}

.ri-discuss-fill:before {
  content: "\\ec27";
}

.ri-discuss-line:before {
  content: "\\ec28";
}

.ri-disqus-fill:before {
  content: "\\ec29";
}

.ri-disqus-line:before {
  content: "\\ec2a";
}

.ri-divide-fill:before {
  content: "\\ec2b";
}

.ri-divide-line:before {
  content: "\\ec2c";
}

.ri-donut-chart-fill:before {
  content: "\\ec2d";
}

.ri-donut-chart-line:before {
  content: "\\ec2e";
}

.ri-door-lock-box-fill:before {
  content: "\\ec2f";
}

.ri-door-lock-box-line:before {
  content: "\\ec30";
}

.ri-door-lock-fill:before {
  content: "\\ec31";
}

.ri-door-lock-line:before {
  content: "\\ec32";
}

.ri-douban-fill:before {
  content: "\\ec33";
}

.ri-douban-line:before {
  content: "\\ec34";
}

.ri-double-quotes-l:before {
  content: "\\ec35";
}

.ri-double-quotes-r:before {
  content: "\\ec36";
}

.ri-download-2-fill:before {
  content: "\\ec37";
}

.ri-download-2-line:before {
  content: "\\ec38";
}

.ri-download-cloud-2-fill:before {
  content: "\\ec39";
}

.ri-download-cloud-2-line:before {
  content: "\\ec3a";
}

.ri-download-cloud-fill:before {
  content: "\\ec3b";
}

.ri-download-cloud-line:before {
  content: "\\ec3c";
}

.ri-download-fill:before {
  content: "\\ec3d";
}

.ri-download-line:before {
  content: "\\ec3e";
}

.ri-drag-drop-fill:before {
  content: "\\ec3f";
}

.ri-drag-drop-line:before {
  content: "\\ec40";
}

.ri-drag-move-2-fill:before {
  content: "\\ec41";
}

.ri-drag-move-2-line:before {
  content: "\\ec42";
}

.ri-drag-move-fill:before {
  content: "\\ec43";
}

.ri-drag-move-line:before {
  content: "\\ec44";
}

.ri-dribbble-fill:before {
  content: "\\ec45";
}

.ri-dribbble-line:before {
  content: "\\ec46";
}

.ri-drive-fill:before {
  content: "\\ec47";
}

.ri-drive-line:before {
  content: "\\ec48";
}

.ri-drizzle-fill:before {
  content: "\\ec49";
}

.ri-drizzle-line:before {
  content: "\\ec4a";
}

.ri-drop-fill:before {
  content: "\\ec4b";
}

.ri-drop-line:before {
  content: "\\ec4c";
}

.ri-dropbox-fill:before {
  content: "\\ec4d";
}

.ri-dropbox-line:before {
  content: "\\ec4e";
}

.ri-dual-sim-1-fill:before {
  content: "\\ec4f";
}

.ri-dual-sim-1-line:before {
  content: "\\ec50";
}

.ri-dual-sim-2-fill:before {
  content: "\\ec51";
}

.ri-dual-sim-2-line:before {
  content: "\\ec52";
}

.ri-dv-fill:before {
  content: "\\ec53";
}

.ri-dv-line:before {
  content: "\\ec54";
}

.ri-dvd-fill:before {
  content: "\\ec55";
}

.ri-dvd-line:before {
  content: "\\ec56";
}

.ri-e-bike-2-fill:before {
  content: "\\ec57";
}

.ri-e-bike-2-line:before {
  content: "\\ec58";
}

.ri-e-bike-fill:before {
  content: "\\ec59";
}

.ri-e-bike-line:before {
  content: "\\ec5a";
}

.ri-earth-fill:before {
  content: "\\ec5b";
}

.ri-earth-line:before {
  content: "\\ec5c";
}

.ri-earthquake-fill:before {
  content: "\\ec5d";
}

.ri-earthquake-line:before {
  content: "\\ec5e";
}

.ri-edge-fill:before {
  content: "\\ec5f";
}

.ri-edge-line:before {
  content: "\\ec60";
}

.ri-edit-2-fill:before {
  content: "\\ec61";
}

.ri-edit-2-line:before {
  content: "\\ec62";
}

.ri-edit-box-fill:before {
  content: "\\ec63";
}

.ri-edit-box-line:before {
  content: "\\ec64";
}

.ri-edit-circle-fill:before {
  content: "\\ec65";
}

.ri-edit-circle-line:before {
  content: "\\ec66";
}

.ri-edit-fill:before {
  content: "\\ec67";
}

.ri-edit-line:before {
  content: "\\ec68";
}

.ri-eject-fill:before {
  content: "\\ec69";
}

.ri-eject-line:before {
  content: "\\ec6a";
}

.ri-emotion-2-fill:before {
  content: "\\ec6b";
}

.ri-emotion-2-line:before {
  content: "\\ec6c";
}

.ri-emotion-fill:before {
  content: "\\ec6d";
}

.ri-emotion-happy-fill:before {
  content: "\\ec6e";
}

.ri-emotion-happy-line:before {
  content: "\\ec6f";
}

.ri-emotion-laugh-fill:before {
  content: "\\ec70";
}

.ri-emotion-laugh-line:before {
  content: "\\ec71";
}

.ri-emotion-line:before {
  content: "\\ec72";
}

.ri-emotion-normal-fill:before {
  content: "\\ec73";
}

.ri-emotion-normal-line:before {
  content: "\\ec74";
}

.ri-emotion-sad-fill:before {
  content: "\\ec75";
}

.ri-emotion-sad-line:before {
  content: "\\ec76";
}

.ri-emotion-unhappy-fill:before {
  content: "\\ec77";
}

.ri-emotion-unhappy-line:before {
  content: "\\ec78";
}

.ri-emphasis-cn:before {
  content: "\\ec79";
}

.ri-emphasis:before {
  content: "\\ec7a";
}

.ri-english-input:before {
  content: "\\ec7b";
}

.ri-equalizer-fill:before {
  content: "\\ec7c";
}

.ri-equalizer-line:before {
  content: "\\ec7d";
}

.ri-eraser-fill:before {
  content: "\\ec7e";
}

.ri-eraser-line:before {
  content: "\\ec7f";
}

.ri-error-warning-fill:before {
  content: "\\ec80";
}

.ri-error-warning-line:before {
  content: "\\ec81";
}

.ri-evernote-fill:before {
  content: "\\ec82";
}

.ri-evernote-line:before {
  content: "\\ec83";
}

.ri-exchange-box-fill:before {
  content: "\\ec84";
}

.ri-exchange-box-line:before {
  content: "\\ec85";
}

.ri-exchange-cny-fill:before {
  content: "\\ec86";
}

.ri-exchange-cny-line:before {
  content: "\\ec87";
}

.ri-exchange-dollar-fill:before {
  content: "\\ec88";
}

.ri-exchange-dollar-line:before {
  content: "\\ec89";
}

.ri-exchange-fill:before {
  content: "\\ec8a";
}

.ri-exchange-funds-fill:before {
  content: "\\ec8b";
}

.ri-exchange-funds-line:before {
  content: "\\ec8c";
}

.ri-exchange-line:before {
  content: "\\ec8d";
}

.ri-external-link-fill:before {
  content: "\\ec8e";
}

.ri-external-link-line:before {
  content: "\\ec8f";
}

.ri-eye-2-fill:before {
  content: "\\ec90";
}

.ri-eye-2-line:before {
  content: "\\ec91";
}

.ri-eye-close-fill:before {
  content: "\\ec92";
}

.ri-eye-close-line:before {
  content: "\\ec93";
}

.ri-eye-fill:before {
  content: "\\ec94";
}

.ri-eye-line:before {
  content: "\\ec95";
}

.ri-eye-off-fill:before {
  content: "\\ec96";
}

.ri-eye-off-line:before {
  content: "\\ec97";
}

.ri-facebook-box-fill:before {
  content: "\\ec98";
}

.ri-facebook-box-line:before {
  content: "\\ec99";
}

.ri-facebook-circle-fill:before {
  content: "\\ec9a";
}

.ri-facebook-circle-line:before {
  content: "\\ec9b";
}

.ri-facebook-fill:before {
  content: "\\ec9c";
}

.ri-facebook-line:before {
  content: "\\ec9d";
}

.ri-fahrenheit-fill:before {
  content: "\\ec9e";
}

.ri-fahrenheit-line:before {
  content: "\\ec9f";
}

.ri-feedback-fill:before {
  content: "\\eca0";
}

.ri-feedback-line:before {
  content: "\\eca1";
}

.ri-file-2-fill:before {
  content: "\\eca2";
}

.ri-file-2-line:before {
  content: "\\eca3";
}

.ri-file-3-fill:before {
  content: "\\eca4";
}

.ri-file-3-line:before {
  content: "\\eca5";
}

.ri-file-4-fill:before {
  content: "\\eca6";
}

.ri-file-4-line:before {
  content: "\\eca7";
}

.ri-file-add-fill:before {
  content: "\\eca8";
}

.ri-file-add-line:before {
  content: "\\eca9";
}

.ri-file-chart-2-fill:before {
  content: "\\ecaa";
}

.ri-file-chart-2-line:before {
  content: "\\ecab";
}

.ri-file-chart-fill:before {
  content: "\\ecac";
}

.ri-file-chart-line:before {
  content: "\\ecad";
}

.ri-file-cloud-fill:before {
  content: "\\ecae";
}

.ri-file-cloud-line:before {
  content: "\\ecaf";
}

.ri-file-code-fill:before {
  content: "\\ecb0";
}

.ri-file-code-line:before {
  content: "\\ecb1";
}

.ri-file-copy-2-fill:before {
  content: "\\ecb2";
}

.ri-file-copy-2-line:before {
  content: "\\ecb3";
}

.ri-file-copy-fill:before {
  content: "\\ecb4";
}

.ri-file-copy-line:before {
  content: "\\ecb5";
}

.ri-file-damage-fill:before {
  content: "\\ecb6";
}

.ri-file-damage-line:before {
  content: "\\ecb7";
}

.ri-file-download-fill:before {
  content: "\\ecb8";
}

.ri-file-download-line:before {
  content: "\\ecb9";
}

.ri-file-edit-fill:before {
  content: "\\ecba";
}

.ri-file-edit-line:before {
  content: "\\ecbb";
}

.ri-file-excel-2-fill:before {
  content: "\\ecbc";
}

.ri-file-excel-2-line:before {
  content: "\\ecbd";
}

.ri-file-excel-fill:before {
  content: "\\ecbe";
}

.ri-file-excel-line:before {
  content: "\\ecbf";
}

.ri-file-fill:before {
  content: "\\ecc0";
}

.ri-file-forbid-fill:before {
  content: "\\ecc1";
}

.ri-file-forbid-line:before {
  content: "\\ecc2";
}

.ri-file-gif-fill:before {
  content: "\\ecc3";
}

.ri-file-gif-line:before {
  content: "\\ecc4";
}

.ri-file-history-fill:before {
  content: "\\ecc5";
}

.ri-file-history-line:before {
  content: "\\ecc6";
}

.ri-file-hwp-fill:before {
  content: "\\ecc7";
}

.ri-file-hwp-line:before {
  content: "\\ecc8";
}

.ri-file-info-fill:before {
  content: "\\ecc9";
}

.ri-file-info-line:before {
  content: "\\ecca";
}

.ri-file-line:before {
  content: "\\eccb";
}

.ri-file-list-2-fill:before {
  content: "\\eccc";
}

.ri-file-list-2-line:before {
  content: "\\eccd";
}

.ri-file-list-3-fill:before {
  content: "\\ecce";
}

.ri-file-list-3-line:before {
  content: "\\eccf";
}

.ri-file-list-fill:before {
  content: "\\ecd0";
}

.ri-file-list-line:before {
  content: "\\ecd1";
}

.ri-file-lock-fill:before {
  content: "\\ecd2";
}

.ri-file-lock-line:before {
  content: "\\ecd3";
}

.ri-file-mark-fill:before {
  content: "\\ecd4";
}

.ri-file-mark-line:before {
  content: "\\ecd5";
}

.ri-file-music-fill:before {
  content: "\\ecd6";
}

.ri-file-music-line:before {
  content: "\\ecd7";
}

.ri-file-paper-2-fill:before {
  content: "\\ecd8";
}

.ri-file-paper-2-line:before {
  content: "\\ecd9";
}

.ri-file-paper-fill:before {
  content: "\\ecda";
}

.ri-file-paper-line:before {
  content: "\\ecdb";
}

.ri-file-pdf-fill:before {
  content: "\\ecdc";
}

.ri-file-pdf-line:before {
  content: "\\ecdd";
}

.ri-file-ppt-2-fill:before {
  content: "\\ecde";
}

.ri-file-ppt-2-line:before {
  content: "\\ecdf";
}

.ri-file-ppt-fill:before {
  content: "\\ece0";
}

.ri-file-ppt-line:before {
  content: "\\ece1";
}

.ri-file-reduce-fill:before {
  content: "\\ece2";
}

.ri-file-reduce-line:before {
  content: "\\ece3";
}

.ri-file-search-fill:before {
  content: "\\ece4";
}

.ri-file-search-line:before {
  content: "\\ece5";
}

.ri-file-settings-fill:before {
  content: "\\ece6";
}

.ri-file-settings-line:before {
  content: "\\ece7";
}

.ri-file-shield-2-fill:before {
  content: "\\ece8";
}

.ri-file-shield-2-line:before {
  content: "\\ece9";
}

.ri-file-shield-fill:before {
  content: "\\ecea";
}

.ri-file-shield-line:before {
  content: "\\eceb";
}

.ri-file-shred-fill:before {
  content: "\\ecec";
}

.ri-file-shred-line:before {
  content: "\\eced";
}

.ri-file-text-fill:before {
  content: "\\ecee";
}

.ri-file-text-line:before {
  content: "\\ecef";
}

.ri-file-transfer-fill:before {
  content: "\\ecf0";
}

.ri-file-transfer-line:before {
  content: "\\ecf1";
}

.ri-file-unknow-fill:before {
  content: "\\ecf2";
}

.ri-file-unknow-line:before {
  content: "\\ecf3";
}

.ri-file-upload-fill:before {
  content: "\\ecf4";
}

.ri-file-upload-line:before {
  content: "\\ecf5";
}

.ri-file-user-fill:before {
  content: "\\ecf6";
}

.ri-file-user-line:before {
  content: "\\ecf7";
}

.ri-file-warning-fill:before {
  content: "\\ecf8";
}

.ri-file-warning-line:before {
  content: "\\ecf9";
}

.ri-file-word-2-fill:before {
  content: "\\ecfa";
}

.ri-file-word-2-line:before {
  content: "\\ecfb";
}

.ri-file-word-fill:before {
  content: "\\ecfc";
}

.ri-file-word-line:before {
  content: "\\ecfd";
}

.ri-file-zip-fill:before {
  content: "\\ecfe";
}

.ri-file-zip-line:before {
  content: "\\ecff";
}

.ri-film-fill:before {
  content: "\\ed00";
}

.ri-film-line:before {
  content: "\\ed01";
}

.ri-filter-2-fill:before {
  content: "\\ed02";
}

.ri-filter-2-line:before {
  content: "\\ed03";
}

.ri-filter-3-fill:before {
  content: "\\ed04";
}

.ri-filter-3-line:before {
  content: "\\ed05";
}

.ri-filter-fill:before {
  content: "\\ed06";
}

.ri-filter-line:before {
  content: "\\ed07";
}

.ri-find-replace-fill:before {
  content: "\\ed08";
}

.ri-find-replace-line:before {
  content: "\\ed09";
}

.ri-fingerprint-2-fill:before {
  content: "\\ed0a";
}

.ri-fingerprint-2-line:before {
  content: "\\ed0b";
}

.ri-fingerprint-fill:before {
  content: "\\ed0c";
}

.ri-fingerprint-line:before {
  content: "\\ed0d";
}

.ri-fire-fill:before {
  content: "\\ed0e";
}

.ri-fire-line:before {
  content: "\\ed0f";
}

.ri-firefox-fill:before {
  content: "\\ed10";
}

.ri-firefox-line:before {
  content: "\\ed11";
}

.ri-flag-2-fill:before {
  content: "\\ed12";
}

.ri-flag-2-line:before {
  content: "\\ed13";
}

.ri-flag-fill:before {
  content: "\\ed14";
}

.ri-flag-line:before {
  content: "\\ed15";
}

.ri-flashlight-fill:before {
  content: "\\ed16";
}

.ri-flashlight-line:before {
  content: "\\ed17";
}

.ri-flask-fill:before {
  content: "\\ed18";
}

.ri-flask-line:before {
  content: "\\ed19";
}

.ri-flight-land-fill:before {
  content: "\\ed1a";
}

.ri-flight-land-line:before {
  content: "\\ed1b";
}

.ri-flight-takeoff-fill:before {
  content: "\\ed1c";
}

.ri-flight-takeoff-line:before {
  content: "\\ed1d";
}

.ri-flood-fill:before {
  content: "\\ed1e";
}

.ri-flood-line:before {
  content: "\\ed1f";
}

.ri-flutter-fill:before {
  content: "\\ed20";
}

.ri-flutter-line:before {
  content: "\\ed21";
}

.ri-focus-2-fill:before {
  content: "\\ed22";
}

.ri-focus-2-line:before {
  content: "\\ed23";
}

.ri-focus-3-fill:before {
  content: "\\ed24";
}

.ri-focus-3-line:before {
  content: "\\ed25";
}

.ri-focus-fill:before {
  content: "\\ed26";
}

.ri-focus-line:before {
  content: "\\ed27";
}

.ri-foggy-fill:before {
  content: "\\ed28";
}

.ri-foggy-line:before {
  content: "\\ed29";
}

.ri-folder-2-fill:before {
  content: "\\ed2a";
}

.ri-folder-2-line:before {
  content: "\\ed2b";
}

.ri-folder-3-fill:before {
  content: "\\ed2c";
}

.ri-folder-3-line:before {
  content: "\\ed2d";
}

.ri-folder-4-fill:before {
  content: "\\ed2e";
}

.ri-folder-4-line:before {
  content: "\\ed2f";
}

.ri-folder-5-fill:before {
  content: "\\ed30";
}

.ri-folder-5-line:before {
  content: "\\ed31";
}

.ri-folder-add-fill:before {
  content: "\\ed32";
}

.ri-folder-add-line:before {
  content: "\\ed33";
}

.ri-folder-chart-2-fill:before {
  content: "\\ed34";
}

.ri-folder-chart-2-line:before {
  content: "\\ed35";
}

.ri-folder-chart-fill:before {
  content: "\\ed36";
}

.ri-folder-chart-line:before {
  content: "\\ed37";
}

.ri-folder-download-fill:before {
  content: "\\ed38";
}

.ri-folder-download-line:before {
  content: "\\ed39";
}

.ri-folder-fill:before {
  content: "\\ed3a";
}

.ri-folder-forbid-fill:before {
  content: "\\ed3b";
}

.ri-folder-forbid-line:before {
  content: "\\ed3c";
}

.ri-folder-history-fill:before {
  content: "\\ed3d";
}

.ri-folder-history-line:before {
  content: "\\ed3e";
}

.ri-folder-info-fill:before {
  content: "\\ed3f";
}

.ri-folder-info-line:before {
  content: "\\ed40";
}

.ri-folder-keyhole-fill:before {
  content: "\\ed41";
}

.ri-folder-keyhole-line:before {
  content: "\\ed42";
}

.ri-folder-line:before {
  content: "\\ed43";
}

.ri-folder-lock-fill:before {
  content: "\\ed44";
}

.ri-folder-lock-line:before {
  content: "\\ed45";
}

.ri-folder-music-fill:before {
  content: "\\ed46";
}

.ri-folder-music-line:before {
  content: "\\ed47";
}

.ri-folder-open-fill:before {
  content: "\\ed48";
}

.ri-folder-open-line:before {
  content: "\\ed49";
}

.ri-folder-received-fill:before {
  content: "\\ed4a";
}

.ri-folder-received-line:before {
  content: "\\ed4b";
}

.ri-folder-reduce-fill:before {
  content: "\\ed4c";
}

.ri-folder-reduce-line:before {
  content: "\\ed4d";
}

.ri-folder-settings-fill:before {
  content: "\\ed4e";
}

.ri-folder-settings-line:before {
  content: "\\ed4f";
}

.ri-folder-shared-fill:before {
  content: "\\ed50";
}

.ri-folder-shared-line:before {
  content: "\\ed51";
}

.ri-folder-shield-2-fill:before {
  content: "\\ed52";
}

.ri-folder-shield-2-line:before {
  content: "\\ed53";
}

.ri-folder-shield-fill:before {
  content: "\\ed54";
}

.ri-folder-shield-line:before {
  content: "\\ed55";
}

.ri-folder-transfer-fill:before {
  content: "\\ed56";
}

.ri-folder-transfer-line:before {
  content: "\\ed57";
}

.ri-folder-unknow-fill:before {
  content: "\\ed58";
}

.ri-folder-unknow-line:before {
  content: "\\ed59";
}

.ri-folder-upload-fill:before {
  content: "\\ed5a";
}

.ri-folder-upload-line:before {
  content: "\\ed5b";
}

.ri-folder-user-fill:before {
  content: "\\ed5c";
}

.ri-folder-user-line:before {
  content: "\\ed5d";
}

.ri-folder-warning-fill:before {
  content: "\\ed5e";
}

.ri-folder-warning-line:before {
  content: "\\ed5f";
}

.ri-folder-zip-fill:before {
  content: "\\ed60";
}

.ri-folder-zip-line:before {
  content: "\\ed61";
}

.ri-folders-fill:before {
  content: "\\ed62";
}

.ri-folders-line:before {
  content: "\\ed63";
}

.ri-font-color:before {
  content: "\\ed64";
}

.ri-font-size-2:before {
  content: "\\ed65";
}

.ri-font-size:before {
  content: "\\ed66";
}

.ri-football-fill:before {
  content: "\\ed67";
}

.ri-football-line:before {
  content: "\\ed68";
}

.ri-footprint-fill:before {
  content: "\\ed69";
}

.ri-footprint-line:before {
  content: "\\ed6a";
}

.ri-forbid-2-fill:before {
  content: "\\ed6b";
}

.ri-forbid-2-line:before {
  content: "\\ed6c";
}

.ri-forbid-fill:before {
  content: "\\ed6d";
}

.ri-forbid-line:before {
  content: "\\ed6e";
}

.ri-format-clear:before {
  content: "\\ed6f";
}

.ri-fridge-fill:before {
  content: "\\ed70";
}

.ri-fridge-line:before {
  content: "\\ed71";
}

.ri-fullscreen-exit-fill:before {
  content: "\\ed72";
}

.ri-fullscreen-exit-line:before {
  content: "\\ed73";
}

.ri-fullscreen-fill:before {
  content: "\\ed74";
}

.ri-fullscreen-line:before {
  content: "\\ed75";
}

.ri-function-fill:before {
  content: "\\ed76";
}

.ri-function-line:before {
  content: "\\ed77";
}

.ri-functions:before {
  content: "\\ed78";
}

.ri-funds-box-fill:before {
  content: "\\ed79";
}

.ri-funds-box-line:before {
  content: "\\ed7a";
}

.ri-funds-fill:before {
  content: "\\ed7b";
}

.ri-funds-line:before {
  content: "\\ed7c";
}

.ri-gallery-fill:before {
  content: "\\ed7d";
}

.ri-gallery-line:before {
  content: "\\ed7e";
}

.ri-gallery-upload-fill:before {
  content: "\\ed7f";
}

.ri-gallery-upload-line:before {
  content: "\\ed80";
}

.ri-game-fill:before {
  content: "\\ed81";
}

.ri-game-line:before {
  content: "\\ed82";
}

.ri-gamepad-fill:before {
  content: "\\ed83";
}

.ri-gamepad-line:before {
  content: "\\ed84";
}

.ri-gas-station-fill:before {
  content: "\\ed85";
}

.ri-gas-station-line:before {
  content: "\\ed86";
}

.ri-gatsby-fill:before {
  content: "\\ed87";
}

.ri-gatsby-line:before {
  content: "\\ed88";
}

.ri-genderless-fill:before {
  content: "\\ed89";
}

.ri-genderless-line:before {
  content: "\\ed8a";
}

.ri-ghost-2-fill:before {
  content: "\\ed8b";
}

.ri-ghost-2-line:before {
  content: "\\ed8c";
}

.ri-ghost-fill:before {
  content: "\\ed8d";
}

.ri-ghost-line:before {
  content: "\\ed8e";
}

.ri-ghost-smile-fill:before {
  content: "\\ed8f";
}

.ri-ghost-smile-line:before {
  content: "\\ed90";
}

.ri-gift-2-fill:before {
  content: "\\ed91";
}

.ri-gift-2-line:before {
  content: "\\ed92";
}

.ri-gift-fill:before {
  content: "\\ed93";
}

.ri-gift-line:before {
  content: "\\ed94";
}

.ri-git-branch-fill:before {
  content: "\\ed95";
}

.ri-git-branch-line:before {
  content: "\\ed96";
}

.ri-git-commit-fill:before {
  content: "\\ed97";
}

.ri-git-commit-line:before {
  content: "\\ed98";
}

.ri-git-merge-fill:before {
  content: "\\ed99";
}

.ri-git-merge-line:before {
  content: "\\ed9a";
}

.ri-git-pull-request-fill:before {
  content: "\\ed9b";
}

.ri-git-pull-request-line:before {
  content: "\\ed9c";
}

.ri-git-repository-commits-fill:before {
  content: "\\ed9d";
}

.ri-git-repository-commits-line:before {
  content: "\\ed9e";
}

.ri-git-repository-fill:before {
  content: "\\ed9f";
}

.ri-git-repository-line:before {
  content: "\\eda0";
}

.ri-git-repository-private-fill:before {
  content: "\\eda1";
}

.ri-git-repository-private-line:before {
  content: "\\eda2";
}

.ri-github-fill:before {
  content: "\\eda3";
}

.ri-github-line:before {
  content: "\\eda4";
}

.ri-gitlab-fill:before {
  content: "\\eda5";
}

.ri-gitlab-line:before {
  content: "\\eda6";
}

.ri-global-fill:before {
  content: "\\eda7";
}

.ri-global-line:before {
  content: "\\eda8";
}

.ri-globe-fill:before {
  content: "\\eda9";
}

.ri-globe-line:before {
  content: "\\edaa";
}

.ri-goblet-fill:before {
  content: "\\edab";
}

.ri-goblet-line:before {
  content: "\\edac";
}

.ri-google-fill:before {
  content: "\\edad";
}

.ri-google-line:before {
  content: "\\edae";
}

.ri-google-play-fill:before {
  content: "\\edaf";
}

.ri-google-play-line:before {
  content: "\\edb0";
}

.ri-government-fill:before {
  content: "\\edb1";
}

.ri-government-line:before {
  content: "\\edb2";
}

.ri-gps-fill:before {
  content: "\\edb3";
}

.ri-gps-line:before {
  content: "\\edb4";
}

.ri-gradienter-fill:before {
  content: "\\edb5";
}

.ri-gradienter-line:before {
  content: "\\edb6";
}

.ri-grid-fill:before {
  content: "\\edb7";
}

.ri-grid-line:before {
  content: "\\edb8";
}

.ri-group-2-fill:before {
  content: "\\edb9";
}

.ri-group-2-line:before {
  content: "\\edba";
}

.ri-group-fill:before {
  content: "\\edbb";
}

.ri-group-line:before {
  content: "\\edbc";
}

.ri-guide-fill:before {
  content: "\\edbd";
}

.ri-guide-line:before {
  content: "\\edbe";
}

.ri-hail-fill:before {
  content: "\\edbf";
}

.ri-hail-line:before {
  content: "\\edc0";
}

.ri-hammer-fill:before {
  content: "\\edc1";
}

.ri-hammer-line:before {
  content: "\\edc2";
}

.ri-hand-coin-fill:before {
  content: "\\edc3";
}

.ri-hand-coin-line:before {
  content: "\\edc4";
}

.ri-hand-heart-fill:before {
  content: "\\edc5";
}

.ri-hand-heart-line:before {
  content: "\\edc6";
}

.ri-handbag-fill:before {
  content: "\\edc7";
}

.ri-handbag-line:before {
  content: "\\edc8";
}

.ri-hard-drive-2-fill:before {
  content: "\\edc9";
}

.ri-hard-drive-2-line:before {
  content: "\\edca";
}

.ri-hard-drive-fill:before {
  content: "\\edcb";
}

.ri-hard-drive-line:before {
  content: "\\edcc";
}

.ri-hashtag:before {
  content: "\\edcd";
}

.ri-haze-2-fill:before {
  content: "\\edce";
}

.ri-haze-2-line:before {
  content: "\\edcf";
}

.ri-haze-fill:before {
  content: "\\edd0";
}

.ri-haze-line:before {
  content: "\\edd1";
}

.ri-hd-fill:before {
  content: "\\edd2";
}

.ri-hd-line:before {
  content: "\\edd3";
}

.ri-heading:before {
  content: "\\edd4";
}

.ri-headphone-fill:before {
  content: "\\edd5";
}

.ri-headphone-line:before {
  content: "\\edd6";
}

.ri-heart-2-fill:before {
  content: "\\edd7";
}

.ri-heart-2-line:before {
  content: "\\edd8";
}

.ri-heart-add-fill:before {
  content: "\\edd9";
}

.ri-heart-add-line:before {
  content: "\\edda";
}

.ri-heart-fill:before {
  content: "\\eddb";
}

.ri-heart-line:before {
  content: "\\eddc";
}

.ri-hearts-fill:before {
  content: "\\eddd";
}

.ri-hearts-line:before {
  content: "\\edde";
}

.ri-heavy-showers-fill:before {
  content: "\\eddf";
}

.ri-heavy-showers-line:before {
  content: "\\ede0";
}

.ri-history-fill:before {
  content: "\\ede1";
}

.ri-history-line:before {
  content: "\\ede2";
}

.ri-home-2-fill:before {
  content: "\\ede3";
}

.ri-home-2-line:before {
  content: "\\ede4";
}

.ri-home-3-fill:before {
  content: "\\ede5";
}

.ri-home-3-line:before {
  content: "\\ede6";
}

.ri-home-4-fill:before {
  content: "\\ede7";
}

.ri-home-4-line:before {
  content: "\\ede8";
}

.ri-home-5-fill:before {
  content: "\\ede9";
}

.ri-home-5-line:before {
  content: "\\edea";
}

.ri-home-6-fill:before {
  content: "\\edeb";
}

.ri-home-6-line:before {
  content: "\\edec";
}

.ri-home-7-fill:before {
  content: "\\eded";
}

.ri-home-7-line:before {
  content: "\\edee";
}

.ri-home-8-fill:before {
  content: "\\edef";
}

.ri-home-8-line:before {
  content: "\\edf0";
}

.ri-home-fill:before {
  content: "\\edf1";
}

.ri-home-gear-fill:before {
  content: "\\edf2";
}

.ri-home-gear-line:before {
  content: "\\edf3";
}

.ri-home-heart-fill:before {
  content: "\\edf4";
}

.ri-home-heart-line:before {
  content: "\\edf5";
}

.ri-home-line:before {
  content: "\\edf6";
}

.ri-home-smile-2-fill:before {
  content: "\\edf7";
}

.ri-home-smile-2-line:before {
  content: "\\edf8";
}

.ri-home-smile-fill:before {
  content: "\\edf9";
}

.ri-home-smile-line:before {
  content: "\\edfa";
}

.ri-home-wifi-fill:before {
  content: "\\edfb";
}

.ri-home-wifi-line:before {
  content: "\\edfc";
}

.ri-honor-of-kings-fill:before {
  content: "\\edfd";
}

.ri-honor-of-kings-line:before {
  content: "\\edfe";
}

.ri-honour-fill:before {
  content: "\\edff";
}

.ri-honour-line:before {
  content: "\\ee00";
}

.ri-hospital-fill:before {
  content: "\\ee01";
}

.ri-hospital-line:before {
  content: "\\ee02";
}

.ri-hotel-bed-fill:before {
  content: "\\ee03";
}

.ri-hotel-bed-line:before {
  content: "\\ee04";
}

.ri-hotel-fill:before {
  content: "\\ee05";
}

.ri-hotel-line:before {
  content: "\\ee06";
}

.ri-hotspot-fill:before {
  content: "\\ee07";
}

.ri-hotspot-line:before {
  content: "\\ee08";
}

.ri-hq-fill:before {
  content: "\\ee09";
}

.ri-hq-line:before {
  content: "\\ee0a";
}

.ri-html5-fill:before {
  content: "\\ee0b";
}

.ri-html5-line:before {
  content: "\\ee0c";
}

.ri-ie-fill:before {
  content: "\\ee0d";
}

.ri-ie-line:before {
  content: "\\ee0e";
}

.ri-image-2-fill:before {
  content: "\\ee0f";
}

.ri-image-2-line:before {
  content: "\\ee10";
}

.ri-image-add-fill:before {
  content: "\\ee11";
}

.ri-image-add-line:before {
  content: "\\ee12";
}

.ri-image-fill:before {
  content: "\\ee13";
}

.ri-image-line:before {
  content: "\\ee14";
}

.ri-inbox-archive-fill:before {
  content: "\\ee15";
}

.ri-inbox-archive-line:before {
  content: "\\ee16";
}

.ri-inbox-fill:before {
  content: "\\ee17";
}

.ri-inbox-line:before {
  content: "\\ee18";
}

.ri-inbox-unarchive-fill:before {
  content: "\\ee19";
}

.ri-inbox-unarchive-line:before {
  content: "\\ee1a";
}

.ri-increase-decrease-fill:before {
  content: "\\ee1b";
}

.ri-increase-decrease-line:before {
  content: "\\ee1c";
}

.ri-indent-decrease:before {
  content: "\\ee1d";
}

.ri-indent-increase:before {
  content: "\\ee1e";
}

.ri-indeterminate-circle-fill:before {
  content: "\\ee1f";
}

.ri-indeterminate-circle-line:before {
  content: "\\ee20";
}

.ri-information-fill:before {
  content: "\\ee21";
}

.ri-information-line:before {
  content: "\\ee22";
}

.ri-input-cursor-move:before {
  content: "\\ee23";
}

.ri-input-method-fill:before {
  content: "\\ee24";
}

.ri-input-method-line:before {
  content: "\\ee25";
}

.ri-instagram-fill:before {
  content: "\\ee26";
}

.ri-instagram-line:before {
  content: "\\ee27";
}

.ri-install-fill:before {
  content: "\\ee28";
}

.ri-install-line:before {
  content: "\\ee29";
}

.ri-invision-fill:before {
  content: "\\ee2a";
}

.ri-invision-line:before {
  content: "\\ee2b";
}

.ri-italic:before {
  content: "\\ee2c";
}

.ri-kakao-talk-fill:before {
  content: "\\ee2d";
}

.ri-kakao-talk-line:before {
  content: "\\ee2e";
}

.ri-key-2-fill:before {
  content: "\\ee2f";
}

.ri-key-2-line:before {
  content: "\\ee30";
}

.ri-key-fill:before {
  content: "\\ee31";
}

.ri-key-line:before {
  content: "\\ee32";
}

.ri-keyboard-box-fill:before {
  content: "\\ee33";
}

.ri-keyboard-box-line:before {
  content: "\\ee34";
}

.ri-keyboard-fill:before {
  content: "\\ee35";
}

.ri-keyboard-line:before {
  content: "\\ee36";
}

.ri-keynote-fill:before {
  content: "\\ee37";
}

.ri-keynote-line:before {
  content: "\\ee38";
}

.ri-knife-blood-fill:before {
  content: "\\ee39";
}

.ri-knife-blood-line:before {
  content: "\\ee3a";
}

.ri-knife-fill:before {
  content: "\\ee3b";
}

.ri-knife-line:before {
  content: "\\ee3c";
}

.ri-landscape-fill:before {
  content: "\\ee3d";
}

.ri-landscape-line:before {
  content: "\\ee3e";
}

.ri-layout-2-fill:before {
  content: "\\ee3f";
}

.ri-layout-2-line:before {
  content: "\\ee40";
}

.ri-layout-3-fill:before {
  content: "\\ee41";
}

.ri-layout-3-line:before {
  content: "\\ee42";
}

.ri-layout-4-fill:before {
  content: "\\ee43";
}

.ri-layout-4-line:before {
  content: "\\ee44";
}

.ri-layout-5-fill:before {
  content: "\\ee45";
}

.ri-layout-5-line:before {
  content: "\\ee46";
}

.ri-layout-6-fill:before {
  content: "\\ee47";
}

.ri-layout-6-line:before {
  content: "\\ee48";
}

.ri-layout-bottom-2-fill:before {
  content: "\\ee49";
}

.ri-layout-bottom-2-line:before {
  content: "\\ee4a";
}

.ri-layout-bottom-fill:before {
  content: "\\ee4b";
}

.ri-layout-bottom-line:before {
  content: "\\ee4c";
}

.ri-layout-column-fill:before {
  content: "\\ee4d";
}

.ri-layout-column-line:before {
  content: "\\ee4e";
}

.ri-layout-fill:before {
  content: "\\ee4f";
}

.ri-layout-grid-fill:before {
  content: "\\ee50";
}

.ri-layout-grid-line:before {
  content: "\\ee51";
}

.ri-layout-left-2-fill:before {
  content: "\\ee52";
}

.ri-layout-left-2-line:before {
  content: "\\ee53";
}

.ri-layout-left-fill:before {
  content: "\\ee54";
}

.ri-layout-left-line:before {
  content: "\\ee55";
}

.ri-layout-line:before {
  content: "\\ee56";
}

.ri-layout-masonry-fill:before {
  content: "\\ee57";
}

.ri-layout-masonry-line:before {
  content: "\\ee58";
}

.ri-layout-right-2-fill:before {
  content: "\\ee59";
}

.ri-layout-right-2-line:before {
  content: "\\ee5a";
}

.ri-layout-right-fill:before {
  content: "\\ee5b";
}

.ri-layout-right-line:before {
  content: "\\ee5c";
}

.ri-layout-row-fill:before {
  content: "\\ee5d";
}

.ri-layout-row-line:before {
  content: "\\ee5e";
}

.ri-layout-top-2-fill:before {
  content: "\\ee5f";
}

.ri-layout-top-2-line:before {
  content: "\\ee60";
}

.ri-layout-top-fill:before {
  content: "\\ee61";
}

.ri-layout-top-line:before {
  content: "\\ee62";
}

.ri-leaf-fill:before {
  content: "\\ee63";
}

.ri-leaf-line:before {
  content: "\\ee64";
}

.ri-lifebuoy-fill:before {
  content: "\\ee65";
}

.ri-lifebuoy-line:before {
  content: "\\ee66";
}

.ri-lightbulb-fill:before {
  content: "\\ee67";
}

.ri-lightbulb-flash-fill:before {
  content: "\\ee68";
}

.ri-lightbulb-flash-line:before {
  content: "\\ee69";
}

.ri-lightbulb-line:before {
  content: "\\ee6a";
}

.ri-line-chart-fill:before {
  content: "\\ee6b";
}

.ri-line-chart-line:before {
  content: "\\ee6c";
}

.ri-line-fill:before {
  content: "\\ee6d";
}

.ri-line-height:before {
  content: "\\ee6e";
}

.ri-line-line:before {
  content: "\\ee6f";
}

.ri-link-m:before {
  content: "\\ee70";
}

.ri-link-unlink-m:before {
  content: "\\ee71";
}

.ri-link-unlink:before {
  content: "\\ee72";
}

.ri-link:before {
  content: "\\ee73";
}

.ri-linkedin-box-fill:before {
  content: "\\ee74";
}

.ri-linkedin-box-line:before {
  content: "\\ee75";
}

.ri-linkedin-fill:before {
  content: "\\ee76";
}

.ri-linkedin-line:before {
  content: "\\ee77";
}

.ri-links-fill:before {
  content: "\\ee78";
}

.ri-links-line:before {
  content: "\\ee79";
}

.ri-list-check-2:before {
  content: "\\ee7a";
}

.ri-list-check:before {
  content: "\\ee7b";
}

.ri-list-ordered:before {
  content: "\\ee7c";
}

.ri-list-settings-fill:before {
  content: "\\ee7d";
}

.ri-list-settings-line:before {
  content: "\\ee7e";
}

.ri-list-unordered:before {
  content: "\\ee7f";
}

.ri-live-fill:before {
  content: "\\ee80";
}

.ri-live-line:before {
  content: "\\ee81";
}

.ri-loader-2-fill:before {
  content: "\\ee82";
}

.ri-loader-2-line:before {
  content: "\\ee83";
}

.ri-loader-3-fill:before {
  content: "\\ee84";
}

.ri-loader-3-line:before {
  content: "\\ee85";
}

.ri-loader-4-fill:before {
  content: "\\ee86";
}

.ri-loader-4-line:before {
  content: "\\ee87";
}

.ri-loader-5-fill:before {
  content: "\\ee88";
}

.ri-loader-5-line:before {
  content: "\\ee89";
}

.ri-loader-fill:before {
  content: "\\ee8a";
}

.ri-loader-line:before {
  content: "\\ee8b";
}

.ri-lock-2-fill:before {
  content: "\\ee8c";
}

.ri-lock-2-line:before {
  content: "\\ee8d";
}

.ri-lock-fill:before {
  content: "\\ee8e";
}

.ri-lock-line:before {
  content: "\\ee8f";
}

.ri-lock-password-fill:before {
  content: "\\ee90";
}

.ri-lock-password-line:before {
  content: "\\ee91";
}

.ri-lock-unlock-fill:before {
  content: "\\ee92";
}

.ri-lock-unlock-line:before {
  content: "\\ee93";
}

.ri-login-box-fill:before {
  content: "\\ee94";
}

.ri-login-box-line:before {
  content: "\\ee95";
}

.ri-login-circle-fill:before {
  content: "\\ee96";
}

.ri-login-circle-line:before {
  content: "\\ee97";
}

.ri-logout-box-fill:before {
  content: "\\ee98";
}

.ri-logout-box-line:before {
  content: "\\ee99";
}

.ri-logout-box-r-fill:before {
  content: "\\ee9a";
}

.ri-logout-box-r-line:before {
  content: "\\ee9b";
}

.ri-logout-circle-fill:before {
  content: "\\ee9c";
}

.ri-logout-circle-line:before {
  content: "\\ee9d";
}

.ri-logout-circle-r-fill:before {
  content: "\\ee9e";
}

.ri-logout-circle-r-line:before {
  content: "\\ee9f";
}

.ri-luggage-cart-fill:before {
  content: "\\eea0";
}

.ri-luggage-cart-line:before {
  content: "\\eea1";
}

.ri-luggage-deposit-fill:before {
  content: "\\eea2";
}

.ri-luggage-deposit-line:before {
  content: "\\eea3";
}

.ri-mac-fill:before {
  content: "\\eea4";
}

.ri-mac-line:before {
  content: "\\eea5";
}

.ri-macbook-fill:before {
  content: "\\eea6";
}

.ri-macbook-line:before {
  content: "\\eea7";
}

.ri-magic-fill:before {
  content: "\\eea8";
}

.ri-magic-line:before {
  content: "\\eea9";
}

.ri-mail-add-fill:before {
  content: "\\eeaa";
}

.ri-mail-add-line:before {
  content: "\\eeab";
}

.ri-mail-check-fill:before {
  content: "\\eeac";
}

.ri-mail-check-line:before {
  content: "\\eead";
}

.ri-mail-close-fill:before {
  content: "\\eeae";
}

.ri-mail-close-line:before {
  content: "\\eeaf";
}

.ri-mail-download-fill:before {
  content: "\\eeb0";
}

.ri-mail-download-line:before {
  content: "\\eeb1";
}

.ri-mail-fill:before {
  content: "\\eeb2";
}

.ri-mail-forbid-fill:before {
  content: "\\eeb3";
}

.ri-mail-forbid-line:before {
  content: "\\eeb4";
}

.ri-mail-line:before {
  content: "\\eeb5";
}

.ri-mail-lock-fill:before {
  content: "\\eeb6";
}

.ri-mail-lock-line:before {
  content: "\\eeb7";
}

.ri-mail-open-fill:before {
  content: "\\eeb8";
}

.ri-mail-open-line:before {
  content: "\\eeb9";
}

.ri-mail-send-fill:before {
  content: "\\eeba";
}

.ri-mail-send-line:before {
  content: "\\eebb";
}

.ri-mail-settings-fill:before {
  content: "\\eebc";
}

.ri-mail-settings-line:before {
  content: "\\eebd";
}

.ri-mail-star-fill:before {
  content: "\\eebe";
}

.ri-mail-star-line:before {
  content: "\\eebf";
}

.ri-mail-unread-fill:before {
  content: "\\eec0";
}

.ri-mail-unread-line:before {
  content: "\\eec1";
}

.ri-mail-volume-fill:before {
  content: "\\eec2";
}

.ri-mail-volume-line:before {
  content: "\\eec3";
}

.ri-map-2-fill:before {
  content: "\\eec4";
}

.ri-map-2-line:before {
  content: "\\eec5";
}

.ri-map-fill:before {
  content: "\\eec6";
}

.ri-map-line:before {
  content: "\\eec7";
}

.ri-map-pin-2-fill:before {
  content: "\\eec8";
}

.ri-map-pin-2-line:before {
  content: "\\eec9";
}

.ri-map-pin-3-fill:before {
  content: "\\eeca";
}

.ri-map-pin-3-line:before {
  content: "\\eecb";
}

.ri-map-pin-4-fill:before {
  content: "\\eecc";
}

.ri-map-pin-4-line:before {
  content: "\\eecd";
}

.ri-map-pin-5-fill:before {
  content: "\\eece";
}

.ri-map-pin-5-line:before {
  content: "\\eecf";
}

.ri-map-pin-add-fill:before {
  content: "\\eed0";
}

.ri-map-pin-add-line:before {
  content: "\\eed1";
}

.ri-map-pin-fill:before {
  content: "\\eed2";
}

.ri-map-pin-line:before {
  content: "\\eed3";
}

.ri-map-pin-range-fill:before {
  content: "\\eed4";
}

.ri-map-pin-range-line:before {
  content: "\\eed5";
}

.ri-map-pin-time-fill:before {
  content: "\\eed6";
}

.ri-map-pin-time-line:before {
  content: "\\eed7";
}

.ri-map-pin-user-fill:before {
  content: "\\eed8";
}

.ri-map-pin-user-line:before {
  content: "\\eed9";
}

.ri-mark-pen-fill:before {
  content: "\\eeda";
}

.ri-mark-pen-line:before {
  content: "\\eedb";
}

.ri-markdown-fill:before {
  content: "\\eedc";
}

.ri-markdown-line:before {
  content: "\\eedd";
}

.ri-markup-fill:before {
  content: "\\eede";
}

.ri-markup-line:before {
  content: "\\eedf";
}

.ri-mastercard-fill:before {
  content: "\\eee0";
}

.ri-mastercard-line:before {
  content: "\\eee1";
}

.ri-mastodon-fill:before {
  content: "\\eee2";
}

.ri-mastodon-line:before {
  content: "\\eee3";
}

.ri-medal-2-fill:before {
  content: "\\eee4";
}

.ri-medal-2-line:before {
  content: "\\eee5";
}

.ri-medal-fill:before {
  content: "\\eee6";
}

.ri-medal-line:before {
  content: "\\eee7";
}

.ri-medium-fill:before {
  content: "\\eee8";
}

.ri-medium-line:before {
  content: "\\eee9";
}

.ri-men-fill:before {
  content: "\\eeea";
}

.ri-men-line:before {
  content: "\\eeeb";
}

.ri-menu-2-fill:before {
  content: "\\eeec";
}

.ri-menu-2-line:before {
  content: "\\eeed";
}

.ri-menu-3-fill:before {
  content: "\\eeee";
}

.ri-menu-3-line:before {
  content: "\\eeef";
}

.ri-menu-4-fill:before {
  content: "\\eef0";
}

.ri-menu-4-line:before {
  content: "\\eef1";
}

.ri-menu-5-fill:before {
  content: "\\eef2";
}

.ri-menu-5-line:before {
  content: "\\eef3";
}

.ri-menu-add-fill:before {
  content: "\\eef4";
}

.ri-menu-add-line:before {
  content: "\\eef5";
}

.ri-menu-fill:before {
  content: "\\eef6";
}

.ri-menu-line:before {
  content: "\\eef7";
}

.ri-message-2-fill:before {
  content: "\\eef8";
}

.ri-message-2-line:before {
  content: "\\eef9";
}

.ri-message-3-fill:before {
  content: "\\eefa";
}

.ri-message-3-line:before {
  content: "\\eefb";
}

.ri-message-fill:before {
  content: "\\eefc";
}

.ri-message-line:before {
  content: "\\eefd";
}

.ri-messenger-fill:before {
  content: "\\eefe";
}

.ri-messenger-line:before {
  content: "\\eeff";
}

.ri-meteor-fill:before {
  content: "\\ef00";
}

.ri-meteor-line:before {
  content: "\\ef01";
}

.ri-mic-2-fill:before {
  content: "\\ef02";
}

.ri-mic-2-line:before {
  content: "\\ef03";
}

.ri-mic-fill:before {
  content: "\\ef04";
}

.ri-mic-line:before {
  content: "\\ef05";
}

.ri-mic-off-fill:before {
  content: "\\ef06";
}

.ri-mic-off-line:before {
  content: "\\ef07";
}

.ri-mickey-fill:before {
  content: "\\ef08";
}

.ri-mickey-line:before {
  content: "\\ef09";
}

.ri-mini-program-fill:before {
  content: "\\ef0a";
}

.ri-mini-program-line:before {
  content: "\\ef0b";
}

.ri-mist-fill:before {
  content: "\\ef0c";
}

.ri-mist-line:before {
  content: "\\ef0d";
}

.ri-money-cny-box-fill:before {
  content: "\\ef0e";
}

.ri-money-cny-box-line:before {
  content: "\\ef0f";
}

.ri-money-cny-circle-fill:before {
  content: "\\ef10";
}

.ri-money-cny-circle-line:before {
  content: "\\ef11";
}

.ri-money-dollar-box-fill:before {
  content: "\\ef12";
}

.ri-money-dollar-box-line:before {
  content: "\\ef13";
}

.ri-money-dollar-circle-fill:before {
  content: "\\ef14";
}

.ri-money-dollar-circle-line:before {
  content: "\\ef15";
}

.ri-money-euro-box-fill:before {
  content: "\\ef16";
}

.ri-money-euro-box-line:before {
  content: "\\ef17";
}

.ri-money-euro-circle-fill:before {
  content: "\\ef18";
}

.ri-money-euro-circle-line:before {
  content: "\\ef19";
}

.ri-money-pound-box-fill:before {
  content: "\\ef1a";
}

.ri-money-pound-box-line:before {
  content: "\\ef1b";
}

.ri-money-pound-circle-fill:before {
  content: "\\ef1c";
}

.ri-money-pound-circle-line:before {
  content: "\\ef1d";
}

.ri-moon-clear-fill:before {
  content: "\\ef1e";
}

.ri-moon-clear-line:before {
  content: "\\ef1f";
}

.ri-moon-cloudy-fill:before {
  content: "\\ef20";
}

.ri-moon-cloudy-line:before {
  content: "\\ef21";
}

.ri-moon-fill:before {
  content: "\\ef22";
}

.ri-moon-foggy-fill:before {
  content: "\\ef23";
}

.ri-moon-foggy-line:before {
  content: "\\ef24";
}

.ri-moon-line:before {
  content: "\\ef25";
}

.ri-more-2-fill:before {
  content: "\\ef26";
}

.ri-more-2-line:before {
  content: "\\ef27";
}

.ri-more-fill:before {
  content: "\\ef28";
}

.ri-more-line:before {
  content: "\\ef29";
}

.ri-motorbike-fill:before {
  content: "\\ef2a";
}

.ri-motorbike-line:before {
  content: "\\ef2b";
}

.ri-mouse-fill:before {
  content: "\\ef2c";
}

.ri-mouse-line:before {
  content: "\\ef2d";
}

.ri-movie-2-fill:before {
  content: "\\ef2e";
}

.ri-movie-2-line:before {
  content: "\\ef2f";
}

.ri-movie-fill:before {
  content: "\\ef30";
}

.ri-movie-line:before {
  content: "\\ef31";
}

.ri-music-2-fill:before {
  content: "\\ef32";
}

.ri-music-2-line:before {
  content: "\\ef33";
}

.ri-music-fill:before {
  content: "\\ef34";
}

.ri-music-line:before {
  content: "\\ef35";
}

.ri-mv-fill:before {
  content: "\\ef36";
}

.ri-mv-line:before {
  content: "\\ef37";
}

.ri-navigation-fill:before {
  content: "\\ef38";
}

.ri-navigation-line:before {
  content: "\\ef39";
}

.ri-netease-cloud-music-fill:before {
  content: "\\ef3a";
}

.ri-netease-cloud-music-line:before {
  content: "\\ef3b";
}

.ri-netflix-fill:before {
  content: "\\ef3c";
}

.ri-netflix-line:before {
  content: "\\ef3d";
}

.ri-newspaper-fill:before {
  content: "\\ef3e";
}

.ri-newspaper-line:before {
  content: "\\ef3f";
}

.ri-notification-2-fill:before {
  content: "\\ef40";
}

.ri-notification-2-line:before {
  content: "\\ef41";
}

.ri-notification-3-fill:before {
  content: "\\ef42";
}

.ri-notification-3-line:before {
  content: "\\ef43";
}

.ri-notification-4-fill:before {
  content: "\\ef44";
}

.ri-notification-4-line:before {
  content: "\\ef45";
}

.ri-notification-badge-fill:before {
  content: "\\ef46";
}

.ri-notification-badge-line:before {
  content: "\\ef47";
}

.ri-notification-fill:before {
  content: "\\ef48";
}

.ri-notification-line:before {
  content: "\\ef49";
}

.ri-notification-off-fill:before {
  content: "\\ef4a";
}

.ri-notification-off-line:before {
  content: "\\ef4b";
}

.ri-npmjs-fill:before {
  content: "\\ef4c";
}

.ri-npmjs-line:before {
  content: "\\ef4d";
}

.ri-number-0:before {
  content: "\\ef4e";
}

.ri-number-1:before {
  content: "\\ef4f";
}

.ri-number-2:before {
  content: "\\ef50";
}

.ri-number-3:before {
  content: "\\ef51";
}

.ri-number-4:before {
  content: "\\ef52";
}

.ri-number-5:before {
  content: "\\ef53";
}

.ri-number-6:before {
  content: "\\ef54";
}

.ri-number-7:before {
  content: "\\ef55";
}

.ri-number-8:before {
  content: "\\ef56";
}

.ri-number-9:before {
  content: "\\ef57";
}

.ri-numbers-fill:before {
  content: "\\ef58";
}

.ri-numbers-line:before {
  content: "\\ef59";
}

.ri-oil-fill:before {
  content: "\\ef5a";
}

.ri-oil-line:before {
  content: "\\ef5b";
}

.ri-omega:before {
  content: "\\ef5c";
}

.ri-open-arm-fill:before {
  content: "\\ef5d";
}

.ri-open-arm-line:before {
  content: "\\ef5e";
}

.ri-open-source-fill:before {
  content: "\\ef5f";
}

.ri-open-source-line:before {
  content: "\\ef60";
}

.ri-opera-fill:before {
  content: "\\ef61";
}

.ri-opera-line:before {
  content: "\\ef62";
}

.ri-order-play-fill:before {
  content: "\\ef63";
}

.ri-order-play-line:before {
  content: "\\ef64";
}

.ri-outlet-2-fill:before {
  content: "\\ef65";
}

.ri-outlet-2-line:before {
  content: "\\ef66";
}

.ri-outlet-fill:before {
  content: "\\ef67";
}

.ri-outlet-line:before {
  content: "\\ef68";
}

.ri-page-separator:before {
  content: "\\ef69";
}

.ri-pages-fill:before {
  content: "\\ef6a";
}

.ri-pages-line:before {
  content: "\\ef6b";
}

.ri-paint-brush-fill:before {
  content: "\\ef6c";
}

.ri-paint-brush-line:before {
  content: "\\ef6d";
}

.ri-paint-fill:before {
  content: "\\ef6e";
}

.ri-paint-line:before {
  content: "\\ef6f";
}

.ri-palette-fill:before {
  content: "\\ef70";
}

.ri-palette-line:before {
  content: "\\ef71";
}

.ri-pantone-fill:before {
  content: "\\ef72";
}

.ri-pantone-line:before {
  content: "\\ef73";
}

.ri-paragraph:before {
  content: "\\ef74";
}

.ri-parent-fill:before {
  content: "\\ef75";
}

.ri-parent-line:before {
  content: "\\ef76";
}

.ri-parentheses-fill:before {
  content: "\\ef77";
}

.ri-parentheses-line:before {
  content: "\\ef78";
}

.ri-parking-box-fill:before {
  content: "\\ef79";
}

.ri-parking-box-line:before {
  content: "\\ef7a";
}

.ri-parking-fill:before {
  content: "\\ef7b";
}

.ri-parking-line:before {
  content: "\\ef7c";
}

.ri-passport-fill:before {
  content: "\\ef7d";
}

.ri-passport-line:before {
  content: "\\ef7e";
}

.ri-patreon-fill:before {
  content: "\\ef7f";
}

.ri-patreon-line:before {
  content: "\\ef80";
}

.ri-pause-circle-fill:before {
  content: "\\ef81";
}

.ri-pause-circle-line:before {
  content: "\\ef82";
}

.ri-pause-fill:before {
  content: "\\ef83";
}

.ri-pause-line:before {
  content: "\\ef84";
}

.ri-pause-mini-fill:before {
  content: "\\ef85";
}

.ri-pause-mini-line:before {
  content: "\\ef86";
}

.ri-paypal-fill:before {
  content: "\\ef87";
}

.ri-paypal-line:before {
  content: "\\ef88";
}

.ri-pen-nib-fill:before {
  content: "\\ef89";
}

.ri-pen-nib-line:before {
  content: "\\ef8a";
}

.ri-pencil-fill:before {
  content: "\\ef8b";
}

.ri-pencil-line:before {
  content: "\\ef8c";
}

.ri-pencil-ruler-2-fill:before {
  content: "\\ef8d";
}

.ri-pencil-ruler-2-line:before {
  content: "\\ef8e";
}

.ri-pencil-ruler-fill:before {
  content: "\\ef8f";
}

.ri-pencil-ruler-line:before {
  content: "\\ef90";
}

.ri-percent-fill:before {
  content: "\\ef91";
}

.ri-percent-line:before {
  content: "\\ef92";
}

.ri-phone-camera-fill:before {
  content: "\\ef93";
}

.ri-phone-camera-line:before {
  content: "\\ef94";
}

.ri-phone-fill:before {
  content: "\\ef95";
}

.ri-phone-find-fill:before {
  content: "\\ef96";
}

.ri-phone-find-line:before {
  content: "\\ef97";
}

.ri-phone-line:before {
  content: "\\ef98";
}

.ri-phone-lock-fill:before {
  content: "\\ef99";
}

.ri-phone-lock-line:before {
  content: "\\ef9a";
}

.ri-picture-in-picture-2-fill:before {
  content: "\\ef9b";
}

.ri-picture-in-picture-2-line:before {
  content: "\\ef9c";
}

.ri-picture-in-picture-exit-fill:before {
  content: "\\ef9d";
}

.ri-picture-in-picture-exit-line:before {
  content: "\\ef9e";
}

.ri-picture-in-picture-fill:before {
  content: "\\ef9f";
}

.ri-picture-in-picture-line:before {
  content: "\\efa0";
}

.ri-pie-chart-2-fill:before {
  content: "\\efa1";
}

.ri-pie-chart-2-line:before {
  content: "\\efa2";
}

.ri-pie-chart-box-fill:before {
  content: "\\efa3";
}

.ri-pie-chart-box-line:before {
  content: "\\efa4";
}

.ri-pie-chart-fill:before {
  content: "\\efa5";
}

.ri-pie-chart-line:before {
  content: "\\efa6";
}

.ri-pin-distance-fill:before {
  content: "\\efa7";
}

.ri-pin-distance-line:before {
  content: "\\efa8";
}

.ri-ping-pong-fill:before {
  content: "\\efa9";
}

.ri-ping-pong-line:before {
  content: "\\efaa";
}

.ri-pinterest-fill:before {
  content: "\\efab";
}

.ri-pinterest-line:before {
  content: "\\efac";
}

.ri-pinyin-input:before {
  content: "\\efad";
}

.ri-pixelfed-fill:before {
  content: "\\efae";
}

.ri-pixelfed-line:before {
  content: "\\efaf";
}

.ri-plane-fill:before {
  content: "\\efb0";
}

.ri-plane-line:before {
  content: "\\efb1";
}

.ri-plant-fill:before {
  content: "\\efb2";
}

.ri-plant-line:before {
  content: "\\efb3";
}

.ri-play-circle-fill:before {
  content: "\\efb4";
}

.ri-play-circle-line:before {
  content: "\\efb5";
}

.ri-play-fill:before {
  content: "\\efb6";
}

.ri-play-line:before {
  content: "\\efb7";
}

.ri-play-list-add-fill:before {
  content: "\\efb8";
}

.ri-play-list-add-line:before {
  content: "\\efb9";
}

.ri-play-list-fill:before {
  content: "\\efba";
}

.ri-play-list-line:before {
  content: "\\efbb";
}

.ri-play-mini-fill:before {
  content: "\\efbc";
}

.ri-play-mini-line:before {
  content: "\\efbd";
}

.ri-playstation-fill:before {
  content: "\\efbe";
}

.ri-playstation-line:before {
  content: "\\efbf";
}

.ri-plug-2-fill:before {
  content: "\\efc0";
}

.ri-plug-2-line:before {
  content: "\\efc1";
}

.ri-plug-fill:before {
  content: "\\efc2";
}

.ri-plug-line:before {
  content: "\\efc3";
}

.ri-polaroid-2-fill:before {
  content: "\\efc4";
}

.ri-polaroid-2-line:before {
  content: "\\efc5";
}

.ri-polaroid-fill:before {
  content: "\\efc6";
}

.ri-polaroid-line:before {
  content: "\\efc7";
}

.ri-police-car-fill:before {
  content: "\\efc8";
}

.ri-police-car-line:before {
  content: "\\efc9";
}

.ri-price-tag-2-fill:before {
  content: "\\efca";
}

.ri-price-tag-2-line:before {
  content: "\\efcb";
}

.ri-price-tag-3-fill:before {
  content: "\\efcc";
}

.ri-price-tag-3-line:before {
  content: "\\efcd";
}

.ri-price-tag-fill:before {
  content: "\\efce";
}

.ri-price-tag-line:before {
  content: "\\efcf";
}

.ri-printer-cloud-fill:before {
  content: "\\efd0";
}

.ri-printer-cloud-line:before {
  content: "\\efd1";
}

.ri-printer-fill:before {
  content: "\\efd2";
}

.ri-printer-line:before {
  content: "\\efd3";
}

.ri-product-hunt-fill:before {
  content: "\\efd4";
}

.ri-product-hunt-line:before {
  content: "\\efd5";
}

.ri-profile-fill:before {
  content: "\\efd6";
}

.ri-profile-line:before {
  content: "\\efd7";
}

.ri-projector-2-fill:before {
  content: "\\efd8";
}

.ri-projector-2-line:before {
  content: "\\efd9";
}

.ri-projector-fill:before {
  content: "\\efda";
}

.ri-projector-line:before {
  content: "\\efdb";
}

.ri-pushpin-2-fill:before {
  content: "\\efdc";
}

.ri-pushpin-2-line:before {
  content: "\\efdd";
}

.ri-pushpin-fill:before {
  content: "\\efde";
}

.ri-pushpin-line:before {
  content: "\\efdf";
}

.ri-qq-fill:before {
  content: "\\efe0";
}

.ri-qq-line:before {
  content: "\\efe1";
}

.ri-qr-code-fill:before {
  content: "\\efe2";
}

.ri-qr-code-line:before {
  content: "\\efe3";
}

.ri-qr-scan-2-fill:before {
  content: "\\efe4";
}

.ri-qr-scan-2-line:before {
  content: "\\efe5";
}

.ri-qr-scan-fill:before {
  content: "\\efe6";
}

.ri-qr-scan-line:before {
  content: "\\efe7";
}

.ri-question-answer-fill:before {
  content: "\\efe8";
}

.ri-question-answer-line:before {
  content: "\\efe9";
}

.ri-question-fill:before {
  content: "\\efea";
}

.ri-question-line:before {
  content: "\\efeb";
}

.ri-questionnaire-fill:before {
  content: "\\efec";
}

.ri-questionnaire-line:before {
  content: "\\efed";
}

.ri-quill-pen-fill:before {
  content: "\\efee";
}

.ri-quill-pen-line:before {
  content: "\\efef";
}

.ri-radar-fill:before {
  content: "\\eff0";
}

.ri-radar-line:before {
  content: "\\eff1";
}

.ri-radio-2-fill:before {
  content: "\\eff2";
}

.ri-radio-2-line:before {
  content: "\\eff3";
}

.ri-radio-button-fill:before {
  content: "\\eff4";
}

.ri-radio-button-line:before {
  content: "\\eff5";
}

.ri-radio-fill:before {
  content: "\\eff6";
}

.ri-radio-line:before {
  content: "\\eff7";
}

.ri-rainbow-fill:before {
  content: "\\eff8";
}

.ri-rainbow-line:before {
  content: "\\eff9";
}

.ri-rainy-fill:before {
  content: "\\effa";
}

.ri-rainy-line:before {
  content: "\\effb";
}

.ri-reactjs-fill:before {
  content: "\\effc";
}

.ri-reactjs-line:before {
  content: "\\effd";
}

.ri-record-circle-fill:before {
  content: "\\effe";
}

.ri-record-circle-line:before {
  content: "\\efff";
}

.ri-record-mail-fill:before {
  content: "\\f000";
}

.ri-record-mail-line:before {
  content: "\\f001";
}

.ri-recycle-fill:before {
  content: "\\f002";
}

.ri-recycle-line:before {
  content: "\\f003";
}

.ri-red-packet-fill:before {
  content: "\\f004";
}

.ri-red-packet-line:before {
  content: "\\f005";
}

.ri-reddit-fill:before {
  content: "\\f006";
}

.ri-reddit-line:before {
  content: "\\f007";
}

.ri-refresh-fill:before {
  content: "\\f008";
}

.ri-refresh-line:before {
  content: "\\f009";
}

.ri-refund-2-fill:before {
  content: "\\f00a";
}

.ri-refund-2-line:before {
  content: "\\f00b";
}

.ri-refund-fill:before {
  content: "\\f00c";
}

.ri-refund-line:before {
  content: "\\f00d";
}

.ri-registered-fill:before {
  content: "\\f00e";
}

.ri-registered-line:before {
  content: "\\f00f";
}

.ri-remixicon-fill:before {
  content: "\\f010";
}

.ri-remixicon-line:before {
  content: "\\f011";
}

.ri-remote-control-2-fill:before {
  content: "\\f012";
}

.ri-remote-control-2-line:before {
  content: "\\f013";
}

.ri-remote-control-fill:before {
  content: "\\f014";
}

.ri-remote-control-line:before {
  content: "\\f015";
}

.ri-repeat-2-fill:before {
  content: "\\f016";
}

.ri-repeat-2-line:before {
  content: "\\f017";
}

.ri-repeat-fill:before {
  content: "\\f018";
}

.ri-repeat-line:before {
  content: "\\f019";
}

.ri-repeat-one-fill:before {
  content: "\\f01a";
}

.ri-repeat-one-line:before {
  content: "\\f01b";
}

.ri-reply-fill:before {
  content: "\\f01c";
}

.ri-reply-line:before {
  content: "\\f01d";
}

.ri-reserved-fill:before {
  content: "\\f01e";
}

.ri-reserved-line:before {
  content: "\\f01f";
}

.ri-restart-fill:before {
  content: "\\f020";
}

.ri-restart-line:before {
  content: "\\f021";
}

.ri-restaurant-2-fill:before {
  content: "\\f022";
}

.ri-restaurant-2-line:before {
  content: "\\f023";
}

.ri-restaurant-fill:before {
  content: "\\f024";
}

.ri-restaurant-line:before {
  content: "\\f025";
}

.ri-rewind-fill:before {
  content: "\\f026";
}

.ri-rewind-line:before {
  content: "\\f027";
}

.ri-rewind-mini-fill:before {
  content: "\\f028";
}

.ri-rewind-mini-line:before {
  content: "\\f029";
}

.ri-rhythm-fill:before {
  content: "\\f02a";
}

.ri-rhythm-line:before {
  content: "\\f02b";
}

.ri-riding-fill:before {
  content: "\\f02c";
}

.ri-riding-line:before {
  content: "\\f02d";
}

.ri-road-map-fill:before {
  content: "\\f02e";
}

.ri-road-map-line:before {
  content: "\\f02f";
}

.ri-roadster-fill:before {
  content: "\\f030";
}

.ri-roadster-line:before {
  content: "\\f031";
}

.ri-robot-fill:before {
  content: "\\f032";
}

.ri-robot-line:before {
  content: "\\f033";
}

.ri-rocket-2-fill:before {
  content: "\\f034";
}

.ri-rocket-2-line:before {
  content: "\\f035";
}

.ri-rocket-fill:before {
  content: "\\f036";
}

.ri-rocket-line:before {
  content: "\\f037";
}

.ri-rotate-lock-fill:before {
  content: "\\f038";
}

.ri-rotate-lock-line:before {
  content: "\\f039";
}

.ri-route-fill:before {
  content: "\\f03a";
}

.ri-route-line:before {
  content: "\\f03b";
}

.ri-router-fill:before {
  content: "\\f03c";
}

.ri-router-line:before {
  content: "\\f03d";
}

.ri-rss-fill:before {
  content: "\\f03e";
}

.ri-rss-line:before {
  content: "\\f03f";
}

.ri-ruler-2-fill:before {
  content: "\\f040";
}

.ri-ruler-2-line:before {
  content: "\\f041";
}

.ri-ruler-fill:before {
  content: "\\f042";
}

.ri-ruler-line:before {
  content: "\\f043";
}

.ri-run-fill:before {
  content: "\\f044";
}

.ri-run-line:before {
  content: "\\f045";
}

.ri-safari-fill:before {
  content: "\\f046";
}

.ri-safari-line:before {
  content: "\\f047";
}

.ri-safe-2-fill:before {
  content: "\\f048";
}

.ri-safe-2-line:before {
  content: "\\f049";
}

.ri-safe-fill:before {
  content: "\\f04a";
}

.ri-safe-line:before {
  content: "\\f04b";
}

.ri-sailboat-fill:before {
  content: "\\f04c";
}

.ri-sailboat-line:before {
  content: "\\f04d";
}

.ri-save-2-fill:before {
  content: "\\f04e";
}

.ri-save-2-line:before {
  content: "\\f04f";
}

.ri-save-3-fill:before {
  content: "\\f050";
}

.ri-save-3-line:before {
  content: "\\f051";
}

.ri-save-fill:before {
  content: "\\f052";
}

.ri-save-line:before {
  content: "\\f053";
}

.ri-scales-2-fill:before {
  content: "\\f054";
}

.ri-scales-2-line:before {
  content: "\\f055";
}

.ri-scales-fill:before {
  content: "\\f056";
}

.ri-scales-line:before {
  content: "\\f057";
}

.ri-scan-2-fill:before {
  content: "\\f058";
}

.ri-scan-2-line:before {
  content: "\\f059";
}

.ri-scan-fill:before {
  content: "\\f05a";
}

.ri-scan-line:before {
  content: "\\f05b";
}

.ri-scissors-2-fill:before {
  content: "\\f05c";
}

.ri-scissors-2-line:before {
  content: "\\f05d";
}

.ri-scissors-cut-fill:before {
  content: "\\f05e";
}

.ri-scissors-cut-line:before {
  content: "\\f05f";
}

.ri-scissors-fill:before {
  content: "\\f060";
}

.ri-scissors-line:before {
  content: "\\f061";
}

.ri-screenshot-2-fill:before {
  content: "\\f062";
}

.ri-screenshot-2-line:before {
  content: "\\f063";
}

.ri-screenshot-fill:before {
  content: "\\f064";
}

.ri-screenshot-line:before {
  content: "\\f065";
}

.ri-sd-card-fill:before {
  content: "\\f066";
}

.ri-sd-card-line:before {
  content: "\\f067";
}

.ri-sd-card-mini-fill:before {
  content: "\\f068";
}

.ri-sd-card-mini-line:before {
  content: "\\f069";
}

.ri-search-2-fill:before {
  content: "\\f06a";
}

.ri-search-2-line:before {
  content: "\\f06b";
}

.ri-search-eye-fill:before {
  content: "\\f06c";
}

.ri-search-eye-line:before {
  content: "\\f06d";
}

.ri-search-fill:before {
  content: "\\f06e";
}

.ri-search-line:before {
  content: "\\f06f";
}

.ri-secure-payment-fill:before {
  content: "\\f070";
}

.ri-secure-payment-line:before {
  content: "\\f071";
}

.ri-send-backward:before {
  content: "\\f072";
}

.ri-send-plane-2-fill:before {
  content: "\\f073";
}

.ri-send-plane-2-line:before {
  content: "\\f074";
}

.ri-send-plane-fill:before {
  content: "\\f075";
}

.ri-send-plane-line:before {
  content: "\\f076";
}

.ri-send-to-back:before {
  content: "\\f077";
}

.ri-sensor-fill:before {
  content: "\\f078";
}

.ri-sensor-line:before {
  content: "\\f079";
}

.ri-separator:before {
  content: "\\f07a";
}

.ri-server-fill:before {
  content: "\\f07b";
}

.ri-server-line:before {
  content: "\\f07c";
}

.ri-service-fill:before {
  content: "\\f07d";
}

.ri-service-line:before {
  content: "\\f07e";
}

.ri-settings-2-fill:before {
  content: "\\f07f";
}

.ri-settings-2-line:before {
  content: "\\f080";
}

.ri-settings-3-fill:before {
  content: "\\f081";
}

.ri-settings-3-line:before {
  content: "\\f082";
}

.ri-settings-4-fill:before {
  content: "\\f083";
}

.ri-settings-4-line:before {
  content: "\\f084";
}

.ri-settings-5-fill:before {
  content: "\\f085";
}

.ri-settings-5-line:before {
  content: "\\f086";
}

.ri-settings-6-fill:before {
  content: "\\f087";
}

.ri-settings-6-line:before {
  content: "\\f088";
}

.ri-settings-fill:before {
  content: "\\f089";
}

.ri-settings-line:before {
  content: "\\f08a";
}

.ri-shape-2-fill:before {
  content: "\\f08b";
}

.ri-shape-2-line:before {
  content: "\\f08c";
}

.ri-shape-fill:before {
  content: "\\f08d";
}

.ri-shape-line:before {
  content: "\\f08e";
}

.ri-share-box-fill:before {
  content: "\\f08f";
}

.ri-share-box-line:before {
  content: "\\f090";
}

.ri-share-circle-fill:before {
  content: "\\f091";
}

.ri-share-circle-line:before {
  content: "\\f092";
}

.ri-share-fill:before {
  content: "\\f093";
}

.ri-share-forward-2-fill:before {
  content: "\\f094";
}

.ri-share-forward-2-line:before {
  content: "\\f095";
}

.ri-share-forward-box-fill:before {
  content: "\\f096";
}

.ri-share-forward-box-line:before {
  content: "\\f097";
}

.ri-share-forward-fill:before {
  content: "\\f098";
}

.ri-share-forward-line:before {
  content: "\\f099";
}

.ri-share-line:before {
  content: "\\f09a";
}

.ri-shield-cross-fill:before {
  content: "\\f09b";
}

.ri-shield-cross-line:before {
  content: "\\f09c";
}

.ri-shield-fill:before {
  content: "\\f09d";
}

.ri-shield-flash-fill:before {
  content: "\\f09e";
}

.ri-shield-flash-line:before {
  content: "\\f09f";
}

.ri-shield-keyhole-fill:before {
  content: "\\f0a0";
}

.ri-shield-keyhole-line:before {
  content: "\\f0a1";
}

.ri-shield-line:before {
  content: "\\f0a2";
}

.ri-shield-star-fill:before {
  content: "\\f0a3";
}

.ri-shield-star-line:before {
  content: "\\f0a4";
}

.ri-shield-user-fill:before {
  content: "\\f0a5";
}

.ri-shield-user-line:before {
  content: "\\f0a6";
}

.ri-ship-2-fill:before {
  content: "\\f0a7";
}

.ri-ship-2-line:before {
  content: "\\f0a8";
}

.ri-ship-fill:before {
  content: "\\f0a9";
}

.ri-ship-line:before {
  content: "\\f0aa";
}

.ri-shirt-fill:before {
  content: "\\f0ab";
}

.ri-shirt-line:before {
  content: "\\f0ac";
}

.ri-shopping-bag-2-fill:before {
  content: "\\f0ad";
}

.ri-shopping-bag-2-line:before {
  content: "\\f0ae";
}

.ri-shopping-bag-3-fill:before {
  content: "\\f0af";
}

.ri-shopping-bag-3-line:before {
  content: "\\f0b0";
}

.ri-shopping-bag-fill:before {
  content: "\\f0b1";
}

.ri-shopping-bag-line:before {
  content: "\\f0b2";
}

.ri-shopping-basket-2-fill:before {
  content: "\\f0b3";
}

.ri-shopping-basket-2-line:before {
  content: "\\f0b4";
}

.ri-shopping-basket-fill:before {
  content: "\\f0b5";
}

.ri-shopping-basket-line:before {
  content: "\\f0b6";
}

.ri-shopping-cart-2-fill:before {
  content: "\\f0b7";
}

.ri-shopping-cart-2-line:before {
  content: "\\f0b8";
}

.ri-shopping-cart-fill:before {
  content: "\\f0b9";
}

.ri-shopping-cart-line:before {
  content: "\\f0ba";
}

.ri-showers-fill:before {
  content: "\\f0bb";
}

.ri-showers-line:before {
  content: "\\f0bc";
}

.ri-shuffle-fill:before {
  content: "\\f0bd";
}

.ri-shuffle-line:before {
  content: "\\f0be";
}

.ri-shut-down-fill:before {
  content: "\\f0bf";
}

.ri-shut-down-line:before {
  content: "\\f0c0";
}

.ri-side-bar-fill:before {
  content: "\\f0c1";
}

.ri-side-bar-line:before {
  content: "\\f0c2";
}

.ri-signal-tower-fill:before {
  content: "\\f0c3";
}

.ri-signal-tower-line:before {
  content: "\\f0c4";
}

.ri-signal-wifi-1-fill:before {
  content: "\\f0c5";
}

.ri-signal-wifi-1-line:before {
  content: "\\f0c6";
}

.ri-signal-wifi-2-fill:before {
  content: "\\f0c7";
}

.ri-signal-wifi-2-line:before {
  content: "\\f0c8";
}

.ri-signal-wifi-3-fill:before {
  content: "\\f0c9";
}

.ri-signal-wifi-3-line:before {
  content: "\\f0ca";
}

.ri-signal-wifi-error-fill:before {
  content: "\\f0cb";
}

.ri-signal-wifi-error-line:before {
  content: "\\f0cc";
}

.ri-signal-wifi-fill:before {
  content: "\\f0cd";
}

.ri-signal-wifi-line:before {
  content: "\\f0ce";
}

.ri-signal-wifi-off-fill:before {
  content: "\\f0cf";
}

.ri-signal-wifi-off-line:before {
  content: "\\f0d0";
}

.ri-sim-card-2-fill:before {
  content: "\\f0d1";
}

.ri-sim-card-2-line:before {
  content: "\\f0d2";
}

.ri-sim-card-fill:before {
  content: "\\f0d3";
}

.ri-sim-card-line:before {
  content: "\\f0d4";
}

.ri-single-quotes-l:before {
  content: "\\f0d5";
}

.ri-single-quotes-r:before {
  content: "\\f0d6";
}

.ri-sip-fill:before {
  content: "\\f0d7";
}

.ri-sip-line:before {
  content: "\\f0d8";
}

.ri-skip-back-fill:before {
  content: "\\f0d9";
}

.ri-skip-back-line:before {
  content: "\\f0da";
}

.ri-skip-back-mini-fill:before {
  content: "\\f0db";
}

.ri-skip-back-mini-line:before {
  content: "\\f0dc";
}

.ri-skip-forward-fill:before {
  content: "\\f0dd";
}

.ri-skip-forward-line:before {
  content: "\\f0de";
}

.ri-skip-forward-mini-fill:before {
  content: "\\f0df";
}

.ri-skip-forward-mini-line:before {
  content: "\\f0e0";
}

.ri-skull-2-fill:before {
  content: "\\f0e1";
}

.ri-skull-2-line:before {
  content: "\\f0e2";
}

.ri-skull-fill:before {
  content: "\\f0e3";
}

.ri-skull-line:before {
  content: "\\f0e4";
}

.ri-skype-fill:before {
  content: "\\f0e5";
}

.ri-skype-line:before {
  content: "\\f0e6";
}

.ri-slack-fill:before {
  content: "\\f0e7";
}

.ri-slack-line:before {
  content: "\\f0e8";
}

.ri-slice-fill:before {
  content: "\\f0e9";
}

.ri-slice-line:before {
  content: "\\f0ea";
}

.ri-slideshow-2-fill:before {
  content: "\\f0eb";
}

.ri-slideshow-2-line:before {
  content: "\\f0ec";
}

.ri-slideshow-3-fill:before {
  content: "\\f0ed";
}

.ri-slideshow-3-line:before {
  content: "\\f0ee";
}

.ri-slideshow-4-fill:before {
  content: "\\f0ef";
}

.ri-slideshow-4-line:before {
  content: "\\f0f0";
}

.ri-slideshow-fill:before {
  content: "\\f0f1";
}

.ri-slideshow-line:before {
  content: "\\f0f2";
}

.ri-smartphone-fill:before {
  content: "\\f0f3";
}

.ri-smartphone-line:before {
  content: "\\f0f4";
}

.ri-snapchat-fill:before {
  content: "\\f0f5";
}

.ri-snapchat-line:before {
  content: "\\f0f6";
}

.ri-snowy-fill:before {
  content: "\\f0f7";
}

.ri-snowy-line:before {
  content: "\\f0f8";
}

.ri-sort-asc:before {
  content: "\\f0f9";
}

.ri-sort-desc:before {
  content: "\\f0fa";
}

.ri-sound-module-fill:before {
  content: "\\f0fb";
}

.ri-sound-module-line:before {
  content: "\\f0fc";
}

.ri-soundcloud-fill:before {
  content: "\\f0fd";
}

.ri-soundcloud-line:before {
  content: "\\f0fe";
}

.ri-space-ship-fill:before {
  content: "\\f0ff";
}

.ri-space-ship-line:before {
  content: "\\f100";
}

.ri-space:before {
  content: "\\f101";
}

.ri-spam-2-fill:before {
  content: "\\f102";
}

.ri-spam-2-line:before {
  content: "\\f103";
}

.ri-spam-3-fill:before {
  content: "\\f104";
}

.ri-spam-3-line:before {
  content: "\\f105";
}

.ri-spam-fill:before {
  content: "\\f106";
}

.ri-spam-line:before {
  content: "\\f107";
}

.ri-speaker-2-fill:before {
  content: "\\f108";
}

.ri-speaker-2-line:before {
  content: "\\f109";
}

.ri-speaker-3-fill:before {
  content: "\\f10a";
}

.ri-speaker-3-line:before {
  content: "\\f10b";
}

.ri-speaker-fill:before {
  content: "\\f10c";
}

.ri-speaker-line:before {
  content: "\\f10d";
}

.ri-spectrum-fill:before {
  content: "\\f10e";
}

.ri-spectrum-line:before {
  content: "\\f10f";
}

.ri-speed-fill:before {
  content: "\\f110";
}

.ri-speed-line:before {
  content: "\\f111";
}

.ri-speed-mini-fill:before {
  content: "\\f112";
}

.ri-speed-mini-line:before {
  content: "\\f113";
}

.ri-spotify-fill:before {
  content: "\\f114";
}

.ri-spotify-line:before {
  content: "\\f115";
}

.ri-spy-fill:before {
  content: "\\f116";
}

.ri-spy-line:before {
  content: "\\f117";
}

.ri-stack-fill:before {
  content: "\\f118";
}

.ri-stack-line:before {
  content: "\\f119";
}

.ri-stack-overflow-fill:before {
  content: "\\f11a";
}

.ri-stack-overflow-line:before {
  content: "\\f11b";
}

.ri-stackshare-fill:before {
  content: "\\f11c";
}

.ri-stackshare-line:before {
  content: "\\f11d";
}

.ri-star-fill:before {
  content: "\\f11e";
}

.ri-star-half-fill:before {
  content: "\\f11f";
}

.ri-star-half-line:before {
  content: "\\f120";
}

.ri-star-half-s-fill:before {
  content: "\\f121";
}

.ri-star-half-s-line:before {
  content: "\\f122";
}

.ri-star-line:before {
  content: "\\f123";
}

.ri-star-s-fill:before {
  content: "\\f124";
}

.ri-star-s-line:before {
  content: "\\f125";
}

.ri-star-smile-fill:before {
  content: "\\f126";
}

.ri-star-smile-line:before {
  content: "\\f127";
}

.ri-steam-fill:before {
  content: "\\f128";
}

.ri-steam-line:before {
  content: "\\f129";
}

.ri-steering-2-fill:before {
  content: "\\f12a";
}

.ri-steering-2-line:before {
  content: "\\f12b";
}

.ri-steering-fill:before {
  content: "\\f12c";
}

.ri-steering-line:before {
  content: "\\f12d";
}

.ri-sticky-note-2-fill:before {
  content: "\\f12e";
}

.ri-sticky-note-2-line:before {
  content: "\\f12f";
}

.ri-sticky-note-fill:before {
  content: "\\f130";
}

.ri-sticky-note-line:before {
  content: "\\f131";
}

.ri-stock-fill:before {
  content: "\\f132";
}

.ri-stock-line:before {
  content: "\\f133";
}

.ri-stop-circle-fill:before {
  content: "\\f134";
}

.ri-stop-circle-line:before {
  content: "\\f135";
}

.ri-stop-fill:before {
  content: "\\f136";
}

.ri-stop-line:before {
  content: "\\f137";
}

.ri-stop-mini-fill:before {
  content: "\\f138";
}

.ri-stop-mini-line:before {
  content: "\\f139";
}

.ri-store-2-fill:before {
  content: "\\f13a";
}

.ri-store-2-line:before {
  content: "\\f13b";
}

.ri-store-3-fill:before {
  content: "\\f13c";
}

.ri-store-3-line:before {
  content: "\\f13d";
}

.ri-store-fill:before {
  content: "\\f13e";
}

.ri-store-line:before {
  content: "\\f13f";
}

.ri-strikethrough-2:before {
  content: "\\f140";
}

.ri-strikethrough:before {
  content: "\\f141";
}

.ri-subscript-2:before {
  content: "\\f142";
}

.ri-subscript:before {
  content: "\\f143";
}

.ri-subtract-fill:before {
  content: "\\f144";
}

.ri-subtract-line:before {
  content: "\\f145";
}

.ri-subway-fill:before {
  content: "\\f146";
}

.ri-subway-line:before {
  content: "\\f147";
}

.ri-subway-wifi-fill:before {
  content: "\\f148";
}

.ri-subway-wifi-line:before {
  content: "\\f149";
}

.ri-suitcase-2-fill:before {
  content: "\\f14a";
}

.ri-suitcase-2-line:before {
  content: "\\f14b";
}

.ri-suitcase-3-fill:before {
  content: "\\f14c";
}

.ri-suitcase-3-line:before {
  content: "\\f14d";
}

.ri-suitcase-fill:before {
  content: "\\f14e";
}

.ri-suitcase-line:before {
  content: "\\f14f";
}

.ri-sun-cloudy-fill:before {
  content: "\\f150";
}

.ri-sun-cloudy-line:before {
  content: "\\f151";
}

.ri-sun-fill:before {
  content: "\\f152";
}

.ri-sun-foggy-fill:before {
  content: "\\f153";
}

.ri-sun-foggy-line:before {
  content: "\\f154";
}

.ri-sun-line:before {
  content: "\\f155";
}

.ri-superscript-2:before {
  content: "\\f156";
}

.ri-superscript:before {
  content: "\\f157";
}

.ri-surround-sound-fill:before {
  content: "\\f158";
}

.ri-surround-sound-line:before {
  content: "\\f159";
}

.ri-survey-fill:before {
  content: "\\f15a";
}

.ri-survey-line:before {
  content: "\\f15b";
}

.ri-swap-box-fill:before {
  content: "\\f15c";
}

.ri-swap-box-line:before {
  content: "\\f15d";
}

.ri-swap-fill:before {
  content: "\\f15e";
}

.ri-swap-line:before {
  content: "\\f15f";
}

.ri-switch-fill:before {
  content: "\\f160";
}

.ri-switch-line:before {
  content: "\\f161";
}

.ri-sword-fill:before {
  content: "\\f162";
}

.ri-sword-line:before {
  content: "\\f163";
}

.ri-t-box-fill:before {
  content: "\\f164";
}

.ri-t-box-line:before {
  content: "\\f165";
}

.ri-t-shirt-2-fill:before {
  content: "\\f166";
}

.ri-t-shirt-2-line:before {
  content: "\\f167";
}

.ri-t-shirt-air-fill:before {
  content: "\\f168";
}

.ri-t-shirt-air-line:before {
  content: "\\f169";
}

.ri-t-shirt-fill:before {
  content: "\\f16a";
}

.ri-t-shirt-line:before {
  content: "\\f16b";
}

.ri-table-2:before {
  content: "\\f16c";
}

.ri-table-alt-fill:before {
  content: "\\f16d";
}

.ri-table-alt-line:before {
  content: "\\f16e";
}

.ri-table-fill:before {
  content: "\\f16f";
}

.ri-table-line:before {
  content: "\\f170";
}

.ri-tablet-fill:before {
  content: "\\f171";
}

.ri-tablet-line:before {
  content: "\\f172";
}

.ri-takeaway-fill:before {
  content: "\\f173";
}

.ri-takeaway-line:before {
  content: "\\f174";
}

.ri-taobao-fill:before {
  content: "\\f175";
}

.ri-taobao-line:before {
  content: "\\f176";
}

.ri-tape-fill:before {
  content: "\\f177";
}

.ri-tape-line:before {
  content: "\\f178";
}

.ri-task-fill:before {
  content: "\\f179";
}

.ri-task-line:before {
  content: "\\f17a";
}

.ri-taxi-fill:before {
  content: "\\f17b";
}

.ri-taxi-line:before {
  content: "\\f17c";
}

.ri-taxi-wifi-fill:before {
  content: "\\f17d";
}

.ri-taxi-wifi-line:before {
  content: "\\f17e";
}

.ri-team-fill:before {
  content: "\\f17f";
}

.ri-team-line:before {
  content: "\\f180";
}

.ri-telegram-fill:before {
  content: "\\f181";
}

.ri-telegram-line:before {
  content: "\\f182";
}

.ri-temp-cold-fill:before {
  content: "\\f183";
}

.ri-temp-cold-line:before {
  content: "\\f184";
}

.ri-temp-hot-fill:before {
  content: "\\f185";
}

.ri-temp-hot-line:before {
  content: "\\f186";
}

.ri-terminal-box-fill:before {
  content: "\\f187";
}

.ri-terminal-box-line:before {
  content: "\\f188";
}

.ri-terminal-fill:before {
  content: "\\f189";
}

.ri-terminal-line:before {
  content: "\\f18a";
}

.ri-terminal-window-fill:before {
  content: "\\f18b";
}

.ri-terminal-window-line:before {
  content: "\\f18c";
}

.ri-text-direction-l:before {
  content: "\\f18d";
}

.ri-text-direction-r:before {
  content: "\\f18e";
}

.ri-text-spacing:before {
  content: "\\f18f";
}

.ri-text-wrap:before {
  content: "\\f190";
}

.ri-text:before {
  content: "\\f191";
}

.ri-thumb-down-fill:before {
  content: "\\f192";
}

.ri-thumb-down-line:before {
  content: "\\f193";
}

.ri-thumb-up-fill:before {
  content: "\\f194";
}

.ri-thumb-up-line:before {
  content: "\\f195";
}

.ri-thunderstorms-fill:before {
  content: "\\f196";
}

.ri-thunderstorms-line:before {
  content: "\\f197";
}

.ri-ticket-2-fill:before {
  content: "\\f198";
}

.ri-ticket-2-line:before {
  content: "\\f199";
}

.ri-ticket-fill:before {
  content: "\\f19a";
}

.ri-ticket-line:before {
  content: "\\f19b";
}

.ri-time-fill:before {
  content: "\\f19c";
}

.ri-time-line:before {
  content: "\\f19d";
}

.ri-timer-2-fill:before {
  content: "\\f19e";
}

.ri-timer-2-line:before {
  content: "\\f19f";
}

.ri-timer-fill:before {
  content: "\\f1a0";
}

.ri-timer-flash-fill:before {
  content: "\\f1a1";
}

.ri-timer-flash-line:before {
  content: "\\f1a2";
}

.ri-timer-line:before {
  content: "\\f1a3";
}

.ri-todo-fill:before {
  content: "\\f1a4";
}

.ri-todo-line:before {
  content: "\\f1a5";
}

.ri-toggle-fill:before {
  content: "\\f1a6";
}

.ri-toggle-line:before {
  content: "\\f1a7";
}

.ri-tools-fill:before {
  content: "\\f1a8";
}

.ri-tools-line:before {
  content: "\\f1a9";
}

.ri-tornado-fill:before {
  content: "\\f1aa";
}

.ri-tornado-line:before {
  content: "\\f1ab";
}

.ri-trademark-fill:before {
  content: "\\f1ac";
}

.ri-trademark-line:before {
  content: "\\f1ad";
}

.ri-traffic-light-fill:before {
  content: "\\f1ae";
}

.ri-traffic-light-line:before {
  content: "\\f1af";
}

.ri-train-fill:before {
  content: "\\f1b0";
}

.ri-train-line:before {
  content: "\\f1b1";
}

.ri-train-wifi-fill:before {
  content: "\\f1b2";
}

.ri-train-wifi-line:before {
  content: "\\f1b3";
}

.ri-translate-2:before {
  content: "\\f1b4";
}

.ri-translate:before {
  content: "\\f1b5";
}

.ri-travesti-fill:before {
  content: "\\f1b6";
}

.ri-travesti-line:before {
  content: "\\f1b7";
}

.ri-treasure-map-fill:before {
  content: "\\f1b8";
}

.ri-treasure-map-line:before {
  content: "\\f1b9";
}

.ri-trello-fill:before {
  content: "\\f1ba";
}

.ri-trello-line:before {
  content: "\\f1bb";
}

.ri-trophy-fill:before {
  content: "\\f1bc";
}

.ri-trophy-line:before {
  content: "\\f1bd";
}

.ri-truck-fill:before {
  content: "\\f1be";
}

.ri-truck-line:before {
  content: "\\f1bf";
}

.ri-tumblr-fill:before {
  content: "\\f1c0";
}

.ri-tumblr-line:before {
  content: "\\f1c1";
}

.ri-tv-2-fill:before {
  content: "\\f1c2";
}

.ri-tv-2-line:before {
  content: "\\f1c3";
}

.ri-tv-fill:before {
  content: "\\f1c4";
}

.ri-tv-line:before {
  content: "\\f1c5";
}

.ri-twitch-fill:before {
  content: "\\f1c6";
}

.ri-twitch-line:before {
  content: "\\f1c7";
}

.ri-twitter-fill:before {
  content: "\\f1c8";
}

.ri-twitter-line:before {
  content: "\\f1c9";
}

.ri-typhoon-fill:before {
  content: "\\f1ca";
}

.ri-typhoon-line:before {
  content: "\\f1cb";
}

.ri-u-disk-fill:before {
  content: "\\f1cc";
}

.ri-u-disk-line:before {
  content: "\\f1cd";
}

.ri-ubuntu-fill:before {
  content: "\\f1ce";
}

.ri-ubuntu-line:before {
  content: "\\f1cf";
}

.ri-umbrella-fill:before {
  content: "\\f1d0";
}

.ri-umbrella-line:before {
  content: "\\f1d1";
}

.ri-underline:before {
  content: "\\f1d2";
}

.ri-uninstall-fill:before {
  content: "\\f1d3";
}

.ri-uninstall-line:before {
  content: "\\f1d4";
}

.ri-unsplash-fill:before {
  content: "\\f1d5";
}

.ri-unsplash-line:before {
  content: "\\f1d6";
}

.ri-upload-2-fill:before {
  content: "\\f1d7";
}

.ri-upload-2-line:before {
  content: "\\f1d8";
}

.ri-upload-cloud-2-fill:before {
  content: "\\f1d9";
}

.ri-upload-cloud-2-line:before {
  content: "\\f1da";
}

.ri-upload-cloud-fill:before {
  content: "\\f1db";
}

.ri-upload-cloud-line:before {
  content: "\\f1dc";
}

.ri-upload-fill:before {
  content: "\\f1dd";
}

.ri-upload-line:before {
  content: "\\f1de";
}

.ri-user-2-fill:before {
  content: "\\f1df";
}

.ri-user-2-line:before {
  content: "\\f1e0";
}

.ri-user-3-fill:before {
  content: "\\f1e1";
}

.ri-user-3-line:before {
  content: "\\f1e2";
}

.ri-user-4-fill:before {
  content: "\\f1e3";
}

.ri-user-4-line:before {
  content: "\\f1e4";
}

.ri-user-5-fill:before {
  content: "\\f1e5";
}

.ri-user-5-line:before {
  content: "\\f1e6";
}

.ri-user-6-fill:before {
  content: "\\f1e7";
}

.ri-user-6-line:before {
  content: "\\f1e8";
}

.ri-user-add-fill:before {
  content: "\\f1e9";
}

.ri-user-add-line:before {
  content: "\\f1ea";
}

.ri-user-fill:before {
  content: "\\f1eb";
}

.ri-user-follow-fill:before {
  content: "\\f1ec";
}

.ri-user-follow-line:before {
  content: "\\f1ed";
}

.ri-user-heart-fill:before {
  content: "\\f1ee";
}

.ri-user-heart-line:before {
  content: "\\f1ef";
}

.ri-user-line:before {
  content: "\\f1f0";
}

.ri-user-location-fill:before {
  content: "\\f1f1";
}

.ri-user-location-line:before {
  content: "\\f1f2";
}

.ri-user-received-2-fill:before {
  content: "\\f1f3";
}

.ri-user-received-2-line:before {
  content: "\\f1f4";
}

.ri-user-received-fill:before {
  content: "\\f1f5";
}

.ri-user-received-line:before {
  content: "\\f1f6";
}

.ri-user-search-fill:before {
  content: "\\f1f7";
}

.ri-user-search-line:before {
  content: "\\f1f8";
}

.ri-user-settings-fill:before {
  content: "\\f1f9";
}

.ri-user-settings-line:before {
  content: "\\f1fa";
}

.ri-user-shared-2-fill:before {
  content: "\\f1fb";
}

.ri-user-shared-2-line:before {
  content: "\\f1fc";
}

.ri-user-shared-fill:before {
  content: "\\f1fd";
}

.ri-user-shared-line:before {
  content: "\\f1fe";
}

.ri-user-smile-fill:before {
  content: "\\f1ff";
}

.ri-user-smile-line:before {
  content: "\\f200";
}

.ri-user-star-fill:before {
  content: "\\f201";
}

.ri-user-star-line:before {
  content: "\\f202";
}

.ri-user-unfollow-fill:before {
  content: "\\f203";
}

.ri-user-unfollow-line:before {
  content: "\\f204";
}

.ri-user-voice-fill:before {
  content: "\\f205";
}

.ri-user-voice-line:before {
  content: "\\f206";
}

.ri-video-add-fill:before {
  content: "\\f207";
}

.ri-video-add-line:before {
  content: "\\f208";
}

.ri-video-chat-fill:before {
  content: "\\f209";
}

.ri-video-chat-line:before {
  content: "\\f20a";
}

.ri-video-download-fill:before {
  content: "\\f20b";
}

.ri-video-download-line:before {
  content: "\\f20c";
}

.ri-video-fill:before {
  content: "\\f20d";
}

.ri-video-line:before {
  content: "\\f20e";
}

.ri-video-upload-fill:before {
  content: "\\f20f";
}

.ri-video-upload-line:before {
  content: "\\f210";
}

.ri-vidicon-2-fill:before {
  content: "\\f211";
}

.ri-vidicon-2-line:before {
  content: "\\f212";
}

.ri-vidicon-fill:before {
  content: "\\f213";
}

.ri-vidicon-line:before {
  content: "\\f214";
}

.ri-vip-crown-2-fill:before {
  content: "\\f215";
}

.ri-vip-crown-2-line:before {
  content: "\\f216";
}

.ri-vip-crown-fill:before {
  content: "\\f217";
}

.ri-vip-crown-line:before {
  content: "\\f218";
}

.ri-vip-diamond-fill:before {
  content: "\\f219";
}

.ri-vip-diamond-line:before {
  content: "\\f21a";
}

.ri-vip-fill:before {
  content: "\\f21b";
}

.ri-vip-line:before {
  content: "\\f21c";
}

.ri-visa-fill:before {
  content: "\\f21d";
}

.ri-visa-line:before {
  content: "\\f21e";
}

.ri-voice-recognition-fill:before {
  content: "\\f21f";
}

.ri-voice-recognition-line:before {
  content: "\\f220";
}

.ri-voiceprint-fill:before {
  content: "\\f221";
}

.ri-voiceprint-line:before {
  content: "\\f222";
}

.ri-volume-down-fill:before {
  content: "\\f223";
}

.ri-volume-down-line:before {
  content: "\\f224";
}

.ri-volume-mute-fill:before {
  content: "\\f225";
}

.ri-volume-mute-line:before {
  content: "\\f226";
}

.ri-volume-off-vibrate-fill:before {
  content: "\\f227";
}

.ri-volume-off-vibrate-line:before {
  content: "\\f228";
}

.ri-volume-up-fill:before {
  content: "\\f229";
}

.ri-volume-up-line:before {
  content: "\\f22a";
}

.ri-volume-vibrate-fill:before {
  content: "\\f22b";
}

.ri-volume-vibrate-line:before {
  content: "\\f22c";
}

.ri-vuejs-fill:before {
  content: "\\f22d";
}

.ri-vuejs-line:before {
  content: "\\f22e";
}

.ri-walk-fill:before {
  content: "\\f22f";
}

.ri-walk-line:before {
  content: "\\f230";
}

.ri-wallet-2-fill:before {
  content: "\\f231";
}

.ri-wallet-2-line:before {
  content: "\\f232";
}

.ri-wallet-3-fill:before {
  content: "\\f233";
}

.ri-wallet-3-line:before {
  content: "\\f234";
}

.ri-wallet-fill:before {
  content: "\\f235";
}

.ri-wallet-line:before {
  content: "\\f236";
}

.ri-water-flash-fill:before {
  content: "\\f237";
}

.ri-water-flash-line:before {
  content: "\\f238";
}

.ri-webcam-fill:before {
  content: "\\f239";
}

.ri-webcam-line:before {
  content: "\\f23a";
}

.ri-wechat-2-fill:before {
  content: "\\f23b";
}

.ri-wechat-2-line:before {
  content: "\\f23c";
}

.ri-wechat-fill:before {
  content: "\\f23d";
}

.ri-wechat-line:before {
  content: "\\f23e";
}

.ri-wechat-pay-fill:before {
  content: "\\f23f";
}

.ri-wechat-pay-line:before {
  content: "\\f240";
}

.ri-weibo-fill:before {
  content: "\\f241";
}

.ri-weibo-line:before {
  content: "\\f242";
}

.ri-whatsapp-fill:before {
  content: "\\f243";
}

.ri-whatsapp-line:before {
  content: "\\f244";
}

.ri-wheelchair-fill:before {
  content: "\\f245";
}

.ri-wheelchair-line:before {
  content: "\\f246";
}

.ri-wifi-fill:before {
  content: "\\f247";
}

.ri-wifi-line:before {
  content: "\\f248";
}

.ri-wifi-off-fill:before {
  content: "\\f249";
}

.ri-wifi-off-line:before {
  content: "\\f24a";
}

.ri-window-2-fill:before {
  content: "\\f24b";
}

.ri-window-2-line:before {
  content: "\\f24c";
}

.ri-window-fill:before {
  content: "\\f24d";
}

.ri-window-line:before {
  content: "\\f24e";
}

.ri-windows-fill:before {
  content: "\\f24f";
}

.ri-windows-line:before {
  content: "\\f250";
}

.ri-windy-fill:before {
  content: "\\f251";
}

.ri-windy-line:before {
  content: "\\f252";
}

.ri-wireless-charging-fill:before {
  content: "\\f253";
}

.ri-wireless-charging-line:before {
  content: "\\f254";
}

.ri-women-fill:before {
  content: "\\f255";
}

.ri-women-line:before {
  content: "\\f256";
}

.ri-wubi-input:before {
  content: "\\f257";
}

.ri-xbox-fill:before {
  content: "\\f258";
}

.ri-xbox-line:before {
  content: "\\f259";
}

.ri-xing-fill:before {
  content: "\\f25a";
}

.ri-xing-line:before {
  content: "\\f25b";
}

.ri-youtube-fill:before {
  content: "\\f25c";
}

.ri-youtube-line:before {
  content: "\\f25d";
}

.ri-zcool-fill:before {
  content: "\\f25e";
}

.ri-zcool-line:before {
  content: "\\f25f";
}

.ri-zhihu-fill:before {
  content: "\\f260";
}

.ri-zhihu-line:before {
  content: "\\f261";
}

.ri-zoom-in-fill:before {
  content: "\\f262";
}

.ri-zoom-in-line:before {
  content: "\\f263";
}

.ri-zoom-out-fill:before {
  content: "\\f264";
}

.ri-zoom-out-line:before {
  content: "\\f265";
}

/*
Template Name: Nazox -  Admin & Dashboard Template
Author: Themesdesign
Version: 2.3.0
Contact: themesdesign.in@gmail.com
File: Custom Bootstrap Css File
*/
/*!
 * Bootstrap  v5.3.3 (https://getbootstrap.com/)
 * Copyright 2011-2024 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #5664d2;
  --bs-indigo: #564ab1;
  --bs-purple: #5664d2;
  --bs-pink: #e83e8c;
  --bs-red: #ff3d60;
  --bs-orange: #f1734f;
  --bs-yellow: #fcb92c;
  --bs-green: #1cbb8c;
  --bs-teal: #050505;
  --bs-cyan: #4aa3ff;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #74788d;
  --bs-gray-dark: #252b3b;
  --bs-gray-100: #faf8f8;
  --bs-gray-200: #f7efef;
  --bs-gray-300: #aaa9a9;
  --bs-gray-400: #dad1ce;
  --bs-gray-500: #bdbcad;
  --bs-gray-600: #74788d;
  --bs-gray-700: #2d3448;
  --bs-gray-800: #252b3b;
  --bs-gray-900: #212529;
  --bs-primary: rgb(255, 90, 95);
  --bs-secondary: #008489;
  --bs-success: #1cbb8c;
  --bs-info: #4aa3ff;
  --bs-warning: #fcb92c;
  --bs-danger: #ff3d60;
  --bs-light: #faf8f8;
  --bs-dark: #212529;
  --bs-primary-rgb: 255, 90, 95;
  --bs-secondary-rgb: 0, 132, 137;
  --bs-success-rgb: 28, 187, 140;
  --bs-info-rgb: 74, 163, 255;
  --bs-warning-rgb: 252, 185, 44;
  --bs-danger-rgb: 255, 61, 96;
  --bs-light-rgb: 250, 248, 248;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: #662426;
  --bs-secondary-text-emphasis: rgb(0, 52.8, 54.8);
  --bs-success-text-emphasis: rgb(11.2, 74.8, 56);
  --bs-info-text-emphasis: rgb(29.6, 65.2, 102);
  --bs-warning-text-emphasis: rgb(100.8, 74, 17.6);
  --bs-danger-text-emphasis: rgb(102, 24.4, 38.4);
  --bs-light-text-emphasis: #2d3448;
  --bs-dark-text-emphasis: #2d3448;
  --bs-primary-bg-subtle: #ffdedf;
  --bs-secondary-bg-subtle: rgb(204, 230.4, 231.4);
  --bs-success-bg-subtle: rgb(209.6, 241.4, 232);
  --bs-info-bg-subtle: rgb(218.8, 236.6, 255);
  --bs-warning-bg-subtle: rgb(254.4, 241, 212.8);
  --bs-danger-bg-subtle: rgb(255, 216.2, 223.2);
  --bs-light-bg-subtle: rgb(252.5, 251.5, 251.5);
  --bs-dark-bg-subtle: #dad1ce;
  --bs-primary-border-subtle: #ffbdbf;
  --bs-secondary-border-subtle: rgb(153, 205.8, 207.8);
  --bs-success-border-subtle: rgb(164.2, 227.8, 209);
  --bs-info-border-subtle: rgb(182.6, 218.2, 255);
  --bs-warning-border-subtle: rgb(253.8, 227, 170.6);
  --bs-danger-border-subtle: rgb(255, 177.4, 191.4);
  --bs-light-border-subtle: #f7efef;
  --bs-dark-border-subtle: #bdbcad;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: "Nunito", sans-serif;
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 0.9rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #f1f5f7;
  --bs-body-bg-rgb: 241, 245, 247;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #fff;
  --bs-secondary-bg-rgb: 255, 255, 255;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #faf8f8;
  --bs-tertiary-bg-rgb: 250, 248, 248;
  --bs-heading-color: #252b3b;
  --bs-link-color: #008489;
  --bs-link-color-rgb: 0, 132, 137;
  --bs-link-decoration: none;
  --bs-link-hover-color: rgb(0, 105.6, 109.6);
  --bs-link-hover-color-rgb: 0, 106, 110;
  --bs-link-hover-decoration: underline;
  --bs-code-color: #e83e8c;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fcf8e3;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #aaa9a9;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  --bs-box-shadow-sm: 0 1px 1px rgba(0, 0, 0, 0.05);
  --bs-box-shadow-lg: 0 5px 12px rgba(0, 0, 0, 0.1);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(255, 90, 95, 0.25);
  --bs-form-valid-color: #1cbb8c;
  --bs-form-valid-border-color: #1cbb8c;
  --bs-form-invalid-color: #ff3d60;
  --bs-form-invalid-border-color: #ff3d60;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #bdbcad;
  --bs-body-color-rgb: 189, 188, 173;
  --bs-body-bg: #171d37;
  --bs-body-bg-rgb: 23, 29, 55;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(189, 188, 173, 0.75);
  --bs-secondary-color-rgb: 189, 188, 173;
  --bs-secondary-bg: #252b3b;
  --bs-secondary-bg-rgb: 37, 43, 59;
  --bs-tertiary-color: rgba(189, 188, 173, 0.5);
  --bs-tertiary-color-rgb: 189, 188, 173;
  --bs-tertiary-bg: #0e142f;
  --bs-tertiary-bg-rgb: 14, 20, 47;
  --bs-primary-text-emphasis: #ff9c9f;
  --bs-secondary-text-emphasis: rgb(102, 181.2, 184.2);
  --bs-success-text-emphasis: rgb(118.8, 214.2, 186);
  --bs-info-text-emphasis: rgb(146.4, 199.8, 255);
  --bs-warning-text-emphasis: rgb(253.2, 213, 128.4);
  --bs-danger-text-emphasis: rgb(255, 138.6, 159.6);
  --bs-light-text-emphasis: #faf8f8;
  --bs-dark-text-emphasis: #aaa9a9;
  --bs-primary-bg-subtle: #662426;
  --bs-secondary-bg-subtle: rgb(0, 52.8, 54.8);
  --bs-success-bg-subtle: rgb(11.2, 74.8, 56);
  --bs-info-bg-subtle: rgb(29.6, 65.2, 102);
  --bs-warning-bg-subtle: rgb(100.8, 74, 17.6);
  --bs-danger-bg-subtle: rgb(102, 24.4, 38.4);
  --bs-light-bg-subtle: #252b3b;
  --bs-dark-bg-subtle: rgb(18.5, 21.5, 29.5);
  --bs-primary-border-subtle: #993639;
  --bs-secondary-border-subtle: rgb(0, 79.2, 82.2);
  --bs-success-border-subtle: rgb(16.8, 112.2, 84);
  --bs-info-border-subtle: rgb(44.4, 97.8, 153);
  --bs-warning-border-subtle: rgb(151.2, 111, 26.4);
  --bs-danger-border-subtle: rgb(153, 36.6, 57.6);
  --bs-light-border-subtle: #2d3448;
  --bs-dark-border-subtle: #252b3b;
  --bs-heading-color: #fff;
  --bs-link-color: #ff9c9f;
  --bs-link-hover-color: rgb(255, 175.8, 178.2);
  --bs-link-color-rgb: 255, 156, 159;
  --bs-link-hover-color-rgb: 255, 176, 178;
  --bs-code-color: rgb(241.2, 139.2, 186);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(102, 77.2, 2.8);
  --bs-border-color: #0e142f;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(118.8, 214.2, 186);
  --bs-form-valid-border-color: rgb(118.8, 214.2, 186);
  --bs-form-invalid-color: rgb(255, 138.6, 159.6);
  --bs-form-invalid-border-color: rgb(255, 138.6, 159.6);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: rgba(0, 0, 0, 0.1);
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.7;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.35rem + 1.2vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.25rem;
  }
}

h2, .h2 {
  font-size: calc(1.305rem + 0.66vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.8rem;
  }
}

h3, .h3 {
  font-size: calc(1.2825rem + 0.39vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.575rem;
  }
}

h4, .h4 {
  font-size: calc(1.26rem + 0.12vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.35rem;
  }
}

h5, .h5 {
  font-size: 1.125rem;
}

h6, .h6 {
  font-size: 0.9rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 800;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 80%;
}

mark, .mark {
  padding: 0.2em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: none;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
  text-decoration: underline;
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 87.5%;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.125rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 80%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.125rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 80%;
  color: #74788d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 80%;
  color: #74788d;
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 0.75rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-body-color);
  --bs-table-bg: var(--bs-table-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-body-color);
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: var(--bs-body-color);
  --bs-table-active-bg: rgba(0, 0, 0, 0.1);
  --bs-table-hover-color: var(--bs-body-color);
  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.75rem 0.75rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid #aaa9a9;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.3rem 0.3rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #ffdedf;
  --bs-table-border-color: rgb(229.5, 199.8, 200.7);
  --bs-table-striped-bg: rgb(242.25, 210.9, 211.85);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(229.5, 199.8, 200.7);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(235.875, 205.35, 206.275);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(204, 230.4, 231.4);
  --bs-table-border-color: rgb(183.6, 207.36, 208.26);
  --bs-table-striped-bg: rgb(193.8, 218.88, 219.83);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(183.6, 207.36, 208.26);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(188.7, 213.12, 214.045);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: rgb(209.6, 241.4, 232);
  --bs-table-border-color: rgb(188.64, 217.26, 208.8);
  --bs-table-striped-bg: rgb(199.12, 229.33, 220.4);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(188.64, 217.26, 208.8);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(193.88, 223.295, 214.6);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: rgb(218.8, 236.6, 255);
  --bs-table-border-color: rgb(196.92, 212.94, 229.5);
  --bs-table-striped-bg: rgb(207.86, 224.77, 242.25);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(196.92, 212.94, 229.5);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(202.39, 218.855, 235.875);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: rgb(254.4, 241, 212.8);
  --bs-table-border-color: rgb(228.96, 216.9, 191.52);
  --bs-table-striped-bg: rgb(241.68, 228.95, 202.16);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(228.96, 216.9, 191.52);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(235.32, 222.925, 196.84);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: rgb(255, 216.2, 223.2);
  --bs-table-border-color: rgb(229.5, 194.58, 200.88);
  --bs-table-striped-bg: rgb(242.25, 205.39, 212.04);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(229.5, 194.58, 200.88);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(235.875, 199.985, 206.46);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #faf8f8;
  --bs-table-border-color: rgb(225, 223.2, 223.2);
  --bs-table-striped-bg: rgb(237.5, 235.6, 235.6);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(225, 223.2, 223.2);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(231.25, 229.4, 229.4);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: rgb(55.2, 58.8, 62.4);
  --bs-table-striped-bg: rgb(44.1, 47.9, 51.7);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(55.2, 58.8, 62.4);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(49.65, 53.35, 57.05);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.47rem + var(--bs-border-width));
  padding-bottom: calc(0.47rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.125rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.7875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 80%;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.47rem 0.75rem;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-secondary-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color-translucent);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-secondary-bg);
  border-color: rgb(255, 172.5, 175);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(255, 90, 95, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.47rem 0.75rem;
  margin: -0.47rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.47rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.7875rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.125rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.94rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.94rem + calc(var(--bs-border-width) * 2));
  padding: 0.47rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  display: block;
  width: 100%;
  padding: 0.47rem 2.25rem 0.47rem 0.75rem;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-secondary-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color-translucent);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(255, 172.5, 175);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(255, 90, 95, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.7875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.125rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}

.form-check {
  display: block;
  min-height: 1.35rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-secondary-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color-translucent);
  print-color-adjust: exact;
  transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-check-input {
    transition: none;
  }
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(255, 172.5, 175);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(255, 90, 95, 0.25);
}
.form-check-input:checked {
  background-color: rgb(255, 90, 95);
  border-color: rgb(255, 90, 95);
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: rgb(255, 90, 95);
  border-color: rgb(255, 90, 95);
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f1f5f7, 0 0 0 0.25rem rgba(255, 90, 95, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f1f5f7, 0 0 0 0.25rem rgba(255, 90, 95, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: rgb(255, 90, 95);
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(255, 205.5, 207);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-tertiary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: rgb(255, 90, 95);
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(255, 205.5, 207);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-tertiary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-secondary-bg);
  border-radius: var(--bs-border-radius);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #74788d;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.47rem 0.75rem;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color-translucent);
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.125rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.7875rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.7875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.94rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.94rem);
  background-position: top calc(0.375em + 0.235rem) right calc(0.375em + 0.235rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.94rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.7875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.94rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.94rem);
  background-position: top calc(0.375em + 0.235rem) right calc(0.375em + 0.235rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.94rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.47rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 0.9rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: #fff;
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  text-decoration: none;
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: rgb(255, 90, 95);
  --bs-btn-border-color: rgb(255, 90, 95);
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(216.75, 76.5, 80.75);
  --bs-btn-hover-border-color: #cc484c;
  --bs-btn-focus-shadow-rgb: 255, 115, 119;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #cc484c;
  --bs-btn-active-border-color: rgb(191.25, 67.5, 71.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: rgb(255, 90, 95);
  --bs-btn-disabled-border-color: rgb(255, 90, 95);
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #008489;
  --bs-btn-border-color: #008489;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(0, 112.2, 116.45);
  --bs-btn-hover-border-color: rgb(0, 105.6, 109.6);
  --bs-btn-focus-shadow-rgb: 38, 150, 155;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(0, 105.6, 109.6);
  --bs-btn-active-border-color: rgb(0, 99, 102.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #008489;
  --bs-btn-disabled-border-color: #008489;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #1cbb8c;
  --bs-btn-border-color: #1cbb8c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(23.8, 158.95, 119);
  --bs-btn-hover-border-color: rgb(22.4, 149.6, 112);
  --bs-btn-focus-shadow-rgb: 62, 197, 157;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(22.4, 149.6, 112);
  --bs-btn-active-border-color: rgb(21, 140.25, 105);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #1cbb8c;
  --bs-btn-disabled-border-color: #1cbb8c;
}

.btn-info {
  --bs-btn-color: #fff;
  --bs-btn-bg: #4aa3ff;
  --bs-btn-border-color: #4aa3ff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(62.9, 138.55, 216.75);
  --bs-btn-hover-border-color: rgb(59.2, 130.4, 204);
  --bs-btn-focus-shadow-rgb: 101, 177, 255;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(59.2, 130.4, 204);
  --bs-btn-active-border-color: rgb(55.5, 122.25, 191.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #4aa3ff;
  --bs-btn-disabled-border-color: #4aa3ff;
}

.btn-warning {
  --bs-btn-color: #fff;
  --bs-btn-bg: #fcb92c;
  --bs-btn-border-color: #fcb92c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(214.2, 157.25, 37.4);
  --bs-btn-hover-border-color: rgb(201.6, 148, 35.2);
  --bs-btn-focus-shadow-rgb: 252, 196, 76;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(201.6, 148, 35.2);
  --bs-btn-active-border-color: rgb(189, 138.75, 33);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #fcb92c;
  --bs-btn-disabled-border-color: #fcb92c;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #ff3d60;
  --bs-btn-border-color: #ff3d60;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(216.75, 51.85, 81.6);
  --bs-btn-hover-border-color: rgb(204, 48.8, 76.8);
  --bs-btn-focus-shadow-rgb: 255, 90, 120;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(204, 48.8, 76.8);
  --bs-btn-active-border-color: rgb(191.25, 45.75, 72);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #ff3d60;
  --bs-btn-disabled-border-color: #ff3d60;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #faf8f8;
  --bs-btn-border-color: #faf8f8;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(212.5, 210.8, 210.8);
  --bs-btn-hover-border-color: rgb(200, 198.4, 198.4);
  --bs-btn-focus-shadow-rgb: 213, 211, 211;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(200, 198.4, 198.4);
  --bs-btn-active-border-color: rgb(187.5, 186, 186);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #faf8f8;
  --bs-btn-disabled-border-color: #faf8f8;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(66.3, 69.7, 73.1);
  --bs-btn-hover-border-color: rgb(55.2, 58.8, 62.4);
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(77.4, 80.6, 83.8);
  --bs-btn-active-border-color: rgb(55.2, 58.8, 62.4);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529;
}

.btn-outline-primary {
  --bs-btn-color: rgb(255, 90, 95);
  --bs-btn-border-color: rgb(255, 90, 95);
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(255, 90, 95);
  --bs-btn-hover-border-color: rgb(255, 90, 95);
  --bs-btn-focus-shadow-rgb: 255, 90, 95;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(255, 90, 95);
  --bs-btn-active-border-color: rgb(255, 90, 95);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(255, 90, 95);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(255, 90, 95);
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #008489;
  --bs-btn-border-color: #008489;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #008489;
  --bs-btn-hover-border-color: #008489;
  --bs-btn-focus-shadow-rgb: 0, 132, 137;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #008489;
  --bs-btn-active-border-color: #008489;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #008489;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #008489;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #1cbb8c;
  --bs-btn-border-color: #1cbb8c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #1cbb8c;
  --bs-btn-hover-border-color: #1cbb8c;
  --bs-btn-focus-shadow-rgb: 28, 187, 140;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #1cbb8c;
  --bs-btn-active-border-color: #1cbb8c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #1cbb8c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #1cbb8c;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #4aa3ff;
  --bs-btn-border-color: #4aa3ff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #4aa3ff;
  --bs-btn-hover-border-color: #4aa3ff;
  --bs-btn-focus-shadow-rgb: 74, 163, 255;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4aa3ff;
  --bs-btn-active-border-color: #4aa3ff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #4aa3ff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #4aa3ff;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #fcb92c;
  --bs-btn-border-color: #fcb92c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #fcb92c;
  --bs-btn-hover-border-color: #fcb92c;
  --bs-btn-focus-shadow-rgb: 252, 185, 44;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #fcb92c;
  --bs-btn-active-border-color: #fcb92c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fcb92c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #fcb92c;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #ff3d60;
  --bs-btn-border-color: #ff3d60;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #ff3d60;
  --bs-btn-hover-border-color: #ff3d60;
  --bs-btn-focus-shadow-rgb: 255, 61, 96;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #ff3d60;
  --bs-btn-active-border-color: #ff3d60;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ff3d60;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ff3d60;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #faf8f8;
  --bs-btn-border-color: #faf8f8;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #faf8f8;
  --bs-btn-hover-border-color: #faf8f8;
  --bs-btn-focus-shadow-rgb: 250, 248, 248;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #faf8f8;
  --bs-btn-active-border-color: #faf8f8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #faf8f8;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #faf8f8;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #74788d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: none;
}
.btn-link:hover, .btn-link:focus-visible {
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.125rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.7875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 0.9rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-secondary-bg);
  --bs-dropdown-border-color: var(--bs-border-color);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: var(--bs-secondary-color);
  --bs-dropdown-link-active-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1.5rem;
  --bs-dropdown-item-padding-y: 0.35rem;
  --bs-dropdown-header-color: #74788d;
  --bs-dropdown-header-padding-x: 1.5rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.7875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #aaa9a9;
  --bs-dropdown-bg: #252b3b;
  --bs-dropdown-border-color: var(--bs-border-color);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #aaa9a9;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: var(--bs-secondary-color);
  --bs-dropdown-link-active-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-disabled-color: #bdbcad;
  --bs-dropdown-header-color: #bdbcad;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--bs-border-width) * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--bs-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
  text-decoration: none;
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(255, 90, 95, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-secondary-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-secondary-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: rgb(255, 90, 95);
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 800;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.33125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.125rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.125rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
  text-decoration: none;
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}

.card {
  --bs-card-spacer-y: 1.25rem;
  --bs-card-spacer-x: 1.25rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.625rem;
  --bs-card-cap-padding-x: 1.25rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-secondary-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-secondary-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color-translucent);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(255, 90, 95, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 0.9rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 1rem;
  --bs-breadcrumb-padding-y: 0.75rem;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: #74788d;
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: #74788d;
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "\\f0142") /* rtl: var(--bs-breadcrumb-divider, "\\f0142") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.5rem;
  --bs-pagination-font-size: 0.9rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-secondary-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(255, 90, 95, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: rgb(255, 90, 95);
  --bs-pagination-active-border-color: rgb(255, 90, 95);
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  text-decoration: none;
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.125rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.7875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 800;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1.25rem;
  --bs-alert-padding-y: 0.75rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 800;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3.75rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.9375rem 1.25rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.675rem;
  --bs-progress-bg: var(--bs-tertiary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: rgb(255, 90, 95);
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-secondary-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1.25rem;
  --bs-list-group-item-padding-y: 0.75rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-secondary-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: rgb(255, 90, 95);
  --bs-list-group-active-border-color: rgb(255, 90, 95);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: none;
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 0.75rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1060;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-secondary-bg);
  --bs-modal-border-color: var(--bs-border-color);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.7875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.7875rem;
  --bs-popover-bg: var(--bs-secondary-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  --bs-popover-header-padding-x: 0.75rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 0.9rem;
  --bs-popover-header-color: var(--bs-headings-color);
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 0.75rem;
  --bs-popover-body-padding-y: 0.5rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1050;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-secondary-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color);
  --bs-offcanvas-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #fff !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(204, 72, 76, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(204, 72, 76, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(0, 106, 110, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(0, 106, 110, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(22, 150, 112, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(22, 150, 112, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(59, 130, 204, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(59, 130, 204, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(202, 148, 35, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(202, 148, 35, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(204, 49, 77, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(204, 49, 77, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(251, 249, 249, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(251, 249, 249, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.7;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-0 {
  border-width: 0 !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -1rem !important;
}

.mt-n4 {
  margin-top: -1.5rem !important;
}

.mt-n5 {
  margin-top: -3rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -1rem !important;
}

.me-n4 {
  margin-right: -1.5rem !important;
}

.me-n5 {
  margin-right: -3rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -1rem !important;
}

.mb-n4 {
  margin-bottom: -1.5rem !important;
}

.mb-n5 {
  margin-bottom: -3rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -1rem !important;
}

.ms-n4 {
  margin-left: -1.5rem !important;
}

.ms-n5 {
  margin-left: -3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.35rem + 1.2vw) !important;
}

.fs-2 {
  font-size: calc(1.305rem + 0.66vw) !important;
}

.fs-3 {
  font-size: calc(1.2825rem + 0.39vw) !important;
}

.fs-4 {
  font-size: calc(1.26rem + 0.12vw) !important;
}

.fs-5 {
  font-size: 1.125rem !important;
}

.fs-6 {
  font-size: 0.9rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 800 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-sm-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-sm-n3 {
    margin-top: -1rem !important;
  }
  .mt-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-sm-n5 {
    margin-top: -3rem !important;
  }
  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .me-sm-n3 {
    margin-right: -1rem !important;
  }
  .me-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .me-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-sm-n3 {
    margin-left: -1rem !important;
  }
  .ms-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-sm-n5 {
    margin-left: -3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-md-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-md-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-md-n3 {
    margin-top: -1rem !important;
  }
  .mt-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-md-n5 {
    margin-top: -3rem !important;
  }
  .me-md-n1 {
    margin-right: -0.25rem !important;
  }
  .me-md-n2 {
    margin-right: -0.5rem !important;
  }
  .me-md-n3 {
    margin-right: -1rem !important;
  }
  .me-md-n4 {
    margin-right: -1.5rem !important;
  }
  .me-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-md-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-md-n3 {
    margin-left: -1rem !important;
  }
  .ms-md-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-md-n5 {
    margin-left: -3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-lg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-lg-n3 {
    margin-top: -1rem !important;
  }
  .mt-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-lg-n5 {
    margin-top: -3rem !important;
  }
  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .me-lg-n3 {
    margin-right: -1rem !important;
  }
  .me-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .me-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-lg-n3 {
    margin-left: -1rem !important;
  }
  .ms-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-lg-n5 {
    margin-left: -3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xl-n5 {
    margin-top: -3rem !important;
  }
  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xl-n3 {
    margin-right: -1rem !important;
  }
  .me-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xl-n5 {
    margin-left: -3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .m-xxl-n1 {
    margin: -0.25rem !important;
  }
  .m-xxl-n2 {
    margin: -0.5rem !important;
  }
  .m-xxl-n3 {
    margin: -1rem !important;
  }
  .m-xxl-n4 {
    margin: -1.5rem !important;
  }
  .m-xxl-n5 {
    margin: -3rem !important;
  }
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xxl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xxl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xxl-n5 {
    margin-top: -3rem !important;
  }
  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xxl-n3 {
    margin-right: -1rem !important;
  }
  .me-xxl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xxl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xxl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xxl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxl-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xxl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xxl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xxl-n5 {
    margin-left: -3rem !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.25rem !important;
  }
  .fs-2 {
    font-size: 1.8rem !important;
  }
  .fs-3 {
    font-size: 1.575rem !important;
  }
  .fs-4 {
    font-size: 1.35rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
:root,
[data-bs-theme=light] {
  --bs-header-bg: #ffffff;
  --bs-header-item-color: var(--bs-header-item-color);
  --bs-header-item-sub-color: var(--bs-secondary-color);
  --bs-header-height: 70px;
  --bs-rightbar-width: 280px;
  --bs-boxed-layout-width: 1300px;
  --bs-footer-height: 60px;
  --bs-footer-bg: #ffffff;
  --bs-header-dark-bg: #252b3b;
  --bs-menu-item-color: #74788d;
  --bs-menu-item-active-color: #5664d2;
  --bs-topbar-search-bg: #f1f5f712;
  --bs-topnav-bg: #fff;
  --bs-topnav-item-color: rgb(92.8221343874, 96.0790513834, 113.1778656126);
  --bs-topnav-item-color-active: var(--bs-primary);
  --bs-twocolumn-menu-iconview-bg: #fff;
  --bs-twocolumn-menu-bg: #fff;
  --bs-header-item-color: #636e75;
  --bs-boxed-body-bg: #dee7ec;
  --bs-sidebar-bg: #ffffff;
  --bs-sidebar-menu-item-color: #74788d;
  --bs-sidebar-menu-sub-item-color: #7c8a96;
  --bs-sidebar-menu-item-icon-color: #505d69;
  --bs-sidebar-menu-item-hover-color: #383c40;
  --bs-sidebar-menu-item-active-color: #556ee6;
  --bs-sidebar-width: 240px;
  --bs-sidebar-collapsed-width: 70px;
  --bs-sidebar-width-sm: 160px;
}
:root [data-topbar=light],
[data-bs-theme=light] [data-topbar=light] {
  --bs-topbar-search-bg: #f1f5f7;
}
:root [data-topbar=dark],
[data-bs-theme=light] [data-topbar=dark] {
  --bs-header-bg: #252b3b;
  --bs-header-item-color: #faf8f8;
  --bs-header-dark-item-color: #e9ecef;
}
:root [data-topbar=colored],
[data-bs-theme=light] [data-topbar=colored] {
  --bs-header-colored-bg: #556ee6;
  --bs-topbar-search-bg: rgba(241, 245, 247, 0.071);
  --bs-header-dark-item-color: #e9ecef;
}
:root [data-sidebar=colored],
[data-bs-theme=light] [data-sidebar=colored] {
  --bs-topbar-search-bg: #f1f5f7;
}
:root [data-sidebar=light],
[data-bs-theme=light] [data-sidebar=light] {
  --bs-sidebar-bg: #ffffff;
  --bs-sidebar-menu-item-color: #74788d;
  --bs-sidebar-menu-sub-item-color: #7c8a96;
  --bs-sidebar-menu-item-icon-color: #505d69;
  --bs-sidebar-menu-item-hover-color: #383c40;
  --bs-sidebar-menu-item-active-color: #556ee6;
}
:root [data-sidebar=dark],
[data-bs-theme=light] [data-sidebar=dark] {
  --bs-sidebar-dark-bg: #252b3b;
  --bs-sidebar-dark-menu-item-color: #8590a5;
  --bs-sidebar-dark-menu-sub-item-color: #8590a5;
  --bs-sidebar-dark-menu-item-icon-color: #8590a5;
  --bs-sidebar-dark-menu-item-hover-color: #d7e4ec;
  --bs-sidebar-dark-menu-item-active-color: #d7e4ec;
  --bs-topbar-search-bg: #f1f5f7;
}

[data-bs-theme=dark] {
  --bs-body-bg: #171d37;
  --bs-body-bg-rgb: 23, 29, 55;
  --bs-light: #2d3448;
  --bs-light-rgb: 45, 52, 72;
  --bs-dark: #2d3448;
  --bs-dark-rgb: 45, 52, 72;
  --bs-header-bg: #171d37;
  --bs-header-dark-bg: #556ee6;
  --bs-header-item-color: #919bae;
  --bs-topbar-search-bg: #0e142f12;
  --bs-topnav-bg: #171d37;
  --bs-header-item-sub-color: var(--bs-secondary-color);
  --bs-footer-bg: #0e142f;
  --bs-boxed-body-bg: #171d37;
  --bs-sidebar-bg: #ffffff;
  --bs-sidebar-menu-item-color: #74788d;
  --bs-sidebar-menu-sub-item-color: #7c8a96;
  --bs-sidebar-menu-item-icon-color: #505d69;
  --bs-sidebar-menu-item-hover-color: #d7e4ec;
  --bs-sidebar-menu-item-active-color: #556ee6;
}
[data-bs-theme=dark] .table-light {
  --bs-table-color: white;
  --bs-table-bg: var(--bs-tertiary-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-striped-bg: var(--bs-tertiary-bg);
  --bs-table-striped-color: white;
  --bs-table-active-bg: var(--bs-tertiary-bg);
  --bs-table-active-color: white;
  --bs-table-hover-bg: var(--bs-tertiary-bg);
  --bs-table-hover-color: white;
}
[data-bs-theme=dark][data-topbar=colored] {
  --bs-header-colored-bg: #556ee6;
  --bs-topbar-search-bg: #0e142f12;
}
[data-bs-theme=dark][data-topbar=light] {
  --bs-topbar-search-bg: #0e142f;
}
[data-bs-theme=dark][data-sidebar=colored] {
  --bs-topbar-search-bg: #0e142f;
}
[data-bs-theme=dark][data-sidebar=dark] {
  ---bs-sidebar-dark-bg: #252b3b;
  --bs-sidebar-dark-menu-item-color: #8590a5;
  --bs-sidebar-dark-menu-sub-item-color: #8590a5;
  --bs-sidebar-dark-menu-item-icon-color: #8590a5;
  --bs-sidebar-dark-menu-item-hover-color: #d7e4ec;
  --bs-sidebar-dark-menu-item-active-color: #d7e4ec;
  --bs-topbar-search-bg: #2b3244;
}

/* =============
   General
============= */
html {
  position: relative;
  min-height: 100%;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Inter", sans-serif;
}

a {
  text-decoration: none !important;
}

label {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.blockquote {
  padding: 10px 20px;
  border-left: 4px solid var(--bs-border-color);
}

.blockquote-reverse {
  border-left: 0;
  border-right: 4px solid var(--bs-border-color);
  text-align: right;
}

.row > * {
  position: relative;
}

pre {
  color: var(--bs-secondary-color);
}

.bg-soft-primary {
  background-color: rgba(255, 90, 95, 0.25) !important;
}

.bg-soft-secondary {
  background-color: rgba(0, 132, 137, 0.25) !important;
}

.bg-soft-success {
  background-color: rgba(28, 187, 140, 0.25) !important;
}

.bg-soft-info {
  background-color: rgba(74, 163, 255, 0.25) !important;
}

.bg-soft-warning {
  background-color: rgba(252, 185, 44, 0.25) !important;
}

.bg-soft-danger {
  background-color: rgba(255, 61, 96, 0.25) !important;
}

.bg-soft-light {
  background-color: rgba(250, 248, 248, 0.25) !important;
}

.bg-soft-dark {
  background-color: rgba(33, 37, 41, 0.25) !important;
}

.badge[href]:hover, .badge[href]:focus {
  color: #fff;
}

.badge.bg-primary[href]:hover, .badge.bg-primary[href]:focus {
  background-color: rgb(255, 69.6, 75.2181818182) !important;
}

.badge.bg-light {
  color: #212529;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #212529;
}

.badge-soft-primary {
  color: rgb(255, 90, 95);
  background-color: rgba(255, 90, 95, 0.18);
}
.badge-soft-primary[href]:hover, .badge-soft-primary[href]:focus {
  color: rgb(255, 90, 95);
  text-decoration: none;
  background-color: rgba(255, 90, 95, 0.4);
}

.badge.bg-secondary[href]:hover, .badge.bg-secondary[href]:focus {
  background-color: rgb(0, 112.3445255474, 116.6) !important;
}

.badge.bg-light {
  color: #212529;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #212529;
}

.badge-soft-secondary {
  color: #008489;
  background-color: rgba(0, 132, 137, 0.18);
}
.badge-soft-secondary[href]:hover, .badge-soft-secondary[href]:focus {
  color: #008489;
  text-decoration: none;
  background-color: rgba(0, 132, 137, 0.4);
}

.badge.bg-success[href]:hover, .badge.bg-success[href]:focus {
  background-color: rgb(25.343255814, 169.256744186, 126.7162790698) !important;
}

.badge.bg-light {
  color: #212529;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #212529;
}

.badge-soft-success {
  color: #1cbb8c;
  background-color: rgba(28, 187, 140, 0.18);
}
.badge-soft-success[href]:hover, .badge-soft-success[href]:focus {
  color: #1cbb8c;
  text-decoration: none;
  background-color: rgba(28, 187, 140, 0.4);
}

.badge.bg-info[href]:hover, .badge.bg-info[href]:focus {
  background-color: rgb(53.6, 152.6309392265, 255) !important;
}

.badge.bg-light {
  color: #212529;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #212529;
}

.badge-soft-info {
  color: #4aa3ff;
  background-color: rgba(74, 163, 255, 0.18);
}
.badge-soft-info[href]:hover, .badge-soft-info[href]:focus {
  color: #4aa3ff;
  text-decoration: none;
  background-color: rgba(74, 163, 255, 0.4);
}

.badge.bg-warning[href]:hover, .badge.bg-warning[href]:focus {
  background-color: rgb(251.7140186916, 178.3271028037, 23.8859813084) !important;
}

.badge.bg-light {
  color: #212529;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #212529;
}

.badge-soft-warning {
  color: #fcb92c;
  background-color: rgba(252, 185, 44, 0.18);
}
.badge-soft-warning[href]:hover, .badge-soft-warning[href]:focus {
  color: #fcb92c;
  text-decoration: none;
  background-color: rgba(252, 185, 44, 0.4);
}

.badge.bg-danger[href]:hover, .badge.bg-danger[href]:focus {
  background-color: rgb(255, 40.6, 79.2804123711) !important;
}

.badge.bg-light {
  color: #212529;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #212529;
}

.badge-soft-danger {
  color: #ff3d60;
  background-color: rgba(255, 61, 96, 0.18);
}
.badge-soft-danger[href]:hover, .badge-soft-danger[href]:focus {
  color: #ff3d60;
  text-decoration: none;
  background-color: rgba(255, 61, 96, 0.4);
}

.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  background-color: rgb(241.5, 236.1, 236.1) !important;
}

.badge.bg-light {
  color: #212529;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #212529;
}

.badge-soft-light {
  color: #faf8f8;
  background-color: rgba(250, 248, 248, 0.18);
}
.badge-soft-light[href]:hover, .badge-soft-light[href]:focus {
  color: #faf8f8;
  text-decoration: none;
  background-color: rgba(250, 248, 248, 0.4);
}

.badge.bg-dark[href]:hover, .badge.bg-dark[href]:focus {
  background-color: rgb(23.9027027027, 26.8, 29.6972972973) !important;
}

.badge.bg-light {
  color: #212529;
}
.badge.bg-light[href]:hover, .badge.bg-light[href]:focus {
  color: #212529;
}

.badge-soft-dark {
  color: #212529;
  background-color: rgba(33, 37, 41, 0.18);
}
.badge-soft-dark[href]:hover, .badge-soft-dark[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: rgba(33, 37, 41, 0.4);
}

.rounded-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
}

.badge.bg-dark {
  color: #faf8f8;
}

button,
a {
  outline: none !important;
}

.btn:hover, .btn:active, .btn:focus, .btn.active, .btn.show {
  border-color: transparent !important;
}

.btn-light {
  border: 1px solid var(--bs-border-color);
}
.btn-light.active, .btn-light:hover, .btn-light:focus {
  background-color: #f7efef;
  border: 1px solid var(--bs-border-color);
}

.btn-check + .btn:hover {
  border-color: var(--bs-btn-border-color) !important;
}

.btn-rounded {
  border-radius: 30px;
}

.btn-dark,
.btn-secondary {
  color: #f7efef;
}

.btn-outline-light {
  color: #212529;
}

[data-bs-theme=dark] .btn-light {
  color: #fff !important;
  background-color: var(--bs-light);
  border-color: var(--bs-light);
}
[data-bs-theme=dark] .btn-light:hover {
  color: #fff !important;
  background-color: rgba(var(--bs-light-rgb), 0.75);
  border-color: rgba(var(--bs-light-rgb), 0.75);
}
[data-bs-theme=dark] .btn-check:focus + .btn-light,
[data-bs-theme=dark] .btn-check:focus + .btn-outline-light,
[data-bs-theme=dark] .btn-check:focus + .btn-soft-light,
[data-bs-theme=dark] .btn-light:focus,
[data-bs-theme=dark] .btn-outline-light:focus,
[data-bs-theme=dark] .btn-soft-light:focus {
  color: #fff !important;
  background-color: rgba(var(--bs-light-rgb), 0.75);
}
[data-bs-theme=dark] .btn-check:active + .btn-light,
[data-bs-theme=dark] .btn-check:active + .btn-outline-light,
[data-bs-theme=dark] .btn-check:active + .btn-soft-light,
[data-bs-theme=dark] .btn-check:checked + .btn-light,
[data-bs-theme=dark] .btn-check:checked + .btn-outline-light,
[data-bs-theme=dark] .btn-check:checked + .btn-soft-light,
[data-bs-theme=dark] .btn-light.active,
[data-bs-theme=dark] .btn-light:active,
[data-bs-theme=dark] .btn-outline-light.active,
[data-bs-theme=dark] .btn-outline-light:active,
[data-bs-theme=dark] .btn-soft-light.active,
[data-bs-theme=dark] .btn-soft-light:active,
[data-bs-theme=dark] .show > .btn-light.dropdown-toggle,
[data-bs-theme=dark] .show > .btn-outline-light.dropdown-toggle,
[data-bs-theme=dark] .show > .btn-soft-light.dropdown-toggle {
  color: #fff !important;
  background-color: rgba(var(--bs-light-rgb), 0.75);
}
[data-bs-theme=dark] .btn-dark {
  color: #fff;
  background-color: var(--bs-dark);
  border-color: var(--bs-dark);
}
[data-bs-theme=dark] .btn-dark:hover {
  background-color: rgba(var(--bs-dark-rgb), 0.75);
  border-color: rgba(var(--bs-dark-rgb), 0.75);
}
[data-bs-theme=dark] .btn-check:focus + .btn-dark,
[data-bs-theme=dark] .btn-check:focus + .btn-outline-dark,
[data-bs-theme=dark] .btn-check:focus + .btn-soft-dark,
[data-bs-theme=dark] .btn-dark:focus,
[data-bs-theme=dark] .btn-outline-dark:focus,
[data-bs-theme=dark] .btn-soft-dark:focus {
  color: #fff;
  background-color: rgba(var(--bs-dark-rgb), 0.75);
  border-color: rgba(var(--bs-dark-rgb), 0.75);
}
[data-bs-theme=dark] .btn-check:active + .btn-dark,
[data-bs-theme=dark] .btn-check:active + .btn-outline-dark,
[data-bs-theme=dark] .btn-check:active + .btn-soft-dark,
[data-bs-theme=dark] .btn-check:checked + .btn-dark,
[data-bs-theme=dark] .btn-check:checked + .btn-outline-dark,
[data-bs-theme=dark] .btn-check:checked + .btn-soft-dark,
[data-bs-theme=dark] .btn-dark.active,
[data-bs-theme=dark] .btn-dark:active,
[data-bs-theme=dark] .btn-outline-dark.active,
[data-bs-theme=dark] .btn-outline-dark:active,
[data-bs-theme=dark] .btn-soft-dark.active,
[data-bs-theme=dark] .btn-soft-dark:active,
[data-bs-theme=dark] .show > .btn-dark.dropdown-toggle,
[data-bs-theme=dark] .show > .btn-outline-dark.dropdown-toggle,
[data-bs-theme=dark] .show > .btn-soft-dark.dropdown-toggle {
  color: var(--bs-light);
  background-color: rgba(var(--bs-dark-rgb), 0.75);
  border-color: rgba(var(--bs-dark-rgb), 0.75);
}
[data-bs-theme=dark] .btn-outline-light {
  color: #fff !important;
  border-color: var(--bs-light);
}
[data-bs-theme=dark] .btn-outline-light:hover {
  color: #fff;
  background-color: rgba(var(--bs-light-rgb), 0.75);
  border-color: rgba(var(--bs-light-rgb), 0.75);
}
[data-bs-theme=dark] .btn-outline-dark {
  color: #fff !important;
  border-color: var(--bs-dark);
}
[data-bs-theme=dark] .btn-outline-dark:hover {
  color: var(--bs-light);
  background-color: rgba(var(--bs-dark-rgb), 0.75);
  border-color: rgba(var(--bs-dark-rgb), 0.75);
}
[data-bs-theme=dark] .btn-soft-light {
  color: #fff !important;
  background-color: rgba(var(--bs-light-rgb), 0.1);
}
[data-bs-theme=dark] .btn-soft-light:hover {
  color: #fff !important;
  background-color: var(--bs-light);
}
[data-bs-theme=dark] .btn-soft-dark {
  color: #fff !important;
  background-color: rgba(var(--bs-dark-rgb), 0.1);
}
[data-bs-theme=dark] .btn-soft-dark:hover {
  color: var(--bs-light);
  background-color: var(--bs-dark);
}

.breadcrumb-item > a {
  color: var(--bs-body-color);
}
.breadcrumb-item + .breadcrumb-item::before {
  font-family: "Material Design Icons";
}

[dir=rtl] .breadcrumb-item + .breadcrumb-item {
  padding-right: 0.5rem;
}
[dir=rtl] .breadcrumb-item + .breadcrumb-item::before {
  font-family: "Material Design Icons";
  padding-left: 0;
  content: "\\f0141";
}

.card {
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.card-drop {
  font-size: 20px;
  line-height: 0;
  color: inherit;
}

.card-title {
  font-size: 15px;
  margin: 0 0 7px 0;
  font-weight: 500;
}

.card-title-desc {
  color: #74788d;
  margin-bottom: 24px;
}

.dropdown-menu {
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  margin: 0;
  position: absolute;
  z-index: 1000;
}
.dropdown-menu.show {
  top: 100% !important;
}

.dropdown-menu-end[style] {
  left: auto !important;
  right: 0 !important;
}

.dropdown-menu[data-popper-placement^=right], .dropdown-menu[data-popper-placement^=top], .dropdown-menu[data-popper-placement^=left] {
  top: auto !important;
  animation: none !important;
}

@keyframes DropDownSlide {
  100% {
    transform: translateY(0);
  }
  0% {
    transform: translateY(10px);
  }
}
@media (min-width: 600px) {
  .dropdown-menu-lg {
    width: 320px;
  }
  .dropdown-menu-md {
    width: 240px;
  }
}
.dropdown-divider {
  border-top-color: var(--bs-border-color);
}

.dropdown-mega {
  position: static !important;
}

.dropdown-megamenu[style] {
  padding: 20px;
  left: 20px !important;
  right: 20px !important;
}

.dropdown-mega-menu-xl {
  width: 40rem;
}

.dropdown-mega-menu-lg {
  width: 26rem;
}

.nav-tabs > li > a, .nav-pills > li > a {
  color: var(--bs-body-color);
  font-weight: 500;
}

.nav-pills > a {
  color: var(--bs-body-color);
  font-weight: 500;
}

.nav-tabs-custom {
  border-bottom: 2px solid var(--bs-border-color);
}
.nav-tabs-custom .nav-item {
  position: relative;
  color: #212529;
}
.nav-tabs-custom .nav-item .nav-link {
  border: none;
}
.nav-tabs-custom .nav-item .nav-link::after {
  content: "";
  background: rgb(255, 90, 95);
  height: 2px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: -1px;
  transition: all 250ms ease 0s;
  transform: scale(0);
}
.nav-tabs-custom .nav-item .nav-link.active {
  color: rgb(255, 90, 95);
}
.nav-tabs-custom .nav-item .nav-link.active:after {
  transform: scale(1);
}

.vertical-nav .nav .nav-link {
  padding: 24px 16px;
  text-align: center;
  margin-bottom: 8px;
}
.vertical-nav .nav .nav-link .nav-icon {
  font-size: 24px;
}

.table .table-light {
  color: var(--bs-body-color);
  border-color: var(--bs-border-color);
  background-color: var(--bs-tertiary-bg) !important;
}

.table-bordered {
  border: var(--bs-border-width) solid var(--bs-border-color);
}

.table-dark > :not(:last-child) > :last-child > * {
  border-bottom-color: rgb(67.225, 72.775, 78.325);
}

.table-nowrap th,
.table-nowrap td {
  white-space: nowrap;
}

.table-responsive::-webkit-scrollbar {
  -webkit-appearance: none;
}
.table-responsive::-webkit-scrollbar:vertical {
  width: 12px;
}
.table-responsive::-webkit-scrollbar:horizontal {
  height: 9px;
}
.table-responsive::-webkit-scrollbar-thumb {
  background-color: rgba(33, 37, 41, 0.2);
  border-radius: 10px;
  border: 2px solid #fff;
}
.table-responsive::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #fff;
}

.pagination-rounded .page-link {
  border-radius: 30px !important;
  margin: 0 3px;
  border: none;
  text-align: center;
  height: 35px;
}

.progress-sm {
  height: 5px;
}

.progress-md {
  height: 8px;
}

.progress-lg {
  height: 12px;
}

.progress-xl {
  height: 16px;
}

.animated-progess {
  position: relative;
}
.animated-progess .progress-bar {
  position: relative;
  border-radius: 6px;
  animation: animate-positive 2s;
}

@keyframes animate-positive {
  0% {
    width: 0;
  }
}
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_53___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_54___}) format("woff");
}
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_55___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_56___}) format("woff");
}
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_57___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_58___}) format("woff");
}
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_59___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_60___}) format("woff");
}
#page-topbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1002;
  background-color: var(--bs-header-bg);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.navbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  height: 70px;
  padding: 0 calc(1.5rem / 2) 0 0;
}
.navbar-header .dropdown .show.header-item {
  background-color: var(--bs-secondary-bg);
}

.navbar-brand-box {
  padding: 0;
  width: 240px;
}

.logo .logo-sm {
  display: none;
}

.logo-light {
  display: none;
}

/* Search */
.app-search {
  padding: calc(32px / 2) 0;
}
.app-search .form-control {
  border: none;
  height: 38px;
  padding-left: 40px;
  padding-right: 20px;
  background-color: var(--bs-topbar-search-bg);
  box-shadow: none;
  border-radius: 30px;
}
.app-search span {
  position: absolute;
  z-index: 10;
  font-size: 16px;
  line-height: 38px;
  left: 13px;
  top: 0;
  color: #74788d;
}

.megamenu-list li {
  position: relative;
  padding: 5px 0px;
}
.megamenu-list li a {
  color: var(--bs-body-color);
}

@media (max-width: 991px) {
  .navbar-brand-box {
    width: auto;
  }
  .logo span.logo-lg {
    display: none;
  }
}
.page-content {
  padding: calc(70px + 1.5rem) 0 60px 0;
}

.header-item {
  width: 70px;
  height: 70px;
  box-shadow: none !important;
  color: var(--bs-header-item-color);
  border: 0;
  border-radius: 0px;
}
.header-item:hover {
  color: var(--bs-header-item-color);
}

.header-profile-user {
  height: 36px;
  width: 36px;
  background-color: var(--bs-secondary-bg);
  padding: 3px;
}

.user-dropdown .dropdown-item i {
  display: inline-block;
}

.noti-icon i {
  font-size: 22px;
  color: var(--bs-header-item-color);
}
.noti-icon .noti-dot {
  position: absolute;
  display: inline-block;
  height: 6px;
  width: 6px;
  background-color: #ff3d60;
  border-radius: 50%;
  top: 20px;
  right: 14px;
}

.notification-item .d-flex {
  padding: 0.75rem 1rem;
}
.notification-item .d-flex:hover {
  background-color: var(--bs-tertiary-bg);
}

.dropdown-icon-item {
  border-radius: 3px;
  line-height: 34px;
  text-align: center;
  padding: 15px 0 9px;
  display: block;
  border: 1px solid transparent;
  color: #74788d;
}
.dropdown-icon-item img {
  height: 24px;
}
.dropdown-icon-item span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dropdown-icon-item:hover {
  border-color: var(--bs-border-color);
}

.fullscreen-enable [data-toggle=fullscreen] .ri-fullscreen-line:before {
  content: "\\ed73";
}

body[data-topbar=dark] #page-topbar {
  background-color: var(--bs-header-dark-bg);
}
body[data-topbar=dark] .navbar-header .dropdown .show.header-item {
  background-color: rgba(255, 255, 255, 0.05);
}
body[data-topbar=dark] .navbar-header .waves-effect .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
}
body[data-topbar=dark] .header-item {
  color: var(--bs-header-dark-item-color);
}
body[data-topbar=dark] .header-item:hover {
  color: var(--bs-header-dark-item-color);
}
body[data-topbar=dark] .header-profile-user {
  background-color: rgba(255, 255, 255, 0.25);
}
body[data-topbar=dark] .noti-icon i {
  color: var(--bs-header-dark-item-color);
}
body[data-topbar=dark] .logo-dark {
  display: none;
}
body[data-topbar=dark] .logo-light {
  display: block;
}
body[data-topbar=dark] .app-search .form-control {
  background-color: var(--bs-topbar-search-bg);
  color: #fff;
}
body[data-topbar=dark] .app-search span,
body[data-topbar=dark] .app-search input.form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}

body[data-sidebar=dark] .navbar-brand-box {
  background: var(--bs-sidebar-dark-bg);
}
body[data-sidebar=dark] .logo-dark {
  display: none;
}
body[data-sidebar=dark] .logo-light {
  display: block;
}

@media (max-width: 600px) {
  .navbar-header .dropdown {
    position: static;
  }
  .navbar-header .dropdown .dropdown-menu {
    left: 10px !important;
    right: 10px !important;
  }
}
@media (max-width: 380px) {
  .navbar-brand-box {
    display: none;
  }
}
body[data-layout=horizontal] .navbar-brand-box {
  width: auto;
}
body[data-layout=horizontal] .page-content {
  margin-top: 70px;
  padding: calc(55px + 1.5rem) calc(1.5rem / 2) 60px calc(1.5rem / 2);
}

@media (max-width: 992px) {
  body[data-layout=horizontal] .page-content {
    margin-top: 15px;
  }
}
body[data-topbar=colored] #page-topbar {
  background-color: var(--bs-header-colored-bg);
}
body[data-topbar=colored] .navbar-header .dropdown .show.header-item {
  background-color: rgba(255, 255, 255, 0.05);
}
body[data-topbar=colored] .navbar-header .waves-effect .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
}
body[data-topbar=colored] .header-item {
  color: var(--bs-header-dark-item-color);
}
body[data-topbar=colored] .header-item:hover {
  color: var(--bs-header-dark-item-color);
}
body[data-topbar=colored] .header-profile-user {
  background-color: rgba(255, 255, 255, 0.25);
}
body[data-topbar=colored] .noti-icon i {
  color: var(--bs-header-dark-item-color);
}
body[data-topbar=colored] .logo-dark {
  display: none;
}
body[data-topbar=colored] .logo-light {
  display: block;
}
body[data-topbar=colored] .app-search .form-control {
  background-color: var(--bs-topbar-search-bg);
  color: #fff;
}
body[data-topbar=colored] .app-search span,
body[data-topbar=colored] .app-search input.form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.page-title-box {
  padding-bottom: 1.5rem;
}
.page-title-box .breadcrumb {
  background-color: transparent;
  padding: 0;
}
.page-title-box h4, .page-title-box .h4 {
  font-size: 15px;
  text-transform: uppercase;
  font-weight: 600;
}

.footer {
  bottom: 0;
  padding: 20px calc(1.5rem / 2);
  position: absolute;
  right: 0;
  color: #74788d;
  left: 240px;
  height: 60px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  background-color: var(--bs-footer-bg);
}

@media (max-width: 992px) {
  .footer {
    left: 0;
  }
}
.vertical-collpsed .footer {
  left: 70px;
}

body[data-layout=horizontal] .footer {
  left: 0 !important;
}

.right-bar {
  background-color: var(--bs-secondary-bg);
  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);
  display: block;
  position: fixed;
  transition: all 200ms ease-out;
  width: 280px;
  z-index: 9999;
  float: right !important;
  right: -290px;
  top: 0;
  bottom: 0;
}
.right-bar .right-bar-toggle {
  background-color: rgb(48.9202702703, 54.85, 60.7797297297);
  height: 24px;
  width: 24px;
  line-height: 24px;
  color: #f7efef;
  text-align: center;
  border-radius: 50%;
}
.right-bar .right-bar-toggle:hover {
  background-color: rgb(55.7432432432, 62.5, 69.2567567568);
}

.rightbar-overlay {
  background-color: rgba(33, 37, 41, 0.55);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: none;
  z-index: 9998;
  transition: all 0.2s ease-out;
}

.right-bar-enabled .right-bar {
  right: 0;
}
.right-bar-enabled .rightbar-overlay {
  display: block;
}

@media (max-width: 767.98px) {
  .right-bar {
    overflow: auto;
  }
  .right-bar .slimscroll-menu {
    height: auto !important;
  }
}
.metismenu {
  margin: 0;
}
.metismenu li {
  display: block;
  width: 100%;
}
.metismenu .mm-collapse {
  display: none;
}
.metismenu .mm-collapse:not(.mm-show) {
  display: none;
}
.metismenu .mm-collapse.mm-show {
  display: block;
}
.metismenu .mm-collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition-timing-function: ease;
  transition-duration: 0.35s;
  transition-property: height, visibility;
}

.vertical-menu {
  width: 240px;
  z-index: 1001;
  background: var(--bs-sidebar-bg);
  bottom: 0;
  margin-top: 0;
  position: fixed;
  top: 70px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.main-content {
  margin-left: 240px;
  overflow: hidden;
}
.main-content .content {
  padding: 0 15px 10px 15px;
  margin-top: 70px;
}

#sidebar-menu {
  padding: 10px 0 30px 0;
}
#sidebar-menu .mm-active > .has-arrow:after {
  transform: rotate(-180deg);
}
#sidebar-menu .has-arrow:after {
  content: "\\f0140";
  font-family: "Material Design Icons";
  display: block;
  float: right;
  transition: transform 0.2s;
  font-size: 1rem;
}
#sidebar-menu ul li a {
  display: block;
  padding: 0.625rem 1.5rem;
  color: var(--bs-sidebar-menu-item-color);
  position: relative;
  font-size: 13.3px;
  transition: all 0.4s;
  font-family: "Inter", sans-serif;
  font-weight: 500;
}
#sidebar-menu ul li a i {
  display: inline-block;
  min-width: 1.5rem;
  padding-bottom: 0.125em;
  font-size: 1.1rem;
  line-height: 1.40625rem;
  vertical-align: middle;
  color: var(--bs-sidebar-menu-item-icon-color);
  transition: all 0.4s;
  opacity: 0.75;
}
#sidebar-menu ul li a:hover {
  color: var(--bs-sidebar-menu-item-hover-color);
}
#sidebar-menu ul li a:hover i {
  color: var(--bs-sidebar-menu-item-hover-color);
}
#sidebar-menu ul li .badge {
  margin-top: 4px;
}
#sidebar-menu ul li ul.sub-menu {
  padding: 0;
}
#sidebar-menu ul li ul.sub-menu li a {
  padding: 0.4rem 1.5rem 0.4rem 3.2rem;
  font-size: 13px;
  color: var(--bs-sidebar-menu-sub-item-color);
}
#sidebar-menu ul li ul.sub-menu li ul.sub-menu {
  padding: 0;
}
#sidebar-menu ul li ul.sub-menu li ul.sub-menu li a {
  padding: 0.4rem 1.5rem 0.4rem 4.2rem;
  font-size: 13.5px;
}

.menu-title {
  padding: 12px 20px !important;
  letter-spacing: 0.05em;
  pointer-events: none;
  cursor: default;
  font-size: 11px;
  text-transform: uppercase;
  color: var(--bs-sidebar-menu-item-icon-color);
  font-weight: 600;
  font-family: "Inter", sans-serif;
  opacity: 0.5;
}

.mm-active {
  color: var(--bs-sidebar-menu-item-active-color) !important;
}
.mm-active > a {
  color: var(--bs-sidebar-menu-item-active-color) !important;
}
.mm-active > a i {
  color: var(--bs-sidebar-menu-item-active-color) !important;
}
.mm-active > i {
  color: var(--bs-sidebar-menu-item-active-color) !important;
}
.mm-active .active {
  color: var(--bs-sidebar-menu-item-active-color) !important;
}
.mm-active .active i {
  color: var(--bs-sidebar-menu-item-active-color) !important;
}

@media (max-width: 992px) {
  .vertical-menu {
    display: none;
  }
  .main-content {
    margin-left: 0 !important;
  }
  body.sidebar-enable .vertical-menu {
    display: block;
  }
}
.vertical-collpsed .main-content {
  margin-left: 70px;
}
.vertical-collpsed .navbar-brand-box {
  width: 70px !important;
}
.vertical-collpsed .logo span.logo-lg {
  display: none;
}
.vertical-collpsed .logo span.logo-sm {
  display: block;
}
.vertical-collpsed .vertical-menu {
  position: absolute;
  width: 70px !important;
  z-index: 5;
}
.vertical-collpsed .vertical-menu .simplebar-mask,
.vertical-collpsed .vertical-menu .simplebar-content-wrapper {
  overflow: visible !important;
}
.vertical-collpsed .vertical-menu .simplebar-scrollbar {
  display: none !important;
}
.vertical-collpsed .vertical-menu .simplebar-offset {
  bottom: 0 !important;
}
.vertical-collpsed .vertical-menu #sidebar-menu .menu-title,
.vertical-collpsed .vertical-menu #sidebar-menu .badge,
.vertical-collpsed .vertical-menu #sidebar-menu .collapse.in {
  display: none !important;
}
.vertical-collpsed .vertical-menu #sidebar-menu .nav.collapse {
  height: inherit !important;
}
.vertical-collpsed .vertical-menu #sidebar-menu .has-arrow:after {
  display: none;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li {
  position: relative;
  white-space: nowrap;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a {
  padding: 15px 20px;
  min-height: 55px;
  transition: none;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:hover, .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:active, .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:focus {
  color: var(--bs-sidebar-menu-item-hover-color);
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a i {
  font-size: 20px;
  margin-left: 4px;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a span {
  display: none;
  padding-left: 25px;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  position: relative;
  width: calc(190px + 70px);
  color: rgb(255, 90, 95);
  transition: none;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i {
  color: rgb(255, 90, 95);
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a span {
  display: inline;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul {
  display: block;
  left: 70px;
  position: absolute;
  width: 190px;
  height: auto !important;
  box-shadow: 3px 5px 12px -4px rgba(18, 19, 21, 0.1);
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul ul {
  box-shadow: 3px 5px 12px -4px rgba(18, 19, 21, 0.1);
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a {
  box-shadow: none;
  padding: 8px 20px;
  position: relative;
  width: 190px;
  z-index: 6;
  color: var(--bs-sidebar-menu-sub-item-color);
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a:hover {
  color: var(--bs-sidebar-menu-item-hover-color);
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul ul {
  padding: 5px 0;
  z-index: 9999;
  display: none;
  background-color: var(--bs-sidebar-bg);
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul ul li:hover > ul {
  display: block;
  left: 190px;
  height: auto !important;
  margin-top: -36px;
  position: absolute;
  width: 190px;
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul ul li > a span.pull-right {
  position: absolute;
  right: 20px;
  top: 12px;
  transform: rotate(270deg);
}
.vertical-collpsed .vertical-menu #sidebar-menu > ul ul li.active a {
  color: #faf8f8;
}

body[data-sidebar=dark] .vertical-menu {
  background: var(--bs-sidebar-dark-bg);
}
body[data-sidebar=dark] #sidebar-menu ul li a {
  color: var(--bs-sidebar-dark-menu-item-color);
}
body[data-sidebar=dark] #sidebar-menu ul li a i {
  color: var(--bs-sidebar-dark-menu-item-color);
}
body[data-sidebar=dark] #sidebar-menu ul li a:hover {
  color: var(--bs-sidebar-dark-menu-item-hover-color);
}
body[data-sidebar=dark] #sidebar-menu ul li a:hover i {
  color: var(--bs-sidebar-dark-menu-item-hover-color);
}
body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a {
  color: var(--bs-sidebar-dark-menu-sub-item-color);
}
body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a:hover {
  color: var(--bs-sidebar-dark-menu-item-hover-color);
}
body[data-sidebar=dark].vertical-collpsed {
  min-height: 1400px;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-color: var(--bs-sidebar-dark-bg);
  color: var(--bs-sidebar-dark-menu-item-hover-color);
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i {
  color: var(--bs-sidebar-dark-menu-item-hover-color);
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a {
  color: var(--bs-sidebar-dark-menu-sub-item-color);
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > ul a:hover {
  color: var(--bs-sidebar-menu-item-hover-color);
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu > ul ul {
  background-color: var(--bs-secondary-bg);
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu ul > li > a.mm-active {
  color: var(--bs-sidebar-dark-menu-item-active-color) !important;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu ul li li.mm-active > a, body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu ul li li.active > a {
  color: var(--bs-sidebar-menu-item-active-color) !important;
}
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu ul li li a.mm-active, body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu ul li li a.active {
  color: var(--bs-sidebar-menu-item-active-color) !important;
}
body[data-sidebar=dark] .mm-active {
  color: var(--bs-sidebar-dark-menu-item-active-color) !important;
}
body[data-sidebar=dark] .mm-active > a {
  color: var(--bs-sidebar-dark-menu-item-active-color) !important;
}
body[data-sidebar=dark] .mm-active > a i {
  color: var(--bs-sidebar-dark-menu-item-active-color) !important;
}
body[data-sidebar=dark] .mm-active > i {
  color: var(--bs-sidebar-dark-menu-item-active-color) !important;
}
body[data-sidebar=dark] .mm-active .active {
  color: var(--bs-sidebar-dark-menu-item-active-color) !important;
}
body[data-sidebar=dark] .mm-active .active i {
  color: var(--bs-sidebar-dark-menu-item-active-color) !important;
}
body[data-sidebar=dark] .menu-title {
  color: var(--bs-sidebar-dark-menu-item-color);
}

body[data-layout=horizontal] .main-content {
  margin-left: 0 !important;
}

body[data-sidebar-size=small] .navbar-brand-box {
  width: 160px;
}
@media (max-width: 992px) {
  body[data-sidebar-size=small] .navbar-brand-box {
    width: auto;
  }
}
body[data-sidebar-size=small] .vertical-menu {
  width: 160px;
  text-align: center;
}
body[data-sidebar-size=small] .vertical-menu .has-arrow:after,
body[data-sidebar-size=small] .vertical-menu .badge {
  display: none !important;
}
body[data-sidebar-size=small] .main-content {
  margin-left: 160px;
}
body[data-sidebar-size=small] .footer {
  left: 160px;
}
@media (max-width: 991px) {
  body[data-sidebar-size=small] .footer {
    left: 0;
  }
}
body[data-sidebar-size=small] #sidebar-menu ul li a i {
  display: block;
}
body[data-sidebar-size=small] #sidebar-menu ul li ul.sub-menu li a {
  padding-left: 1.5rem;
}
body[data-sidebar-size=small] #sidebar-menu ul li ul.sub-menu li ul.sub-menu li a {
  padding-left: 1.5rem;
}
body[data-sidebar-size=small].vertical-collpsed .main-content {
  margin-left: 70px;
}
body[data-sidebar-size=small].vertical-collpsed .vertical-menu #sidebar-menu {
  text-align: left;
}
body[data-sidebar-size=small].vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a i {
  display: inline-block;
}
body[data-sidebar-size=small].vertical-collpsed .footer {
  left: 70px;
}

body[data-sidebar=colored] .vertical-menu {
  background: rgb(255, 90, 95);
}
body[data-sidebar=colored] .navbar-brand-box {
  background-color: rgb(255, 90, 95);
}
body[data-sidebar=colored] .navbar-brand-box .logo-dark {
  display: none;
}
body[data-sidebar=colored] .navbar-brand-box .logo-light {
  display: block;
}
body[data-sidebar=colored] #sidebar-menu ul li.menu-title {
  color: rgba(255, 255, 255, 0.6);
}
body[data-sidebar=colored] #sidebar-menu ul li a {
  color: rgba(255, 255, 255, 0.6);
}
body[data-sidebar=colored] #sidebar-menu ul li a i {
  color: rgba(255, 255, 255, 0.6);
}
body[data-sidebar=colored] #sidebar-menu ul li a.waves-effect .waves-ripple {
  background: rgba(255, 255, 255, 0.1);
}
body[data-sidebar=colored] #sidebar-menu ul li ul.sub-menu li a {
  color: rgba(255, 255, 255, 0.5);
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-color: rgb(255, 100.2, 104.8909090909);
  color: #fff;
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a i {
  color: #fff;
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu ul > li > a.mm-active {
  color: var(--bs-sidebar-dark-menu-item-active-color) !important;
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu ul li li.mm-active > a, body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu ul li li.active > a {
  color: var(--bs-sidebar-menu-item-active-color) !important;
}
body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu ul li li a.mm-active, body[data-sidebar=colored].vertical-collpsed .vertical-menu #sidebar-menu ul li li a.active {
  color: var(--bs-sidebar-menu-item-active-color) !important;
}
body[data-sidebar=colored] .mm-active {
  color: #fff !important;
}
body[data-sidebar=colored] .mm-active > a {
  color: #fff !important;
}
body[data-sidebar=colored] .mm-active > a i {
  color: #fff !important;
}
body[data-sidebar=colored] .mm-active > i {
  color: #fff !important;
}
body[data-sidebar=colored] .mm-active .active {
  color: #fff !important;
}
body[data-sidebar=colored] .mm-active .active i {
  color: #fff !important;
}
body[data-sidebar=colored] .menu-title {
  color: #fff !important;
}

.topnav {
  background: var(--bs-topnav-bg);
  padding: 0 calc(1.5rem / 2);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  margin-top: 70px;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100;
}
.topnav .topnav-menu {
  margin: 0;
  padding: 0;
}
.topnav .navbar-nav .nav-link {
  font-size: 15px;
  position: relative;
  padding: 1rem 1.3rem;
  color: var(--bs-menu-item-color);
  font-family: "Inter", sans-serif;
}
.topnav .navbar-nav .nav-link i {
  font-size: 15px;
  vertical-align: middle;
  display: inline-block;
}
.topnav .navbar-nav .nav-link:focus, .topnav .navbar-nav .nav-link:hover {
  color: var(--bs-menu-item-active-color);
  background-color: transparent;
}
.topnav .navbar-nav .dropdown-item {
  color: var(--bs-menu-item-color);
}
.topnav .navbar-nav .dropdown-item.active, .topnav .navbar-nav .dropdown-item:hover {
  color: var(--bs-menu-item-active-color);
}
.topnav .navbar-nav .nav-item .nav-link.active {
  color: var(--bs-menu-item-active-color);
}
.topnav .navbar-nav .dropdown.active > a {
  color: var(--bs-menu-item-active-color);
  background-color: transparent;
}

@media (min-width: 1200px) {
  body[data-layout=horizontal] .container-fluid, body[data-layout=horizontal] .container-sm, body[data-layout=horizontal] .container-md, body[data-layout=horizontal] .container-lg, body[data-layout=horizontal] .container-xl, body[data-layout=horizontal] .container-xxl,
  body[data-layout=horizontal] .navbar-header {
    max-width: 85%;
  }
}
@media (min-width: 992px) {
  .topnav .navbar-nav .nav-item:first-of-type .nav-link {
    padding-left: 0;
  }
  .topnav .dropdown-item {
    padding: 0.5rem 1.5rem;
    min-width: 180px;
  }
  .topnav .dropdown.mega-dropdown .mega-dropdown-menu {
    left: 0px;
    right: auto;
  }
  .topnav .dropdown .dropdown-menu {
    margin-top: 0;
    border-radius: 0 0 var(--bs-border-radius) var(--bs-border-radius);
  }
  .topnav .dropdown .dropdown-menu .arrow-down::after {
    right: 15px;
    transform: rotate(-135deg) translateY(-50%);
    position: absolute;
  }
  .topnav .dropdown .dropdown-menu .dropdown .dropdown-menu {
    position: absolute;
    top: 0 !important;
    left: 100%;
    display: none;
  }
  .topnav .dropdown:hover > .dropdown-menu {
    display: block;
  }
  .topnav .dropdown:hover > .dropdown-menu > .dropdown:hover > .dropdown-menu {
    display: block;
  }
  .navbar-toggle {
    display: none;
  }
}
.arrow-down {
  display: inline-block;
}
.arrow-down:after {
  border-color: initial;
  border-style: solid;
  border-width: 0 0 1px 1px;
  content: "";
  height: 0.4em;
  display: inline-block;
  right: 5px;
  top: 50%;
  margin-left: 10px;
  transform: rotate(-45deg) translateY(-50%);
  transform-origin: top;
  transition: all 0.3s ease-out;
  width: 0.4em;
}

@media (max-width: 1199.98px) {
  .topnav-menu .navbar-nav li:last-of-type .dropdown .dropdown-menu {
    right: 100%;
    left: auto;
  }
}
@media (max-width: 991.98px) {
  .navbar-brand-box .logo-dark {
    display: block;
  }
  .navbar-brand-box .logo-dark span.logo-sm {
    display: block;
  }
  .navbar-brand-box .logo-light {
    display: none;
  }
  .topnav {
    max-height: 360px;
    overflow-y: auto;
    padding: 0;
  }
  .topnav .navbar-nav .nav-link {
    padding: 0.75rem 1.1rem;
  }
  .topnav .dropdown .dropdown-menu {
    background-color: transparent;
    border: none;
    box-shadow: none;
    padding-left: 15px;
  }
  .topnav .dropdown .dropdown-menu.dropdown-mega-menu-xl {
    width: auto;
  }
  .topnav .dropdown .dropdown-menu.dropdown-mega-menu-xl .row {
    margin: 0px;
  }
  .topnav .dropdown .dropdown-item {
    position: relative;
    background-color: transparent;
  }
  .topnav .dropdown .dropdown-item.active, .topnav .dropdown .dropdown-item:active {
    color: rgb(255, 90, 95);
  }
  .topnav .arrow-down::after {
    right: 15px;
    position: absolute;
  }
}
@media (min-width: 992px) {
  body[data-layout=horizontal][data-topbar=light] .navbar-brand-box .logo-dark {
    display: block;
  }
  body[data-layout=horizontal][data-topbar=light] .navbar-brand-box .logo-light {
    display: none;
  }
  body[data-layout=horizontal][data-topbar=light] .topnav {
    background-color: var(--bs-header-dark-bg);
  }
  body[data-layout=horizontal][data-topbar=light] .topnav .navbar-nav .nav-link {
    color: rgba(255, 255, 255, 0.6);
  }
  body[data-layout=horizontal][data-topbar=light] .topnav .navbar-nav .nav-link:focus, body[data-layout=horizontal][data-topbar=light] .topnav .navbar-nav .nav-link:hover {
    color: rgba(255, 255, 255, 0.9);
  }
  body[data-layout=horizontal][data-topbar=light] .topnav .navbar-nav > .dropdown.active > a {
    color: rgba(255, 255, 255, 0.9) !important;
  }
}
[data-bs-theme=dark][data-layout=horizontal][data-topbar=light] .navbar-brand-box .logo-dark {
  display: none;
}
[data-bs-theme=dark][data-layout=horizontal][data-topbar=light] .navbar-brand-box .logo-light {
  display: block;
}

body[data-layout-size=boxed] {
  background-color: var(--bs-boxed-body-bg);
}
body[data-layout-size=boxed] #layout-wrapper {
  background-color: var(--bs-body-bg);
  max-width: 1300px;
  margin: 0 auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}
body[data-layout-size=boxed] #page-topbar {
  max-width: 1300px;
  margin: 0 auto;
}
body[data-layout-size=boxed] .footer {
  margin: 0 auto;
  max-width: calc(1300px - 240px);
}
body[data-layout-size=boxed].vertical-collpsed .footer {
  max-width: calc(1300px - 70px);
}

body[data-layout=horizontal][data-layout-size=boxed] .topnav {
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
}

:root,
[data-bs-theme=light] {
  --bs-header-bg: #ffffff;
  --bs-header-item-color: var(--bs-header-item-color);
  --bs-header-item-sub-color: var(--bs-secondary-color);
  --bs-header-height: 70px;
  --bs-rightbar-width: 280px;
  --bs-boxed-layout-width: 1300px;
  --bs-footer-height: 60px;
  --bs-footer-bg: #ffffff;
  --bs-header-dark-bg: #252b3b;
  --bs-menu-item-color: #74788d;
  --bs-menu-item-active-color: #5664d2;
  --bs-topbar-search-bg: #f1f5f712;
  --bs-topnav-bg: #fff;
  --bs-topnav-item-color: rgb(92.8221343874, 96.0790513834, 113.1778656126);
  --bs-topnav-item-color-active: var(--bs-primary);
  --bs-twocolumn-menu-iconview-bg: #fff;
  --bs-twocolumn-menu-bg: #fff;
  --bs-header-item-color: #636e75;
  --bs-boxed-body-bg: #dee7ec;
  --bs-sidebar-bg: #ffffff;
  --bs-sidebar-menu-item-color: #74788d;
  --bs-sidebar-menu-sub-item-color: #7c8a96;
  --bs-sidebar-menu-item-icon-color: #505d69;
  --bs-sidebar-menu-item-hover-color: #383c40;
  --bs-sidebar-menu-item-active-color: #556ee6;
  --bs-sidebar-width: 240px;
  --bs-sidebar-collapsed-width: 70px;
  --bs-sidebar-width-sm: 160px;
}
:root [data-topbar=light],
[data-bs-theme=light] [data-topbar=light] {
  --bs-topbar-search-bg: #f1f5f7;
}
:root [data-topbar=dark],
[data-bs-theme=light] [data-topbar=dark] {
  --bs-header-bg: #252b3b;
  --bs-header-item-color: #faf8f8;
  --bs-header-dark-item-color: #e9ecef;
}
:root [data-topbar=colored],
[data-bs-theme=light] [data-topbar=colored] {
  --bs-header-colored-bg: #556ee6;
  --bs-topbar-search-bg: rgba(241, 245, 247, 0.071);
  --bs-header-dark-item-color: #e9ecef;
}
:root [data-sidebar=colored],
[data-bs-theme=light] [data-sidebar=colored] {
  --bs-topbar-search-bg: #f1f5f7;
}
:root [data-sidebar=light],
[data-bs-theme=light] [data-sidebar=light] {
  --bs-sidebar-bg: #ffffff;
  --bs-sidebar-menu-item-color: #74788d;
  --bs-sidebar-menu-sub-item-color: #7c8a96;
  --bs-sidebar-menu-item-icon-color: #505d69;
  --bs-sidebar-menu-item-hover-color: #383c40;
  --bs-sidebar-menu-item-active-color: #556ee6;
}
:root [data-sidebar=dark],
[data-bs-theme=light] [data-sidebar=dark] {
  --bs-sidebar-dark-bg: #252b3b;
  --bs-sidebar-dark-menu-item-color: #8590a5;
  --bs-sidebar-dark-menu-sub-item-color: #8590a5;
  --bs-sidebar-dark-menu-item-icon-color: #8590a5;
  --bs-sidebar-dark-menu-item-hover-color: #d7e4ec;
  --bs-sidebar-dark-menu-item-active-color: #d7e4ec;
  --bs-topbar-search-bg: #f1f5f7;
}

[data-bs-theme=dark] {
  --bs-body-bg: #171d37;
  --bs-body-bg-rgb: 23, 29, 55;
  --bs-light: #2d3448;
  --bs-light-rgb: 45, 52, 72;
  --bs-dark: #2d3448;
  --bs-dark-rgb: 45, 52, 72;
  --bs-header-bg: #171d37;
  --bs-header-dark-bg: #556ee6;
  --bs-header-item-color: #919bae;
  --bs-topbar-search-bg: #0e142f12;
  --bs-topnav-bg: #171d37;
  --bs-header-item-sub-color: var(--bs-secondary-color);
  --bs-footer-bg: #0e142f;
  --bs-boxed-body-bg: #171d37;
  --bs-sidebar-bg: #ffffff;
  --bs-sidebar-menu-item-color: #74788d;
  --bs-sidebar-menu-sub-item-color: #7c8a96;
  --bs-sidebar-menu-item-icon-color: #505d69;
  --bs-sidebar-menu-item-hover-color: #d7e4ec;
  --bs-sidebar-menu-item-active-color: #556ee6;
}
[data-bs-theme=dark] .table-light {
  --bs-table-color: white;
  --bs-table-bg: var(--bs-tertiary-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-striped-bg: var(--bs-tertiary-bg);
  --bs-table-striped-color: white;
  --bs-table-active-bg: var(--bs-tertiary-bg);
  --bs-table-active-color: white;
  --bs-table-hover-bg: var(--bs-tertiary-bg);
  --bs-table-hover-color: white;
}
[data-bs-theme=dark][data-topbar=colored] {
  --bs-header-colored-bg: #556ee6;
  --bs-topbar-search-bg: #0e142f12;
}
[data-bs-theme=dark][data-topbar=light] {
  --bs-topbar-search-bg: #0e142f;
}
[data-bs-theme=dark][data-sidebar=colored] {
  --bs-topbar-search-bg: #0e142f;
}
[data-bs-theme=dark][data-sidebar=dark] {
  ---bs-sidebar-dark-bg: #252b3b;
  --bs-sidebar-dark-menu-item-color: #8590a5;
  --bs-sidebar-dark-menu-sub-item-color: #8590a5;
  --bs-sidebar-dark-menu-item-icon-color: #8590a5;
  --bs-sidebar-dark-menu-item-hover-color: #d7e4ec;
  --bs-sidebar-dark-menu-item-active-color: #d7e4ec;
  --bs-topbar-search-bg: #2b3244;
}

/*!
 * Waves v0.7.6
 * http://fian.my.id/Waves 
 * 
 * Copyright 2014-2018 Alfiana E. Sibuea and other contributors 
 * Released under the MIT license 
 * https://github.com/fians/Waves/blob/master/LICENSE */
.waves-effect {
  position: relative;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.waves-effect .waves-ripple {
  position: absolute;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin-top: -50px;
  margin-left: -50px;
  opacity: 0;
  background: rgba(0, 0, 0, 0.2);
  background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
  transition: all 0.5s ease-out;
  transition-property: transform, opacity;
  transform: scale(0) translate(0, 0);
  pointer-events: none;
}

.waves-effect.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
  background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
}

.waves-effect.waves-classic .waves-ripple {
  background: rgba(0, 0, 0, 0.2);
}

.waves-effect.waves-classic.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
}

.waves-notransition {
  transition: none !important;
}

.waves-button,
.waves-circle {
  transform: translateZ(0);
  -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);
}

.waves-button,
.waves-button:hover,
.waves-button:visited,
.waves-button-input {
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: none;
  outline: none;
  color: inherit;
  background-color: rgba(0, 0, 0, 0);
  font-size: 1em;
  line-height: 1em;
  text-align: center;
  text-decoration: none;
  z-index: 1;
}

.waves-button {
  padding: 0.85em 1.1em;
  border-radius: 0.2em;
}

.waves-button-input {
  margin: 0;
  padding: 0.85em 1.1em;
}

.waves-input-wrapper {
  border-radius: 0.2em;
  vertical-align: bottom;
}

.waves-input-wrapper.waves-button {
  padding: 0;
}

.waves-input-wrapper .waves-button-input {
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
}

.waves-circle {
  text-align: center;
  width: 2.5em;
  height: 2.5em;
  line-height: 2.5em;
  border-radius: 50%;
}

.waves-float {
  -webkit-mask-image: none;
  box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);
  transition: all 300ms;
}

.waves-float:active {
  box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);
}

.waves-block {
  display: block;
}

.waves-effect.waves-light .waves-ripple {
  background-color: rgba(255, 255, 255, 0.4);
}

.waves-effect.waves-primary .waves-ripple {
  background-color: rgba(255, 90, 95, 0.4);
}

.waves-effect.waves-success .waves-ripple {
  background-color: rgba(28, 187, 140, 0.4);
}

.waves-effect.waves-info .waves-ripple {
  background-color: rgba(74, 163, 255, 0.4);
}

.waves-effect.waves-warning .waves-ripple {
  background-color: rgba(252, 185, 44, 0.4);
}

.waves-effect.waves-danger .waves-ripple {
  background-color: rgba(255, 61, 96, 0.4);
}

.avatar-xs {
  height: 2rem;
  width: 2rem;
}

.avatar-sm {
  height: 3rem;
  width: 3rem;
}

.avatar-md {
  height: 4.5rem;
  width: 4.5rem;
}

.avatar-lg {
  height: 6rem;
  width: 6rem;
}

.avatar-xl {
  height: 7.5rem;
  width: 7.5rem;
}

.avatar-title {
  align-items: center;
  background-color: rgb(255, 90, 95);
  color: #fff;
  display: flex;
  font-weight: 500;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.avatar-group {
  padding-left: 12px;
  display: flex;
  flex-wrap: wrap;
}
.avatar-group .avatar-group-item {
  margin-left: -12px;
  border: 2px solid var(--bs-secondary-bg);
  border-radius: 50%;
  transition: all 0.2s;
}
.avatar-group .avatar-group-item:hover {
  position: relative;
  transform: translateY(-2px);
}

.custom-accordion .card + .card {
  margin-top: 0.5rem;
}
.custom-accordion a.collapsed i.accor-plus-icon:before {
  content: "\\f0415";
}
.custom-accordion .card-header {
  border-radius: 7px;
}

.custom-accordion-arrow .card {
  border: 1px solid var(--bs-border-color);
  box-shadow: none;
}
.custom-accordion-arrow .card-header {
  padding-left: 45px;
  position: relative;
}
.custom-accordion-arrow .card-header .accor-arrow-icon {
  position: absolute;
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  font-size: 16px;
  background-color: rgb(255, 90, 95);
  color: #fff;
  border-radius: 50%;
  text-align: center;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}
.custom-accordion-arrow a.collapsed i.accor-arrow-icon:before {
  content: "\\f0142";
}

.font-family-secondary {
  font-family: "Inter", sans-serif;
}

.font-size-10 {
  font-size: 10px !important;
}

.font-size-11 {
  font-size: 11px !important;
}

.font-size-12 {
  font-size: 12px !important;
}

.font-size-13 {
  font-size: 13px !important;
}

.font-size-14 {
  font-size: 14px !important;
}

.font-size-15 {
  font-size: 15px !important;
}

.font-size-16 {
  font-size: 16px !important;
}

.font-size-17 {
  font-size: 17px !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.font-size-20 {
  font-size: 20px !important;
}

.font-size-22 {
  font-size: 22px !important;
}

.font-size-24 {
  font-size: 24px !important;
}

.social-list-item {
  height: 2rem;
  width: 2rem;
  line-height: calc(2rem - 2px);
  display: block;
  border: 1px solid #bdbcad;
  border-radius: 50%;
  color: #bdbcad;
  text-align: center;
  transition: all 0.4s;
}
.social-list-item:hover {
  color: #74788d;
  background-color: #f7efef;
}

.w-xs {
  min-width: 80px;
}

.w-sm {
  min-width: 95px;
}

.w-md {
  min-width: 110px;
}

.w-lg {
  min-width: 140px;
}

.w-xl {
  min-width: 160px;
}

.bg-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
}

.flex-1 {
  flex: 1 1;
}

.alert-dismissible .btn-close {
  font-size: 10px;
  padding: 1.05rem 1.25rem;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_61___}) center/1em auto no-repeat;
}

#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--bs-secondary-bg);
  z-index: 9999;
}

#status {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateY(-50%);
  margin: -20px 0 0 -20px;
}

.spinner .spin-icon {
  font-size: 56px;
  color: rgb(255, 90, 95);
  position: relative;
  display: inline-block;
  animation: spin 1.6s infinite linear;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
.form-check-right {
  padding-left: 0;
  display: inline-block;
  padding-right: 1.5em;
}
.form-check-right .form-check-input {
  float: right;
  margin-left: 0;
  margin-right: -1.5em;
}
.form-check-right .form-check-label {
  display: block;
}

.form-check {
  position: relative;
  text-align: left;
}

.form-check-label {
  cursor: pointer;
  margin-bottom: 0;
}

.activity-wid {
  margin-top: 8px;
  margin-left: 16px;
}
.activity-wid .activity-list {
  position: relative;
  padding: 0 0 40px 30px;
}
.activity-wid .activity-list:before {
  content: "";
  border-left: 2px dashed rgba(255, 90, 95, 0.25);
  position: absolute;
  left: 0;
  bottom: 0;
  top: 32px;
}
.activity-wid .activity-list .activity-icon {
  position: absolute;
  left: -15px;
  top: 0;
  z-index: 9;
}
.activity-wid .activity-list:last-child {
  padding-bottom: 0px;
}

.button-items {
  margin-left: -8px;
  margin-bottom: -12px;
}
.button-items .btn {
  margin-bottom: 12px;
  margin-left: 8px;
}

.mfp-popup-form {
  max-width: 1140px;
}

.bs-example-modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block;
}

.icon-demo-content {
  color: #bdbcad;
}
.icon-demo-content i {
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 36px;
  font-size: 22px;
  color: #74788d;
  border: 2px solid var(--bs-border-color);
  border-radius: 4px;
  transition: all 0.4s;
  text-align: center;
  margin-right: 16px;
  vertical-align: middle;
}
.icon-demo-content .col-lg-4 {
  margin-top: 24px;
}
.icon-demo-content .col-lg-4:hover i {
  color: #fff;
  background-color: rgb(255, 90, 95);
  border-color: rgb(255, 90, 95);
}

.grid-structure .grid-container {
  background-color: #faf8f8;
  margin-top: 10px;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 10px 20px;
}

.card-radio {
  background-color: var(--bs-secondary-bg);
  border: 2px solid var(--bs-border-color);
  border-radius: 0.375rem;
  padding: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
.card-radio:hover {
  cursor: pointer;
}

.card-radio-label {
  display: block;
}

.card-radio-input {
  display: none;
}
.card-radio-input:checked + .card-radio {
  border-color: rgb(255, 90, 95) !important;
}

.navs-carousel .owl-nav {
  margin-top: 16px;
}
.navs-carousel .owl-nav button {
  width: 30px;
  height: 30px;
  line-height: 28px !important;
  font-size: 20px !important;
  border-radius: 50% !important;
  background-color: rgba(255, 90, 95, 0.25) !important;
  color: rgb(255, 90, 95) !important;
  margin: 4px 8px !important;
}

@media print {
  .vertical-menu,
  .right-bar,
  .page-title-box,
  .navbar-header,
  .footer {
    display: none !important;
  }
  .card-body,
  .main-content,
  .right-bar,
  .page-content,
  body {
    padding: 0;
    margin: 0;
  }
  .card {
    border: 0;
  }
}
[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0 !important;
  bottom: 0;
  right: 0 !important;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.simplebar-content-wrapper {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  visibility: visible;
  overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */
  max-width: 100%; /* Not required for horizontal scroll to trigger */
  max-height: 100%; /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
  padding: 0px !important;
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.simplebar-content:before,
.simplebar-content:after {
  content: " ";
  display: table;
}

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0;
}

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
}

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all;
}

.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 6px;
  min-height: 10px;
}

.simplebar-scrollbar:before {
  position: absolute;
  content: "";
  background: #a2adb7;
  border-radius: 7px;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.2s linear;
}

.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear;
}

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px;
}

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px;
}

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto;
}

/* Rtl support */
[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0;
}

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll;
}

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
}

.custom-scroll {
  height: 100%;
}

.fc-toolbar h2, .fc-toolbar .h2 {
  font-size: 16px;
  line-height: 30px;
  text-transform: uppercase;
}

.fc th.fc-widget-header {
  background: #faf8f8;
  font-size: 13px;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
  font-weight: 600;
}

.fc-unthemed .fc-content,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-list-heading td,
.fc-unthemed .fc-list-view,
.fc-unthemed .fc-popover,
.fc-unthemed .fc-row,
.fc-unthemed tbody,
.fc-unthemed td,
.fc-unthemed th,
.fc-unthemed thead {
  border-color: var(--bs-border-color);
}
.fc-unthemed td.fc-today {
  background: rgb(253.8, 252.6, 252.6);
}

.fc-button {
  background: var(--bs-secondary-bg);
  border-color: var(--bs-border-color);
  color: #2d3448;
  text-transform: capitalize;
  box-shadow: none;
  padding: 6px 12px !important;
  height: auto !important;
}

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: rgb(255, 90, 95);
  color: #fff;
  text-shadow: none;
}

.fc-event {
  border-radius: 2px;
  border: none;
  cursor: move;
  font-size: 0.8125rem;
  margin: 5px 7px;
  padding: 5px 5px;
  text-align: center;
}

#external-events .external-event {
  text-align: left !important;
  padding: 8px 16px;
}

.fc-event, .fc-event-dot {
  background-color: rgb(255, 90, 95);
}

.fc-event .fc-content {
  color: #fff;
}

.fc .table-bordered td, .fc .table-bordered th {
  border-color: var(--bs-border-color);
}
@media (max-width: 575.98px) {
  .fc .fc-toolbar {
    display: block;
  }
}
.fc .fc-toolbar h2, .fc .fc-toolbar .h2 {
  font-size: 16px;
  line-height: 30px;
  text-transform: uppercase;
}
@media (max-width: 767.98px) {
  .fc .fc-toolbar .fc-left,
  .fc .fc-toolbar .fc-right,
  .fc .fc-toolbar .fc-center {
    float: none;
    display: block;
    text-align: center;
    clear: both;
    margin: 10px 0;
  }
  .fc .fc-toolbar > * > * {
    float: none;
  }
  .fc .fc-toolbar .fc-today-button {
    display: none;
  }
}
.fc .fc-toolbar .btn {
  text-transform: capitalize;
}

.fc-bootstrap .fc-today.alert-info {
  background-color: var(--bs-tertiary-bg);
}

.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark {
  background-color: #000 !important;
}

[dir=rtl] .fc-header-toolbar {
  direction: ltr !important;
}

[dir=rtl] .fc-toolbar > * > :not(:first-child) {
  margin-left: 0.75em;
}

.sp-container {
  background-color: var(--bs-secondary-bg);
}
.sp-container button {
  padding: 0.25rem 0.5rem;
  font-size: 0.71094rem;
  border-radius: 0.2rem;
  font-weight: 400;
  color: #212529;
}
.sp-container button.sp-palette-toggle {
  background-color: #faf8f8;
}
.sp-container button.sp-choose {
  background-color: #1cbb8c;
  margin-left: 5px;
  margin-right: 0;
}

.sp-palette-container {
  border-right: 1px solid var(--bs-border-color);
}

.sp-input {
  background-color: var(--bs-secondary-bg);
  border-color: var(--bs-border-color-translucent) !important;
  color: var(--bs-body-color);
}
.sp-input:focus {
  outline: none;
}

[dir=rtl] .sp-alpha {
  direction: rtl;
}
[dir=rtl] .sp-original-input-container .sp-add-on {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}
[dir=rtl] input.spectrum.with-add-on {
  border: 1px solid var(--bs-border-color-translucent);
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: var(--bs-border-radius);
  border-bottom-right-radius: var(--bs-border-radius);
}

#session-timeout-dialog .close {
  display: none;
}
#session-timeout-dialog .countdown-holder {
  color: #ff3d60;
  font-weight: 500;
}
#session-timeout-dialog .btn-default {
  background-color: #fff;
  color: #ff3d60;
  box-shadow: none;
}

.rs-control {
  margin: 0px auto;
}

.rs-path-color {
  background-color: #aaa9a9;
}

.rs-bg-color {
  background-color: var(--bs-body-bg) !important;
}

.rs-border {
  border-color: transparent;
}

.rs-handle {
  background-color: #2d3448;
}

.rs-circle-border .rs-border {
  border: 8px solid #aaa9a9;
}

.rs-disabled {
  opacity: 1;
}

.outer-border .rs-border {
  border-width: 0px;
}
.outer-border .rs-border.rs-outer {
  border: 14px solid #aaa9a9;
}
.outer-border .rs-handle {
  margin-left: 0 !important;
}
.outer-border .rs-path-color {
  background-color: transparent;
}

.outer-border-dot .rs-border.rs-outer {
  border: 16px dotted;
}
.outer-border-dot .rs-handle {
  margin-left: 0 !important;
}

.rs-range-primary .rs-range-color {
  background-color: rgb(255, 90, 95);
}
.rs-range-primary .rs-handle-dot {
  background-color: rgb(255, 212.4, 213.6909090909);
  border-color: rgb(255, 90, 95);
}
.rs-range-primary .rs-handle-dot:after {
  background-color: rgb(255, 90, 95);
}
.rs-range-primary.rs-circle-border .rs-handle {
  background-color: rgb(255, 90, 95);
}
.rs-range-primary.outer-border-dot .rs-border.rs-outer {
  border-color: rgb(255, 212.4, 213.6909090909);
}

.rs-range-secondary .rs-range-color {
  background-color: #008489;
}
.rs-range-secondary .rs-handle-dot {
  background-color: rgb(4.4, 245.8540145985, 255);
  border-color: #008489;
}
.rs-range-secondary .rs-handle-dot:after {
  background-color: #008489;
}
.rs-range-secondary.rs-circle-border .rs-handle {
  background-color: #008489;
}
.rs-range-secondary.outer-border-dot .rs-border.rs-outer {
  border-color: rgb(4.4, 245.8540145985, 255);
}

.rs-range-success .rs-range-color {
  background-color: #1cbb8c;
}
.rs-range-success .rs-handle-dot {
  background-color: rgb(104.8781395349, 232.5218604651, 194.7906976744);
  border-color: #1cbb8c;
}
.rs-range-success .rs-handle-dot:after {
  background-color: #1cbb8c;
}
.rs-range-success.rs-circle-border .rs-handle {
  background-color: #1cbb8c;
}
.rs-range-success.outer-border-dot .rs-border.rs-outer {
  border-color: rgb(104.8781395349, 232.5218604651, 194.7906976744);
}

.rs-range-info .rs-range-color {
  background-color: #4aa3ff;
}
.rs-range-info .rs-handle-dot {
  background-color: rgb(196.4, 225.2143646409, 255);
  border-color: #4aa3ff;
}
.rs-range-info .rs-handle-dot:after {
  background-color: #4aa3ff;
}
.rs-range-info.rs-circle-border .rs-handle {
  background-color: #4aa3ff;
}
.rs-range-info.outer-border-dot .rs-border.rs-outer {
  border-color: rgb(196.4, 225.2143646409, 255);
}

.rs-range-warning .rs-range-color {
  background-color: #fcb92c;
}
.rs-range-warning .rs-handle-dot {
  background-color: rgb(253.7158878505, 225.0373831776, 164.6841121495);
  border-color: #fcb92c;
}
.rs-range-warning .rs-handle-dot:after {
  background-color: #fcb92c;
}
.rs-range-warning.rs-circle-border .rs-handle {
  background-color: #fcb92c;
}
.rs-range-warning.outer-border-dot .rs-border.rs-outer {
  border-color: rgb(253.7158878505, 225.0373831776, 164.6841121495);
}

.rs-range-danger .rs-range-color {
  background-color: #ff3d60;
}
.rs-range-danger .rs-handle-dot {
  background-color: rgb(255, 183.4, 196.3175257732);
  border-color: #ff3d60;
}
.rs-range-danger .rs-handle-dot:after {
  background-color: #ff3d60;
}
.rs-range-danger.rs-circle-border .rs-handle {
  background-color: #ff3d60;
}
.rs-range-danger.outer-border-dot .rs-border.rs-outer {
  border-color: rgb(255, 183.4, 196.3175257732);
}

.rs-range-light .rs-range-color {
  background-color: #faf8f8;
}
.rs-range-light .rs-handle-dot {
  background-color: white;
  border-color: #faf8f8;
}
.rs-range-light .rs-handle-dot:after {
  background-color: #faf8f8;
}
.rs-range-light.rs-circle-border .rs-handle {
  background-color: #faf8f8;
}
.rs-range-light.outer-border-dot .rs-border.rs-outer {
  border-color: white;
}

.rs-range-dark .rs-range-color {
  background-color: #212529;
}
.rs-range-dark .rs-handle-dot {
  background-color: rgb(87.5837837838, 98.2, 108.8162162162);
  border-color: #212529;
}
.rs-range-dark .rs-handle-dot:after {
  background-color: #212529;
}
.rs-range-dark.rs-circle-border .rs-handle {
  background-color: #212529;
}
.rs-range-dark.outer-border-dot .rs-border.rs-outer {
  border-color: rgb(87.5837837838, 98.2, 108.8162162162);
}

.rs-handle-arrow .rs-handle {
  background-color: transparent;
  border: 8px solid transparent;
  border-right-color: #2d3448;
  margin: -6px 0px 0px 14px !important;
  border-width: 6px 104px 6px 4px;
}
.rs-handle-arrow .rs-handle:before {
  display: block;
  content: " ";
  position: absolute;
  height: 22px;
  width: 22px;
  background: #2d3448;
  right: -11px;
  bottom: -11px;
  border-radius: 100px;
}

.rs-handle-arrow-dash .rs-handle {
  background-color: transparent;
  border: 8px solid transparent;
  border-right-color: #2d3448;
  margin: -8px 0 0 14px !important;
}
.rs-handle-arrow-dash .rs-handle:before {
  display: block;
  content: " ";
  position: absolute;
  height: 12px;
  width: 12px;
  background: #2d3448;
  right: -6px;
  bottom: -6px;
  border-radius: 100%;
}
.rs-handle-arrow-dash .rs-handle:after {
  display: block;
  content: " ";
  width: 80px;
  position: absolute;
  top: -1px;
  right: 0px;
  border-top: 2px dotted #2d3448;
}

.irs {
  font-family: var(--bs-font-sans-serif);
}

.irs--round .irs-bar,
.irs--round .irs-to,
.irs--round .irs-from,
.irs--round .irs-single {
  background: rgb(255, 90, 95) !important;
  font-size: 11px;
}
.irs--round .irs-to:before,
.irs--round .irs-from:before,
.irs--round .irs-single:before {
  display: none;
}
.irs--round .irs-line {
  background: var(--bs-tertiary-bg);
  border-color: var(--bs-border-color);
}
.irs--round .irs-grid-text {
  font-size: 11px;
  color: #bdbcad;
}
.irs--round .irs-min,
.irs--round .irs-max {
  color: #bdbcad;
  background: var(--bs-tertiary-bg);
  font-size: 11px;
}
.irs--round .irs-handle {
  border: 2px solid rgb(255, 90, 95);
  width: 16px;
  height: 16px;
  top: 29px;
  background-color: var(--bs-secondary-bg) !important;
}

.swal2-container .swal2-title {
  font-size: 24px;
  font-weight: 500;
}

.swal2-content {
  font-size: 16px;
}

.swal2-icon.swal2-question {
  border-color: #4aa3ff;
  color: #4aa3ff;
}
.swal2-icon.swal2-success [class^=swal2-success-line] {
  background-color: #1cbb8c;
}
.swal2-icon.swal2-success .swal2-success-ring {
  border-color: rgba(28, 187, 140, 0.3);
}
.swal2-icon.swal2-warning {
  border-color: #fcb92c;
  color: #fcb92c;
}

.swal2-styled:focus {
  box-shadow: none;
}

.swal2-progress-steps .swal2-progress-step {
  background: rgb(255, 90, 95);
}
.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
  background: rgb(255, 90, 95);
}
.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step, .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {
  background: rgba(255, 90, 95, 0.3);
}
.swal2-progress-steps .swal2-progress-step-line {
  background: rgb(255, 90, 95);
}

.swal2-loader {
  border-color: rgb(255, 90, 95) transparent rgb(255, 90, 95) transparent;
}

.swal2-modal {
  background-color: var(--bs-secondary-bg) !important;
  color: var(--bs-body-color) !important;
}

.swal2-content {
  background-color: var(--bs-secondary-bg) !important;
  color: var(--bs-secondary-color) !important;
}

.swal2-title {
  color: var(--bs-secondary-color) !important;
}

.symbol {
  border-color: var(--bs-secondary-bg);
}

.rating-symbol-background, .rating-symbol-foreground {
  font-size: 24px;
}

.rating-symbol-foreground {
  top: 0px;
}

.rating-star > span {
  display: inline-block;
  vertical-align: middle;
}
.rating-star > span.badge {
  margin-left: 4px;
}

/* =============
   Notification
============= */
#toast-container > div {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  opacity: 1;
}
#toast-container > div:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  opacity: 0.9;
}
#toast-container.toast-top-full-width > div, #toast-container.toast-bottom-full-width > div {
  min-width: 96%;
  margin: 4px auto;
}

.toast-primary {
  border: 2px solid rgb(255, 90, 95) !important;
  background-color: rgba(255, 90, 95, 0.8) !important;
}

.toast-secondary {
  border: 2px solid #008489 !important;
  background-color: rgba(0, 132, 137, 0.8) !important;
}

.toast-success {
  border: 2px solid #1cbb8c !important;
  background-color: rgba(28, 187, 140, 0.8) !important;
}

.toast-info {
  border: 2px solid #4aa3ff !important;
  background-color: rgba(74, 163, 255, 0.8) !important;
}

.toast-warning {
  border: 2px solid #fcb92c !important;
  background-color: rgba(252, 185, 44, 0.8) !important;
}

.toast-danger {
  border: 2px solid #ff3d60 !important;
  background-color: rgba(255, 61, 96, 0.8) !important;
}

.toast-light {
  border: 2px solid #faf8f8 !important;
  background-color: rgba(250, 248, 248, 0.8) !important;
}

.toast-dark {
  border: 2px solid #212529 !important;
  background-color: rgba(33, 37, 41, 0.8) !important;
}

.toast-error {
  background-color: rgba(255, 61, 96, 0.8);
  border: 2px solid #ff3d60;
}

.toastr-options {
  padding: 24px;
  background-color: var(--bs-tertiary-bg);
  margin-bottom: 0;
  border: 1px solid var(--bs-border-color);
}

.error {
  color: #ff3d60;
}

.parsley-error {
  border-color: #ff3d60;
}

.parsley-errors-list {
  display: none;
  margin: 0;
  padding: 0;
}
.parsley-errors-list.filled {
  display: block;
}
.parsley-errors-list > li {
  font-size: 12px;
  list-style: none;
  color: #ff3d60;
  margin-top: 5px;
}

.select2-container {
  display: block;
}
.select2-container .select2-selection--single {
  background-color: var(--bs-secondary-bg);
  border: 1px solid var(--bs-border-color-translucent);
  height: 38px;
}
.select2-container .select2-selection--single:focus {
  outline: none;
}
.select2-container .select2-selection--single .select2-selection__rendered {
  line-height: 36px;
  padding-left: 12px;
  color: var(--bs-body-color);
}
.select2-container .select2-selection--single .select2-selection__arrow {
  height: 34px;
  width: 34px;
  right: 3px;
}
.select2-container .select2-selection--single .select2-selection__arrow b {
  border-color: #bdbcad transparent transparent transparent;
  border-width: 6px 6px 0 6px;
}
.select2-container .select2-selection--single .select2-selection__placeholder {
  color: var(--bs-body-color);
}

.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: transparent transparent #bdbcad transparent !important;
  border-width: 0 6px 6px 6px !important;
}

.select2-container--default .select2-search--dropdown {
  padding: 10px;
  background-color: var(--bs-secondary-bg);
}
.select2-container--default .select2-search--dropdown .select2-search__field {
  border: 1px solid var(--bs-border-color-translucent);
  background-color: var(--bs-secondary-bg);
  color: #74788d;
  outline: none;
}
.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: rgb(255, 90, 95);
}
.select2-container--default .select2-results__option[aria-selected=true] {
  background-color: var(--bs-tertiary-bg);
  color: var(--bs-secondary-color);
}
.select2-container--default .select2-results__option[aria-selected=true]:hover {
  background-color: rgb(255, 90, 95);
  color: #fff;
}

.select2-results__option {
  padding: 6px 12px;
}

.select2-dropdown {
  border: 1px solid var(--bs-border-color);
  background-color: var(--bs-secondary-bg);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.select2-search input {
  border: 1px solid var(--bs-border-color);
}

.select2-container .select2-selection--multiple {
  min-height: 38px;
  background-color: var(--bs-secondary-bg);
  border: 1px solid var(--bs-border-color-translucent) !important;
}
.select2-container .select2-selection--multiple .select2-selection__rendered {
  padding: 2px 10px;
}
.select2-container .select2-selection--multiple .select2-search__field {
  border: 0;
  color: var(--bs-body-color);
}
.select2-container .select2-selection--multiple .select2-search__field::placeholder {
  color: var(--bs-body-color);
}
.select2-container .select2-selection--multiple .select2-selection__choice {
  background-color: var(--bs-tertiary-bg);
  border: 1px solid var(--bs-border-color);
  border-radius: 1px;
  padding: 0 7px;
}

.select2-container--default.select2-container--focus .select2-selection--multiple {
  border-color: var(--bs-border-color);
}
.select2-container--default .select2-results__group {
  font-weight: 600;
}

.select2-result-repository__avatar {
  float: left;
  width: 60px;
  margin-right: 10px;
}
.select2-result-repository__avatar img {
  width: 100%;
  height: auto;
  border-radius: 2px;
}

.select2-result-repository__statistics {
  margin-top: 7px;
}

.select2-result-repository__forks,
.select2-result-repository__stargazers,
.select2-result-repository__watchers {
  display: inline-block;
  font-size: 11px;
  margin-right: 1em;
  color: #bdbcad;
}
.select2-result-repository__forks .fa,
.select2-result-repository__stargazers .fa,
.select2-result-repository__watchers .fa {
  margin-right: 4px;
}
.select2-result-repository__forks .fa.fa-flash::before,
.select2-result-repository__stargazers .fa.fa-flash::before,
.select2-result-repository__watchers .fa.fa-flash::before {
  content: "\\f0e7";
  font-family: "Font Awesome 5 Free";
}

.select2-results__option--highlighted .select2-result-repository__forks,
.select2-results__option--highlighted .select2-result-repository__stargazers,
.select2-results__option--highlighted .select2-result-repository__watchers {
  color: rgba(255, 255, 255, 0.8);
}

.select2-result-repository__meta {
  overflow: hidden;
}

.img-flag {
  margin-right: 7px;
  height: 15px;
  width: 18px;
}

/* CSS Switch */
input[switch] {
  display: none;
}
input[switch] + label {
  font-size: 1em;
  line-height: 1;
  width: 56px;
  height: 24px;
  background-color: #dad1ce;
  background-image: none;
  border-radius: 2rem;
  padding: 0.16667rem;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  position: relative;
  font-weight: 500;
  transition: all 0.1s ease-in-out;
}
input[switch] + label:before {
  color: #212529;
  content: attr(data-off-label);
  display: block;
  font-family: inherit;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  position: absolute;
  right: 1px;
  margin: 3px;
  top: -2px;
  text-align: center;
  min-width: 1.66667rem;
  overflow: hidden;
  transition: all 0.1s ease-in-out;
}
input[switch] + label:after {
  content: "";
  position: absolute;
  left: 3px;
  background-color: #f7efef;
  box-shadow: none;
  border-radius: 2rem;
  height: 20px;
  width: 20px;
  top: 2px;
  transition: all 0.1s ease-in-out;
}
input[switch]:checked + label {
  background-color: rgb(255, 90, 95);
}
input[switch]:checked + label:before {
  color: #fff;
  content: attr(data-on-label);
  right: auto;
  left: 3px;
}
input[switch]:checked + label:after {
  left: 33px;
  background-color: #f7efef;
}

input[switch=bool] + label {
  background-color: #ff3d60;
}

input[switch=bool] + label:before, input[switch=bool]:checked + label:before,
input[switch=default]:checked + label:before {
  color: #fff;
}

input[switch=bool]:checked + label {
  background-color: #1cbb8c;
}

input[switch=default]:checked + label {
  background-color: #a2a2a2;
}

input[switch=primary]:checked + label {
  background-color: rgb(255, 90, 95);
}

input[switch=success]:checked + label {
  background-color: #1cbb8c;
}

input[switch=info]:checked + label {
  background-color: #4aa3ff;
}

input[switch=warning]:checked + label {
  background-color: #fcb92c;
}

input[switch=danger]:checked + label {
  background-color: #ff3d60;
}

input[switch=dark]:checked + label {
  background-color: #212529;
}

.square-switch {
  margin-right: 7px;
}
.square-switch input[switch] + label, .square-switch input[switch] + label:after {
  border-radius: 4px;
}

.datepicker {
  border: 1px solid #faf8f8;
  padding: 8px;
  z-index: 999 !important;
}
.datepicker table tr th {
  font-weight: 500;
}
.datepicker table tr td.active, .datepicker table tr td.active:hover, .datepicker table tr td .active.disabled, .datepicker table tr td.active.disabled:hover, .datepicker table tr td.today, .datepicker table tr td.today:hover, .datepicker table tr td.today.disabled, .datepicker table tr td.today.disabled:hover, .datepicker table tr td.selected, .datepicker table tr td.selected:hover, .datepicker table tr td.selected.disabled, .datepicker table tr td.selected.disabled:hover {
  background-color: rgb(255, 90, 95) !important;
  background-image: none;
  box-shadow: none;
  color: #fff !important;
}
.datepicker table tr td.day.focused, .datepicker table tr td.day:hover,
.datepicker table tr td span.focused,
.datepicker table tr td span:hover {
  background: #f7efef;
}
.datepicker table tr td.new, .datepicker table tr td.old,
.datepicker table tr td span.new,
.datepicker table tr td span.old {
  color: #bdbcad;
  opacity: 0.6;
}
.datepicker table tr td.range, .datepicker table tr td.range.disabled, .datepicker table tr td.range.disabled:hover, .datepicker table tr td.range:hover {
  background-color: #aaa9a9;
}

.table-condensed > thead > tr > th, .table-condensed > tbody > tr > td {
  padding: 7px;
}

.bootstrap-touchspin.input-group > .input-group-prepend > .btn, .bootstrap-touchspin.input-group > .input-group-prepend > .input-group-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.bootstrap-touchspin.input-group > .input-group-append > .btn, .bootstrap-touchspin.input-group > .input-group-append > .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dataTables_wrapper.container-fluid, .dataTables_wrapper.container-sm, .dataTables_wrapper.container-md, .dataTables_wrapper.container-lg, .dataTables_wrapper.container-xl, .dataTables_wrapper.container-xxl {
  padding: 0;
}

div.dataTables_wrapper div.dataTables_filter {
  text-align: right;
}
@media (max-width: 767px) {
  div.dataTables_wrapper div.dataTables_filter {
    text-align: center;
  }
}
div.dataTables_wrapper div.dataTables_filter input {
  margin-left: 0.5em;
  margin-right: 0;
}

.datatable td:focus {
  outline: none;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:first-child {
  padding-left: 0;
}
div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:last-child {
  padding-right: 0;
}

table.dataTable {
  border-collapse: collapse !important;
  margin-bottom: 15px !important;
}
table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc_disabled:before {
  left: auto;
  right: 0.5rem;
  content: "\\f0360";
  font-family: "Material Design Icons";
  font-size: 1rem;
  top: 9px;
}
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  left: auto;
  right: 0.5em;
  content: "\\f035d";
  font-family: "Material Design Icons";
  top: 15px;
  font-size: 1rem;
}
table.dataTable thead tr th.sorting_asc, table.dataTable thead tr th.sorting_desc, table.dataTable thead tr th.sorting,
table.dataTable thead tr td.sorting_asc,
table.dataTable thead tr td.sorting_desc,
table.dataTable thead tr td.sorting {
  padding-left: 12px;
  padding-right: 30px;
}
table.dataTable tbody > tr.selected, table.dataTable tbody > tr > .selected {
  background-color: rgba(255, 90, 95, 0.2);
}
table.dataTable tbody > tr.selected td, table.dataTable tbody > tr > .selected td {
  border-color: rgba(255, 90, 95, 0.2);
  color: rgb(255, 90, 95);
}
table.dataTable tbody td:focus {
  outline: none !important;
}
table.dataTable tbody th.focus, table.dataTable tbody td.focus {
  outline: 2px solid rgb(255, 90, 95) !important;
  outline-offset: -1px;
  background-color: rgba(255, 90, 95, 0.15);
}

.dataTables_info {
  font-weight: 600;
}

table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > td:first-child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > th:first-child:before {
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);
  background-color: #1cbb8c;
  bottom: auto;
}
table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td:first-child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr.parent > th:first-child:before {
  background-color: #ff3d60;
}

div.dt-button-info {
  background-color: rgb(255, 90, 95);
  border: none;
  color: #fff;
  box-shadow: none;
  border-radius: 3px;
  text-align: center;
  z-index: 21;
}
div.dt-button-info h2, div.dt-button-info .h2 {
  border-bottom: none;
  background-color: rgba(255, 255, 255, 0.2);
  color: #fff;
}

@media (max-width: 767.98px) {
  li.paginate_button.previous,
  li.paginate_button.next {
    display: inline-block;
    font-size: 1.5rem;
  }
  li.paginate_button {
    display: none;
  }
  .dataTables_paginate ul {
    text-align: center;
    display: block;
    margin: 1rem 0 0 !important;
  }
  div.dt-buttons {
    display: inline-table;
    margin-bottom: 1rem;
  }
}
.activate-select .sorting_1 {
  background-color: #faf8f8;
}

.table-bordered {
  border: var(--bs-border-width) solid var(--bs-border-color);
}

.table.dataTable.dtr-inline.collapsed > tbody > tr > td,
table.dataTable.dtr-inline.collapsed > tbody > tr > td {
  position: relative;
}
.table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control {
  padding-left: 30px;
}
.table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control:before {
  top: 64%;
  left: 5px;
  height: 14px;
  width: 14px;
  margin-top: -14px;
  display: block;
  position: absolute;
  color: #fff;
  border: 2px solid #fff;
  border-radius: 14px;
  box-sizing: content-box;
  text-align: center;
  text-indent: 0 !important;
  line-height: 12px;
  content: "+";
  background-color: rgb(255, 90, 95);
}

.tox-tinymce {
  border: 2px solid var(--bs-border-color) !important;
}

.tox .tox-statusbar {
  border-top: 1px solid var(--bs-border-color) !important;
}
.tox .tox-menubar,
.tox .tox-edit-area__iframe,
.tox .tox-statusbar {
  background-color: var(--bs-secondary-bg) !important;
  background: none !important;
}
.tox .tox-mbtn {
  color: var(--bs-body-color) !important;
}
.tox .tox-mbtn:hover:not(:disabled):not(.tox-mbtn--active) {
  background-color: var(--bs-tertiary-bg) !important;
}
.tox .tox-tbtn:hover {
  background-color: var(--bs-tertiary-bg) !important;
}
.tox .tox-toolbar__primary {
  border-color: var(--bs-border-color) !important;
}
.tox .tox-toolbar,
.tox .tox-toolbar__overflow,
.tox .tox-toolbar__primary {
  background: var(--bs-tertiary-bg) !important;
}
.tox .tox-tbtn {
  color: var(--bs-body-color) !important;
}
.tox .tox-tbtn svg {
  fill: var(--bs-body-color) !important;
}
.tox .tox-statusbar a,
.tox .tox-statusbar__path-item,
.tox .tox-statusbar__wordcount {
  color: var(--bs-body-color) !important;
}
.tox:not([dir=rtl]) .tox-toolbar__group:not(:last-of-type) {
  border-right: 1px solid var(--bs-border-color) !important;
}

.tox-tinymce-aux {
  z-index: 1050 !important;
}

.tox .tox-toolbar-overlord {
  background-color: var(--bs-tertiary-bg) !important;
}

/* Dropzone */
.dropzone {
  min-height: 230px;
  border: 2px dashed var(--bs-border-color);
  background: var(--bs-secondary-bg);
  border-radius: 6px;
}
.dropzone .dz-message {
  font-size: 24px;
  width: 100%;
}

.sp-colorize-container {
  border: none !important;
}

.twitter-bs-wizard .twitter-bs-wizard-nav {
  position: relative;
}
.twitter-bs-wizard .twitter-bs-wizard-nav:before {
  content: "";
  width: 100%;
  height: 2px;
  background-color: var(--bs-border-color);
  position: absolute;
  left: 0;
  top: 26px;
}
.twitter-bs-wizard .twitter-bs-wizard-nav .step-number {
  display: inline-block;
  width: 38px;
  height: 38px;
  line-height: 34px;
  border: 2px solid rgb(255, 90, 95);
  color: rgb(255, 90, 95);
  text-align: center;
  border-radius: 50%;
  position: relative;
  background-color: var(--bs-secondary-bg);
}
@media (max-width: 991.98px) {
  .twitter-bs-wizard .twitter-bs-wizard-nav .step-number {
    display: block;
    margin: 0 auto 8px !important;
  }
}
.twitter-bs-wizard .twitter-bs-wizard-nav .nav-link .step-title {
  display: block;
  margin-top: 8px;
  font-weight: 800;
}
@media (max-width: 575.98px) {
  .twitter-bs-wizard .twitter-bs-wizard-nav .nav-link .step-title {
    display: none;
  }
}
.twitter-bs-wizard .twitter-bs-wizard-nav .nav-link.active {
  background-color: transparent;
  color: var(--bs-body-color);
}
.twitter-bs-wizard .twitter-bs-wizard-nav .nav-link.active .step-number {
  background-color: rgb(255, 90, 95);
  color: #fff;
}
.twitter-bs-wizard .twitter-bs-wizard-pager-link {
  padding-top: 24px;
  padding-left: 0;
  list-style: none;
  margin-bottom: 0;
}
.twitter-bs-wizard .twitter-bs-wizard-pager-link li {
  display: inline-block;
}
.twitter-bs-wizard .twitter-bs-wizard-pager-link li a {
  display: inline-block;
  padding: 0.47rem 0.75rem;
  background-color: rgb(255, 90, 95);
  color: #fff;
  border-radius: 0.25rem;
}
.twitter-bs-wizard .twitter-bs-wizard-pager-link li.disabled a {
  cursor: not-allowed;
  background-color: rgb(255, 130.8, 134.5636363636);
}
.twitter-bs-wizard .twitter-bs-wizard-pager-link li.next {
  float: right;
}

.twitter-bs-wizard-tab-content {
  padding-top: 24px;
  min-height: 262px;
}

.table-rep-plugin .btn-toolbar {
  display: block;
}
.table-rep-plugin .table-responsive {
  border: none !important;
}
.table-rep-plugin .btn-group .btn-default {
  background-color: #faf8f8;
  color: #212529;
  border: 1px solid rgb(245.75, 242.05, 242.05);
}
.table-rep-plugin .btn-group .btn-default.btn-primary {
  background-color: rgb(255, 90, 95);
  border-color: rgb(255, 90, 95);
  color: #fff;
}
.table-rep-plugin .btn-group.pull-right {
  float: right;
}
.table-rep-plugin .btn-group.pull-right .dropdown-menu {
  right: 0;
  transform: none !important;
  top: 100% !important;
}
.table-rep-plugin tbody th {
  font-size: 14px;
  font-weight: normal;
}
.table-rep-plugin .checkbox-row {
  padding-left: 40px;
  color: var(--bs-body-color) !important;
}
.table-rep-plugin .checkbox-row:hover {
  background-color: rgb(250.4, 245.8, 245.8) !important;
}
.table-rep-plugin .checkbox-row label {
  display: inline-block;
  padding-left: 5px;
  position: relative;
}
.table-rep-plugin .checkbox-row label::before {
  -o-transition: 0.3s ease-in-out;
  -webkit-transition: 0.3s ease-in-out;
  background-color: #fff;
  border-radius: 3px;
  border: 1px solid #aaa9a9;
  content: "";
  display: inline-block;
  height: 17px;
  left: 0;
  margin-left: -20px;
  position: absolute;
  transition: 0.3s ease-in-out;
  width: 17px;
  outline: none !important;
}
.table-rep-plugin .checkbox-row label::after {
  color: #f7efef;
  display: inline-block;
  font-size: 11px;
  height: 16px;
  left: 0;
  margin-left: -20px;
  padding-left: 3px;
  padding-top: 1px;
  position: absolute;
  top: -1px;
  width: 16px;
}
.table-rep-plugin .checkbox-row input[type=checkbox] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:disabled + label {
  opacity: 0.65;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:focus + label::before {
  outline-offset: -2px;
  outline: none;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:checked + label::after {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:disabled + label::before {
  background-color: #faf8f8;
  cursor: not-allowed;
}
.table-rep-plugin .checkbox-row input[type=checkbox]:checked + label::before {
  background-color: rgb(255, 90, 95);
  border-color: rgb(255, 90, 95);
}
.table-rep-plugin .checkbox-row input[type=checkbox]:checked + label::after {
  color: #fff;
}
.table-rep-plugin .fixed-solution .sticky-table-header {
  top: 70px !important;
  background-color: rgb(255, 90, 95);
}
.table-rep-plugin .fixed-solution .sticky-table-header table {
  color: #fff;
}

@media (min-width: 992px) {
  body[data-layout=horizontal] .fixed-solution .sticky-table-header {
    top: 120px !important;
  }
}

.ck {
  font-family: var(--bs-font-sans-serif) !important;
}
.ck.ck-reset_all, .ck.ck-reset_all * {
  color: var(--bs-body-color) !important;
}
.ck.ck-toolbar {
  background: var(--bs-secondary-bg) !important;
}
.ck p {
  margin-bottom: 0;
}
.ck.ck-toolbar {
  border: 1px solid var(--bs-border-color-translucent) !important;
}
.ck.ck-toolbar.ck-toolbar_grouping > .ck-toolbar__items {
  flex-wrap: wrap !important;
}
.ck.ck-toolbar .ck.ck-toolbar__separator {
  background: transparent !important;
}
.ck.ck-editor__main > .ck-editor__editable {
  border-top: 0 !important;
  background-color: var(--bs-secondary-bg) !important;
  border-color: var(--bs-border-color-translucent) !important;
  box-shadow: none !important;
}
.ck.ck-dropdown__panel {
  background: var(--bs-secondary-bg) !important;
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  border-radius: var(--bs-border-radius);
}
.ck.ck-list {
  background: var(--bs-secondary-bg) !important;
}
.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne, .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se {
  left: 0;
  right: auto !important;
}
.ck.ck-editor__editable_inline[dir=ltr] {
  text-align: left !important;
}
.ck.ck-dropdown__panel {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175) !important;
  border-radius: var(--bs-border-radius) !important;
  border: 1px solid var(--bs-border-color) !important;
}

.ck.ck-button:focus, .ck.ck-button:active,
a.ck.ck-button:focus,
a.ck.ck-button:active {
  box-shadow: none !important;
  border: 1px solid var(--bs-light) !important;
}
.ck.ck-button:not(.ck-disabled):hover,
a.ck.ck-button:not(.ck-disabled):hover {
  background: var(--bs-light) !important;
}
.ck.ck-button.ck-on,
a.ck.ck-button.ck-on {
  background: var(--bs-light) !important;
}

.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: 0.375rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: 0.375rem !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.ck-editor__editable {
  min-height: 245px !important;
}

.ck[class*=ck-heading_heading] {
  font-weight: 500 !important;
}

.ck.ck-button.ck-on:not(.ck-disabled):hover, .ck.ck-button.ck-on:not(.ck-disabled):active,
a.ck.ck-button.ck-on:not(.ck-disabled):hover,
a.ck.ck-button.ck-on:not(.ck-disabled):active {
  box-shadow: none !important;
}

.ck.ck-tooltip .ck-tooltip__text {
  background: #212529 !important;
  color: #faf8f8 !important;
}
.ck.ck-input-text {
  background: var(--bs-secondary-bg) !important;
  border: 1px solid var(--bs-border-color-translucent) !important;
}
.ck.ck-input-text:focus {
  border: 1px solid rgb(255, 172.5, 175) !important;
  box-shadow: none !important;
}
.ck.ck-balloon-panel {
  background: var(--bs-secondary-bg) !important;
  border: 1px solid var(--bs-border-color) !important;
}
.ck.ck-balloon-panel[class*=arrow_n]:after {
  border-bottom-color: var(--bs-secondary-bg) !important;
}
.ck.ck-balloon-panel[class*=arrow_n]::before {
  border-bottom-color: var(--bs-border-color) !important;
}

.ck.ck-labeled-field-view > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {
  background: var(--bs-secondary-bg) !important;
}

.ck-editor-reverse .ck-editor {
  display: flex;
  flex-direction: column-reverse;
}
.ck-editor-reverse .ck.ck-editor__main > .ck-editor__editable {
  border: 1px solid var(--bs-border-color-translucent) !important;
  border-bottom: 0 !important;
}
.ck-editor-reverse .ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck-editor-reverse .ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: 0.375rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.ck-editor-reverse .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck-editor-reverse .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: 0.375rem !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

[dir=rtl] .ck.ck-toolbar > .ck-toolbar__items {
  flex-direction: row-reverse;
}

.table-edits input, .table-edits select {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  border: 1px solid var(--bs-border-color-translucent);
  background-color: var(--bs-secondary-bg);
  color: var(--bs-body-color);
  border-radius: var(--bs-border-radius);
}
.table-edits input:focus, .table-edits select:focus {
  outline: none;
  border-color: rgb(255, 172.5, 175);
}

.apex-charts {
  min-height: 10px !important;
}
.apex-charts text {
  font-family: var(--bs-font-sans-serif) !important;
  fill: #bdbcad;
}
.apex-charts .apexcharts-canvas {
  margin: 0 auto;
}

.apexcharts-tooltip {
  background-color: var(--bs-card-bg) !important;
  border: 1px solid var(--bs-border-color) !important;
}

.apexcharts-tooltip-title {
  background-color: var(--bs-body-bg) !important;
  border-bottom: 1px solid var(--bs-border-color) !important;
}

.apexcharts-tooltip-title,
.apexcharts-tooltip-text {
  font-family: var(--bs-font-sans-serif) !important;
}

.apexcharts-legend-series {
  font-weight: 500;
}

.apexcharts-gridline {
  pointer-events: none;
  stroke: #aaa9a9;
}

.apexcharts-legend-text {
  color: #74788d !important;
  font-family: var(--bs-font-sans-serif) !important;
  font-size: 13px !important;
}

.apexcharts-pie-label {
  fill: #fff !important;
}

.apexcharts-yaxis text,
.apexcharts-xaxis text {
  font-family: var(--bs-font-sans-serif) !important;
  fill: #bdbcad;
}

.apexcharts-grid-row {
  stroke: var(--bs-border-color) !important;
}

.apexcharts-gridline {
  stroke: var(--bs-border-color) !important;
}

/* Flot chart */
.flot-charts-height {
  height: 320px;
}

.flotTip {
  padding: 8px 12px;
  background-color: rgba(33, 37, 41, 0.9);
  z-index: 100;
  color: #faf8f8;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
}

.legendLabel {
  color: #bdbcad;
}

.jqstooltip {
  box-sizing: content-box;
  width: auto !important;
  height: auto !important;
  background-color: #252b3b !important;
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);
  padding: 5px 10px !important;
  border-radius: 3px;
  border-color: #212529 !important;
}

.jqsfield {
  color: #f7efef !important;
  font-size: 12px !important;
  line-height: 18px !important;
  font-family: var(--bs-font-sans-serif) !important;
  font-weight: 500 !important;
}

.gmaps, .gmaps-panaroma {
  height: 300px;
  background: #faf8f8;
  border-radius: 3px;
}

.gmaps-overlay {
  display: block;
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  background: rgb(255, 90, 95);
  border-radius: 4px;
  padding: 10px 20px;
}

.gmaps-overlay_arrow {
  left: 50%;
  margin-left: -16px;
  width: 0;
  height: 0;
  position: absolute;
}
.gmaps-overlay_arrow.above {
  bottom: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-top: 16px solid rgb(255, 90, 95);
}
.gmaps-overlay_arrow.below {
  top: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-bottom: 16px solid rgb(255, 90, 95);
}

.jvectormap-label {
  border: none;
  background: #252b3b;
  color: #faf8f8;
  font-family: var(--bs-font-sans-serif);
  font-size: 0.9rem;
  padding: 5px 8px;
}

.editable-input .form-control {
  display: inline-block;
}

.editable-buttons {
  margin-left: 7px;
}
.editable-buttons .editable-cancel {
  margin-left: 7px;
}

.auth-body-bg {
  background-color: var(--bs-secondary-bg);
}

.authentication-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
  height: 100%;
  width: 100%;
  padding-top: 64%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 50%;
}
@media (max-width: 991px) {
  .authentication-bg {
    display: none;
  }
}

.authentication-page-content {
  height: 100vh;
  display: flex;
}

.auth-form-group-custom {
  position: relative;
}
.auth-form-group-custom .form-control {
  height: 60px;
  padding-top: 28px;
  padding-left: 60px;
}
.auth-form-group-custom label {
  position: absolute;
  top: 7px;
  left: 60px;
}
.auth-form-group-custom .auti-custom-input-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 19px;
  font-size: 24px;
  color: rgb(255, 90, 95);
}

.auth-logo.logo-light {
  display: none;
}
.auth-logo.logo-dark {
  display: block;
}

[data-bs-theme=dark] .authentication-logo .logo-light {
  display: block;
}
[data-bs-theme=dark] .authentication-logo .logo-dark {
  display: none;
}

.search-box .form-control {
  border-radius: 30px;
  padding-left: 40px;
}
.search-box .search-icon {
  font-size: 16px;
  position: absolute;
  left: 13px;
  top: 0;
  line-height: 38px;
}

.ecommerce .accordion-item {
  border-bottom: 1px solid var(--bs-border-color);
}
.ecommerce .accordion-item .accordion-collapse {
  border: 0;
}
.ecommerce button {
  border: 0;
  display: block;
  color: var(--bs-body-color);
  font-weight: 500;
  padding: 8px 16px;
}
.ecommerce button[data-bs-toggle=collapse].collapsed::after {
  content: "\\f0415";
}
.ecommerce button[data-bs-toggle=collapse]::after {
  content: "\\f0374";
  display: block;
  font-family: "Material Design Icons";
  font-size: 16px;
  position: absolute;
  right: 20px;
  font-weight: 500;
  top: 50%;
  background-image: none;
  transform: translateY(-50%);
}
.ecommerce .accordion-body {
  padding: 8px 0;
  border: 0;
}
.ecommerce .accordion-body li a {
  display: block;
  padding: 4px 16px;
  color: var(--bs-body-color);
}
.ecommerce .accordion-body li.active a {
  color: rgb(255, 90, 95);
}

.product-detai-imgs .nav .nav-link {
  margin: 7px 0px;
}
.product-detai-imgs .nav .nav-link.active {
  background-color: var(--bs-tertiary-bg);
}

.product-color a {
  display: inline-block;
  text-align: center;
  color: var(--bs-body-color);
}
.product-color a .product-color-item {
  margin: 7px;
  border: 2px solid var(--bs-border-color);
  border-radius: 4px;
}
.product-color a.active, .product-color a:hover {
  color: rgb(255, 90, 95);
}
.product-color a.active .product-color-item, .product-color a:hover .product-color-item {
  border-color: rgb(255, 90, 95) !important;
}

.ecommerce-sortby-list li {
  color: var(--bs-body-color);
}
.ecommerce-sortby-list li a {
  color: var(--bs-body-color);
  padding: 4px;
}
.ecommerce-sortby-list li.active a {
  color: rgb(255, 90, 95);
}

.product-box {
  padding: 24px;
  border: 1px solid var(--bs-border-color);
  transition: all 0.4s;
}
.product-box:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.product-img {
  position: relative;
}
.product-img .product-ribbon {
  position: absolute;
  top: 0;
  left: -24px;
  padding: 6px 8px;
  border-radius: 0px 30px 30px 0px;
}
.product-img .product-like {
  position: absolute;
  top: 0;
  right: 0;
}
.product-img .product-like a {
  display: inline-block;
  width: 40px;
  height: 40px;
  border: 2px solid var(--bs-border-color);
  line-height: 38px;
  border-radius: 50%;
  text-align: center;
  color: #bdbcad;
}

.product-detail .nav-pills .nav-link {
  margin-bottom: 7px;
}
.product-detail .nav-pills .nav-link.active {
  background-color: var(--bs-tertiary-bg);
}
.product-detail .nav-pills .nav-link .tab-img {
  width: 5rem;
}
.product-detail .product-img {
  border: 1px solid var(--bs-border-color);
  padding: 24px;
}

.product-desc-list li {
  padding: 4px 0px;
}

.product-review-link .list-inline-item a {
  color: #74788d;
}
.product-review-link .list-inline-item:not(:last-child) {
  margin-right: 14px;
}

.product-cart-touchspin {
  border: 1px solid var(--bs-border-color);
  background-color: var(--bs-secondary-bg);
  border-radius: 0.375rem;
}
.product-cart-touchspin .form-control {
  border-color: transparent;
  height: 32px;
}
.product-cart-touchspin .input-group-btn .btn {
  background-color: transparent !important;
  border-color: transparent !important;
  color: rgb(255, 90, 95) !important;
  font-size: 16px;
  padding: 3px 12px;
  box-shadow: none;
}

.shipping-address {
  box-shadow: none;
}
.shipping-address.active {
  border-color: rgb(255, 90, 95) !important;
}

/* ==============
  Email
===================*/
.email-leftbar {
  width: 236px;
  float: left;
  padding: 20px;
  border-radius: 5px;
}

.email-rightbar {
  margin-left: 260px;
}

.chat-user-box p.user-title {
  color: var(--bs-body-color);
  font-weight: 600;
}
.chat-user-box p {
  font-size: 12px;
}

@media (max-width: 767px) {
  .email-leftbar {
    float: none;
    width: 100%;
  }
  .email-rightbar {
    margin: 0;
  }
}
.mail-list a {
  display: block;
  color: #74788d;
  line-height: 24px;
  padding: 8px 5px;
}
.mail-list a.active {
  color: #ff3d60;
  font-weight: 500;
}

.message-list {
  display: block;
  padding-left: 0;
}
.message-list li {
  position: relative;
  display: block;
  height: 50px;
  line-height: 50px;
  cursor: default;
  transition-duration: 0.3s;
}
.message-list li a {
  color: #74788d;
}
.message-list li:hover {
  background: var(--bs-tertiary-bg);
  transition-duration: 0.05s;
}
.message-list li .col-mail {
  float: left;
  position: relative;
}
.message-list li .col-mail-1 {
  width: 320px;
}
.message-list li .col-mail-1 .star-toggle,
.message-list li .col-mail-1 .checkbox-wrapper-mail,
.message-list li .col-mail-1 .dot {
  display: block;
  float: left;
}
.message-list li .col-mail-1 .dot {
  border: 4px solid transparent;
  border-radius: 100px;
  margin: 22px 26px 0;
  height: 0;
  width: 0;
  line-height: 0;
  font-size: 0;
}
.message-list li .col-mail-1 .checkbox-wrapper-mail {
  margin: 15px 10px 0 20px;
}
.message-list li .col-mail-1 .star-toggle {
  margin-top: 18px;
  margin-left: 5px;
}
.message-list li .col-mail-1 .title {
  position: absolute;
  top: 0;
  left: 110px;
  right: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 0;
}
.message-list li .col-mail-2 {
  position: absolute;
  top: 0;
  left: 320px;
  right: 0;
  bottom: 0;
}
.message-list li .col-mail-2 .subject,
.message-list li .col-mail-2 .date {
  position: absolute;
  top: 0;
}
.message-list li .col-mail-2 .subject {
  left: 0;
  right: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.message-list li .col-mail-2 .date {
  right: 0;
  width: 170px;
  padding-left: 80px;
}
.message-list li.active, .message-list li.active:hover {
  box-shadow: inset 3px 0 0 rgb(255, 90, 95);
}
.message-list li.unread {
  background-color: var(--bs-tertiary-bg);
  font-weight: 500;
  color: var(--bs-body-color);
}
.message-list li.unread a {
  color: var(--bs-body-color);
  font-weight: 500;
}
.message-list .checkbox-wrapper-mail {
  cursor: pointer;
  height: 20px;
  width: 20px;
  position: relative;
  display: inline-block;
  box-shadow: inset 0 0 0 1px #dad1ce;
  border-radius: 1px;
}
.message-list .checkbox-wrapper-mail input {
  opacity: 0;
  cursor: pointer;
}
.message-list .checkbox-wrapper-mail input:checked ~ label {
  opacity: 1;
}
.message-list .checkbox-wrapper-mail label {
  position: absolute;
  height: 20px;
  width: 20px;
  left: 0;
  cursor: pointer;
  opacity: 0;
  margin-bottom: 0;
  transition-duration: 0.05s;
  top: 0;
}
.message-list .checkbox-wrapper-mail label:before {
  content: "\\f012c";
  font-family: "Material Design Icons";
  top: 0;
  height: 20px;
  color: rgb(21.6283783784, 24.25, 26.8716216216);
  width: 20px;
  position: absolute;
  margin-top: -16px;
  left: 4px;
  font-size: 13px;
}

@media (max-width: 575.98px) {
  .message-list li .col-mail-1 {
    width: 200px;
  }
}
.chat-leftsidebar {
  background-color: var(--bs-secondary-bg);
  border-radius: 0.375rem 0 0 0.375rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}
@media (min-width: 992px) {
  .chat-leftsidebar {
    min-width: 360px;
  }
}
.chat-leftsidebar .chat-leftsidebar-nav .nav {
  background-color: var(--bs-tertiary-bg);
}
.chat-leftsidebar .chat-leftsidebar-nav .nav .nav-link.active {
  background-color: var(--bs-secondary-bg);
  color: rgb(255, 90, 95);
}

.chat-noti-dropdown.active:before {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #ff3d60;
  border-radius: 50%;
  right: 0;
}
.chat-noti-dropdown .btn {
  padding: 0px;
  box-shadow: none;
  font-size: 16px;
}

.chat-search-box .form-control {
  border: 0;
}

.chat-list {
  margin: 0;
}
.chat-list li.active a {
  background-color: var(--bs-tertiary-bg);
}
.chat-list li a {
  display: block;
  padding: 14px 16px;
  color: #74788d;
  transition: all 0.4s;
  border-top: 1px solid var(--bs-border-color);
  border-radius: 4px;
}
.chat-list li a:hover {
  background-color: rgba(var(--bs-tertiary-bg), 0.7);
}
.chat-list li .user-img {
  position: relative;
}
.chat-list li .user-img .user-status {
  width: 10px;
  height: 10px;
  background-color: #bdbcad;
  border-radius: 50%;
  border: 2px solid var(--bs-border-color);
  position: absolute;
  right: 0;
  bottom: 0;
}
.chat-list li .user-img.online .user-status {
  background-color: #1cbb8c;
}
.chat-list li .user-img.away .user-status {
  background-color: #fcb92c;
}

.user-chat {
  background-color: var(--bs-secondary-bg);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}
.user-chat .user-chat-border {
  border-bottom: 1px solid var(--bs-border-color);
}

.user-chat-nav .dropdown .nav-btn {
  height: 36px;
  width: 36px;
  line-height: 36px;
  box-shadow: none;
  padding: 0;
  font-size: 20px;
  border-radius: 50%;
}
.user-chat-nav .dropdown .dropdown-menu {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  border: 1px solid var(--bs-border-color);
}

.chat-conversation li {
  clear: both;
}
.chat-conversation .chat-avatar {
  float: left;
  margin-right: 8px;
}
.chat-conversation .chat-avatar img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.chat-conversation .chat-day-title {
  position: relative;
  text-align: center;
  margin-bottom: 24px;
  margin-top: 12px;
}
.chat-conversation .chat-day-title .title {
  background-color: var(--bs-tertiary-bg);
  position: relative;
  z-index: 1;
  padding: 3px 16px;
  border-radius: 30px;
}
.chat-conversation .chat-day-title:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  right: 0;
  background-color: var(--bs-border-color);
  top: 10px;
}
.chat-conversation .chat-day-title .badge {
  font-size: 12px;
}
.chat-conversation .conversation-list {
  margin-bottom: 24px;
  display: inline-block;
  position: relative;
}
.chat-conversation .conversation-list .ctext-wrap {
  overflow: hidden;
}
.chat-conversation .conversation-list .ctext-wrap .conversation-name {
  font-weight: 600;
  margin-bottom: 7px;
}
.chat-conversation .conversation-list .ctext-wrap-content {
  padding: 12px 16px;
  background-color: rgb(255, 90, 95);
  border-radius: 0.375rem;
  color: #fff;
}
.chat-conversation .conversation-list .chat-time {
  margin-top: 7px;
  font-size: 12px;
  text-align: right;
}
.chat-conversation .right .conversation-list {
  float: right;
}
.chat-conversation .right .conversation-list .conversation-name {
  text-align: right;
}
.chat-conversation .right .conversation-list .ctext-wrap-content {
  background-color: var(--bs-tertiary-bg);
  text-align: right;
  color: #74788d;
}
.chat-conversation .right .conversation-list .chat-time {
  text-align: left;
}

.chat-input-section {
  background-color: var(--bs-secondary-bg);
  border-radius: 0.375rem;
}

.chat-input {
  background-color: var(--bs-tertiary-bg) !important;
  border-color: var(--bs-border-color) !important;
}

.chat-input-links {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
}
.chat-input-links li a {
  font-size: 16px;
  line-height: 36px;
  padding: 0px 4px;
  display: inline-block;
}

@media (max-width: 575.98px) {
  .chat-send {
    min-width: auto;
  }
}

.task-box {
  border: 1px solid var(--bs-border-color);
  box-shadow: none;
}
.task-box .team .team-member {
  margin-right: 6px;
}

.gu-transit {
  border: 1px dashed var(--bs-border-color) !important;
  background-color: #f7efef !important;
}

.counter-number {
  font-size: 24px;
  font-weight: 800;
  font-family: "Inter", sans-serif;
  text-align: center;
  display: flex;
}
.counter-number span {
  font-size: 14px;
  font-weight: 400;
  display: block;
  padding-top: 5px;
}

.coming-box {
  width: 25%;
}

.comingsoon-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
}

/************** vertical timeline **************/
.timeline {
  position: relative;
  margin-bottom: 30px;
}
.timeline:before {
  content: "";
  position: absolute;
  width: 3px;
  top: 30px;
  left: 0;
  bottom: 0;
  background-color: var(--bs-tertiary-bg);
}
.timeline .timeline-item {
  display: flex;
}
.timeline .timeline-block {
  width: 100%;
}
.timeline .time-show-btn {
  margin-bottom: 30px;
}
.timeline .timeline-box {
  margin: 20px 0;
  position: relative;
  margin-left: 45px;
}
.timeline .timeline-date {
  display: inline-block;
  padding: 4px 16px 4px 8px;
  border-radius: 0px 30px 30px 0px;
  background-color: rgb(255, 90, 95);
  color: #fff;
  position: relative;
  left: -30px;
}
.timeline .timeline-date .circle-dot {
  margin-right: 8px;
}
.timeline .timeline-icon {
  position: absolute;
  width: 10px;
  height: 10px;
  background: var(--bs-secondary-bg);
  border-radius: 50%;
  display: block;
  border: 2px solid rgb(255, 90, 95);
  left: -48px;
  text-align: center;
  top: 27px;
  z-index: 9;
}
.timeline .timeline-icon:before {
  content: "";
  position: absolute;
  height: 3px;
  width: 20px;
  background-color: var(--bs-tertiary-bg);
  left: 12px;
  top: 3px;
}
.timeline .timeline-album {
  margin-top: 16px;
}
.timeline .timeline-album a {
  display: inline-block;
  margin-right: 5px;
}
.timeline .timeline-album img {
  height: 40px;
  width: auto;
  border-radius: 4px;
}

@media (min-width: 768px) {
  .timeline .timeline-block {
    width: 50%;
  }
  .timeline:before {
    left: 50%;
  }
  .timeline .time-show-btn {
    position: relative;
    left: 67px;
    text-align: right;
  }
  .timeline-item::before {
    content: "";
    display: block;
    width: 50%;
  }
  .timeline-item.timeline-left {
    text-align: right;
  }
  .timeline-item.timeline-left::after {
    content: "";
    display: block;
    width: 50%;
  }
  .timeline-item.timeline-left::before {
    display: none;
  }
  .timeline-item.timeline-left .timeline-box {
    margin-left: 0;
    margin-right: 45px;
  }
  .timeline-item.timeline-left .timeline-date {
    padding: 4px 8px 4px 16px;
    border-radius: 30px 0px 0px 30px;
    left: auto;
    right: -30px;
  }
  .timeline-item.timeline-left .timeline-date .circle-dot {
    float: right;
    margin-right: 0px;
    margin-left: 8px;
  }
  .timeline-item.timeline-left .timeline-icon {
    left: auto;
    right: -52px;
  }
  .timeline-item.timeline-left .timeline-icon::before {
    left: auto;
    right: 12px;
  }
}
.left-timeline::before {
  left: 3px;
}
.left-timeline .timeline-item::before {
  display: none;
}
.left-timeline .timeline-block {
  width: 100%;
}
.left-timeline .timeline-icon {
  left: -45px;
}

.pricing-nav-tabs {
  display: inline-block;
  background-color: var(--bs-secondary-bg);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  padding: 4px;
  border-radius: 7px;
}
.pricing-nav-tabs li {
  display: inline-block;
}

.pricing-box .plan-features li {
  padding: 7px 0px;
}

/*********************
    Faqs
**********************/
.faq-nav-tabs .nav-item {
  margin: 0px 8px;
}
.faq-nav-tabs .nav-link {
  text-align: center;
  margin-bottom: 8px;
  border: 2px solid var(--bs-border-color);
  color: var(--bs-body-color);
}
.faq-nav-tabs .nav-link .nav-icon {
  font-size: 40px;
  margin-bottom: 8px;
  display: block;
}
.faq-nav-tabs .nav-link.active {
  border-color: rgb(255, 90, 95);
  background-color: transparent;
  color: var(--bs-body-color);
}
.faq-nav-tabs .nav-link.active .nav-icon {
  color: rgb(255, 90, 95);
}

.text-error {
  font-size: 120px;
}
@media (max-width: 575.98px) {
  .text-error {
    font-size: 86px;
  }
}

.error-text {
  color: #ff3d60;
  position: relative;
}
.error-text .error-img {
  position: absolute;
  width: 120px;
  left: -15px;
  right: 0;
  bottom: 47px;
}
@media (max-width: 575.98px) {
  .error-text .error-img {
    width: 86px;
    left: -12px;
    bottom: 38px;
  }
}

body * {
  outline: none;
}

.accordian-bg-products {
  background-color: #aaa9a9;
}

.nav-link {
  cursor: pointer;
}

.dataTables_filter,
.dataTables_paginate {
  float: right;
}
.dataTables_filter .pagination .page-link,
.dataTables_paginate .pagination .page-link {
  border-radius: 30px !important;
  margin: 0 3px;
  border: none;
  text-align: center;
  cursor: pointer;
}

.rdw-editor-main {
  border: 1px solid #aaa9a9;
  height: 239px;
}

.dz-message {
  text-align: center;
  padding: 0px;
  margin: 2em 0;
}

.react-datepicker-wrapper {
  width: 100% !important;
}

.ReactModal__Overlay {
  z-index: 1001 !important;
}

.rangeslider__fill {
  background-color: rgb(255, 90, 95) !important;
}

.react-bootstrap-table {
  padding-top: 0px !important;
}

.square-switch .react-switch-bg {
  border-radius: 5px !important;
}

input[type=range] {
  -webkit-appearance: auto !important;
}

.chat-conversation-height {
  min-height: 500px;
}

.expand-cell {
  cursor: pointer !important;
}

.close {
  background: transparent;
  border: 0;
  font-size: 10px;
  padding: 1.35rem 1.25rem;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_61___}) center/1em auto no-repeat;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.5;
  width: 1em;
  height: 1em;
  z-index: 2;
}
.close span {
  display: none;
}

.fc-daygrid-event {
  color: #fff !important;
}

.card-columns .card {
  margin-bottom: 24px;
}

@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}
.react-bootstrap-table-pagination {
  --bs-gutter-x: 0;
}

.logo-dark-element {
  display: block;
}

.logo-light-element {
  display: none;
}

[data-bs-theme=dark] .logo-dark-element {
  display: none;
}
[data-bs-theme=dark] .logo-light-element {
  display: block;
}

.css-b62m3t-container .css-13cymwt-control {
  background-color: var(--bs-secondary-bg);
  color: var(--bs-body-color);
  border-color: var(--bs-border-color);
}
.css-b62m3t-container .css-13cymwt-control:hover, .css-b62m3t-container .css-13cymwt-control:focus {
  border-color: var(--bs-primary);
}
.css-b62m3t-container .css-13cymwt-control .css-1p3m7a8-multiValue {
  color: var(--bs-white);
  background-color: var(--bs-primary);
}
.css-b62m3t-container .css-13cymwt-control .css-1p3m7a8-multiValue .css-wsp0cs-MultiValueGeneric {
  color: var(--bs-white);
}
.css-b62m3t-container .css-13cymwt-control .css-1p3m7a8-multiValue .css-1u9des2-indicatorSeparator {
  border-color: var(--bs-border-color);
}
.css-b62m3t-container :is(.css-qbdosj-Input, .css-1dimb5e-singleValue) {
  color: var(--bs-body-color);
}
.css-b62m3t-container .css-t3ipsp-control {
  background-color: var(--bs-secondary-bg);
  color: var(--bs-body-color);
  border-color: var(--bs-border-color);
}
.css-b62m3t-container .css-t3ipsp-control .css-1p3m7a8-multiValue {
  color: var(--bs-white);
  background-color: var(--bs-primary);
}
.css-b62m3t-container .css-t3ipsp-control .css-1p3m7a8-multiValue .css-wsp0cs-MultiValueGeneric {
  color: var(--bs-white);
}
.css-b62m3t-container .css-t3ipsp-control .css-1p3m7a8-multiValue .css-1u9des2-indicatorSeparator {
  border-color: var(--bs-border-color);
}
.css-b62m3t-container .css-1nmdiq5-menu {
  background-color: var(--bs-secondary-bg);
  color: var(--bs-body-color);
  border-color: var(--bs-border-color);
}
.css-b62m3t-container .css-1nmdiq5-menu .css-d7l1ni-option {
  color: #fff;
  background-color: var(--bs-primary);
}
.css-b62m3t-container .css-1nmdiq5-menu .css-d7l1ni-option:hover, .css-b62m3t-container .css-1nmdiq5-menu .css-d7l1ni-option:active, .css-b62m3t-container .css-1nmdiq5-menu .css-d7l1ni-option:focus {
  background-color: var(--bs-primary);
}

.flatpickr-innerContainer {
  border-bottom: var(--bs-border-color) !important;
}

.flatpickr-calendar {
  border-color: var(--bs-border-color) !important;
  color: var(--bs-body-color) !important;
}

.flatpickr-days {
  background-color: var(--bs-secondary-bg) !important;
  color: var(--bs-body-color) !important;
  border-color: var(--bs-border-color) !important;
}

.flatpickr-day.today {
  border-color: var(--bs-border-color) !important;
  color: var(--bs-body-color) !important;
}
.flatpickr-day.today:hover, .flatpickr-day.today:focus {
  border-color: var(--bs-border-color) !important;
  background: var(--bs-tertiary-bg) !important;
  color: var(--bs-body-color) !important;
}

.flatpickr-day {
  color: var(--bs-body-color) !important;
}
.flatpickr-day:hover {
  border-color: var(--bs-border-color) !important;
  background: var(--bs-tertiary-bg) !important;
  color: var(--bs-body-color) !important;
}

.dayContainer {
  border-color: var(--bs-border-color) !important;
}

.chartjs-chart {
  max-height: 300px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/theme.scss","webpack://./src/assets/scss/icons.scss","webpack://./src/assets/scss/custom/plugins/icons/_materialdesignicons.scss","webpack://./src/assets/scss/custom/plugins/icons/_fontawesome-all.scss","webpack://./src/assets/scss/custom/plugins/icons/_dripicons.scss","webpack://./src/assets/scss/custom/plugins/icons/_remixicon.scss","webpack://./src/assets/scss/bootstrap.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/assets/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/custom/components/_root.scss","webpack://./src/assets/scss/custom/components/_reboot.scss","webpack://./src/assets/scss/custom/components/_backgrounds.scss","webpack://./src/assets/scss/custom/components/_badge.scss","webpack://./src/assets/scss/custom/components/_buttons.scss","webpack://./src/assets/scss/custom/components/_breadcrumb.scss","webpack://./src/assets/scss/custom/components/_card.scss","webpack://./src/assets/scss/custom/components/_dropdown.scss","webpack://./src/assets/scss/custom/components/_nav.scss","webpack://./src/assets/scss/custom/components/_table.scss","webpack://./src/assets/scss/custom/components/_pagination.scss","webpack://./src/assets/scss/custom/components/_progress.scss","webpack://./src/assets/scss/custom/fonts/_fonts.scss","webpack://./src/assets/scss/custom/structure/_topbar.scss","webpack://./src/assets/scss/custom/structure/_page-head.scss","webpack://./src/assets/scss/custom/structure/_footer.scss","webpack://./src/assets/scss/custom/structure/_right-sidebar.scss","webpack://./src/assets/scss/custom/structure/_vertical.scss","webpack://./src/assets/scss/custom/structure/_horizontal-nav.scss","webpack://./src/assets/scss/custom/structure/_layouts.scss","webpack://./src/assets/scss/custom/components/_waves.scss","webpack://./src/assets/scss/custom/components/_avatar.scss","webpack://./src/assets/scss/custom/components/_accordion.scss","webpack://./src/assets/scss/custom/components/_helper.scss","webpack://./src/assets/scss/custom/components/_preloader.scss","webpack://./src/assets/scss/custom/components/_forms.scss","webpack://./src/assets/scss/custom/components/_widgets.scss","webpack://./src/assets/scss/custom/components/_demos.scss","webpack://./src/assets/scss/custom/components/_print.scss","webpack://./src/assets/scss/custom/plugins/_custom-scrollbar.scss","webpack://./src/assets/scss/custom/plugins/_calendar.scss","webpack://./src/assets/scss/custom/plugins/_color-picker.scss","webpack://./src/assets/scss/custom/plugins/_session-timeout.scss","webpack://./src/assets/scss/custom/plugins/_round-slider.scss","webpack://./src/assets/scss/custom/plugins/_range-slider.scss","webpack://./src/assets/scss/custom/plugins/_sweatalert2.scss","webpack://./src/assets/scss/custom/plugins/_rating.scss","webpack://./src/assets/scss/custom/plugins/_toastr.scss","webpack://./src/assets/scss/custom/plugins/_parsley.scss","webpack://./src/assets/scss/custom/plugins/_select2.scss","webpack://./src/assets/scss/custom/plugins/_switch.scss","webpack://./src/assets/scss/custom/plugins/_datepicker.scss","webpack://./src/assets/scss/custom/plugins/_bootstrap-touchspin.scss","webpack://./src/assets/scss/custom/plugins/_datatable.scss","webpack://./src/assets/scss/custom/plugins/_form-editors.scss","webpack://./src/assets/scss/custom/plugins/_form-upload.scss","webpack://./src/assets/scss/custom/plugins/_form-wizard.scss","webpack://./src/assets/scss/custom/plugins/_responsive-table.scss","webpack://./src/assets/scss/custom/plugins/_ckeditor.scss","webpack://./src/assets/scss/custom/plugins/_table-editable.scss","webpack://./src/assets/scss/custom/plugins/_apexcharts.scss","webpack://./src/assets/scss/custom/plugins/_flot.scss","webpack://./src/assets/scss/custom/plugins/_sparkline-chart.scss","webpack://./src/assets/scss/custom/plugins/_google-map.scss","webpack://./src/assets/scss/custom/plugins/_vector-maps.scss","webpack://./src/assets/scss/custom/plugins/_x-editable.scss","webpack://./src/assets/scss/custom/pages/_authentication.scss","webpack://./src/assets/scss/custom/pages/_ecommerce.scss","webpack://./src/assets/scss/custom/pages/_email.scss","webpack://./src/assets/scss/custom/pages/_chat.scss","webpack://./src/assets/scss/custom/pages/_kanbanboard.scss","webpack://./src/assets/scss/custom/pages/_coming-soon.scss","webpack://./src/assets/scss/custom/pages/_timeline.scss","webpack://./src/assets/scss/custom/pages/_extras-pages.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;CAAA;ACAA,4BAAA;AACA;EACE,oCAAA;EACA,4CAAA;EACA,qPAAA;EACA,mBAAA;EACA,kBAAA;AFUF;AEPA;;EAEE,qBAAA;EACA,yDAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,iBAAA;AFSF;;AENA;EACE,gBAAA;EACA,kBAAA;AFSF;;AENA;EACE,eAAA;AFSF;;AENA;EACE,eAAA;AFSF;;AENA;EACE,eAAA;AFSF;;AENA;EACE,eAAA;AFSF;;AENA;EACE,0BAAA;AFSF;;AENA;EACE,0BAAA;AFSF;;AENA;EACE,YAAA;AFSF;;AENA;EACE,+BAAA;AFSF;;AENA;EACE;;;;;;;;;;;;;;;SAAA;AFwBF;;AENA;EAGE,wBAAA;AFSF;;AENA;EACE;;;;;;;;;;;;;;;SAAA;AFwBF;;AENA;EAGE,wBAAA;AFSF;;AENA;EACE;;;;;;;;;;;;;;;SAAA;AFwBF;;AENA;EAGE,yBAAA;AFSF;;AENA;EACE;;;;;;;;;;;;;;;SAAA;AFwBF;;AENA;EAGE,yBAAA;AFSF;;AENA;EACE;;;;;;;;;;;;;;;SAAA;AFwBF;;AENA;EAGE,yBAAA;AFSF;;AENA;EACE;;;;;;;;;;;;;;;SAAA;AFwBF;;AENA;EAGE,yBAAA;AFSF;;AENA;EACE;;;;;;;;;;;;;;;SAAA;AFwBF;;AENA;EAGE,yBAAA;AFSF;;AENA;EAEE,qBAAA;EACA,aAAA;EACA,mBAAA;AFSF;;AENA;EAEE,qBAAA;EACA,aAAA;EACA,mBAAA;AFSF;;AENA;EAEE,sCAAA;AFSF;AEKA;EACE;IAEE,uBAAA;EFQF;EENA;IAEE,yBAAA;EFQF;AACF;;AGlivBA;;;EAAA;AAIA;;;;;;EAME,kCAAA;EACA,mCAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;AHqivBF;;AGnivBA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;AHsivBF;;AGpivBA;EACE,iBAAA;AHuivBF;;AGrivBA;EACE,kBAAA;AHwivBF;;AGtivBA;EACE,cAAA;AHyivBF;;AGvivBA;EACE,cAAA;AH0ivBF;;AGxivBA;EACE,cAAA;AH2ivBF;;AGzivBA;EACE,cAAA;AH4ivBF;;AG1ivBA;EACE,cAAA;AH6ivBF;;AG3ivBA;EACE,cAAA;AH8ivBF;;AG5ivBA;EACE,cAAA;AH+ivBF;;AG7ivBA;EACE,cAAA;AHgjvBF;;AG9ivBA;EACE,cAAA;AHijvBF;;AG/ivBA;EACE,eAAA;AHkjvBF;;AGhjvBA;EACE,kBAAA;EACA,aAAA;AHmjvBF;;AGjjvBA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;AHojvBF;;AGnjvBE;EACE,kBAAA;AHsjvBJ;;AGpjvBA;EACE,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AHujvBF;;AGrjvBA;EACE,yBAAA;EACA,oBAAA;EACA,4BAAA;AHwjvBF;;AGtjvBA;EACE,WAAA;AHyjvBF;;AGvjvBA;EACE,YAAA;AH0jvBF;;AGxjvBA;;;;;EAKE,mBAAA;AH2jvBF;;AGzjvBA;;;;;EAKE,kBAAA;AH4jvBF;;AG1jvBA;EAEU,qCAAA;AH6jvBV;;AG3jvBA;EAEU,uCAAA;AH8jvBV;AGpjvBA;EACE;IAEU,uBAAA;EHikvBV;EGhkvBA;IAEU,yBAAA;EHkkvBV;AACF;AGjkvBA;EACE,sEAAA;EAEQ,wBAAA;AHmkvBV;;AGjkvBA;EACE,sEAAA;EAEQ,yBAAA;AHokvBV;;AGlkvBA;EACE,sEAAA;EAEQ,yBAAA;AHqkvBV;;AGnkvBA;EACE,gFAAA;EAEQ,uBAAA;AHskvBV;;AGpkvBA;EACE,gFAAA;EAEQ,uBAAA;AHukvBV;;AGrkvBA;EACE,gFAAA;EAEQ,wBAAA;AHwkvBV;;AGtkvBA;;;;;;EAOU,YAAA;AHykvBV;;AGvkvBA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AH0kvBF;;AGxkvBA;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AH2kvBF;;AGzkvBA;EACE,oBAAA;AH4kvBF;;AG1kvBA;EACE,cAAA;AH6kvBF;;AG3kvBA;EACE,WAAA;AH8kvBF;;AG5kvBA;gEAAA;AAEA;EACE,gBAAA;AH+kvBF;;AG7kvBA;EACE,gBAAA;AHglvBF;;AG9kvBA;EACE,gBAAA;AHilvBF;;AG/kvBA;EACE,gBAAA;AHklvBF;;AGhlvBA;EACE,gBAAA;AHmlvBF;;AGjlvBA;EACE,gBAAA;AHolvBF;;AGllvBA;EACE,gBAAA;AHqlvBF;;AGnlvBA;EACE,gBAAA;AHslvBF;;AGplvBA;EACE,gBAAA;AHulvBF;;AGrlvBA;EACE,gBAAA;AHwlvBF;;AGtlvBA;EACE,gBAAA;AHylvBF;;AGvlvBA;EACE,gBAAA;AH0lvBF;;AGxlvBA;EACE,gBAAA;AH2lvBF;;AGzlvBA;EACE,gBAAA;AH4lvBF;;AG1lvBA;EACE,gBAAA;AH6lvBF;;AG3lvBA;EACE,gBAAA;AH8lvBF;;AG5lvBA;EACE,gBAAA;AH+lvBF;;AG7lvBA;EACE,gBAAA;AHgmvBF;;AG9lvBA;EACE,gBAAA;AHimvBF;;AG/lvBA;EACE,gBAAA;AHkmvBF;;AGhmvBA;EACE,gBAAA;AHmmvBF;;AGjmvBA;EACE,gBAAA;AHomvBF;;AGlmvBA;EACE,gBAAA;AHqmvBF;;AGnmvBA;EACE,gBAAA;AHsmvBF;;AGpmvBA;EACE,gBAAA;AHumvBF;;AGrmvBA;EACE,gBAAA;AHwmvBF;;AGtmvBA;EACE,gBAAA;AHymvBF;;AGvmvBA;EACE,gBAAA;AH0mvBF;;AGxmvBA;EACE,gBAAA;AH2mvBF;;AGzmvBA;EACE,gBAAA;AH4mvBF;;AG1mvBA;EACE,gBAAA;AH6mvBF;;AG3mvBA;EACE,gBAAA;AH8mvBF;;AG5mvBA;EACE,gBAAA;AH+mvBF;;AG7mvBA;EACE,gBAAA;AHgnvBF;;AG9mvBA;EACE,gBAAA;AHinvBF;;AG/mvBA;EACE,gBAAA;AHknvBF;;AGhnvBA;EACE,gBAAA;AHmnvBF;;AGjnvBA;EACE,gBAAA;AHonvBF;;AGlnvBA;EACE,gBAAA;AHqnvBF;;AGnnvBA;EACE,gBAAA;AHsnvBF;;AGpnvBA;EACE,gBAAA;AHunvBF;;AGrnvBA;EACE,gBAAA;AHwnvBF;;AGtnvBA;EACE,gBAAA;AHynvBF;;AGvnvBA;EACE,gBAAA;AH0nvBF;;AGxnvBA;EACE,gBAAA;AH2nvBF;;AGznvBA;EACE,gBAAA;AH4nvBF;;AG1nvBA;EACE,gBAAA;AH6nvBF;;AG3nvBA;EACE,gBAAA;AH8nvBF;;AG5nvBA;EACE,gBAAA;AH+nvBF;;AG7nvBA;EACE,gBAAA;AHgovBF;;AG9nvBA;EACE,gBAAA;AHiovBF;;AG/nvBA;EACE,gBAAA;AHkovBF;;AGhovBA;EACE,gBAAA;AHmovBF;;AGjovBA;EACE,gBAAA;AHoovBF;;AGlovBA;EACE,gBAAA;AHqovBF;;AGnovBA;EACE,gBAAA;AHsovBF;;AGpovBA;EACE,gBAAA;AHuovBF;;AGrovBA;EACE,gBAAA;AHwovBF;;AGtovBA;EACE,gBAAA;AHyovBF;;AGvovBA;EACE,gBAAA;AH0ovBF;;AGxovBA;EACE,gBAAA;AH2ovBF;;AGzovBA;EACE,gBAAA;AH4ovBF;;AG1ovBA;EACE,gBAAA;AH6ovBF;;AG3ovBA;EACE,gBAAA;AH8ovBF;;AG5ovBA;EACE,gBAAA;AH+ovBF;;AG7ovBA;EACE,gBAAA;AHgpvBF;;AG9ovBA;EACE,gBAAA;AHipvBF;;AG/ovBA;EACE,gBAAA;AHkpvBF;;AGhpvBA;EACE,gBAAA;AHmpvBF;;AGjpvBA;EACE,gBAAA;AHopvBF;;AGlpvBA;EACE,gBAAA;AHqpvBF;;AGnpvBA;EACE,gBAAA;AHspvBF;;AGppvBA;EACE,gBAAA;AHupvBF;;AGrpvBA;EACE,gBAAA;AHwpvBF;;AGtpvBA;EACE,gBAAA;AHypvBF;;AGvpvBA;EACE,gBAAA;AH0pvBF;;AGxpvBA;EACE,gBAAA;AH2pvBF;;AGzpvBA;EACE,gBAAA;AH4pvBF;;AG1pvBA;EACE,gBAAA;AH6pvBF;;AG3pvBA;EACE,gBAAA;AH8pvBF;;AG5pvBA;EACE,gBAAA;AH+pvBF;;AG7pvBA;EACE,gBAAA;AHgqvBF;;AG9pvBA;EACE,gBAAA;AHiqvBF;;AG/pvBA;EACE,gBAAA;AHkqvBF;;AGhqvBA;EACE,gBAAA;AHmqvBF;;AGjqvBA;EACE,gBAAA;AHoqvBF;;AGlqvBA;EACE,gBAAA;AHqqvBF;;AGnqvBA;EACE,gBAAA;AHsqvBF;;AGpqvBA;EACE,gBAAA;AHuqvBF;;AGrqvBA;EACE,gBAAA;AHwqvBF;;AGtqvBA;EACE,gBAAA;AHyqvBF;;AGvqvBA;EACE,gBAAA;AH0qvBF;;AGxqvBA;EACE,gBAAA;AH2qvBF;;AGzqvBA;EACE,gBAAA;AH4qvBF;;AG1qvBA;EACE,gBAAA;AH6qvBF;;AG3qvBA;EACE,gBAAA;AH8qvBF;;AG5qvBA;EACE,gBAAA;AH+qvBF;;AG7qvBA;EACE,gBAAA;AHgrvBF;;AG9qvBA;EACE,gBAAA;AHirvBF;;AG/qvBA;EACE,gBAAA;AHkrvBF;;AGhrvBA;EACE,gBAAA;AHmrvBF;;AGjrvBA;EACE,gBAAA;AHorvBF;;AGlrvBA;EACE,gBAAA;AHqrvBF;;AGnrvBA;EACE,gBAAA;AHsrvBF;;AGprvBA;EACE,gBAAA;AHurvBF;;AGrrvBA;EACE,gBAAA;AHwrvBF;;AGtrvBA;EACE,gBAAA;AHyrvBF;;AGvrvBA;EACE,gBAAA;AH0rvBF;;AGxrvBA;EACE,gBAAA;AH2rvBF;;AGzrvBA;EACE,gBAAA;AH4rvBF;;AG1rvBA;EACE,gBAAA;AH6rvBF;;AG3rvBA;EACE,gBAAA;AH8rvBF;;AG5rvBA;EACE,gBAAA;AH+rvBF;;AG7rvBA;EACE,gBAAA;AHgsvBF;;AG9rvBA;EACE,gBAAA;AHisvBF;;AG/rvBA;EACE,gBAAA;AHksvBF;;AGhsvBA;EACE,gBAAA;AHmsvBF;;AGjsvBA;EACE,gBAAA;AHosvBF;;AGlsvBA;EACE,gBAAA;AHqsvBF;;AGnsvBA;EACE,gBAAA;AHssvBF;;AGpsvBA;EACE,gBAAA;AHusvBF;;AGrsvBA;EACE,gBAAA;AHwsvBF;;AGtsvBA;EACE,gBAAA;AHysvBF;;AGvsvBA;EACE,gBAAA;AH0svBF;;AGxsvBA;EACE,gBAAA;AH2svBF;;AGzsvBA;EACE,gBAAA;AH4svBF;;AG1svBA;EACE,gBAAA;AH6svBF;;AG3svBA;EACE,gBAAA;AH8svBF;;AG5svBA;EACE,gBAAA;AH+svBF;;AG7svBA;EACE,gBAAA;AHgtvBF;;AG9svBA;EACE,gBAAA;AHitvBF;;AG/svBA;EACE,gBAAA;AHktvBF;;AGhtvBA;EACE,gBAAA;AHmtvBF;;AGjtvBA;EACE,gBAAA;AHotvBF;;AGltvBA;EACE,gBAAA;AHqtvBF;;AGntvBA;EACE,gBAAA;AHstvBF;;AGptvBA;EACE,gBAAA;AHutvBF;;AGrtvBA;EACE,gBAAA;AHwtvBF;;AGttvBA;EACE,gBAAA;AHytvBF;;AGvtvBA;EACE,gBAAA;AH0tvBF;;AGxtvBA;EACE,gBAAA;AH2tvBF;;AGztvBA;EACE,gBAAA;AH4tvBF;;AG1tvBA;EACE,gBAAA;AH6tvBF;;AG3tvBA;EACE,gBAAA;AH8tvBF;;AG5tvBA;EACE,gBAAA;AH+tvBF;;AG7tvBA;EACE,gBAAA;AHguvBF;;AG9tvBA;EACE,gBAAA;AHiuvBF;;AG/tvBA;EACE,YAAA;AHkuvBF;;AGhuvBA;EACE,gBAAA;AHmuvBF;;AGjuvBA;EACE,gBAAA;AHouvBF;;AGluvBA;EACE,gBAAA;AHquvBF;;AGnuvBA;EACE,gBAAA;AHsuvBF;;AGpuvBA;EACE,gBAAA;AHuuvBF;;AGruvBA;EACE,gBAAA;AHwuvBF;;AGtuvBA;EACE,gBAAA;AHyuvBF;;AGvuvBA;EACE,gBAAA;AH0uvBF;;AGxuvBA;EACE,gBAAA;AH2uvBF;;AGzuvBA;EACE,gBAAA;AH4uvBF;;AG1uvBA;EACE,gBAAA;AH6uvBF;;AG3uvBA;EACE,gBAAA;AH8uvBF;;AG5uvBA;EACE,gBAAA;AH+uvBF;;AG7uvBA;EACE,gBAAA;AHgvvBF;;AG9uvBA;EACE,gBAAA;AHivvBF;;AG/uvBA;EACE,gBAAA;AHkvvBF;;AGhvvBA;EACE,gBAAA;AHmvvBF;;AGjvvBA;EACE,gBAAA;AHovvBF;;AGlvvBA;EACE,gBAAA;AHqvvBF;;AGnvvBA;EACE,gBAAA;AHsvvBF;;AGpvvBA;EACE,gBAAA;AHuvvBF;;AGrvvBA;EACE,gBAAA;AHwvvBF;;AGtvvBA;EACE,gBAAA;AHyvvBF;;AGvvvBA;EACE,gBAAA;AH0vvBF;;AGxvvBA;EACE,gBAAA;AH2vvBF;;AGzvvBA;EACE,gBAAA;AH4vvBF;;AG1vvBA;EACE,gBAAA;AH6vvBF;;AG3vvBA;EACE,gBAAA;AH8vvBF;;AG5vvBA;EACE,gBAAA;AH+vvBF;;AG7vvBA;EACE,gBAAA;AHgwvBF;;AG9vvBA;EACE,gBAAA;AHiwvBF;;AG/vvBA;EACE,gBAAA;AHkwvBF;;AGhwvBA;EACE,gBAAA;AHmwvBF;;AGjwvBA;EACE,gBAAA;AHowvBF;;AGlwvBA;EACE,gBAAA;AHqwvBF;;AGnwvBA;EACE,gBAAA;AHswvBF;;AGpwvBA;EACE,gBAAA;AHuwvBF;;AGrwvBA;EACE,gBAAA;AHwwvBF;;AGtwvBA;EACE,gBAAA;AHywvBF;;AGvwvBA;EACE,gBAAA;AH0wvBF;;AGxwvBA;EACE,gBAAA;AH2wvBF;;AGzwvBA;EACE,gBAAA;AH4wvBF;;AG1wvBA;EACE,gBAAA;AH6wvBF;;AG3wvBA;EACE,gBAAA;AH8wvBF;;AG5wvBA;EACE,gBAAA;AH+wvBF;;AG7wvBA;EACE,gBAAA;AHgxvBF;;AG9wvBA;EACE,gBAAA;AHixvBF;;AG/wvBA;EACE,gBAAA;AHkxvBF;;AGhxvBA;EACE,gBAAA;AHmxvBF;;AGjxvBA;EACE,gBAAA;AHoxvBF;;AGlxvBA;EACE,gBAAA;AHqxvBF;;AGnxvBA;EACE,gBAAA;AHsxvBF;;AGpxvBA;EACE,gBAAA;AHuxvBF;;AGrxvBA;EACE,gBAAA;AHwxvBF;;AGtxvBA;EACE,gBAAA;AHyxvBF;;AGvxvBA;EACE,gBAAA;AH0xvBF;;AGxxvBA;EACE,gBAAA;AH2xvBF;;AGzxvBA;EACE,gBAAA;AH4xvBF;;AG1xvBA;EACE,gBAAA;AH6xvBF;;AG3xvBA;EACE,gBAAA;AH8xvBF;;AG5xvBA;EACE,gBAAA;AH+xvBF;;AG7xvBA;EACE,gBAAA;AHgyvBF;;AG9xvBA;EACE,gBAAA;AHiyvBF;;AG/xvBA;EACE,gBAAA;AHkyvBF;;AGhyvBA;EACE,gBAAA;AHmyvBF;;AGjyvBA;EACE,gBAAA;AHoyvBF;;AGlyvBA;EACE,gBAAA;AHqyvBF;;AGnyvBA;EACE,gBAAA;AHsyvBF;;AGpyvBA;EACE,gBAAA;AHuyvBF;;AGryvBA;EACE,gBAAA;AHwyvBF;;AGtyvBA;EACE,gBAAA;AHyyvBF;;AGvyvBA;EACE,gBAAA;AH0yvBF;;AGxyvBA;EACE,gBAAA;AH2yvBF;;AGzyvBA;EACE,gBAAA;AH4yvBF;;AG1yvBA;EACE,gBAAA;AH6yvBF;;AG3yvBA;EACE,gBAAA;AH8yvBF;;AG5yvBA;EACE,gBAAA;AH+yvBF;;AG7yvBA;EACE,gBAAA;AHgzvBF;;AG9yvBA;EACE,gBAAA;AHizvBF;;AG/yvBA;EACE,gBAAA;AHkzvBF;;AGhzvBA;EACE,gBAAA;AHmzvBF;;AGjzvBA;EACE,gBAAA;AHozvBF;;AGlzvBA;EACE,gBAAA;AHqzvBF;;AGnzvBA;EACE,gBAAA;AHszvBF;;AGpzvBA;EACE,gBAAA;AHuzvBF;;AGrzvBA;EACE,gBAAA;AHwzvBF;;AGtzvBA;EACE,gBAAA;AHyzvBF;;AGvzvBA;EACE,gBAAA;AH0zvBF;;AGxzvBA;EACE,gBAAA;AH2zvBF;;AGzzvBA;EACE,gBAAA;AH4zvBF;;AG1zvBA;EACE,gBAAA;AH6zvBF;;AG3zvBA;EACE,gBAAA;AH8zvBF;;AG5zvBA;EACE,gBAAA;AH+zvBF;;AG7zvBA;EACE,gBAAA;AHg0vBF;;AG9zvBA;EACE,gBAAA;AHi0vBF;;AG/zvBA;EACE,gBAAA;AHk0vBF;;AGh0vBA;EACE,gBAAA;AHm0vBF;;AGj0vBA;EACE,gBAAA;AHo0vBF;;AGl0vBA;EACE,gBAAA;AHq0vBF;;AGn0vBA;EACE,gBAAA;AHs0vBF;;AGp0vBA;EACE,gBAAA;AHu0vBF;;AGr0vBA;EACE,gBAAA;AHw0vBF;;AGt0vBA;EACE,gBAAA;AHy0vBF;;AGv0vBA;EACE,gBAAA;AH00vBF;;AGx0vBA;EACE,gBAAA;AH20vBF;;AGz0vBA;EACE,gBAAA;AH40vBF;;AG10vBA;EACE,gBAAA;AH60vBF;;AG30vBA;EACE,gBAAA;AH80vBF;;AG50vBA;EACE,gBAAA;AH+0vBF;;AG70vBA;EACE,gBAAA;AHg1vBF;;AG90vBA;EACE,gBAAA;AHi1vBF;;AG/0vBA;EACE,gBAAA;AHk1vBF;;AGh1vBA;EACE,gBAAA;AHm1vBF;;AGj1vBA;EACE,gBAAA;AHo1vBF;;AGl1vBA;EACE,gBAAA;AHq1vBF;;AGn1vBA;EACE,gBAAA;AHs1vBF;;AGp1vBA;EACE,gBAAA;AHu1vBF;;AGr1vBA;EACE,gBAAA;AHw1vBF;;AGt1vBA;EACE,gBAAA;AHy1vBF;;AGv1vBA;EACE,gBAAA;AH01vBF;;AGx1vBA;EACE,gBAAA;AH21vBF;;AGz1vBA;EACE,gBAAA;AH41vBF;;AG11vBA;EACE,gBAAA;AH61vBF;;AG31vBA;EACE,gBAAA;AH81vBF;;AG51vBA;EACE,gBAAA;AH+1vBF;;AG71vBA;EACE,gBAAA;AHg2vBF;;AG91vBA;EACE,gBAAA;AHi2vBF;;AG/1vBA;EACE,gBAAA;AHk2vBF;;AGh2vBA;EACE,gBAAA;AHm2vBF;;AGj2vBA;EACE,gBAAA;AHo2vBF;;AGl2vBA;EACE,gBAAA;AHq2vBF;;AGn2vBA;EACE,gBAAA;AHs2vBF;;AGp2vBA;EACE,gBAAA;AHu2vBF;;AGr2vBA;EACE,gBAAA;AHw2vBF;;AGt2vBA;EACE,gBAAA;AHy2vBF;;AGv2vBA;EACE,gBAAA;AH02vBF;;AGx2vBA;EACE,gBAAA;AH22vBF;;AGz2vBA;EACE,gBAAA;AH42vBF;;AG12vBA;EACE,gBAAA;AH62vBF;;AG32vBA;EACE,gBAAA;AH82vBF;;AG52vBA;EACE,gBAAA;AH+2vBF;;AG72vBA;EACE,gBAAA;AHg3vBF;;AG92vBA;EACE,gBAAA;AHi3vBF;;AG/2vBA;EACE,gBAAA;AHk3vBF;;AGh3vBA;EACE,gBAAA;AHm3vBF;;AGj3vBA;EACE,gBAAA;AHo3vBF;;AGl3vBA;EACE,gBAAA;AHq3vBF;;AGn3vBA;EACE,gBAAA;AHs3vBF;;AGp3vBA;EACE,gBAAA;AHu3vBF;;AGr3vBA;EACE,gBAAA;AHw3vBF;;AGt3vBA;EACE,gBAAA;AHy3vBF;;AGv3vBA;EACE,gBAAA;AH03vBF;;AGx3vBA;EACE,gBAAA;AH23vBF;;AGz3vBA;EACE,gBAAA;AH43vBF;;AG13vBA;EACE,gBAAA;AH63vBF;;AG33vBA;EACE,gBAAA;AH83vBF;;AG53vBA;EACE,gBAAA;AH+3vBF;;AG73vBA;EACE,gBAAA;AHg4vBF;;AG93vBA;EACE,gBAAA;AHi4vBF;;AG/3vBA;EACE,gBAAA;AHk4vBF;;AGh4vBA;EACE,gBAAA;AHm4vBF;;AGj4vBA;EACE,gBAAA;AHo4vBF;;AGl4vBA;EACE,gBAAA;AHq4vBF;;AGn4vBA;EACE,gBAAA;AHs4vBF;;AGp4vBA;EACE,gBAAA;AHu4vBF;;AGr4vBA;EACE,gBAAA;AHw4vBF;;AGt4vBA;EACE,gBAAA;AHy4vBF;;AGv4vBA;EACE,gBAAA;AH04vBF;;AGx4vBA;EACE,gBAAA;AH24vBF;;AGz4vBA;EACE,gBAAA;AH44vBF;;AG14vBA;EACE,gBAAA;AH64vBF;;AG34vBA;EACE,gBAAA;AH84vBF;;AG54vBA;EACE,gBAAA;AH+4vBF;;AG74vBA;EACE,gBAAA;AHg5vBF;;AG94vBA;EACE,gBAAA;AHi5vBF;;AG/4vBA;EACE,gBAAA;AHk5vBF;;AGh5vBA;EACE,gBAAA;AHm5vBF;;AGj5vBA;EACE,gBAAA;AHo5vBF;;AGl5vBA;EACE,gBAAA;AHq5vBF;;AGn5vBA;EACE,gBAAA;AHs5vBF;;AGp5vBA;EACE,gBAAA;AHu5vBF;;AGr5vBA;EACE,gBAAA;AHw5vBF;;AGt5vBA;EACE,gBAAA;AHy5vBF;;AGv5vBA;EACE,gBAAA;AH05vBF;;AGx5vBA;EACE,gBAAA;AH25vBF;;AGz5vBA;EACE,gBAAA;AH45vBF;;AG15vBA;EACE,gBAAA;AH65vBF;;AG35vBA;EACE,gBAAA;AH85vBF;;AG55vBA;EACE,gBAAA;AH+5vBF;;AG75vBA;EACE,gBAAA;AHg6vBF;;AG95vBA;EACE,gBAAA;AHi6vBF;;AG/5vBA;EACE,YAAA;AHk6vBF;;AGh6vBA;EACE,gBAAA;AHm6vBF;;AGj6vBA;EACE,gBAAA;AHo6vBF;;AGl6vBA;EACE,gBAAA;AHq6vBF;;AGn6vBA;EACE,gBAAA;AHs6vBF;;AGp6vBA;EACE,gBAAA;AHu6vBF;;AGr6vBA;EACE,gBAAA;AHw6vBF;;AGt6vBA;EACE,gBAAA;AHy6vBF;;AGv6vBA;EACE,gBAAA;AH06vBF;;AGx6vBA;EACE,gBAAA;AH26vBF;;AGz6vBA;EACE,gBAAA;AH46vBF;;AG16vBA;EACE,gBAAA;AH66vBF;;AG36vBA;EACE,gBAAA;AH86vBF;;AG56vBA;EACE,gBAAA;AH+6vBF;;AG76vBA;EACE,gBAAA;AHg7vBF;;AG96vBA;EACE,gBAAA;AHi7vBF;;AG/6vBA;EACE,gBAAA;AHk7vBF;;AGh7vBA;EACE,gBAAA;AHm7vBF;;AGj7vBA;EACE,gBAAA;AHo7vBF;;AGl7vBA;EACE,gBAAA;AHq7vBF;;AGn7vBA;EACE,gBAAA;AHs7vBF;;AGp7vBA;EACE,gBAAA;AHu7vBF;;AGr7vBA;EACE,gBAAA;AHw7vBF;;AGt7vBA;EACE,gBAAA;AHy7vBF;;AGv7vBA;EACE,gBAAA;AH07vBF;;AGx7vBA;EACE,gBAAA;AH27vBF;;AGz7vBA;EACE,gBAAA;AH47vBF;;AG17vBA;EACE,gBAAA;AH67vBF;;AG37vBA;EACE,gBAAA;AH87vBF;;AG57vBA;EACE,gBAAA;AH+7vBF;;AG77vBA;EACE,gBAAA;AHg8vBF;;AG97vBA;EACE,gBAAA;AHi8vBF;;AG/7vBA;EACE,gBAAA;AHk8vBF;;AGh8vBA;EACE,gBAAA;AHm8vBF;;AGj8vBA;EACE,gBAAA;AHo8vBF;;AGl8vBA;EACE,gBAAA;AHq8vBF;;AGn8vBA;EACE,gBAAA;AHs8vBF;;AGp8vBA;EACE,gBAAA;AHu8vBF;;AGr8vBA;EACE,gBAAA;AHw8vBF;;AGt8vBA;EACE,gBAAA;AHy8vBF;;AGv8vBA;EACE,gBAAA;AH08vBF;;AGx8vBA;EACE,gBAAA;AH28vBF;;AGz8vBA;EACE,gBAAA;AH48vBF;;AG18vBA;EACE,gBAAA;AH68vBF;;AG38vBA;EACE,gBAAA;AH88vBF;;AG58vBA;EACE,gBAAA;AH+8vBF;;AG78vBA;EACE,gBAAA;AHg9vBF;;AG98vBA;EACE,gBAAA;AHi9vBF;;AG/8vBA;EACE,gBAAA;AHk9vBF;;AGh9vBA;EACE,gBAAA;AHm9vBF;;AGj9vBA;EACE,gBAAA;AHo9vBF;;AGl9vBA;EACE,gBAAA;AHq9vBF;;AGn9vBA;EACE,gBAAA;AHs9vBF;;AGp9vBA;EACE,gBAAA;AHu9vBF;;AGr9vBA;EACE,gBAAA;AHw9vBF;;AGt9vBA;EACE,gBAAA;AHy9vBF;;AGv9vBA;EACE,gBAAA;AH09vBF;;AGx9vBA;EACE,gBAAA;AH29vBF;;AGz9vBA;EACE,gBAAA;AH49vBF;;AG19vBA;EACE,gBAAA;AH69vBF;;AG39vBA;EACE,gBAAA;AH89vBF;;AG59vBA;EACE,gBAAA;AH+9vBF;;AG79vBA;EACE,gBAAA;AHg+vBF;;AG99vBA;EACE,gBAAA;AHi+vBF;;AG/9vBA;EACE,gBAAA;AHk+vBF;;AGh+vBA;EACE,gBAAA;AHm+vBF;;AGj+vBA;EACE,gBAAA;AHo+vBF;;AGl+vBA;EACE,gBAAA;AHq+vBF;;AGn+vBA;EACE,gBAAA;AHs+vBF;;AGp+vBA;EACE,gBAAA;AHu+vBF;;AGr+vBA;EACE,gBAAA;AHw+vBF;;AGt+vBA;EACE,gBAAA;AHy+vBF;;AGv+vBA;EACE,gBAAA;AH0+vBF;;AGx+vBA;EACE,gBAAA;AH2+vBF;;AGz+vBA;EACE,gBAAA;AH4+vBF;;AG1+vBA;EACE,gBAAA;AH6+vBF;;AG3+vBA;EACE,gBAAA;AH8+vBF;;AG5+vBA;EACE,gBAAA;AH++vBF;;AG7+vBA;EACE,gBAAA;AHg/vBF;;AG9+vBA;EACE,gBAAA;AHi/vBF;;AG/+vBA;EACE,gBAAA;AHk/vBF;;AGh/vBA;EACE,gBAAA;AHm/vBF;;AGj/vBA;EACE,gBAAA;AHo/vBF;;AGl/vBA;EACE,gBAAA;AHq/vBF;;AGn/vBA;EACE,gBAAA;AHs/vBF;;AGp/vBA;EACE,gBAAA;AHu/vBF;;AGr/vBA;EACE,gBAAA;AHw/vBF;;AGt/vBA;EACE,gBAAA;AHy/vBF;;AGv/vBA;EACE,gBAAA;AH0/vBF;;AGx/vBA;EACE,gBAAA;AH2/vBF;;AGz/vBA;EACE,gBAAA;AH4/vBF;;AG1/vBA;EACE,gBAAA;AH6/vBF;;AG3/vBA;EACE,gBAAA;AH8/vBF;;AG5/vBA;EACE,gBAAA;AH+/vBF;;AG7/vBA;EACE,gBAAA;AHggwBF;;AG9/vBA;EACE,gBAAA;AHigwBF;;AG//vBA;EACE,gBAAA;AHkgwBF;;AGhgwBA;EACE,gBAAA;AHmgwBF;;AGjgwBA;EACE,gBAAA;AHogwBF;;AGlgwBA;EACE,gBAAA;AHqgwBF;;AGngwBA;EACE,gBAAA;AHsgwBF;;AGpgwBA;EACE,gBAAA;AHugwBF;;AGrgwBA;EACE,gBAAA;AHwgwBF;;AGtgwBA;EACE,gBAAA;AHygwBF;;AGvgwBA;EACE,gBAAA;AH0gwBF;;AGxgwBA;EACE,gBAAA;AH2gwBF;;AGzgwBA;EACE,gBAAA;AH4gwBF;;AG1gwBA;EACE,gBAAA;AH6gwBF;;AG3gwBA;EACE,YAAA;AH8gwBF;;AG5gwBA;EACE,gBAAA;AH+gwBF;;AG7gwBA;EACE,gBAAA;AHghwBF;;AG9gwBA;EACE,gBAAA;AHihwBF;;AG/gwBA;EACE,gBAAA;AHkhwBF;;AGhhwBA;EACE,gBAAA;AHmhwBF;;AGjhwBA;EACE,gBAAA;AHohwBF;;AGlhwBA;EACE,gBAAA;AHqhwBF;;AGnhwBA;EACE,gBAAA;AHshwBF;;AGphwBA;EACE,gBAAA;AHuhwBF;;AGrhwBA;EACE,gBAAA;AHwhwBF;;AGthwBA;EACE,gBAAA;AHyhwBF;;AGvhwBA;EACE,gBAAA;AH0hwBF;;AGxhwBA;EACE,gBAAA;AH2hwBF;;AGzhwBA;EACE,gBAAA;AH4hwBF;;AG1hwBA;EACE,gBAAA;AH6hwBF;;AG3hwBA;EACE,gBAAA;AH8hwBF;;AG5hwBA;EACE,gBAAA;AH+hwBF;;AG7hwBA;EACE,gBAAA;AHgiwBF;;AG9hwBA;EACE,gBAAA;AHiiwBF;;AG/hwBA;EACE,gBAAA;AHkiwBF;;AGhiwBA;EACE,gBAAA;AHmiwBF;;AGjiwBA;EACE,gBAAA;AHoiwBF;;AGliwBA;EACE,gBAAA;AHqiwBF;;AGniwBA;EACE,gBAAA;AHsiwBF;;AGpiwBA;EACE,gBAAA;AHuiwBF;;AGriwBA;EACE,gBAAA;AHwiwBF;;AGtiwBA;EACE,gBAAA;AHyiwBF;;AGviwBA;EACE,gBAAA;AH0iwBF;;AGxiwBA;EACE,gBAAA;AH2iwBF;;AGziwBA;EACE,gBAAA;AH4iwBF;;AG1iwBA;EACE,gBAAA;AH6iwBF;;AG3iwBA;EACE,gBAAA;AH8iwBF;;AG5iwBA;EACE,gBAAA;AH+iwBF;;AG7iwBA;EACE,gBAAA;AHgjwBF;;AG9iwBA;EACE,gBAAA;AHijwBF;;AG/iwBA;EACE,gBAAA;AHkjwBF;;AGhjwBA;EACE,gBAAA;AHmjwBF;;AGjjwBA;EACE,gBAAA;AHojwBF;;AGljwBA;EACE,gBAAA;AHqjwBF;;AGnjwBA;EACE,gBAAA;AHsjwBF;;AGpjwBA;EACE,YAAA;AHujwBF;;AGrjwBA;EACE,gBAAA;AHwjwBF;;AGtjwBA;EACE,gBAAA;AHyjwBF;;AGvjwBA;EACE,gBAAA;AH0jwBF;;AGxjwBA;EACE,gBAAA;AH2jwBF;;AGzjwBA;EACE,gBAAA;AH4jwBF;;AG1jwBA;EACE,gBAAA;AH6jwBF;;AG3jwBA;EACE,gBAAA;AH8jwBF;;AG5jwBA;EACE,gBAAA;AH+jwBF;;AG7jwBA;EACE,gBAAA;AHgkwBF;;AG9jwBA;EACE,gBAAA;AHikwBF;;AG/jwBA;EACE,gBAAA;AHkkwBF;;AGhkwBA;EACE,gBAAA;AHmkwBF;;AGjkwBA;EACE,gBAAA;AHokwBF;;AGlkwBA;EACE,gBAAA;AHqkwBF;;AGnkwBA;EACE,gBAAA;AHskwBF;;AGpkwBA;EACE,gBAAA;AHukwBF;;AGrkwBA;EACE,gBAAA;AHwkwBF;;AGtkwBA;EACE,gBAAA;AHykwBF;;AGvkwBA;EACE,gBAAA;AH0kwBF;;AGxkwBA;EACE,gBAAA;AH2kwBF;;AGzkwBA;EACE,gBAAA;AH4kwBF;;AG1kwBA;EACE,gBAAA;AH6kwBF;;AG3kwBA;EACE,gBAAA;AH8kwBF;;AG5kwBA;EACE,gBAAA;AH+kwBF;;AG7kwBA;EACE,gBAAA;AHglwBF;;AG9kwBA;EACE,gBAAA;AHilwBF;;AG/kwBA;EACE,gBAAA;AHklwBF;;AGhlwBA;EACE,gBAAA;AHmlwBF;;AGjlwBA;EACE,gBAAA;AHolwBF;;AGllwBA;EACE,gBAAA;AHqlwBF;;AGnlwBA;EACE,gBAAA;AHslwBF;;AGplwBA;EACE,gBAAA;AHulwBF;;AGrlwBA;EACE,gBAAA;AHwlwBF;;AGtlwBA;EACE,gBAAA;AHylwBF;;AGvlwBA;EACE,gBAAA;AH0lwBF;;AGxlwBA;EACE,gBAAA;AH2lwBF;;AGzlwBA;EACE,gBAAA;AH4lwBF;;AG1lwBA;EACE,gBAAA;AH6lwBF;;AG3lwBA;EACE,gBAAA;AH8lwBF;;AG5lwBA;EACE,gBAAA;AH+lwBF;;AG7lwBA;EACE,gBAAA;AHgmwBF;;AG9lwBA;EACE,gBAAA;AHimwBF;;AG/lwBA;EACE,gBAAA;AHkmwBF;;AGhmwBA;EACE,gBAAA;AHmmwBF;;AGjmwBA;EACE,gBAAA;AHomwBF;;AGlmwBA;EACE,gBAAA;AHqmwBF;;AGnmwBA;EACE,gBAAA;AHsmwBF;;AGpmwBA;EACE,gBAAA;AHumwBF;;AGrmwBA;EACE,gBAAA;AHwmwBF;;AGtmwBA;EACE,gBAAA;AHymwBF;;AGvmwBA;EACE,gBAAA;AH0mwBF;;AGxmwBA;EACE,gBAAA;AH2mwBF;;AGzmwBA;EACE,gBAAA;AH4mwBF;;AG1mwBA;EACE,gBAAA;AH6mwBF;;AG3mwBA;EACE,gBAAA;AH8mwBF;;AG5mwBA;EACE,gBAAA;AH+mwBF;;AG7mwBA;EACE,gBAAA;AHgnwBF;;AG9mwBA;EACE,gBAAA;AHinwBF;;AG/mwBA;EACE,gBAAA;AHknwBF;;AGhnwBA;EACE,gBAAA;AHmnwBF;;AGjnwBA;EACE,gBAAA;AHonwBF;;AGlnwBA;EACE,gBAAA;AHqnwBF;;AGnnwBA;EACE,gBAAA;AHsnwBF;;AGpnwBA;EACE,gBAAA;AHunwBF;;AGrnwBA;EACE,gBAAA;AHwnwBF;;AGtnwBA;EACE,gBAAA;AHynwBF;;AGvnwBA;EACE,gBAAA;AH0nwBF;;AGxnwBA;EACE,gBAAA;AH2nwBF;;AGznwBA;EACE,gBAAA;AH4nwBF;;AG1nwBA;EACE,gBAAA;AH6nwBF;;AG3nwBA;EACE,gBAAA;AH8nwBF;;AG5nwBA;EACE,gBAAA;AH+nwBF;;AG7nwBA;EACE,gBAAA;AHgowBF;;AG9nwBA;EACE,gBAAA;AHiowBF;;AG/nwBA;EACE,gBAAA;AHkowBF;;AGhowBA;EACE,gBAAA;AHmowBF;;AGjowBA;EACE,gBAAA;AHoowBF;;AGlowBA;EACE,gBAAA;AHqowBF;;AGnowBA;EACE,gBAAA;AHsowBF;;AGpowBA;EACE,gBAAA;AHuowBF;;AGrowBA;EACE,gBAAA;AHwowBF;;AGtowBA;EACE,gBAAA;AHyowBF;;AGvowBA;EACE,gBAAA;AH0owBF;;AGxowBA;EACE,gBAAA;AH2owBF;;AGzowBA;EACE,gBAAA;AH4owBF;;AG1owBA;EACE,gBAAA;AH6owBF;;AG3owBA;EACE,gBAAA;AH8owBF;;AG5owBA;EACE,gBAAA;AH+owBF;;AG7owBA;EACE,gBAAA;AHgpwBF;;AG9owBA;EACE,gBAAA;AHipwBF;;AG/owBA;EACE,gBAAA;AHkpwBF;;AGhpwBA;EACE,gBAAA;AHmpwBF;;AGjpwBA;EACE,gBAAA;AHopwBF;;AGlpwBA;EACE,gBAAA;AHqpwBF;;AGnpwBA;EACE,gBAAA;AHspwBF;;AGppwBA;EACE,gBAAA;AHupwBF;;AGrpwBA;EACE,gBAAA;AHwpwBF;;AGtpwBA;EACE,gBAAA;AHypwBF;;AGvpwBA;EACE,gBAAA;AH0pwBF;;AGxpwBA;EACE,gBAAA;AH2pwBF;;AGzpwBA;EACE,gBAAA;AH4pwBF;;AG1pwBA;EACE,gBAAA;AH6pwBF;;AG3pwBA;EACE,gBAAA;AH8pwBF;;AG5pwBA;EACE,gBAAA;AH+pwBF;;AG7pwBA;EACE,gBAAA;AHgqwBF;;AG9pwBA;EACE,gBAAA;AHiqwBF;;AG/pwBA;EACE,gBAAA;AHkqwBF;;AGhqwBA;EACE,gBAAA;AHmqwBF;;AGjqwBA;EACE,gBAAA;AHoqwBF;;AGlqwBA;EACE,gBAAA;AHqqwBF;;AGnqwBA;EACE,gBAAA;AHsqwBF;;AGpqwBA;EACE,gBAAA;AHuqwBF;;AGrqwBA;EACE,gBAAA;AHwqwBF;;AGtqwBA;EACE,gBAAA;AHyqwBF;;AGvqwBA;EACE,gBAAA;AH0qwBF;;AGxqwBA;EACE,gBAAA;AH2qwBF;;AGzqwBA;EACE,gBAAA;AH4qwBF;;AG1qwBA;EACE,gBAAA;AH6qwBF;;AG3qwBA;EACE,gBAAA;AH8qwBF;;AG5qwBA;EACE,gBAAA;AH+qwBF;;AG7qwBA;EACE,gBAAA;AHgrwBF;;AG9qwBA;EACE,YAAA;AHirwBF;;AG/qwBA;EACE,gBAAA;AHkrwBF;;AGhrwBA;EACE,gBAAA;AHmrwBF;;AGjrwBA;EACE,gBAAA;AHorwBF;;AGlrwBA;EACE,gBAAA;AHqrwBF;;AGnrwBA;EACE,gBAAA;AHsrwBF;;AGprwBA;EACE,gBAAA;AHurwBF;;AGrrwBA;EACE,gBAAA;AHwrwBF;;AGtrwBA;EACE,gBAAA;AHyrwBF;;AGvrwBA;EACE,gBAAA;AH0rwBF;;AGxrwBA;EACE,gBAAA;AH2rwBF;;AGzrwBA;EACE,gBAAA;AH4rwBF;;AG1rwBA;EACE,gBAAA;AH6rwBF;;AG3rwBA;EACE,gBAAA;AH8rwBF;;AG5rwBA;EACE,YAAA;AH+rwBF;;AG7rwBA;EACE,gBAAA;AHgswBF;;AG9rwBA;EACE,gBAAA;AHiswBF;;AG/rwBA;EACE,gBAAA;AHkswBF;;AGhswBA;EACE,YAAA;AHmswBF;;AGjswBA;EACE,gBAAA;AHoswBF;;AGlswBA;EACE,YAAA;AHqswBF;;AGnswBA;EACE,YAAA;AHsswBF;;AGpswBA;EACE,gBAAA;AHuswBF;;AGrswBA;EACE,gBAAA;AHwswBF;;AGtswBA;EACE,gBAAA;AHyswBF;;AGvswBA;EACE,gBAAA;AH0swBF;;AGxswBA;EACE,gBAAA;AH2swBF;;AGzswBA;EACE,gBAAA;AH4swBF;;AG1swBA;EACE,gBAAA;AH6swBF;;AG3swBA;EACE,YAAA;AH8swBF;;AG5swBA;EACE,YAAA;AH+swBF;;AG7swBA;EACE,YAAA;AHgtwBF;;AG9swBA;EACE,YAAA;AHitwBF;;AG/swBA;EACE,gBAAA;AHktwBF;;AGhtwBA;EACE,gBAAA;AHmtwBF;;AGjtwBA;EACE,gBAAA;AHotwBF;;AGltwBA;EACE,gBAAA;AHqtwBF;;AGntwBA;EACE,gBAAA;AHstwBF;;AGptwBA;EACE,gBAAA;AHutwBF;;AGrtwBA;EACE,gBAAA;AHwtwBF;;AGttwBA;EACE,gBAAA;AHytwBF;;AGvtwBA;EACE,gBAAA;AH0twBF;;AGxtwBA;EACE,gBAAA;AH2twBF;;AGztwBA;EACE,gBAAA;AH4twBF;;AG1twBA;EACE,gBAAA;AH6twBF;;AG3twBA;EACE,gBAAA;AH8twBF;;AG5twBA;EACE,gBAAA;AH+twBF;;AG7twBA;EACE,gBAAA;AHguwBF;;AG9twBA;EACE,gBAAA;AHiuwBF;;AG/twBA;EACE,gBAAA;AHkuwBF;;AGhuwBA;EACE,gBAAA;AHmuwBF;;AGjuwBA;EACE,gBAAA;AHouwBF;;AGluwBA;EACE,gBAAA;AHquwBF;;AGnuwBA;EACE,gBAAA;AHsuwBF;;AGpuwBA;EACE,gBAAA;AHuuwBF;;AGruwBA;EACE,gBAAA;AHwuwBF;;AGtuwBA;EACE,gBAAA;AHyuwBF;;AGvuwBA;EACE,gBAAA;AH0uwBF;;AGxuwBA;EACE,gBAAA;AH2uwBF;;AGzuwBA;EACE,gBAAA;AH4uwBF;;AG1uwBA;EACE,gBAAA;AH6uwBF;;AG3uwBA;EACE,gBAAA;AH8uwBF;;AG5uwBA;EACE,gBAAA;AH+uwBF;;AG7uwBA;EACE,gBAAA;AHgvwBF;;AG9uwBA;EACE,gBAAA;AHivwBF;;AG/uwBA;EACE,gBAAA;AHkvwBF;;AGhvwBA;EACE,gBAAA;AHmvwBF;;AGjvwBA;EACE,YAAA;AHovwBF;;AGlvwBA;EACE,gBAAA;AHqvwBF;;AGnvwBA;EACE,gBAAA;AHsvwBF;;AGpvwBA;EACE,gBAAA;AHuvwBF;;AGrvwBA;EACE,gBAAA;AHwvwBF;;AGtvwBA;EACE,gBAAA;AHyvwBF;;AGvvwBA;EACE,gBAAA;AH0vwBF;;AGxvwBA;EACE,gBAAA;AH2vwBF;;AGzvwBA;EACE,gBAAA;AH4vwBF;;AG1vwBA;EACE,gBAAA;AH6vwBF;;AG3vwBA;EACE,gBAAA;AH8vwBF;;AG5vwBA;EACE,gBAAA;AH+vwBF;;AG7vwBA;EACE,YAAA;AHgwwBF;;AG9vwBA;EACE,gBAAA;AHiwwBF;;AG/vwBA;EACE,gBAAA;AHkwwBF;;AGhwwBA;EACE,gBAAA;AHmwwBF;;AGjwwBA;EACE,gBAAA;AHowwBF;;AGlwwBA;EACE,gBAAA;AHqwwBF;;AGnwwBA;EACE,gBAAA;AHswwBF;;AGpwwBA;EACE,gBAAA;AHuwwBF;;AGrwwBA;EACE,gBAAA;AHwwwBF;;AGtwwBA;EACE,gBAAA;AHywwBF;;AGvwwBA;EACE,gBAAA;AH0wwBF;;AGxwwBA;EACE,gBAAA;AH2wwBF;;AGzwwBA;EACE,YAAA;AH4wwBF;;AG1wwBA;EACE,gBAAA;AH6wwBF;;AG3wwBA;EACE,gBAAA;AH8wwBF;;AG5wwBA;EACE,gBAAA;AH+wwBF;;AG7wwBA;EACE,gBAAA;AHgxwBF;;AG9wwBA;EACE,gBAAA;AHixwBF;;AG/wwBA;EACE,gBAAA;AHkxwBF;;AGhxwBA;EACE,gBAAA;AHmxwBF;;AGjxwBA;EACE,gBAAA;AHoxwBF;;AGlxwBA;EACE,gBAAA;AHqxwBF;;AGnxwBA;EACE,gBAAA;AHsxwBF;;AGpxwBA;EACE,gBAAA;AHuxwBF;;AGrxwBA;EACE,gBAAA;AHwxwBF;;AGtxwBA;EACE,gBAAA;AHyxwBF;;AGvxwBA;EACE,gBAAA;AH0xwBF;;AGxxwBA;EACE,gBAAA;AH2xwBF;;AGzxwBA;EACE,gBAAA;AH4xwBF;;AG1xwBA;EACE,gBAAA;AH6xwBF;;AG3xwBA;EACE,gBAAA;AH8xwBF;;AG5xwBA;EACE,gBAAA;AH+xwBF;;AG7xwBA;EACE,gBAAA;AHgywBF;;AG9xwBA;EACE,gBAAA;AHiywBF;;AG/xwBA;EACE,gBAAA;AHkywBF;;AGhywBA;EACE,gBAAA;AHmywBF;;AGjywBA;EACE,gBAAA;AHoywBF;;AGlywBA;EACE,gBAAA;AHqywBF;;AGnywBA;EACE,gBAAA;AHsywBF;;AGpywBA;EACE,gBAAA;AHuywBF;;AGrywBA;EACE,gBAAA;AHwywBF;;AGtywBA;EACE,gBAAA;AHyywBF;;AGvywBA;EACE,gBAAA;AH0ywBF;;AGxywBA;EACE,gBAAA;AH2ywBF;;AGzywBA;EACE,gBAAA;AH4ywBF;;AG1ywBA;EACE,gBAAA;AH6ywBF;;AG3ywBA;EACE,gBAAA;AH8ywBF;;AG5ywBA;EACE,gBAAA;AH+ywBF;;AG7ywBA;EACE,gBAAA;AHgzwBF;;AG9ywBA;EACE,gBAAA;AHizwBF;;AG/ywBA;EACE,gBAAA;AHkzwBF;;AGhzwBA;EACE,YAAA;AHmzwBF;;AGjzwBA;EACE,gBAAA;AHozwBF;;AGlzwBA;EACE,gBAAA;AHqzwBF;;AGnzwBA;EACE,gBAAA;AHszwBF;;AGpzwBA;EACE,gBAAA;AHuzwBF;;AGrzwBA;EACE,gBAAA;AHwzwBF;;AGtzwBA;EACE,gBAAA;AHyzwBF;;AGvzwBA;EACE,gBAAA;AH0zwBF;;AGxzwBA;EACE,gBAAA;AH2zwBF;;AGzzwBA;EACE,gBAAA;AH4zwBF;;AG1zwBA;EACE,gBAAA;AH6zwBF;;AG3zwBA;EACE,gBAAA;AH8zwBF;;AG5zwBA;EACE,gBAAA;AH+zwBF;;AG7zwBA;EACE,gBAAA;AHg0wBF;;AG9zwBA;EACE,gBAAA;AHi0wBF;;AG/zwBA;EACE,gBAAA;AHk0wBF;;AGh0wBA;EACE,gBAAA;AHm0wBF;;AGj0wBA;EACE,gBAAA;AHo0wBF;;AGl0wBA;EACE,gBAAA;AHq0wBF;;AGn0wBA;EACE,gBAAA;AHs0wBF;;AGp0wBA;EACE,gBAAA;AHu0wBF;;AGr0wBA;EACE,gBAAA;AHw0wBF;;AGt0wBA;EACE,gBAAA;AHy0wBF;;AGv0wBA;EACE,gBAAA;AH00wBF;;AGx0wBA;EACE,gBAAA;AH20wBF;;AGz0wBA;EACE,gBAAA;AH40wBF;;AG10wBA;EACE,gBAAA;AH60wBF;;AG30wBA;EACE,gBAAA;AH80wBF;;AG50wBA;EACE,gBAAA;AH+0wBF;;AG70wBA;EACE,gBAAA;AHg1wBF;;AG90wBA;EACE,gBAAA;AHi1wBF;;AG/0wBA;EACE,gBAAA;AHk1wBF;;AGh1wBA;EACE,gBAAA;AHm1wBF;;AGj1wBA;EACE,gBAAA;AHo1wBF;;AGl1wBA;EACE,gBAAA;AHq1wBF;;AGn1wBA;EACE,gBAAA;AHs1wBF;;AGp1wBA;EACE,gBAAA;AHu1wBF;;AGr1wBA;EACE,gBAAA;AHw1wBF;;AGt1wBA;EACE,gBAAA;AHy1wBF;;AGv1wBA;EACE,gBAAA;AH01wBF;;AGx1wBA;EACE,gBAAA;AH21wBF;;AGz1wBA;EACE,YAAA;AH41wBF;;AG11wBA;EACE,gBAAA;AH61wBF;;AG31wBA;EACE,gBAAA;AH81wBF;;AG51wBA;EACE,gBAAA;AH+1wBF;;AG71wBA;EACE,gBAAA;AHg2wBF;;AG91wBA;EACE,gBAAA;AHi2wBF;;AG/1wBA;EACE,gBAAA;AHk2wBF;;AGh2wBA;EACE,gBAAA;AHm2wBF;;AGj2wBA;EACE,gBAAA;AHo2wBF;;AGl2wBA;EACE,gBAAA;AHq2wBF;;AGn2wBA;EACE,gBAAA;AHs2wBF;;AGp2wBA;EACE,gBAAA;AHu2wBF;;AGr2wBA;EACE,gBAAA;AHw2wBF;;AGt2wBA;EACE,gBAAA;AHy2wBF;;AGv2wBA;EACE,gBAAA;AH02wBF;;AGx2wBA;EACE,gBAAA;AH22wBF;;AGz2wBA;EACE,gBAAA;AH42wBF;;AG12wBA;EACE,gBAAA;AH62wBF;;AG32wBA;EACE,gBAAA;AH82wBF;;AG52wBA;EACE,gBAAA;AH+2wBF;;AG72wBA;EACE,gBAAA;AHg3wBF;;AG92wBA;EACE,gBAAA;AHi3wBF;;AG/2wBA;EACE,gBAAA;AHk3wBF;;AGh3wBA;EACE,gBAAA;AHm3wBF;;AGj3wBA;EACE,gBAAA;AHo3wBF;;AGl3wBA;EACE,gBAAA;AHq3wBF;;AGn3wBA;EACE,gBAAA;AHs3wBF;;AGp3wBA;EACE,gBAAA;AHu3wBF;;AGr3wBA;EACE,gBAAA;AHw3wBF;;AGt3wBA;EACE,gBAAA;AHy3wBF;;AGv3wBA;EACE,gBAAA;AH03wBF;;AGx3wBA;EACE,gBAAA;AH23wBF;;AGz3wBA;EACE,gBAAA;AH43wBF;;AG13wBA;EACE,gBAAA;AH63wBF;;AG33wBA;EACE,gBAAA;AH83wBF;;AG53wBA;EACE,gBAAA;AH+3wBF;;AG73wBA;EACE,gBAAA;AHg4wBF;;AG93wBA;EACE,gBAAA;AHi4wBF;;AG/3wBA;EACE,gBAAA;AHk4wBF;;AGh4wBA;EACE,gBAAA;AHm4wBF;;AGj4wBA;EACE,gBAAA;AHo4wBF;;AGl4wBA;EACE,gBAAA;AHq4wBF;;AGn4wBA;EACE,gBAAA;AHs4wBF;;AGp4wBA;EACE,YAAA;AHu4wBF;;AGr4wBA;EACE,gBAAA;AHw4wBF;;AGt4wBA;EACE,gBAAA;AHy4wBF;;AGv4wBA;EACE,gBAAA;AH04wBF;;AGx4wBA;EACE,gBAAA;AH24wBF;;AGz4wBA;EACE,gBAAA;AH44wBF;;AG14wBA;EACE,gBAAA;AH64wBF;;AG34wBA;EACE,gBAAA;AH84wBF;;AG54wBA;EACE,gBAAA;AH+4wBF;;AG74wBA;EACE,gBAAA;AHg5wBF;;AG94wBA;EACE,gBAAA;AHi5wBF;;AG/4wBA;EACE,gBAAA;AHk5wBF;;AGh5wBA;EACE,gBAAA;AHm5wBF;;AGj5wBA;EACE,gBAAA;AHo5wBF;;AGl5wBA;EACE,YAAA;AHq5wBF;;AGn5wBA;EACE,gBAAA;AHs5wBF;;AGp5wBA;EACE,gBAAA;AHu5wBF;;AGr5wBA;EACE,gBAAA;AHw5wBF;;AGt5wBA;EACE,gBAAA;AHy5wBF;;AGv5wBA;EACE,gBAAA;AH05wBF;;AGx5wBA;EACE,gBAAA;AH25wBF;;AGz5wBA;EACE,gBAAA;AH45wBF;;AG15wBA;EACE,gBAAA;AH65wBF;;AG35wBA;EACE,gBAAA;AH85wBF;;AG55wBA;EACE,gBAAA;AH+5wBF;;AG75wBA;EACE,gBAAA;AHg6wBF;;AG95wBA;EACE,gBAAA;AHi6wBF;;AG/5wBA;EACE,gBAAA;AHk6wBF;;AGh6wBA;EACE,gBAAA;AHm6wBF;;AGj6wBA;EACE,gBAAA;AHo6wBF;;AGl6wBA;EACE,gBAAA;AHq6wBF;;AGn6wBA;EACE,gBAAA;AHs6wBF;;AGp6wBA;EACE,gBAAA;AHu6wBF;;AGr6wBA;EACE,gBAAA;AHw6wBF;;AGt6wBA;EACE,gBAAA;AHy6wBF;;AGv6wBA;EACE,gBAAA;AH06wBF;;AGx6wBA;EACE,gBAAA;AH26wBF;;AGz6wBA;EACE,gBAAA;AH46wBF;;AG16wBA;EACE,gBAAA;AH66wBF;;AG36wBA;EACE,gBAAA;AH86wBF;;AG56wBA;EACE,gBAAA;AH+6wBF;;AG76wBA;EACE,gBAAA;AHg7wBF;;AG96wBA;EACE,gBAAA;AHi7wBF;;AG/6wBA;EACE,gBAAA;AHk7wBF;;AGh7wBA;EACE,gBAAA;AHm7wBF;;AGj7wBA;EACE,gBAAA;AHo7wBF;;AGl7wBA;EACE,gBAAA;AHq7wBF;;AGn7wBA;EACE,gBAAA;AHs7wBF;;AGp7wBA;EACE,gBAAA;AHu7wBF;;AGr7wBA;EACE,gBAAA;AHw7wBF;;AGt7wBA;EACE,gBAAA;AHy7wBF;;AGv7wBA;EACE,gBAAA;AH07wBF;;AGx7wBA;EACE,gBAAA;AH27wBF;;AGz7wBA;EACE,gBAAA;AH47wBF;;AG17wBA;EACE,gBAAA;AH67wBF;;AG37wBA;EACE,gBAAA;AH87wBF;;AG57wBA;EACE,gBAAA;AH+7wBF;;AG77wBA;EACE,gBAAA;AHg8wBF;;AG97wBA;EACE,gBAAA;AHi8wBF;;AG/7wBA;EACE,gBAAA;AHk8wBF;;AGh8wBA;EACE,gBAAA;AHm8wBF;;AGj8wBA;EACE,gBAAA;AHo8wBF;;AGl8wBA;EACE,gBAAA;AHq8wBF;;AGn8wBA;EACE,gBAAA;AHs8wBF;;AGp8wBA;EACE,gBAAA;AHu8wBF;;AGr8wBA;EACE,gBAAA;AHw8wBF;;AGt8wBA;EACE,gBAAA;AHy8wBF;;AGv8wBA;EACE,gBAAA;AH08wBF;;AGx8wBA;EACE,gBAAA;AH28wBF;;AGz8wBA;EACE,gBAAA;AH48wBF;;AG18wBA;EACE,gBAAA;AH68wBF;;AG38wBA;EACE,gBAAA;AH88wBF;;AG58wBA;EACE,gBAAA;AH+8wBF;;AG78wBA;EACE,gBAAA;AHg9wBF;;AG98wBA;EACE,gBAAA;AHi9wBF;;AG/8wBA;EACE,gBAAA;AHk9wBF;;AGh9wBA;EACE,gBAAA;AHm9wBF;;AGj9wBA;EACE,gBAAA;AHo9wBF;;AGl9wBA;EACE,gBAAA;AHq9wBF;;AGn9wBA;EACE,gBAAA;AHs9wBF;;AGp9wBA;EACE,gBAAA;AHu9wBF;;AGr9wBA;EACE,gBAAA;AHw9wBF;;AGt9wBA;EACE,gBAAA;AHy9wBF;;AGv9wBA;EACE,gBAAA;AH09wBF;;AGx9wBA;EACE,gBAAA;AH29wBF;;AGz9wBA;EACE,gBAAA;AH49wBF;;AG19wBA;EACE,gBAAA;AH69wBF;;AG39wBA;EACE,gBAAA;AH89wBF;;AG59wBA;EACE,gBAAA;AH+9wBF;;AG79wBA;EACE,gBAAA;AHg+wBF;;AG99wBA;EACE,gBAAA;AHi+wBF;;AG/9wBA;EACE,gBAAA;AHk+wBF;;AGh+wBA;EACE,gBAAA;AHm+wBF;;AGj+wBA;EACE,gBAAA;AHo+wBF;;AGl+wBA;EACE,YAAA;AHq+wBF;;AGn+wBA;EACE,gBAAA;AHs+wBF;;AGp+wBA;EACE,gBAAA;AHu+wBF;;AGr+wBA;EACE,gBAAA;AHw+wBF;;AGt+wBA;EACE,gBAAA;AHy+wBF;;AGv+wBA;EACE,gBAAA;AH0+wBF;;AGx+wBA;EACE,gBAAA;AH2+wBF;;AGz+wBA;EACE,gBAAA;AH4+wBF;;AG1+wBA;EACE,gBAAA;AH6+wBF;;AG3+wBA;EACE,gBAAA;AH8+wBF;;AG5+wBA;EACE,gBAAA;AH++wBF;;AG7+wBA;EACE,gBAAA;AHg/wBF;;AG9+wBA;EACE,gBAAA;AHi/wBF;;AG/+wBA;EACE,gBAAA;AHk/wBF;;AGh/wBA;EACE,gBAAA;AHm/wBF;;AGj/wBA;EACE,gBAAA;AHo/wBF;;AGl/wBA;EACE,gBAAA;AHq/wBF;;AGn/wBA;EACE,gBAAA;AHs/wBF;;AGp/wBA;EACE,gBAAA;AHu/wBF;;AGr/wBA;EACE,gBAAA;AHw/wBF;;AGt/wBA;EACE,gBAAA;AHy/wBF;;AGv/wBA;EACE,gBAAA;AH0/wBF;;AGx/wBA;EACE,YAAA;AH2/wBF;;AGz/wBA;EACE,gBAAA;AH4/wBF;;AG1/wBA;EACE,gBAAA;AH6/wBF;;AG3/wBA;EACE,gBAAA;AH8/wBF;;AG5/wBA;EACE,gBAAA;AH+/wBF;;AG7/wBA;EACE,gBAAA;AHggxBF;;AG9/wBA;EACE,gBAAA;AHigxBF;;AG//wBA;EACE,gBAAA;AHkgxBF;;AGhgxBA;EACE,gBAAA;AHmgxBF;;AGjgxBA;EACE,gBAAA;AHogxBF;;AGlgxBA;EACE,gBAAA;AHqgxBF;;AGngxBA;EACE,YAAA;AHsgxBF;;AGpgxBA;EACE,gBAAA;AHugxBF;;AGrgxBA;EACE,gBAAA;AHwgxBF;;AGtgxBA;EACE,gBAAA;AHygxBF;;AGvgxBA;EACE,gBAAA;AH0gxBF;;AGxgxBA;EACE,gBAAA;AH2gxBF;;AGzgxBA;EACE,gBAAA;AH4gxBF;;AG1gxBA;EACE,gBAAA;AH6gxBF;;AG3gxBA;EACE,gBAAA;AH8gxBF;;AG5gxBA;EACE,gBAAA;AH+gxBF;;AG7gxBA;EACE,gBAAA;AHghxBF;;AG9gxBA;EACE,gBAAA;AHihxBF;;AG/gxBA;EACE,gBAAA;AHkhxBF;;AGhhxBA;EACE,gBAAA;AHmhxBF;;AGjhxBA;EACE,gBAAA;AHohxBF;;AGlhxBA;EACE,gBAAA;AHqhxBF;;AGnhxBA;EACE,gBAAA;AHshxBF;;AGphxBA;EACE,gBAAA;AHuhxBF;;AGrhxBA;EACE,gBAAA;AHwhxBF;;AGthxBA;EACE,gBAAA;AHyhxBF;;AGvhxBA;EACE,gBAAA;AH0hxBF;;AGxhxBA;EACE,gBAAA;AH2hxBF;;AGzhxBA;EACE,gBAAA;AH4hxBF;;AG1hxBA;EACE,gBAAA;AH6hxBF;;AG3hxBA;EACE,gBAAA;AH8hxBF;;AG5hxBA;EACE,gBAAA;AH+hxBF;;AG7hxBA;EACE,YAAA;AHgixBF;;AG9hxBA;EACE,YAAA;AHiixBF;;AG/hxBA;EACE,gBAAA;AHkixBF;;AGhixBA;EACE,gBAAA;AHmixBF;;AGjixBA;EACE,gBAAA;AHoixBF;;AGlixBA;EACE,gBAAA;AHqixBF;;AGnixBA;EACE,gBAAA;AHsixBF;;AGpixBA;EACE,gBAAA;AHuixBF;;AGrixBA;EACE,gBAAA;AHwixBF;;AGtixBA;EACE,gBAAA;AHyixBF;;AGvixBA;EACE,gBAAA;AH0ixBF;;AGxixBA;EACE,gBAAA;AH2ixBF;;AGzixBA;EACE,gBAAA;AH4ixBF;;AG1ixBA;EACE,gBAAA;AH6ixBF;;AG3ixBA;EACE,gBAAA;AH8ixBF;;AG5ixBA;EACE,gBAAA;AH+ixBF;;AG7ixBA;EACE,gBAAA;AHgjxBF;;AG9ixBA;EACE,gBAAA;AHijxBF;;AG/ixBA;EACE,gBAAA;AHkjxBF;;AGhjxBA;EACE,gBAAA;AHmjxBF;;AGjjxBA;EACE,gBAAA;AHojxBF;;AGljxBA;EACE,gBAAA;AHqjxBF;;AGnjxBA;EACE,gBAAA;AHsjxBF;;AGpjxBA;EACE,gBAAA;AHujxBF;;AGrjxBA;EACE,gBAAA;AHwjxBF;;AGtjxBA;EACE,gBAAA;AHyjxBF;;AGvjxBA;EACE,gBAAA;AH0jxBF;;AGxjxBA;EACE,gBAAA;AH2jxBF;;AGzjxBA;EACE,gBAAA;AH4jxBF;;AG1jxBA;EACE,gBAAA;AH6jxBF;;AG3jxBA;EACE,gBAAA;AH8jxBF;;AG5jxBA;EACE,gBAAA;AH+jxBF;;AG7jxBA;EACE,gBAAA;AHgkxBF;;AG9jxBA;EACE,gBAAA;AHikxBF;;AG/jxBA;EACE,gBAAA;AHkkxBF;;AGhkxBA;EACE,gBAAA;AHmkxBF;;AGjkxBA;EACE,gBAAA;AHokxBF;;AGlkxBA;EACE,gBAAA;AHqkxBF;;AGnkxBA;EACE,gBAAA;AHskxBF;;AGpkxBA;EACE,gBAAA;AHukxBF;;AGrkxBA;EACE,gBAAA;AHwkxBF;;AGtkxBA;EACE,gBAAA;AHykxBF;;AGvkxBA;EACE,gBAAA;AH0kxBF;;AGxkxBA;EACE,gBAAA;AH2kxBF;;AGzkxBA;EACE,gBAAA;AH4kxBF;;AG1kxBA;EACE,gBAAA;AH6kxBF;;AG3kxBA;EACE,gBAAA;AH8kxBF;;AG5kxBA;EACE,gBAAA;AH+kxBF;;AG7kxBA;EACE,gBAAA;AHglxBF;;AG9kxBA;EACE,gBAAA;AHilxBF;;AG/kxBA;EACE,gBAAA;AHklxBF;;AGhlxBA;EACE,gBAAA;AHmlxBF;;AGjlxBA;EACE,gBAAA;AHolxBF;;AGllxBA;EACE,gBAAA;AHqlxBF;;AGnlxBA;EACE,gBAAA;AHslxBF;;AGplxBA;EACE,gBAAA;AHulxBF;;AGrlxBA;EACE,gBAAA;AHwlxBF;;AGtlxBA;EACE,gBAAA;AHylxBF;;AGvlxBA;EACE,gBAAA;AH0lxBF;;AGxlxBA;EACE,gBAAA;AH2lxBF;;AGzlxBA;EACE,gBAAA;AH4lxBF;;AG1lxBA;EACE,gBAAA;AH6lxBF;;AG3lxBA;EACE,gBAAA;AH8lxBF;;AG5lxBA;EACE,gBAAA;AH+lxBF;;AG7lxBA;EACE,gBAAA;AHgmxBF;;AG9lxBA;EACE,gBAAA;AHimxBF;;AG/lxBA;EACE,gBAAA;AHkmxBF;;AGhmxBA;EACE,gBAAA;AHmmxBF;;AGjmxBA;EACE,gBAAA;AHomxBF;;AGlmxBA;EACE,gBAAA;AHqmxBF;;AGnmxBA;EACE,gBAAA;AHsmxBF;;AGpmxBA;EACE,gBAAA;AHumxBF;;AGrmxBA;EACE,gBAAA;AHwmxBF;;AGtmxBA;EACE,gBAAA;AHymxBF;;AGvmxBA;EACE,gBAAA;AH0mxBF;;AGxmxBA;EACE,gBAAA;AH2mxBF;;AGzmxBA;EACE,gBAAA;AH4mxBF;;AG1mxBA;EACE,gBAAA;AH6mxBF;;AG3mxBA;EACE,gBAAA;AH8mxBF;;AG5mxBA;EACE,gBAAA;AH+mxBF;;AG7mxBA;EACE,gBAAA;AHgnxBF;;AG9mxBA;EACE,gBAAA;AHinxBF;;AG/mxBA;EACE,gBAAA;AHknxBF;;AGhnxBA;EACE,gBAAA;AHmnxBF;;AGjnxBA;EACE,gBAAA;AHonxBF;;AGlnxBA;EACE,gBAAA;AHqnxBF;;AGnnxBA;EACE,gBAAA;AHsnxBF;;AGpnxBA;EACE,gBAAA;AHunxBF;;AGrnxBA;EACE,gBAAA;AHwnxBF;;AGtnxBA;EACE,gBAAA;AHynxBF;;AGvnxBA;EACE,gBAAA;AH0nxBF;;AGxnxBA;EACE,gBAAA;AH2nxBF;;AGznxBA;EACE,gBAAA;AH4nxBF;;AG1nxBA;EACE,gBAAA;AH6nxBF;;AG3nxBA;EACE,gBAAA;AH8nxBF;;AG5nxBA;EACE,gBAAA;AH+nxBF;;AG7nxBA;EACE,gBAAA;AHgoxBF;;AG9nxBA;EACE,YAAA;AHioxBF;;AG/nxBA;EACE,gBAAA;AHkoxBF;;AGhoxBA;EACE,gBAAA;AHmoxBF;;AGjoxBA;EACE,gBAAA;AHooxBF;;AGloxBA;EACE,gBAAA;AHqoxBF;;AGnoxBA;EACE,YAAA;AHsoxBF;;AGpoxBA;EACE,gBAAA;AHuoxBF;;AGroxBA;EACE,gBAAA;AHwoxBF;;AGtoxBA;EACE,gBAAA;AHyoxBF;;AGvoxBA;EACE,gBAAA;AH0oxBF;;AGxoxBA;EACE,gBAAA;AH2oxBF;;AGzoxBA;EACE,gBAAA;AH4oxBF;;AG1oxBA;EACE,gBAAA;AH6oxBF;;AG3oxBA;EACE,gBAAA;AH8oxBF;;AG5oxBA;EACE,gBAAA;AH+oxBF;;AG7oxBA;EACE,gBAAA;AHgpxBF;;AG9oxBA;EACE,gBAAA;AHipxBF;;AG/oxBA;EACE,gBAAA;AHkpxBF;;AGhpxBA;EACE,gBAAA;AHmpxBF;;AGjpxBA;EACE,gBAAA;AHopxBF;;AGlpxBA;EACE,gBAAA;AHqpxBF;;AGnpxBA;EACE,gBAAA;AHspxBF;;AGppxBA;EACE,gBAAA;AHupxBF;;AGrpxBA;EACE,gBAAA;AHwpxBF;;AGtpxBA;EACE,gBAAA;AHypxBF;;AGvpxBA;EACE,gBAAA;AH0pxBF;;AGxpxBA;EACE,gBAAA;AH2pxBF;;AGzpxBA;EACE,gBAAA;AH4pxBF;;AG1pxBA;EACE,gBAAA;AH6pxBF;;AG3pxBA;EACE,gBAAA;AH8pxBF;;AG5pxBA;EACE,gBAAA;AH+pxBF;;AG7pxBA;EACE,gBAAA;AHgqxBF;;AG9pxBA;EACE,gBAAA;AHiqxBF;;AG/pxBA;EACE,gBAAA;AHkqxBF;;AGhqxBA;EACE,gBAAA;AHmqxBF;;AGjqxBA;EACE,gBAAA;AHoqxBF;;AGlqxBA;EACE,gBAAA;AHqqxBF;;AGnqxBA;EACE,gBAAA;AHsqxBF;;AGpqxBA;EACE,gBAAA;AHuqxBF;;AGrqxBA;EACE,gBAAA;AHwqxBF;;AGtqxBA;EACE,gBAAA;AHyqxBF;;AGvqxBA;EACE,gBAAA;AH0qxBF;;AGxqxBA;EACE,gBAAA;AH2qxBF;;AGzqxBA;EACE,gBAAA;AH4qxBF;;AG1qxBA;EACE,gBAAA;AH6qxBF;;AG3qxBA;EACE,gBAAA;AH8qxBF;;AG5qxBA;EACE,gBAAA;AH+qxBF;;AG7qxBA;EACE,gBAAA;AHgrxBF;;AG9qxBA;EACE,gBAAA;AHirxBF;;AG/qxBA;EACE,gBAAA;AHkrxBF;;AGhrxBA;EACE,gBAAA;AHmrxBF;;AGjrxBA;EACE,YAAA;AHorxBF;;AGlrxBA;EACE,gBAAA;AHqrxBF;;AGnrxBA;EACE,gBAAA;AHsrxBF;;AGprxBA;EACE,gBAAA;AHurxBF;;AGrrxBA;EACE,gBAAA;AHwrxBF;;AGtrxBA;EACE,gBAAA;AHyrxBF;;AGvrxBA;EACE,gBAAA;AH0rxBF;;AGxrxBA;EACE,gBAAA;AH2rxBF;;AGzrxBA;EACE,gBAAA;AH4rxBF;;AG1rxBA;EACE,gBAAA;AH6rxBF;;AG3rxBA;EACE,gBAAA;AH8rxBF;;AG5rxBA;EACE,gBAAA;AH+rxBF;;AG7rxBA;EACE,gBAAA;AHgsxBF;;AG9rxBA;EACE,gBAAA;AHisxBF;;AG/rxBA;EACE,gBAAA;AHksxBF;;AGhsxBA;EACE,gBAAA;AHmsxBF;;AGjsxBA;EACE,gBAAA;AHosxBF;;AGlsxBA;EACE,gBAAA;AHqsxBF;;AGnsxBA;EACE,gBAAA;AHssxBF;;AGpsxBA;EACE,gBAAA;AHusxBF;;AGrsxBA;EACE,gBAAA;AHwsxBF;;AGtsxBA;EACE,gBAAA;AHysxBF;;AGvsxBA;EACE,gBAAA;AH0sxBF;;AGxsxBA;EACE,gBAAA;AH2sxBF;;AGzsxBA;EACE,gBAAA;AH4sxBF;;AG1sxBA;EACE,gBAAA;AH6sxBF;;AG3sxBA;EACE,gBAAA;AH8sxBF;;AG5sxBA;EACE,gBAAA;AH+sxBF;;AG7sxBA;EACE,gBAAA;AHgtxBF;;AG9sxBA;EACE,gBAAA;AHitxBF;;AG/sxBA;EACE,gBAAA;AHktxBF;;AGhtxBA;EACE,gBAAA;AHmtxBF;;AGjtxBA;EACE,gBAAA;AHotxBF;;AGltxBA;EACE,gBAAA;AHqtxBF;;AGntxBA;EACE,gBAAA;AHstxBF;;AGptxBA;EACE,gBAAA;AHutxBF;;AGrtxBA;EACE,gBAAA;AHwtxBF;;AGttxBA;EACE,gBAAA;AHytxBF;;AGvtxBA;EACE,gBAAA;AH0txBF;;AGxtxBA;EACE,gBAAA;AH2txBF;;AGztxBA;EACE,gBAAA;AH4txBF;;AG1txBA;EACE,gBAAA;AH6txBF;;AG3txBA;EACE,gBAAA;AH8txBF;;AG5txBA;EACE,gBAAA;AH+txBF;;AG7txBA;EACE,gBAAA;AHguxBF;;AG9txBA;EACE,gBAAA;AHiuxBF;;AG/txBA;EACE,gBAAA;AHkuxBF;;AGhuxBA;EACE,gBAAA;AHmuxBF;;AGjuxBA;EACE,gBAAA;AHouxBF;;AGluxBA;EACE,gBAAA;AHquxBF;;AGnuxBA;EACE,gBAAA;AHsuxBF;;AGpuxBA;EACE,gBAAA;AHuuxBF;;AGruxBA;EACE,gBAAA;AHwuxBF;;AGtuxBA;EACE,gBAAA;AHyuxBF;;AGvuxBA;EACE,gBAAA;AH0uxBF;;AGxuxBA;EACE,gBAAA;AH2uxBF;;AGzuxBA;EACE,YAAA;AH4uxBF;;AG1uxBA;EACE,gBAAA;AH6uxBF;;AG3uxBA;EACE,gBAAA;AH8uxBF;;AG5uxBA;EACE,YAAA;AH+uxBF;;AG7uxBA;EACE,YAAA;AHgvxBF;;AG9uxBA;EACE,gBAAA;AHivxBF;;AG/uxBA;EACE,gBAAA;AHkvxBF;;AGhvxBA;EACE,gBAAA;AHmvxBF;;AGjvxBA;EACE,gBAAA;AHovxBF;;AGlvxBA;EACE,gBAAA;AHqvxBF;;AGnvxBA;EACE,gBAAA;AHsvxBF;;AGpvxBA;EACE,gBAAA;AHuvxBF;;AGrvxBA;EACE,gBAAA;AHwvxBF;;AGtvxBA;EACE,gBAAA;AHyvxBF;;AGvvxBA;EACE,gBAAA;AH0vxBF;;AGxvxBA;EACE,gBAAA;AH2vxBF;;AGzvxBA;EACE,gBAAA;AH4vxBF;;AG1vxBA;EACE,gBAAA;AH6vxBF;;AG3vxBA;EACE,gBAAA;AH8vxBF;;AG5vxBA;EACE,gBAAA;AH+vxBF;;AG7vxBA;EACE,gBAAA;AHgwxBF;;AG9vxBA;EACE,gBAAA;AHiwxBF;;AG/vxBA;EACE,gBAAA;AHkwxBF;;AGhwxBA;EACE,gBAAA;AHmwxBF;;AGjwxBA;EACE,gBAAA;AHowxBF;;AGlwxBA;EACE,gBAAA;AHqwxBF;;AGnwxBA;EACE,gBAAA;AHswxBF;;AGpwxBA;EACE,gBAAA;AHuwxBF;;AGrwxBA;EACE,gBAAA;AHwwxBF;;AGtwxBA;EACE,gBAAA;AHywxBF;;AGvwxBA;EACE,gBAAA;AH0wxBF;;AGxwxBA;EACE,gBAAA;AH2wxBF;;AGzwxBA;EACE,gBAAA;AH4wxBF;;AG1wxBA;EACE,gBAAA;AH6wxBF;;AG3wxBA;EACE,gBAAA;AH8wxBF;;AG5wxBA;EACE,gBAAA;AH+wxBF;;AG7wxBA;EACE,gBAAA;AHgxxBF;;AG9wxBA;EACE,gBAAA;AHixxBF;;AG/wxBA;EACE,gBAAA;AHkxxBF;;AGhxxBA;EACE,gBAAA;AHmxxBF;;AGjxxBA;EACE,gBAAA;AHoxxBF;;AGlxxBA;EACE,gBAAA;AHqxxBF;;AGnxxBA;EACE,gBAAA;AHsxxBF;;AGpxxBA;EACE,gBAAA;AHuxxBF;;AGrxxBA;EACE,gBAAA;AHwxxBF;;AGtxxBA;EACE,gBAAA;AHyxxBF;;AGvxxBA;EACE,gBAAA;AH0xxBF;;AGxxxBA;EACE,gBAAA;AH2xxBF;;AGzxxBA;EACE,gBAAA;AH4xxBF;;AG1xxBA;EACE,gBAAA;AH6xxBF;;AG3xxBA;EACE,gBAAA;AH8xxBF;;AG5xxBA;EACE,gBAAA;AH+xxBF;;AG7xxBA;EACE,gBAAA;AHgyxBF;;AG9xxBA;EACE,gBAAA;AHiyxBF;;AG/xxBA;EACE,gBAAA;AHkyxBF;;AGhyxBA;EACE,gBAAA;AHmyxBF;;AGjyxBA;EACE,gBAAA;AHoyxBF;;AGlyxBA;EACE,gBAAA;AHqyxBF;;AGnyxBA;EACE,gBAAA;AHsyxBF;;AGpyxBA;EACE,gBAAA;AHuyxBF;;AGryxBA;EACE,gBAAA;AHwyxBF;;AGtyxBA;EACE,gBAAA;AHyyxBF;;AGvyxBA;EACE,gBAAA;AH0yxBF;;AGxyxBA;EACE,gBAAA;AH2yxBF;;AGzyxBA;EACE,gBAAA;AH4yxBF;;AG1yxBA;EACE,gBAAA;AH6yxBF;;AG3yxBA;EACE,gBAAA;AH8yxBF;;AG5yxBA;EACE,gBAAA;AH+yxBF;;AG7yxBA;EACE,gBAAA;AHgzxBF;;AG9yxBA;EACE,gBAAA;AHizxBF;;AG/yxBA;EACE,gBAAA;AHkzxBF;;AGhzxBA;EACE,gBAAA;AHmzxBF;;AGjzxBA;EACE,gBAAA;AHozxBF;;AGlzxBA;EACE,gBAAA;AHqzxBF;;AGnzxBA;EACE,gBAAA;AHszxBF;;AGpzxBA;EACE,gBAAA;AHuzxBF;;AGrzxBA;EACE,gBAAA;AHwzxBF;;AGtzxBA;EACE,gBAAA;AHyzxBF;;AGvzxBA;EACE,gBAAA;AH0zxBF;;AGxzxBA;EACE,gBAAA;AH2zxBF;;AGzzxBA;EACE,gBAAA;AH4zxBF;;AG1zxBA;EACE,gBAAA;AH6zxBF;;AG3zxBA;EACE,gBAAA;AH8zxBF;;AG5zxBA;EACE,gBAAA;AH+zxBF;;AG7zxBA;EACE,YAAA;AHg0xBF;;AG9zxBA;EACE,gBAAA;AHi0xBF;;AG/zxBA;EACE,gBAAA;AHk0xBF;;AGh0xBA;EACE,gBAAA;AHm0xBF;;AGj0xBA;EACE,gBAAA;AHo0xBF;;AGl0xBA;EACE,gBAAA;AHq0xBF;;AGn0xBA;EACE,gBAAA;AHs0xBF;;AGp0xBA;EACE,gBAAA;AHu0xBF;;AGr0xBA;EACE,gBAAA;AHw0xBF;;AGt0xBA;EACE,gBAAA;AHy0xBF;;AGv0xBA;EACE,YAAA;AH00xBF;;AGx0xBA;EACE,gBAAA;AH20xBF;;AGz0xBA;EACE,gBAAA;AH40xBF;;AG10xBA;EACE,gBAAA;AH60xBF;;AG30xBA;EACE,gBAAA;AH80xBF;;AG50xBA;EACE,gBAAA;AH+0xBF;;AG70xBA;EACE,gBAAA;AHg1xBF;;AG90xBA;EACE,gBAAA;AHi1xBF;;AG/0xBA;EACE,gBAAA;AHk1xBF;;AGh1xBA;EACE,gBAAA;AHm1xBF;;AGj1xBA;EACE,gBAAA;AHo1xBF;;AGl1xBA;EACE,gBAAA;AHq1xBF;;AGn1xBA;EACE,gBAAA;AHs1xBF;;AGp1xBA;EACE,gBAAA;AHu1xBF;;AGr1xBA;EACE,gBAAA;AHw1xBF;;AGt1xBA;EACE,gBAAA;AHy1xBF;;AGv1xBA;EACE,gBAAA;AH01xBF;;AGx1xBA;EACE,gBAAA;AH21xBF;;AGz1xBA;EACE,gBAAA;AH41xBF;;AG11xBA;EACE,gBAAA;AH61xBF;;AG31xBA;EACE,gBAAA;AH81xBF;;AG51xBA;EACE,gBAAA;AH+1xBF;;AG71xBA;EACE,gBAAA;AHg2xBF;;AG91xBA;EACE,gBAAA;AHi2xBF;;AG/1xBA;EACE,gBAAA;AHk2xBF;;AGh2xBA;EACE,gBAAA;AHm2xBF;;AGj2xBA;EACE,gBAAA;AHo2xBF;;AGl2xBA;EACE,gBAAA;AHq2xBF;;AGn2xBA;EACE,gBAAA;AHs2xBF;;AGp2xBA;EACE,gBAAA;AHu2xBF;;AGr2xBA;EACE,gBAAA;AHw2xBF;;AGt2xBA;EACE,gBAAA;AHy2xBF;;AGv2xBA;EACE,gBAAA;AH02xBF;;AGx2xBA;EACE,gBAAA;AH22xBF;;AGz2xBA;EACE,gBAAA;AH42xBF;;AG12xBA;EACE,gBAAA;AH62xBF;;AG32xBA;EACE,gBAAA;AH82xBF;;AG52xBA;EACE,YAAA;AH+2xBF;;AG72xBA;EACE,gBAAA;AHg3xBF;;AG92xBA;EACE,gBAAA;AHi3xBF;;AG/2xBA;EACE,gBAAA;AHk3xBF;;AGh3xBA;EACE,gBAAA;AHm3xBF;;AGj3xBA;EACE,gBAAA;AHo3xBF;;AGl3xBA;EACE,gBAAA;AHq3xBF;;AGn3xBA;EACE,gBAAA;AHs3xBF;;AGp3xBA;EACE,gBAAA;AHu3xBF;;AGr3xBA;EACE,gBAAA;AHw3xBF;;AGt3xBA;EACE,gBAAA;AHy3xBF;;AGv3xBA;EACE,gBAAA;AH03xBF;;AGx3xBA;EACE,gBAAA;AH23xBF;;AGz3xBA;EACE,gBAAA;AH43xBF;;AG13xBA;EACE,gBAAA;AH63xBF;;AG33xBA;EACE,gBAAA;AH83xBF;;AG53xBA;EACE,gBAAA;AH+3xBF;;AG73xBA;EACE,gBAAA;AHg4xBF;;AG93xBA;EACE,gBAAA;AHi4xBF;;AG/3xBA;EACE,gBAAA;AHk4xBF;;AGh4xBA;EACE,gBAAA;AHm4xBF;;AGj4xBA;EACE,gBAAA;AHo4xBF;;AGl4xBA;EACE,gBAAA;AHq4xBF;;AGn4xBA;EACE,gBAAA;AHs4xBF;;AGp4xBA;EACE,gBAAA;AHu4xBF;;AGr4xBA;EACE,gBAAA;AHw4xBF;;AGt4xBA;EACE,gBAAA;AHy4xBF;;AGv4xBA;EACE,gBAAA;AH04xBF;;AGx4xBA;EACE,gBAAA;AH24xBF;;AGz4xBA;EACE,gBAAA;AH44xBF;;AG14xBA;EACE,gBAAA;AH64xBF;;AG34xBA;EACE,gBAAA;AH84xBF;;AG54xBA;EACE,gBAAA;AH+4xBF;;AG74xBA;EACE,gBAAA;AHg5xBF;;AG94xBA;EACE,gBAAA;AHi5xBF;;AG/4xBA;EACE,gBAAA;AHk5xBF;;AGh5xBA;EACE,gBAAA;AHm5xBF;;AGj5xBA;EACE,gBAAA;AHo5xBF;;AGl5xBA;EACE,gBAAA;AHq5xBF;;AGn5xBA;EACE,gBAAA;AHs5xBF;;AGp5xBA;EACE,gBAAA;AHu5xBF;;AGr5xBA;EACE,gBAAA;AHw5xBF;;AGt5xBA;EACE,gBAAA;AHy5xBF;;AGv5xBA;EACE,gBAAA;AH05xBF;;AGx5xBA;EACE,gBAAA;AH25xBF;;AGz5xBA;EACE,gBAAA;AH45xBF;;AG15xBA;EACE,gBAAA;AH65xBF;;AG35xBA;EACE,gBAAA;AH85xBF;;AG55xBA;EACE,gBAAA;AH+5xBF;;AG75xBA;EACE,gBAAA;AHg6xBF;;AG95xBA;EACE,gBAAA;AHi6xBF;;AG/5xBA;EACE,gBAAA;AHk6xBF;;AGh6xBA;EACE,gBAAA;AHm6xBF;;AGj6xBA;EACE,gBAAA;AHo6xBF;;AGl6xBA;EACE,gBAAA;AHq6xBF;;AGn6xBA;EACE,gBAAA;AHs6xBF;;AGp6xBA;EACE,gBAAA;AHu6xBF;;AGr6xBA;EACE,gBAAA;AHw6xBF;;AGt6xBA;EACE,YAAA;AHy6xBF;;AGv6xBA;EACE,YAAA;AH06xBF;;AGx6xBA;EACE,YAAA;AH26xBF;;AGz6xBA;EACE,gBAAA;AH46xBF;;AG16xBA;EACE,gBAAA;AH66xBF;;AG36xBA;EACE,gBAAA;AH86xBF;;AG56xBA;EACE,gBAAA;AH+6xBF;;AG76xBA;EACE,gBAAA;AHg7xBF;;AG96xBA;EACE,gBAAA;AHi7xBF;;AG/6xBA;EACE,gBAAA;AHk7xBF;;AGh7xBA;EACE,gBAAA;AHm7xBF;;AGj7xBA;EACE,gBAAA;AHo7xBF;;AGl7xBA;EACE,gBAAA;AHq7xBF;;AGn7xBA;EACE,gBAAA;AHs7xBF;;AGp7xBA;EACE,gBAAA;AHu7xBF;;AGr7xBA;EACE,gBAAA;AHw7xBF;;AGt7xBA;EACE,gBAAA;AHy7xBF;;AGv7xBA;EACE,gBAAA;AH07xBF;;AGx7xBA;EACE,gBAAA;AH27xBF;;AGz7xBA;EACE,gBAAA;AH47xBF;;AG17xBA;EACE,gBAAA;AH67xBF;;AG37xBA;EACE,gBAAA;AH87xBF;;AG57xBA;EACE,gBAAA;AH+7xBF;;AG77xBA;EACE,gBAAA;AHg8xBF;;AG97xBA;EACE,gBAAA;AHi8xBF;;AG/7xBA;EACE,gBAAA;AHk8xBF;;AGh8xBA;EACE,gBAAA;AHm8xBF;;AGj8xBA;EACE,gBAAA;AHo8xBF;;AGl8xBA;EACE,gBAAA;AHq8xBF;;AGn8xBA;EACE,gBAAA;AHs8xBF;;AGp8xBA;EACE,gBAAA;AHu8xBF;;AGr8xBA;EACE,gBAAA;AHw8xBF;;AGt8xBA;EACE,gBAAA;AHy8xBF;;AGv8xBA;EACE,gBAAA;AH08xBF;;AGx8xBA;EACE,gBAAA;AH28xBF;;AGz8xBA;EACE,gBAAA;AH48xBF;;AG18xBA;EACE,gBAAA;AH68xBF;;AG38xBA;EACE,gBAAA;AH88xBF;;AG58xBA;EACE,gBAAA;AH+8xBF;;AG78xBA;EACE,gBAAA;AHg9xBF;;AG98xBA;EACE,gBAAA;AHi9xBF;;AG/8xBA;EACE,gBAAA;AHk9xBF;;AGh9xBA;EACE,gBAAA;AHm9xBF;;AGj9xBA;EACE,gBAAA;AHo9xBF;;AGl9xBA;EACE,gBAAA;AHq9xBF;;AGn9xBA;EACE,gBAAA;AHs9xBF;;AGp9xBA;EACE,gBAAA;AHu9xBF;;AGr9xBA;EACE,gBAAA;AHw9xBF;;AGt9xBA;EACE,gBAAA;AHy9xBF;;AGv9xBA;EACE,gBAAA;AH09xBF;;AGx9xBA;EACE,gBAAA;AH29xBF;;AGz9xBA;EACE,gBAAA;AH49xBF;;AG19xBA;EACE,gBAAA;AH69xBF;;AG39xBA;EACE,gBAAA;AH89xBF;;AG59xBA;EACE,gBAAA;AH+9xBF;;AG79xBA;EACE,gBAAA;AHg+xBF;;AG99xBA;EACE,gBAAA;AHi+xBF;;AG/9xBA;EACE,gBAAA;AHk+xBF;;AGh+xBA;EACE,gBAAA;AHm+xBF;;AGj+xBA;EACE,gBAAA;AHo+xBF;;AGl+xBA;EACE,gBAAA;AHq+xBF;;AGn+xBA;EACE,gBAAA;AHs+xBF;;AGp+xBA;EACE,gBAAA;AHu+xBF;;AGr+xBA;EACE,gBAAA;AHw+xBF;;AGt+xBA;EACE,gBAAA;AHy+xBF;;AGv+xBA;EACE,gBAAA;AH0+xBF;;AGx+xBA;EACE,gBAAA;AH2+xBF;;AGz+xBA;EACE,gBAAA;AH4+xBF;;AG1+xBA;EACE,SAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AH6+xBF;;AG3+xBA;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AH8+xBF;;AG7+xBA;EACE,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,6SAAA;AHg/xBF;AG9+xBA;EACE,oCAAA;EACA,gBAAA;AHg/xBF;;AG/+xBA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,iTAAA;AHk/xBF;AGh/xBA;EACE,kCAAA;EACA,gBAAA;AHk/xBF;;AGj/xBA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,iTAAA;AHo/xBF;AGl/xBA;;EAEE,kCAAA;EACA,gBAAA;AHo/xBF;;AI776BA;EACE,2BAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;AJ676BF;AIz76BA;EACE,sCAAA;EACA,wBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,+BAAA;EACA,WAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;AJ276BF;;AIx76BA;;EAEE,sCAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,+BAAA;EACA,WAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;AJ276BF;;AIx76BA;EACE,YAAA;AJ276BF;;AIz76BA;EACE,YAAA;AJ476BF;;AI176BA;EACE,YAAA;AJ676BF;;AI376BA;EACE,YAAA;AJ876BF;;AI576BA;EACE,YAAA;AJ+76BF;;AI776BA;EACE,YAAA;AJg86BF;;AI976BA;EACE,YAAA;AJi86BF;;AI/76BA;EACE,YAAA;AJk86BF;;AIh86BA;EACE,YAAA;AJm86BF;;AIj86BA;EACE,YAAA;AJo86BF;;AIl86BA;EACE,YAAA;AJq86BF;;AIn86BA;EACE,YAAA;AJs86BF;;AIp86BA;EACE,YAAA;AJu86BF;;AIr86BA;EACE,YAAA;AJw86BF;;AIt86BA;EACE,YAAA;AJy86BF;;AIv86BA;EACE,YAAA;AJ086BF;;AIx86BA;EACE,YAAA;AJ286BF;;AIz86BA;EACE,YAAA;AJ486BF;;AI186BA;EACE,YAAA;AJ686BF;;AI386BA;EACE,YAAA;AJ886BF;;AI586BA;EACE,YAAA;AJ+86BF;;AI786BA;EACE,YAAA;AJg96BF;;AI986BA;EACE,YAAA;AJi96BF;;AI/86BA;EACE,YAAA;AJk96BF;;AIh96BA;EACE,YAAA;AJm96BF;;AIj96BA;EACE,YAAA;AJo96BF;;AIl96BA;EACE,YAAA;AJq96BF;;AIn96BA;EACE,YAAA;AJs96BF;;AIp96BA;EACE,YAAA;AJu96BF;;AIr96BA;EACE,YAAA;AJw96BF;;AIt96BA;EACE,YAAA;AJy96BF;;AIv96BA;EACE,YAAA;AJ096BF;;AIx96BA;EACE,YAAA;AJ296BF;;AIz96BA;EACE,YAAA;AJ496BF;;AI196BA;EACE,YAAA;AJ696BF;;AI396BA;EACE,YAAA;AJ896BF;;AI596BA;EACE,YAAA;AJ+96BF;;AI796BA;EACE,YAAA;AJg+6BF;;AI996BA;EACE,YAAA;AJi+6BF;;AI/96BA;EACE,YAAA;AJk+6BF;;AIh+6BA;EACE,YAAA;AJm+6BF;;AIj+6BA;EACE,YAAA;AJo+6BF;;AIl+6BA;EACE,YAAA;AJq+6BF;;AIn+6BA;EACE,YAAA;AJs+6BF;;AIp+6BA;EACE,YAAA;AJu+6BF;;AIr+6BA;EACE,YAAA;AJw+6BF;;AIt+6BA;EACE,YAAA;AJy+6BF;;AIv+6BA;EACE,YAAA;AJ0+6BF;;AIx+6BA;EACE,YAAA;AJ2+6BF;;AIz+6BA;EACE,YAAA;AJ4+6BF;;AI1+6BA;EACE,YAAA;AJ6+6BF;;AI3+6BA;EACE,YAAA;AJ8+6BF;;AI5+6BA;EACE,YAAA;AJ++6BF;;AI7+6BA;EACE,YAAA;AJg/6BF;;AI9+6BA;EACE,YAAA;AJi/6BF;;AI/+6BA;EACE,YAAA;AJk/6BF;;AIh/6BA;EACE,YAAA;AJm/6BF;;AIj/6BA;EACE,YAAA;AJo/6BF;;AIl/6BA;EACE,YAAA;AJq/6BF;;AIn/6BA;EACE,YAAA;AJs/6BF;;AIp/6BA;EACE,YAAA;AJu/6BF;;AIr/6BA;EACE,YAAA;AJw/6BF;;AIt/6BA;EACE,YAAA;AJy/6BF;;AIv/6BA;EACE,YAAA;AJ0/6BF;;AIx/6BA;EACE,YAAA;AJ2/6BF;;AIz/6BA;EACE,YAAA;AJ4/6BF;;AI1/6BA;EACE,YAAA;AJ6/6BF;;AI3/6BA;EACE,YAAA;AJ8/6BF;;AI5/6BA;EACE,YAAA;AJ+/6BF;;AI7/6BA;EACE,YAAA;AJgg7BF;;AI9/6BA;EACE,YAAA;AJig7BF;;AI//6BA;EACE,YAAA;AJkg7BF;;AIhg7BA;EACE,YAAA;AJmg7BF;;AIjg7BA;EACE,YAAA;AJog7BF;;AIlg7BA;EACE,YAAA;AJqg7BF;;AIng7BA;EACE,YAAA;AJsg7BF;;AIpg7BA;EACE,YAAA;AJug7BF;;AIrg7BA;EACE,YAAA;AJwg7BF;;AItg7BA;EACE,YAAA;AJyg7BF;;AIvg7BA;EACE,YAAA;AJ0g7BF;;AIxg7BA;EACE,YAAA;AJ2g7BF;;AIzg7BA;EACE,YAAA;AJ4g7BF;;AI1g7BA;EACE,YAAA;AJ6g7BF;;AI3g7BA;EACE,YAAA;AJ8g7BF;;AI5g7BA;EACE,YAAA;AJ+g7BF;;AI7g7BA;EACE,YAAA;AJgh7BF;;AI9g7BA;EACE,YAAA;AJih7BF;;AI/g7BA;EACE,YAAA;AJkh7BF;;AIhh7BA;EACE,YAAA;AJmh7BF;;AIjh7BA;EACE,YAAA;AJoh7BF;;AIlh7BA;EACE,YAAA;AJqh7BF;;AInh7BA;EACE,YAAA;AJsh7BF;;AIph7BA;EACE,YAAA;AJuh7BF;;AIrh7BA;EACE,aAAA;AJwh7BF;;AIth7BA;EACE,gBAAA;AJyh7BF;;AIvh7BA;EACE,gBAAA;AJ0h7BF;;AIxh7BA;EACE,gBAAA;AJ2h7BF;;AIzh7BA;EACE,gBAAA;AJ4h7BF;;AI1h7BA;EACE,gBAAA;AJ6h7BF;;AI3h7BA;EACE,gBAAA;AJ8h7BF;;AI5h7BA;EACE,gBAAA;AJ+h7BF;;AI7h7BA;EACE,gBAAA;AJgi7BF;;AI9h7BA;EACE,gBAAA;AJii7BF;;AI/h7BA;EACE,gBAAA;AJki7BF;;AIhi7BA;EACE,gBAAA;AJmi7BF;;AIji7BA;EACE,gBAAA;AJoi7BF;;AIli7BA;EACE,gBAAA;AJqi7BF;;AIni7BA;EACE,gBAAA;AJsi7BF;;AIpi7BA;EACE,gBAAA;AJui7BF;;AIri7BA;EACE,gBAAA;AJwi7BF;;AIti7BA;EACE,gBAAA;AJyi7BF;;AIvi7BA;EACE,gBAAA;AJ0i7BF;;AIxi7BA;EACE,gBAAA;AJ2i7BF;;AIzi7BA;EACE,gBAAA;AJ4i7BF;;AI1i7BA;EACE,gBAAA;AJ6i7BF;;AI3i7BA;EACE,gBAAA;AJ8i7BF;;AI5i7BA;EACE,gBAAA;AJ+i7BF;;AI7i7BA;EACE,gBAAA;AJgj7BF;;AI9i7BA;EACE,gBAAA;AJij7BF;;AI/i7BA;EACE,gBAAA;AJkj7BF;;AIhj7BA;EACE,gBAAA;AJmj7BF;;AIjj7BA;EACE,gBAAA;AJoj7BF;;AIlj7BA;EACE,gBAAA;AJqj7BF;;AInj7BA;EACE,gBAAA;AJsj7BF;;AIpj7BA;EACE,gBAAA;AJuj7BF;;AIrj7BA;EACE,gBAAA;AJwj7BF;;AItj7BA;EACE,gBAAA;AJyj7BF;;AIvj7BA;EACE,gBAAA;AJ0j7BF;;AIxj7BA;EACE,gBAAA;AJ2j7BF;;AIzj7BA;EACE,gBAAA;AJ4j7BF;;AI1j7BA;EACE,gBAAA;AJ6j7BF;;AI3j7BA;EACE,gBAAA;AJ8j7BF;;AI5j7BA;EACE,gBAAA;AJ+j7BF;;AI7j7BA;EACE,gBAAA;AJgk7BF;;AI9j7BA;EACE,gBAAA;AJik7BF;;AI/j7BA;EACE,gBAAA;AJkk7BF;;AIhk7BA;EACE,gBAAA;AJmk7BF;;AIjk7BA;EACE,gBAAA;AJok7BF;;AIlk7BA;EACE,gBAAA;AJqk7BF;;AInk7BA;EACE,gBAAA;AJsk7BF;;AIpk7BA;EACE,gBAAA;AJuk7BF;;AIrk7BA;EACE,gBAAA;AJwk7BF;;AItk7BA;EACE,gBAAA;AJyk7BF;;AIvk7BA;EACE,gBAAA;AJ0k7BF;;AIxk7BA;EACE,gBAAA;AJ2k7BF;;AIzk7BA;EACE,gBAAA;AJ4k7BF;;AI1k7BA;EACE,gBAAA;AJ6k7BF;;AI3k7BA;EACE,gBAAA;AJ8k7BF;;AI5k7BA;EACE,gBAAA;AJ+k7BF;;AI7k7BA;EACE,gBAAA;AJgl7BF;;AI9k7BA;EACE,gBAAA;AJil7BF;;AI/k7BA;EACE,gBAAA;AJkl7BF;;AIhl7BA;EACE,gBAAA;AJml7BF;;AIjl7BA;EACE,gBAAA;AJol7BF;;AIll7BA;EACE,gBAAA;AJql7BF;;AInl7BA;EACE,gBAAA;AJsl7BF;;AIpl7BA;EACE,gBAAA;AJul7BF;;AIrl7BA;EACE,gBAAA;AJwl7BF;;AItl7BA;EACE,gBAAA;AJyl7BF;;AIvl7BA;EACE,gBAAA;AJ0l7BF;;AIxl7BA;EACE,gBAAA;AJ2l7BF;;AIzl7BA;EACE,gBAAA;AJ4l7BF;;AI1l7BA;EACE,gBAAA;AJ6l7BF;;AI3l7BA;EACE,gBAAA;AJ8l7BF;;AI5l7BA;EACE,gBAAA;AJ+l7BF;;AI7l7BA;EACE,gBAAA;AJgm7BF;;AI9l7BA;EACE,gBAAA;AJim7BF;;AI/l7BA;EACE,gBAAA;AJkm7BF;;AIhm7BA;EACE,gBAAA;AJmm7BF;;AIjm7BA;EACE,gBAAA;AJom7BF;;AIlm7BA;EACE,gBAAA;AJqm7BF;;AInm7BA;EACE,gBAAA;AJsm7BF;;AIpm7BA;EACE,gBAAA;AJum7BF;;AIrm7BA;EACE,gBAAA;AJwm7BF;;AItm7BA;EACE,gBAAA;AJym7BF;;AIvm7BA;EACE,gBAAA;AJ0m7BF;;AIxm7BA;EACE,gBAAA;AJ2m7BF;;AIzm7BA;EACE,gBAAA;AJ4m7BF;;AI1m7BA;EACE,gBAAA;AJ6m7BF;;AI3m7BA;EACE,gBAAA;AJ8m7BF;;AI5m7BA;EACE,gBAAA;AJ+m7BF;;AI7m7BA;EACE,gBAAA;AJgn7BF;;AI9m7BA;EACE,gBAAA;AJin7BF;;AI/m7BA;EACE,gBAAA;AJkn7BF;;AIhn7BA;EACE,gBAAA;AJmn7BF;;AIjn7BA;EACE,gBAAA;AJon7BF;;AIln7BA;EACE,gBAAA;AJqn7BF;;AInn7BA;EACE,gBAAA;AJsn7BF;;AIpn7BA;EACE,gBAAA;AJun7BF;;AIrn7BA;EACE,gBAAA;AJwn7BF;;AItn7BA;EACE,gBAAA;AJyn7BF;;AIvn7BA;EACE,gBAAA;AJ0n7BF;;AIxn7BA;EACE,gBAAA;AJ2n7BF;;AIzn7BA;EACE,gBAAA;AJ4n7BF;;AI1n7BA;EACE,gBAAA;AJ6n7BF;;AI3n7BA;EACE,gBAAA;AJ8n7BF;;AI5n7BA;EACE,gBAAA;AJ+n7BF;;AI7n7BA;EACE,gBAAA;AJgo7BF;;AI9n7BA;EACE,gBAAA;AJio7BF;;AI/n7BA;EACE,gBAAA;AJko7BF;;AKhw8BA;;;;;;;;;CAAA;AAUA;EACE,wBAAA;EACA,6CAAA,EAAA,OAAA;EACA,iTAAA,EAIgF,aAAA;EAChF,kBAAA;AL+v8BF;AK5v8BA;EACE,mCAAA;EACA,kBAAA;EACA,mCAAA;EACA,kCAAA;AL8v8BF;;AK3v8BA;EAAS,mBAAA;EAAqB,mBAAA;EAAqB,yBAAA;ALiw8BnD;;AKhw8BA;EAAS,gBAAA;EAAkB,qBAAA;EAAuB,wBAAA;ALsw8BlD;;AKrw8BA;EAAU,gBAAA;ALyw8BV;;AKxw8BA;EAAS,iBAAA;AL4w8BT;;AK3w8BA;EAAS,kBAAA;AL+w8BT;;AK9w8BA;EAAS,cAAA;ALkx8BT;;AKjx8BA;EAAS,cAAA;ALqx8BT;;AKpx8BA;EAAS,cAAA;ALwx8BT;;AKvx8BA;EAAS,cAAA;AL2x8BT;;AK1x8BA;EAAS,cAAA;AL8x8BT;;AK7x8BA;EAAS,cAAA;ALiy8BT;;AKhy8BA;EAAS,cAAA;ALoy8BT;;AKny8BA;EAAS,cAAA;ALuy8BT;;AKty8BA;EAAS,cAAA;AL0y8BT;;AKzy8BA;EAAU,eAAA;AL6y8BV;;AK5y8BA;EAAS,kBAAA;EAAoB,aAAA;ALiz8B7B;;AK/y8BA;EAAqB,gBAAA;ALmz8BrB;;AKlz8BA;EAAqB,gBAAA;ALsz8BrB;;AKrz8BA;EAAiB,gBAAA;ALyz8BjB;;AKxz8BA;EAA8B,gBAAA;AL4z8B9B;;AK3z8BA;EAA8B,gBAAA;AL+z8B9B;;AK9z8BA;EAAiC,gBAAA;ALk08BjC;;AKj08BA;EAAiC,gBAAA;ALq08BjC;;AKp08BA;EAAkC,gBAAA;ALw08BlC;;AKv08BA;EAAkC,gBAAA;AL208BlC;;AK108BA;EAAqC,gBAAA;AL808BrC;;AK708BA;EAAqC,gBAAA;ALi18BrC;;AKh18BA;EAA0B,gBAAA;ALo18B1B;;AKn18BA;EAA0B,gBAAA;ALu18B1B;;AKt18BA;EAA6B,gBAAA;AL018B7B;;AKz18BA;EAA6B,gBAAA;AL618B7B;;AK518BA;EAAsB,gBAAA;ALg28BtB;;AK/18BA;EAAsB,gBAAA;ALm28BtB;;AKl28BA;EAAwB,gBAAA;ALs28BxB;;AKr28BA;EAAwB,gBAAA;ALy28BxB;;AKx28BA;EAAgC,gBAAA;AL428BhC;;AK328BA;EAAgC,gBAAA;AL+28BhC;;AK928BA;EAA0B,gBAAA;ALk38B1B;;AKj38BA;EAA0B,gBAAA;ALq38B1B;;AKp38BA;EAAwB,gBAAA;ALw38BxB;;AKv38BA;EAAwB,gBAAA;AL238BxB;;AK138BA;EAAgC,gBAAA;AL838BhC;;AK738BA;EAAgC,gBAAA;ALi48BhC;;AKh48BA;EAAwB,gBAAA;ALo48BxB;;AKn48BA;EAAwB,gBAAA;ALu48BxB;;AKt48BA;EAAwB,gBAAA;AL048BxB;;AKz48BA;EAAwB,gBAAA;AL648BxB;;AK548BA;EAAyB,gBAAA;ALg58BzB;;AK/48BA;EAAyB,gBAAA;ALm58BzB;;AKl58BA;EAA0B,gBAAA;ALs58B1B;;AKr58BA;EAA0B,gBAAA;ALy58B1B;;AKx58BA;EAA2B,gBAAA;AL458B3B;;AK358BA;EAAwB,gBAAA;AL+58BxB;;AK958BA;EAAyB,gBAAA;ALk68BzB;;AKj68BA;EAAuB,gBAAA;ALq68BvB;;AKp68BA;EAA8B,gBAAA;ALw68B9B;;AKv68BA;EAAyB,gBAAA;AL268BzB;;AK168BA;EAAyB,gBAAA;AL868BzB;;AK768BA;EAAyB,gBAAA;ALi78BzB;;AKh78BA;EAAyB,gBAAA;ALo78BzB;;AKn78BA;EAAyB,gBAAA;ALu78BzB;;AKt78BA;EAAyB,gBAAA;AL078BzB;;AKz78BA;EAA+B,gBAAA;AL678B/B;;AK578BA;EAA+B,gBAAA;ALg88B/B;;AK/78BA;EAAmC,gBAAA;ALm88BnC;;AKl88BA;EAAmC,gBAAA;ALs88BnC;;AKr88BA;EAA0B,gBAAA;ALy88B1B;;AKx88BA;EAA0B,gBAAA;AL488B1B;;AK388BA;EAA4B,gBAAA;AL+88B5B;;AK988BA;EAA4B,gBAAA;ALk98B5B;;AKj98BA;EAAkC,gBAAA;ALq98BlC;;AKp98BA;EAAkC,gBAAA;ALw98BlC;;AKv98BA;EAAgC,gBAAA;AL298BhC;;AK198BA;EAAgC,gBAAA;AL898BhC;;AK798BA;EAA4B,gBAAA;ALi+8B5B;;AKh+8BA;EAA4B,gBAAA;ALo+8B5B;;AKn+8BA;EAAwB,gBAAA;ALu+8BxB;;AKt+8BA;EAAwB,gBAAA;AL0+8BxB;;AKz+8BA;EAAyB,gBAAA;AL6+8BzB;;AK5+8BA;EAAyB,gBAAA;ALg/8BzB;;AK/+8BA;EAAuB,gBAAA;ALm/8BvB;;AKl/8BA;EAAuB,gBAAA;ALs/8BvB;;AKr/8BA;EAAiC,gBAAA;ALy/8BjC;;AKx/8BA;EAAiC,gBAAA;AL4/8BjC;;AK3/8BA;EAA0B,gBAAA;AL+/8B1B;;AK9/8BA;EAA0B,gBAAA;ALkg9B1B;;AKjg9BA;EAAoC,gBAAA;ALqg9BpC;;AKpg9BA;EAAoC,gBAAA;ALwg9BpC;;AKvg9BA;EAA6B,gBAAA;AL2g9B7B;;AK1g9BA;EAA6B,gBAAA;AL8g9B7B;;AK7g9BA;EAA+B,gBAAA;ALih9B/B;;AKhh9BA;EAA+B,gBAAA;ALoh9B/B;;AKnh9BA;EAAkC,gBAAA;ALuh9BlC;;AKth9BA;EAAkC,gBAAA;AL0h9BlC;;AKzh9BA;EAAkC,gBAAA;AL6h9BlC;;AK5h9BA;EAAkC,gBAAA;ALgi9BlC;;AK/h9BA;EAAmC,gBAAA;ALmi9BnC;;AKli9BA;EAAmC,gBAAA;ALsi9BnC;;AKri9BA;EAAgC,gBAAA;ALyi9BhC;;AKxi9BA;EAAgC,gBAAA;AL4i9BhC;;AK3i9BA;EAAgC,gBAAA;AL+i9BhC;;AK9i9BA;EAAgC,gBAAA;ALkj9BhC;;AKjj9BA;EAAmC,gBAAA;ALqj9BnC;;AKpj9BA;EAAmC,gBAAA;ALwj9BnC;;AKvj9BA;EAAoC,gBAAA;AL2j9BpC;;AK1j9BA;EAAoC,gBAAA;AL8j9BpC;;AK7j9BA;EAAkC,gBAAA;ALik9BlC;;AKhk9BA;EAAkC,gBAAA;ALok9BlC;;AKnk9BA;EAA6B,gBAAA;ALuk9B7B;;AKtk9BA;EAA6B,gBAAA;AL0k9B7B;;AKzk9BA;EAAmC,gBAAA;AL6k9BnC;;AK5k9BA;EAAmC,gBAAA;ALgl9BnC;;AK/k9BA;EAA+B,gBAAA;ALml9B/B;;AKll9BA;EAA+B,gBAAA;ALsl9B/B;;AKrl9BA;EAAgC,gBAAA;ALyl9BhC;;AKxl9BA;EAAgC,gBAAA;AL4l9BhC;;AK3l9BA;EAAqC,gBAAA;AL+l9BrC;;AK9l9BA;EAAqC,gBAAA;ALkm9BrC;;AKjm9BA;EAAmC,gBAAA;ALqm9BnC;;AKpm9BA;EAAmC,gBAAA;ALwm9BnC;;AKvm9BA;EAA8B,gBAAA;AL2m9B9B;;AK1m9BA;EAA8B,gBAAA;AL8m9B9B;;AK7m9BA;EAAgC,gBAAA;ALin9BhC;;AKhn9BA;EAAgC,gBAAA;ALon9BhC;;AKnn9BA;EAAiC,gBAAA;ALun9BjC;;AKtn9BA;EAAiC,gBAAA;AL0n9BjC;;AKzn9BA;EAAkC,gBAAA;AL6n9BlC;;AK5n9BA;EAAkC,gBAAA;ALgo9BlC;;AK/n9BA;EAAgC,gBAAA;ALmo9BhC;;AKlo9BA;EAAgC,gBAAA;ALso9BhC;;AKro9BA;EAA2B,gBAAA;ALyo9B3B;;AKxo9BA;EAA2B,gBAAA;AL4o9B3B;;AK3o9BA;EAA6B,gBAAA;AL+o9B7B;;AK9o9BA;EAA6B,gBAAA;ALkp9B7B;;AKjp9BA;EAA6B,gBAAA;ALqp9B7B;;AKpp9BA;EAA6B,gBAAA;ALwp9B7B;;AKvp9BA;EAA2B,gBAAA;AL2p9B3B;;AK1p9BA;EAA2B,gBAAA;AL8p9B3B;;AK7p9BA;EAA0B,gBAAA;ALiq9B1B;;AKhq9BA;EAA0B,gBAAA;ALoq9B1B;;AKnq9BA;EAA+B,gBAAA;ALuq9B/B;;AKtq9BA;EAA+B,gBAAA;AL0q9B/B;;AKzq9BA;EAAsB,gBAAA;AL6q9BtB;;AK5q9BA;EAAqB,gBAAA;ALgr9BrB;;AK/q9BA;EAAqB,gBAAA;ALmr9BrB;;AKlr9BA;EAA0B,gBAAA;ALsr9B1B;;AKrr9BA;EAA6B,gBAAA;ALyr9B7B;;AKxr9BA;EAA6B,gBAAA;AL4r9B7B;;AK3r9BA;EAA0B,gBAAA;AL+r9B1B;;AK9r9BA;EAA0B,gBAAA;ALks9B1B;;AKjs9BA;EAAwB,gBAAA;ALqs9BxB;;AKps9BA;EAAwB,gBAAA;ALws9BxB;;AKvs9BA;EAAwB,gBAAA;AL2s9BxB;;AK1s9BA;EAAwB,gBAAA;AL8s9BxB;;AK7s9BA;EAA2B,gBAAA;ALit9B3B;;AKht9BA;EAA2B,gBAAA;ALot9B3B;;AKnt9BA;EAA8B,gBAAA;ALut9B9B;;AKtt9BA;EAA8B,gBAAA;AL0t9B9B;;AKzt9BA;EAA4B,gBAAA;AL6t9B5B;;AK5t9BA;EAA4B,gBAAA;ALgu9B5B;;AK/t9BA;EAAuB,gBAAA;ALmu9BvB;;AKlu9BA;EAAuB,gBAAA;ALsu9BvB;;AKru9BA;EAA8B,gBAAA;ALyu9B9B;;AKxu9BA;EAA8B,gBAAA;AL4u9B9B;;AK3u9BA;EAAgC,gBAAA;AL+u9BhC;;AK9u9BA;EAAgC,gBAAA;ALkv9BhC;;AKjv9BA;EAA4B,gBAAA;ALqv9B5B;;AKpv9BA;EAAoC,gBAAA;ALwv9BpC;;AKvv9BA;EAAoC,gBAAA;AL2v9BpC;;AK1v9BA;EAAuC,gBAAA;AL8v9BvC;;AK7v9BA;EAAuC,gBAAA;ALiw9BvC;;AKhw9BA;EAA4B,gBAAA;ALow9B5B;;AKnw9BA;EAA8B,gBAAA;ALuw9B9B;;AKtw9BA;EAA8B,gBAAA;AL0w9B9B;;AKzw9BA;EAA0B,gBAAA;AL6w9B1B;;AK5w9BA;EAA0B,gBAAA;ALgx9B1B;;AK/w9BA;EAA4B,gBAAA;ALmx9B5B;;AKlx9BA;EAA4B,gBAAA;ALsx9B5B;;AKrx9BA;EAA+B,gBAAA;ALyx9B/B;;AKxx9BA;EAA+B,gBAAA;AL4x9B/B;;AK3x9BA;EAA6B,gBAAA;AL+x9B7B;;AK9x9BA;EAA6B,gBAAA;ALky9B7B;;AKjy9BA;EAAmC,gBAAA;ALqy9BnC;;AKpy9BA;EAAmC,gBAAA;ALwy9BnC;;AKvy9BA;EAA4B,gBAAA;AL2y9B5B;;AK1y9BA;EAA4B,gBAAA;AL8y9B5B;;AK7y9BA;EAAiC,gBAAA;ALiz9BjC;;AKhz9BA;EAAiC,gBAAA;ALoz9BjC;;AKnz9BA;EAA0B,gBAAA;ALuz9B1B;;AKtz9BA;EAA0B,gBAAA;AL0z9B1B;;AKzz9BA;EAA8B,gBAAA;AL6z9B9B;;AK5z9BA;EAA8B,gBAAA;ALg09B9B;;AK/z9BA;EAAgC,gBAAA;ALm09BhC;;AKl09BA;EAAgC,gBAAA;ALs09BhC;;AKr09BA;EAAgC,gBAAA;ALy09BhC;;AKx09BA;EAAgC,gBAAA;AL409BhC;;AK309BA;EAA6B,gBAAA;AL+09B7B;;AK909BA;EAA6B,gBAAA;ALk19B7B;;AKj19BA;EAA0B,gBAAA;ALq19B1B;;AKp19BA;EAA0B,gBAAA;ALw19B1B;;AKv19BA;EAAuB,gBAAA;AL219BvB;;AK119BA;EAAuB,gBAAA;AL819BvB;;AK719BA;EAAuB,gBAAA;ALi29BvB;;AKh29BA;EAAuB,gBAAA;ALo29BvB;;AKn29BA;EAA2B,gBAAA;ALu29B3B;;AKt29BA;EAA2B,gBAAA;AL029B3B;;AKz29BA;EAAuB,gBAAA;AL629BvB;;AK529BA;EAAuB,gBAAA;ALg39BvB;;AK/29BA;EAA4B,gBAAA;ALm39B5B;;AKl39BA;EAA4B,gBAAA;ALs39B5B;;AKr39BA;EAA2B,gBAAA;ALy39B3B;;AKx39BA;EAA2B,gBAAA;AL439B3B;;AK339BA;EAAwB,gBAAA;AL+39BxB;;AK939BA;EAAwB,gBAAA;ALk49BxB;;AKj49BA;EAAoC,gBAAA;ALq49BpC;;AKp49BA;EAAoC,gBAAA;ALw49BpC;;AKv49BA;EAA4B,gBAAA;AL249B5B;;AK149BA;EAA4B,gBAAA;AL849B5B;;AK749BA;EAA2B,gBAAA;ALi59B3B;;AKh59BA;EAA2B,gBAAA;ALo59B3B;;AKn59BA;EAA4B,gBAAA;ALu59B5B;;AKt59BA;EAA4B,gBAAA;AL059B5B;;AKz59BA;EAAkB,gBAAA;AL659BlB;;AK559BA;EAAyB,gBAAA;ALg69BzB;;AK/59BA;EAAyB,gBAAA;ALm69BzB;;AKl69BA;EAAyB,gBAAA;ALs69BzB;;AKr69BA;EAAyB,gBAAA;ALy69BzB;;AKx69BA;EAAuB,gBAAA;AL469BvB;;AK369BA;EAAuB,gBAAA;AL+69BvB;;AK969BA;EAA4B,gBAAA;ALk79B5B;;AKj79BA;EAA4B,gBAAA;ALq79B5B;;AKp79BA;EAA4B,gBAAA;ALw79B5B;;AKv79BA;EAA4B,gBAAA;AL279B5B;;AK179BA;EAA4B,gBAAA;AL879B5B;;AK779BA;EAA4B,gBAAA;ALi89B5B;;AKh89BA;EAA0B,gBAAA;ALo89B1B;;AKn89BA;EAA0B,gBAAA;ALu89B1B;;AKt89BA;EAA6B,gBAAA;AL089B7B;;AKz89BA;EAA6B,gBAAA;AL689B7B;;AK589BA;EAA6B,gBAAA;ALg99B7B;;AK/89BA;EAA6B,gBAAA;ALm99B7B;;AKl99BA;EAA2B,gBAAA;ALs99B3B;;AKr99BA;EAA2B,gBAAA;ALy99B3B;;AKx99BA;EAAyB,gBAAA;AL499BzB;;AK399BA;EAAyB,gBAAA;AL+99BzB;;AK999BA;EAAyB,gBAAA;ALk+9BzB;;AKj+9BA;EAAyB,gBAAA;ALq+9BzB;;AKp+9BA;EAA2B,gBAAA;ALw+9B3B;;AKv+9BA;EAA2B,gBAAA;AL2+9B3B;;AK1+9BA;EAA8B,gBAAA;AL8+9B9B;;AK7+9BA;EAA8B,gBAAA;ALi/9B9B;;AKh/9BA;EAA8B,gBAAA;ALo/9B9B;;AKn/9BA;EAA8B,gBAAA;ALu/9B9B;;AKt/9BA;EAA8B,gBAAA;AL0/9B9B;;AKz/9BA;EAA8B,gBAAA;AL6/9B9B;;AK5/9BA;EAA8B,gBAAA;ALgg+B9B;;AK//9BA;EAA8B,gBAAA;ALmg+B9B;;AKlg+BA;EAA4B,gBAAA;ALsg+B5B;;AKrg+BA;EAA4B,gBAAA;ALyg+B5B;;AKxg+BA;EAA2B,gBAAA;AL4g+B3B;;AK3g+BA;EAA4B,gBAAA;AL+g+B5B;;AK9g+BA;EAA4B,gBAAA;ALkh+B5B;;AKjh+BA;EAA4B,gBAAA;ALqh+B5B;;AKph+BA;EAA0B,gBAAA;ALwh+B1B;;AKvh+BA;EAA0B,gBAAA;AL2h+B1B;;AK1h+BA;EAA0B,gBAAA;AL8h+B1B;;AK7h+BA;EAA0B,gBAAA;ALii+B1B;;AKhi+BA;EAA0B,gBAAA;ALoi+B1B;;AKni+BA;EAA0B,gBAAA;ALui+B1B;;AKti+BA;EAAwB,gBAAA;AL0i+BxB;;AKzi+BA;EAAwB,gBAAA;AL6i+BxB;;AK5i+BA;EAA+B,gBAAA;ALgj+B/B;;AK/i+BA;EAA+B,gBAAA;ALmj+B/B;;AKlj+BA;EAAwB,gBAAA;ALsj+BxB;;AKrj+BA;EAAwB,gBAAA;ALyj+BxB;;AKxj+BA;EAAsB,gBAAA;AL4j+BtB;;AK3j+BA;EAAsB,gBAAA;AL+j+BtB;;AK9j+BA;EAA6B,gBAAA;ALkk+B7B;;AKjk+BA;EAA6B,gBAAA;ALqk+B7B;;AKpk+BA;EAA6B,gBAAA;ALwk+B7B;;AKvk+BA;EAA6B,gBAAA;AL2k+B7B;;AK1k+BA;EAA6B,gBAAA;AL8k+B7B;;AK7k+BA;EAA6B,gBAAA;ALil+B7B;;AKhl+BA;EAA2B,gBAAA;ALol+B3B;;AKnl+BA;EAA2B,gBAAA;ALul+B3B;;AKtl+BA;EAAwB,gBAAA;AL0l+BxB;;AKzl+BA;EAAwB,gBAAA;AL6l+BxB;;AK5l+BA;EAAsB,gBAAA;ALgm+BtB;;AK/l+BA;EAAsB,gBAAA;ALmm+BtB;;AKlm+BA;EAA2B,gBAAA;ALsm+B3B;;AKrm+BA;EAA2B,gBAAA;ALym+B3B;;AKxm+BA;EAAyB,gBAAA;AL4m+BzB;;AK3m+BA;EAAyB,gBAAA;AL+m+BzB;;AK9m+BA;EAAyB,gBAAA;ALkn+BzB;;AKjn+BA;EAAyB,gBAAA;ALqn+BzB;;AKpn+BA;EAAuB,gBAAA;ALwn+BvB;;AKvn+BA;EAAuB,gBAAA;AL2n+BvB;;AK1n+BA;EAA6B,gBAAA;AL8n+B7B;;AK7n+BA;EAA6B,gBAAA;ALio+B7B;;AKho+BA;EAA6B,gBAAA;ALoo+B7B;;AKno+BA;EAA6B,gBAAA;ALuo+B7B;;AKto+BA;EAAiC,gBAAA;AL0o+BjC;;AKzo+BA;EAAiC,gBAAA;AL6o+BjC;;AK5o+BA;EAAiC,gBAAA;ALgp+BjC;;AK/o+BA;EAAiC,gBAAA;ALmp+BjC;;AKlp+BA;EAA2B,gBAAA;ALsp+B3B;;AKrp+BA;EAA2B,gBAAA;ALyp+B3B;;AKxp+BA;EAAgC,gBAAA;AL4p+BhC;;AK3p+BA;EAAgC,gBAAA;AL+p+BhC;;AK9p+BA;EAA2B,gBAAA;ALkq+B3B;;AKjq+BA;EAA2B,gBAAA;ALqq+B3B;;AKpq+BA;EAA2B,gBAAA;ALwq+B3B;;AKvq+BA;EAA2B,gBAAA;AL2q+B3B;;AK1q+BA;EAAyB,gBAAA;AL8q+BzB;;AK7q+BA;EAA8B,gBAAA;ALir+B9B;;AKhr+BA;EAA8B,gBAAA;ALor+B9B;;AKnr+BA;EAAyB,gBAAA;ALur+BzB;;AKtr+BA;EAA6B,gBAAA;AL0r+B7B;;AKzr+BA;EAA6B,gBAAA;AL6r+B7B;;AK5r+BA;EAAgC,gBAAA;ALgs+BhC;;AK/r+BA;EAAgC,gBAAA;ALms+BhC;;AKls+BA;EAAsB,gBAAA;ALss+BtB;;AKrs+BA;EAAsB,gBAAA;ALys+BtB;;AKxs+BA;EAA8B,gBAAA;AL4s+B9B;;AK3s+BA;EAA8B,gBAAA;AL+s+B9B;;AK9s+BA;EAA0B,gBAAA;ALkt+B1B;;AKjt+BA;EAA0B,gBAAA;ALqt+B1B;;AKpt+BA;EAAuB,gBAAA;ALwt+BvB;;AKvt+BA;EAAuB,gBAAA;AL2t+BvB;;AK1t+BA;EAA4B,gBAAA;AL8t+B5B;;AK7t+BA;EAA4B,gBAAA;ALiu+B5B;;AKhu+BA;EAA0B,gBAAA;ALou+B1B;;AKnu+BA;EAA0B,gBAAA;ALuu+B1B;;AKtu+BA;EAAyB,gBAAA;AL0u+BzB;;AKzu+BA;EAAyB,gBAAA;AL6u+BzB;;AK5u+BA;EAAwC,gBAAA;ALgv+BxC;;AK/u+BA;EAAwC,gBAAA;ALmv+BxC;;AKlv+BA;EAAkC,gBAAA;ALsv+BlC;;AKrv+BA;EAAkC,gBAAA;ALyv+BlC;;AKxv+BA;EAAgC,gBAAA;AL4v+BhC;;AK3v+BA;EAAgC,gBAAA;AL+v+BhC;;AK9v+BA;EAAyB,gBAAA;ALkw+BzB;;AKjw+BA;EAAyB,gBAAA;ALqw+BzB;;AKpw+BA;EAAyB,gBAAA;ALww+BzB;;AKvw+BA;EAAyB,gBAAA;AL2w+BzB;;AK1w+BA;EAAyB,gBAAA;AL8w+BzB;;AK7w+BA;EAAyB,gBAAA;ALix+BzB;;AKhx+BA;EAAyB,gBAAA;ALox+BzB;;AKnx+BA;EAAyB,gBAAA;ALux+BzB;;AKtx+BA;EAA6B,gBAAA;AL0x+B7B;;AKzx+BA;EAA6B,gBAAA;AL6x+B7B;;AK5x+BA;EAA8B,gBAAA;ALgy+B9B;;AK/x+BA;EAA8B,gBAAA;ALmy+B9B;;AKly+BA;EAAgC,gBAAA;ALsy+BhC;;AKry+BA;EAAgC,gBAAA;ALyy+BhC;;AKxy+BA;EAAiC,gBAAA;AL4y+BjC;;AK3y+BA;EAAiC,gBAAA;AL+y+BjC;;AK9y+BA;EAA+B,gBAAA;ALkz+B/B;;AKjz+BA;EAA+B,gBAAA;ALqz+B/B;;AKpz+BA;EAA6B,gBAAA;ALwz+B7B;;AKvz+BA;EAA6B,gBAAA;AL2z+B7B;;AK1z+BA;EAA+B,gBAAA;AL8z+B/B;;AK7z+BA;EAA+B,gBAAA;ALi0+B/B;;AKh0+BA;EAA2B,gBAAA;ALo0+B3B;;AKn0+BA;EAA2B,gBAAA;ALu0+B3B;;AKt0+BA;EAA2B,gBAAA;AL00+B3B;;AKz0+BA;EAA2B,gBAAA;AL60+B3B;;AK50+BA;EAA4B,gBAAA;ALg1+B5B;;AK/0+BA;EAA4B,gBAAA;ALm1+B5B;;AKl1+BA;EAA+B,gBAAA;ALs1+B/B;;AKr1+BA;EAA+B,gBAAA;ALy1+B/B;;AKx1+BA;EAA6B,gBAAA;AL41+B7B;;AK31+BA;EAA6B,gBAAA;AL+1+B7B;;AK91+BA;EAAgC,gBAAA;ALk2+BhC;;AKj2+BA;EAAgC,gBAAA;ALq2+BhC;;AKp2+BA;EAA+B,gBAAA;ALw2+B/B;;AKv2+BA;EAA+B,gBAAA;AL22+B/B;;AK12+BA;EAA+B,gBAAA;AL82+B/B;;AK72+BA;EAA+B,gBAAA;ALi3+B/B;;AKh3+BA;EAA6B,gBAAA;ALo3+B7B;;AKn3+BA;EAA6B,gBAAA;ALu3+B7B;;AKt3+BA;EAA8B,gBAAA;AL03+B9B;;AKz3+BA;EAA8B,gBAAA;AL63+B9B;;AK53+BA;EAA6B,gBAAA;ALg4+B7B;;AK/3+BA;EAA6B,gBAAA;ALm4+B7B;;AKl4+BA;EAA+B,gBAAA;ALs4+B/B;;AKr4+BA;EAA+B,gBAAA;ALy4+B/B;;AKx4+BA;EAAwB,gBAAA;AL44+BxB;;AK34+BA;EAAwB,gBAAA;AL+4+BxB;;AK94+BA;EAAwC,gBAAA;ALk5+BxC;;AKj5+BA;EAAwC,gBAAA;ALq5+BxC;;AKp5+BA;EAAiC,gBAAA;ALw5+BjC;;AKv5+BA;EAAiC,gBAAA;AL25+BjC;;AK15+BA;EAAkC,gBAAA;AL85+BlC;;AK75+BA;EAAkC,gBAAA;ALi6+BlC;;AKh6+BA;EAA2B,gBAAA;ALo6+B3B;;AKn6+BA;EAAyC,gBAAA;ALu6+BzC;;AKt6+BA;EAAyC,gBAAA;AL06+BzC;;AKz6+BA;EAA2B,gBAAA;AL66+B3B;;AK56+BA;EAA0C,gBAAA;ALg7+B1C;;AK/6+BA;EAA0C,gBAAA;ALm7+B1C;;AKl7+BA;EAAoC,gBAAA;ALs7+BpC;;AKr7+BA;EAAoC,gBAAA;ALy7+BpC;;AKx7+BA;EAAgC,gBAAA;AL47+BhC;;AK37+BA;EAAgC,gBAAA;AL+7+BhC;;AK97+BA;EAAyB,gBAAA;ALk8+BzB;;AKj8+BA;EAAyB,gBAAA;ALq8+BzB;;AKp8+BA;EAA+B,gBAAA;ALw8+B/B;;AKv8+BA;EAA+B,gBAAA;AL28+B/B;;AK18+BA;EAA4B,gBAAA;AL88+B5B;;AK78+BA;EAA4B,gBAAA;ALi9+B5B;;AKh9+BA;EAA8B,gBAAA;ALo9+B9B;;AKn9+BA;EAA8B,gBAAA;ALu9+B9B;;AKt9+BA;EAA4B,gBAAA;AL09+B5B;;AKz9+BA;EAA4B,gBAAA;AL69+B5B;;AK59+BA;EAA+B,gBAAA;ALg++B/B;;AK/9+BA;EAA+B,gBAAA;ALm++B/B;;AKl++BA;EAAwB,gBAAA;ALs++BxB;;AKr++BA;EAAwB,gBAAA;ALy++BxB;;AKx++BA;EAAwB,gBAAA;AL4++BxB;;AK3++BA;EAAwB,gBAAA;AL+++BxB;;AK9++BA;EAA4B,gBAAA;ALk/+B5B;;AKj/+BA;EAA4B,gBAAA;ALq/+B5B;;AKp/+BA;EAA8B,gBAAA;ALw/+B9B;;AKv/+BA;EAA8B,gBAAA;AL2/+B9B;;AK1/+BA;EAA2B,gBAAA;AL8/+B3B;;AK7/+BA;EAA2B,gBAAA;ALig/B3B;;AKhg/BA;EAAyB,gBAAA;ALog/BzB;;AKng/BA;EAAyB,gBAAA;ALug/BzB;;AKtg/BA;EAA2B,gBAAA;AL0g/B3B;;AKzg/BA;EAA2B,gBAAA;AL6g/B3B;;AK5g/BA;EAAuB,gBAAA;ALgh/BvB;;AK/g/BA;EAAuB,gBAAA;ALmh/BvB;;AKlh/BA;EAAyB,gBAAA;ALsh/BzB;;AKrh/BA;EAAyB,gBAAA;ALyh/BzB;;AKxh/BA;EAA+B,gBAAA;AL4h/B/B;;AK3h/BA;EAA+B,gBAAA;AL+h/B/B;;AK9h/BA;EAAuB,gBAAA;ALki/BvB;;AKji/BA;EAA0B,gBAAA;ALqi/B1B;;AKpi/BA;EAA0B,gBAAA;ALwi/B1B;;AKvi/BA;EAAuB,gBAAA;AL2i/BvB;;AK1i/BA;EAAuB,gBAAA;AL8i/BvB;;AK7i/BA;EAAwB,gBAAA;ALij/BxB;;AKhj/BA;EAAwB,gBAAA;ALoj/BxB;;AKnj/BA;EAA0B,gBAAA;ALuj/B1B;;AKtj/BA;EAA0B,gBAAA;AL0j/B1B;;AKzj/BA;EAA4B,gBAAA;AL6j/B5B;;AK5j/BA;EAA4B,gBAAA;ALgk/B5B;;AK/j/BA;EAA4B,gBAAA;ALmk/B5B;;AKlk/BA;EAA4B,gBAAA;ALsk/B5B;;AKrk/BA;EAA4B,gBAAA;ALyk/B5B;;AKxk/BA;EAA4B,gBAAA;AL4k/B5B;;AK3k/BA;EAA4B,gBAAA;AL+k/B5B;;AK9k/BA;EAA4B,gBAAA;ALkl/B5B;;AKjl/BA;EAAmC,gBAAA;ALql/BnC;;AKpl/BA;EAAmC,gBAAA;ALwl/BnC;;AKvl/BA;EAA0B,gBAAA;AL2l/B1B;;AK1l/BA;EAA0B,gBAAA;AL8l/B1B;;AK7l/BA;EAA8B,gBAAA;ALim/B9B;;AKhm/BA;EAA8B,gBAAA;ALom/B9B;;AKnm/BA;EAA4B,gBAAA;ALum/B5B;;AKtm/BA;EAA4B,gBAAA;AL0m/B5B;;AKzm/BA;EAA2B,gBAAA;AL6m/B3B;;AK5m/BA;EAA2B,gBAAA;ALgn/B3B;;AK/m/BA;EAAkC,gBAAA;ALmn/BlC;;AKln/BA;EAAkC,gBAAA;ALsn/BlC;;AKrn/BA;EAAgC,gBAAA;ALyn/BhC;;AKxn/BA;EAAgC,gBAAA;AL4n/BhC;;AK3n/BA;EAAuC,gBAAA;AL+n/BvC;;AK9n/BA;EAAuC,gBAAA;ALko/BvC;;AKjo/BA;EAA2B,gBAAA;ALqo/B3B;;AKpo/BA;EAA2B,gBAAA;ALwo/B3B;;AKvo/BA;EAA6B,gBAAA;AL2o/B7B;;AK1o/BA;EAA6B,gBAAA;AL8o/B7B;;AK7o/BA;EAAkC,gBAAA;ALip/BlC;;AKhp/BA;EAAkC,gBAAA;ALop/BlC;;AKnp/BA;EAAgC,gBAAA;ALup/BhC;;AKtp/BA;EAAgC,gBAAA;AL0p/BhC;;AKzp/BA;EAA2B,gBAAA;AL6p/B3B;;AK5p/BA;EAA2B,gBAAA;ALgq/B3B;;AK/p/BA;EAA8B,gBAAA;ALmq/B9B;;AKlq/BA;EAA8B,gBAAA;ALsq/B9B;;AKrq/BA;EAAiC,gBAAA;ALyq/BjC;;AKxq/BA;EAAiC,gBAAA;AL4q/BjC;;AK3q/BA;EAA4B,gBAAA;AL+q/B5B;;AK9q/BA;EAA4B,gBAAA;ALkr/B5B;;AKjr/BA;EAAyB,gBAAA;ALqr/BzB;;AKpr/BA;EAAyB,gBAAA;ALwr/BzB;;AKvr/BA;EAA2B,gBAAA;AL2r/B3B;;AK1r/BA;EAA2B,gBAAA;AL8r/B3B;;AK7r/BA;EAA2B,gBAAA;ALis/B3B;;AKhs/BA;EAA2B,gBAAA;ALos/B3B;;AKns/BA;EAA2B,gBAAA;ALus/B3B;;AKts/BA;EAA2B,gBAAA;AL0s/B3B;;AKzs/BA;EAA2B,gBAAA;AL6s/B3B;;AK5s/BA;EAA2B,gBAAA;ALgt/B3B;;AK/s/BA;EAAyB,gBAAA;ALmt/BzB;;AKlt/BA;EAAyB,gBAAA;ALst/BzB;;AKrt/BA;EAAsB,gBAAA;ALyt/BtB;;AKxt/BA;EAAsB,gBAAA;AL4t/BtB;;AK3t/BA;EAAsC,gBAAA;AL+t/BtC;;AK9t/BA;EAAsC,gBAAA;ALku/BtC;;AKju/BA;EAAmC,gBAAA;ALqu/BnC;;AKpu/BA;EAAmC,gBAAA;ALwu/BnC;;AKvu/BA;EAAsC,gBAAA;AL2u/BtC;;AK1u/BA;EAAsC,gBAAA;AL8u/BtC;;AK7u/BA;EAAsC,gBAAA;ALiv/BtC;;AKhv/BA;EAAsC,gBAAA;ALov/BtC;;AKnv/BA;EAAsC,gBAAA;ALuv/BtC;;AKtv/BA;EAAsC,gBAAA;AL0v/BtC;;AKzv/BA;EAAwC,gBAAA;AL6v/BxC;;AK5v/BA;EAAwC,gBAAA;ALgw/BxC;;AK/v/BA;EAA2B,gBAAA;ALmw/B3B;;AKlw/BA;EAA2B,gBAAA;ALsw/B3B;;AKrw/BA;EAAyB,gBAAA;ALyw/BzB;;AKxw/BA;EAAyB,gBAAA;AL4w/BzB;;AK3w/BA;EAAuB,gBAAA;AL+w/BvB;;AK9w/BA;EAAuB,gBAAA;ALkx/BvB;;AKjx/BA;EAAuB,gBAAA;ALqx/BvB;;AKpx/BA;EAAuB,gBAAA;ALwx/BvB;;AKvx/BA;EAAsB,gBAAA;AL2x/BtB;;AK1x/BA;EAAsB,gBAAA;AL8x/BtB;;AK7x/BA;EAA2B,gBAAA;ALiy/B3B;;AKhy/BA;EAA2B,gBAAA;ALoy/B3B;;AKny/BA;EAAyB,gBAAA;ALuy/BzB;;AKty/BA;EAAyB,gBAAA;AL0y/BzB;;AKzy/BA;EAAqC,gBAAA;AL6y/BrC;;AK5y/BA;EAAqC,gBAAA;ALgz/BrC;;AK/y/BA;EAAmC,gBAAA;ALmz/BnC;;AKlz/BA;EAAmC,gBAAA;ALsz/BnC;;AKrz/BA;EAA4B,gBAAA;ALyz/B5B;;AKxz/BA;EAA4B,gBAAA;AL4z/B5B;;AK3z/BA;EAA6B,gBAAA;AL+z/B7B;;AK9z/BA;EAA6B,gBAAA;ALk0/B7B;;AKj0/BA;EAA2B,gBAAA;ALq0/B3B;;AKp0/BA;EAA2B,gBAAA;ALw0/B3B;;AKv0/BA;EAAgC,gBAAA;AL20/BhC;;AK10/BA;EAAgC,gBAAA;AL80/BhC;;AK70/BA;EAA8B,gBAAA;ALi1/B9B;;AKh1/BA;EAA8B,gBAAA;ALo1/B9B;;AKn1/BA;EAA+B,gBAAA;ALu1/B/B;;AKt1/BA;EAA+B,gBAAA;AL01/B/B;;AKz1/BA;EAA+B,gBAAA;AL61/B/B;;AK51/BA;EAA+B,gBAAA;ALg2/B/B;;AK/1/BA;EAA+B,gBAAA;ALm2/B/B;;AKl2/BA;EAA+B,gBAAA;ALs2/B/B;;AKr2/BA;EAA+B,gBAAA;ALy2/B/B;;AKx2/BA;EAA+B,gBAAA;AL42/B/B;;AK32/BA;EAA+B,gBAAA;AL+2/B/B;;AK92/BA;EAA+B,gBAAA;ALk3/B/B;;AKj3/BA;EAA+B,gBAAA;ALq3/B/B;;AKp3/BA;EAA+B,gBAAA;ALw3/B/B;;AKv3/BA;EAA6B,gBAAA;AL23/B7B;;AK13/BA;EAA6B,gBAAA;AL83/B7B;;AK73/BA;EAAyB,gBAAA;ALi4/BzB;;AKh4/BA;EAAyB,gBAAA;ALo4/BzB;;AKn4/BA;EAAiC,gBAAA;ALu4/BjC;;AKt4/BA;EAAiC,gBAAA;AL04/BjC;;AKz4/BA;EAA2B,gBAAA;AL64/B3B;;AK54/BA;EAA2B,gBAAA;ALg5/B3B;;AK/4/BA;EAA4B,gBAAA;ALm5/B5B;;AKl5/BA;EAA4B,gBAAA;ALs5/B5B;;AKr5/BA;EAAuB,gBAAA;ALy5/BvB;;AKx5/BA;EAAuB,gBAAA;AL45/BvB;;AK35/BA;EAA0B,gBAAA;AL+5/B1B;;AK95/BA;EAA0B,gBAAA;ALk6/B1B;;AKj6/BA;EAA0B,gBAAA;ALq6/B1B;;AKp6/BA;EAA0B,gBAAA;ALw6/B1B;;AKv6/BA;EAAyB,gBAAA;AL26/BzB;;AK16/BA;EAAyB,gBAAA;AL86/BzB;;AK76/BA;EAAyB,gBAAA;ALi7/BzB;;AKh7/BA;EAAyB,gBAAA;ALo7/BzB;;AKn7/BA;EAA8B,gBAAA;ALu7/B9B;;AKt7/BA;EAA8B,gBAAA;AL07/B9B;;AKz7/BA;EAAgC,gBAAA;AL67/BhC;;AK57/BA;EAAgC,gBAAA;ALg8/BhC;;AK/7/BA;EAA4B,gBAAA;ALm8/B5B;;AKl8/BA;EAA4B,gBAAA;ALs8/B5B;;AKr8/BA;EAAyB,gBAAA;ALy8/BzB;;AKx8/BA;EAAyB,gBAAA;AL48/BzB;;AK38/BA;EAA6B,gBAAA;AL+8/B7B;;AK98/BA;EAA6B,gBAAA;ALk9/B7B;;AKj9/BA;EAA6B,gBAAA;ALq9/B7B;;AKp9/BA;EAA6B,gBAAA;ALw9/B7B;;AKv9/BA;EAAmC,gBAAA;AL29/BnC;;AK19/BA;EAAmC,gBAAA;AL89/BnC;;AK79/BA;EAAiC,gBAAA;ALi+/BjC;;AKh+/BA;EAAiC,gBAAA;ALo+/BjC;;AKn+/BA;EAA2B,gBAAA;ALu+/B3B;;AKt+/BA;EAA2B,gBAAA;AL0+/B3B;;AKz+/BA;EAA4B,gBAAA;AL6+/B5B;;AK5+/BA;EAA4B,gBAAA;ALg//B5B;;AK/+/BA;EAA8B,gBAAA;ALm//B9B;;AKl//BA;EAA8B,gBAAA;ALs//B9B;;AKr//BA;EAA4B,gBAAA;ALy//B5B;;AKx//BA;EAA4B,gBAAA;AL4//B5B;;AK3//BA;EAA2B,gBAAA;AL+//B3B;;AK9//BA;EAA2B,gBAAA;ALkggC3B;;AKjggCA;EAAwB,gBAAA;ALqggCxB;;AKpggCA;EAAwB,gBAAA;ALwggCxB;;AKvggCA;EAA0B,gBAAA;AL2ggC1B;;AK1ggCA;EAA0B,gBAAA;AL8ggC1B;;AK7ggCA;EAAuB,gBAAA;ALihgCvB;;AKhhgCA;EAAuB,gBAAA;ALohgCvB;;AKnhgCA;EAA0B,gBAAA;ALuhgC1B;;AKthgCA;EAA0B,gBAAA;AL0hgC1B;;AKzhgCA;EAA6B,gBAAA;AL6hgC7B;;AK5hgCA;EAA6B,gBAAA;ALgigC7B;;AK/hgCA;EAA6B,gBAAA;ALmigC7B;;AKligCA;EAA6B,gBAAA;ALsigC7B;;AKrigCA;EAAqB,gBAAA;ALyigCrB;;AKxigCA;EAAqB,gBAAA;AL4igCrB;;AK3igCA;EAAsB,gBAAA;AL+igCtB;;AK9igCA;EAAsB,gBAAA;ALkjgCtB;;AKjjgCA;EAA2B,gBAAA;ALqjgC3B;;AKpjgCA;EAA2B,gBAAA;ALwjgC3B;;AKvjgCA;EAAyB,gBAAA;AL2jgCzB;;AK1jgCA;EAAyB,gBAAA;AL8jgCzB;;AK7jgCA;EAAwB,gBAAA;ALikgCxB;;AKhkgCA;EAAwB,gBAAA;ALokgCxB;;AKnkgCA;EAA6B,gBAAA;ALukgC7B;;AKtkgCA;EAA6B,gBAAA;AL0kgC7B;;AKzkgCA;EAAuB,gBAAA;AL6kgCvB;;AK5kgCA;EAAuB,gBAAA;ALglgCvB;;AK/kgCA;EAAyB,gBAAA;ALmlgCzB;;AKllgCA;EAAyB,gBAAA;ALslgCzB;;AKrlgCA;EAA2B,gBAAA;ALylgC3B;;AKxlgCA;EAA2B,gBAAA;AL4lgC3B;;AK3lgCA;EAA8B,gBAAA;AL+lgC9B;;AK9lgCA;EAA8B,gBAAA;ALkmgC9B;;AKjmgCA;EAAuB,gBAAA;ALqmgCvB;;AKpmgCA;EAAuB,gBAAA;ALwmgCvB;;AKvmgCA;EAAwB,gBAAA;AL2mgCxB;;AK1mgCA;EAAwB,gBAAA;AL8mgCxB;;AK7mgCA;EAA4B,gBAAA;ALingC5B;;AKhngCA;EAA4B,gBAAA;ALongC5B;;AKnngCA;EAA0B,gBAAA;ALungC1B;;AKtngCA;EAAgC,gBAAA;AL0ngChC;;AKzngCA;EAAgC,gBAAA;AL6ngChC;;AK5ngCA;EAAgC,gBAAA;ALgogChC;;AK/ngCA;EAAgC,gBAAA;ALmogChC;;AKlogCA;EAA0B,gBAAA;ALsogC1B;;AKrogCA;EAAiC,gBAAA;ALyogCjC;;AKxogCA;EAAiC,gBAAA;AL4ogCjC;;AK3ogCA;EAA8B,gBAAA;AL+ogC9B;;AK9ogCA;EAA8B,gBAAA;ALkpgC9B;;AKjpgCA;EAAkC,gBAAA;ALqpgClC;;AKppgCA;EAAkC,gBAAA;ALwpgClC;;AKvpgCA;EAAyB,gBAAA;AL2pgCzB;;AK1pgCA;EAAsB,gBAAA;AL8pgCtB;;AK7pgCA;EAA2B,gBAAA;ALiqgC3B;;AKhqgCA;EAA4B,gBAAA;ALoqgC5B;;AKnqgCA;EAA4B,gBAAA;ALuqgC5B;;AKtqgCA;EAAyB,gBAAA;AL0qgCzB;;AKzqgCA;EAAyB,gBAAA;AL6qgCzB;;AK5qgCA;EAAgC,gBAAA;ALgrgChC;;AK/qgCA;EAAgC,gBAAA;ALmrgChC;;AKlrgCA;EAA2B,gBAAA;ALsrgC3B;;AKrrgCA;EAA2B,gBAAA;ALyrgC3B;;AKxrgCA;EAA+B,gBAAA;AL4rgC/B;;AK3rgCA;EAA+B,gBAAA;AL+rgC/B;;AK9rgCA;EAA+B,gBAAA;ALksgC/B;;AKjsgCA;EAA+B,gBAAA;ALqsgC/B;;AKpsgCA;EAAkC,gBAAA;ALwsgClC;;AKvsgCA;EAAkC,gBAAA;AL2sgClC;;AK1sgCA;EAA2B,gBAAA;AL8sgC3B;;AK7sgCA;EAAiC,gBAAA;ALitgCjC;;AKhtgCA;EAAiC,gBAAA;ALotgCjC;;AKntgCA;EAA2B,gBAAA;ALutgC3B;;AKttgCA;EAAgC,gBAAA;AL0tgChC;;AKztgCA;EAAgC,gBAAA;AL6tgChC;;AK5tgCA;EAAwB,gBAAA;ALgugCxB;;AK/tgCA;EAAwB,gBAAA;ALmugCxB;;AKlugCA;EAA4B,gBAAA;ALsugC5B;;AKrugCA;EAA4B,gBAAA;ALyugC5B;;AKxugCA;EAAsB,gBAAA;AL4ugCtB;;AK3ugCA;EAAsB,gBAAA;AL+ugCtB;;AK9ugCA;EAA0B,gBAAA;ALkvgC1B;;AKjvgCA;EAA0B,gBAAA;ALqvgC1B;;AKpvgCA;EAA+B,gBAAA;ALwvgC/B;;AKvvgCA;EAA+B,gBAAA;AL2vgC/B;;AK1vgCA;EAAkC,gBAAA;AL8vgClC;;AK7vgCA;EAAkC,gBAAA;ALiwgClC;;AKhwgCA;EAA2B,gBAAA;ALowgC3B;;AKnwgCA;EAA2B,gBAAA;ALuwgC3B;;AKtwgCA;EAA6B,gBAAA;AL0wgC7B;;AKzwgCA;EAA6B,gBAAA;AL6wgC7B;;AK5wgCA;EAA2B,gBAAA;ALgxgC3B;;AK/wgCA;EAA2B,gBAAA;ALmxgC3B;;AKlxgCA;EAAyB,gBAAA;ALsxgCzB;;AKrxgCA;EAAyB,gBAAA;ALyxgCzB;;AKxxgCA;EAAyB,gBAAA;AL4xgCzB;;AK3xgCA;EAAyB,gBAAA;AL+xgCzB;;AK9xgCA;EAAyB,gBAAA;ALkygCzB;;AKjygCA;EAAyB,gBAAA;ALqygCzB;;AKpygCA;EAA2B,gBAAA;ALwygC3B;;AKvygCA;EAA2B,gBAAA;AL2ygC3B;;AK1ygCA;EAA+B,gBAAA;AL8ygC/B;;AK7ygCA;EAA+B,gBAAA;ALizgC/B;;AKhzgCA;EAA6B,gBAAA;ALozgC7B;;AKnzgCA;EAA6B,gBAAA;ALuzgC7B;;AKtzgCA;EAA6B,gBAAA;AL0zgC7B;;AKzzgCA;EAA6B,gBAAA;AL6zgC7B;;AK5zgCA;EAA4B,gBAAA;ALg0gC5B;;AK/zgCA;EAA4B,gBAAA;ALm0gC5B;;AKl0gCA;EAA8B,gBAAA;ALs0gC9B;;AKr0gCA;EAA8B,gBAAA;ALy0gC9B;;AKx0gCA;EAA4B,gBAAA;AL40gC5B;;AK30gCA;EAA4B,gBAAA;AL+0gC5B;;AK90gCA;EAA8B,gBAAA;ALk1gC9B;;AKj1gCA;EAA8B,gBAAA;ALq1gC9B;;AKp1gCA;EAAgC,gBAAA;ALw1gChC;;AKv1gCA;EAAgC,gBAAA;AL21gChC;;AK11gCA;EAA4B,gBAAA;AL81gC5B;;AK71gCA;EAA4B,gBAAA;ALi2gC5B;;AKh2gCA;EAA+B,gBAAA;ALo2gC/B;;AKn2gCA;EAA+B,gBAAA;ALu2gC/B;;AKt2gCA;EAA6B,gBAAA;AL02gC7B;;AKz2gCA;EAA6B,gBAAA;AL62gC7B;;AK52gCA;EAAuB,gBAAA;ALg3gCvB;;AK/2gCA;EAA8B,gBAAA;ALm3gC9B;;AKl3gCA;EAA8B,gBAAA;ALs3gC9B;;AKr3gCA;EAA2B,gBAAA;ALy3gC3B;;AKx3gCA;EAA2B,gBAAA;AL43gC3B;;AK33gCA;EAA+B,gBAAA;AL+3gC/B;;AK93gCA;EAA+B,gBAAA;ALk4gC/B;;AKj4gCA;EAA2B,gBAAA;ALq4gC3B;;AKp4gCA;EAA2B,gBAAA;ALw4gC3B;;AKv4gCA;EAA4B,gBAAA;AL24gC5B;;AK14gCA;EAA4B,gBAAA;AL84gC5B;;AK74gCA;EAAuB,gBAAA;ALi5gCvB;;AKh5gCA;EAA8B,gBAAA;ALo5gC9B;;AKn5gCA;EAA8B,gBAAA;ALu5gC9B;;AKt5gCA;EAA8B,gBAAA;AL05gC9B;;AKz5gCA;EAA8B,gBAAA;AL65gC9B;;AK55gCA;EAA4B,gBAAA;ALg6gC5B;;AK/5gCA;EAA4B,gBAAA;ALm6gC5B;;AKl6gCA;EAA4B,gBAAA;ALs6gC5B;;AKr6gCA;EAA4B,gBAAA;ALy6gC5B;;AKx6gCA;EAA4B,gBAAA;AL46gC5B;;AK36gCA;EAA4B,gBAAA;AL+6gC5B;;AK96gCA;EAA6B,gBAAA;ALk7gC7B;;AKj7gCA;EAA6B,gBAAA;ALq7gC7B;;AKp7gCA;EAA+B,gBAAA;ALw7gC/B;;AKv7gCA;EAA+B,gBAAA;AL27gC/B;;AK17gCA;EAA6B,gBAAA;AL87gC7B;;AK77gCA;EAA6B,gBAAA;ALi8gC7B;;AKh8gCA;EAA2B,gBAAA;ALo8gC3B;;AKn8gCA;EAA2B,gBAAA;ALu8gC3B;;AKt8gCA;EAA6B,gBAAA;AL08gC7B;;AKz8gCA;EAA6B,gBAAA;AL68gC7B;;AK58gCA;EAA2B,gBAAA;ALg9gC3B;;AK/8gCA;EAA2B,gBAAA;ALm9gC3B;;AKl9gCA;EAA8B,gBAAA;ALs9gC9B;;AKr9gCA;EAA8B,gBAAA;ALy9gC9B;;AKx9gCA;EAA8B,gBAAA;AL49gC9B;;AK39gCA;EAA8B,gBAAA;AL+9gC9B;;AK99gCA;EAAgC,gBAAA;ALk+gChC;;AKj+gCA;EAAgC,gBAAA;ALq+gChC;;AKp+gCA;EAAgC,gBAAA;ALw+gChC;;AKv+gCA;EAAgC,gBAAA;AL2+gChC;;AK1+gCA;EAA8B,gBAAA;AL8+gC9B;;AK7+gCA;EAA8B,gBAAA;ALi/gC9B;;AKh/gCA;EAA6B,gBAAA;ALo/gC7B;;AKn/gCA;EAA6B,gBAAA;ALu/gC7B;;AKt/gCA;EAA4B,gBAAA;AL0/gC5B;;AKz/gCA;EAA4B,gBAAA;AL6/gC5B;;AK5/gCA;EAAgC,gBAAA;ALgghChC;;AK//gCA;EAAgC,gBAAA;ALmghChC;;AKlghCA;EAA8B,gBAAA;ALsghC9B;;AKrghCA;EAA8B,gBAAA;ALyghC9B;;AKxghCA;EAA8B,gBAAA;AL4ghC9B;;AK3ghCA;EAA8B,gBAAA;AL+ghC9B;;AK9ghCA;EAA4B,gBAAA;ALkhhC5B;;AKjhhCA;EAA4B,gBAAA;ALqhhC5B;;AKphhCA;EAA+B,gBAAA;ALwhhC/B;;AKvhhCA;EAA+B,gBAAA;AL2hhC/B;;AK1hhCA;EAA8B,gBAAA;AL8hhC9B;;AK7hhCA;EAA8B,gBAAA;ALiihC9B;;AKhihCA;EAA4B,gBAAA;ALoihC5B;;AKnihCA;EAA4B,gBAAA;ALuihC5B;;AKtihCA;EAA2B,gBAAA;AL0ihC3B;;AKzihCA;EAA2B,gBAAA;AL6ihC3B;;AK5ihCA;EAAuB,gBAAA;ALgjhCvB;;AK/ihCA;EAAuB,gBAAA;ALmjhCvB;;AKljhCA;EAA2B,gBAAA;ALsjhC3B;;AKrjhCA;EAA2B,gBAAA;ALyjhC3B;;AKxjhCA;EAA2B,gBAAA;AL4jhC3B;;AK3jhCA;EAA2B,gBAAA;AL+jhC3B;;AK9jhCA;EAAyB,gBAAA;ALkkhCzB;;AKjkhCA;EAAyB,gBAAA;ALqkhCzB;;AKpkhCA;EAA+B,gBAAA;ALwkhC/B;;AKvkhCA;EAA+B,gBAAA;AL2khC/B;;AK1khCA;EAAgC,gBAAA;AL8khChC;;AK7khCA;EAAgC,gBAAA;ALilhChC;;AKhlhCA;EAA8B,gBAAA;ALolhC9B;;AKnlhCA;EAA8B,gBAAA;ALulhC9B;;AKtlhCA;EAAuB,gBAAA;AL0lhCvB;;AKzlhCA;EAAuB,gBAAA;AL6lhCvB;;AK5lhCA;EAA0B,gBAAA;ALgmhC1B;;AK/lhCA;EAA0B,gBAAA;ALmmhC1B;;AKlmhCA;EAAyB,gBAAA;ALsmhCzB;;AKrmhCA;EAAyB,gBAAA;ALymhCzB;;AKxmhCA;EAAuB,gBAAA;AL4mhCvB;;AK3mhCA;EAAuB,gBAAA;AL+mhCvB;;AK9mhCA;EAA6B,gBAAA;ALknhC7B;;AKjnhCA;EAA6B,gBAAA;ALqnhC7B;;AKpnhCA;EAAwB,gBAAA;ALwnhCxB;;AKvnhCA;EAAwB,gBAAA;AL2nhCxB;;AK1nhCA;EAA8B,gBAAA;AL8nhC9B;;AK7nhCA;EAA8B,gBAAA;ALiohC9B;;AKhohCA;EAAiC,gBAAA;ALoohCjC;;AKnohCA;EAAiC,gBAAA;ALuohCjC;;AKtohCA;EAAwB,gBAAA;AL0ohCxB;;AKzohCA;EAAwB,gBAAA;AL6ohCxB;;AK5ohCA;EAA0B,gBAAA;ALgphC1B;;AK/ohCA;EAA0B,gBAAA;ALmphC1B;;AKlphCA;EAA0B,gBAAA;ALsphC1B;;AKrphCA;EAA0B,gBAAA;ALyphC1B;;AKxphCA;EAA0B,gBAAA;AL4phC1B;;AK3phCA;EAA0B,gBAAA;AL+phC1B;;AK9phCA;EAAwB,gBAAA;ALkqhCxB;;AKjqhCA;EAAwB,gBAAA;ALqqhCxB;;AKpqhCA;EAAwB,gBAAA;ALwqhCxB;;AKvqhCA;EAAwB,gBAAA;AL2qhCxB;;AK1qhCA;EAA2B,gBAAA;AL8qhC3B;;AK7qhCA;EAA2B,gBAAA;ALirhC3B;;AKhrhCA;EAA2B,gBAAA;ALorhC3B;;AKnrhCA;EAA2B,gBAAA;ALurhC3B;;AKtrhCA;EAA2B,gBAAA;AL0rhC3B;;AKzrhCA;EAA2B,gBAAA;AL6rhC3B;;AK5rhCA;EAA2B,gBAAA;ALgshC3B;;AK/rhCA;EAA2B,gBAAA;ALmshC3B;;AKlshCA;EAA6B,gBAAA;ALsshC7B;;AKrshCA;EAA6B,gBAAA;ALyshC7B;;AKxshCA;EAAiC,gBAAA;AL4shCjC;;AK3shCA;EAAiC,gBAAA;AL+shCjC;;AK9shCA;EAA+B,gBAAA;ALkthC/B;;AKjthCA;EAA+B,gBAAA;ALqthC/B;;AKpthCA;EAAkC,gBAAA;ALwthClC;;AKvthCA;EAAkC,gBAAA;AL2thClC;;AK1thCA;EAAyB,gBAAA;AL8thCzB;;AK7thCA;EAAgC,gBAAA;ALiuhChC;;AKhuhCA;EAAgC,gBAAA;ALouhChC;;AKnuhCA;EAAiC,gBAAA;ALuuhCjC;;AKtuhCA;EAAiC,gBAAA;AL0uhCjC;;AKzuhCA;EAA8B,gBAAA;AL6uhC9B;;AK5uhCA;EAA8B,gBAAA;ALgvhC9B;;AK/uhCA;EAAiC,gBAAA;ALmvhCjC;;AKlvhCA;EAAiC,gBAAA;ALsvhCjC;;AKrvhCA;EAAyB,gBAAA;ALyvhCzB;;AKxvhCA;EAA8B,gBAAA;AL4vhC9B;;AK3vhCA;EAA8B,gBAAA;AL+vhC9B;;AK9vhCA;EAA+B,gBAAA;ALkwhC/B;;AKjwhCA;EAA+B,gBAAA;ALqwhC/B;;AKpwhCA;EAA8B,gBAAA;ALwwhC9B;;AKvwhCA;EAA8B,gBAAA;AL2whC9B;;AK1whCA;EAAkC,gBAAA;AL8whClC;;AK7whCA;EAAkC,gBAAA;ALixhClC;;AKhxhCA;EAAgC,gBAAA;ALoxhChC;;AKnxhCA;EAAgC,gBAAA;ALuxhChC;;AKtxhCA;EAAkC,gBAAA;AL0xhClC;;AKzxhCA;EAAkC,gBAAA;AL6xhClC;;AK5xhCA;EAAgC,gBAAA;ALgyhChC;;AK/xhCA;EAAgC,gBAAA;ALmyhChC;;AKlyhCA;EAAkC,gBAAA;ALsyhClC;;AKryhCA;EAAkC,gBAAA;ALyyhClC;;AKxyhCA;EAAgC,gBAAA;AL4yhChC;;AK3yhCA;EAAgC,gBAAA;AL+yhChC;;AK9yhCA;EAAkC,gBAAA;ALkzhClC;;AKjzhCA;EAAkC,gBAAA;ALqzhClC;;AKpzhCA;EAAgC,gBAAA;ALwzhChC;;AKvzhCA;EAAgC,gBAAA;AL2zhChC;;AK1zhCA;EAAgC,gBAAA;AL8zhChC;;AK7zhCA;EAAgC,gBAAA;ALi0hChC;;AKh0hCA;EAA8B,gBAAA;ALo0hC9B;;AKn0hCA;EAA8B,gBAAA;ALu0hC9B;;AKt0hCA;EAAiC,gBAAA;AL00hCjC;;AKz0hCA;EAAiC,gBAAA;AL60hCjC;;AK50hCA;EAA6B,gBAAA;ALg1hC7B;;AK/0hCA;EAA6B,gBAAA;ALm1hC7B;;AKl1hCA;EAA0B,gBAAA;ALs1hC1B;;AKr1hCA;EAA0B,gBAAA;ALy1hC1B;;AKx1hCA;EAAwB,gBAAA;AL41hCxB;;AK31hCA;EAAyB,gBAAA;AL+1hCzB;;AK91hCA;EAAuB,gBAAA;ALk2hCvB;;AKj2hCA;EAA2B,gBAAA;ALq2hC3B;;AKp2hCA;EAA2B,gBAAA;ALw2hC3B;;AKv2hCA;EAA4B,gBAAA;AL22hC5B;;AK12hCA;EAA4B,gBAAA;AL82hC5B;;AK72hCA;EAA2B,gBAAA;ALi3hC3B;;AKh3hCA;EAA2B,gBAAA;ALo3hC3B;;AKn3hCA;EAAyB,gBAAA;ALu3hCzB;;AKt3hCA;EAAyB,gBAAA;AL03hCzB;;AKz3hCA;EAA0B,gBAAA;AL63hC1B;;AK53hCA;EAAyB,gBAAA;ALg4hCzB;;AK/3hCA;EAAyB,gBAAA;ALm4hCzB;;AKl4hCA;EAAkC,gBAAA;ALs4hClC;;AKr4hCA;EAAkC,gBAAA;ALy4hClC;;AKx4hCA;EAA6B,gBAAA;AL44hC7B;;AK34hCA;EAA6B,gBAAA;AL+4hC7B;;AK94hCA;EAA2B,gBAAA;ALk5hC3B;;AKj5hCA;EAA2B,gBAAA;ALq5hC3B;;AKp5hCA;EAAuB,gBAAA;ALw5hCvB;;AKv5hCA;EAA4B,gBAAA;AL25hC5B;;AK15hCA;EAA4B,gBAAA;AL85hC5B;;AK75hCA;EAAwB,gBAAA;ALi6hCxB;;AKh6hCA;EAAwB,gBAAA;ALo6hCxB;;AKn6hCA;EAA0B,gBAAA;ALu6hC1B;;AKt6hCA;EAA0B,gBAAA;AL06hC1B;;AKz6hCA;EAAiC,gBAAA;AL66hCjC;;AK56hCA;EAAiC,gBAAA;ALg7hCjC;;AK/6hCA;EAAuB,gBAAA;ALm7hCvB;;AKl7hCA;EAAuB,gBAAA;ALs7hCvB;;AKr7hCA;EAA0B,gBAAA;ALy7hC1B;;AKx7hCA;EAA0B,gBAAA;AL47hC1B;;AK37hCA;EAA8B,gBAAA;AL+7hC9B;;AK97hCA;EAA8B,gBAAA;ALk8hC9B;;AKj8hCA;EAAyB,gBAAA;ALq8hCzB;;AKp8hCA;EAAyB,gBAAA;ALw8hCzB;;AKv8hCA;EAA6B,gBAAA;AL28hC7B;;AK18hCA;EAA6B,gBAAA;AL88hC7B;;AK78hCA;EAA0B,gBAAA;ALi9hC1B;;AKh9hCA;EAA0B,gBAAA;ALo9hC1B;;AKn9hCA;EAAwB,gBAAA;ALu9hCxB;;AKt9hCA;EAAwB,gBAAA;AL09hCxB;;AKz9hCA;EAA8B,gBAAA;AL69hC9B;;AK59hCA;EAA8B,gBAAA;ALg+hC9B;;AK/9hCA;EAAyB,gBAAA;ALm+hCzB;;AKl+hCA;EAAyB,gBAAA;ALs+hCzB;;AKr+hCA;EAAuB,gBAAA;ALy+hCvB;;AKx+hCA;EAAuB,gBAAA;AL4+hCvB;;AK3+hCA;EAA6B,gBAAA;AL++hC7B;;AK9+hCA;EAA6B,gBAAA;ALk/hC7B;;AKj/hCA;EAA6B,gBAAA;ALq/hC7B;;AKp/hCA;EAA6B,gBAAA;ALw/hC7B;;AKv/hCA;EAA4B,gBAAA;AL2/hC5B;;AK1/hCA;EAA4B,gBAAA;AL8/hC5B;;AK7/hCA;EAAmC,gBAAA;ALigiCnC;;AKhgiCA;EAAmC,gBAAA;ALogiCnC;;AKngiCA;EAAyC,gBAAA;ALugiCzC;;AKtgiCA;EAAyC,gBAAA;AL0giCzC;;AKzgiCA;EAAiC,gBAAA;AL6giCjC;;AK5giCA;EAAiC,gBAAA;ALghiCjC;;AK/giCA;EAAyC,gBAAA;ALmhiCzC;;AKlhiCA;EAAyC,gBAAA;ALshiCzC;;AKrhiCA;EAAyB,gBAAA;ALyhiCzB;;AKxhiCA;EAAyB,gBAAA;AL4hiCzB;;AK3hiCA;EAAyB,gBAAA;AL+hiCzB;;AK9hiCA;EAAyB,gBAAA;ALkiiCzB;;AKjiiCA;EAAyB,gBAAA;ALqiiCzB;;AKpiiCA;EAAyB,gBAAA;ALwiiCzB;;AKviiCA;EAAwB,gBAAA;AL2iiCxB;;AK1iiCA;EAAwB,gBAAA;AL8iiCxB;;AK7iiCA;EAAyB,gBAAA;ALijiCzB;;AKhjiCA;EAAyB,gBAAA;ALojiCzB;;AKnjiCA;EAAyB,gBAAA;ALujiCzB;;AKtjiCA;EAAyB,gBAAA;AL0jiCzB;;AKzjiCA;EAA8B,gBAAA;AL6jiC9B;;AK5jiCA;EAA8B,gBAAA;ALgkiC9B;;AK/jiCA;EAA6B,gBAAA;ALmkiC7B;;AKlkiCA;EAA6B,gBAAA;ALskiC7B;;AKrkiCA;EAAsB,gBAAA;ALykiCtB;;AKxkiCA;EAAsB,gBAAA;AL4kiCtB;;AK3kiCA;EAA6B,gBAAA;AL+kiC7B;;AK9kiCA;EAA6B,gBAAA;ALkliC7B;;AKjliCA;EAAuB,gBAAA;ALqliCvB;;AKpliCA;EAAuB,gBAAA;ALwliCvB;;AKvliCA;EAA0B,gBAAA;AL2liC1B;;AK1liCA;EAA0B,gBAAA;AL8liC1B;;AK7liCA;EAAwB,gBAAA;ALimiCxB;;AKhmiCA;EAAwB,gBAAA;ALomiCxB;;AKnmiCA;EAAwB,gBAAA;ALumiCxB;;AKtmiCA;EAAwB,gBAAA;AL0miCxB;;AKzmiCA;EAAuB,gBAAA;AL6miCvB;;AK5miCA;EAAuB,gBAAA;ALgniCvB;;AK/miCA;EAAyB,gBAAA;ALmniCzB;;AKlniCA;EAAyB,gBAAA;ALsniCzB;;AKrniCA;EAA4B,gBAAA;ALyniC5B;;AKxniCA;EAA4B,gBAAA;AL4niC5B;;AK3niCA;EAA6B,gBAAA;AL+niC7B;;AK9niCA;EAA6B,gBAAA;ALkoiC7B;;AKjoiCA;EAA0B,gBAAA;ALqoiC1B;;AKpoiCA;EAA0B,gBAAA;ALwoiC1B;;AKvoiCA;EAA+B,gBAAA;AL2oiC/B;;AK1oiCA;EAA+B,gBAAA;AL8oiC/B;;AK7oiCA;EAA6B,gBAAA;ALipiC7B;;AKhpiCA;EAA6B,gBAAA;ALopiC7B;;AKnpiCA;EAAqB,gBAAA;ALupiCrB;;AKtpiCA;EAAyB,gBAAA;AL0piCzB;;AKzpiCA;EAAyB,gBAAA;AL6piCzB;;AK5piCA;EAAuB,gBAAA;ALgqiCvB;;AK/piCA;EAAuB,gBAAA;ALmqiCvB;;AKlqiCA;EAAqB,gBAAA;ALsqiCrB;;AKrqiCA;EAAqB,gBAAA;ALyqiCrB;;AKxqiCA;EAAqB,gBAAA;AL4qiCrB;;AK3qiCA;EAA4B,gBAAA;AL+qiC5B;;AK9qiCA;EAA4B,gBAAA;ALkriC5B;;AKjriCA;EAA0B,gBAAA;ALqriC1B;;AKpriCA;EAA0B,gBAAA;ALwriC1B;;AKvriCA;EAA4B,gBAAA;AL2riC5B;;AK1riCA;EAA4B,gBAAA;AL8riC5B;;AK7riCA;EAAwB,gBAAA;ALisiCxB;;AKhsiCA;EAAwB,gBAAA;ALosiCxB;;AKnsiCA;EAAyB,gBAAA;ALusiCzB;;AKtsiCA;EAAyB,gBAAA;AL0siCzB;;AKzsiCA;EAAgC,gBAAA;AL6siChC;;AK5siCA;EAAgC,gBAAA;ALgtiChC;;AK/siCA;EAA0B,gBAAA;ALmtiC1B;;AKltiCA;EAA0B,gBAAA;ALstiC1B;;AKrtiCA;EAAyB,gBAAA;ALytiCzB;;AKxtiCA;EAAyB,gBAAA;AL4tiCzB;;AK3tiCA;EAAyB,gBAAA;AL+tiCzB;;AK9tiCA;EAAyB,gBAAA;ALkuiCzB;;AKjuiCA;EAAyB,gBAAA;ALquiCzB;;AKpuiCA;EAAyB,gBAAA;ALwuiCzB;;AKvuiCA;EAAyB,gBAAA;AL2uiCzB;;AK1uiCA;EAAyB,gBAAA;AL8uiCzB;;AK7uiCA;EAAyB,gBAAA;ALiviCzB;;AKhviCA;EAAyB,gBAAA;ALoviCzB;;AKnviCA;EAAyB,gBAAA;ALuviCzB;;AKtviCA;EAAyB,gBAAA;AL0viCzB;;AKzviCA;EAAyB,gBAAA;AL6viCzB;;AK5viCA;EAAyB,gBAAA;ALgwiCzB;;AK/viCA;EAAuB,gBAAA;ALmwiCvB;;AKlwiCA;EAA4B,gBAAA;ALswiC5B;;AKrwiCA;EAA4B,gBAAA;ALywiC5B;;AKxwiCA;EAA6B,gBAAA;AL4wiC7B;;AK3wiCA;EAA6B,gBAAA;AL+wiC7B;;AK9wiCA;EAAuB,gBAAA;ALkxiCvB;;AKjxiCA;EAA+B,gBAAA;ALqxiC/B;;AKpxiCA;EAA+B,gBAAA;ALwxiC/B;;AKvxiCA;EAA6B,gBAAA;AL2xiC7B;;AK1xiCA;EAA6B,gBAAA;AL8xiC7B;;AK7xiCA;EAA4B,gBAAA;ALiyiC5B;;AKhyiCA;EAA4B,gBAAA;ALoyiC5B;;AKnyiCA;EAAiC,gBAAA;ALuyiCjC;;AKtyiCA;EAAiC,gBAAA;AL0yiCjC;;AKzyiCA;EAAyB,gBAAA;AL6yiCzB;;AK5yiCA;EAAyB,gBAAA;ALgziCzB;;AK/yiCA;EAA2B,gBAAA;ALmziC3B;;AKlziCA;EAA2B,gBAAA;ALsziC3B;;AKrziCA;EAA4B,gBAAA;ALyziC5B;;AKxziCA;EAA4B,gBAAA;AL4ziC5B;;AK3ziCA;EAAwB,gBAAA;AL+ziCxB;;AK9ziCA;EAAwB,gBAAA;ALk0iCxB;;AKj0iCA;EAA0B,gBAAA;ALq0iC1B;;AKp0iCA;EAA0B,gBAAA;ALw0iC1B;;AKv0iCA;EAAqB,gBAAA;AL20iCrB;;AK10iCA;EAAqB,gBAAA;AL80iCrB;;AK70iCA;EAAwB,gBAAA;ALi1iCxB;;AKh1iCA;EAAwB,gBAAA;ALo1iCxB;;AKn1iCA;EAAqB,gBAAA;ALu1iCrB;;AKt1iCA;EAAqB,gBAAA;AL01iCrB;;AKz1iCA;EAA0B,gBAAA;AL61iC1B;;AK51iCA;EAA0B,gBAAA;ALg2iC1B;;AK/1iCA;EAA4B,gBAAA;ALm2iC5B;;AKl2iCA;EAA4B,gBAAA;ALs2iC5B;;AKr2iCA;EAAwB,gBAAA;ALy2iCxB;;AKx2iCA;EAAwB,gBAAA;AL42iCxB;;AK32iCA;EAAgC,gBAAA;AL+2iChC;;AK92iCA;EAAgC,gBAAA;ALk3iChC;;AKj3iCA;EAAwB,gBAAA;ALq3iCxB;;AKp3iCA;EAAwB,gBAAA;ALw3iCxB;;AKv3iCA;EAAkC,gBAAA;AL23iClC;;AK13iCA;EAAkC,gBAAA;AL83iClC;;AK73iCA;EAAoC,gBAAA;ALi4iCpC;;AKh4iCA;EAAoC,gBAAA;ALo4iCpC;;AKn4iCA;EAA6B,gBAAA;ALu4iC7B;;AKt4iCA;EAA6B,gBAAA;AL04iC7B;;AKz4iCA;EAAuC,gBAAA;AL64iCvC;;AK54iCA;EAAuC,gBAAA;ALg5iCvC;;AK/4iCA;EAA8B,gBAAA;ALm5iC9B;;AKl5iCA;EAA8B,gBAAA;ALs5iC9B;;AKr5iCA;EAA+B,gBAAA;ALy5iC/B;;AKx5iCA;EAA+B,gBAAA;AL45iC/B;;AK35iCA;EAA+B,gBAAA;AL+5iC/B;;AK95iCA;EAA4B,gBAAA;ALk6iC5B;;AKj6iCA;EAA4B,gBAAA;ALq6iC5B;;AKp6iCA;EAA0B,gBAAA;ALw6iC1B;;AKv6iCA;EAA0B,gBAAA;AL26iC1B;;AK16iCA;EAA2B,gBAAA;AL86iC3B;;AK76iCA;EAA2B,gBAAA;ALi7iC3B;;AKh7iCA;EAAoB,gBAAA;ALo7iCpB;;AKn7iCA;EAA6B,gBAAA;ALu7iC7B;;AKt7iCA;EAA6B,gBAAA;AL07iC7B;;AKz7iCA;EAAwB,gBAAA;AL67iCxB;;AK57iCA;EAAwB,gBAAA;ALg8iCxB;;AK/7iCA;EAAsB,gBAAA;ALm8iCtB;;AKl8iCA;EAAsB,gBAAA;ALs8iCtB;;AKr8iCA;EAA+B,gBAAA;ALy8iC/B;;AKx8iCA;EAA+B,gBAAA;AL48iC/B;;AK38iCA;EAA2B,gBAAA;AL+8iC3B;;AK98iCA;EAA2B,gBAAA;ALk9iC3B;;AKj9iCA;EAA0B,gBAAA;ALq9iC1B;;AKp9iCA;EAA0B,gBAAA;ALw9iC1B;;AKv9iCA;EAA8B,gBAAA;AL29iC9B;;AK19iCA;EAA8B,gBAAA;AL89iC9B;;AK79iCA;EAAwB,gBAAA;ALi+iCxB;;AKh+iCA;EAAwB,gBAAA;ALo+iCxB;;AKn+iCA;EAA4B,gBAAA;ALu+iC5B;;AKt+iCA;EAA4B,gBAAA;AL0+iC5B;;AKz+iCA;EAA2B,gBAAA;AL6+iC3B;;AK5+iCA;EAA2B,gBAAA;ALg/iC3B;;AK/+iCA;EAA2B,gBAAA;ALm/iC3B;;AKl/iCA;EAA2B,gBAAA;ALs/iC3B;;AKr/iCA;EAA2B,gBAAA;ALy/iC3B;;AKx/iCA;EAA2B,gBAAA;AL4/iC3B;;AK3/iCA;EAA2B,gBAAA;AL+/iC3B;;AK9/iCA;EAA2B,gBAAA;ALkgjC3B;;AKjgjCA;EAA2B,gBAAA;ALqgjC3B;;AKpgjCA;EAA2B,gBAAA;ALwgjC3B;;AKvgjCA;EAAkC,gBAAA;AL2gjClC;;AK1gjCA;EAAkC,gBAAA;AL8gjClC;;AK7gjCA;EAAgC,gBAAA;ALihjChC;;AKhhjCA;EAAgC,gBAAA;ALohjChC;;AKnhjCA;EAAgC,gBAAA;ALuhjChC;;AKthjCA;EAAgC,gBAAA;AL0hjChC;;AKzhjCA;EAAyB,gBAAA;AL6hjCzB;;AK5hjCA;EAA8B,gBAAA;ALgijC9B;;AK/hjCA;EAA8B,gBAAA;ALmijC9B;;AKlijCA;EAAgC,gBAAA;ALsijChC;;AKrijCA;EAAgC,gBAAA;ALyijChC;;AKxijCA;EAA8B,gBAAA;AL4ijC9B;;AK3ijCA;EAA8B,gBAAA;AL+ijC9B;;AK9ijCA;EAAyB,gBAAA;ALkjjCzB;;AKjjjCA;EAAiC,gBAAA;ALqjjCjC;;AKpjjCA;EAAiC,gBAAA;ALwjjCjC;;AKvjjCA;EAAiC,gBAAA;AL2jjCjC;;AK1jjCA;EAAiC,gBAAA;AL8jjCjC;;AK7jjCA;EAA+B,gBAAA;ALikjC/B;;AKhkjCA;EAA+B,gBAAA;ALokjC/B;;AKnkjCA;EAA6B,gBAAA;ALukjC7B;;AKtkjCA;EAA6B,gBAAA;AL0kjC7B;;AKzkjCA;EAA+B,gBAAA;AL6kjC/B;;AK5kjCA;EAA+B,gBAAA;ALgljC/B;;AK/kjCA;EAA6B,gBAAA;ALmljC7B;;AKlljCA;EAA6B,gBAAA;ALsljC7B;;AKrljCA;EAAuB,gBAAA;ALyljCvB;;AKxljCA;EAAuB,gBAAA;AL4ljCvB;;AK3ljCA;EAA2B,gBAAA;AL+ljC3B;;AK9ljCA;EAA2B,gBAAA;ALkmjC3B;;AKjmjCA;EAA4B,gBAAA;ALqmjC5B;;AKpmjCA;EAAkC,gBAAA;ALwmjClC;;AKvmjCA;EAAkC,gBAAA;AL2mjClC;;AK1mjCA;EAA4B,gBAAA;AL8mjC5B;;AK7mjCA;EAA6B,gBAAA;ALinjC7B;;AKhnjCA;EAA6B,gBAAA;ALonjC7B;;AKnnjCA;EAAuB,gBAAA;ALunjCvB;;AKtnjCA;EAAyB,gBAAA;AL0njCzB;;AKznjCA;EAAuB,gBAAA;AL6njCvB;;AK5njCA;EAAoB,gBAAA;ALgojCpB;;AK/njCA;EAA2B,gBAAA;ALmojC3B;;AKlojCA;EAAyB,gBAAA;ALsojCzB;;AKrojCA;EAAkB,gBAAA;ALyojClB;;AKxojCA;EAA+B,gBAAA;AL4ojC/B;;AK3ojCA;EAA+B,gBAAA;AL+ojC/B;;AK9ojCA;EAA2B,gBAAA;ALkpjC3B;;AKjpjCA;EAA2B,gBAAA;ALqpjC3B;;AKppjCA;EAAwB,gBAAA;ALwpjCxB;;AKvpjCA;EAAwB,gBAAA;AL2pjCxB;;AK1pjCA;EAA0B,gBAAA;AL8pjC1B;;AK7pjCA;EAAwB,gBAAA;ALiqjCxB;;AKhqjCA;EAA0B,gBAAA;ALoqjC1B;;AKnqjCA;EAAgC,gBAAA;ALuqjChC;;AKtqjCA;EAAgC,gBAAA;AL0qjChC;;AKzqjCA;EAA4B,gBAAA;AL6qjC5B;;AK5qjCA;EAAuB,gBAAA;ALgrjCvB;;AK/qjCA;EAAuB,gBAAA;ALmrjCvB;;AKlrjCA;EAA2B,gBAAA;ALsrjC3B;;AKrrjCA;EAA2B,gBAAA;ALyrjC3B;;AKxrjCA;EAA2B,gBAAA;AL4rjC3B;;AK3rjCA;EAA2B,gBAAA;AL+rjC3B;;AK9rjCA;EAA2B,gBAAA;ALksjC3B;;AKjsjCA;EAA2B,gBAAA;ALqsjC3B;;AKpsjCA;EAA2B,gBAAA;ALwsjC3B;;AKvsjCA;EAA2B,gBAAA;AL2sjC3B;;AK1sjCA;EAAyB,gBAAA;AL8sjCzB;;AK7sjCA;EAAyB,gBAAA;ALitjCzB;;AKhtjCA;EAAyB,gBAAA;ALotjCzB;;AKntjCA;EAAyB,gBAAA;ALutjCzB;;AKttjCA;EAAuB,gBAAA;AL0tjCvB;;AKztjCA;EAAuB,gBAAA;AL6tjCvB;;AK5tjCA;EAAgC,gBAAA;ALgujChC;;AK/tjCA;EAAgC,gBAAA;ALmujChC;;AKlujCA;EAA8B,gBAAA;ALsujC9B;;AKrujCA;EAA8B,gBAAA;ALyujC9B;;AKxujCA;EAA4B,gBAAA;AL4ujC5B;;AK3ujCA;EAA4B,gBAAA;AL+ujC5B;;AK9ujCA;EAA+B,gBAAA;ALkvjC/B;;AKjvjCA;EAA+B,gBAAA;ALqvjC/B;;AKpvjCA;EAA6B,gBAAA;ALwvjC7B;;AKvvjCA;EAA6B,gBAAA;AL2vjC7B;;AK1vjCA;EAA+B,gBAAA;AL8vjC/B;;AK7vjCA;EAA+B,gBAAA;ALiwjC/B;;AKhwjCA;EAAgC,gBAAA;ALowjChC;;AKnwjCA;EAAgC,gBAAA;ALuwjChC;;AKtwjCA;EAAkC,gBAAA;AL0wjClC;;AKzwjCA;EAAkC,gBAAA;AL6wjClC;;AK5wjCA;EAA+B,gBAAA;ALgxjC/B;;AK/wjCA;EAA+B,gBAAA;ALmxjC/B;;AKlxjCA;EAAkC,gBAAA;ALsxjClC;;AKrxjCA;EAAkC,gBAAA;ALyxjClC;;AKxxjCA;EAAsB,gBAAA;AL4xjCtB;;AK3xjCA;EAAsB,gBAAA;AL+xjCtB;;AK9xjCA;EAA0B,gBAAA;ALkyjC1B;;AKjyjCA;EAA0B,gBAAA;ALqyjC1B;;AKpyjCA;EAAwB,gBAAA;ALwyjCxB;;AKvyjCA;EAAwB,gBAAA;AL2yjCxB;;AK1yjCA;EAA2B,gBAAA;AL8yjC3B;;AK7yjCA;EAA2B,gBAAA;ALizjC3B;;AKhzjCA;EAA6B,gBAAA;ALozjC7B;;AKnzjCA;EAA6B,gBAAA;ALuzjC7B;;AKtzjCA;EAA6B,gBAAA;AL0zjC7B;;AKzzjCA;EAA6B,gBAAA;AL6zjC7B;;AK5zjCA;EAAgC,gBAAA;ALg0jChC;;AK/zjCA;EAAgC,gBAAA;ALm0jChC;;AKl0jCA;EAAuB,gBAAA;ALs0jCvB;;AKr0jCA;EAA8B,gBAAA;ALy0jC9B;;AKx0jCA;EAA8B,gBAAA;AL40jC9B;;AK30jCA;EAAuB,gBAAA;AL+0jCvB;;AK90jCA;EAA4B,gBAAA;ALk1jC5B;;AKj1jCA;EAA4B,gBAAA;ALq1jC5B;;AKp1jCA;EAA4B,gBAAA;ALw1jC5B;;AKv1jCA;EAA4B,gBAAA;AL21jC5B;;AK11jCA;EAA4B,gBAAA;AL81jC5B;;AK71jCA;EAA4B,gBAAA;ALi2jC5B;;AKh2jCA;EAAgC,gBAAA;ALo2jChC;;AKn2jCA;EAAgC,gBAAA;ALu2jChC;;AKt2jCA;EAA4B,gBAAA;AL02jC5B;;AKz2jCA;EAA4B,gBAAA;AL62jC5B;;AK52jCA;EAA8B,gBAAA;ALg3jC9B;;AK/2jCA;EAA8B,gBAAA;ALm3jC9B;;AKl3jCA;EAA8B,gBAAA;ALs3jC9B;;AKr3jCA;EAA8B,gBAAA;ALy3jC9B;;AKx3jCA;EAAwB,gBAAA;AL43jCxB;;AK33jCA;EAAwB,gBAAA;AL+3jCxB;;AK93jCA;EAAsB,gBAAA;ALk4jCtB;;AKj4jCA;EAAsB,gBAAA;ALq4jCtB;;AKp4jCA;EAA4B,gBAAA;ALw4jC5B;;AKv4jCA;EAA4B,gBAAA;AL24jC5B;;AK14jCA;EAA4B,gBAAA;AL84jC5B;;AK74jCA;EAA4B,gBAAA;ALi5jC5B;;AKh5jCA;EAA4B,gBAAA;ALo5jC5B;;AKn5jCA;EAA4B,gBAAA;ALu5jC5B;;AKt5jCA;EAA4B,gBAAA;AL05jC5B;;AKz5jCA;EAA4B,gBAAA;AL65jC5B;;AK55jCA;EAA8B,gBAAA;ALg6jC9B;;AK/5jCA;EAA8B,gBAAA;ALm6jC9B;;AKl6jCA;EAA0B,gBAAA;ALs6jC1B;;AKr6jCA;EAA0B,gBAAA;ALy6jC1B;;AKx6jCA;EAAgC,gBAAA;AL46jChC;;AK36jCA;EAAgC,gBAAA;AL+6jChC;;AK96jCA;EAA+B,gBAAA;ALk7jC/B;;AKj7jCA;EAA+B,gBAAA;ALq7jC/B;;AKp7jCA;EAA+B,gBAAA;ALw7jC/B;;AKv7jCA;EAA+B,gBAAA;AL27jC/B;;AK17jCA;EAA2B,gBAAA;AL87jC3B;;AK77jCA;EAA2B,gBAAA;ALi8jC3B;;AKh8jCA;EAA2B,gBAAA;ALo8jC3B;;AKn8jCA;EAA2B,gBAAA;ALu8jC3B;;AKt8jCA;EAAyB,gBAAA;AL08jCzB;;AKz8jCA;EAAyB,gBAAA;AL68jCzB;;AK58jCA;EAA6B,gBAAA;ALg9jC7B;;AK/8jCA;EAA6B,gBAAA;ALm9jC7B;;AKl9jCA;EAA2B,gBAAA;ALs9jC3B;;AKr9jCA;EAA2B,gBAAA;ALy9jC3B;;AKx9jCA;EAA0B,gBAAA;AL49jC1B;;AK39jCA;EAA0B,gBAAA;AL+9jC1B;;AK99jCA;EAAwB,gBAAA;ALk+jCxB;;AKj+jCA;EAAwB,gBAAA;ALq+jCxB;;AKp+jCA;EAAyB,gBAAA;ALw+jCzB;;AKv+jCA;EAAyB,gBAAA;AL2+jCzB;;AK1+jCA;EAAsB,gBAAA;AL8+jCtB;;AK7+jCA;EAAsB,gBAAA;ALi/jCtB;;AKh/jCA;EAAyB,gBAAA;ALo/jCzB;;AKn/jCA;EAAyB,gBAAA;ALu/jCzB;;AKt/jCA;EAAyB,gBAAA;AL0/jCzB;;AKz/jCA;EAAyB,gBAAA;AL6/jCzB;;AK5/jCA;EAAyB,gBAAA;ALggkCzB;;AK//jCA;EAAyB,gBAAA;ALmgkCzB;;AKlgkCA;EAAyB,gBAAA;ALsgkCzB;;AKrgkCA;EAAyB,gBAAA;ALygkCzB;;AKxgkCA;EAA2B,gBAAA;AL4gkC3B;;AK3gkCA;EAA2B,gBAAA;AL+gkC3B;;AK9gkCA;EAAuB,gBAAA;ALkhkCvB;;AKjhkCA;EAAuB,gBAAA;ALqhkCvB;;AKphkCA;EAA4B,gBAAA;ALwhkC5B;;AKvhkCA;EAA4B,gBAAA;AL2hkC5B;;AK1hkCA;EAA4B,gBAAA;AL8hkC5B;;AK7hkCA;EAA4B,gBAAA;ALiikC5B;;AKhikCA;EAA0B,gBAAA;ALoikC1B;;AKnikCA;EAA0B,gBAAA;ALuikC1B;;AKtikCA;EAA4B,gBAAA;AL0ikC5B;;AKzikCA;EAA4B,gBAAA;AL6ikC5B;;AK5ikCA;EAAyB,gBAAA;ALgjkCzB;;AK/ikCA;EAAyB,gBAAA;ALmjkCzB;;AKljkCA;EAAwB,gBAAA;ALsjkCxB;;AKrjkCA;EAAwB,gBAAA;ALyjkCxB;;AKxjkCA;EAAsB,gBAAA;AL4jkCtB;;AK3jkCA;EAAsB,gBAAA;AL+jkCtB;;AK9jkCA;EAA0B,gBAAA;ALkkkC1B;;AKjkkCA;EAA0B,gBAAA;ALqkkC1B;;AKpkkCA;EAAyB,gBAAA;ALwkkCzB;;AKvkkCA;EAAyB,gBAAA;AL2kkCzB;;AK1kkCA;EAA+B,gBAAA;AL8kkC/B;;AK7kkCA;EAA+B,gBAAA;ALilkC/B;;AKhlkCA;EAAuB,gBAAA;ALolkCvB;;AKnlkCA;EAAuB,gBAAA;ALulkCvB;;AKtlkCA;EAAgC,gBAAA;AL0lkChC;;AKzlkCA;EAAgC,gBAAA;AL6lkChC;;AK5lkCA;EAAmC,gBAAA;ALgmkCnC;;AK/lkCA;EAAmC,gBAAA;ALmmkCnC;;AKlmkCA;EAAmC,gBAAA;ALsmkCnC;;AKrmkCA;EAAmC,gBAAA;ALymkCnC;;AKxmkCA;EAAsC,gBAAA;AL4mkCtC;;AK3mkCA;EAAsC,gBAAA;AL+mkCtC;;AK9mkCA;EAAiC,gBAAA;ALknkCjC;;AKjnkCA;EAAiC,gBAAA;ALqnkCjC;;AKpnkCA;EAAoC,gBAAA;ALwnkCpC;;AKvnkCA;EAAoC,gBAAA;AL2nkCpC;;AK1nkCA;EAAkC,gBAAA;AL8nkClC;;AK7nkCA;EAAkC,gBAAA;ALiokClC;;AKhokCA;EAAqC,gBAAA;ALookCrC;;AKnokCA;EAAqC,gBAAA;ALuokCrC;;AKtokCA;EAA6B,gBAAA;AL0okC7B;;AKzokCA;EAA6B,gBAAA;AL6okC7B;;AK5okCA;EAA8B,gBAAA;ALgpkC9B;;AK/okCA;EAA8B,gBAAA;ALmpkC9B;;AKlpkCA;EAAuB,gBAAA;ALspkCvB;;AKrpkCA;EAA6B,gBAAA;ALypkC7B;;AKxpkCA;EAA6B,gBAAA;AL4pkC7B;;AK3pkCA;EAAuB,gBAAA;AL+pkCvB;;AK9pkCA;EAAyB,gBAAA;ALkqkCzB;;AKjqkCA;EAAyB,gBAAA;ALqqkCzB;;AKpqkCA;EAAuB,gBAAA;ALwqkCvB;;AKvqkCA;EAAuB,gBAAA;AL2qkCvB;;AK1qkCA;EAA4B,gBAAA;AL8qkC5B;;AK7qkCA;EAA4B,gBAAA;ALirkC5B;;AKhrkCA;EAAwB,gBAAA;ALorkCxB;;AKnrkCA;EAAwB,gBAAA;ALurkCxB;;AKtrkCA;EAA0B,gBAAA;AL0rkC1B;;AKzrkCA;EAA0B,gBAAA;AL6rkC1B;;AK5rkCA;EAAwB,gBAAA;ALgskCxB;;AK/rkCA;EAAwB,gBAAA;ALmskCxB;;AKlskCA;EAA0B,gBAAA;ALsskC1B;;AKrskCA;EAA0B,gBAAA;ALyskC1B;;AKxskCA;EAAwB,gBAAA;AL4skCxB;;AK3skCA;EAAwB,gBAAA;AL+skCxB;;AK9skCA;EAAqB,gBAAA;ALktkCrB;;AKjtkCA;EAAqB,gBAAA;ALqtkCrB;;AKptkCA;EAA6B,gBAAA;ALwtkC7B;;AKvtkCA;EAA6B,gBAAA;AL2tkC7B;;AK1tkCA;EAAsC,gBAAA;AL8tkCtC;;AK7tkCA;EAAsC,gBAAA;ALiukCtC;;AKhukCA;EAA0B,gBAAA;ALoukC1B;;AKnukCA;EAA0B,gBAAA;ALuukC1B;;AKtukCA;EAA4B,gBAAA;AL0ukC5B;;AKzukCA;EAA4B,gBAAA;AL6ukC5B;;AK5ukCA;EAAiC,gBAAA;ALgvkCjC;;AK/ukCA;EAAiC,gBAAA;ALmvkCjC;;AKlvkCA;EAAiC,gBAAA;ALsvkCjC;;AKrvkCA;EAAiC,gBAAA;ALyvkCjC;;AKxvkCA;EAAiC,gBAAA;AL4vkCjC;;AK3vkCA;EAAiC,gBAAA;AL+vkCjC;;AK9vkCA;EAAqC,gBAAA;ALkwkCrC;;AKjwkCA;EAAqC,gBAAA;ALqwkCrC;;AKpwkCA;EAA+B,gBAAA;ALwwkC/B;;AKvwkCA;EAA+B,gBAAA;AL2wkC/B;;AK1wkCA;EAAmC,gBAAA;AL8wkCnC;;AK7wkCA;EAAmC,gBAAA;ALixkCnC;;AKhxkCA;EAAwB,gBAAA;ALoxkCxB;;AKnxkCA;EAAwB,gBAAA;ALuxkCxB;;AKtxkCA;EAAsB,gBAAA;AL0xkCtB;;AKzxkCA;EAAsB,gBAAA;AL6xkCtB;;AK5xkCA;EAAsB,gBAAA;ALgykCtB;;AK/xkCA;EAAsB,gBAAA;ALmykCtB;;AKlykCA;EAAsB,gBAAA;ALsykCtB;;AKrykCA;EAAsB,gBAAA;ALyykCtB;;AKxykCA;EAAsB,gBAAA;AL4ykCtB;;AK3ykCA;EAAsB,gBAAA;AL+ykCtB;;AK9ykCA;EAAsB,gBAAA;ALkzkCtB;;AKjzkCA;EAAsB,gBAAA;ALqzkCtB;;AKpzkCA;EAA0B,gBAAA;ALwzkC1B;;AKvzkCA;EAA0B,gBAAA;AL2zkC1B;;AK1zkCA;EAAsB,gBAAA;AL8zkCtB;;AK7zkCA;EAAsB,gBAAA;ALi0kCtB;;AKh0kCA;EAAmB,gBAAA;ALo0kCnB;;AKn0kCA;EAA2B,gBAAA;ALu0kC3B;;AKt0kCA;EAA2B,gBAAA;AL00kC3B;;AKz0kCA;EAA8B,gBAAA;AL60kC9B;;AK50kCA;EAA8B,gBAAA;ALg1kC9B;;AK/0kCA;EAAwB,gBAAA;ALm1kCxB;;AKl1kCA;EAAwB,gBAAA;ALs1kCxB;;AKr1kCA;EAA6B,gBAAA;ALy1kC7B;;AKx1kCA;EAA6B,gBAAA;AL41kC7B;;AK31kCA;EAA2B,gBAAA;AL+1kC3B;;AK91kCA;EAA2B,gBAAA;ALk2kC3B;;AKj2kCA;EAAyB,gBAAA;ALq2kCzB;;AKp2kCA;EAAyB,gBAAA;ALw2kCzB;;AKv2kCA;EAA4B,gBAAA;AL22kC5B;;AK12kCA;EAAwB,gBAAA;AL82kCxB;;AK72kCA;EAAwB,gBAAA;ALi3kCxB;;AKh3kCA;EAA8B,gBAAA;ALo3kC9B;;AKn3kCA;EAA8B,gBAAA;ALu3kC9B;;AKt3kCA;EAAwB,gBAAA;AL03kCxB;;AKz3kCA;EAAwB,gBAAA;AL63kCxB;;AK53kCA;EAA0B,gBAAA;ALg4kC1B;;AK/3kCA;EAA0B,gBAAA;ALm4kC1B;;AKl4kCA;EAA0B,gBAAA;ALs4kC1B;;AKr4kCA;EAA0B,gBAAA;ALy4kC1B;;AKx4kCA;EAAuB,gBAAA;AL44kCvB;;AK34kCA;EAAyB,gBAAA;AL+4kCzB;;AK94kCA;EAAyB,gBAAA;ALk5kCzB;;AKj5kCA;EAA8B,gBAAA;ALq5kC9B;;AKp5kCA;EAA8B,gBAAA;ALw5kC9B;;AKv5kCA;EAA8B,gBAAA;AL25kC9B;;AK15kCA;EAA8B,gBAAA;AL85kC9B;;AK75kCA;EAA0B,gBAAA;ALi6kC1B;;AKh6kCA;EAA0B,gBAAA;ALo6kC1B;;AKn6kCA;EAA2B,gBAAA;ALu6kC3B;;AKt6kCA;EAA2B,gBAAA;AL06kC3B;;AKz6kCA;EAA0B,gBAAA;AL66kC1B;;AK56kCA;EAA0B,gBAAA;ALg7kC1B;;AK/6kCA;EAA+B,gBAAA;ALm7kC/B;;AKl7kCA;EAA+B,gBAAA;ALs7kC/B;;AKr7kCA;EAAwB,gBAAA;ALy7kCxB;;AKx7kCA;EAAwB,gBAAA;AL47kCxB;;AK37kCA;EAA6B,gBAAA;AL+7kC7B;;AK97kCA;EAA6B,gBAAA;ALk8kC7B;;AKj8kCA;EAAyB,gBAAA;ALq8kCzB;;AKp8kCA;EAAyB,gBAAA;ALw8kCzB;;AKv8kCA;EAA0B,gBAAA;AL28kC1B;;AK18kCA;EAA0B,gBAAA;AL88kC1B;;AK78kCA;EAAyB,gBAAA;ALi9kCzB;;AKh9kCA;EAAyB,gBAAA;ALo9kCzB;;AKn9kCA;EAAiC,gBAAA;ALu9kCjC;;AKt9kCA;EAAiC,gBAAA;AL09kCjC;;AKz9kCA;EAA+B,gBAAA;AL69kC/B;;AK59kCA;EAA+B,gBAAA;ALg+kC/B;;AK/9kCA;EAA0B,gBAAA;ALm+kC1B;;AKl+kCA;EAA0B,gBAAA;ALs+kC1B;;AKr+kCA;EAA+B,gBAAA;ALy+kC/B;;AKx+kCA;EAA+B,gBAAA;AL4+kC/B;;AK3+kCA;EAAwB,gBAAA;AL++kCxB;;AK9+kCA;EAA6B,gBAAA;ALk/kC7B;;AKj/kCA;EAA6B,gBAAA;ALq/kC7B;;AKp/kCA;EAAwB,gBAAA;ALw/kCxB;;AKv/kCA;EAA6B,gBAAA;AL2/kC7B;;AK1/kCA;EAA6B,gBAAA;AL8/kC7B;;AK7/kCA;EAAuC,gBAAA;ALiglCvC;;AKhglCA;EAAuC,gBAAA;ALoglCvC;;AKnglCA;EAA0C,gBAAA;ALuglC1C;;AKtglCA;EAA0C,gBAAA;AL0glC1C;;AKzglCA;EAAqC,gBAAA;AL6glCrC;;AK5glCA;EAAqC,gBAAA;ALghlCrC;;AK/glCA;EAA8B,gBAAA;ALmhlC9B;;AKlhlCA;EAA8B,gBAAA;ALshlC9B;;AKrhlCA;EAAgC,gBAAA;ALyhlChC;;AKxhlCA;EAAgC,gBAAA;AL4hlChC;;AK3hlCA;EAA4B,gBAAA;AL+hlC5B;;AK9hlCA;EAA4B,gBAAA;ALkilC5B;;AKjilCA;EAA+B,gBAAA;ALqilC/B;;AKpilCA;EAA+B,gBAAA;ALwilC/B;;AKvilCA;EAA4B,gBAAA;AL2ilC5B;;AK1ilCA;EAA4B,gBAAA;AL8ilC5B;;AK7ilCA;EAA4B,gBAAA;ALijlC5B;;AKhjlCA;EAA4B,gBAAA;ALojlC5B;;AKnjlCA;EAA0B,gBAAA;ALujlC1B;;AKtjlCA;EAA2B,gBAAA;AL0jlC3B;;AKzjlCA;EAA2B,gBAAA;AL6jlC3B;;AK5jlCA;EAAwB,gBAAA;ALgklCxB;;AK/jlCA;EAAwB,gBAAA;ALmklCxB;;AKlklCA;EAAwB,gBAAA;ALsklCxB;;AKrklCA;EAAwB,gBAAA;ALyklCxB;;AKxklCA;EAA8B,gBAAA;AL4klC9B;;AK3klCA;EAA8B,gBAAA;AL+klC9B;;AK9klCA;EAAuB,gBAAA;ALkllCvB;;AKjllCA;EAAuB,gBAAA;ALqllCvB;;AKpllCA;EAAgC,gBAAA;ALwllChC;;AKvllCA;EAAgC,gBAAA;AL2llChC;;AK1llCA;EAA4B,gBAAA;AL8llC5B;;AK7llCA;EAA4B,gBAAA;ALimlC5B;;AKhmlCA;EAA4B,gBAAA;ALomlC5B;;AKnmlCA;EAA4B,gBAAA;ALumlC5B;;AKtmlCA;EAA8B,gBAAA;AL0mlC9B;;AKzmlCA;EAA8B,gBAAA;AL6mlC9B;;AK5mlCA;EAAyB,gBAAA;ALgnlCzB;;AK/mlCA;EAAyB,gBAAA;ALmnlCzB;;AKlnlCA;EAAuB,gBAAA;ALsnlCvB;;AKrnlCA;EAAuB,gBAAA;ALynlCvB;;AKxnlCA;EAA6B,gBAAA;AL4nlC7B;;AK3nlCA;EAA6B,gBAAA;AL+nlC7B;;AK9nlCA;EAA2B,gBAAA;ALkolC3B;;AKjolCA;EAA2B,gBAAA;ALqolC3B;;AKpolCA;EAA6B,gBAAA;ALwolC7B;;AKvolCA;EAA6B,gBAAA;AL2olC7B;;AK1olCA;EAA8B,gBAAA;AL8olC9B;;AK7olCA;EAA8B,gBAAA;ALiplC9B;;AKhplCA;EAA8B,gBAAA;ALoplC9B;;AKnplCA;EAA8B,gBAAA;ALuplC9B;;AKtplCA;EAA4B,gBAAA;AL0plC5B;;AKzplCA;EAA4B,gBAAA;AL6plC5B;;AK5plCA;EAAgC,gBAAA;ALgqlChC;;AK/plCA;EAAgC,gBAAA;ALmqlChC;;AKlqlCA;EAA0B,gBAAA;ALsqlC1B;;AKrqlCA;EAA0B,gBAAA;ALyqlC1B;;AKxqlCA;EAA+B,gBAAA;AL4qlC/B;;AK3qlCA;EAA+B,gBAAA;AL+qlC/B;;AK9qlCA;EAA0B,gBAAA;ALkrlC1B;;AKjrlCA;EAA0B,gBAAA;ALqrlC1B;;AKprlCA;EAA8B,gBAAA;ALwrlC9B;;AKvrlCA;EAA8B,gBAAA;AL2rlC9B;;AK1rlCA;EAA4B,gBAAA;AL8rlC5B;;AK7rlCA;EAA4B,gBAAA;ALislC5B;;AKhslCA;EAA4B,gBAAA;ALoslC5B;;AKnslCA;EAA4B,gBAAA;ALuslC5B;;AKtslCA;EAA0B,gBAAA;AL0slC1B;;AKzslCA;EAA0B,gBAAA;AL6slC1B;;AK5slCA;EAAqB,gBAAA;ALgtlCrB;;AK/slCA;EAAqB,gBAAA;ALmtlCrB;;AKltlCA;EAA0B,gBAAA;ALstlC1B;;AKrtlCA;EAA0B,gBAAA;ALytlC1B;;AKxtlCA;EAA4B,gBAAA;AL4tlC5B;;AK3tlCA;EAA4B,gBAAA;AL+tlC5B;;AK9tlCA;EAA0B,gBAAA;ALkulC1B;;AKjulCA;EAA0B,gBAAA;ALqulC1B;;AKpulCA;EAAkC,gBAAA;ALwulClC;;AKvulCA;EAAkC,gBAAA;AL2ulClC;;AK1ulCA;EAA2B,gBAAA;AL8ulC3B;;AK7ulCA;EAA2B,gBAAA;ALivlC3B;;AKhvlCA;EAAgC,gBAAA;ALovlChC;;AKnvlCA;EAAgC,gBAAA;ALuvlChC;;AKtvlCA;EAA4B,gBAAA;AL0vlC5B;;AKzvlCA;EAA4B,gBAAA;AL6vlC5B;;AK5vlCA;EAAwB,gBAAA;ALgwlCxB;;AK/vlCA;EAAwB,gBAAA;ALmwlCxB;;AKlwlCA;EAA0B,gBAAA;ALswlC1B;;AKrwlCA;EAA0B,gBAAA;ALywlC1B;;AKxwlCA;EAA+B,gBAAA;AL4wlC/B;;AK3wlCA;EAA+B,gBAAA;AL+wlC/B;;AK9wlCA;EAAwB,gBAAA;ALkxlCxB;;AKjxlCA;EAAwB,gBAAA;ALqxlCxB;;AKpxlCA;EAA0B,gBAAA;ALwxlC1B;;AKvxlCA;EAA0B,gBAAA;AL2xlC1B;;AK1xlCA;EAAwB,gBAAA;AL8xlCxB;;AK7xlCA;EAAwB,gBAAA;ALiylCxB;;AKhylCA;EAA0B,gBAAA;ALoylC1B;;AKnylCA;EAA0B,gBAAA;ALuylC1B;;AKtylCA;EAAgC,gBAAA;AL0ylChC;;AKzylCA;EAAgC,gBAAA;AL6ylChC;;AK5ylCA;EAA8B,gBAAA;ALgzlC9B;;AK/ylCA;EAA8B,gBAAA;ALmzlC9B;;AKlzlCA;EAA0B,gBAAA;ALszlC1B;;AKrzlCA;EAA0B,gBAAA;ALyzlC1B;;AKxzlCA;EAA6B,gBAAA;AL4zlC7B;;AK3zlCA;EAA6B,gBAAA;AL+zlC7B;;AK9zlCA;EAAyB,gBAAA;ALk0lCzB;;AKj0lCA;EAAyB,gBAAA;ALq0lCzB;;AKp0lCA;EAA0B,gBAAA;ALw0lC1B;;AKv0lCA;EAA0B,gBAAA;AL20lC1B;;AK10lCA;EAA2B,gBAAA;AL80lC3B;;AK70lCA;EAA2B,gBAAA;ALi1lC3B;;AKh1lCA;EAAyB,gBAAA;ALo1lCzB;;AKn1lCA;EAAyB,gBAAA;ALu1lCzB;;AKt1lCA;EAA6B,gBAAA;AL01lC7B;;AKz1lCA;EAA6B,gBAAA;AL61lC7B;;AK51lCA;EAA4B,gBAAA;ALg2lC5B;;AK/1lCA;EAA4B,gBAAA;ALm2lC5B;;AKl2lCA;EAAmC,gBAAA;ALs2lCnC;;AKr2lCA;EAAmC,gBAAA;ALy2lCnC;;AKx2lCA;EAAiC,gBAAA;AL42lCjC;;AK32lCA;EAAiC,gBAAA;AL+2lCjC;;AK92lCA;EAA2B,gBAAA;ALk3lC3B;;AKj3lCA;EAA2B,gBAAA;ALq3lC3B;;AKp3lCA;EAAyB,gBAAA;ALw3lCzB;;AKv3lCA;EAAyB,gBAAA;AL23lCzB;;AK13lCA;EAA6B,gBAAA;AL83lC7B;;AK73lCA;EAA6B,gBAAA;ALi4lC7B;;AKh4lCA;EAAwB,gBAAA;ALo4lCxB;;AKn4lCA;EAAwB,gBAAA;ALu4lCxB;;AKt4lCA;EAA2B,gBAAA;AL04lC3B;;AKz4lCA;EAA2B,gBAAA;AL64lC3B;;AK54lCA;EAA0B,gBAAA;ALg5lC1B;;AK/4lCA;EAA0B,gBAAA;ALm5lC1B;;AKl5lCA;EAA+B,gBAAA;ALs5lC/B;;AKr5lCA;EAA+B,gBAAA;ALy5lC/B;;AKx5lCA;EAA6B,gBAAA;AL45lC7B;;AK35lCA;EAA6B,gBAAA;AL+5lC7B;;AK95lCA;EAAyB,gBAAA;ALk6lCzB;;AKj6lCA;EAAyB,gBAAA;ALq6lCzB;;AKp6lCA;EAA8B,gBAAA;ALw6lC9B;;AKv6lCA;EAA8B,gBAAA;AL26lC9B;;AK16lCA;EAAyB,gBAAA;AL86lCzB;;AK76lCA;EAAyB,gBAAA;ALi7lCzB;;AKh7lCA;EAAyB,gBAAA;ALo7lCzB;;AKn7lCA;EAAyB,gBAAA;ALu7lCzB;;AKt7lCA;EAA2B,gBAAA;AL07lC3B;;AKz7lCA;EAA2B,gBAAA;AL67lC3B;;AK57lCA;EAA2B,gBAAA;ALg8lC3B;;AK/7lCA;EAA2B,gBAAA;ALm8lC3B;;AKl8lCA;EAAwB,gBAAA;ALs8lCxB;;AKr8lCA;EAAwB,gBAAA;ALy8lCxB;;AKx8lCA;EAA2B,gBAAA;AL48lC3B;;AK38lCA;EAA2B,gBAAA;AL+8lC3B;;AK98lCA;EAAyB,gBAAA;ALk9lCzB;;AKj9lCA;EAAyB,gBAAA;ALq9lCzB;;AKp9lCA;EAA8B,gBAAA;ALw9lC9B;;AKv9lCA;EAA8B,gBAAA;AL29lC9B;;AK19lCA;EAAwB,gBAAA;AL89lCxB;;AK79lCA;EAAwB,gBAAA;ALi+lCxB;;AKh+lCA;EAAyB,gBAAA;ALo+lCzB;;AKn+lCA;EAAyB,gBAAA;ALu+lCzB;;AKt+lCA;EAAsB,gBAAA;AL0+lCtB;;AKz+lCA;EAAsB,gBAAA;AL6+lCtB;;AK5+lCA;EAA0B,gBAAA;ALg/lC1B;;AK/+lCA;EAA0B,gBAAA;ALm/lC1B;;AKl/lCA;EAAwB,gBAAA;ALs/lCxB;;AKr/lCA;EAAwB,gBAAA;ALy/lCxB;;AKx/lCA;EAAsB,gBAAA;AL4/lCtB;;AK3/lCA;EAAsB,gBAAA;AL+/lCtB;;AK9/lCA;EAAyB,gBAAA;ALkgmCzB;;AKjgmCA;EAAyB,gBAAA;ALqgmCzB;;AKpgmCA;EAAyB,gBAAA;ALwgmCzB;;AKvgmCA;EAAyB,gBAAA;AL2gmCzB;;AK1gmCA;EAAuB,gBAAA;AL8gmCvB;;AK7gmCA;EAAuB,gBAAA;ALihmCvB;;AKhhmCA;EAA2B,gBAAA;ALohmC3B;;AKnhmCA;EAA2B,gBAAA;ALuhmC3B;;AKthmCA;EAAyB,gBAAA;AL0hmCzB;;AKzhmCA;EAAyB,gBAAA;AL6hmCzB;;AK5hmCA;EAAyB,gBAAA;ALgimCzB;;AK/hmCA;EAAyB,gBAAA;ALmimCzB;;AKlimCA;EAAuB,gBAAA;ALsimCvB;;AKrimCA;EAAuB,gBAAA;ALyimCvB;;AKximCA;EAA2B,gBAAA;AL4imC3B;;AK3imCA;EAA2B,gBAAA;AL+imC3B;;AK9imCA;EAAyB,gBAAA;ALkjmCzB;;AKjjmCA;EAAyB,gBAAA;ALqjmCzB;;AKpjmCA;EAAyB,gBAAA;ALwjmCzB;;AKvjmCA;EAAyB,gBAAA;AL2jmCzB;;AK1jmCA;EAAuB,gBAAA;AL8jmCvB;;AK7jmCA;EAAuB,gBAAA;ALikmCvB;;AKhkmCA;EAA6B,gBAAA;ALokmC7B;;AKnkmCA;EAA6B,gBAAA;ALukmC7B;;AKtkmCA;EAA+B,gBAAA;AL0kmC/B;;AKzkmCA;EAA+B,gBAAA;AL6kmC/B;;AK5kmCA;EAA2B,gBAAA;ALglmC3B;;AK/kmCA;EAA2B,gBAAA;ALmlmC3B;;AKllmCA;EAA+B,gBAAA;ALslmC/B;;AKrlmCA;EAA+B,gBAAA;ALylmC/B;;AKxlmCA;EAA6B,gBAAA;AL4lmC7B;;AK3lmCA;EAA6B,gBAAA;AL+lmC7B;;AK9lmCA;EAA0B,gBAAA;ALkmmC1B;;AKjmmCA;EAA0B,gBAAA;ALqmmC1B;;AKpmmCA;EAA+B,gBAAA;ALwmmC/B;;AKvmmCA;EAA+B,gBAAA;AL2mmC/B;;AK1mmCA;EAA2B,gBAAA;AL8mmC3B;;AK7mmCA;EAA2B,gBAAA;ALinmC3B;;AKhnmCA;EAA6B,gBAAA;ALonmC7B;;AKnnmCA;EAA6B,gBAAA;ALunmC7B;;AKtnmCA;EAAyB,gBAAA;AL0nmCzB;;AKznmCA;EAAyB,gBAAA;AL6nmCzB;;AK5nmCA;EAAiC,gBAAA;ALgomCjC;;AK/nmCA;EAAiC,gBAAA;ALmomCjC;;AKlomCA;EAA2B,gBAAA;ALsomC3B;;AKromCA;EAA+B,gBAAA;ALyomC/B;;AKxomCA;EAA+B,gBAAA;AL4omC/B;;AK3omCA;EAA6B,gBAAA;AL+omC7B;;AK9omCA;EAA6B,gBAAA;ALkpmC7B;;AKjpmCA;EAA0B,gBAAA;ALqpmC1B;;AKppmCA;EAAyB,gBAAA;ALwpmCzB;;AKvpmCA;EAAyB,gBAAA;AL2pmCzB;;AK1pmCA;EAAuB,gBAAA;AL8pmCvB;;AK7pmCA;EAAyB,gBAAA;ALiqmCzB;;AKhqmCA;EAAyB,gBAAA;ALoqmCzB;;AKnqmCA;EAA0B,gBAAA;ALuqmC1B;;AKtqmCA;EAA0B,gBAAA;AL0qmC1B;;AKzqmCA;EAA6B,gBAAA;AL6qmC7B;;AK5qmCA;EAA6B,gBAAA;ALgrmC7B;;AK/qmCA;EAA6B,gBAAA;ALmrmC7B;;AKlrmCA;EAA6B,gBAAA;ALsrmC7B;;AKrrmCA;EAA6B,gBAAA;ALyrmC7B;;AKxrmCA;EAA6B,gBAAA;AL4rmC7B;;AK3rmCA;EAA6B,gBAAA;AL+rmC7B;;AK9rmCA;EAA6B,gBAAA;ALksmC7B;;AKjsmCA;EAA6B,gBAAA;ALqsmC7B;;AKpsmCA;EAA6B,gBAAA;ALwsmC7B;;AKvsmCA;EAA2B,gBAAA;AL2smC3B;;AK1smCA;EAA2B,gBAAA;AL8smC3B;;AK7smCA;EAA0B,gBAAA;ALitmC1B;;AKhtmCA;EAA0B,gBAAA;ALotmC1B;;AKntmCA;EAAwB,gBAAA;ALutmCxB;;AKttmCA;EAAwB,gBAAA;AL0tmCxB;;AKztmCA;EAA4B,gBAAA;AL6tmC5B;;AK5tmCA;EAA4B,gBAAA;ALgumC5B;;AK/tmCA;EAA+B,gBAAA;ALmumC/B;;AKlumCA;EAA+B,gBAAA;ALsumC/B;;AKrumCA;EAAwB,gBAAA;ALyumCxB;;AKxumCA;EAAkC,gBAAA;AL4umClC;;AK3umCA;EAAkC,gBAAA;AL+umClC;;AK9umCA;EAAoC,gBAAA;ALkvmCpC;;AKjvmCA;EAAoC,gBAAA;ALqvmCpC;;AKpvmCA;EAAgC,gBAAA;ALwvmChC;;AKvvmCA;EAAgC,gBAAA;AL2vmChC;;AK1vmCA;EAAwB,gBAAA;AL8vmCxB;;AK7vmCA;EAA+B,gBAAA;ALiwmC/B;;AKhwmCA;EAA+B,gBAAA;ALowmC/B;;AKnwmCA;EAAyB,gBAAA;ALuwmCzB;;AKtwmCA;EAA+B,gBAAA;AL0wmC/B;;AKzwmCA;EAA+B,gBAAA;AL6wmC/B;;AK5wmCA;EAAiC,gBAAA;ALgxmCjC;;AK/wmCA;EAAiC,gBAAA;ALmxmCjC;;AKlxmCA;EAAyB,gBAAA;ALsxmCzB;;AKrxmCA;EAA8B,gBAAA;ALyxmC9B;;AKxxmCA;EAA8B,gBAAA;AL4xmC9B;;AK3xmCA;EAA8B,gBAAA;AL+xmC9B;;AK9xmCA;EAA8B,gBAAA;ALkymC9B;;AKjymCA;EAAyB,gBAAA;ALqymCzB;;AKpymCA;EAAyB,gBAAA;ALwymCzB;;AKvymCA;EAAuB,gBAAA;AL2ymCvB;;AK1ymCA;EAAuB,gBAAA;AL8ymCvB;;AK7ymCA;EAAwB,gBAAA;ALizmCxB;;AKhzmCA;EAAwB,gBAAA;ALozmCxB;;AKnzmCA;EAAiC,gBAAA;ALuzmCjC;;AKtzmCA;EAAiC,gBAAA;AL0zmCjC;;AKzzmCA;EAAiC,gBAAA;AL6zmCjC;;AK5zmCA;EAAiC,gBAAA;ALg0mCjC;;AK/zmCA;EAA+B,gBAAA;ALm0mC/B;;AKl0mCA;EAA+B,gBAAA;ALs0mC/B;;AKr0mCA;EAAoC,gBAAA;ALy0mCpC;;AKx0mCA;EAAoC,gBAAA;AL40mCpC;;AK30mCA;EAAkC,gBAAA;AL+0mClC;;AK90mCA;EAAkC,gBAAA;ALk1mClC;;AKj1mCA;EAAkC,gBAAA;ALq1mClC;;AKp1mCA;EAAkC,gBAAA;ALw1mClC;;AKv1mCA;EAAgC,gBAAA;AL21mChC;;AK11mCA;EAAgC,gBAAA;AL81mChC;;AK71mCA;EAA0B,gBAAA;ALi2mC1B;;AKh2mCA;EAA0B,gBAAA;ALo2mC1B;;AKn2mCA;EAA0B,gBAAA;ALu2mC1B;;AKt2mCA;EAA0B,gBAAA;AL02mC1B;;AKz2mCA;EAA4B,gBAAA;AL62mC5B;;AK52mCA;EAA4B,gBAAA;ALg3mC5B;;AK/2mCA;EAA2B,gBAAA;ALm3mC3B;;AKl3mCA;EAA2B,gBAAA;ALs3mC3B;;AKr3mCA;EAA+B,gBAAA;ALy3mC/B;;AKx3mCA;EAA+B,gBAAA;AL43mC/B;;AK33mCA;EAAgC,gBAAA;AL+3mChC;;AK93mCA;EAAgC,gBAAA;ALk4mChC;;AKj4mCA;EAAgC,gBAAA;ALq4mChC;;AKp4mCA;EAAgC,gBAAA;ALw4mChC;;AKv4mCA;EAAgC,gBAAA;AL24mChC;;AK14mCA;EAAgC,gBAAA;AL84mChC;;AK74mCA;EAAoC,gBAAA;ALi5mCpC;;AKh5mCA;EAAoC,gBAAA;ALo5mCpC;;AKn5mCA;EAA8B,gBAAA;ALu5mC9B;;AKt5mCA;EAA8B,gBAAA;AL05mC9B;;AKz5mCA;EAAkC,gBAAA;AL65mClC;;AK55mCA;EAAkC,gBAAA;ALg6mClC;;AK/5mCA;EAA6B,gBAAA;ALm6mC7B;;AKl6mCA;EAA6B,gBAAA;ALs6mC7B;;AKr6mCA;EAA2B,gBAAA;ALy6mC3B;;AKx6mCA;EAA2B,gBAAA;AL46mC3B;;AK36mCA;EAA6B,gBAAA;AL+6mC7B;;AK96mCA;EAA6B,gBAAA;ALk7mC7B;;AKj7mCA;EAAsB,gBAAA;ALq7mCtB;;AKp7mCA;EAAsB,gBAAA;ALw7mCtB;;AKv7mCA;EAA4B,gBAAA;AL27mC5B;;AK17mCA;EAA4B,gBAAA;AL87mC5B;;AK77mCA;EAAiC,gBAAA;ALi8mCjC;;AKh8mCA;EAAiC,gBAAA;ALo8mCjC;;AKn8mCA;EAA+B,gBAAA;ALu8mC/B;;AKt8mCA;EAA+B,gBAAA;AL08mC/B;;AKz8mCA;EAAoC,gBAAA;AL68mCpC;;AK58mCA;EAAoC,gBAAA;ALg9mCpC;;AK/8mCA;EAA0B,gBAAA;ALm9mC1B;;AKl9mCA;EAA0B,gBAAA;ALs9mC1B;;AKr9mCA;EAAwB,gBAAA;ALy9mCxB;;AKx9mCA;EAAwB,gBAAA;AL49mCxB;;AK39mCA;EAAwB,gBAAA;AL+9mCxB;;AK99mCA;EAAwB,gBAAA;ALk+mCxB;;AKj+mCA;EAAwB,gBAAA;ALq+mCxB;;AKp+mCA;EAAwB,gBAAA;ALw+mCxB;;AKv+mCA;EAAwB,gBAAA;AL2+mCxB;;AK1+mCA;EAAwB,gBAAA;AL8+mCxB;;AK7+mCA;EAA8B,gBAAA;ALi/mC9B;;AKh/mCA;EAA8B,gBAAA;ALo/mC9B;;AKn/mCA;EAA8B,gBAAA;ALu/mC9B;;AKt/mCA;EAA8B,gBAAA;AL0/mC9B;;AKz/mCA;EAA8B,gBAAA;AL6/mC9B;;AK5/mCA;EAA8B,gBAAA;ALggnC9B;;AK//mCA;EAA4B,gBAAA;ALmgnC5B;;AKlgnCA;EAA4B,gBAAA;ALsgnC5B;;AKrgnCA;EAA6B,gBAAA;ALygnC7B;;AKxgnCA;EAA6B,gBAAA;AL4gnC7B;;AK3gnCA;EAA2B,gBAAA;AL+gnC3B;;AK9gnCA;EAA2B,gBAAA;ALkhnC3B;;AKjhnCA;EAAwB,gBAAA;ALqhnCxB;;AKphnCA;EAAwB,gBAAA;ALwhnCxB;;AKvhnCA;EAAsB,gBAAA;AL2hnCtB;;AK1hnCA;EAAuB,gBAAA;AL8hnCvB;;AK7hnCA;EAA+B,gBAAA;ALiinC/B;;AKhinCA;EAA+B,gBAAA;ALoinC/B;;AKninCA;EAA6B,gBAAA;ALuinC7B;;AKtinCA;EAA6B,gBAAA;AL0inC7B;;AKzinCA;EAA6B,gBAAA;AL6inC7B;;AK5inCA;EAA6B,gBAAA;ALgjnC7B;;AK/inCA;EAAmB,gBAAA;ALmjnCnB;;AKljnCA;EAAyB,gBAAA;ALsjnCzB;;AKrjnCA;EAAyB,gBAAA;ALyjnCzB;;AKxjnCA;EAAyB,gBAAA;AL4jnCzB;;AK3jnCA;EAAyB,gBAAA;AL+jnCzB;;AK9jnCA;EAAuB,gBAAA;ALkknCvB;;AKjknCA;EAAuB,gBAAA;ALqknCvB;;AKpknCA;EAA4B,gBAAA;ALwknC5B;;AKvknCA;EAA4B,gBAAA;AL2knC5B;;AK1knCA;EAA4B,gBAAA;AL8knC5B;;AK7knCA;EAA4B,gBAAA;ALilnC5B;;AKhlnCA;EAA0B,gBAAA;ALolnC1B;;AKnlnCA;EAA0B,gBAAA;ALulnC1B;;AKtlnCA;EAA2B,gBAAA;AL0lnC3B;;AKzlnCA;EAA2B,gBAAA;AL6lnC3B;;AK5lnCA;EAAwB,gBAAA;ALgmnCxB;;AK/lnCA;EAAwB,gBAAA;ALmmnCxB;;AKlmnCA;EAA6B,gBAAA;ALsmnC7B;;AKrmnCA;EAA6B,gBAAA;ALymnC7B;;AKxmnCA;EAA0B,gBAAA;AL4mnC1B;;AK3mnCA;EAA0B,gBAAA;AL+mnC1B;;AK9mnCA;EAAsB,gBAAA;ALknnCtB;;AKjnnCA;EAAsB,gBAAA;ALqnnCtB;;AKpnnCA;EAAwB,gBAAA;ALwnnCxB;;AKvnnCA;EAAwB,gBAAA;AL2nnCxB;;AK1nnCA;EAAiC,gBAAA;AL8nnCjC;;AK7nnCA;EAAiC,gBAAA;ALionCjC;;AKhonCA;EAA6B,gBAAA;ALoonC7B;;AKnonCA;EAA6B,gBAAA;ALuonC7B;;AKtonCA;EAAuB,gBAAA;AL0onCvB;;AKzonCA;EAA4B,gBAAA;AL6onC5B;;AK5onCA;EAA4B,gBAAA;ALgpnC5B;;AK/onCA;EAA8B,gBAAA;ALmpnC9B;;AKlpnCA;EAA8B,gBAAA;ALspnC9B;;AKrpnCA;EAAuB,gBAAA;ALypnCvB;;AKxpnCA;EAAyB,gBAAA;AL4pnCzB;;AK3pnCA;EAAyB,gBAAA;AL+pnCzB;;AK9pnCA;EAA6B,gBAAA;ALkqnC7B;;AKjqnCA;EAA6B,gBAAA;ALqqnC7B;;AKpqnCA;EAAwB,gBAAA;ALwqnCxB;;AKvqnCA;EAAwB,gBAAA;AL2qnCxB;;AK1qnCA;EAA6B,gBAAA;AL8qnC7B;;AK7qnCA;EAA6B,gBAAA;ALirnC7B;;AKhrnCA;EAA2B,gBAAA;ALornC3B;;AKnrnCA;EAA2B,gBAAA;ALurnC3B;;AKtrnCA;EAAgC,gBAAA;AL0rnChC;;AKzrnCA;EAAgC,gBAAA;AL6rnChC;;AK5rnCA;EAA8B,gBAAA;ALgsnC9B;;AK/rnCA;EAA8B,gBAAA;ALmsnC9B;;AKlsnCA;EAAwB,gBAAA;ALssnCxB;;AKrsnCA;EAAwB,gBAAA;ALysnCxB;;AKxsnCA;EAA8B,gBAAA;AL4snC9B;;AK3snCA;EAA8B,gBAAA;AL+snC9B;;AK9snCA;EAAuB,gBAAA;ALktnCvB;;AKjtnCA;EAAuB,gBAAA;ALqtnCvB;;AKptnCA;EAA4B,gBAAA;ALwtnC5B;;AKvtnCA;EAA4B,gBAAA;AL2tnC5B;;AK1tnCA;EAA0B,gBAAA;AL8tnC1B;;AK7tnCA;EAA0B,gBAAA;ALiunC1B;;AKhunCA;EAA0B,gBAAA;ALounC1B;;AKnunCA;EAA0B,gBAAA;ALuunC1B;;AKtunCA;EAAwB,gBAAA;AL0unCxB;;AKzunCA;EAAwB,gBAAA;AL6unCxB;;AK5unCA;EAA6B,gBAAA;ALgvnC7B;;AK/unCA;EAA2B,gBAAA;ALmvnC3B;;AKlvnCA;EAAyB,gBAAA;ALsvnCzB;;AKrvnCA;EAAuB,gBAAA;ALyvnCvB;;AKxvnCA;EAA2B,gBAAA;AL4vnC3B;;AK3vnCA;EAA2B,gBAAA;AL+vnC3B;;AK9vnCA;EAAyB,gBAAA;ALkwnCzB;;AKjwnCA;EAAyB,gBAAA;ALqwnCzB;;AKpwnCA;EAA8B,gBAAA;ALwwnC9B;;AKvwnCA;EAA8B,gBAAA;AL2wnC9B;;AK1wnCA;EAA6B,gBAAA;AL8wnC7B;;AK7wnCA;EAA6B,gBAAA;ALixnC7B;;AKhxnCA;EAA6B,gBAAA;ALoxnC7B;;AKnxnCA;EAA6B,gBAAA;ALuxnC7B;;AKtxnCA;EAA2B,gBAAA;AL0xnC3B;;AKzxnCA;EAA2B,gBAAA;AL6xnC3B;;AK5xnCA;EAA6B,gBAAA;ALgynC7B;;AK/xnCA;EAA6B,gBAAA;ALmynC7B;;AKlynCA;EAAsB,gBAAA;ALsynCtB;;AKrynCA;EAA4B,gBAAA;ALyynC5B;;AKxynCA;EAA4B,gBAAA;AL4ynC5B;;AK3ynCA;EAAsB,gBAAA;AL+ynCtB;;AK9ynCA;EAA2B,gBAAA;ALkznC3B;;AKjznCA;EAAyB,gBAAA;ALqznCzB;;AKpznCA;EAAiC,gBAAA;ALwznCjC;;AKvznCA;EAAiC,gBAAA;AL2znCjC;;AK1znCA;EAAyB,gBAAA;AL8znCzB;;AK7znCA;EAAyB,gBAAA;ALi0nCzB;;AKh0nCA;EAA2B,gBAAA;ALo0nC3B;;AKn0nCA;EAA2B,gBAAA;ALu0nC3B;;AKt0nCA;EAAuB,gBAAA;AL00nCvB;;AKz0nCA;EAAuB,gBAAA;AL60nCvB;;AK50nCA;EAAyB,gBAAA;ALg1nCzB;;AK/0nCA;EAAyB,gBAAA;ALm1nCzB;;AKl1nCA;EAAwB,gBAAA;ALs1nCxB;;AKr1nCA;EAAwB,gBAAA;ALy1nCxB;;AKx1nCA;EAAwB,gBAAA;AL41nCxB;;AK31nCA;EAAwB,gBAAA;AL+1nCxB;;AK91nCA;EAA4B,gBAAA;ALk2nC5B;;AKj2nCA;EAA4B,gBAAA;ALq2nC5B;;AKp2nCA;EAA8B,gBAAA;ALw2nC9B;;AKv2nCA;EAA8B,gBAAA;AL22nC9B;;AK12nCA;EAA0B,gBAAA;AL82nC1B;;AK72nCA;EAA0B,gBAAA;ALi3nC1B;;AKh3nCA;EAAqB,gBAAA;ALo3nCrB;;AKn3nCA;EAA4B,gBAAA;ALu3nC5B;;AKt3nCA;EAA4B,gBAAA;AL03nC5B;;AKz3nCA;EAAwB,gBAAA;AL63nCxB;;AK53nCA;EAAwB,gBAAA;ALg4nCxB;;AK/3nCA;EAAyB,gBAAA;ALm4nCzB;;AKl4nCA;EAAyB,gBAAA;ALs4nCzB;;AKr4nCA;EAA2B,gBAAA;ALy4nC3B;;AKx4nCA;EAA2B,gBAAA;AL44nC3B;;AK34nCA;EAAyB,gBAAA;AL+4nCzB;;AK94nCA;EAAyB,gBAAA;ALk5nCzB;;AKj5nCA;EAAuB,gBAAA;ALq5nCvB;;AKp5nCA;EAAuB,gBAAA;ALw5nCvB;;AKv5nCA;EAAuB,gBAAA;AL25nCvB;;AK15nCA;EAAuB,gBAAA;AL85nCvB;;AK75nCA;EAAuB,gBAAA;ALi6nCvB;;AKh6nCA;EAAuB,gBAAA;ALo6nCvB;;AKn6nCA;EAA4B,gBAAA;ALu6nC5B;;AKt6nCA;EAA4B,gBAAA;AL06nC5B;;AKz6nCA;EAAuB,gBAAA;AL66nCvB;;AK56nCA;EAAuB,gBAAA;ALg7nCvB;;AK/6nCA;EAA2B,gBAAA;ALm7nC3B;;AKl7nCA;EAA2B,gBAAA;ALs7nC3B;;AKr7nCA;EAA4B,gBAAA;ALy7nC5B;;AKx7nCA;EAA4B,gBAAA;AL47nC5B;;AK37nCA;EAA2B,gBAAA;AL+7nC3B;;AK97nCA;EAA2B,gBAAA;ALk8nC3B;;AKj8nCA;EAA+B,gBAAA;ALq8nC/B;;AKp8nCA;EAA+B,gBAAA;ALw8nC/B;;AKv8nCA;EAA2B,gBAAA;AL28nC3B;;AK18nCA;EAA2B,gBAAA;AL88nC3B;;AK78nCA;EAAkC,gBAAA;ALi9nClC;;AKh9nCA;EAAkC,gBAAA;ALo9nClC;;AKn9nCA;EAA8B,gBAAA;ALu9nC9B;;AKt9nCA;EAA8B,gBAAA;AL09nC9B;;AKz9nCA;EAA0B,gBAAA;AL69nC1B;;AK59nCA;EAAuB,gBAAA;ALg+nCvB;;AK/9nCA;EAAkB,gBAAA;ALm+nClB;;AKl+nCA;EAA6B,gBAAA;ALs+nC7B;;AKr+nCA;EAA6B,gBAAA;ALy+nC7B;;AKx+nCA;EAA2B,gBAAA;AL4+nC3B;;AK3+nCA;EAA2B,gBAAA;AL++nC3B;;AK9+nCA;EAAgC,gBAAA;ALk/nChC;;AKj/nCA;EAAgC,gBAAA;ALq/nChC;;AKp/nCA;EAA2B,gBAAA;ALw/nC3B;;AKv/nCA;EAA2B,gBAAA;AL2/nC3B;;AK1/nCA;EAAyB,gBAAA;AL8/nCzB;;AK7/nCA;EAAyB,gBAAA;ALigoCzB;;AKhgoCA;EAAuB,gBAAA;ALogoCvB;;AKngoCA;EAAuB,gBAAA;ALugoCvB;;AKtgoCA;EAA0B,gBAAA;AL0goC1B;;AKzgoCA;EAA0B,gBAAA;AL6goC1B;;AK5goCA;EAAwB,gBAAA;ALghoCxB;;AK/goCA;EAA8B,gBAAA;ALmhoC9B;;AKlhoCA;EAA8B,gBAAA;ALshoC9B;;AKrhoCA;EAAwB,gBAAA;ALyhoCxB;;AKxhoCA;EAAuB,gBAAA;AL4hoCvB;;AK3hoCA;EAAuB,gBAAA;AL+hoCvB;;AK9hoCA;EAAyB,gBAAA;ALkioCzB;;AKjioCA;EAAyB,gBAAA;ALqioCzB;;AKpioCA;EAAwB,gBAAA;ALwioCxB;;AKvioCA;EAAwB,gBAAA;AL2ioCxB;;AK1ioCA;EAA0B,gBAAA;AL8ioC1B;;AK7ioCA;EAA0B,gBAAA;ALijoC1B;;AKhjoCA;EAA4B,gBAAA;ALojoC5B;;AKnjoCA;EAA4B,gBAAA;ALujoC5B;;AKtjoCA;EAAgC,gBAAA;AL0joChC;;AKzjoCA;EAAgC,gBAAA;AL6joChC;;AK5joCA;EAAwB,gBAAA;ALgkoCxB;;AK/joCA;EAAwB,gBAAA;ALmkoCxB;;AKlkoCA;EAA6B,gBAAA;ALskoC7B;;AKrkoCA;EAA6B,gBAAA;ALykoC7B;;AKxkoCA;EAAyB,gBAAA;AL4koCzB;;AK3koCA;EAAuB,gBAAA;AL+koCvB;;AK9koCA;EAA2B,gBAAA;ALkloC3B;;AKjloCA;EAA2B,gBAAA;ALqloC3B;;AKploCA;EAA+B,gBAAA;ALwloC/B;;AKvloCA;EAA+B,gBAAA;AL2loC/B;;AK1loCA;EAAyB,gBAAA;AL8loCzB;;AK7loCA;EAAyB,gBAAA;ALimoCzB;;AKhmoCA;EAAyB,gBAAA;ALomoCzB;;AKnmoCA;EAAyB,gBAAA;ALumoCzB;;AKtmoCA;EAAwB,gBAAA;AL0moCxB;;AKzmoCA;EAAwB,gBAAA;AL6moCxB;;AK5moCA;EAAyB,gBAAA;ALgnoCzB;;AK/moCA;EAAyB,gBAAA;ALmnoCzB;;AKlnoCA;EAAuB,gBAAA;ALsnoCvB;;AKrnoCA;EAAuB,gBAAA;ALynoCvB;;AKxnoCA;EAAqB,gBAAA;AL4noCrB;;AK3noCA;EAAqB,gBAAA;AL+noCrB;;AK9noCA;EAAyB,gBAAA;ALkooCzB;;AKjooCA;EAAyB,gBAAA;ALqooCzB;;AKpooCA;EAA0B,gBAAA;ALwooC1B;;AKvooCA;EAA0B,gBAAA;AL2ooC1B;;AK1ooCA;EAA0B,gBAAA;AL8ooC1B;;AK7ooCA;EAA0B,gBAAA;ALipoC1B;;AKhpoCA;EAAyB,gBAAA;ALopoCzB;;AKnpoCA;EAAyB,gBAAA;ALupoCzB;;AKtpoCA;EAAyB,gBAAA;AL0poCzB;;AKzpoCA;EAAyB,gBAAA;AL6poCzB;;AK5poCA;EAA2B,gBAAA;ALgqoC3B;;AK/poCA;EAA2B,gBAAA;ALmqoC3B;;AKlqoCA;EAAuB,gBAAA;ALsqoCvB;;AKrqoCA;EAA4B,gBAAA;ALyqoC5B;;AKxqoCA;EAA4B,gBAAA;AL4qoC5B;;AK3qoCA;EAA2B,gBAAA;AL+qoC3B;;AK9qoCA;EAA2B,gBAAA;ALkroC3B;;AKjroCA;EAA2B,gBAAA;ALqroC3B;;AKproCA;EAA2B,gBAAA;ALwroC3B;;AKvroCA;EAAiC,gBAAA;AL2roCjC;;AK1roCA;EAAiC,gBAAA;AL8roCjC;;AK7roCA;EAA+B,gBAAA;ALisoC/B;;AKhsoCA;EAA+B,gBAAA;ALosoC/B;;AKnsoCA;EAAyB,gBAAA;ALusoCzB;;AKtsoCA;EAAyB,gBAAA;AL0soCzB;;AKzsoCA;EAAyB,gBAAA;AL6soCzB;;AK5soCA;EAAyB,gBAAA;ALgtoCzB;;AK/soCA;EAAyB,gBAAA;ALmtoCzB;;AKltoCA;EAAyB,gBAAA;ALstoCzB;;AKrtoCA;EAAyB,gBAAA;ALytoCzB;;AKxtoCA;EAAyB,gBAAA;AL4toCzB;;AK3toCA;EAAyB,gBAAA;AL+toCzB;;AK9toCA;EAAyB,gBAAA;ALkuoCzB;;AKjuoCA;EAAyB,gBAAA;ALquoCzB;;AKpuoCA;EAAyB,gBAAA;ALwuoCzB;;AKvuoCA;EAA2B,gBAAA;AL2uoC3B;;AK1uoCA;EAA2B,gBAAA;AL8uoC3B;;AK7uoCA;EAAuB,gBAAA;ALivoCvB;;AKhvoCA;EAA8B,gBAAA;ALovoC9B;;AKnvoCA;EAA8B,gBAAA;ALuvoC9B;;AKtvoCA;EAA6B,gBAAA;AL0voC7B;;AKzvoCA;EAA6B,gBAAA;AL6voC7B;;AK5voCA;EAAuB,gBAAA;ALgwoCvB;;AK/voCA;EAAgC,gBAAA;ALmwoChC;;AKlwoCA;EAAgC,gBAAA;ALswoChC;;AKrwoCA;EAAkC,gBAAA;ALywoClC;;AKxwoCA;EAAkC,gBAAA;AL4woClC;;AK3woCA;EAAgC,gBAAA;AL+woChC;;AK9woCA;EAAgC,gBAAA;ALkxoChC;;AKjxoCA;EAA8B,gBAAA;ALqxoC9B;;AKpxoCA;EAA8B,gBAAA;ALwxoC9B;;AKvxoCA;EAAgC,gBAAA;AL2xoChC;;AK1xoCA;EAAgC,gBAAA;AL8xoChC;;AK7xoCA;EAAgC,gBAAA;ALiyoChC;;AKhyoCA;EAAgC,gBAAA;ALoyoChC;;AKnyoCA;EAA8B,gBAAA;ALuyoC9B;;AKtyoCA;EAA8B,gBAAA;AL0yoC9B;;AKzyoCA;EAA6B,gBAAA;AL6yoC7B;;AK5yoCA;EAA6B,gBAAA;ALgzoC7B;;AK/yoCA;EAA4B,gBAAA;ALmzoC5B;;AKlzoCA;EAA4B,gBAAA;ALszoC5B;;AKrzoCA;EAAgC,gBAAA;ALyzoChC;;AKxzoCA;EAAgC,gBAAA;AL4zoChC;;AK3zoCA;EAA6B,gBAAA;AL+zoC7B;;AK9zoCA;EAA6B,gBAAA;ALk0oC7B;;AKj0oCA;EAA4B,gBAAA;ALq0oC5B;;AKp0oCA;EAA4B,gBAAA;ALw0oC5B;;AKv0oCA;EAA6B,gBAAA;AL20oC7B;;AK10oCA;EAA6B,gBAAA;AL80oC7B;;AK70oCA;EAAiC,gBAAA;ALi1oCjC;;AKh1oCA;EAAiC,gBAAA;ALo1oCjC;;AKn1oCA;EAAwB,gBAAA;ALu1oCxB;;AKt1oCA;EAAwB,gBAAA;AL01oCxB;;AKz1oCA;EAA+B,gBAAA;AL61oC/B;;AK51oCA;EAA+B,gBAAA;ALg2oC/B;;AK/1oCA;EAA4B,gBAAA;ALm2oC5B;;AKl2oCA;EAA4B,gBAAA;ALs2oC5B;;AKr2oCA;EAA0B,gBAAA;ALy2oC1B;;AKx2oCA;EAA0B,gBAAA;AL42oC1B;;AK32oCA;EAA8B,gBAAA;AL+2oC9B;;AK92oCA;EAA8B,gBAAA;ALk3oC9B;;AKj3oCA;EAA4B,gBAAA;ALq3oC5B;;AKp3oCA;EAA4B,gBAAA;ALw3oC5B;;AKv3oCA;EAA8B,gBAAA;AL23oC9B;;AK13oCA;EAA8B,gBAAA;AL83oC9B;;AK73oCA;EAAsB,gBAAA;ALi4oCtB;;AKh4oCA;EAAsB,gBAAA;ALo4oCtB;;AKn4oCA;EAAuB,gBAAA;ALu4oCvB;;AKt4oCA;EAAuB,gBAAA;AL04oCvB;;AKz4oCA;EAAoC,gBAAA;AL64oCpC;;AK54oCA;EAAoC,gBAAA;ALg5oCpC;;AK/4oCA;EAA6B,gBAAA;ALm5oC7B;;AKl5oCA;EAA6B,gBAAA;ALs5oC7B;;AKr5oCA;EAA8B,gBAAA;ALy5oC9B;;AKx5oCA;EAA8B,gBAAA;AL45oC9B;;AK35oCA;EAA8B,gBAAA;AL+5oC9B;;AK95oCA;EAA8B,gBAAA;ALk6oC9B;;AKj6oCA;EAAqC,gBAAA;ALq6oCrC;;AKp6oCA;EAAqC,gBAAA;ALw6oCrC;;AKv6oCA;EAA4B,gBAAA;AL26oC5B;;AK16oCA;EAA4B,gBAAA;AL86oC5B;;AK76oCA;EAAiC,gBAAA;ALi7oCjC;;AKh7oCA;EAAiC,gBAAA;ALo7oCjC;;AKn7oCA;EAAwB,gBAAA;ALu7oCxB;;AKt7oCA;EAAwB,gBAAA;AL07oCxB;;AKz7oCA;EAAuB,gBAAA;AL67oCvB;;AK57oCA;EAAuB,gBAAA;ALg8oCvB;;AK/7oCA;EAA2B,gBAAA;ALm8oC3B;;AKl8oCA;EAA2B,gBAAA;ALs8oC3B;;AKr8oCA;EAA2B,gBAAA;ALy8oC3B;;AKx8oCA;EAA2B,gBAAA;AL48oC3B;;AK38oCA;EAAyB,gBAAA;AL+8oCzB;;AK98oCA;EAAyB,gBAAA;ALk9oCzB;;AKj9oCA;EAA8B,gBAAA;ALq9oC9B;;AKp9oCA;EAA8B,gBAAA;ALw9oC9B;;AKv9oCA;EAAyB,gBAAA;AL29oCzB;;AK19oCA;EAAyB,gBAAA;AL89oCzB;;AK79oCA;EAA2B,gBAAA;ALi+oC3B;;AKh+oCA;EAA2B,gBAAA;ALo+oC3B;;AKn+oCA;EAAyB,gBAAA;ALu+oCzB;;AKt+oCA;EAAyB,gBAAA;AL0+oCzB;;AKz+oCA;EAA6B,gBAAA;AL6+oC7B;;AK5+oCA;EAA6B,gBAAA;ALg/oC7B;;AK/+oCA;EAAwB,gBAAA;ALm/oCxB;;AKl/oCA;EAAwB,gBAAA;ALs/oCxB;;AKr/oCA;EAA2B,gBAAA;ALy/oC3B;;AKx/oCA;EAA2B,gBAAA;AL4/oC3B;;AK3/oCA;EAA6B,gBAAA;AL+/oC7B;;AK9/oCA;EAA6B,gBAAA;ALkgpC7B;;AKjgpCA;EAAuB,gBAAA;ALqgpCvB;;AKpgpCA;EAAuB,gBAAA;ALwgpCvB;;AKvgpCA;EAA2B,gBAAA;AL2gpC3B;;AK1gpCA;EAA2B,gBAAA;AL8gpC3B;;AK7gpCA;EAA2B,gBAAA;ALihpC3B;;AKhhpCA;EAA2B,gBAAA;ALohpC3B;;AKnhpCA;EAAyB,gBAAA;ALuhpCzB;;AKthpCA;EAAyB,gBAAA;AL0hpCzB;;AKzhpCA;EAA0B,gBAAA;AL6hpC1B;;AK5hpCA;EAA0B,gBAAA;ALgipC1B;;AK/hpCA;EAAwB,gBAAA;ALmipCxB;;AKlipCA;EAAwB,gBAAA;ALsipCxB;;AKripCA;EAAoC,gBAAA;ALyipCpC;;AKxipCA;EAAoC,gBAAA;AL4ipCpC;;AK3ipCA;EAAwB,gBAAA;AL+ipCxB;;AK9ipCA;EAAwB,gBAAA;ALkjpCxB;;AKjjpCA;EAAwB,gBAAA;ALqjpCxB;;AKpjpCA;EAAuB,gBAAA;ALwjpCvB;;AKvjpCA;EAAuB,gBAAA;AL2jpCvB;;AK1jpCA;EAAuB,gBAAA;AL8jpCvB;;AK7jpCA;EAAuB,gBAAA;ALikpCvB;;AKhkpCA;EAA0B,gBAAA;ALokpC1B;;AKnkpCA;EAA0B,gBAAA;ALukpC1B;;AKtkpCA;EAAwB,gBAAA;AL0kpCxB;;AKzkpCA;EAAwB,gBAAA;AL6kpCxB;;AK5kpCA;EAAwB,gBAAA;ALglpCxB;;AK/kpCA;EAAwB,gBAAA;ALmlpCxB;;AKllpCA;EAA0B,gBAAA;ALslpC1B;;AKrlpCA;EAA0B,gBAAA;ALylpC1B;;AKxlpCA;EAA2B,gBAAA;AL4lpC3B;;AK3lpCA;EAA2B,gBAAA;AL+lpC3B;;AMhvtCA;;;;;;CAAA;ACCE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,8BAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,6BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,mCAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,gDAAA;EAAA,8CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,oDAAA;EAAA,kDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,0CAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,2BALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,uBAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,gCAAA;EACA,0BAAA;EAEA,2CAAA;EACA,sCAAA;EAGE,qCAAA;EAGF,wBAAA;EACA,6BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,8CAAA;EACA,iDAAA;EACA,iDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,8CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;ARuvtCF;;AUv2tCI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,gCAAA;EAGE,mCAAA;EAAA,oDAAA;EAAA,kDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,yCAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,6BAAA;EAAA,0CAAA;EAIA,mCAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,iDAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,wBAAA;EAEA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,wCAAA;EAEA,uCAAA;EACA,6BAAA;EACA,sCAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,6CAAA;EACA,oDAAA;EACA,+CAAA;EACA,sDAAA;ARuvtCJ;;AW/5tCA;;;EAGE,sBAAA;AXk6tCF;;AWn5tCI;EANJ;IAOM,uBAAA;EXu5tCJ;AACF;;AW14tCA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AX64tCF;;AWp4tCA;EACE,cAAA;EACA,yBC0sBS;EDzsBT,SAAA;EACA,wCAAA;EACA,YCgtBW;AZursCb;;AW73tCA;EACE,aAAA;EACA,qBC+oBuB;ED5oBvB,gBC+oBqB;ED9oBrB,gBC+oBqB;ED9oBrB,8BAAA;AX83tCF;;AW33tCA;EFuMQ,gCAAA;ATwrtCR;ASp1tCI;EE3CJ;IF8MQ,kBAAA;ETqrtCN;AACF;;AW/3tCA;EFkMQ,kCAAA;ATistCR;AS71tCI;EEtCJ;IFyMQ,iBAAA;ET8rtCN;AACF;;AWn4tCA;EF6LQ,mCAAA;AT0stCR;ASt2tCI;EEjCJ;IFoMQ,mBAAA;ETustCN;AACF;;AWv4tCA;EFwLQ,iCAAA;ATmttCR;AS/2tCI;EE5BJ;IF+LQ,kBAAA;ETgttCN;AACF;;AW34tCA;EF+KM,mBALI;ATqutCV;;AW14tCA;EF0KM,iBALI;ATyutCV;;AWn4tCA;EACE,aAAA;EACA,mBCibwB;AZq9sC1B;;AW53tCA;EACE,iCAAA;EACA,YAAA;EACA,8BAAA;AX+3tCF;;AWz3tCA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AX43tCF;;AWt3tCA;;EAEE,kBAAA;AXy3tCF;;AWt3tCA;;;EAGE,aAAA;EACA,mBAAA;AXy3tCF;;AWt3tCA;;;;EAIE,gBAAA;AXy3tCF;;AWt3tCA;EACE,gBCohBiB;AZq2sCnB;;AWp3tCA;EACE,qBAAA;EACA,cAAA;AXu3tCF;;AWj3tCA;EACE,gBAAA;AXo3tCF;;AW52tCA;;EAEE,mBC6fmB;AZk3sCrB;;AWv2tCA;EF6EM,cALI;ATmytCV;;AWp2tCA;EACE,cC4kBa;ED3kBb,gCAAA;EACA,wCAAA;AXu2tCF;;AW91tCA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;AXi2tCF;;AW91tCA;EAAM,eAAA;AXk2tCN;;AWj2tCA;EAAM,WAAA;AXq2tCN;;AWh2tCA;EACE,gEAAA;EACA,qBCySgB;AZ0jtClB;AWj2tCE;EACE,mDAAA;EACA,0BCwSoB;AZ2jtCxB;;AWz1tCE;EAEE,cAAA;EACA,qBAAA;AX21tCJ;;AWp1tCA;;;;EAIE,qCCuaiB;EHzZb,cALI;AT+0tCV;;AWh1tCA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,gBALI;EEKR,cCrLS;AZwguCX;AWh1tCE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;AXk1tCJ;;AW90tCA;EFVM,gBALI;EEiBR,2BAAA;EACA,qBAAA;AXi1tCF;AW90tCE;EACE,cAAA;AXg1tCJ;;AW50tCA;EACE,sBAAA;EFtBI,gBALI;EE6BR,wBCogDU;EDngDV,sCCogDO;ECzyDL,sBAAA;AbqnuCJ;AW70tCE;EACE,UAAA;EF7BE,cALI;ATk3tCV;;AWr0tCA;EACE,gBAAA;AXw0tCF;;AWl0tCA;;EAEE,sBAAA;AXq0tCF;;AW7ztCA;EACE,oBAAA;EACA,yBAAA;AXg0tCF;;AW7ztCA;EACE,oBCkdqB;EDjdrB,uBCidqB;EDhdrB,gCCkfoB;EDjfpB,gBAAA;AXg0tCF;;AWzztCA;EAEE,mBAAA;EACA,gCAAA;AX2ztCF;;AWxztCA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AX2ztCF;;AWnztCA;EACE,qBAAA;AXsztCF;;AWhztCA;EAEE,gBAAA;AXkztCF;;AW1ytCA;EACE,UAAA;AX6ytCF;;AWxytCA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;AX2ytCF;;AWvytCA;;EAEE,oBAAA;AX0ytCF;;AWrytCA;EACE,eAAA;AXwytCF;;AWrytCA;EAGE,iBAAA;AXsytCF;AWnytCE;EACE,UAAA;AXqytCJ;;AW9xtCA;EACE,wBAAA;AXiytCF;;AWzxtCA;;;;EAIE,0BAAA;AX4xtCF;AWzxtCI;;;;EACE,eAAA;AX8xtCN;;AWvxtCA;EACE,UAAA;EACA,kBAAA;AX0xtCF;;AWrxtCA;EACE,gBAAA;AXwxtCF;;AW9wtCA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AXixtCF;;AWzwtCA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBGmN4B;ELpatB,iCAAA;EEoNN,oBAAA;AX2wtCF;AS3nuCI;EEyWJ;IFtMQ,iBAAA;ET49tCN;AACF;AW9wtCE;EACE,WAAA;AXgxtCJ;;AWzwtCA;;;;;;;EAOE,UAAA;AX4wtCF;;AWzwtCA;EACE,YAAA;AX4wtCF;;AWnwtCA;EACE,6BAAA;EACA,oBAAA;AXswtCF;;AW9vtCA;;;;;;;CAAA;AAWA;EACE,wBAAA;AX8vtCF;;AWzvtCA;EACE,UAAA;AX4vtCF;;AWrvtCA;EACE,aAAA;EACA,0BAAA;AXwvtCF;;AWnvtCA;EACE,qBAAA;AXsvtCF;;AWjvtCA;EACE,SAAA;AXovtCF;;AW7utCA;EACE,kBAAA;EACA,eAAA;AXgvtCF;;AWxutCA;EACE,wBAAA;AX2utCF;;AWnutCA;EACE,wBAAA;AXsutCF;;Ae3yuCA;ENmQM,mBALI;EM5PR,gBH+tBiB;AZ+ktCnB;;AezyuCE;ENgQM,iCAAA;EM5PJ,gBHgtBkB;EG/sBlB,gBH+rBmB;AZ2mtCvB;AS3suCI;EMpGF;INuQM,eAAA;ET4iuCN;AACF;;AepzuCE;ENgQM,iCAAA;EM5PJ,gBHgtBkB;EG/sBlB,gBH+rBmB;AZsntCvB;ASttuCI;EMpGF;INuQM,iBAAA;ETujuCN;AACF;;Ae/zuCE;ENgQM,iCAAA;EM5PJ,gBHgtBkB;EG/sBlB,gBH+rBmB;AZiotCvB;ASjuuCI;EMpGF;INuQM,eAAA;ETkkuCN;AACF;;Ae10uCE;ENgQM,iCAAA;EM5PJ,gBHgtBkB;EG/sBlB,gBH+rBmB;AZ4otCvB;AS5uuCI;EMpGF;INuQM,iBAAA;ET6kuCN;AACF;;Aer1uCE;ENgQM,iCAAA;EM5PJ,gBHgtBkB;EG/sBlB,gBH+rBmB;AZuptCvB;ASvvuCI;EMpGF;INuQM,eAAA;ETwluCN;AACF;;Aeh2uCE;ENgQM,iCAAA;EM5PJ,gBHgtBkB;EG/sBlB,gBH+rBmB;AZkqtCvB;ASlwuCI;EMpGF;INuQM,iBAAA;ETmmuCN;AACF;;Aen1uCA;ECvDE,eAAA;EACA,gBAAA;AhB84uCF;;Aen1uCA;EC5DE,eAAA;EACA,gBAAA;AhBm5uCF;;Aer1uCA;EACE,qBAAA;Afw1uCF;Aet1uCE;EACE,oBH6tBkB;AZ2ntCtB;;Ae90uCA;EN8MM,cALI;EMvMR,yBAAA;Afi1uCF;;Ae70uCA;EACE,mBH0ZO;EHnNH,mBALI;AT+ouCV;Ae90uCE;EACE,gBAAA;Afg1uCJ;;Ae50uCA;EACE,iBAAA;EACA,mBHgZO;EHnNH,cALI;EMtLR,cHGS;AZ40uCX;Ae70uCE;EACE,aAAA;Af+0uCJ;;AiB/6uCA;ECIE,eAAA;EAGA,YAAA;AlB66uCF;;AiB96uCA;EACE,gBL8qDkB;EK7qDlB,mCL8qDa;EK7qDb,2DAAA;EJGE,sCAAA;EKRF,eAAA;EAGA,YAAA;AlBs7uCF;;AiBx6uCA;EAEE,qBAAA;AjB06uCF;;AiBv6uCA;EACE,qBAAA;EACA,cAAA;AjB06uCF;;AiBv6uCA;ERyPM,cALI;EQlPR,cL+DS;AZ22uCX;;AmB58uCE;;;;;;;ECHA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;ApBy9uCF;;AqBn6uCI;EF5CE;IACE,gBPyjBe;EZ05tCrB;AACF;AqBz6uCI;EF5CE;IACE,gBPyjBe;EZ+5tCrB;AACF;AqB96uCI;EF5CE;IACE,gBPyjBe;EZo6tCrB;AACF;AqBn7uCI;EF5CE;IACE,iBPyjBe;EZy6tCrB;AACF;AqBx7uCI;EF5CE;IACE,iBPyjBe;EZ86tCrB;AACF;AsBx/uCA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AtB8/uCJ;;AsBz/uCE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AvBkgvCF;AsBhgvCI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AvB4/uCF;;AuB78uCM;EACE,SAAA;AvBg9uCR;;AuB78uCM;EApCJ,cAAA;EACA,WAAA;AvBq/uCF;;AuBv+uCE;EACE,cAAA;EACA,WAAA;AvB0+uCJ;;AuB5+uCE;EACE,cAAA;EACA,UAAA;AvB++uCJ;;AuBj/uCE;EACE,cAAA;EACA,mBAAA;AvBo/uCJ;;AuBt/uCE;EACE,cAAA;EACA,UAAA;AvBy/uCJ;;AuB3/uCE;EACE,cAAA;EACA,UAAA;AvB8/uCJ;;AuBhgvCE;EACE,cAAA;EACA,mBAAA;AvBmgvCJ;;AuBp+uCM;EAhDJ,cAAA;EACA,WAAA;AvBwhvCF;;AuBn+uCU;EAhEN,cAAA;EACA,kBAAA;AvBuivCJ;;AuBx+uCU;EAhEN,cAAA;EACA,mBAAA;AvB4ivCJ;;AuB7+uCU;EAhEN,cAAA;EACA,UAAA;AvBijvCJ;;AuBl/uCU;EAhEN,cAAA;EACA,mBAAA;AvBsjvCJ;;AuBv/uCU;EAhEN,cAAA;EACA,mBAAA;AvB2jvCJ;;AuB5/uCU;EAhEN,cAAA;EACA,UAAA;AvBgkvCJ;;AuBjgvCU;EAhEN,cAAA;EACA,mBAAA;AvBqkvCJ;;AuBtgvCU;EAhEN,cAAA;EACA,mBAAA;AvB0kvCJ;;AuB3gvCU;EAhEN,cAAA;EACA,UAAA;AvB+kvCJ;;AuBhhvCU;EAhEN,cAAA;EACA,mBAAA;AvBolvCJ;;AuBrhvCU;EAhEN,cAAA;EACA,mBAAA;AvBylvCJ;;AuB1hvCU;EAhEN,cAAA;EACA,WAAA;AvB8lvCJ;;AuBvhvCY;EAxDV,wBAAA;AvBmlvCF;;AuB3hvCY;EAxDV,yBAAA;AvBulvCF;;AuB/hvCY;EAxDV,gBAAA;AvB2lvCF;;AuBnivCY;EAxDV,yBAAA;AvB+lvCF;;AuBvivCY;EAxDV,yBAAA;AvBmmvCF;;AuB3ivCY;EAxDV,gBAAA;AvBumvCF;;AuB/ivCY;EAxDV,yBAAA;AvB2mvCF;;AuBnjvCY;EAxDV,yBAAA;AvB+mvCF;;AuBvjvCY;EAxDV,gBAAA;AvBmnvCF;;AuB3jvCY;EAxDV,yBAAA;AvBunvCF;;AuB/jvCY;EAxDV,yBAAA;AvB2nvCF;;AuBxjvCQ;;EAEE,gBAAA;AvB2jvCV;;AuBxjvCQ;;EAEE,gBAAA;AvB2jvCV;;AuBlkvCQ;;EAEE,sBAAA;AvBqkvCV;;AuBlkvCQ;;EAEE,sBAAA;AvBqkvCV;;AuB5kvCQ;;EAEE,qBAAA;AvB+kvCV;;AuB5kvCQ;;EAEE,qBAAA;AvB+kvCV;;AuBtlvCQ;;EAEE,mBAAA;AvBylvCV;;AuBtlvCQ;;EAEE,mBAAA;AvBylvCV;;AuBhmvCQ;;EAEE,qBAAA;AvBmmvCV;;AuBhmvCQ;;EAEE,qBAAA;AvBmmvCV;;AuB1mvCQ;;EAEE,mBAAA;AvB6mvCV;;AuB1mvCQ;;EAEE,mBAAA;AvB6mvCV;;AqBvqvCI;EEUE;IACE,SAAA;EvBiqvCN;EuB9pvCI;IApCJ,cAAA;IACA,WAAA;EvBqsvCA;EuBvrvCA;IACE,cAAA;IACA,WAAA;EvByrvCF;EuB3rvCA;IACE,cAAA;IACA,UAAA;EvB6rvCF;EuB/rvCA;IACE,cAAA;IACA,mBAAA;EvBisvCF;EuBnsvCA;IACE,cAAA;IACA,UAAA;EvBqsvCF;EuBvsvCA;IACE,cAAA;IACA,UAAA;EvBysvCF;EuB3svCA;IACE,cAAA;IACA,mBAAA;EvB6svCF;EuB9qvCI;IAhDJ,cAAA;IACA,WAAA;EvBiuvCA;EuB5qvCQ;IAhEN,cAAA;IACA,kBAAA;EvB+uvCF;EuBhrvCQ;IAhEN,cAAA;IACA,mBAAA;EvBmvvCF;EuBprvCQ;IAhEN,cAAA;IACA,UAAA;EvBuvvCF;EuBxrvCQ;IAhEN,cAAA;IACA,mBAAA;EvB2vvCF;EuB5rvCQ;IAhEN,cAAA;IACA,mBAAA;EvB+vvCF;EuBhsvCQ;IAhEN,cAAA;IACA,UAAA;EvBmwvCF;EuBpsvCQ;IAhEN,cAAA;IACA,mBAAA;EvBuwvCF;EuBxsvCQ;IAhEN,cAAA;IACA,mBAAA;EvB2wvCF;EuB5svCQ;IAhEN,cAAA;IACA,UAAA;EvB+wvCF;EuBhtvCQ;IAhEN,cAAA;IACA,mBAAA;EvBmxvCF;EuBptvCQ;IAhEN,cAAA;IACA,mBAAA;EvBuxvCF;EuBxtvCQ;IAhEN,cAAA;IACA,WAAA;EvB2xvCF;EuBptvCU;IAxDV,cAAA;EvB+wvCA;EuBvtvCU;IAxDV,wBAAA;EvBkxvCA;EuB1tvCU;IAxDV,yBAAA;EvBqxvCA;EuB7tvCU;IAxDV,gBAAA;EvBwxvCA;EuBhuvCU;IAxDV,yBAAA;EvB2xvCA;EuBnuvCU;IAxDV,yBAAA;EvB8xvCA;EuBtuvCU;IAxDV,gBAAA;EvBiyvCA;EuBzuvCU;IAxDV,yBAAA;EvBoyvCA;EuB5uvCU;IAxDV,yBAAA;EvBuyvCA;EuB/uvCU;IAxDV,gBAAA;EvB0yvCA;EuBlvvCU;IAxDV,yBAAA;EvB6yvCA;EuBrvvCU;IAxDV,yBAAA;EvBgzvCA;EuB7uvCM;;IAEE,gBAAA;EvB+uvCR;EuB5uvCM;;IAEE,gBAAA;EvB8uvCR;EuBrvvCM;;IAEE,sBAAA;EvBuvvCR;EuBpvvCM;;IAEE,sBAAA;EvBsvvCR;EuB7vvCM;;IAEE,qBAAA;EvB+vvCR;EuB5vvCM;;IAEE,qBAAA;EvB8vvCR;EuBrwvCM;;IAEE,mBAAA;EvBuwvCR;EuBpwvCM;;IAEE,mBAAA;EvBswvCR;EuB7wvCM;;IAEE,qBAAA;EvB+wvCR;EuB5wvCM;;IAEE,qBAAA;EvB8wvCR;EuBrxvCM;;IAEE,mBAAA;EvBuxvCR;EuBpxvCM;;IAEE,mBAAA;EvBsxvCR;AACF;AqBj1vCI;EEUE;IACE,SAAA;EvB00vCN;EuBv0vCI;IApCJ,cAAA;IACA,WAAA;EvB82vCA;EuBh2vCA;IACE,cAAA;IACA,WAAA;EvBk2vCF;EuBp2vCA;IACE,cAAA;IACA,UAAA;EvBs2vCF;EuBx2vCA;IACE,cAAA;IACA,mBAAA;EvB02vCF;EuB52vCA;IACE,cAAA;IACA,UAAA;EvB82vCF;EuBh3vCA;IACE,cAAA;IACA,UAAA;EvBk3vCF;EuBp3vCA;IACE,cAAA;IACA,mBAAA;EvBs3vCF;EuBv1vCI;IAhDJ,cAAA;IACA,WAAA;EvB04vCA;EuBr1vCQ;IAhEN,cAAA;IACA,kBAAA;EvBw5vCF;EuBz1vCQ;IAhEN,cAAA;IACA,mBAAA;EvB45vCF;EuB71vCQ;IAhEN,cAAA;IACA,UAAA;EvBg6vCF;EuBj2vCQ;IAhEN,cAAA;IACA,mBAAA;EvBo6vCF;EuBr2vCQ;IAhEN,cAAA;IACA,mBAAA;EvBw6vCF;EuBz2vCQ;IAhEN,cAAA;IACA,UAAA;EvB46vCF;EuB72vCQ;IAhEN,cAAA;IACA,mBAAA;EvBg7vCF;EuBj3vCQ;IAhEN,cAAA;IACA,mBAAA;EvBo7vCF;EuBr3vCQ;IAhEN,cAAA;IACA,UAAA;EvBw7vCF;EuBz3vCQ;IAhEN,cAAA;IACA,mBAAA;EvB47vCF;EuB73vCQ;IAhEN,cAAA;IACA,mBAAA;EvBg8vCF;EuBj4vCQ;IAhEN,cAAA;IACA,WAAA;EvBo8vCF;EuB73vCU;IAxDV,cAAA;EvBw7vCA;EuBh4vCU;IAxDV,wBAAA;EvB27vCA;EuBn4vCU;IAxDV,yBAAA;EvB87vCA;EuBt4vCU;IAxDV,gBAAA;EvBi8vCA;EuBz4vCU;IAxDV,yBAAA;EvBo8vCA;EuB54vCU;IAxDV,yBAAA;EvBu8vCA;EuB/4vCU;IAxDV,gBAAA;EvB08vCA;EuBl5vCU;IAxDV,yBAAA;EvB68vCA;EuBr5vCU;IAxDV,yBAAA;EvBg9vCA;EuBx5vCU;IAxDV,gBAAA;EvBm9vCA;EuB35vCU;IAxDV,yBAAA;EvBs9vCA;EuB95vCU;IAxDV,yBAAA;EvBy9vCA;EuBt5vCM;;IAEE,gBAAA;EvBw5vCR;EuBr5vCM;;IAEE,gBAAA;EvBu5vCR;EuB95vCM;;IAEE,sBAAA;EvBg6vCR;EuB75vCM;;IAEE,sBAAA;EvB+5vCR;EuBt6vCM;;IAEE,qBAAA;EvBw6vCR;EuBr6vCM;;IAEE,qBAAA;EvBu6vCR;EuB96vCM;;IAEE,mBAAA;EvBg7vCR;EuB76vCM;;IAEE,mBAAA;EvB+6vCR;EuBt7vCM;;IAEE,qBAAA;EvBw7vCR;EuBr7vCM;;IAEE,qBAAA;EvBu7vCR;EuB97vCM;;IAEE,mBAAA;EvBg8vCR;EuB77vCM;;IAEE,mBAAA;EvB+7vCR;AACF;AqB1/vCI;EEUE;IACE,SAAA;EvBm/vCN;EuBh/vCI;IApCJ,cAAA;IACA,WAAA;EvBuhwCA;EuBzgwCA;IACE,cAAA;IACA,WAAA;EvB2gwCF;EuB7gwCA;IACE,cAAA;IACA,UAAA;EvB+gwCF;EuBjhwCA;IACE,cAAA;IACA,mBAAA;EvBmhwCF;EuBrhwCA;IACE,cAAA;IACA,UAAA;EvBuhwCF;EuBzhwCA;IACE,cAAA;IACA,UAAA;EvB2hwCF;EuB7hwCA;IACE,cAAA;IACA,mBAAA;EvB+hwCF;EuBhgwCI;IAhDJ,cAAA;IACA,WAAA;EvBmjwCA;EuB9/vCQ;IAhEN,cAAA;IACA,kBAAA;EvBikwCF;EuBlgwCQ;IAhEN,cAAA;IACA,mBAAA;EvBqkwCF;EuBtgwCQ;IAhEN,cAAA;IACA,UAAA;EvBykwCF;EuB1gwCQ;IAhEN,cAAA;IACA,mBAAA;EvB6kwCF;EuB9gwCQ;IAhEN,cAAA;IACA,mBAAA;EvBilwCF;EuBlhwCQ;IAhEN,cAAA;IACA,UAAA;EvBqlwCF;EuBthwCQ;IAhEN,cAAA;IACA,mBAAA;EvBylwCF;EuB1hwCQ;IAhEN,cAAA;IACA,mBAAA;EvB6lwCF;EuB9hwCQ;IAhEN,cAAA;IACA,UAAA;EvBimwCF;EuBliwCQ;IAhEN,cAAA;IACA,mBAAA;EvBqmwCF;EuBtiwCQ;IAhEN,cAAA;IACA,mBAAA;EvBymwCF;EuB1iwCQ;IAhEN,cAAA;IACA,WAAA;EvB6mwCF;EuBtiwCU;IAxDV,cAAA;EvBimwCA;EuBziwCU;IAxDV,wBAAA;EvBomwCA;EuB5iwCU;IAxDV,yBAAA;EvBumwCA;EuB/iwCU;IAxDV,gBAAA;EvB0mwCA;EuBljwCU;IAxDV,yBAAA;EvB6mwCA;EuBrjwCU;IAxDV,yBAAA;EvBgnwCA;EuBxjwCU;IAxDV,gBAAA;EvBmnwCA;EuB3jwCU;IAxDV,yBAAA;EvBsnwCA;EuB9jwCU;IAxDV,yBAAA;EvBynwCA;EuBjkwCU;IAxDV,gBAAA;EvB4nwCA;EuBpkwCU;IAxDV,yBAAA;EvB+nwCA;EuBvkwCU;IAxDV,yBAAA;EvBkowCA;EuB/jwCM;;IAEE,gBAAA;EvBikwCR;EuB9jwCM;;IAEE,gBAAA;EvBgkwCR;EuBvkwCM;;IAEE,sBAAA;EvBykwCR;EuBtkwCM;;IAEE,sBAAA;EvBwkwCR;EuB/kwCM;;IAEE,qBAAA;EvBilwCR;EuB9kwCM;;IAEE,qBAAA;EvBglwCR;EuBvlwCM;;IAEE,mBAAA;EvBylwCR;EuBtlwCM;;IAEE,mBAAA;EvBwlwCR;EuB/lwCM;;IAEE,qBAAA;EvBimwCR;EuB9lwCM;;IAEE,qBAAA;EvBgmwCR;EuBvmwCM;;IAEE,mBAAA;EvBymwCR;EuBtmwCM;;IAEE,mBAAA;EvBwmwCR;AACF;AqBnqwCI;EEUE;IACE,SAAA;EvB4pwCN;EuBzpwCI;IApCJ,cAAA;IACA,WAAA;EvBgswCA;EuBlrwCA;IACE,cAAA;IACA,WAAA;EvBorwCF;EuBtrwCA;IACE,cAAA;IACA,UAAA;EvBwrwCF;EuB1rwCA;IACE,cAAA;IACA,mBAAA;EvB4rwCF;EuB9rwCA;IACE,cAAA;IACA,UAAA;EvBgswCF;EuBlswCA;IACE,cAAA;IACA,UAAA;EvBoswCF;EuBtswCA;IACE,cAAA;IACA,mBAAA;EvBwswCF;EuBzqwCI;IAhDJ,cAAA;IACA,WAAA;EvB4twCA;EuBvqwCQ;IAhEN,cAAA;IACA,kBAAA;EvB0uwCF;EuB3qwCQ;IAhEN,cAAA;IACA,mBAAA;EvB8uwCF;EuB/qwCQ;IAhEN,cAAA;IACA,UAAA;EvBkvwCF;EuBnrwCQ;IAhEN,cAAA;IACA,mBAAA;EvBsvwCF;EuBvrwCQ;IAhEN,cAAA;IACA,mBAAA;EvB0vwCF;EuB3rwCQ;IAhEN,cAAA;IACA,UAAA;EvB8vwCF;EuB/rwCQ;IAhEN,cAAA;IACA,mBAAA;EvBkwwCF;EuBnswCQ;IAhEN,cAAA;IACA,mBAAA;EvBswwCF;EuBvswCQ;IAhEN,cAAA;IACA,UAAA;EvB0wwCF;EuB3swCQ;IAhEN,cAAA;IACA,mBAAA;EvB8wwCF;EuB/swCQ;IAhEN,cAAA;IACA,mBAAA;EvBkxwCF;EuBntwCQ;IAhEN,cAAA;IACA,WAAA;EvBsxwCF;EuB/swCU;IAxDV,cAAA;EvB0wwCA;EuBltwCU;IAxDV,wBAAA;EvB6wwCA;EuBrtwCU;IAxDV,yBAAA;EvBgxwCA;EuBxtwCU;IAxDV,gBAAA;EvBmxwCA;EuB3twCU;IAxDV,yBAAA;EvBsxwCA;EuB9twCU;IAxDV,yBAAA;EvByxwCA;EuBjuwCU;IAxDV,gBAAA;EvB4xwCA;EuBpuwCU;IAxDV,yBAAA;EvB+xwCA;EuBvuwCU;IAxDV,yBAAA;EvBkywCA;EuB1uwCU;IAxDV,gBAAA;EvBqywCA;EuB7uwCU;IAxDV,yBAAA;EvBwywCA;EuBhvwCU;IAxDV,yBAAA;EvB2ywCA;EuBxuwCM;;IAEE,gBAAA;EvB0uwCR;EuBvuwCM;;IAEE,gBAAA;EvByuwCR;EuBhvwCM;;IAEE,sBAAA;EvBkvwCR;EuB/uwCM;;IAEE,sBAAA;EvBivwCR;EuBxvwCM;;IAEE,qBAAA;EvB0vwCR;EuBvvwCM;;IAEE,qBAAA;EvByvwCR;EuBhwwCM;;IAEE,mBAAA;EvBkwwCR;EuB/vwCM;;IAEE,mBAAA;EvBiwwCR;EuBxwwCM;;IAEE,qBAAA;EvB0wwCR;EuBvwwCM;;IAEE,qBAAA;EvBywwCR;EuBhxwCM;;IAEE,mBAAA;EvBkxwCR;EuB/wwCM;;IAEE,mBAAA;EvBixwCR;AACF;AqB50wCI;EEUE;IACE,SAAA;EvBq0wCN;EuBl0wCI;IApCJ,cAAA;IACA,WAAA;EvBy2wCA;EuB31wCA;IACE,cAAA;IACA,WAAA;EvB61wCF;EuB/1wCA;IACE,cAAA;IACA,UAAA;EvBi2wCF;EuBn2wCA;IACE,cAAA;IACA,mBAAA;EvBq2wCF;EuBv2wCA;IACE,cAAA;IACA,UAAA;EvBy2wCF;EuB32wCA;IACE,cAAA;IACA,UAAA;EvB62wCF;EuB/2wCA;IACE,cAAA;IACA,mBAAA;EvBi3wCF;EuBl1wCI;IAhDJ,cAAA;IACA,WAAA;EvBq4wCA;EuBh1wCQ;IAhEN,cAAA;IACA,kBAAA;EvBm5wCF;EuBp1wCQ;IAhEN,cAAA;IACA,mBAAA;EvBu5wCF;EuBx1wCQ;IAhEN,cAAA;IACA,UAAA;EvB25wCF;EuB51wCQ;IAhEN,cAAA;IACA,mBAAA;EvB+5wCF;EuBh2wCQ;IAhEN,cAAA;IACA,mBAAA;EvBm6wCF;EuBp2wCQ;IAhEN,cAAA;IACA,UAAA;EvBu6wCF;EuBx2wCQ;IAhEN,cAAA;IACA,mBAAA;EvB26wCF;EuB52wCQ;IAhEN,cAAA;IACA,mBAAA;EvB+6wCF;EuBh3wCQ;IAhEN,cAAA;IACA,UAAA;EvBm7wCF;EuBp3wCQ;IAhEN,cAAA;IACA,mBAAA;EvBu7wCF;EuBx3wCQ;IAhEN,cAAA;IACA,mBAAA;EvB27wCF;EuB53wCQ;IAhEN,cAAA;IACA,WAAA;EvB+7wCF;EuBx3wCU;IAxDV,cAAA;EvBm7wCA;EuB33wCU;IAxDV,wBAAA;EvBs7wCA;EuB93wCU;IAxDV,yBAAA;EvBy7wCA;EuBj4wCU;IAxDV,gBAAA;EvB47wCA;EuBp4wCU;IAxDV,yBAAA;EvB+7wCA;EuBv4wCU;IAxDV,yBAAA;EvBk8wCA;EuB14wCU;IAxDV,gBAAA;EvBq8wCA;EuB74wCU;IAxDV,yBAAA;EvBw8wCA;EuBh5wCU;IAxDV,yBAAA;EvB28wCA;EuBn5wCU;IAxDV,gBAAA;EvB88wCA;EuBt5wCU;IAxDV,yBAAA;EvBi9wCA;EuBz5wCU;IAxDV,yBAAA;EvBo9wCA;EuBj5wCM;;IAEE,gBAAA;EvBm5wCR;EuBh5wCM;;IAEE,gBAAA;EvBk5wCR;EuBz5wCM;;IAEE,sBAAA;EvB25wCR;EuBx5wCM;;IAEE,sBAAA;EvB05wCR;EuBj6wCM;;IAEE,qBAAA;EvBm6wCR;EuBh6wCM;;IAEE,qBAAA;EvBk6wCR;EuBz6wCM;;IAEE,mBAAA;EvB26wCR;EuBx6wCM;;IAEE,mBAAA;EvB06wCR;EuBj7wCM;;IAEE,qBAAA;EvBm7wCR;EuBh7wCM;;IAEE,qBAAA;EvBk7wCR;EuBz7wCM;;IAEE,mBAAA;EvB27wCR;EuBx7wCM;;IAEE,mBAAA;EvB07wCR;AACF;AwBhjxCA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,sCAAA;EACA,iCAAA;EACA,+CAAA;EACA,iCAAA;EACA,8CAAA;EACA,0CAAA;EACA,6CAAA;EACA,wCAAA;EACA,4CAAA;EACA,yCAAA;EAEA,WAAA;EACA,mBZ2dO;EY1dP,mBZ6xB0B;EY5xB1B,0CAAA;AxB+ixCF;AwBxixCE;EACE,wBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CZqyBiB;EYpyBjB,2GAAA;AxByixCJ;AwBtixCE;EACE,uBAAA;AxBwixCJ;AwBrixCE;EACE,sBAAA;AxBuixCJ;;AwBnixCA;EACE,0DAAA;AxBsixCF;;AwB/hxCA;EACE,iBAAA;AxBkixCF;;AwBxhxCE;EACE,sBAAA;AxB2hxCJ;;AwB5gxCE;EACE,sCAAA;AxB+gxCJ;AwB5gxCI;EACE,sCAAA;AxB8gxCN;;AwBvgxCE;EACE,sBAAA;AxB0gxCJ;AwBvgxCE;EACE,mBAAA;AxBygxCJ;;AwB//wCE;EACE,oDAAA;EACA,8CAAA;AxBkgxCJ;;AwB5/wCE;EACE,oDAAA;EACA,8CAAA;AxB+/wCJ;;AwBv/wCA;EACE,oDAAA;EACA,8CAAA;AxB0/wCF;;AwBl/wCE;EACE,mDAAA;EACA,6CAAA;AxBq/wCJ;;AyBjoxCE;EAOE,sBAAA;EACA,sBAAA;EACA,iDAAA;EACA,iDAAA;EACA,8BAAA;EACA,8CAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AzB6nxCJ;;AyB/oxCE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AzB2oxCJ;;AyB7pxCE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AzBypxCJ;;AyB3qxCE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AzBuqxCJ;;AyBzrxCE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AzBqrxCJ;;AyBvsxCE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AzBmsxCJ;;AyBrtxCE;EAOE,sBAAA;EACA,sBAAA;EACA,+CAAA;EACA,+CAAA;EACA,8BAAA;EACA,4CAAA;EACA,6BAAA;EACA,8CAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AzBitxCJ;;AyBnuxCE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,4CAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,6CAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AzB+txCJ;;AwB9kxCI;EACE,gBAAA;EACA,iCAAA;AxBilxCN;;AqB5qxCI;EGyFA;IACE,gBAAA;IACA,iCAAA;ExBulxCJ;AACF;AqBnrxCI;EGyFA;IACE,gBAAA;IACA,iCAAA;ExB6lxCJ;AACF;AqBzrxCI;EGyFA;IACE,gBAAA;IACA,iCAAA;ExBmmxCJ;AACF;AqB/rxCI;EGyFA;IACE,gBAAA;IACA,iCAAA;ExBymxCJ;AACF;AqBrsxCI;EGyFA;IACE,gBAAA;IACA,iCAAA;ExB+mxCJ;AACF;A0BnxxCA;EACE,qBd07ByB;AZ21vC3B;;A0B5wxCA;EACE,mDAAA;EACA,sDAAA;EACA,gBAAA;EjB8QI,kBALI;EiBrQR,gBdsrBiB;AZulwCnB;;A0BzwxCA;EACE,kDAAA;EACA,qDAAA;EjBoQI,mBALI;AT8gxCV;;A0BzwxCA;EACE,mDAAA;EACA,sDAAA;EjB8PI,oBALI;ATohxCV;;A2B1yxCA;EACE,mBfk7BqB;EHxpBjB,cALI;EkBjRR,gCfk7BgB;AZy3vClB;;A4BhzxCA;EACE,cAAA;EACA,WAAA;EACA,wBAAA;EnBwRI,iBALI;EmBhRR,gBhByrBmB;EgBxrBnB,gBhBgsBiB;EgB/rBjB,2BhB+8BY;EgB98BZ,gBAAA;EACA,wChBw8BS;EgBv8BT,4BAAA;EACA,uEAAA;EfGE,sCAAA;EgBHE,wEDMJ;A5B8yxCF;A6BhzxCM;EDhBN;ICiBQ,gBAAA;E7BmzxCN;AACF;A4BjzxCE;EACE,gBAAA;A5BmzxCJ;A4BjzxCI;EACE,eAAA;A5BmzxCN;A4B9yxCE;EACE,2BhBy7BU;EgBx7BV,wChBm7BO;EgBl7BP,kChBi8BuB;EgBh8BvB,UAAA;EAKE,iDhBwmBkB;AZoswCxB;A4BxyxCE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;A5B4xxCJ;A4BvxxCE;EACE,cAAA;EACA,UAAA;A5ByxxCJ;A4BrxxCE;EACE,gChB+5BsB;EgB75BtB,UAAA;A5BsxxCJ;A4B9wxCE;EAEE,wChBi4BgB;EgB93BhB,UAAA;A5B6wxCJ;A4BzwxCE;EACE,wBAAA;EACA,yBAAA;EACA,0BhBywBkB;EgBxwBlB,2BhBy3BU;EkBv9BZ,uClB4oCoB;EgB5iClB,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+ChBqxBqB;EgBpxBrB,gBAAA;ECzFE,qID0FF;A5B2wxCJ;A6Bj2xCM;ED0EJ;ICzEM,gBAAA;E7Bo2xCN;AACF;A4B7wxCE;EACE,wChBmiCwB;AZ4uvC5B;;A4BtwxCA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBhB+kBiB;EgB9kBjB,2BhB82BsB;EgB72BtB,6BAAA;EACA,yBAAA;EACA,sCAAA;A5BywxCF;A4BvwxCE;EACE,UAAA;A5BywxCJ;A4BtwxCE;EAEE,gBAAA;EACA,eAAA;A5BuwxCJ;;A4B5vxCA;EACE,mEhBu2BgB;EgBt2BhB,uBAAA;EnByII,oBALI;EIvQN,yCAAA;Abo4xCJ;A4B7vxCE;EACE,uBAAA;EACA,wBAAA;EACA,yBhBytBqB;AZsiwCzB;;A4B3vxCA;EACE,iEhB81BgB;EgB71BhB,oBAAA;EnB4HI,mBALI;EIvQN,yCAAA;Abg5xCJ;A4B5vxCE;EACE,oBAAA;EACA,qBAAA;EACA,uBhBgtBqB;AZ8iwCzB;;A4BtvxCE;EACE,oEhBq0BW;AZo7vCf;A4BtvxCE;EACE,mEhBq0Bc;AZm7vClB;A4BrvxCE;EACE,iEhBq0Bc;AZk7vClB;;A4BlvxCA;EACE,WhBs0BiB;EgBr0BjB,gEhBszBa;EgBrzBb,gBhBsqBoB;AZ+kwCtB;A4BnvxCE;EACE,eAAA;A5BqvxCJ;A4BlvxCE;EACE,oBAAA;EfvLA,sCAAA;Ab46xCJ;A4BjvxCE;EACE,oBAAA;Ef5LA,sCAAA;Abg7xCJ;A4BhvxCE;EAAoB,+DhByyBJ;AZ08vClB;A4BlvxCE;EAAoB,6DhB4yBJ;AZy8vClB;;A+Bp8xCA;EACE,iEAAA;EAEA,cAAA;EACA,WAAA;EACA,wCAAA;EtBqRI,iBALI;EsB7QR,gBnBsrBmB;EmBrrBnB,gBnB6rBiB;EmB5rBjB,2BnB48BY;EmB38BZ,gBAAA;EACA,wCnBq8BS;EmBp8BT,mFAAA;EACA,4BAAA;EACA,yCnBmkCwB;EmBlkCxB,0BnBmkCoB;EmBlkCpB,uEAAA;ElBHE,sCAAA;EgBHE,wEESJ;A/Bo8xCF;A6Bz8xCM;EEfN;IFgBQ,gBAAA;E7B48xCN;AACF;A+Bv8xCE;EACE,kCnBy8BuB;EmBx8BvB,UAAA;EAKE,iDnBukCyB;AZ83vC/B;A+Bj8xCE;EAEE,sBnBk0BkB;EmBj0BlB,sBAAA;A/Bk8xCJ;A+B/7xCE;EAEE,wCnB06BgB;AZshwCpB;A+B37xCE;EACE,kBAAA;EACA,uCAAA;A/B67xCJ;;A+Bz7xCA;EACE,oBnB2zBuB;EmB1zBvB,uBnB0zBuB;EmBzzBvB,oBnB0zBuB;EHvlBnB,oBALI;EIvQN,yCAAA;Abu+xCJ;;A+Bz7xCA;EACE,mBnBuzBuB;EmBtzBvB,sBnBszBuB;EmBrzBvB,kBnBszBuB;EH3lBnB,mBALI;EIvQN,yCAAA;Ab++xCJ;;A+Bv7xCI;EACE,iEAAA;A/B07xCN;;AgClgyCA;EACE,cAAA;EACA,mBpBsgCsB;EoBrgCtB,mBpBsgCyB;EoBrgCzB,uBpBsgCyB;AZ+/vC3B;AgCngyCE;EACE,WAAA;EACA,mBAAA;AhCqgyCJ;;AgCjgyCA;EACE,oBpB4/ByB;EoB3/BzB,eAAA;EACA,iBAAA;AhCogyCF;AgClgyCE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;AhCogyCJ;;AgChgyCA;EACE,0CAAA;EAEA,cAAA;EACA,UpB2+BuB;EoB1+BvB,WpB0+BuB;EoBz+BvB,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,uEpB8+BwB;EoB7+BxB,yBAAA;EH3BI,mJG4BJ;AhCkgyCF;A6B1hyCM;EGQN;IHPQ,gBAAA;E7B6hyCN;AACF;AgCrgyCE;EnB3BE,qBAAA;AbmiyCJ;AgCpgyCE;EAEE,kBpBu+B6B;AZ8hwCjC;AgClgyCE;EACE,uBpB69B6B;AZuiwCjC;AgCjgyCE;EACE,kCpBy6BuB;EoBx6BvB,UAAA;EACA,iDpBolBoB;AZ+6wCxB;AgChgyCE;EACE,kCpBmUM;EoBlUN,8BpBkUM;AZgsxCV;AgChgyCI;EAII,kEAAA;AhC+/xCR;AgC3/xCI;EAII,kEAAA;AhC0/xCR;AgCr/xCE;EACE,kCpB8SM;EoB7SN,8BpB6SM;EoBxSJ,kEAAA;AhCm/xCN;AgC/+xCE;EACE,oBAAA;EACA,YAAA;EACA,YpBs8BgC;AZ2iwCpC;AgC1+xCI;EACE,eAAA;EACA,YpB67B8B;AZ+iwCpC;;AgC99xCA;EACE,mBpBw7B0B;AZyiwC5B;AgC/9xCE;EACE,6DAAA;EAEA,UpBk7BgB;EoBj7BhB,mBAAA;EACA,0CAAA;EACA,gCAAA;EnBjHA,kBAAA;EgBHE,iDGsHF;AhCg+xCJ;A6BllyCM;EG0GJ;IHzGM,gBAAA;E7BqlyCN;AACF;AgCn+xCI;EACE,6DAAA;AhCq+xCN;AgCl+xCI;EACE,iCpBi7B4B;EoB56B1B,6DAAA;AhCg+xCR;AgC39xCE;EACE,oBpB45BwB;EoB35BxB,eAAA;AhC69xCJ;AgC39xCI;EACE,oBAAA;EACA,cAAA;AhC69xCN;;AgCx9xCA;EACE,qBAAA;EACA,kBpB04B6B;AZilwC/B;;AgCx9xCA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AhC29xCF;AgCv9xCI;EACE,oBAAA;EACA,YAAA;EACA,apB0uBiB;AZ+uwCvB;;AgCl9xCI;EACE,6DAAA;AhCq9xCN;;AiCxoyCA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;AjC2oyCF;AiCzoyCE;EACE,UAAA;AjC2oyCJ;AiCvoyCI;EAA0B,oErBonCM;AZshwCpC;AiCzoyCI;EAA0B,oErBmnCM;AZyhwCpC;AiCzoyCE;EACE,SAAA;AjC2oyCJ;AiCxoyCE;EACE,WrBqmCqB;EqBpmCrB,YrBomCqB;EqBnmCrB,oBAAA;EACA,gBAAA;EH1BF,kClBiYQ;EqBrWN,SrBmmCsB;EChnCtB,mBAAA;EgBHE,oHImBF;EJnBE,4GImBF;AjCyoyCJ;A6BxpyCM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;E7B2pyCN;AACF;AiC5oyCI;EHjCF,sClBooC2B;AZ4iwC7B;AiC1oyCE;EACE,WrB8kCqB;EqB7kCrB,crB8kCsB;EqB7kCtB,kBAAA;EACA,erB6kCsB;EqB5kCtB,uCrB6kCkB;EqB5kClB,yBAAA;EpB7BA,mBAAA;Ab0qyCJ;AiCxoyCE;EACE,WrB0kCqB;EqBzkCrB,YrBykCqB;EqBxkCrB,gBAAA;EHpDF,kClBiYQ;EqB3UN,SrBykCsB;EChnCtB,mBAAA;EgBHE,iHI6CF;EJ7CE,4GI6CF;AjCyoyCJ;A6BlryCM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;E7BqryCN;AACF;AiC5oyCI;EH3DF,sClBooC2B;AZskwC7B;AiC1oyCE;EACE,WrBojCqB;EqBnjCrB,crBojCsB;EqBnjCtB,kBAAA;EACA,erBmjCsB;EqBljCtB,uCrBmjCkB;EqBljClB,yBAAA;EpBvDA,mBAAA;AbosyCJ;AiCxoyCE;EACE,oBAAA;AjC0oyCJ;AiCxoyCI;EACE,2CrBsjCyB;AZolwC/B;AiCvoyCI;EACE,2CrBkjCyB;AZulwC/B;;AkChuyCA;EACE,kBAAA;AlCmuyCF;AkCjuyCE;;;EAGE,uDtB+oCmB;EsB9oCnB,2DtB8oCmB;EsB7oCnB,iBtB8oCwB;AZqlwC5B;AkChuyCE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELRE,gEKSF;AlCkuyCJ;A6BvuyCM;EKTJ;ILUM,gBAAA;E7B0uyCN;AACF;AkCpuyCE;;EAEE,qBAAA;AlCsuyCJ;AkCpuyCI;;EACE,kBAAA;AlCuuyCN;AkCpuyCI;;;EAEE,qBtBmnC0B;EsBlnC1B,wBtBmnC0B;AZonwChC;AkCpuyCI;;EACE,qBtB8mC0B;EsB7mC1B,wBtB8mC0B;AZynwChC;AkCnuyCE;EACE,qBtBwmC4B;EsBvmC5B,wBtBwmC4B;AZ6nwChC;AkC9tyCI;;;;EACE,2CAAA;EACA,8DtBkmC0B;AZiowChC;AkCjuyCM;;;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,atB0lCqB;EsBzlCrB,WAAA;EACA,wCtBm5BG;ECn8BP,sCAAA;AbuxyCJ;AkChuyCI;EACE,2CAAA;EACA,8DtBilC0B;AZipwChC;AkC7tyCI;EACE,sCAAA;AlC+tyCN;AkC3tyCE;;EAEE,ctBeO;AZ8syCX;AkC3tyCI;;EACE,wCtB63Bc;AZi2wCpB;;AmCrzyCA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AnCwzyCF;AmCtzyCE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AnCwzyCJ;AmCpzyCE;;;EAGE,UAAA;AnCszyCJ;AmChzyCE;EACE,kBAAA;EACA,UAAA;AnCkzyCJ;AmChzyCI;EACE,UAAA;AnCkzyCN;;AmCvyyCA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;E1B8OI,iBALI;E0BvOR,gBvBgpBmB;EuB/oBnB,gBvBupBiB;EuBtpBjB,2BvBs6BY;EuBr6BZ,kBAAA;EACA,mBAAA;EACA,uCvB8gCqB;EuB7gCrB,uEAAA;EtBtCE,sCAAA;Abi1yCJ;;AmCjyyCA;;;;EAIE,oBAAA;E1BwNI,mBALI;EIvQN,yCAAA;Ab01yCJ;;AmCjyyCA;;;;EAIE,uBAAA;E1B+MI,oBALI;EIvQN,yCAAA;Abm2yCJ;;AmCjyyCA;;EAEE,mBAAA;AnCoyyCF;;AmCvxyCI;;;;EtBjEA,0BAAA;EACA,6BAAA;Ab+1yCJ;AmCtxyCI;;;;EtB1EA,0BAAA;EACA,6BAAA;Abs2yCJ;AmChxyCE;EACE,8CAAA;EtB1EA,yBAAA;EACA,4BAAA;Ab61yCJ;AmChxyCE;;EtB9EE,yBAAA;EACA,4BAAA;Abk2yCJ;;AoC13yCE;EACE,aAAA;EACA,WAAA;EACA,mBxB05BmB;EHxpBjB,cALI;E2B1PN,iCxB0pCqB;AZkuwCzB;;AoCz3yCE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E3BqPE,oBALI;E2B7ON,WxB6oCqB;EwB5oCrB,mCxB4oCqB;ECvqCrB,sCAAA;Abu5yCJ;;AoCv3yCI;;;;EAEE,cAAA;ApC43yCN;;AoC36yCI;EAqDE,+CxB+nCmB;EwB5nCjB,oCxBm7Ba;EwBl7Bb,0DAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;ApCw3yCR;AoCr3yCM;EACE,+CxBonCiB;EwB/mCf,2DxB+mCe;AZowwCzB;;AoCx7yCI;EA+EI,oCxB45Ba;EwB35Bb,gFAAA;ApC62yCR;;AoC77yCI;EAuFE,+CxB6lCmB;AZ6wwCzB;AoCv2yCQ;EAEE,kEAAA;EACA,uBxBy/B8B;EwBx/B9B,+DAAA;EACA,yEAAA;ApCw2yCV;AoCp2yCM;EACE,+CxBglCiB;EwB3kCf,2DxB2kCe;AZuxwCzB;;AoC38yCI;EAkHI,yCAAA;ApC61yCR;;AoC/8yCI;EAyHE,+CxB2jCmB;AZ+xwCzB;AoCx1yCM;EACE,4CxBwjCiB;AZkywCzB;AoCv1yCM;EACE,2DxBojCiB;AZqywCzB;AoCt1yCM;EACE,iCxBgjCiB;AZwywCzB;;AoCn1yCI;EACE,kBAAA;ApCs1yCN;;AoCh+yCI;;;;;EAoJM,UAAA;ApCo1yCV;;AoCp9yCE;EACE,aAAA;EACA,WAAA;EACA,mBxB05BmB;EHxpBjB,cALI;E2B1PN,mCxB0pCqB;AZ4zwCzB;;AoCn9yCE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E3BqPE,oBALI;E2B7ON,WxB6oCqB;EwB5oCrB,kCxB4oCqB;ECvqCrB,sCAAA;Abi/yCJ;;AoCj9yCI;;;;EAEE,cAAA;ApCs9yCN;;AoCrgzCI;EAqDE,iDxB+nCmB;EwB5nCjB,oCxBm7Ba;EwBl7Bb,0DAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;ApCk9yCR;AoC/8yCM;EACE,iDxBonCiB;EwB/mCf,0DxB+mCe;AZ81wCzB;;AoClhzCI;EA+EI,oCxB45Ba;EwB35Bb,gFAAA;ApCu8yCR;;AoCvhzCI;EAuFE,iDxB6lCmB;AZu2wCzB;AoCj8yCQ;EAEE,kEAAA;EACA,uBxBy/B8B;EwBx/B9B,+DAAA;EACA,yEAAA;ApCk8yCV;AoC97yCM;EACE,iDxBglCiB;EwB3kCf,0DxB2kCe;AZi3wCzB;;AoCrizCI;EAkHI,yCAAA;ApCu7yCR;;AoCzizCI;EAyHE,iDxB2jCmB;AZy3wCzB;AoCl7yCM;EACE,8CxBwjCiB;AZ43wCzB;AoCj7yCM;EACE,0DxBojCiB;AZ+3wCzB;AoCh7yCM;EACE,mCxBgjCiB;AZk4wCzB;;AoC76yCI;EACE,kBAAA;ApCg7yCN;;AoC1jzCI;;;;;EAsJM,UAAA;ApC46yCV;;AqCpkzCA;EAEE,2BAAA;EACA,2BAAA;EACA,sBAAA;E5BuRI,0BALI;E4BhRR,yBAAA;EACA,yBAAA;EACA,oBAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E5BsQI,kCALI;E4B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EAGA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;ExBjBE,0CAAA;EiBfF,kCOkCqB;ERtBjB,qIQwBJ;ArCikzCF;A6BrlzCM;EQhBN;IRiBQ,gBAAA;E7BwlzCN;AACF;AqCpkzCE;EACE,gCAAA;EACA,qBAAA;EACA,wCAAA;EACA,8CAAA;ArCskzCJ;AqCnkzCE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;ArCokzCJ;AqCjkzCE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;ArC+jzCN;AqC3jzCE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;ArCyjzCN;AqCrjzCE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;ArCijzCJ;AqC9izCI;EAKI,0CAAA;ArC4izCR;AqCvizCE;EAKI,0CAAA;ArCqizCN;AqCjizCE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;ArCgizCJ;;AqCphzCE;EC/GA,oBAAA;EACA,6BAAA;EACA,uCAAA;EACA,0BAAA;EACA,2CAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,sCAAA;EACA,gDAAA;AtCuozCF;;AqCrizCE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,gDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtCwpzCF;;AqCtjzCE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,kDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,kDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtCyqzCF;;AqCvkzCE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,kDAAA;EACA,wCAAA;EACA,2BAAA;EACA,yCAAA;EACA,uDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC0rzCF;;AqCxlzCE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,kDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,kDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC2szCF;;AqCzmzCE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC4tzCF;;AqC1nzCE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,kDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC6uzCF;;AqC3ozCE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AtC8vzCF;;AqClozCE;EChHA,gCAAA;EACA,uCAAA;EACA,0BAAA;EACA,mCAAA;EACA,6CAAA;EACA,sCAAA;EACA,2BAAA;EACA,oCAAA;EACA,8CAAA;EACA,4DAAA;EACA,yCAAA;EACA,iCAAA;EACA,gDAAA;EACA,mBAAA;AtCsvzCF;;AqCnpzCE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtCuwzCF;;AqCpqzCE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtCwxzCF;;AqCrrzCE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtCyyzCF;;AqCtszCE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtC0zzCF;;AqCvtzCE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtC20zCF;;AqCxuzCE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtC41zCF;;AqCzvzCE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AtC62zCF;;AqC9vzCA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,qBzBuWgB;AZy5yClB;AqC3vzCE;EAEE,0BzBmWoB;AZy5yCxB;AqCzvzCE;EACE,0BAAA;ArC2vzCJ;AqCxvzCE;EACE,gCAAA;ArC0vzCJ;;AqC/uzCA;ECjJE,0BAAA;EACA,wBAAA;E7B8NI,4BALI;E6BvNR,kDAAA;AtCo4zCF;;AqClvzCA;ECrJE,2BAAA;EACA,0BAAA;E7B8NI,6BALI;E6BvNR,kDAAA;AtC24zCF;;AuC98zCA;EVgBM,gCUfJ;AvCi9zCF;A6B97zCM;EUpBN;IVqBQ,gBAAA;E7Bi8zCN;AACF;AuCp9zCE;EACE,UAAA;AvCs9zCJ;;AuCh9zCE;EACE,aAAA;AvCm9zCJ;;AuC/8zCA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AvCk9zCF;A6Bh9zCM;EULN;IVMQ,gBAAA;E7Bm9zCN;AACF;AuCr9zCE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AvCu9zCJ;A6B19zCM;EUAJ;IVCM,gBAAA;E7B69zCN;AACF;;AwCl/zCA;;;;;;EAME,kBAAA;AxCq/zCF;;AwCl/zCA;EACE,mBAAA;AxCq/zCF;;AwC9+zCA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E/BuQI,+BALI;E+BhQR,yCAAA;EACA,wCAAA;EACA,kDAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,gDAAA;EACA,sCAAA;EACA,4DAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,0DAAA;EACA,mDAAA;EACA,2DAAA;EACA,oCAAA;EACA,qCAAA;EACA,mCAAA;EACA,sCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E/B0OI,uCALI;E+BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E3BzCE,+CAAA;Abwh0CJ;AwC3+zCE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AxC6+zCJ;;AwCr9zCI;EACE,oBAAA;AxCw9zCN;AwCt9zCM;EACE,WAAA;EACA,OAAA;AxCw9zCR;;AwCp9zCI;EACE,kBAAA;AxCu9zCN;AwCr9zCM;EACE,QAAA;EACA,UAAA;AxCu9zCR;;AqBjg0CI;EmB4BA;IACE,oBAAA;ExCy+zCJ;EwCv+zCI;IACE,WAAA;IACA,OAAA;ExCy+zCN;EwCr+zCE;IACE,kBAAA;ExCu+zCJ;EwCr+zCI;IACE,QAAA;IACA,UAAA;ExCu+zCN;AACF;AqBlh0CI;EmB4BA;IACE,oBAAA;ExCy/zCJ;EwCv/zCI;IACE,WAAA;IACA,OAAA;ExCy/zCN;EwCr/zCE;IACE,kBAAA;ExCu/zCJ;EwCr/zCI;IACE,QAAA;IACA,UAAA;ExCu/zCN;AACF;AqBli0CI;EmB4BA;IACE,oBAAA;ExCyg0CJ;EwCvg0CI;IACE,WAAA;IACA,OAAA;ExCyg0CN;EwCrg0CE;IACE,kBAAA;ExCug0CJ;EwCrg0CI;IACE,QAAA;IACA,UAAA;ExCug0CN;AACF;AqBlj0CI;EmB4BA;IACE,oBAAA;ExCyh0CJ;EwCvh0CI;IACE,WAAA;IACA,OAAA;ExCyh0CN;EwCrh0CE;IACE,kBAAA;ExCuh0CJ;EwCrh0CI;IACE,QAAA;IACA,UAAA;ExCuh0CN;AACF;AqBlk0CI;EmB4BA;IACE,oBAAA;ExCyi0CJ;EwCvi0CI;IACE,WAAA;IACA,OAAA;ExCyi0CN;EwCri0CE;IACE,kBAAA;ExCui0CJ;EwCri0CI;IACE,QAAA;IACA,UAAA;ExCui0CN;AACF;AwC9h0CE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AxCgi0CJ;AwCvh0CE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AxCyh0CJ;AwCph0CI;EACE,iBAAA;AxCsh0CN;;AwChh0CE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AxCmh0CJ;AwC9g0CI;EACE,iBAAA;AxCgh0CN;;AwCzg0CA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AxC4g0CF;;AwCtg0CA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB5BghBmB;E4B/gBnB,oCAAA;EACA,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;E3BtKE,uDAAA;Ab+q0CJ;AwCtg0CE;EAEE,0CAAA;EACA,qBAAA;EV3LF,kDU4LuB;AxCug0CzB;AwCpg0CE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AxCqg0CzB;AwClg0CE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AxCmg0CJ;;AwC7/zCA;EACE,cAAA;AxCgg0CF;;AwC5/zCA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E/BmEI,oBALI;E+B5DR,sCAAA;EACA,mBAAA;AxC+/zCF;;AwC3/zCA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AxC8/zCF;;AwC1/zCA;EAEE,4BAAA;EACA,yBAAA;EACA,kDAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,gDAAA;EACA,sDAAA;EACA,0DAAA;EACA,mDAAA;EACA,0CAAA;EACA,mCAAA;AxC4/zCF;;AyClv0CA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AzCqv0CF;AyCnv0CE;;EACE,kBAAA;EACA,cAAA;AzCsv0CJ;AyCjv0CE;;;;;;;;;;;;EAME,UAAA;AzCyv0CJ;;AyCpv0CA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AzCuv0CF;AyCrv0CE;EACE,WAAA;AzCuv0CJ;;AyCnv0CA;E5BhBI,sCAAA;Abuw0CJ;AyCnv0CE;;EAEE,8CAAA;AzCqv0CJ;AyCjv0CE;;;E5BVE,0BAAA;EACA,6BAAA;Abgw0CJ;AyC7u0CE;;;E5BNE,yBAAA;EACA,4BAAA;Abwv0CJ;;AyChu0CA;EACE,wBAAA;EACA,uBAAA;AzCmu0CF;AyCju0CE;EAGE,cAAA;AzCiu0CJ;AyC9t0CE;EACE,eAAA;AzCgu0CJ;;AyC5t0CA;EACE,uBAAA;EACA,sBAAA;AzC+t0CF;;AyC5t0CA;EACE,sBAAA;EACA,qBAAA;AzC+t0CF;;AyC3s0CA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AzC8s0CF;AyC5s0CE;;EAEE,WAAA;AzC8s0CJ;AyC3s0CE;;EAEE,6CAAA;AzC6s0CJ;AyCzs0CE;;E5B1FE,6BAAA;EACA,4BAAA;Abuy0CJ;AyCzs0CE;;E5B7GE,yBAAA;EACA,0BAAA;Ab0z0CJ;;A0Cl10CA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;A1Ci10CF;;A0C900CA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EAEA,gBAAA;EACA,SAAA;EbfI,uGagBJ;A1Cg10CF;A6B510CM;EaGN;IbFQ,gBAAA;E7B+10CN;AACF;A0Cn10CE;EAEE,qCAAA;EACA,qBAAA;A1Co10CJ;A0Cj10CE;EACE,UAAA;EACA,iD9BwmBoB;AZ2uzCxB;A0C/00CE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;A1Cg10CJ;;A0Cx00CA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,oDAAA;EACA,4GAAA;EAGA,oFAAA;A1Cw00CF;A0Ct00CE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;Abs30CJ;A0Cv00CI;EAGE,kBAAA;EACA,wDAAA;A1Cu00CN;A0Cn00CE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;A1Cq00CJ;A0Cl00CE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;Abq40CJ;;A0C1z0CA;EAEE,qDAAA;EACA,sCAAA;EACA,+CAAA;A1C4z0CF;A0Czz0CE;E7B5FE,gDAAA;Abw50CJ;A0Cxz0CE;;EAEE,4CAAA;EZjHF,oDYkHuB;A1C0z0CzB;;A0Cjz0CA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;A1Ciz0CF;A0C/y0CE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;A1Ciz0CJ;A0C/y0CI;EAEE,iCAAA;A1Cgz0CN;A0C5y0CE;;EAEE,gB9BijBe;E8BhjBf,gDAAA;EACA,iCAAA;A1C8y0CJ;;A0Cpy0CE;;EAEE,cAAA;EACA,kBAAA;A1Cuy0CJ;;A0Cly0CE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;A1Cqy0CJ;;A0C/x0CE;;EACE,WAAA;A1Cmy0CJ;;A0Czx0CE;EACE,aAAA;A1C4x0CJ;A0C1x0CE;EACE,cAAA;A1C4x0CJ;;A2Cz90CA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,uCAAA;EACA,kCAAA;EACA,qCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,uCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;A3Cy90CF;A2Cn90CE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;A3C290CJ;A2Cv80CA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EAEA,mBAAA;A3Cw80CF;A2Ct80CE;EAEE,yCAAA;EACA,qBAAA;A3Cu80CJ;;A2C970CA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;A3C670CF;A2C170CI;EAEE,oCAAA;A3C270CN;A2Cv70CE;EACE,gBAAA;A3Cy70CJ;;A2Ch70CA;EACE,mB/BunCmB;E+BtnCnB,sB/BsnCmB;E+BrnCnB,6BAAA;A3Cm70CF;A2Cj70CE;;;EAGE,oCAAA;A3Cm70CJ;;A2Ct60CA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;A3Cu60CF;;A2Cn60CA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EgBHE,+Cc6IJ;A3Cs60CF;A6B/i1CM;EciIN;IdhIQ,gBAAA;E7Bkj1CN;AACF;A2Cz60CE;EACE,qBAAA;A3C260CJ;A2Cx60CE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;A3C060CJ;;A2Cp60CA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;A3Cu60CF;;A2Cp60CA;EACE,yCAAA;EACA,gBAAA;A3Cu60CF;;AqBji1CI;EsBsIA;IAEI,iBAAA;IACA,2BAAA;E3C850CN;E2C550CM;IACE,mBAAA;E3C850CR;E2C550CQ;IACE,kBAAA;E3C850CV;E2C350CQ;IACE,kDAAA;IACA,iDAAA;E3C650CV;E2Cz50CM;IACE,iBAAA;E3C250CR;E2Cx50CM;IACE,wBAAA;IACA,gBAAA;E3C050CR;E2Cv50CM;IACE,aAAA;E3Cy50CR;E2Ct50CM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id9NJ,gBcgOI;E3Cs50CR;E2Cn50CQ;IACE,aAAA;E3Cq50CV;E2Cl50CQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3Co50CV;AACF;AqBjl1CI;EsBsIA;IAEI,iBAAA;IACA,2BAAA;E3C680CN;E2C380CM;IACE,mBAAA;E3C680CR;E2C380CQ;IACE,kBAAA;E3C680CV;E2C180CQ;IACE,kDAAA;IACA,iDAAA;E3C480CV;E2Cx80CM;IACE,iBAAA;E3C080CR;E2Cv80CM;IACE,wBAAA;IACA,gBAAA;E3Cy80CR;E2Ct80CM;IACE,aAAA;E3Cw80CR;E2Cr80CM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id9NJ,gBcgOI;E3Cq80CR;E2Cl80CQ;IACE,aAAA;E3Co80CV;E2Cj80CQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3Cm80CV;AACF;AqBho1CI;EsBsIA;IAEI,iBAAA;IACA,2BAAA;E3C4/0CN;E2C1/0CM;IACE,mBAAA;E3C4/0CR;E2C1/0CQ;IACE,kBAAA;E3C4/0CV;E2Cz/0CQ;IACE,kDAAA;IACA,iDAAA;E3C2/0CV;E2Cv/0CM;IACE,iBAAA;E3Cy/0CR;E2Ct/0CM;IACE,wBAAA;IACA,gBAAA;E3Cw/0CR;E2Cr/0CM;IACE,aAAA;E3Cu/0CR;E2Cp/0CM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id9NJ,gBcgOI;E3Co/0CR;E2Cj/0CQ;IACE,aAAA;E3Cm/0CV;E2Ch/0CQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3Ck/0CV;AACF;AqB/q1CI;EsBsIA;IAEI,iBAAA;IACA,2BAAA;E3C2i1CN;E2Czi1CM;IACE,mBAAA;E3C2i1CR;E2Czi1CQ;IACE,kBAAA;E3C2i1CV;E2Cxi1CQ;IACE,kDAAA;IACA,iDAAA;E3C0i1CV;E2Cti1CM;IACE,iBAAA;E3Cwi1CR;E2Cri1CM;IACE,wBAAA;IACA,gBAAA;E3Cui1CR;E2Cpi1CM;IACE,aAAA;E3Csi1CR;E2Cni1CM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id9NJ,gBcgOI;E3Cmi1CR;E2Chi1CQ;IACE,aAAA;E3Cki1CV;E2C/h1CQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3Cii1CV;AACF;AqB9t1CI;EsBsIA;IAEI,iBAAA;IACA,2BAAA;E3C0l1CN;E2Cxl1CM;IACE,mBAAA;E3C0l1CR;E2Cxl1CQ;IACE,kBAAA;E3C0l1CV;E2Cvl1CQ;IACE,kDAAA;IACA,iDAAA;E3Cyl1CV;E2Crl1CM;IACE,iBAAA;E3Cul1CR;E2Cpl1CM;IACE,wBAAA;IACA,gBAAA;E3Csl1CR;E2Cnl1CM;IACE,aAAA;E3Cql1CR;E2Cll1CM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id9NJ,gBcgOI;E3Ckl1CR;E2C/k1CQ;IACE,aAAA;E3Cil1CV;E2C9k1CQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;E3Cgl1CV;AACF;A2Cvo1CI;EAEI,iBAAA;EACA,2BAAA;A3Cwo1CR;A2Cto1CQ;EACE,mBAAA;A3Cwo1CV;A2Cto1CU;EACE,kBAAA;A3Cwo1CZ;A2Cro1CU;EACE,kDAAA;EACA,iDAAA;A3Cuo1CZ;A2Cno1CQ;EACE,iBAAA;A3Cqo1CV;A2Clo1CQ;EACE,wBAAA;EACA,gBAAA;A3Coo1CV;A2Cjo1CQ;EACE,aAAA;A3Cmo1CV;A2Cho1CQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ed9NJ,gBcgOI;A3Cgo1CV;A2C7n1CU;EACE,aAAA;A3C+n1CZ;A2C5n1CU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;A3C8n1CZ;;A2C7m1CA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;A3C+m1CF;;A2Czm1CI;EACE,qEAAA;A3C4m1CN;;A4Cr41CA;EAEE,2BAAA;EACA,2BAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,8CAAA;EACA,gDAAA;EACA,mDAAA;EACA,uFAAA;EACA,iCAAA;EACA,gCAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oCAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;Abu51CJ;A4Cl41CE;EACE,eAAA;EACA,cAAA;A5Co41CJ;A4Cj41CE;EACE,mBAAA;EACA,sBAAA;A5Cm41CJ;A4Cj41CI;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;Ab051CJ;A4Cj41CI;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;Abi51CJ;A4C931CE;;EAEE,aAAA;A5Cg41CJ;;A4C531CA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;A5C631CF;;A4C131CA;EACE,4CAAA;EACA,iCAAA;A5C631CF;;A4C131CA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;A5C631CF;;A4C131CA;EACE,gBAAA;A5C631CF;;A4Cz31CE;EACE,qBAAA;A5C431CJ;A4Cz31CE;EACE,oCAAA;A5C231CJ;;A4Cn31CA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;A5Cs31CF;A4Cp31CE;E/B7FE,wFAAA;Abo91CJ;;A4Cl31CA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;A5Cq31CF;A4Cn31CE;E/BxGE,wFAAA;Ab891CJ;;A4C521CA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;A5C+21CF;A4C721CE;EACE,mCAAA;EACA,sCAAA;A5C+21CJ;;A4C321CA;EACE,uDAAA;EACA,sDAAA;A5C821CF;;A4C121CA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;Abw/1CJ;;A4C121CA;;;EAGE,WAAA;A5C621CF;;A4C121CA;;E/B3II,0DAAA;EACA,2DAAA;Ab0/1CJ;;A4C321CA;;E/BlII,8DAAA;EACA,6DAAA;Abk/1CJ;;A4Cp21CE;EACE,0CAAA;A5Cu21CJ;AqBl+1CI;EuBuHJ;IAQI,aAAA;IACA,mBAAA;E5Cu21CF;E4Cp21CE;IAEE,SAAA;IACA,gBAAA;E5Cq21CJ;E4Cn21CI;IACE,cAAA;IACA,cAAA;E5Cq21CN;E4Ch21CM;I/B3KJ,0BAAA;IACA,6BAAA;Eb8g2CF;E4Cj21CQ;;IAGE,0BAAA;E5Ck21CV;E4Ch21CQ;;IAGE,6BAAA;E5Ci21CV;E4C711CM;I/B5KJ,yBAAA;IACA,4BAAA;Eb4g2CF;E4C911CQ;;IAGE,yBAAA;E5C+11CV;E4C711CQ;;IAGE,4BAAA;E5C811CV;AACF;;A6Cnk2CA;EAEE,0CAAA;EACA,yCAAA;EACA,8KAAA;EACA,+DAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,0EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;A7Cqk2CF;;A6Cjk2CA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,iBALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EhB1BI,0CgB2BJ;A7Cok2CF;A6B3l2CM;EgBUN;IhBTQ,gBAAA;E7B8l2CN;AACF;A6Cvk2CE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;A7Cyk2CJ;A6Cvk2CI;EACE,qDAAA;EACA,iDAAA;A7Cyk2CN;A6Cpk2CE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EhBjDE,mDgBkDF;A7Csk2CJ;A6Bpn2CM;EgBqCJ;IhBpCM,gBAAA;E7Bun2CN;AACF;A6Cxk2CE;EACE,UAAA;A7C0k2CJ;A6Cvk2CE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;A7Cyk2CJ;;A6Crk2CA;EACE,gBAAA;A7Cwk2CF;;A6Crk2CA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;A7Cwk2CF;A6Ctk2CE;EhC7DE,yDAAA;EACA,0DAAA;Abso2CJ;A6Cvk2CI;EhChEA,+DAAA;EACA,gEAAA;Ab0o2CJ;A6Ctk2CE;EACE,aAAA;A7Cwk2CJ;A6Cpk2CE;EhC5DE,6DAAA;EACA,4DAAA;Abmo2CJ;A6Cpk2CM;EhChEF,mEAAA;EACA,kEAAA;Abuo2CJ;A6Cnk2CI;EhCrEA,6DAAA;EACA,4DAAA;Ab2o2CJ;;A6Cjk2CA;EACE,8EAAA;A7Cok2CF;;A6C3j2CE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;Ab6q2CJ;A6C5j2CI;EAAgB,aAAA;A7C+j2CpB;A6C9j2CI;EAAe,gBAAA;A7Cik2CnB;A6C7j2CM;EhCtHF,gBAAA;Absr2CJ;A6Czj2CI;EhC7HA,gBAAA;Abyr2CJ;;A6Cpj2CI;EACE,iEAAA;EACA,wEAAA;A7Cuj2CN;;A8Cjt2CA;EAEE,+BAAA;EACA,kCAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,sCAAA;EACA,sCAAA;EACA,0CAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;Abit2CJ;;A8C3s2CE;EACE,iDAAA;A9C8s2CJ;A8C5s2CI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,iGAAA;A9C8s2CN;A8C1s2CE;EACE,6CAAA;A9C4s2CJ;;A+Cjv2CA;EAEE,kCAAA;EACA,iCAAA;EtC4RI,iCALI;EsCrRR,2CAAA;EACA,0CAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,uEAAA;EACA,kCAAA;EACA,2CAAA;EACA,qDAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;E/BpBA,eAAA;EACA,gBAAA;AhBsw2CF;;A+C/u2CA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EAEA,yCAAA;EACA,iFAAA;ElBpBI,qIkBqBJ;A/Civ2CF;A6Blw2CM;EkBQN;IlBPQ,gBAAA;E7Bqw2CN;AACF;A+Cpv2CE;EACE,UAAA;EACA,uCAAA;EACA,qBAAA;EACA,+CAAA;EACA,qDAAA;A/Csv2CJ;A+Cnv2CE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC01CuB;EmCz1CvB,iDAAA;A/Cqv2CJ;A+Clv2CE;EAEE,UAAA;EACA,wCAAA;EjBtDF,gDiBuDuB;EACrB,sDAAA;A/Cmv2CJ;A+Chv2CE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A/Civ2CJ;;A+C5u2CE;EACE,8CnC2zCsB;AZo7zC1B;A+C1u2CM;ElC9BF,0DAAA;EACA,6DAAA;Ab2w2CJ;A+Cxu2CM;ElClDF,2DAAA;EACA,8DAAA;Ab6x2CJ;;A+C3t2CA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,mCALI;EuCnRR,yDAAA;AhDi02CF;;A+C9t2CA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,oCALI;EuCnRR,yDAAA;AhDw02CF;;AiD102CA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;Ab+02CJ;AiDt02CE;EACE,aAAA;AjDw02CJ;;AiDn02CA;EACE,kBAAA;EACA,SAAA;AjDs02CF;;AkDt22CA;EAEE,0BAAA;EACA,6BAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;Ab022CJ;;AkDl22CA;EAEE,cAAA;AlDo22CF;;AkDh22CA;EACE,gBtCoqBiB;EsCnqBjB,iCAAA;AlDm22CF;;AkD312CA;EACE,sBtC6lD4B;AZiwzC9B;AkD312CE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,0BAAA;AlD612CJ;;AkDr12CE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AlDw12CJ;;AkD512CE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;AlD+12CJ;;AkDn22CE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AlDs22CJ;;AkD122CE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AlD622CJ;;AkDj32CE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AlDo32CJ;;AkDx32CE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;AlD232CJ;;AkD/32CE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;AlDk42CJ;;AkDt42CE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AlDy42CJ;;AmDr82CE;EACE;IAAK,2BvC0oDS;EZ+zzChB;AACF;AmDr82CA;;EAGE,0BAAA;E1CkRI,iCALI;E0C3QR,uCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,sCAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;Ab682CJ;;AmDh82CA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EtBxBI,6CsByBJ;AnDm82CF;A6Bx92CM;EsBYN;ItBXQ,gBAAA;E7B292CN;AACF;;AmDr82CA;ErBAE,qMAAA;EqBEA,oEAAA;AnDw82CF;;AmDr82CA;EACE,iBAAA;AnDw82CF;;AmDr82CA;EACE,WAAA;AnDw82CF;;AmDp82CE;EACE,kDAAA;AnDu82CJ;AmDp82CM;EAJJ;IAKM,eAAA;EnDu82CN;AACF;;AoDng3CA;EAEE,2CAAA;EACA,0CAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uCAAA;EACA,uCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,mDAAA;EACA,kCAAA;EACA,2CAAA;EACA,qDAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;Ab6g3CJ;;AoD9/2CA;EACE,qBAAA;EACA,sBAAA;ApDig3CF;AoD//2CE;EAEE,oCAAA;EACA,0BAAA;ApDgg3CJ;;AoDv/2CA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;ApD0/2CF;AoDv/2CE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;ApDw/2CJ;AoDr/2CE;EACE,+CAAA;EACA,uDAAA;ApDu/2CJ;;AoD/+2CA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EAEA,yCAAA;EACA,iFAAA;ApDi/2CF;AoD/+2CE;EvCvDE,+BAAA;EACA,gCAAA;Abyi3CJ;AoD/+2CE;EvC7CE,mCAAA;EACA,kCAAA;Ab+h3CJ;AoD/+2CE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;ApDg/2CJ;AoD5+2CE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;ApD8+2CJ;AoD1+2CE;EACE,mBAAA;ApD4+2CJ;AoD1+2CI;EACE,wDAAA;EACA,mDAAA;ApD4+2CN;;AoD/92CI;EACE,mBAAA;ApDk+2CN;AoD/92CQ;EvCvDJ,6DAAA;EAZA,0BAAA;Absi3CJ;AoD992CQ;EvCxEJ,2DAAA;EAYA,4BAAA;Ab8h3CJ;AoD792CQ;EACE,aAAA;ApD+92CV;AoD592CQ;EACE,mDAAA;EACA,oBAAA;ApD892CV;AoD592CU;EACE,yDAAA;EACA,oDAAA;ApD892CZ;;AqBpj3CI;E+B8DA;IACE,mBAAA;EpD0/2CJ;EoDv/2CM;IvCvDJ,6DAAA;IAZA,0BAAA;Eb8j3CF;EoDt/2CM;IvCxEJ,2DAAA;IAYA,4BAAA;Ebsj3CF;EoDr/2CM;IACE,aAAA;EpDu/2CR;EoDp/2CM;IACE,mDAAA;IACA,oBAAA;EpDs/2CR;EoDp/2CQ;IACE,yDAAA;IACA,oDAAA;EpDs/2CV;AACF;AqB7k3CI;E+B8DA;IACE,mBAAA;EpDkh3CJ;EoD/g3CM;IvCvDJ,6DAAA;IAZA,0BAAA;Ebsl3CF;EoD9g3CM;IvCxEJ,2DAAA;IAYA,4BAAA;Eb8k3CF;EoD7g3CM;IACE,aAAA;EpD+g3CR;EoD5g3CM;IACE,mDAAA;IACA,oBAAA;EpD8g3CR;EoD5g3CQ;IACE,yDAAA;IACA,oDAAA;EpD8g3CV;AACF;AqBrm3CI;E+B8DA;IACE,mBAAA;EpD0i3CJ;EoDvi3CM;IvCvDJ,6DAAA;IAZA,0BAAA;Eb8m3CF;EoDti3CM;IvCxEJ,2DAAA;IAYA,4BAAA;Ebsm3CF;EoDri3CM;IACE,aAAA;EpDui3CR;EoDpi3CM;IACE,mDAAA;IACA,oBAAA;EpDsi3CR;EoDpi3CQ;IACE,yDAAA;IACA,oDAAA;EpDsi3CV;AACF;AqB7n3CI;E+B8DA;IACE,mBAAA;EpDkk3CJ;EoD/j3CM;IvCvDJ,6DAAA;IAZA,0BAAA;Ebso3CF;EoD9j3CM;IvCxEJ,2DAAA;IAYA,4BAAA;Eb8n3CF;EoD7j3CM;IACE,aAAA;EpD+j3CR;EoD5j3CM;IACE,mDAAA;IACA,oBAAA;EpD8j3CR;EoD5j3CQ;IACE,yDAAA;IACA,oDAAA;EpD8j3CV;AACF;AqBrp3CI;E+B8DA;IACE,mBAAA;EpD0l3CJ;EoDvl3CM;IvCvDJ,6DAAA;IAZA,0BAAA;Eb8p3CF;EoDtl3CM;IvCxEJ,2DAAA;IAYA,4BAAA;Ebsp3CF;EoDrl3CM;IACE,aAAA;EpDul3CR;EoDpl3CM;IACE,mDAAA;IACA,oBAAA;EpDsl3CR;EoDpl3CQ;IACE,yDAAA;IACA,oDAAA;EpDsl3CV;AACF;AoDzk3CA;EvChJI,gBAAA;Ab4t3CJ;AoDzk3CE;EACE,mDAAA;ApD2k3CJ;AoDzk3CI;EACE,sBAAA;ApD2k3CN;;AoD9j3CE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;ApDik3CJ;;AoD3k3CE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;ApD8k3CJ;;AoDxl3CE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;ApD2l3CJ;;AoDrm3CE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;ApDwm3CJ;;AoDln3CE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;ApDqn3CJ;;AoD/n3CE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;ApDko3CJ;;AoD5o3CE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;ApD+o3CJ;;AoDzp3CE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;ApD4p3CJ;;AqDx13CA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,iCAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,UzCgwDgB;EyC/vDhB,WzC+vDgB;EyC9vDhB,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;ExCJE,uBAAA;EwCMF,oCAAA;ArDw13CF;AqDr13CE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;ArDu13CJ;AqDp13CE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;ArDs13CJ;AqDn13CE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;ArDo13CJ;;AqD503CA;EAHE,wCAAA;ArDm13CF;;AqD103CI;EATF,wCAAA;ArDu13CF;;AsDx43CA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;Abi53CJ;AsDt43CE;EACE,UAAA;AtDw43CJ;AsDr43CE;EACE,aAAA;AtDu43CJ;;AsDn43CA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AtDq43CF;AsDn43CE;EACE,sCAAA;AtDq43CJ;;AsDj43CA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;Abq63CJ;AsDn43CE;EACE,oDAAA;EACA,sCAAA;AtDq43CJ;;AsDj43CA;EACE,kCAAA;EACA,qBAAA;AtDo43CF;;AuDl83CA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qCAAA;EACA,+CAAA;EACA,+CAAA;EACA,oDAAA;EACA,oDAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AvDg83CF;;AuDz73CA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AvD273CF;AuDx73CE;E1B5CI,mC0B6CF;EACA,8B3CujDmB;AZm40CvB;A6Bp+3CM;E0BwCJ;I1BvCM,gBAAA;E7Bu+3CN;AACF;AuD773CE;EACE,e3CqjDmB;AZ040CvB;AuD373CE;EACE,sB3CkjDoB;AZ240CxB;;AuDz73CA;EACE,+CAAA;AvD473CF;AuD173CE;EACE,gBAAA;EACA,gBAAA;AvD473CJ;AuDz73CE;EACE,gBAAA;AvD273CJ;;AuDv73CA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AvD073CF;;AuDt73CA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AvDs73CF;;AuDl73CA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AvDw73C9D;AwDpi4CE;EAAS,UAAA;AxDui4CX;AwDti4CE;EAAS,mCD2GiF;AvD873C5F;;AuDz73CA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;Abki4CJ;AuD373CE;EACE,kGAAA;EACA,sJAAA;AvD673CJ;;AuDx73CA;EACE,gBAAA;EACA,8CAAA;AvD273CF;;AuDt73CA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AvDu73CF;;AuDn73CA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1CzHE,+DAAA;EACA,8DAAA;Abgj4CJ;AuDl73CE;EACE,8CAAA;AvDo73CJ;;AqB/h4CI;EkCiHF;IACE,0BAAA;IACA,oDAAA;EvDk73CF;EuD963CA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EvDg73CF;EuD763CA;IACE,uBAAA;EvD+63CF;AACF;AqB9i4CI;EkCmIF;;IAEE,uBAAA;EvD863CF;AACF;AqBpj4CI;EkC0IF;IACE,wBAAA;EvD663CF;AACF;AuDp63CI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AvDs63CN;AuDp63CM;EACE,YAAA;EACA,SAAA;E1CzMJ,gBAAA;Abgn4CJ;AuDn63CM;;E1C7MF,gBAAA;Abon4CJ;AuDl63CM;EACE,gBAAA;AvDo63CR;;AqB9j4CI;EkCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvD073CJ;EuDx73CI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;Eboo4CF;EuDv73CI;;I1C7MF,gBAAA;Ebwo4CF;EuDt73CI;IACE,gBAAA;EvDw73CN;AACF;AqBnl4CI;EkCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvD883CJ;EuD583CI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;Ebwp4CF;EuD383CI;;I1C7MF,gBAAA;Eb4p4CF;EuD183CI;IACE,gBAAA;EvD483CN;AACF;AqBvm4CI;EkCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDk+3CJ;EuDh+3CI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;Eb4q4CF;EuD/93CI;;I1C7MF,gBAAA;Ebgr4CF;EuD993CI;IACE,gBAAA;EvDg+3CN;AACF;AqB3n4CI;EkCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDs/3CJ;EuDp/3CI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;Ebgs4CF;EuDn/3CI;;I1C7MF,gBAAA;Ebos4CF;EuDl/3CI;IACE,gBAAA;EvDo/3CN;AACF;AqB/o4CI;EkCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvD0g4CJ;EuDxg4CI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;Ebot4CF;EuDvg4CI;;I1C7MF,gBAAA;Ebwt4CF;EuDtg4CI;IACE,gBAAA;EvDwg4CN;AACF;AyD9u4CA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EhDwRI,iCALI;EgDjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC9CsrBiB;E8CprBjB,kBAAA;EACA,gB9C+rBmB;E8C9rBnB,gB9CssBiB;E8CrsBjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;AzDsv4CF;AyDpv4CE;EAAS,kCAAA;AzDuv4CX;AyDrv4CE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AzDuv4CJ;AyDrv4CI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AzDuv4CN;;AyDlv4CA;EACE,iDAAA;AzDqv4CF;AyDnv4CE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AzDqv4CJ;;AyDjv4CA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AzDov4CF;AyDlv4CE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AzDov4CJ;;AyDhv4CA,mBAAA;AAEA;EACE,8CAAA;AzDkv4CF;AyDhv4CE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AzDkv4CJ;;AyD9u4CA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AzDiv4CF;AyD/u4CE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AzDiv4CJ;;AyD7u4CA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;Abi04CJ;;A2Dp14CA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,iCALI;EkDrRR,uCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,sDAAA;EACA,sCAAA;EACA,qCAAA;ElDmRI,qCALI;EkD5QR,mDAAA;EACA,8CAAA;EACA,oCAAA;EACA,mCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC9CsrBiB;E8CprBjB,kBAAA;EACA,gB9C+rBmB;E8C9rBnB,gB9CssBiB;E8CrsBjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;Ab+24CJ;A2D314CE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;A3D614CJ;A2D314CI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;A3D414CN;;A2Dt14CE;EACE,oFAAA;A3Dy14CJ;A2Dv14CI;EAEE,wFAAA;A3Dw14CN;A2Dr14CI;EACE,SAAA;EACA,gDAAA;A3Du14CN;A2Dp14CI;EACE,sCAAA;EACA,sCAAA;A3Ds14CN;;A2Dj14CA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;A3Dm14CJ;A2Dj14CI;EAEE,kIAAA;A3Dk14CN;A2D/04CI;EACE,OAAA;EACA,kDAAA;A3Di14CN;A2D904CI;EACE,oCAAA;EACA,wCAAA;A3Dg14CN;;A2D304CA,mBAAA;AAGE;EACE,iFAAA;A3D404CJ;A2D104CI;EAEE,wFAAA;A3D204CN;A2Dx04CI;EACE,MAAA;EACA,mDAAA;A3D004CN;A2Dv04CI;EACE,mCAAA;EACA,yCAAA;A3Dy04CN;A2Dp04CE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;A3Ds04CJ;;A2Dl04CA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;A3Do04CJ;A2Dl04CI;EAEE,kIAAA;A3Dm04CN;A2Dh04CI;EACE,QAAA;EACA,iDAAA;A3Dk04CN;A2D/z4CI;EACE,qCAAA;EACA,uCAAA;A3Di04CN;;A2D5z4CA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;Ab284CJ;A2D7y4CE;EACE,aAAA;A3D+y4CJ;;A2D3y4CA;EACE,0EAAA;EACA,mCAAA;A3D8y4CF;;A4Dn+4CA;EACE,kBAAA;A5Ds+4CF;;A4Dn+4CA;EACE,mBAAA;A5Ds+4CF;;A4Dn+4CA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;A5Ds+4CF;A6D5/4CE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A7D8/4CJ;;A4Dv+4CA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;E/BlBI,sC+BmBJ;A5D0+4CF;A6Bz/4CM;E+BQN;I/BPQ,gBAAA;E7B4/4CN;AACF;;A4D5+4CA;;;EAGE,cAAA;A5D++4CF;;A4D5+4CA;;EAEE,2BAAA;A5D++4CF;;A4D5+4CA;;EAEE,4BAAA;A5D++4CF;;A4Dt+4CE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;A5Dy+4CJ;A4Dt+4CE;;;EAGE,UAAA;EACA,UAAA;A5Dw+4CJ;A4Dr+4CE;;EAEE,UAAA;EACA,UAAA;E/B5DE,2B+B6DF;A5Du+4CJ;A6Bhi5CM;E+BqDJ;;I/BpDM,gBAAA;E7Boi5CN;AACF;;A4Dp+4CA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhD+nDuB;EgD9nDvB,UAAA;EACA,WhDDM;EgDEN,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YhD0nDyB;EiBhtDrB,8B+BuFJ;A5Ds+4CF;A6Bzj5CM;E+BkEN;;I/BjEQ,gBAAA;E7B6j5CN;AACF;A4Dz+4CE;;;EAEE,WhDXI;EgDYJ,qBAAA;EACA,UAAA;EACA,YhDknD6B;AZ031CjC;;A4Dz+4CA;EACE,OAAA;A5D4+4CF;;A4Dz+4CA;EACE,QAAA;A5D4+4CF;;A4Dv+4CA;;EAEE,qBAAA;EACA,WhDmnD4B;EgDlnD5B,YhDknD4B;EgDjnD5B,4BAAA;EACA,wBAAA;EACA,0BAAA;A5D0+4CF;;A4Dv+4CA;EACE,2TAAA;A5D0+4CF;;A4Dx+4CA;EACE,0TAAA;A5D2+4CF;;A4Dn+4CA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhDmkDuB;EgDlkDvB,mBAAA;EACA,gBhDikDuB;AZo61CzB;A4Dn+4CE;EACE,uBAAA;EACA,cAAA;EACA,WhDikDuB;EgDhkDvB,WhDikDwB;EgDhkDxB,UAAA;EACA,iBhDikDwB;EgDhkDxB,gBhDgkDwB;EgD/jDxB,mBAAA;EACA,eAAA;EACA,sBhDzEI;EgD0EJ,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhDwjDyB;EiBxtDvB,6B+BiKF;A5Do+4CJ;A6Bjo5CM;E+B4IJ;I/B3IM,gBAAA;E7Boo5CN;AACF;A4Dt+4CE;EACE,UhDqjDgC;AZm71CpC;;A4D/94CA;EACE,kBAAA;EACA,UAAA;EACA,ehD+iDwB;EgD9iDxB,SAAA;EACA,oBhD4iD2B;EgD3iD3B,uBhD2iD2B;EgD1iD3B,WhDpGM;EgDqGN,kBAAA;A5Dk+4CF;;A4D594CE;;EAEE,gChDgjDgC;AZ+61CpC;A4D594CE;EACE,sBhDvGI;AZqk5CR;A4D394CE;EACE,WhD3GI;AZwk5CR;;A4Dv+4CE;;;EAEE,gChDgjDgC;AZ271CpC;A4Dx+4CE;EACE,sBhDvGI;AZil5CR;A4Dv+4CE;EACE,WhD3GI;AZol5CR;;A8D3r5CA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;A9D6r5CF;;A8Dzr5CA;EACE;IAAK,0CAAA;E9D6r5CL;AACF;A8D1r5CA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;A9Dyr5CF;;A8Dtr5CA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;A9Dwr5CF;;A8D/q5CA;EACE;IACE,mBAAA;E9Dkr5CF;E8Dhr5CA;IACE,UAAA;IACA,eAAA;E9Dkr5CF;AACF;A8D9q5CA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;A9D6q5CF;;A8D1q5CA;EACE,wBAAA;EACA,yBAAA;A9D6q5CF;;A8Dzq5CE;EACE;;IAEE,kCAAA;E9D4q5CJ;AACF;A+D5v5CA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,yCAAA;EACA,mDAAA;EACA,mDAAA;EACA,wDAAA;EACA,qDAAA;EACA,qCAAA;A/D6v5CF;;AqBhs5CI;E0C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IlC5BA,0CkC8BA;E/D8u5CJ;AACF;A6Bzw5CM;EkCYJ;IlCXM,gBAAA;E7B4w5CN;AACF;AqBtt5CI;E0C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/Dqv5CN;E+Dlv5CI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/Dov5CN;E+Djv5CI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/Dmv5CN;E+Dhv5CI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/Dkv5CN;E+D/u5CI;IAEE,eAAA;E/Dgv5CN;E+D7u5CI;IAGE,mBAAA;E/D6u5CN;AACF;AqB1w5CI;E0C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/D4u5CN;E+D1u5CM;IACE,aAAA;E/D4u5CR;E+Dzu5CM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/D0u5CR;AACF;;AqB9w5CI;E0C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IlC5BA,0CkC8BA;E/D4z5CJ;AACF;A6Bv15CM;EkCYJ;IlCXM,gBAAA;E7B015CN;AACF;AqBpy5CI;E0C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/Dm05CN;E+Dh05CI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/Dk05CN;E+D/z5CI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/Di05CN;E+D9z5CI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/Dg05CN;E+D7z5CI;IAEE,eAAA;E/D8z5CN;E+D3z5CI;IAGE,mBAAA;E/D2z5CN;AACF;AqBx15CI;E0C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/D0z5CN;E+Dxz5CM;IACE,aAAA;E/D0z5CR;E+Dvz5CM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/Dwz5CR;AACF;;AqB515CI;E0C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IlC5BA,0CkC8BA;E/D045CJ;AACF;A6Br65CM;EkCYJ;IlCXM,gBAAA;E7Bw65CN;AACF;AqBl35CI;E0C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/Di55CN;E+D945CI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/Dg55CN;E+D745CI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/D+45CN;E+D545CI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/D845CN;E+D345CI;IAEE,eAAA;E/D445CN;E+Dz45CI;IAGE,mBAAA;E/Dy45CN;AACF;AqBt65CI;E0C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/Dw45CN;E+Dt45CM;IACE,aAAA;E/Dw45CR;E+Dr45CM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/Ds45CR;AACF;;AqB165CI;E0C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IlC5BA,0CkC8BA;E/Dw95CJ;AACF;A6Bn/5CM;EkCYJ;IlCXM,gBAAA;E7Bs/5CN;AACF;AqBh85CI;E0C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/D+95CN;E+D595CI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/D895CN;E+D395CI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/D695CN;E+D195CI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/D495CN;E+Dz95CI;IAEE,eAAA;E/D095CN;E+Dv95CI;IAGE,mBAAA;E/Du95CN;AACF;AqBp/5CI;E0C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/Ds95CN;E+Dp95CM;IACE,aAAA;E/Ds95CR;E+Dn95CM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/Do95CR;AACF;;AqBx/5CI;E0C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IlC5BA,0CkC8BA;E/Dsi6CJ;AACF;A6Bjk6CM;EkCYJ;IlCXM,gBAAA;E7Bok6CN;AACF;AqB9g6CI;E0C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/D6i6CN;E+D1i6CI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/D4i6CN;E+Dzi6CI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/D2i6CN;E+Dxi6CI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/D0i6CN;E+Dvi6CI;IAEE,eAAA;E/Dwi6CN;E+Dri6CI;IAGE,mBAAA;E/Dqi6CN;AACF;AqBlk6CI;E0C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/Doi6CN;E+Dli6CM;IACE,aAAA;E/Doi6CR;E+Dji6CM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/Dki6CR;AACF;;A+Dln6CE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;ElC5BA,0CkC8BA;A/Dmn6CN;A6B7o6CM;EkCYJ;IlCXM,gBAAA;E7Bgp6CN;AACF;A+Dtn6CM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A/Dwn6CR;A+Drn6CM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A/Dun6CR;A+Dpn6CM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A/Dsn6CR;A+Dnn6CM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A/Dqn6CR;A+Dln6CM;EAEE,eAAA;A/Dmn6CR;A+Dhn6CM;EAGE,mBAAA;A/Dgn6CR;;A+Drl6CA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5CotC0B;E4CntC1B,YAAA;EACA,aAAA;EACA,sB5CmGM;AZ0m6CR;AwD1s6CE;EAAS,UAAA;AxD6s6CX;AwD5s6CE;EAAS,Y5CwlDc;AZun3CzB;;A+Djm6CA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;A/Dom6CF;A+Dlm6CE;EACE,4FAAA;EACA,6IAAA;A/Dom6CJ;;A+Dhm6CA;EACE,gBAAA;EACA,kDAAA;A/Dmm6CF;;A+Dhm6CA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A/Dmm6CF;;AgEhv6CA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpDk6CwB;AZi13C1B;AgEjv6CE;EACE,qBAAA;EACA,WAAA;AhEmv6CJ;;AgE9u6CA;EACE,iBAAA;AhEiv6CF;;AgE9u6CA;EACE,iBAAA;AhEiv6CF;;AgE9u6CA;EACE,iBAAA;AhEiv6CF;;AgE5u6CE;EACE,mDAAA;AhE+u6CJ;;AgE3u6CA;EACE;IACE,YpDq4CsB;EZy23CxB;AACF;AgE3u6CA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;AhE6u6CF;;AgE1u6CA;EACE;IACE,uBAAA;EhE6u6CF;AACF;A6D5x6CE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A7D8x6CJ;;AiEjy6CE;EACE,sBAAA;EACA,iFAAA;AjEoy6CJ;;AiEty6CE;EACE,sBAAA;EACA,mFAAA;AjEyy6CJ;;AiE3y6CE;EACE,sBAAA;EACA,iFAAA;AjE8y6CJ;;AiEhz6CE;EACE,sBAAA;EACA,8EAAA;AjEmz6CJ;;AiErz6CE;EACE,sBAAA;EACA,iFAAA;AjEwz6CJ;;AiE1z6CE;EACE,sBAAA;EACA,gFAAA;AjE6z6CJ;;AiE/z6CE;EACE,sBAAA;EACA,+EAAA;AjEk06CJ;;AiEp06CE;EACE,sBAAA;EACA,8EAAA;AjEu06CJ;;AkEz06CE;EACE,wEAAA;EACA,kGAAA;AlE406CJ;AkEz06CM;EAGE,8DAAA;EACA,wFAAA;AlEy06CR;;AkEl16CE;EACE,0EAAA;EACA,oGAAA;AlEq16CJ;AkEl16CM;EAGE,8DAAA;EACA,wFAAA;AlEk16CR;;AkE316CE;EACE,wEAAA;EACA,kGAAA;AlE816CJ;AkE316CM;EAGE,+DAAA;EACA,yFAAA;AlE216CR;;AkEp26CE;EACE,qEAAA;EACA,+FAAA;AlEu26CJ;AkEp26CM;EAGE,+DAAA;EACA,yFAAA;AlEo26CR;;AkE726CE;EACE,wEAAA;EACA,kGAAA;AlEg36CJ;AkE726CM;EAGE,+DAAA;EACA,yFAAA;AlE626CR;;AkEt36CE;EACE,uEAAA;EACA,iGAAA;AlEy36CJ;AkEt36CM;EAGE,8DAAA;EACA,wFAAA;AlEs36CR;;AkE/36CE;EACE,sEAAA;EACA,gGAAA;AlEk46CJ;AkE/36CM;EAGE,gEAAA;EACA,0FAAA;AlE+36CR;;AkEx46CE;EACE,qEAAA;EACA,+FAAA;AlE246CJ;AkEx46CM;EAGE,6DAAA;EACA,uFAAA;AlEw46CR;;AkEj46CA;EACE,+EAAA;EACA,yGAAA;AlEo46CF;AkEj46CI;EAEE,kFAAA;EACA,4GAAA;AlEk46CN;;AmE556CA;EACE,UAAA;EAEA,kJAAA;AnE856CF;;AoEj66CA;EACE,oBAAA;EACA,axDsiBc;EwDriBd,mBAAA;EACA,kFAAA;EACA,6BxDoiB2B;EwDniB3B,2BAAA;ApEo66CF;AoEl66CE;EACE,cAAA;EACA,UxDgiBkB;EwD/hBlB,WxD+hBkB;EwD9hBlB,kBAAA;EvCIE,sCuCHF;ApEo66CJ;A6B756CM;EuCZJ;IvCaM,gBAAA;E7Bg66CN;AACF;;AoEl66CI;EACE,mEAAA;ApEq66CN;;AqEx76CA;EACE,kBAAA;EACA,WAAA;ArE276CF;AqEz76CE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;ArE276CJ;AqEx76CE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;ArE076CJ;;AqEr76CE;EACE,uBAAA;ArEw76CJ;;AqEz76CE;EACE,sBAAA;ArE476CJ;;AqE776CE;EACE,yBAAA;ArEg86CJ;;AqEj86CE;EACE,iCAAA;ArEo86CJ;;AsEz96CA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DitCa;AZ2w4Cf;;AsEz96CA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1DysCa;AZmx4Cf;;AsEp96CI;EACE,gBAAA;EACA,MAAA;EACA,a1D6rCU;AZ0x4ChB;;AsEp96CI;EACE,gBAAA;EACA,SAAA;EACA,a1DurCU;AZgy4ChB;;AqBx76CI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1D6rCU;EZuy4Cd;EsEj+6CE;IACE,gBAAA;IACA,SAAA;IACA,a1DurCU;EZ4y4Cd;AACF;AqBr86CI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1D6rCU;EZmz4Cd;EsE7+6CE;IACE,gBAAA;IACA,SAAA;IACA,a1DurCU;EZwz4Cd;AACF;AqBj96CI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1D6rCU;EZ+z4Cd;EsEz/6CE;IACE,gBAAA;IACA,SAAA;IACA,a1DurCU;EZo04Cd;AACF;AqB796CI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1D6rCU;EZ204Cd;EsErg7CE;IACE,gBAAA;IACA,SAAA;IACA,a1DurCU;EZg14Cd;AACF;AqBz+6CI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1D6rCU;EZu14Cd;EsEjh7CE;IACE,gBAAA;IACA,SAAA;IACA,a1DurCU;EZ414Cd;AACF;AuEnj7CA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AvEqj7CF;;AuElj7CA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AvEqj7CF;;AwE7j7CA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AzE8j7CF;AyE3j7CE;;EACE,6BAAA;AzE8j7CJ;;A0E5k7CE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DyhBqB;E8DxhBrB,WAAA;A1E+k7CJ;;A2Evl7CA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;A5E2l7CF;;A6Ejm7CA;EACE,qBAAA;EACA,mBAAA;EACA,6BjEwxBgB;EiEvxBhB,eAAA;EACA,8BAAA;EACA,YjEkxBW;AZk15Cb;;A8Exi7CQ;EAOI,mCAAA;A9Eqi7CZ;;A8E5i7CQ;EAOI,8BAAA;A9Eyi7CZ;;A8Ehj7CQ;EAOI,iCAAA;A9E6i7CZ;;A8Epj7CQ;EAOI,iCAAA;A9Eij7CZ;;A8Exj7CQ;EAOI,sCAAA;A9Eqj7CZ;;A8E5j7CQ;EAOI,mCAAA;A9Eyj7CZ;;A8Ehk7CQ;EAOI,sBAAA;A9E6j7CZ;;A8Epk7CQ;EAOI,uBAAA;A9Eik7CZ;;A8Exk7CQ;EAOI,sBAAA;A9Eqk7CZ;;A8E5k7CQ;EAOI,8BAAA;A9Eyk7CZ;;A8Ehl7CQ;EAOI,4BAAA;A9E6k7CZ;;A8Epl7CQ;EAOI,2BAAA;A9Eil7CZ;;A8Exl7CQ;EAOI,iCAAA;A9Eql7CZ;;A8E5l7CQ;EAOI,2BAAA;A9Eyl7CZ;;A8Ehm7CQ;EAOI,qBAAA;A9E6l7CZ;;A8Epm7CQ;EAOI,wBAAA;A9Eim7CZ;;A8Exm7CQ;EAOI,uBAAA;A9Eqm7CZ;;A8E5m7CQ;EAOI,wBAAA;A9Eym7CZ;;A8Ehn7CQ;EAOI,qBAAA;A9E6m7CZ;;A8Epn7CQ;EAOI,yBAAA;A9Ein7CZ;;A8Exn7CQ;EAOI,2BAAA;A9Eqn7CZ;;A8E5n7CQ;EAOI,4BAAA;A9Eyn7CZ;;A8Eho7CQ;EAOI,2BAAA;A9E6n7CZ;;A8Epo7CQ;EAOI,2BAAA;A9Eio7CZ;;A8Exo7CQ;EAOI,6BAAA;A9Eqo7CZ;;A8E5o7CQ;EAOI,8BAAA;A9Eyo7CZ;;A8Ehp7CQ;EAOI,6BAAA;A9E6o7CZ;;A8Epp7CQ;EAOI,2BAAA;A9Eip7CZ;;A8Exp7CQ;EAOI,6BAAA;A9Eqp7CZ;;A8E5p7CQ;EAOI,8BAAA;A9Eyp7CZ;;A8Ehq7CQ;EAOI,6BAAA;A9E6p7CZ;;A8Epq7CQ;EAOI,0BAAA;A9Eiq7CZ;;A8Exq7CQ;EAOI,gCAAA;A9Eqq7CZ;;A8E5q7CQ;EAOI,yBAAA;A9Eyq7CZ;;A8Ehr7CQ;EAOI,wBAAA;A9E6q7CZ;;A8Epr7CQ;EAOI,+BAAA;A9Eir7CZ;;A8Exr7CQ;EAOI,yBAAA;A9Eqr7CZ;;A8E5r7CQ;EAOI,6BAAA;A9Eyr7CZ;;A8Ehs7CQ;EAOI,8BAAA;A9E6r7CZ;;A8Eps7CQ;EAOI,wBAAA;A9Eis7CZ;;A8Exs7CQ;EAOI,+BAAA;A9Eqs7CZ;;A8E5s7CQ;EAOI,wBAAA;A9Eys7CZ;;A8Eht7CQ;EAOI,2CAAA;A9E6s7CZ;;A8Ept7CQ;EAOI,8CAAA;A9Eit7CZ;;A8Ext7CQ;EAOI,8CAAA;A9Eqt7CZ;;A8E5t7CQ;EAOI,2BAAA;A9Eyt7CZ;;A8E1u7CQ;EACE,gFAAA;A9E6u7CV;;A8E9u7CQ;EACE,kFAAA;A9Eiv7CV;;A8Elv7CQ;EACE,gFAAA;A9Eqv7CV;;A8Etv7CQ;EACE,6EAAA;A9Eyv7CV;;A8E1v7CQ;EACE,gFAAA;A9E6v7CV;;A8E9v7CQ;EACE,+EAAA;A9Eiw7CV;;A8Elw7CQ;EACE,8EAAA;A9Eqw7CV;;A8Etw7CQ;EACE,6EAAA;A9Eyw7CV;;A8Ehw7CQ;EAOI,2BAAA;A9E6v7CZ;;A8Epw7CQ;EAOI,6BAAA;A9Eiw7CZ;;A8Exw7CQ;EAOI,6BAAA;A9Eqw7CZ;;A8E5w7CQ;EAOI,0BAAA;A9Eyw7CZ;;A8Ehx7CQ;EAOI,2BAAA;A9E6w7CZ;;A8Epx7CQ;EAOI,iBAAA;A9Eix7CZ;;A8Exx7CQ;EAOI,mBAAA;A9Eqx7CZ;;A8E5x7CQ;EAOI,oBAAA;A9Eyx7CZ;;A8Ehy7CQ;EAOI,oBAAA;A9E6x7CZ;;A8Epy7CQ;EAOI,sBAAA;A9Eiy7CZ;;A8Exy7CQ;EAOI,uBAAA;A9Eqy7CZ;;A8E5y7CQ;EAOI,kBAAA;A9Eyy7CZ;;A8Ehz7CQ;EAOI,oBAAA;A9E6y7CZ;;A8Epz7CQ;EAOI,qBAAA;A9Eiz7CZ;;A8Exz7CQ;EAOI,mBAAA;A9Eqz7CZ;;A8E5z7CQ;EAOI,qBAAA;A9Eyz7CZ;;A8Eh07CQ;EAOI,sBAAA;A9E6z7CZ;;A8Ep07CQ;EAOI,2CAAA;A9Ei07CZ;;A8Ex07CQ;EAOI,sCAAA;A9Eq07CZ;;A8E507CQ;EAOI,sCAAA;A9Ey07CZ;;A8Eh17CQ;EAOI,uFAAA;A9E607CZ;;A8Ep17CQ;EAOI,oBAAA;A9Ei17CZ;;A8Ex17CQ;EAOI,2FAAA;A9Eq17CZ;;A8E517CQ;EAOI,wBAAA;A9Ey17CZ;;A8Eh27CQ;EAOI,6FAAA;A9E617CZ;;A8Ep27CQ;EAOI,0BAAA;A9Ei27CZ;;A8Ex27CQ;EAOI,8FAAA;A9Eq27CZ;;A8E527CQ;EAOI,2BAAA;A9Ey27CZ;;A8Eh37CQ;EAOI,4FAAA;A9E627CZ;;A8Ep37CQ;EAOI,yBAAA;A9Ei37CZ;;A8Ex37CQ;EAIQ,sBAAA;EAGJ,8EAAA;A9Es37CZ;;A8E737CQ;EAIQ,sBAAA;EAGJ,gFAAA;A9E237CZ;;A8El47CQ;EAIQ,sBAAA;EAGJ,8EAAA;A9Eg47CZ;;A8Ev47CQ;EAIQ,sBAAA;EAGJ,2EAAA;A9Eq47CZ;;A8E547CQ;EAIQ,sBAAA;EAGJ,8EAAA;A9E047CZ;;A8Ej57CQ;EAIQ,sBAAA;EAGJ,6EAAA;A9E+47CZ;;A8Et57CQ;EAIQ,sBAAA;EAGJ,4EAAA;A9Eo57CZ;;A8E357CQ;EAIQ,sBAAA;EAGJ,2EAAA;A9Ey57CZ;;A8Eh67CQ;EAIQ,sBAAA;EAGJ,4EAAA;A9E857CZ;;A8Er67CQ;EAIQ,sBAAA;EAGJ,4EAAA;A9Em67CZ;;A8E167CQ;EAOI,wDAAA;A9Eu67CZ;;A8E967CQ;EAOI,0DAAA;A9E267CZ;;A8El77CQ;EAOI,wDAAA;A9E+67CZ;;A8Et77CQ;EAOI,qDAAA;A9Em77CZ;;A8E177CQ;EAOI,wDAAA;A9Eu77CZ;;A8E977CQ;EAOI,uDAAA;A9E277CZ;;A8El87CQ;EAOI,sDAAA;A9E+77CZ;;A8Et87CQ;EAOI,qDAAA;A9Em87CZ;;A8E187CQ;EAOI,0BAAA;A9Eu87CZ;;A8E987CQ;EAOI,4BAAA;A9E287CZ;;A8El97CQ;EAOI,4BAAA;A9E+87CZ;;A8Et97CQ;EAOI,4BAAA;A9Em97CZ;;A8E197CQ;EAOI,4BAAA;A9Eu97CZ;;A8E997CQ;EAOI,4BAAA;A9E297CZ;;A8E5+7CQ;EACE,wBAAA;A9E++7CV;;A8Eh/7CQ;EACE,yBAAA;A9Em/7CV;;A8Ep/7CQ;EACE,wBAAA;A9Eu/7CV;;A8Ex/7CQ;EACE,yBAAA;A9E2/7CV;;A8E5/7CQ;EACE,sBAAA;A9E+/7CV;;A8Et/7CQ;EAOI,qBAAA;A9Em/7CZ;;A8E1/7CQ;EAOI,qBAAA;A9Eu/7CZ;;A8E9/7CQ;EAOI,qBAAA;A9E2/7CZ;;A8Elg8CQ;EAOI,sBAAA;A9E+/7CZ;;A8Etg8CQ;EAOI,sBAAA;A9Emg8CZ;;A8E1g8CQ;EAOI,0BAAA;A9Eug8CZ;;A8E9g8CQ;EAOI,uBAAA;A9E2g8CZ;;A8Elh8CQ;EAOI,2BAAA;A9E+g8CZ;;A8Eth8CQ;EAOI,sBAAA;A9Emh8CZ;;A8E1h8CQ;EAOI,sBAAA;A9Euh8CZ;;A8E9h8CQ;EAOI,sBAAA;A9E2h8CZ;;A8Eli8CQ;EAOI,uBAAA;A9E+h8CZ;;A8Eti8CQ;EAOI,uBAAA;A9Emi8CZ;;A8E1i8CQ;EAOI,2BAAA;A9Eui8CZ;;A8E9i8CQ;EAOI,wBAAA;A9E2i8CZ;;A8Elj8CQ;EAOI,4BAAA;A9E+i8CZ;;A8Etj8CQ;EAOI,yBAAA;A9Emj8CZ;;A8E1j8CQ;EAOI,8BAAA;A9Euj8CZ;;A8E9j8CQ;EAOI,iCAAA;A9E2j8CZ;;A8Elk8CQ;EAOI,sCAAA;A9E+j8CZ;;A8Etk8CQ;EAOI,yCAAA;A9Emk8CZ;;A8E1k8CQ;EAOI,uBAAA;A9Euk8CZ;;A8E9k8CQ;EAOI,uBAAA;A9E2k8CZ;;A8Ell8CQ;EAOI,yBAAA;A9E+k8CZ;;A8Etl8CQ;EAOI,yBAAA;A9Eml8CZ;;A8E1l8CQ;EAOI,0BAAA;A9Eul8CZ;;A8E9l8CQ;EAOI,4BAAA;A9E2l8CZ;;A8Elm8CQ;EAOI,kCAAA;A9E+l8CZ;;A8Etm8CQ;EAOI,sCAAA;A9Emm8CZ;;A8E1m8CQ;EAOI,oCAAA;A9Eum8CZ;;A8E9m8CQ;EAOI,kCAAA;A9E2m8CZ;;A8Eln8CQ;EAOI,yCAAA;A9E+m8CZ;;A8Etn8CQ;EAOI,wCAAA;A9Emn8CZ;;A8E1n8CQ;EAOI,wCAAA;A9Eun8CZ;;A8E9n8CQ;EAOI,kCAAA;A9E2n8CZ;;A8Elo8CQ;EAOI,gCAAA;A9E+n8CZ;;A8Eto8CQ;EAOI,8BAAA;A9Emo8CZ;;A8E1o8CQ;EAOI,gCAAA;A9Euo8CZ;;A8E9o8CQ;EAOI,+BAAA;A9E2o8CZ;;A8Elp8CQ;EAOI,oCAAA;A9E+o8CZ;;A8Etp8CQ;EAOI,kCAAA;A9Emp8CZ;;A8E1p8CQ;EAOI,gCAAA;A9Eup8CZ;;A8E9p8CQ;EAOI,uCAAA;A9E2p8CZ;;A8Elq8CQ;EAOI,sCAAA;A9E+p8CZ;;A8Etq8CQ;EAOI,iCAAA;A9Emq8CZ;;A8E1q8CQ;EAOI,2BAAA;A9Euq8CZ;;A8E9q8CQ;EAOI,iCAAA;A9E2q8CZ;;A8Elr8CQ;EAOI,+BAAA;A9E+q8CZ;;A8Etr8CQ;EAOI,6BAAA;A9Emr8CZ;;A8E1r8CQ;EAOI,+BAAA;A9Eur8CZ;;A8E9r8CQ;EAOI,8BAAA;A9E2r8CZ;;A8Els8CQ;EAOI,oBAAA;A9E+r8CZ;;A8Ets8CQ;EAOI,mBAAA;A9Ems8CZ;;A8E1s8CQ;EAOI,mBAAA;A9Eus8CZ;;A8E9s8CQ;EAOI,mBAAA;A9E2s8CZ;;A8Elt8CQ;EAOI,mBAAA;A9E+s8CZ;;A8Ett8CQ;EAOI,mBAAA;A9Emt8CZ;;A8E1t8CQ;EAOI,mBAAA;A9Eut8CZ;;A8E9t8CQ;EAOI,mBAAA;A9E2t8CZ;;A8Elu8CQ;EAOI,oBAAA;A9E+t8CZ;;A8Etu8CQ;EAOI,0BAAA;A9Emu8CZ;;A8E1u8CQ;EAOI,yBAAA;A9Euu8CZ;;A8E9u8CQ;EAOI,uBAAA;A9E2u8CZ;;A8Elv8CQ;EAOI,yBAAA;A9E+u8CZ;;A8Etv8CQ;EAOI,uBAAA;A9Emv8CZ;;A8E1v8CQ;EAOI,uBAAA;A9Euv8CZ;;A8E9v8CQ;EAOI,0BAAA;EAAA,yBAAA;A9E4v8CZ;;A8Enw8CQ;EAOI,gCAAA;EAAA,+BAAA;A9Eiw8CZ;;A8Exw8CQ;EAOI,+BAAA;EAAA,8BAAA;A9Esw8CZ;;A8E7w8CQ;EAOI,6BAAA;EAAA,4BAAA;A9E2w8CZ;;A8Elx8CQ;EAOI,+BAAA;EAAA,8BAAA;A9Egx8CZ;;A8Evx8CQ;EAOI,6BAAA;EAAA,4BAAA;A9Eqx8CZ;;A8E5x8CQ;EAOI,6BAAA;EAAA,4BAAA;A9E0x8CZ;;A8Ejy8CQ;EAOI,wBAAA;EAAA,2BAAA;A9E+x8CZ;;A8Ety8CQ;EAOI,8BAAA;EAAA,iCAAA;A9Eoy8CZ;;A8E3y8CQ;EAOI,6BAAA;EAAA,gCAAA;A9Eyy8CZ;;A8Ehz8CQ;EAOI,2BAAA;EAAA,8BAAA;A9E8y8CZ;;A8Erz8CQ;EAOI,6BAAA;EAAA,gCAAA;A9Emz8CZ;;A8E1z8CQ;EAOI,2BAAA;EAAA,8BAAA;A9Ewz8CZ;;A8E/z8CQ;EAOI,2BAAA;EAAA,8BAAA;A9E6z8CZ;;A8Ep08CQ;EAOI,wBAAA;A9Ei08CZ;;A8Ex08CQ;EAOI,8BAAA;A9Eq08CZ;;A8E508CQ;EAOI,6BAAA;A9Ey08CZ;;A8Eh18CQ;EAOI,2BAAA;A9E608CZ;;A8Ep18CQ;EAOI,6BAAA;A9Ei18CZ;;A8Ex18CQ;EAOI,2BAAA;A9Eq18CZ;;A8E518CQ;EAOI,2BAAA;A9Ey18CZ;;A8Eh28CQ;EAOI,0BAAA;A9E618CZ;;A8Ep28CQ;EAOI,gCAAA;A9Ei28CZ;;A8Ex28CQ;EAOI,+BAAA;A9Eq28CZ;;A8E528CQ;EAOI,6BAAA;A9Ey28CZ;;A8Eh38CQ;EAOI,+BAAA;A9E628CZ;;A8Ep38CQ;EAOI,6BAAA;A9Ei38CZ;;A8Ex38CQ;EAOI,6BAAA;A9Eq38CZ;;A8E538CQ;EAOI,2BAAA;A9Ey38CZ;;A8Eh48CQ;EAOI,iCAAA;A9E638CZ;;A8Ep48CQ;EAOI,gCAAA;A9Ei48CZ;;A8Ex48CQ;EAOI,8BAAA;A9Eq48CZ;;A8E548CQ;EAOI,gCAAA;A9Ey48CZ;;A8Eh58CQ;EAOI,8BAAA;A9E648CZ;;A8Ep58CQ;EAOI,8BAAA;A9Ei58CZ;;A8Ex58CQ;EAOI,yBAAA;A9Eq58CZ;;A8E558CQ;EAOI,+BAAA;A9Ey58CZ;;A8Eh68CQ;EAOI,8BAAA;A9E658CZ;;A8Ep68CQ;EAOI,4BAAA;A9Ei68CZ;;A8Ex68CQ;EAOI,8BAAA;A9Eq68CZ;;A8E568CQ;EAOI,4BAAA;A9Ey68CZ;;A8Eh78CQ;EAOI,4BAAA;A9E668CZ;;A8Ep78CQ;EAOI,2BAAA;A9Ei78CZ;;A8Ex78CQ;EAOI,0BAAA;A9Eq78CZ;;A8E578CQ;EAOI,wBAAA;A9Ey78CZ;;A8Eh88CQ;EAOI,0BAAA;A9E678CZ;;A8Ep88CQ;EAOI,wBAAA;A9Ei88CZ;;A8Ex88CQ;EAOI,iCAAA;EAAA,gCAAA;A9Es88CZ;;A8E788CQ;EAOI,gCAAA;EAAA,+BAAA;A9E288CZ;;A8El98CQ;EAOI,8BAAA;EAAA,6BAAA;A9Eg98CZ;;A8Ev98CQ;EAOI,gCAAA;EAAA,+BAAA;A9Eq98CZ;;A8E598CQ;EAOI,8BAAA;EAAA,6BAAA;A9E098CZ;;A8Ej+8CQ;EAOI,+BAAA;EAAA,kCAAA;A9E+98CZ;;A8Et+8CQ;EAOI,8BAAA;EAAA,iCAAA;A9Eo+8CZ;;A8E3+8CQ;EAOI,4BAAA;EAAA,+BAAA;A9Ey+8CZ;;A8Eh/8CQ;EAOI,8BAAA;EAAA,iCAAA;A9E8+8CZ;;A8Er/8CQ;EAOI,4BAAA;EAAA,+BAAA;A9Em/8CZ;;A8E1/8CQ;EAOI,+BAAA;A9Eu/8CZ;;A8E9/8CQ;EAOI,8BAAA;A9E2/8CZ;;A8Elg9CQ;EAOI,4BAAA;A9E+/8CZ;;A8Etg9CQ;EAOI,8BAAA;A9Emg9CZ;;A8E1g9CQ;EAOI,4BAAA;A9Eug9CZ;;A8E9g9CQ;EAOI,iCAAA;A9E2g9CZ;;A8Elh9CQ;EAOI,gCAAA;A9E+g9CZ;;A8Eth9CQ;EAOI,8BAAA;A9Emh9CZ;;A8E1h9CQ;EAOI,gCAAA;A9Euh9CZ;;A8E9h9CQ;EAOI,8BAAA;A9E2h9CZ;;A8Eli9CQ;EAOI,kCAAA;A9E+h9CZ;;A8Eti9CQ;EAOI,iCAAA;A9Emi9CZ;;A8E1i9CQ;EAOI,+BAAA;A9Eui9CZ;;A8E9i9CQ;EAOI,iCAAA;A9E2i9CZ;;A8Elj9CQ;EAOI,+BAAA;A9E+i9CZ;;A8Etj9CQ;EAOI,gCAAA;A9Emj9CZ;;A8E1j9CQ;EAOI,+BAAA;A9Euj9CZ;;A8E9j9CQ;EAOI,6BAAA;A9E2j9CZ;;A8Elk9CQ;EAOI,+BAAA;A9E+j9CZ;;A8Etk9CQ;EAOI,6BAAA;A9Emk9CZ;;A8E1k9CQ;EAOI,qBAAA;A9Euk9CZ;;A8E9k9CQ;EAOI,2BAAA;A9E2k9CZ;;A8Ell9CQ;EAOI,0BAAA;A9E+k9CZ;;A8Etl9CQ;EAOI,wBAAA;A9Eml9CZ;;A8E1l9CQ;EAOI,0BAAA;A9Eul9CZ;;A8E9l9CQ;EAOI,wBAAA;A9E2l9CZ;;A8Elm9CQ;EAOI,2BAAA;EAAA,0BAAA;A9Egm9CZ;;A8Evm9CQ;EAOI,iCAAA;EAAA,gCAAA;A9Eqm9CZ;;A8E5m9CQ;EAOI,gCAAA;EAAA,+BAAA;A9E0m9CZ;;A8Ejn9CQ;EAOI,8BAAA;EAAA,6BAAA;A9E+m9CZ;;A8Etn9CQ;EAOI,gCAAA;EAAA,+BAAA;A9Eon9CZ;;A8E3n9CQ;EAOI,8BAAA;EAAA,6BAAA;A9Eyn9CZ;;A8Eho9CQ;EAOI,yBAAA;EAAA,4BAAA;A9E8n9CZ;;A8Ero9CQ;EAOI,+BAAA;EAAA,kCAAA;A9Emo9CZ;;A8E1o9CQ;EAOI,8BAAA;EAAA,iCAAA;A9Ewo9CZ;;A8E/o9CQ;EAOI,4BAAA;EAAA,+BAAA;A9E6o9CZ;;A8Epp9CQ;EAOI,8BAAA;EAAA,iCAAA;A9Ekp9CZ;;A8Ezp9CQ;EAOI,4BAAA;EAAA,+BAAA;A9Eup9CZ;;A8E9p9CQ;EAOI,yBAAA;A9E2p9CZ;;A8Elq9CQ;EAOI,+BAAA;A9E+p9CZ;;A8Etq9CQ;EAOI,8BAAA;A9Emq9CZ;;A8E1q9CQ;EAOI,4BAAA;A9Euq9CZ;;A8E9q9CQ;EAOI,8BAAA;A9E2q9CZ;;A8Elr9CQ;EAOI,4BAAA;A9E+q9CZ;;A8Etr9CQ;EAOI,2BAAA;A9Emr9CZ;;A8E1r9CQ;EAOI,iCAAA;A9Eur9CZ;;A8E9r9CQ;EAOI,gCAAA;A9E2r9CZ;;A8Els9CQ;EAOI,8BAAA;A9E+r9CZ;;A8Ets9CQ;EAOI,gCAAA;A9Ems9CZ;;A8E1s9CQ;EAOI,8BAAA;A9Eus9CZ;;A8E9s9CQ;EAOI,4BAAA;A9E2s9CZ;;A8Elt9CQ;EAOI,kCAAA;A9E+s9CZ;;A8Ett9CQ;EAOI,iCAAA;A9Emt9CZ;;A8E1t9CQ;EAOI,+BAAA;A9Eut9CZ;;A8E9t9CQ;EAOI,iCAAA;A9E2t9CZ;;A8Elu9CQ;EAOI,+BAAA;A9E+t9CZ;;A8Etu9CQ;EAOI,0BAAA;A9Emu9CZ;;A8E1u9CQ;EAOI,gCAAA;A9Euu9CZ;;A8E9u9CQ;EAOI,+BAAA;A9E2u9CZ;;A8Elv9CQ;EAOI,6BAAA;A9E+u9CZ;;A8Etv9CQ;EAOI,+BAAA;A9Emv9CZ;;A8E1v9CQ;EAOI,6BAAA;A9Euv9CZ;;A8E9v9CQ;EAOI,iBAAA;A9E2v9CZ;;A8Elw9CQ;EAOI,uBAAA;A9E+v9CZ;;A8Etw9CQ;EAOI,sBAAA;A9Emw9CZ;;A8E1w9CQ;EAOI,oBAAA;A9Euw9CZ;;A8E9w9CQ;EAOI,sBAAA;A9E2w9CZ;;A8Elx9CQ;EAOI,oBAAA;A9E+w9CZ;;A8Etx9CQ;EAOI,qBAAA;A9Emx9CZ;;A8E1x9CQ;EAOI,2BAAA;A9Eux9CZ;;A8E9x9CQ;EAOI,0BAAA;A9E2x9CZ;;A8Ely9CQ;EAOI,wBAAA;A9E+x9CZ;;A8Ety9CQ;EAOI,0BAAA;A9Emy9CZ;;A8E1y9CQ;EAOI,wBAAA;A9Euy9CZ;;A8E9y9CQ;EAOI,wBAAA;A9E2y9CZ;;A8Elz9CQ;EAOI,8BAAA;A9E+y9CZ;;A8Etz9CQ;EAOI,6BAAA;A9Emz9CZ;;A8E1z9CQ;EAOI,2BAAA;A9Euz9CZ;;A8E9z9CQ;EAOI,6BAAA;A9E2z9CZ;;A8El09CQ;EAOI,2BAAA;A9E+z9CZ;;A8Et09CQ;EAOI,gDAAA;A9Em09CZ;;A8E109CQ;EAOI,2CAAA;A9Eu09CZ;;A8E909CQ;EAOI,6CAAA;A9E209CZ;;A8El19CQ;EAOI,8CAAA;A9E+09CZ;;A8Et19CQ;EAOI,4CAAA;A9Em19CZ;;A8E119CQ;EAOI,8BAAA;A9Eu19CZ;;A8E919CQ;EAOI,4BAAA;A9E219CZ;;A8El29CQ;EAOI,6BAAA;A9E+19CZ;;A8Et29CQ;EAOI,6BAAA;A9Em29CZ;;A8E129CQ;EAOI,+BAAA;A9Eu29CZ;;A8E929CQ;EAOI,2BAAA;A9E229CZ;;A8El39CQ;EAOI,2BAAA;A9E+29CZ;;A8Et39CQ;EAOI,2BAAA;A9Em39CZ;;A8E139CQ;EAOI,2BAAA;A9Eu39CZ;;A8E939CQ;EAOI,2BAAA;A9E239CZ;;A8El49CQ;EAOI,8BAAA;A9E+39CZ;;A8Et49CQ;EAOI,yBAAA;A9Em49CZ;;A8E149CQ;EAOI,4BAAA;A9Eu49CZ;;A8E949CQ;EAOI,2BAAA;A9E249CZ;;A8El59CQ;EAOI,yBAAA;A9E+49CZ;;A8Et59CQ;EAOI,2BAAA;A9Em59CZ;;A8E159CQ;EAOI,4BAAA;A9Eu59CZ;;A8E959CQ;EAOI,6BAAA;A9E259CZ;;A8El69CQ;EAOI,gCAAA;A9E+59CZ;;A8Et69CQ;EAOI,qCAAA;A9Em69CZ;;A8E169CQ;EAOI,wCAAA;A9Eu69CZ;;A8E969CQ;EAOI,oCAAA;A9E269CZ;;A8El79CQ;EAOI,oCAAA;A9E+69CZ;;A8Et79CQ;EAOI,qCAAA;A9Em79CZ;;A8E179CQ;EAOI,8BAAA;A9Eu79CZ;;A8E979CQ;EAOI,8BAAA;A9E279CZ;;A8Eh99CQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;A9Ei89CZ;;A8E969CQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;A9Eu89CZ;;A8E989CQ;EAIQ,oBAAA;EAGJ,uEAAA;A9E489CZ;;A8En99CQ;EAIQ,oBAAA;EAGJ,qEAAA;A9Ei99CZ;;A8Ex99CQ;EAIQ,oBAAA;EAGJ,kEAAA;A9Es99CZ;;A8E799CQ;EAIQ,oBAAA;EAGJ,qEAAA;A9E299CZ;;A8El+9CQ;EAIQ,oBAAA;EAGJ,oEAAA;A9Eg+9CZ;;A8Ev+9CQ;EAIQ,oBAAA;EAGJ,mEAAA;A9Eq+9CZ;;A8E5+9CQ;EAIQ,oBAAA;EAGJ,kEAAA;A9E0+9CZ;;A8Ej/9CQ;EAIQ,oBAAA;EAGJ,mEAAA;A9E++9CZ;;A8Et/9CQ;EAIQ,oBAAA;EAGJ,mEAAA;A9Eo/9CZ;;A8E3/9CQ;EAIQ,oBAAA;EAGJ,wEAAA;A9Ey/9CZ;;A8Ehg+CQ;EAIQ,oBAAA;EAGJ,2CAAA;A9E8/9CZ;;A8Erg+CQ;EAIQ,oBAAA;EAGJ,oCAAA;A9Emg+CZ;;A8E1g+CQ;EAIQ,oBAAA;EAGJ,0CAAA;A9Ewg+CZ;;A8E/g+CQ;EAIQ,oBAAA;EAGJ,2CAAA;A9E6g+CZ;;A8Eph+CQ;EAIQ,oBAAA;EAGJ,0CAAA;A9Ekh+CZ;;A8Ezh+CQ;EAIQ,oBAAA;EAGJ,0CAAA;A9Euh+CZ;;A8E9h+CQ;EAIQ,oBAAA;EAGJ,yBAAA;A9E4h+CZ;;A8E7i+CQ;EACE,uBAAA;A9Egj+CV;;A8Ejj+CQ;EACE,sBAAA;A9Eoj+CV;;A8Erj+CQ;EACE,uBAAA;A9Ewj+CV;;A8Ezj+CQ;EACE,oBAAA;A9E4j+CV;;A8Enj+CQ;EAOI,iDAAA;A9Egj+CZ;;A8Evj+CQ;EAOI,mDAAA;A9Eoj+CZ;;A8E3j+CQ;EAOI,iDAAA;A9Ewj+CZ;;A8E/j+CQ;EAOI,8CAAA;A9E4j+CZ;;A8Enk+CQ;EAOI,iDAAA;A9Egk+CZ;;A8Evk+CQ;EAOI,gDAAA;A9Eok+CZ;;A8E3k+CQ;EAOI,+CAAA;A9Ewk+CZ;;A8E/k+CQ;EAOI,8CAAA;A9E4k+CZ;;A8E7l+CQ;EACE,sBAAA;A9Egm+CV;;A8E5l+CU;EACE,sBAAA;A9E+l+CZ;;A8Erm+CQ;EACE,uBAAA;A9Ewm+CV;;A8Epm+CU;EACE,uBAAA;A9Eum+CZ;;A8E7m+CQ;EACE,sBAAA;A9Egn+CV;;A8E5m+CU;EACE,sBAAA;A9E+m+CZ;;A8Ern+CQ;EACE,uBAAA;A9Ewn+CV;;A8Epn+CU;EACE,uBAAA;A9Eun+CZ;;A8E7n+CQ;EACE,oBAAA;A9Ego+CV;;A8E5n+CU;EACE,oBAAA;A9E+n+CZ;;A8E3n+CQ;EAOI,yCAAA;A9Ewn+CZ;;A8Enn+CU;EAOI,yCAAA;A9Egn+Cd;;A8Eno+CQ;EAOI,wCAAA;A9Ego+CZ;;A8E3n+CU;EAOI,wCAAA;A9Ewn+Cd;;A8E3o+CQ;EAOI,yCAAA;A9Ewo+CZ;;A8Eno+CU;EAOI,yCAAA;A9Ego+Cd;;A8Enp+CQ;EAIQ,8BAAA;EAGJ,+FAAA;A9Eip+CZ;;A8Exp+CQ;EAIQ,8BAAA;EAGJ,iGAAA;A9Esp+CZ;;A8E7p+CQ;EAIQ,8BAAA;EAGJ,+FAAA;A9E2p+CZ;;A8Elq+CQ;EAIQ,8BAAA;EAGJ,4FAAA;A9Egq+CZ;;A8Evq+CQ;EAIQ,8BAAA;EAGJ,+FAAA;A9Eqq+CZ;;A8E5q+CQ;EAIQ,8BAAA;EAGJ,8FAAA;A9E0q+CZ;;A8Ejr+CQ;EAIQ,8BAAA;EAGJ,6FAAA;A9E+q+CZ;;A8Etr+CQ;EAIQ,8BAAA;EAGJ,4FAAA;A9Eor+CZ;;A8E3r+CQ;EAIQ,8BAAA;EAGJ,qGAAA;A9Eyr+CZ;;A8E1s+CQ;EACE,8BAAA;A9E6s+CV;;A8Ezs+CU;EACE,8BAAA;A9E4s+CZ;;A8Elt+CQ;EACE,gCAAA;A9Eqt+CV;;A8Ejt+CU;EACE,gCAAA;A9Eot+CZ;;A8E1t+CQ;EACE,iCAAA;A9E6t+CV;;A8Ezt+CU;EACE,iCAAA;A9E4t+CZ;;A8Elu+CQ;EACE,gCAAA;A9Equ+CV;;A8Eju+CU;EACE,gCAAA;A9Eou+CZ;;A8E1u+CQ;EACE,iCAAA;A9E6u+CV;;A8Ezu+CU;EACE,iCAAA;A9E4u+CZ;;A8Elv+CQ;EACE,8BAAA;A9Eqv+CV;;A8Ejv+CU;EACE,8BAAA;A9Eov+CZ;;A8Ehv+CQ;EAIQ,kBAAA;EAGJ,8EAAA;A9E8u+CZ;;A8Erv+CQ;EAIQ,kBAAA;EAGJ,gFAAA;A9Emv+CZ;;A8E1v+CQ;EAIQ,kBAAA;EAGJ,8EAAA;A9Ewv+CZ;;A8E/v+CQ;EAIQ,kBAAA;EAGJ,2EAAA;A9E6v+CZ;;A8Epw+CQ;EAIQ,kBAAA;EAGJ,8EAAA;A9Ekw+CZ;;A8Ezw+CQ;EAIQ,kBAAA;EAGJ,6EAAA;A9Euw+CZ;;A8E9w+CQ;EAIQ,kBAAA;EAGJ,4EAAA;A9E4w+CZ;;A8Enx+CQ;EAIQ,kBAAA;EAGJ,2EAAA;A9Eix+CZ;;A8Exx+CQ;EAIQ,kBAAA;EAGJ,4EAAA;A9Esx+CZ;;A8E7x+CQ;EAIQ,kBAAA;EAGJ,4EAAA;A9E2x+CZ;;A8Ely+CQ;EAIQ,kBAAA;EAGJ,8EAAA;A9Egy+CZ;;A8Evy+CQ;EAIQ,kBAAA;EAGJ,wCAAA;A9Eqy+CZ;;A8E5y+CQ;EAIQ,kBAAA;EAGJ,mFAAA;A9E0y+CZ;;A8Ejz+CQ;EAIQ,kBAAA;EAGJ,kFAAA;A9E+y+CZ;;A8Eh0+CQ;EACE,oBAAA;A9Em0+CV;;A8Ep0+CQ;EACE,qBAAA;A9Eu0+CV;;A8Ex0+CQ;EACE,oBAAA;A9E20+CV;;A8E50+CQ;EACE,qBAAA;A9E+0+CV;;A8Eh1+CQ;EACE,kBAAA;A9Em1+CV;;A8E10+CQ;EAOI,wDAAA;A9Eu0+CZ;;A8E90+CQ;EAOI,0DAAA;A9E20+CZ;;A8El1+CQ;EAOI,wDAAA;A9E+0+CZ;;A8Et1+CQ;EAOI,qDAAA;A9Em1+CZ;;A8E11+CQ;EAOI,wDAAA;A9Eu1+CZ;;A8E91+CQ;EAOI,uDAAA;A9E21+CZ;;A8El2+CQ;EAOI,sDAAA;A9E+1+CZ;;A8Et2+CQ;EAOI,qDAAA;A9Em2+CZ;;A8E12+CQ;EAOI,+CAAA;A9Eu2+CZ;;A8E92+CQ;EAOI,mCAAA;UAAA,2BAAA;A9E22+CZ;;A8El3+CQ;EAOI,oCAAA;UAAA,4BAAA;A9E+2+CZ;;A8Et3+CQ;EAOI,oCAAA;UAAA,4BAAA;A9Em3+CZ;;A8E13+CQ;EAOI,+BAAA;A9Eu3+CZ;;A8E93+CQ;EAOI,+BAAA;A9E23+CZ;;A8El4+CQ;EAOI,iDAAA;A9E+3+CZ;;A8Et4+CQ;EAOI,2BAAA;A9Em4+CZ;;A8E14+CQ;EAOI,oDAAA;A9Eu4+CZ;;A8E94+CQ;EAOI,iDAAA;A9E24+CZ;;A8El5+CQ;EAOI,oDAAA;A9E+4+CZ;;A8Et5+CQ;EAOI,oDAAA;A9Em5+CZ;;A8E15+CQ;EAOI,qDAAA;A9Eu5+CZ;;A8E95+CQ;EAOI,6BAAA;A9E25+CZ;;A8El6+CQ;EAOI,sDAAA;A9E+5+CZ;;A8Et6+CQ;EAOI,0DAAA;EAAA,2DAAA;A9Eo6+CZ;;A8E36+CQ;EAOI,oCAAA;EAAA,qCAAA;A9Ey6+CZ;;A8Eh7+CQ;EAOI,6DAAA;EAAA,8DAAA;A9E86+CZ;;A8Er7+CQ;EAOI,0DAAA;EAAA,2DAAA;A9Em7+CZ;;A8E17+CQ;EAOI,6DAAA;EAAA,8DAAA;A9Ew7+CZ;;A8E/7+CQ;EAOI,6DAAA;EAAA,8DAAA;A9E67+CZ;;A8Ep8+CQ;EAOI,8DAAA;EAAA,+DAAA;A9Ek8+CZ;;A8Ez8+CQ;EAOI,sCAAA;EAAA,uCAAA;A9Eu8+CZ;;A8E98+CQ;EAOI,+DAAA;EAAA,gEAAA;A9E48+CZ;;A8En9+CQ;EAOI,2DAAA;EAAA,8DAAA;A9Ei9+CZ;;A8Ex9+CQ;EAOI,qCAAA;EAAA,wCAAA;A9Es9+CZ;;A8E79+CQ;EAOI,8DAAA;EAAA,iEAAA;A9E29+CZ;;A8El++CQ;EAOI,2DAAA;EAAA,8DAAA;A9Eg++CZ;;A8Ev++CQ;EAOI,8DAAA;EAAA,iEAAA;A9Eq++CZ;;A8E5++CQ;EAOI,8DAAA;EAAA,iEAAA;A9E0++CZ;;A8Ej/+CQ;EAOI,+DAAA;EAAA,kEAAA;A9E+++CZ;;A8Et/+CQ;EAOI,uCAAA;EAAA,0CAAA;A9Eo/+CZ;;A8E3/+CQ;EAOI,gEAAA;EAAA,mEAAA;A9Ey/+CZ;;A8Ehg/CQ;EAOI,8DAAA;EAAA,6DAAA;A9E8/+CZ;;A8Erg/CQ;EAOI,wCAAA;EAAA,uCAAA;A9Emg/CZ;;A8E1g/CQ;EAOI,iEAAA;EAAA,gEAAA;A9Ewg/CZ;;A8E/g/CQ;EAOI,8DAAA;EAAA,6DAAA;A9E6g/CZ;;A8Eph/CQ;EAOI,iEAAA;EAAA,gEAAA;A9Ekh/CZ;;A8Ezh/CQ;EAOI,iEAAA;EAAA,gEAAA;A9Euh/CZ;;A8E9h/CQ;EAOI,kEAAA;EAAA,iEAAA;A9E4h/CZ;;A8Eni/CQ;EAOI,0CAAA;EAAA,yCAAA;A9Eii/CZ;;A8Exi/CQ;EAOI,mEAAA;EAAA,kEAAA;A9Esi/CZ;;A8E7i/CQ;EAOI,6DAAA;EAAA,0DAAA;A9E2i/CZ;;A8Elj/CQ;EAOI,uCAAA;EAAA,oCAAA;A9Egj/CZ;;A8Evj/CQ;EAOI,gEAAA;EAAA,6DAAA;A9Eqj/CZ;;A8E5j/CQ;EAOI,6DAAA;EAAA,0DAAA;A9E0j/CZ;;A8Ejk/CQ;EAOI,gEAAA;EAAA,6DAAA;A9E+j/CZ;;A8Etk/CQ;EAOI,gEAAA;EAAA,6DAAA;A9Eok/CZ;;A8E3k/CQ;EAOI,iEAAA;EAAA,8DAAA;A9Eyk/CZ;;A8Ehl/CQ;EAOI,yCAAA;EAAA,sCAAA;A9E8k/CZ;;A8Erl/CQ;EAOI,kEAAA;EAAA,+DAAA;A9Eml/CZ;;A8E1l/CQ;EAOI,8BAAA;A9Eul/CZ;;A8E9l/CQ;EAOI,6BAAA;A9E2l/CZ;;A8Elm/CQ;EAOI,sBAAA;A9E+l/CZ;;A8Etm/CQ;EAOI,qBAAA;A9Emm/CZ;;A8E1m/CQ;EAOI,qBAAA;A9Eum/CZ;;A8E9m/CQ;EAOI,qBAAA;A9E2m/CZ;;A8Eln/CQ;EAOI,qBAAA;A9E+m/CZ;;AqBzn/CI;EyDGI;IAOI,sBAAA;E9Eon/CV;E8E3n/CM;IAOI,uBAAA;E9Eun/CV;E8E9n/CM;IAOI,sBAAA;E9E0n/CV;E8Ejo/CM;IAOI,8BAAA;E9E6n/CV;E8Epo/CM;IAOI,4BAAA;E9Ego/CV;E8Evo/CM;IAOI,2BAAA;E9Emo/CV;E8E1o/CM;IAOI,iCAAA;E9Eso/CV;E8E7o/CM;IAOI,2BAAA;E9Eyo/CV;E8Ehp/CM;IAOI,0BAAA;E9E4o/CV;E8Enp/CM;IAOI,gCAAA;E9E+o/CV;E8Etp/CM;IAOI,yBAAA;E9Ekp/CV;E8Ezp/CM;IAOI,wBAAA;E9Eqp/CV;E8E5p/CM;IAOI,+BAAA;E9Ewp/CV;E8E/p/CM;IAOI,yBAAA;E9E2p/CV;E8Elq/CM;IAOI,6BAAA;E9E8p/CV;E8Erq/CM;IAOI,8BAAA;E9Eiq/CV;E8Exq/CM;IAOI,wBAAA;E9Eoq/CV;E8E3q/CM;IAOI,+BAAA;E9Euq/CV;E8E9q/CM;IAOI,wBAAA;E9E0q/CV;E8Ejr/CM;IAOI,yBAAA;E9E6q/CV;E8Epr/CM;IAOI,8BAAA;E9Egr/CV;E8Evr/CM;IAOI,iCAAA;E9Emr/CV;E8E1r/CM;IAOI,sCAAA;E9Esr/CV;E8E7r/CM;IAOI,yCAAA;E9Eyr/CV;E8Ehs/CM;IAOI,uBAAA;E9E4r/CV;E8Ens/CM;IAOI,uBAAA;E9E+r/CV;E8Ets/CM;IAOI,yBAAA;E9Eks/CV;E8Ezs/CM;IAOI,yBAAA;E9Eqs/CV;E8E5s/CM;IAOI,0BAAA;E9Ews/CV;E8E/s/CM;IAOI,4BAAA;E9E2s/CV;E8Elt/CM;IAOI,kCAAA;E9E8s/CV;E8Ert/CM;IAOI,sCAAA;E9Eit/CV;E8Ext/CM;IAOI,oCAAA;E9Eot/CV;E8E3t/CM;IAOI,kCAAA;E9Eut/CV;E8E9t/CM;IAOI,yCAAA;E9E0t/CV;E8Eju/CM;IAOI,wCAAA;E9E6t/CV;E8Epu/CM;IAOI,wCAAA;E9Egu/CV;E8Evu/CM;IAOI,kCAAA;E9Emu/CV;E8E1u/CM;IAOI,gCAAA;E9Esu/CV;E8E7u/CM;IAOI,8BAAA;E9Eyu/CV;E8Ehv/CM;IAOI,gCAAA;E9E4u/CV;E8Env/CM;IAOI,+BAAA;E9E+u/CV;E8Etv/CM;IAOI,oCAAA;E9Ekv/CV;E8Ezv/CM;IAOI,kCAAA;E9Eqv/CV;E8E5v/CM;IAOI,gCAAA;E9Ewv/CV;E8E/v/CM;IAOI,uCAAA;E9E2v/CV;E8Elw/CM;IAOI,sCAAA;E9E8v/CV;E8Erw/CM;IAOI,iCAAA;E9Eiw/CV;E8Exw/CM;IAOI,2BAAA;E9Eow/CV;E8E3w/CM;IAOI,iCAAA;E9Euw/CV;E8E9w/CM;IAOI,+BAAA;E9E0w/CV;E8Ejx/CM;IAOI,6BAAA;E9E6w/CV;E8Epx/CM;IAOI,+BAAA;E9Egx/CV;E8Evx/CM;IAOI,8BAAA;E9Emx/CV;E8E1x/CM;IAOI,oBAAA;E9Esx/CV;E8E7x/CM;IAOI,mBAAA;E9Eyx/CV;E8Ehy/CM;IAOI,mBAAA;E9E4x/CV;E8Eny/CM;IAOI,mBAAA;E9E+x/CV;E8Ety/CM;IAOI,mBAAA;E9Eky/CV;E8Ezy/CM;IAOI,mBAAA;E9Eqy/CV;E8E5y/CM;IAOI,mBAAA;E9Ewy/CV;E8E/y/CM;IAOI,mBAAA;E9E2y/CV;E8Elz/CM;IAOI,oBAAA;E9E8y/CV;E8Erz/CM;IAOI,0BAAA;E9Eiz/CV;E8Exz/CM;IAOI,yBAAA;E9Eoz/CV;E8E3z/CM;IAOI,uBAAA;E9Euz/CV;E8E9z/CM;IAOI,yBAAA;E9E0z/CV;E8Ej0/CM;IAOI,uBAAA;E9E6z/CV;E8Ep0/CM;IAOI,uBAAA;E9Eg0/CV;E8Ev0/CM;IAOI,0BAAA;IAAA,yBAAA;E9Eo0/CV;E8E30/CM;IAOI,gCAAA;IAAA,+BAAA;E9Ew0/CV;E8E/0/CM;IAOI,+BAAA;IAAA,8BAAA;E9E40/CV;E8En1/CM;IAOI,6BAAA;IAAA,4BAAA;E9Eg1/CV;E8Ev1/CM;IAOI,+BAAA;IAAA,8BAAA;E9Eo1/CV;E8E31/CM;IAOI,6BAAA;IAAA,4BAAA;E9Ew1/CV;E8E/1/CM;IAOI,6BAAA;IAAA,4BAAA;E9E41/CV;E8En2/CM;IAOI,wBAAA;IAAA,2BAAA;E9Eg2/CV;E8Ev2/CM;IAOI,8BAAA;IAAA,iCAAA;E9Eo2/CV;E8E32/CM;IAOI,6BAAA;IAAA,gCAAA;E9Ew2/CV;E8E/2/CM;IAOI,2BAAA;IAAA,8BAAA;E9E42/CV;E8En3/CM;IAOI,6BAAA;IAAA,gCAAA;E9Eg3/CV;E8Ev3/CM;IAOI,2BAAA;IAAA,8BAAA;E9Eo3/CV;E8E33/CM;IAOI,2BAAA;IAAA,8BAAA;E9Ew3/CV;E8E/3/CM;IAOI,wBAAA;E9E23/CV;E8El4/CM;IAOI,8BAAA;E9E83/CV;E8Er4/CM;IAOI,6BAAA;E9Ei4/CV;E8Ex4/CM;IAOI,2BAAA;E9Eo4/CV;E8E34/CM;IAOI,6BAAA;E9Eu4/CV;E8E94/CM;IAOI,2BAAA;E9E04/CV;E8Ej5/CM;IAOI,2BAAA;E9E64/CV;E8Ep5/CM;IAOI,0BAAA;E9Eg5/CV;E8Ev5/CM;IAOI,gCAAA;E9Em5/CV;E8E15/CM;IAOI,+BAAA;E9Es5/CV;E8E75/CM;IAOI,6BAAA;E9Ey5/CV;E8Eh6/CM;IAOI,+BAAA;E9E45/CV;E8En6/CM;IAOI,6BAAA;E9E+5/CV;E8Et6/CM;IAOI,6BAAA;E9Ek6/CV;E8Ez6/CM;IAOI,2BAAA;E9Eq6/CV;E8E56/CM;IAOI,iCAAA;E9Ew6/CV;E8E/6/CM;IAOI,gCAAA;E9E26/CV;E8El7/CM;IAOI,8BAAA;E9E86/CV;E8Er7/CM;IAOI,gCAAA;E9Ei7/CV;E8Ex7/CM;IAOI,8BAAA;E9Eo7/CV;E8E37/CM;IAOI,8BAAA;E9Eu7/CV;E8E97/CM;IAOI,yBAAA;E9E07/CV;E8Ej8/CM;IAOI,+BAAA;E9E67/CV;E8Ep8/CM;IAOI,8BAAA;E9Eg8/CV;E8Ev8/CM;IAOI,4BAAA;E9Em8/CV;E8E18/CM;IAOI,8BAAA;E9Es8/CV;E8E78/CM;IAOI,4BAAA;E9Ey8/CV;E8Eh9/CM;IAOI,4BAAA;E9E48/CV;E8En9/CM;IAOI,2BAAA;E9E+8/CV;E8Et9/CM;IAOI,0BAAA;E9Ek9/CV;E8Ez9/CM;IAOI,wBAAA;E9Eq9/CV;E8E59/CM;IAOI,0BAAA;E9Ew9/CV;E8E/9/CM;IAOI,wBAAA;E9E29/CV;E8El+/CM;IAOI,iCAAA;IAAA,gCAAA;E9E+9/CV;E8Et+/CM;IAOI,gCAAA;IAAA,+BAAA;E9Em+/CV;E8E1+/CM;IAOI,8BAAA;IAAA,6BAAA;E9Eu+/CV;E8E9+/CM;IAOI,gCAAA;IAAA,+BAAA;E9E2+/CV;E8El//CM;IAOI,8BAAA;IAAA,6BAAA;E9E++/CV;E8Et//CM;IAOI,+BAAA;IAAA,kCAAA;E9Em//CV;E8E1//CM;IAOI,8BAAA;IAAA,iCAAA;E9Eu//CV;E8E9//CM;IAOI,4BAAA;IAAA,+BAAA;E9E2//CV;E8ElggDM;IAOI,8BAAA;IAAA,iCAAA;E9E+//CV;E8EtggDM;IAOI,4BAAA;IAAA,+BAAA;E9EmggDV;E8E1ggDM;IAOI,+BAAA;E9EsggDV;E8E7ggDM;IAOI,8BAAA;E9EyggDV;E8EhhgDM;IAOI,4BAAA;E9E4ggDV;E8EnhgDM;IAOI,8BAAA;E9E+ggDV;E8EthgDM;IAOI,4BAAA;E9EkhgDV;E8EzhgDM;IAOI,iCAAA;E9EqhgDV;E8E5hgDM;IAOI,gCAAA;E9EwhgDV;E8E/hgDM;IAOI,8BAAA;E9E2hgDV;E8EligDM;IAOI,gCAAA;E9E8hgDV;E8ErigDM;IAOI,8BAAA;E9EiigDV;E8ExigDM;IAOI,kCAAA;E9EoigDV;E8E3igDM;IAOI,iCAAA;E9EuigDV;E8E9igDM;IAOI,+BAAA;E9E0igDV;E8EjjgDM;IAOI,iCAAA;E9E6igDV;E8EpjgDM;IAOI,+BAAA;E9EgjgDV;E8EvjgDM;IAOI,gCAAA;E9EmjgDV;E8E1jgDM;IAOI,+BAAA;E9EsjgDV;E8E7jgDM;IAOI,6BAAA;E9EyjgDV;E8EhkgDM;IAOI,+BAAA;E9E4jgDV;E8EnkgDM;IAOI,6BAAA;E9E+jgDV;E8EtkgDM;IAOI,qBAAA;E9EkkgDV;E8EzkgDM;IAOI,2BAAA;E9EqkgDV;E8E5kgDM;IAOI,0BAAA;E9EwkgDV;E8E/kgDM;IAOI,wBAAA;E9E2kgDV;E8EllgDM;IAOI,0BAAA;E9E8kgDV;E8ErlgDM;IAOI,wBAAA;E9EilgDV;E8ExlgDM;IAOI,2BAAA;IAAA,0BAAA;E9EqlgDV;E8E5lgDM;IAOI,iCAAA;IAAA,gCAAA;E9EylgDV;E8EhmgDM;IAOI,gCAAA;IAAA,+BAAA;E9E6lgDV;E8EpmgDM;IAOI,8BAAA;IAAA,6BAAA;E9EimgDV;E8ExmgDM;IAOI,gCAAA;IAAA,+BAAA;E9EqmgDV;E8E5mgDM;IAOI,8BAAA;IAAA,6BAAA;E9EymgDV;E8EhngDM;IAOI,yBAAA;IAAA,4BAAA;E9E6mgDV;E8EpngDM;IAOI,+BAAA;IAAA,kCAAA;E9EingDV;E8ExngDM;IAOI,8BAAA;IAAA,iCAAA;E9EqngDV;E8E5ngDM;IAOI,4BAAA;IAAA,+BAAA;E9EyngDV;E8EhogDM;IAOI,8BAAA;IAAA,iCAAA;E9E6ngDV;E8EpogDM;IAOI,4BAAA;IAAA,+BAAA;E9EiogDV;E8ExogDM;IAOI,yBAAA;E9EoogDV;E8E3ogDM;IAOI,+BAAA;E9EuogDV;E8E9ogDM;IAOI,8BAAA;E9E0ogDV;E8EjpgDM;IAOI,4BAAA;E9E6ogDV;E8EppgDM;IAOI,8BAAA;E9EgpgDV;E8EvpgDM;IAOI,4BAAA;E9EmpgDV;E8E1pgDM;IAOI,2BAAA;E9EspgDV;E8E7pgDM;IAOI,iCAAA;E9EypgDV;E8EhqgDM;IAOI,gCAAA;E9E4pgDV;E8EnqgDM;IAOI,8BAAA;E9E+pgDV;E8EtqgDM;IAOI,gCAAA;E9EkqgDV;E8EzqgDM;IAOI,8BAAA;E9EqqgDV;E8E5qgDM;IAOI,4BAAA;E9EwqgDV;E8E/qgDM;IAOI,kCAAA;E9E2qgDV;E8ElrgDM;IAOI,iCAAA;E9E8qgDV;E8ErrgDM;IAOI,+BAAA;E9EirgDV;E8ExrgDM;IAOI,iCAAA;E9EorgDV;E8E3rgDM;IAOI,+BAAA;E9EurgDV;E8E9rgDM;IAOI,0BAAA;E9E0rgDV;E8EjsgDM;IAOI,gCAAA;E9E6rgDV;E8EpsgDM;IAOI,+BAAA;E9EgsgDV;E8EvsgDM;IAOI,6BAAA;E9EmsgDV;E8E1sgDM;IAOI,+BAAA;E9EssgDV;E8E7sgDM;IAOI,6BAAA;E9EysgDV;E8EhtgDM;IAOI,iBAAA;E9E4sgDV;E8EntgDM;IAOI,uBAAA;E9E+sgDV;E8EttgDM;IAOI,sBAAA;E9EktgDV;E8EztgDM;IAOI,oBAAA;E9EqtgDV;E8E5tgDM;IAOI,sBAAA;E9EwtgDV;E8E/tgDM;IAOI,oBAAA;E9E2tgDV;E8ElugDM;IAOI,qBAAA;E9E8tgDV;E8ErugDM;IAOI,2BAAA;E9EiugDV;E8ExugDM;IAOI,0BAAA;E9EougDV;E8E3ugDM;IAOI,wBAAA;E9EuugDV;E8E9ugDM;IAOI,0BAAA;E9E0ugDV;E8EjvgDM;IAOI,wBAAA;E9E6ugDV;E8EpvgDM;IAOI,wBAAA;E9EgvgDV;E8EvvgDM;IAOI,8BAAA;E9EmvgDV;E8E1vgDM;IAOI,6BAAA;E9EsvgDV;E8E7vgDM;IAOI,2BAAA;E9EyvgDV;E8EhwgDM;IAOI,6BAAA;E9E4vgDV;E8EnwgDM;IAOI,2BAAA;E9E+vgDV;E8EtwgDM;IAOI,2BAAA;E9EkwgDV;E8EzwgDM;IAOI,4BAAA;E9EqwgDV;E8E5wgDM;IAOI,6BAAA;E9EwwgDV;AACF;AqBnxgDI;EyDGI;IAOI,sBAAA;E9E6wgDV;E8EpxgDM;IAOI,uBAAA;E9EgxgDV;E8EvxgDM;IAOI,sBAAA;E9EmxgDV;E8E1xgDM;IAOI,8BAAA;E9EsxgDV;E8E7xgDM;IAOI,4BAAA;E9EyxgDV;E8EhygDM;IAOI,2BAAA;E9E4xgDV;E8EnygDM;IAOI,iCAAA;E9E+xgDV;E8EtygDM;IAOI,2BAAA;E9EkygDV;E8EzygDM;IAOI,0BAAA;E9EqygDV;E8E5ygDM;IAOI,gCAAA;E9EwygDV;E8E/ygDM;IAOI,yBAAA;E9E2ygDV;E8ElzgDM;IAOI,wBAAA;E9E8ygDV;E8ErzgDM;IAOI,+BAAA;E9EizgDV;E8ExzgDM;IAOI,yBAAA;E9EozgDV;E8E3zgDM;IAOI,6BAAA;E9EuzgDV;E8E9zgDM;IAOI,8BAAA;E9E0zgDV;E8Ej0gDM;IAOI,wBAAA;E9E6zgDV;E8Ep0gDM;IAOI,+BAAA;E9Eg0gDV;E8Ev0gDM;IAOI,wBAAA;E9Em0gDV;E8E10gDM;IAOI,yBAAA;E9Es0gDV;E8E70gDM;IAOI,8BAAA;E9Ey0gDV;E8Eh1gDM;IAOI,iCAAA;E9E40gDV;E8En1gDM;IAOI,sCAAA;E9E+0gDV;E8Et1gDM;IAOI,yCAAA;E9Ek1gDV;E8Ez1gDM;IAOI,uBAAA;E9Eq1gDV;E8E51gDM;IAOI,uBAAA;E9Ew1gDV;E8E/1gDM;IAOI,yBAAA;E9E21gDV;E8El2gDM;IAOI,yBAAA;E9E81gDV;E8Er2gDM;IAOI,0BAAA;E9Ei2gDV;E8Ex2gDM;IAOI,4BAAA;E9Eo2gDV;E8E32gDM;IAOI,kCAAA;E9Eu2gDV;E8E92gDM;IAOI,sCAAA;E9E02gDV;E8Ej3gDM;IAOI,oCAAA;E9E62gDV;E8Ep3gDM;IAOI,kCAAA;E9Eg3gDV;E8Ev3gDM;IAOI,yCAAA;E9Em3gDV;E8E13gDM;IAOI,wCAAA;E9Es3gDV;E8E73gDM;IAOI,wCAAA;E9Ey3gDV;E8Eh4gDM;IAOI,kCAAA;E9E43gDV;E8En4gDM;IAOI,gCAAA;E9E+3gDV;E8Et4gDM;IAOI,8BAAA;E9Ek4gDV;E8Ez4gDM;IAOI,gCAAA;E9Eq4gDV;E8E54gDM;IAOI,+BAAA;E9Ew4gDV;E8E/4gDM;IAOI,oCAAA;E9E24gDV;E8El5gDM;IAOI,kCAAA;E9E84gDV;E8Er5gDM;IAOI,gCAAA;E9Ei5gDV;E8Ex5gDM;IAOI,uCAAA;E9Eo5gDV;E8E35gDM;IAOI,sCAAA;E9Eu5gDV;E8E95gDM;IAOI,iCAAA;E9E05gDV;E8Ej6gDM;IAOI,2BAAA;E9E65gDV;E8Ep6gDM;IAOI,iCAAA;E9Eg6gDV;E8Ev6gDM;IAOI,+BAAA;E9Em6gDV;E8E16gDM;IAOI,6BAAA;E9Es6gDV;E8E76gDM;IAOI,+BAAA;E9Ey6gDV;E8Eh7gDM;IAOI,8BAAA;E9E46gDV;E8En7gDM;IAOI,oBAAA;E9E+6gDV;E8Et7gDM;IAOI,mBAAA;E9Ek7gDV;E8Ez7gDM;IAOI,mBAAA;E9Eq7gDV;E8E57gDM;IAOI,mBAAA;E9Ew7gDV;E8E/7gDM;IAOI,mBAAA;E9E27gDV;E8El8gDM;IAOI,mBAAA;E9E87gDV;E8Er8gDM;IAOI,mBAAA;E9Ei8gDV;E8Ex8gDM;IAOI,mBAAA;E9Eo8gDV;E8E38gDM;IAOI,oBAAA;E9Eu8gDV;E8E98gDM;IAOI,0BAAA;E9E08gDV;E8Ej9gDM;IAOI,yBAAA;E9E68gDV;E8Ep9gDM;IAOI,uBAAA;E9Eg9gDV;E8Ev9gDM;IAOI,yBAAA;E9Em9gDV;E8E19gDM;IAOI,uBAAA;E9Es9gDV;E8E79gDM;IAOI,uBAAA;E9Ey9gDV;E8Eh+gDM;IAOI,0BAAA;IAAA,yBAAA;E9E69gDV;E8Ep+gDM;IAOI,gCAAA;IAAA,+BAAA;E9Ei+gDV;E8Ex+gDM;IAOI,+BAAA;IAAA,8BAAA;E9Eq+gDV;E8E5+gDM;IAOI,6BAAA;IAAA,4BAAA;E9Ey+gDV;E8Eh/gDM;IAOI,+BAAA;IAAA,8BAAA;E9E6+gDV;E8Ep/gDM;IAOI,6BAAA;IAAA,4BAAA;E9Ei/gDV;E8Ex/gDM;IAOI,6BAAA;IAAA,4BAAA;E9Eq/gDV;E8E5/gDM;IAOI,wBAAA;IAAA,2BAAA;E9Ey/gDV;E8EhghDM;IAOI,8BAAA;IAAA,iCAAA;E9E6/gDV;E8EpghDM;IAOI,6BAAA;IAAA,gCAAA;E9EighDV;E8ExghDM;IAOI,2BAAA;IAAA,8BAAA;E9EqghDV;E8E5ghDM;IAOI,6BAAA;IAAA,gCAAA;E9EyghDV;E8EhhhDM;IAOI,2BAAA;IAAA,8BAAA;E9E6ghDV;E8EphhDM;IAOI,2BAAA;IAAA,8BAAA;E9EihhDV;E8ExhhDM;IAOI,wBAAA;E9EohhDV;E8E3hhDM;IAOI,8BAAA;E9EuhhDV;E8E9hhDM;IAOI,6BAAA;E9E0hhDV;E8EjihDM;IAOI,2BAAA;E9E6hhDV;E8EpihDM;IAOI,6BAAA;E9EgihDV;E8EvihDM;IAOI,2BAAA;E9EmihDV;E8E1ihDM;IAOI,2BAAA;E9EsihDV;E8E7ihDM;IAOI,0BAAA;E9EyihDV;E8EhjhDM;IAOI,gCAAA;E9E4ihDV;E8EnjhDM;IAOI,+BAAA;E9E+ihDV;E8EtjhDM;IAOI,6BAAA;E9EkjhDV;E8EzjhDM;IAOI,+BAAA;E9EqjhDV;E8E5jhDM;IAOI,6BAAA;E9EwjhDV;E8E/jhDM;IAOI,6BAAA;E9E2jhDV;E8ElkhDM;IAOI,2BAAA;E9E8jhDV;E8ErkhDM;IAOI,iCAAA;E9EikhDV;E8ExkhDM;IAOI,gCAAA;E9EokhDV;E8E3khDM;IAOI,8BAAA;E9EukhDV;E8E9khDM;IAOI,gCAAA;E9E0khDV;E8EjlhDM;IAOI,8BAAA;E9E6khDV;E8EplhDM;IAOI,8BAAA;E9EglhDV;E8EvlhDM;IAOI,yBAAA;E9EmlhDV;E8E1lhDM;IAOI,+BAAA;E9EslhDV;E8E7lhDM;IAOI,8BAAA;E9EylhDV;E8EhmhDM;IAOI,4BAAA;E9E4lhDV;E8EnmhDM;IAOI,8BAAA;E9E+lhDV;E8EtmhDM;IAOI,4BAAA;E9EkmhDV;E8EzmhDM;IAOI,4BAAA;E9EqmhDV;E8E5mhDM;IAOI,2BAAA;E9EwmhDV;E8E/mhDM;IAOI,0BAAA;E9E2mhDV;E8ElnhDM;IAOI,wBAAA;E9E8mhDV;E8ErnhDM;IAOI,0BAAA;E9EinhDV;E8ExnhDM;IAOI,wBAAA;E9EonhDV;E8E3nhDM;IAOI,iCAAA;IAAA,gCAAA;E9EwnhDV;E8E/nhDM;IAOI,gCAAA;IAAA,+BAAA;E9E4nhDV;E8EnohDM;IAOI,8BAAA;IAAA,6BAAA;E9EgohDV;E8EvohDM;IAOI,gCAAA;IAAA,+BAAA;E9EoohDV;E8E3ohDM;IAOI,8BAAA;IAAA,6BAAA;E9EwohDV;E8E/ohDM;IAOI,+BAAA;IAAA,kCAAA;E9E4ohDV;E8EnphDM;IAOI,8BAAA;IAAA,iCAAA;E9EgphDV;E8EvphDM;IAOI,4BAAA;IAAA,+BAAA;E9EophDV;E8E3phDM;IAOI,8BAAA;IAAA,iCAAA;E9EwphDV;E8E/phDM;IAOI,4BAAA;IAAA,+BAAA;E9E4phDV;E8EnqhDM;IAOI,+BAAA;E9E+phDV;E8EtqhDM;IAOI,8BAAA;E9EkqhDV;E8EzqhDM;IAOI,4BAAA;E9EqqhDV;E8E5qhDM;IAOI,8BAAA;E9EwqhDV;E8E/qhDM;IAOI,4BAAA;E9E2qhDV;E8ElrhDM;IAOI,iCAAA;E9E8qhDV;E8ErrhDM;IAOI,gCAAA;E9EirhDV;E8ExrhDM;IAOI,8BAAA;E9EorhDV;E8E3rhDM;IAOI,gCAAA;E9EurhDV;E8E9rhDM;IAOI,8BAAA;E9E0rhDV;E8EjshDM;IAOI,kCAAA;E9E6rhDV;E8EpshDM;IAOI,iCAAA;E9EgshDV;E8EvshDM;IAOI,+BAAA;E9EmshDV;E8E1shDM;IAOI,iCAAA;E9EsshDV;E8E7shDM;IAOI,+BAAA;E9EyshDV;E8EhthDM;IAOI,gCAAA;E9E4shDV;E8EnthDM;IAOI,+BAAA;E9E+shDV;E8EtthDM;IAOI,6BAAA;E9EkthDV;E8EzthDM;IAOI,+BAAA;E9EqthDV;E8E5thDM;IAOI,6BAAA;E9EwthDV;E8E/thDM;IAOI,qBAAA;E9E2thDV;E8EluhDM;IAOI,2BAAA;E9E8thDV;E8EruhDM;IAOI,0BAAA;E9EiuhDV;E8ExuhDM;IAOI,wBAAA;E9EouhDV;E8E3uhDM;IAOI,0BAAA;E9EuuhDV;E8E9uhDM;IAOI,wBAAA;E9E0uhDV;E8EjvhDM;IAOI,2BAAA;IAAA,0BAAA;E9E8uhDV;E8ErvhDM;IAOI,iCAAA;IAAA,gCAAA;E9EkvhDV;E8EzvhDM;IAOI,gCAAA;IAAA,+BAAA;E9EsvhDV;E8E7vhDM;IAOI,8BAAA;IAAA,6BAAA;E9E0vhDV;E8EjwhDM;IAOI,gCAAA;IAAA,+BAAA;E9E8vhDV;E8ErwhDM;IAOI,8BAAA;IAAA,6BAAA;E9EkwhDV;E8EzwhDM;IAOI,yBAAA;IAAA,4BAAA;E9EswhDV;E8E7whDM;IAOI,+BAAA;IAAA,kCAAA;E9E0whDV;E8EjxhDM;IAOI,8BAAA;IAAA,iCAAA;E9E8whDV;E8ErxhDM;IAOI,4BAAA;IAAA,+BAAA;E9EkxhDV;E8EzxhDM;IAOI,8BAAA;IAAA,iCAAA;E9EsxhDV;E8E7xhDM;IAOI,4BAAA;IAAA,+BAAA;E9E0xhDV;E8EjyhDM;IAOI,yBAAA;E9E6xhDV;E8EpyhDM;IAOI,+BAAA;E9EgyhDV;E8EvyhDM;IAOI,8BAAA;E9EmyhDV;E8E1yhDM;IAOI,4BAAA;E9EsyhDV;E8E7yhDM;IAOI,8BAAA;E9EyyhDV;E8EhzhDM;IAOI,4BAAA;E9E4yhDV;E8EnzhDM;IAOI,2BAAA;E9E+yhDV;E8EtzhDM;IAOI,iCAAA;E9EkzhDV;E8EzzhDM;IAOI,gCAAA;E9EqzhDV;E8E5zhDM;IAOI,8BAAA;E9EwzhDV;E8E/zhDM;IAOI,gCAAA;E9E2zhDV;E8El0hDM;IAOI,8BAAA;E9E8zhDV;E8Er0hDM;IAOI,4BAAA;E9Ei0hDV;E8Ex0hDM;IAOI,kCAAA;E9Eo0hDV;E8E30hDM;IAOI,iCAAA;E9Eu0hDV;E8E90hDM;IAOI,+BAAA;E9E00hDV;E8Ej1hDM;IAOI,iCAAA;E9E60hDV;E8Ep1hDM;IAOI,+BAAA;E9Eg1hDV;E8Ev1hDM;IAOI,0BAAA;E9Em1hDV;E8E11hDM;IAOI,gCAAA;E9Es1hDV;E8E71hDM;IAOI,+BAAA;E9Ey1hDV;E8Eh2hDM;IAOI,6BAAA;E9E41hDV;E8En2hDM;IAOI,+BAAA;E9E+1hDV;E8Et2hDM;IAOI,6BAAA;E9Ek2hDV;E8Ez2hDM;IAOI,iBAAA;E9Eq2hDV;E8E52hDM;IAOI,uBAAA;E9Ew2hDV;E8E/2hDM;IAOI,sBAAA;E9E22hDV;E8El3hDM;IAOI,oBAAA;E9E82hDV;E8Er3hDM;IAOI,sBAAA;E9Ei3hDV;E8Ex3hDM;IAOI,oBAAA;E9Eo3hDV;E8E33hDM;IAOI,qBAAA;E9Eu3hDV;E8E93hDM;IAOI,2BAAA;E9E03hDV;E8Ej4hDM;IAOI,0BAAA;E9E63hDV;E8Ep4hDM;IAOI,wBAAA;E9Eg4hDV;E8Ev4hDM;IAOI,0BAAA;E9Em4hDV;E8E14hDM;IAOI,wBAAA;E9Es4hDV;E8E74hDM;IAOI,wBAAA;E9Ey4hDV;E8Eh5hDM;IAOI,8BAAA;E9E44hDV;E8En5hDM;IAOI,6BAAA;E9E+4hDV;E8Et5hDM;IAOI,2BAAA;E9Ek5hDV;E8Ez5hDM;IAOI,6BAAA;E9Eq5hDV;E8E55hDM;IAOI,2BAAA;E9Ew5hDV;E8E/5hDM;IAOI,2BAAA;E9E25hDV;E8El6hDM;IAOI,4BAAA;E9E85hDV;E8Er6hDM;IAOI,6BAAA;E9Ei6hDV;AACF;AqB56hDI;EyDGI;IAOI,sBAAA;E9Es6hDV;E8E76hDM;IAOI,uBAAA;E9Ey6hDV;E8Eh7hDM;IAOI,sBAAA;E9E46hDV;E8En7hDM;IAOI,8BAAA;E9E+6hDV;E8Et7hDM;IAOI,4BAAA;E9Ek7hDV;E8Ez7hDM;IAOI,2BAAA;E9Eq7hDV;E8E57hDM;IAOI,iCAAA;E9Ew7hDV;E8E/7hDM;IAOI,2BAAA;E9E27hDV;E8El8hDM;IAOI,0BAAA;E9E87hDV;E8Er8hDM;IAOI,gCAAA;E9Ei8hDV;E8Ex8hDM;IAOI,yBAAA;E9Eo8hDV;E8E38hDM;IAOI,wBAAA;E9Eu8hDV;E8E98hDM;IAOI,+BAAA;E9E08hDV;E8Ej9hDM;IAOI,yBAAA;E9E68hDV;E8Ep9hDM;IAOI,6BAAA;E9Eg9hDV;E8Ev9hDM;IAOI,8BAAA;E9Em9hDV;E8E19hDM;IAOI,wBAAA;E9Es9hDV;E8E79hDM;IAOI,+BAAA;E9Ey9hDV;E8Eh+hDM;IAOI,wBAAA;E9E49hDV;E8En+hDM;IAOI,yBAAA;E9E+9hDV;E8Et+hDM;IAOI,8BAAA;E9Ek+hDV;E8Ez+hDM;IAOI,iCAAA;E9Eq+hDV;E8E5+hDM;IAOI,sCAAA;E9Ew+hDV;E8E/+hDM;IAOI,yCAAA;E9E2+hDV;E8El/hDM;IAOI,uBAAA;E9E8+hDV;E8Er/hDM;IAOI,uBAAA;E9Ei/hDV;E8Ex/hDM;IAOI,yBAAA;E9Eo/hDV;E8E3/hDM;IAOI,yBAAA;E9Eu/hDV;E8E9/hDM;IAOI,0BAAA;E9E0/hDV;E8EjgiDM;IAOI,4BAAA;E9E6/hDV;E8EpgiDM;IAOI,kCAAA;E9EggiDV;E8EvgiDM;IAOI,sCAAA;E9EmgiDV;E8E1giDM;IAOI,oCAAA;E9EsgiDV;E8E7giDM;IAOI,kCAAA;E9EygiDV;E8EhhiDM;IAOI,yCAAA;E9E4giDV;E8EnhiDM;IAOI,wCAAA;E9E+giDV;E8EthiDM;IAOI,wCAAA;E9EkhiDV;E8EzhiDM;IAOI,kCAAA;E9EqhiDV;E8E5hiDM;IAOI,gCAAA;E9EwhiDV;E8E/hiDM;IAOI,8BAAA;E9E2hiDV;E8EliiDM;IAOI,gCAAA;E9E8hiDV;E8EriiDM;IAOI,+BAAA;E9EiiiDV;E8ExiiDM;IAOI,oCAAA;E9EoiiDV;E8E3iiDM;IAOI,kCAAA;E9EuiiDV;E8E9iiDM;IAOI,gCAAA;E9E0iiDV;E8EjjiDM;IAOI,uCAAA;E9E6iiDV;E8EpjiDM;IAOI,sCAAA;E9EgjiDV;E8EvjiDM;IAOI,iCAAA;E9EmjiDV;E8E1jiDM;IAOI,2BAAA;E9EsjiDV;E8E7jiDM;IAOI,iCAAA;E9EyjiDV;E8EhkiDM;IAOI,+BAAA;E9E4jiDV;E8EnkiDM;IAOI,6BAAA;E9E+jiDV;E8EtkiDM;IAOI,+BAAA;E9EkkiDV;E8EzkiDM;IAOI,8BAAA;E9EqkiDV;E8E5kiDM;IAOI,oBAAA;E9EwkiDV;E8E/kiDM;IAOI,mBAAA;E9E2kiDV;E8ElliDM;IAOI,mBAAA;E9E8kiDV;E8ErliDM;IAOI,mBAAA;E9EiliDV;E8ExliDM;IAOI,mBAAA;E9EoliDV;E8E3liDM;IAOI,mBAAA;E9EuliDV;E8E9liDM;IAOI,mBAAA;E9E0liDV;E8EjmiDM;IAOI,mBAAA;E9E6liDV;E8EpmiDM;IAOI,oBAAA;E9EgmiDV;E8EvmiDM;IAOI,0BAAA;E9EmmiDV;E8E1miDM;IAOI,yBAAA;E9EsmiDV;E8E7miDM;IAOI,uBAAA;E9EymiDV;E8EhniDM;IAOI,yBAAA;E9E4miDV;E8EnniDM;IAOI,uBAAA;E9E+miDV;E8EtniDM;IAOI,uBAAA;E9EkniDV;E8EzniDM;IAOI,0BAAA;IAAA,yBAAA;E9EsniDV;E8E7niDM;IAOI,gCAAA;IAAA,+BAAA;E9E0niDV;E8EjoiDM;IAOI,+BAAA;IAAA,8BAAA;E9E8niDV;E8EroiDM;IAOI,6BAAA;IAAA,4BAAA;E9EkoiDV;E8EzoiDM;IAOI,+BAAA;IAAA,8BAAA;E9EsoiDV;E8E7oiDM;IAOI,6BAAA;IAAA,4BAAA;E9E0oiDV;E8EjpiDM;IAOI,6BAAA;IAAA,4BAAA;E9E8oiDV;E8ErpiDM;IAOI,wBAAA;IAAA,2BAAA;E9EkpiDV;E8EzpiDM;IAOI,8BAAA;IAAA,iCAAA;E9EspiDV;E8E7piDM;IAOI,6BAAA;IAAA,gCAAA;E9E0piDV;E8EjqiDM;IAOI,2BAAA;IAAA,8BAAA;E9E8piDV;E8ErqiDM;IAOI,6BAAA;IAAA,gCAAA;E9EkqiDV;E8EzqiDM;IAOI,2BAAA;IAAA,8BAAA;E9EsqiDV;E8E7qiDM;IAOI,2BAAA;IAAA,8BAAA;E9E0qiDV;E8EjriDM;IAOI,wBAAA;E9E6qiDV;E8EpriDM;IAOI,8BAAA;E9EgriDV;E8EvriDM;IAOI,6BAAA;E9EmriDV;E8E1riDM;IAOI,2BAAA;E9EsriDV;E8E7riDM;IAOI,6BAAA;E9EyriDV;E8EhsiDM;IAOI,2BAAA;E9E4riDV;E8EnsiDM;IAOI,2BAAA;E9E+riDV;E8EtsiDM;IAOI,0BAAA;E9EksiDV;E8EzsiDM;IAOI,gCAAA;E9EqsiDV;E8E5siDM;IAOI,+BAAA;E9EwsiDV;E8E/siDM;IAOI,6BAAA;E9E2siDV;E8EltiDM;IAOI,+BAAA;E9E8siDV;E8ErtiDM;IAOI,6BAAA;E9EitiDV;E8ExtiDM;IAOI,6BAAA;E9EotiDV;E8E3tiDM;IAOI,2BAAA;E9EutiDV;E8E9tiDM;IAOI,iCAAA;E9E0tiDV;E8EjuiDM;IAOI,gCAAA;E9E6tiDV;E8EpuiDM;IAOI,8BAAA;E9EguiDV;E8EvuiDM;IAOI,gCAAA;E9EmuiDV;E8E1uiDM;IAOI,8BAAA;E9EsuiDV;E8E7uiDM;IAOI,8BAAA;E9EyuiDV;E8EhviDM;IAOI,yBAAA;E9E4uiDV;E8EnviDM;IAOI,+BAAA;E9E+uiDV;E8EtviDM;IAOI,8BAAA;E9EkviDV;E8EzviDM;IAOI,4BAAA;E9EqviDV;E8E5viDM;IAOI,8BAAA;E9EwviDV;E8E/viDM;IAOI,4BAAA;E9E2viDV;E8ElwiDM;IAOI,4BAAA;E9E8viDV;E8ErwiDM;IAOI,2BAAA;E9EiwiDV;E8ExwiDM;IAOI,0BAAA;E9EowiDV;E8E3wiDM;IAOI,wBAAA;E9EuwiDV;E8E9wiDM;IAOI,0BAAA;E9E0wiDV;E8EjxiDM;IAOI,wBAAA;E9E6wiDV;E8EpxiDM;IAOI,iCAAA;IAAA,gCAAA;E9EixiDV;E8ExxiDM;IAOI,gCAAA;IAAA,+BAAA;E9EqxiDV;E8E5xiDM;IAOI,8BAAA;IAAA,6BAAA;E9EyxiDV;E8EhyiDM;IAOI,gCAAA;IAAA,+BAAA;E9E6xiDV;E8EpyiDM;IAOI,8BAAA;IAAA,6BAAA;E9EiyiDV;E8ExyiDM;IAOI,+BAAA;IAAA,kCAAA;E9EqyiDV;E8E5yiDM;IAOI,8BAAA;IAAA,iCAAA;E9EyyiDV;E8EhziDM;IAOI,4BAAA;IAAA,+BAAA;E9E6yiDV;E8EpziDM;IAOI,8BAAA;IAAA,iCAAA;E9EiziDV;E8ExziDM;IAOI,4BAAA;IAAA,+BAAA;E9EqziDV;E8E5ziDM;IAOI,+BAAA;E9EwziDV;E8E/ziDM;IAOI,8BAAA;E9E2ziDV;E8El0iDM;IAOI,4BAAA;E9E8ziDV;E8Er0iDM;IAOI,8BAAA;E9Ei0iDV;E8Ex0iDM;IAOI,4BAAA;E9Eo0iDV;E8E30iDM;IAOI,iCAAA;E9Eu0iDV;E8E90iDM;IAOI,gCAAA;E9E00iDV;E8Ej1iDM;IAOI,8BAAA;E9E60iDV;E8Ep1iDM;IAOI,gCAAA;E9Eg1iDV;E8Ev1iDM;IAOI,8BAAA;E9Em1iDV;E8E11iDM;IAOI,kCAAA;E9Es1iDV;E8E71iDM;IAOI,iCAAA;E9Ey1iDV;E8Eh2iDM;IAOI,+BAAA;E9E41iDV;E8En2iDM;IAOI,iCAAA;E9E+1iDV;E8Et2iDM;IAOI,+BAAA;E9Ek2iDV;E8Ez2iDM;IAOI,gCAAA;E9Eq2iDV;E8E52iDM;IAOI,+BAAA;E9Ew2iDV;E8E/2iDM;IAOI,6BAAA;E9E22iDV;E8El3iDM;IAOI,+BAAA;E9E82iDV;E8Er3iDM;IAOI,6BAAA;E9Ei3iDV;E8Ex3iDM;IAOI,qBAAA;E9Eo3iDV;E8E33iDM;IAOI,2BAAA;E9Eu3iDV;E8E93iDM;IAOI,0BAAA;E9E03iDV;E8Ej4iDM;IAOI,wBAAA;E9E63iDV;E8Ep4iDM;IAOI,0BAAA;E9Eg4iDV;E8Ev4iDM;IAOI,wBAAA;E9Em4iDV;E8E14iDM;IAOI,2BAAA;IAAA,0BAAA;E9Eu4iDV;E8E94iDM;IAOI,iCAAA;IAAA,gCAAA;E9E24iDV;E8El5iDM;IAOI,gCAAA;IAAA,+BAAA;E9E+4iDV;E8Et5iDM;IAOI,8BAAA;IAAA,6BAAA;E9Em5iDV;E8E15iDM;IAOI,gCAAA;IAAA,+BAAA;E9Eu5iDV;E8E95iDM;IAOI,8BAAA;IAAA,6BAAA;E9E25iDV;E8El6iDM;IAOI,yBAAA;IAAA,4BAAA;E9E+5iDV;E8Et6iDM;IAOI,+BAAA;IAAA,kCAAA;E9Em6iDV;E8E16iDM;IAOI,8BAAA;IAAA,iCAAA;E9Eu6iDV;E8E96iDM;IAOI,4BAAA;IAAA,+BAAA;E9E26iDV;E8El7iDM;IAOI,8BAAA;IAAA,iCAAA;E9E+6iDV;E8Et7iDM;IAOI,4BAAA;IAAA,+BAAA;E9Em7iDV;E8E17iDM;IAOI,yBAAA;E9Es7iDV;E8E77iDM;IAOI,+BAAA;E9Ey7iDV;E8Eh8iDM;IAOI,8BAAA;E9E47iDV;E8En8iDM;IAOI,4BAAA;E9E+7iDV;E8Et8iDM;IAOI,8BAAA;E9Ek8iDV;E8Ez8iDM;IAOI,4BAAA;E9Eq8iDV;E8E58iDM;IAOI,2BAAA;E9Ew8iDV;E8E/8iDM;IAOI,iCAAA;E9E28iDV;E8El9iDM;IAOI,gCAAA;E9E88iDV;E8Er9iDM;IAOI,8BAAA;E9Ei9iDV;E8Ex9iDM;IAOI,gCAAA;E9Eo9iDV;E8E39iDM;IAOI,8BAAA;E9Eu9iDV;E8E99iDM;IAOI,4BAAA;E9E09iDV;E8Ej+iDM;IAOI,kCAAA;E9E69iDV;E8Ep+iDM;IAOI,iCAAA;E9Eg+iDV;E8Ev+iDM;IAOI,+BAAA;E9Em+iDV;E8E1+iDM;IAOI,iCAAA;E9Es+iDV;E8E7+iDM;IAOI,+BAAA;E9Ey+iDV;E8Eh/iDM;IAOI,0BAAA;E9E4+iDV;E8En/iDM;IAOI,gCAAA;E9E++iDV;E8Et/iDM;IAOI,+BAAA;E9Ek/iDV;E8Ez/iDM;IAOI,6BAAA;E9Eq/iDV;E8E5/iDM;IAOI,+BAAA;E9Ew/iDV;E8E//iDM;IAOI,6BAAA;E9E2/iDV;E8ElgjDM;IAOI,iBAAA;E9E8/iDV;E8ErgjDM;IAOI,uBAAA;E9EigjDV;E8ExgjDM;IAOI,sBAAA;E9EogjDV;E8E3gjDM;IAOI,oBAAA;E9EugjDV;E8E9gjDM;IAOI,sBAAA;E9E0gjDV;E8EjhjDM;IAOI,oBAAA;E9E6gjDV;E8EphjDM;IAOI,qBAAA;E9EghjDV;E8EvhjDM;IAOI,2BAAA;E9EmhjDV;E8E1hjDM;IAOI,0BAAA;E9EshjDV;E8E7hjDM;IAOI,wBAAA;E9EyhjDV;E8EhijDM;IAOI,0BAAA;E9E4hjDV;E8EnijDM;IAOI,wBAAA;E9E+hjDV;E8EtijDM;IAOI,wBAAA;E9EkijDV;E8EzijDM;IAOI,8BAAA;E9EqijDV;E8E5ijDM;IAOI,6BAAA;E9EwijDV;E8E/ijDM;IAOI,2BAAA;E9E2ijDV;E8EljjDM;IAOI,6BAAA;E9E8ijDV;E8ErjjDM;IAOI,2BAAA;E9EijjDV;E8ExjjDM;IAOI,2BAAA;E9EojjDV;E8E3jjDM;IAOI,4BAAA;E9EujjDV;E8E9jjDM;IAOI,6BAAA;E9E0jjDV;AACF;AqBrkjDI;EyDGI;IAOI,sBAAA;E9E+jjDV;E8EtkjDM;IAOI,uBAAA;E9EkkjDV;E8EzkjDM;IAOI,sBAAA;E9EqkjDV;E8E5kjDM;IAOI,8BAAA;E9EwkjDV;E8E/kjDM;IAOI,4BAAA;E9E2kjDV;E8ElljDM;IAOI,2BAAA;E9E8kjDV;E8ErljDM;IAOI,iCAAA;E9EiljDV;E8ExljDM;IAOI,2BAAA;E9EoljDV;E8E3ljDM;IAOI,0BAAA;E9EuljDV;E8E9ljDM;IAOI,gCAAA;E9E0ljDV;E8EjmjDM;IAOI,yBAAA;E9E6ljDV;E8EpmjDM;IAOI,wBAAA;E9EgmjDV;E8EvmjDM;IAOI,+BAAA;E9EmmjDV;E8E1mjDM;IAOI,yBAAA;E9EsmjDV;E8E7mjDM;IAOI,6BAAA;E9EymjDV;E8EhnjDM;IAOI,8BAAA;E9E4mjDV;E8EnnjDM;IAOI,wBAAA;E9E+mjDV;E8EtnjDM;IAOI,+BAAA;E9EknjDV;E8EznjDM;IAOI,wBAAA;E9EqnjDV;E8E5njDM;IAOI,yBAAA;E9EwnjDV;E8E/njDM;IAOI,8BAAA;E9E2njDV;E8ElojDM;IAOI,iCAAA;E9E8njDV;E8ErojDM;IAOI,sCAAA;E9EiojDV;E8ExojDM;IAOI,yCAAA;E9EoojDV;E8E3ojDM;IAOI,uBAAA;E9EuojDV;E8E9ojDM;IAOI,uBAAA;E9E0ojDV;E8EjpjDM;IAOI,yBAAA;E9E6ojDV;E8EppjDM;IAOI,yBAAA;E9EgpjDV;E8EvpjDM;IAOI,0BAAA;E9EmpjDV;E8E1pjDM;IAOI,4BAAA;E9EspjDV;E8E7pjDM;IAOI,kCAAA;E9EypjDV;E8EhqjDM;IAOI,sCAAA;E9E4pjDV;E8EnqjDM;IAOI,oCAAA;E9E+pjDV;E8EtqjDM;IAOI,kCAAA;E9EkqjDV;E8EzqjDM;IAOI,yCAAA;E9EqqjDV;E8E5qjDM;IAOI,wCAAA;E9EwqjDV;E8E/qjDM;IAOI,wCAAA;E9E2qjDV;E8ElrjDM;IAOI,kCAAA;E9E8qjDV;E8ErrjDM;IAOI,gCAAA;E9EirjDV;E8ExrjDM;IAOI,8BAAA;E9EorjDV;E8E3rjDM;IAOI,gCAAA;E9EurjDV;E8E9rjDM;IAOI,+BAAA;E9E0rjDV;E8EjsjDM;IAOI,oCAAA;E9E6rjDV;E8EpsjDM;IAOI,kCAAA;E9EgsjDV;E8EvsjDM;IAOI,gCAAA;E9EmsjDV;E8E1sjDM;IAOI,uCAAA;E9EssjDV;E8E7sjDM;IAOI,sCAAA;E9EysjDV;E8EhtjDM;IAOI,iCAAA;E9E4sjDV;E8EntjDM;IAOI,2BAAA;E9E+sjDV;E8EttjDM;IAOI,iCAAA;E9EktjDV;E8EztjDM;IAOI,+BAAA;E9EqtjDV;E8E5tjDM;IAOI,6BAAA;E9EwtjDV;E8E/tjDM;IAOI,+BAAA;E9E2tjDV;E8ElujDM;IAOI,8BAAA;E9E8tjDV;E8ErujDM;IAOI,oBAAA;E9EiujDV;E8ExujDM;IAOI,mBAAA;E9EoujDV;E8E3ujDM;IAOI,mBAAA;E9EuujDV;E8E9ujDM;IAOI,mBAAA;E9E0ujDV;E8EjvjDM;IAOI,mBAAA;E9E6ujDV;E8EpvjDM;IAOI,mBAAA;E9EgvjDV;E8EvvjDM;IAOI,mBAAA;E9EmvjDV;E8E1vjDM;IAOI,mBAAA;E9EsvjDV;E8E7vjDM;IAOI,oBAAA;E9EyvjDV;E8EhwjDM;IAOI,0BAAA;E9E4vjDV;E8EnwjDM;IAOI,yBAAA;E9E+vjDV;E8EtwjDM;IAOI,uBAAA;E9EkwjDV;E8EzwjDM;IAOI,yBAAA;E9EqwjDV;E8E5wjDM;IAOI,uBAAA;E9EwwjDV;E8E/wjDM;IAOI,uBAAA;E9E2wjDV;E8ElxjDM;IAOI,0BAAA;IAAA,yBAAA;E9E+wjDV;E8EtxjDM;IAOI,gCAAA;IAAA,+BAAA;E9EmxjDV;E8E1xjDM;IAOI,+BAAA;IAAA,8BAAA;E9EuxjDV;E8E9xjDM;IAOI,6BAAA;IAAA,4BAAA;E9E2xjDV;E8ElyjDM;IAOI,+BAAA;IAAA,8BAAA;E9E+xjDV;E8EtyjDM;IAOI,6BAAA;IAAA,4BAAA;E9EmyjDV;E8E1yjDM;IAOI,6BAAA;IAAA,4BAAA;E9EuyjDV;E8E9yjDM;IAOI,wBAAA;IAAA,2BAAA;E9E2yjDV;E8ElzjDM;IAOI,8BAAA;IAAA,iCAAA;E9E+yjDV;E8EtzjDM;IAOI,6BAAA;IAAA,gCAAA;E9EmzjDV;E8E1zjDM;IAOI,2BAAA;IAAA,8BAAA;E9EuzjDV;E8E9zjDM;IAOI,6BAAA;IAAA,gCAAA;E9E2zjDV;E8El0jDM;IAOI,2BAAA;IAAA,8BAAA;E9E+zjDV;E8Et0jDM;IAOI,2BAAA;IAAA,8BAAA;E9Em0jDV;E8E10jDM;IAOI,wBAAA;E9Es0jDV;E8E70jDM;IAOI,8BAAA;E9Ey0jDV;E8Eh1jDM;IAOI,6BAAA;E9E40jDV;E8En1jDM;IAOI,2BAAA;E9E+0jDV;E8Et1jDM;IAOI,6BAAA;E9Ek1jDV;E8Ez1jDM;IAOI,2BAAA;E9Eq1jDV;E8E51jDM;IAOI,2BAAA;E9Ew1jDV;E8E/1jDM;IAOI,0BAAA;E9E21jDV;E8El2jDM;IAOI,gCAAA;E9E81jDV;E8Er2jDM;IAOI,+BAAA;E9Ei2jDV;E8Ex2jDM;IAOI,6BAAA;E9Eo2jDV;E8E32jDM;IAOI,+BAAA;E9Eu2jDV;E8E92jDM;IAOI,6BAAA;E9E02jDV;E8Ej3jDM;IAOI,6BAAA;E9E62jDV;E8Ep3jDM;IAOI,2BAAA;E9Eg3jDV;E8Ev3jDM;IAOI,iCAAA;E9Em3jDV;E8E13jDM;IAOI,gCAAA;E9Es3jDV;E8E73jDM;IAOI,8BAAA;E9Ey3jDV;E8Eh4jDM;IAOI,gCAAA;E9E43jDV;E8En4jDM;IAOI,8BAAA;E9E+3jDV;E8Et4jDM;IAOI,8BAAA;E9Ek4jDV;E8Ez4jDM;IAOI,yBAAA;E9Eq4jDV;E8E54jDM;IAOI,+BAAA;E9Ew4jDV;E8E/4jDM;IAOI,8BAAA;E9E24jDV;E8El5jDM;IAOI,4BAAA;E9E84jDV;E8Er5jDM;IAOI,8BAAA;E9Ei5jDV;E8Ex5jDM;IAOI,4BAAA;E9Eo5jDV;E8E35jDM;IAOI,4BAAA;E9Eu5jDV;E8E95jDM;IAOI,2BAAA;E9E05jDV;E8Ej6jDM;IAOI,0BAAA;E9E65jDV;E8Ep6jDM;IAOI,wBAAA;E9Eg6jDV;E8Ev6jDM;IAOI,0BAAA;E9Em6jDV;E8E16jDM;IAOI,wBAAA;E9Es6jDV;E8E76jDM;IAOI,iCAAA;IAAA,gCAAA;E9E06jDV;E8Ej7jDM;IAOI,gCAAA;IAAA,+BAAA;E9E86jDV;E8Er7jDM;IAOI,8BAAA;IAAA,6BAAA;E9Ek7jDV;E8Ez7jDM;IAOI,gCAAA;IAAA,+BAAA;E9Es7jDV;E8E77jDM;IAOI,8BAAA;IAAA,6BAAA;E9E07jDV;E8Ej8jDM;IAOI,+BAAA;IAAA,kCAAA;E9E87jDV;E8Er8jDM;IAOI,8BAAA;IAAA,iCAAA;E9Ek8jDV;E8Ez8jDM;IAOI,4BAAA;IAAA,+BAAA;E9Es8jDV;E8E78jDM;IAOI,8BAAA;IAAA,iCAAA;E9E08jDV;E8Ej9jDM;IAOI,4BAAA;IAAA,+BAAA;E9E88jDV;E8Er9jDM;IAOI,+BAAA;E9Ei9jDV;E8Ex9jDM;IAOI,8BAAA;E9Eo9jDV;E8E39jDM;IAOI,4BAAA;E9Eu9jDV;E8E99jDM;IAOI,8BAAA;E9E09jDV;E8Ej+jDM;IAOI,4BAAA;E9E69jDV;E8Ep+jDM;IAOI,iCAAA;E9Eg+jDV;E8Ev+jDM;IAOI,gCAAA;E9Em+jDV;E8E1+jDM;IAOI,8BAAA;E9Es+jDV;E8E7+jDM;IAOI,gCAAA;E9Ey+jDV;E8Eh/jDM;IAOI,8BAAA;E9E4+jDV;E8En/jDM;IAOI,kCAAA;E9E++jDV;E8Et/jDM;IAOI,iCAAA;E9Ek/jDV;E8Ez/jDM;IAOI,+BAAA;E9Eq/jDV;E8E5/jDM;IAOI,iCAAA;E9Ew/jDV;E8E//jDM;IAOI,+BAAA;E9E2/jDV;E8ElgkDM;IAOI,gCAAA;E9E8/jDV;E8ErgkDM;IAOI,+BAAA;E9EigkDV;E8ExgkDM;IAOI,6BAAA;E9EogkDV;E8E3gkDM;IAOI,+BAAA;E9EugkDV;E8E9gkDM;IAOI,6BAAA;E9E0gkDV;E8EjhkDM;IAOI,qBAAA;E9E6gkDV;E8EphkDM;IAOI,2BAAA;E9EghkDV;E8EvhkDM;IAOI,0BAAA;E9EmhkDV;E8E1hkDM;IAOI,wBAAA;E9EshkDV;E8E7hkDM;IAOI,0BAAA;E9EyhkDV;E8EhikDM;IAOI,wBAAA;E9E4hkDV;E8EnikDM;IAOI,2BAAA;IAAA,0BAAA;E9EgikDV;E8EvikDM;IAOI,iCAAA;IAAA,gCAAA;E9EoikDV;E8E3ikDM;IAOI,gCAAA;IAAA,+BAAA;E9EwikDV;E8E/ikDM;IAOI,8BAAA;IAAA,6BAAA;E9E4ikDV;E8EnjkDM;IAOI,gCAAA;IAAA,+BAAA;E9EgjkDV;E8EvjkDM;IAOI,8BAAA;IAAA,6BAAA;E9EojkDV;E8E3jkDM;IAOI,yBAAA;IAAA,4BAAA;E9EwjkDV;E8E/jkDM;IAOI,+BAAA;IAAA,kCAAA;E9E4jkDV;E8EnkkDM;IAOI,8BAAA;IAAA,iCAAA;E9EgkkDV;E8EvkkDM;IAOI,4BAAA;IAAA,+BAAA;E9EokkDV;E8E3kkDM;IAOI,8BAAA;IAAA,iCAAA;E9EwkkDV;E8E/kkDM;IAOI,4BAAA;IAAA,+BAAA;E9E4kkDV;E8EnlkDM;IAOI,yBAAA;E9E+kkDV;E8EtlkDM;IAOI,+BAAA;E9EklkDV;E8EzlkDM;IAOI,8BAAA;E9EqlkDV;E8E5lkDM;IAOI,4BAAA;E9EwlkDV;E8E/lkDM;IAOI,8BAAA;E9E2lkDV;E8ElmkDM;IAOI,4BAAA;E9E8lkDV;E8ErmkDM;IAOI,2BAAA;E9EimkDV;E8ExmkDM;IAOI,iCAAA;E9EomkDV;E8E3mkDM;IAOI,gCAAA;E9EumkDV;E8E9mkDM;IAOI,8BAAA;E9E0mkDV;E8EjnkDM;IAOI,gCAAA;E9E6mkDV;E8EpnkDM;IAOI,8BAAA;E9EgnkDV;E8EvnkDM;IAOI,4BAAA;E9EmnkDV;E8E1nkDM;IAOI,kCAAA;E9EsnkDV;E8E7nkDM;IAOI,iCAAA;E9EynkDV;E8EhokDM;IAOI,+BAAA;E9E4nkDV;E8EnokDM;IAOI,iCAAA;E9E+nkDV;E8EtokDM;IAOI,+BAAA;E9EkokDV;E8EzokDM;IAOI,0BAAA;E9EqokDV;E8E5okDM;IAOI,gCAAA;E9EwokDV;E8E/okDM;IAOI,+BAAA;E9E2okDV;E8ElpkDM;IAOI,6BAAA;E9E8okDV;E8ErpkDM;IAOI,+BAAA;E9EipkDV;E8ExpkDM;IAOI,6BAAA;E9EopkDV;E8E3pkDM;IAOI,iBAAA;E9EupkDV;E8E9pkDM;IAOI,uBAAA;E9E0pkDV;E8EjqkDM;IAOI,sBAAA;E9E6pkDV;E8EpqkDM;IAOI,oBAAA;E9EgqkDV;E8EvqkDM;IAOI,sBAAA;E9EmqkDV;E8E1qkDM;IAOI,oBAAA;E9EsqkDV;E8E7qkDM;IAOI,qBAAA;E9EyqkDV;E8EhrkDM;IAOI,2BAAA;E9E4qkDV;E8EnrkDM;IAOI,0BAAA;E9E+qkDV;E8EtrkDM;IAOI,wBAAA;E9EkrkDV;E8EzrkDM;IAOI,0BAAA;E9EqrkDV;E8E5rkDM;IAOI,wBAAA;E9EwrkDV;E8E/rkDM;IAOI,wBAAA;E9E2rkDV;E8ElskDM;IAOI,8BAAA;E9E8rkDV;E8ErskDM;IAOI,6BAAA;E9EiskDV;E8ExskDM;IAOI,2BAAA;E9EoskDV;E8E3skDM;IAOI,6BAAA;E9EuskDV;E8E9skDM;IAOI,2BAAA;E9E0skDV;E8EjtkDM;IAOI,2BAAA;E9E6skDV;E8EptkDM;IAOI,4BAAA;E9EgtkDV;E8EvtkDM;IAOI,6BAAA;E9EmtkDV;AACF;AqB9tkDI;EyDGI;IAOI,sBAAA;E9EwtkDV;E8E/tkDM;IAOI,uBAAA;E9E2tkDV;E8ElukDM;IAOI,sBAAA;E9E8tkDV;E8ErukDM;IAOI,8BAAA;E9EiukDV;E8ExukDM;IAOI,4BAAA;E9EoukDV;E8E3ukDM;IAOI,2BAAA;E9EuukDV;E8E9ukDM;IAOI,iCAAA;E9E0ukDV;E8EjvkDM;IAOI,2BAAA;E9E6ukDV;E8EpvkDM;IAOI,0BAAA;E9EgvkDV;E8EvvkDM;IAOI,gCAAA;E9EmvkDV;E8E1vkDM;IAOI,yBAAA;E9EsvkDV;E8E7vkDM;IAOI,wBAAA;E9EyvkDV;E8EhwkDM;IAOI,+BAAA;E9E4vkDV;E8EnwkDM;IAOI,yBAAA;E9E+vkDV;E8EtwkDM;IAOI,6BAAA;E9EkwkDV;E8EzwkDM;IAOI,8BAAA;E9EqwkDV;E8E5wkDM;IAOI,wBAAA;E9EwwkDV;E8E/wkDM;IAOI,+BAAA;E9E2wkDV;E8ElxkDM;IAOI,wBAAA;E9E8wkDV;E8ErxkDM;IAOI,yBAAA;E9EixkDV;E8ExxkDM;IAOI,8BAAA;E9EoxkDV;E8E3xkDM;IAOI,iCAAA;E9EuxkDV;E8E9xkDM;IAOI,sCAAA;E9E0xkDV;E8EjykDM;IAOI,yCAAA;E9E6xkDV;E8EpykDM;IAOI,uBAAA;E9EgykDV;E8EvykDM;IAOI,uBAAA;E9EmykDV;E8E1ykDM;IAOI,yBAAA;E9EsykDV;E8E7ykDM;IAOI,yBAAA;E9EyykDV;E8EhzkDM;IAOI,0BAAA;E9E4ykDV;E8EnzkDM;IAOI,4BAAA;E9E+ykDV;E8EtzkDM;IAOI,kCAAA;E9EkzkDV;E8EzzkDM;IAOI,sCAAA;E9EqzkDV;E8E5zkDM;IAOI,oCAAA;E9EwzkDV;E8E/zkDM;IAOI,kCAAA;E9E2zkDV;E8El0kDM;IAOI,yCAAA;E9E8zkDV;E8Er0kDM;IAOI,wCAAA;E9Ei0kDV;E8Ex0kDM;IAOI,wCAAA;E9Eo0kDV;E8E30kDM;IAOI,kCAAA;E9Eu0kDV;E8E90kDM;IAOI,gCAAA;E9E00kDV;E8Ej1kDM;IAOI,8BAAA;E9E60kDV;E8Ep1kDM;IAOI,gCAAA;E9Eg1kDV;E8Ev1kDM;IAOI,+BAAA;E9Em1kDV;E8E11kDM;IAOI,oCAAA;E9Es1kDV;E8E71kDM;IAOI,kCAAA;E9Ey1kDV;E8Eh2kDM;IAOI,gCAAA;E9E41kDV;E8En2kDM;IAOI,uCAAA;E9E+1kDV;E8Et2kDM;IAOI,sCAAA;E9Ek2kDV;E8Ez2kDM;IAOI,iCAAA;E9Eq2kDV;E8E52kDM;IAOI,2BAAA;E9Ew2kDV;E8E/2kDM;IAOI,iCAAA;E9E22kDV;E8El3kDM;IAOI,+BAAA;E9E82kDV;E8Er3kDM;IAOI,6BAAA;E9Ei3kDV;E8Ex3kDM;IAOI,+BAAA;E9Eo3kDV;E8E33kDM;IAOI,8BAAA;E9Eu3kDV;E8E93kDM;IAOI,oBAAA;E9E03kDV;E8Ej4kDM;IAOI,mBAAA;E9E63kDV;E8Ep4kDM;IAOI,mBAAA;E9Eg4kDV;E8Ev4kDM;IAOI,mBAAA;E9Em4kDV;E8E14kDM;IAOI,mBAAA;E9Es4kDV;E8E74kDM;IAOI,mBAAA;E9Ey4kDV;E8Eh5kDM;IAOI,mBAAA;E9E44kDV;E8En5kDM;IAOI,mBAAA;E9E+4kDV;E8Et5kDM;IAOI,oBAAA;E9Ek5kDV;E8Ez5kDM;IAOI,0BAAA;E9Eq5kDV;E8E55kDM;IAOI,yBAAA;E9Ew5kDV;E8E/5kDM;IAOI,uBAAA;E9E25kDV;E8El6kDM;IAOI,yBAAA;E9E85kDV;E8Er6kDM;IAOI,uBAAA;E9Ei6kDV;E8Ex6kDM;IAOI,uBAAA;E9Eo6kDV;E8E36kDM;IAOI,0BAAA;IAAA,yBAAA;E9Ew6kDV;E8E/6kDM;IAOI,gCAAA;IAAA,+BAAA;E9E46kDV;E8En7kDM;IAOI,+BAAA;IAAA,8BAAA;E9Eg7kDV;E8Ev7kDM;IAOI,6BAAA;IAAA,4BAAA;E9Eo7kDV;E8E37kDM;IAOI,+BAAA;IAAA,8BAAA;E9Ew7kDV;E8E/7kDM;IAOI,6BAAA;IAAA,4BAAA;E9E47kDV;E8En8kDM;IAOI,6BAAA;IAAA,4BAAA;E9Eg8kDV;E8Ev8kDM;IAOI,wBAAA;IAAA,2BAAA;E9Eo8kDV;E8E38kDM;IAOI,8BAAA;IAAA,iCAAA;E9Ew8kDV;E8E/8kDM;IAOI,6BAAA;IAAA,gCAAA;E9E48kDV;E8En9kDM;IAOI,2BAAA;IAAA,8BAAA;E9Eg9kDV;E8Ev9kDM;IAOI,6BAAA;IAAA,gCAAA;E9Eo9kDV;E8E39kDM;IAOI,2BAAA;IAAA,8BAAA;E9Ew9kDV;E8E/9kDM;IAOI,2BAAA;IAAA,8BAAA;E9E49kDV;E8En+kDM;IAOI,wBAAA;E9E+9kDV;E8Et+kDM;IAOI,8BAAA;E9Ek+kDV;E8Ez+kDM;IAOI,6BAAA;E9Eq+kDV;E8E5+kDM;IAOI,2BAAA;E9Ew+kDV;E8E/+kDM;IAOI,6BAAA;E9E2+kDV;E8El/kDM;IAOI,2BAAA;E9E8+kDV;E8Er/kDM;IAOI,2BAAA;E9Ei/kDV;E8Ex/kDM;IAOI,0BAAA;E9Eo/kDV;E8E3/kDM;IAOI,gCAAA;E9Eu/kDV;E8E9/kDM;IAOI,+BAAA;E9E0/kDV;E8EjglDM;IAOI,6BAAA;E9E6/kDV;E8EpglDM;IAOI,+BAAA;E9EgglDV;E8EvglDM;IAOI,6BAAA;E9EmglDV;E8E1glDM;IAOI,6BAAA;E9EsglDV;E8E7glDM;IAOI,2BAAA;E9EyglDV;E8EhhlDM;IAOI,iCAAA;E9E4glDV;E8EnhlDM;IAOI,gCAAA;E9E+glDV;E8EthlDM;IAOI,8BAAA;E9EkhlDV;E8EzhlDM;IAOI,gCAAA;E9EqhlDV;E8E5hlDM;IAOI,8BAAA;E9EwhlDV;E8E/hlDM;IAOI,8BAAA;E9E2hlDV;E8ElilDM;IAOI,yBAAA;E9E8hlDV;E8ErilDM;IAOI,+BAAA;E9EiilDV;E8ExilDM;IAOI,8BAAA;E9EoilDV;E8E3ilDM;IAOI,4BAAA;E9EuilDV;E8E9ilDM;IAOI,8BAAA;E9E0ilDV;E8EjjlDM;IAOI,4BAAA;E9E6ilDV;E8EpjlDM;IAOI,4BAAA;E9EgjlDV;E8EvjlDM;IAOI,2BAAA;E9EmjlDV;E8E1jlDM;IAOI,0BAAA;E9EsjlDV;E8E7jlDM;IAOI,wBAAA;E9EyjlDV;E8EhklDM;IAOI,0BAAA;E9E4jlDV;E8EnklDM;IAOI,wBAAA;E9E+jlDV;E8EtklDM;IAOI,iCAAA;IAAA,gCAAA;E9EmklDV;E8E1klDM;IAOI,gCAAA;IAAA,+BAAA;E9EuklDV;E8E9klDM;IAOI,8BAAA;IAAA,6BAAA;E9E2klDV;E8ElllDM;IAOI,gCAAA;IAAA,+BAAA;E9E+klDV;E8EtllDM;IAOI,8BAAA;IAAA,6BAAA;E9EmllDV;E8E1llDM;IAOI,+BAAA;IAAA,kCAAA;E9EullDV;E8E9llDM;IAOI,8BAAA;IAAA,iCAAA;E9E2llDV;E8ElmlDM;IAOI,4BAAA;IAAA,+BAAA;E9E+llDV;E8EtmlDM;IAOI,8BAAA;IAAA,iCAAA;E9EmmlDV;E8E1mlDM;IAOI,4BAAA;IAAA,+BAAA;E9EumlDV;E8E9mlDM;IAOI,+BAAA;E9E0mlDV;E8EjnlDM;IAOI,8BAAA;E9E6mlDV;E8EpnlDM;IAOI,4BAAA;E9EgnlDV;E8EvnlDM;IAOI,8BAAA;E9EmnlDV;E8E1nlDM;IAOI,4BAAA;E9EsnlDV;E8E7nlDM;IAOI,iCAAA;E9EynlDV;E8EholDM;IAOI,gCAAA;E9E4nlDV;E8EnolDM;IAOI,8BAAA;E9E+nlDV;E8EtolDM;IAOI,gCAAA;E9EkolDV;E8EzolDM;IAOI,8BAAA;E9EqolDV;E8E5olDM;IAOI,kCAAA;E9EwolDV;E8E/olDM;IAOI,iCAAA;E9E2olDV;E8ElplDM;IAOI,+BAAA;E9E8olDV;E8ErplDM;IAOI,iCAAA;E9EiplDV;E8ExplDM;IAOI,+BAAA;E9EoplDV;E8E3plDM;IAOI,gCAAA;E9EuplDV;E8E9plDM;IAOI,+BAAA;E9E0plDV;E8EjqlDM;IAOI,6BAAA;E9E6plDV;E8EpqlDM;IAOI,+BAAA;E9EgqlDV;E8EvqlDM;IAOI,6BAAA;E9EmqlDV;E8E1qlDM;IAOI,qBAAA;E9EsqlDV;E8E7qlDM;IAOI,2BAAA;E9EyqlDV;E8EhrlDM;IAOI,0BAAA;E9E4qlDV;E8EnrlDM;IAOI,wBAAA;E9E+qlDV;E8EtrlDM;IAOI,0BAAA;E9EkrlDV;E8EzrlDM;IAOI,wBAAA;E9EqrlDV;E8E5rlDM;IAOI,2BAAA;IAAA,0BAAA;E9EyrlDV;E8EhslDM;IAOI,iCAAA;IAAA,gCAAA;E9E6rlDV;E8EpslDM;IAOI,gCAAA;IAAA,+BAAA;E9EislDV;E8ExslDM;IAOI,8BAAA;IAAA,6BAAA;E9EqslDV;E8E5slDM;IAOI,gCAAA;IAAA,+BAAA;E9EyslDV;E8EhtlDM;IAOI,8BAAA;IAAA,6BAAA;E9E6slDV;E8EptlDM;IAOI,yBAAA;IAAA,4BAAA;E9EitlDV;E8ExtlDM;IAOI,+BAAA;IAAA,kCAAA;E9EqtlDV;E8E5tlDM;IAOI,8BAAA;IAAA,iCAAA;E9EytlDV;E8EhulDM;IAOI,4BAAA;IAAA,+BAAA;E9E6tlDV;E8EpulDM;IAOI,8BAAA;IAAA,iCAAA;E9EiulDV;E8ExulDM;IAOI,4BAAA;IAAA,+BAAA;E9EqulDV;E8E5ulDM;IAOI,yBAAA;E9EwulDV;E8E/ulDM;IAOI,+BAAA;E9E2ulDV;E8ElvlDM;IAOI,8BAAA;E9E8ulDV;E8ErvlDM;IAOI,4BAAA;E9EivlDV;E8ExvlDM;IAOI,8BAAA;E9EovlDV;E8E3vlDM;IAOI,4BAAA;E9EuvlDV;E8E9vlDM;IAOI,2BAAA;E9E0vlDV;E8EjwlDM;IAOI,iCAAA;E9E6vlDV;E8EpwlDM;IAOI,gCAAA;E9EgwlDV;E8EvwlDM;IAOI,8BAAA;E9EmwlDV;E8E1wlDM;IAOI,gCAAA;E9EswlDV;E8E7wlDM;IAOI,8BAAA;E9EywlDV;E8EhxlDM;IAOI,4BAAA;E9E4wlDV;E8EnxlDM;IAOI,kCAAA;E9E+wlDV;E8EtxlDM;IAOI,iCAAA;E9EkxlDV;E8EzxlDM;IAOI,+BAAA;E9EqxlDV;E8E5xlDM;IAOI,iCAAA;E9EwxlDV;E8E/xlDM;IAOI,+BAAA;E9E2xlDV;E8ElylDM;IAOI,0BAAA;E9E8xlDV;E8ErylDM;IAOI,gCAAA;E9EiylDV;E8ExylDM;IAOI,+BAAA;E9EoylDV;E8E3ylDM;IAOI,6BAAA;E9EuylDV;E8E9ylDM;IAOI,+BAAA;E9E0ylDV;E8EjzlDM;IAOI,6BAAA;E9E6ylDV;E8EpzlDM;IAOI,iBAAA;E9EgzlDV;E8EvzlDM;IAOI,uBAAA;E9EmzlDV;E8E1zlDM;IAOI,sBAAA;E9EszlDV;E8E7zlDM;IAOI,oBAAA;E9EyzlDV;E8Eh0lDM;IAOI,sBAAA;E9E4zlDV;E8En0lDM;IAOI,oBAAA;E9E+zlDV;E8Et0lDM;IAOI,qBAAA;E9Ek0lDV;E8Ez0lDM;IAOI,2BAAA;E9Eq0lDV;E8E50lDM;IAOI,0BAAA;E9Ew0lDV;E8E/0lDM;IAOI,wBAAA;E9E20lDV;E8El1lDM;IAOI,0BAAA;E9E80lDV;E8Er1lDM;IAOI,wBAAA;E9Ei1lDV;E8Ex1lDM;IAOI,wBAAA;E9Eo1lDV;E8E31lDM;IAOI,8BAAA;E9Eu1lDV;E8E91lDM;IAOI,6BAAA;E9E01lDV;E8Ej2lDM;IAOI,2BAAA;E9E61lDV;E8Ep2lDM;IAOI,6BAAA;E9Eg2lDV;E8Ev2lDM;IAOI,2BAAA;E9Em2lDV;E8E12lDM;IAOI,2BAAA;E9Es2lDV;E8E72lDM;IAOI,4BAAA;E9Ey2lDV;E8Eh3lDM;IAOI,6BAAA;E9E42lDV;AACF;A+En6lDA;ED+CQ;IAOI,6BAAA;E9Ei3lDV;E8Ex3lDM;IAOI,4BAAA;E9Eo3lDV;E8E33lDM;IAOI,8BAAA;E9Eu3lDV;E8E93lDM;IAOI,6BAAA;E9E03lDV;AACF;A+E95lDA;ED4BQ;IAOI,0BAAA;E9E+3lDV;E8Et4lDM;IAOI,gCAAA;E9Ek4lDV;E8Ez4lDM;IAOI,yBAAA;E9Eq4lDV;E8E54lDM;IAOI,wBAAA;E9Ew4lDV;E8E/4lDM;IAOI,+BAAA;E9E24lDV;E8El5lDM;IAOI,yBAAA;E9E84lDV;E8Er5lDM;IAOI,6BAAA;E9Ei5lDV;E8Ex5lDM;IAOI,8BAAA;E9Eo5lDV;E8E35lDM;IAOI,wBAAA;E9Eu5lDV;E8E95lDM;IAOI,+BAAA;E9E05lDV;E8Ej6lDM;IAOI,wBAAA;E9E65lDV;AACF;AgF98lDA;;EAEE,uBAAA;EACA,mDAAA;EACA,qDAAA;EACA,wBAAA;EAEA,0BAAA;EAEA,+BAAA;EAEA,wBAAA;EACA,uBAAA;EAMA,4BAAA;EAEA,6BAAA;EACA,oCAAA;EAGA,gCAAA;EAGA,oBAAA;EACA,yEAAA;EACA,gDAAA;EAGA,qCAAA;EACA,4BAAA;EAEA,+BAAA;EAEA,2BAAA;EAmBA,wBAAA;EACA,qCAAA;EACA,yCAAA;EACA,0CAAA;EACA,2CAAA;EACA,4CAAA;EACA,yBAAA;EACA,kCAAA;EACA,4BAAA;AhF66lDF;AgF/9lDE;;EACE,8BAAA;AhFk+lDJ;AgF18lDE;;EACE,uBAAA;EACA,+BAAA;EACA,oCAAA;AhF68lDJ;AgF18lDE;;EACE,+BAAA;EACA,iDAAA;EACA,oCAAA;AhF68lDJ;AgF18lDE;;EACE,8BAAA;AhF68lDJ;AgF/7lDE;;EACE,wBAAA;EACA,qCAAA;EACA,yCAAA;EACA,0CAAA;EACA,2CAAA;EACA,4CAAA;AhFk8lDJ;AgF/7lDE;;EACE,6BAAA;EACA,0CAAA;EACA,8CAAA;EACA,+CAAA;EACA,gDAAA;EACA,iDAAA;EACA,8BAAA;AhFk8lDJ;;AgF3hmDI;EAiGA,qBAAA;EACA,4BAAA;EAEA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,yBAAA;EAGA,uBAAA;EACA,4BAAA;EACA,+BAAA;EACA,gCAAA;EA4BA,uBAAA;EAEA,qDAAA;EAEA,uBAAA;EAEA,2BAAA;EAEA,wBAAA;EACA,qCAAA;EACA,yCAAA;EACA,0CAAA;EACA,2CAAA;EACA,4CAAA;AhF45lDJ;AgFn8lDI;EACE,uBAAA;EACA,oCAAA;EACA,+CAAA;EACA,4CAAA;EACA,+BAAA;EACA,2CAAA;EACA,8BAAA;EACA,0CAAA;EACA,6BAAA;AhFq8lDN;AgFl8lDI;EACE,+BAAA;EACA,gCAAA;AhFo8lDN;AgFj8lDI;EACE,8BAAA;AhFm8lDN;AgFh8lDI;EACE,8BAAA;AhFk8lDN;AgF/6lDI;EACE,8BAAA;EACA,0CAAA;EACA,8CAAA;EACA,+CAAA;EACA,gDAAA;EACA,iDAAA;EACA,8BAAA;AhFi7lDN;;AiFlmmDA;;eAAA;AAIA;EACE,kBAAA;EACA,gBAAA;AjFommDF;;AiFjmmDA;;;;;;;;;;;;EAYE,gCrEkEsB;AZkimDxB;;AiFjmmDA;EACE,gCAAA;AjFommDF;;AiFjmmDA;EACE,gBAAA;EACA,qBAAA;AjFommDF;;AiF/lmDA;EACE,kBAAA;EACA,6CAAA;AjFkmmDF;;AiF/lmDA;EACE,cAAA;EACA,8CAAA;EACA,iBAAA;AjFkmmDF;;AiF5lmDE;EACE,kBAAA;AjF+lmDJ;;AiF3lmDA;EACE,gCAAA;AjF8lmDF;;AkF9omDI;EACI,oDAAA;AlFipmDR;;AkFlpmDI;EACI,oDAAA;AlFqpmDR;;AkFtpmDI;EACI,qDAAA;AlFypmDR;;AkF1pmDI;EACI,qDAAA;AlF6pmDR;;AkF9pmDI;EACI,qDAAA;AlFiqmDR;;AkFlqmDI;EACI,oDAAA;AlFqqmDR;;AkFtqmDI;EACI,sDAAA;AlFyqmDR;;AkF1qmDI;EACI,mDAAA;AlF6qmDR;;AmF9qmDI;EAEE,WvEwFE;AZwlmDR;;AmFxpmDM;EAEE,0DAAA;AnF0pmDR;;AmFnpmDE;EACE,cvE+DO;AZulmDX;AmFnpmDM;EAEE,cvE0DG;AZ0lmDX;;AmF9omDE;EAtCA,uBvEgYa;EuE/Xb,yCAAA;AnFwrmDF;AmFrrmDI;EAEE,uBvE0XS;EuEzXT,qBAAA;EACA,wCAAA;AnFsrmDN;;AmF7qmDM;EAEE,0DAAA;AnF+qmDR;;AmFxqmDE;EACE,cvE+DO;AZ4mmDX;AmFxqmDM;EAEE,cvE0DG;AZ+mmDX;;AmFnqmDE;EAtCA,cvEgYa;EuE/Xb,yCAAA;AnF6smDF;AmF1smDI;EAEE,cvE0XS;EuEzXT,qBAAA;EACA,wCAAA;AnF2smDN;;AmFlsmDM;EAEE,6EAAA;AnFosmDR;;AmF7rmDE;EACE,cvE+DO;AZiomDX;AmF7rmDM;EAEE,cvE0DG;AZoomDX;;AmFxrmDE;EAtCA,cvEgYa;EuE/Xb,0CAAA;AnFkumDF;AmF/tmDI;EAEE,cvE0XS;EuEzXT,qBAAA;EACA,yCAAA;AnFgumDN;;AmFvtmDM;EAEE,2DAAA;AnFytmDR;;AmFltmDE;EACE,cvE+DO;AZspmDX;AmFltmDM;EAEE,cvE0DG;AZypmDX;;AmF7smDE;EAtCA,cvEgYa;EuE/Xb,0CAAA;AnFuvmDF;AmFpvmDI;EAEE,cvE0XS;EuEzXT,qBAAA;EACA,yCAAA;AnFqvmDN;;AmF5umDM;EAEE,+EAAA;AnF8umDR;;AmFvumDE;EACE,cvE+DO;AZ2qmDX;AmFvumDM;EAEE,cvE0DG;AZ8qmDX;;AmFlumDE;EAtCA,cvEgYa;EuE/Xb,0CAAA;AnF4wmDF;AmFzwmDI;EAEE,cvE0XS;EuEzXT,qBAAA;EACA,yCAAA;AnF0wmDN;;AmFjwmDM;EAEE,0DAAA;AnFmwmDR;;AmF5vmDE;EACE,cvE+DO;AZgsmDX;AmF5vmDM;EAEE,cvE0DG;AZmsmDX;;AmFvvmDE;EAtCA,cvEgYa;EuE/Xb,yCAAA;AnFiymDF;AmF9xmDI;EAEE,cvE0XS;EuEzXT,qBAAA;EACA,wCAAA;AnF+xmDN;;AmFtxmDM;EAEE,qDAAA;AnFwxmDR;;AmFjxmDE;EACE,cvE+DO;AZqtmDX;AmFjxmDM;EAEE,cvE0DG;AZwtmDX;;AmF5wmDE;EAtCA,cvEgYa;EuE/Xb,2CAAA;AnFszmDF;AmFnzmDI;EAEE,cvE0XS;EuEzXT,qBAAA;EACA,0CAAA;AnFozmDN;;AmF3ymDM;EAEE,oEAAA;AnF6ymDR;;AmFtymDE;EACE,cvE+DO;AZ0umDX;AmFtymDM;EAEE,cvE0DG;AZ6umDX;;AmFjymDE;EAtCA,cvEgYa;EuE/Xb,wCAAA;AnF20mDF;AmFx0mDI;EAEE,cvE0XS;EuEzXT,qBAAA;EACA,uCAAA;AnFy0mDN;;AmFrymDA;EACG,oBAAA;EACC,mBAAA;AnFwymDJ;;AmFnymDA;EACE,cvE8BS;AZwwmDX;;AoFt2mDA;;EAEE,wBAAA;ApFy2mDF;;AoFr2mDE;EAKE,oCAAA;ApFo2mDJ;;AoFh2mDA;EACE,wCAAA;ApFm2mDF;AoFj2mDE;EAGE,yBxE0EO;EwEzEP,wCAAA;ApFi2mDJ;;AoF51mDE;EACE,mDAAA;ApF+1mDJ;;AoF11mDA;EACE,mBAAA;ApF61mDF;;AoF11mDA;;EAEE,cxEwDS;AZqymDX;;AoF11mDA;EACE,cxE2DS;AZkymDX;;AoFx1mDE;EACE,sBAAA;EACA,iCAAA;EACA,6BAAA;ApF21mDJ;AoFz1mDI;EACE,sBAAA;EACA,iDAAA;EACA,6CAAA;ApF21mDN;AoFv1mDE;;;;;;EAME,sBAAA;EACA,iDAAA;ApFy1mDJ;AoFr1mDE;;;;;;;;;;;;;;;EAeE,sBAAA;EACA,iDAAA;ApFu1mDJ;AoFj1mDE;EACE,WxEDI;EwEEJ,gCAAA;EACA,4BAAA;ApFm1mDJ;AoFj1mDI;EACE,gDAAA;EACA,4CAAA;ApFm1mDN;AoF/0mDE;;;;;;EAME,WxEjBI;EwEkBJ,gDAAA;EACA,4CAAA;ApFi1mDJ;AoF90mDE;;;;;;;;;;;;;;;EAeE,sBAAA;EACA,gDAAA;EACA,4CAAA;ApFg1mDJ;AoF30mDE;EACE,sBAAA;EACA,6BAAA;ApF60mDJ;AoF30mDI;EACE,WxEjDE;EwEkDF,iDAAA;EACA,6CAAA;ApF60mDN;AoFz0mDE;EACE,sBAAA;EACA,4BAAA;ApF20mDJ;AoFz0mDI;EACE,sBAAA;EACA,gDAAA;EACA,4CAAA;ApF20mDN;AoFr0mDE;EACE,sBAAA;EACA,gDAAA;ApFu0mDJ;AoFr0mDI;EACE,sBAAA;EACA,iCAAA;ApFu0mDN;AoFn0mDE;EACE,sBAAA;EACA,+CAAA;ApFq0mDJ;AoFn0mDI;EACE,sBAAA;EACA,gCAAA;ApFq0mDN;;AqFl/mDI;EACI,2BAAA;ArFq/mDR;AqFl/mDQ;EACI,oCAAA;ArFo/mDZ;;AqF3+mDQ;EACI,qBzE0rDgB;AZozjD5B;AqF5+mDY;EACA,oCAAA;EACA,eAAA;EACI,iBAAA;ArF8+mDhB;;AsFtgnDA;EACI,qB1EwlBgB;E0EvlBhB,yC1E+nBS;AZ04lDb;;AsFtgnDA;EACI,eAAA;EACA,cAAA;EACA,cAAA;AtFygnDJ;;AsFtgnDA;EACI,eAAA;EACA,iBAAA;EACA,gB1EkrBiB;AZu1lDrB;;AsFtgnDA;EACI,c1EiFO;E0EhFP,mBAAA;AtFygnDJ;;AuF5hnDA;EACE,yC3EioBc;E2EhoBd,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;AvF+hnDF;AuF7hnDE;EACE,oBAAA;AvF+hnDJ;;AuF3hnDA;EACE,qBAAA;EACA,mBAAA;AvF8hnDF;;AuF3hnDA;EACE,oBAAA;EACA,0BAAA;AvF8hnDF;;AuF3hnDA;EACE;IACI,wBAAA;EvF8hnDJ;EuF5hnDA;IACI,2BAAA;EvF8hnDJ;AACF;AuF3hnDA;EACE;IACE,YAAA;EvF6hnDF;EuF1hnDA;IACE,YAAA;EvF4hnDF;AACF;AuFzhnDA;EACE,wCAAA;AvF2hnDF;;AuFthnDA;EACE,2BAAA;AvFyhnDF;;AuFthnDA;EACE,aAAA;EACA,qBAAA;EACA,sBAAA;AvFyhnDF;;AuFphnDA;EACE,YAAA;AvFuhnDF;;AuFphnDA;EACE,YAAA;AvFuhnDF;;AwFvlnDM;EACI,2BAAA;EACA,gB5E4rBW;AZ85lDrB;;AwFplnDE;EACI,2BAAA;EACA,gB5EorBe;AZm6lDrB;;AwFllnDA;EACE,+CAAA;AxFqlnDF;AwFnlnDE;EACE,kBAAA;EACA,c5EgFO;AZqgnDX;AwFplnDI;EACE,YAAA;AxFslnDN;AwFplnDM;EACE,WAAA;EACA,4B5EqWE;E4EpWF,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;AxFslnDR;AwFnlnDM;EACE,uB5E0VE;AZ2vmDV;AwFplnDQ;EACE,mBAAA;AxFslnDV;;AwFzknDM;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;AxF4knDV;AwF3knDU;EACI,eAAA;AxF6knDd;;AyFlmnDE;EACI,2BAAA;EACA,oC7E+xBe;E6E9xBf,kDAAA;AzFqmnDN;;AyFhmnDA;EACE,2DAAA;AzFmmnDF;;AyF/lnDA;EACE,gD7E4BwB;AZsknD1B;;AyF9lnDE;;EAEI,mBAAA;AzFimnDN;;AyF5lnDE;EACE,wBAAA;AzF+lnDJ;AyF5lnDE;EACE,WAAA;AzF8lnDJ;AyF3lnDE;EACE,WAAA;AzF6lnDJ;AyF1lnDE;EACE,uCAAA;EACA,mBAAA;EACA,sBAAA;AzF4lnDJ;AyFzlnDE;EACE,mBAAA;EACA,sB7EUI;AZilnDR;;A0F5qnDI;EACI,8BAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;A1F+qnDR;;A2FrrnDA;EACE,WAAA;A3FwrnDF;;A2FnrnDA;EACE,WAAA;A3FsrnDF;;A2FjrnDA;EACE,YAAA;A3FornDF;;A2FhrnDA;EACE,YAAA;A3FmrnDF;;A2FhrnDA;EACE,kBAAA;A3FmrnDF;A2FlrnDE;EACE,kBAAA;EACA,kBAAA;EACA,8BAAA;A3FornDJ;;A2FhrnDA;EACE;IACI,QAAA;E3FmrnDJ;AACF;A4FltnDA;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sHAAA;A5FotnDJ;A4FhtnDA;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sHAAA;A5FktnDJ;A4F9snDA;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sHAAA;A5FgtnDJ;A4F5snDA;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sHAAA;A5F8snDJ;A6FjvnDA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;EACA,qCAAA;EACA,yCjF0nBW;AZynmDb;;A6FhvnDA;EACE,aAAA;EAEA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,YjFgBc;EiFfd,+BAAA;A7FmvnDF;A6FhvnDI;EACE,wCAAA;A7FkvnDN;;A6F7unDA;EACE,UAAA;EACA,YjFqCuB;AZ2snDzB;;A6F5unDE;EACE,aAAA;A7F+unDJ;;A6F3unDA;EACE,aAAA;A7F8unDF;;A6F3unDA,WAAA;AAEA;EACE,yBAAA;A7F6unDF;A6F3unDE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CjFPe;EiFQf,gBAAA;EACA,mBAAA;A7F6unDJ;A6F3unDE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,MAAA;EACA,cjFqCO;AZwsnDX;;A6FtunDE;EACE,kBAAA;EACA,gBAAA;A7FyunDJ;A6FxunDI;EACE,2BjFyvCW;AZi/kDjB;;A6FrunDA;EACE;IACE,WAAA;E7FwunDF;E6FpunDE;IACE,aAAA;E7FsunDJ;AACF;A6F9tnDA;EACE,qCAAA;A7FgunDF;;A6F7tnDA;EACE,WjFnEc;EiFoEd,YjFpEc;EiFqEd,2BAAA;EACA,kCAAA;EACA,SAAA;EACA,kBAAA;A7FgunDF;A6F9tnDE;EACE,kCAAA;A7FgunDJ;;A6F5tnDA;EACE,YAAA;EACA,WAAA;EACA,wCAAA;EACA,YAAA;A7F+tnDF;;A6F1tnDI;EACE,qBAAA;A7F6tnDN;;A6FvtnDE;EACE,eAAA;EACA,kCAAA;A7F0tnDJ;A6FvtnDE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;EACA,yBjFVE;EiFWF,kBAAA;EACA,SAAA;EACA,WAAA;A7FytnDJ;;A6FptnDE;EACE,qBAAA;A7FutnDJ;A6FrtnDI;EACE,uCAAA;A7FutnDN;;A6FjtnDA;EAEE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;EACA,cjFhES;AZoxnDX;A6FltnDE;EACE,YAAA;A7FotnDJ;A6FjtnDE;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A7FmtnDJ;A6FhtnDE;EACE,oCAAA;A7FktnDJ;;A6F3snDI;EACE,gBAAA;A7F8snDN;;A6FxsnDE;EACE,0CAAA;A7F2snDJ;A6FvsnDM;EACE,2CAAA;A7FysnDR;A6FrsnDI;EACE,oCAAA;A7FusnDN;A6FnsnDE;EACE,uCAAA;A7FqsnDJ;A6FnsnDI;EACE,uCAAA;A7FqsnDN;A6FjsnDE;EACE,2CAAA;A7FmsnDJ;A6F/rnDI;EACE,uCAAA;A7FisnDN;A6F7rnDE;EACE,aAAA;A7F+rnDJ;A6F5rnDE;EACE,cAAA;A7F8rnDJ;A6F1rnDI;EACE,4CAAA;EACA,WjF9IE;AZ00nDR;A6F1rnDI;;EAEE,+BAAA;A7F4rnDN;;A6FtrnDE;EACE,qCAAA;A7FyrnDJ;A6FtrnDE;EACE,aAAA;A7FwrnDJ;A6FrrnDE;EACE,cAAA;A7FurnDJ;;A6FnrnDA;EAEI;IACE,gBAAA;E7FqrnDJ;E6FnrnDI;IACE,qBAAA;IACA,sBAAA;E7FqrnDN;AACF;A6FhrnDA;EACE;IACE,aAAA;E7FkrnDF;AACF;A6F9qnDE;EACE,WAAA;A7FgrnDJ;A6F9qnDE;EACE,gBjF1PY;EiF2PZ,mEAAA;A7FgrnDJ;;A6F3qnDA;EAEI;IACE,gBAAA;E7F6qnDJ;AACF;A6FxqnDE;EACE,6CAAA;A7F0qnDJ;A6FtqnDM;EACE,2CAAA;A7FwqnDR;A6FpqnDI;EACE,oCAAA;A7FsqnDN;A6FlqnDE;EACE,uCAAA;A7FoqnDJ;A6FlqnDI;EACE,uCAAA;A7FoqnDN;A6FhqnDE;EACE,2CAAA;A7FkqnDJ;A6F9pnDI;EACE,uCAAA;A7FgqnDN;A6F5pnDE;EACE,aAAA;A7F8pnDJ;A6F3pnDE;EACE,cAAA;A7F6pnDJ;A6FzpnDI;EACE,4CAAA;EACA,WjFxPE;AZm5nDR;A6FzpnDI;;EAEE,+BAAA;A7F2pnDN;;A8Fp/nDA;EACI,sBlFwlBgB;AZ+5mDpB;A8Fr/nDI;EACI,6BAAA;EACA,UAAA;A9Fu/nDR;A8Fp/nDI;EACI,eAAA;EACA,yBAAA;EACA,gBAAA;A9Fs/nDR;;A+FjgoDA;EACI,SAAA;EACA,8BAAA;EACA,kBAAA;EACA,QAAA;EACA,cnF4CW;EmF3CX,WnFKY;EmFJZ,YnFwCY;EmFvCZ,yCnFynBS;EmFxnBT,qCnFuCQ;AZ69nDZ;;A+FjgoDA;EACI;IACI,OAAA;E/FogoDN;AACF;A+F//nDI;EACI,UnFTkB;AZ0goD1B;;A+F5/nDI;EACI,kBAAA;A/F+/nDR;;AgG1hoDA;EACI,wCpF07CM;EoFz7CN,yEAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,YpFoDa;EoFnDb,aAAA;EACA,uBAAA;EACA,aAAA;EACA,MAAA;EACA,SAAA;AhG6hoDJ;AgG3hoDI;EACI,0DAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cpF6EG;EoF5EH,kBAAA;EACA,kBAAA;AhG6hoDR;AgG3hoDQ;EACI,yDAAA;AhG6hoDZ;;AgGvhoDA;EACI,wCAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;AhG0hoDJ;;AgGthoDI;EACI,QAAA;AhGyhoDR;AgGvhoDI;EACI,cAAA;AhGyhoDR;;AqB//nDI;E2ErBA;IACI,cAAA;EhGwhoDN;EgGvhoDM;IACI,uBAAA;EhGyhoDV;AACF;AiGhloDA;EACI,SAAA;AjGkloDJ;AiGhloDI;EACI,cAAA;EACA,WAAA;AjGkloDR;AiG/koDI;EACI,aAAA;AjGiloDR;AiG/koDQ;EACI,aAAA;AjGiloDZ;AiG9koDQ;EACI,cAAA;AjGgloDZ;AiG5koDI;EACI,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,gCAAA;EACA,0BAAA;EACA,uCAAA;AjG8koDR;;AiGzkoDA;EACI,YrFrBY;EqFsBZ,aAAA;EACA,gCAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,SrFNY;EqFOZ,yCrF0lBS;AZk/mDb;;AiGzkoDA;EACI,kBrFhCY;EqFiCZ,gBAAA;AjG4koDJ;AiG1koDI;EACI,yBAAA;EACA,gBrFhBQ;AZ4loDhB;;AiGvkoDA;EACI,sBAAA;AjG0koDJ;AiGtkoDY;EACI,0BAAA;AjGwkoDhB;AiGlkoDQ;EACI,iBAAA;EACA,oCAAA;EACA,cAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;AjGokoDZ;AiG9joDY;EACI,cAAA;EACA,wBAAA;EACA,wCAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gCrFDQ;EqFER,gBAAA;AjGgkoDhB;AiG9joDgB;EACI,qBAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,6CAAA;EACA,oBAAA;EACA,aAAA;AjGgkoDpB;AiG7joDgB;EACI,8CAAA;AjG+joDpB;AiG7joDoB;EACI,8CAAA;AjG+joDxB;AiG1joDY;EACI,eAAA;AjG4joDhB;AiGzjoDY;EACI,UAAA;AjG2joDhB;AiGvjoDoB;EACI,oCAAA;EACA,eAAA;EACA,4CAAA;AjGyjoDxB;AiGtjoDoB;EACI,UAAA;AjGwjoDxB;AiGrjoD4B;EACI,oCAAA;EACA,iBAAA;AjGujoDhC;;AiG5ioDA;EACI,6BAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,6CAAA;EACA,gBrF6iBmB;EqF5iBnB,gCrFlEoB;EqFmEpB,YAAA;AjG+ioDJ;;AiG3ioDA;EACI,0DAAA;AjG8ioDJ;AiG7ioDI;EACI,0DAAA;AjG+ioDR;AiG9ioDQ;EACI,0DAAA;AjGgjoDZ;AiG7ioDI;EACI,0DAAA;AjG+ioDR;AiG7ioDI;EACI,0DAAA;AjG+ioDR;AiG7ioDQ;EACI,0DAAA;AjG+ioDZ;;AiG1ioDA;EACI;IACI,aAAA;EjG6ioDN;EiG1ioDE;IACI,yBAAA;EjG4ioDN;EiGxioDM;IACI,cAAA;EjG0ioDV;AACF;AiGnioDI;EACI,iBrFtLkB;AZ2toD1B;AiGlioDI;EACI,sBAAA;AjGoioDR;AiGhioDQ;EACI,aAAA;AjGkioDZ;AiG/hoDQ;EACI,cAAA;AjGiioDZ;AiG5hoDI;EACI,kBAAA;EACA,sBAAA;EACA,UAAA;AjG8hoDR;AiG5hoDQ;;EAEI,4BAAA;AjG8hoDZ;AiG3hoDQ;EACI,wBAAA;AjG6hoDZ;AiG1hoDQ;EACI,oBAAA;AjG4hoDZ;AiGthoDY;;;EAGI,wBAAA;AjGwhoDhB;AiGrhoDY;EACI,0BAAA;AjGuhoDhB;AiGnhoDgB;EACI,aAAA;AjGqhoDpB;AiGhhoDgB;EACI,kBAAA;EACA,mBAAA;AjGkhoDpB;AiGhhoDoB;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;AjGkhoDxB;AiGhhoDwB;EAGI,8CAAA;AjGghoD5B;AiG7goDwB;EACI,eAAA;EACA,gBAAA;AjG+goD5B;AiG5goDwB;EACI,aAAA;EACA,kBAAA;AjG8goD5B;AiGzgoDwB;EACI,kBAAA;EACA,yBAAA;EACA,uBrFyGlB;EqFvGkB,gBAAA;AjG0goD5B;AiGxgoD4B;EACI,uBrFoGtB;AZs6nDV;AiGvgoD4B;EACI,eAAA;AjGygoDhC;AiGrgoDwB;EACI,cAAA;EACA,UrF3RF;EqF4RE,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,mDAAA;AjGugoD5B;AiGrgoD4B;EACI,mDAAA;AjGugoDhC;AiGpgoD4B;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,4CAAA;AjGsgoDhC;AiGpgoDgC;EACI,8CAAA;AjGsgoDpC;AiG//nDgB;EACI,cAAA;EACA,aAAA;EACA,aAAA;EACA,sCAAA;AjGigoDpB;AiG7/nD4B;EACI,cAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AjG+/nDhC;AiG1/nD4B;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;AjG4/nDhC;AiGt/nDwB;EACI,crFjQjB;AZyvoDX;;AiG1+nDI;EACI,qCAAA;AjG6+nDR;AiGt+nDgB;EACI,6CAAA;AjGw+nDpB;AiGt+nDoB;EACI,6CAAA;AjGw+nDxB;AiGr+nDoB;EACI,mDAAA;AjGu+nDxB;AiGr+nDwB;EACI,mDAAA;AjGu+nD5B;AiG/9nDwB;EACI,iDAAA;AjGi+nD5B;AiG/9nD4B;EACI,mDAAA;AjGi+nDhC;AiGx9nDI;EACI,kBAAA;AjG09nDR;AiG98nD4B;EACI,2CAAA;EACA,mDAAA;AjGg9nDhC;AiG/8nDgC;EACI,mDAAA;AjGi9nDpC;AiG58nDgC;EACI,iDAAA;AjG88nDpC;AiG78nDoC;EACI,8CAAA;AjG+8nDxC;AiGx8nDoB;EACI,wCAAA;AjG08nDxB;AiGj8nD4B;EACI,+DAAA;AjGm8nDhC;AiG37nD+B;EACK,0DAAA;AjG67nDpC;AiGx7nDgC;EACI,0DAAA;AjG07nDpC;AiG16nDI;EACI,+DAAA;AjG46nDR;AiG36nDQ;EACI,+DAAA;AjG66nDZ;AiG56nDY;EACI,+DAAA;AjG86nDhB;AiG36nDQ;EACI,+DAAA;AjG66nDZ;AiG36nDQ;EACI,+DAAA;AjG66nDZ;AiG36nDY;EACI,+DAAA;AjG66nDhB;AiGx6nDI;EACI,6CAAA;AjG06nDR;;AiGp6nDI;EACI,yBAAA;AjGu6nDR;;AiGh6nDI;EACI,YrFtfW;AZy5oDnB;AiGj6nDQ;EAHJ;IAIQ,WAAA;EjGo6nDV;AACF;AiGl6nDI;EACI,YrF7fW;EqF8fX,kBAAA;AjGo6nDR;AiGl6nDQ;;EAEI,wBAAA;AjGo6nDZ;AiGj6nDI;EACI,kBrFtgBW;AZy6oDnB;AiGj6nDI;EACI,WrFzgBW;AZ46oDnB;AiGl6nDQ;EAFJ;IAGQ,OAAA;EjGq6nDV;AACF;AiG55nDgB;EACI,cAAA;AjG85nDpB;AiGz5nDoB;EACI,oBAAA;AjG25nDxB;AiGt5nD4B;EACI,oBAAA;AjGw5nDhC;AiG/4nDQ;EACI,iBrF7iBc;AZ87oD1B;AiG94nDY;EACI,gBAAA;AjGg5nDhB;AiG54nD4B;EACI,qBAAA;AjG84nDhC;AiGv4nDQ;EACI,UrF9jBc;AZu8oD1B;;AiGj4nDI;EACI,4BrFlNE;AZsloDV;AiGl4nDI;EACI,kCrFrNE;AZyloDV;AiGn4nDQ;EACI,aAAA;AjGq4nDZ;AiGn4nDQ;EACI,cAAA;AjGq4nDZ;AiG93nDgB;EACI,+BAAA;AjGg4nDpB;AiG73nDgB;EACI,+BAAA;AjG+3nDpB;AiG93nDoB;EACI,+BAAA;AjGg4nDxB;AiG73nDwB;EACE,oCAAA;AjG+3nD1B;AiGx3nDwB;EACI,+BAAA;AjG03nD5B;AiG52nDwB;EACI,iDAAA;EACA,WrFxiBpB;AZs5oDR;AiG72nD4B;EACI,WrF1iBxB;AZy5oDR;AiGp2nD4B;EACI,+DAAA;AjGs2nDhC;AiG91nD+B;EACK,0DAAA;AjGg2nDpC;AiG31nDgC;EACI,0DAAA;AjG61nDpC;AiG/0nDI;EACI,sBAAA;AjGi1nDR;AiGh1nDQ;EACI,sBAAA;AjGk1nDZ;AiGj1nDY;EACI,sBAAA;AjGm1nDhB;AiGh1nDQ;EACI,sBAAA;AjGk1nDZ;AiGh1nDQ;EACI,sBAAA;AjGk1nDZ;AiGh1nDY;EACI,sBAAA;AjGk1nDhB;AiG70nDI;EACI,sBAAA;AjG+0nDR;;AkGphpDA;EACI,+BAAA;EACA,2BAAA;EACA,yCtF8nBS;EsF7nBT,gBtF4BY;EsF3BZ,eAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AlGuhpDJ;AkGrhpDI;EACI,SAAA;EACA,UAAA;AlGuhpDR;AkGlhpDQ;EACI,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,gCtFiCM;EsFhCN,gCtF6DY;AZu9oDxB;AkGlhpDY;EACI,eAAA;EACA,sBAAA;EACA,qBAAA;AlGohpDhB;AkGjhpDY;EAEI,uCtFuBS;EsFtBT,6BAAA;AlGkhpDhB;AkG9gpDQ;EACI,gCtFgBM;AZggpDlB;AkG9gpDY;EAEI,uCtFaS;AZkgpDzB;AkG1gpDY;EACI,uCtFOS;AZqgpDzB;AkGtgpDgB;EACI,uCAAA;EACA,6BAAA;AlGwgpDpB;;AqBrgpDI;E6EQI;;IAEI,cAAA;ElGigpDV;AACF;AqB5gpDI;E6EoBgB;IACI,eAAA;ElG2/oDtB;EkGr/oDM;IACI,sBAAA;IACA,gBAAA;ElGu/oDV;EkGh/oDc;IACI,SAAA;IACA,WAAA;ElGk/oDlB;EkG9+oDU;IACI,aAAA;IACA,kEAAA;ElGg/oDd;EkG7+oDkB;IACI,WAAA;IACA,2CAAA;IACA,kBAAA;ElG++oDtB;EkG1+oDkB;IACI,kBAAA;IACA,iBAAA;IACA,UAAA;IACA,aAAA;ElG4+oDtB;EkGt+oDc;IACI,cAAA;ElGw+oDlB;EkGn+oDM;IACI,cAAA;ElGq+oDV;EkGj+oDE;IACI,aAAA;ElGm+oDN;AACF;AkGh+oDA;EACI,qBAAA;AlGk+oDJ;AkGh+oDI;EACI,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,UAAA;EACA,QAAA;EACA,iBAAA;EACA,0CAAA;EACA,qBAAA;EACA,6BAAA;EACA,YAAA;AlGk+oDR;;AqBtjpDI;E6E+FoB;IACI,WAAA;IACA,UAAA;ElG29oD1B;AACF;AqB7jpDI;E6E6GI;IACI,ctFxHI;EZ2kpDd;EkGj9oDU;IACI,ctF3HA;EZ8kpDd;EkG/8oDM;IACI,atFjIG;EZklpDb;EkG78oDE;IACI,iBAAA;IACA,gBAAA;IACA,UAAA;ElG+8oDN;EkG58oDU;IACI,uBAAA;ElG88oDd;EkGz8oDU;IACI,6BAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;ElG28oDd;EkGz8oDc;IACI,WAAA;ElG28oDlB;EkGz8oDkB;IACI,WAAA;ElG28oDtB;EkGt8oDU;IACI,kBAAA;IACA,6BAAA;ElGw8oDd;EkGt8oDc;IAEI,uBtF8JV;EZyyoDR;EkGj8oDU;IACI,WAAA;IACA,kBAAA;ElGm8oDd;AACF;AqBpnpDI;E6E2LQ;IACI,ctFzLA;EZqnpDd;EkGz7oDU;IACI,atF9LD;EZynpDb;EkGv7oDM;IACI,0CAAA;ElGy7oDV;EkGr7oDc;IACI,+BAAA;ElGu7oDlB;EkGr7oDkB;IAEI,+BAAA;ElGs7oDtB;EkGh7oDsB;IACI,0CAAA;ElGk7oD1B;AACF;AkGx6oDQ;EACI,atF/NG;AZyopDf;AkGv6oDQ;EACI,ctFlOI;AZ2opDhB;;AmGzspDA;EACI,yCAAA;AnG4spDJ;AmG3spDI;EACI,mCAAA;EACA,iBvFgEa;EuF/Db,cAAA;EACA,yCvF2nBK;AZkloDb;AmG1spDI;EACI,iBvF0Da;EuFzDb,cAAA;AnG4spDR;AmGzspDI;EACI,cAAA;EACA,+BAAA;AnG2spDR;AmGvspDQ;EACI,8BAAA;AnGyspDZ;;AmGhspDI;EACI,iBvFqCa;EuFpCb,iBAAA;EACA,kBAAA;AnGmspDR;;AgF/spDA;;EAEE,uBAAA;EACA,mDAAA;EACA,qDAAA;EACA,wBAAA;EAEA,0BAAA;EAEA,+BAAA;EAEA,wBAAA;EACA,uBAAA;EAMA,4BAAA;EAEA,6BAAA;EACA,oCAAA;EAGA,gCAAA;EAGA,oBAAA;EACA,yEAAA;EACA,gDAAA;EAGA,qCAAA;EACA,4BAAA;EAEA,+BAAA;EAEA,2BAAA;EAmBA,wBAAA;EACA,qCAAA;EACA,yCAAA;EACA,0CAAA;EACA,2CAAA;EACA,4CAAA;EACA,yBAAA;EACA,kCAAA;EACA,4BAAA;AhF+qpDF;AgFjupDE;;EACE,8BAAA;AhFoupDJ;AgF5spDE;;EACE,uBAAA;EACA,+BAAA;EACA,oCAAA;AhF+spDJ;AgF5spDE;;EACE,+BAAA;EACA,iDAAA;EACA,oCAAA;AhF+spDJ;AgF5spDE;;EACE,8BAAA;AhF+spDJ;AgFjspDE;;EACE,wBAAA;EACA,qCAAA;EACA,yCAAA;EACA,0CAAA;EACA,2CAAA;EACA,4CAAA;AhFospDJ;AgFjspDE;;EACE,6BAAA;EACA,0CAAA;EACA,8CAAA;EACA,+CAAA;EACA,gDAAA;EACA,iDAAA;EACA,8BAAA;AhFospDJ;;AgF7xpDI;EAiGA,qBAAA;EACA,4BAAA;EAEA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,yBAAA;EAGA,uBAAA;EACA,4BAAA;EACA,+BAAA;EACA,gCAAA;EA4BA,uBAAA;EAEA,qDAAA;EAEA,uBAAA;EAEA,2BAAA;EAEA,wBAAA;EACA,qCAAA;EACA,yCAAA;EACA,0CAAA;EACA,2CAAA;EACA,4CAAA;AhF8ppDJ;AgFrspDI;EACE,uBAAA;EACA,oCAAA;EACA,+CAAA;EACA,4CAAA;EACA,+BAAA;EACA,2CAAA;EACA,8BAAA;EACA,0CAAA;EACA,6BAAA;AhFuspDN;AgFpspDI;EACE,+BAAA;EACA,gCAAA;AhFsspDN;AgFnspDI;EACE,8BAAA;AhFqspDN;AgFlspDI;EACE,8BAAA;AhFospDN;AgFjrpDI;EACE,8BAAA;EACA,0CAAA;EACA,8CAAA;EACA,+CAAA;EACA,gDAAA;EACA,iDAAA;EACA,8BAAA;AhFmrpDN;;AoGn2pDA;;;;;;uDAAA;AAOC;EACG,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,wCAAA;ApGs2pDJ;;AoGp2pDE;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,8BAAA;EAIA,qJAAA;EAIA,6BAAA;EAIA,uCAAA;EAKA,mCAAA;EACA,oBAAA;ApGu2pDJ;;AoGr2pDE;EACE,oCAAA;EAIA,6KAAA;ApGw2pDJ;;AoGt2pDE;EACE,8BAAA;ApGy2pDJ;;AoGv2pDE;EACE,oCAAA;ApG02pDJ;;AoGx2pDE;EAIE,2BAAA;ApG22pDJ;;AoGz2pDE;;EAME,wBAAA;EACA,2EAAA;ApG42pDJ;;AoG12pDE;;;;EAIE,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,kCAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;ApG62pDJ;;AoG32pDE;EACE,qBAAA;EACA,oBAAA;ApG82pDJ;;AoG52pDE;EACE,SAAA;EACA,qBAAA;ApG+2pDJ;;AoG72pDE;EACE,oBAAA;EACA,sBAAA;ApGg3pDJ;;AoG92pDE;EACE,UAAA;ApGi3pDJ;;AoG/2pDE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;ApGk3pDJ;;AoGh3pDE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;ApGm3pDJ;;AoGj3pDE;EACE,wBAAA;EAEA,iDAAA;EAIA,qBAAA;ApGo3pDJ;;AoGl3pDE;EAEE,+CAAA;ApGq3pDJ;;AoGn3pDE;EACE,cAAA;ApGs3pDJ;;AoGl3pDI;EACI,0CAAA;ApGq3pDR;;AoGh3pDI;EACI,wCAAA;ApGm3pDR;;AoG/2pDI;EACI,yCAAA;ApGk3pDR;;AoG92pDI;EACI,yCAAA;ApGi3pDR;;AoG72pDI;EACI,yCAAA;ApGg3pDR;;AoG52pDI;EACI,wCAAA;ApG+2pDR;;AqGhhqDA;EACE,YAAA;EACA,WAAA;ArGmhqDF;;AqGhhqDA;EACE,YAAA;EACA,WAAA;ArGmhqDF;;AqGhhqDA;EACE,cAAA;EACA,aAAA;ArGmhqDF;;AqGhhqDA;EACE,YAAA;EACA,WAAA;ArGmhqDF;;AqGhhqDA;EACE,cAAA;EACA,aAAA;ArGmhqDF;;AqGhhqDA;EACE,mBAAA;EACA,kCzFsWQ;EyFrWR,WzFiEM;EyFhEN,aAAA;EACA,gBzFkqBmB;EyFjqBnB,YAAA;EACA,uBAAA;EACA,WAAA;ArGmhqDF;;AqG9gqDA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;ArGihqDF;AqGhhqDE;EACE,kBAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;ArGkhqDJ;AqGjhqDI;EACE,kBAAA;EACA,2BAAA;ArGmhqDN;;AsGjkqDQ;EACI,kBAAA;AtGokqDZ;AsG7jqDgB;EACI,iBAAA;AtG+jqDpB;AsGzjqDI;EACI,kBAAA;AtG2jqDR;;AsGtjqDI;EACI,wCAAA;EACA,gBAAA;AtGyjqDR;AsGvjqDI;EACI,kBAAA;EACA,kBAAA;AtGyjqDR;AsGvjqDQ;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kC1F0VF;E0FzVE,W1FqDJ;E0FpDI,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;AtGyjqDZ;AsGljqDgB;EACI,iBAAA;AtGojqDpB;;AuGxmqDA;EACE,gC3FiFsB;AZ0hqDxB;;AuGxmqDA;EACE,0BAAA;AvG2mqDF;;AuGxmqDA;EACE,0BAAA;AvG2mqDF;;AuGxmqDA;EACE,0BAAA;AvG2mqDF;;AuGxmqDA;EACE,0BAAA;AvG2mqDF;;AuGxmqDA;EACE,0BAAA;AvG2mqDF;;AuGxmqDA;EACE,0BAAA;AvG2mqDF;;AuGxmqDA;EACE,0BAAA;AvG2mqDF;;AuGxmqDA;EACE,0BAAA;AvG2mqDF;;AuGxmqDA;EACE,0BAAA;AvG2mqDF;;AuGxmqDA;EACE,0BAAA;AvG2mqDF;;AuGxmqDA;EACE,0BAAA;AvG2mqDF;;AuGxmqDA;EACE,0BAAA;AvG2mqDF;;AuGtmqDA;EACE,YAAA;EACA,WAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,c3FoCS;E2FnCT,kBAAA;EACA,oBAAA;AvGymqDF;AuGvmqDE;EACE,c3FgCO;E2F/BP,yB3F2BO;AZ8kqDX;;AuGrmqDA;EACE,eAAA;AvGwmqDF;;AuGrmqDA;EACE,eAAA;AvGwmqDF;;AuGrmqDA;EACE,gBAAA;AvGwmqDF;;AuGrmqDA;EACE,gBAAA;AvGwmqDF;;AuGrmqDA;EACE,gBAAA;AvGwmqDF;;AuGnmqDA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;AvGsmqDF;;AuGjmqDA;EACE,SAAA;AvGomqDF;;AuG9lqDE;EACE,eAAA;EACA,wBAAA;EACA,0FAAA;AvGimqDJ;;AwGrtqDA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,wC5Fq7CM;E4Fp7CN,aAAA;AxGwtqDJ;;AwGrtqDA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,uBAAA;AxGwtqDJ;;AwGptqDI;EACI,eAAA;EACA,uB5F4WE;E4F3WF,kBAAA;EACA,qBAAA;EACA,oCAAA;AxGutqDR;;AwGntqDA;EACI;IACE,uBAAA;ExGstqDJ;EwGptqDE;IACE,yBAAA;ExGstqDJ;AACF;AyGrvqDA;EACE,eAAA;EACA,qBAAA;EACA,oB7FmgCyB;AZovoD3B;AyGtvqDE;EACE,YAAA;EACA,cAAA;EACA,oBAAA;AzGwvqDJ;AyGtvqDE;EACE,cAAA;AzGwvqDJ;;AyGpvqDA;EACE,kBAAA;EACA,gBAAA;AzGuvqDF;;AyGnvqDA;EACE,eAAA;EACA,gBAAA;AzGsvqDF;;A0G3wqDA;EACI,eAAA;EACA,iBAAA;A1G8wqDJ;A0G5wqDI;EACI,kBAAA;EACA,sBAAA;A1G8wqDR;A0G5wqDQ;EACI,WAAA;EACA,+CAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,SAAA;A1G8wqDZ;A0G5wqDQ;EACI,kBAAA;EACA,WAAA;EACA,MAAA;EACA,UAAA;A1G8wqDZ;A0G3wqDQ;EACI,mBAAA;A1G6wqDZ;;A2GxyqDA;EACI,iBAAA;EACA,oBAAA;A3G2yqDJ;A2GzyqDI;EACI,mBAAA;EACA,gBAAA;A3G2yqDR;;A2GryqDA;EACI,iBAAA;A3GwyqDJ;;A2GnyqDA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;A3GsyqDJ;;A2GjyqDA;EACE,c/FkES;AZkuqDX;A2GlyqDE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,c/F2DO;E+F1DP,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;A3GoyqDJ;A2GjyqDE;EACE,gBAAA;A3GmyqDJ;A2GhyqDM;EACE,W/FuCA;E+FtCA,kC/F0UE;E+FzUF,8B/FyUE;AZy9pDV;;A2GxxqDI;EACI,yB/F2BG;E+F1BH,gBAAA;EACA,iBAAA;EACA,gB/F0nBa;E+FznBb,kBAAA;A3G2xqDR;;A2GpxqDA;EACE,wC/F42CQ;E+F32CR,wCAAA;EACA,uB/FmiBc;E+FliBd,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;A3GuxqDF;A2GrxqDE;EACE,eAAA;A3GuxqDJ;;A2GnxqDA;EACE,cAAA;A3GsxqDF;;A2GlxqDA;EACE,aAAA;A3GqxqDF;A2GpxqDE;EACE,yCAAA;A3GsxqDJ;;A2GjxqDE;EACI,gBAAA;A3GoxqDN;A2GnxqDM;EACI,WAAA;EACA,YAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;EACA,oDAAA;EACA,kCAAA;EACA,0BAAA;A3GqxqDV;;A4Gx4qDA;EACI;;;;;IAKI,wBAAA;E5G24qDN;E4Gz4qDE;;;;;IAKI,UAAA;IACA,SAAA;E5G24qDN;E4Gx4qDE;IACI,SAAA;E5G04qDN;AACF;A6Gl6qDA;EACE,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;A7Go6qDF;;A6Gj6qDA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;A7Go6qDF;;A6Gj6qDA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;A7Go6qDF;;A6Gj6qDA;EACE,6BAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;A7Go6qDF;;A6Gj6qDA;EACE,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA,EAAA,mGAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA,EAAA,mFAAA;EACA,eAAA,EAAA,kDAAA;EACA,gBAAA,EAAA,0CAAA;EACA,qBAAA;EACA,uBAAA;A7Go6qDF;;A6Gj6qDA;;EAEE,aAAA;A7Go6qDF;;A6Gj6qDA;;EAEE,YAAA;EACA,cAAA;A7Go6qDF;;A6Gj6qDA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;A7Go6qDF;;A6Gj6qDA;EACE,8BAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;A7Go6qDF;;A6Gj6qDA;EACE,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;A7Go6qDF;;A6Gj6qDA;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;A7Go6qDF;;A6Gj6qDA;EACE,oBAAA;EACA,iBAAA;EACA,yBAAA;A7Go6qDF;;A6Gj6qDA;EACE,mBAAA;A7Go6qDF;;A6Gj6qDA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;A7Go6qDF;;A6Gj6qDA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,+BAAA;A7Go6qDF;;A6Gj6qDA;EACE,0DAAA;EACA,YAAA;EACA,6BAAA;A7Go6qDF;;A6Gj6qDA;EACE,MAAA;EACA,WAAA;A7Go6qDF;;A6Gj6qDA;EACE,QAAA;EACA,WAAA;A7Go6qDF;;A6Gj6qDA;EACE,OAAA;EACA,YAAA;A7Go6qDF;;A6Gj6qDA;EACE,YAAA;EACA,SAAA;EACA,UAAA;A7Go6qDF;;A6Gj6qDA;EACE,WAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;A7Go6qDF;;A6Gj6qDA,gBAAA;AACA;EACE,WAAA;EACA,OAAA;A7Go6qDF;;A6Gj6qDA;EACE,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A7Go6qDF;;A6Gj6qDA;EACE,eAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;A7Go6qDF;;A6Gj6qDA;EACE,YAAA;A7Go6qDF;;A8GpnrDE;EACI,eAAA;EACA,iBAAA;EACA,yBAAA;A9GunrDN;;A8GlnrDE;EACI,mBlGoFK;EkGnFL,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBlGkrBiB;AZm8pDvB;;A8GhnrDE;;;;;;;;;;EAUI,oCAAA;A9GmnrDN;A8GjnrDE;EACI,oCAAA;A9GmnrDN;;A8G/mrDA;EACE,kClGq5CQ;EkGp5CR,oCAAA;EACA,clG4DS;EkG3DT,0BAAA;EACA,gBAAA;EACA,4BAAA;EACA,uBAAA;A9GknrDF;;A8G/mrDA;;;EAGE,kClG+UQ;EkG9UR,WlG0CM;EkGzCN,iBAAA;A9GknrDF;;A8G/mrDA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;A9GknrDF;;A8G/mrDA;EACE,2BAAA;EACA,iBAAA;A9GknrDF;;A8G/mrDA;EACE,kClG0TQ;AZwzqDV;;A8G/mrDA;EACE,WlGkBM;AZgmrDR;;A8G7mrDI;EACE,oCAAA;A9GgnrDN;A8G3mrDI;EADF;IAEI,cAAA;E9G8mrDJ;AACF;A8G5mrDM;EACI,eAAA;EACA,iBAAA;EACA,yBAAA;A9G8mrDV;A8G3mrDM;EAEI;;;IAGI,WAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;IACA,cAAA;E9G4mrDZ;E8GzmrDQ;IACI,WAAA;E9G2mrDZ;E8GxmrDQ;IACI,aAAA;E9G0mrDZ;AACF;A8GvmrDM;EACI,0BAAA;A9GymrDV;;A8GpmrDA;EACE,uCAAA;A9GumrDF;;A8GpmrDA;EACE,iCAAA;A9GumrDF;;A8GnmrDA;EACE,yBAAA;A9GsmrDF;;A8GnmrDA;EACE,mBAAA;A9GsmrDF;;A+G9urDA;EACE,wCnGi0CY;AZg7oDd;A+GhvrDE;EACE,uBAAA;EACE,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cnG8FK;AZoprDX;A+GhvrDM;EACE,yBnGmFG;AZ+prDX;A+G/urDM;EACE,yBnGmHA;EmGlHA,gBAAA;EACA,eAAA;A/GivrDR;;A+G5urDA;EACE,8CAAA;A/G+urDF;;A+G5urDA;EACE,wCnGu7BS;EmGt7BT,2DAAA;EACA,2BnG07BY;AZqzpDd;A+G9urDE;EACE,aAAA;A/GgvrDJ;;A+GzurDE;EACE,cAAA;A/G4urDJ;A+GxurDI;EACE,qCAAA;EACA,wCAAA;EACA,sCAAA;EACA,yCAAA;A/G0urDN;A+GturDE;EACE,oDAAA;EACA,cAAA;EACA,yBAAA;EACA,4BAAA;EACA,gDnGo6BkB;EmGn6BlB,mDnGm6BkB;AZq0pDtB;;AgHhyrDI;EACI,aAAA;AhHmyrDR;AgHhyrDI;EACI,cpGyHF;EoGxHE,gBpGyrBa;AZymqDrB;AgH/xrDI;EACI,sBpGkFA;EoGjFA,cpGmHF;EoGlHE,gBAAA;AhHiyrDR;;AiH7yrDA;EACE,gBAAA;AjHgzrDF;;AiH7yrDA;EACE,yBrG0FS;AZstrDX;;AiH7yrDA;EACE,8CAAA;AjHgzrDF;;AiH7yrDA;EACE,yBAAA;AjHgzrDF;;AiH7yrDA;EACE,yBrGkFS;AZ8trDX;;AiH5yrDE;EACE,yBAAA;AjH+yrDJ;;AiH3yrDA;EACE,UAAA;AjH8yrDF;;AiHxyrDE;EACE,iBAAA;AjH2yrDJ;AiH1yrDI;EACE,0BAAA;AjH4yrDN;AiHzyrDE;EACE,yBAAA;AjH2yrDJ;AiHzyrDE;EACE,6BAAA;AjH2yrDJ;;AiHpyrDE;EACE,mBAAA;AjHuyrDJ;AiHryrDE;EACE,yBAAA;AjHuyrDJ;;AiHhyrDQ;EACE,kCrG6UK;AZs9qDf;AiHhyrDQ;EACE,iDAAA;EACA,8BrGwUK;AZ09qDf;AiHjyrDU;EACE,kCrGsUG;AZ69qDf;AiH9xrDU;EACE,kCrGgUG;AZg+qDf;AiH3xrDU;EACE,6CAAA;AjH6xrDZ;;AiHjzrDQ;EACE,yBrG6UK;AZu+qDf;AiHjzrDQ;EACE,+CAAA;EACA,qBrGwUK;AZ2+qDf;AiHlzrDU;EACE,yBrGsUG;AZ8+qDf;AiH/yrDU;EACE,yBrGgUG;AZi/qDf;AiH5yrDU;EACE,2CAAA;AjH8yrDZ;;AiHl0rDQ;EACE,yBrG6UK;AZw/qDf;AiHl0rDQ;EACE,qEAAA;EACA,qBrGwUK;AZ4/qDf;AiHn0rDU;EACE,yBrGsUG;AZ+/qDf;AiHh0rDU;EACE,yBrGgUG;AZkgrDf;AiH7zrDU;EACE,iEAAA;AjH+zrDZ;;AiHn1rDQ;EACE,yBrG6UK;AZygrDf;AiHn1rDQ;EACE,iDAAA;EACA,qBrGwUK;AZ6grDf;AiHp1rDU;EACE,yBrGsUG;AZghrDf;AiHj1rDU;EACE,yBrGgUG;AZmhrDf;AiH90rDU;EACE,6CAAA;AjHg1rDZ;;AiHp2rDQ;EACE,yBrG6UK;AZ0hrDf;AiHp2rDQ;EACE,qEAAA;EACA,qBrGwUK;AZ8hrDf;AiHr2rDU;EACE,yBrGsUG;AZiirDf;AiHl2rDU;EACE,yBrGgUG;AZoirDf;AiH/1rDU;EACE,iEAAA;AjHi2rDZ;;AiHr3rDQ;EACE,yBrG6UK;AZ2irDf;AiHr3rDQ;EACE,iDAAA;EACA,qBrGwUK;AZ+irDf;AiHt3rDU;EACE,yBrGsUG;AZkjrDf;AiHn3rDU;EACE,yBrGgUG;AZqjrDf;AiHh3rDU;EACE,6CAAA;AjHk3rDZ;;AiHt4rDQ;EACE,yBrG6UK;AZ4jrDf;AiHt4rDQ;EACE,uBAAA;EACA,qBrGwUK;AZgkrDf;AiHv4rDU;EACE,yBrGsUG;AZmkrDf;AiHp4rDU;EACE,yBrGgUG;AZskrDf;AiHj4rDU;EACE,mBAAA;AjHm4rDZ;;AiHv5rDQ;EACE,yBrG6UK;AZ6krDf;AiHv5rDQ;EACE,0DAAA;EACA,qBrGwUK;AZilrDf;AiHx5rDU;EACE,yBrGsUG;AZolrDf;AiHr5rDU;EACE,yBrGgUG;AZulrDf;AiHl5rDU;EACE,sDAAA;AjHo5rDZ;;AiH34rDI;EACE,6BAAA;EACA,6BAAA;EACA,2BrGMK;EqGLL,oCAAA;EACA,+BAAA;AjH84rDN;AiH74rDM;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBrGHG;EqGIH,YAAA;EACA,aAAA;EACA,oBAAA;AjH+4rDR;;AiHx4rDE;EACE,6BAAA;EACA,6BAAA;EACA,2BrGhBO;EqGiBP,gCAAA;AjH24rDJ;AiH14rDI;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBrGxBK;EqGyBL,WAAA;EACA,YAAA;EACA,mBAAA;AjH44rDN;AiH14rDE;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;AjH44rDJ;;AkHphsDA;EACI,sCtGkrBe;AZq2qDnB;;AkHlhsDI;;;;EAII,uCAAA;EACA,eAAA;AlHqhsDR;AkH/gsDQ;;;EACI,aAAA;AlHmhsDZ;AkH/gsDI;EACI,iCAAA;EACA,oCAAA;AlHihsDR;AkH9gsDI;EACI,eAAA;EACA,ctGqEG;AZ28rDX;AkH7gsDI;;EAEI,ctGgEG;EsG/DH,iCAAA;EACA,eAAA;AlH+gsDR;AkH5gsDI;EACI,kCAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,mDAAA;AlH8gsDR;;AmHxjsDE;EACE,eAAA;EACA,gBvG4rBiB;AZ+3qDrB;;AmHvjsDA;EACE,eAAA;AnH0jsDF;;AmHtjsDE;EACE,qBvGsHG;EuGrHH,cvGqHG;AZo8rDP;AmHtjsDI;EACE,yBvG+GE;AZy8rDR;AmHrjsDI;EACE,qCAAA;AnHujsDN;AmHpjsDE;EACE,qBvGsGK;EuGrGL,cvGqGK;AZi9rDT;;AmHjjsDE;EACE,gBAAA;AnHojsDJ;;AmH/isDE;EACE,4BvGyVM;AZytrDV;AmHjjsDI;EACE,4BvGuVI;AZ4trDV;AmHljsDM;EACE,kCAAA;AnHojsDR;AmH/isDE;EACE,4BvG+UM;AZkurDV;;AmH7isDA;EACE,uEAAA;AnHgjsDF;;AmH7isDA;EACE,mDAAA;EACA,sCAAA;AnHgjsDF;;AmH9isDA;EACE,mDAAA;EACE,2CAAA;AnHijsDJ;;AmH7isDA;EACE,2CAAA;AnHgjsDF;;AoHpnsDA;EACE,oCxGy7CQ;AZ8rpDV;;AoHpnsDA;EACE,eAAA;ApHunsDF;;AoHpnsDA;EACE,QAAA;ApHunsDF;;AoHnnsDE;EACE,qBAAA;EACA,sBAAA;ApHsnsDJ;AoHpnsDI;EACE,gBAAA;ApHsnsDN;;AqHvosDA;;eAAA;AAII;EACI,yCzG0nBK;EyGznBL,UAAA;ArHyosDR;AqHxosDQ;EACI,yCzGunBC;EyGtnBD,YAAA;ArH0osDZ;AqHrosDQ;EACE,cAAA;EACA,gBAAA;ArHuosDV;;AqH/nsDI;EACI,6CAAA;EACA,mDAAA;ArHkosDR;;AqHposDI;EACI,oCAAA;EACA,mDAAA;ArHuosDR;;AqHzosDI;EACI,oCAAA;EACA,oDAAA;ArH4osDR;;AqH9osDI;EACI,oCAAA;EACA,oDAAA;ArHipsDR;;AqHnpsDI;EACI,oCAAA;EACA,oDAAA;ArHspsDR;;AqHxpsDI;EACI,oCAAA;EACA,mDAAA;ArH2psDR;;AqH7psDI;EACI,oCAAA;EACA,qDAAA;ArHgqsDR;;AqHlqsDI;EACI,oCAAA;EACA,kDAAA;ArHqqsDR;;AqH9psDA;EACI,wCAAA;EACA,yBAAA;ArHiqsDJ;;AqH9psDA;EACI,aAAA;EACA,uCAAA;EACA,gBAAA;EACA,wCAAA;ArHiqsDJ;;AsH5ssDA;EACE,c1G6HI;AZklsDN;;AsH5ssDA;EACE,qB1GyHI;AZslsDN;;AsH5ssDA;EACE,aAAA;EACA,SAAA;EACA,UAAA;AtH+ssDF;AsH9ssDE;EACE,cAAA;AtHgtsDJ;AsH9ssDE;EACE,eAAA;EACA,gBAAA;EACA,c1G4GE;E0G3GF,eAAA;AtHgtsDJ;;AuHnusDA;EACE,cAAA;AvHsusDF;AuHrusDE;EACE,wC3G88BO;E2G78BP,oDAAA;EACA,YAAA;AvHuusDJ;AuHtusDI;EACE,aAAA;AvHwusDN;AuHrusDI;EACE,iBAAA;EACA,kBAAA;EACA,2B3Gy8BQ;AZ8xqDd;AuHpusDI;EACE,YAAA;EACA,WAAA;EACA,UAAA;AvHsusDN;AuHpusDM;EACE,yDAAA;EACA,2BAAA;AvHsusDR;AuHlusDI;EACE,2BAAA;AvHousDN;;AuH1tsDM;EACE,oEAAA;EACA,sCAAA;AvH6tsDR;;AuHttsDE;EACI,aAAA;EACA,wC3GixCQ;AZw8pDd;AuHxtsDM;EACI,oDAAA;EACA,wC3G65BC;E2G55BD,c3G6CC;E2G5CD,aAAA;AvH0tsDV;AuHvtsDE;EACI,kC3GsUI;AZm5rDV;AuHvtsDE;EACI,uC3GqxCoB;E2GpxCpB,gC3GmxCuB;AZs8pD7B;AuHxtsDM;EACI,kC3GgUA;E2G/TA,W3G2BF;AZ+rsDR;;AuHrtsDA;EACE,iBAAA;AvHwtsDF;;AuHrtsDA;EACE,wCAAA;EACA,wC3GsvCY;E2GrvCZ,yC3GmjBW;AZqqrDb;;AuHptsDE;EACE,wCAAA;AvHutsDJ;;AuHltsDE;EACE,gBAAA;EACA,wC3Gw3BO;E2Gv3BP,+DAAA;AvHqtsDJ;AuHntsDI;EACE,iBAAA;AvHqtsDN;AuHntsDI;EACE,SAAA;EACA,2B3Gq3BQ;AZg2qDd;AuHptsDM;EACI,2B3Gm3BI;AZm2qDd;AuHntsDI;EACE,uCAAA;EACA,wCAAA;EACA,kBAAA;EACA,cAAA;AvHqtsDN;;AuH9ssDI;EACE,oCAAA;AvHitsDN;AuH7ssDE;EACE,gB3GykBmB;AZsorDvB;;AuHzssDA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;AvH4ssDJ;AuH3ssDE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AvH6ssDJ;;AuHzssDA;EACE,eAAA;AvH4ssDF;;AuHzssDA;;;EAGE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,c3GjDS;AZ6vsDX;AuH1ssDE;;;EACE,iBAAA;AvH8ssDJ;AuH3ssDM;;;EACE,gBAAA;EACA,kCAAA;AvH+ssDR;;AuHxssDE;;;EAGA,+BAAA;AvH2ssDF;;AuHvssDA;EACE,gBAAA;AvH0ssDF;;AuHpssDA;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AvHussDF;;AwH13sDA,eAAA;AACA;EACE,aAAA;AxH63sDF;AwH53sDE;EACE,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,yB5GyFO;E4GxFP,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gB5GgrBiB;E4G/qBjB,gCAAA;AxH83sDJ;AwH73sDI;EACE,c5GmFK;E4GlFL,6BAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gCAAA;AxH+3sDN;AwH53sDI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,yB5GuDK;E4GtDL,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,gCAAA;AxH83sDN;AwH13sDE;EAMA,kC5GyUQ;AZ8isDV;AwHt3sDE;EACE,W5GmCI;E4GlCJ,4BAAA;EACA,WAAA;EACA,SAAA;AxH43sDJ;AwHz3sDE;EACE,UAAA;EACA,yB5G6BO;AZ81sDX;;AwHv3sDA;EACE,yB5GwDI;AZk0sDN;;AwHx3sDA;;EAEE,W5GkBM;AZy2sDR;;AwHx3sDA;EACE,yB5GmDM;AZw0sDR;;AwHx3sDA;EACE,yBAAA;AxH23sDF;;AwHx3sDA;EACE,kC5G0SQ;AZilsDV;;AwHx3sDA;EACE,yB5GuCM;AZo1sDR;;AwHx3sDA;EACE,yB5GqCK;AZs1sDP;;AwHx3sDA;EACE,yB5G8BO;AZ61sDT;;AwHx3sDA;EACE,yB5GwBI;AZm2sDN;;AwHx3sDA;EACE,yB5GLS;AZg4sDX;;AwHx3sDA;EACE,iBAAA;AxH23sDF;AwH13sDE;EACE,kBAAA;AxH43sDJ;;AyH5+sDA;EACE,yBAAA;EACA,YAAA;EACA,uBAAA;AzH++sDF;AyH5+sDM;EACE,gBAAA;AzH8+sDR;AyH3+sDQ;EAGE,6CAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;AzH2+sDV;AyHx+sDQ;;;EAII,mB7GuED;AZk6sDX;AyHt+sDQ;;;EAII,c7GmED;E6GlEC,YAAA;AzHu+sDZ;AyHp+sDQ;EACI,yB7G4DD;AZ06sDX;;AyH99sDE;EACE,YAAA;AzHi+sDJ;;A0HzgtDQ;EACA,0BAAA;EACA,6BAAA;A1H4gtDR;A0HrgtDQ;EACE,yBAAA;EACA,4BAAA;A1HugtDV;;A2HthtDE;EACE,UAAA;A3HyhtDJ;;A2HphtDE;EACE,iBAAA;A3HuhtDJ;A2HrhtDI;EAHF;IAII,kBAAA;E3HwhtDJ;AACF;A2HrhtDI;EACE,kBAAA;EACA,eAAA;A3HuhtDN;;A2HhhtDI;EACE,aAAA;A3HmhtDN;;A2H7gtDE;EACE,eAAA;A3HghtDJ;A2H7gtDE;EACE,gBAAA;A3H+gtDJ;;A2H1gtDA;EACE,oCAAA;EACA,8BAAA;A3H6gtDF;A2HngtDM;;;;;EACE,UAAA;EACA,aAAA;EACA,iBAAA;EACA,oCAAA;EACA,eAAA;EACA,QAAA;A3HygtDR;A2HpgtDM;;;;;EACE,UAAA;EACA,YAAA;EACA,iBAAA;EACA,oCAAA;EACA,SAAA;EACA,eAAA;A3H0gtDR;A2HjgtDQ;;;;EAGE,kBAAA;EACA,mBAAA;A3HogtDV;A2H3/sDI;EACI,wCAAA;A3H6/sDR;A2H3/sDQ;EACI,oCAAA;EACA,uB/GgSF;AZ6tsDV;A2Hz/sDQ;EACI,wBAAA;A3H2/sDZ;A2Hv/sDI;EACI,8CAAA;EACA,oBAAA;EACA,yCAAA;A3Hy/sDR;;A2Hp/sDA;EACE,gB/G8kBqB;AZy6rDvB;;A2H3+sDU;;EACE,yC/GkgBI;E+GjgBJ,yB/GCJ;E+GAI,YAAA;A3H++sDZ;A2Hp+sDU;;EACE,yB/GfN;AZs/sDN;;A2H79sDA;EACE,kC/GwOQ;E+GvOR,YAAA;EACA,W/G9DM;E+G+DN,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;A3Hg+sDF;A2H99sDE;EACE,mBAAA;EACA,0CAAA;EACA,W/GvEI;AZuitDR;;AqB5jtDI;EsGkGF;;IAEE,qBAAA;IACA,iBAAA;E3H89sDF;E2H39sDA;IACE,aAAA;E3H69sDF;E2Hz9sDE;IACE,kBAAA;IACA,cAAA;IACA,2BAAA;E3H29sDJ;E2Hv9sDA;IACE,qBAAA;IACA,mB/GgTK;EZyqsDP;AACF;A2Hp9sDE;EACE,yB/GvGO;AZ6jtDX;;A2H78sDA;EACE,2DAAA;A3Hg9sDF;;A2Hx8sDI;;EACE,kBAAA;A3H48sDN;A2H18sDM;;EACE,kBAAA;A3H68sDR;A2H38sDQ;;EACE,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,W/GxIF;E+GyIE,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,kC/GoJA;AZ0zsDV;;A4HzrtDA;EACI,mDAAA;A5H4rtDJ;;A4HxrtDI;EACI,uDAAA;A5H2rtDR;A4HxrtDI;;;EAGI,mDAAA;EACA,2BAAA;A5H0rtDR;A4HvrtDI;EACI,sCAAA;A5HyrtDR;A4HvrtDQ;EACI,kDAAA;A5HyrtDZ;A4HprtDQ;EACI,kDAAA;A5HsrtDZ;A4HlrtDI;EACI,+CAAA;A5HortDR;A4HjrtDI;;;EAGI,4CAAA;A5HmrtDR;A4HhrtDI;EACI,sCAAA;A5HkrtDR;A4HhrtDQ;EACI,qCAAA;A5HkrtDZ;A4H9qtDI;;;EAGI,sCAAA;A5HgrtDR;A4H7qtDI;EACI,yDAAA;A5H+qtDR;;A4H5qtDA;EACI,wBAAA;A5H+qtDJ;;A4H5qtDA;EACI,kDAAA;A5H+qtDJ;;A6H/utDA,aAAA;AACA;EACE,iBAAA;EACA,yCAAA;EACA,kCjHs7CQ;EiHr7CR,kBAAA;A7HkvtDF;A6HhvtDE;EACE,eAAA;EACA,WAAA;A7HkvtDJ;;A6H9utDA;EACE,uBAAA;A7HivtDF;;A8H5vtDI;EACI,kBAAA;A9H+vtDR;A8H7vtDQ;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;A9H+vtDZ;A8H5vtDQ;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kCAAA;EACA,uBlH0WF;EkHzWE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wClHg6CF;AZ81qDV;A8H5vtDY;EAZJ;IAaQ,cAAA;IACA,6BAAA;E9H+vtDd;AACF;A8H3vtDY;EACI,cAAA;EACA,eAAA;EACA,gBlH2pBG;AZkmsDnB;A8H3vtDgB;EALJ;IAMQ,aAAA;E9H8vtDlB;AACF;A8H3vtDY;EACI,6BAAA;EACA,2BAAA;A9H6vtDhB;A8H3vtDgB;EACI,kClH8UV;EkH7UU,WlHyCZ;AZottDR;A8HvvtDI;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;A9HyvtDR;A8HvvtDQ;EACI,qBAAA;A9HyvtDZ;A8HvvtDY;EACI,qBAAA;EACA,wBAAA;EACA,kClH2TN;EkH1TM,WlHsBR;EkHrBQ,sBAAA;A9HyvtDhB;A8HrvtDgB;EACI,mBAAA;EACA,iDAAA;A9HuvtDpB;A8HnvtDY;EACI,YAAA;A9HqvtDhB;;A8H/utDA;EACI,iBAAA;EACA,iBAAA;A9HkvtDJ;;A+H30tDE;EACE,cAAA;A/H80tDJ;A+H50tDE;EACE,uBAAA;A/H80tDJ;A+H30tDI;EACE,yBnHoFK;EmHnFL,cnH2FK;EmH1FL,6CAAA;A/H60tDN;A+H50tDM;EACI,kCnHmXA;EmHlXA,8BnHkXA;EmHjXA,WnH6EF;AZiwtDR;A+H30tDI;EACE,YAAA;A/H60tDN;A+H50tDM;EACE,QAAA;EACA,0BAAA;EACA,oBAAA;A/H80tDR;A+Hz0tDI;EACE,eAAA;EACA,mBAAA;A/H20tDN;A+Hv0tDE;EACE,kBAAA;EACA,sCAAA;A/Hy0tDJ;A+Hv0tDI;EACE,qDAAA;A/Hy0tDN;A+Ht0tDI;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;A/Hw0tDN;A+Hv0tDM;EACE,+BAAA;EACA,oCAAA;EACA,sBnH2CA;EmH1CA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,wBAAA;A/Hy0tDR;A+Hv0tDM;EACE,cnH+BG;EmH9BH,qBAAA;EACA,eAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;A/Hy0tDR;A+Ht0tDI;EACE,eAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;A/Hw0tDN;A+Ht0tDM;EACE,aAAA;A/Hw0tDR;A+Hp0tDM;EACE,oBAAA;EACA,aAAA;A/Hs0tDR;A+Hl0tDM;EACE,gBAAA;EACA,kCAAA;EACA,gBAAA;A/Ho0tDR;A+Hh0tDM;EACE,yBnHRG;EmHSH,mBAAA;A/Hk0tDR;A+H9ztDM;EACE,kCnHqRE;EmHpRF,8BnHoRE;AZ4itDV;A+H9ztDM;EACE,WnHnBA;AZm1tDR;A+H1ztDI;EACE,oBAAA;EACA,kCnHyQI;AZmjtDV;A+H3ztDM;EACE,WnH7BA;AZ01tDR;;A+HtztDE;EAEI;IACE,qBAAA;E/HwztDN;AACF;;AgI77tDA;EACI,iDAAA;AhIg8tDJ;AgI97tDI;EACI,sCAAA;AhIg8tDR;AgI97tDI;EACI,6CAAA;AhIg8tDR;AgI77tDI;EACI,gBAAA;AhI+7tDR;AgI57tDI;EACI,+DAAA;AhI87tDR;AgI57tDQ;EACI,0BAAA;AhI87tDZ;AgI37tDQ;EACI,kCAAA;AhI67tDZ;AgIz7tDI;EACI,wBAAA;EACA,mDAAA;EACA,2DAAA;EACA,2BAAA;AhI27tDR;AgIx7tDI;EACI,6CAAA;EACA,yCpH+lBQ;EoH9lBR,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,sCpH8xCiB;AZ4prDzB;AgIv7tDI;EACI,6CAAA;AhIy7tDR;AgIp7tDY;EAEI,OAAA;EACA,sBAAA;AhIq7tDhB;AgI/6tDQ;EACI,2BAAA;AhIi7tDZ;AgI76tDI;EACI,yDAAA;EACA,iDAAA;EACA,mDAAA;AhI+6tDR;;AgIx6tDI;;;EACI,2BAAA;EACA,4CAAA;AhI66tDR;AgIz6tDQ;;EACI,sCAAA;AhI46tDZ;AgIx6tDI;;EACI,sCAAA;AhI26tDR;;AgIv6tDA;;EAEI,kCAAA;EACA,uCAAA;EACA,wCAAA;AhI06tDJ;;AgIv6tDA;;EAEI,kCAAA;EACA,oCAAA;EACA,qCAAA;AhI06tDJ;;AgIv6tDA;EACI,4BAAA;AhI06tDJ;;AgIv6tDA;EACI,2BAAA;AhI06tDJ;;AgIn6tDY;;;EAEI,2BAAA;AhIu6tDhB;;AgI/5tDQ;EACI,8BAAA;EACA,yBAAA;AhIk6tDZ;AgI95tDI;EACI,6CAAA;EACA,+DAAA;AhIg6tDR;AgI/5tDQ;EACI,iDAAA;EACA,2BAAA;AhIi6tDZ;AgI75tDI;EACI,6CAAA;EACA,mDAAA;AhI+5tDR;AgI55tDY;EACI,sDAAA;AhI85tDhB;AgI35tDY;EACI,sDAAA;AhI65tDhB;;AgIr5tDA;EACI,6CAAA;AhIw5tDJ;;AgIl5tDI;EACE,aAAA;EACA,8BAAA;AhIq5tDN;AgIj5tDM;EACE,+DAAA;EACA,2BAAA;AhIm5tDR;AgI/4tDI;;EAEE,kCAAA;EACA,uCAAA;EACA,wCAAA;AhIi5tDN;AgI94tDI;;EAEE,kCAAA;EACA,oCAAA;EACA,qCAAA;AhIg5tDN;;AgI34tDI;EACI,2BAAA;AhI84tDR;;AiI7kuDE;EACE,+DrHq/Bc;EqHp/Bd,uBAAA;EACA,oDAAA;EACA,wCrH48BO;EqH38BP,2BrHg9BU;EqH/8BV,sCrHo9BkB;AZ4nsDtB;AiI/kuDI;EACE,aAAA;EACA,kCrHs9BqB;AZ2nsD3B;;AkI5luDA;EACI,2BAAA;AlI+luDJ;AkI9luDI;EACI,iDAAA;EACA,atH8FG;AZkguDX;AkI9luDI;EACI,cAAA;AlIgmuDR;;AkI5luDA;EACI,8CAAA;EACA,mDAAA;AlI+luDJ;;AkI7luDA;EACI,8CAAA;EACA,0DAAA;AlIgmuDJ;;AkI9luDA;;EAEI,iDAAA;AlIimuDJ;;AkI9luDA;EACI,gBtHuqBiB;AZ07sDrB;;AkI9luDA;EACI,oBAAA;EACA,etHkEO;AZ+huDX;;AkI9luDA;EACI,yBAAA;EACA,iDAAA;EACA,0BAAA;AlIimuDJ;;AkI9luDA;EACI,qBAAA;AlIimuDJ;;AkI5luDI;;EACI,iDAAA;EACA,atHmDG;AZ6iuDX;;AkI5luDA;EACI,yCAAA;AlI+luDJ;;AkI5luDA;EACI,yCAAA;AlI+luDJ;;AmIzpuDA,eAAA;AACA;EACE,aAAA;AnI4puDF;;AmIzpuDA;EACE,iBAAA;EACA,uCAAA;EACA,YAAA;EACA,cvHuFS;EuHtFT,yCvHynBW;EuHxnBX,kBAAA;AnI4puDF;;AmIzpuDA;EACE,cvHqFS;AZukuDX;;AoIzquDA;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,oCAAA;EACA,yCxH6nBc;EwH5nBd,4BAAA;EACA,kBAAA;EACA,gCAAA;ApI4quDF;;AoIzquDA;EACE,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,iDAAA;EACA,2BAAA;ApI4quDF;;AqI3ruDA;EACE,aAAA;EACA,mBzH2FS;EyH1FT,kBAAA;ArI8ruDF;;AqI3ruDA;EACE,cAAA;EACA,kBAAA;EACA,WzHmFM;EyHlFN,eAAA;EACA,iBAAA;EACA,4BzHoXQ;EyHnXR,kBAAA;EACA,kBAAA;ArI8ruDF;;AqI3ruDA;EACE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;ArI8ruDF;AqI7ruDE;EACE,aAAA;EACA,mCAAA;EACA,oCAAA;EACA,uCAAA;ArI+ruDJ;AqI7ruDE;EACE,UAAA;EACA,mCAAA;EACA,oCAAA;EACA,0CAAA;ArI+ruDJ;;AsIjuuDA;EACI,YAAA;EACA,mB1HmGO;E0HlGP,c1H2FO;E0H1FP,sC1H+qBe;E0H9qBf,iB1HorBa;E0HnrBb,gBAAA;AtIouuDJ;;AuIzuuDI;EACE,qBAAA;AvI4uuDN;;AuIxuuDE;EACE,gBAAA;AvI2uuDJ;AuI1uuDI;EACE,gBAAA;AvI4uuDN;;AwIrvuDA;EACE,wC5H07CQ;AZ8zrDV;;AwIrvuDA;EACE,0DAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,4BAAA;EAEA,4BAAA;AxIuvuDF;AwIlvuDE;EAbF;IAcI,aAAA;ExIqvuDF;AACF;;AwIlvuDA;EACE,aAAA;EACA,aAAA;AxIqvuDF;;AwIlvuDA;EACE,kBAAA;AxIqvuDF;AwIpvuDE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;AxIsvuDJ;AwInvuDE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AxIqvuDJ;AwIlvuDE;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,eAAA;EACA,uB5HkVM;AZk6tDV;;AwI/uuDE;EACE,a5HQW;AZ0uuDf;AwIhvuDE;EACE,c5HMY;AZ4uuDhB;;AwI5uuDI;EACE,cAAA;AxI+uuDN;AwI7uuDI;EACE,aAAA;AxI+uuDN;;AyI9yuDI;EACI,mBAAA;EACA,kBAAA;AzIizuDR;AyI/yuDI;EACI,eAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,iBAAA;AzIizuDR;;AyI1yuDI;EACI,+CAAA;AzI6yuDR;AyI1yuDQ;EACI,SAAA;AzI4yuDZ;AyIxyuDI;EACI,SAAA;EACA,cAAA;EACA,2BAAA;EACA,gB7HgqBa;E6H/pBb,iBAAA;AzI0yuDR;AyIpyuDI;EACI,iBAAA;AzIsyuDR;AyInyuDI;EACI,iBAAA;EACA,cAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,gB7H8oBa;E6H7oBb,QAAA;EACA,sBAAA;EACA,2BAAA;AzIqyuDR;AyIlyuDI;EACI,cAAA;EACA,SAAA;AzIoyuDR;AyIjyuDY;EACI,cAAA;EACA,iBAAA;EACA,2BAAA;AzImyuDhB;AyI/xuDgB;EACI,uB7H4TV;AZq+tDV;;AyIpxuDQ;EACI,eAAA;AzIuxuDZ;AyIrxuDY;EACI,uCAAA;AzIuxuDhB;;AyIhxuDI;EACI,qBAAA;EACA,kBAAA;EACA,2BAAA;AzImxuDR;AyIjxuDQ;EACI,WAAA;EACA,wCAAA;EACA,kBAAA;AzImxuDZ;AyIjxuDQ;EACI,uB7HyRF;AZ0/tDV;AyIlxuDY;EACI,yCAAA;AzIoxuDhB;;AyI7wuDI;EACI,2BAAA;AzIgxuDR;AyI/wuDQ;EACI,2BAAA;EACA,YAAA;AzIixuDZ;AyI7wuDY;EACI,uB7HuQN;AZwguDV;;AyIzwuDA;EACI,aAAA;EACA,wCAAA;EACA,oBAAA;AzI4wuDJ;AyI1wuDI;EACI,yC7H2fK;AZixtDb;;AyIxwuDA;EACI,kBAAA;AzI2wuDJ;AyIzwuDI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,gBAAA;EACA,gCAAA;AzI2wuDR;AyIxwuDI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;AzI0wuDR;AyIzwuDQ;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,c7H/DD;AZ00uDX;;AyIpwuDQ;EACI,kBAAA;AzIuwuDZ;AyItwuDY;EACI,uCAAA;AzIwwuDhB;AyIpwuDY;EACI,WAAA;AzIswuDhB;AyIjwuDI;EACI,wCAAA;EACA,aAAA;AzImwuDR;;AyI9vuDI;EACI,gBAAA;AzIiwuDR;;AyI3vuDQ;EACI,c7HjGD;AZ+1uDX;AyI5vuDQ;EACI,kBAAA;AzI8vuDZ;;AyIvvuDA;EACI,wCAAA;EACA,wC7HkwBO;E6HjwBP,uB7HmaY;AZu1tDhB;AyIzvuDI;EACI,yBAAA;EACA,YAAA;AzI2vuDR;AyIxvuDI;EACI,wCAAA;EACA,oCAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AzI0vuDR;;AyInvuDA;EACI,gBAAA;AzIsvuDJ;AyIrvuDI;EACI,yCAAA;AzIuvuDR;;A0Il+uDA;;oBAAA;AAGA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;A1Iq+uDF;;A0Il+uDA;EACE,kBAAA;A1Iq+uDF;;A0Ij+uDE;EACE,2BAAA;EACA,gBAAA;A1Io+uDJ;A0Il+uDE;EACE,eAAA;A1Io+uDJ;;A0Ih+uDA;EACE;IACE,WAAA;IACA,WAAA;E1Im+uDF;E0Ij+uDA;IACE,SAAA;E1Im+uDF;AACF;A0I99uDE;EACE,cAAA;EACA,c9HiEO;E8HhEP,iBAAA;EACA,gBAAA;A1Ig+uDJ;A0I/9uDI;EACE,c9HyFA;E8HxFA,gBAAA;A1Ii+uDN;;A0I59uDA;EACE,cAAA;EACA,eAAA;A1I+9uDF;A0I79uDE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;A1I+9uDJ;A0I79uDI;EACE,c9H0CK;AZq7uDX;A0I59uDI;EACE,iCAAA;EACA,0BAAA;A1I89uDN;A0I39uDI;EACE,WAAA;EACA,kBAAA;A1I69uDN;A0I19uDI;EACE,YAAA;A1I49uDN;A0I19uDM;;;EAGE,cAAA;EACA,WAAA;A1I49uDR;A0Iz9uDM;EACE,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;A1I29uDR;A0Ix9uDM;EACE,wBAAA;A1I09uDR;A0Iv9uDM;EACE,gBAAA;EACA,gBAAA;A1Iy9uDR;A0It9uDM;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;A1Iw9uDR;A0Ip9uDI;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;A1Is9uDN;A0Ip9uDM;;EAEE,kBAAA;EACA,MAAA;A1Is9uDR;A0In9uDM;EACE,OAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;A1Iq9uDR;A0Il9uDM;EACE,QAAA;EACA,YAAA;EACA,kBAAA;A1Io9uDR;A0Ih9uDI;EAEE,0CAAA;A1Ii9uDN;A0I78uDE;EACE,uCAAA;EACA,gBAAA;EACA,2BAAA;A1I+8uDJ;A0I98uDM;EACE,2BAAA;EACA,gBAAA;A1Ig9uDR;A0I18uDE;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;A1I48uDJ;A0I18uDI;EACE,UAAA;EACA,eAAA;A1I48uDN;A0I18uDI;EACE,UAAA;A1I48uDN;A0Iz8uDI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,0BAAA;EACA,MAAA;A1I28uDN;A0I18uDM;EACE,iBAAA;EACA,oCAAA;EACA,MAAA;EACA,YAAA;EACA,+CAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;A1I48uDR;;A0It8uDA;EACE;IACI,YAAA;E1Iy8uDJ;AACF;A2IppvDA;EACI,wC/H07CM;E+Hz7CN,oCAAA;EACA,yC/H8nBS;AZwhuDb;A2IppvDI;EALJ;IAMQ,gBAAA;E3IupvDN;AACF;A2InpvDQ;EACI,uCAAA;A3IqpvDZ;A2IlpvDgB;EACI,wC/H26CV;E+H16CU,uB/HgXV;AZoyuDV;;A2I1ovDQ;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yB/H+FN;E+H9FM,kBAAA;EACA,QAAA;A3I6ovDZ;A2IzovDI;EACI,YAAA;EACA,gBAAA;EACA,eAAA;A3I2ovDR;;A2ItovDI;EACI,SAAA;A3IyovDR;;A2IrovDA;EACI,SAAA;A3IwovDJ;A2IpovDY;EACI,uCAAA;A3IsovDhB;A2IlovDQ;EACI,cAAA;EACA,kBAAA;EACA,c/HmCD;E+HlCC,oBAAA;EACA,4CAAA;EACA,kBAAA;A3IoovDZ;A2IlovDY;EACI,kDAAA;A3IoovDhB;A2IhovDQ;EACI,kBAAA;A3IkovDZ;A2IhovDY;EACI,WAAA;EACA,YAAA;EACA,yB/HkBL;E+HjBK,kBAAA;EACA,wCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;A3IkovDhB;A2I5nvDgB;EACI,yB/HsCZ;AZwlvDR;A2IznvDgB;EACI,yB/H+BX;AZ4lvDT;;A2IpnvDA;EACI,wC/Hi1CM;E+Hh1CN,yC/HshBS;AZimuDb;A2ItnvDI;EACI,+CAAA;A3IwnvDR;;A2IlnvDQ;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;A3IqnvDZ;A2IlnvDQ;EACI,yC/HmgBC;E+HlgBD,wCAAA;A3IonvDZ;;A2I7mvDI;EACI,WAAA;A3IgnvDR;A2I7mvDI;EACI,WAAA;EACA,iBAAA;A3I+mvDR;A2I7mvDQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A3I+mvDZ;A2I3mvDI;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;A3I6mvDR;A2I3mvDQ;EACI,uCAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;A3I6mvDZ;A2I1mvDQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,wCAAA;EACA,SAAA;A3I4mvDZ;A2IzmvDQ;EACI,eAAA;A3I2mvDZ;A2IvmvDI;EACI,mBAAA;EACA,qBAAA;EACA,kBAAA;A3IymvDR;A2IvmvDQ;EACI,gBAAA;A3IymvDZ;A2IvmvDY;EACI,gB/HqgBO;E+HpgBP,kBAAA;A3IymvDhB;A2IrmvDQ;EACI,kBAAA;EACA,kC/H8LF;E+H7LE,uB/HgbI;E+H/aJ,W/HxGJ;AZ+svDR;A2IpmvDQ;EACI,eAAA;EACA,eAAA;EACA,iBAAA;A3IsmvDZ;A2IjmvDQ;EACI,YAAA;A3ImmvDZ;A2IjmvDY;EACI,iBAAA;A3ImmvDhB;A2IhmvDY;EACI,uCAAA;EACA,iBAAA;EACA,c/HvHL;AZytvDX;A2I/lvDY;EACI,gBAAA;A3IimvDhB;;A2IxlvDA;EACI,wC/HmtCM;E+HltCN,uB/H2YY;AZgtuDhB;;A2IxlvDA;EACI,kDAAA;EACA,+CAAA;A3I2lvDJ;;A2IxlvDA;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;A3I2lvDJ;A2IxlvDQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;A3I0lvDZ;;A2IplvDI;EADJ;IAEQ,eAAA;E3IwlvDN;AACF;;A4I51vDA;EACE,wCAAA;EACA,gBAAA;A5I+1vDF;A4I51vDI;EACE,iBAAA;A5I81vDN;;A4Iz1vDA;EACI,oDAAA;EACA,oCAAA;A5I41vDJ;;A6Iz2vDA;EACI,eAAA;EACA,gBjIgsBe;EiI/rBf,gCjIgFoB;EiI/EpB,kBAAA;EACA,aAAA;A7I42vDJ;A6I32vDI;EACI,eAAA;EACA,gBjIurBa;EiItrBb,cAAA;EACA,gBAAA;A7I62vDR;;A6Iz2vDA;EACI,UAAA;A7I42vDJ;;A6Iz2vDA;EACI,0DAAA;A7I42vDJ;;A8Ih4vDA,gDAAA;AAEA;EACI,kBAAA;EACA,mBAAA;A9Ik4vDJ;A8Ij4vDI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,SAAA;EACA,uCAAA;A9Im4vDR;A8Ih4vDI;EACI,aAAA;A9Ik4vDR;A8I/3vDI;EACI,WAAA;A9Ii4vDR;A8I93vDI;EACI,mBAAA;A9Ig4vDR;A8I73vDI;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;A9I+3vDR;A8I53vDI;EACI,qBAAA;EACA,yBAAA;EACA,gCAAA;EACA,kClI6VE;EkI5VF,WlIwDA;EkIvDA,kBAAA;EACA,WAAA;A9I83vDR;A8I53vDQ;EACI,iBAAA;A9I83vDZ;A8I13vDI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kClIy4CE;EkIx4CF,kBAAA;EACA,cAAA;EACA,kCAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;A9I43vDR;A8I33vDQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,uCAAA;EACA,UAAA;EACA,QAAA;A9I63vDZ;A8Iz3vDI;EACI,gBAAA;A9I23vDR;A8I13vDQ;EACI,qBAAA;EACA,iBAAA;A9I43vDZ;A8I13vDQ;EACI,YAAA;EACA,WAAA;EACA,kBAAA;A9I43vDZ;;A8It3vDA;EAIQ;IACI,UAAA;E9Is3vDV;E8In3vDM;IACI,SAAA;E9Iq3vDV;E8In3vDM;IACI,kBAAA;IACA,UAAA;IACA,iBAAA;E9Iq3vDV;E8Ih3vDM;IACI,WAAA;IACA,cAAA;IACA,UAAA;E9Ik3vDV;E8I/2vDM;IACI,iBAAA;E9Ii3vDV;E8Ih3vDU;IACI,WAAA;IACA,cAAA;IACA,UAAA;E9Ik3vDd;E8I/2vDU;IACI,aAAA;E9Ii3vDd;E8I52vDU;IACI,cAAA;IACA,kBAAA;E9I82vDd;E8I32vDU;IACI,yBAAA;IACA,gCAAA;IACA,UAAA;IACA,YAAA;E9I62vDd;E8I32vDc;IACI,YAAA;IACA,iBAAA;IACA,gBAAA;E9I62vDlB;E8Iz2vDU;IACI,UAAA;IACA,YAAA;E9I22vDd;E8I12vDc;IACI,UAAA;IACA,WAAA;E9I42vDlB;AACF;A8In2vDI;EACI,SAAA;A9Iq2vDR;A8In2vDI;EACI,aAAA;A9Iq2vDR;A8Il2vDI;EACI,WAAA;A9Io2vDR;A8Ij2vDI;EACI,WAAA;A9Im2vDR;;A+IxgwDA;EACI,qBAAA;EACA,wCnIs7CM;EmIr7CN,yCnI2nBS;EmI1nBT,YAAA;EACA,kBAAA;A/I2gwDJ;A+I1gwDI;EACI,qBAAA;A/I4gwDR;;A+IrgwDQ;EACI,gBAAA;A/IwgwDZ;;A+IngwDA;;sBAAA;AAKI;EACI,eAAA;A/IogwDR;A+IlgwDI;EACI,kBAAA;EACA,kBAAA;EACA,wCAAA;EACA,2BAAA;A/IogwDR;A+IngwDQ;EACI,eAAA;EACA,kBAAA;EACA,cAAA;A/IqgwDZ;A+IlgwDQ;EACI,8BnIsVF;EmIrVE,6BAAA;EACA,2BAAA;A/IogwDZ;A+IlgwDY;EACI,uBnIiVN;AZmrvDV;;A+I9/vDA;EACI,gBAAA;A/IigwDJ;A+IhgwDI;EAFJ;IAGQ,eAAA;E/ImgwDN;AACF;;A+IhgwDA;EACI,cnIiEE;EmIhEF,kBAAA;A/ImgwDJ;A+IjgwDI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;A/ImgwDR;A+IjgwDQ;EAPJ;IAQQ,WAAA;IACA,WAAA;IACA,YAAA;E/IogwDV;AACF;;AAjkwDE;EACE,aAAA;AAokwDJ;;AAhkwDA;EACE,yBY2ES;AZw/vDX;;AAhkwDA;EACE,eAAA;AAmkwDF;;AAhkwDA;;EAEE,YAAA;AAmkwDF;AAjkwDI;;EACE,8BAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAokwDN;;AA/jwDA;EACE,yBAAA;EACA,aAAA;AAkkwDF;;AAhkwDA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AAmkwDF;;AAhkwDA;EACE,sBAAA;AAmkwDF;;AAhkwDA;EACE,wBAAA;AAmkwDF;;AAhkwDA;EACE,6CAAA;AAmkwDF;;AAhkwDA;EACE,2BAAA;AAmkwDF;;AA/jwDE;EACE,6BAAA;AAkkwDJ;;AA9jwDA;EACE,mCAAA;AAikwDF;;AA9jwDA;EACE,iBAAA;AAikwDF;;AA9jwDA;EACE,0BAAA;AAikwDF;;AA7jwDA;EACE,uBAAA;EACA,SAAA;EACA,eAAA;EACA,wBAAA;EACA,0FAAA;EAEA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AA+jwDF;AA9jwDE;EACE,aAAA;AAgkwDJ;;AA3jwDA;EACE,sBAAA;AA8jwDF;;AA5jwDA;EACE,mBAAA;AA+jwDF;;AA5jwDA;EACE;IAEE,eAAA;IACA,wBAAA;IAEA,mBAAA;IACA,UAAA;IACA,SAAA;EA+jwDF;EA7jwDA;IACE,qBAAA;IACA,WAAA;EA+jwDF;AACF;AA7jwDA;EACE,gBAAA;AA+jwDF;;AA3jwDA;EACE,cAAA;AA8jwDF;;AA3jwDA;EACE,aAAA;AA8jwDF;;AA1jwDE;EACE,aAAA;AA6jwDJ;AA1jwDE;EACE,cAAA;AA4jwDJ;;AAtjwDE;EACE,wCAAA;EACA,2BAAA;EACA,oCAAA;AAyjwDJ;AAvjwDI;EAEE,+BAAA;AAwjwDN;AArjwDI;EACE,sBAAA;EACA,mCAAA;AAujwDN;AArjwDM;EACE,sBAAA;AAujwDR;AApjwDM;EACE,oCAAA;AAsjwDR;AAjjwDE;EACE,2BAAA;AAmjwDJ;AAhjwDE;EACE,wCAAA;EACA,2BAAA;EACA,oCAAA;AAkjwDJ;AAhjwDI;EACE,sBAAA;EACA,mCAAA;AAkjwDN;AAhjwDM;EACE,sBAAA;AAkjwDR;AA/iwDM;EACE,oCAAA;AAijwDR;AA5iwDE;EACE,wCAAA;EACA,2BAAA;EACA,oCAAA;AA8iwDJ;AA5iwDI;EACE,WYlHE;EZmHF,mCAAA;AA8iwDN;AA5iwDM;EAGE,mCAAA;AA4iwDR;;AAtiwDA;EACE,gDAAA;AAyiwDF;;AAviwDA;EACE,+CAAA;EACA,sCAAA;AA0iwDF;;AAxiwDA;EACE,mDAAA;EACA,sCAAA;EACA,+CAAA;AA2iwDF;;AAziwDA;EACE,+CAAA;EACA,sCAAA;AA4iwDF;AA3iwDE;EAEE,+CAAA;EACA,4CAAA;EACA,sCAAA;AA4iwDJ;;AAziwDA;EACE,sCAAA;AA4iwDF;AA3iwDE;EACE,+CAAA;EACA,4CAAA;EACA,sCAAA;AA6iwDJ;;AA1iwDA;EACE,+CAAA;AA6iwDF;;AA1iwDA;EACE,iBAAA;AA6iwDF","sourcesContent":["//Import Icon scss\n@import \"../scss/icons.scss\";\n\n//import Light Theme\n@import \"../scss/bootstrap.scss\";\n@import \"../scss/app.scss\";\n\n// RTL mode\n// @import \"../scss/custom/rtl/bootstrap-rtl\";\n// @import \"../scss/custom/rtl/components-rtl\";\n// @import \"../scss/custom/rtl/float-rtl\";\n// @import \"../scss/custom/rtl/general-rtl\";\n// @import \"../scss/custom/rtl/pages-rtl\";\n// @import \"../scss/custom/rtl/plugins-rtl\";\n// @import \"../scss/custom/rtl/spacing-rtl\";\n// @import \"../scss/custom/rtl/structure-rtl\";\n// @import \"../scss/custom/rtl/text-rtl\";\n\nbody {\n  * {\n    outline: none;\n  }\n}\n\n.accordian-bg-products {\n  background-color: $gray-300;\n}\n\n.nav-link {\n  cursor: pointer;\n}\n\n.dataTables_filter,\n.dataTables_paginate {\n  float: right;\n  .pagination {\n    .page-link {\n      border-radius: 30px !important;\n      margin: 0 3px;\n      border: none;\n      text-align: center;\n      cursor: pointer;\n    }\n  }\n}\n\n.rdw-editor-main {\n  border: 1px solid $gray-300;\n  height: 239px;\n}\n.dz-message {\n  text-align: center;\n  padding: 0px;\n  margin: 2em 0;\n}\n\n.react-datepicker-wrapper {\n  width: 100% !important;\n}\n\n.ReactModal__Overlay {\n  z-index: 1001 !important;\n}\n\n.rangeslider__fill {\n  background-color: $primary !important;\n}\n\n.react-bootstrap-table {\n  padding-top: 0px !important;\n}\n\n.square-switch {\n  .react-switch-bg {\n    border-radius: 5px !important;\n  }\n}\n\ninput[type=\"range\"] {\n  -webkit-appearance: auto !important;\n}\n\n.chat-conversation-height {\n  min-height: 500px;\n}\n\n.expand-cell {\n  cursor: pointer !important;\n}\n\n//modal close icon\n.close {\n  background: transparent;\n  border: 0;\n  font-size: 10px;\n  padding: 1.35rem 1.25rem;\n  background: transparent escape-svg($btn-close-bg-dark) center /\n    $btn-close-width auto no-repeat;\n  position: absolute;\n  top: 0;\n  right: 0;\n  opacity: 0.5;\n  width: 1em;\n  height: 1em;\n  z-index: 2;\n  span {\n    display: none;\n  }\n}\n\n// calendar\n.fc-daygrid-event {\n  color: $white !important;\n}\n.card-columns .card {\n  margin-bottom: 24px;\n}\n\n@media (min-width: 576px) {\n  .card-columns {\n    -webkit-column-count: 3;\n    column-count: 3;\n    grid-column-gap: 1.25rem;\n    -webkit-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n    orphans: 1;\n    widows: 1;\n  }\n  .card-columns .card {\n    display: inline-block;\n    width: 100%;\n  }\n}\n.react-bootstrap-table-pagination {\n  --bs-gutter-x: 0;\n}\n\n// logo\n.logo-dark-element {\n  display: block;\n}\n\n.logo-light-element {\n  display: none;\n}\n\n[data-bs-theme=\"dark\"] {\n  .logo-dark-element {\n    display: none;\n  }\n\n  .logo-light-element {\n    display: block;\n  }\n}\n\n//react select\n.css-b62m3t-container {\n  .css-13cymwt-control {\n    background-color: var(--#{$prefix}secondary-bg);\n    color: var(--#{$prefix}body-color);\n    border-color: var(--#{$prefix}border-color);\n\n    &:hover,\n    &:focus {\n      border-color: var(--#{$prefix}primary);\n    }\n\n    .css-1p3m7a8-multiValue {\n      color: var(--#{$prefix}white);\n      background-color: var(--#{$prefix}primary);\n\n      .css-wsp0cs-MultiValueGeneric {\n        color: var(--#{$prefix}white);\n      }\n\n      .css-1u9des2-indicatorSeparator {\n        border-color: var(--#{$prefix}border-color);\n      }\n    }\n  }\n\n  :is(.css-qbdosj-Input, .css-1dimb5e-singleValue) {\n    color: var(--#{$prefix}body-color);\n  }\n\n  .css-t3ipsp-control {\n    background-color: var(--#{$prefix}secondary-bg);\n    color: var(--#{$prefix}body-color);\n    border-color: var(--#{$prefix}border-color);\n\n    .css-1p3m7a8-multiValue {\n      color: var(--#{$prefix}white);\n      background-color: var(--#{$prefix}primary);\n\n      .css-wsp0cs-MultiValueGeneric {\n        color: var(--#{$prefix}white);\n      }\n\n      .css-1u9des2-indicatorSeparator {\n        border-color: var(--#{$prefix}border-color);\n      }\n    }\n  }\n\n  .css-1nmdiq5-menu {\n    background-color: var(--#{$prefix}secondary-bg);\n    color: var(--#{$prefix}body-color);\n    border-color: var(--#{$prefix}border-color);\n\n    .css-d7l1ni-option {\n      color: $white;\n      background-color: var(--#{$prefix}primary);\n\n      &:hover,\n      &:active,\n      &:focus {\n        background-color: var(--#{$prefix}primary);\n      }\n    }\n  }\n}\n//  calendar\n.flatpickr-innerContainer {\n  border-bottom: var(--#{$prefix}border-color) !important;\n}\n.flatpickr-calendar {\n  border-color: var(--#{$prefix}border-color) !important;\n  color: var(--#{$prefix}body-color) !important;\n}\n.flatpickr-days {\n  background-color: var(--#{$prefix}secondary-bg) !important;\n  color: var(--#{$prefix}body-color) !important;\n  border-color: var(--#{$prefix}border-color) !important;\n}\n.flatpickr-day.today {\n  border-color: var(--#{$prefix}border-color) !important;\n  color: var(--#{$prefix}body-color) !important;\n  &:hover,\n  &:focus {\n    border-color: var(--#{$prefix}border-color) !important;\n    background: var(--#{$prefix}tertiary-bg) !important;\n    color: var(--#{$prefix}body-color) !important;\n  }\n}\n.flatpickr-day {\n  color: var(--#{$prefix}body-color) !important;\n  &:hover {\n    border-color: var(--#{$prefix}border-color) !important;\n    background: var(--#{$prefix}tertiary-bg) !important;\n    color: var(--#{$prefix}body-color) !important;\n  }\n}\n.dayContainer {\n  border-color: var(--#{$prefix}border-color) !important;\n}\n\n.chartjs-chart {\n  max-height: 300px;\n}\n","/*\nTemplate Name: Nazox -  Admin & Dashboard Template\nAuthor: Themesdesign\nVersion: 2.3.0\nContact: themesdesign.in@gmail.com\nFile: Icons Css File\n*/\n\n// Plugins\n@import \"custom/plugins/icons\";","/* MaterialDesignIcons.com */\n@font-face {\n  font-family: \"Material Design Icons\";\n  src: url(\"../../../../fonts/materialdesignicons-webfont.eot?v=5.9.55\");\n  src: url(\"../../../../fonts/materialdesignicons-webfont.eot?#iefix&v=5.9.55\") format(\"embedded-opentype\"), url(\"../../../../fonts/materialdesignicons-webfont.woff2?v=5.9.55\") format(\"woff2\"), url(\"../../../../fonts/materialdesignicons-webfont.woff?v=5.9.55\") format(\"woff\"), url(\"../../../../fonts/materialdesignicons-webfont.ttf?v=5.9.55\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.mdi:before,\n.mdi-set {\n  display: inline-block;\n  font: normal normal normal 24px/1 \"Material Design Icons\";\n  font-size: inherit;\n  text-rendering: auto;\n  line-height: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.mdi-ab-testing::before {\n  content: \"\\F01C9\";\n}\n\n.mdi-abacus::before {\n  content: \"\\F16E0\";\n}\n\n.mdi-abjad-arabic::before {\n  content: \"\\F1328\";\n}\n\n.mdi-abjad-hebrew::before {\n  content: \"\\F1329\";\n}\n\n.mdi-abugida-devanagari::before {\n  content: \"\\F132A\";\n}\n\n.mdi-abugida-thai::before {\n  content: \"\\F132B\";\n}\n\n.mdi-access-point::before {\n  content: \"\\F0003\";\n}\n\n.mdi-access-point-check::before {\n  content: \"\\F1538\";\n}\n\n.mdi-access-point-minus::before {\n  content: \"\\F1539\";\n}\n\n.mdi-access-point-network::before {\n  content: \"\\F0002\";\n}\n\n.mdi-access-point-network-off::before {\n  content: \"\\F0BE1\";\n}\n\n.mdi-access-point-off::before {\n  content: \"\\F1511\";\n}\n\n.mdi-access-point-plus::before {\n  content: \"\\F153A\";\n}\n\n.mdi-access-point-remove::before {\n  content: \"\\F153B\";\n}\n\n.mdi-account::before {\n  content: \"\\F0004\";\n}\n\n.mdi-account-alert::before {\n  content: \"\\F0005\";\n}\n\n.mdi-account-alert-outline::before {\n  content: \"\\F0B50\";\n}\n\n.mdi-account-arrow-left::before {\n  content: \"\\F0B51\";\n}\n\n.mdi-account-arrow-left-outline::before {\n  content: \"\\F0B52\";\n}\n\n.mdi-account-arrow-right::before {\n  content: \"\\F0B53\";\n}\n\n.mdi-account-arrow-right-outline::before {\n  content: \"\\F0B54\";\n}\n\n.mdi-account-box::before {\n  content: \"\\F0006\";\n}\n\n.mdi-account-box-multiple::before {\n  content: \"\\F0934\";\n}\n\n.mdi-account-box-multiple-outline::before {\n  content: \"\\F100A\";\n}\n\n.mdi-account-box-outline::before {\n  content: \"\\F0007\";\n}\n\n.mdi-account-cancel::before {\n  content: \"\\F12DF\";\n}\n\n.mdi-account-cancel-outline::before {\n  content: \"\\F12E0\";\n}\n\n.mdi-account-cash::before {\n  content: \"\\F1097\";\n}\n\n.mdi-account-cash-outline::before {\n  content: \"\\F1098\";\n}\n\n.mdi-account-check::before {\n  content: \"\\F0008\";\n}\n\n.mdi-account-check-outline::before {\n  content: \"\\F0BE2\";\n}\n\n.mdi-account-child::before {\n  content: \"\\F0A89\";\n}\n\n.mdi-account-child-circle::before {\n  content: \"\\F0A8A\";\n}\n\n.mdi-account-child-outline::before {\n  content: \"\\F10C8\";\n}\n\n.mdi-account-circle::before {\n  content: \"\\F0009\";\n}\n\n.mdi-account-circle-outline::before {\n  content: \"\\F0B55\";\n}\n\n.mdi-account-clock::before {\n  content: \"\\F0B56\";\n}\n\n.mdi-account-clock-outline::before {\n  content: \"\\F0B57\";\n}\n\n.mdi-account-cog::before {\n  content: \"\\F1370\";\n}\n\n.mdi-account-cog-outline::before {\n  content: \"\\F1371\";\n}\n\n.mdi-account-convert::before {\n  content: \"\\F000A\";\n}\n\n.mdi-account-convert-outline::before {\n  content: \"\\F1301\";\n}\n\n.mdi-account-cowboy-hat::before {\n  content: \"\\F0E9B\";\n}\n\n.mdi-account-details::before {\n  content: \"\\F0631\";\n}\n\n.mdi-account-details-outline::before {\n  content: \"\\F1372\";\n}\n\n.mdi-account-edit::before {\n  content: \"\\F06BC\";\n}\n\n.mdi-account-edit-outline::before {\n  content: \"\\F0FFB\";\n}\n\n.mdi-account-group::before {\n  content: \"\\F0849\";\n}\n\n.mdi-account-group-outline::before {\n  content: \"\\F0B58\";\n}\n\n.mdi-account-hard-hat::before {\n  content: \"\\F05B5\";\n}\n\n.mdi-account-heart::before {\n  content: \"\\F0899\";\n}\n\n.mdi-account-heart-outline::before {\n  content: \"\\F0BE3\";\n}\n\n.mdi-account-key::before {\n  content: \"\\F000B\";\n}\n\n.mdi-account-key-outline::before {\n  content: \"\\F0BE4\";\n}\n\n.mdi-account-lock::before {\n  content: \"\\F115E\";\n}\n\n.mdi-account-lock-outline::before {\n  content: \"\\F115F\";\n}\n\n.mdi-account-minus::before {\n  content: \"\\F000D\";\n}\n\n.mdi-account-minus-outline::before {\n  content: \"\\F0AEC\";\n}\n\n.mdi-account-multiple::before {\n  content: \"\\F000E\";\n}\n\n.mdi-account-multiple-check::before {\n  content: \"\\F08C5\";\n}\n\n.mdi-account-multiple-check-outline::before {\n  content: \"\\F11FE\";\n}\n\n.mdi-account-multiple-minus::before {\n  content: \"\\F05D3\";\n}\n\n.mdi-account-multiple-minus-outline::before {\n  content: \"\\F0BE5\";\n}\n\n.mdi-account-multiple-outline::before {\n  content: \"\\F000F\";\n}\n\n.mdi-account-multiple-plus::before {\n  content: \"\\F0010\";\n}\n\n.mdi-account-multiple-plus-outline::before {\n  content: \"\\F0800\";\n}\n\n.mdi-account-multiple-remove::before {\n  content: \"\\F120A\";\n}\n\n.mdi-account-multiple-remove-outline::before {\n  content: \"\\F120B\";\n}\n\n.mdi-account-music::before {\n  content: \"\\F0803\";\n}\n\n.mdi-account-music-outline::before {\n  content: \"\\F0CE9\";\n}\n\n.mdi-account-network::before {\n  content: \"\\F0011\";\n}\n\n.mdi-account-network-outline::before {\n  content: \"\\F0BE6\";\n}\n\n.mdi-account-off::before {\n  content: \"\\F0012\";\n}\n\n.mdi-account-off-outline::before {\n  content: \"\\F0BE7\";\n}\n\n.mdi-account-outline::before {\n  content: \"\\F0013\";\n}\n\n.mdi-account-plus::before {\n  content: \"\\F0014\";\n}\n\n.mdi-account-plus-outline::before {\n  content: \"\\F0801\";\n}\n\n.mdi-account-question::before {\n  content: \"\\F0B59\";\n}\n\n.mdi-account-question-outline::before {\n  content: \"\\F0B5A\";\n}\n\n.mdi-account-reactivate::before {\n  content: \"\\F152B\";\n}\n\n.mdi-account-reactivate-outline::before {\n  content: \"\\F152C\";\n}\n\n.mdi-account-remove::before {\n  content: \"\\F0015\";\n}\n\n.mdi-account-remove-outline::before {\n  content: \"\\F0AED\";\n}\n\n.mdi-account-search::before {\n  content: \"\\F0016\";\n}\n\n.mdi-account-search-outline::before {\n  content: \"\\F0935\";\n}\n\n.mdi-account-settings::before {\n  content: \"\\F0630\";\n}\n\n.mdi-account-settings-outline::before {\n  content: \"\\F10C9\";\n}\n\n.mdi-account-star::before {\n  content: \"\\F0017\";\n}\n\n.mdi-account-star-outline::before {\n  content: \"\\F0BE8\";\n}\n\n.mdi-account-supervisor::before {\n  content: \"\\F0A8B\";\n}\n\n.mdi-account-supervisor-circle::before {\n  content: \"\\F0A8C\";\n}\n\n.mdi-account-supervisor-circle-outline::before {\n  content: \"\\F14EC\";\n}\n\n.mdi-account-supervisor-outline::before {\n  content: \"\\F112D\";\n}\n\n.mdi-account-switch::before {\n  content: \"\\F0019\";\n}\n\n.mdi-account-switch-outline::before {\n  content: \"\\F04CB\";\n}\n\n.mdi-account-tie::before {\n  content: \"\\F0CE3\";\n}\n\n.mdi-account-tie-outline::before {\n  content: \"\\F10CA\";\n}\n\n.mdi-account-tie-voice::before {\n  content: \"\\F1308\";\n}\n\n.mdi-account-tie-voice-off::before {\n  content: \"\\F130A\";\n}\n\n.mdi-account-tie-voice-off-outline::before {\n  content: \"\\F130B\";\n}\n\n.mdi-account-tie-voice-outline::before {\n  content: \"\\F1309\";\n}\n\n.mdi-account-voice::before {\n  content: \"\\F05CB\";\n}\n\n.mdi-adjust::before {\n  content: \"\\F001A\";\n}\n\n.mdi-adobe::before {\n  content: \"\\F0936\";\n}\n\n.mdi-adobe-acrobat::before {\n  content: \"\\F0F9D\";\n}\n\n.mdi-air-conditioner::before {\n  content: \"\\F001B\";\n}\n\n.mdi-air-filter::before {\n  content: \"\\F0D43\";\n}\n\n.mdi-air-horn::before {\n  content: \"\\F0DAC\";\n}\n\n.mdi-air-humidifier::before {\n  content: \"\\F1099\";\n}\n\n.mdi-air-humidifier-off::before {\n  content: \"\\F1466\";\n}\n\n.mdi-air-purifier::before {\n  content: \"\\F0D44\";\n}\n\n.mdi-airbag::before {\n  content: \"\\F0BE9\";\n}\n\n.mdi-airballoon::before {\n  content: \"\\F001C\";\n}\n\n.mdi-airballoon-outline::before {\n  content: \"\\F100B\";\n}\n\n.mdi-airplane::before {\n  content: \"\\F001D\";\n}\n\n.mdi-airplane-landing::before {\n  content: \"\\F05D4\";\n}\n\n.mdi-airplane-off::before {\n  content: \"\\F001E\";\n}\n\n.mdi-airplane-takeoff::before {\n  content: \"\\F05D5\";\n}\n\n.mdi-airport::before {\n  content: \"\\F084B\";\n}\n\n.mdi-alarm::before {\n  content: \"\\F0020\";\n}\n\n.mdi-alarm-bell::before {\n  content: \"\\F078E\";\n}\n\n.mdi-alarm-check::before {\n  content: \"\\F0021\";\n}\n\n.mdi-alarm-light::before {\n  content: \"\\F078F\";\n}\n\n.mdi-alarm-light-off::before {\n  content: \"\\F171E\";\n}\n\n.mdi-alarm-light-off-outline::before {\n  content: \"\\F171F\";\n}\n\n.mdi-alarm-light-outline::before {\n  content: \"\\F0BEA\";\n}\n\n.mdi-alarm-multiple::before {\n  content: \"\\F0022\";\n}\n\n.mdi-alarm-note::before {\n  content: \"\\F0E71\";\n}\n\n.mdi-alarm-note-off::before {\n  content: \"\\F0E72\";\n}\n\n.mdi-alarm-off::before {\n  content: \"\\F0023\";\n}\n\n.mdi-alarm-panel::before {\n  content: \"\\F15C4\";\n}\n\n.mdi-alarm-panel-outline::before {\n  content: \"\\F15C5\";\n}\n\n.mdi-alarm-plus::before {\n  content: \"\\F0024\";\n}\n\n.mdi-alarm-snooze::before {\n  content: \"\\F068E\";\n}\n\n.mdi-album::before {\n  content: \"\\F0025\";\n}\n\n.mdi-alert::before {\n  content: \"\\F0026\";\n}\n\n.mdi-alert-box::before {\n  content: \"\\F0027\";\n}\n\n.mdi-alert-box-outline::before {\n  content: \"\\F0CE4\";\n}\n\n.mdi-alert-circle::before {\n  content: \"\\F0028\";\n}\n\n.mdi-alert-circle-check::before {\n  content: \"\\F11ED\";\n}\n\n.mdi-alert-circle-check-outline::before {\n  content: \"\\F11EE\";\n}\n\n.mdi-alert-circle-outline::before {\n  content: \"\\F05D6\";\n}\n\n.mdi-alert-decagram::before {\n  content: \"\\F06BD\";\n}\n\n.mdi-alert-decagram-outline::before {\n  content: \"\\F0CE5\";\n}\n\n.mdi-alert-minus::before {\n  content: \"\\F14BB\";\n}\n\n.mdi-alert-minus-outline::before {\n  content: \"\\F14BE\";\n}\n\n.mdi-alert-octagon::before {\n  content: \"\\F0029\";\n}\n\n.mdi-alert-octagon-outline::before {\n  content: \"\\F0CE6\";\n}\n\n.mdi-alert-octagram::before {\n  content: \"\\F0767\";\n}\n\n.mdi-alert-octagram-outline::before {\n  content: \"\\F0CE7\";\n}\n\n.mdi-alert-outline::before {\n  content: \"\\F002A\";\n}\n\n.mdi-alert-plus::before {\n  content: \"\\F14BA\";\n}\n\n.mdi-alert-plus-outline::before {\n  content: \"\\F14BD\";\n}\n\n.mdi-alert-remove::before {\n  content: \"\\F14BC\";\n}\n\n.mdi-alert-remove-outline::before {\n  content: \"\\F14BF\";\n}\n\n.mdi-alert-rhombus::before {\n  content: \"\\F11CE\";\n}\n\n.mdi-alert-rhombus-outline::before {\n  content: \"\\F11CF\";\n}\n\n.mdi-alien::before {\n  content: \"\\F089A\";\n}\n\n.mdi-alien-outline::before {\n  content: \"\\F10CB\";\n}\n\n.mdi-align-horizontal-center::before {\n  content: \"\\F11C3\";\n}\n\n.mdi-align-horizontal-left::before {\n  content: \"\\F11C2\";\n}\n\n.mdi-align-horizontal-right::before {\n  content: \"\\F11C4\";\n}\n\n.mdi-align-vertical-bottom::before {\n  content: \"\\F11C5\";\n}\n\n.mdi-align-vertical-center::before {\n  content: \"\\F11C6\";\n}\n\n.mdi-align-vertical-top::before {\n  content: \"\\F11C7\";\n}\n\n.mdi-all-inclusive::before {\n  content: \"\\F06BE\";\n}\n\n.mdi-allergy::before {\n  content: \"\\F1258\";\n}\n\n.mdi-alpha::before {\n  content: \"\\F002B\";\n}\n\n.mdi-alpha-a::before {\n  content: \"\\F0AEE\";\n}\n\n.mdi-alpha-a-box::before {\n  content: \"\\F0B08\";\n}\n\n.mdi-alpha-a-box-outline::before {\n  content: \"\\F0BEB\";\n}\n\n.mdi-alpha-a-circle::before {\n  content: \"\\F0BEC\";\n}\n\n.mdi-alpha-a-circle-outline::before {\n  content: \"\\F0BED\";\n}\n\n.mdi-alpha-b::before {\n  content: \"\\F0AEF\";\n}\n\n.mdi-alpha-b-box::before {\n  content: \"\\F0B09\";\n}\n\n.mdi-alpha-b-box-outline::before {\n  content: \"\\F0BEE\";\n}\n\n.mdi-alpha-b-circle::before {\n  content: \"\\F0BEF\";\n}\n\n.mdi-alpha-b-circle-outline::before {\n  content: \"\\F0BF0\";\n}\n\n.mdi-alpha-c::before {\n  content: \"\\F0AF0\";\n}\n\n.mdi-alpha-c-box::before {\n  content: \"\\F0B0A\";\n}\n\n.mdi-alpha-c-box-outline::before {\n  content: \"\\F0BF1\";\n}\n\n.mdi-alpha-c-circle::before {\n  content: \"\\F0BF2\";\n}\n\n.mdi-alpha-c-circle-outline::before {\n  content: \"\\F0BF3\";\n}\n\n.mdi-alpha-d::before {\n  content: \"\\F0AF1\";\n}\n\n.mdi-alpha-d-box::before {\n  content: \"\\F0B0B\";\n}\n\n.mdi-alpha-d-box-outline::before {\n  content: \"\\F0BF4\";\n}\n\n.mdi-alpha-d-circle::before {\n  content: \"\\F0BF5\";\n}\n\n.mdi-alpha-d-circle-outline::before {\n  content: \"\\F0BF6\";\n}\n\n.mdi-alpha-e::before {\n  content: \"\\F0AF2\";\n}\n\n.mdi-alpha-e-box::before {\n  content: \"\\F0B0C\";\n}\n\n.mdi-alpha-e-box-outline::before {\n  content: \"\\F0BF7\";\n}\n\n.mdi-alpha-e-circle::before {\n  content: \"\\F0BF8\";\n}\n\n.mdi-alpha-e-circle-outline::before {\n  content: \"\\F0BF9\";\n}\n\n.mdi-alpha-f::before {\n  content: \"\\F0AF3\";\n}\n\n.mdi-alpha-f-box::before {\n  content: \"\\F0B0D\";\n}\n\n.mdi-alpha-f-box-outline::before {\n  content: \"\\F0BFA\";\n}\n\n.mdi-alpha-f-circle::before {\n  content: \"\\F0BFB\";\n}\n\n.mdi-alpha-f-circle-outline::before {\n  content: \"\\F0BFC\";\n}\n\n.mdi-alpha-g::before {\n  content: \"\\F0AF4\";\n}\n\n.mdi-alpha-g-box::before {\n  content: \"\\F0B0E\";\n}\n\n.mdi-alpha-g-box-outline::before {\n  content: \"\\F0BFD\";\n}\n\n.mdi-alpha-g-circle::before {\n  content: \"\\F0BFE\";\n}\n\n.mdi-alpha-g-circle-outline::before {\n  content: \"\\F0BFF\";\n}\n\n.mdi-alpha-h::before {\n  content: \"\\F0AF5\";\n}\n\n.mdi-alpha-h-box::before {\n  content: \"\\F0B0F\";\n}\n\n.mdi-alpha-h-box-outline::before {\n  content: \"\\F0C00\";\n}\n\n.mdi-alpha-h-circle::before {\n  content: \"\\F0C01\";\n}\n\n.mdi-alpha-h-circle-outline::before {\n  content: \"\\F0C02\";\n}\n\n.mdi-alpha-i::before {\n  content: \"\\F0AF6\";\n}\n\n.mdi-alpha-i-box::before {\n  content: \"\\F0B10\";\n}\n\n.mdi-alpha-i-box-outline::before {\n  content: \"\\F0C03\";\n}\n\n.mdi-alpha-i-circle::before {\n  content: \"\\F0C04\";\n}\n\n.mdi-alpha-i-circle-outline::before {\n  content: \"\\F0C05\";\n}\n\n.mdi-alpha-j::before {\n  content: \"\\F0AF7\";\n}\n\n.mdi-alpha-j-box::before {\n  content: \"\\F0B11\";\n}\n\n.mdi-alpha-j-box-outline::before {\n  content: \"\\F0C06\";\n}\n\n.mdi-alpha-j-circle::before {\n  content: \"\\F0C07\";\n}\n\n.mdi-alpha-j-circle-outline::before {\n  content: \"\\F0C08\";\n}\n\n.mdi-alpha-k::before {\n  content: \"\\F0AF8\";\n}\n\n.mdi-alpha-k-box::before {\n  content: \"\\F0B12\";\n}\n\n.mdi-alpha-k-box-outline::before {\n  content: \"\\F0C09\";\n}\n\n.mdi-alpha-k-circle::before {\n  content: \"\\F0C0A\";\n}\n\n.mdi-alpha-k-circle-outline::before {\n  content: \"\\F0C0B\";\n}\n\n.mdi-alpha-l::before {\n  content: \"\\F0AF9\";\n}\n\n.mdi-alpha-l-box::before {\n  content: \"\\F0B13\";\n}\n\n.mdi-alpha-l-box-outline::before {\n  content: \"\\F0C0C\";\n}\n\n.mdi-alpha-l-circle::before {\n  content: \"\\F0C0D\";\n}\n\n.mdi-alpha-l-circle-outline::before {\n  content: \"\\F0C0E\";\n}\n\n.mdi-alpha-m::before {\n  content: \"\\F0AFA\";\n}\n\n.mdi-alpha-m-box::before {\n  content: \"\\F0B14\";\n}\n\n.mdi-alpha-m-box-outline::before {\n  content: \"\\F0C0F\";\n}\n\n.mdi-alpha-m-circle::before {\n  content: \"\\F0C10\";\n}\n\n.mdi-alpha-m-circle-outline::before {\n  content: \"\\F0C11\";\n}\n\n.mdi-alpha-n::before {\n  content: \"\\F0AFB\";\n}\n\n.mdi-alpha-n-box::before {\n  content: \"\\F0B15\";\n}\n\n.mdi-alpha-n-box-outline::before {\n  content: \"\\F0C12\";\n}\n\n.mdi-alpha-n-circle::before {\n  content: \"\\F0C13\";\n}\n\n.mdi-alpha-n-circle-outline::before {\n  content: \"\\F0C14\";\n}\n\n.mdi-alpha-o::before {\n  content: \"\\F0AFC\";\n}\n\n.mdi-alpha-o-box::before {\n  content: \"\\F0B16\";\n}\n\n.mdi-alpha-o-box-outline::before {\n  content: \"\\F0C15\";\n}\n\n.mdi-alpha-o-circle::before {\n  content: \"\\F0C16\";\n}\n\n.mdi-alpha-o-circle-outline::before {\n  content: \"\\F0C17\";\n}\n\n.mdi-alpha-p::before {\n  content: \"\\F0AFD\";\n}\n\n.mdi-alpha-p-box::before {\n  content: \"\\F0B17\";\n}\n\n.mdi-alpha-p-box-outline::before {\n  content: \"\\F0C18\";\n}\n\n.mdi-alpha-p-circle::before {\n  content: \"\\F0C19\";\n}\n\n.mdi-alpha-p-circle-outline::before {\n  content: \"\\F0C1A\";\n}\n\n.mdi-alpha-q::before {\n  content: \"\\F0AFE\";\n}\n\n.mdi-alpha-q-box::before {\n  content: \"\\F0B18\";\n}\n\n.mdi-alpha-q-box-outline::before {\n  content: \"\\F0C1B\";\n}\n\n.mdi-alpha-q-circle::before {\n  content: \"\\F0C1C\";\n}\n\n.mdi-alpha-q-circle-outline::before {\n  content: \"\\F0C1D\";\n}\n\n.mdi-alpha-r::before {\n  content: \"\\F0AFF\";\n}\n\n.mdi-alpha-r-box::before {\n  content: \"\\F0B19\";\n}\n\n.mdi-alpha-r-box-outline::before {\n  content: \"\\F0C1E\";\n}\n\n.mdi-alpha-r-circle::before {\n  content: \"\\F0C1F\";\n}\n\n.mdi-alpha-r-circle-outline::before {\n  content: \"\\F0C20\";\n}\n\n.mdi-alpha-s::before {\n  content: \"\\F0B00\";\n}\n\n.mdi-alpha-s-box::before {\n  content: \"\\F0B1A\";\n}\n\n.mdi-alpha-s-box-outline::before {\n  content: \"\\F0C21\";\n}\n\n.mdi-alpha-s-circle::before {\n  content: \"\\F0C22\";\n}\n\n.mdi-alpha-s-circle-outline::before {\n  content: \"\\F0C23\";\n}\n\n.mdi-alpha-t::before {\n  content: \"\\F0B01\";\n}\n\n.mdi-alpha-t-box::before {\n  content: \"\\F0B1B\";\n}\n\n.mdi-alpha-t-box-outline::before {\n  content: \"\\F0C24\";\n}\n\n.mdi-alpha-t-circle::before {\n  content: \"\\F0C25\";\n}\n\n.mdi-alpha-t-circle-outline::before {\n  content: \"\\F0C26\";\n}\n\n.mdi-alpha-u::before {\n  content: \"\\F0B02\";\n}\n\n.mdi-alpha-u-box::before {\n  content: \"\\F0B1C\";\n}\n\n.mdi-alpha-u-box-outline::before {\n  content: \"\\F0C27\";\n}\n\n.mdi-alpha-u-circle::before {\n  content: \"\\F0C28\";\n}\n\n.mdi-alpha-u-circle-outline::before {\n  content: \"\\F0C29\";\n}\n\n.mdi-alpha-v::before {\n  content: \"\\F0B03\";\n}\n\n.mdi-alpha-v-box::before {\n  content: \"\\F0B1D\";\n}\n\n.mdi-alpha-v-box-outline::before {\n  content: \"\\F0C2A\";\n}\n\n.mdi-alpha-v-circle::before {\n  content: \"\\F0C2B\";\n}\n\n.mdi-alpha-v-circle-outline::before {\n  content: \"\\F0C2C\";\n}\n\n.mdi-alpha-w::before {\n  content: \"\\F0B04\";\n}\n\n.mdi-alpha-w-box::before {\n  content: \"\\F0B1E\";\n}\n\n.mdi-alpha-w-box-outline::before {\n  content: \"\\F0C2D\";\n}\n\n.mdi-alpha-w-circle::before {\n  content: \"\\F0C2E\";\n}\n\n.mdi-alpha-w-circle-outline::before {\n  content: \"\\F0C2F\";\n}\n\n.mdi-alpha-x::before {\n  content: \"\\F0B05\";\n}\n\n.mdi-alpha-x-box::before {\n  content: \"\\F0B1F\";\n}\n\n.mdi-alpha-x-box-outline::before {\n  content: \"\\F0C30\";\n}\n\n.mdi-alpha-x-circle::before {\n  content: \"\\F0C31\";\n}\n\n.mdi-alpha-x-circle-outline::before {\n  content: \"\\F0C32\";\n}\n\n.mdi-alpha-y::before {\n  content: \"\\F0B06\";\n}\n\n.mdi-alpha-y-box::before {\n  content: \"\\F0B20\";\n}\n\n.mdi-alpha-y-box-outline::before {\n  content: \"\\F0C33\";\n}\n\n.mdi-alpha-y-circle::before {\n  content: \"\\F0C34\";\n}\n\n.mdi-alpha-y-circle-outline::before {\n  content: \"\\F0C35\";\n}\n\n.mdi-alpha-z::before {\n  content: \"\\F0B07\";\n}\n\n.mdi-alpha-z-box::before {\n  content: \"\\F0B21\";\n}\n\n.mdi-alpha-z-box-outline::before {\n  content: \"\\F0C36\";\n}\n\n.mdi-alpha-z-circle::before {\n  content: \"\\F0C37\";\n}\n\n.mdi-alpha-z-circle-outline::before {\n  content: \"\\F0C38\";\n}\n\n.mdi-alphabet-aurebesh::before {\n  content: \"\\F132C\";\n}\n\n.mdi-alphabet-cyrillic::before {\n  content: \"\\F132D\";\n}\n\n.mdi-alphabet-greek::before {\n  content: \"\\F132E\";\n}\n\n.mdi-alphabet-latin::before {\n  content: \"\\F132F\";\n}\n\n.mdi-alphabet-piqad::before {\n  content: \"\\F1330\";\n}\n\n.mdi-alphabet-tengwar::before {\n  content: \"\\F1337\";\n}\n\n.mdi-alphabetical::before {\n  content: \"\\F002C\";\n}\n\n.mdi-alphabetical-off::before {\n  content: \"\\F100C\";\n}\n\n.mdi-alphabetical-variant::before {\n  content: \"\\F100D\";\n}\n\n.mdi-alphabetical-variant-off::before {\n  content: \"\\F100E\";\n}\n\n.mdi-altimeter::before {\n  content: \"\\F05D7\";\n}\n\n.mdi-amazon::before {\n  content: \"\\F002D\";\n}\n\n.mdi-amazon-alexa::before {\n  content: \"\\F08C6\";\n}\n\n.mdi-ambulance::before {\n  content: \"\\F002F\";\n}\n\n.mdi-ammunition::before {\n  content: \"\\F0CE8\";\n}\n\n.mdi-ampersand::before {\n  content: \"\\F0A8D\";\n}\n\n.mdi-amplifier::before {\n  content: \"\\F0030\";\n}\n\n.mdi-amplifier-off::before {\n  content: \"\\F11B5\";\n}\n\n.mdi-anchor::before {\n  content: \"\\F0031\";\n}\n\n.mdi-android::before {\n  content: \"\\F0032\";\n}\n\n.mdi-android-auto::before {\n  content: \"\\F0A8E\";\n}\n\n.mdi-android-debug-bridge::before {\n  content: \"\\F0033\";\n}\n\n.mdi-android-messages::before {\n  content: \"\\F0D45\";\n}\n\n.mdi-android-studio::before {\n  content: \"\\F0034\";\n}\n\n.mdi-angle-acute::before {\n  content: \"\\F0937\";\n}\n\n.mdi-angle-obtuse::before {\n  content: \"\\F0938\";\n}\n\n.mdi-angle-right::before {\n  content: \"\\F0939\";\n}\n\n.mdi-angular::before {\n  content: \"\\F06B2\";\n}\n\n.mdi-angularjs::before {\n  content: \"\\F06BF\";\n}\n\n.mdi-animation::before {\n  content: \"\\F05D8\";\n}\n\n.mdi-animation-outline::before {\n  content: \"\\F0A8F\";\n}\n\n.mdi-animation-play::before {\n  content: \"\\F093A\";\n}\n\n.mdi-animation-play-outline::before {\n  content: \"\\F0A90\";\n}\n\n.mdi-ansible::before {\n  content: \"\\F109A\";\n}\n\n.mdi-antenna::before {\n  content: \"\\F1119\";\n}\n\n.mdi-anvil::before {\n  content: \"\\F089B\";\n}\n\n.mdi-apache-kafka::before {\n  content: \"\\F100F\";\n}\n\n.mdi-api::before {\n  content: \"\\F109B\";\n}\n\n.mdi-api-off::before {\n  content: \"\\F1257\";\n}\n\n.mdi-apple::before {\n  content: \"\\F0035\";\n}\n\n.mdi-apple-airplay::before {\n  content: \"\\F001F\";\n}\n\n.mdi-apple-finder::before {\n  content: \"\\F0036\";\n}\n\n.mdi-apple-icloud::before {\n  content: \"\\F0038\";\n}\n\n.mdi-apple-ios::before {\n  content: \"\\F0037\";\n}\n\n.mdi-apple-keyboard-caps::before {\n  content: \"\\F0632\";\n}\n\n.mdi-apple-keyboard-command::before {\n  content: \"\\F0633\";\n}\n\n.mdi-apple-keyboard-control::before {\n  content: \"\\F0634\";\n}\n\n.mdi-apple-keyboard-option::before {\n  content: \"\\F0635\";\n}\n\n.mdi-apple-keyboard-shift::before {\n  content: \"\\F0636\";\n}\n\n.mdi-apple-safari::before {\n  content: \"\\F0039\";\n}\n\n.mdi-application::before {\n  content: \"\\F0614\";\n}\n\n.mdi-application-cog::before {\n  content: \"\\F1577\";\n}\n\n.mdi-application-export::before {\n  content: \"\\F0DAD\";\n}\n\n.mdi-application-import::before {\n  content: \"\\F0DAE\";\n}\n\n.mdi-application-settings::before {\n  content: \"\\F1555\";\n}\n\n.mdi-approximately-equal::before {\n  content: \"\\F0F9E\";\n}\n\n.mdi-approximately-equal-box::before {\n  content: \"\\F0F9F\";\n}\n\n.mdi-apps::before {\n  content: \"\\F003B\";\n}\n\n.mdi-apps-box::before {\n  content: \"\\F0D46\";\n}\n\n.mdi-arch::before {\n  content: \"\\F08C7\";\n}\n\n.mdi-archive::before {\n  content: \"\\F003C\";\n}\n\n.mdi-archive-alert::before {\n  content: \"\\F14FD\";\n}\n\n.mdi-archive-alert-outline::before {\n  content: \"\\F14FE\";\n}\n\n.mdi-archive-arrow-down::before {\n  content: \"\\F1259\";\n}\n\n.mdi-archive-arrow-down-outline::before {\n  content: \"\\F125A\";\n}\n\n.mdi-archive-arrow-up::before {\n  content: \"\\F125B\";\n}\n\n.mdi-archive-arrow-up-outline::before {\n  content: \"\\F125C\";\n}\n\n.mdi-archive-outline::before {\n  content: \"\\F120E\";\n}\n\n.mdi-arm-flex::before {\n  content: \"\\F0FD7\";\n}\n\n.mdi-arm-flex-outline::before {\n  content: \"\\F0FD6\";\n}\n\n.mdi-arrange-bring-forward::before {\n  content: \"\\F003D\";\n}\n\n.mdi-arrange-bring-to-front::before {\n  content: \"\\F003E\";\n}\n\n.mdi-arrange-send-backward::before {\n  content: \"\\F003F\";\n}\n\n.mdi-arrange-send-to-back::before {\n  content: \"\\F0040\";\n}\n\n.mdi-arrow-all::before {\n  content: \"\\F0041\";\n}\n\n.mdi-arrow-bottom-left::before {\n  content: \"\\F0042\";\n}\n\n.mdi-arrow-bottom-left-bold-outline::before {\n  content: \"\\F09B7\";\n}\n\n.mdi-arrow-bottom-left-thick::before {\n  content: \"\\F09B8\";\n}\n\n.mdi-arrow-bottom-left-thin-circle-outline::before {\n  content: \"\\F1596\";\n}\n\n.mdi-arrow-bottom-right::before {\n  content: \"\\F0043\";\n}\n\n.mdi-arrow-bottom-right-bold-outline::before {\n  content: \"\\F09B9\";\n}\n\n.mdi-arrow-bottom-right-thick::before {\n  content: \"\\F09BA\";\n}\n\n.mdi-arrow-bottom-right-thin-circle-outline::before {\n  content: \"\\F1595\";\n}\n\n.mdi-arrow-collapse::before {\n  content: \"\\F0615\";\n}\n\n.mdi-arrow-collapse-all::before {\n  content: \"\\F0044\";\n}\n\n.mdi-arrow-collapse-down::before {\n  content: \"\\F0792\";\n}\n\n.mdi-arrow-collapse-horizontal::before {\n  content: \"\\F084C\";\n}\n\n.mdi-arrow-collapse-left::before {\n  content: \"\\F0793\";\n}\n\n.mdi-arrow-collapse-right::before {\n  content: \"\\F0794\";\n}\n\n.mdi-arrow-collapse-up::before {\n  content: \"\\F0795\";\n}\n\n.mdi-arrow-collapse-vertical::before {\n  content: \"\\F084D\";\n}\n\n.mdi-arrow-decision::before {\n  content: \"\\F09BB\";\n}\n\n.mdi-arrow-decision-auto::before {\n  content: \"\\F09BC\";\n}\n\n.mdi-arrow-decision-auto-outline::before {\n  content: \"\\F09BD\";\n}\n\n.mdi-arrow-decision-outline::before {\n  content: \"\\F09BE\";\n}\n\n.mdi-arrow-down::before {\n  content: \"\\F0045\";\n}\n\n.mdi-arrow-down-bold::before {\n  content: \"\\F072E\";\n}\n\n.mdi-arrow-down-bold-box::before {\n  content: \"\\F072F\";\n}\n\n.mdi-arrow-down-bold-box-outline::before {\n  content: \"\\F0730\";\n}\n\n.mdi-arrow-down-bold-circle::before {\n  content: \"\\F0047\";\n}\n\n.mdi-arrow-down-bold-circle-outline::before {\n  content: \"\\F0048\";\n}\n\n.mdi-arrow-down-bold-hexagon-outline::before {\n  content: \"\\F0049\";\n}\n\n.mdi-arrow-down-bold-outline::before {\n  content: \"\\F09BF\";\n}\n\n.mdi-arrow-down-box::before {\n  content: \"\\F06C0\";\n}\n\n.mdi-arrow-down-circle::before {\n  content: \"\\F0CDB\";\n}\n\n.mdi-arrow-down-circle-outline::before {\n  content: \"\\F0CDC\";\n}\n\n.mdi-arrow-down-drop-circle::before {\n  content: \"\\F004A\";\n}\n\n.mdi-arrow-down-drop-circle-outline::before {\n  content: \"\\F004B\";\n}\n\n.mdi-arrow-down-thick::before {\n  content: \"\\F0046\";\n}\n\n.mdi-arrow-down-thin-circle-outline::before {\n  content: \"\\F1599\";\n}\n\n.mdi-arrow-expand::before {\n  content: \"\\F0616\";\n}\n\n.mdi-arrow-expand-all::before {\n  content: \"\\F004C\";\n}\n\n.mdi-arrow-expand-down::before {\n  content: \"\\F0796\";\n}\n\n.mdi-arrow-expand-horizontal::before {\n  content: \"\\F084E\";\n}\n\n.mdi-arrow-expand-left::before {\n  content: \"\\F0797\";\n}\n\n.mdi-arrow-expand-right::before {\n  content: \"\\F0798\";\n}\n\n.mdi-arrow-expand-up::before {\n  content: \"\\F0799\";\n}\n\n.mdi-arrow-expand-vertical::before {\n  content: \"\\F084F\";\n}\n\n.mdi-arrow-horizontal-lock::before {\n  content: \"\\F115B\";\n}\n\n.mdi-arrow-left::before {\n  content: \"\\F004D\";\n}\n\n.mdi-arrow-left-bold::before {\n  content: \"\\F0731\";\n}\n\n.mdi-arrow-left-bold-box::before {\n  content: \"\\F0732\";\n}\n\n.mdi-arrow-left-bold-box-outline::before {\n  content: \"\\F0733\";\n}\n\n.mdi-arrow-left-bold-circle::before {\n  content: \"\\F004F\";\n}\n\n.mdi-arrow-left-bold-circle-outline::before {\n  content: \"\\F0050\";\n}\n\n.mdi-arrow-left-bold-hexagon-outline::before {\n  content: \"\\F0051\";\n}\n\n.mdi-arrow-left-bold-outline::before {\n  content: \"\\F09C0\";\n}\n\n.mdi-arrow-left-box::before {\n  content: \"\\F06C1\";\n}\n\n.mdi-arrow-left-circle::before {\n  content: \"\\F0CDD\";\n}\n\n.mdi-arrow-left-circle-outline::before {\n  content: \"\\F0CDE\";\n}\n\n.mdi-arrow-left-drop-circle::before {\n  content: \"\\F0052\";\n}\n\n.mdi-arrow-left-drop-circle-outline::before {\n  content: \"\\F0053\";\n}\n\n.mdi-arrow-left-right::before {\n  content: \"\\F0E73\";\n}\n\n.mdi-arrow-left-right-bold::before {\n  content: \"\\F0E74\";\n}\n\n.mdi-arrow-left-right-bold-outline::before {\n  content: \"\\F09C1\";\n}\n\n.mdi-arrow-left-thick::before {\n  content: \"\\F004E\";\n}\n\n.mdi-arrow-left-thin-circle-outline::before {\n  content: \"\\F159A\";\n}\n\n.mdi-arrow-right::before {\n  content: \"\\F0054\";\n}\n\n.mdi-arrow-right-bold::before {\n  content: \"\\F0734\";\n}\n\n.mdi-arrow-right-bold-box::before {\n  content: \"\\F0735\";\n}\n\n.mdi-arrow-right-bold-box-outline::before {\n  content: \"\\F0736\";\n}\n\n.mdi-arrow-right-bold-circle::before {\n  content: \"\\F0056\";\n}\n\n.mdi-arrow-right-bold-circle-outline::before {\n  content: \"\\F0057\";\n}\n\n.mdi-arrow-right-bold-hexagon-outline::before {\n  content: \"\\F0058\";\n}\n\n.mdi-arrow-right-bold-outline::before {\n  content: \"\\F09C2\";\n}\n\n.mdi-arrow-right-box::before {\n  content: \"\\F06C2\";\n}\n\n.mdi-arrow-right-circle::before {\n  content: \"\\F0CDF\";\n}\n\n.mdi-arrow-right-circle-outline::before {\n  content: \"\\F0CE0\";\n}\n\n.mdi-arrow-right-drop-circle::before {\n  content: \"\\F0059\";\n}\n\n.mdi-arrow-right-drop-circle-outline::before {\n  content: \"\\F005A\";\n}\n\n.mdi-arrow-right-thick::before {\n  content: \"\\F0055\";\n}\n\n.mdi-arrow-right-thin-circle-outline::before {\n  content: \"\\F1598\";\n}\n\n.mdi-arrow-split-horizontal::before {\n  content: \"\\F093B\";\n}\n\n.mdi-arrow-split-vertical::before {\n  content: \"\\F093C\";\n}\n\n.mdi-arrow-top-left::before {\n  content: \"\\F005B\";\n}\n\n.mdi-arrow-top-left-bold-outline::before {\n  content: \"\\F09C3\";\n}\n\n.mdi-arrow-top-left-bottom-right::before {\n  content: \"\\F0E75\";\n}\n\n.mdi-arrow-top-left-bottom-right-bold::before {\n  content: \"\\F0E76\";\n}\n\n.mdi-arrow-top-left-thick::before {\n  content: \"\\F09C4\";\n}\n\n.mdi-arrow-top-left-thin-circle-outline::before {\n  content: \"\\F1593\";\n}\n\n.mdi-arrow-top-right::before {\n  content: \"\\F005C\";\n}\n\n.mdi-arrow-top-right-bold-outline::before {\n  content: \"\\F09C5\";\n}\n\n.mdi-arrow-top-right-bottom-left::before {\n  content: \"\\F0E77\";\n}\n\n.mdi-arrow-top-right-bottom-left-bold::before {\n  content: \"\\F0E78\";\n}\n\n.mdi-arrow-top-right-thick::before {\n  content: \"\\F09C6\";\n}\n\n.mdi-arrow-top-right-thin-circle-outline::before {\n  content: \"\\F1594\";\n}\n\n.mdi-arrow-up::before {\n  content: \"\\F005D\";\n}\n\n.mdi-arrow-up-bold::before {\n  content: \"\\F0737\";\n}\n\n.mdi-arrow-up-bold-box::before {\n  content: \"\\F0738\";\n}\n\n.mdi-arrow-up-bold-box-outline::before {\n  content: \"\\F0739\";\n}\n\n.mdi-arrow-up-bold-circle::before {\n  content: \"\\F005F\";\n}\n\n.mdi-arrow-up-bold-circle-outline::before {\n  content: \"\\F0060\";\n}\n\n.mdi-arrow-up-bold-hexagon-outline::before {\n  content: \"\\F0061\";\n}\n\n.mdi-arrow-up-bold-outline::before {\n  content: \"\\F09C7\";\n}\n\n.mdi-arrow-up-box::before {\n  content: \"\\F06C3\";\n}\n\n.mdi-arrow-up-circle::before {\n  content: \"\\F0CE1\";\n}\n\n.mdi-arrow-up-circle-outline::before {\n  content: \"\\F0CE2\";\n}\n\n.mdi-arrow-up-down::before {\n  content: \"\\F0E79\";\n}\n\n.mdi-arrow-up-down-bold::before {\n  content: \"\\F0E7A\";\n}\n\n.mdi-arrow-up-down-bold-outline::before {\n  content: \"\\F09C8\";\n}\n\n.mdi-arrow-up-drop-circle::before {\n  content: \"\\F0062\";\n}\n\n.mdi-arrow-up-drop-circle-outline::before {\n  content: \"\\F0063\";\n}\n\n.mdi-arrow-up-thick::before {\n  content: \"\\F005E\";\n}\n\n.mdi-arrow-up-thin-circle-outline::before {\n  content: \"\\F1597\";\n}\n\n.mdi-arrow-vertical-lock::before {\n  content: \"\\F115C\";\n}\n\n.mdi-artstation::before {\n  content: \"\\F0B5B\";\n}\n\n.mdi-aspect-ratio::before {\n  content: \"\\F0A24\";\n}\n\n.mdi-assistant::before {\n  content: \"\\F0064\";\n}\n\n.mdi-asterisk::before {\n  content: \"\\F06C4\";\n}\n\n.mdi-at::before {\n  content: \"\\F0065\";\n}\n\n.mdi-atlassian::before {\n  content: \"\\F0804\";\n}\n\n.mdi-atm::before {\n  content: \"\\F0D47\";\n}\n\n.mdi-atom::before {\n  content: \"\\F0768\";\n}\n\n.mdi-atom-variant::before {\n  content: \"\\F0E7B\";\n}\n\n.mdi-attachment::before {\n  content: \"\\F0066\";\n}\n\n.mdi-audio-video::before {\n  content: \"\\F093D\";\n}\n\n.mdi-audio-video-off::before {\n  content: \"\\F11B6\";\n}\n\n.mdi-augmented-reality::before {\n  content: \"\\F0850\";\n}\n\n.mdi-auto-download::before {\n  content: \"\\F137E\";\n}\n\n.mdi-auto-fix::before {\n  content: \"\\F0068\";\n}\n\n.mdi-auto-upload::before {\n  content: \"\\F0069\";\n}\n\n.mdi-autorenew::before {\n  content: \"\\F006A\";\n}\n\n.mdi-av-timer::before {\n  content: \"\\F006B\";\n}\n\n.mdi-aws::before {\n  content: \"\\F0E0F\";\n}\n\n.mdi-axe::before {\n  content: \"\\F08C8\";\n}\n\n.mdi-axis::before {\n  content: \"\\F0D48\";\n}\n\n.mdi-axis-arrow::before {\n  content: \"\\F0D49\";\n}\n\n.mdi-axis-arrow-info::before {\n  content: \"\\F140E\";\n}\n\n.mdi-axis-arrow-lock::before {\n  content: \"\\F0D4A\";\n}\n\n.mdi-axis-lock::before {\n  content: \"\\F0D4B\";\n}\n\n.mdi-axis-x-arrow::before {\n  content: \"\\F0D4C\";\n}\n\n.mdi-axis-x-arrow-lock::before {\n  content: \"\\F0D4D\";\n}\n\n.mdi-axis-x-rotate-clockwise::before {\n  content: \"\\F0D4E\";\n}\n\n.mdi-axis-x-rotate-counterclockwise::before {\n  content: \"\\F0D4F\";\n}\n\n.mdi-axis-x-y-arrow-lock::before {\n  content: \"\\F0D50\";\n}\n\n.mdi-axis-y-arrow::before {\n  content: \"\\F0D51\";\n}\n\n.mdi-axis-y-arrow-lock::before {\n  content: \"\\F0D52\";\n}\n\n.mdi-axis-y-rotate-clockwise::before {\n  content: \"\\F0D53\";\n}\n\n.mdi-axis-y-rotate-counterclockwise::before {\n  content: \"\\F0D54\";\n}\n\n.mdi-axis-z-arrow::before {\n  content: \"\\F0D55\";\n}\n\n.mdi-axis-z-arrow-lock::before {\n  content: \"\\F0D56\";\n}\n\n.mdi-axis-z-rotate-clockwise::before {\n  content: \"\\F0D57\";\n}\n\n.mdi-axis-z-rotate-counterclockwise::before {\n  content: \"\\F0D58\";\n}\n\n.mdi-babel::before {\n  content: \"\\F0A25\";\n}\n\n.mdi-baby::before {\n  content: \"\\F006C\";\n}\n\n.mdi-baby-bottle::before {\n  content: \"\\F0F39\";\n}\n\n.mdi-baby-bottle-outline::before {\n  content: \"\\F0F3A\";\n}\n\n.mdi-baby-buggy::before {\n  content: \"\\F13E0\";\n}\n\n.mdi-baby-carriage::before {\n  content: \"\\F068F\";\n}\n\n.mdi-baby-carriage-off::before {\n  content: \"\\F0FA0\";\n}\n\n.mdi-baby-face::before {\n  content: \"\\F0E7C\";\n}\n\n.mdi-baby-face-outline::before {\n  content: \"\\F0E7D\";\n}\n\n.mdi-backburger::before {\n  content: \"\\F006D\";\n}\n\n.mdi-backspace::before {\n  content: \"\\F006E\";\n}\n\n.mdi-backspace-outline::before {\n  content: \"\\F0B5C\";\n}\n\n.mdi-backspace-reverse::before {\n  content: \"\\F0E7E\";\n}\n\n.mdi-backspace-reverse-outline::before {\n  content: \"\\F0E7F\";\n}\n\n.mdi-backup-restore::before {\n  content: \"\\F006F\";\n}\n\n.mdi-bacteria::before {\n  content: \"\\F0ED5\";\n}\n\n.mdi-bacteria-outline::before {\n  content: \"\\F0ED6\";\n}\n\n.mdi-badge-account::before {\n  content: \"\\F0DA7\";\n}\n\n.mdi-badge-account-alert::before {\n  content: \"\\F0DA8\";\n}\n\n.mdi-badge-account-alert-outline::before {\n  content: \"\\F0DA9\";\n}\n\n.mdi-badge-account-horizontal::before {\n  content: \"\\F0E0D\";\n}\n\n.mdi-badge-account-horizontal-outline::before {\n  content: \"\\F0E0E\";\n}\n\n.mdi-badge-account-outline::before {\n  content: \"\\F0DAA\";\n}\n\n.mdi-badminton::before {\n  content: \"\\F0851\";\n}\n\n.mdi-bag-carry-on::before {\n  content: \"\\F0F3B\";\n}\n\n.mdi-bag-carry-on-check::before {\n  content: \"\\F0D65\";\n}\n\n.mdi-bag-carry-on-off::before {\n  content: \"\\F0F3C\";\n}\n\n.mdi-bag-checked::before {\n  content: \"\\F0F3D\";\n}\n\n.mdi-bag-personal::before {\n  content: \"\\F0E10\";\n}\n\n.mdi-bag-personal-off::before {\n  content: \"\\F0E11\";\n}\n\n.mdi-bag-personal-off-outline::before {\n  content: \"\\F0E12\";\n}\n\n.mdi-bag-personal-outline::before {\n  content: \"\\F0E13\";\n}\n\n.mdi-bag-suitcase::before {\n  content: \"\\F158B\";\n}\n\n.mdi-bag-suitcase-off::before {\n  content: \"\\F158D\";\n}\n\n.mdi-bag-suitcase-off-outline::before {\n  content: \"\\F158E\";\n}\n\n.mdi-bag-suitcase-outline::before {\n  content: \"\\F158C\";\n}\n\n.mdi-baguette::before {\n  content: \"\\F0F3E\";\n}\n\n.mdi-balloon::before {\n  content: \"\\F0A26\";\n}\n\n.mdi-ballot::before {\n  content: \"\\F09C9\";\n}\n\n.mdi-ballot-outline::before {\n  content: \"\\F09CA\";\n}\n\n.mdi-ballot-recount::before {\n  content: \"\\F0C39\";\n}\n\n.mdi-ballot-recount-outline::before {\n  content: \"\\F0C3A\";\n}\n\n.mdi-bandage::before {\n  content: \"\\F0DAF\";\n}\n\n.mdi-bandcamp::before {\n  content: \"\\F0675\";\n}\n\n.mdi-bank::before {\n  content: \"\\F0070\";\n}\n\n.mdi-bank-check::before {\n  content: \"\\F1655\";\n}\n\n.mdi-bank-minus::before {\n  content: \"\\F0DB0\";\n}\n\n.mdi-bank-off::before {\n  content: \"\\F1656\";\n}\n\n.mdi-bank-off-outline::before {\n  content: \"\\F1657\";\n}\n\n.mdi-bank-outline::before {\n  content: \"\\F0E80\";\n}\n\n.mdi-bank-plus::before {\n  content: \"\\F0DB1\";\n}\n\n.mdi-bank-remove::before {\n  content: \"\\F0DB2\";\n}\n\n.mdi-bank-transfer::before {\n  content: \"\\F0A27\";\n}\n\n.mdi-bank-transfer-in::before {\n  content: \"\\F0A28\";\n}\n\n.mdi-bank-transfer-out::before {\n  content: \"\\F0A29\";\n}\n\n.mdi-barcode::before {\n  content: \"\\F0071\";\n}\n\n.mdi-barcode-off::before {\n  content: \"\\F1236\";\n}\n\n.mdi-barcode-scan::before {\n  content: \"\\F0072\";\n}\n\n.mdi-barley::before {\n  content: \"\\F0073\";\n}\n\n.mdi-barley-off::before {\n  content: \"\\F0B5D\";\n}\n\n.mdi-barn::before {\n  content: \"\\F0B5E\";\n}\n\n.mdi-barrel::before {\n  content: \"\\F0074\";\n}\n\n.mdi-baseball::before {\n  content: \"\\F0852\";\n}\n\n.mdi-baseball-bat::before {\n  content: \"\\F0853\";\n}\n\n.mdi-baseball-diamond::before {\n  content: \"\\F15EC\";\n}\n\n.mdi-baseball-diamond-outline::before {\n  content: \"\\F15ED\";\n}\n\n.mdi-bash::before {\n  content: \"\\F1183\";\n}\n\n.mdi-basket::before {\n  content: \"\\F0076\";\n}\n\n.mdi-basket-fill::before {\n  content: \"\\F0077\";\n}\n\n.mdi-basket-minus::before {\n  content: \"\\F1523\";\n}\n\n.mdi-basket-minus-outline::before {\n  content: \"\\F1524\";\n}\n\n.mdi-basket-off::before {\n  content: \"\\F1525\";\n}\n\n.mdi-basket-off-outline::before {\n  content: \"\\F1526\";\n}\n\n.mdi-basket-outline::before {\n  content: \"\\F1181\";\n}\n\n.mdi-basket-plus::before {\n  content: \"\\F1527\";\n}\n\n.mdi-basket-plus-outline::before {\n  content: \"\\F1528\";\n}\n\n.mdi-basket-remove::before {\n  content: \"\\F1529\";\n}\n\n.mdi-basket-remove-outline::before {\n  content: \"\\F152A\";\n}\n\n.mdi-basket-unfill::before {\n  content: \"\\F0078\";\n}\n\n.mdi-basketball::before {\n  content: \"\\F0806\";\n}\n\n.mdi-basketball-hoop::before {\n  content: \"\\F0C3B\";\n}\n\n.mdi-basketball-hoop-outline::before {\n  content: \"\\F0C3C\";\n}\n\n.mdi-bat::before {\n  content: \"\\F0B5F\";\n}\n\n.mdi-battery::before {\n  content: \"\\F0079\";\n}\n\n.mdi-battery-10::before {\n  content: \"\\F007A\";\n}\n\n.mdi-battery-10-bluetooth::before {\n  content: \"\\F093E\";\n}\n\n.mdi-battery-20::before {\n  content: \"\\F007B\";\n}\n\n.mdi-battery-20-bluetooth::before {\n  content: \"\\F093F\";\n}\n\n.mdi-battery-30::before {\n  content: \"\\F007C\";\n}\n\n.mdi-battery-30-bluetooth::before {\n  content: \"\\F0940\";\n}\n\n.mdi-battery-40::before {\n  content: \"\\F007D\";\n}\n\n.mdi-battery-40-bluetooth::before {\n  content: \"\\F0941\";\n}\n\n.mdi-battery-50::before {\n  content: \"\\F007E\";\n}\n\n.mdi-battery-50-bluetooth::before {\n  content: \"\\F0942\";\n}\n\n.mdi-battery-60::before {\n  content: \"\\F007F\";\n}\n\n.mdi-battery-60-bluetooth::before {\n  content: \"\\F0943\";\n}\n\n.mdi-battery-70::before {\n  content: \"\\F0080\";\n}\n\n.mdi-battery-70-bluetooth::before {\n  content: \"\\F0944\";\n}\n\n.mdi-battery-80::before {\n  content: \"\\F0081\";\n}\n\n.mdi-battery-80-bluetooth::before {\n  content: \"\\F0945\";\n}\n\n.mdi-battery-90::before {\n  content: \"\\F0082\";\n}\n\n.mdi-battery-90-bluetooth::before {\n  content: \"\\F0946\";\n}\n\n.mdi-battery-alert::before {\n  content: \"\\F0083\";\n}\n\n.mdi-battery-alert-bluetooth::before {\n  content: \"\\F0947\";\n}\n\n.mdi-battery-alert-variant::before {\n  content: \"\\F10CC\";\n}\n\n.mdi-battery-alert-variant-outline::before {\n  content: \"\\F10CD\";\n}\n\n.mdi-battery-bluetooth::before {\n  content: \"\\F0948\";\n}\n\n.mdi-battery-bluetooth-variant::before {\n  content: \"\\F0949\";\n}\n\n.mdi-battery-charging::before {\n  content: \"\\F0084\";\n}\n\n.mdi-battery-charging-10::before {\n  content: \"\\F089C\";\n}\n\n.mdi-battery-charging-100::before {\n  content: \"\\F0085\";\n}\n\n.mdi-battery-charging-20::before {\n  content: \"\\F0086\";\n}\n\n.mdi-battery-charging-30::before {\n  content: \"\\F0087\";\n}\n\n.mdi-battery-charging-40::before {\n  content: \"\\F0088\";\n}\n\n.mdi-battery-charging-50::before {\n  content: \"\\F089D\";\n}\n\n.mdi-battery-charging-60::before {\n  content: \"\\F0089\";\n}\n\n.mdi-battery-charging-70::before {\n  content: \"\\F089E\";\n}\n\n.mdi-battery-charging-80::before {\n  content: \"\\F008A\";\n}\n\n.mdi-battery-charging-90::before {\n  content: \"\\F008B\";\n}\n\n.mdi-battery-charging-high::before {\n  content: \"\\F12A6\";\n}\n\n.mdi-battery-charging-low::before {\n  content: \"\\F12A4\";\n}\n\n.mdi-battery-charging-medium::before {\n  content: \"\\F12A5\";\n}\n\n.mdi-battery-charging-outline::before {\n  content: \"\\F089F\";\n}\n\n.mdi-battery-charging-wireless::before {\n  content: \"\\F0807\";\n}\n\n.mdi-battery-charging-wireless-10::before {\n  content: \"\\F0808\";\n}\n\n.mdi-battery-charging-wireless-20::before {\n  content: \"\\F0809\";\n}\n\n.mdi-battery-charging-wireless-30::before {\n  content: \"\\F080A\";\n}\n\n.mdi-battery-charging-wireless-40::before {\n  content: \"\\F080B\";\n}\n\n.mdi-battery-charging-wireless-50::before {\n  content: \"\\F080C\";\n}\n\n.mdi-battery-charging-wireless-60::before {\n  content: \"\\F080D\";\n}\n\n.mdi-battery-charging-wireless-70::before {\n  content: \"\\F080E\";\n}\n\n.mdi-battery-charging-wireless-80::before {\n  content: \"\\F080F\";\n}\n\n.mdi-battery-charging-wireless-90::before {\n  content: \"\\F0810\";\n}\n\n.mdi-battery-charging-wireless-alert::before {\n  content: \"\\F0811\";\n}\n\n.mdi-battery-charging-wireless-outline::before {\n  content: \"\\F0812\";\n}\n\n.mdi-battery-heart::before {\n  content: \"\\F120F\";\n}\n\n.mdi-battery-heart-outline::before {\n  content: \"\\F1210\";\n}\n\n.mdi-battery-heart-variant::before {\n  content: \"\\F1211\";\n}\n\n.mdi-battery-high::before {\n  content: \"\\F12A3\";\n}\n\n.mdi-battery-low::before {\n  content: \"\\F12A1\";\n}\n\n.mdi-battery-medium::before {\n  content: \"\\F12A2\";\n}\n\n.mdi-battery-minus::before {\n  content: \"\\F008C\";\n}\n\n.mdi-battery-negative::before {\n  content: \"\\F008D\";\n}\n\n.mdi-battery-off::before {\n  content: \"\\F125D\";\n}\n\n.mdi-battery-off-outline::before {\n  content: \"\\F125E\";\n}\n\n.mdi-battery-outline::before {\n  content: \"\\F008E\";\n}\n\n.mdi-battery-plus::before {\n  content: \"\\F008F\";\n}\n\n.mdi-battery-positive::before {\n  content: \"\\F0090\";\n}\n\n.mdi-battery-unknown::before {\n  content: \"\\F0091\";\n}\n\n.mdi-battery-unknown-bluetooth::before {\n  content: \"\\F094A\";\n}\n\n.mdi-battlenet::before {\n  content: \"\\F0B60\";\n}\n\n.mdi-beach::before {\n  content: \"\\F0092\";\n}\n\n.mdi-beaker::before {\n  content: \"\\F0CEA\";\n}\n\n.mdi-beaker-alert::before {\n  content: \"\\F1229\";\n}\n\n.mdi-beaker-alert-outline::before {\n  content: \"\\F122A\";\n}\n\n.mdi-beaker-check::before {\n  content: \"\\F122B\";\n}\n\n.mdi-beaker-check-outline::before {\n  content: \"\\F122C\";\n}\n\n.mdi-beaker-minus::before {\n  content: \"\\F122D\";\n}\n\n.mdi-beaker-minus-outline::before {\n  content: \"\\F122E\";\n}\n\n.mdi-beaker-outline::before {\n  content: \"\\F0690\";\n}\n\n.mdi-beaker-plus::before {\n  content: \"\\F122F\";\n}\n\n.mdi-beaker-plus-outline::before {\n  content: \"\\F1230\";\n}\n\n.mdi-beaker-question::before {\n  content: \"\\F1231\";\n}\n\n.mdi-beaker-question-outline::before {\n  content: \"\\F1232\";\n}\n\n.mdi-beaker-remove::before {\n  content: \"\\F1233\";\n}\n\n.mdi-beaker-remove-outline::before {\n  content: \"\\F1234\";\n}\n\n.mdi-bed::before {\n  content: \"\\F02E3\";\n}\n\n.mdi-bed-double::before {\n  content: \"\\F0FD4\";\n}\n\n.mdi-bed-double-outline::before {\n  content: \"\\F0FD3\";\n}\n\n.mdi-bed-empty::before {\n  content: \"\\F08A0\";\n}\n\n.mdi-bed-king::before {\n  content: \"\\F0FD2\";\n}\n\n.mdi-bed-king-outline::before {\n  content: \"\\F0FD1\";\n}\n\n.mdi-bed-outline::before {\n  content: \"\\F0099\";\n}\n\n.mdi-bed-queen::before {\n  content: \"\\F0FD0\";\n}\n\n.mdi-bed-queen-outline::before {\n  content: \"\\F0FDB\";\n}\n\n.mdi-bed-single::before {\n  content: \"\\F106D\";\n}\n\n.mdi-bed-single-outline::before {\n  content: \"\\F106E\";\n}\n\n.mdi-bee::before {\n  content: \"\\F0FA1\";\n}\n\n.mdi-bee-flower::before {\n  content: \"\\F0FA2\";\n}\n\n.mdi-beehive-off-outline::before {\n  content: \"\\F13ED\";\n}\n\n.mdi-beehive-outline::before {\n  content: \"\\F10CE\";\n}\n\n.mdi-beekeeper::before {\n  content: \"\\F14E2\";\n}\n\n.mdi-beer::before {\n  content: \"\\F0098\";\n}\n\n.mdi-beer-outline::before {\n  content: \"\\F130C\";\n}\n\n.mdi-bell::before {\n  content: \"\\F009A\";\n}\n\n.mdi-bell-alert::before {\n  content: \"\\F0D59\";\n}\n\n.mdi-bell-alert-outline::before {\n  content: \"\\F0E81\";\n}\n\n.mdi-bell-cancel::before {\n  content: \"\\F13E7\";\n}\n\n.mdi-bell-cancel-outline::before {\n  content: \"\\F13E8\";\n}\n\n.mdi-bell-check::before {\n  content: \"\\F11E5\";\n}\n\n.mdi-bell-check-outline::before {\n  content: \"\\F11E6\";\n}\n\n.mdi-bell-circle::before {\n  content: \"\\F0D5A\";\n}\n\n.mdi-bell-circle-outline::before {\n  content: \"\\F0D5B\";\n}\n\n.mdi-bell-minus::before {\n  content: \"\\F13E9\";\n}\n\n.mdi-bell-minus-outline::before {\n  content: \"\\F13EA\";\n}\n\n.mdi-bell-off::before {\n  content: \"\\F009B\";\n}\n\n.mdi-bell-off-outline::before {\n  content: \"\\F0A91\";\n}\n\n.mdi-bell-outline::before {\n  content: \"\\F009C\";\n}\n\n.mdi-bell-plus::before {\n  content: \"\\F009D\";\n}\n\n.mdi-bell-plus-outline::before {\n  content: \"\\F0A92\";\n}\n\n.mdi-bell-remove::before {\n  content: \"\\F13EB\";\n}\n\n.mdi-bell-remove-outline::before {\n  content: \"\\F13EC\";\n}\n\n.mdi-bell-ring::before {\n  content: \"\\F009E\";\n}\n\n.mdi-bell-ring-outline::before {\n  content: \"\\F009F\";\n}\n\n.mdi-bell-sleep::before {\n  content: \"\\F00A0\";\n}\n\n.mdi-bell-sleep-outline::before {\n  content: \"\\F0A93\";\n}\n\n.mdi-beta::before {\n  content: \"\\F00A1\";\n}\n\n.mdi-betamax::before {\n  content: \"\\F09CB\";\n}\n\n.mdi-biathlon::before {\n  content: \"\\F0E14\";\n}\n\n.mdi-bicycle::before {\n  content: \"\\F109C\";\n}\n\n.mdi-bicycle-basket::before {\n  content: \"\\F1235\";\n}\n\n.mdi-bicycle-electric::before {\n  content: \"\\F15B4\";\n}\n\n.mdi-bicycle-penny-farthing::before {\n  content: \"\\F15E9\";\n}\n\n.mdi-bike::before {\n  content: \"\\F00A3\";\n}\n\n.mdi-bike-fast::before {\n  content: \"\\F111F\";\n}\n\n.mdi-billboard::before {\n  content: \"\\F1010\";\n}\n\n.mdi-billiards::before {\n  content: \"\\F0B61\";\n}\n\n.mdi-billiards-rack::before {\n  content: \"\\F0B62\";\n}\n\n.mdi-binoculars::before {\n  content: \"\\F00A5\";\n}\n\n.mdi-bio::before {\n  content: \"\\F00A6\";\n}\n\n.mdi-biohazard::before {\n  content: \"\\F00A7\";\n}\n\n.mdi-bird::before {\n  content: \"\\F15C6\";\n}\n\n.mdi-bitbucket::before {\n  content: \"\\F00A8\";\n}\n\n.mdi-bitcoin::before {\n  content: \"\\F0813\";\n}\n\n.mdi-black-mesa::before {\n  content: \"\\F00A9\";\n}\n\n.mdi-blender::before {\n  content: \"\\F0CEB\";\n}\n\n.mdi-blender-software::before {\n  content: \"\\F00AB\";\n}\n\n.mdi-blinds::before {\n  content: \"\\F00AC\";\n}\n\n.mdi-blinds-open::before {\n  content: \"\\F1011\";\n}\n\n.mdi-block-helper::before {\n  content: \"\\F00AD\";\n}\n\n.mdi-blogger::before {\n  content: \"\\F00AE\";\n}\n\n.mdi-blood-bag::before {\n  content: \"\\F0CEC\";\n}\n\n.mdi-bluetooth::before {\n  content: \"\\F00AF\";\n}\n\n.mdi-bluetooth-audio::before {\n  content: \"\\F00B0\";\n}\n\n.mdi-bluetooth-connect::before {\n  content: \"\\F00B1\";\n}\n\n.mdi-bluetooth-off::before {\n  content: \"\\F00B2\";\n}\n\n.mdi-bluetooth-settings::before {\n  content: \"\\F00B3\";\n}\n\n.mdi-bluetooth-transfer::before {\n  content: \"\\F00B4\";\n}\n\n.mdi-blur::before {\n  content: \"\\F00B5\";\n}\n\n.mdi-blur-linear::before {\n  content: \"\\F00B6\";\n}\n\n.mdi-blur-off::before {\n  content: \"\\F00B7\";\n}\n\n.mdi-blur-radial::before {\n  content: \"\\F00B8\";\n}\n\n.mdi-bolnisi-cross::before {\n  content: \"\\F0CED\";\n}\n\n.mdi-bolt::before {\n  content: \"\\F0DB3\";\n}\n\n.mdi-bomb::before {\n  content: \"\\F0691\";\n}\n\n.mdi-bomb-off::before {\n  content: \"\\F06C5\";\n}\n\n.mdi-bone::before {\n  content: \"\\F00B9\";\n}\n\n.mdi-book::before {\n  content: \"\\F00BA\";\n}\n\n.mdi-book-account::before {\n  content: \"\\F13AD\";\n}\n\n.mdi-book-account-outline::before {\n  content: \"\\F13AE\";\n}\n\n.mdi-book-alert::before {\n  content: \"\\F167C\";\n}\n\n.mdi-book-alert-outline::before {\n  content: \"\\F167D\";\n}\n\n.mdi-book-alphabet::before {\n  content: \"\\F061D\";\n}\n\n.mdi-book-arrow-down::before {\n  content: \"\\F167E\";\n}\n\n.mdi-book-arrow-down-outline::before {\n  content: \"\\F167F\";\n}\n\n.mdi-book-arrow-left::before {\n  content: \"\\F1680\";\n}\n\n.mdi-book-arrow-left-outline::before {\n  content: \"\\F1681\";\n}\n\n.mdi-book-arrow-right::before {\n  content: \"\\F1682\";\n}\n\n.mdi-book-arrow-right-outline::before {\n  content: \"\\F1683\";\n}\n\n.mdi-book-arrow-up::before {\n  content: \"\\F1684\";\n}\n\n.mdi-book-arrow-up-outline::before {\n  content: \"\\F1685\";\n}\n\n.mdi-book-cancel::before {\n  content: \"\\F1686\";\n}\n\n.mdi-book-cancel-outline::before {\n  content: \"\\F1687\";\n}\n\n.mdi-book-check::before {\n  content: \"\\F14F3\";\n}\n\n.mdi-book-check-outline::before {\n  content: \"\\F14F4\";\n}\n\n.mdi-book-clock::before {\n  content: \"\\F1688\";\n}\n\n.mdi-book-clock-outline::before {\n  content: \"\\F1689\";\n}\n\n.mdi-book-cog::before {\n  content: \"\\F168A\";\n}\n\n.mdi-book-cog-outline::before {\n  content: \"\\F168B\";\n}\n\n.mdi-book-cross::before {\n  content: \"\\F00A2\";\n}\n\n.mdi-book-edit::before {\n  content: \"\\F168C\";\n}\n\n.mdi-book-edit-outline::before {\n  content: \"\\F168D\";\n}\n\n.mdi-book-education::before {\n  content: \"\\F16C9\";\n}\n\n.mdi-book-education-outline::before {\n  content: \"\\F16CA\";\n}\n\n.mdi-book-information-variant::before {\n  content: \"\\F106F\";\n}\n\n.mdi-book-lock::before {\n  content: \"\\F079A\";\n}\n\n.mdi-book-lock-open::before {\n  content: \"\\F079B\";\n}\n\n.mdi-book-lock-open-outline::before {\n  content: \"\\F168E\";\n}\n\n.mdi-book-lock-outline::before {\n  content: \"\\F168F\";\n}\n\n.mdi-book-marker::before {\n  content: \"\\F1690\";\n}\n\n.mdi-book-marker-outline::before {\n  content: \"\\F1691\";\n}\n\n.mdi-book-minus::before {\n  content: \"\\F05D9\";\n}\n\n.mdi-book-minus-multiple::before {\n  content: \"\\F0A94\";\n}\n\n.mdi-book-minus-multiple-outline::before {\n  content: \"\\F090B\";\n}\n\n.mdi-book-minus-outline::before {\n  content: \"\\F1692\";\n}\n\n.mdi-book-multiple::before {\n  content: \"\\F00BB\";\n}\n\n.mdi-book-multiple-outline::before {\n  content: \"\\F0436\";\n}\n\n.mdi-book-music::before {\n  content: \"\\F0067\";\n}\n\n.mdi-book-music-outline::before {\n  content: \"\\F1693\";\n}\n\n.mdi-book-off::before {\n  content: \"\\F1694\";\n}\n\n.mdi-book-off-outline::before {\n  content: \"\\F1695\";\n}\n\n.mdi-book-open::before {\n  content: \"\\F00BD\";\n}\n\n.mdi-book-open-blank-variant::before {\n  content: \"\\F00BE\";\n}\n\n.mdi-book-open-outline::before {\n  content: \"\\F0B63\";\n}\n\n.mdi-book-open-page-variant::before {\n  content: \"\\F05DA\";\n}\n\n.mdi-book-open-page-variant-outline::before {\n  content: \"\\F15D6\";\n}\n\n.mdi-book-open-variant::before {\n  content: \"\\F14F7\";\n}\n\n.mdi-book-outline::before {\n  content: \"\\F0B64\";\n}\n\n.mdi-book-play::before {\n  content: \"\\F0E82\";\n}\n\n.mdi-book-play-outline::before {\n  content: \"\\F0E83\";\n}\n\n.mdi-book-plus::before {\n  content: \"\\F05DB\";\n}\n\n.mdi-book-plus-multiple::before {\n  content: \"\\F0A95\";\n}\n\n.mdi-book-plus-multiple-outline::before {\n  content: \"\\F0ADE\";\n}\n\n.mdi-book-plus-outline::before {\n  content: \"\\F1696\";\n}\n\n.mdi-book-refresh::before {\n  content: \"\\F1697\";\n}\n\n.mdi-book-refresh-outline::before {\n  content: \"\\F1698\";\n}\n\n.mdi-book-remove::before {\n  content: \"\\F0A97\";\n}\n\n.mdi-book-remove-multiple::before {\n  content: \"\\F0A96\";\n}\n\n.mdi-book-remove-multiple-outline::before {\n  content: \"\\F04CA\";\n}\n\n.mdi-book-remove-outline::before {\n  content: \"\\F1699\";\n}\n\n.mdi-book-search::before {\n  content: \"\\F0E84\";\n}\n\n.mdi-book-search-outline::before {\n  content: \"\\F0E85\";\n}\n\n.mdi-book-settings::before {\n  content: \"\\F169A\";\n}\n\n.mdi-book-settings-outline::before {\n  content: \"\\F169B\";\n}\n\n.mdi-book-sync::before {\n  content: \"\\F169C\";\n}\n\n.mdi-book-sync-outline::before {\n  content: \"\\F16C8\";\n}\n\n.mdi-book-variant::before {\n  content: \"\\F00BF\";\n}\n\n.mdi-book-variant-multiple::before {\n  content: \"\\F00BC\";\n}\n\n.mdi-bookmark::before {\n  content: \"\\F00C0\";\n}\n\n.mdi-bookmark-check::before {\n  content: \"\\F00C1\";\n}\n\n.mdi-bookmark-check-outline::before {\n  content: \"\\F137B\";\n}\n\n.mdi-bookmark-minus::before {\n  content: \"\\F09CC\";\n}\n\n.mdi-bookmark-minus-outline::before {\n  content: \"\\F09CD\";\n}\n\n.mdi-bookmark-multiple::before {\n  content: \"\\F0E15\";\n}\n\n.mdi-bookmark-multiple-outline::before {\n  content: \"\\F0E16\";\n}\n\n.mdi-bookmark-music::before {\n  content: \"\\F00C2\";\n}\n\n.mdi-bookmark-music-outline::before {\n  content: \"\\F1379\";\n}\n\n.mdi-bookmark-off::before {\n  content: \"\\F09CE\";\n}\n\n.mdi-bookmark-off-outline::before {\n  content: \"\\F09CF\";\n}\n\n.mdi-bookmark-outline::before {\n  content: \"\\F00C3\";\n}\n\n.mdi-bookmark-plus::before {\n  content: \"\\F00C5\";\n}\n\n.mdi-bookmark-plus-outline::before {\n  content: \"\\F00C4\";\n}\n\n.mdi-bookmark-remove::before {\n  content: \"\\F00C6\";\n}\n\n.mdi-bookmark-remove-outline::before {\n  content: \"\\F137A\";\n}\n\n.mdi-bookshelf::before {\n  content: \"\\F125F\";\n}\n\n.mdi-boom-gate::before {\n  content: \"\\F0E86\";\n}\n\n.mdi-boom-gate-alert::before {\n  content: \"\\F0E87\";\n}\n\n.mdi-boom-gate-alert-outline::before {\n  content: \"\\F0E88\";\n}\n\n.mdi-boom-gate-down::before {\n  content: \"\\F0E89\";\n}\n\n.mdi-boom-gate-down-outline::before {\n  content: \"\\F0E8A\";\n}\n\n.mdi-boom-gate-outline::before {\n  content: \"\\F0E8B\";\n}\n\n.mdi-boom-gate-up::before {\n  content: \"\\F0E8C\";\n}\n\n.mdi-boom-gate-up-outline::before {\n  content: \"\\F0E8D\";\n}\n\n.mdi-boombox::before {\n  content: \"\\F05DC\";\n}\n\n.mdi-boomerang::before {\n  content: \"\\F10CF\";\n}\n\n.mdi-bootstrap::before {\n  content: \"\\F06C6\";\n}\n\n.mdi-border-all::before {\n  content: \"\\F00C7\";\n}\n\n.mdi-border-all-variant::before {\n  content: \"\\F08A1\";\n}\n\n.mdi-border-bottom::before {\n  content: \"\\F00C8\";\n}\n\n.mdi-border-bottom-variant::before {\n  content: \"\\F08A2\";\n}\n\n.mdi-border-color::before {\n  content: \"\\F00C9\";\n}\n\n.mdi-border-horizontal::before {\n  content: \"\\F00CA\";\n}\n\n.mdi-border-inside::before {\n  content: \"\\F00CB\";\n}\n\n.mdi-border-left::before {\n  content: \"\\F00CC\";\n}\n\n.mdi-border-left-variant::before {\n  content: \"\\F08A3\";\n}\n\n.mdi-border-none::before {\n  content: \"\\F00CD\";\n}\n\n.mdi-border-none-variant::before {\n  content: \"\\F08A4\";\n}\n\n.mdi-border-outside::before {\n  content: \"\\F00CE\";\n}\n\n.mdi-border-right::before {\n  content: \"\\F00CF\";\n}\n\n.mdi-border-right-variant::before {\n  content: \"\\F08A5\";\n}\n\n.mdi-border-style::before {\n  content: \"\\F00D0\";\n}\n\n.mdi-border-top::before {\n  content: \"\\F00D1\";\n}\n\n.mdi-border-top-variant::before {\n  content: \"\\F08A6\";\n}\n\n.mdi-border-vertical::before {\n  content: \"\\F00D2\";\n}\n\n.mdi-bottle-soda::before {\n  content: \"\\F1070\";\n}\n\n.mdi-bottle-soda-classic::before {\n  content: \"\\F1071\";\n}\n\n.mdi-bottle-soda-classic-outline::before {\n  content: \"\\F1363\";\n}\n\n.mdi-bottle-soda-outline::before {\n  content: \"\\F1072\";\n}\n\n.mdi-bottle-tonic::before {\n  content: \"\\F112E\";\n}\n\n.mdi-bottle-tonic-outline::before {\n  content: \"\\F112F\";\n}\n\n.mdi-bottle-tonic-plus::before {\n  content: \"\\F1130\";\n}\n\n.mdi-bottle-tonic-plus-outline::before {\n  content: \"\\F1131\";\n}\n\n.mdi-bottle-tonic-skull::before {\n  content: \"\\F1132\";\n}\n\n.mdi-bottle-tonic-skull-outline::before {\n  content: \"\\F1133\";\n}\n\n.mdi-bottle-wine::before {\n  content: \"\\F0854\";\n}\n\n.mdi-bottle-wine-outline::before {\n  content: \"\\F1310\";\n}\n\n.mdi-bow-tie::before {\n  content: \"\\F0678\";\n}\n\n.mdi-bowl::before {\n  content: \"\\F028E\";\n}\n\n.mdi-bowl-mix::before {\n  content: \"\\F0617\";\n}\n\n.mdi-bowl-mix-outline::before {\n  content: \"\\F02E4\";\n}\n\n.mdi-bowl-outline::before {\n  content: \"\\F02A9\";\n}\n\n.mdi-bowling::before {\n  content: \"\\F00D3\";\n}\n\n.mdi-box::before {\n  content: \"\\F00D4\";\n}\n\n.mdi-box-cutter::before {\n  content: \"\\F00D5\";\n}\n\n.mdi-box-cutter-off::before {\n  content: \"\\F0B4A\";\n}\n\n.mdi-box-shadow::before {\n  content: \"\\F0637\";\n}\n\n.mdi-boxing-glove::before {\n  content: \"\\F0B65\";\n}\n\n.mdi-braille::before {\n  content: \"\\F09D0\";\n}\n\n.mdi-brain::before {\n  content: \"\\F09D1\";\n}\n\n.mdi-bread-slice::before {\n  content: \"\\F0CEE\";\n}\n\n.mdi-bread-slice-outline::before {\n  content: \"\\F0CEF\";\n}\n\n.mdi-bridge::before {\n  content: \"\\F0618\";\n}\n\n.mdi-briefcase::before {\n  content: \"\\F00D6\";\n}\n\n.mdi-briefcase-account::before {\n  content: \"\\F0CF0\";\n}\n\n.mdi-briefcase-account-outline::before {\n  content: \"\\F0CF1\";\n}\n\n.mdi-briefcase-check::before {\n  content: \"\\F00D7\";\n}\n\n.mdi-briefcase-check-outline::before {\n  content: \"\\F131E\";\n}\n\n.mdi-briefcase-clock::before {\n  content: \"\\F10D0\";\n}\n\n.mdi-briefcase-clock-outline::before {\n  content: \"\\F10D1\";\n}\n\n.mdi-briefcase-download::before {\n  content: \"\\F00D8\";\n}\n\n.mdi-briefcase-download-outline::before {\n  content: \"\\F0C3D\";\n}\n\n.mdi-briefcase-edit::before {\n  content: \"\\F0A98\";\n}\n\n.mdi-briefcase-edit-outline::before {\n  content: \"\\F0C3E\";\n}\n\n.mdi-briefcase-minus::before {\n  content: \"\\F0A2A\";\n}\n\n.mdi-briefcase-minus-outline::before {\n  content: \"\\F0C3F\";\n}\n\n.mdi-briefcase-off::before {\n  content: \"\\F1658\";\n}\n\n.mdi-briefcase-off-outline::before {\n  content: \"\\F1659\";\n}\n\n.mdi-briefcase-outline::before {\n  content: \"\\F0814\";\n}\n\n.mdi-briefcase-plus::before {\n  content: \"\\F0A2B\";\n}\n\n.mdi-briefcase-plus-outline::before {\n  content: \"\\F0C40\";\n}\n\n.mdi-briefcase-remove::before {\n  content: \"\\F0A2C\";\n}\n\n.mdi-briefcase-remove-outline::before {\n  content: \"\\F0C41\";\n}\n\n.mdi-briefcase-search::before {\n  content: \"\\F0A2D\";\n}\n\n.mdi-briefcase-search-outline::before {\n  content: \"\\F0C42\";\n}\n\n.mdi-briefcase-upload::before {\n  content: \"\\F00D9\";\n}\n\n.mdi-briefcase-upload-outline::before {\n  content: \"\\F0C43\";\n}\n\n.mdi-briefcase-variant::before {\n  content: \"\\F1494\";\n}\n\n.mdi-briefcase-variant-off::before {\n  content: \"\\F165A\";\n}\n\n.mdi-briefcase-variant-off-outline::before {\n  content: \"\\F165B\";\n}\n\n.mdi-briefcase-variant-outline::before {\n  content: \"\\F1495\";\n}\n\n.mdi-brightness-1::before {\n  content: \"\\F00DA\";\n}\n\n.mdi-brightness-2::before {\n  content: \"\\F00DB\";\n}\n\n.mdi-brightness-3::before {\n  content: \"\\F00DC\";\n}\n\n.mdi-brightness-4::before {\n  content: \"\\F00DD\";\n}\n\n.mdi-brightness-5::before {\n  content: \"\\F00DE\";\n}\n\n.mdi-brightness-6::before {\n  content: \"\\F00DF\";\n}\n\n.mdi-brightness-7::before {\n  content: \"\\F00E0\";\n}\n\n.mdi-brightness-auto::before {\n  content: \"\\F00E1\";\n}\n\n.mdi-brightness-percent::before {\n  content: \"\\F0CF2\";\n}\n\n.mdi-broadcast::before {\n  content: \"\\F1720\";\n}\n\n.mdi-broadcast-off::before {\n  content: \"\\F1721\";\n}\n\n.mdi-broom::before {\n  content: \"\\F00E2\";\n}\n\n.mdi-brush::before {\n  content: \"\\F00E3\";\n}\n\n.mdi-bucket::before {\n  content: \"\\F1415\";\n}\n\n.mdi-bucket-outline::before {\n  content: \"\\F1416\";\n}\n\n.mdi-buddhism::before {\n  content: \"\\F094B\";\n}\n\n.mdi-buffer::before {\n  content: \"\\F0619\";\n}\n\n.mdi-buffet::before {\n  content: \"\\F0578\";\n}\n\n.mdi-bug::before {\n  content: \"\\F00E4\";\n}\n\n.mdi-bug-check::before {\n  content: \"\\F0A2E\";\n}\n\n.mdi-bug-check-outline::before {\n  content: \"\\F0A2F\";\n}\n\n.mdi-bug-outline::before {\n  content: \"\\F0A30\";\n}\n\n.mdi-bugle::before {\n  content: \"\\F0DB4\";\n}\n\n.mdi-bulldozer::before {\n  content: \"\\F0B22\";\n}\n\n.mdi-bullet::before {\n  content: \"\\F0CF3\";\n}\n\n.mdi-bulletin-board::before {\n  content: \"\\F00E5\";\n}\n\n.mdi-bullhorn::before {\n  content: \"\\F00E6\";\n}\n\n.mdi-bullhorn-outline::before {\n  content: \"\\F0B23\";\n}\n\n.mdi-bullseye::before {\n  content: \"\\F05DD\";\n}\n\n.mdi-bullseye-arrow::before {\n  content: \"\\F08C9\";\n}\n\n.mdi-bulma::before {\n  content: \"\\F12E7\";\n}\n\n.mdi-bunk-bed::before {\n  content: \"\\F1302\";\n}\n\n.mdi-bunk-bed-outline::before {\n  content: \"\\F0097\";\n}\n\n.mdi-bus::before {\n  content: \"\\F00E7\";\n}\n\n.mdi-bus-alert::before {\n  content: \"\\F0A99\";\n}\n\n.mdi-bus-articulated-end::before {\n  content: \"\\F079C\";\n}\n\n.mdi-bus-articulated-front::before {\n  content: \"\\F079D\";\n}\n\n.mdi-bus-clock::before {\n  content: \"\\F08CA\";\n}\n\n.mdi-bus-double-decker::before {\n  content: \"\\F079E\";\n}\n\n.mdi-bus-marker::before {\n  content: \"\\F1212\";\n}\n\n.mdi-bus-multiple::before {\n  content: \"\\F0F3F\";\n}\n\n.mdi-bus-school::before {\n  content: \"\\F079F\";\n}\n\n.mdi-bus-side::before {\n  content: \"\\F07A0\";\n}\n\n.mdi-bus-stop::before {\n  content: \"\\F1012\";\n}\n\n.mdi-bus-stop-covered::before {\n  content: \"\\F1013\";\n}\n\n.mdi-bus-stop-uncovered::before {\n  content: \"\\F1014\";\n}\n\n.mdi-butterfly::before {\n  content: \"\\F1589\";\n}\n\n.mdi-butterfly-outline::before {\n  content: \"\\F158A\";\n}\n\n.mdi-cable-data::before {\n  content: \"\\F1394\";\n}\n\n.mdi-cached::before {\n  content: \"\\F00E8\";\n}\n\n.mdi-cactus::before {\n  content: \"\\F0DB5\";\n}\n\n.mdi-cake::before {\n  content: \"\\F00E9\";\n}\n\n.mdi-cake-layered::before {\n  content: \"\\F00EA\";\n}\n\n.mdi-cake-variant::before {\n  content: \"\\F00EB\";\n}\n\n.mdi-calculator::before {\n  content: \"\\F00EC\";\n}\n\n.mdi-calculator-variant::before {\n  content: \"\\F0A9A\";\n}\n\n.mdi-calculator-variant-outline::before {\n  content: \"\\F15A6\";\n}\n\n.mdi-calendar::before {\n  content: \"\\F00ED\";\n}\n\n.mdi-calendar-account::before {\n  content: \"\\F0ED7\";\n}\n\n.mdi-calendar-account-outline::before {\n  content: \"\\F0ED8\";\n}\n\n.mdi-calendar-alert::before {\n  content: \"\\F0A31\";\n}\n\n.mdi-calendar-arrow-left::before {\n  content: \"\\F1134\";\n}\n\n.mdi-calendar-arrow-right::before {\n  content: \"\\F1135\";\n}\n\n.mdi-calendar-blank::before {\n  content: \"\\F00EE\";\n}\n\n.mdi-calendar-blank-multiple::before {\n  content: \"\\F1073\";\n}\n\n.mdi-calendar-blank-outline::before {\n  content: \"\\F0B66\";\n}\n\n.mdi-calendar-check::before {\n  content: \"\\F00EF\";\n}\n\n.mdi-calendar-check-outline::before {\n  content: \"\\F0C44\";\n}\n\n.mdi-calendar-clock::before {\n  content: \"\\F00F0\";\n}\n\n.mdi-calendar-clock-outline::before {\n  content: \"\\F16E1\";\n}\n\n.mdi-calendar-cursor::before {\n  content: \"\\F157B\";\n}\n\n.mdi-calendar-edit::before {\n  content: \"\\F08A7\";\n}\n\n.mdi-calendar-end::before {\n  content: \"\\F166C\";\n}\n\n.mdi-calendar-export::before {\n  content: \"\\F0B24\";\n}\n\n.mdi-calendar-heart::before {\n  content: \"\\F09D2\";\n}\n\n.mdi-calendar-import::before {\n  content: \"\\F0B25\";\n}\n\n.mdi-calendar-lock::before {\n  content: \"\\F1641\";\n}\n\n.mdi-calendar-lock-outline::before {\n  content: \"\\F1642\";\n}\n\n.mdi-calendar-minus::before {\n  content: \"\\F0D5C\";\n}\n\n.mdi-calendar-month::before {\n  content: \"\\F0E17\";\n}\n\n.mdi-calendar-month-outline::before {\n  content: \"\\F0E18\";\n}\n\n.mdi-calendar-multiple::before {\n  content: \"\\F00F1\";\n}\n\n.mdi-calendar-multiple-check::before {\n  content: \"\\F00F2\";\n}\n\n.mdi-calendar-multiselect::before {\n  content: \"\\F0A32\";\n}\n\n.mdi-calendar-outline::before {\n  content: \"\\F0B67\";\n}\n\n.mdi-calendar-plus::before {\n  content: \"\\F00F3\";\n}\n\n.mdi-calendar-question::before {\n  content: \"\\F0692\";\n}\n\n.mdi-calendar-range::before {\n  content: \"\\F0679\";\n}\n\n.mdi-calendar-range-outline::before {\n  content: \"\\F0B68\";\n}\n\n.mdi-calendar-refresh::before {\n  content: \"\\F01E1\";\n}\n\n.mdi-calendar-refresh-outline::before {\n  content: \"\\F0203\";\n}\n\n.mdi-calendar-remove::before {\n  content: \"\\F00F4\";\n}\n\n.mdi-calendar-remove-outline::before {\n  content: \"\\F0C45\";\n}\n\n.mdi-calendar-search::before {\n  content: \"\\F094C\";\n}\n\n.mdi-calendar-star::before {\n  content: \"\\F09D3\";\n}\n\n.mdi-calendar-start::before {\n  content: \"\\F166D\";\n}\n\n.mdi-calendar-sync::before {\n  content: \"\\F0E8E\";\n}\n\n.mdi-calendar-sync-outline::before {\n  content: \"\\F0E8F\";\n}\n\n.mdi-calendar-text::before {\n  content: \"\\F00F5\";\n}\n\n.mdi-calendar-text-outline::before {\n  content: \"\\F0C46\";\n}\n\n.mdi-calendar-today::before {\n  content: \"\\F00F6\";\n}\n\n.mdi-calendar-week::before {\n  content: \"\\F0A33\";\n}\n\n.mdi-calendar-week-begin::before {\n  content: \"\\F0A34\";\n}\n\n.mdi-calendar-weekend::before {\n  content: \"\\F0ED9\";\n}\n\n.mdi-calendar-weekend-outline::before {\n  content: \"\\F0EDA\";\n}\n\n.mdi-call-made::before {\n  content: \"\\F00F7\";\n}\n\n.mdi-call-merge::before {\n  content: \"\\F00F8\";\n}\n\n.mdi-call-missed::before {\n  content: \"\\F00F9\";\n}\n\n.mdi-call-received::before {\n  content: \"\\F00FA\";\n}\n\n.mdi-call-split::before {\n  content: \"\\F00FB\";\n}\n\n.mdi-camcorder::before {\n  content: \"\\F00FC\";\n}\n\n.mdi-camcorder-off::before {\n  content: \"\\F00FF\";\n}\n\n.mdi-camera::before {\n  content: \"\\F0100\";\n}\n\n.mdi-camera-account::before {\n  content: \"\\F08CB\";\n}\n\n.mdi-camera-burst::before {\n  content: \"\\F0693\";\n}\n\n.mdi-camera-control::before {\n  content: \"\\F0B69\";\n}\n\n.mdi-camera-enhance::before {\n  content: \"\\F0101\";\n}\n\n.mdi-camera-enhance-outline::before {\n  content: \"\\F0B6A\";\n}\n\n.mdi-camera-flip::before {\n  content: \"\\F15D9\";\n}\n\n.mdi-camera-flip-outline::before {\n  content: \"\\F15DA\";\n}\n\n.mdi-camera-front::before {\n  content: \"\\F0102\";\n}\n\n.mdi-camera-front-variant::before {\n  content: \"\\F0103\";\n}\n\n.mdi-camera-gopro::before {\n  content: \"\\F07A1\";\n}\n\n.mdi-camera-image::before {\n  content: \"\\F08CC\";\n}\n\n.mdi-camera-iris::before {\n  content: \"\\F0104\";\n}\n\n.mdi-camera-metering-center::before {\n  content: \"\\F07A2\";\n}\n\n.mdi-camera-metering-matrix::before {\n  content: \"\\F07A3\";\n}\n\n.mdi-camera-metering-partial::before {\n  content: \"\\F07A4\";\n}\n\n.mdi-camera-metering-spot::before {\n  content: \"\\F07A5\";\n}\n\n.mdi-camera-off::before {\n  content: \"\\F05DF\";\n}\n\n.mdi-camera-outline::before {\n  content: \"\\F0D5D\";\n}\n\n.mdi-camera-party-mode::before {\n  content: \"\\F0105\";\n}\n\n.mdi-camera-plus::before {\n  content: \"\\F0EDB\";\n}\n\n.mdi-camera-plus-outline::before {\n  content: \"\\F0EDC\";\n}\n\n.mdi-camera-rear::before {\n  content: \"\\F0106\";\n}\n\n.mdi-camera-rear-variant::before {\n  content: \"\\F0107\";\n}\n\n.mdi-camera-retake::before {\n  content: \"\\F0E19\";\n}\n\n.mdi-camera-retake-outline::before {\n  content: \"\\F0E1A\";\n}\n\n.mdi-camera-switch::before {\n  content: \"\\F0108\";\n}\n\n.mdi-camera-switch-outline::before {\n  content: \"\\F084A\";\n}\n\n.mdi-camera-timer::before {\n  content: \"\\F0109\";\n}\n\n.mdi-camera-wireless::before {\n  content: \"\\F0DB6\";\n}\n\n.mdi-camera-wireless-outline::before {\n  content: \"\\F0DB7\";\n}\n\n.mdi-campfire::before {\n  content: \"\\F0EDD\";\n}\n\n.mdi-cancel::before {\n  content: \"\\F073A\";\n}\n\n.mdi-candle::before {\n  content: \"\\F05E2\";\n}\n\n.mdi-candycane::before {\n  content: \"\\F010A\";\n}\n\n.mdi-cannabis::before {\n  content: \"\\F07A6\";\n}\n\n.mdi-cannabis-off::before {\n  content: \"\\F166E\";\n}\n\n.mdi-caps-lock::before {\n  content: \"\\F0A9B\";\n}\n\n.mdi-car::before {\n  content: \"\\F010B\";\n}\n\n.mdi-car-2-plus::before {\n  content: \"\\F1015\";\n}\n\n.mdi-car-3-plus::before {\n  content: \"\\F1016\";\n}\n\n.mdi-car-arrow-left::before {\n  content: \"\\F13B2\";\n}\n\n.mdi-car-arrow-right::before {\n  content: \"\\F13B3\";\n}\n\n.mdi-car-back::before {\n  content: \"\\F0E1B\";\n}\n\n.mdi-car-battery::before {\n  content: \"\\F010C\";\n}\n\n.mdi-car-brake-abs::before {\n  content: \"\\F0C47\";\n}\n\n.mdi-car-brake-alert::before {\n  content: \"\\F0C48\";\n}\n\n.mdi-car-brake-hold::before {\n  content: \"\\F0D5E\";\n}\n\n.mdi-car-brake-parking::before {\n  content: \"\\F0D5F\";\n}\n\n.mdi-car-brake-retarder::before {\n  content: \"\\F1017\";\n}\n\n.mdi-car-child-seat::before {\n  content: \"\\F0FA3\";\n}\n\n.mdi-car-clutch::before {\n  content: \"\\F1018\";\n}\n\n.mdi-car-cog::before {\n  content: \"\\F13CC\";\n}\n\n.mdi-car-connected::before {\n  content: \"\\F010D\";\n}\n\n.mdi-car-convertible::before {\n  content: \"\\F07A7\";\n}\n\n.mdi-car-coolant-level::before {\n  content: \"\\F1019\";\n}\n\n.mdi-car-cruise-control::before {\n  content: \"\\F0D60\";\n}\n\n.mdi-car-defrost-front::before {\n  content: \"\\F0D61\";\n}\n\n.mdi-car-defrost-rear::before {\n  content: \"\\F0D62\";\n}\n\n.mdi-car-door::before {\n  content: \"\\F0B6B\";\n}\n\n.mdi-car-door-lock::before {\n  content: \"\\F109D\";\n}\n\n.mdi-car-electric::before {\n  content: \"\\F0B6C\";\n}\n\n.mdi-car-electric-outline::before {\n  content: \"\\F15B5\";\n}\n\n.mdi-car-emergency::before {\n  content: \"\\F160F\";\n}\n\n.mdi-car-esp::before {\n  content: \"\\F0C49\";\n}\n\n.mdi-car-estate::before {\n  content: \"\\F07A8\";\n}\n\n.mdi-car-hatchback::before {\n  content: \"\\F07A9\";\n}\n\n.mdi-car-info::before {\n  content: \"\\F11BE\";\n}\n\n.mdi-car-key::before {\n  content: \"\\F0B6D\";\n}\n\n.mdi-car-lifted-pickup::before {\n  content: \"\\F152D\";\n}\n\n.mdi-car-light-dimmed::before {\n  content: \"\\F0C4A\";\n}\n\n.mdi-car-light-fog::before {\n  content: \"\\F0C4B\";\n}\n\n.mdi-car-light-high::before {\n  content: \"\\F0C4C\";\n}\n\n.mdi-car-limousine::before {\n  content: \"\\F08CD\";\n}\n\n.mdi-car-multiple::before {\n  content: \"\\F0B6E\";\n}\n\n.mdi-car-off::before {\n  content: \"\\F0E1C\";\n}\n\n.mdi-car-outline::before {\n  content: \"\\F14ED\";\n}\n\n.mdi-car-parking-lights::before {\n  content: \"\\F0D63\";\n}\n\n.mdi-car-pickup::before {\n  content: \"\\F07AA\";\n}\n\n.mdi-car-seat::before {\n  content: \"\\F0FA4\";\n}\n\n.mdi-car-seat-cooler::before {\n  content: \"\\F0FA5\";\n}\n\n.mdi-car-seat-heater::before {\n  content: \"\\F0FA6\";\n}\n\n.mdi-car-settings::before {\n  content: \"\\F13CD\";\n}\n\n.mdi-car-shift-pattern::before {\n  content: \"\\F0F40\";\n}\n\n.mdi-car-side::before {\n  content: \"\\F07AB\";\n}\n\n.mdi-car-sports::before {\n  content: \"\\F07AC\";\n}\n\n.mdi-car-tire-alert::before {\n  content: \"\\F0C4D\";\n}\n\n.mdi-car-traction-control::before {\n  content: \"\\F0D64\";\n}\n\n.mdi-car-turbocharger::before {\n  content: \"\\F101A\";\n}\n\n.mdi-car-wash::before {\n  content: \"\\F010E\";\n}\n\n.mdi-car-windshield::before {\n  content: \"\\F101B\";\n}\n\n.mdi-car-windshield-outline::before {\n  content: \"\\F101C\";\n}\n\n.mdi-carabiner::before {\n  content: \"\\F14C0\";\n}\n\n.mdi-caravan::before {\n  content: \"\\F07AD\";\n}\n\n.mdi-card::before {\n  content: \"\\F0B6F\";\n}\n\n.mdi-card-account-details::before {\n  content: \"\\F05D2\";\n}\n\n.mdi-card-account-details-outline::before {\n  content: \"\\F0DAB\";\n}\n\n.mdi-card-account-details-star::before {\n  content: \"\\F02A3\";\n}\n\n.mdi-card-account-details-star-outline::before {\n  content: \"\\F06DB\";\n}\n\n.mdi-card-account-mail::before {\n  content: \"\\F018E\";\n}\n\n.mdi-card-account-mail-outline::before {\n  content: \"\\F0E98\";\n}\n\n.mdi-card-account-phone::before {\n  content: \"\\F0E99\";\n}\n\n.mdi-card-account-phone-outline::before {\n  content: \"\\F0E9A\";\n}\n\n.mdi-card-bulleted::before {\n  content: \"\\F0B70\";\n}\n\n.mdi-card-bulleted-off::before {\n  content: \"\\F0B71\";\n}\n\n.mdi-card-bulleted-off-outline::before {\n  content: \"\\F0B72\";\n}\n\n.mdi-card-bulleted-outline::before {\n  content: \"\\F0B73\";\n}\n\n.mdi-card-bulleted-settings::before {\n  content: \"\\F0B74\";\n}\n\n.mdi-card-bulleted-settings-outline::before {\n  content: \"\\F0B75\";\n}\n\n.mdi-card-minus::before {\n  content: \"\\F1600\";\n}\n\n.mdi-card-minus-outline::before {\n  content: \"\\F1601\";\n}\n\n.mdi-card-off::before {\n  content: \"\\F1602\";\n}\n\n.mdi-card-off-outline::before {\n  content: \"\\F1603\";\n}\n\n.mdi-card-outline::before {\n  content: \"\\F0B76\";\n}\n\n.mdi-card-plus::before {\n  content: \"\\F11FF\";\n}\n\n.mdi-card-plus-outline::before {\n  content: \"\\F1200\";\n}\n\n.mdi-card-remove::before {\n  content: \"\\F1604\";\n}\n\n.mdi-card-remove-outline::before {\n  content: \"\\F1605\";\n}\n\n.mdi-card-search::before {\n  content: \"\\F1074\";\n}\n\n.mdi-card-search-outline::before {\n  content: \"\\F1075\";\n}\n\n.mdi-card-text::before {\n  content: \"\\F0B77\";\n}\n\n.mdi-card-text-outline::before {\n  content: \"\\F0B78\";\n}\n\n.mdi-cards::before {\n  content: \"\\F0638\";\n}\n\n.mdi-cards-club::before {\n  content: \"\\F08CE\";\n}\n\n.mdi-cards-diamond::before {\n  content: \"\\F08CF\";\n}\n\n.mdi-cards-diamond-outline::before {\n  content: \"\\F101D\";\n}\n\n.mdi-cards-heart::before {\n  content: \"\\F08D0\";\n}\n\n.mdi-cards-outline::before {\n  content: \"\\F0639\";\n}\n\n.mdi-cards-playing-outline::before {\n  content: \"\\F063A\";\n}\n\n.mdi-cards-spade::before {\n  content: \"\\F08D1\";\n}\n\n.mdi-cards-variant::before {\n  content: \"\\F06C7\";\n}\n\n.mdi-carrot::before {\n  content: \"\\F010F\";\n}\n\n.mdi-cart::before {\n  content: \"\\F0110\";\n}\n\n.mdi-cart-arrow-down::before {\n  content: \"\\F0D66\";\n}\n\n.mdi-cart-arrow-right::before {\n  content: \"\\F0C4E\";\n}\n\n.mdi-cart-arrow-up::before {\n  content: \"\\F0D67\";\n}\n\n.mdi-cart-check::before {\n  content: \"\\F15EA\";\n}\n\n.mdi-cart-minus::before {\n  content: \"\\F0D68\";\n}\n\n.mdi-cart-off::before {\n  content: \"\\F066B\";\n}\n\n.mdi-cart-outline::before {\n  content: \"\\F0111\";\n}\n\n.mdi-cart-plus::before {\n  content: \"\\F0112\";\n}\n\n.mdi-cart-remove::before {\n  content: \"\\F0D69\";\n}\n\n.mdi-cart-variant::before {\n  content: \"\\F15EB\";\n}\n\n.mdi-case-sensitive-alt::before {\n  content: \"\\F0113\";\n}\n\n.mdi-cash::before {\n  content: \"\\F0114\";\n}\n\n.mdi-cash-100::before {\n  content: \"\\F0115\";\n}\n\n.mdi-cash-check::before {\n  content: \"\\F14EE\";\n}\n\n.mdi-cash-lock::before {\n  content: \"\\F14EA\";\n}\n\n.mdi-cash-lock-open::before {\n  content: \"\\F14EB\";\n}\n\n.mdi-cash-marker::before {\n  content: \"\\F0DB8\";\n}\n\n.mdi-cash-minus::before {\n  content: \"\\F1260\";\n}\n\n.mdi-cash-multiple::before {\n  content: \"\\F0116\";\n}\n\n.mdi-cash-plus::before {\n  content: \"\\F1261\";\n}\n\n.mdi-cash-refund::before {\n  content: \"\\F0A9C\";\n}\n\n.mdi-cash-register::before {\n  content: \"\\F0CF4\";\n}\n\n.mdi-cash-remove::before {\n  content: \"\\F1262\";\n}\n\n.mdi-cash-usd::before {\n  content: \"\\F1176\";\n}\n\n.mdi-cash-usd-outline::before {\n  content: \"\\F0117\";\n}\n\n.mdi-cassette::before {\n  content: \"\\F09D4\";\n}\n\n.mdi-cast::before {\n  content: \"\\F0118\";\n}\n\n.mdi-cast-audio::before {\n  content: \"\\F101E\";\n}\n\n.mdi-cast-connected::before {\n  content: \"\\F0119\";\n}\n\n.mdi-cast-education::before {\n  content: \"\\F0E1D\";\n}\n\n.mdi-cast-off::before {\n  content: \"\\F078A\";\n}\n\n.mdi-castle::before {\n  content: \"\\F011A\";\n}\n\n.mdi-cat::before {\n  content: \"\\F011B\";\n}\n\n.mdi-cctv::before {\n  content: \"\\F07AE\";\n}\n\n.mdi-ceiling-light::before {\n  content: \"\\F0769\";\n}\n\n.mdi-cellphone::before {\n  content: \"\\F011C\";\n}\n\n.mdi-cellphone-android::before {\n  content: \"\\F011D\";\n}\n\n.mdi-cellphone-arrow-down::before {\n  content: \"\\F09D5\";\n}\n\n.mdi-cellphone-basic::before {\n  content: \"\\F011E\";\n}\n\n.mdi-cellphone-charging::before {\n  content: \"\\F1397\";\n}\n\n.mdi-cellphone-cog::before {\n  content: \"\\F0951\";\n}\n\n.mdi-cellphone-dock::before {\n  content: \"\\F011F\";\n}\n\n.mdi-cellphone-erase::before {\n  content: \"\\F094D\";\n}\n\n.mdi-cellphone-information::before {\n  content: \"\\F0F41\";\n}\n\n.mdi-cellphone-iphone::before {\n  content: \"\\F0120\";\n}\n\n.mdi-cellphone-key::before {\n  content: \"\\F094E\";\n}\n\n.mdi-cellphone-link::before {\n  content: \"\\F0121\";\n}\n\n.mdi-cellphone-link-off::before {\n  content: \"\\F0122\";\n}\n\n.mdi-cellphone-lock::before {\n  content: \"\\F094F\";\n}\n\n.mdi-cellphone-message::before {\n  content: \"\\F08D3\";\n}\n\n.mdi-cellphone-message-off::before {\n  content: \"\\F10D2\";\n}\n\n.mdi-cellphone-nfc::before {\n  content: \"\\F0E90\";\n}\n\n.mdi-cellphone-nfc-off::before {\n  content: \"\\F12D8\";\n}\n\n.mdi-cellphone-off::before {\n  content: \"\\F0950\";\n}\n\n.mdi-cellphone-play::before {\n  content: \"\\F101F\";\n}\n\n.mdi-cellphone-screenshot::before {\n  content: \"\\F0A35\";\n}\n\n.mdi-cellphone-settings::before {\n  content: \"\\F0123\";\n}\n\n.mdi-cellphone-sound::before {\n  content: \"\\F0952\";\n}\n\n.mdi-cellphone-text::before {\n  content: \"\\F08D2\";\n}\n\n.mdi-cellphone-wireless::before {\n  content: \"\\F0815\";\n}\n\n.mdi-celtic-cross::before {\n  content: \"\\F0CF5\";\n}\n\n.mdi-centos::before {\n  content: \"\\F111A\";\n}\n\n.mdi-certificate::before {\n  content: \"\\F0124\";\n}\n\n.mdi-certificate-outline::before {\n  content: \"\\F1188\";\n}\n\n.mdi-chair-rolling::before {\n  content: \"\\F0F48\";\n}\n\n.mdi-chair-school::before {\n  content: \"\\F0125\";\n}\n\n.mdi-charity::before {\n  content: \"\\F0C4F\";\n}\n\n.mdi-chart-arc::before {\n  content: \"\\F0126\";\n}\n\n.mdi-chart-areaspline::before {\n  content: \"\\F0127\";\n}\n\n.mdi-chart-areaspline-variant::before {\n  content: \"\\F0E91\";\n}\n\n.mdi-chart-bar::before {\n  content: \"\\F0128\";\n}\n\n.mdi-chart-bar-stacked::before {\n  content: \"\\F076A\";\n}\n\n.mdi-chart-bell-curve::before {\n  content: \"\\F0C50\";\n}\n\n.mdi-chart-bell-curve-cumulative::before {\n  content: \"\\F0FA7\";\n}\n\n.mdi-chart-box::before {\n  content: \"\\F154D\";\n}\n\n.mdi-chart-box-outline::before {\n  content: \"\\F154E\";\n}\n\n.mdi-chart-box-plus-outline::before {\n  content: \"\\F154F\";\n}\n\n.mdi-chart-bubble::before {\n  content: \"\\F05E3\";\n}\n\n.mdi-chart-donut::before {\n  content: \"\\F07AF\";\n}\n\n.mdi-chart-donut-variant::before {\n  content: \"\\F07B0\";\n}\n\n.mdi-chart-gantt::before {\n  content: \"\\F066C\";\n}\n\n.mdi-chart-histogram::before {\n  content: \"\\F0129\";\n}\n\n.mdi-chart-line::before {\n  content: \"\\F012A\";\n}\n\n.mdi-chart-line-stacked::before {\n  content: \"\\F076B\";\n}\n\n.mdi-chart-line-variant::before {\n  content: \"\\F07B1\";\n}\n\n.mdi-chart-multiline::before {\n  content: \"\\F08D4\";\n}\n\n.mdi-chart-multiple::before {\n  content: \"\\F1213\";\n}\n\n.mdi-chart-pie::before {\n  content: \"\\F012B\";\n}\n\n.mdi-chart-ppf::before {\n  content: \"\\F1380\";\n}\n\n.mdi-chart-sankey::before {\n  content: \"\\F11DF\";\n}\n\n.mdi-chart-sankey-variant::before {\n  content: \"\\F11E0\";\n}\n\n.mdi-chart-scatter-plot::before {\n  content: \"\\F0E92\";\n}\n\n.mdi-chart-scatter-plot-hexbin::before {\n  content: \"\\F066D\";\n}\n\n.mdi-chart-timeline::before {\n  content: \"\\F066E\";\n}\n\n.mdi-chart-timeline-variant::before {\n  content: \"\\F0E93\";\n}\n\n.mdi-chart-timeline-variant-shimmer::before {\n  content: \"\\F15B6\";\n}\n\n.mdi-chart-tree::before {\n  content: \"\\F0E94\";\n}\n\n.mdi-chat::before {\n  content: \"\\F0B79\";\n}\n\n.mdi-chat-alert::before {\n  content: \"\\F0B7A\";\n}\n\n.mdi-chat-alert-outline::before {\n  content: \"\\F12C9\";\n}\n\n.mdi-chat-minus::before {\n  content: \"\\F1410\";\n}\n\n.mdi-chat-minus-outline::before {\n  content: \"\\F1413\";\n}\n\n.mdi-chat-outline::before {\n  content: \"\\F0EDE\";\n}\n\n.mdi-chat-plus::before {\n  content: \"\\F140F\";\n}\n\n.mdi-chat-plus-outline::before {\n  content: \"\\F1412\";\n}\n\n.mdi-chat-processing::before {\n  content: \"\\F0B7B\";\n}\n\n.mdi-chat-processing-outline::before {\n  content: \"\\F12CA\";\n}\n\n.mdi-chat-question::before {\n  content: \"\\F1738\";\n}\n\n.mdi-chat-question-outline::before {\n  content: \"\\F1739\";\n}\n\n.mdi-chat-remove::before {\n  content: \"\\F1411\";\n}\n\n.mdi-chat-remove-outline::before {\n  content: \"\\F1414\";\n}\n\n.mdi-chat-sleep::before {\n  content: \"\\F12D1\";\n}\n\n.mdi-chat-sleep-outline::before {\n  content: \"\\F12D2\";\n}\n\n.mdi-check::before {\n  content: \"\\F012C\";\n}\n\n.mdi-check-all::before {\n  content: \"\\F012D\";\n}\n\n.mdi-check-bold::before {\n  content: \"\\F0E1E\";\n}\n\n.mdi-check-box-multiple-outline::before {\n  content: \"\\F0C51\";\n}\n\n.mdi-check-box-outline::before {\n  content: \"\\F0C52\";\n}\n\n.mdi-check-circle::before {\n  content: \"\\F05E0\";\n}\n\n.mdi-check-circle-outline::before {\n  content: \"\\F05E1\";\n}\n\n.mdi-check-decagram::before {\n  content: \"\\F0791\";\n}\n\n.mdi-check-decagram-outline::before {\n  content: \"\\F1740\";\n}\n\n.mdi-check-network::before {\n  content: \"\\F0C53\";\n}\n\n.mdi-check-network-outline::before {\n  content: \"\\F0C54\";\n}\n\n.mdi-check-outline::before {\n  content: \"\\F0855\";\n}\n\n.mdi-check-underline::before {\n  content: \"\\F0E1F\";\n}\n\n.mdi-check-underline-circle::before {\n  content: \"\\F0E20\";\n}\n\n.mdi-check-underline-circle-outline::before {\n  content: \"\\F0E21\";\n}\n\n.mdi-checkbook::before {\n  content: \"\\F0A9D\";\n}\n\n.mdi-checkbox-blank::before {\n  content: \"\\F012E\";\n}\n\n.mdi-checkbox-blank-circle::before {\n  content: \"\\F012F\";\n}\n\n.mdi-checkbox-blank-circle-outline::before {\n  content: \"\\F0130\";\n}\n\n.mdi-checkbox-blank-off::before {\n  content: \"\\F12EC\";\n}\n\n.mdi-checkbox-blank-off-outline::before {\n  content: \"\\F12ED\";\n}\n\n.mdi-checkbox-blank-outline::before {\n  content: \"\\F0131\";\n}\n\n.mdi-checkbox-intermediate::before {\n  content: \"\\F0856\";\n}\n\n.mdi-checkbox-marked::before {\n  content: \"\\F0132\";\n}\n\n.mdi-checkbox-marked-circle::before {\n  content: \"\\F0133\";\n}\n\n.mdi-checkbox-marked-circle-outline::before {\n  content: \"\\F0134\";\n}\n\n.mdi-checkbox-marked-outline::before {\n  content: \"\\F0135\";\n}\n\n.mdi-checkbox-multiple-blank::before {\n  content: \"\\F0136\";\n}\n\n.mdi-checkbox-multiple-blank-circle::before {\n  content: \"\\F063B\";\n}\n\n.mdi-checkbox-multiple-blank-circle-outline::before {\n  content: \"\\F063C\";\n}\n\n.mdi-checkbox-multiple-blank-outline::before {\n  content: \"\\F0137\";\n}\n\n.mdi-checkbox-multiple-marked::before {\n  content: \"\\F0138\";\n}\n\n.mdi-checkbox-multiple-marked-circle::before {\n  content: \"\\F063D\";\n}\n\n.mdi-checkbox-multiple-marked-circle-outline::before {\n  content: \"\\F063E\";\n}\n\n.mdi-checkbox-multiple-marked-outline::before {\n  content: \"\\F0139\";\n}\n\n.mdi-checkerboard::before {\n  content: \"\\F013A\";\n}\n\n.mdi-checkerboard-minus::before {\n  content: \"\\F1202\";\n}\n\n.mdi-checkerboard-plus::before {\n  content: \"\\F1201\";\n}\n\n.mdi-checkerboard-remove::before {\n  content: \"\\F1203\";\n}\n\n.mdi-cheese::before {\n  content: \"\\F12B9\";\n}\n\n.mdi-cheese-off::before {\n  content: \"\\F13EE\";\n}\n\n.mdi-chef-hat::before {\n  content: \"\\F0B7C\";\n}\n\n.mdi-chemical-weapon::before {\n  content: \"\\F013B\";\n}\n\n.mdi-chess-bishop::before {\n  content: \"\\F085C\";\n}\n\n.mdi-chess-king::before {\n  content: \"\\F0857\";\n}\n\n.mdi-chess-knight::before {\n  content: \"\\F0858\";\n}\n\n.mdi-chess-pawn::before {\n  content: \"\\F0859\";\n}\n\n.mdi-chess-queen::before {\n  content: \"\\F085A\";\n}\n\n.mdi-chess-rook::before {\n  content: \"\\F085B\";\n}\n\n.mdi-chevron-double-down::before {\n  content: \"\\F013C\";\n}\n\n.mdi-chevron-double-left::before {\n  content: \"\\F013D\";\n}\n\n.mdi-chevron-double-right::before {\n  content: \"\\F013E\";\n}\n\n.mdi-chevron-double-up::before {\n  content: \"\\F013F\";\n}\n\n.mdi-chevron-down::before {\n  content: \"\\F0140\";\n}\n\n.mdi-chevron-down-box::before {\n  content: \"\\F09D6\";\n}\n\n.mdi-chevron-down-box-outline::before {\n  content: \"\\F09D7\";\n}\n\n.mdi-chevron-down-circle::before {\n  content: \"\\F0B26\";\n}\n\n.mdi-chevron-down-circle-outline::before {\n  content: \"\\F0B27\";\n}\n\n.mdi-chevron-left::before {\n  content: \"\\F0141\";\n}\n\n.mdi-chevron-left-box::before {\n  content: \"\\F09D8\";\n}\n\n.mdi-chevron-left-box-outline::before {\n  content: \"\\F09D9\";\n}\n\n.mdi-chevron-left-circle::before {\n  content: \"\\F0B28\";\n}\n\n.mdi-chevron-left-circle-outline::before {\n  content: \"\\F0B29\";\n}\n\n.mdi-chevron-right::before {\n  content: \"\\F0142\";\n}\n\n.mdi-chevron-right-box::before {\n  content: \"\\F09DA\";\n}\n\n.mdi-chevron-right-box-outline::before {\n  content: \"\\F09DB\";\n}\n\n.mdi-chevron-right-circle::before {\n  content: \"\\F0B2A\";\n}\n\n.mdi-chevron-right-circle-outline::before {\n  content: \"\\F0B2B\";\n}\n\n.mdi-chevron-triple-down::before {\n  content: \"\\F0DB9\";\n}\n\n.mdi-chevron-triple-left::before {\n  content: \"\\F0DBA\";\n}\n\n.mdi-chevron-triple-right::before {\n  content: \"\\F0DBB\";\n}\n\n.mdi-chevron-triple-up::before {\n  content: \"\\F0DBC\";\n}\n\n.mdi-chevron-up::before {\n  content: \"\\F0143\";\n}\n\n.mdi-chevron-up-box::before {\n  content: \"\\F09DC\";\n}\n\n.mdi-chevron-up-box-outline::before {\n  content: \"\\F09DD\";\n}\n\n.mdi-chevron-up-circle::before {\n  content: \"\\F0B2C\";\n}\n\n.mdi-chevron-up-circle-outline::before {\n  content: \"\\F0B2D\";\n}\n\n.mdi-chili-hot::before {\n  content: \"\\F07B2\";\n}\n\n.mdi-chili-medium::before {\n  content: \"\\F07B3\";\n}\n\n.mdi-chili-mild::before {\n  content: \"\\F07B4\";\n}\n\n.mdi-chili-off::before {\n  content: \"\\F1467\";\n}\n\n.mdi-chip::before {\n  content: \"\\F061A\";\n}\n\n.mdi-christianity::before {\n  content: \"\\F0953\";\n}\n\n.mdi-christianity-outline::before {\n  content: \"\\F0CF6\";\n}\n\n.mdi-church::before {\n  content: \"\\F0144\";\n}\n\n.mdi-cigar::before {\n  content: \"\\F1189\";\n}\n\n.mdi-cigar-off::before {\n  content: \"\\F141B\";\n}\n\n.mdi-circle::before {\n  content: \"\\F0765\";\n}\n\n.mdi-circle-box::before {\n  content: \"\\F15DC\";\n}\n\n.mdi-circle-box-outline::before {\n  content: \"\\F15DD\";\n}\n\n.mdi-circle-double::before {\n  content: \"\\F0E95\";\n}\n\n.mdi-circle-edit-outline::before {\n  content: \"\\F08D5\";\n}\n\n.mdi-circle-expand::before {\n  content: \"\\F0E96\";\n}\n\n.mdi-circle-half::before {\n  content: \"\\F1395\";\n}\n\n.mdi-circle-half-full::before {\n  content: \"\\F1396\";\n}\n\n.mdi-circle-medium::before {\n  content: \"\\F09DE\";\n}\n\n.mdi-circle-multiple::before {\n  content: \"\\F0B38\";\n}\n\n.mdi-circle-multiple-outline::before {\n  content: \"\\F0695\";\n}\n\n.mdi-circle-off-outline::before {\n  content: \"\\F10D3\";\n}\n\n.mdi-circle-outline::before {\n  content: \"\\F0766\";\n}\n\n.mdi-circle-slice-1::before {\n  content: \"\\F0A9E\";\n}\n\n.mdi-circle-slice-2::before {\n  content: \"\\F0A9F\";\n}\n\n.mdi-circle-slice-3::before {\n  content: \"\\F0AA0\";\n}\n\n.mdi-circle-slice-4::before {\n  content: \"\\F0AA1\";\n}\n\n.mdi-circle-slice-5::before {\n  content: \"\\F0AA2\";\n}\n\n.mdi-circle-slice-6::before {\n  content: \"\\F0AA3\";\n}\n\n.mdi-circle-slice-7::before {\n  content: \"\\F0AA4\";\n}\n\n.mdi-circle-slice-8::before {\n  content: \"\\F0AA5\";\n}\n\n.mdi-circle-small::before {\n  content: \"\\F09DF\";\n}\n\n.mdi-circular-saw::before {\n  content: \"\\F0E22\";\n}\n\n.mdi-city::before {\n  content: \"\\F0146\";\n}\n\n.mdi-city-variant::before {\n  content: \"\\F0A36\";\n}\n\n.mdi-city-variant-outline::before {\n  content: \"\\F0A37\";\n}\n\n.mdi-clipboard::before {\n  content: \"\\F0147\";\n}\n\n.mdi-clipboard-account::before {\n  content: \"\\F0148\";\n}\n\n.mdi-clipboard-account-outline::before {\n  content: \"\\F0C55\";\n}\n\n.mdi-clipboard-alert::before {\n  content: \"\\F0149\";\n}\n\n.mdi-clipboard-alert-outline::before {\n  content: \"\\F0CF7\";\n}\n\n.mdi-clipboard-arrow-down::before {\n  content: \"\\F014A\";\n}\n\n.mdi-clipboard-arrow-down-outline::before {\n  content: \"\\F0C56\";\n}\n\n.mdi-clipboard-arrow-left::before {\n  content: \"\\F014B\";\n}\n\n.mdi-clipboard-arrow-left-outline::before {\n  content: \"\\F0CF8\";\n}\n\n.mdi-clipboard-arrow-right::before {\n  content: \"\\F0CF9\";\n}\n\n.mdi-clipboard-arrow-right-outline::before {\n  content: \"\\F0CFA\";\n}\n\n.mdi-clipboard-arrow-up::before {\n  content: \"\\F0C57\";\n}\n\n.mdi-clipboard-arrow-up-outline::before {\n  content: \"\\F0C58\";\n}\n\n.mdi-clipboard-check::before {\n  content: \"\\F014E\";\n}\n\n.mdi-clipboard-check-multiple::before {\n  content: \"\\F1263\";\n}\n\n.mdi-clipboard-check-multiple-outline::before {\n  content: \"\\F1264\";\n}\n\n.mdi-clipboard-check-outline::before {\n  content: \"\\F08A8\";\n}\n\n.mdi-clipboard-clock::before {\n  content: \"\\F16E2\";\n}\n\n.mdi-clipboard-clock-outline::before {\n  content: \"\\F16E3\";\n}\n\n.mdi-clipboard-edit::before {\n  content: \"\\F14E5\";\n}\n\n.mdi-clipboard-edit-outline::before {\n  content: \"\\F14E6\";\n}\n\n.mdi-clipboard-file::before {\n  content: \"\\F1265\";\n}\n\n.mdi-clipboard-file-outline::before {\n  content: \"\\F1266\";\n}\n\n.mdi-clipboard-flow::before {\n  content: \"\\F06C8\";\n}\n\n.mdi-clipboard-flow-outline::before {\n  content: \"\\F1117\";\n}\n\n.mdi-clipboard-list::before {\n  content: \"\\F10D4\";\n}\n\n.mdi-clipboard-list-outline::before {\n  content: \"\\F10D5\";\n}\n\n.mdi-clipboard-minus::before {\n  content: \"\\F1618\";\n}\n\n.mdi-clipboard-minus-outline::before {\n  content: \"\\F1619\";\n}\n\n.mdi-clipboard-multiple::before {\n  content: \"\\F1267\";\n}\n\n.mdi-clipboard-multiple-outline::before {\n  content: \"\\F1268\";\n}\n\n.mdi-clipboard-off::before {\n  content: \"\\F161A\";\n}\n\n.mdi-clipboard-off-outline::before {\n  content: \"\\F161B\";\n}\n\n.mdi-clipboard-outline::before {\n  content: \"\\F014C\";\n}\n\n.mdi-clipboard-play::before {\n  content: \"\\F0C59\";\n}\n\n.mdi-clipboard-play-multiple::before {\n  content: \"\\F1269\";\n}\n\n.mdi-clipboard-play-multiple-outline::before {\n  content: \"\\F126A\";\n}\n\n.mdi-clipboard-play-outline::before {\n  content: \"\\F0C5A\";\n}\n\n.mdi-clipboard-plus::before {\n  content: \"\\F0751\";\n}\n\n.mdi-clipboard-plus-outline::before {\n  content: \"\\F131F\";\n}\n\n.mdi-clipboard-pulse::before {\n  content: \"\\F085D\";\n}\n\n.mdi-clipboard-pulse-outline::before {\n  content: \"\\F085E\";\n}\n\n.mdi-clipboard-remove::before {\n  content: \"\\F161C\";\n}\n\n.mdi-clipboard-remove-outline::before {\n  content: \"\\F161D\";\n}\n\n.mdi-clipboard-search::before {\n  content: \"\\F161E\";\n}\n\n.mdi-clipboard-search-outline::before {\n  content: \"\\F161F\";\n}\n\n.mdi-clipboard-text::before {\n  content: \"\\F014D\";\n}\n\n.mdi-clipboard-text-multiple::before {\n  content: \"\\F126B\";\n}\n\n.mdi-clipboard-text-multiple-outline::before {\n  content: \"\\F126C\";\n}\n\n.mdi-clipboard-text-off::before {\n  content: \"\\F1620\";\n}\n\n.mdi-clipboard-text-off-outline::before {\n  content: \"\\F1621\";\n}\n\n.mdi-clipboard-text-outline::before {\n  content: \"\\F0A38\";\n}\n\n.mdi-clipboard-text-play::before {\n  content: \"\\F0C5B\";\n}\n\n.mdi-clipboard-text-play-outline::before {\n  content: \"\\F0C5C\";\n}\n\n.mdi-clipboard-text-search::before {\n  content: \"\\F1622\";\n}\n\n.mdi-clipboard-text-search-outline::before {\n  content: \"\\F1623\";\n}\n\n.mdi-clippy::before {\n  content: \"\\F014F\";\n}\n\n.mdi-clock::before {\n  content: \"\\F0954\";\n}\n\n.mdi-clock-alert::before {\n  content: \"\\F0955\";\n}\n\n.mdi-clock-alert-outline::before {\n  content: \"\\F05CE\";\n}\n\n.mdi-clock-check::before {\n  content: \"\\F0FA8\";\n}\n\n.mdi-clock-check-outline::before {\n  content: \"\\F0FA9\";\n}\n\n.mdi-clock-digital::before {\n  content: \"\\F0E97\";\n}\n\n.mdi-clock-end::before {\n  content: \"\\F0151\";\n}\n\n.mdi-clock-fast::before {\n  content: \"\\F0152\";\n}\n\n.mdi-clock-in::before {\n  content: \"\\F0153\";\n}\n\n.mdi-clock-out::before {\n  content: \"\\F0154\";\n}\n\n.mdi-clock-outline::before {\n  content: \"\\F0150\";\n}\n\n.mdi-clock-start::before {\n  content: \"\\F0155\";\n}\n\n.mdi-clock-time-eight::before {\n  content: \"\\F1446\";\n}\n\n.mdi-clock-time-eight-outline::before {\n  content: \"\\F1452\";\n}\n\n.mdi-clock-time-eleven::before {\n  content: \"\\F1449\";\n}\n\n.mdi-clock-time-eleven-outline::before {\n  content: \"\\F1455\";\n}\n\n.mdi-clock-time-five::before {\n  content: \"\\F1443\";\n}\n\n.mdi-clock-time-five-outline::before {\n  content: \"\\F144F\";\n}\n\n.mdi-clock-time-four::before {\n  content: \"\\F1442\";\n}\n\n.mdi-clock-time-four-outline::before {\n  content: \"\\F144E\";\n}\n\n.mdi-clock-time-nine::before {\n  content: \"\\F1447\";\n}\n\n.mdi-clock-time-nine-outline::before {\n  content: \"\\F1453\";\n}\n\n.mdi-clock-time-one::before {\n  content: \"\\F143F\";\n}\n\n.mdi-clock-time-one-outline::before {\n  content: \"\\F144B\";\n}\n\n.mdi-clock-time-seven::before {\n  content: \"\\F1445\";\n}\n\n.mdi-clock-time-seven-outline::before {\n  content: \"\\F1451\";\n}\n\n.mdi-clock-time-six::before {\n  content: \"\\F1444\";\n}\n\n.mdi-clock-time-six-outline::before {\n  content: \"\\F1450\";\n}\n\n.mdi-clock-time-ten::before {\n  content: \"\\F1448\";\n}\n\n.mdi-clock-time-ten-outline::before {\n  content: \"\\F1454\";\n}\n\n.mdi-clock-time-three::before {\n  content: \"\\F1441\";\n}\n\n.mdi-clock-time-three-outline::before {\n  content: \"\\F144D\";\n}\n\n.mdi-clock-time-twelve::before {\n  content: \"\\F144A\";\n}\n\n.mdi-clock-time-twelve-outline::before {\n  content: \"\\F1456\";\n}\n\n.mdi-clock-time-two::before {\n  content: \"\\F1440\";\n}\n\n.mdi-clock-time-two-outline::before {\n  content: \"\\F144C\";\n}\n\n.mdi-close::before {\n  content: \"\\F0156\";\n}\n\n.mdi-close-box::before {\n  content: \"\\F0157\";\n}\n\n.mdi-close-box-multiple::before {\n  content: \"\\F0C5D\";\n}\n\n.mdi-close-box-multiple-outline::before {\n  content: \"\\F0C5E\";\n}\n\n.mdi-close-box-outline::before {\n  content: \"\\F0158\";\n}\n\n.mdi-close-circle::before {\n  content: \"\\F0159\";\n}\n\n.mdi-close-circle-multiple::before {\n  content: \"\\F062A\";\n}\n\n.mdi-close-circle-multiple-outline::before {\n  content: \"\\F0883\";\n}\n\n.mdi-close-circle-outline::before {\n  content: \"\\F015A\";\n}\n\n.mdi-close-network::before {\n  content: \"\\F015B\";\n}\n\n.mdi-close-network-outline::before {\n  content: \"\\F0C5F\";\n}\n\n.mdi-close-octagon::before {\n  content: \"\\F015C\";\n}\n\n.mdi-close-octagon-outline::before {\n  content: \"\\F015D\";\n}\n\n.mdi-close-outline::before {\n  content: \"\\F06C9\";\n}\n\n.mdi-close-thick::before {\n  content: \"\\F1398\";\n}\n\n.mdi-closed-caption::before {\n  content: \"\\F015E\";\n}\n\n.mdi-closed-caption-outline::before {\n  content: \"\\F0DBD\";\n}\n\n.mdi-cloud::before {\n  content: \"\\F015F\";\n}\n\n.mdi-cloud-alert::before {\n  content: \"\\F09E0\";\n}\n\n.mdi-cloud-braces::before {\n  content: \"\\F07B5\";\n}\n\n.mdi-cloud-check::before {\n  content: \"\\F0160\";\n}\n\n.mdi-cloud-check-outline::before {\n  content: \"\\F12CC\";\n}\n\n.mdi-cloud-circle::before {\n  content: \"\\F0161\";\n}\n\n.mdi-cloud-download::before {\n  content: \"\\F0162\";\n}\n\n.mdi-cloud-download-outline::before {\n  content: \"\\F0B7D\";\n}\n\n.mdi-cloud-lock::before {\n  content: \"\\F11F1\";\n}\n\n.mdi-cloud-lock-outline::before {\n  content: \"\\F11F2\";\n}\n\n.mdi-cloud-off-outline::before {\n  content: \"\\F0164\";\n}\n\n.mdi-cloud-outline::before {\n  content: \"\\F0163\";\n}\n\n.mdi-cloud-print::before {\n  content: \"\\F0165\";\n}\n\n.mdi-cloud-print-outline::before {\n  content: \"\\F0166\";\n}\n\n.mdi-cloud-question::before {\n  content: \"\\F0A39\";\n}\n\n.mdi-cloud-refresh::before {\n  content: \"\\F052A\";\n}\n\n.mdi-cloud-search::before {\n  content: \"\\F0956\";\n}\n\n.mdi-cloud-search-outline::before {\n  content: \"\\F0957\";\n}\n\n.mdi-cloud-sync::before {\n  content: \"\\F063F\";\n}\n\n.mdi-cloud-sync-outline::before {\n  content: \"\\F12D6\";\n}\n\n.mdi-cloud-tags::before {\n  content: \"\\F07B6\";\n}\n\n.mdi-cloud-upload::before {\n  content: \"\\F0167\";\n}\n\n.mdi-cloud-upload-outline::before {\n  content: \"\\F0B7E\";\n}\n\n.mdi-clover::before {\n  content: \"\\F0816\";\n}\n\n.mdi-coach-lamp::before {\n  content: \"\\F1020\";\n}\n\n.mdi-coat-rack::before {\n  content: \"\\F109E\";\n}\n\n.mdi-code-array::before {\n  content: \"\\F0168\";\n}\n\n.mdi-code-braces::before {\n  content: \"\\F0169\";\n}\n\n.mdi-code-braces-box::before {\n  content: \"\\F10D6\";\n}\n\n.mdi-code-brackets::before {\n  content: \"\\F016A\";\n}\n\n.mdi-code-equal::before {\n  content: \"\\F016B\";\n}\n\n.mdi-code-greater-than::before {\n  content: \"\\F016C\";\n}\n\n.mdi-code-greater-than-or-equal::before {\n  content: \"\\F016D\";\n}\n\n.mdi-code-json::before {\n  content: \"\\F0626\";\n}\n\n.mdi-code-less-than::before {\n  content: \"\\F016E\";\n}\n\n.mdi-code-less-than-or-equal::before {\n  content: \"\\F016F\";\n}\n\n.mdi-code-not-equal::before {\n  content: \"\\F0170\";\n}\n\n.mdi-code-not-equal-variant::before {\n  content: \"\\F0171\";\n}\n\n.mdi-code-parentheses::before {\n  content: \"\\F0172\";\n}\n\n.mdi-code-parentheses-box::before {\n  content: \"\\F10D7\";\n}\n\n.mdi-code-string::before {\n  content: \"\\F0173\";\n}\n\n.mdi-code-tags::before {\n  content: \"\\F0174\";\n}\n\n.mdi-code-tags-check::before {\n  content: \"\\F0694\";\n}\n\n.mdi-codepen::before {\n  content: \"\\F0175\";\n}\n\n.mdi-coffee::before {\n  content: \"\\F0176\";\n}\n\n.mdi-coffee-maker::before {\n  content: \"\\F109F\";\n}\n\n.mdi-coffee-off::before {\n  content: \"\\F0FAA\";\n}\n\n.mdi-coffee-off-outline::before {\n  content: \"\\F0FAB\";\n}\n\n.mdi-coffee-outline::before {\n  content: \"\\F06CA\";\n}\n\n.mdi-coffee-to-go::before {\n  content: \"\\F0177\";\n}\n\n.mdi-coffee-to-go-outline::before {\n  content: \"\\F130E\";\n}\n\n.mdi-coffin::before {\n  content: \"\\F0B7F\";\n}\n\n.mdi-cog::before {\n  content: \"\\F0493\";\n}\n\n.mdi-cog-box::before {\n  content: \"\\F0494\";\n}\n\n.mdi-cog-clockwise::before {\n  content: \"\\F11DD\";\n}\n\n.mdi-cog-counterclockwise::before {\n  content: \"\\F11DE\";\n}\n\n.mdi-cog-off::before {\n  content: \"\\F13CE\";\n}\n\n.mdi-cog-off-outline::before {\n  content: \"\\F13CF\";\n}\n\n.mdi-cog-outline::before {\n  content: \"\\F08BB\";\n}\n\n.mdi-cog-refresh::before {\n  content: \"\\F145E\";\n}\n\n.mdi-cog-refresh-outline::before {\n  content: \"\\F145F\";\n}\n\n.mdi-cog-sync::before {\n  content: \"\\F1460\";\n}\n\n.mdi-cog-sync-outline::before {\n  content: \"\\F1461\";\n}\n\n.mdi-cog-transfer::before {\n  content: \"\\F105B\";\n}\n\n.mdi-cog-transfer-outline::before {\n  content: \"\\F105C\";\n}\n\n.mdi-cogs::before {\n  content: \"\\F08D6\";\n}\n\n.mdi-collage::before {\n  content: \"\\F0640\";\n}\n\n.mdi-collapse-all::before {\n  content: \"\\F0AA6\";\n}\n\n.mdi-collapse-all-outline::before {\n  content: \"\\F0AA7\";\n}\n\n.mdi-color-helper::before {\n  content: \"\\F0179\";\n}\n\n.mdi-comma::before {\n  content: \"\\F0E23\";\n}\n\n.mdi-comma-box::before {\n  content: \"\\F0E2B\";\n}\n\n.mdi-comma-box-outline::before {\n  content: \"\\F0E24\";\n}\n\n.mdi-comma-circle::before {\n  content: \"\\F0E25\";\n}\n\n.mdi-comma-circle-outline::before {\n  content: \"\\F0E26\";\n}\n\n.mdi-comment::before {\n  content: \"\\F017A\";\n}\n\n.mdi-comment-account::before {\n  content: \"\\F017B\";\n}\n\n.mdi-comment-account-outline::before {\n  content: \"\\F017C\";\n}\n\n.mdi-comment-alert::before {\n  content: \"\\F017D\";\n}\n\n.mdi-comment-alert-outline::before {\n  content: \"\\F017E\";\n}\n\n.mdi-comment-arrow-left::before {\n  content: \"\\F09E1\";\n}\n\n.mdi-comment-arrow-left-outline::before {\n  content: \"\\F09E2\";\n}\n\n.mdi-comment-arrow-right::before {\n  content: \"\\F09E3\";\n}\n\n.mdi-comment-arrow-right-outline::before {\n  content: \"\\F09E4\";\n}\n\n.mdi-comment-bookmark::before {\n  content: \"\\F15AE\";\n}\n\n.mdi-comment-bookmark-outline::before {\n  content: \"\\F15AF\";\n}\n\n.mdi-comment-check::before {\n  content: \"\\F017F\";\n}\n\n.mdi-comment-check-outline::before {\n  content: \"\\F0180\";\n}\n\n.mdi-comment-edit::before {\n  content: \"\\F11BF\";\n}\n\n.mdi-comment-edit-outline::before {\n  content: \"\\F12C4\";\n}\n\n.mdi-comment-eye::before {\n  content: \"\\F0A3A\";\n}\n\n.mdi-comment-eye-outline::before {\n  content: \"\\F0A3B\";\n}\n\n.mdi-comment-flash::before {\n  content: \"\\F15B0\";\n}\n\n.mdi-comment-flash-outline::before {\n  content: \"\\F15B1\";\n}\n\n.mdi-comment-minus::before {\n  content: \"\\F15DF\";\n}\n\n.mdi-comment-minus-outline::before {\n  content: \"\\F15E0\";\n}\n\n.mdi-comment-multiple::before {\n  content: \"\\F085F\";\n}\n\n.mdi-comment-multiple-outline::before {\n  content: \"\\F0181\";\n}\n\n.mdi-comment-off::before {\n  content: \"\\F15E1\";\n}\n\n.mdi-comment-off-outline::before {\n  content: \"\\F15E2\";\n}\n\n.mdi-comment-outline::before {\n  content: \"\\F0182\";\n}\n\n.mdi-comment-plus::before {\n  content: \"\\F09E5\";\n}\n\n.mdi-comment-plus-outline::before {\n  content: \"\\F0183\";\n}\n\n.mdi-comment-processing::before {\n  content: \"\\F0184\";\n}\n\n.mdi-comment-processing-outline::before {\n  content: \"\\F0185\";\n}\n\n.mdi-comment-question::before {\n  content: \"\\F0817\";\n}\n\n.mdi-comment-question-outline::before {\n  content: \"\\F0186\";\n}\n\n.mdi-comment-quote::before {\n  content: \"\\F1021\";\n}\n\n.mdi-comment-quote-outline::before {\n  content: \"\\F1022\";\n}\n\n.mdi-comment-remove::before {\n  content: \"\\F05DE\";\n}\n\n.mdi-comment-remove-outline::before {\n  content: \"\\F0187\";\n}\n\n.mdi-comment-search::before {\n  content: \"\\F0A3C\";\n}\n\n.mdi-comment-search-outline::before {\n  content: \"\\F0A3D\";\n}\n\n.mdi-comment-text::before {\n  content: \"\\F0188\";\n}\n\n.mdi-comment-text-multiple::before {\n  content: \"\\F0860\";\n}\n\n.mdi-comment-text-multiple-outline::before {\n  content: \"\\F0861\";\n}\n\n.mdi-comment-text-outline::before {\n  content: \"\\F0189\";\n}\n\n.mdi-compare::before {\n  content: \"\\F018A\";\n}\n\n.mdi-compare-horizontal::before {\n  content: \"\\F1492\";\n}\n\n.mdi-compare-vertical::before {\n  content: \"\\F1493\";\n}\n\n.mdi-compass::before {\n  content: \"\\F018B\";\n}\n\n.mdi-compass-off::before {\n  content: \"\\F0B80\";\n}\n\n.mdi-compass-off-outline::before {\n  content: \"\\F0B81\";\n}\n\n.mdi-compass-outline::before {\n  content: \"\\F018C\";\n}\n\n.mdi-compass-rose::before {\n  content: \"\\F1382\";\n}\n\n.mdi-concourse-ci::before {\n  content: \"\\F10A0\";\n}\n\n.mdi-connection::before {\n  content: \"\\F1616\";\n}\n\n.mdi-console::before {\n  content: \"\\F018D\";\n}\n\n.mdi-console-line::before {\n  content: \"\\F07B7\";\n}\n\n.mdi-console-network::before {\n  content: \"\\F08A9\";\n}\n\n.mdi-console-network-outline::before {\n  content: \"\\F0C60\";\n}\n\n.mdi-consolidate::before {\n  content: \"\\F10D8\";\n}\n\n.mdi-contactless-payment::before {\n  content: \"\\F0D6A\";\n}\n\n.mdi-contactless-payment-circle::before {\n  content: \"\\F0321\";\n}\n\n.mdi-contactless-payment-circle-outline::before {\n  content: \"\\F0408\";\n}\n\n.mdi-contacts::before {\n  content: \"\\F06CB\";\n}\n\n.mdi-contacts-outline::before {\n  content: \"\\F05B8\";\n}\n\n.mdi-contain::before {\n  content: \"\\F0A3E\";\n}\n\n.mdi-contain-end::before {\n  content: \"\\F0A3F\";\n}\n\n.mdi-contain-start::before {\n  content: \"\\F0A40\";\n}\n\n.mdi-content-copy::before {\n  content: \"\\F018F\";\n}\n\n.mdi-content-cut::before {\n  content: \"\\F0190\";\n}\n\n.mdi-content-duplicate::before {\n  content: \"\\F0191\";\n}\n\n.mdi-content-paste::before {\n  content: \"\\F0192\";\n}\n\n.mdi-content-save::before {\n  content: \"\\F0193\";\n}\n\n.mdi-content-save-alert::before {\n  content: \"\\F0F42\";\n}\n\n.mdi-content-save-alert-outline::before {\n  content: \"\\F0F43\";\n}\n\n.mdi-content-save-all::before {\n  content: \"\\F0194\";\n}\n\n.mdi-content-save-all-outline::before {\n  content: \"\\F0F44\";\n}\n\n.mdi-content-save-cog::before {\n  content: \"\\F145B\";\n}\n\n.mdi-content-save-cog-outline::before {\n  content: \"\\F145C\";\n}\n\n.mdi-content-save-edit::before {\n  content: \"\\F0CFB\";\n}\n\n.mdi-content-save-edit-outline::before {\n  content: \"\\F0CFC\";\n}\n\n.mdi-content-save-move::before {\n  content: \"\\F0E27\";\n}\n\n.mdi-content-save-move-outline::before {\n  content: \"\\F0E28\";\n}\n\n.mdi-content-save-off::before {\n  content: \"\\F1643\";\n}\n\n.mdi-content-save-off-outline::before {\n  content: \"\\F1644\";\n}\n\n.mdi-content-save-outline::before {\n  content: \"\\F0818\";\n}\n\n.mdi-content-save-settings::before {\n  content: \"\\F061B\";\n}\n\n.mdi-content-save-settings-outline::before {\n  content: \"\\F0B2E\";\n}\n\n.mdi-contrast::before {\n  content: \"\\F0195\";\n}\n\n.mdi-contrast-box::before {\n  content: \"\\F0196\";\n}\n\n.mdi-contrast-circle::before {\n  content: \"\\F0197\";\n}\n\n.mdi-controller-classic::before {\n  content: \"\\F0B82\";\n}\n\n.mdi-controller-classic-outline::before {\n  content: \"\\F0B83\";\n}\n\n.mdi-cookie::before {\n  content: \"\\F0198\";\n}\n\n.mdi-cookie-alert::before {\n  content: \"\\F16D0\";\n}\n\n.mdi-cookie-alert-outline::before {\n  content: \"\\F16D1\";\n}\n\n.mdi-cookie-check::before {\n  content: \"\\F16D2\";\n}\n\n.mdi-cookie-check-outline::before {\n  content: \"\\F16D3\";\n}\n\n.mdi-cookie-clock::before {\n  content: \"\\F16E4\";\n}\n\n.mdi-cookie-clock-outline::before {\n  content: \"\\F16E5\";\n}\n\n.mdi-cookie-cog::before {\n  content: \"\\F16D4\";\n}\n\n.mdi-cookie-cog-outline::before {\n  content: \"\\F16D5\";\n}\n\n.mdi-cookie-edit::before {\n  content: \"\\F16E6\";\n}\n\n.mdi-cookie-edit-outline::before {\n  content: \"\\F16E7\";\n}\n\n.mdi-cookie-lock::before {\n  content: \"\\F16E8\";\n}\n\n.mdi-cookie-lock-outline::before {\n  content: \"\\F16E9\";\n}\n\n.mdi-cookie-minus::before {\n  content: \"\\F16DA\";\n}\n\n.mdi-cookie-minus-outline::before {\n  content: \"\\F16DB\";\n}\n\n.mdi-cookie-off::before {\n  content: \"\\F16EA\";\n}\n\n.mdi-cookie-off-outline::before {\n  content: \"\\F16EB\";\n}\n\n.mdi-cookie-outline::before {\n  content: \"\\F16DE\";\n}\n\n.mdi-cookie-plus::before {\n  content: \"\\F16D6\";\n}\n\n.mdi-cookie-plus-outline::before {\n  content: \"\\F16D7\";\n}\n\n.mdi-cookie-refresh::before {\n  content: \"\\F16EC\";\n}\n\n.mdi-cookie-refresh-outline::before {\n  content: \"\\F16ED\";\n}\n\n.mdi-cookie-remove::before {\n  content: \"\\F16D8\";\n}\n\n.mdi-cookie-remove-outline::before {\n  content: \"\\F16D9\";\n}\n\n.mdi-cookie-settings::before {\n  content: \"\\F16DC\";\n}\n\n.mdi-cookie-settings-outline::before {\n  content: \"\\F16DD\";\n}\n\n.mdi-coolant-temperature::before {\n  content: \"\\F03C8\";\n}\n\n.mdi-copyright::before {\n  content: \"\\F05E6\";\n}\n\n.mdi-cordova::before {\n  content: \"\\F0958\";\n}\n\n.mdi-corn::before {\n  content: \"\\F07B8\";\n}\n\n.mdi-corn-off::before {\n  content: \"\\F13EF\";\n}\n\n.mdi-cosine-wave::before {\n  content: \"\\F1479\";\n}\n\n.mdi-counter::before {\n  content: \"\\F0199\";\n}\n\n.mdi-cow::before {\n  content: \"\\F019A\";\n}\n\n.mdi-cpu-32-bit::before {\n  content: \"\\F0EDF\";\n}\n\n.mdi-cpu-64-bit::before {\n  content: \"\\F0EE0\";\n}\n\n.mdi-crane::before {\n  content: \"\\F0862\";\n}\n\n.mdi-creation::before {\n  content: \"\\F0674\";\n}\n\n.mdi-creative-commons::before {\n  content: \"\\F0D6B\";\n}\n\n.mdi-credit-card::before {\n  content: \"\\F0FEF\";\n}\n\n.mdi-credit-card-check::before {\n  content: \"\\F13D0\";\n}\n\n.mdi-credit-card-check-outline::before {\n  content: \"\\F13D1\";\n}\n\n.mdi-credit-card-clock::before {\n  content: \"\\F0EE1\";\n}\n\n.mdi-credit-card-clock-outline::before {\n  content: \"\\F0EE2\";\n}\n\n.mdi-credit-card-marker::before {\n  content: \"\\F06A8\";\n}\n\n.mdi-credit-card-marker-outline::before {\n  content: \"\\F0DBE\";\n}\n\n.mdi-credit-card-minus::before {\n  content: \"\\F0FAC\";\n}\n\n.mdi-credit-card-minus-outline::before {\n  content: \"\\F0FAD\";\n}\n\n.mdi-credit-card-multiple::before {\n  content: \"\\F0FF0\";\n}\n\n.mdi-credit-card-multiple-outline::before {\n  content: \"\\F019C\";\n}\n\n.mdi-credit-card-off::before {\n  content: \"\\F0FF1\";\n}\n\n.mdi-credit-card-off-outline::before {\n  content: \"\\F05E4\";\n}\n\n.mdi-credit-card-outline::before {\n  content: \"\\F019B\";\n}\n\n.mdi-credit-card-plus::before {\n  content: \"\\F0FF2\";\n}\n\n.mdi-credit-card-plus-outline::before {\n  content: \"\\F0676\";\n}\n\n.mdi-credit-card-refresh::before {\n  content: \"\\F1645\";\n}\n\n.mdi-credit-card-refresh-outline::before {\n  content: \"\\F1646\";\n}\n\n.mdi-credit-card-refund::before {\n  content: \"\\F0FF3\";\n}\n\n.mdi-credit-card-refund-outline::before {\n  content: \"\\F0AA8\";\n}\n\n.mdi-credit-card-remove::before {\n  content: \"\\F0FAE\";\n}\n\n.mdi-credit-card-remove-outline::before {\n  content: \"\\F0FAF\";\n}\n\n.mdi-credit-card-scan::before {\n  content: \"\\F0FF4\";\n}\n\n.mdi-credit-card-scan-outline::before {\n  content: \"\\F019D\";\n}\n\n.mdi-credit-card-search::before {\n  content: \"\\F1647\";\n}\n\n.mdi-credit-card-search-outline::before {\n  content: \"\\F1648\";\n}\n\n.mdi-credit-card-settings::before {\n  content: \"\\F0FF5\";\n}\n\n.mdi-credit-card-settings-outline::before {\n  content: \"\\F08D7\";\n}\n\n.mdi-credit-card-sync::before {\n  content: \"\\F1649\";\n}\n\n.mdi-credit-card-sync-outline::before {\n  content: \"\\F164A\";\n}\n\n.mdi-credit-card-wireless::before {\n  content: \"\\F0802\";\n}\n\n.mdi-credit-card-wireless-off::before {\n  content: \"\\F057A\";\n}\n\n.mdi-credit-card-wireless-off-outline::before {\n  content: \"\\F057B\";\n}\n\n.mdi-credit-card-wireless-outline::before {\n  content: \"\\F0D6C\";\n}\n\n.mdi-cricket::before {\n  content: \"\\F0D6D\";\n}\n\n.mdi-crop::before {\n  content: \"\\F019E\";\n}\n\n.mdi-crop-free::before {\n  content: \"\\F019F\";\n}\n\n.mdi-crop-landscape::before {\n  content: \"\\F01A0\";\n}\n\n.mdi-crop-portrait::before {\n  content: \"\\F01A1\";\n}\n\n.mdi-crop-rotate::before {\n  content: \"\\F0696\";\n}\n\n.mdi-crop-square::before {\n  content: \"\\F01A2\";\n}\n\n.mdi-crosshairs::before {\n  content: \"\\F01A3\";\n}\n\n.mdi-crosshairs-gps::before {\n  content: \"\\F01A4\";\n}\n\n.mdi-crosshairs-off::before {\n  content: \"\\F0F45\";\n}\n\n.mdi-crosshairs-question::before {\n  content: \"\\F1136\";\n}\n\n.mdi-crown::before {\n  content: \"\\F01A5\";\n}\n\n.mdi-crown-outline::before {\n  content: \"\\F11D0\";\n}\n\n.mdi-cryengine::before {\n  content: \"\\F0959\";\n}\n\n.mdi-crystal-ball::before {\n  content: \"\\F0B2F\";\n}\n\n.mdi-cube::before {\n  content: \"\\F01A6\";\n}\n\n.mdi-cube-off::before {\n  content: \"\\F141C\";\n}\n\n.mdi-cube-off-outline::before {\n  content: \"\\F141D\";\n}\n\n.mdi-cube-outline::before {\n  content: \"\\F01A7\";\n}\n\n.mdi-cube-scan::before {\n  content: \"\\F0B84\";\n}\n\n.mdi-cube-send::before {\n  content: \"\\F01A8\";\n}\n\n.mdi-cube-unfolded::before {\n  content: \"\\F01A9\";\n}\n\n.mdi-cup::before {\n  content: \"\\F01AA\";\n}\n\n.mdi-cup-off::before {\n  content: \"\\F05E5\";\n}\n\n.mdi-cup-off-outline::before {\n  content: \"\\F137D\";\n}\n\n.mdi-cup-outline::before {\n  content: \"\\F130F\";\n}\n\n.mdi-cup-water::before {\n  content: \"\\F01AB\";\n}\n\n.mdi-cupboard::before {\n  content: \"\\F0F46\";\n}\n\n.mdi-cupboard-outline::before {\n  content: \"\\F0F47\";\n}\n\n.mdi-cupcake::before {\n  content: \"\\F095A\";\n}\n\n.mdi-curling::before {\n  content: \"\\F0863\";\n}\n\n.mdi-currency-bdt::before {\n  content: \"\\F0864\";\n}\n\n.mdi-currency-brl::before {\n  content: \"\\F0B85\";\n}\n\n.mdi-currency-btc::before {\n  content: \"\\F01AC\";\n}\n\n.mdi-currency-cny::before {\n  content: \"\\F07BA\";\n}\n\n.mdi-currency-eth::before {\n  content: \"\\F07BB\";\n}\n\n.mdi-currency-eur::before {\n  content: \"\\F01AD\";\n}\n\n.mdi-currency-eur-off::before {\n  content: \"\\F1315\";\n}\n\n.mdi-currency-gbp::before {\n  content: \"\\F01AE\";\n}\n\n.mdi-currency-ils::before {\n  content: \"\\F0C61\";\n}\n\n.mdi-currency-inr::before {\n  content: \"\\F01AF\";\n}\n\n.mdi-currency-jpy::before {\n  content: \"\\F07BC\";\n}\n\n.mdi-currency-krw::before {\n  content: \"\\F07BD\";\n}\n\n.mdi-currency-kzt::before {\n  content: \"\\F0865\";\n}\n\n.mdi-currency-mnt::before {\n  content: \"\\F1512\";\n}\n\n.mdi-currency-ngn::before {\n  content: \"\\F01B0\";\n}\n\n.mdi-currency-php::before {\n  content: \"\\F09E6\";\n}\n\n.mdi-currency-rial::before {\n  content: \"\\F0E9C\";\n}\n\n.mdi-currency-rub::before {\n  content: \"\\F01B1\";\n}\n\n.mdi-currency-sign::before {\n  content: \"\\F07BE\";\n}\n\n.mdi-currency-try::before {\n  content: \"\\F01B2\";\n}\n\n.mdi-currency-twd::before {\n  content: \"\\F07BF\";\n}\n\n.mdi-currency-usd::before {\n  content: \"\\F01C1\";\n}\n\n.mdi-currency-usd-circle::before {\n  content: \"\\F116B\";\n}\n\n.mdi-currency-usd-circle-outline::before {\n  content: \"\\F0178\";\n}\n\n.mdi-currency-usd-off::before {\n  content: \"\\F067A\";\n}\n\n.mdi-current-ac::before {\n  content: \"\\F1480\";\n}\n\n.mdi-current-dc::before {\n  content: \"\\F095C\";\n}\n\n.mdi-cursor-default::before {\n  content: \"\\F01C0\";\n}\n\n.mdi-cursor-default-click::before {\n  content: \"\\F0CFD\";\n}\n\n.mdi-cursor-default-click-outline::before {\n  content: \"\\F0CFE\";\n}\n\n.mdi-cursor-default-gesture::before {\n  content: \"\\F1127\";\n}\n\n.mdi-cursor-default-gesture-outline::before {\n  content: \"\\F1128\";\n}\n\n.mdi-cursor-default-outline::before {\n  content: \"\\F01BF\";\n}\n\n.mdi-cursor-move::before {\n  content: \"\\F01BE\";\n}\n\n.mdi-cursor-pointer::before {\n  content: \"\\F01BD\";\n}\n\n.mdi-cursor-text::before {\n  content: \"\\F05E7\";\n}\n\n.mdi-dance-ballroom::before {\n  content: \"\\F15FB\";\n}\n\n.mdi-dance-pole::before {\n  content: \"\\F1578\";\n}\n\n.mdi-data-matrix::before {\n  content: \"\\F153C\";\n}\n\n.mdi-data-matrix-edit::before {\n  content: \"\\F153D\";\n}\n\n.mdi-data-matrix-minus::before {\n  content: \"\\F153E\";\n}\n\n.mdi-data-matrix-plus::before {\n  content: \"\\F153F\";\n}\n\n.mdi-data-matrix-remove::before {\n  content: \"\\F1540\";\n}\n\n.mdi-data-matrix-scan::before {\n  content: \"\\F1541\";\n}\n\n.mdi-database::before {\n  content: \"\\F01BC\";\n}\n\n.mdi-database-alert::before {\n  content: \"\\F163A\";\n}\n\n.mdi-database-alert-outline::before {\n  content: \"\\F1624\";\n}\n\n.mdi-database-arrow-down::before {\n  content: \"\\F163B\";\n}\n\n.mdi-database-arrow-down-outline::before {\n  content: \"\\F1625\";\n}\n\n.mdi-database-arrow-left::before {\n  content: \"\\F163C\";\n}\n\n.mdi-database-arrow-left-outline::before {\n  content: \"\\F1626\";\n}\n\n.mdi-database-arrow-right::before {\n  content: \"\\F163D\";\n}\n\n.mdi-database-arrow-right-outline::before {\n  content: \"\\F1627\";\n}\n\n.mdi-database-arrow-up::before {\n  content: \"\\F163E\";\n}\n\n.mdi-database-arrow-up-outline::before {\n  content: \"\\F1628\";\n}\n\n.mdi-database-check::before {\n  content: \"\\F0AA9\";\n}\n\n.mdi-database-check-outline::before {\n  content: \"\\F1629\";\n}\n\n.mdi-database-clock::before {\n  content: \"\\F163F\";\n}\n\n.mdi-database-clock-outline::before {\n  content: \"\\F162A\";\n}\n\n.mdi-database-cog::before {\n  content: \"\\F164B\";\n}\n\n.mdi-database-cog-outline::before {\n  content: \"\\F164C\";\n}\n\n.mdi-database-edit::before {\n  content: \"\\F0B86\";\n}\n\n.mdi-database-edit-outline::before {\n  content: \"\\F162B\";\n}\n\n.mdi-database-export::before {\n  content: \"\\F095E\";\n}\n\n.mdi-database-export-outline::before {\n  content: \"\\F162C\";\n}\n\n.mdi-database-import::before {\n  content: \"\\F095D\";\n}\n\n.mdi-database-import-outline::before {\n  content: \"\\F162D\";\n}\n\n.mdi-database-lock::before {\n  content: \"\\F0AAA\";\n}\n\n.mdi-database-lock-outline::before {\n  content: \"\\F162E\";\n}\n\n.mdi-database-marker::before {\n  content: \"\\F12F6\";\n}\n\n.mdi-database-marker-outline::before {\n  content: \"\\F162F\";\n}\n\n.mdi-database-minus::before {\n  content: \"\\F01BB\";\n}\n\n.mdi-database-minus-outline::before {\n  content: \"\\F1630\";\n}\n\n.mdi-database-off::before {\n  content: \"\\F1640\";\n}\n\n.mdi-database-off-outline::before {\n  content: \"\\F1631\";\n}\n\n.mdi-database-outline::before {\n  content: \"\\F1632\";\n}\n\n.mdi-database-plus::before {\n  content: \"\\F01BA\";\n}\n\n.mdi-database-plus-outline::before {\n  content: \"\\F1633\";\n}\n\n.mdi-database-refresh::before {\n  content: \"\\F05C2\";\n}\n\n.mdi-database-refresh-outline::before {\n  content: \"\\F1634\";\n}\n\n.mdi-database-remove::before {\n  content: \"\\F0D00\";\n}\n\n.mdi-database-remove-outline::before {\n  content: \"\\F1635\";\n}\n\n.mdi-database-search::before {\n  content: \"\\F0866\";\n}\n\n.mdi-database-search-outline::before {\n  content: \"\\F1636\";\n}\n\n.mdi-database-settings::before {\n  content: \"\\F0D01\";\n}\n\n.mdi-database-settings-outline::before {\n  content: \"\\F1637\";\n}\n\n.mdi-database-sync::before {\n  content: \"\\F0CFF\";\n}\n\n.mdi-database-sync-outline::before {\n  content: \"\\F1638\";\n}\n\n.mdi-death-star::before {\n  content: \"\\F08D8\";\n}\n\n.mdi-death-star-variant::before {\n  content: \"\\F08D9\";\n}\n\n.mdi-deathly-hallows::before {\n  content: \"\\F0B87\";\n}\n\n.mdi-debian::before {\n  content: \"\\F08DA\";\n}\n\n.mdi-debug-step-into::before {\n  content: \"\\F01B9\";\n}\n\n.mdi-debug-step-out::before {\n  content: \"\\F01B8\";\n}\n\n.mdi-debug-step-over::before {\n  content: \"\\F01B7\";\n}\n\n.mdi-decagram::before {\n  content: \"\\F076C\";\n}\n\n.mdi-decagram-outline::before {\n  content: \"\\F076D\";\n}\n\n.mdi-decimal::before {\n  content: \"\\F10A1\";\n}\n\n.mdi-decimal-comma::before {\n  content: \"\\F10A2\";\n}\n\n.mdi-decimal-comma-decrease::before {\n  content: \"\\F10A3\";\n}\n\n.mdi-decimal-comma-increase::before {\n  content: \"\\F10A4\";\n}\n\n.mdi-decimal-decrease::before {\n  content: \"\\F01B6\";\n}\n\n.mdi-decimal-increase::before {\n  content: \"\\F01B5\";\n}\n\n.mdi-delete::before {\n  content: \"\\F01B4\";\n}\n\n.mdi-delete-alert::before {\n  content: \"\\F10A5\";\n}\n\n.mdi-delete-alert-outline::before {\n  content: \"\\F10A6\";\n}\n\n.mdi-delete-circle::before {\n  content: \"\\F0683\";\n}\n\n.mdi-delete-circle-outline::before {\n  content: \"\\F0B88\";\n}\n\n.mdi-delete-clock::before {\n  content: \"\\F1556\";\n}\n\n.mdi-delete-clock-outline::before {\n  content: \"\\F1557\";\n}\n\n.mdi-delete-empty::before {\n  content: \"\\F06CC\";\n}\n\n.mdi-delete-empty-outline::before {\n  content: \"\\F0E9D\";\n}\n\n.mdi-delete-forever::before {\n  content: \"\\F05E8\";\n}\n\n.mdi-delete-forever-outline::before {\n  content: \"\\F0B89\";\n}\n\n.mdi-delete-off::before {\n  content: \"\\F10A7\";\n}\n\n.mdi-delete-off-outline::before {\n  content: \"\\F10A8\";\n}\n\n.mdi-delete-outline::before {\n  content: \"\\F09E7\";\n}\n\n.mdi-delete-restore::before {\n  content: \"\\F0819\";\n}\n\n.mdi-delete-sweep::before {\n  content: \"\\F05E9\";\n}\n\n.mdi-delete-sweep-outline::before {\n  content: \"\\F0C62\";\n}\n\n.mdi-delete-variant::before {\n  content: \"\\F01B3\";\n}\n\n.mdi-delta::before {\n  content: \"\\F01C2\";\n}\n\n.mdi-desk::before {\n  content: \"\\F1239\";\n}\n\n.mdi-desk-lamp::before {\n  content: \"\\F095F\";\n}\n\n.mdi-deskphone::before {\n  content: \"\\F01C3\";\n}\n\n.mdi-desktop-classic::before {\n  content: \"\\F07C0\";\n}\n\n.mdi-desktop-mac::before {\n  content: \"\\F01C4\";\n}\n\n.mdi-desktop-mac-dashboard::before {\n  content: \"\\F09E8\";\n}\n\n.mdi-desktop-tower::before {\n  content: \"\\F01C5\";\n}\n\n.mdi-desktop-tower-monitor::before {\n  content: \"\\F0AAB\";\n}\n\n.mdi-details::before {\n  content: \"\\F01C6\";\n}\n\n.mdi-dev-to::before {\n  content: \"\\F0D6E\";\n}\n\n.mdi-developer-board::before {\n  content: \"\\F0697\";\n}\n\n.mdi-deviantart::before {\n  content: \"\\F01C7\";\n}\n\n.mdi-devices::before {\n  content: \"\\F0FB0\";\n}\n\n.mdi-diabetes::before {\n  content: \"\\F1126\";\n}\n\n.mdi-dialpad::before {\n  content: \"\\F061C\";\n}\n\n.mdi-diameter::before {\n  content: \"\\F0C63\";\n}\n\n.mdi-diameter-outline::before {\n  content: \"\\F0C64\";\n}\n\n.mdi-diameter-variant::before {\n  content: \"\\F0C65\";\n}\n\n.mdi-diamond::before {\n  content: \"\\F0B8A\";\n}\n\n.mdi-diamond-outline::before {\n  content: \"\\F0B8B\";\n}\n\n.mdi-diamond-stone::before {\n  content: \"\\F01C8\";\n}\n\n.mdi-dice-1::before {\n  content: \"\\F01CA\";\n}\n\n.mdi-dice-1-outline::before {\n  content: \"\\F114A\";\n}\n\n.mdi-dice-2::before {\n  content: \"\\F01CB\";\n}\n\n.mdi-dice-2-outline::before {\n  content: \"\\F114B\";\n}\n\n.mdi-dice-3::before {\n  content: \"\\F01CC\";\n}\n\n.mdi-dice-3-outline::before {\n  content: \"\\F114C\";\n}\n\n.mdi-dice-4::before {\n  content: \"\\F01CD\";\n}\n\n.mdi-dice-4-outline::before {\n  content: \"\\F114D\";\n}\n\n.mdi-dice-5::before {\n  content: \"\\F01CE\";\n}\n\n.mdi-dice-5-outline::before {\n  content: \"\\F114E\";\n}\n\n.mdi-dice-6::before {\n  content: \"\\F01CF\";\n}\n\n.mdi-dice-6-outline::before {\n  content: \"\\F114F\";\n}\n\n.mdi-dice-d10::before {\n  content: \"\\F1153\";\n}\n\n.mdi-dice-d10-outline::before {\n  content: \"\\F076F\";\n}\n\n.mdi-dice-d12::before {\n  content: \"\\F1154\";\n}\n\n.mdi-dice-d12-outline::before {\n  content: \"\\F0867\";\n}\n\n.mdi-dice-d20::before {\n  content: \"\\F1155\";\n}\n\n.mdi-dice-d20-outline::before {\n  content: \"\\F05EA\";\n}\n\n.mdi-dice-d4::before {\n  content: \"\\F1150\";\n}\n\n.mdi-dice-d4-outline::before {\n  content: \"\\F05EB\";\n}\n\n.mdi-dice-d6::before {\n  content: \"\\F1151\";\n}\n\n.mdi-dice-d6-outline::before {\n  content: \"\\F05ED\";\n}\n\n.mdi-dice-d8::before {\n  content: \"\\F1152\";\n}\n\n.mdi-dice-d8-outline::before {\n  content: \"\\F05EC\";\n}\n\n.mdi-dice-multiple::before {\n  content: \"\\F076E\";\n}\n\n.mdi-dice-multiple-outline::before {\n  content: \"\\F1156\";\n}\n\n.mdi-digital-ocean::before {\n  content: \"\\F1237\";\n}\n\n.mdi-dip-switch::before {\n  content: \"\\F07C1\";\n}\n\n.mdi-directions::before {\n  content: \"\\F01D0\";\n}\n\n.mdi-directions-fork::before {\n  content: \"\\F0641\";\n}\n\n.mdi-disc::before {\n  content: \"\\F05EE\";\n}\n\n.mdi-disc-alert::before {\n  content: \"\\F01D1\";\n}\n\n.mdi-disc-player::before {\n  content: \"\\F0960\";\n}\n\n.mdi-discord::before {\n  content: \"\\F066F\";\n}\n\n.mdi-dishwasher::before {\n  content: \"\\F0AAC\";\n}\n\n.mdi-dishwasher-alert::before {\n  content: \"\\F11B8\";\n}\n\n.mdi-dishwasher-off::before {\n  content: \"\\F11B9\";\n}\n\n.mdi-disqus::before {\n  content: \"\\F01D2\";\n}\n\n.mdi-distribute-horizontal-center::before {\n  content: \"\\F11C9\";\n}\n\n.mdi-distribute-horizontal-left::before {\n  content: \"\\F11C8\";\n}\n\n.mdi-distribute-horizontal-right::before {\n  content: \"\\F11CA\";\n}\n\n.mdi-distribute-vertical-bottom::before {\n  content: \"\\F11CB\";\n}\n\n.mdi-distribute-vertical-center::before {\n  content: \"\\F11CC\";\n}\n\n.mdi-distribute-vertical-top::before {\n  content: \"\\F11CD\";\n}\n\n.mdi-diving-flippers::before {\n  content: \"\\F0DBF\";\n}\n\n.mdi-diving-helmet::before {\n  content: \"\\F0DC0\";\n}\n\n.mdi-diving-scuba::before {\n  content: \"\\F0DC1\";\n}\n\n.mdi-diving-scuba-flag::before {\n  content: \"\\F0DC2\";\n}\n\n.mdi-diving-scuba-tank::before {\n  content: \"\\F0DC3\";\n}\n\n.mdi-diving-scuba-tank-multiple::before {\n  content: \"\\F0DC4\";\n}\n\n.mdi-diving-snorkel::before {\n  content: \"\\F0DC5\";\n}\n\n.mdi-division::before {\n  content: \"\\F01D4\";\n}\n\n.mdi-division-box::before {\n  content: \"\\F01D5\";\n}\n\n.mdi-dlna::before {\n  content: \"\\F0A41\";\n}\n\n.mdi-dna::before {\n  content: \"\\F0684\";\n}\n\n.mdi-dns::before {\n  content: \"\\F01D6\";\n}\n\n.mdi-dns-outline::before {\n  content: \"\\F0B8C\";\n}\n\n.mdi-do-not-disturb::before {\n  content: \"\\F0698\";\n}\n\n.mdi-do-not-disturb-off::before {\n  content: \"\\F0699\";\n}\n\n.mdi-dock-bottom::before {\n  content: \"\\F10A9\";\n}\n\n.mdi-dock-left::before {\n  content: \"\\F10AA\";\n}\n\n.mdi-dock-right::before {\n  content: \"\\F10AB\";\n}\n\n.mdi-dock-top::before {\n  content: \"\\F1513\";\n}\n\n.mdi-dock-window::before {\n  content: \"\\F10AC\";\n}\n\n.mdi-docker::before {\n  content: \"\\F0868\";\n}\n\n.mdi-doctor::before {\n  content: \"\\F0A42\";\n}\n\n.mdi-dog::before {\n  content: \"\\F0A43\";\n}\n\n.mdi-dog-service::before {\n  content: \"\\F0AAD\";\n}\n\n.mdi-dog-side::before {\n  content: \"\\F0A44\";\n}\n\n.mdi-dog-side-off::before {\n  content: \"\\F16EE\";\n}\n\n.mdi-dolby::before {\n  content: \"\\F06B3\";\n}\n\n.mdi-dolly::before {\n  content: \"\\F0E9E\";\n}\n\n.mdi-domain::before {\n  content: \"\\F01D7\";\n}\n\n.mdi-domain-off::before {\n  content: \"\\F0D6F\";\n}\n\n.mdi-domain-plus::before {\n  content: \"\\F10AD\";\n}\n\n.mdi-domain-remove::before {\n  content: \"\\F10AE\";\n}\n\n.mdi-dome-light::before {\n  content: \"\\F141E\";\n}\n\n.mdi-domino-mask::before {\n  content: \"\\F1023\";\n}\n\n.mdi-donkey::before {\n  content: \"\\F07C2\";\n}\n\n.mdi-door::before {\n  content: \"\\F081A\";\n}\n\n.mdi-door-closed::before {\n  content: \"\\F081B\";\n}\n\n.mdi-door-closed-lock::before {\n  content: \"\\F10AF\";\n}\n\n.mdi-door-open::before {\n  content: \"\\F081C\";\n}\n\n.mdi-doorbell::before {\n  content: \"\\F12E6\";\n}\n\n.mdi-doorbell-video::before {\n  content: \"\\F0869\";\n}\n\n.mdi-dot-net::before {\n  content: \"\\F0AAE\";\n}\n\n.mdi-dots-grid::before {\n  content: \"\\F15FC\";\n}\n\n.mdi-dots-hexagon::before {\n  content: \"\\F15FF\";\n}\n\n.mdi-dots-horizontal::before {\n  content: \"\\F01D8\";\n}\n\n.mdi-dots-horizontal-circle::before {\n  content: \"\\F07C3\";\n}\n\n.mdi-dots-horizontal-circle-outline::before {\n  content: \"\\F0B8D\";\n}\n\n.mdi-dots-square::before {\n  content: \"\\F15FD\";\n}\n\n.mdi-dots-triangle::before {\n  content: \"\\F15FE\";\n}\n\n.mdi-dots-vertical::before {\n  content: \"\\F01D9\";\n}\n\n.mdi-dots-vertical-circle::before {\n  content: \"\\F07C4\";\n}\n\n.mdi-dots-vertical-circle-outline::before {\n  content: \"\\F0B8E\";\n}\n\n.mdi-douban::before {\n  content: \"\\F069A\";\n}\n\n.mdi-download::before {\n  content: \"\\F01DA\";\n}\n\n.mdi-download-box::before {\n  content: \"\\F1462\";\n}\n\n.mdi-download-box-outline::before {\n  content: \"\\F1463\";\n}\n\n.mdi-download-circle::before {\n  content: \"\\F1464\";\n}\n\n.mdi-download-circle-outline::before {\n  content: \"\\F1465\";\n}\n\n.mdi-download-lock::before {\n  content: \"\\F1320\";\n}\n\n.mdi-download-lock-outline::before {\n  content: \"\\F1321\";\n}\n\n.mdi-download-multiple::before {\n  content: \"\\F09E9\";\n}\n\n.mdi-download-network::before {\n  content: \"\\F06F4\";\n}\n\n.mdi-download-network-outline::before {\n  content: \"\\F0C66\";\n}\n\n.mdi-download-off::before {\n  content: \"\\F10B0\";\n}\n\n.mdi-download-off-outline::before {\n  content: \"\\F10B1\";\n}\n\n.mdi-download-outline::before {\n  content: \"\\F0B8F\";\n}\n\n.mdi-drag::before {\n  content: \"\\F01DB\";\n}\n\n.mdi-drag-horizontal::before {\n  content: \"\\F01DC\";\n}\n\n.mdi-drag-horizontal-variant::before {\n  content: \"\\F12F0\";\n}\n\n.mdi-drag-variant::before {\n  content: \"\\F0B90\";\n}\n\n.mdi-drag-vertical::before {\n  content: \"\\F01DD\";\n}\n\n.mdi-drag-vertical-variant::before {\n  content: \"\\F12F1\";\n}\n\n.mdi-drama-masks::before {\n  content: \"\\F0D02\";\n}\n\n.mdi-draw::before {\n  content: \"\\F0F49\";\n}\n\n.mdi-drawing::before {\n  content: \"\\F01DE\";\n}\n\n.mdi-drawing-box::before {\n  content: \"\\F01DF\";\n}\n\n.mdi-dresser::before {\n  content: \"\\F0F4A\";\n}\n\n.mdi-dresser-outline::before {\n  content: \"\\F0F4B\";\n}\n\n.mdi-drone::before {\n  content: \"\\F01E2\";\n}\n\n.mdi-dropbox::before {\n  content: \"\\F01E3\";\n}\n\n.mdi-drupal::before {\n  content: \"\\F01E4\";\n}\n\n.mdi-duck::before {\n  content: \"\\F01E5\";\n}\n\n.mdi-dumbbell::before {\n  content: \"\\F01E6\";\n}\n\n.mdi-dump-truck::before {\n  content: \"\\F0C67\";\n}\n\n.mdi-ear-hearing::before {\n  content: \"\\F07C5\";\n}\n\n.mdi-ear-hearing-off::before {\n  content: \"\\F0A45\";\n}\n\n.mdi-earth::before {\n  content: \"\\F01E7\";\n}\n\n.mdi-earth-arrow-right::before {\n  content: \"\\F1311\";\n}\n\n.mdi-earth-box::before {\n  content: \"\\F06CD\";\n}\n\n.mdi-earth-box-minus::before {\n  content: \"\\F1407\";\n}\n\n.mdi-earth-box-off::before {\n  content: \"\\F06CE\";\n}\n\n.mdi-earth-box-plus::before {\n  content: \"\\F1406\";\n}\n\n.mdi-earth-box-remove::before {\n  content: \"\\F1408\";\n}\n\n.mdi-earth-minus::before {\n  content: \"\\F1404\";\n}\n\n.mdi-earth-off::before {\n  content: \"\\F01E8\";\n}\n\n.mdi-earth-plus::before {\n  content: \"\\F1403\";\n}\n\n.mdi-earth-remove::before {\n  content: \"\\F1405\";\n}\n\n.mdi-egg::before {\n  content: \"\\F0AAF\";\n}\n\n.mdi-egg-easter::before {\n  content: \"\\F0AB0\";\n}\n\n.mdi-egg-off::before {\n  content: \"\\F13F0\";\n}\n\n.mdi-egg-off-outline::before {\n  content: \"\\F13F1\";\n}\n\n.mdi-egg-outline::before {\n  content: \"\\F13F2\";\n}\n\n.mdi-eiffel-tower::before {\n  content: \"\\F156B\";\n}\n\n.mdi-eight-track::before {\n  content: \"\\F09EA\";\n}\n\n.mdi-eject::before {\n  content: \"\\F01EA\";\n}\n\n.mdi-eject-outline::before {\n  content: \"\\F0B91\";\n}\n\n.mdi-electric-switch::before {\n  content: \"\\F0E9F\";\n}\n\n.mdi-electric-switch-closed::before {\n  content: \"\\F10D9\";\n}\n\n.mdi-electron-framework::before {\n  content: \"\\F1024\";\n}\n\n.mdi-elephant::before {\n  content: \"\\F07C6\";\n}\n\n.mdi-elevation-decline::before {\n  content: \"\\F01EB\";\n}\n\n.mdi-elevation-rise::before {\n  content: \"\\F01EC\";\n}\n\n.mdi-elevator::before {\n  content: \"\\F01ED\";\n}\n\n.mdi-elevator-down::before {\n  content: \"\\F12C2\";\n}\n\n.mdi-elevator-passenger::before {\n  content: \"\\F1381\";\n}\n\n.mdi-elevator-up::before {\n  content: \"\\F12C1\";\n}\n\n.mdi-ellipse::before {\n  content: \"\\F0EA0\";\n}\n\n.mdi-ellipse-outline::before {\n  content: \"\\F0EA1\";\n}\n\n.mdi-email::before {\n  content: \"\\F01EE\";\n}\n\n.mdi-email-alert::before {\n  content: \"\\F06CF\";\n}\n\n.mdi-email-alert-outline::before {\n  content: \"\\F0D42\";\n}\n\n.mdi-email-box::before {\n  content: \"\\F0D03\";\n}\n\n.mdi-email-check::before {\n  content: \"\\F0AB1\";\n}\n\n.mdi-email-check-outline::before {\n  content: \"\\F0AB2\";\n}\n\n.mdi-email-edit::before {\n  content: \"\\F0EE3\";\n}\n\n.mdi-email-edit-outline::before {\n  content: \"\\F0EE4\";\n}\n\n.mdi-email-lock::before {\n  content: \"\\F01F1\";\n}\n\n.mdi-email-mark-as-unread::before {\n  content: \"\\F0B92\";\n}\n\n.mdi-email-minus::before {\n  content: \"\\F0EE5\";\n}\n\n.mdi-email-minus-outline::before {\n  content: \"\\F0EE6\";\n}\n\n.mdi-email-multiple::before {\n  content: \"\\F0EE7\";\n}\n\n.mdi-email-multiple-outline::before {\n  content: \"\\F0EE8\";\n}\n\n.mdi-email-newsletter::before {\n  content: \"\\F0FB1\";\n}\n\n.mdi-email-off::before {\n  content: \"\\F13E3\";\n}\n\n.mdi-email-off-outline::before {\n  content: \"\\F13E4\";\n}\n\n.mdi-email-open::before {\n  content: \"\\F01EF\";\n}\n\n.mdi-email-open-multiple::before {\n  content: \"\\F0EE9\";\n}\n\n.mdi-email-open-multiple-outline::before {\n  content: \"\\F0EEA\";\n}\n\n.mdi-email-open-outline::before {\n  content: \"\\F05EF\";\n}\n\n.mdi-email-outline::before {\n  content: \"\\F01F0\";\n}\n\n.mdi-email-plus::before {\n  content: \"\\F09EB\";\n}\n\n.mdi-email-plus-outline::before {\n  content: \"\\F09EC\";\n}\n\n.mdi-email-receive::before {\n  content: \"\\F10DA\";\n}\n\n.mdi-email-receive-outline::before {\n  content: \"\\F10DB\";\n}\n\n.mdi-email-remove::before {\n  content: \"\\F1661\";\n}\n\n.mdi-email-remove-outline::before {\n  content: \"\\F1662\";\n}\n\n.mdi-email-search::before {\n  content: \"\\F0961\";\n}\n\n.mdi-email-search-outline::before {\n  content: \"\\F0962\";\n}\n\n.mdi-email-send::before {\n  content: \"\\F10DC\";\n}\n\n.mdi-email-send-outline::before {\n  content: \"\\F10DD\";\n}\n\n.mdi-email-sync::before {\n  content: \"\\F12C7\";\n}\n\n.mdi-email-sync-outline::before {\n  content: \"\\F12C8\";\n}\n\n.mdi-email-variant::before {\n  content: \"\\F05F0\";\n}\n\n.mdi-ember::before {\n  content: \"\\F0B30\";\n}\n\n.mdi-emby::before {\n  content: \"\\F06B4\";\n}\n\n.mdi-emoticon::before {\n  content: \"\\F0C68\";\n}\n\n.mdi-emoticon-angry::before {\n  content: \"\\F0C69\";\n}\n\n.mdi-emoticon-angry-outline::before {\n  content: \"\\F0C6A\";\n}\n\n.mdi-emoticon-confused::before {\n  content: \"\\F10DE\";\n}\n\n.mdi-emoticon-confused-outline::before {\n  content: \"\\F10DF\";\n}\n\n.mdi-emoticon-cool::before {\n  content: \"\\F0C6B\";\n}\n\n.mdi-emoticon-cool-outline::before {\n  content: \"\\F01F3\";\n}\n\n.mdi-emoticon-cry::before {\n  content: \"\\F0C6C\";\n}\n\n.mdi-emoticon-cry-outline::before {\n  content: \"\\F0C6D\";\n}\n\n.mdi-emoticon-dead::before {\n  content: \"\\F0C6E\";\n}\n\n.mdi-emoticon-dead-outline::before {\n  content: \"\\F069B\";\n}\n\n.mdi-emoticon-devil::before {\n  content: \"\\F0C6F\";\n}\n\n.mdi-emoticon-devil-outline::before {\n  content: \"\\F01F4\";\n}\n\n.mdi-emoticon-excited::before {\n  content: \"\\F0C70\";\n}\n\n.mdi-emoticon-excited-outline::before {\n  content: \"\\F069C\";\n}\n\n.mdi-emoticon-frown::before {\n  content: \"\\F0F4C\";\n}\n\n.mdi-emoticon-frown-outline::before {\n  content: \"\\F0F4D\";\n}\n\n.mdi-emoticon-happy::before {\n  content: \"\\F0C71\";\n}\n\n.mdi-emoticon-happy-outline::before {\n  content: \"\\F01F5\";\n}\n\n.mdi-emoticon-kiss::before {\n  content: \"\\F0C72\";\n}\n\n.mdi-emoticon-kiss-outline::before {\n  content: \"\\F0C73\";\n}\n\n.mdi-emoticon-lol::before {\n  content: \"\\F1214\";\n}\n\n.mdi-emoticon-lol-outline::before {\n  content: \"\\F1215\";\n}\n\n.mdi-emoticon-neutral::before {\n  content: \"\\F0C74\";\n}\n\n.mdi-emoticon-neutral-outline::before {\n  content: \"\\F01F6\";\n}\n\n.mdi-emoticon-outline::before {\n  content: \"\\F01F2\";\n}\n\n.mdi-emoticon-poop::before {\n  content: \"\\F01F7\";\n}\n\n.mdi-emoticon-poop-outline::before {\n  content: \"\\F0C75\";\n}\n\n.mdi-emoticon-sad::before {\n  content: \"\\F0C76\";\n}\n\n.mdi-emoticon-sad-outline::before {\n  content: \"\\F01F8\";\n}\n\n.mdi-emoticon-sick::before {\n  content: \"\\F157C\";\n}\n\n.mdi-emoticon-sick-outline::before {\n  content: \"\\F157D\";\n}\n\n.mdi-emoticon-tongue::before {\n  content: \"\\F01F9\";\n}\n\n.mdi-emoticon-tongue-outline::before {\n  content: \"\\F0C77\";\n}\n\n.mdi-emoticon-wink::before {\n  content: \"\\F0C78\";\n}\n\n.mdi-emoticon-wink-outline::before {\n  content: \"\\F0C79\";\n}\n\n.mdi-engine::before {\n  content: \"\\F01FA\";\n}\n\n.mdi-engine-off::before {\n  content: \"\\F0A46\";\n}\n\n.mdi-engine-off-outline::before {\n  content: \"\\F0A47\";\n}\n\n.mdi-engine-outline::before {\n  content: \"\\F01FB\";\n}\n\n.mdi-epsilon::before {\n  content: \"\\F10E0\";\n}\n\n.mdi-equal::before {\n  content: \"\\F01FC\";\n}\n\n.mdi-equal-box::before {\n  content: \"\\F01FD\";\n}\n\n.mdi-equalizer::before {\n  content: \"\\F0EA2\";\n}\n\n.mdi-equalizer-outline::before {\n  content: \"\\F0EA3\";\n}\n\n.mdi-eraser::before {\n  content: \"\\F01FE\";\n}\n\n.mdi-eraser-variant::before {\n  content: \"\\F0642\";\n}\n\n.mdi-escalator::before {\n  content: \"\\F01FF\";\n}\n\n.mdi-escalator-box::before {\n  content: \"\\F1399\";\n}\n\n.mdi-escalator-down::before {\n  content: \"\\F12C0\";\n}\n\n.mdi-escalator-up::before {\n  content: \"\\F12BF\";\n}\n\n.mdi-eslint::before {\n  content: \"\\F0C7A\";\n}\n\n.mdi-et::before {\n  content: \"\\F0AB3\";\n}\n\n.mdi-ethereum::before {\n  content: \"\\F086A\";\n}\n\n.mdi-ethernet::before {\n  content: \"\\F0200\";\n}\n\n.mdi-ethernet-cable::before {\n  content: \"\\F0201\";\n}\n\n.mdi-ethernet-cable-off::before {\n  content: \"\\F0202\";\n}\n\n.mdi-ev-plug-ccs1::before {\n  content: \"\\F1519\";\n}\n\n.mdi-ev-plug-ccs2::before {\n  content: \"\\F151A\";\n}\n\n.mdi-ev-plug-chademo::before {\n  content: \"\\F151B\";\n}\n\n.mdi-ev-plug-tesla::before {\n  content: \"\\F151C\";\n}\n\n.mdi-ev-plug-type1::before {\n  content: \"\\F151D\";\n}\n\n.mdi-ev-plug-type2::before {\n  content: \"\\F151E\";\n}\n\n.mdi-ev-station::before {\n  content: \"\\F05F1\";\n}\n\n.mdi-evernote::before {\n  content: \"\\F0204\";\n}\n\n.mdi-excavator::before {\n  content: \"\\F1025\";\n}\n\n.mdi-exclamation::before {\n  content: \"\\F0205\";\n}\n\n.mdi-exclamation-thick::before {\n  content: \"\\F1238\";\n}\n\n.mdi-exit-run::before {\n  content: \"\\F0A48\";\n}\n\n.mdi-exit-to-app::before {\n  content: \"\\F0206\";\n}\n\n.mdi-expand-all::before {\n  content: \"\\F0AB4\";\n}\n\n.mdi-expand-all-outline::before {\n  content: \"\\F0AB5\";\n}\n\n.mdi-expansion-card::before {\n  content: \"\\F08AE\";\n}\n\n.mdi-expansion-card-variant::before {\n  content: \"\\F0FB2\";\n}\n\n.mdi-exponent::before {\n  content: \"\\F0963\";\n}\n\n.mdi-exponent-box::before {\n  content: \"\\F0964\";\n}\n\n.mdi-export::before {\n  content: \"\\F0207\";\n}\n\n.mdi-export-variant::before {\n  content: \"\\F0B93\";\n}\n\n.mdi-eye::before {\n  content: \"\\F0208\";\n}\n\n.mdi-eye-check::before {\n  content: \"\\F0D04\";\n}\n\n.mdi-eye-check-outline::before {\n  content: \"\\F0D05\";\n}\n\n.mdi-eye-circle::before {\n  content: \"\\F0B94\";\n}\n\n.mdi-eye-circle-outline::before {\n  content: \"\\F0B95\";\n}\n\n.mdi-eye-minus::before {\n  content: \"\\F1026\";\n}\n\n.mdi-eye-minus-outline::before {\n  content: \"\\F1027\";\n}\n\n.mdi-eye-off::before {\n  content: \"\\F0209\";\n}\n\n.mdi-eye-off-outline::before {\n  content: \"\\F06D1\";\n}\n\n.mdi-eye-outline::before {\n  content: \"\\F06D0\";\n}\n\n.mdi-eye-plus::before {\n  content: \"\\F086B\";\n}\n\n.mdi-eye-plus-outline::before {\n  content: \"\\F086C\";\n}\n\n.mdi-eye-remove::before {\n  content: \"\\F15E3\";\n}\n\n.mdi-eye-remove-outline::before {\n  content: \"\\F15E4\";\n}\n\n.mdi-eye-settings::before {\n  content: \"\\F086D\";\n}\n\n.mdi-eye-settings-outline::before {\n  content: \"\\F086E\";\n}\n\n.mdi-eyedropper::before {\n  content: \"\\F020A\";\n}\n\n.mdi-eyedropper-minus::before {\n  content: \"\\F13DD\";\n}\n\n.mdi-eyedropper-off::before {\n  content: \"\\F13DF\";\n}\n\n.mdi-eyedropper-plus::before {\n  content: \"\\F13DC\";\n}\n\n.mdi-eyedropper-remove::before {\n  content: \"\\F13DE\";\n}\n\n.mdi-eyedropper-variant::before {\n  content: \"\\F020B\";\n}\n\n.mdi-face::before {\n  content: \"\\F0643\";\n}\n\n.mdi-face-agent::before {\n  content: \"\\F0D70\";\n}\n\n.mdi-face-mask::before {\n  content: \"\\F1586\";\n}\n\n.mdi-face-mask-outline::before {\n  content: \"\\F1587\";\n}\n\n.mdi-face-outline::before {\n  content: \"\\F0B96\";\n}\n\n.mdi-face-profile::before {\n  content: \"\\F0644\";\n}\n\n.mdi-face-profile-woman::before {\n  content: \"\\F1076\";\n}\n\n.mdi-face-recognition::before {\n  content: \"\\F0C7B\";\n}\n\n.mdi-face-shimmer::before {\n  content: \"\\F15CC\";\n}\n\n.mdi-face-shimmer-outline::before {\n  content: \"\\F15CD\";\n}\n\n.mdi-face-woman::before {\n  content: \"\\F1077\";\n}\n\n.mdi-face-woman-outline::before {\n  content: \"\\F1078\";\n}\n\n.mdi-face-woman-shimmer::before {\n  content: \"\\F15CE\";\n}\n\n.mdi-face-woman-shimmer-outline::before {\n  content: \"\\F15CF\";\n}\n\n.mdi-facebook::before {\n  content: \"\\F020C\";\n}\n\n.mdi-facebook-gaming::before {\n  content: \"\\F07DD\";\n}\n\n.mdi-facebook-messenger::before {\n  content: \"\\F020E\";\n}\n\n.mdi-facebook-workplace::before {\n  content: \"\\F0B31\";\n}\n\n.mdi-factory::before {\n  content: \"\\F020F\";\n}\n\n.mdi-family-tree::before {\n  content: \"\\F160E\";\n}\n\n.mdi-fan::before {\n  content: \"\\F0210\";\n}\n\n.mdi-fan-alert::before {\n  content: \"\\F146C\";\n}\n\n.mdi-fan-auto::before {\n  content: \"\\F171D\";\n}\n\n.mdi-fan-chevron-down::before {\n  content: \"\\F146D\";\n}\n\n.mdi-fan-chevron-up::before {\n  content: \"\\F146E\";\n}\n\n.mdi-fan-minus::before {\n  content: \"\\F1470\";\n}\n\n.mdi-fan-off::before {\n  content: \"\\F081D\";\n}\n\n.mdi-fan-plus::before {\n  content: \"\\F146F\";\n}\n\n.mdi-fan-remove::before {\n  content: \"\\F1471\";\n}\n\n.mdi-fan-speed-1::before {\n  content: \"\\F1472\";\n}\n\n.mdi-fan-speed-2::before {\n  content: \"\\F1473\";\n}\n\n.mdi-fan-speed-3::before {\n  content: \"\\F1474\";\n}\n\n.mdi-fast-forward::before {\n  content: \"\\F0211\";\n}\n\n.mdi-fast-forward-10::before {\n  content: \"\\F0D71\";\n}\n\n.mdi-fast-forward-30::before {\n  content: \"\\F0D06\";\n}\n\n.mdi-fast-forward-5::before {\n  content: \"\\F11F8\";\n}\n\n.mdi-fast-forward-60::before {\n  content: \"\\F160B\";\n}\n\n.mdi-fast-forward-outline::before {\n  content: \"\\F06D2\";\n}\n\n.mdi-fax::before {\n  content: \"\\F0212\";\n}\n\n.mdi-feather::before {\n  content: \"\\F06D3\";\n}\n\n.mdi-feature-search::before {\n  content: \"\\F0A49\";\n}\n\n.mdi-feature-search-outline::before {\n  content: \"\\F0A4A\";\n}\n\n.mdi-fedora::before {\n  content: \"\\F08DB\";\n}\n\n.mdi-fencing::before {\n  content: \"\\F14C1\";\n}\n\n.mdi-ferris-wheel::before {\n  content: \"\\F0EA4\";\n}\n\n.mdi-ferry::before {\n  content: \"\\F0213\";\n}\n\n.mdi-file::before {\n  content: \"\\F0214\";\n}\n\n.mdi-file-account::before {\n  content: \"\\F073B\";\n}\n\n.mdi-file-account-outline::before {\n  content: \"\\F1028\";\n}\n\n.mdi-file-alert::before {\n  content: \"\\F0A4B\";\n}\n\n.mdi-file-alert-outline::before {\n  content: \"\\F0A4C\";\n}\n\n.mdi-file-cabinet::before {\n  content: \"\\F0AB6\";\n}\n\n.mdi-file-cad::before {\n  content: \"\\F0EEB\";\n}\n\n.mdi-file-cad-box::before {\n  content: \"\\F0EEC\";\n}\n\n.mdi-file-cancel::before {\n  content: \"\\F0DC6\";\n}\n\n.mdi-file-cancel-outline::before {\n  content: \"\\F0DC7\";\n}\n\n.mdi-file-certificate::before {\n  content: \"\\F1186\";\n}\n\n.mdi-file-certificate-outline::before {\n  content: \"\\F1187\";\n}\n\n.mdi-file-chart::before {\n  content: \"\\F0215\";\n}\n\n.mdi-file-chart-outline::before {\n  content: \"\\F1029\";\n}\n\n.mdi-file-check::before {\n  content: \"\\F0216\";\n}\n\n.mdi-file-check-outline::before {\n  content: \"\\F0E29\";\n}\n\n.mdi-file-clock::before {\n  content: \"\\F12E1\";\n}\n\n.mdi-file-clock-outline::before {\n  content: \"\\F12E2\";\n}\n\n.mdi-file-cloud::before {\n  content: \"\\F0217\";\n}\n\n.mdi-file-cloud-outline::before {\n  content: \"\\F102A\";\n}\n\n.mdi-file-code::before {\n  content: \"\\F022E\";\n}\n\n.mdi-file-code-outline::before {\n  content: \"\\F102B\";\n}\n\n.mdi-file-cog::before {\n  content: \"\\F107B\";\n}\n\n.mdi-file-cog-outline::before {\n  content: \"\\F107C\";\n}\n\n.mdi-file-compare::before {\n  content: \"\\F08AA\";\n}\n\n.mdi-file-delimited::before {\n  content: \"\\F0218\";\n}\n\n.mdi-file-delimited-outline::before {\n  content: \"\\F0EA5\";\n}\n\n.mdi-file-document::before {\n  content: \"\\F0219\";\n}\n\n.mdi-file-document-edit::before {\n  content: \"\\F0DC8\";\n}\n\n.mdi-file-document-edit-outline::before {\n  content: \"\\F0DC9\";\n}\n\n.mdi-file-document-multiple::before {\n  content: \"\\F1517\";\n}\n\n.mdi-file-document-multiple-outline::before {\n  content: \"\\F1518\";\n}\n\n.mdi-file-document-outline::before {\n  content: \"\\F09EE\";\n}\n\n.mdi-file-download::before {\n  content: \"\\F0965\";\n}\n\n.mdi-file-download-outline::before {\n  content: \"\\F0966\";\n}\n\n.mdi-file-edit::before {\n  content: \"\\F11E7\";\n}\n\n.mdi-file-edit-outline::before {\n  content: \"\\F11E8\";\n}\n\n.mdi-file-excel::before {\n  content: \"\\F021B\";\n}\n\n.mdi-file-excel-box::before {\n  content: \"\\F021C\";\n}\n\n.mdi-file-excel-box-outline::before {\n  content: \"\\F102C\";\n}\n\n.mdi-file-excel-outline::before {\n  content: \"\\F102D\";\n}\n\n.mdi-file-export::before {\n  content: \"\\F021D\";\n}\n\n.mdi-file-export-outline::before {\n  content: \"\\F102E\";\n}\n\n.mdi-file-eye::before {\n  content: \"\\F0DCA\";\n}\n\n.mdi-file-eye-outline::before {\n  content: \"\\F0DCB\";\n}\n\n.mdi-file-find::before {\n  content: \"\\F021E\";\n}\n\n.mdi-file-find-outline::before {\n  content: \"\\F0B97\";\n}\n\n.mdi-file-hidden::before {\n  content: \"\\F0613\";\n}\n\n.mdi-file-image::before {\n  content: \"\\F021F\";\n}\n\n.mdi-file-image-outline::before {\n  content: \"\\F0EB0\";\n}\n\n.mdi-file-import::before {\n  content: \"\\F0220\";\n}\n\n.mdi-file-import-outline::before {\n  content: \"\\F102F\";\n}\n\n.mdi-file-key::before {\n  content: \"\\F1184\";\n}\n\n.mdi-file-key-outline::before {\n  content: \"\\F1185\";\n}\n\n.mdi-file-link::before {\n  content: \"\\F1177\";\n}\n\n.mdi-file-link-outline::before {\n  content: \"\\F1178\";\n}\n\n.mdi-file-lock::before {\n  content: \"\\F0221\";\n}\n\n.mdi-file-lock-outline::before {\n  content: \"\\F1030\";\n}\n\n.mdi-file-move::before {\n  content: \"\\F0AB9\";\n}\n\n.mdi-file-move-outline::before {\n  content: \"\\F1031\";\n}\n\n.mdi-file-multiple::before {\n  content: \"\\F0222\";\n}\n\n.mdi-file-multiple-outline::before {\n  content: \"\\F1032\";\n}\n\n.mdi-file-music::before {\n  content: \"\\F0223\";\n}\n\n.mdi-file-music-outline::before {\n  content: \"\\F0E2A\";\n}\n\n.mdi-file-outline::before {\n  content: \"\\F0224\";\n}\n\n.mdi-file-pdf::before {\n  content: \"\\F0225\";\n}\n\n.mdi-file-pdf-box::before {\n  content: \"\\F0226\";\n}\n\n.mdi-file-pdf-box-outline::before {\n  content: \"\\F0FB3\";\n}\n\n.mdi-file-pdf-outline::before {\n  content: \"\\F0E2D\";\n}\n\n.mdi-file-percent::before {\n  content: \"\\F081E\";\n}\n\n.mdi-file-percent-outline::before {\n  content: \"\\F1033\";\n}\n\n.mdi-file-phone::before {\n  content: \"\\F1179\";\n}\n\n.mdi-file-phone-outline::before {\n  content: \"\\F117A\";\n}\n\n.mdi-file-plus::before {\n  content: \"\\F0752\";\n}\n\n.mdi-file-plus-outline::before {\n  content: \"\\F0EED\";\n}\n\n.mdi-file-powerpoint::before {\n  content: \"\\F0227\";\n}\n\n.mdi-file-powerpoint-box::before {\n  content: \"\\F0228\";\n}\n\n.mdi-file-powerpoint-box-outline::before {\n  content: \"\\F1034\";\n}\n\n.mdi-file-powerpoint-outline::before {\n  content: \"\\F1035\";\n}\n\n.mdi-file-presentation-box::before {\n  content: \"\\F0229\";\n}\n\n.mdi-file-question::before {\n  content: \"\\F086F\";\n}\n\n.mdi-file-question-outline::before {\n  content: \"\\F1036\";\n}\n\n.mdi-file-refresh::before {\n  content: \"\\F0918\";\n}\n\n.mdi-file-refresh-outline::before {\n  content: \"\\F0541\";\n}\n\n.mdi-file-remove::before {\n  content: \"\\F0B98\";\n}\n\n.mdi-file-remove-outline::before {\n  content: \"\\F1037\";\n}\n\n.mdi-file-replace::before {\n  content: \"\\F0B32\";\n}\n\n.mdi-file-replace-outline::before {\n  content: \"\\F0B33\";\n}\n\n.mdi-file-restore::before {\n  content: \"\\F0670\";\n}\n\n.mdi-file-restore-outline::before {\n  content: \"\\F1038\";\n}\n\n.mdi-file-search::before {\n  content: \"\\F0C7C\";\n}\n\n.mdi-file-search-outline::before {\n  content: \"\\F0C7D\";\n}\n\n.mdi-file-send::before {\n  content: \"\\F022A\";\n}\n\n.mdi-file-send-outline::before {\n  content: \"\\F1039\";\n}\n\n.mdi-file-settings::before {\n  content: \"\\F1079\";\n}\n\n.mdi-file-settings-outline::before {\n  content: \"\\F107A\";\n}\n\n.mdi-file-star::before {\n  content: \"\\F103A\";\n}\n\n.mdi-file-star-outline::before {\n  content: \"\\F103B\";\n}\n\n.mdi-file-swap::before {\n  content: \"\\F0FB4\";\n}\n\n.mdi-file-swap-outline::before {\n  content: \"\\F0FB5\";\n}\n\n.mdi-file-sync::before {\n  content: \"\\F1216\";\n}\n\n.mdi-file-sync-outline::before {\n  content: \"\\F1217\";\n}\n\n.mdi-file-table::before {\n  content: \"\\F0C7E\";\n}\n\n.mdi-file-table-box::before {\n  content: \"\\F10E1\";\n}\n\n.mdi-file-table-box-multiple::before {\n  content: \"\\F10E2\";\n}\n\n.mdi-file-table-box-multiple-outline::before {\n  content: \"\\F10E3\";\n}\n\n.mdi-file-table-box-outline::before {\n  content: \"\\F10E4\";\n}\n\n.mdi-file-table-outline::before {\n  content: \"\\F0C7F\";\n}\n\n.mdi-file-tree::before {\n  content: \"\\F0645\";\n}\n\n.mdi-file-tree-outline::before {\n  content: \"\\F13D2\";\n}\n\n.mdi-file-undo::before {\n  content: \"\\F08DC\";\n}\n\n.mdi-file-undo-outline::before {\n  content: \"\\F103C\";\n}\n\n.mdi-file-upload::before {\n  content: \"\\F0A4D\";\n}\n\n.mdi-file-upload-outline::before {\n  content: \"\\F0A4E\";\n}\n\n.mdi-file-video::before {\n  content: \"\\F022B\";\n}\n\n.mdi-file-video-outline::before {\n  content: \"\\F0E2C\";\n}\n\n.mdi-file-word::before {\n  content: \"\\F022C\";\n}\n\n.mdi-file-word-box::before {\n  content: \"\\F022D\";\n}\n\n.mdi-file-word-box-outline::before {\n  content: \"\\F103D\";\n}\n\n.mdi-file-word-outline::before {\n  content: \"\\F103E\";\n}\n\n.mdi-film::before {\n  content: \"\\F022F\";\n}\n\n.mdi-filmstrip::before {\n  content: \"\\F0230\";\n}\n\n.mdi-filmstrip-box::before {\n  content: \"\\F0332\";\n}\n\n.mdi-filmstrip-box-multiple::before {\n  content: \"\\F0D18\";\n}\n\n.mdi-filmstrip-off::before {\n  content: \"\\F0231\";\n}\n\n.mdi-filter::before {\n  content: \"\\F0232\";\n}\n\n.mdi-filter-menu::before {\n  content: \"\\F10E5\";\n}\n\n.mdi-filter-menu-outline::before {\n  content: \"\\F10E6\";\n}\n\n.mdi-filter-minus::before {\n  content: \"\\F0EEE\";\n}\n\n.mdi-filter-minus-outline::before {\n  content: \"\\F0EEF\";\n}\n\n.mdi-filter-off::before {\n  content: \"\\F14EF\";\n}\n\n.mdi-filter-off-outline::before {\n  content: \"\\F14F0\";\n}\n\n.mdi-filter-outline::before {\n  content: \"\\F0233\";\n}\n\n.mdi-filter-plus::before {\n  content: \"\\F0EF0\";\n}\n\n.mdi-filter-plus-outline::before {\n  content: \"\\F0EF1\";\n}\n\n.mdi-filter-remove::before {\n  content: \"\\F0234\";\n}\n\n.mdi-filter-remove-outline::before {\n  content: \"\\F0235\";\n}\n\n.mdi-filter-variant::before {\n  content: \"\\F0236\";\n}\n\n.mdi-filter-variant-minus::before {\n  content: \"\\F1112\";\n}\n\n.mdi-filter-variant-plus::before {\n  content: \"\\F1113\";\n}\n\n.mdi-filter-variant-remove::before {\n  content: \"\\F103F\";\n}\n\n.mdi-finance::before {\n  content: \"\\F081F\";\n}\n\n.mdi-find-replace::before {\n  content: \"\\F06D4\";\n}\n\n.mdi-fingerprint::before {\n  content: \"\\F0237\";\n}\n\n.mdi-fingerprint-off::before {\n  content: \"\\F0EB1\";\n}\n\n.mdi-fire::before {\n  content: \"\\F0238\";\n}\n\n.mdi-fire-alert::before {\n  content: \"\\F15D7\";\n}\n\n.mdi-fire-extinguisher::before {\n  content: \"\\F0EF2\";\n}\n\n.mdi-fire-hydrant::before {\n  content: \"\\F1137\";\n}\n\n.mdi-fire-hydrant-alert::before {\n  content: \"\\F1138\";\n}\n\n.mdi-fire-hydrant-off::before {\n  content: \"\\F1139\";\n}\n\n.mdi-fire-off::before {\n  content: \"\\F1722\";\n}\n\n.mdi-fire-truck::before {\n  content: \"\\F08AB\";\n}\n\n.mdi-firebase::before {\n  content: \"\\F0967\";\n}\n\n.mdi-firefox::before {\n  content: \"\\F0239\";\n}\n\n.mdi-fireplace::before {\n  content: \"\\F0E2E\";\n}\n\n.mdi-fireplace-off::before {\n  content: \"\\F0E2F\";\n}\n\n.mdi-firework::before {\n  content: \"\\F0E30\";\n}\n\n.mdi-firework-off::before {\n  content: \"\\F1723\";\n}\n\n.mdi-fish::before {\n  content: \"\\F023A\";\n}\n\n.mdi-fish-off::before {\n  content: \"\\F13F3\";\n}\n\n.mdi-fishbowl::before {\n  content: \"\\F0EF3\";\n}\n\n.mdi-fishbowl-outline::before {\n  content: \"\\F0EF4\";\n}\n\n.mdi-fit-to-page::before {\n  content: \"\\F0EF5\";\n}\n\n.mdi-fit-to-page-outline::before {\n  content: \"\\F0EF6\";\n}\n\n.mdi-flag::before {\n  content: \"\\F023B\";\n}\n\n.mdi-flag-checkered::before {\n  content: \"\\F023C\";\n}\n\n.mdi-flag-minus::before {\n  content: \"\\F0B99\";\n}\n\n.mdi-flag-minus-outline::before {\n  content: \"\\F10B2\";\n}\n\n.mdi-flag-outline::before {\n  content: \"\\F023D\";\n}\n\n.mdi-flag-plus::before {\n  content: \"\\F0B9A\";\n}\n\n.mdi-flag-plus-outline::before {\n  content: \"\\F10B3\";\n}\n\n.mdi-flag-remove::before {\n  content: \"\\F0B9B\";\n}\n\n.mdi-flag-remove-outline::before {\n  content: \"\\F10B4\";\n}\n\n.mdi-flag-triangle::before {\n  content: \"\\F023F\";\n}\n\n.mdi-flag-variant::before {\n  content: \"\\F0240\";\n}\n\n.mdi-flag-variant-outline::before {\n  content: \"\\F023E\";\n}\n\n.mdi-flare::before {\n  content: \"\\F0D72\";\n}\n\n.mdi-flash::before {\n  content: \"\\F0241\";\n}\n\n.mdi-flash-alert::before {\n  content: \"\\F0EF7\";\n}\n\n.mdi-flash-alert-outline::before {\n  content: \"\\F0EF8\";\n}\n\n.mdi-flash-auto::before {\n  content: \"\\F0242\";\n}\n\n.mdi-flash-circle::before {\n  content: \"\\F0820\";\n}\n\n.mdi-flash-off::before {\n  content: \"\\F0243\";\n}\n\n.mdi-flash-outline::before {\n  content: \"\\F06D5\";\n}\n\n.mdi-flash-red-eye::before {\n  content: \"\\F067B\";\n}\n\n.mdi-flashlight::before {\n  content: \"\\F0244\";\n}\n\n.mdi-flashlight-off::before {\n  content: \"\\F0245\";\n}\n\n.mdi-flask::before {\n  content: \"\\F0093\";\n}\n\n.mdi-flask-empty::before {\n  content: \"\\F0094\";\n}\n\n.mdi-flask-empty-minus::before {\n  content: \"\\F123A\";\n}\n\n.mdi-flask-empty-minus-outline::before {\n  content: \"\\F123B\";\n}\n\n.mdi-flask-empty-off::before {\n  content: \"\\F13F4\";\n}\n\n.mdi-flask-empty-off-outline::before {\n  content: \"\\F13F5\";\n}\n\n.mdi-flask-empty-outline::before {\n  content: \"\\F0095\";\n}\n\n.mdi-flask-empty-plus::before {\n  content: \"\\F123C\";\n}\n\n.mdi-flask-empty-plus-outline::before {\n  content: \"\\F123D\";\n}\n\n.mdi-flask-empty-remove::before {\n  content: \"\\F123E\";\n}\n\n.mdi-flask-empty-remove-outline::before {\n  content: \"\\F123F\";\n}\n\n.mdi-flask-minus::before {\n  content: \"\\F1240\";\n}\n\n.mdi-flask-minus-outline::before {\n  content: \"\\F1241\";\n}\n\n.mdi-flask-off::before {\n  content: \"\\F13F6\";\n}\n\n.mdi-flask-off-outline::before {\n  content: \"\\F13F7\";\n}\n\n.mdi-flask-outline::before {\n  content: \"\\F0096\";\n}\n\n.mdi-flask-plus::before {\n  content: \"\\F1242\";\n}\n\n.mdi-flask-plus-outline::before {\n  content: \"\\F1243\";\n}\n\n.mdi-flask-remove::before {\n  content: \"\\F1244\";\n}\n\n.mdi-flask-remove-outline::before {\n  content: \"\\F1245\";\n}\n\n.mdi-flask-round-bottom::before {\n  content: \"\\F124B\";\n}\n\n.mdi-flask-round-bottom-empty::before {\n  content: \"\\F124C\";\n}\n\n.mdi-flask-round-bottom-empty-outline::before {\n  content: \"\\F124D\";\n}\n\n.mdi-flask-round-bottom-outline::before {\n  content: \"\\F124E\";\n}\n\n.mdi-fleur-de-lis::before {\n  content: \"\\F1303\";\n}\n\n.mdi-flip-horizontal::before {\n  content: \"\\F10E7\";\n}\n\n.mdi-flip-to-back::before {\n  content: \"\\F0247\";\n}\n\n.mdi-flip-to-front::before {\n  content: \"\\F0248\";\n}\n\n.mdi-flip-vertical::before {\n  content: \"\\F10E8\";\n}\n\n.mdi-floor-lamp::before {\n  content: \"\\F08DD\";\n}\n\n.mdi-floor-lamp-dual::before {\n  content: \"\\F1040\";\n}\n\n.mdi-floor-lamp-variant::before {\n  content: \"\\F1041\";\n}\n\n.mdi-floor-plan::before {\n  content: \"\\F0821\";\n}\n\n.mdi-floppy::before {\n  content: \"\\F0249\";\n}\n\n.mdi-floppy-variant::before {\n  content: \"\\F09EF\";\n}\n\n.mdi-flower::before {\n  content: \"\\F024A\";\n}\n\n.mdi-flower-outline::before {\n  content: \"\\F09F0\";\n}\n\n.mdi-flower-poppy::before {\n  content: \"\\F0D08\";\n}\n\n.mdi-flower-tulip::before {\n  content: \"\\F09F1\";\n}\n\n.mdi-flower-tulip-outline::before {\n  content: \"\\F09F2\";\n}\n\n.mdi-focus-auto::before {\n  content: \"\\F0F4E\";\n}\n\n.mdi-focus-field::before {\n  content: \"\\F0F4F\";\n}\n\n.mdi-focus-field-horizontal::before {\n  content: \"\\F0F50\";\n}\n\n.mdi-focus-field-vertical::before {\n  content: \"\\F0F51\";\n}\n\n.mdi-folder::before {\n  content: \"\\F024B\";\n}\n\n.mdi-folder-account::before {\n  content: \"\\F024C\";\n}\n\n.mdi-folder-account-outline::before {\n  content: \"\\F0B9C\";\n}\n\n.mdi-folder-alert::before {\n  content: \"\\F0DCC\";\n}\n\n.mdi-folder-alert-outline::before {\n  content: \"\\F0DCD\";\n}\n\n.mdi-folder-clock::before {\n  content: \"\\F0ABA\";\n}\n\n.mdi-folder-clock-outline::before {\n  content: \"\\F0ABB\";\n}\n\n.mdi-folder-cog::before {\n  content: \"\\F107F\";\n}\n\n.mdi-folder-cog-outline::before {\n  content: \"\\F1080\";\n}\n\n.mdi-folder-download::before {\n  content: \"\\F024D\";\n}\n\n.mdi-folder-download-outline::before {\n  content: \"\\F10E9\";\n}\n\n.mdi-folder-edit::before {\n  content: \"\\F08DE\";\n}\n\n.mdi-folder-edit-outline::before {\n  content: \"\\F0DCE\";\n}\n\n.mdi-folder-google-drive::before {\n  content: \"\\F024E\";\n}\n\n.mdi-folder-heart::before {\n  content: \"\\F10EA\";\n}\n\n.mdi-folder-heart-outline::before {\n  content: \"\\F10EB\";\n}\n\n.mdi-folder-home::before {\n  content: \"\\F10B5\";\n}\n\n.mdi-folder-home-outline::before {\n  content: \"\\F10B6\";\n}\n\n.mdi-folder-image::before {\n  content: \"\\F024F\";\n}\n\n.mdi-folder-information::before {\n  content: \"\\F10B7\";\n}\n\n.mdi-folder-information-outline::before {\n  content: \"\\F10B8\";\n}\n\n.mdi-folder-key::before {\n  content: \"\\F08AC\";\n}\n\n.mdi-folder-key-network::before {\n  content: \"\\F08AD\";\n}\n\n.mdi-folder-key-network-outline::before {\n  content: \"\\F0C80\";\n}\n\n.mdi-folder-key-outline::before {\n  content: \"\\F10EC\";\n}\n\n.mdi-folder-lock::before {\n  content: \"\\F0250\";\n}\n\n.mdi-folder-lock-open::before {\n  content: \"\\F0251\";\n}\n\n.mdi-folder-marker::before {\n  content: \"\\F126D\";\n}\n\n.mdi-folder-marker-outline::before {\n  content: \"\\F126E\";\n}\n\n.mdi-folder-move::before {\n  content: \"\\F0252\";\n}\n\n.mdi-folder-move-outline::before {\n  content: \"\\F1246\";\n}\n\n.mdi-folder-multiple::before {\n  content: \"\\F0253\";\n}\n\n.mdi-folder-multiple-image::before {\n  content: \"\\F0254\";\n}\n\n.mdi-folder-multiple-outline::before {\n  content: \"\\F0255\";\n}\n\n.mdi-folder-multiple-plus::before {\n  content: \"\\F147E\";\n}\n\n.mdi-folder-multiple-plus-outline::before {\n  content: \"\\F147F\";\n}\n\n.mdi-folder-music::before {\n  content: \"\\F1359\";\n}\n\n.mdi-folder-music-outline::before {\n  content: \"\\F135A\";\n}\n\n.mdi-folder-network::before {\n  content: \"\\F0870\";\n}\n\n.mdi-folder-network-outline::before {\n  content: \"\\F0C81\";\n}\n\n.mdi-folder-open::before {\n  content: \"\\F0770\";\n}\n\n.mdi-folder-open-outline::before {\n  content: \"\\F0DCF\";\n}\n\n.mdi-folder-outline::before {\n  content: \"\\F0256\";\n}\n\n.mdi-folder-plus::before {\n  content: \"\\F0257\";\n}\n\n.mdi-folder-plus-outline::before {\n  content: \"\\F0B9D\";\n}\n\n.mdi-folder-pound::before {\n  content: \"\\F0D09\";\n}\n\n.mdi-folder-pound-outline::before {\n  content: \"\\F0D0A\";\n}\n\n.mdi-folder-refresh::before {\n  content: \"\\F0749\";\n}\n\n.mdi-folder-refresh-outline::before {\n  content: \"\\F0542\";\n}\n\n.mdi-folder-remove::before {\n  content: \"\\F0258\";\n}\n\n.mdi-folder-remove-outline::before {\n  content: \"\\F0B9E\";\n}\n\n.mdi-folder-search::before {\n  content: \"\\F0968\";\n}\n\n.mdi-folder-search-outline::before {\n  content: \"\\F0969\";\n}\n\n.mdi-folder-settings::before {\n  content: \"\\F107D\";\n}\n\n.mdi-folder-settings-outline::before {\n  content: \"\\F107E\";\n}\n\n.mdi-folder-star::before {\n  content: \"\\F069D\";\n}\n\n.mdi-folder-star-multiple::before {\n  content: \"\\F13D3\";\n}\n\n.mdi-folder-star-multiple-outline::before {\n  content: \"\\F13D4\";\n}\n\n.mdi-folder-star-outline::before {\n  content: \"\\F0B9F\";\n}\n\n.mdi-folder-swap::before {\n  content: \"\\F0FB6\";\n}\n\n.mdi-folder-swap-outline::before {\n  content: \"\\F0FB7\";\n}\n\n.mdi-folder-sync::before {\n  content: \"\\F0D0B\";\n}\n\n.mdi-folder-sync-outline::before {\n  content: \"\\F0D0C\";\n}\n\n.mdi-folder-table::before {\n  content: \"\\F12E3\";\n}\n\n.mdi-folder-table-outline::before {\n  content: \"\\F12E4\";\n}\n\n.mdi-folder-text::before {\n  content: \"\\F0C82\";\n}\n\n.mdi-folder-text-outline::before {\n  content: \"\\F0C83\";\n}\n\n.mdi-folder-upload::before {\n  content: \"\\F0259\";\n}\n\n.mdi-folder-upload-outline::before {\n  content: \"\\F10ED\";\n}\n\n.mdi-folder-zip::before {\n  content: \"\\F06EB\";\n}\n\n.mdi-folder-zip-outline::before {\n  content: \"\\F07B9\";\n}\n\n.mdi-font-awesome::before {\n  content: \"\\F003A\";\n}\n\n.mdi-food::before {\n  content: \"\\F025A\";\n}\n\n.mdi-food-apple::before {\n  content: \"\\F025B\";\n}\n\n.mdi-food-apple-outline::before {\n  content: \"\\F0C84\";\n}\n\n.mdi-food-croissant::before {\n  content: \"\\F07C8\";\n}\n\n.mdi-food-drumstick::before {\n  content: \"\\F141F\";\n}\n\n.mdi-food-drumstick-off::before {\n  content: \"\\F1468\";\n}\n\n.mdi-food-drumstick-off-outline::before {\n  content: \"\\F1469\";\n}\n\n.mdi-food-drumstick-outline::before {\n  content: \"\\F1420\";\n}\n\n.mdi-food-fork-drink::before {\n  content: \"\\F05F2\";\n}\n\n.mdi-food-halal::before {\n  content: \"\\F1572\";\n}\n\n.mdi-food-kosher::before {\n  content: \"\\F1573\";\n}\n\n.mdi-food-off::before {\n  content: \"\\F05F3\";\n}\n\n.mdi-food-steak::before {\n  content: \"\\F146A\";\n}\n\n.mdi-food-steak-off::before {\n  content: \"\\F146B\";\n}\n\n.mdi-food-turkey::before {\n  content: \"\\F171C\";\n}\n\n.mdi-food-variant::before {\n  content: \"\\F025C\";\n}\n\n.mdi-food-variant-off::before {\n  content: \"\\F13E5\";\n}\n\n.mdi-foot-print::before {\n  content: \"\\F0F52\";\n}\n\n.mdi-football::before {\n  content: \"\\F025D\";\n}\n\n.mdi-football-australian::before {\n  content: \"\\F025E\";\n}\n\n.mdi-football-helmet::before {\n  content: \"\\F025F\";\n}\n\n.mdi-forklift::before {\n  content: \"\\F07C9\";\n}\n\n.mdi-form-dropdown::before {\n  content: \"\\F1400\";\n}\n\n.mdi-form-select::before {\n  content: \"\\F1401\";\n}\n\n.mdi-form-textarea::before {\n  content: \"\\F1095\";\n}\n\n.mdi-form-textbox::before {\n  content: \"\\F060E\";\n}\n\n.mdi-form-textbox-lock::before {\n  content: \"\\F135D\";\n}\n\n.mdi-form-textbox-password::before {\n  content: \"\\F07F5\";\n}\n\n.mdi-format-align-bottom::before {\n  content: \"\\F0753\";\n}\n\n.mdi-format-align-center::before {\n  content: \"\\F0260\";\n}\n\n.mdi-format-align-justify::before {\n  content: \"\\F0261\";\n}\n\n.mdi-format-align-left::before {\n  content: \"\\F0262\";\n}\n\n.mdi-format-align-middle::before {\n  content: \"\\F0754\";\n}\n\n.mdi-format-align-right::before {\n  content: \"\\F0263\";\n}\n\n.mdi-format-align-top::before {\n  content: \"\\F0755\";\n}\n\n.mdi-format-annotation-minus::before {\n  content: \"\\F0ABC\";\n}\n\n.mdi-format-annotation-plus::before {\n  content: \"\\F0646\";\n}\n\n.mdi-format-bold::before {\n  content: \"\\F0264\";\n}\n\n.mdi-format-clear::before {\n  content: \"\\F0265\";\n}\n\n.mdi-format-color-fill::before {\n  content: \"\\F0266\";\n}\n\n.mdi-format-color-highlight::before {\n  content: \"\\F0E31\";\n}\n\n.mdi-format-color-marker-cancel::before {\n  content: \"\\F1313\";\n}\n\n.mdi-format-color-text::before {\n  content: \"\\F069E\";\n}\n\n.mdi-format-columns::before {\n  content: \"\\F08DF\";\n}\n\n.mdi-format-float-center::before {\n  content: \"\\F0267\";\n}\n\n.mdi-format-float-left::before {\n  content: \"\\F0268\";\n}\n\n.mdi-format-float-none::before {\n  content: \"\\F0269\";\n}\n\n.mdi-format-float-right::before {\n  content: \"\\F026A\";\n}\n\n.mdi-format-font::before {\n  content: \"\\F06D6\";\n}\n\n.mdi-format-font-size-decrease::before {\n  content: \"\\F09F3\";\n}\n\n.mdi-format-font-size-increase::before {\n  content: \"\\F09F4\";\n}\n\n.mdi-format-header-1::before {\n  content: \"\\F026B\";\n}\n\n.mdi-format-header-2::before {\n  content: \"\\F026C\";\n}\n\n.mdi-format-header-3::before {\n  content: \"\\F026D\";\n}\n\n.mdi-format-header-4::before {\n  content: \"\\F026E\";\n}\n\n.mdi-format-header-5::before {\n  content: \"\\F026F\";\n}\n\n.mdi-format-header-6::before {\n  content: \"\\F0270\";\n}\n\n.mdi-format-header-decrease::before {\n  content: \"\\F0271\";\n}\n\n.mdi-format-header-equal::before {\n  content: \"\\F0272\";\n}\n\n.mdi-format-header-increase::before {\n  content: \"\\F0273\";\n}\n\n.mdi-format-header-pound::before {\n  content: \"\\F0274\";\n}\n\n.mdi-format-horizontal-align-center::before {\n  content: \"\\F061E\";\n}\n\n.mdi-format-horizontal-align-left::before {\n  content: \"\\F061F\";\n}\n\n.mdi-format-horizontal-align-right::before {\n  content: \"\\F0620\";\n}\n\n.mdi-format-indent-decrease::before {\n  content: \"\\F0275\";\n}\n\n.mdi-format-indent-increase::before {\n  content: \"\\F0276\";\n}\n\n.mdi-format-italic::before {\n  content: \"\\F0277\";\n}\n\n.mdi-format-letter-case::before {\n  content: \"\\F0B34\";\n}\n\n.mdi-format-letter-case-lower::before {\n  content: \"\\F0B35\";\n}\n\n.mdi-format-letter-case-upper::before {\n  content: \"\\F0B36\";\n}\n\n.mdi-format-letter-ends-with::before {\n  content: \"\\F0FB8\";\n}\n\n.mdi-format-letter-matches::before {\n  content: \"\\F0FB9\";\n}\n\n.mdi-format-letter-starts-with::before {\n  content: \"\\F0FBA\";\n}\n\n.mdi-format-line-spacing::before {\n  content: \"\\F0278\";\n}\n\n.mdi-format-line-style::before {\n  content: \"\\F05C8\";\n}\n\n.mdi-format-line-weight::before {\n  content: \"\\F05C9\";\n}\n\n.mdi-format-list-bulleted::before {\n  content: \"\\F0279\";\n}\n\n.mdi-format-list-bulleted-square::before {\n  content: \"\\F0DD0\";\n}\n\n.mdi-format-list-bulleted-triangle::before {\n  content: \"\\F0EB2\";\n}\n\n.mdi-format-list-bulleted-type::before {\n  content: \"\\F027A\";\n}\n\n.mdi-format-list-checkbox::before {\n  content: \"\\F096A\";\n}\n\n.mdi-format-list-checks::before {\n  content: \"\\F0756\";\n}\n\n.mdi-format-list-numbered::before {\n  content: \"\\F027B\";\n}\n\n.mdi-format-list-numbered-rtl::before {\n  content: \"\\F0D0D\";\n}\n\n.mdi-format-list-text::before {\n  content: \"\\F126F\";\n}\n\n.mdi-format-overline::before {\n  content: \"\\F0EB3\";\n}\n\n.mdi-format-page-break::before {\n  content: \"\\F06D7\";\n}\n\n.mdi-format-paint::before {\n  content: \"\\F027C\";\n}\n\n.mdi-format-paragraph::before {\n  content: \"\\F027D\";\n}\n\n.mdi-format-pilcrow::before {\n  content: \"\\F06D8\";\n}\n\n.mdi-format-quote-close::before {\n  content: \"\\F027E\";\n}\n\n.mdi-format-quote-close-outline::before {\n  content: \"\\F11A8\";\n}\n\n.mdi-format-quote-open::before {\n  content: \"\\F0757\";\n}\n\n.mdi-format-quote-open-outline::before {\n  content: \"\\F11A7\";\n}\n\n.mdi-format-rotate-90::before {\n  content: \"\\F06AA\";\n}\n\n.mdi-format-section::before {\n  content: \"\\F069F\";\n}\n\n.mdi-format-size::before {\n  content: \"\\F027F\";\n}\n\n.mdi-format-strikethrough::before {\n  content: \"\\F0280\";\n}\n\n.mdi-format-strikethrough-variant::before {\n  content: \"\\F0281\";\n}\n\n.mdi-format-subscript::before {\n  content: \"\\F0282\";\n}\n\n.mdi-format-superscript::before {\n  content: \"\\F0283\";\n}\n\n.mdi-format-text::before {\n  content: \"\\F0284\";\n}\n\n.mdi-format-text-rotation-angle-down::before {\n  content: \"\\F0FBB\";\n}\n\n.mdi-format-text-rotation-angle-up::before {\n  content: \"\\F0FBC\";\n}\n\n.mdi-format-text-rotation-down::before {\n  content: \"\\F0D73\";\n}\n\n.mdi-format-text-rotation-down-vertical::before {\n  content: \"\\F0FBD\";\n}\n\n.mdi-format-text-rotation-none::before {\n  content: \"\\F0D74\";\n}\n\n.mdi-format-text-rotation-up::before {\n  content: \"\\F0FBE\";\n}\n\n.mdi-format-text-rotation-vertical::before {\n  content: \"\\F0FBF\";\n}\n\n.mdi-format-text-variant::before {\n  content: \"\\F0E32\";\n}\n\n.mdi-format-text-variant-outline::before {\n  content: \"\\F150F\";\n}\n\n.mdi-format-text-wrapping-clip::before {\n  content: \"\\F0D0E\";\n}\n\n.mdi-format-text-wrapping-overflow::before {\n  content: \"\\F0D0F\";\n}\n\n.mdi-format-text-wrapping-wrap::before {\n  content: \"\\F0D10\";\n}\n\n.mdi-format-textbox::before {\n  content: \"\\F0D11\";\n}\n\n.mdi-format-textdirection-l-to-r::before {\n  content: \"\\F0285\";\n}\n\n.mdi-format-textdirection-r-to-l::before {\n  content: \"\\F0286\";\n}\n\n.mdi-format-title::before {\n  content: \"\\F05F4\";\n}\n\n.mdi-format-underline::before {\n  content: \"\\F0287\";\n}\n\n.mdi-format-vertical-align-bottom::before {\n  content: \"\\F0621\";\n}\n\n.mdi-format-vertical-align-center::before {\n  content: \"\\F0622\";\n}\n\n.mdi-format-vertical-align-top::before {\n  content: \"\\F0623\";\n}\n\n.mdi-format-wrap-inline::before {\n  content: \"\\F0288\";\n}\n\n.mdi-format-wrap-square::before {\n  content: \"\\F0289\";\n}\n\n.mdi-format-wrap-tight::before {\n  content: \"\\F028A\";\n}\n\n.mdi-format-wrap-top-bottom::before {\n  content: \"\\F028B\";\n}\n\n.mdi-forum::before {\n  content: \"\\F028C\";\n}\n\n.mdi-forum-outline::before {\n  content: \"\\F0822\";\n}\n\n.mdi-forward::before {\n  content: \"\\F028D\";\n}\n\n.mdi-forwardburger::before {\n  content: \"\\F0D75\";\n}\n\n.mdi-fountain::before {\n  content: \"\\F096B\";\n}\n\n.mdi-fountain-pen::before {\n  content: \"\\F0D12\";\n}\n\n.mdi-fountain-pen-tip::before {\n  content: \"\\F0D13\";\n}\n\n.mdi-freebsd::before {\n  content: \"\\F08E0\";\n}\n\n.mdi-frequently-asked-questions::before {\n  content: \"\\F0EB4\";\n}\n\n.mdi-fridge::before {\n  content: \"\\F0290\";\n}\n\n.mdi-fridge-alert::before {\n  content: \"\\F11B1\";\n}\n\n.mdi-fridge-alert-outline::before {\n  content: \"\\F11B2\";\n}\n\n.mdi-fridge-bottom::before {\n  content: \"\\F0292\";\n}\n\n.mdi-fridge-industrial::before {\n  content: \"\\F15EE\";\n}\n\n.mdi-fridge-industrial-alert::before {\n  content: \"\\F15EF\";\n}\n\n.mdi-fridge-industrial-alert-outline::before {\n  content: \"\\F15F0\";\n}\n\n.mdi-fridge-industrial-off::before {\n  content: \"\\F15F1\";\n}\n\n.mdi-fridge-industrial-off-outline::before {\n  content: \"\\F15F2\";\n}\n\n.mdi-fridge-industrial-outline::before {\n  content: \"\\F15F3\";\n}\n\n.mdi-fridge-off::before {\n  content: \"\\F11AF\";\n}\n\n.mdi-fridge-off-outline::before {\n  content: \"\\F11B0\";\n}\n\n.mdi-fridge-outline::before {\n  content: \"\\F028F\";\n}\n\n.mdi-fridge-top::before {\n  content: \"\\F0291\";\n}\n\n.mdi-fridge-variant::before {\n  content: \"\\F15F4\";\n}\n\n.mdi-fridge-variant-alert::before {\n  content: \"\\F15F5\";\n}\n\n.mdi-fridge-variant-alert-outline::before {\n  content: \"\\F15F6\";\n}\n\n.mdi-fridge-variant-off::before {\n  content: \"\\F15F7\";\n}\n\n.mdi-fridge-variant-off-outline::before {\n  content: \"\\F15F8\";\n}\n\n.mdi-fridge-variant-outline::before {\n  content: \"\\F15F9\";\n}\n\n.mdi-fruit-cherries::before {\n  content: \"\\F1042\";\n}\n\n.mdi-fruit-cherries-off::before {\n  content: \"\\F13F8\";\n}\n\n.mdi-fruit-citrus::before {\n  content: \"\\F1043\";\n}\n\n.mdi-fruit-citrus-off::before {\n  content: \"\\F13F9\";\n}\n\n.mdi-fruit-grapes::before {\n  content: \"\\F1044\";\n}\n\n.mdi-fruit-grapes-outline::before {\n  content: \"\\F1045\";\n}\n\n.mdi-fruit-pineapple::before {\n  content: \"\\F1046\";\n}\n\n.mdi-fruit-watermelon::before {\n  content: \"\\F1047\";\n}\n\n.mdi-fuel::before {\n  content: \"\\F07CA\";\n}\n\n.mdi-fullscreen::before {\n  content: \"\\F0293\";\n}\n\n.mdi-fullscreen-exit::before {\n  content: \"\\F0294\";\n}\n\n.mdi-function::before {\n  content: \"\\F0295\";\n}\n\n.mdi-function-variant::before {\n  content: \"\\F0871\";\n}\n\n.mdi-furigana-horizontal::before {\n  content: \"\\F1081\";\n}\n\n.mdi-furigana-vertical::before {\n  content: \"\\F1082\";\n}\n\n.mdi-fuse::before {\n  content: \"\\F0C85\";\n}\n\n.mdi-fuse-alert::before {\n  content: \"\\F142D\";\n}\n\n.mdi-fuse-blade::before {\n  content: \"\\F0C86\";\n}\n\n.mdi-fuse-off::before {\n  content: \"\\F142C\";\n}\n\n.mdi-gamepad::before {\n  content: \"\\F0296\";\n}\n\n.mdi-gamepad-circle::before {\n  content: \"\\F0E33\";\n}\n\n.mdi-gamepad-circle-down::before {\n  content: \"\\F0E34\";\n}\n\n.mdi-gamepad-circle-left::before {\n  content: \"\\F0E35\";\n}\n\n.mdi-gamepad-circle-outline::before {\n  content: \"\\F0E36\";\n}\n\n.mdi-gamepad-circle-right::before {\n  content: \"\\F0E37\";\n}\n\n.mdi-gamepad-circle-up::before {\n  content: \"\\F0E38\";\n}\n\n.mdi-gamepad-down::before {\n  content: \"\\F0E39\";\n}\n\n.mdi-gamepad-left::before {\n  content: \"\\F0E3A\";\n}\n\n.mdi-gamepad-right::before {\n  content: \"\\F0E3B\";\n}\n\n.mdi-gamepad-round::before {\n  content: \"\\F0E3C\";\n}\n\n.mdi-gamepad-round-down::before {\n  content: \"\\F0E3D\";\n}\n\n.mdi-gamepad-round-left::before {\n  content: \"\\F0E3E\";\n}\n\n.mdi-gamepad-round-outline::before {\n  content: \"\\F0E3F\";\n}\n\n.mdi-gamepad-round-right::before {\n  content: \"\\F0E40\";\n}\n\n.mdi-gamepad-round-up::before {\n  content: \"\\F0E41\";\n}\n\n.mdi-gamepad-square::before {\n  content: \"\\F0EB5\";\n}\n\n.mdi-gamepad-square-outline::before {\n  content: \"\\F0EB6\";\n}\n\n.mdi-gamepad-up::before {\n  content: \"\\F0E42\";\n}\n\n.mdi-gamepad-variant::before {\n  content: \"\\F0297\";\n}\n\n.mdi-gamepad-variant-outline::before {\n  content: \"\\F0EB7\";\n}\n\n.mdi-gamma::before {\n  content: \"\\F10EE\";\n}\n\n.mdi-gantry-crane::before {\n  content: \"\\F0DD1\";\n}\n\n.mdi-garage::before {\n  content: \"\\F06D9\";\n}\n\n.mdi-garage-alert::before {\n  content: \"\\F0872\";\n}\n\n.mdi-garage-alert-variant::before {\n  content: \"\\F12D5\";\n}\n\n.mdi-garage-open::before {\n  content: \"\\F06DA\";\n}\n\n.mdi-garage-open-variant::before {\n  content: \"\\F12D4\";\n}\n\n.mdi-garage-variant::before {\n  content: \"\\F12D3\";\n}\n\n.mdi-gas-cylinder::before {\n  content: \"\\F0647\";\n}\n\n.mdi-gas-station::before {\n  content: \"\\F0298\";\n}\n\n.mdi-gas-station-off::before {\n  content: \"\\F1409\";\n}\n\n.mdi-gas-station-off-outline::before {\n  content: \"\\F140A\";\n}\n\n.mdi-gas-station-outline::before {\n  content: \"\\F0EB8\";\n}\n\n.mdi-gate::before {\n  content: \"\\F0299\";\n}\n\n.mdi-gate-and::before {\n  content: \"\\F08E1\";\n}\n\n.mdi-gate-arrow-right::before {\n  content: \"\\F1169\";\n}\n\n.mdi-gate-nand::before {\n  content: \"\\F08E2\";\n}\n\n.mdi-gate-nor::before {\n  content: \"\\F08E3\";\n}\n\n.mdi-gate-not::before {\n  content: \"\\F08E4\";\n}\n\n.mdi-gate-open::before {\n  content: \"\\F116A\";\n}\n\n.mdi-gate-or::before {\n  content: \"\\F08E5\";\n}\n\n.mdi-gate-xnor::before {\n  content: \"\\F08E6\";\n}\n\n.mdi-gate-xor::before {\n  content: \"\\F08E7\";\n}\n\n.mdi-gatsby::before {\n  content: \"\\F0E43\";\n}\n\n.mdi-gauge::before {\n  content: \"\\F029A\";\n}\n\n.mdi-gauge-empty::before {\n  content: \"\\F0873\";\n}\n\n.mdi-gauge-full::before {\n  content: \"\\F0874\";\n}\n\n.mdi-gauge-low::before {\n  content: \"\\F0875\";\n}\n\n.mdi-gavel::before {\n  content: \"\\F029B\";\n}\n\n.mdi-gender-female::before {\n  content: \"\\F029C\";\n}\n\n.mdi-gender-male::before {\n  content: \"\\F029D\";\n}\n\n.mdi-gender-male-female::before {\n  content: \"\\F029E\";\n}\n\n.mdi-gender-male-female-variant::before {\n  content: \"\\F113F\";\n}\n\n.mdi-gender-non-binary::before {\n  content: \"\\F1140\";\n}\n\n.mdi-gender-transgender::before {\n  content: \"\\F029F\";\n}\n\n.mdi-gentoo::before {\n  content: \"\\F08E8\";\n}\n\n.mdi-gesture::before {\n  content: \"\\F07CB\";\n}\n\n.mdi-gesture-double-tap::before {\n  content: \"\\F073C\";\n}\n\n.mdi-gesture-pinch::before {\n  content: \"\\F0ABD\";\n}\n\n.mdi-gesture-spread::before {\n  content: \"\\F0ABE\";\n}\n\n.mdi-gesture-swipe::before {\n  content: \"\\F0D76\";\n}\n\n.mdi-gesture-swipe-down::before {\n  content: \"\\F073D\";\n}\n\n.mdi-gesture-swipe-horizontal::before {\n  content: \"\\F0ABF\";\n}\n\n.mdi-gesture-swipe-left::before {\n  content: \"\\F073E\";\n}\n\n.mdi-gesture-swipe-right::before {\n  content: \"\\F073F\";\n}\n\n.mdi-gesture-swipe-up::before {\n  content: \"\\F0740\";\n}\n\n.mdi-gesture-swipe-vertical::before {\n  content: \"\\F0AC0\";\n}\n\n.mdi-gesture-tap::before {\n  content: \"\\F0741\";\n}\n\n.mdi-gesture-tap-box::before {\n  content: \"\\F12A9\";\n}\n\n.mdi-gesture-tap-button::before {\n  content: \"\\F12A8\";\n}\n\n.mdi-gesture-tap-hold::before {\n  content: \"\\F0D77\";\n}\n\n.mdi-gesture-two-double-tap::before {\n  content: \"\\F0742\";\n}\n\n.mdi-gesture-two-tap::before {\n  content: \"\\F0743\";\n}\n\n.mdi-ghost::before {\n  content: \"\\F02A0\";\n}\n\n.mdi-ghost-off::before {\n  content: \"\\F09F5\";\n}\n\n.mdi-ghost-off-outline::before {\n  content: \"\\F165C\";\n}\n\n.mdi-ghost-outline::before {\n  content: \"\\F165D\";\n}\n\n.mdi-gif::before {\n  content: \"\\F0D78\";\n}\n\n.mdi-gift::before {\n  content: \"\\F0E44\";\n}\n\n.mdi-gift-off::before {\n  content: \"\\F16EF\";\n}\n\n.mdi-gift-off-outline::before {\n  content: \"\\F16F0\";\n}\n\n.mdi-gift-open::before {\n  content: \"\\F16F1\";\n}\n\n.mdi-gift-open-outline::before {\n  content: \"\\F16F2\";\n}\n\n.mdi-gift-outline::before {\n  content: \"\\F02A1\";\n}\n\n.mdi-git::before {\n  content: \"\\F02A2\";\n}\n\n.mdi-github::before {\n  content: \"\\F02A4\";\n}\n\n.mdi-gitlab::before {\n  content: \"\\F0BA0\";\n}\n\n.mdi-glass-cocktail::before {\n  content: \"\\F0356\";\n}\n\n.mdi-glass-cocktail-off::before {\n  content: \"\\F15E6\";\n}\n\n.mdi-glass-flute::before {\n  content: \"\\F02A5\";\n}\n\n.mdi-glass-mug::before {\n  content: \"\\F02A6\";\n}\n\n.mdi-glass-mug-off::before {\n  content: \"\\F15E7\";\n}\n\n.mdi-glass-mug-variant::before {\n  content: \"\\F1116\";\n}\n\n.mdi-glass-mug-variant-off::before {\n  content: \"\\F15E8\";\n}\n\n.mdi-glass-pint-outline::before {\n  content: \"\\F130D\";\n}\n\n.mdi-glass-stange::before {\n  content: \"\\F02A7\";\n}\n\n.mdi-glass-tulip::before {\n  content: \"\\F02A8\";\n}\n\n.mdi-glass-wine::before {\n  content: \"\\F0876\";\n}\n\n.mdi-glasses::before {\n  content: \"\\F02AA\";\n}\n\n.mdi-globe-light::before {\n  content: \"\\F12D7\";\n}\n\n.mdi-globe-model::before {\n  content: \"\\F08E9\";\n}\n\n.mdi-gmail::before {\n  content: \"\\F02AB\";\n}\n\n.mdi-gnome::before {\n  content: \"\\F02AC\";\n}\n\n.mdi-go-kart::before {\n  content: \"\\F0D79\";\n}\n\n.mdi-go-kart-track::before {\n  content: \"\\F0D7A\";\n}\n\n.mdi-gog::before {\n  content: \"\\F0BA1\";\n}\n\n.mdi-gold::before {\n  content: \"\\F124F\";\n}\n\n.mdi-golf::before {\n  content: \"\\F0823\";\n}\n\n.mdi-golf-cart::before {\n  content: \"\\F11A4\";\n}\n\n.mdi-golf-tee::before {\n  content: \"\\F1083\";\n}\n\n.mdi-gondola::before {\n  content: \"\\F0686\";\n}\n\n.mdi-goodreads::before {\n  content: \"\\F0D7B\";\n}\n\n.mdi-google::before {\n  content: \"\\F02AD\";\n}\n\n.mdi-google-ads::before {\n  content: \"\\F0C87\";\n}\n\n.mdi-google-analytics::before {\n  content: \"\\F07CC\";\n}\n\n.mdi-google-assistant::before {\n  content: \"\\F07CD\";\n}\n\n.mdi-google-cardboard::before {\n  content: \"\\F02AE\";\n}\n\n.mdi-google-chrome::before {\n  content: \"\\F02AF\";\n}\n\n.mdi-google-circles::before {\n  content: \"\\F02B0\";\n}\n\n.mdi-google-circles-communities::before {\n  content: \"\\F02B1\";\n}\n\n.mdi-google-circles-extended::before {\n  content: \"\\F02B2\";\n}\n\n.mdi-google-circles-group::before {\n  content: \"\\F02B3\";\n}\n\n.mdi-google-classroom::before {\n  content: \"\\F02C0\";\n}\n\n.mdi-google-cloud::before {\n  content: \"\\F11F6\";\n}\n\n.mdi-google-controller::before {\n  content: \"\\F02B4\";\n}\n\n.mdi-google-controller-off::before {\n  content: \"\\F02B5\";\n}\n\n.mdi-google-downasaur::before {\n  content: \"\\F1362\";\n}\n\n.mdi-google-drive::before {\n  content: \"\\F02B6\";\n}\n\n.mdi-google-earth::before {\n  content: \"\\F02B7\";\n}\n\n.mdi-google-fit::before {\n  content: \"\\F096C\";\n}\n\n.mdi-google-glass::before {\n  content: \"\\F02B8\";\n}\n\n.mdi-google-hangouts::before {\n  content: \"\\F02C9\";\n}\n\n.mdi-google-home::before {\n  content: \"\\F0824\";\n}\n\n.mdi-google-keep::before {\n  content: \"\\F06DC\";\n}\n\n.mdi-google-lens::before {\n  content: \"\\F09F6\";\n}\n\n.mdi-google-maps::before {\n  content: \"\\F05F5\";\n}\n\n.mdi-google-my-business::before {\n  content: \"\\F1048\";\n}\n\n.mdi-google-nearby::before {\n  content: \"\\F02B9\";\n}\n\n.mdi-google-photos::before {\n  content: \"\\F06DD\";\n}\n\n.mdi-google-play::before {\n  content: \"\\F02BC\";\n}\n\n.mdi-google-plus::before {\n  content: \"\\F02BD\";\n}\n\n.mdi-google-podcast::before {\n  content: \"\\F0EB9\";\n}\n\n.mdi-google-spreadsheet::before {\n  content: \"\\F09F7\";\n}\n\n.mdi-google-street-view::before {\n  content: \"\\F0C88\";\n}\n\n.mdi-google-translate::before {\n  content: \"\\F02BF\";\n}\n\n.mdi-gradient::before {\n  content: \"\\F06A0\";\n}\n\n.mdi-grain::before {\n  content: \"\\F0D7C\";\n}\n\n.mdi-graph::before {\n  content: \"\\F1049\";\n}\n\n.mdi-graph-outline::before {\n  content: \"\\F104A\";\n}\n\n.mdi-graphql::before {\n  content: \"\\F0877\";\n}\n\n.mdi-grass::before {\n  content: \"\\F1510\";\n}\n\n.mdi-grave-stone::before {\n  content: \"\\F0BA2\";\n}\n\n.mdi-grease-pencil::before {\n  content: \"\\F0648\";\n}\n\n.mdi-greater-than::before {\n  content: \"\\F096D\";\n}\n\n.mdi-greater-than-or-equal::before {\n  content: \"\\F096E\";\n}\n\n.mdi-grid::before {\n  content: \"\\F02C1\";\n}\n\n.mdi-grid-large::before {\n  content: \"\\F0758\";\n}\n\n.mdi-grid-off::before {\n  content: \"\\F02C2\";\n}\n\n.mdi-grill::before {\n  content: \"\\F0E45\";\n}\n\n.mdi-grill-outline::before {\n  content: \"\\F118A\";\n}\n\n.mdi-group::before {\n  content: \"\\F02C3\";\n}\n\n.mdi-guitar-acoustic::before {\n  content: \"\\F0771\";\n}\n\n.mdi-guitar-electric::before {\n  content: \"\\F02C4\";\n}\n\n.mdi-guitar-pick::before {\n  content: \"\\F02C5\";\n}\n\n.mdi-guitar-pick-outline::before {\n  content: \"\\F02C6\";\n}\n\n.mdi-guy-fawkes-mask::before {\n  content: \"\\F0825\";\n}\n\n.mdi-hail::before {\n  content: \"\\F0AC1\";\n}\n\n.mdi-hair-dryer::before {\n  content: \"\\F10EF\";\n}\n\n.mdi-hair-dryer-outline::before {\n  content: \"\\F10F0\";\n}\n\n.mdi-halloween::before {\n  content: \"\\F0BA3\";\n}\n\n.mdi-hamburger::before {\n  content: \"\\F0685\";\n}\n\n.mdi-hammer::before {\n  content: \"\\F08EA\";\n}\n\n.mdi-hammer-screwdriver::before {\n  content: \"\\F1322\";\n}\n\n.mdi-hammer-wrench::before {\n  content: \"\\F1323\";\n}\n\n.mdi-hand::before {\n  content: \"\\F0A4F\";\n}\n\n.mdi-hand-heart::before {\n  content: \"\\F10F1\";\n}\n\n.mdi-hand-heart-outline::before {\n  content: \"\\F157E\";\n}\n\n.mdi-hand-left::before {\n  content: \"\\F0E46\";\n}\n\n.mdi-hand-okay::before {\n  content: \"\\F0A50\";\n}\n\n.mdi-hand-peace::before {\n  content: \"\\F0A51\";\n}\n\n.mdi-hand-peace-variant::before {\n  content: \"\\F0A52\";\n}\n\n.mdi-hand-pointing-down::before {\n  content: \"\\F0A53\";\n}\n\n.mdi-hand-pointing-left::before {\n  content: \"\\F0A54\";\n}\n\n.mdi-hand-pointing-right::before {\n  content: \"\\F02C7\";\n}\n\n.mdi-hand-pointing-up::before {\n  content: \"\\F0A55\";\n}\n\n.mdi-hand-right::before {\n  content: \"\\F0E47\";\n}\n\n.mdi-hand-saw::before {\n  content: \"\\F0E48\";\n}\n\n.mdi-hand-wash::before {\n  content: \"\\F157F\";\n}\n\n.mdi-hand-wash-outline::before {\n  content: \"\\F1580\";\n}\n\n.mdi-hand-water::before {\n  content: \"\\F139F\";\n}\n\n.mdi-handball::before {\n  content: \"\\F0F53\";\n}\n\n.mdi-handcuffs::before {\n  content: \"\\F113E\";\n}\n\n.mdi-handshake::before {\n  content: \"\\F1218\";\n}\n\n.mdi-handshake-outline::before {\n  content: \"\\F15A1\";\n}\n\n.mdi-hanger::before {\n  content: \"\\F02C8\";\n}\n\n.mdi-hard-hat::before {\n  content: \"\\F096F\";\n}\n\n.mdi-harddisk::before {\n  content: \"\\F02CA\";\n}\n\n.mdi-harddisk-plus::before {\n  content: \"\\F104B\";\n}\n\n.mdi-harddisk-remove::before {\n  content: \"\\F104C\";\n}\n\n.mdi-hat-fedora::before {\n  content: \"\\F0BA4\";\n}\n\n.mdi-hazard-lights::before {\n  content: \"\\F0C89\";\n}\n\n.mdi-hdr::before {\n  content: \"\\F0D7D\";\n}\n\n.mdi-hdr-off::before {\n  content: \"\\F0D7E\";\n}\n\n.mdi-head::before {\n  content: \"\\F135E\";\n}\n\n.mdi-head-alert::before {\n  content: \"\\F1338\";\n}\n\n.mdi-head-alert-outline::before {\n  content: \"\\F1339\";\n}\n\n.mdi-head-check::before {\n  content: \"\\F133A\";\n}\n\n.mdi-head-check-outline::before {\n  content: \"\\F133B\";\n}\n\n.mdi-head-cog::before {\n  content: \"\\F133C\";\n}\n\n.mdi-head-cog-outline::before {\n  content: \"\\F133D\";\n}\n\n.mdi-head-dots-horizontal::before {\n  content: \"\\F133E\";\n}\n\n.mdi-head-dots-horizontal-outline::before {\n  content: \"\\F133F\";\n}\n\n.mdi-head-flash::before {\n  content: \"\\F1340\";\n}\n\n.mdi-head-flash-outline::before {\n  content: \"\\F1341\";\n}\n\n.mdi-head-heart::before {\n  content: \"\\F1342\";\n}\n\n.mdi-head-heart-outline::before {\n  content: \"\\F1343\";\n}\n\n.mdi-head-lightbulb::before {\n  content: \"\\F1344\";\n}\n\n.mdi-head-lightbulb-outline::before {\n  content: \"\\F1345\";\n}\n\n.mdi-head-minus::before {\n  content: \"\\F1346\";\n}\n\n.mdi-head-minus-outline::before {\n  content: \"\\F1347\";\n}\n\n.mdi-head-outline::before {\n  content: \"\\F135F\";\n}\n\n.mdi-head-plus::before {\n  content: \"\\F1348\";\n}\n\n.mdi-head-plus-outline::before {\n  content: \"\\F1349\";\n}\n\n.mdi-head-question::before {\n  content: \"\\F134A\";\n}\n\n.mdi-head-question-outline::before {\n  content: \"\\F134B\";\n}\n\n.mdi-head-remove::before {\n  content: \"\\F134C\";\n}\n\n.mdi-head-remove-outline::before {\n  content: \"\\F134D\";\n}\n\n.mdi-head-snowflake::before {\n  content: \"\\F134E\";\n}\n\n.mdi-head-snowflake-outline::before {\n  content: \"\\F134F\";\n}\n\n.mdi-head-sync::before {\n  content: \"\\F1350\";\n}\n\n.mdi-head-sync-outline::before {\n  content: \"\\F1351\";\n}\n\n.mdi-headphones::before {\n  content: \"\\F02CB\";\n}\n\n.mdi-headphones-bluetooth::before {\n  content: \"\\F0970\";\n}\n\n.mdi-headphones-box::before {\n  content: \"\\F02CC\";\n}\n\n.mdi-headphones-off::before {\n  content: \"\\F07CE\";\n}\n\n.mdi-headphones-settings::before {\n  content: \"\\F02CD\";\n}\n\n.mdi-headset::before {\n  content: \"\\F02CE\";\n}\n\n.mdi-headset-dock::before {\n  content: \"\\F02CF\";\n}\n\n.mdi-headset-off::before {\n  content: \"\\F02D0\";\n}\n\n.mdi-heart::before {\n  content: \"\\F02D1\";\n}\n\n.mdi-heart-box::before {\n  content: \"\\F02D2\";\n}\n\n.mdi-heart-box-outline::before {\n  content: \"\\F02D3\";\n}\n\n.mdi-heart-broken::before {\n  content: \"\\F02D4\";\n}\n\n.mdi-heart-broken-outline::before {\n  content: \"\\F0D14\";\n}\n\n.mdi-heart-circle::before {\n  content: \"\\F0971\";\n}\n\n.mdi-heart-circle-outline::before {\n  content: \"\\F0972\";\n}\n\n.mdi-heart-cog::before {\n  content: \"\\F1663\";\n}\n\n.mdi-heart-cog-outline::before {\n  content: \"\\F1664\";\n}\n\n.mdi-heart-flash::before {\n  content: \"\\F0EF9\";\n}\n\n.mdi-heart-half::before {\n  content: \"\\F06DF\";\n}\n\n.mdi-heart-half-full::before {\n  content: \"\\F06DE\";\n}\n\n.mdi-heart-half-outline::before {\n  content: \"\\F06E0\";\n}\n\n.mdi-heart-minus::before {\n  content: \"\\F142F\";\n}\n\n.mdi-heart-minus-outline::before {\n  content: \"\\F1432\";\n}\n\n.mdi-heart-multiple::before {\n  content: \"\\F0A56\";\n}\n\n.mdi-heart-multiple-outline::before {\n  content: \"\\F0A57\";\n}\n\n.mdi-heart-off::before {\n  content: \"\\F0759\";\n}\n\n.mdi-heart-off-outline::before {\n  content: \"\\F1434\";\n}\n\n.mdi-heart-outline::before {\n  content: \"\\F02D5\";\n}\n\n.mdi-heart-plus::before {\n  content: \"\\F142E\";\n}\n\n.mdi-heart-plus-outline::before {\n  content: \"\\F1431\";\n}\n\n.mdi-heart-pulse::before {\n  content: \"\\F05F6\";\n}\n\n.mdi-heart-remove::before {\n  content: \"\\F1430\";\n}\n\n.mdi-heart-remove-outline::before {\n  content: \"\\F1433\";\n}\n\n.mdi-heart-settings::before {\n  content: \"\\F1665\";\n}\n\n.mdi-heart-settings-outline::before {\n  content: \"\\F1666\";\n}\n\n.mdi-helicopter::before {\n  content: \"\\F0AC2\";\n}\n\n.mdi-help::before {\n  content: \"\\F02D6\";\n}\n\n.mdi-help-box::before {\n  content: \"\\F078B\";\n}\n\n.mdi-help-circle::before {\n  content: \"\\F02D7\";\n}\n\n.mdi-help-circle-outline::before {\n  content: \"\\F0625\";\n}\n\n.mdi-help-network::before {\n  content: \"\\F06F5\";\n}\n\n.mdi-help-network-outline::before {\n  content: \"\\F0C8A\";\n}\n\n.mdi-help-rhombus::before {\n  content: \"\\F0BA5\";\n}\n\n.mdi-help-rhombus-outline::before {\n  content: \"\\F0BA6\";\n}\n\n.mdi-hexadecimal::before {\n  content: \"\\F12A7\";\n}\n\n.mdi-hexagon::before {\n  content: \"\\F02D8\";\n}\n\n.mdi-hexagon-multiple::before {\n  content: \"\\F06E1\";\n}\n\n.mdi-hexagon-multiple-outline::before {\n  content: \"\\F10F2\";\n}\n\n.mdi-hexagon-outline::before {\n  content: \"\\F02D9\";\n}\n\n.mdi-hexagon-slice-1::before {\n  content: \"\\F0AC3\";\n}\n\n.mdi-hexagon-slice-2::before {\n  content: \"\\F0AC4\";\n}\n\n.mdi-hexagon-slice-3::before {\n  content: \"\\F0AC5\";\n}\n\n.mdi-hexagon-slice-4::before {\n  content: \"\\F0AC6\";\n}\n\n.mdi-hexagon-slice-5::before {\n  content: \"\\F0AC7\";\n}\n\n.mdi-hexagon-slice-6::before {\n  content: \"\\F0AC8\";\n}\n\n.mdi-hexagram::before {\n  content: \"\\F0AC9\";\n}\n\n.mdi-hexagram-outline::before {\n  content: \"\\F0ACA\";\n}\n\n.mdi-high-definition::before {\n  content: \"\\F07CF\";\n}\n\n.mdi-high-definition-box::before {\n  content: \"\\F0878\";\n}\n\n.mdi-highway::before {\n  content: \"\\F05F7\";\n}\n\n.mdi-hiking::before {\n  content: \"\\F0D7F\";\n}\n\n.mdi-hinduism::before {\n  content: \"\\F0973\";\n}\n\n.mdi-history::before {\n  content: \"\\F02DA\";\n}\n\n.mdi-hockey-puck::before {\n  content: \"\\F0879\";\n}\n\n.mdi-hockey-sticks::before {\n  content: \"\\F087A\";\n}\n\n.mdi-hololens::before {\n  content: \"\\F02DB\";\n}\n\n.mdi-home::before {\n  content: \"\\F02DC\";\n}\n\n.mdi-home-account::before {\n  content: \"\\F0826\";\n}\n\n.mdi-home-alert::before {\n  content: \"\\F087B\";\n}\n\n.mdi-home-alert-outline::before {\n  content: \"\\F15D0\";\n}\n\n.mdi-home-analytics::before {\n  content: \"\\F0EBA\";\n}\n\n.mdi-home-assistant::before {\n  content: \"\\F07D0\";\n}\n\n.mdi-home-automation::before {\n  content: \"\\F07D1\";\n}\n\n.mdi-home-circle::before {\n  content: \"\\F07D2\";\n}\n\n.mdi-home-circle-outline::before {\n  content: \"\\F104D\";\n}\n\n.mdi-home-city::before {\n  content: \"\\F0D15\";\n}\n\n.mdi-home-city-outline::before {\n  content: \"\\F0D16\";\n}\n\n.mdi-home-currency-usd::before {\n  content: \"\\F08AF\";\n}\n\n.mdi-home-edit::before {\n  content: \"\\F1159\";\n}\n\n.mdi-home-edit-outline::before {\n  content: \"\\F115A\";\n}\n\n.mdi-home-export-outline::before {\n  content: \"\\F0F9B\";\n}\n\n.mdi-home-flood::before {\n  content: \"\\F0EFA\";\n}\n\n.mdi-home-floor-0::before {\n  content: \"\\F0DD2\";\n}\n\n.mdi-home-floor-1::before {\n  content: \"\\F0D80\";\n}\n\n.mdi-home-floor-2::before {\n  content: \"\\F0D81\";\n}\n\n.mdi-home-floor-3::before {\n  content: \"\\F0D82\";\n}\n\n.mdi-home-floor-a::before {\n  content: \"\\F0D83\";\n}\n\n.mdi-home-floor-b::before {\n  content: \"\\F0D84\";\n}\n\n.mdi-home-floor-g::before {\n  content: \"\\F0D85\";\n}\n\n.mdi-home-floor-l::before {\n  content: \"\\F0D86\";\n}\n\n.mdi-home-floor-negative-1::before {\n  content: \"\\F0DD3\";\n}\n\n.mdi-home-group::before {\n  content: \"\\F0DD4\";\n}\n\n.mdi-home-heart::before {\n  content: \"\\F0827\";\n}\n\n.mdi-home-import-outline::before {\n  content: \"\\F0F9C\";\n}\n\n.mdi-home-lightbulb::before {\n  content: \"\\F1251\";\n}\n\n.mdi-home-lightbulb-outline::before {\n  content: \"\\F1252\";\n}\n\n.mdi-home-lock::before {\n  content: \"\\F08EB\";\n}\n\n.mdi-home-lock-open::before {\n  content: \"\\F08EC\";\n}\n\n.mdi-home-map-marker::before {\n  content: \"\\F05F8\";\n}\n\n.mdi-home-minus::before {\n  content: \"\\F0974\";\n}\n\n.mdi-home-minus-outline::before {\n  content: \"\\F13D5\";\n}\n\n.mdi-home-modern::before {\n  content: \"\\F02DD\";\n}\n\n.mdi-home-outline::before {\n  content: \"\\F06A1\";\n}\n\n.mdi-home-plus::before {\n  content: \"\\F0975\";\n}\n\n.mdi-home-plus-outline::before {\n  content: \"\\F13D6\";\n}\n\n.mdi-home-remove::before {\n  content: \"\\F1247\";\n}\n\n.mdi-home-remove-outline::before {\n  content: \"\\F13D7\";\n}\n\n.mdi-home-roof::before {\n  content: \"\\F112B\";\n}\n\n.mdi-home-search::before {\n  content: \"\\F13B0\";\n}\n\n.mdi-home-search-outline::before {\n  content: \"\\F13B1\";\n}\n\n.mdi-home-thermometer::before {\n  content: \"\\F0F54\";\n}\n\n.mdi-home-thermometer-outline::before {\n  content: \"\\F0F55\";\n}\n\n.mdi-home-variant::before {\n  content: \"\\F02DE\";\n}\n\n.mdi-home-variant-outline::before {\n  content: \"\\F0BA7\";\n}\n\n.mdi-hook::before {\n  content: \"\\F06E2\";\n}\n\n.mdi-hook-off::before {\n  content: \"\\F06E3\";\n}\n\n.mdi-hops::before {\n  content: \"\\F02DF\";\n}\n\n.mdi-horizontal-rotate-clockwise::before {\n  content: \"\\F10F3\";\n}\n\n.mdi-horizontal-rotate-counterclockwise::before {\n  content: \"\\F10F4\";\n}\n\n.mdi-horse::before {\n  content: \"\\F15BF\";\n}\n\n.mdi-horse-human::before {\n  content: \"\\F15C0\";\n}\n\n.mdi-horse-variant::before {\n  content: \"\\F15C1\";\n}\n\n.mdi-horseshoe::before {\n  content: \"\\F0A58\";\n}\n\n.mdi-hospital::before {\n  content: \"\\F0FF6\";\n}\n\n.mdi-hospital-box::before {\n  content: \"\\F02E0\";\n}\n\n.mdi-hospital-box-outline::before {\n  content: \"\\F0FF7\";\n}\n\n.mdi-hospital-building::before {\n  content: \"\\F02E1\";\n}\n\n.mdi-hospital-marker::before {\n  content: \"\\F02E2\";\n}\n\n.mdi-hot-tub::before {\n  content: \"\\F0828\";\n}\n\n.mdi-hours-24::before {\n  content: \"\\F1478\";\n}\n\n.mdi-hubspot::before {\n  content: \"\\F0D17\";\n}\n\n.mdi-hulu::before {\n  content: \"\\F0829\";\n}\n\n.mdi-human::before {\n  content: \"\\F02E6\";\n}\n\n.mdi-human-baby-changing-table::before {\n  content: \"\\F138B\";\n}\n\n.mdi-human-cane::before {\n  content: \"\\F1581\";\n}\n\n.mdi-human-capacity-decrease::before {\n  content: \"\\F159B\";\n}\n\n.mdi-human-capacity-increase::before {\n  content: \"\\F159C\";\n}\n\n.mdi-human-child::before {\n  content: \"\\F02E7\";\n}\n\n.mdi-human-edit::before {\n  content: \"\\F14E8\";\n}\n\n.mdi-human-female::before {\n  content: \"\\F0649\";\n}\n\n.mdi-human-female-boy::before {\n  content: \"\\F0A59\";\n}\n\n.mdi-human-female-dance::before {\n  content: \"\\F15C9\";\n}\n\n.mdi-human-female-female::before {\n  content: \"\\F0A5A\";\n}\n\n.mdi-human-female-girl::before {\n  content: \"\\F0A5B\";\n}\n\n.mdi-human-greeting::before {\n  content: \"\\F064A\";\n}\n\n.mdi-human-greeting-proximity::before {\n  content: \"\\F159D\";\n}\n\n.mdi-human-handsdown::before {\n  content: \"\\F064B\";\n}\n\n.mdi-human-handsup::before {\n  content: \"\\F064C\";\n}\n\n.mdi-human-male::before {\n  content: \"\\F064D\";\n}\n\n.mdi-human-male-boy::before {\n  content: \"\\F0A5C\";\n}\n\n.mdi-human-male-child::before {\n  content: \"\\F138C\";\n}\n\n.mdi-human-male-female::before {\n  content: \"\\F02E8\";\n}\n\n.mdi-human-male-girl::before {\n  content: \"\\F0A5D\";\n}\n\n.mdi-human-male-height::before {\n  content: \"\\F0EFB\";\n}\n\n.mdi-human-male-height-variant::before {\n  content: \"\\F0EFC\";\n}\n\n.mdi-human-male-male::before {\n  content: \"\\F0A5E\";\n}\n\n.mdi-human-pregnant::before {\n  content: \"\\F05CF\";\n}\n\n.mdi-human-queue::before {\n  content: \"\\F1571\";\n}\n\n.mdi-human-scooter::before {\n  content: \"\\F11E9\";\n}\n\n.mdi-human-wheelchair::before {\n  content: \"\\F138D\";\n}\n\n.mdi-humble-bundle::before {\n  content: \"\\F0744\";\n}\n\n.mdi-hvac::before {\n  content: \"\\F1352\";\n}\n\n.mdi-hvac-off::before {\n  content: \"\\F159E\";\n}\n\n.mdi-hydraulic-oil-level::before {\n  content: \"\\F1324\";\n}\n\n.mdi-hydraulic-oil-temperature::before {\n  content: \"\\F1325\";\n}\n\n.mdi-hydro-power::before {\n  content: \"\\F12E5\";\n}\n\n.mdi-ice-cream::before {\n  content: \"\\F082A\";\n}\n\n.mdi-ice-cream-off::before {\n  content: \"\\F0E52\";\n}\n\n.mdi-ice-pop::before {\n  content: \"\\F0EFD\";\n}\n\n.mdi-id-card::before {\n  content: \"\\F0FC0\";\n}\n\n.mdi-identifier::before {\n  content: \"\\F0EFE\";\n}\n\n.mdi-ideogram-cjk::before {\n  content: \"\\F1331\";\n}\n\n.mdi-ideogram-cjk-variant::before {\n  content: \"\\F1332\";\n}\n\n.mdi-iframe::before {\n  content: \"\\F0C8B\";\n}\n\n.mdi-iframe-array::before {\n  content: \"\\F10F5\";\n}\n\n.mdi-iframe-array-outline::before {\n  content: \"\\F10F6\";\n}\n\n.mdi-iframe-braces::before {\n  content: \"\\F10F7\";\n}\n\n.mdi-iframe-braces-outline::before {\n  content: \"\\F10F8\";\n}\n\n.mdi-iframe-outline::before {\n  content: \"\\F0C8C\";\n}\n\n.mdi-iframe-parentheses::before {\n  content: \"\\F10F9\";\n}\n\n.mdi-iframe-parentheses-outline::before {\n  content: \"\\F10FA\";\n}\n\n.mdi-iframe-variable::before {\n  content: \"\\F10FB\";\n}\n\n.mdi-iframe-variable-outline::before {\n  content: \"\\F10FC\";\n}\n\n.mdi-image::before {\n  content: \"\\F02E9\";\n}\n\n.mdi-image-album::before {\n  content: \"\\F02EA\";\n}\n\n.mdi-image-area::before {\n  content: \"\\F02EB\";\n}\n\n.mdi-image-area-close::before {\n  content: \"\\F02EC\";\n}\n\n.mdi-image-auto-adjust::before {\n  content: \"\\F0FC1\";\n}\n\n.mdi-image-broken::before {\n  content: \"\\F02ED\";\n}\n\n.mdi-image-broken-variant::before {\n  content: \"\\F02EE\";\n}\n\n.mdi-image-edit::before {\n  content: \"\\F11E3\";\n}\n\n.mdi-image-edit-outline::before {\n  content: \"\\F11E4\";\n}\n\n.mdi-image-filter-black-white::before {\n  content: \"\\F02F0\";\n}\n\n.mdi-image-filter-center-focus::before {\n  content: \"\\F02F1\";\n}\n\n.mdi-image-filter-center-focus-strong::before {\n  content: \"\\F0EFF\";\n}\n\n.mdi-image-filter-center-focus-strong-outline::before {\n  content: \"\\F0F00\";\n}\n\n.mdi-image-filter-center-focus-weak::before {\n  content: \"\\F02F2\";\n}\n\n.mdi-image-filter-drama::before {\n  content: \"\\F02F3\";\n}\n\n.mdi-image-filter-frames::before {\n  content: \"\\F02F4\";\n}\n\n.mdi-image-filter-hdr::before {\n  content: \"\\F02F5\";\n}\n\n.mdi-image-filter-none::before {\n  content: \"\\F02F6\";\n}\n\n.mdi-image-filter-tilt-shift::before {\n  content: \"\\F02F7\";\n}\n\n.mdi-image-filter-vintage::before {\n  content: \"\\F02F8\";\n}\n\n.mdi-image-frame::before {\n  content: \"\\F0E49\";\n}\n\n.mdi-image-minus::before {\n  content: \"\\F1419\";\n}\n\n.mdi-image-move::before {\n  content: \"\\F09F8\";\n}\n\n.mdi-image-multiple::before {\n  content: \"\\F02F9\";\n}\n\n.mdi-image-multiple-outline::before {\n  content: \"\\F02EF\";\n}\n\n.mdi-image-off::before {\n  content: \"\\F082B\";\n}\n\n.mdi-image-off-outline::before {\n  content: \"\\F11D1\";\n}\n\n.mdi-image-outline::before {\n  content: \"\\F0976\";\n}\n\n.mdi-image-plus::before {\n  content: \"\\F087C\";\n}\n\n.mdi-image-remove::before {\n  content: \"\\F1418\";\n}\n\n.mdi-image-search::before {\n  content: \"\\F0977\";\n}\n\n.mdi-image-search-outline::before {\n  content: \"\\F0978\";\n}\n\n.mdi-image-size-select-actual::before {\n  content: \"\\F0C8D\";\n}\n\n.mdi-image-size-select-large::before {\n  content: \"\\F0C8E\";\n}\n\n.mdi-image-size-select-small::before {\n  content: \"\\F0C8F\";\n}\n\n.mdi-image-text::before {\n  content: \"\\F160D\";\n}\n\n.mdi-import::before {\n  content: \"\\F02FA\";\n}\n\n.mdi-inbox::before {\n  content: \"\\F0687\";\n}\n\n.mdi-inbox-arrow-down::before {\n  content: \"\\F02FB\";\n}\n\n.mdi-inbox-arrow-down-outline::before {\n  content: \"\\F1270\";\n}\n\n.mdi-inbox-arrow-up::before {\n  content: \"\\F03D1\";\n}\n\n.mdi-inbox-arrow-up-outline::before {\n  content: \"\\F1271\";\n}\n\n.mdi-inbox-full::before {\n  content: \"\\F1272\";\n}\n\n.mdi-inbox-full-outline::before {\n  content: \"\\F1273\";\n}\n\n.mdi-inbox-multiple::before {\n  content: \"\\F08B0\";\n}\n\n.mdi-inbox-multiple-outline::before {\n  content: \"\\F0BA8\";\n}\n\n.mdi-inbox-outline::before {\n  content: \"\\F1274\";\n}\n\n.mdi-inbox-remove::before {\n  content: \"\\F159F\";\n}\n\n.mdi-inbox-remove-outline::before {\n  content: \"\\F15A0\";\n}\n\n.mdi-incognito::before {\n  content: \"\\F05F9\";\n}\n\n.mdi-incognito-circle::before {\n  content: \"\\F1421\";\n}\n\n.mdi-incognito-circle-off::before {\n  content: \"\\F1422\";\n}\n\n.mdi-incognito-off::before {\n  content: \"\\F0075\";\n}\n\n.mdi-infinity::before {\n  content: \"\\F06E4\";\n}\n\n.mdi-information::before {\n  content: \"\\F02FC\";\n}\n\n.mdi-information-outline::before {\n  content: \"\\F02FD\";\n}\n\n.mdi-information-variant::before {\n  content: \"\\F064E\";\n}\n\n.mdi-instagram::before {\n  content: \"\\F02FE\";\n}\n\n.mdi-instrument-triangle::before {\n  content: \"\\F104E\";\n}\n\n.mdi-invert-colors::before {\n  content: \"\\F0301\";\n}\n\n.mdi-invert-colors-off::before {\n  content: \"\\F0E4A\";\n}\n\n.mdi-iobroker::before {\n  content: \"\\F12E8\";\n}\n\n.mdi-ip::before {\n  content: \"\\F0A5F\";\n}\n\n.mdi-ip-network::before {\n  content: \"\\F0A60\";\n}\n\n.mdi-ip-network-outline::before {\n  content: \"\\F0C90\";\n}\n\n.mdi-ipod::before {\n  content: \"\\F0C91\";\n}\n\n.mdi-islam::before {\n  content: \"\\F0979\";\n}\n\n.mdi-island::before {\n  content: \"\\F104F\";\n}\n\n.mdi-iv-bag::before {\n  content: \"\\F10B9\";\n}\n\n.mdi-jabber::before {\n  content: \"\\F0DD5\";\n}\n\n.mdi-jeepney::before {\n  content: \"\\F0302\";\n}\n\n.mdi-jellyfish::before {\n  content: \"\\F0F01\";\n}\n\n.mdi-jellyfish-outline::before {\n  content: \"\\F0F02\";\n}\n\n.mdi-jira::before {\n  content: \"\\F0303\";\n}\n\n.mdi-jquery::before {\n  content: \"\\F087D\";\n}\n\n.mdi-jsfiddle::before {\n  content: \"\\F0304\";\n}\n\n.mdi-judaism::before {\n  content: \"\\F097A\";\n}\n\n.mdi-jump-rope::before {\n  content: \"\\F12FF\";\n}\n\n.mdi-kabaddi::before {\n  content: \"\\F0D87\";\n}\n\n.mdi-kangaroo::before {\n  content: \"\\F1558\";\n}\n\n.mdi-karate::before {\n  content: \"\\F082C\";\n}\n\n.mdi-keg::before {\n  content: \"\\F0305\";\n}\n\n.mdi-kettle::before {\n  content: \"\\F05FA\";\n}\n\n.mdi-kettle-alert::before {\n  content: \"\\F1317\";\n}\n\n.mdi-kettle-alert-outline::before {\n  content: \"\\F1318\";\n}\n\n.mdi-kettle-off::before {\n  content: \"\\F131B\";\n}\n\n.mdi-kettle-off-outline::before {\n  content: \"\\F131C\";\n}\n\n.mdi-kettle-outline::before {\n  content: \"\\F0F56\";\n}\n\n.mdi-kettle-pour-over::before {\n  content: \"\\F173C\";\n}\n\n.mdi-kettle-steam::before {\n  content: \"\\F1319\";\n}\n\n.mdi-kettle-steam-outline::before {\n  content: \"\\F131A\";\n}\n\n.mdi-kettlebell::before {\n  content: \"\\F1300\";\n}\n\n.mdi-key::before {\n  content: \"\\F0306\";\n}\n\n.mdi-key-arrow-right::before {\n  content: \"\\F1312\";\n}\n\n.mdi-key-chain::before {\n  content: \"\\F1574\";\n}\n\n.mdi-key-chain-variant::before {\n  content: \"\\F1575\";\n}\n\n.mdi-key-change::before {\n  content: \"\\F0307\";\n}\n\n.mdi-key-link::before {\n  content: \"\\F119F\";\n}\n\n.mdi-key-minus::before {\n  content: \"\\F0308\";\n}\n\n.mdi-key-outline::before {\n  content: \"\\F0DD6\";\n}\n\n.mdi-key-plus::before {\n  content: \"\\F0309\";\n}\n\n.mdi-key-remove::before {\n  content: \"\\F030A\";\n}\n\n.mdi-key-star::before {\n  content: \"\\F119E\";\n}\n\n.mdi-key-variant::before {\n  content: \"\\F030B\";\n}\n\n.mdi-key-wireless::before {\n  content: \"\\F0FC2\";\n}\n\n.mdi-keyboard::before {\n  content: \"\\F030C\";\n}\n\n.mdi-keyboard-backspace::before {\n  content: \"\\F030D\";\n}\n\n.mdi-keyboard-caps::before {\n  content: \"\\F030E\";\n}\n\n.mdi-keyboard-close::before {\n  content: \"\\F030F\";\n}\n\n.mdi-keyboard-esc::before {\n  content: \"\\F12B7\";\n}\n\n.mdi-keyboard-f1::before {\n  content: \"\\F12AB\";\n}\n\n.mdi-keyboard-f10::before {\n  content: \"\\F12B4\";\n}\n\n.mdi-keyboard-f11::before {\n  content: \"\\F12B5\";\n}\n\n.mdi-keyboard-f12::before {\n  content: \"\\F12B6\";\n}\n\n.mdi-keyboard-f2::before {\n  content: \"\\F12AC\";\n}\n\n.mdi-keyboard-f3::before {\n  content: \"\\F12AD\";\n}\n\n.mdi-keyboard-f4::before {\n  content: \"\\F12AE\";\n}\n\n.mdi-keyboard-f5::before {\n  content: \"\\F12AF\";\n}\n\n.mdi-keyboard-f6::before {\n  content: \"\\F12B0\";\n}\n\n.mdi-keyboard-f7::before {\n  content: \"\\F12B1\";\n}\n\n.mdi-keyboard-f8::before {\n  content: \"\\F12B2\";\n}\n\n.mdi-keyboard-f9::before {\n  content: \"\\F12B3\";\n}\n\n.mdi-keyboard-off::before {\n  content: \"\\F0310\";\n}\n\n.mdi-keyboard-off-outline::before {\n  content: \"\\F0E4B\";\n}\n\n.mdi-keyboard-outline::before {\n  content: \"\\F097B\";\n}\n\n.mdi-keyboard-return::before {\n  content: \"\\F0311\";\n}\n\n.mdi-keyboard-settings::before {\n  content: \"\\F09F9\";\n}\n\n.mdi-keyboard-settings-outline::before {\n  content: \"\\F09FA\";\n}\n\n.mdi-keyboard-space::before {\n  content: \"\\F1050\";\n}\n\n.mdi-keyboard-tab::before {\n  content: \"\\F0312\";\n}\n\n.mdi-keyboard-variant::before {\n  content: \"\\F0313\";\n}\n\n.mdi-khanda::before {\n  content: \"\\F10FD\";\n}\n\n.mdi-kickstarter::before {\n  content: \"\\F0745\";\n}\n\n.mdi-klingon::before {\n  content: \"\\F135B\";\n}\n\n.mdi-knife::before {\n  content: \"\\F09FB\";\n}\n\n.mdi-knife-military::before {\n  content: \"\\F09FC\";\n}\n\n.mdi-koala::before {\n  content: \"\\F173F\";\n}\n\n.mdi-kodi::before {\n  content: \"\\F0314\";\n}\n\n.mdi-kubernetes::before {\n  content: \"\\F10FE\";\n}\n\n.mdi-label::before {\n  content: \"\\F0315\";\n}\n\n.mdi-label-multiple::before {\n  content: \"\\F1375\";\n}\n\n.mdi-label-multiple-outline::before {\n  content: \"\\F1376\";\n}\n\n.mdi-label-off::before {\n  content: \"\\F0ACB\";\n}\n\n.mdi-label-off-outline::before {\n  content: \"\\F0ACC\";\n}\n\n.mdi-label-outline::before {\n  content: \"\\F0316\";\n}\n\n.mdi-label-percent::before {\n  content: \"\\F12EA\";\n}\n\n.mdi-label-percent-outline::before {\n  content: \"\\F12EB\";\n}\n\n.mdi-label-variant::before {\n  content: \"\\F0ACD\";\n}\n\n.mdi-label-variant-outline::before {\n  content: \"\\F0ACE\";\n}\n\n.mdi-ladder::before {\n  content: \"\\F15A2\";\n}\n\n.mdi-ladybug::before {\n  content: \"\\F082D\";\n}\n\n.mdi-lambda::before {\n  content: \"\\F0627\";\n}\n\n.mdi-lamp::before {\n  content: \"\\F06B5\";\n}\n\n.mdi-lamps::before {\n  content: \"\\F1576\";\n}\n\n.mdi-lan::before {\n  content: \"\\F0317\";\n}\n\n.mdi-lan-check::before {\n  content: \"\\F12AA\";\n}\n\n.mdi-lan-connect::before {\n  content: \"\\F0318\";\n}\n\n.mdi-lan-disconnect::before {\n  content: \"\\F0319\";\n}\n\n.mdi-lan-pending::before {\n  content: \"\\F031A\";\n}\n\n.mdi-language-c::before {\n  content: \"\\F0671\";\n}\n\n.mdi-language-cpp::before {\n  content: \"\\F0672\";\n}\n\n.mdi-language-csharp::before {\n  content: \"\\F031B\";\n}\n\n.mdi-language-css3::before {\n  content: \"\\F031C\";\n}\n\n.mdi-language-fortran::before {\n  content: \"\\F121A\";\n}\n\n.mdi-language-go::before {\n  content: \"\\F07D3\";\n}\n\n.mdi-language-haskell::before {\n  content: \"\\F0C92\";\n}\n\n.mdi-language-html5::before {\n  content: \"\\F031D\";\n}\n\n.mdi-language-java::before {\n  content: \"\\F0B37\";\n}\n\n.mdi-language-javascript::before {\n  content: \"\\F031E\";\n}\n\n.mdi-language-kotlin::before {\n  content: \"\\F1219\";\n}\n\n.mdi-language-lua::before {\n  content: \"\\F08B1\";\n}\n\n.mdi-language-markdown::before {\n  content: \"\\F0354\";\n}\n\n.mdi-language-markdown-outline::before {\n  content: \"\\F0F5B\";\n}\n\n.mdi-language-php::before {\n  content: \"\\F031F\";\n}\n\n.mdi-language-python::before {\n  content: \"\\F0320\";\n}\n\n.mdi-language-r::before {\n  content: \"\\F07D4\";\n}\n\n.mdi-language-ruby::before {\n  content: \"\\F0D2D\";\n}\n\n.mdi-language-ruby-on-rails::before {\n  content: \"\\F0ACF\";\n}\n\n.mdi-language-rust::before {\n  content: \"\\F1617\";\n}\n\n.mdi-language-swift::before {\n  content: \"\\F06E5\";\n}\n\n.mdi-language-typescript::before {\n  content: \"\\F06E6\";\n}\n\n.mdi-language-xaml::before {\n  content: \"\\F0673\";\n}\n\n.mdi-laptop::before {\n  content: \"\\F0322\";\n}\n\n.mdi-laptop-chromebook::before {\n  content: \"\\F0323\";\n}\n\n.mdi-laptop-mac::before {\n  content: \"\\F0324\";\n}\n\n.mdi-laptop-off::before {\n  content: \"\\F06E7\";\n}\n\n.mdi-laptop-windows::before {\n  content: \"\\F0325\";\n}\n\n.mdi-laravel::before {\n  content: \"\\F0AD0\";\n}\n\n.mdi-laser-pointer::before {\n  content: \"\\F1484\";\n}\n\n.mdi-lasso::before {\n  content: \"\\F0F03\";\n}\n\n.mdi-lastpass::before {\n  content: \"\\F0446\";\n}\n\n.mdi-latitude::before {\n  content: \"\\F0F57\";\n}\n\n.mdi-launch::before {\n  content: \"\\F0327\";\n}\n\n.mdi-lava-lamp::before {\n  content: \"\\F07D5\";\n}\n\n.mdi-layers::before {\n  content: \"\\F0328\";\n}\n\n.mdi-layers-minus::before {\n  content: \"\\F0E4C\";\n}\n\n.mdi-layers-off::before {\n  content: \"\\F0329\";\n}\n\n.mdi-layers-off-outline::before {\n  content: \"\\F09FD\";\n}\n\n.mdi-layers-outline::before {\n  content: \"\\F09FE\";\n}\n\n.mdi-layers-plus::before {\n  content: \"\\F0E4D\";\n}\n\n.mdi-layers-remove::before {\n  content: \"\\F0E4E\";\n}\n\n.mdi-layers-search::before {\n  content: \"\\F1206\";\n}\n\n.mdi-layers-search-outline::before {\n  content: \"\\F1207\";\n}\n\n.mdi-layers-triple::before {\n  content: \"\\F0F58\";\n}\n\n.mdi-layers-triple-outline::before {\n  content: \"\\F0F59\";\n}\n\n.mdi-lead-pencil::before {\n  content: \"\\F064F\";\n}\n\n.mdi-leaf::before {\n  content: \"\\F032A\";\n}\n\n.mdi-leaf-maple::before {\n  content: \"\\F0C93\";\n}\n\n.mdi-leaf-maple-off::before {\n  content: \"\\F12DA\";\n}\n\n.mdi-leaf-off::before {\n  content: \"\\F12D9\";\n}\n\n.mdi-leak::before {\n  content: \"\\F0DD7\";\n}\n\n.mdi-leak-off::before {\n  content: \"\\F0DD8\";\n}\n\n.mdi-led-off::before {\n  content: \"\\F032B\";\n}\n\n.mdi-led-on::before {\n  content: \"\\F032C\";\n}\n\n.mdi-led-outline::before {\n  content: \"\\F032D\";\n}\n\n.mdi-led-strip::before {\n  content: \"\\F07D6\";\n}\n\n.mdi-led-strip-variant::before {\n  content: \"\\F1051\";\n}\n\n.mdi-led-variant-off::before {\n  content: \"\\F032E\";\n}\n\n.mdi-led-variant-on::before {\n  content: \"\\F032F\";\n}\n\n.mdi-led-variant-outline::before {\n  content: \"\\F0330\";\n}\n\n.mdi-leek::before {\n  content: \"\\F117D\";\n}\n\n.mdi-less-than::before {\n  content: \"\\F097C\";\n}\n\n.mdi-less-than-or-equal::before {\n  content: \"\\F097D\";\n}\n\n.mdi-library::before {\n  content: \"\\F0331\";\n}\n\n.mdi-library-shelves::before {\n  content: \"\\F0BA9\";\n}\n\n.mdi-license::before {\n  content: \"\\F0FC3\";\n}\n\n.mdi-lifebuoy::before {\n  content: \"\\F087E\";\n}\n\n.mdi-light-switch::before {\n  content: \"\\F097E\";\n}\n\n.mdi-lightbulb::before {\n  content: \"\\F0335\";\n}\n\n.mdi-lightbulb-cfl::before {\n  content: \"\\F1208\";\n}\n\n.mdi-lightbulb-cfl-off::before {\n  content: \"\\F1209\";\n}\n\n.mdi-lightbulb-cfl-spiral::before {\n  content: \"\\F1275\";\n}\n\n.mdi-lightbulb-cfl-spiral-off::before {\n  content: \"\\F12C3\";\n}\n\n.mdi-lightbulb-group::before {\n  content: \"\\F1253\";\n}\n\n.mdi-lightbulb-group-off::before {\n  content: \"\\F12CD\";\n}\n\n.mdi-lightbulb-group-off-outline::before {\n  content: \"\\F12CE\";\n}\n\n.mdi-lightbulb-group-outline::before {\n  content: \"\\F1254\";\n}\n\n.mdi-lightbulb-multiple::before {\n  content: \"\\F1255\";\n}\n\n.mdi-lightbulb-multiple-off::before {\n  content: \"\\F12CF\";\n}\n\n.mdi-lightbulb-multiple-off-outline::before {\n  content: \"\\F12D0\";\n}\n\n.mdi-lightbulb-multiple-outline::before {\n  content: \"\\F1256\";\n}\n\n.mdi-lightbulb-off::before {\n  content: \"\\F0E4F\";\n}\n\n.mdi-lightbulb-off-outline::before {\n  content: \"\\F0E50\";\n}\n\n.mdi-lightbulb-on::before {\n  content: \"\\F06E8\";\n}\n\n.mdi-lightbulb-on-outline::before {\n  content: \"\\F06E9\";\n}\n\n.mdi-lightbulb-outline::before {\n  content: \"\\F0336\";\n}\n\n.mdi-lighthouse::before {\n  content: \"\\F09FF\";\n}\n\n.mdi-lighthouse-on::before {\n  content: \"\\F0A00\";\n}\n\n.mdi-lightning-bolt::before {\n  content: \"\\F140B\";\n}\n\n.mdi-lightning-bolt-outline::before {\n  content: \"\\F140C\";\n}\n\n.mdi-lingerie::before {\n  content: \"\\F1476\";\n}\n\n.mdi-link::before {\n  content: \"\\F0337\";\n}\n\n.mdi-link-box::before {\n  content: \"\\F0D1A\";\n}\n\n.mdi-link-box-outline::before {\n  content: \"\\F0D1B\";\n}\n\n.mdi-link-box-variant::before {\n  content: \"\\F0D1C\";\n}\n\n.mdi-link-box-variant-outline::before {\n  content: \"\\F0D1D\";\n}\n\n.mdi-link-lock::before {\n  content: \"\\F10BA\";\n}\n\n.mdi-link-off::before {\n  content: \"\\F0338\";\n}\n\n.mdi-link-plus::before {\n  content: \"\\F0C94\";\n}\n\n.mdi-link-variant::before {\n  content: \"\\F0339\";\n}\n\n.mdi-link-variant-minus::before {\n  content: \"\\F10FF\";\n}\n\n.mdi-link-variant-off::before {\n  content: \"\\F033A\";\n}\n\n.mdi-link-variant-plus::before {\n  content: \"\\F1100\";\n}\n\n.mdi-link-variant-remove::before {\n  content: \"\\F1101\";\n}\n\n.mdi-linkedin::before {\n  content: \"\\F033B\";\n}\n\n.mdi-linux::before {\n  content: \"\\F033D\";\n}\n\n.mdi-linux-mint::before {\n  content: \"\\F08ED\";\n}\n\n.mdi-lipstick::before {\n  content: \"\\F13B5\";\n}\n\n.mdi-list-status::before {\n  content: \"\\F15AB\";\n}\n\n.mdi-litecoin::before {\n  content: \"\\F0A61\";\n}\n\n.mdi-loading::before {\n  content: \"\\F0772\";\n}\n\n.mdi-location-enter::before {\n  content: \"\\F0FC4\";\n}\n\n.mdi-location-exit::before {\n  content: \"\\F0FC5\";\n}\n\n.mdi-lock::before {\n  content: \"\\F033E\";\n}\n\n.mdi-lock-alert::before {\n  content: \"\\F08EE\";\n}\n\n.mdi-lock-alert-outline::before {\n  content: \"\\F15D1\";\n}\n\n.mdi-lock-check::before {\n  content: \"\\F139A\";\n}\n\n.mdi-lock-check-outline::before {\n  content: \"\\F16A8\";\n}\n\n.mdi-lock-clock::before {\n  content: \"\\F097F\";\n}\n\n.mdi-lock-minus::before {\n  content: \"\\F16A9\";\n}\n\n.mdi-lock-minus-outline::before {\n  content: \"\\F16AA\";\n}\n\n.mdi-lock-off::before {\n  content: \"\\F1671\";\n}\n\n.mdi-lock-off-outline::before {\n  content: \"\\F1672\";\n}\n\n.mdi-lock-open::before {\n  content: \"\\F033F\";\n}\n\n.mdi-lock-open-alert::before {\n  content: \"\\F139B\";\n}\n\n.mdi-lock-open-alert-outline::before {\n  content: \"\\F15D2\";\n}\n\n.mdi-lock-open-check::before {\n  content: \"\\F139C\";\n}\n\n.mdi-lock-open-check-outline::before {\n  content: \"\\F16AB\";\n}\n\n.mdi-lock-open-minus::before {\n  content: \"\\F16AC\";\n}\n\n.mdi-lock-open-minus-outline::before {\n  content: \"\\F16AD\";\n}\n\n.mdi-lock-open-outline::before {\n  content: \"\\F0340\";\n}\n\n.mdi-lock-open-plus::before {\n  content: \"\\F16AE\";\n}\n\n.mdi-lock-open-plus-outline::before {\n  content: \"\\F16AF\";\n}\n\n.mdi-lock-open-remove::before {\n  content: \"\\F16B0\";\n}\n\n.mdi-lock-open-remove-outline::before {\n  content: \"\\F16B1\";\n}\n\n.mdi-lock-open-variant::before {\n  content: \"\\F0FC6\";\n}\n\n.mdi-lock-open-variant-outline::before {\n  content: \"\\F0FC7\";\n}\n\n.mdi-lock-outline::before {\n  content: \"\\F0341\";\n}\n\n.mdi-lock-pattern::before {\n  content: \"\\F06EA\";\n}\n\n.mdi-lock-plus::before {\n  content: \"\\F05FB\";\n}\n\n.mdi-lock-plus-outline::before {\n  content: \"\\F16B2\";\n}\n\n.mdi-lock-question::before {\n  content: \"\\F08EF\";\n}\n\n.mdi-lock-remove::before {\n  content: \"\\F16B3\";\n}\n\n.mdi-lock-remove-outline::before {\n  content: \"\\F16B4\";\n}\n\n.mdi-lock-reset::before {\n  content: \"\\F0773\";\n}\n\n.mdi-lock-smart::before {\n  content: \"\\F08B2\";\n}\n\n.mdi-locker::before {\n  content: \"\\F07D7\";\n}\n\n.mdi-locker-multiple::before {\n  content: \"\\F07D8\";\n}\n\n.mdi-login::before {\n  content: \"\\F0342\";\n}\n\n.mdi-login-variant::before {\n  content: \"\\F05FC\";\n}\n\n.mdi-logout::before {\n  content: \"\\F0343\";\n}\n\n.mdi-logout-variant::before {\n  content: \"\\F05FD\";\n}\n\n.mdi-longitude::before {\n  content: \"\\F0F5A\";\n}\n\n.mdi-looks::before {\n  content: \"\\F0344\";\n}\n\n.mdi-lotion::before {\n  content: \"\\F1582\";\n}\n\n.mdi-lotion-outline::before {\n  content: \"\\F1583\";\n}\n\n.mdi-lotion-plus::before {\n  content: \"\\F1584\";\n}\n\n.mdi-lotion-plus-outline::before {\n  content: \"\\F1585\";\n}\n\n.mdi-loupe::before {\n  content: \"\\F0345\";\n}\n\n.mdi-lumx::before {\n  content: \"\\F0346\";\n}\n\n.mdi-lungs::before {\n  content: \"\\F1084\";\n}\n\n.mdi-magnet::before {\n  content: \"\\F0347\";\n}\n\n.mdi-magnet-on::before {\n  content: \"\\F0348\";\n}\n\n.mdi-magnify::before {\n  content: \"\\F0349\";\n}\n\n.mdi-magnify-close::before {\n  content: \"\\F0980\";\n}\n\n.mdi-magnify-minus::before {\n  content: \"\\F034A\";\n}\n\n.mdi-magnify-minus-cursor::before {\n  content: \"\\F0A62\";\n}\n\n.mdi-magnify-minus-outline::before {\n  content: \"\\F06EC\";\n}\n\n.mdi-magnify-plus::before {\n  content: \"\\F034B\";\n}\n\n.mdi-magnify-plus-cursor::before {\n  content: \"\\F0A63\";\n}\n\n.mdi-magnify-plus-outline::before {\n  content: \"\\F06ED\";\n}\n\n.mdi-magnify-remove-cursor::before {\n  content: \"\\F120C\";\n}\n\n.mdi-magnify-remove-outline::before {\n  content: \"\\F120D\";\n}\n\n.mdi-magnify-scan::before {\n  content: \"\\F1276\";\n}\n\n.mdi-mail::before {\n  content: \"\\F0EBB\";\n}\n\n.mdi-mailbox::before {\n  content: \"\\F06EE\";\n}\n\n.mdi-mailbox-open::before {\n  content: \"\\F0D88\";\n}\n\n.mdi-mailbox-open-outline::before {\n  content: \"\\F0D89\";\n}\n\n.mdi-mailbox-open-up::before {\n  content: \"\\F0D8A\";\n}\n\n.mdi-mailbox-open-up-outline::before {\n  content: \"\\F0D8B\";\n}\n\n.mdi-mailbox-outline::before {\n  content: \"\\F0D8C\";\n}\n\n.mdi-mailbox-up::before {\n  content: \"\\F0D8D\";\n}\n\n.mdi-mailbox-up-outline::before {\n  content: \"\\F0D8E\";\n}\n\n.mdi-manjaro::before {\n  content: \"\\F160A\";\n}\n\n.mdi-map::before {\n  content: \"\\F034D\";\n}\n\n.mdi-map-check::before {\n  content: \"\\F0EBC\";\n}\n\n.mdi-map-check-outline::before {\n  content: \"\\F0EBD\";\n}\n\n.mdi-map-clock::before {\n  content: \"\\F0D1E\";\n}\n\n.mdi-map-clock-outline::before {\n  content: \"\\F0D1F\";\n}\n\n.mdi-map-legend::before {\n  content: \"\\F0A01\";\n}\n\n.mdi-map-marker::before {\n  content: \"\\F034E\";\n}\n\n.mdi-map-marker-alert::before {\n  content: \"\\F0F05\";\n}\n\n.mdi-map-marker-alert-outline::before {\n  content: \"\\F0F06\";\n}\n\n.mdi-map-marker-check::before {\n  content: \"\\F0C95\";\n}\n\n.mdi-map-marker-check-outline::before {\n  content: \"\\F12FB\";\n}\n\n.mdi-map-marker-circle::before {\n  content: \"\\F034F\";\n}\n\n.mdi-map-marker-distance::before {\n  content: \"\\F08F0\";\n}\n\n.mdi-map-marker-down::before {\n  content: \"\\F1102\";\n}\n\n.mdi-map-marker-left::before {\n  content: \"\\F12DB\";\n}\n\n.mdi-map-marker-left-outline::before {\n  content: \"\\F12DD\";\n}\n\n.mdi-map-marker-minus::before {\n  content: \"\\F0650\";\n}\n\n.mdi-map-marker-minus-outline::before {\n  content: \"\\F12F9\";\n}\n\n.mdi-map-marker-multiple::before {\n  content: \"\\F0350\";\n}\n\n.mdi-map-marker-multiple-outline::before {\n  content: \"\\F1277\";\n}\n\n.mdi-map-marker-off::before {\n  content: \"\\F0351\";\n}\n\n.mdi-map-marker-off-outline::before {\n  content: \"\\F12FD\";\n}\n\n.mdi-map-marker-outline::before {\n  content: \"\\F07D9\";\n}\n\n.mdi-map-marker-path::before {\n  content: \"\\F0D20\";\n}\n\n.mdi-map-marker-plus::before {\n  content: \"\\F0651\";\n}\n\n.mdi-map-marker-plus-outline::before {\n  content: \"\\F12F8\";\n}\n\n.mdi-map-marker-question::before {\n  content: \"\\F0F07\";\n}\n\n.mdi-map-marker-question-outline::before {\n  content: \"\\F0F08\";\n}\n\n.mdi-map-marker-radius::before {\n  content: \"\\F0352\";\n}\n\n.mdi-map-marker-radius-outline::before {\n  content: \"\\F12FC\";\n}\n\n.mdi-map-marker-remove::before {\n  content: \"\\F0F09\";\n}\n\n.mdi-map-marker-remove-outline::before {\n  content: \"\\F12FA\";\n}\n\n.mdi-map-marker-remove-variant::before {\n  content: \"\\F0F0A\";\n}\n\n.mdi-map-marker-right::before {\n  content: \"\\F12DC\";\n}\n\n.mdi-map-marker-right-outline::before {\n  content: \"\\F12DE\";\n}\n\n.mdi-map-marker-star::before {\n  content: \"\\F1608\";\n}\n\n.mdi-map-marker-star-outline::before {\n  content: \"\\F1609\";\n}\n\n.mdi-map-marker-up::before {\n  content: \"\\F1103\";\n}\n\n.mdi-map-minus::before {\n  content: \"\\F0981\";\n}\n\n.mdi-map-outline::before {\n  content: \"\\F0982\";\n}\n\n.mdi-map-plus::before {\n  content: \"\\F0983\";\n}\n\n.mdi-map-search::before {\n  content: \"\\F0984\";\n}\n\n.mdi-map-search-outline::before {\n  content: \"\\F0985\";\n}\n\n.mdi-mapbox::before {\n  content: \"\\F0BAA\";\n}\n\n.mdi-margin::before {\n  content: \"\\F0353\";\n}\n\n.mdi-marker::before {\n  content: \"\\F0652\";\n}\n\n.mdi-marker-cancel::before {\n  content: \"\\F0DD9\";\n}\n\n.mdi-marker-check::before {\n  content: \"\\F0355\";\n}\n\n.mdi-mastodon::before {\n  content: \"\\F0AD1\";\n}\n\n.mdi-material-design::before {\n  content: \"\\F0986\";\n}\n\n.mdi-material-ui::before {\n  content: \"\\F0357\";\n}\n\n.mdi-math-compass::before {\n  content: \"\\F0358\";\n}\n\n.mdi-math-cos::before {\n  content: \"\\F0C96\";\n}\n\n.mdi-math-integral::before {\n  content: \"\\F0FC8\";\n}\n\n.mdi-math-integral-box::before {\n  content: \"\\F0FC9\";\n}\n\n.mdi-math-log::before {\n  content: \"\\F1085\";\n}\n\n.mdi-math-norm::before {\n  content: \"\\F0FCA\";\n}\n\n.mdi-math-norm-box::before {\n  content: \"\\F0FCB\";\n}\n\n.mdi-math-sin::before {\n  content: \"\\F0C97\";\n}\n\n.mdi-math-tan::before {\n  content: \"\\F0C98\";\n}\n\n.mdi-matrix::before {\n  content: \"\\F0628\";\n}\n\n.mdi-medal::before {\n  content: \"\\F0987\";\n}\n\n.mdi-medal-outline::before {\n  content: \"\\F1326\";\n}\n\n.mdi-medical-bag::before {\n  content: \"\\F06EF\";\n}\n\n.mdi-meditation::before {\n  content: \"\\F117B\";\n}\n\n.mdi-memory::before {\n  content: \"\\F035B\";\n}\n\n.mdi-menu::before {\n  content: \"\\F035C\";\n}\n\n.mdi-menu-down::before {\n  content: \"\\F035D\";\n}\n\n.mdi-menu-down-outline::before {\n  content: \"\\F06B6\";\n}\n\n.mdi-menu-left::before {\n  content: \"\\F035E\";\n}\n\n.mdi-menu-left-outline::before {\n  content: \"\\F0A02\";\n}\n\n.mdi-menu-open::before {\n  content: \"\\F0BAB\";\n}\n\n.mdi-menu-right::before {\n  content: \"\\F035F\";\n}\n\n.mdi-menu-right-outline::before {\n  content: \"\\F0A03\";\n}\n\n.mdi-menu-swap::before {\n  content: \"\\F0A64\";\n}\n\n.mdi-menu-swap-outline::before {\n  content: \"\\F0A65\";\n}\n\n.mdi-menu-up::before {\n  content: \"\\F0360\";\n}\n\n.mdi-menu-up-outline::before {\n  content: \"\\F06B7\";\n}\n\n.mdi-merge::before {\n  content: \"\\F0F5C\";\n}\n\n.mdi-message::before {\n  content: \"\\F0361\";\n}\n\n.mdi-message-alert::before {\n  content: \"\\F0362\";\n}\n\n.mdi-message-alert-outline::before {\n  content: \"\\F0A04\";\n}\n\n.mdi-message-arrow-left::before {\n  content: \"\\F12F2\";\n}\n\n.mdi-message-arrow-left-outline::before {\n  content: \"\\F12F3\";\n}\n\n.mdi-message-arrow-right::before {\n  content: \"\\F12F4\";\n}\n\n.mdi-message-arrow-right-outline::before {\n  content: \"\\F12F5\";\n}\n\n.mdi-message-bookmark::before {\n  content: \"\\F15AC\";\n}\n\n.mdi-message-bookmark-outline::before {\n  content: \"\\F15AD\";\n}\n\n.mdi-message-bulleted::before {\n  content: \"\\F06A2\";\n}\n\n.mdi-message-bulleted-off::before {\n  content: \"\\F06A3\";\n}\n\n.mdi-message-cog::before {\n  content: \"\\F06F1\";\n}\n\n.mdi-message-cog-outline::before {\n  content: \"\\F1172\";\n}\n\n.mdi-message-draw::before {\n  content: \"\\F0363\";\n}\n\n.mdi-message-flash::before {\n  content: \"\\F15A9\";\n}\n\n.mdi-message-flash-outline::before {\n  content: \"\\F15AA\";\n}\n\n.mdi-message-image::before {\n  content: \"\\F0364\";\n}\n\n.mdi-message-image-outline::before {\n  content: \"\\F116C\";\n}\n\n.mdi-message-lock::before {\n  content: \"\\F0FCC\";\n}\n\n.mdi-message-lock-outline::before {\n  content: \"\\F116D\";\n}\n\n.mdi-message-minus::before {\n  content: \"\\F116E\";\n}\n\n.mdi-message-minus-outline::before {\n  content: \"\\F116F\";\n}\n\n.mdi-message-off::before {\n  content: \"\\F164D\";\n}\n\n.mdi-message-off-outline::before {\n  content: \"\\F164E\";\n}\n\n.mdi-message-outline::before {\n  content: \"\\F0365\";\n}\n\n.mdi-message-plus::before {\n  content: \"\\F0653\";\n}\n\n.mdi-message-plus-outline::before {\n  content: \"\\F10BB\";\n}\n\n.mdi-message-processing::before {\n  content: \"\\F0366\";\n}\n\n.mdi-message-processing-outline::before {\n  content: \"\\F1170\";\n}\n\n.mdi-message-question::before {\n  content: \"\\F173A\";\n}\n\n.mdi-message-question-outline::before {\n  content: \"\\F173B\";\n}\n\n.mdi-message-reply::before {\n  content: \"\\F0367\";\n}\n\n.mdi-message-reply-outline::before {\n  content: \"\\F173D\";\n}\n\n.mdi-message-reply-text::before {\n  content: \"\\F0368\";\n}\n\n.mdi-message-reply-text-outline::before {\n  content: \"\\F173E\";\n}\n\n.mdi-message-settings::before {\n  content: \"\\F06F0\";\n}\n\n.mdi-message-settings-outline::before {\n  content: \"\\F1171\";\n}\n\n.mdi-message-text::before {\n  content: \"\\F0369\";\n}\n\n.mdi-message-text-clock::before {\n  content: \"\\F1173\";\n}\n\n.mdi-message-text-clock-outline::before {\n  content: \"\\F1174\";\n}\n\n.mdi-message-text-lock::before {\n  content: \"\\F0FCD\";\n}\n\n.mdi-message-text-lock-outline::before {\n  content: \"\\F1175\";\n}\n\n.mdi-message-text-outline::before {\n  content: \"\\F036A\";\n}\n\n.mdi-message-video::before {\n  content: \"\\F036B\";\n}\n\n.mdi-meteor::before {\n  content: \"\\F0629\";\n}\n\n.mdi-metronome::before {\n  content: \"\\F07DA\";\n}\n\n.mdi-metronome-tick::before {\n  content: \"\\F07DB\";\n}\n\n.mdi-micro-sd::before {\n  content: \"\\F07DC\";\n}\n\n.mdi-microphone::before {\n  content: \"\\F036C\";\n}\n\n.mdi-microphone-minus::before {\n  content: \"\\F08B3\";\n}\n\n.mdi-microphone-off::before {\n  content: \"\\F036D\";\n}\n\n.mdi-microphone-outline::before {\n  content: \"\\F036E\";\n}\n\n.mdi-microphone-plus::before {\n  content: \"\\F08B4\";\n}\n\n.mdi-microphone-settings::before {\n  content: \"\\F036F\";\n}\n\n.mdi-microphone-variant::before {\n  content: \"\\F0370\";\n}\n\n.mdi-microphone-variant-off::before {\n  content: \"\\F0371\";\n}\n\n.mdi-microscope::before {\n  content: \"\\F0654\";\n}\n\n.mdi-microsoft::before {\n  content: \"\\F0372\";\n}\n\n.mdi-microsoft-access::before {\n  content: \"\\F138E\";\n}\n\n.mdi-microsoft-azure::before {\n  content: \"\\F0805\";\n}\n\n.mdi-microsoft-azure-devops::before {\n  content: \"\\F0FD5\";\n}\n\n.mdi-microsoft-bing::before {\n  content: \"\\F00A4\";\n}\n\n.mdi-microsoft-dynamics-365::before {\n  content: \"\\F0988\";\n}\n\n.mdi-microsoft-edge::before {\n  content: \"\\F01E9\";\n}\n\n.mdi-microsoft-edge-legacy::before {\n  content: \"\\F1250\";\n}\n\n.mdi-microsoft-excel::before {\n  content: \"\\F138F\";\n}\n\n.mdi-microsoft-internet-explorer::before {\n  content: \"\\F0300\";\n}\n\n.mdi-microsoft-office::before {\n  content: \"\\F03C6\";\n}\n\n.mdi-microsoft-onedrive::before {\n  content: \"\\F03CA\";\n}\n\n.mdi-microsoft-onenote::before {\n  content: \"\\F0747\";\n}\n\n.mdi-microsoft-outlook::before {\n  content: \"\\F0D22\";\n}\n\n.mdi-microsoft-powerpoint::before {\n  content: \"\\F1390\";\n}\n\n.mdi-microsoft-sharepoint::before {\n  content: \"\\F1391\";\n}\n\n.mdi-microsoft-teams::before {\n  content: \"\\F02BB\";\n}\n\n.mdi-microsoft-visual-studio::before {\n  content: \"\\F0610\";\n}\n\n.mdi-microsoft-visual-studio-code::before {\n  content: \"\\F0A1E\";\n}\n\n.mdi-microsoft-windows::before {\n  content: \"\\F05B3\";\n}\n\n.mdi-microsoft-windows-classic::before {\n  content: \"\\F0A21\";\n}\n\n.mdi-microsoft-word::before {\n  content: \"\\F1392\";\n}\n\n.mdi-microsoft-xbox::before {\n  content: \"\\F05B9\";\n}\n\n.mdi-microsoft-xbox-controller::before {\n  content: \"\\F05BA\";\n}\n\n.mdi-microsoft-xbox-controller-battery-alert::before {\n  content: \"\\F074B\";\n}\n\n.mdi-microsoft-xbox-controller-battery-charging::before {\n  content: \"\\F0A22\";\n}\n\n.mdi-microsoft-xbox-controller-battery-empty::before {\n  content: \"\\F074C\";\n}\n\n.mdi-microsoft-xbox-controller-battery-full::before {\n  content: \"\\F074D\";\n}\n\n.mdi-microsoft-xbox-controller-battery-low::before {\n  content: \"\\F074E\";\n}\n\n.mdi-microsoft-xbox-controller-battery-medium::before {\n  content: \"\\F074F\";\n}\n\n.mdi-microsoft-xbox-controller-battery-unknown::before {\n  content: \"\\F0750\";\n}\n\n.mdi-microsoft-xbox-controller-menu::before {\n  content: \"\\F0E6F\";\n}\n\n.mdi-microsoft-xbox-controller-off::before {\n  content: \"\\F05BB\";\n}\n\n.mdi-microsoft-xbox-controller-view::before {\n  content: \"\\F0E70\";\n}\n\n.mdi-microsoft-yammer::before {\n  content: \"\\F0789\";\n}\n\n.mdi-microwave::before {\n  content: \"\\F0C99\";\n}\n\n.mdi-microwave-off::before {\n  content: \"\\F1423\";\n}\n\n.mdi-middleware::before {\n  content: \"\\F0F5D\";\n}\n\n.mdi-middleware-outline::before {\n  content: \"\\F0F5E\";\n}\n\n.mdi-midi::before {\n  content: \"\\F08F1\";\n}\n\n.mdi-midi-port::before {\n  content: \"\\F08F2\";\n}\n\n.mdi-mine::before {\n  content: \"\\F0DDA\";\n}\n\n.mdi-minecraft::before {\n  content: \"\\F0373\";\n}\n\n.mdi-mini-sd::before {\n  content: \"\\F0A05\";\n}\n\n.mdi-minidisc::before {\n  content: \"\\F0A06\";\n}\n\n.mdi-minus::before {\n  content: \"\\F0374\";\n}\n\n.mdi-minus-box::before {\n  content: \"\\F0375\";\n}\n\n.mdi-minus-box-multiple::before {\n  content: \"\\F1141\";\n}\n\n.mdi-minus-box-multiple-outline::before {\n  content: \"\\F1142\";\n}\n\n.mdi-minus-box-outline::before {\n  content: \"\\F06F2\";\n}\n\n.mdi-minus-circle::before {\n  content: \"\\F0376\";\n}\n\n.mdi-minus-circle-multiple::before {\n  content: \"\\F035A\";\n}\n\n.mdi-minus-circle-multiple-outline::before {\n  content: \"\\F0AD3\";\n}\n\n.mdi-minus-circle-off::before {\n  content: \"\\F1459\";\n}\n\n.mdi-minus-circle-off-outline::before {\n  content: \"\\F145A\";\n}\n\n.mdi-minus-circle-outline::before {\n  content: \"\\F0377\";\n}\n\n.mdi-minus-network::before {\n  content: \"\\F0378\";\n}\n\n.mdi-minus-network-outline::before {\n  content: \"\\F0C9A\";\n}\n\n.mdi-minus-thick::before {\n  content: \"\\F1639\";\n}\n\n.mdi-mirror::before {\n  content: \"\\F11FD\";\n}\n\n.mdi-mixed-martial-arts::before {\n  content: \"\\F0D8F\";\n}\n\n.mdi-mixed-reality::before {\n  content: \"\\F087F\";\n}\n\n.mdi-molecule::before {\n  content: \"\\F0BAC\";\n}\n\n.mdi-molecule-co::before {\n  content: \"\\F12FE\";\n}\n\n.mdi-molecule-co2::before {\n  content: \"\\F07E4\";\n}\n\n.mdi-monitor::before {\n  content: \"\\F0379\";\n}\n\n.mdi-monitor-cellphone::before {\n  content: \"\\F0989\";\n}\n\n.mdi-monitor-cellphone-star::before {\n  content: \"\\F098A\";\n}\n\n.mdi-monitor-clean::before {\n  content: \"\\F1104\";\n}\n\n.mdi-monitor-dashboard::before {\n  content: \"\\F0A07\";\n}\n\n.mdi-monitor-edit::before {\n  content: \"\\F12C6\";\n}\n\n.mdi-monitor-eye::before {\n  content: \"\\F13B4\";\n}\n\n.mdi-monitor-lock::before {\n  content: \"\\F0DDB\";\n}\n\n.mdi-monitor-multiple::before {\n  content: \"\\F037A\";\n}\n\n.mdi-monitor-off::before {\n  content: \"\\F0D90\";\n}\n\n.mdi-monitor-screenshot::before {\n  content: \"\\F0E51\";\n}\n\n.mdi-monitor-share::before {\n  content: \"\\F1483\";\n}\n\n.mdi-monitor-speaker::before {\n  content: \"\\F0F5F\";\n}\n\n.mdi-monitor-speaker-off::before {\n  content: \"\\F0F60\";\n}\n\n.mdi-monitor-star::before {\n  content: \"\\F0DDC\";\n}\n\n.mdi-moon-first-quarter::before {\n  content: \"\\F0F61\";\n}\n\n.mdi-moon-full::before {\n  content: \"\\F0F62\";\n}\n\n.mdi-moon-last-quarter::before {\n  content: \"\\F0F63\";\n}\n\n.mdi-moon-new::before {\n  content: \"\\F0F64\";\n}\n\n.mdi-moon-waning-crescent::before {\n  content: \"\\F0F65\";\n}\n\n.mdi-moon-waning-gibbous::before {\n  content: \"\\F0F66\";\n}\n\n.mdi-moon-waxing-crescent::before {\n  content: \"\\F0F67\";\n}\n\n.mdi-moon-waxing-gibbous::before {\n  content: \"\\F0F68\";\n}\n\n.mdi-moped::before {\n  content: \"\\F1086\";\n}\n\n.mdi-moped-electric::before {\n  content: \"\\F15B7\";\n}\n\n.mdi-moped-electric-outline::before {\n  content: \"\\F15B8\";\n}\n\n.mdi-moped-outline::before {\n  content: \"\\F15B9\";\n}\n\n.mdi-more::before {\n  content: \"\\F037B\";\n}\n\n.mdi-mother-heart::before {\n  content: \"\\F1314\";\n}\n\n.mdi-mother-nurse::before {\n  content: \"\\F0D21\";\n}\n\n.mdi-motion::before {\n  content: \"\\F15B2\";\n}\n\n.mdi-motion-outline::before {\n  content: \"\\F15B3\";\n}\n\n.mdi-motion-pause::before {\n  content: \"\\F1590\";\n}\n\n.mdi-motion-pause-outline::before {\n  content: \"\\F1592\";\n}\n\n.mdi-motion-play::before {\n  content: \"\\F158F\";\n}\n\n.mdi-motion-play-outline::before {\n  content: \"\\F1591\";\n}\n\n.mdi-motion-sensor::before {\n  content: \"\\F0D91\";\n}\n\n.mdi-motion-sensor-off::before {\n  content: \"\\F1435\";\n}\n\n.mdi-motorbike::before {\n  content: \"\\F037C\";\n}\n\n.mdi-motorbike-electric::before {\n  content: \"\\F15BA\";\n}\n\n.mdi-mouse::before {\n  content: \"\\F037D\";\n}\n\n.mdi-mouse-bluetooth::before {\n  content: \"\\F098B\";\n}\n\n.mdi-mouse-move-down::before {\n  content: \"\\F1550\";\n}\n\n.mdi-mouse-move-up::before {\n  content: \"\\F1551\";\n}\n\n.mdi-mouse-move-vertical::before {\n  content: \"\\F1552\";\n}\n\n.mdi-mouse-off::before {\n  content: \"\\F037E\";\n}\n\n.mdi-mouse-variant::before {\n  content: \"\\F037F\";\n}\n\n.mdi-mouse-variant-off::before {\n  content: \"\\F0380\";\n}\n\n.mdi-move-resize::before {\n  content: \"\\F0655\";\n}\n\n.mdi-move-resize-variant::before {\n  content: \"\\F0656\";\n}\n\n.mdi-movie::before {\n  content: \"\\F0381\";\n}\n\n.mdi-movie-check::before {\n  content: \"\\F16F3\";\n}\n\n.mdi-movie-check-outline::before {\n  content: \"\\F16F4\";\n}\n\n.mdi-movie-cog::before {\n  content: \"\\F16F5\";\n}\n\n.mdi-movie-cog-outline::before {\n  content: \"\\F16F6\";\n}\n\n.mdi-movie-edit::before {\n  content: \"\\F1122\";\n}\n\n.mdi-movie-edit-outline::before {\n  content: \"\\F1123\";\n}\n\n.mdi-movie-filter::before {\n  content: \"\\F1124\";\n}\n\n.mdi-movie-filter-outline::before {\n  content: \"\\F1125\";\n}\n\n.mdi-movie-minus::before {\n  content: \"\\F16F7\";\n}\n\n.mdi-movie-minus-outline::before {\n  content: \"\\F16F8\";\n}\n\n.mdi-movie-off::before {\n  content: \"\\F16F9\";\n}\n\n.mdi-movie-off-outline::before {\n  content: \"\\F16FA\";\n}\n\n.mdi-movie-open::before {\n  content: \"\\F0FCE\";\n}\n\n.mdi-movie-open-check::before {\n  content: \"\\F16FB\";\n}\n\n.mdi-movie-open-check-outline::before {\n  content: \"\\F16FC\";\n}\n\n.mdi-movie-open-cog::before {\n  content: \"\\F16FD\";\n}\n\n.mdi-movie-open-cog-outline::before {\n  content: \"\\F16FE\";\n}\n\n.mdi-movie-open-edit::before {\n  content: \"\\F16FF\";\n}\n\n.mdi-movie-open-edit-outline::before {\n  content: \"\\F1700\";\n}\n\n.mdi-movie-open-minus::before {\n  content: \"\\F1701\";\n}\n\n.mdi-movie-open-minus-outline::before {\n  content: \"\\F1702\";\n}\n\n.mdi-movie-open-off::before {\n  content: \"\\F1703\";\n}\n\n.mdi-movie-open-off-outline::before {\n  content: \"\\F1704\";\n}\n\n.mdi-movie-open-outline::before {\n  content: \"\\F0FCF\";\n}\n\n.mdi-movie-open-play::before {\n  content: \"\\F1705\";\n}\n\n.mdi-movie-open-play-outline::before {\n  content: \"\\F1706\";\n}\n\n.mdi-movie-open-plus::before {\n  content: \"\\F1707\";\n}\n\n.mdi-movie-open-plus-outline::before {\n  content: \"\\F1708\";\n}\n\n.mdi-movie-open-remove::before {\n  content: \"\\F1709\";\n}\n\n.mdi-movie-open-remove-outline::before {\n  content: \"\\F170A\";\n}\n\n.mdi-movie-open-settings::before {\n  content: \"\\F170B\";\n}\n\n.mdi-movie-open-settings-outline::before {\n  content: \"\\F170C\";\n}\n\n.mdi-movie-open-star::before {\n  content: \"\\F170D\";\n}\n\n.mdi-movie-open-star-outline::before {\n  content: \"\\F170E\";\n}\n\n.mdi-movie-outline::before {\n  content: \"\\F0DDD\";\n}\n\n.mdi-movie-play::before {\n  content: \"\\F170F\";\n}\n\n.mdi-movie-play-outline::before {\n  content: \"\\F1710\";\n}\n\n.mdi-movie-plus::before {\n  content: \"\\F1711\";\n}\n\n.mdi-movie-plus-outline::before {\n  content: \"\\F1712\";\n}\n\n.mdi-movie-remove::before {\n  content: \"\\F1713\";\n}\n\n.mdi-movie-remove-outline::before {\n  content: \"\\F1714\";\n}\n\n.mdi-movie-roll::before {\n  content: \"\\F07DE\";\n}\n\n.mdi-movie-search::before {\n  content: \"\\F11D2\";\n}\n\n.mdi-movie-search-outline::before {\n  content: \"\\F11D3\";\n}\n\n.mdi-movie-settings::before {\n  content: \"\\F1715\";\n}\n\n.mdi-movie-settings-outline::before {\n  content: \"\\F1716\";\n}\n\n.mdi-movie-star::before {\n  content: \"\\F1717\";\n}\n\n.mdi-movie-star-outline::before {\n  content: \"\\F1718\";\n}\n\n.mdi-mower::before {\n  content: \"\\F166F\";\n}\n\n.mdi-mower-bag::before {\n  content: \"\\F1670\";\n}\n\n.mdi-muffin::before {\n  content: \"\\F098C\";\n}\n\n.mdi-multiplication::before {\n  content: \"\\F0382\";\n}\n\n.mdi-multiplication-box::before {\n  content: \"\\F0383\";\n}\n\n.mdi-mushroom::before {\n  content: \"\\F07DF\";\n}\n\n.mdi-mushroom-off::before {\n  content: \"\\F13FA\";\n}\n\n.mdi-mushroom-off-outline::before {\n  content: \"\\F13FB\";\n}\n\n.mdi-mushroom-outline::before {\n  content: \"\\F07E0\";\n}\n\n.mdi-music::before {\n  content: \"\\F075A\";\n}\n\n.mdi-music-accidental-double-flat::before {\n  content: \"\\F0F69\";\n}\n\n.mdi-music-accidental-double-sharp::before {\n  content: \"\\F0F6A\";\n}\n\n.mdi-music-accidental-flat::before {\n  content: \"\\F0F6B\";\n}\n\n.mdi-music-accidental-natural::before {\n  content: \"\\F0F6C\";\n}\n\n.mdi-music-accidental-sharp::before {\n  content: \"\\F0F6D\";\n}\n\n.mdi-music-box::before {\n  content: \"\\F0384\";\n}\n\n.mdi-music-box-multiple::before {\n  content: \"\\F0333\";\n}\n\n.mdi-music-box-multiple-outline::before {\n  content: \"\\F0F04\";\n}\n\n.mdi-music-box-outline::before {\n  content: \"\\F0385\";\n}\n\n.mdi-music-circle::before {\n  content: \"\\F0386\";\n}\n\n.mdi-music-circle-outline::before {\n  content: \"\\F0AD4\";\n}\n\n.mdi-music-clef-alto::before {\n  content: \"\\F0F6E\";\n}\n\n.mdi-music-clef-bass::before {\n  content: \"\\F0F6F\";\n}\n\n.mdi-music-clef-treble::before {\n  content: \"\\F0F70\";\n}\n\n.mdi-music-note::before {\n  content: \"\\F0387\";\n}\n\n.mdi-music-note-bluetooth::before {\n  content: \"\\F05FE\";\n}\n\n.mdi-music-note-bluetooth-off::before {\n  content: \"\\F05FF\";\n}\n\n.mdi-music-note-eighth::before {\n  content: \"\\F0388\";\n}\n\n.mdi-music-note-eighth-dotted::before {\n  content: \"\\F0F71\";\n}\n\n.mdi-music-note-half::before {\n  content: \"\\F0389\";\n}\n\n.mdi-music-note-half-dotted::before {\n  content: \"\\F0F72\";\n}\n\n.mdi-music-note-off::before {\n  content: \"\\F038A\";\n}\n\n.mdi-music-note-off-outline::before {\n  content: \"\\F0F73\";\n}\n\n.mdi-music-note-outline::before {\n  content: \"\\F0F74\";\n}\n\n.mdi-music-note-plus::before {\n  content: \"\\F0DDE\";\n}\n\n.mdi-music-note-quarter::before {\n  content: \"\\F038B\";\n}\n\n.mdi-music-note-quarter-dotted::before {\n  content: \"\\F0F75\";\n}\n\n.mdi-music-note-sixteenth::before {\n  content: \"\\F038C\";\n}\n\n.mdi-music-note-sixteenth-dotted::before {\n  content: \"\\F0F76\";\n}\n\n.mdi-music-note-whole::before {\n  content: \"\\F038D\";\n}\n\n.mdi-music-note-whole-dotted::before {\n  content: \"\\F0F77\";\n}\n\n.mdi-music-off::before {\n  content: \"\\F075B\";\n}\n\n.mdi-music-rest-eighth::before {\n  content: \"\\F0F78\";\n}\n\n.mdi-music-rest-half::before {\n  content: \"\\F0F79\";\n}\n\n.mdi-music-rest-quarter::before {\n  content: \"\\F0F7A\";\n}\n\n.mdi-music-rest-sixteenth::before {\n  content: \"\\F0F7B\";\n}\n\n.mdi-music-rest-whole::before {\n  content: \"\\F0F7C\";\n}\n\n.mdi-mustache::before {\n  content: \"\\F15DE\";\n}\n\n.mdi-nail::before {\n  content: \"\\F0DDF\";\n}\n\n.mdi-nas::before {\n  content: \"\\F08F3\";\n}\n\n.mdi-nativescript::before {\n  content: \"\\F0880\";\n}\n\n.mdi-nature::before {\n  content: \"\\F038E\";\n}\n\n.mdi-nature-people::before {\n  content: \"\\F038F\";\n}\n\n.mdi-navigation::before {\n  content: \"\\F0390\";\n}\n\n.mdi-navigation-outline::before {\n  content: \"\\F1607\";\n}\n\n.mdi-near-me::before {\n  content: \"\\F05CD\";\n}\n\n.mdi-necklace::before {\n  content: \"\\F0F0B\";\n}\n\n.mdi-needle::before {\n  content: \"\\F0391\";\n}\n\n.mdi-netflix::before {\n  content: \"\\F0746\";\n}\n\n.mdi-network::before {\n  content: \"\\F06F3\";\n}\n\n.mdi-network-off::before {\n  content: \"\\F0C9B\";\n}\n\n.mdi-network-off-outline::before {\n  content: \"\\F0C9C\";\n}\n\n.mdi-network-outline::before {\n  content: \"\\F0C9D\";\n}\n\n.mdi-network-strength-1::before {\n  content: \"\\F08F4\";\n}\n\n.mdi-network-strength-1-alert::before {\n  content: \"\\F08F5\";\n}\n\n.mdi-network-strength-2::before {\n  content: \"\\F08F6\";\n}\n\n.mdi-network-strength-2-alert::before {\n  content: \"\\F08F7\";\n}\n\n.mdi-network-strength-3::before {\n  content: \"\\F08F8\";\n}\n\n.mdi-network-strength-3-alert::before {\n  content: \"\\F08F9\";\n}\n\n.mdi-network-strength-4::before {\n  content: \"\\F08FA\";\n}\n\n.mdi-network-strength-4-alert::before {\n  content: \"\\F08FB\";\n}\n\n.mdi-network-strength-off::before {\n  content: \"\\F08FC\";\n}\n\n.mdi-network-strength-off-outline::before {\n  content: \"\\F08FD\";\n}\n\n.mdi-network-strength-outline::before {\n  content: \"\\F08FE\";\n}\n\n.mdi-new-box::before {\n  content: \"\\F0394\";\n}\n\n.mdi-newspaper::before {\n  content: \"\\F0395\";\n}\n\n.mdi-newspaper-minus::before {\n  content: \"\\F0F0C\";\n}\n\n.mdi-newspaper-plus::before {\n  content: \"\\F0F0D\";\n}\n\n.mdi-newspaper-variant::before {\n  content: \"\\F1001\";\n}\n\n.mdi-newspaper-variant-multiple::before {\n  content: \"\\F1002\";\n}\n\n.mdi-newspaper-variant-multiple-outline::before {\n  content: \"\\F1003\";\n}\n\n.mdi-newspaper-variant-outline::before {\n  content: \"\\F1004\";\n}\n\n.mdi-nfc::before {\n  content: \"\\F0396\";\n}\n\n.mdi-nfc-search-variant::before {\n  content: \"\\F0E53\";\n}\n\n.mdi-nfc-tap::before {\n  content: \"\\F0397\";\n}\n\n.mdi-nfc-variant::before {\n  content: \"\\F0398\";\n}\n\n.mdi-nfc-variant-off::before {\n  content: \"\\F0E54\";\n}\n\n.mdi-ninja::before {\n  content: \"\\F0774\";\n}\n\n.mdi-nintendo-game-boy::before {\n  content: \"\\F1393\";\n}\n\n.mdi-nintendo-switch::before {\n  content: \"\\F07E1\";\n}\n\n.mdi-nintendo-wii::before {\n  content: \"\\F05AB\";\n}\n\n.mdi-nintendo-wiiu::before {\n  content: \"\\F072D\";\n}\n\n.mdi-nix::before {\n  content: \"\\F1105\";\n}\n\n.mdi-nodejs::before {\n  content: \"\\F0399\";\n}\n\n.mdi-noodles::before {\n  content: \"\\F117E\";\n}\n\n.mdi-not-equal::before {\n  content: \"\\F098D\";\n}\n\n.mdi-not-equal-variant::before {\n  content: \"\\F098E\";\n}\n\n.mdi-note::before {\n  content: \"\\F039A\";\n}\n\n.mdi-note-minus::before {\n  content: \"\\F164F\";\n}\n\n.mdi-note-minus-outline::before {\n  content: \"\\F1650\";\n}\n\n.mdi-note-multiple::before {\n  content: \"\\F06B8\";\n}\n\n.mdi-note-multiple-outline::before {\n  content: \"\\F06B9\";\n}\n\n.mdi-note-outline::before {\n  content: \"\\F039B\";\n}\n\n.mdi-note-plus::before {\n  content: \"\\F039C\";\n}\n\n.mdi-note-plus-outline::before {\n  content: \"\\F039D\";\n}\n\n.mdi-note-remove::before {\n  content: \"\\F1651\";\n}\n\n.mdi-note-remove-outline::before {\n  content: \"\\F1652\";\n}\n\n.mdi-note-search::before {\n  content: \"\\F1653\";\n}\n\n.mdi-note-search-outline::before {\n  content: \"\\F1654\";\n}\n\n.mdi-note-text::before {\n  content: \"\\F039E\";\n}\n\n.mdi-note-text-outline::before {\n  content: \"\\F11D7\";\n}\n\n.mdi-notebook::before {\n  content: \"\\F082E\";\n}\n\n.mdi-notebook-check::before {\n  content: \"\\F14F5\";\n}\n\n.mdi-notebook-check-outline::before {\n  content: \"\\F14F6\";\n}\n\n.mdi-notebook-edit::before {\n  content: \"\\F14E7\";\n}\n\n.mdi-notebook-edit-outline::before {\n  content: \"\\F14E9\";\n}\n\n.mdi-notebook-minus::before {\n  content: \"\\F1610\";\n}\n\n.mdi-notebook-minus-outline::before {\n  content: \"\\F1611\";\n}\n\n.mdi-notebook-multiple::before {\n  content: \"\\F0E55\";\n}\n\n.mdi-notebook-outline::before {\n  content: \"\\F0EBF\";\n}\n\n.mdi-notebook-plus::before {\n  content: \"\\F1612\";\n}\n\n.mdi-notebook-plus-outline::before {\n  content: \"\\F1613\";\n}\n\n.mdi-notebook-remove::before {\n  content: \"\\F1614\";\n}\n\n.mdi-notebook-remove-outline::before {\n  content: \"\\F1615\";\n}\n\n.mdi-notification-clear-all::before {\n  content: \"\\F039F\";\n}\n\n.mdi-npm::before {\n  content: \"\\F06F7\";\n}\n\n.mdi-nuke::before {\n  content: \"\\F06A4\";\n}\n\n.mdi-null::before {\n  content: \"\\F07E2\";\n}\n\n.mdi-numeric::before {\n  content: \"\\F03A0\";\n}\n\n.mdi-numeric-0::before {\n  content: \"\\F0B39\";\n}\n\n.mdi-numeric-0-box::before {\n  content: \"\\F03A1\";\n}\n\n.mdi-numeric-0-box-multiple::before {\n  content: \"\\F0F0E\";\n}\n\n.mdi-numeric-0-box-multiple-outline::before {\n  content: \"\\F03A2\";\n}\n\n.mdi-numeric-0-box-outline::before {\n  content: \"\\F03A3\";\n}\n\n.mdi-numeric-0-circle::before {\n  content: \"\\F0C9E\";\n}\n\n.mdi-numeric-0-circle-outline::before {\n  content: \"\\F0C9F\";\n}\n\n.mdi-numeric-1::before {\n  content: \"\\F0B3A\";\n}\n\n.mdi-numeric-1-box::before {\n  content: \"\\F03A4\";\n}\n\n.mdi-numeric-1-box-multiple::before {\n  content: \"\\F0F0F\";\n}\n\n.mdi-numeric-1-box-multiple-outline::before {\n  content: \"\\F03A5\";\n}\n\n.mdi-numeric-1-box-outline::before {\n  content: \"\\F03A6\";\n}\n\n.mdi-numeric-1-circle::before {\n  content: \"\\F0CA0\";\n}\n\n.mdi-numeric-1-circle-outline::before {\n  content: \"\\F0CA1\";\n}\n\n.mdi-numeric-10::before {\n  content: \"\\F0FE9\";\n}\n\n.mdi-numeric-10-box::before {\n  content: \"\\F0F7D\";\n}\n\n.mdi-numeric-10-box-multiple::before {\n  content: \"\\F0FEA\";\n}\n\n.mdi-numeric-10-box-multiple-outline::before {\n  content: \"\\F0FEB\";\n}\n\n.mdi-numeric-10-box-outline::before {\n  content: \"\\F0F7E\";\n}\n\n.mdi-numeric-10-circle::before {\n  content: \"\\F0FEC\";\n}\n\n.mdi-numeric-10-circle-outline::before {\n  content: \"\\F0FED\";\n}\n\n.mdi-numeric-2::before {\n  content: \"\\F0B3B\";\n}\n\n.mdi-numeric-2-box::before {\n  content: \"\\F03A7\";\n}\n\n.mdi-numeric-2-box-multiple::before {\n  content: \"\\F0F10\";\n}\n\n.mdi-numeric-2-box-multiple-outline::before {\n  content: \"\\F03A8\";\n}\n\n.mdi-numeric-2-box-outline::before {\n  content: \"\\F03A9\";\n}\n\n.mdi-numeric-2-circle::before {\n  content: \"\\F0CA2\";\n}\n\n.mdi-numeric-2-circle-outline::before {\n  content: \"\\F0CA3\";\n}\n\n.mdi-numeric-3::before {\n  content: \"\\F0B3C\";\n}\n\n.mdi-numeric-3-box::before {\n  content: \"\\F03AA\";\n}\n\n.mdi-numeric-3-box-multiple::before {\n  content: \"\\F0F11\";\n}\n\n.mdi-numeric-3-box-multiple-outline::before {\n  content: \"\\F03AB\";\n}\n\n.mdi-numeric-3-box-outline::before {\n  content: \"\\F03AC\";\n}\n\n.mdi-numeric-3-circle::before {\n  content: \"\\F0CA4\";\n}\n\n.mdi-numeric-3-circle-outline::before {\n  content: \"\\F0CA5\";\n}\n\n.mdi-numeric-4::before {\n  content: \"\\F0B3D\";\n}\n\n.mdi-numeric-4-box::before {\n  content: \"\\F03AD\";\n}\n\n.mdi-numeric-4-box-multiple::before {\n  content: \"\\F0F12\";\n}\n\n.mdi-numeric-4-box-multiple-outline::before {\n  content: \"\\F03B2\";\n}\n\n.mdi-numeric-4-box-outline::before {\n  content: \"\\F03AE\";\n}\n\n.mdi-numeric-4-circle::before {\n  content: \"\\F0CA6\";\n}\n\n.mdi-numeric-4-circle-outline::before {\n  content: \"\\F0CA7\";\n}\n\n.mdi-numeric-5::before {\n  content: \"\\F0B3E\";\n}\n\n.mdi-numeric-5-box::before {\n  content: \"\\F03B1\";\n}\n\n.mdi-numeric-5-box-multiple::before {\n  content: \"\\F0F13\";\n}\n\n.mdi-numeric-5-box-multiple-outline::before {\n  content: \"\\F03AF\";\n}\n\n.mdi-numeric-5-box-outline::before {\n  content: \"\\F03B0\";\n}\n\n.mdi-numeric-5-circle::before {\n  content: \"\\F0CA8\";\n}\n\n.mdi-numeric-5-circle-outline::before {\n  content: \"\\F0CA9\";\n}\n\n.mdi-numeric-6::before {\n  content: \"\\F0B3F\";\n}\n\n.mdi-numeric-6-box::before {\n  content: \"\\F03B3\";\n}\n\n.mdi-numeric-6-box-multiple::before {\n  content: \"\\F0F14\";\n}\n\n.mdi-numeric-6-box-multiple-outline::before {\n  content: \"\\F03B4\";\n}\n\n.mdi-numeric-6-box-outline::before {\n  content: \"\\F03B5\";\n}\n\n.mdi-numeric-6-circle::before {\n  content: \"\\F0CAA\";\n}\n\n.mdi-numeric-6-circle-outline::before {\n  content: \"\\F0CAB\";\n}\n\n.mdi-numeric-7::before {\n  content: \"\\F0B40\";\n}\n\n.mdi-numeric-7-box::before {\n  content: \"\\F03B6\";\n}\n\n.mdi-numeric-7-box-multiple::before {\n  content: \"\\F0F15\";\n}\n\n.mdi-numeric-7-box-multiple-outline::before {\n  content: \"\\F03B7\";\n}\n\n.mdi-numeric-7-box-outline::before {\n  content: \"\\F03B8\";\n}\n\n.mdi-numeric-7-circle::before {\n  content: \"\\F0CAC\";\n}\n\n.mdi-numeric-7-circle-outline::before {\n  content: \"\\F0CAD\";\n}\n\n.mdi-numeric-8::before {\n  content: \"\\F0B41\";\n}\n\n.mdi-numeric-8-box::before {\n  content: \"\\F03B9\";\n}\n\n.mdi-numeric-8-box-multiple::before {\n  content: \"\\F0F16\";\n}\n\n.mdi-numeric-8-box-multiple-outline::before {\n  content: \"\\F03BA\";\n}\n\n.mdi-numeric-8-box-outline::before {\n  content: \"\\F03BB\";\n}\n\n.mdi-numeric-8-circle::before {\n  content: \"\\F0CAE\";\n}\n\n.mdi-numeric-8-circle-outline::before {\n  content: \"\\F0CAF\";\n}\n\n.mdi-numeric-9::before {\n  content: \"\\F0B42\";\n}\n\n.mdi-numeric-9-box::before {\n  content: \"\\F03BC\";\n}\n\n.mdi-numeric-9-box-multiple::before {\n  content: \"\\F0F17\";\n}\n\n.mdi-numeric-9-box-multiple-outline::before {\n  content: \"\\F03BD\";\n}\n\n.mdi-numeric-9-box-outline::before {\n  content: \"\\F03BE\";\n}\n\n.mdi-numeric-9-circle::before {\n  content: \"\\F0CB0\";\n}\n\n.mdi-numeric-9-circle-outline::before {\n  content: \"\\F0CB1\";\n}\n\n.mdi-numeric-9-plus::before {\n  content: \"\\F0FEE\";\n}\n\n.mdi-numeric-9-plus-box::before {\n  content: \"\\F03BF\";\n}\n\n.mdi-numeric-9-plus-box-multiple::before {\n  content: \"\\F0F18\";\n}\n\n.mdi-numeric-9-plus-box-multiple-outline::before {\n  content: \"\\F03C0\";\n}\n\n.mdi-numeric-9-plus-box-outline::before {\n  content: \"\\F03C1\";\n}\n\n.mdi-numeric-9-plus-circle::before {\n  content: \"\\F0CB2\";\n}\n\n.mdi-numeric-9-plus-circle-outline::before {\n  content: \"\\F0CB3\";\n}\n\n.mdi-numeric-negative-1::before {\n  content: \"\\F1052\";\n}\n\n.mdi-numeric-positive-1::before {\n  content: \"\\F15CB\";\n}\n\n.mdi-nut::before {\n  content: \"\\F06F8\";\n}\n\n.mdi-nutrition::before {\n  content: \"\\F03C2\";\n}\n\n.mdi-nuxt::before {\n  content: \"\\F1106\";\n}\n\n.mdi-oar::before {\n  content: \"\\F067C\";\n}\n\n.mdi-ocarina::before {\n  content: \"\\F0DE0\";\n}\n\n.mdi-oci::before {\n  content: \"\\F12E9\";\n}\n\n.mdi-ocr::before {\n  content: \"\\F113A\";\n}\n\n.mdi-octagon::before {\n  content: \"\\F03C3\";\n}\n\n.mdi-octagon-outline::before {\n  content: \"\\F03C4\";\n}\n\n.mdi-octagram::before {\n  content: \"\\F06F9\";\n}\n\n.mdi-octagram-outline::before {\n  content: \"\\F0775\";\n}\n\n.mdi-odnoklassniki::before {\n  content: \"\\F03C5\";\n}\n\n.mdi-offer::before {\n  content: \"\\F121B\";\n}\n\n.mdi-office-building::before {\n  content: \"\\F0991\";\n}\n\n.mdi-office-building-marker::before {\n  content: \"\\F1520\";\n}\n\n.mdi-office-building-marker-outline::before {\n  content: \"\\F1521\";\n}\n\n.mdi-office-building-outline::before {\n  content: \"\\F151F\";\n}\n\n.mdi-oil::before {\n  content: \"\\F03C7\";\n}\n\n.mdi-oil-lamp::before {\n  content: \"\\F0F19\";\n}\n\n.mdi-oil-level::before {\n  content: \"\\F1053\";\n}\n\n.mdi-oil-temperature::before {\n  content: \"\\F0FF8\";\n}\n\n.mdi-omega::before {\n  content: \"\\F03C9\";\n}\n\n.mdi-one-up::before {\n  content: \"\\F0BAD\";\n}\n\n.mdi-onepassword::before {\n  content: \"\\F0881\";\n}\n\n.mdi-opacity::before {\n  content: \"\\F05CC\";\n}\n\n.mdi-open-in-app::before {\n  content: \"\\F03CB\";\n}\n\n.mdi-open-in-new::before {\n  content: \"\\F03CC\";\n}\n\n.mdi-open-source-initiative::before {\n  content: \"\\F0BAE\";\n}\n\n.mdi-openid::before {\n  content: \"\\F03CD\";\n}\n\n.mdi-opera::before {\n  content: \"\\F03CE\";\n}\n\n.mdi-orbit::before {\n  content: \"\\F0018\";\n}\n\n.mdi-orbit-variant::before {\n  content: \"\\F15DB\";\n}\n\n.mdi-order-alphabetical-ascending::before {\n  content: \"\\F020D\";\n}\n\n.mdi-order-alphabetical-descending::before {\n  content: \"\\F0D07\";\n}\n\n.mdi-order-bool-ascending::before {\n  content: \"\\F02BE\";\n}\n\n.mdi-order-bool-ascending-variant::before {\n  content: \"\\F098F\";\n}\n\n.mdi-order-bool-descending::before {\n  content: \"\\F1384\";\n}\n\n.mdi-order-bool-descending-variant::before {\n  content: \"\\F0990\";\n}\n\n.mdi-order-numeric-ascending::before {\n  content: \"\\F0545\";\n}\n\n.mdi-order-numeric-descending::before {\n  content: \"\\F0546\";\n}\n\n.mdi-origin::before {\n  content: \"\\F0B43\";\n}\n\n.mdi-ornament::before {\n  content: \"\\F03CF\";\n}\n\n.mdi-ornament-variant::before {\n  content: \"\\F03D0\";\n}\n\n.mdi-outdoor-lamp::before {\n  content: \"\\F1054\";\n}\n\n.mdi-overscan::before {\n  content: \"\\F1005\";\n}\n\n.mdi-owl::before {\n  content: \"\\F03D2\";\n}\n\n.mdi-pac-man::before {\n  content: \"\\F0BAF\";\n}\n\n.mdi-package::before {\n  content: \"\\F03D3\";\n}\n\n.mdi-package-down::before {\n  content: \"\\F03D4\";\n}\n\n.mdi-package-up::before {\n  content: \"\\F03D5\";\n}\n\n.mdi-package-variant::before {\n  content: \"\\F03D6\";\n}\n\n.mdi-package-variant-closed::before {\n  content: \"\\F03D7\";\n}\n\n.mdi-page-first::before {\n  content: \"\\F0600\";\n}\n\n.mdi-page-last::before {\n  content: \"\\F0601\";\n}\n\n.mdi-page-layout-body::before {\n  content: \"\\F06FA\";\n}\n\n.mdi-page-layout-footer::before {\n  content: \"\\F06FB\";\n}\n\n.mdi-page-layout-header::before {\n  content: \"\\F06FC\";\n}\n\n.mdi-page-layout-header-footer::before {\n  content: \"\\F0F7F\";\n}\n\n.mdi-page-layout-sidebar-left::before {\n  content: \"\\F06FD\";\n}\n\n.mdi-page-layout-sidebar-right::before {\n  content: \"\\F06FE\";\n}\n\n.mdi-page-next::before {\n  content: \"\\F0BB0\";\n}\n\n.mdi-page-next-outline::before {\n  content: \"\\F0BB1\";\n}\n\n.mdi-page-previous::before {\n  content: \"\\F0BB2\";\n}\n\n.mdi-page-previous-outline::before {\n  content: \"\\F0BB3\";\n}\n\n.mdi-pail::before {\n  content: \"\\F1417\";\n}\n\n.mdi-pail-minus::before {\n  content: \"\\F1437\";\n}\n\n.mdi-pail-minus-outline::before {\n  content: \"\\F143C\";\n}\n\n.mdi-pail-off::before {\n  content: \"\\F1439\";\n}\n\n.mdi-pail-off-outline::before {\n  content: \"\\F143E\";\n}\n\n.mdi-pail-outline::before {\n  content: \"\\F143A\";\n}\n\n.mdi-pail-plus::before {\n  content: \"\\F1436\";\n}\n\n.mdi-pail-plus-outline::before {\n  content: \"\\F143B\";\n}\n\n.mdi-pail-remove::before {\n  content: \"\\F1438\";\n}\n\n.mdi-pail-remove-outline::before {\n  content: \"\\F143D\";\n}\n\n.mdi-palette::before {\n  content: \"\\F03D8\";\n}\n\n.mdi-palette-advanced::before {\n  content: \"\\F03D9\";\n}\n\n.mdi-palette-outline::before {\n  content: \"\\F0E0C\";\n}\n\n.mdi-palette-swatch::before {\n  content: \"\\F08B5\";\n}\n\n.mdi-palette-swatch-outline::before {\n  content: \"\\F135C\";\n}\n\n.mdi-palm-tree::before {\n  content: \"\\F1055\";\n}\n\n.mdi-pan::before {\n  content: \"\\F0BB4\";\n}\n\n.mdi-pan-bottom-left::before {\n  content: \"\\F0BB5\";\n}\n\n.mdi-pan-bottom-right::before {\n  content: \"\\F0BB6\";\n}\n\n.mdi-pan-down::before {\n  content: \"\\F0BB7\";\n}\n\n.mdi-pan-horizontal::before {\n  content: \"\\F0BB8\";\n}\n\n.mdi-pan-left::before {\n  content: \"\\F0BB9\";\n}\n\n.mdi-pan-right::before {\n  content: \"\\F0BBA\";\n}\n\n.mdi-pan-top-left::before {\n  content: \"\\F0BBB\";\n}\n\n.mdi-pan-top-right::before {\n  content: \"\\F0BBC\";\n}\n\n.mdi-pan-up::before {\n  content: \"\\F0BBD\";\n}\n\n.mdi-pan-vertical::before {\n  content: \"\\F0BBE\";\n}\n\n.mdi-panda::before {\n  content: \"\\F03DA\";\n}\n\n.mdi-pandora::before {\n  content: \"\\F03DB\";\n}\n\n.mdi-panorama::before {\n  content: \"\\F03DC\";\n}\n\n.mdi-panorama-fisheye::before {\n  content: \"\\F03DD\";\n}\n\n.mdi-panorama-horizontal::before {\n  content: \"\\F03DE\";\n}\n\n.mdi-panorama-vertical::before {\n  content: \"\\F03DF\";\n}\n\n.mdi-panorama-wide-angle::before {\n  content: \"\\F03E0\";\n}\n\n.mdi-paper-cut-vertical::before {\n  content: \"\\F03E1\";\n}\n\n.mdi-paper-roll::before {\n  content: \"\\F1157\";\n}\n\n.mdi-paper-roll-outline::before {\n  content: \"\\F1158\";\n}\n\n.mdi-paperclip::before {\n  content: \"\\F03E2\";\n}\n\n.mdi-parachute::before {\n  content: \"\\F0CB4\";\n}\n\n.mdi-parachute-outline::before {\n  content: \"\\F0CB5\";\n}\n\n.mdi-parking::before {\n  content: \"\\F03E3\";\n}\n\n.mdi-party-popper::before {\n  content: \"\\F1056\";\n}\n\n.mdi-passport::before {\n  content: \"\\F07E3\";\n}\n\n.mdi-passport-biometric::before {\n  content: \"\\F0DE1\";\n}\n\n.mdi-pasta::before {\n  content: \"\\F1160\";\n}\n\n.mdi-patio-heater::before {\n  content: \"\\F0F80\";\n}\n\n.mdi-patreon::before {\n  content: \"\\F0882\";\n}\n\n.mdi-pause::before {\n  content: \"\\F03E4\";\n}\n\n.mdi-pause-circle::before {\n  content: \"\\F03E5\";\n}\n\n.mdi-pause-circle-outline::before {\n  content: \"\\F03E6\";\n}\n\n.mdi-pause-octagon::before {\n  content: \"\\F03E7\";\n}\n\n.mdi-pause-octagon-outline::before {\n  content: \"\\F03E8\";\n}\n\n.mdi-paw::before {\n  content: \"\\F03E9\";\n}\n\n.mdi-paw-off::before {\n  content: \"\\F0657\";\n}\n\n.mdi-paw-off-outline::before {\n  content: \"\\F1676\";\n}\n\n.mdi-paw-outline::before {\n  content: \"\\F1675\";\n}\n\n.mdi-pdf-box::before {\n  content: \"\\F0E56\";\n}\n\n.mdi-peace::before {\n  content: \"\\F0884\";\n}\n\n.mdi-peanut::before {\n  content: \"\\F0FFC\";\n}\n\n.mdi-peanut-off::before {\n  content: \"\\F0FFD\";\n}\n\n.mdi-peanut-off-outline::before {\n  content: \"\\F0FFF\";\n}\n\n.mdi-peanut-outline::before {\n  content: \"\\F0FFE\";\n}\n\n.mdi-pen::before {\n  content: \"\\F03EA\";\n}\n\n.mdi-pen-lock::before {\n  content: \"\\F0DE2\";\n}\n\n.mdi-pen-minus::before {\n  content: \"\\F0DE3\";\n}\n\n.mdi-pen-off::before {\n  content: \"\\F0DE4\";\n}\n\n.mdi-pen-plus::before {\n  content: \"\\F0DE5\";\n}\n\n.mdi-pen-remove::before {\n  content: \"\\F0DE6\";\n}\n\n.mdi-pencil::before {\n  content: \"\\F03EB\";\n}\n\n.mdi-pencil-box::before {\n  content: \"\\F03EC\";\n}\n\n.mdi-pencil-box-multiple::before {\n  content: \"\\F1144\";\n}\n\n.mdi-pencil-box-multiple-outline::before {\n  content: \"\\F1145\";\n}\n\n.mdi-pencil-box-outline::before {\n  content: \"\\F03ED\";\n}\n\n.mdi-pencil-circle::before {\n  content: \"\\F06FF\";\n}\n\n.mdi-pencil-circle-outline::before {\n  content: \"\\F0776\";\n}\n\n.mdi-pencil-lock::before {\n  content: \"\\F03EE\";\n}\n\n.mdi-pencil-lock-outline::before {\n  content: \"\\F0DE7\";\n}\n\n.mdi-pencil-minus::before {\n  content: \"\\F0DE8\";\n}\n\n.mdi-pencil-minus-outline::before {\n  content: \"\\F0DE9\";\n}\n\n.mdi-pencil-off::before {\n  content: \"\\F03EF\";\n}\n\n.mdi-pencil-off-outline::before {\n  content: \"\\F0DEA\";\n}\n\n.mdi-pencil-outline::before {\n  content: \"\\F0CB6\";\n}\n\n.mdi-pencil-plus::before {\n  content: \"\\F0DEB\";\n}\n\n.mdi-pencil-plus-outline::before {\n  content: \"\\F0DEC\";\n}\n\n.mdi-pencil-remove::before {\n  content: \"\\F0DED\";\n}\n\n.mdi-pencil-remove-outline::before {\n  content: \"\\F0DEE\";\n}\n\n.mdi-pencil-ruler::before {\n  content: \"\\F1353\";\n}\n\n.mdi-penguin::before {\n  content: \"\\F0EC0\";\n}\n\n.mdi-pentagon::before {\n  content: \"\\F0701\";\n}\n\n.mdi-pentagon-outline::before {\n  content: \"\\F0700\";\n}\n\n.mdi-pentagram::before {\n  content: \"\\F1667\";\n}\n\n.mdi-percent::before {\n  content: \"\\F03F0\";\n}\n\n.mdi-percent-outline::before {\n  content: \"\\F1278\";\n}\n\n.mdi-periodic-table::before {\n  content: \"\\F08B6\";\n}\n\n.mdi-perspective-less::before {\n  content: \"\\F0D23\";\n}\n\n.mdi-perspective-more::before {\n  content: \"\\F0D24\";\n}\n\n.mdi-pharmacy::before {\n  content: \"\\F03F1\";\n}\n\n.mdi-phone::before {\n  content: \"\\F03F2\";\n}\n\n.mdi-phone-alert::before {\n  content: \"\\F0F1A\";\n}\n\n.mdi-phone-alert-outline::before {\n  content: \"\\F118E\";\n}\n\n.mdi-phone-bluetooth::before {\n  content: \"\\F03F3\";\n}\n\n.mdi-phone-bluetooth-outline::before {\n  content: \"\\F118F\";\n}\n\n.mdi-phone-cancel::before {\n  content: \"\\F10BC\";\n}\n\n.mdi-phone-cancel-outline::before {\n  content: \"\\F1190\";\n}\n\n.mdi-phone-check::before {\n  content: \"\\F11A9\";\n}\n\n.mdi-phone-check-outline::before {\n  content: \"\\F11AA\";\n}\n\n.mdi-phone-classic::before {\n  content: \"\\F0602\";\n}\n\n.mdi-phone-classic-off::before {\n  content: \"\\F1279\";\n}\n\n.mdi-phone-dial::before {\n  content: \"\\F1559\";\n}\n\n.mdi-phone-dial-outline::before {\n  content: \"\\F155A\";\n}\n\n.mdi-phone-forward::before {\n  content: \"\\F03F4\";\n}\n\n.mdi-phone-forward-outline::before {\n  content: \"\\F1191\";\n}\n\n.mdi-phone-hangup::before {\n  content: \"\\F03F5\";\n}\n\n.mdi-phone-hangup-outline::before {\n  content: \"\\F1192\";\n}\n\n.mdi-phone-in-talk::before {\n  content: \"\\F03F6\";\n}\n\n.mdi-phone-in-talk-outline::before {\n  content: \"\\F1182\";\n}\n\n.mdi-phone-incoming::before {\n  content: \"\\F03F7\";\n}\n\n.mdi-phone-incoming-outline::before {\n  content: \"\\F1193\";\n}\n\n.mdi-phone-lock::before {\n  content: \"\\F03F8\";\n}\n\n.mdi-phone-lock-outline::before {\n  content: \"\\F1194\";\n}\n\n.mdi-phone-log::before {\n  content: \"\\F03F9\";\n}\n\n.mdi-phone-log-outline::before {\n  content: \"\\F1195\";\n}\n\n.mdi-phone-message::before {\n  content: \"\\F1196\";\n}\n\n.mdi-phone-message-outline::before {\n  content: \"\\F1197\";\n}\n\n.mdi-phone-minus::before {\n  content: \"\\F0658\";\n}\n\n.mdi-phone-minus-outline::before {\n  content: \"\\F1198\";\n}\n\n.mdi-phone-missed::before {\n  content: \"\\F03FA\";\n}\n\n.mdi-phone-missed-outline::before {\n  content: \"\\F11A5\";\n}\n\n.mdi-phone-off::before {\n  content: \"\\F0DEF\";\n}\n\n.mdi-phone-off-outline::before {\n  content: \"\\F11A6\";\n}\n\n.mdi-phone-outgoing::before {\n  content: \"\\F03FB\";\n}\n\n.mdi-phone-outgoing-outline::before {\n  content: \"\\F1199\";\n}\n\n.mdi-phone-outline::before {\n  content: \"\\F0DF0\";\n}\n\n.mdi-phone-paused::before {\n  content: \"\\F03FC\";\n}\n\n.mdi-phone-paused-outline::before {\n  content: \"\\F119A\";\n}\n\n.mdi-phone-plus::before {\n  content: \"\\F0659\";\n}\n\n.mdi-phone-plus-outline::before {\n  content: \"\\F119B\";\n}\n\n.mdi-phone-remove::before {\n  content: \"\\F152F\";\n}\n\n.mdi-phone-remove-outline::before {\n  content: \"\\F1530\";\n}\n\n.mdi-phone-return::before {\n  content: \"\\F082F\";\n}\n\n.mdi-phone-return-outline::before {\n  content: \"\\F119C\";\n}\n\n.mdi-phone-ring::before {\n  content: \"\\F11AB\";\n}\n\n.mdi-phone-ring-outline::before {\n  content: \"\\F11AC\";\n}\n\n.mdi-phone-rotate-landscape::before {\n  content: \"\\F0885\";\n}\n\n.mdi-phone-rotate-portrait::before {\n  content: \"\\F0886\";\n}\n\n.mdi-phone-settings::before {\n  content: \"\\F03FD\";\n}\n\n.mdi-phone-settings-outline::before {\n  content: \"\\F119D\";\n}\n\n.mdi-phone-voip::before {\n  content: \"\\F03FE\";\n}\n\n.mdi-pi::before {\n  content: \"\\F03FF\";\n}\n\n.mdi-pi-box::before {\n  content: \"\\F0400\";\n}\n\n.mdi-pi-hole::before {\n  content: \"\\F0DF1\";\n}\n\n.mdi-piano::before {\n  content: \"\\F067D\";\n}\n\n.mdi-pickaxe::before {\n  content: \"\\F08B7\";\n}\n\n.mdi-picture-in-picture-bottom-right::before {\n  content: \"\\F0E57\";\n}\n\n.mdi-picture-in-picture-bottom-right-outline::before {\n  content: \"\\F0E58\";\n}\n\n.mdi-picture-in-picture-top-right::before {\n  content: \"\\F0E59\";\n}\n\n.mdi-picture-in-picture-top-right-outline::before {\n  content: \"\\F0E5A\";\n}\n\n.mdi-pier::before {\n  content: \"\\F0887\";\n}\n\n.mdi-pier-crane::before {\n  content: \"\\F0888\";\n}\n\n.mdi-pig::before {\n  content: \"\\F0401\";\n}\n\n.mdi-pig-variant::before {\n  content: \"\\F1006\";\n}\n\n.mdi-pig-variant-outline::before {\n  content: \"\\F1678\";\n}\n\n.mdi-piggy-bank::before {\n  content: \"\\F1007\";\n}\n\n.mdi-piggy-bank-outline::before {\n  content: \"\\F1679\";\n}\n\n.mdi-pill::before {\n  content: \"\\F0402\";\n}\n\n.mdi-pillar::before {\n  content: \"\\F0702\";\n}\n\n.mdi-pin::before {\n  content: \"\\F0403\";\n}\n\n.mdi-pin-off::before {\n  content: \"\\F0404\";\n}\n\n.mdi-pin-off-outline::before {\n  content: \"\\F0930\";\n}\n\n.mdi-pin-outline::before {\n  content: \"\\F0931\";\n}\n\n.mdi-pine-tree::before {\n  content: \"\\F0405\";\n}\n\n.mdi-pine-tree-box::before {\n  content: \"\\F0406\";\n}\n\n.mdi-pine-tree-fire::before {\n  content: \"\\F141A\";\n}\n\n.mdi-pinterest::before {\n  content: \"\\F0407\";\n}\n\n.mdi-pinwheel::before {\n  content: \"\\F0AD5\";\n}\n\n.mdi-pinwheel-outline::before {\n  content: \"\\F0AD6\";\n}\n\n.mdi-pipe::before {\n  content: \"\\F07E5\";\n}\n\n.mdi-pipe-disconnected::before {\n  content: \"\\F07E6\";\n}\n\n.mdi-pipe-leak::before {\n  content: \"\\F0889\";\n}\n\n.mdi-pipe-wrench::before {\n  content: \"\\F1354\";\n}\n\n.mdi-pirate::before {\n  content: \"\\F0A08\";\n}\n\n.mdi-pistol::before {\n  content: \"\\F0703\";\n}\n\n.mdi-piston::before {\n  content: \"\\F088A\";\n}\n\n.mdi-pitchfork::before {\n  content: \"\\F1553\";\n}\n\n.mdi-pizza::before {\n  content: \"\\F0409\";\n}\n\n.mdi-play::before {\n  content: \"\\F040A\";\n}\n\n.mdi-play-box::before {\n  content: \"\\F127A\";\n}\n\n.mdi-play-box-multiple::before {\n  content: \"\\F0D19\";\n}\n\n.mdi-play-box-multiple-outline::before {\n  content: \"\\F13E6\";\n}\n\n.mdi-play-box-outline::before {\n  content: \"\\F040B\";\n}\n\n.mdi-play-circle::before {\n  content: \"\\F040C\";\n}\n\n.mdi-play-circle-outline::before {\n  content: \"\\F040D\";\n}\n\n.mdi-play-network::before {\n  content: \"\\F088B\";\n}\n\n.mdi-play-network-outline::before {\n  content: \"\\F0CB7\";\n}\n\n.mdi-play-outline::before {\n  content: \"\\F0F1B\";\n}\n\n.mdi-play-pause::before {\n  content: \"\\F040E\";\n}\n\n.mdi-play-protected-content::before {\n  content: \"\\F040F\";\n}\n\n.mdi-play-speed::before {\n  content: \"\\F08FF\";\n}\n\n.mdi-playlist-check::before {\n  content: \"\\F05C7\";\n}\n\n.mdi-playlist-edit::before {\n  content: \"\\F0900\";\n}\n\n.mdi-playlist-minus::before {\n  content: \"\\F0410\";\n}\n\n.mdi-playlist-music::before {\n  content: \"\\F0CB8\";\n}\n\n.mdi-playlist-music-outline::before {\n  content: \"\\F0CB9\";\n}\n\n.mdi-playlist-play::before {\n  content: \"\\F0411\";\n}\n\n.mdi-playlist-plus::before {\n  content: \"\\F0412\";\n}\n\n.mdi-playlist-remove::before {\n  content: \"\\F0413\";\n}\n\n.mdi-playlist-star::before {\n  content: \"\\F0DF2\";\n}\n\n.mdi-plex::before {\n  content: \"\\F06BA\";\n}\n\n.mdi-plus::before {\n  content: \"\\F0415\";\n}\n\n.mdi-plus-box::before {\n  content: \"\\F0416\";\n}\n\n.mdi-plus-box-multiple::before {\n  content: \"\\F0334\";\n}\n\n.mdi-plus-box-multiple-outline::before {\n  content: \"\\F1143\";\n}\n\n.mdi-plus-box-outline::before {\n  content: \"\\F0704\";\n}\n\n.mdi-plus-circle::before {\n  content: \"\\F0417\";\n}\n\n.mdi-plus-circle-multiple::before {\n  content: \"\\F034C\";\n}\n\n.mdi-plus-circle-multiple-outline::before {\n  content: \"\\F0418\";\n}\n\n.mdi-plus-circle-outline::before {\n  content: \"\\F0419\";\n}\n\n.mdi-plus-minus::before {\n  content: \"\\F0992\";\n}\n\n.mdi-plus-minus-box::before {\n  content: \"\\F0993\";\n}\n\n.mdi-plus-minus-variant::before {\n  content: \"\\F14C9\";\n}\n\n.mdi-plus-network::before {\n  content: \"\\F041A\";\n}\n\n.mdi-plus-network-outline::before {\n  content: \"\\F0CBA\";\n}\n\n.mdi-plus-one::before {\n  content: \"\\F041B\";\n}\n\n.mdi-plus-outline::before {\n  content: \"\\F0705\";\n}\n\n.mdi-plus-thick::before {\n  content: \"\\F11EC\";\n}\n\n.mdi-podcast::before {\n  content: \"\\F0994\";\n}\n\n.mdi-podium::before {\n  content: \"\\F0D25\";\n}\n\n.mdi-podium-bronze::before {\n  content: \"\\F0D26\";\n}\n\n.mdi-podium-gold::before {\n  content: \"\\F0D27\";\n}\n\n.mdi-podium-silver::before {\n  content: \"\\F0D28\";\n}\n\n.mdi-point-of-sale::before {\n  content: \"\\F0D92\";\n}\n\n.mdi-pokeball::before {\n  content: \"\\F041D\";\n}\n\n.mdi-pokemon-go::before {\n  content: \"\\F0A09\";\n}\n\n.mdi-poker-chip::before {\n  content: \"\\F0830\";\n}\n\n.mdi-polaroid::before {\n  content: \"\\F041E\";\n}\n\n.mdi-police-badge::before {\n  content: \"\\F1167\";\n}\n\n.mdi-police-badge-outline::before {\n  content: \"\\F1168\";\n}\n\n.mdi-poll::before {\n  content: \"\\F041F\";\n}\n\n.mdi-poll-box::before {\n  content: \"\\F0420\";\n}\n\n.mdi-poll-box-outline::before {\n  content: \"\\F127B\";\n}\n\n.mdi-polo::before {\n  content: \"\\F14C3\";\n}\n\n.mdi-polymer::before {\n  content: \"\\F0421\";\n}\n\n.mdi-pool::before {\n  content: \"\\F0606\";\n}\n\n.mdi-popcorn::before {\n  content: \"\\F0422\";\n}\n\n.mdi-post::before {\n  content: \"\\F1008\";\n}\n\n.mdi-post-outline::before {\n  content: \"\\F1009\";\n}\n\n.mdi-postage-stamp::before {\n  content: \"\\F0CBB\";\n}\n\n.mdi-pot::before {\n  content: \"\\F02E5\";\n}\n\n.mdi-pot-mix::before {\n  content: \"\\F065B\";\n}\n\n.mdi-pot-mix-outline::before {\n  content: \"\\F0677\";\n}\n\n.mdi-pot-outline::before {\n  content: \"\\F02FF\";\n}\n\n.mdi-pot-steam::before {\n  content: \"\\F065A\";\n}\n\n.mdi-pot-steam-outline::before {\n  content: \"\\F0326\";\n}\n\n.mdi-pound::before {\n  content: \"\\F0423\";\n}\n\n.mdi-pound-box::before {\n  content: \"\\F0424\";\n}\n\n.mdi-pound-box-outline::before {\n  content: \"\\F117F\";\n}\n\n.mdi-power::before {\n  content: \"\\F0425\";\n}\n\n.mdi-power-cycle::before {\n  content: \"\\F0901\";\n}\n\n.mdi-power-off::before {\n  content: \"\\F0902\";\n}\n\n.mdi-power-on::before {\n  content: \"\\F0903\";\n}\n\n.mdi-power-plug::before {\n  content: \"\\F06A5\";\n}\n\n.mdi-power-plug-off::before {\n  content: \"\\F06A6\";\n}\n\n.mdi-power-plug-off-outline::before {\n  content: \"\\F1424\";\n}\n\n.mdi-power-plug-outline::before {\n  content: \"\\F1425\";\n}\n\n.mdi-power-settings::before {\n  content: \"\\F0426\";\n}\n\n.mdi-power-sleep::before {\n  content: \"\\F0904\";\n}\n\n.mdi-power-socket::before {\n  content: \"\\F0427\";\n}\n\n.mdi-power-socket-au::before {\n  content: \"\\F0905\";\n}\n\n.mdi-power-socket-de::before {\n  content: \"\\F1107\";\n}\n\n.mdi-power-socket-eu::before {\n  content: \"\\F07E7\";\n}\n\n.mdi-power-socket-fr::before {\n  content: \"\\F1108\";\n}\n\n.mdi-power-socket-it::before {\n  content: \"\\F14FF\";\n}\n\n.mdi-power-socket-jp::before {\n  content: \"\\F1109\";\n}\n\n.mdi-power-socket-uk::before {\n  content: \"\\F07E8\";\n}\n\n.mdi-power-socket-us::before {\n  content: \"\\F07E9\";\n}\n\n.mdi-power-standby::before {\n  content: \"\\F0906\";\n}\n\n.mdi-powershell::before {\n  content: \"\\F0A0A\";\n}\n\n.mdi-prescription::before {\n  content: \"\\F0706\";\n}\n\n.mdi-presentation::before {\n  content: \"\\F0428\";\n}\n\n.mdi-presentation-play::before {\n  content: \"\\F0429\";\n}\n\n.mdi-pretzel::before {\n  content: \"\\F1562\";\n}\n\n.mdi-printer::before {\n  content: \"\\F042A\";\n}\n\n.mdi-printer-3d::before {\n  content: \"\\F042B\";\n}\n\n.mdi-printer-3d-nozzle::before {\n  content: \"\\F0E5B\";\n}\n\n.mdi-printer-3d-nozzle-alert::before {\n  content: \"\\F11C0\";\n}\n\n.mdi-printer-3d-nozzle-alert-outline::before {\n  content: \"\\F11C1\";\n}\n\n.mdi-printer-3d-nozzle-outline::before {\n  content: \"\\F0E5C\";\n}\n\n.mdi-printer-alert::before {\n  content: \"\\F042C\";\n}\n\n.mdi-printer-check::before {\n  content: \"\\F1146\";\n}\n\n.mdi-printer-eye::before {\n  content: \"\\F1458\";\n}\n\n.mdi-printer-off::before {\n  content: \"\\F0E5D\";\n}\n\n.mdi-printer-pos::before {\n  content: \"\\F1057\";\n}\n\n.mdi-printer-search::before {\n  content: \"\\F1457\";\n}\n\n.mdi-printer-settings::before {\n  content: \"\\F0707\";\n}\n\n.mdi-printer-wireless::before {\n  content: \"\\F0A0B\";\n}\n\n.mdi-priority-high::before {\n  content: \"\\F0603\";\n}\n\n.mdi-priority-low::before {\n  content: \"\\F0604\";\n}\n\n.mdi-professional-hexagon::before {\n  content: \"\\F042D\";\n}\n\n.mdi-progress-alert::before {\n  content: \"\\F0CBC\";\n}\n\n.mdi-progress-check::before {\n  content: \"\\F0995\";\n}\n\n.mdi-progress-clock::before {\n  content: \"\\F0996\";\n}\n\n.mdi-progress-close::before {\n  content: \"\\F110A\";\n}\n\n.mdi-progress-download::before {\n  content: \"\\F0997\";\n}\n\n.mdi-progress-question::before {\n  content: \"\\F1522\";\n}\n\n.mdi-progress-upload::before {\n  content: \"\\F0998\";\n}\n\n.mdi-progress-wrench::before {\n  content: \"\\F0CBD\";\n}\n\n.mdi-projector::before {\n  content: \"\\F042E\";\n}\n\n.mdi-projector-screen::before {\n  content: \"\\F042F\";\n}\n\n.mdi-projector-screen-outline::before {\n  content: \"\\F1724\";\n}\n\n.mdi-propane-tank::before {\n  content: \"\\F1357\";\n}\n\n.mdi-propane-tank-outline::before {\n  content: \"\\F1358\";\n}\n\n.mdi-protocol::before {\n  content: \"\\F0FD8\";\n}\n\n.mdi-publish::before {\n  content: \"\\F06A7\";\n}\n\n.mdi-pulse::before {\n  content: \"\\F0430\";\n}\n\n.mdi-pump::before {\n  content: \"\\F1402\";\n}\n\n.mdi-pumpkin::before {\n  content: \"\\F0BBF\";\n}\n\n.mdi-purse::before {\n  content: \"\\F0F1C\";\n}\n\n.mdi-purse-outline::before {\n  content: \"\\F0F1D\";\n}\n\n.mdi-puzzle::before {\n  content: \"\\F0431\";\n}\n\n.mdi-puzzle-check::before {\n  content: \"\\F1426\";\n}\n\n.mdi-puzzle-check-outline::before {\n  content: \"\\F1427\";\n}\n\n.mdi-puzzle-edit::before {\n  content: \"\\F14D3\";\n}\n\n.mdi-puzzle-edit-outline::before {\n  content: \"\\F14D9\";\n}\n\n.mdi-puzzle-heart::before {\n  content: \"\\F14D4\";\n}\n\n.mdi-puzzle-heart-outline::before {\n  content: \"\\F14DA\";\n}\n\n.mdi-puzzle-minus::before {\n  content: \"\\F14D1\";\n}\n\n.mdi-puzzle-minus-outline::before {\n  content: \"\\F14D7\";\n}\n\n.mdi-puzzle-outline::before {\n  content: \"\\F0A66\";\n}\n\n.mdi-puzzle-plus::before {\n  content: \"\\F14D0\";\n}\n\n.mdi-puzzle-plus-outline::before {\n  content: \"\\F14D6\";\n}\n\n.mdi-puzzle-remove::before {\n  content: \"\\F14D2\";\n}\n\n.mdi-puzzle-remove-outline::before {\n  content: \"\\F14D8\";\n}\n\n.mdi-puzzle-star::before {\n  content: \"\\F14D5\";\n}\n\n.mdi-puzzle-star-outline::before {\n  content: \"\\F14DB\";\n}\n\n.mdi-qi::before {\n  content: \"\\F0999\";\n}\n\n.mdi-qqchat::before {\n  content: \"\\F0605\";\n}\n\n.mdi-qrcode::before {\n  content: \"\\F0432\";\n}\n\n.mdi-qrcode-edit::before {\n  content: \"\\F08B8\";\n}\n\n.mdi-qrcode-minus::before {\n  content: \"\\F118C\";\n}\n\n.mdi-qrcode-plus::before {\n  content: \"\\F118B\";\n}\n\n.mdi-qrcode-remove::before {\n  content: \"\\F118D\";\n}\n\n.mdi-qrcode-scan::before {\n  content: \"\\F0433\";\n}\n\n.mdi-quadcopter::before {\n  content: \"\\F0434\";\n}\n\n.mdi-quality-high::before {\n  content: \"\\F0435\";\n}\n\n.mdi-quality-low::before {\n  content: \"\\F0A0C\";\n}\n\n.mdi-quality-medium::before {\n  content: \"\\F0A0D\";\n}\n\n.mdi-quora::before {\n  content: \"\\F0D29\";\n}\n\n.mdi-rabbit::before {\n  content: \"\\F0907\";\n}\n\n.mdi-racing-helmet::before {\n  content: \"\\F0D93\";\n}\n\n.mdi-racquetball::before {\n  content: \"\\F0D94\";\n}\n\n.mdi-radar::before {\n  content: \"\\F0437\";\n}\n\n.mdi-radiator::before {\n  content: \"\\F0438\";\n}\n\n.mdi-radiator-disabled::before {\n  content: \"\\F0AD7\";\n}\n\n.mdi-radiator-off::before {\n  content: \"\\F0AD8\";\n}\n\n.mdi-radio::before {\n  content: \"\\F0439\";\n}\n\n.mdi-radio-am::before {\n  content: \"\\F0CBE\";\n}\n\n.mdi-radio-fm::before {\n  content: \"\\F0CBF\";\n}\n\n.mdi-radio-handheld::before {\n  content: \"\\F043A\";\n}\n\n.mdi-radio-off::before {\n  content: \"\\F121C\";\n}\n\n.mdi-radio-tower::before {\n  content: \"\\F043B\";\n}\n\n.mdi-radioactive::before {\n  content: \"\\F043C\";\n}\n\n.mdi-radioactive-off::before {\n  content: \"\\F0EC1\";\n}\n\n.mdi-radiobox-blank::before {\n  content: \"\\F043D\";\n}\n\n.mdi-radiobox-marked::before {\n  content: \"\\F043E\";\n}\n\n.mdi-radiology-box::before {\n  content: \"\\F14C5\";\n}\n\n.mdi-radiology-box-outline::before {\n  content: \"\\F14C6\";\n}\n\n.mdi-radius::before {\n  content: \"\\F0CC0\";\n}\n\n.mdi-radius-outline::before {\n  content: \"\\F0CC1\";\n}\n\n.mdi-railroad-light::before {\n  content: \"\\F0F1E\";\n}\n\n.mdi-rake::before {\n  content: \"\\F1544\";\n}\n\n.mdi-raspberry-pi::before {\n  content: \"\\F043F\";\n}\n\n.mdi-ray-end::before {\n  content: \"\\F0440\";\n}\n\n.mdi-ray-end-arrow::before {\n  content: \"\\F0441\";\n}\n\n.mdi-ray-start::before {\n  content: \"\\F0442\";\n}\n\n.mdi-ray-start-arrow::before {\n  content: \"\\F0443\";\n}\n\n.mdi-ray-start-end::before {\n  content: \"\\F0444\";\n}\n\n.mdi-ray-start-vertex-end::before {\n  content: \"\\F15D8\";\n}\n\n.mdi-ray-vertex::before {\n  content: \"\\F0445\";\n}\n\n.mdi-react::before {\n  content: \"\\F0708\";\n}\n\n.mdi-read::before {\n  content: \"\\F0447\";\n}\n\n.mdi-receipt::before {\n  content: \"\\F0449\";\n}\n\n.mdi-record::before {\n  content: \"\\F044A\";\n}\n\n.mdi-record-circle::before {\n  content: \"\\F0EC2\";\n}\n\n.mdi-record-circle-outline::before {\n  content: \"\\F0EC3\";\n}\n\n.mdi-record-player::before {\n  content: \"\\F099A\";\n}\n\n.mdi-record-rec::before {\n  content: \"\\F044B\";\n}\n\n.mdi-rectangle::before {\n  content: \"\\F0E5E\";\n}\n\n.mdi-rectangle-outline::before {\n  content: \"\\F0E5F\";\n}\n\n.mdi-recycle::before {\n  content: \"\\F044C\";\n}\n\n.mdi-recycle-variant::before {\n  content: \"\\F139D\";\n}\n\n.mdi-reddit::before {\n  content: \"\\F044D\";\n}\n\n.mdi-redhat::before {\n  content: \"\\F111B\";\n}\n\n.mdi-redo::before {\n  content: \"\\F044E\";\n}\n\n.mdi-redo-variant::before {\n  content: \"\\F044F\";\n}\n\n.mdi-reflect-horizontal::before {\n  content: \"\\F0A0E\";\n}\n\n.mdi-reflect-vertical::before {\n  content: \"\\F0A0F\";\n}\n\n.mdi-refresh::before {\n  content: \"\\F0450\";\n}\n\n.mdi-refresh-circle::before {\n  content: \"\\F1377\";\n}\n\n.mdi-regex::before {\n  content: \"\\F0451\";\n}\n\n.mdi-registered-trademark::before {\n  content: \"\\F0A67\";\n}\n\n.mdi-reiterate::before {\n  content: \"\\F1588\";\n}\n\n.mdi-relation-many-to-many::before {\n  content: \"\\F1496\";\n}\n\n.mdi-relation-many-to-one::before {\n  content: \"\\F1497\";\n}\n\n.mdi-relation-many-to-one-or-many::before {\n  content: \"\\F1498\";\n}\n\n.mdi-relation-many-to-only-one::before {\n  content: \"\\F1499\";\n}\n\n.mdi-relation-many-to-zero-or-many::before {\n  content: \"\\F149A\";\n}\n\n.mdi-relation-many-to-zero-or-one::before {\n  content: \"\\F149B\";\n}\n\n.mdi-relation-one-or-many-to-many::before {\n  content: \"\\F149C\";\n}\n\n.mdi-relation-one-or-many-to-one::before {\n  content: \"\\F149D\";\n}\n\n.mdi-relation-one-or-many-to-one-or-many::before {\n  content: \"\\F149E\";\n}\n\n.mdi-relation-one-or-many-to-only-one::before {\n  content: \"\\F149F\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-many::before {\n  content: \"\\F14A0\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-one::before {\n  content: \"\\F14A1\";\n}\n\n.mdi-relation-one-to-many::before {\n  content: \"\\F14A2\";\n}\n\n.mdi-relation-one-to-one::before {\n  content: \"\\F14A3\";\n}\n\n.mdi-relation-one-to-one-or-many::before {\n  content: \"\\F14A4\";\n}\n\n.mdi-relation-one-to-only-one::before {\n  content: \"\\F14A5\";\n}\n\n.mdi-relation-one-to-zero-or-many::before {\n  content: \"\\F14A6\";\n}\n\n.mdi-relation-one-to-zero-or-one::before {\n  content: \"\\F14A7\";\n}\n\n.mdi-relation-only-one-to-many::before {\n  content: \"\\F14A8\";\n}\n\n.mdi-relation-only-one-to-one::before {\n  content: \"\\F14A9\";\n}\n\n.mdi-relation-only-one-to-one-or-many::before {\n  content: \"\\F14AA\";\n}\n\n.mdi-relation-only-one-to-only-one::before {\n  content: \"\\F14AB\";\n}\n\n.mdi-relation-only-one-to-zero-or-many::before {\n  content: \"\\F14AC\";\n}\n\n.mdi-relation-only-one-to-zero-or-one::before {\n  content: \"\\F14AD\";\n}\n\n.mdi-relation-zero-or-many-to-many::before {\n  content: \"\\F14AE\";\n}\n\n.mdi-relation-zero-or-many-to-one::before {\n  content: \"\\F14AF\";\n}\n\n.mdi-relation-zero-or-many-to-one-or-many::before {\n  content: \"\\F14B0\";\n}\n\n.mdi-relation-zero-or-many-to-only-one::before {\n  content: \"\\F14B1\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-many::before {\n  content: \"\\F14B2\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-one::before {\n  content: \"\\F14B3\";\n}\n\n.mdi-relation-zero-or-one-to-many::before {\n  content: \"\\F14B4\";\n}\n\n.mdi-relation-zero-or-one-to-one::before {\n  content: \"\\F14B5\";\n}\n\n.mdi-relation-zero-or-one-to-one-or-many::before {\n  content: \"\\F14B6\";\n}\n\n.mdi-relation-zero-or-one-to-only-one::before {\n  content: \"\\F14B7\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-many::before {\n  content: \"\\F14B8\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-one::before {\n  content: \"\\F14B9\";\n}\n\n.mdi-relative-scale::before {\n  content: \"\\F0452\";\n}\n\n.mdi-reload::before {\n  content: \"\\F0453\";\n}\n\n.mdi-reload-alert::before {\n  content: \"\\F110B\";\n}\n\n.mdi-reminder::before {\n  content: \"\\F088C\";\n}\n\n.mdi-remote::before {\n  content: \"\\F0454\";\n}\n\n.mdi-remote-desktop::before {\n  content: \"\\F08B9\";\n}\n\n.mdi-remote-off::before {\n  content: \"\\F0EC4\";\n}\n\n.mdi-remote-tv::before {\n  content: \"\\F0EC5\";\n}\n\n.mdi-remote-tv-off::before {\n  content: \"\\F0EC6\";\n}\n\n.mdi-rename-box::before {\n  content: \"\\F0455\";\n}\n\n.mdi-reorder-horizontal::before {\n  content: \"\\F0688\";\n}\n\n.mdi-reorder-vertical::before {\n  content: \"\\F0689\";\n}\n\n.mdi-repeat::before {\n  content: \"\\F0456\";\n}\n\n.mdi-repeat-off::before {\n  content: \"\\F0457\";\n}\n\n.mdi-repeat-once::before {\n  content: \"\\F0458\";\n}\n\n.mdi-replay::before {\n  content: \"\\F0459\";\n}\n\n.mdi-reply::before {\n  content: \"\\F045A\";\n}\n\n.mdi-reply-all::before {\n  content: \"\\F045B\";\n}\n\n.mdi-reply-all-outline::before {\n  content: \"\\F0F1F\";\n}\n\n.mdi-reply-circle::before {\n  content: \"\\F11AE\";\n}\n\n.mdi-reply-outline::before {\n  content: \"\\F0F20\";\n}\n\n.mdi-reproduction::before {\n  content: \"\\F045C\";\n}\n\n.mdi-resistor::before {\n  content: \"\\F0B44\";\n}\n\n.mdi-resistor-nodes::before {\n  content: \"\\F0B45\";\n}\n\n.mdi-resize::before {\n  content: \"\\F0A68\";\n}\n\n.mdi-resize-bottom-right::before {\n  content: \"\\F045D\";\n}\n\n.mdi-responsive::before {\n  content: \"\\F045E\";\n}\n\n.mdi-restart::before {\n  content: \"\\F0709\";\n}\n\n.mdi-restart-alert::before {\n  content: \"\\F110C\";\n}\n\n.mdi-restart-off::before {\n  content: \"\\F0D95\";\n}\n\n.mdi-restore::before {\n  content: \"\\F099B\";\n}\n\n.mdi-restore-alert::before {\n  content: \"\\F110D\";\n}\n\n.mdi-rewind::before {\n  content: \"\\F045F\";\n}\n\n.mdi-rewind-10::before {\n  content: \"\\F0D2A\";\n}\n\n.mdi-rewind-30::before {\n  content: \"\\F0D96\";\n}\n\n.mdi-rewind-5::before {\n  content: \"\\F11F9\";\n}\n\n.mdi-rewind-60::before {\n  content: \"\\F160C\";\n}\n\n.mdi-rewind-outline::before {\n  content: \"\\F070A\";\n}\n\n.mdi-rhombus::before {\n  content: \"\\F070B\";\n}\n\n.mdi-rhombus-medium::before {\n  content: \"\\F0A10\";\n}\n\n.mdi-rhombus-medium-outline::before {\n  content: \"\\F14DC\";\n}\n\n.mdi-rhombus-outline::before {\n  content: \"\\F070C\";\n}\n\n.mdi-rhombus-split::before {\n  content: \"\\F0A11\";\n}\n\n.mdi-rhombus-split-outline::before {\n  content: \"\\F14DD\";\n}\n\n.mdi-ribbon::before {\n  content: \"\\F0460\";\n}\n\n.mdi-rice::before {\n  content: \"\\F07EA\";\n}\n\n.mdi-rickshaw::before {\n  content: \"\\F15BB\";\n}\n\n.mdi-rickshaw-electric::before {\n  content: \"\\F15BC\";\n}\n\n.mdi-ring::before {\n  content: \"\\F07EB\";\n}\n\n.mdi-rivet::before {\n  content: \"\\F0E60\";\n}\n\n.mdi-road::before {\n  content: \"\\F0461\";\n}\n\n.mdi-road-variant::before {\n  content: \"\\F0462\";\n}\n\n.mdi-robber::before {\n  content: \"\\F1058\";\n}\n\n.mdi-robot::before {\n  content: \"\\F06A9\";\n}\n\n.mdi-robot-angry::before {\n  content: \"\\F169D\";\n}\n\n.mdi-robot-angry-outline::before {\n  content: \"\\F169E\";\n}\n\n.mdi-robot-confused::before {\n  content: \"\\F169F\";\n}\n\n.mdi-robot-confused-outline::before {\n  content: \"\\F16A0\";\n}\n\n.mdi-robot-dead::before {\n  content: \"\\F16A1\";\n}\n\n.mdi-robot-dead-outline::before {\n  content: \"\\F16A2\";\n}\n\n.mdi-robot-excited::before {\n  content: \"\\F16A3\";\n}\n\n.mdi-robot-excited-outline::before {\n  content: \"\\F16A4\";\n}\n\n.mdi-robot-happy::before {\n  content: \"\\F1719\";\n}\n\n.mdi-robot-happy-outline::before {\n  content: \"\\F171A\";\n}\n\n.mdi-robot-industrial::before {\n  content: \"\\F0B46\";\n}\n\n.mdi-robot-love::before {\n  content: \"\\F16A5\";\n}\n\n.mdi-robot-love-outline::before {\n  content: \"\\F16A6\";\n}\n\n.mdi-robot-mower::before {\n  content: \"\\F11F7\";\n}\n\n.mdi-robot-mower-outline::before {\n  content: \"\\F11F3\";\n}\n\n.mdi-robot-off::before {\n  content: \"\\F16A7\";\n}\n\n.mdi-robot-off-outline::before {\n  content: \"\\F167B\";\n}\n\n.mdi-robot-outline::before {\n  content: \"\\F167A\";\n}\n\n.mdi-robot-vacuum::before {\n  content: \"\\F070D\";\n}\n\n.mdi-robot-vacuum-variant::before {\n  content: \"\\F0908\";\n}\n\n.mdi-rocket::before {\n  content: \"\\F0463\";\n}\n\n.mdi-rocket-launch::before {\n  content: \"\\F14DE\";\n}\n\n.mdi-rocket-launch-outline::before {\n  content: \"\\F14DF\";\n}\n\n.mdi-rocket-outline::before {\n  content: \"\\F13AF\";\n}\n\n.mdi-rodent::before {\n  content: \"\\F1327\";\n}\n\n.mdi-roller-skate::before {\n  content: \"\\F0D2B\";\n}\n\n.mdi-roller-skate-off::before {\n  content: \"\\F0145\";\n}\n\n.mdi-rollerblade::before {\n  content: \"\\F0D2C\";\n}\n\n.mdi-rollerblade-off::before {\n  content: \"\\F002E\";\n}\n\n.mdi-rollupjs::before {\n  content: \"\\F0BC0\";\n}\n\n.mdi-roman-numeral-1::before {\n  content: \"\\F1088\";\n}\n\n.mdi-roman-numeral-10::before {\n  content: \"\\F1091\";\n}\n\n.mdi-roman-numeral-2::before {\n  content: \"\\F1089\";\n}\n\n.mdi-roman-numeral-3::before {\n  content: \"\\F108A\";\n}\n\n.mdi-roman-numeral-4::before {\n  content: \"\\F108B\";\n}\n\n.mdi-roman-numeral-5::before {\n  content: \"\\F108C\";\n}\n\n.mdi-roman-numeral-6::before {\n  content: \"\\F108D\";\n}\n\n.mdi-roman-numeral-7::before {\n  content: \"\\F108E\";\n}\n\n.mdi-roman-numeral-8::before {\n  content: \"\\F108F\";\n}\n\n.mdi-roman-numeral-9::before {\n  content: \"\\F1090\";\n}\n\n.mdi-room-service::before {\n  content: \"\\F088D\";\n}\n\n.mdi-room-service-outline::before {\n  content: \"\\F0D97\";\n}\n\n.mdi-rotate-3d::before {\n  content: \"\\F0EC7\";\n}\n\n.mdi-rotate-3d-variant::before {\n  content: \"\\F0464\";\n}\n\n.mdi-rotate-left::before {\n  content: \"\\F0465\";\n}\n\n.mdi-rotate-left-variant::before {\n  content: \"\\F0466\";\n}\n\n.mdi-rotate-orbit::before {\n  content: \"\\F0D98\";\n}\n\n.mdi-rotate-right::before {\n  content: \"\\F0467\";\n}\n\n.mdi-rotate-right-variant::before {\n  content: \"\\F0468\";\n}\n\n.mdi-rounded-corner::before {\n  content: \"\\F0607\";\n}\n\n.mdi-router::before {\n  content: \"\\F11E2\";\n}\n\n.mdi-router-network::before {\n  content: \"\\F1087\";\n}\n\n.mdi-router-wireless::before {\n  content: \"\\F0469\";\n}\n\n.mdi-router-wireless-off::before {\n  content: \"\\F15A3\";\n}\n\n.mdi-router-wireless-settings::before {\n  content: \"\\F0A69\";\n}\n\n.mdi-routes::before {\n  content: \"\\F046A\";\n}\n\n.mdi-routes-clock::before {\n  content: \"\\F1059\";\n}\n\n.mdi-rowing::before {\n  content: \"\\F0608\";\n}\n\n.mdi-rss::before {\n  content: \"\\F046B\";\n}\n\n.mdi-rss-box::before {\n  content: \"\\F046C\";\n}\n\n.mdi-rss-off::before {\n  content: \"\\F0F21\";\n}\n\n.mdi-rug::before {\n  content: \"\\F1475\";\n}\n\n.mdi-rugby::before {\n  content: \"\\F0D99\";\n}\n\n.mdi-ruler::before {\n  content: \"\\F046D\";\n}\n\n.mdi-ruler-square::before {\n  content: \"\\F0CC2\";\n}\n\n.mdi-ruler-square-compass::before {\n  content: \"\\F0EBE\";\n}\n\n.mdi-run::before {\n  content: \"\\F070E\";\n}\n\n.mdi-run-fast::before {\n  content: \"\\F046E\";\n}\n\n.mdi-rv-truck::before {\n  content: \"\\F11D4\";\n}\n\n.mdi-sack::before {\n  content: \"\\F0D2E\";\n}\n\n.mdi-sack-percent::before {\n  content: \"\\F0D2F\";\n}\n\n.mdi-safe::before {\n  content: \"\\F0A6A\";\n}\n\n.mdi-safe-square::before {\n  content: \"\\F127C\";\n}\n\n.mdi-safe-square-outline::before {\n  content: \"\\F127D\";\n}\n\n.mdi-safety-goggles::before {\n  content: \"\\F0D30\";\n}\n\n.mdi-sail-boat::before {\n  content: \"\\F0EC8\";\n}\n\n.mdi-sale::before {\n  content: \"\\F046F\";\n}\n\n.mdi-salesforce::before {\n  content: \"\\F088E\";\n}\n\n.mdi-sass::before {\n  content: \"\\F07EC\";\n}\n\n.mdi-satellite::before {\n  content: \"\\F0470\";\n}\n\n.mdi-satellite-uplink::before {\n  content: \"\\F0909\";\n}\n\n.mdi-satellite-variant::before {\n  content: \"\\F0471\";\n}\n\n.mdi-sausage::before {\n  content: \"\\F08BA\";\n}\n\n.mdi-saw-blade::before {\n  content: \"\\F0E61\";\n}\n\n.mdi-sawtooth-wave::before {\n  content: \"\\F147A\";\n}\n\n.mdi-saxophone::before {\n  content: \"\\F0609\";\n}\n\n.mdi-scale::before {\n  content: \"\\F0472\";\n}\n\n.mdi-scale-balance::before {\n  content: \"\\F05D1\";\n}\n\n.mdi-scale-bathroom::before {\n  content: \"\\F0473\";\n}\n\n.mdi-scale-off::before {\n  content: \"\\F105A\";\n}\n\n.mdi-scan-helper::before {\n  content: \"\\F13D8\";\n}\n\n.mdi-scanner::before {\n  content: \"\\F06AB\";\n}\n\n.mdi-scanner-off::before {\n  content: \"\\F090A\";\n}\n\n.mdi-scatter-plot::before {\n  content: \"\\F0EC9\";\n}\n\n.mdi-scatter-plot-outline::before {\n  content: \"\\F0ECA\";\n}\n\n.mdi-school::before {\n  content: \"\\F0474\";\n}\n\n.mdi-school-outline::before {\n  content: \"\\F1180\";\n}\n\n.mdi-scissors-cutting::before {\n  content: \"\\F0A6B\";\n}\n\n.mdi-scooter::before {\n  content: \"\\F15BD\";\n}\n\n.mdi-scooter-electric::before {\n  content: \"\\F15BE\";\n}\n\n.mdi-scoreboard::before {\n  content: \"\\F127E\";\n}\n\n.mdi-scoreboard-outline::before {\n  content: \"\\F127F\";\n}\n\n.mdi-screen-rotation::before {\n  content: \"\\F0475\";\n}\n\n.mdi-screen-rotation-lock::before {\n  content: \"\\F0478\";\n}\n\n.mdi-screw-flat-top::before {\n  content: \"\\F0DF3\";\n}\n\n.mdi-screw-lag::before {\n  content: \"\\F0DF4\";\n}\n\n.mdi-screw-machine-flat-top::before {\n  content: \"\\F0DF5\";\n}\n\n.mdi-screw-machine-round-top::before {\n  content: \"\\F0DF6\";\n}\n\n.mdi-screw-round-top::before {\n  content: \"\\F0DF7\";\n}\n\n.mdi-screwdriver::before {\n  content: \"\\F0476\";\n}\n\n.mdi-script::before {\n  content: \"\\F0BC1\";\n}\n\n.mdi-script-outline::before {\n  content: \"\\F0477\";\n}\n\n.mdi-script-text::before {\n  content: \"\\F0BC2\";\n}\n\n.mdi-script-text-key::before {\n  content: \"\\F1725\";\n}\n\n.mdi-script-text-key-outline::before {\n  content: \"\\F1726\";\n}\n\n.mdi-script-text-outline::before {\n  content: \"\\F0BC3\";\n}\n\n.mdi-script-text-play::before {\n  content: \"\\F1727\";\n}\n\n.mdi-script-text-play-outline::before {\n  content: \"\\F1728\";\n}\n\n.mdi-sd::before {\n  content: \"\\F0479\";\n}\n\n.mdi-seal::before {\n  content: \"\\F047A\";\n}\n\n.mdi-seal-variant::before {\n  content: \"\\F0FD9\";\n}\n\n.mdi-search-web::before {\n  content: \"\\F070F\";\n}\n\n.mdi-seat::before {\n  content: \"\\F0CC3\";\n}\n\n.mdi-seat-flat::before {\n  content: \"\\F047B\";\n}\n\n.mdi-seat-flat-angled::before {\n  content: \"\\F047C\";\n}\n\n.mdi-seat-individual-suite::before {\n  content: \"\\F047D\";\n}\n\n.mdi-seat-legroom-extra::before {\n  content: \"\\F047E\";\n}\n\n.mdi-seat-legroom-normal::before {\n  content: \"\\F047F\";\n}\n\n.mdi-seat-legroom-reduced::before {\n  content: \"\\F0480\";\n}\n\n.mdi-seat-outline::before {\n  content: \"\\F0CC4\";\n}\n\n.mdi-seat-passenger::before {\n  content: \"\\F1249\";\n}\n\n.mdi-seat-recline-extra::before {\n  content: \"\\F0481\";\n}\n\n.mdi-seat-recline-normal::before {\n  content: \"\\F0482\";\n}\n\n.mdi-seatbelt::before {\n  content: \"\\F0CC5\";\n}\n\n.mdi-security::before {\n  content: \"\\F0483\";\n}\n\n.mdi-security-network::before {\n  content: \"\\F0484\";\n}\n\n.mdi-seed::before {\n  content: \"\\F0E62\";\n}\n\n.mdi-seed-off::before {\n  content: \"\\F13FD\";\n}\n\n.mdi-seed-off-outline::before {\n  content: \"\\F13FE\";\n}\n\n.mdi-seed-outline::before {\n  content: \"\\F0E63\";\n}\n\n.mdi-seesaw::before {\n  content: \"\\F15A4\";\n}\n\n.mdi-segment::before {\n  content: \"\\F0ECB\";\n}\n\n.mdi-select::before {\n  content: \"\\F0485\";\n}\n\n.mdi-select-all::before {\n  content: \"\\F0486\";\n}\n\n.mdi-select-color::before {\n  content: \"\\F0D31\";\n}\n\n.mdi-select-compare::before {\n  content: \"\\F0AD9\";\n}\n\n.mdi-select-drag::before {\n  content: \"\\F0A6C\";\n}\n\n.mdi-select-group::before {\n  content: \"\\F0F82\";\n}\n\n.mdi-select-inverse::before {\n  content: \"\\F0487\";\n}\n\n.mdi-select-marker::before {\n  content: \"\\F1280\";\n}\n\n.mdi-select-multiple::before {\n  content: \"\\F1281\";\n}\n\n.mdi-select-multiple-marker::before {\n  content: \"\\F1282\";\n}\n\n.mdi-select-off::before {\n  content: \"\\F0488\";\n}\n\n.mdi-select-place::before {\n  content: \"\\F0FDA\";\n}\n\n.mdi-select-search::before {\n  content: \"\\F1204\";\n}\n\n.mdi-selection::before {\n  content: \"\\F0489\";\n}\n\n.mdi-selection-drag::before {\n  content: \"\\F0A6D\";\n}\n\n.mdi-selection-ellipse::before {\n  content: \"\\F0D32\";\n}\n\n.mdi-selection-ellipse-arrow-inside::before {\n  content: \"\\F0F22\";\n}\n\n.mdi-selection-marker::before {\n  content: \"\\F1283\";\n}\n\n.mdi-selection-multiple::before {\n  content: \"\\F1285\";\n}\n\n.mdi-selection-multiple-marker::before {\n  content: \"\\F1284\";\n}\n\n.mdi-selection-off::before {\n  content: \"\\F0777\";\n}\n\n.mdi-selection-search::before {\n  content: \"\\F1205\";\n}\n\n.mdi-semantic-web::before {\n  content: \"\\F1316\";\n}\n\n.mdi-send::before {\n  content: \"\\F048A\";\n}\n\n.mdi-send-check::before {\n  content: \"\\F1161\";\n}\n\n.mdi-send-check-outline::before {\n  content: \"\\F1162\";\n}\n\n.mdi-send-circle::before {\n  content: \"\\F0DF8\";\n}\n\n.mdi-send-circle-outline::before {\n  content: \"\\F0DF9\";\n}\n\n.mdi-send-clock::before {\n  content: \"\\F1163\";\n}\n\n.mdi-send-clock-outline::before {\n  content: \"\\F1164\";\n}\n\n.mdi-send-lock::before {\n  content: \"\\F07ED\";\n}\n\n.mdi-send-lock-outline::before {\n  content: \"\\F1166\";\n}\n\n.mdi-send-outline::before {\n  content: \"\\F1165\";\n}\n\n.mdi-serial-port::before {\n  content: \"\\F065C\";\n}\n\n.mdi-server::before {\n  content: \"\\F048B\";\n}\n\n.mdi-server-minus::before {\n  content: \"\\F048C\";\n}\n\n.mdi-server-network::before {\n  content: \"\\F048D\";\n}\n\n.mdi-server-network-off::before {\n  content: \"\\F048E\";\n}\n\n.mdi-server-off::before {\n  content: \"\\F048F\";\n}\n\n.mdi-server-plus::before {\n  content: \"\\F0490\";\n}\n\n.mdi-server-remove::before {\n  content: \"\\F0491\";\n}\n\n.mdi-server-security::before {\n  content: \"\\F0492\";\n}\n\n.mdi-set-all::before {\n  content: \"\\F0778\";\n}\n\n.mdi-set-center::before {\n  content: \"\\F0779\";\n}\n\n.mdi-set-center-right::before {\n  content: \"\\F077A\";\n}\n\n.mdi-set-left::before {\n  content: \"\\F077B\";\n}\n\n.mdi-set-left-center::before {\n  content: \"\\F077C\";\n}\n\n.mdi-set-left-right::before {\n  content: \"\\F077D\";\n}\n\n.mdi-set-merge::before {\n  content: \"\\F14E0\";\n}\n\n.mdi-set-none::before {\n  content: \"\\F077E\";\n}\n\n.mdi-set-right::before {\n  content: \"\\F077F\";\n}\n\n.mdi-set-split::before {\n  content: \"\\F14E1\";\n}\n\n.mdi-set-square::before {\n  content: \"\\F145D\";\n}\n\n.mdi-set-top-box::before {\n  content: \"\\F099F\";\n}\n\n.mdi-settings-helper::before {\n  content: \"\\F0A6E\";\n}\n\n.mdi-shaker::before {\n  content: \"\\F110E\";\n}\n\n.mdi-shaker-outline::before {\n  content: \"\\F110F\";\n}\n\n.mdi-shape::before {\n  content: \"\\F0831\";\n}\n\n.mdi-shape-circle-plus::before {\n  content: \"\\F065D\";\n}\n\n.mdi-shape-outline::before {\n  content: \"\\F0832\";\n}\n\n.mdi-shape-oval-plus::before {\n  content: \"\\F11FA\";\n}\n\n.mdi-shape-plus::before {\n  content: \"\\F0495\";\n}\n\n.mdi-shape-polygon-plus::before {\n  content: \"\\F065E\";\n}\n\n.mdi-shape-rectangle-plus::before {\n  content: \"\\F065F\";\n}\n\n.mdi-shape-square-plus::before {\n  content: \"\\F0660\";\n}\n\n.mdi-shape-square-rounded-plus::before {\n  content: \"\\F14FA\";\n}\n\n.mdi-share::before {\n  content: \"\\F0496\";\n}\n\n.mdi-share-all::before {\n  content: \"\\F11F4\";\n}\n\n.mdi-share-all-outline::before {\n  content: \"\\F11F5\";\n}\n\n.mdi-share-circle::before {\n  content: \"\\F11AD\";\n}\n\n.mdi-share-off::before {\n  content: \"\\F0F23\";\n}\n\n.mdi-share-off-outline::before {\n  content: \"\\F0F24\";\n}\n\n.mdi-share-outline::before {\n  content: \"\\F0932\";\n}\n\n.mdi-share-variant::before {\n  content: \"\\F0497\";\n}\n\n.mdi-share-variant-outline::before {\n  content: \"\\F1514\";\n}\n\n.mdi-shark-fin::before {\n  content: \"\\F1673\";\n}\n\n.mdi-shark-fin-outline::before {\n  content: \"\\F1674\";\n}\n\n.mdi-sheep::before {\n  content: \"\\F0CC6\";\n}\n\n.mdi-shield::before {\n  content: \"\\F0498\";\n}\n\n.mdi-shield-account::before {\n  content: \"\\F088F\";\n}\n\n.mdi-shield-account-outline::before {\n  content: \"\\F0A12\";\n}\n\n.mdi-shield-account-variant::before {\n  content: \"\\F15A7\";\n}\n\n.mdi-shield-account-variant-outline::before {\n  content: \"\\F15A8\";\n}\n\n.mdi-shield-airplane::before {\n  content: \"\\F06BB\";\n}\n\n.mdi-shield-airplane-outline::before {\n  content: \"\\F0CC7\";\n}\n\n.mdi-shield-alert::before {\n  content: \"\\F0ECC\";\n}\n\n.mdi-shield-alert-outline::before {\n  content: \"\\F0ECD\";\n}\n\n.mdi-shield-bug::before {\n  content: \"\\F13DA\";\n}\n\n.mdi-shield-bug-outline::before {\n  content: \"\\F13DB\";\n}\n\n.mdi-shield-car::before {\n  content: \"\\F0F83\";\n}\n\n.mdi-shield-check::before {\n  content: \"\\F0565\";\n}\n\n.mdi-shield-check-outline::before {\n  content: \"\\F0CC8\";\n}\n\n.mdi-shield-cross::before {\n  content: \"\\F0CC9\";\n}\n\n.mdi-shield-cross-outline::before {\n  content: \"\\F0CCA\";\n}\n\n.mdi-shield-edit::before {\n  content: \"\\F11A0\";\n}\n\n.mdi-shield-edit-outline::before {\n  content: \"\\F11A1\";\n}\n\n.mdi-shield-half::before {\n  content: \"\\F1360\";\n}\n\n.mdi-shield-half-full::before {\n  content: \"\\F0780\";\n}\n\n.mdi-shield-home::before {\n  content: \"\\F068A\";\n}\n\n.mdi-shield-home-outline::before {\n  content: \"\\F0CCB\";\n}\n\n.mdi-shield-key::before {\n  content: \"\\F0BC4\";\n}\n\n.mdi-shield-key-outline::before {\n  content: \"\\F0BC5\";\n}\n\n.mdi-shield-link-variant::before {\n  content: \"\\F0D33\";\n}\n\n.mdi-shield-link-variant-outline::before {\n  content: \"\\F0D34\";\n}\n\n.mdi-shield-lock::before {\n  content: \"\\F099D\";\n}\n\n.mdi-shield-lock-outline::before {\n  content: \"\\F0CCC\";\n}\n\n.mdi-shield-off::before {\n  content: \"\\F099E\";\n}\n\n.mdi-shield-off-outline::before {\n  content: \"\\F099C\";\n}\n\n.mdi-shield-outline::before {\n  content: \"\\F0499\";\n}\n\n.mdi-shield-plus::before {\n  content: \"\\F0ADA\";\n}\n\n.mdi-shield-plus-outline::before {\n  content: \"\\F0ADB\";\n}\n\n.mdi-shield-refresh::before {\n  content: \"\\F00AA\";\n}\n\n.mdi-shield-refresh-outline::before {\n  content: \"\\F01E0\";\n}\n\n.mdi-shield-remove::before {\n  content: \"\\F0ADC\";\n}\n\n.mdi-shield-remove-outline::before {\n  content: \"\\F0ADD\";\n}\n\n.mdi-shield-search::before {\n  content: \"\\F0D9A\";\n}\n\n.mdi-shield-star::before {\n  content: \"\\F113B\";\n}\n\n.mdi-shield-star-outline::before {\n  content: \"\\F113C\";\n}\n\n.mdi-shield-sun::before {\n  content: \"\\F105D\";\n}\n\n.mdi-shield-sun-outline::before {\n  content: \"\\F105E\";\n}\n\n.mdi-shield-sync::before {\n  content: \"\\F11A2\";\n}\n\n.mdi-shield-sync-outline::before {\n  content: \"\\F11A3\";\n}\n\n.mdi-ship-wheel::before {\n  content: \"\\F0833\";\n}\n\n.mdi-shoe-ballet::before {\n  content: \"\\F15CA\";\n}\n\n.mdi-shoe-cleat::before {\n  content: \"\\F15C7\";\n}\n\n.mdi-shoe-formal::before {\n  content: \"\\F0B47\";\n}\n\n.mdi-shoe-heel::before {\n  content: \"\\F0B48\";\n}\n\n.mdi-shoe-print::before {\n  content: \"\\F0DFA\";\n}\n\n.mdi-shoe-sneaker::before {\n  content: \"\\F15C8\";\n}\n\n.mdi-shopping::before {\n  content: \"\\F049A\";\n}\n\n.mdi-shopping-music::before {\n  content: \"\\F049B\";\n}\n\n.mdi-shopping-outline::before {\n  content: \"\\F11D5\";\n}\n\n.mdi-shopping-search::before {\n  content: \"\\F0F84\";\n}\n\n.mdi-shore::before {\n  content: \"\\F14F9\";\n}\n\n.mdi-shovel::before {\n  content: \"\\F0710\";\n}\n\n.mdi-shovel-off::before {\n  content: \"\\F0711\";\n}\n\n.mdi-shower::before {\n  content: \"\\F09A0\";\n}\n\n.mdi-shower-head::before {\n  content: \"\\F09A1\";\n}\n\n.mdi-shredder::before {\n  content: \"\\F049C\";\n}\n\n.mdi-shuffle::before {\n  content: \"\\F049D\";\n}\n\n.mdi-shuffle-disabled::before {\n  content: \"\\F049E\";\n}\n\n.mdi-shuffle-variant::before {\n  content: \"\\F049F\";\n}\n\n.mdi-shuriken::before {\n  content: \"\\F137F\";\n}\n\n.mdi-sigma::before {\n  content: \"\\F04A0\";\n}\n\n.mdi-sigma-lower::before {\n  content: \"\\F062B\";\n}\n\n.mdi-sign-caution::before {\n  content: \"\\F04A1\";\n}\n\n.mdi-sign-direction::before {\n  content: \"\\F0781\";\n}\n\n.mdi-sign-direction-minus::before {\n  content: \"\\F1000\";\n}\n\n.mdi-sign-direction-plus::before {\n  content: \"\\F0FDC\";\n}\n\n.mdi-sign-direction-remove::before {\n  content: \"\\F0FDD\";\n}\n\n.mdi-sign-pole::before {\n  content: \"\\F14F8\";\n}\n\n.mdi-sign-real-estate::before {\n  content: \"\\F1118\";\n}\n\n.mdi-sign-text::before {\n  content: \"\\F0782\";\n}\n\n.mdi-signal::before {\n  content: \"\\F04A2\";\n}\n\n.mdi-signal-2g::before {\n  content: \"\\F0712\";\n}\n\n.mdi-signal-3g::before {\n  content: \"\\F0713\";\n}\n\n.mdi-signal-4g::before {\n  content: \"\\F0714\";\n}\n\n.mdi-signal-5g::before {\n  content: \"\\F0A6F\";\n}\n\n.mdi-signal-cellular-1::before {\n  content: \"\\F08BC\";\n}\n\n.mdi-signal-cellular-2::before {\n  content: \"\\F08BD\";\n}\n\n.mdi-signal-cellular-3::before {\n  content: \"\\F08BE\";\n}\n\n.mdi-signal-cellular-outline::before {\n  content: \"\\F08BF\";\n}\n\n.mdi-signal-distance-variant::before {\n  content: \"\\F0E64\";\n}\n\n.mdi-signal-hspa::before {\n  content: \"\\F0715\";\n}\n\n.mdi-signal-hspa-plus::before {\n  content: \"\\F0716\";\n}\n\n.mdi-signal-off::before {\n  content: \"\\F0783\";\n}\n\n.mdi-signal-variant::before {\n  content: \"\\F060A\";\n}\n\n.mdi-signature::before {\n  content: \"\\F0DFB\";\n}\n\n.mdi-signature-freehand::before {\n  content: \"\\F0DFC\";\n}\n\n.mdi-signature-image::before {\n  content: \"\\F0DFD\";\n}\n\n.mdi-signature-text::before {\n  content: \"\\F0DFE\";\n}\n\n.mdi-silo::before {\n  content: \"\\F0B49\";\n}\n\n.mdi-silverware::before {\n  content: \"\\F04A3\";\n}\n\n.mdi-silverware-clean::before {\n  content: \"\\F0FDE\";\n}\n\n.mdi-silverware-fork::before {\n  content: \"\\F04A4\";\n}\n\n.mdi-silverware-fork-knife::before {\n  content: \"\\F0A70\";\n}\n\n.mdi-silverware-spoon::before {\n  content: \"\\F04A5\";\n}\n\n.mdi-silverware-variant::before {\n  content: \"\\F04A6\";\n}\n\n.mdi-sim::before {\n  content: \"\\F04A7\";\n}\n\n.mdi-sim-alert::before {\n  content: \"\\F04A8\";\n}\n\n.mdi-sim-alert-outline::before {\n  content: \"\\F15D3\";\n}\n\n.mdi-sim-off::before {\n  content: \"\\F04A9\";\n}\n\n.mdi-sim-off-outline::before {\n  content: \"\\F15D4\";\n}\n\n.mdi-sim-outline::before {\n  content: \"\\F15D5\";\n}\n\n.mdi-simple-icons::before {\n  content: \"\\F131D\";\n}\n\n.mdi-sina-weibo::before {\n  content: \"\\F0ADF\";\n}\n\n.mdi-sine-wave::before {\n  content: \"\\F095B\";\n}\n\n.mdi-sitemap::before {\n  content: \"\\F04AA\";\n}\n\n.mdi-size-l::before {\n  content: \"\\F13A6\";\n}\n\n.mdi-size-m::before {\n  content: \"\\F13A5\";\n}\n\n.mdi-size-s::before {\n  content: \"\\F13A4\";\n}\n\n.mdi-size-xl::before {\n  content: \"\\F13A7\";\n}\n\n.mdi-size-xs::before {\n  content: \"\\F13A3\";\n}\n\n.mdi-size-xxl::before {\n  content: \"\\F13A8\";\n}\n\n.mdi-size-xxs::before {\n  content: \"\\F13A2\";\n}\n\n.mdi-size-xxxl::before {\n  content: \"\\F13A9\";\n}\n\n.mdi-skate::before {\n  content: \"\\F0D35\";\n}\n\n.mdi-skateboard::before {\n  content: \"\\F14C2\";\n}\n\n.mdi-skew-less::before {\n  content: \"\\F0D36\";\n}\n\n.mdi-skew-more::before {\n  content: \"\\F0D37\";\n}\n\n.mdi-ski::before {\n  content: \"\\F1304\";\n}\n\n.mdi-ski-cross-country::before {\n  content: \"\\F1305\";\n}\n\n.mdi-ski-water::before {\n  content: \"\\F1306\";\n}\n\n.mdi-skip-backward::before {\n  content: \"\\F04AB\";\n}\n\n.mdi-skip-backward-outline::before {\n  content: \"\\F0F25\";\n}\n\n.mdi-skip-forward::before {\n  content: \"\\F04AC\";\n}\n\n.mdi-skip-forward-outline::before {\n  content: \"\\F0F26\";\n}\n\n.mdi-skip-next::before {\n  content: \"\\F04AD\";\n}\n\n.mdi-skip-next-circle::before {\n  content: \"\\F0661\";\n}\n\n.mdi-skip-next-circle-outline::before {\n  content: \"\\F0662\";\n}\n\n.mdi-skip-next-outline::before {\n  content: \"\\F0F27\";\n}\n\n.mdi-skip-previous::before {\n  content: \"\\F04AE\";\n}\n\n.mdi-skip-previous-circle::before {\n  content: \"\\F0663\";\n}\n\n.mdi-skip-previous-circle-outline::before {\n  content: \"\\F0664\";\n}\n\n.mdi-skip-previous-outline::before {\n  content: \"\\F0F28\";\n}\n\n.mdi-skull::before {\n  content: \"\\F068C\";\n}\n\n.mdi-skull-crossbones::before {\n  content: \"\\F0BC6\";\n}\n\n.mdi-skull-crossbones-outline::before {\n  content: \"\\F0BC7\";\n}\n\n.mdi-skull-outline::before {\n  content: \"\\F0BC8\";\n}\n\n.mdi-skull-scan::before {\n  content: \"\\F14C7\";\n}\n\n.mdi-skull-scan-outline::before {\n  content: \"\\F14C8\";\n}\n\n.mdi-skype::before {\n  content: \"\\F04AF\";\n}\n\n.mdi-skype-business::before {\n  content: \"\\F04B0\";\n}\n\n.mdi-slack::before {\n  content: \"\\F04B1\";\n}\n\n.mdi-slash-forward::before {\n  content: \"\\F0FDF\";\n}\n\n.mdi-slash-forward-box::before {\n  content: \"\\F0FE0\";\n}\n\n.mdi-sleep::before {\n  content: \"\\F04B2\";\n}\n\n.mdi-sleep-off::before {\n  content: \"\\F04B3\";\n}\n\n.mdi-slide::before {\n  content: \"\\F15A5\";\n}\n\n.mdi-slope-downhill::before {\n  content: \"\\F0DFF\";\n}\n\n.mdi-slope-uphill::before {\n  content: \"\\F0E00\";\n}\n\n.mdi-slot-machine::before {\n  content: \"\\F1114\";\n}\n\n.mdi-slot-machine-outline::before {\n  content: \"\\F1115\";\n}\n\n.mdi-smart-card::before {\n  content: \"\\F10BD\";\n}\n\n.mdi-smart-card-outline::before {\n  content: \"\\F10BE\";\n}\n\n.mdi-smart-card-reader::before {\n  content: \"\\F10BF\";\n}\n\n.mdi-smart-card-reader-outline::before {\n  content: \"\\F10C0\";\n}\n\n.mdi-smog::before {\n  content: \"\\F0A71\";\n}\n\n.mdi-smoke-detector::before {\n  content: \"\\F0392\";\n}\n\n.mdi-smoking::before {\n  content: \"\\F04B4\";\n}\n\n.mdi-smoking-off::before {\n  content: \"\\F04B5\";\n}\n\n.mdi-smoking-pipe::before {\n  content: \"\\F140D\";\n}\n\n.mdi-smoking-pipe-off::before {\n  content: \"\\F1428\";\n}\n\n.mdi-snail::before {\n  content: \"\\F1677\";\n}\n\n.mdi-snake::before {\n  content: \"\\F150E\";\n}\n\n.mdi-snapchat::before {\n  content: \"\\F04B6\";\n}\n\n.mdi-snowboard::before {\n  content: \"\\F1307\";\n}\n\n.mdi-snowflake::before {\n  content: \"\\F0717\";\n}\n\n.mdi-snowflake-alert::before {\n  content: \"\\F0F29\";\n}\n\n.mdi-snowflake-melt::before {\n  content: \"\\F12CB\";\n}\n\n.mdi-snowflake-off::before {\n  content: \"\\F14E3\";\n}\n\n.mdi-snowflake-variant::before {\n  content: \"\\F0F2A\";\n}\n\n.mdi-snowman::before {\n  content: \"\\F04B7\";\n}\n\n.mdi-soccer::before {\n  content: \"\\F04B8\";\n}\n\n.mdi-soccer-field::before {\n  content: \"\\F0834\";\n}\n\n.mdi-social-distance-2-meters::before {\n  content: \"\\F1579\";\n}\n\n.mdi-social-distance-6-feet::before {\n  content: \"\\F157A\";\n}\n\n.mdi-sofa::before {\n  content: \"\\F04B9\";\n}\n\n.mdi-sofa-outline::before {\n  content: \"\\F156D\";\n}\n\n.mdi-sofa-single::before {\n  content: \"\\F156E\";\n}\n\n.mdi-sofa-single-outline::before {\n  content: \"\\F156F\";\n}\n\n.mdi-solar-panel::before {\n  content: \"\\F0D9B\";\n}\n\n.mdi-solar-panel-large::before {\n  content: \"\\F0D9C\";\n}\n\n.mdi-solar-power::before {\n  content: \"\\F0A72\";\n}\n\n.mdi-soldering-iron::before {\n  content: \"\\F1092\";\n}\n\n.mdi-solid::before {\n  content: \"\\F068D\";\n}\n\n.mdi-sony-playstation::before {\n  content: \"\\F0414\";\n}\n\n.mdi-sort::before {\n  content: \"\\F04BA\";\n}\n\n.mdi-sort-alphabetical-ascending::before {\n  content: \"\\F05BD\";\n}\n\n.mdi-sort-alphabetical-ascending-variant::before {\n  content: \"\\F1148\";\n}\n\n.mdi-sort-alphabetical-descending::before {\n  content: \"\\F05BF\";\n}\n\n.mdi-sort-alphabetical-descending-variant::before {\n  content: \"\\F1149\";\n}\n\n.mdi-sort-alphabetical-variant::before {\n  content: \"\\F04BB\";\n}\n\n.mdi-sort-ascending::before {\n  content: \"\\F04BC\";\n}\n\n.mdi-sort-bool-ascending::before {\n  content: \"\\F1385\";\n}\n\n.mdi-sort-bool-ascending-variant::before {\n  content: \"\\F1386\";\n}\n\n.mdi-sort-bool-descending::before {\n  content: \"\\F1387\";\n}\n\n.mdi-sort-bool-descending-variant::before {\n  content: \"\\F1388\";\n}\n\n.mdi-sort-calendar-ascending::before {\n  content: \"\\F1547\";\n}\n\n.mdi-sort-calendar-descending::before {\n  content: \"\\F1548\";\n}\n\n.mdi-sort-clock-ascending::before {\n  content: \"\\F1549\";\n}\n\n.mdi-sort-clock-ascending-outline::before {\n  content: \"\\F154A\";\n}\n\n.mdi-sort-clock-descending::before {\n  content: \"\\F154B\";\n}\n\n.mdi-sort-clock-descending-outline::before {\n  content: \"\\F154C\";\n}\n\n.mdi-sort-descending::before {\n  content: \"\\F04BD\";\n}\n\n.mdi-sort-numeric-ascending::before {\n  content: \"\\F1389\";\n}\n\n.mdi-sort-numeric-ascending-variant::before {\n  content: \"\\F090D\";\n}\n\n.mdi-sort-numeric-descending::before {\n  content: \"\\F138A\";\n}\n\n.mdi-sort-numeric-descending-variant::before {\n  content: \"\\F0AD2\";\n}\n\n.mdi-sort-numeric-variant::before {\n  content: \"\\F04BE\";\n}\n\n.mdi-sort-reverse-variant::before {\n  content: \"\\F033C\";\n}\n\n.mdi-sort-variant::before {\n  content: \"\\F04BF\";\n}\n\n.mdi-sort-variant-lock::before {\n  content: \"\\F0CCD\";\n}\n\n.mdi-sort-variant-lock-open::before {\n  content: \"\\F0CCE\";\n}\n\n.mdi-sort-variant-remove::before {\n  content: \"\\F1147\";\n}\n\n.mdi-soundcloud::before {\n  content: \"\\F04C0\";\n}\n\n.mdi-source-branch::before {\n  content: \"\\F062C\";\n}\n\n.mdi-source-branch-check::before {\n  content: \"\\F14CF\";\n}\n\n.mdi-source-branch-minus::before {\n  content: \"\\F14CB\";\n}\n\n.mdi-source-branch-plus::before {\n  content: \"\\F14CA\";\n}\n\n.mdi-source-branch-refresh::before {\n  content: \"\\F14CD\";\n}\n\n.mdi-source-branch-remove::before {\n  content: \"\\F14CC\";\n}\n\n.mdi-source-branch-sync::before {\n  content: \"\\F14CE\";\n}\n\n.mdi-source-commit::before {\n  content: \"\\F0718\";\n}\n\n.mdi-source-commit-end::before {\n  content: \"\\F0719\";\n}\n\n.mdi-source-commit-end-local::before {\n  content: \"\\F071A\";\n}\n\n.mdi-source-commit-local::before {\n  content: \"\\F071B\";\n}\n\n.mdi-source-commit-next-local::before {\n  content: \"\\F071C\";\n}\n\n.mdi-source-commit-start::before {\n  content: \"\\F071D\";\n}\n\n.mdi-source-commit-start-next-local::before {\n  content: \"\\F071E\";\n}\n\n.mdi-source-fork::before {\n  content: \"\\F04C1\";\n}\n\n.mdi-source-merge::before {\n  content: \"\\F062D\";\n}\n\n.mdi-source-pull::before {\n  content: \"\\F04C2\";\n}\n\n.mdi-source-repository::before {\n  content: \"\\F0CCF\";\n}\n\n.mdi-source-repository-multiple::before {\n  content: \"\\F0CD0\";\n}\n\n.mdi-soy-sauce::before {\n  content: \"\\F07EE\";\n}\n\n.mdi-soy-sauce-off::before {\n  content: \"\\F13FC\";\n}\n\n.mdi-spa::before {\n  content: \"\\F0CD1\";\n}\n\n.mdi-spa-outline::before {\n  content: \"\\F0CD2\";\n}\n\n.mdi-space-invaders::before {\n  content: \"\\F0BC9\";\n}\n\n.mdi-space-station::before {\n  content: \"\\F1383\";\n}\n\n.mdi-spade::before {\n  content: \"\\F0E65\";\n}\n\n.mdi-sparkles::before {\n  content: \"\\F1545\";\n}\n\n.mdi-speaker::before {\n  content: \"\\F04C3\";\n}\n\n.mdi-speaker-bluetooth::before {\n  content: \"\\F09A2\";\n}\n\n.mdi-speaker-multiple::before {\n  content: \"\\F0D38\";\n}\n\n.mdi-speaker-off::before {\n  content: \"\\F04C4\";\n}\n\n.mdi-speaker-wireless::before {\n  content: \"\\F071F\";\n}\n\n.mdi-speedometer::before {\n  content: \"\\F04C5\";\n}\n\n.mdi-speedometer-medium::before {\n  content: \"\\F0F85\";\n}\n\n.mdi-speedometer-slow::before {\n  content: \"\\F0F86\";\n}\n\n.mdi-spellcheck::before {\n  content: \"\\F04C6\";\n}\n\n.mdi-spider::before {\n  content: \"\\F11EA\";\n}\n\n.mdi-spider-thread::before {\n  content: \"\\F11EB\";\n}\n\n.mdi-spider-web::before {\n  content: \"\\F0BCA\";\n}\n\n.mdi-spirit-level::before {\n  content: \"\\F14F1\";\n}\n\n.mdi-spoon-sugar::before {\n  content: \"\\F1429\";\n}\n\n.mdi-spotify::before {\n  content: \"\\F04C7\";\n}\n\n.mdi-spotlight::before {\n  content: \"\\F04C8\";\n}\n\n.mdi-spotlight-beam::before {\n  content: \"\\F04C9\";\n}\n\n.mdi-spray::before {\n  content: \"\\F0665\";\n}\n\n.mdi-spray-bottle::before {\n  content: \"\\F0AE0\";\n}\n\n.mdi-sprinkler::before {\n  content: \"\\F105F\";\n}\n\n.mdi-sprinkler-variant::before {\n  content: \"\\F1060\";\n}\n\n.mdi-sprout::before {\n  content: \"\\F0E66\";\n}\n\n.mdi-sprout-outline::before {\n  content: \"\\F0E67\";\n}\n\n.mdi-square::before {\n  content: \"\\F0764\";\n}\n\n.mdi-square-circle::before {\n  content: \"\\F1500\";\n}\n\n.mdi-square-edit-outline::before {\n  content: \"\\F090C\";\n}\n\n.mdi-square-medium::before {\n  content: \"\\F0A13\";\n}\n\n.mdi-square-medium-outline::before {\n  content: \"\\F0A14\";\n}\n\n.mdi-square-off::before {\n  content: \"\\F12EE\";\n}\n\n.mdi-square-off-outline::before {\n  content: \"\\F12EF\";\n}\n\n.mdi-square-outline::before {\n  content: \"\\F0763\";\n}\n\n.mdi-square-root::before {\n  content: \"\\F0784\";\n}\n\n.mdi-square-root-box::before {\n  content: \"\\F09A3\";\n}\n\n.mdi-square-rounded::before {\n  content: \"\\F14FB\";\n}\n\n.mdi-square-rounded-outline::before {\n  content: \"\\F14FC\";\n}\n\n.mdi-square-small::before {\n  content: \"\\F0A15\";\n}\n\n.mdi-square-wave::before {\n  content: \"\\F147B\";\n}\n\n.mdi-squeegee::before {\n  content: \"\\F0AE1\";\n}\n\n.mdi-ssh::before {\n  content: \"\\F08C0\";\n}\n\n.mdi-stack-exchange::before {\n  content: \"\\F060B\";\n}\n\n.mdi-stack-overflow::before {\n  content: \"\\F04CC\";\n}\n\n.mdi-stackpath::before {\n  content: \"\\F0359\";\n}\n\n.mdi-stadium::before {\n  content: \"\\F0FF9\";\n}\n\n.mdi-stadium-variant::before {\n  content: \"\\F0720\";\n}\n\n.mdi-stairs::before {\n  content: \"\\F04CD\";\n}\n\n.mdi-stairs-box::before {\n  content: \"\\F139E\";\n}\n\n.mdi-stairs-down::before {\n  content: \"\\F12BE\";\n}\n\n.mdi-stairs-up::before {\n  content: \"\\F12BD\";\n}\n\n.mdi-stamper::before {\n  content: \"\\F0D39\";\n}\n\n.mdi-standard-definition::before {\n  content: \"\\F07EF\";\n}\n\n.mdi-star::before {\n  content: \"\\F04CE\";\n}\n\n.mdi-star-box::before {\n  content: \"\\F0A73\";\n}\n\n.mdi-star-box-multiple::before {\n  content: \"\\F1286\";\n}\n\n.mdi-star-box-multiple-outline::before {\n  content: \"\\F1287\";\n}\n\n.mdi-star-box-outline::before {\n  content: \"\\F0A74\";\n}\n\n.mdi-star-check::before {\n  content: \"\\F1566\";\n}\n\n.mdi-star-check-outline::before {\n  content: \"\\F156A\";\n}\n\n.mdi-star-circle::before {\n  content: \"\\F04CF\";\n}\n\n.mdi-star-circle-outline::before {\n  content: \"\\F09A4\";\n}\n\n.mdi-star-cog::before {\n  content: \"\\F1668\";\n}\n\n.mdi-star-cog-outline::before {\n  content: \"\\F1669\";\n}\n\n.mdi-star-face::before {\n  content: \"\\F09A5\";\n}\n\n.mdi-star-four-points::before {\n  content: \"\\F0AE2\";\n}\n\n.mdi-star-four-points-outline::before {\n  content: \"\\F0AE3\";\n}\n\n.mdi-star-half::before {\n  content: \"\\F0246\";\n}\n\n.mdi-star-half-full::before {\n  content: \"\\F04D0\";\n}\n\n.mdi-star-minus::before {\n  content: \"\\F1564\";\n}\n\n.mdi-star-minus-outline::before {\n  content: \"\\F1568\";\n}\n\n.mdi-star-off::before {\n  content: \"\\F04D1\";\n}\n\n.mdi-star-off-outline::before {\n  content: \"\\F155B\";\n}\n\n.mdi-star-outline::before {\n  content: \"\\F04D2\";\n}\n\n.mdi-star-plus::before {\n  content: \"\\F1563\";\n}\n\n.mdi-star-plus-outline::before {\n  content: \"\\F1567\";\n}\n\n.mdi-star-remove::before {\n  content: \"\\F1565\";\n}\n\n.mdi-star-remove-outline::before {\n  content: \"\\F1569\";\n}\n\n.mdi-star-settings::before {\n  content: \"\\F166A\";\n}\n\n.mdi-star-settings-outline::before {\n  content: \"\\F166B\";\n}\n\n.mdi-star-shooting::before {\n  content: \"\\F1741\";\n}\n\n.mdi-star-shooting-outline::before {\n  content: \"\\F1742\";\n}\n\n.mdi-star-three-points::before {\n  content: \"\\F0AE4\";\n}\n\n.mdi-star-three-points-outline::before {\n  content: \"\\F0AE5\";\n}\n\n.mdi-state-machine::before {\n  content: \"\\F11EF\";\n}\n\n.mdi-steam::before {\n  content: \"\\F04D3\";\n}\n\n.mdi-steering::before {\n  content: \"\\F04D4\";\n}\n\n.mdi-steering-off::before {\n  content: \"\\F090E\";\n}\n\n.mdi-step-backward::before {\n  content: \"\\F04D5\";\n}\n\n.mdi-step-backward-2::before {\n  content: \"\\F04D6\";\n}\n\n.mdi-step-forward::before {\n  content: \"\\F04D7\";\n}\n\n.mdi-step-forward-2::before {\n  content: \"\\F04D8\";\n}\n\n.mdi-stethoscope::before {\n  content: \"\\F04D9\";\n}\n\n.mdi-sticker::before {\n  content: \"\\F1364\";\n}\n\n.mdi-sticker-alert::before {\n  content: \"\\F1365\";\n}\n\n.mdi-sticker-alert-outline::before {\n  content: \"\\F1366\";\n}\n\n.mdi-sticker-check::before {\n  content: \"\\F1367\";\n}\n\n.mdi-sticker-check-outline::before {\n  content: \"\\F1368\";\n}\n\n.mdi-sticker-circle-outline::before {\n  content: \"\\F05D0\";\n}\n\n.mdi-sticker-emoji::before {\n  content: \"\\F0785\";\n}\n\n.mdi-sticker-minus::before {\n  content: \"\\F1369\";\n}\n\n.mdi-sticker-minus-outline::before {\n  content: \"\\F136A\";\n}\n\n.mdi-sticker-outline::before {\n  content: \"\\F136B\";\n}\n\n.mdi-sticker-plus::before {\n  content: \"\\F136C\";\n}\n\n.mdi-sticker-plus-outline::before {\n  content: \"\\F136D\";\n}\n\n.mdi-sticker-remove::before {\n  content: \"\\F136E\";\n}\n\n.mdi-sticker-remove-outline::before {\n  content: \"\\F136F\";\n}\n\n.mdi-stocking::before {\n  content: \"\\F04DA\";\n}\n\n.mdi-stomach::before {\n  content: \"\\F1093\";\n}\n\n.mdi-stop::before {\n  content: \"\\F04DB\";\n}\n\n.mdi-stop-circle::before {\n  content: \"\\F0666\";\n}\n\n.mdi-stop-circle-outline::before {\n  content: \"\\F0667\";\n}\n\n.mdi-store::before {\n  content: \"\\F04DC\";\n}\n\n.mdi-store-24-hour::before {\n  content: \"\\F04DD\";\n}\n\n.mdi-store-minus::before {\n  content: \"\\F165E\";\n}\n\n.mdi-store-outline::before {\n  content: \"\\F1361\";\n}\n\n.mdi-store-plus::before {\n  content: \"\\F165F\";\n}\n\n.mdi-store-remove::before {\n  content: \"\\F1660\";\n}\n\n.mdi-storefront::before {\n  content: \"\\F07C7\";\n}\n\n.mdi-storefront-outline::before {\n  content: \"\\F10C1\";\n}\n\n.mdi-stove::before {\n  content: \"\\F04DE\";\n}\n\n.mdi-strategy::before {\n  content: \"\\F11D6\";\n}\n\n.mdi-stretch-to-page::before {\n  content: \"\\F0F2B\";\n}\n\n.mdi-stretch-to-page-outline::before {\n  content: \"\\F0F2C\";\n}\n\n.mdi-string-lights::before {\n  content: \"\\F12BA\";\n}\n\n.mdi-string-lights-off::before {\n  content: \"\\F12BB\";\n}\n\n.mdi-subdirectory-arrow-left::before {\n  content: \"\\F060C\";\n}\n\n.mdi-subdirectory-arrow-right::before {\n  content: \"\\F060D\";\n}\n\n.mdi-submarine::before {\n  content: \"\\F156C\";\n}\n\n.mdi-subtitles::before {\n  content: \"\\F0A16\";\n}\n\n.mdi-subtitles-outline::before {\n  content: \"\\F0A17\";\n}\n\n.mdi-subway::before {\n  content: \"\\F06AC\";\n}\n\n.mdi-subway-alert-variant::before {\n  content: \"\\F0D9D\";\n}\n\n.mdi-subway-variant::before {\n  content: \"\\F04DF\";\n}\n\n.mdi-summit::before {\n  content: \"\\F0786\";\n}\n\n.mdi-sunglasses::before {\n  content: \"\\F04E0\";\n}\n\n.mdi-surround-sound::before {\n  content: \"\\F05C5\";\n}\n\n.mdi-surround-sound-2-0::before {\n  content: \"\\F07F0\";\n}\n\n.mdi-surround-sound-2-1::before {\n  content: \"\\F1729\";\n}\n\n.mdi-surround-sound-3-1::before {\n  content: \"\\F07F1\";\n}\n\n.mdi-surround-sound-5-1::before {\n  content: \"\\F07F2\";\n}\n\n.mdi-surround-sound-5-1-2::before {\n  content: \"\\F172A\";\n}\n\n.mdi-surround-sound-7-1::before {\n  content: \"\\F07F3\";\n}\n\n.mdi-svg::before {\n  content: \"\\F0721\";\n}\n\n.mdi-swap-horizontal::before {\n  content: \"\\F04E1\";\n}\n\n.mdi-swap-horizontal-bold::before {\n  content: \"\\F0BCD\";\n}\n\n.mdi-swap-horizontal-circle::before {\n  content: \"\\F0FE1\";\n}\n\n.mdi-swap-horizontal-circle-outline::before {\n  content: \"\\F0FE2\";\n}\n\n.mdi-swap-horizontal-variant::before {\n  content: \"\\F08C1\";\n}\n\n.mdi-swap-vertical::before {\n  content: \"\\F04E2\";\n}\n\n.mdi-swap-vertical-bold::before {\n  content: \"\\F0BCE\";\n}\n\n.mdi-swap-vertical-circle::before {\n  content: \"\\F0FE3\";\n}\n\n.mdi-swap-vertical-circle-outline::before {\n  content: \"\\F0FE4\";\n}\n\n.mdi-swap-vertical-variant::before {\n  content: \"\\F08C2\";\n}\n\n.mdi-swim::before {\n  content: \"\\F04E3\";\n}\n\n.mdi-switch::before {\n  content: \"\\F04E4\";\n}\n\n.mdi-sword::before {\n  content: \"\\F04E5\";\n}\n\n.mdi-sword-cross::before {\n  content: \"\\F0787\";\n}\n\n.mdi-syllabary-hangul::before {\n  content: \"\\F1333\";\n}\n\n.mdi-syllabary-hiragana::before {\n  content: \"\\F1334\";\n}\n\n.mdi-syllabary-katakana::before {\n  content: \"\\F1335\";\n}\n\n.mdi-syllabary-katakana-halfwidth::before {\n  content: \"\\F1336\";\n}\n\n.mdi-symbol::before {\n  content: \"\\F1501\";\n}\n\n.mdi-symfony::before {\n  content: \"\\F0AE6\";\n}\n\n.mdi-sync::before {\n  content: \"\\F04E6\";\n}\n\n.mdi-sync-alert::before {\n  content: \"\\F04E7\";\n}\n\n.mdi-sync-circle::before {\n  content: \"\\F1378\";\n}\n\n.mdi-sync-off::before {\n  content: \"\\F04E8\";\n}\n\n.mdi-tab::before {\n  content: \"\\F04E9\";\n}\n\n.mdi-tab-minus::before {\n  content: \"\\F0B4B\";\n}\n\n.mdi-tab-plus::before {\n  content: \"\\F075C\";\n}\n\n.mdi-tab-remove::before {\n  content: \"\\F0B4C\";\n}\n\n.mdi-tab-unselected::before {\n  content: \"\\F04EA\";\n}\n\n.mdi-table::before {\n  content: \"\\F04EB\";\n}\n\n.mdi-table-account::before {\n  content: \"\\F13B9\";\n}\n\n.mdi-table-alert::before {\n  content: \"\\F13BA\";\n}\n\n.mdi-table-arrow-down::before {\n  content: \"\\F13BB\";\n}\n\n.mdi-table-arrow-left::before {\n  content: \"\\F13BC\";\n}\n\n.mdi-table-arrow-right::before {\n  content: \"\\F13BD\";\n}\n\n.mdi-table-arrow-up::before {\n  content: \"\\F13BE\";\n}\n\n.mdi-table-border::before {\n  content: \"\\F0A18\";\n}\n\n.mdi-table-cancel::before {\n  content: \"\\F13BF\";\n}\n\n.mdi-table-chair::before {\n  content: \"\\F1061\";\n}\n\n.mdi-table-check::before {\n  content: \"\\F13C0\";\n}\n\n.mdi-table-clock::before {\n  content: \"\\F13C1\";\n}\n\n.mdi-table-cog::before {\n  content: \"\\F13C2\";\n}\n\n.mdi-table-column::before {\n  content: \"\\F0835\";\n}\n\n.mdi-table-column-plus-after::before {\n  content: \"\\F04EC\";\n}\n\n.mdi-table-column-plus-before::before {\n  content: \"\\F04ED\";\n}\n\n.mdi-table-column-remove::before {\n  content: \"\\F04EE\";\n}\n\n.mdi-table-column-width::before {\n  content: \"\\F04EF\";\n}\n\n.mdi-table-edit::before {\n  content: \"\\F04F0\";\n}\n\n.mdi-table-eye::before {\n  content: \"\\F1094\";\n}\n\n.mdi-table-eye-off::before {\n  content: \"\\F13C3\";\n}\n\n.mdi-table-furniture::before {\n  content: \"\\F05BC\";\n}\n\n.mdi-table-headers-eye::before {\n  content: \"\\F121D\";\n}\n\n.mdi-table-headers-eye-off::before {\n  content: \"\\F121E\";\n}\n\n.mdi-table-heart::before {\n  content: \"\\F13C4\";\n}\n\n.mdi-table-key::before {\n  content: \"\\F13C5\";\n}\n\n.mdi-table-large::before {\n  content: \"\\F04F1\";\n}\n\n.mdi-table-large-plus::before {\n  content: \"\\F0F87\";\n}\n\n.mdi-table-large-remove::before {\n  content: \"\\F0F88\";\n}\n\n.mdi-table-lock::before {\n  content: \"\\F13C6\";\n}\n\n.mdi-table-merge-cells::before {\n  content: \"\\F09A6\";\n}\n\n.mdi-table-minus::before {\n  content: \"\\F13C7\";\n}\n\n.mdi-table-multiple::before {\n  content: \"\\F13C8\";\n}\n\n.mdi-table-network::before {\n  content: \"\\F13C9\";\n}\n\n.mdi-table-of-contents::before {\n  content: \"\\F0836\";\n}\n\n.mdi-table-off::before {\n  content: \"\\F13CA\";\n}\n\n.mdi-table-picnic::before {\n  content: \"\\F1743\";\n}\n\n.mdi-table-plus::before {\n  content: \"\\F0A75\";\n}\n\n.mdi-table-refresh::before {\n  content: \"\\F13A0\";\n}\n\n.mdi-table-remove::before {\n  content: \"\\F0A76\";\n}\n\n.mdi-table-row::before {\n  content: \"\\F0837\";\n}\n\n.mdi-table-row-height::before {\n  content: \"\\F04F2\";\n}\n\n.mdi-table-row-plus-after::before {\n  content: \"\\F04F3\";\n}\n\n.mdi-table-row-plus-before::before {\n  content: \"\\F04F4\";\n}\n\n.mdi-table-row-remove::before {\n  content: \"\\F04F5\";\n}\n\n.mdi-table-search::before {\n  content: \"\\F090F\";\n}\n\n.mdi-table-settings::before {\n  content: \"\\F0838\";\n}\n\n.mdi-table-split-cell::before {\n  content: \"\\F142A\";\n}\n\n.mdi-table-star::before {\n  content: \"\\F13CB\";\n}\n\n.mdi-table-sync::before {\n  content: \"\\F13A1\";\n}\n\n.mdi-table-tennis::before {\n  content: \"\\F0E68\";\n}\n\n.mdi-tablet::before {\n  content: \"\\F04F6\";\n}\n\n.mdi-tablet-android::before {\n  content: \"\\F04F7\";\n}\n\n.mdi-tablet-cellphone::before {\n  content: \"\\F09A7\";\n}\n\n.mdi-tablet-dashboard::before {\n  content: \"\\F0ECE\";\n}\n\n.mdi-tablet-ipad::before {\n  content: \"\\F04F8\";\n}\n\n.mdi-taco::before {\n  content: \"\\F0762\";\n}\n\n.mdi-tag::before {\n  content: \"\\F04F9\";\n}\n\n.mdi-tag-arrow-down::before {\n  content: \"\\F172B\";\n}\n\n.mdi-tag-arrow-down-outline::before {\n  content: \"\\F172C\";\n}\n\n.mdi-tag-arrow-left::before {\n  content: \"\\F172D\";\n}\n\n.mdi-tag-arrow-left-outline::before {\n  content: \"\\F172E\";\n}\n\n.mdi-tag-arrow-right::before {\n  content: \"\\F172F\";\n}\n\n.mdi-tag-arrow-right-outline::before {\n  content: \"\\F1730\";\n}\n\n.mdi-tag-arrow-up::before {\n  content: \"\\F1731\";\n}\n\n.mdi-tag-arrow-up-outline::before {\n  content: \"\\F1732\";\n}\n\n.mdi-tag-faces::before {\n  content: \"\\F04FA\";\n}\n\n.mdi-tag-heart::before {\n  content: \"\\F068B\";\n}\n\n.mdi-tag-heart-outline::before {\n  content: \"\\F0BCF\";\n}\n\n.mdi-tag-minus::before {\n  content: \"\\F0910\";\n}\n\n.mdi-tag-minus-outline::before {\n  content: \"\\F121F\";\n}\n\n.mdi-tag-multiple::before {\n  content: \"\\F04FB\";\n}\n\n.mdi-tag-multiple-outline::before {\n  content: \"\\F12F7\";\n}\n\n.mdi-tag-off::before {\n  content: \"\\F1220\";\n}\n\n.mdi-tag-off-outline::before {\n  content: \"\\F1221\";\n}\n\n.mdi-tag-outline::before {\n  content: \"\\F04FC\";\n}\n\n.mdi-tag-plus::before {\n  content: \"\\F0722\";\n}\n\n.mdi-tag-plus-outline::before {\n  content: \"\\F1222\";\n}\n\n.mdi-tag-remove::before {\n  content: \"\\F0723\";\n}\n\n.mdi-tag-remove-outline::before {\n  content: \"\\F1223\";\n}\n\n.mdi-tag-text::before {\n  content: \"\\F1224\";\n}\n\n.mdi-tag-text-outline::before {\n  content: \"\\F04FD\";\n}\n\n.mdi-tailwind::before {\n  content: \"\\F13FF\";\n}\n\n.mdi-tank::before {\n  content: \"\\F0D3A\";\n}\n\n.mdi-tanker-truck::before {\n  content: \"\\F0FE5\";\n}\n\n.mdi-tape-drive::before {\n  content: \"\\F16DF\";\n}\n\n.mdi-tape-measure::before {\n  content: \"\\F0B4D\";\n}\n\n.mdi-target::before {\n  content: \"\\F04FE\";\n}\n\n.mdi-target-account::before {\n  content: \"\\F0BD0\";\n}\n\n.mdi-target-variant::before {\n  content: \"\\F0A77\";\n}\n\n.mdi-taxi::before {\n  content: \"\\F04FF\";\n}\n\n.mdi-tea::before {\n  content: \"\\F0D9E\";\n}\n\n.mdi-tea-outline::before {\n  content: \"\\F0D9F\";\n}\n\n.mdi-teach::before {\n  content: \"\\F0890\";\n}\n\n.mdi-teamviewer::before {\n  content: \"\\F0500\";\n}\n\n.mdi-telegram::before {\n  content: \"\\F0501\";\n}\n\n.mdi-telescope::before {\n  content: \"\\F0B4E\";\n}\n\n.mdi-television::before {\n  content: \"\\F0502\";\n}\n\n.mdi-television-ambient-light::before {\n  content: \"\\F1356\";\n}\n\n.mdi-television-box::before {\n  content: \"\\F0839\";\n}\n\n.mdi-television-classic::before {\n  content: \"\\F07F4\";\n}\n\n.mdi-television-classic-off::before {\n  content: \"\\F083A\";\n}\n\n.mdi-television-clean::before {\n  content: \"\\F1110\";\n}\n\n.mdi-television-guide::before {\n  content: \"\\F0503\";\n}\n\n.mdi-television-off::before {\n  content: \"\\F083B\";\n}\n\n.mdi-television-pause::before {\n  content: \"\\F0F89\";\n}\n\n.mdi-television-play::before {\n  content: \"\\F0ECF\";\n}\n\n.mdi-television-stop::before {\n  content: \"\\F0F8A\";\n}\n\n.mdi-temperature-celsius::before {\n  content: \"\\F0504\";\n}\n\n.mdi-temperature-fahrenheit::before {\n  content: \"\\F0505\";\n}\n\n.mdi-temperature-kelvin::before {\n  content: \"\\F0506\";\n}\n\n.mdi-tennis::before {\n  content: \"\\F0DA0\";\n}\n\n.mdi-tennis-ball::before {\n  content: \"\\F0507\";\n}\n\n.mdi-tent::before {\n  content: \"\\F0508\";\n}\n\n.mdi-terraform::before {\n  content: \"\\F1062\";\n}\n\n.mdi-terrain::before {\n  content: \"\\F0509\";\n}\n\n.mdi-test-tube::before {\n  content: \"\\F0668\";\n}\n\n.mdi-test-tube-empty::before {\n  content: \"\\F0911\";\n}\n\n.mdi-test-tube-off::before {\n  content: \"\\F0912\";\n}\n\n.mdi-text::before {\n  content: \"\\F09A8\";\n}\n\n.mdi-text-account::before {\n  content: \"\\F1570\";\n}\n\n.mdi-text-box::before {\n  content: \"\\F021A\";\n}\n\n.mdi-text-box-check::before {\n  content: \"\\F0EA6\";\n}\n\n.mdi-text-box-check-outline::before {\n  content: \"\\F0EA7\";\n}\n\n.mdi-text-box-minus::before {\n  content: \"\\F0EA8\";\n}\n\n.mdi-text-box-minus-outline::before {\n  content: \"\\F0EA9\";\n}\n\n.mdi-text-box-multiple::before {\n  content: \"\\F0AB7\";\n}\n\n.mdi-text-box-multiple-outline::before {\n  content: \"\\F0AB8\";\n}\n\n.mdi-text-box-outline::before {\n  content: \"\\F09ED\";\n}\n\n.mdi-text-box-plus::before {\n  content: \"\\F0EAA\";\n}\n\n.mdi-text-box-plus-outline::before {\n  content: \"\\F0EAB\";\n}\n\n.mdi-text-box-remove::before {\n  content: \"\\F0EAC\";\n}\n\n.mdi-text-box-remove-outline::before {\n  content: \"\\F0EAD\";\n}\n\n.mdi-text-box-search::before {\n  content: \"\\F0EAE\";\n}\n\n.mdi-text-box-search-outline::before {\n  content: \"\\F0EAF\";\n}\n\n.mdi-text-recognition::before {\n  content: \"\\F113D\";\n}\n\n.mdi-text-search::before {\n  content: \"\\F13B8\";\n}\n\n.mdi-text-shadow::before {\n  content: \"\\F0669\";\n}\n\n.mdi-text-short::before {\n  content: \"\\F09A9\";\n}\n\n.mdi-text-subject::before {\n  content: \"\\F09AA\";\n}\n\n.mdi-text-to-speech::before {\n  content: \"\\F050A\";\n}\n\n.mdi-text-to-speech-off::before {\n  content: \"\\F050B\";\n}\n\n.mdi-texture::before {\n  content: \"\\F050C\";\n}\n\n.mdi-texture-box::before {\n  content: \"\\F0FE6\";\n}\n\n.mdi-theater::before {\n  content: \"\\F050D\";\n}\n\n.mdi-theme-light-dark::before {\n  content: \"\\F050E\";\n}\n\n.mdi-thermometer::before {\n  content: \"\\F050F\";\n}\n\n.mdi-thermometer-alert::before {\n  content: \"\\F0E01\";\n}\n\n.mdi-thermometer-chevron-down::before {\n  content: \"\\F0E02\";\n}\n\n.mdi-thermometer-chevron-up::before {\n  content: \"\\F0E03\";\n}\n\n.mdi-thermometer-high::before {\n  content: \"\\F10C2\";\n}\n\n.mdi-thermometer-lines::before {\n  content: \"\\F0510\";\n}\n\n.mdi-thermometer-low::before {\n  content: \"\\F10C3\";\n}\n\n.mdi-thermometer-minus::before {\n  content: \"\\F0E04\";\n}\n\n.mdi-thermometer-off::before {\n  content: \"\\F1531\";\n}\n\n.mdi-thermometer-plus::before {\n  content: \"\\F0E05\";\n}\n\n.mdi-thermostat::before {\n  content: \"\\F0393\";\n}\n\n.mdi-thermostat-box::before {\n  content: \"\\F0891\";\n}\n\n.mdi-thought-bubble::before {\n  content: \"\\F07F6\";\n}\n\n.mdi-thought-bubble-outline::before {\n  content: \"\\F07F7\";\n}\n\n.mdi-thumb-down::before {\n  content: \"\\F0511\";\n}\n\n.mdi-thumb-down-outline::before {\n  content: \"\\F0512\";\n}\n\n.mdi-thumb-up::before {\n  content: \"\\F0513\";\n}\n\n.mdi-thumb-up-outline::before {\n  content: \"\\F0514\";\n}\n\n.mdi-thumbs-up-down::before {\n  content: \"\\F0515\";\n}\n\n.mdi-ticket::before {\n  content: \"\\F0516\";\n}\n\n.mdi-ticket-account::before {\n  content: \"\\F0517\";\n}\n\n.mdi-ticket-confirmation::before {\n  content: \"\\F0518\";\n}\n\n.mdi-ticket-confirmation-outline::before {\n  content: \"\\F13AA\";\n}\n\n.mdi-ticket-outline::before {\n  content: \"\\F0913\";\n}\n\n.mdi-ticket-percent::before {\n  content: \"\\F0724\";\n}\n\n.mdi-ticket-percent-outline::before {\n  content: \"\\F142B\";\n}\n\n.mdi-tie::before {\n  content: \"\\F0519\";\n}\n\n.mdi-tilde::before {\n  content: \"\\F0725\";\n}\n\n.mdi-timelapse::before {\n  content: \"\\F051A\";\n}\n\n.mdi-timeline::before {\n  content: \"\\F0BD1\";\n}\n\n.mdi-timeline-alert::before {\n  content: \"\\F0F95\";\n}\n\n.mdi-timeline-alert-outline::before {\n  content: \"\\F0F98\";\n}\n\n.mdi-timeline-check::before {\n  content: \"\\F1532\";\n}\n\n.mdi-timeline-check-outline::before {\n  content: \"\\F1533\";\n}\n\n.mdi-timeline-clock::before {\n  content: \"\\F11FB\";\n}\n\n.mdi-timeline-clock-outline::before {\n  content: \"\\F11FC\";\n}\n\n.mdi-timeline-help::before {\n  content: \"\\F0F99\";\n}\n\n.mdi-timeline-help-outline::before {\n  content: \"\\F0F9A\";\n}\n\n.mdi-timeline-minus::before {\n  content: \"\\F1534\";\n}\n\n.mdi-timeline-minus-outline::before {\n  content: \"\\F1535\";\n}\n\n.mdi-timeline-outline::before {\n  content: \"\\F0BD2\";\n}\n\n.mdi-timeline-plus::before {\n  content: \"\\F0F96\";\n}\n\n.mdi-timeline-plus-outline::before {\n  content: \"\\F0F97\";\n}\n\n.mdi-timeline-remove::before {\n  content: \"\\F1536\";\n}\n\n.mdi-timeline-remove-outline::before {\n  content: \"\\F1537\";\n}\n\n.mdi-timeline-text::before {\n  content: \"\\F0BD3\";\n}\n\n.mdi-timeline-text-outline::before {\n  content: \"\\F0BD4\";\n}\n\n.mdi-timer::before {\n  content: \"\\F13AB\";\n}\n\n.mdi-timer-10::before {\n  content: \"\\F051C\";\n}\n\n.mdi-timer-3::before {\n  content: \"\\F051D\";\n}\n\n.mdi-timer-off::before {\n  content: \"\\F13AC\";\n}\n\n.mdi-timer-off-outline::before {\n  content: \"\\F051E\";\n}\n\n.mdi-timer-outline::before {\n  content: \"\\F051B\";\n}\n\n.mdi-timer-sand::before {\n  content: \"\\F051F\";\n}\n\n.mdi-timer-sand-empty::before {\n  content: \"\\F06AD\";\n}\n\n.mdi-timer-sand-full::before {\n  content: \"\\F078C\";\n}\n\n.mdi-timetable::before {\n  content: \"\\F0520\";\n}\n\n.mdi-toaster::before {\n  content: \"\\F1063\";\n}\n\n.mdi-toaster-off::before {\n  content: \"\\F11B7\";\n}\n\n.mdi-toaster-oven::before {\n  content: \"\\F0CD3\";\n}\n\n.mdi-toggle-switch::before {\n  content: \"\\F0521\";\n}\n\n.mdi-toggle-switch-off::before {\n  content: \"\\F0522\";\n}\n\n.mdi-toggle-switch-off-outline::before {\n  content: \"\\F0A19\";\n}\n\n.mdi-toggle-switch-outline::before {\n  content: \"\\F0A1A\";\n}\n\n.mdi-toilet::before {\n  content: \"\\F09AB\";\n}\n\n.mdi-toolbox::before {\n  content: \"\\F09AC\";\n}\n\n.mdi-toolbox-outline::before {\n  content: \"\\F09AD\";\n}\n\n.mdi-tools::before {\n  content: \"\\F1064\";\n}\n\n.mdi-tooltip::before {\n  content: \"\\F0523\";\n}\n\n.mdi-tooltip-account::before {\n  content: \"\\F000C\";\n}\n\n.mdi-tooltip-check::before {\n  content: \"\\F155C\";\n}\n\n.mdi-tooltip-check-outline::before {\n  content: \"\\F155D\";\n}\n\n.mdi-tooltip-edit::before {\n  content: \"\\F0524\";\n}\n\n.mdi-tooltip-edit-outline::before {\n  content: \"\\F12C5\";\n}\n\n.mdi-tooltip-image::before {\n  content: \"\\F0525\";\n}\n\n.mdi-tooltip-image-outline::before {\n  content: \"\\F0BD5\";\n}\n\n.mdi-tooltip-minus::before {\n  content: \"\\F155E\";\n}\n\n.mdi-tooltip-minus-outline::before {\n  content: \"\\F155F\";\n}\n\n.mdi-tooltip-outline::before {\n  content: \"\\F0526\";\n}\n\n.mdi-tooltip-plus::before {\n  content: \"\\F0BD6\";\n}\n\n.mdi-tooltip-plus-outline::before {\n  content: \"\\F0527\";\n}\n\n.mdi-tooltip-remove::before {\n  content: \"\\F1560\";\n}\n\n.mdi-tooltip-remove-outline::before {\n  content: \"\\F1561\";\n}\n\n.mdi-tooltip-text::before {\n  content: \"\\F0528\";\n}\n\n.mdi-tooltip-text-outline::before {\n  content: \"\\F0BD7\";\n}\n\n.mdi-tooth::before {\n  content: \"\\F08C3\";\n}\n\n.mdi-tooth-outline::before {\n  content: \"\\F0529\";\n}\n\n.mdi-toothbrush::before {\n  content: \"\\F1129\";\n}\n\n.mdi-toothbrush-electric::before {\n  content: \"\\F112C\";\n}\n\n.mdi-toothbrush-paste::before {\n  content: \"\\F112A\";\n}\n\n.mdi-torch::before {\n  content: \"\\F1606\";\n}\n\n.mdi-tortoise::before {\n  content: \"\\F0D3B\";\n}\n\n.mdi-toslink::before {\n  content: \"\\F12B8\";\n}\n\n.mdi-tournament::before {\n  content: \"\\F09AE\";\n}\n\n.mdi-tow-truck::before {\n  content: \"\\F083C\";\n}\n\n.mdi-tower-beach::before {\n  content: \"\\F0681\";\n}\n\n.mdi-tower-fire::before {\n  content: \"\\F0682\";\n}\n\n.mdi-toy-brick::before {\n  content: \"\\F1288\";\n}\n\n.mdi-toy-brick-marker::before {\n  content: \"\\F1289\";\n}\n\n.mdi-toy-brick-marker-outline::before {\n  content: \"\\F128A\";\n}\n\n.mdi-toy-brick-minus::before {\n  content: \"\\F128B\";\n}\n\n.mdi-toy-brick-minus-outline::before {\n  content: \"\\F128C\";\n}\n\n.mdi-toy-brick-outline::before {\n  content: \"\\F128D\";\n}\n\n.mdi-toy-brick-plus::before {\n  content: \"\\F128E\";\n}\n\n.mdi-toy-brick-plus-outline::before {\n  content: \"\\F128F\";\n}\n\n.mdi-toy-brick-remove::before {\n  content: \"\\F1290\";\n}\n\n.mdi-toy-brick-remove-outline::before {\n  content: \"\\F1291\";\n}\n\n.mdi-toy-brick-search::before {\n  content: \"\\F1292\";\n}\n\n.mdi-toy-brick-search-outline::before {\n  content: \"\\F1293\";\n}\n\n.mdi-track-light::before {\n  content: \"\\F0914\";\n}\n\n.mdi-trackpad::before {\n  content: \"\\F07F8\";\n}\n\n.mdi-trackpad-lock::before {\n  content: \"\\F0933\";\n}\n\n.mdi-tractor::before {\n  content: \"\\F0892\";\n}\n\n.mdi-tractor-variant::before {\n  content: \"\\F14C4\";\n}\n\n.mdi-trademark::before {\n  content: \"\\F0A78\";\n}\n\n.mdi-traffic-cone::before {\n  content: \"\\F137C\";\n}\n\n.mdi-traffic-light::before {\n  content: \"\\F052B\";\n}\n\n.mdi-train::before {\n  content: \"\\F052C\";\n}\n\n.mdi-train-car::before {\n  content: \"\\F0BD8\";\n}\n\n.mdi-train-car-passenger::before {\n  content: \"\\F1733\";\n}\n\n.mdi-train-car-passenger-door::before {\n  content: \"\\F1734\";\n}\n\n.mdi-train-car-passenger-door-open::before {\n  content: \"\\F1735\";\n}\n\n.mdi-train-car-passenger-variant::before {\n  content: \"\\F1736\";\n}\n\n.mdi-train-variant::before {\n  content: \"\\F08C4\";\n}\n\n.mdi-tram::before {\n  content: \"\\F052D\";\n}\n\n.mdi-tram-side::before {\n  content: \"\\F0FE7\";\n}\n\n.mdi-transcribe::before {\n  content: \"\\F052E\";\n}\n\n.mdi-transcribe-close::before {\n  content: \"\\F052F\";\n}\n\n.mdi-transfer::before {\n  content: \"\\F1065\";\n}\n\n.mdi-transfer-down::before {\n  content: \"\\F0DA1\";\n}\n\n.mdi-transfer-left::before {\n  content: \"\\F0DA2\";\n}\n\n.mdi-transfer-right::before {\n  content: \"\\F0530\";\n}\n\n.mdi-transfer-up::before {\n  content: \"\\F0DA3\";\n}\n\n.mdi-transit-connection::before {\n  content: \"\\F0D3C\";\n}\n\n.mdi-transit-connection-horizontal::before {\n  content: \"\\F1546\";\n}\n\n.mdi-transit-connection-variant::before {\n  content: \"\\F0D3D\";\n}\n\n.mdi-transit-detour::before {\n  content: \"\\F0F8B\";\n}\n\n.mdi-transit-skip::before {\n  content: \"\\F1515\";\n}\n\n.mdi-transit-transfer::before {\n  content: \"\\F06AE\";\n}\n\n.mdi-transition::before {\n  content: \"\\F0915\";\n}\n\n.mdi-transition-masked::before {\n  content: \"\\F0916\";\n}\n\n.mdi-translate::before {\n  content: \"\\F05CA\";\n}\n\n.mdi-translate-off::before {\n  content: \"\\F0E06\";\n}\n\n.mdi-transmission-tower::before {\n  content: \"\\F0D3E\";\n}\n\n.mdi-trash-can::before {\n  content: \"\\F0A79\";\n}\n\n.mdi-trash-can-outline::before {\n  content: \"\\F0A7A\";\n}\n\n.mdi-tray::before {\n  content: \"\\F1294\";\n}\n\n.mdi-tray-alert::before {\n  content: \"\\F1295\";\n}\n\n.mdi-tray-full::before {\n  content: \"\\F1296\";\n}\n\n.mdi-tray-minus::before {\n  content: \"\\F1297\";\n}\n\n.mdi-tray-plus::before {\n  content: \"\\F1298\";\n}\n\n.mdi-tray-remove::before {\n  content: \"\\F1299\";\n}\n\n.mdi-treasure-chest::before {\n  content: \"\\F0726\";\n}\n\n.mdi-tree::before {\n  content: \"\\F0531\";\n}\n\n.mdi-tree-outline::before {\n  content: \"\\F0E69\";\n}\n\n.mdi-trello::before {\n  content: \"\\F0532\";\n}\n\n.mdi-trending-down::before {\n  content: \"\\F0533\";\n}\n\n.mdi-trending-neutral::before {\n  content: \"\\F0534\";\n}\n\n.mdi-trending-up::before {\n  content: \"\\F0535\";\n}\n\n.mdi-triangle::before {\n  content: \"\\F0536\";\n}\n\n.mdi-triangle-outline::before {\n  content: \"\\F0537\";\n}\n\n.mdi-triangle-wave::before {\n  content: \"\\F147C\";\n}\n\n.mdi-triforce::before {\n  content: \"\\F0BD9\";\n}\n\n.mdi-trophy::before {\n  content: \"\\F0538\";\n}\n\n.mdi-trophy-award::before {\n  content: \"\\F0539\";\n}\n\n.mdi-trophy-broken::before {\n  content: \"\\F0DA4\";\n}\n\n.mdi-trophy-outline::before {\n  content: \"\\F053A\";\n}\n\n.mdi-trophy-variant::before {\n  content: \"\\F053B\";\n}\n\n.mdi-trophy-variant-outline::before {\n  content: \"\\F053C\";\n}\n\n.mdi-truck::before {\n  content: \"\\F053D\";\n}\n\n.mdi-truck-check::before {\n  content: \"\\F0CD4\";\n}\n\n.mdi-truck-check-outline::before {\n  content: \"\\F129A\";\n}\n\n.mdi-truck-delivery::before {\n  content: \"\\F053E\";\n}\n\n.mdi-truck-delivery-outline::before {\n  content: \"\\F129B\";\n}\n\n.mdi-truck-fast::before {\n  content: \"\\F0788\";\n}\n\n.mdi-truck-fast-outline::before {\n  content: \"\\F129C\";\n}\n\n.mdi-truck-outline::before {\n  content: \"\\F129D\";\n}\n\n.mdi-truck-trailer::before {\n  content: \"\\F0727\";\n}\n\n.mdi-trumpet::before {\n  content: \"\\F1096\";\n}\n\n.mdi-tshirt-crew::before {\n  content: \"\\F0A7B\";\n}\n\n.mdi-tshirt-crew-outline::before {\n  content: \"\\F053F\";\n}\n\n.mdi-tshirt-v::before {\n  content: \"\\F0A7C\";\n}\n\n.mdi-tshirt-v-outline::before {\n  content: \"\\F0540\";\n}\n\n.mdi-tumble-dryer::before {\n  content: \"\\F0917\";\n}\n\n.mdi-tumble-dryer-alert::before {\n  content: \"\\F11BA\";\n}\n\n.mdi-tumble-dryer-off::before {\n  content: \"\\F11BB\";\n}\n\n.mdi-tune::before {\n  content: \"\\F062E\";\n}\n\n.mdi-tune-variant::before {\n  content: \"\\F1542\";\n}\n\n.mdi-tune-vertical::before {\n  content: \"\\F066A\";\n}\n\n.mdi-tune-vertical-variant::before {\n  content: \"\\F1543\";\n}\n\n.mdi-turkey::before {\n  content: \"\\F171B\";\n}\n\n.mdi-turnstile::before {\n  content: \"\\F0CD5\";\n}\n\n.mdi-turnstile-outline::before {\n  content: \"\\F0CD6\";\n}\n\n.mdi-turtle::before {\n  content: \"\\F0CD7\";\n}\n\n.mdi-twitch::before {\n  content: \"\\F0543\";\n}\n\n.mdi-twitter::before {\n  content: \"\\F0544\";\n}\n\n.mdi-twitter-retweet::before {\n  content: \"\\F0547\";\n}\n\n.mdi-two-factor-authentication::before {\n  content: \"\\F09AF\";\n}\n\n.mdi-typewriter::before {\n  content: \"\\F0F2D\";\n}\n\n.mdi-ubisoft::before {\n  content: \"\\F0BDA\";\n}\n\n.mdi-ubuntu::before {\n  content: \"\\F0548\";\n}\n\n.mdi-ufo::before {\n  content: \"\\F10C4\";\n}\n\n.mdi-ufo-outline::before {\n  content: \"\\F10C5\";\n}\n\n.mdi-ultra-high-definition::before {\n  content: \"\\F07F9\";\n}\n\n.mdi-umbraco::before {\n  content: \"\\F0549\";\n}\n\n.mdi-umbrella::before {\n  content: \"\\F054A\";\n}\n\n.mdi-umbrella-closed::before {\n  content: \"\\F09B0\";\n}\n\n.mdi-umbrella-closed-outline::before {\n  content: \"\\F13E2\";\n}\n\n.mdi-umbrella-closed-variant::before {\n  content: \"\\F13E1\";\n}\n\n.mdi-umbrella-outline::before {\n  content: \"\\F054B\";\n}\n\n.mdi-undo::before {\n  content: \"\\F054C\";\n}\n\n.mdi-undo-variant::before {\n  content: \"\\F054D\";\n}\n\n.mdi-unfold-less-horizontal::before {\n  content: \"\\F054E\";\n}\n\n.mdi-unfold-less-vertical::before {\n  content: \"\\F0760\";\n}\n\n.mdi-unfold-more-horizontal::before {\n  content: \"\\F054F\";\n}\n\n.mdi-unfold-more-vertical::before {\n  content: \"\\F0761\";\n}\n\n.mdi-ungroup::before {\n  content: \"\\F0550\";\n}\n\n.mdi-unicode::before {\n  content: \"\\F0ED0\";\n}\n\n.mdi-unicorn::before {\n  content: \"\\F15C2\";\n}\n\n.mdi-unicorn-variant::before {\n  content: \"\\F15C3\";\n}\n\n.mdi-unicycle::before {\n  content: \"\\F15E5\";\n}\n\n.mdi-unity::before {\n  content: \"\\F06AF\";\n}\n\n.mdi-unreal::before {\n  content: \"\\F09B1\";\n}\n\n.mdi-untappd::before {\n  content: \"\\F0551\";\n}\n\n.mdi-update::before {\n  content: \"\\F06B0\";\n}\n\n.mdi-upload::before {\n  content: \"\\F0552\";\n}\n\n.mdi-upload-lock::before {\n  content: \"\\F1373\";\n}\n\n.mdi-upload-lock-outline::before {\n  content: \"\\F1374\";\n}\n\n.mdi-upload-multiple::before {\n  content: \"\\F083D\";\n}\n\n.mdi-upload-network::before {\n  content: \"\\F06F6\";\n}\n\n.mdi-upload-network-outline::before {\n  content: \"\\F0CD8\";\n}\n\n.mdi-upload-off::before {\n  content: \"\\F10C6\";\n}\n\n.mdi-upload-off-outline::before {\n  content: \"\\F10C7\";\n}\n\n.mdi-upload-outline::before {\n  content: \"\\F0E07\";\n}\n\n.mdi-usb::before {\n  content: \"\\F0553\";\n}\n\n.mdi-usb-flash-drive::before {\n  content: \"\\F129E\";\n}\n\n.mdi-usb-flash-drive-outline::before {\n  content: \"\\F129F\";\n}\n\n.mdi-usb-port::before {\n  content: \"\\F11F0\";\n}\n\n.mdi-valve::before {\n  content: \"\\F1066\";\n}\n\n.mdi-valve-closed::before {\n  content: \"\\F1067\";\n}\n\n.mdi-valve-open::before {\n  content: \"\\F1068\";\n}\n\n.mdi-van-passenger::before {\n  content: \"\\F07FA\";\n}\n\n.mdi-van-utility::before {\n  content: \"\\F07FB\";\n}\n\n.mdi-vanish::before {\n  content: \"\\F07FC\";\n}\n\n.mdi-vanish-quarter::before {\n  content: \"\\F1554\";\n}\n\n.mdi-vanity-light::before {\n  content: \"\\F11E1\";\n}\n\n.mdi-variable::before {\n  content: \"\\F0AE7\";\n}\n\n.mdi-variable-box::before {\n  content: \"\\F1111\";\n}\n\n.mdi-vector-arrange-above::before {\n  content: \"\\F0554\";\n}\n\n.mdi-vector-arrange-below::before {\n  content: \"\\F0555\";\n}\n\n.mdi-vector-bezier::before {\n  content: \"\\F0AE8\";\n}\n\n.mdi-vector-circle::before {\n  content: \"\\F0556\";\n}\n\n.mdi-vector-circle-variant::before {\n  content: \"\\F0557\";\n}\n\n.mdi-vector-combine::before {\n  content: \"\\F0558\";\n}\n\n.mdi-vector-curve::before {\n  content: \"\\F0559\";\n}\n\n.mdi-vector-difference::before {\n  content: \"\\F055A\";\n}\n\n.mdi-vector-difference-ab::before {\n  content: \"\\F055B\";\n}\n\n.mdi-vector-difference-ba::before {\n  content: \"\\F055C\";\n}\n\n.mdi-vector-ellipse::before {\n  content: \"\\F0893\";\n}\n\n.mdi-vector-intersection::before {\n  content: \"\\F055D\";\n}\n\n.mdi-vector-line::before {\n  content: \"\\F055E\";\n}\n\n.mdi-vector-link::before {\n  content: \"\\F0FE8\";\n}\n\n.mdi-vector-point::before {\n  content: \"\\F055F\";\n}\n\n.mdi-vector-polygon::before {\n  content: \"\\F0560\";\n}\n\n.mdi-vector-polyline::before {\n  content: \"\\F0561\";\n}\n\n.mdi-vector-polyline-edit::before {\n  content: \"\\F1225\";\n}\n\n.mdi-vector-polyline-minus::before {\n  content: \"\\F1226\";\n}\n\n.mdi-vector-polyline-plus::before {\n  content: \"\\F1227\";\n}\n\n.mdi-vector-polyline-remove::before {\n  content: \"\\F1228\";\n}\n\n.mdi-vector-radius::before {\n  content: \"\\F074A\";\n}\n\n.mdi-vector-rectangle::before {\n  content: \"\\F05C6\";\n}\n\n.mdi-vector-selection::before {\n  content: \"\\F0562\";\n}\n\n.mdi-vector-square::before {\n  content: \"\\F0001\";\n}\n\n.mdi-vector-triangle::before {\n  content: \"\\F0563\";\n}\n\n.mdi-vector-union::before {\n  content: \"\\F0564\";\n}\n\n.mdi-vhs::before {\n  content: \"\\F0A1B\";\n}\n\n.mdi-vibrate::before {\n  content: \"\\F0566\";\n}\n\n.mdi-vibrate-off::before {\n  content: \"\\F0CD9\";\n}\n\n.mdi-video::before {\n  content: \"\\F0567\";\n}\n\n.mdi-video-3d::before {\n  content: \"\\F07FD\";\n}\n\n.mdi-video-3d-off::before {\n  content: \"\\F13D9\";\n}\n\n.mdi-video-3d-variant::before {\n  content: \"\\F0ED1\";\n}\n\n.mdi-video-4k-box::before {\n  content: \"\\F083E\";\n}\n\n.mdi-video-account::before {\n  content: \"\\F0919\";\n}\n\n.mdi-video-box::before {\n  content: \"\\F00FD\";\n}\n\n.mdi-video-box-off::before {\n  content: \"\\F00FE\";\n}\n\n.mdi-video-check::before {\n  content: \"\\F1069\";\n}\n\n.mdi-video-check-outline::before {\n  content: \"\\F106A\";\n}\n\n.mdi-video-high-definition::before {\n  content: \"\\F152E\";\n}\n\n.mdi-video-image::before {\n  content: \"\\F091A\";\n}\n\n.mdi-video-input-antenna::before {\n  content: \"\\F083F\";\n}\n\n.mdi-video-input-component::before {\n  content: \"\\F0840\";\n}\n\n.mdi-video-input-hdmi::before {\n  content: \"\\F0841\";\n}\n\n.mdi-video-input-scart::before {\n  content: \"\\F0F8C\";\n}\n\n.mdi-video-input-svideo::before {\n  content: \"\\F0842\";\n}\n\n.mdi-video-minus::before {\n  content: \"\\F09B2\";\n}\n\n.mdi-video-minus-outline::before {\n  content: \"\\F02BA\";\n}\n\n.mdi-video-off::before {\n  content: \"\\F0568\";\n}\n\n.mdi-video-off-outline::before {\n  content: \"\\F0BDB\";\n}\n\n.mdi-video-outline::before {\n  content: \"\\F0BDC\";\n}\n\n.mdi-video-plus::before {\n  content: \"\\F09B3\";\n}\n\n.mdi-video-plus-outline::before {\n  content: \"\\F01D3\";\n}\n\n.mdi-video-stabilization::before {\n  content: \"\\F091B\";\n}\n\n.mdi-video-switch::before {\n  content: \"\\F0569\";\n}\n\n.mdi-video-switch-outline::before {\n  content: \"\\F0790\";\n}\n\n.mdi-video-vintage::before {\n  content: \"\\F0A1C\";\n}\n\n.mdi-video-wireless::before {\n  content: \"\\F0ED2\";\n}\n\n.mdi-video-wireless-outline::before {\n  content: \"\\F0ED3\";\n}\n\n.mdi-view-agenda::before {\n  content: \"\\F056A\";\n}\n\n.mdi-view-agenda-outline::before {\n  content: \"\\F11D8\";\n}\n\n.mdi-view-array::before {\n  content: \"\\F056B\";\n}\n\n.mdi-view-array-outline::before {\n  content: \"\\F1485\";\n}\n\n.mdi-view-carousel::before {\n  content: \"\\F056C\";\n}\n\n.mdi-view-carousel-outline::before {\n  content: \"\\F1486\";\n}\n\n.mdi-view-column::before {\n  content: \"\\F056D\";\n}\n\n.mdi-view-column-outline::before {\n  content: \"\\F1487\";\n}\n\n.mdi-view-comfy::before {\n  content: \"\\F0E6A\";\n}\n\n.mdi-view-comfy-outline::before {\n  content: \"\\F1488\";\n}\n\n.mdi-view-compact::before {\n  content: \"\\F0E6B\";\n}\n\n.mdi-view-compact-outline::before {\n  content: \"\\F0E6C\";\n}\n\n.mdi-view-dashboard::before {\n  content: \"\\F056E\";\n}\n\n.mdi-view-dashboard-outline::before {\n  content: \"\\F0A1D\";\n}\n\n.mdi-view-dashboard-variant::before {\n  content: \"\\F0843\";\n}\n\n.mdi-view-dashboard-variant-outline::before {\n  content: \"\\F1489\";\n}\n\n.mdi-view-day::before {\n  content: \"\\F056F\";\n}\n\n.mdi-view-day-outline::before {\n  content: \"\\F148A\";\n}\n\n.mdi-view-grid::before {\n  content: \"\\F0570\";\n}\n\n.mdi-view-grid-outline::before {\n  content: \"\\F11D9\";\n}\n\n.mdi-view-grid-plus::before {\n  content: \"\\F0F8D\";\n}\n\n.mdi-view-grid-plus-outline::before {\n  content: \"\\F11DA\";\n}\n\n.mdi-view-headline::before {\n  content: \"\\F0571\";\n}\n\n.mdi-view-list::before {\n  content: \"\\F0572\";\n}\n\n.mdi-view-list-outline::before {\n  content: \"\\F148B\";\n}\n\n.mdi-view-module::before {\n  content: \"\\F0573\";\n}\n\n.mdi-view-module-outline::before {\n  content: \"\\F148C\";\n}\n\n.mdi-view-parallel::before {\n  content: \"\\F0728\";\n}\n\n.mdi-view-parallel-outline::before {\n  content: \"\\F148D\";\n}\n\n.mdi-view-quilt::before {\n  content: \"\\F0574\";\n}\n\n.mdi-view-quilt-outline::before {\n  content: \"\\F148E\";\n}\n\n.mdi-view-sequential::before {\n  content: \"\\F0729\";\n}\n\n.mdi-view-sequential-outline::before {\n  content: \"\\F148F\";\n}\n\n.mdi-view-split-horizontal::before {\n  content: \"\\F0BCB\";\n}\n\n.mdi-view-split-vertical::before {\n  content: \"\\F0BCC\";\n}\n\n.mdi-view-stream::before {\n  content: \"\\F0575\";\n}\n\n.mdi-view-stream-outline::before {\n  content: \"\\F1490\";\n}\n\n.mdi-view-week::before {\n  content: \"\\F0576\";\n}\n\n.mdi-view-week-outline::before {\n  content: \"\\F1491\";\n}\n\n.mdi-vimeo::before {\n  content: \"\\F0577\";\n}\n\n.mdi-violin::before {\n  content: \"\\F060F\";\n}\n\n.mdi-virtual-reality::before {\n  content: \"\\F0894\";\n}\n\n.mdi-virus::before {\n  content: \"\\F13B6\";\n}\n\n.mdi-virus-outline::before {\n  content: \"\\F13B7\";\n}\n\n.mdi-vk::before {\n  content: \"\\F0579\";\n}\n\n.mdi-vlc::before {\n  content: \"\\F057C\";\n}\n\n.mdi-voice-off::before {\n  content: \"\\F0ED4\";\n}\n\n.mdi-voicemail::before {\n  content: \"\\F057D\";\n}\n\n.mdi-volleyball::before {\n  content: \"\\F09B4\";\n}\n\n.mdi-volume-high::before {\n  content: \"\\F057E\";\n}\n\n.mdi-volume-low::before {\n  content: \"\\F057F\";\n}\n\n.mdi-volume-medium::before {\n  content: \"\\F0580\";\n}\n\n.mdi-volume-minus::before {\n  content: \"\\F075E\";\n}\n\n.mdi-volume-mute::before {\n  content: \"\\F075F\";\n}\n\n.mdi-volume-off::before {\n  content: \"\\F0581\";\n}\n\n.mdi-volume-plus::before {\n  content: \"\\F075D\";\n}\n\n.mdi-volume-source::before {\n  content: \"\\F1120\";\n}\n\n.mdi-volume-variant-off::before {\n  content: \"\\F0E08\";\n}\n\n.mdi-volume-vibrate::before {\n  content: \"\\F1121\";\n}\n\n.mdi-vote::before {\n  content: \"\\F0A1F\";\n}\n\n.mdi-vote-outline::before {\n  content: \"\\F0A20\";\n}\n\n.mdi-vpn::before {\n  content: \"\\F0582\";\n}\n\n.mdi-vuejs::before {\n  content: \"\\F0844\";\n}\n\n.mdi-vuetify::before {\n  content: \"\\F0E6D\";\n}\n\n.mdi-walk::before {\n  content: \"\\F0583\";\n}\n\n.mdi-wall::before {\n  content: \"\\F07FE\";\n}\n\n.mdi-wall-sconce::before {\n  content: \"\\F091C\";\n}\n\n.mdi-wall-sconce-flat::before {\n  content: \"\\F091D\";\n}\n\n.mdi-wall-sconce-flat-variant::before {\n  content: \"\\F041C\";\n}\n\n.mdi-wall-sconce-round::before {\n  content: \"\\F0748\";\n}\n\n.mdi-wall-sconce-round-variant::before {\n  content: \"\\F091E\";\n}\n\n.mdi-wallet::before {\n  content: \"\\F0584\";\n}\n\n.mdi-wallet-giftcard::before {\n  content: \"\\F0585\";\n}\n\n.mdi-wallet-membership::before {\n  content: \"\\F0586\";\n}\n\n.mdi-wallet-outline::before {\n  content: \"\\F0BDD\";\n}\n\n.mdi-wallet-plus::before {\n  content: \"\\F0F8E\";\n}\n\n.mdi-wallet-plus-outline::before {\n  content: \"\\F0F8F\";\n}\n\n.mdi-wallet-travel::before {\n  content: \"\\F0587\";\n}\n\n.mdi-wallpaper::before {\n  content: \"\\F0E09\";\n}\n\n.mdi-wan::before {\n  content: \"\\F0588\";\n}\n\n.mdi-wardrobe::before {\n  content: \"\\F0F90\";\n}\n\n.mdi-wardrobe-outline::before {\n  content: \"\\F0F91\";\n}\n\n.mdi-warehouse::before {\n  content: \"\\F0F81\";\n}\n\n.mdi-washing-machine::before {\n  content: \"\\F072A\";\n}\n\n.mdi-washing-machine-alert::before {\n  content: \"\\F11BC\";\n}\n\n.mdi-washing-machine-off::before {\n  content: \"\\F11BD\";\n}\n\n.mdi-watch::before {\n  content: \"\\F0589\";\n}\n\n.mdi-watch-export::before {\n  content: \"\\F058A\";\n}\n\n.mdi-watch-export-variant::before {\n  content: \"\\F0895\";\n}\n\n.mdi-watch-import::before {\n  content: \"\\F058B\";\n}\n\n.mdi-watch-import-variant::before {\n  content: \"\\F0896\";\n}\n\n.mdi-watch-variant::before {\n  content: \"\\F0897\";\n}\n\n.mdi-watch-vibrate::before {\n  content: \"\\F06B1\";\n}\n\n.mdi-watch-vibrate-off::before {\n  content: \"\\F0CDA\";\n}\n\n.mdi-water::before {\n  content: \"\\F058C\";\n}\n\n.mdi-water-alert::before {\n  content: \"\\F1502\";\n}\n\n.mdi-water-alert-outline::before {\n  content: \"\\F1503\";\n}\n\n.mdi-water-boiler::before {\n  content: \"\\F0F92\";\n}\n\n.mdi-water-boiler-alert::before {\n  content: \"\\F11B3\";\n}\n\n.mdi-water-boiler-off::before {\n  content: \"\\F11B4\";\n}\n\n.mdi-water-check::before {\n  content: \"\\F1504\";\n}\n\n.mdi-water-check-outline::before {\n  content: \"\\F1505\";\n}\n\n.mdi-water-minus::before {\n  content: \"\\F1506\";\n}\n\n.mdi-water-minus-outline::before {\n  content: \"\\F1507\";\n}\n\n.mdi-water-off::before {\n  content: \"\\F058D\";\n}\n\n.mdi-water-off-outline::before {\n  content: \"\\F1508\";\n}\n\n.mdi-water-outline::before {\n  content: \"\\F0E0A\";\n}\n\n.mdi-water-percent::before {\n  content: \"\\F058E\";\n}\n\n.mdi-water-percent-alert::before {\n  content: \"\\F1509\";\n}\n\n.mdi-water-plus::before {\n  content: \"\\F150A\";\n}\n\n.mdi-water-plus-outline::before {\n  content: \"\\F150B\";\n}\n\n.mdi-water-polo::before {\n  content: \"\\F12A0\";\n}\n\n.mdi-water-pump::before {\n  content: \"\\F058F\";\n}\n\n.mdi-water-pump-off::before {\n  content: \"\\F0F93\";\n}\n\n.mdi-water-remove::before {\n  content: \"\\F150C\";\n}\n\n.mdi-water-remove-outline::before {\n  content: \"\\F150D\";\n}\n\n.mdi-water-well::before {\n  content: \"\\F106B\";\n}\n\n.mdi-water-well-outline::before {\n  content: \"\\F106C\";\n}\n\n.mdi-watering-can::before {\n  content: \"\\F1481\";\n}\n\n.mdi-watering-can-outline::before {\n  content: \"\\F1482\";\n}\n\n.mdi-watermark::before {\n  content: \"\\F0612\";\n}\n\n.mdi-wave::before {\n  content: \"\\F0F2E\";\n}\n\n.mdi-waveform::before {\n  content: \"\\F147D\";\n}\n\n.mdi-waves::before {\n  content: \"\\F078D\";\n}\n\n.mdi-waze::before {\n  content: \"\\F0BDE\";\n}\n\n.mdi-weather-cloudy::before {\n  content: \"\\F0590\";\n}\n\n.mdi-weather-cloudy-alert::before {\n  content: \"\\F0F2F\";\n}\n\n.mdi-weather-cloudy-arrow-right::before {\n  content: \"\\F0E6E\";\n}\n\n.mdi-weather-fog::before {\n  content: \"\\F0591\";\n}\n\n.mdi-weather-hail::before {\n  content: \"\\F0592\";\n}\n\n.mdi-weather-hazy::before {\n  content: \"\\F0F30\";\n}\n\n.mdi-weather-hurricane::before {\n  content: \"\\F0898\";\n}\n\n.mdi-weather-lightning::before {\n  content: \"\\F0593\";\n}\n\n.mdi-weather-lightning-rainy::before {\n  content: \"\\F067E\";\n}\n\n.mdi-weather-night::before {\n  content: \"\\F0594\";\n}\n\n.mdi-weather-night-partly-cloudy::before {\n  content: \"\\F0F31\";\n}\n\n.mdi-weather-partly-cloudy::before {\n  content: \"\\F0595\";\n}\n\n.mdi-weather-partly-lightning::before {\n  content: \"\\F0F32\";\n}\n\n.mdi-weather-partly-rainy::before {\n  content: \"\\F0F33\";\n}\n\n.mdi-weather-partly-snowy::before {\n  content: \"\\F0F34\";\n}\n\n.mdi-weather-partly-snowy-rainy::before {\n  content: \"\\F0F35\";\n}\n\n.mdi-weather-pouring::before {\n  content: \"\\F0596\";\n}\n\n.mdi-weather-rainy::before {\n  content: \"\\F0597\";\n}\n\n.mdi-weather-snowy::before {\n  content: \"\\F0598\";\n}\n\n.mdi-weather-snowy-heavy::before {\n  content: \"\\F0F36\";\n}\n\n.mdi-weather-snowy-rainy::before {\n  content: \"\\F067F\";\n}\n\n.mdi-weather-sunny::before {\n  content: \"\\F0599\";\n}\n\n.mdi-weather-sunny-alert::before {\n  content: \"\\F0F37\";\n}\n\n.mdi-weather-sunny-off::before {\n  content: \"\\F14E4\";\n}\n\n.mdi-weather-sunset::before {\n  content: \"\\F059A\";\n}\n\n.mdi-weather-sunset-down::before {\n  content: \"\\F059B\";\n}\n\n.mdi-weather-sunset-up::before {\n  content: \"\\F059C\";\n}\n\n.mdi-weather-tornado::before {\n  content: \"\\F0F38\";\n}\n\n.mdi-weather-windy::before {\n  content: \"\\F059D\";\n}\n\n.mdi-weather-windy-variant::before {\n  content: \"\\F059E\";\n}\n\n.mdi-web::before {\n  content: \"\\F059F\";\n}\n\n.mdi-web-box::before {\n  content: \"\\F0F94\";\n}\n\n.mdi-web-clock::before {\n  content: \"\\F124A\";\n}\n\n.mdi-webcam::before {\n  content: \"\\F05A0\";\n}\n\n.mdi-webcam-off::before {\n  content: \"\\F1737\";\n}\n\n.mdi-webhook::before {\n  content: \"\\F062F\";\n}\n\n.mdi-webpack::before {\n  content: \"\\F072B\";\n}\n\n.mdi-webrtc::before {\n  content: \"\\F1248\";\n}\n\n.mdi-wechat::before {\n  content: \"\\F0611\";\n}\n\n.mdi-weight::before {\n  content: \"\\F05A1\";\n}\n\n.mdi-weight-gram::before {\n  content: \"\\F0D3F\";\n}\n\n.mdi-weight-kilogram::before {\n  content: \"\\F05A2\";\n}\n\n.mdi-weight-lifter::before {\n  content: \"\\F115D\";\n}\n\n.mdi-weight-pound::before {\n  content: \"\\F09B5\";\n}\n\n.mdi-whatsapp::before {\n  content: \"\\F05A3\";\n}\n\n.mdi-wheel-barrow::before {\n  content: \"\\F14F2\";\n}\n\n.mdi-wheelchair-accessibility::before {\n  content: \"\\F05A4\";\n}\n\n.mdi-whistle::before {\n  content: \"\\F09B6\";\n}\n\n.mdi-whistle-outline::before {\n  content: \"\\F12BC\";\n}\n\n.mdi-white-balance-auto::before {\n  content: \"\\F05A5\";\n}\n\n.mdi-white-balance-incandescent::before {\n  content: \"\\F05A6\";\n}\n\n.mdi-white-balance-iridescent::before {\n  content: \"\\F05A7\";\n}\n\n.mdi-white-balance-sunny::before {\n  content: \"\\F05A8\";\n}\n\n.mdi-widgets::before {\n  content: \"\\F072C\";\n}\n\n.mdi-widgets-outline::before {\n  content: \"\\F1355\";\n}\n\n.mdi-wifi::before {\n  content: \"\\F05A9\";\n}\n\n.mdi-wifi-alert::before {\n  content: \"\\F16B5\";\n}\n\n.mdi-wifi-arrow-down::before {\n  content: \"\\F16B6\";\n}\n\n.mdi-wifi-arrow-left::before {\n  content: \"\\F16B7\";\n}\n\n.mdi-wifi-arrow-left-right::before {\n  content: \"\\F16B8\";\n}\n\n.mdi-wifi-arrow-right::before {\n  content: \"\\F16B9\";\n}\n\n.mdi-wifi-arrow-up::before {\n  content: \"\\F16BA\";\n}\n\n.mdi-wifi-arrow-up-down::before {\n  content: \"\\F16BB\";\n}\n\n.mdi-wifi-cancel::before {\n  content: \"\\F16BC\";\n}\n\n.mdi-wifi-check::before {\n  content: \"\\F16BD\";\n}\n\n.mdi-wifi-cog::before {\n  content: \"\\F16BE\";\n}\n\n.mdi-wifi-lock::before {\n  content: \"\\F16BF\";\n}\n\n.mdi-wifi-lock-open::before {\n  content: \"\\F16C0\";\n}\n\n.mdi-wifi-marker::before {\n  content: \"\\F16C1\";\n}\n\n.mdi-wifi-minus::before {\n  content: \"\\F16C2\";\n}\n\n.mdi-wifi-off::before {\n  content: \"\\F05AA\";\n}\n\n.mdi-wifi-plus::before {\n  content: \"\\F16C3\";\n}\n\n.mdi-wifi-refresh::before {\n  content: \"\\F16C4\";\n}\n\n.mdi-wifi-remove::before {\n  content: \"\\F16C5\";\n}\n\n.mdi-wifi-settings::before {\n  content: \"\\F16C6\";\n}\n\n.mdi-wifi-star::before {\n  content: \"\\F0E0B\";\n}\n\n.mdi-wifi-strength-1::before {\n  content: \"\\F091F\";\n}\n\n.mdi-wifi-strength-1-alert::before {\n  content: \"\\F0920\";\n}\n\n.mdi-wifi-strength-1-lock::before {\n  content: \"\\F0921\";\n}\n\n.mdi-wifi-strength-1-lock-open::before {\n  content: \"\\F16CB\";\n}\n\n.mdi-wifi-strength-2::before {\n  content: \"\\F0922\";\n}\n\n.mdi-wifi-strength-2-alert::before {\n  content: \"\\F0923\";\n}\n\n.mdi-wifi-strength-2-lock::before {\n  content: \"\\F0924\";\n}\n\n.mdi-wifi-strength-2-lock-open::before {\n  content: \"\\F16CC\";\n}\n\n.mdi-wifi-strength-3::before {\n  content: \"\\F0925\";\n}\n\n.mdi-wifi-strength-3-alert::before {\n  content: \"\\F0926\";\n}\n\n.mdi-wifi-strength-3-lock::before {\n  content: \"\\F0927\";\n}\n\n.mdi-wifi-strength-3-lock-open::before {\n  content: \"\\F16CD\";\n}\n\n.mdi-wifi-strength-4::before {\n  content: \"\\F0928\";\n}\n\n.mdi-wifi-strength-4-alert::before {\n  content: \"\\F0929\";\n}\n\n.mdi-wifi-strength-4-lock::before {\n  content: \"\\F092A\";\n}\n\n.mdi-wifi-strength-4-lock-open::before {\n  content: \"\\F16CE\";\n}\n\n.mdi-wifi-strength-alert-outline::before {\n  content: \"\\F092B\";\n}\n\n.mdi-wifi-strength-lock-open-outline::before {\n  content: \"\\F16CF\";\n}\n\n.mdi-wifi-strength-lock-outline::before {\n  content: \"\\F092C\";\n}\n\n.mdi-wifi-strength-off::before {\n  content: \"\\F092D\";\n}\n\n.mdi-wifi-strength-off-outline::before {\n  content: \"\\F092E\";\n}\n\n.mdi-wifi-strength-outline::before {\n  content: \"\\F092F\";\n}\n\n.mdi-wifi-sync::before {\n  content: \"\\F16C7\";\n}\n\n.mdi-wikipedia::before {\n  content: \"\\F05AC\";\n}\n\n.mdi-wind-turbine::before {\n  content: \"\\F0DA5\";\n}\n\n.mdi-window-close::before {\n  content: \"\\F05AD\";\n}\n\n.mdi-window-closed::before {\n  content: \"\\F05AE\";\n}\n\n.mdi-window-closed-variant::before {\n  content: \"\\F11DB\";\n}\n\n.mdi-window-maximize::before {\n  content: \"\\F05AF\";\n}\n\n.mdi-window-minimize::before {\n  content: \"\\F05B0\";\n}\n\n.mdi-window-open::before {\n  content: \"\\F05B1\";\n}\n\n.mdi-window-open-variant::before {\n  content: \"\\F11DC\";\n}\n\n.mdi-window-restore::before {\n  content: \"\\F05B2\";\n}\n\n.mdi-window-shutter::before {\n  content: \"\\F111C\";\n}\n\n.mdi-window-shutter-alert::before {\n  content: \"\\F111D\";\n}\n\n.mdi-window-shutter-open::before {\n  content: \"\\F111E\";\n}\n\n.mdi-windsock::before {\n  content: \"\\F15FA\";\n}\n\n.mdi-wiper::before {\n  content: \"\\F0AE9\";\n}\n\n.mdi-wiper-wash::before {\n  content: \"\\F0DA6\";\n}\n\n.mdi-wizard-hat::before {\n  content: \"\\F1477\";\n}\n\n.mdi-wordpress::before {\n  content: \"\\F05B4\";\n}\n\n.mdi-wrap::before {\n  content: \"\\F05B6\";\n}\n\n.mdi-wrap-disabled::before {\n  content: \"\\F0BDF\";\n}\n\n.mdi-wrench::before {\n  content: \"\\F05B7\";\n}\n\n.mdi-wrench-outline::before {\n  content: \"\\F0BE0\";\n}\n\n.mdi-xamarin::before {\n  content: \"\\F0845\";\n}\n\n.mdi-xamarin-outline::before {\n  content: \"\\F0846\";\n}\n\n.mdi-xing::before {\n  content: \"\\F05BE\";\n}\n\n.mdi-xml::before {\n  content: \"\\F05C0\";\n}\n\n.mdi-xmpp::before {\n  content: \"\\F07FF\";\n}\n\n.mdi-y-combinator::before {\n  content: \"\\F0624\";\n}\n\n.mdi-yahoo::before {\n  content: \"\\F0B4F\";\n}\n\n.mdi-yeast::before {\n  content: \"\\F05C1\";\n}\n\n.mdi-yin-yang::before {\n  content: \"\\F0680\";\n}\n\n.mdi-yoga::before {\n  content: \"\\F117C\";\n}\n\n.mdi-youtube::before {\n  content: \"\\F05C3\";\n}\n\n.mdi-youtube-gaming::before {\n  content: \"\\F0848\";\n}\n\n.mdi-youtube-studio::before {\n  content: \"\\F0847\";\n}\n\n.mdi-youtube-subscription::before {\n  content: \"\\F0D40\";\n}\n\n.mdi-youtube-tv::before {\n  content: \"\\F0448\";\n}\n\n.mdi-yurt::before {\n  content: \"\\F1516\";\n}\n\n.mdi-z-wave::before {\n  content: \"\\F0AEA\";\n}\n\n.mdi-zend::before {\n  content: \"\\F0AEB\";\n}\n\n.mdi-zigbee::before {\n  content: \"\\F0D41\";\n}\n\n.mdi-zip-box::before {\n  content: \"\\F05C4\";\n}\n\n.mdi-zip-box-outline::before {\n  content: \"\\F0FFA\";\n}\n\n.mdi-zip-disk::before {\n  content: \"\\F0A23\";\n}\n\n.mdi-zodiac-aquarius::before {\n  content: \"\\F0A7D\";\n}\n\n.mdi-zodiac-aries::before {\n  content: \"\\F0A7E\";\n}\n\n.mdi-zodiac-cancer::before {\n  content: \"\\F0A7F\";\n}\n\n.mdi-zodiac-capricorn::before {\n  content: \"\\F0A80\";\n}\n\n.mdi-zodiac-gemini::before {\n  content: \"\\F0A81\";\n}\n\n.mdi-zodiac-leo::before {\n  content: \"\\F0A82\";\n}\n\n.mdi-zodiac-libra::before {\n  content: \"\\F0A83\";\n}\n\n.mdi-zodiac-pisces::before {\n  content: \"\\F0A84\";\n}\n\n.mdi-zodiac-sagittarius::before {\n  content: \"\\F0A85\";\n}\n\n.mdi-zodiac-scorpio::before {\n  content: \"\\F0A86\";\n}\n\n.mdi-zodiac-taurus::before {\n  content: \"\\F0A87\";\n}\n\n.mdi-zodiac-virgo::before {\n  content: \"\\F0A88\";\n}\n\n.mdi-blank::before {\n  content: \"\\F68C\";\n  visibility: hidden;\n}\n\n.mdi-18px.mdi-set, .mdi-18px.mdi:before {\n  font-size: 18px;\n}\n\n.mdi-24px.mdi-set, .mdi-24px.mdi:before {\n  font-size: 24px;\n}\n\n.mdi-36px.mdi-set, .mdi-36px.mdi:before {\n  font-size: 36px;\n}\n\n.mdi-48px.mdi-set, .mdi-48px.mdi:before {\n  font-size: 48px;\n}\n\n.mdi-dark:before {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mdi-dark.mdi-inactive:before {\n  color: rgba(0, 0, 0, 0.26);\n}\n\n.mdi-light:before {\n  color: white;\n}\n\n.mdi-light.mdi-inactive:before {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.mdi-rotate-45 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(45deg);\n            transform: scaleX(-1) rotate(45deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: scaleY(-1) rotate(45deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-45:before {\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.mdi-rotate-90 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(90deg);\n            transform: scaleX(-1) rotate(90deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(90deg);\n            -ms-transform: rotate(90deg);\n            transform: scaleY(-1) rotate(90deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.mdi-rotate-135 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(135deg);\n            -ms-transform: rotate(135deg);\n            transform: scaleY(-1) rotate(135deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-135:before {\n  -webkit-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n\n.mdi-rotate-180 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(180deg);\n            transform: scaleX(-1) rotate(180deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(180deg);\n            -ms-transform: rotate(180deg);\n            transform: scaleY(-1) rotate(180deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.mdi-rotate-225 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(225deg);\n            transform: scaleX(-1) rotate(225deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(225deg);\n            -ms-transform: rotate(225deg);\n            transform: scaleY(-1) rotate(225deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-225:before {\n  -webkit-transform: rotate(225deg);\n  -ms-transform: rotate(225deg);\n  transform: rotate(225deg);\n}\n\n.mdi-rotate-270 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(270deg);\n            transform: scaleX(-1) rotate(270deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(270deg);\n            -ms-transform: rotate(270deg);\n            transform: scaleY(-1) rotate(270deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.mdi-rotate-315 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(315deg);\n            transform: scaleX(-1) rotate(315deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(315deg);\n            -ms-transform: rotate(315deg);\n            transform: scaleY(-1) rotate(315deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-315:before {\n  -webkit-transform: rotate(315deg);\n  -ms-transform: rotate(315deg);\n  transform: rotate(315deg);\n}\n\n.mdi-flip-h:before {\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: \"FlipH\";\n}\n\n.mdi-flip-v:before {\n  -webkit-transform: scaleY(-1);\n  transform: scaleY(-1);\n  filter: FlipV;\n  -ms-filter: \"FlipV\";\n}\n\n.mdi-spin:before {\n  -webkit-animation: mdi-spin 2s infinite linear;\n  animation: mdi-spin 2s infinite linear;\n}\n\n@-webkit-keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n@keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n/*# sourceMappingURL=materialdesignicons.css.map */","/*!\n * Font Awesome Free 5.13.0 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n */\n.fa,\n.fas,\n.far,\n.fal,\n.fad,\n.fab {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  line-height: 1; }\n\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -.0667em; }\n\n.fa-xs {\n  font-size: .75em; }\n\n.fa-sm {\n  font-size: .875em; }\n\n.fa-1x {\n  font-size: 1em; }\n\n.fa-2x {\n  font-size: 2em; }\n\n.fa-3x {\n  font-size: 3em; }\n\n.fa-4x {\n  font-size: 4em; }\n\n.fa-5x {\n  font-size: 5em; }\n\n.fa-6x {\n  font-size: 6em; }\n\n.fa-7x {\n  font-size: 7em; }\n\n.fa-8x {\n  font-size: 8em; }\n\n.fa-9x {\n  font-size: 9em; }\n\n.fa-10x {\n  font-size: 10em; }\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em; }\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0; }\n  .fa-ul > li {\n    position: relative; }\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit; }\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: .1em;\n  padding: .2em .25em .15em; }\n\n.fa-pull-left {\n  float: left; }\n\n.fa-pull-right {\n  float: right; }\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: .3em; }\n\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: .3em; }\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear; }\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8); }\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg); }\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg); }\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg); }\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1); }\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1); }\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1); }\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none; }\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2.5em; }\n\n.fa-stack-1x,\n.fa-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%; }\n\n.fa-stack-1x {\n  line-height: inherit; }\n\n.fa-stack-2x {\n  font-size: 2em; }\n\n.fa-inverse {\n  color: #fff; }\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\nreaders do not read off random characters that represent icons */\n.fa-500px:before {\n  content: \"\\f26e\"; }\n\n.fa-accessible-icon:before {\n  content: \"\\f368\"; }\n\n.fa-accusoft:before {\n  content: \"\\f369\"; }\n\n.fa-acquisitions-incorporated:before {\n  content: \"\\f6af\"; }\n\n.fa-ad:before {\n  content: \"\\f641\"; }\n\n.fa-address-book:before {\n  content: \"\\f2b9\"; }\n\n.fa-address-card:before {\n  content: \"\\f2bb\"; }\n\n.fa-adjust:before {\n  content: \"\\f042\"; }\n\n.fa-adn:before {\n  content: \"\\f170\"; }\n\n.fa-adobe:before {\n  content: \"\\f778\"; }\n\n.fa-adversal:before {\n  content: \"\\f36a\"; }\n\n.fa-affiliatetheme:before {\n  content: \"\\f36b\"; }\n\n.fa-air-freshener:before {\n  content: \"\\f5d0\"; }\n\n.fa-airbnb:before {\n  content: \"\\f834\"; }\n\n.fa-algolia:before {\n  content: \"\\f36c\"; }\n\n.fa-align-center:before {\n  content: \"\\f037\"; }\n\n.fa-align-justify:before {\n  content: \"\\f039\"; }\n\n.fa-align-left:before {\n  content: \"\\f036\"; }\n\n.fa-align-right:before {\n  content: \"\\f038\"; }\n\n.fa-alipay:before {\n  content: \"\\f642\"; }\n\n.fa-allergies:before {\n  content: \"\\f461\"; }\n\n.fa-amazon:before {\n  content: \"\\f270\"; }\n\n.fa-amazon-pay:before {\n  content: \"\\f42c\"; }\n\n.fa-ambulance:before {\n  content: \"\\f0f9\"; }\n\n.fa-american-sign-language-interpreting:before {\n  content: \"\\f2a3\"; }\n\n.fa-amilia:before {\n  content: \"\\f36d\"; }\n\n.fa-anchor:before {\n  content: \"\\f13d\"; }\n\n.fa-android:before {\n  content: \"\\f17b\"; }\n\n.fa-angellist:before {\n  content: \"\\f209\"; }\n\n.fa-angle-double-down:before {\n  content: \"\\f103\"; }\n\n.fa-angle-double-left:before {\n  content: \"\\f100\"; }\n\n.fa-angle-double-right:before {\n  content: \"\\f101\"; }\n\n.fa-angle-double-up:before {\n  content: \"\\f102\"; }\n\n.fa-angle-down:before {\n  content: \"\\f107\"; }\n\n.fa-angle-left:before {\n  content: \"\\f104\"; }\n\n.fa-angle-right:before {\n  content: \"\\f105\"; }\n\n.fa-angle-up:before {\n  content: \"\\f106\"; }\n\n.fa-angry:before {\n  content: \"\\f556\"; }\n\n.fa-angrycreative:before {\n  content: \"\\f36e\"; }\n\n.fa-angular:before {\n  content: \"\\f420\"; }\n\n.fa-ankh:before {\n  content: \"\\f644\"; }\n\n.fa-app-store:before {\n  content: \"\\f36f\"; }\n\n.fa-app-store-ios:before {\n  content: \"\\f370\"; }\n\n.fa-apper:before {\n  content: \"\\f371\"; }\n\n.fa-apple:before {\n  content: \"\\f179\"; }\n\n.fa-apple-alt:before {\n  content: \"\\f5d1\"; }\n\n.fa-apple-pay:before {\n  content: \"\\f415\"; }\n\n.fa-archive:before {\n  content: \"\\f187\"; }\n\n.fa-archway:before {\n  content: \"\\f557\"; }\n\n.fa-arrow-alt-circle-down:before {\n  content: \"\\f358\"; }\n\n.fa-arrow-alt-circle-left:before {\n  content: \"\\f359\"; }\n\n.fa-arrow-alt-circle-right:before {\n  content: \"\\f35a\"; }\n\n.fa-arrow-alt-circle-up:before {\n  content: \"\\f35b\"; }\n\n.fa-arrow-circle-down:before {\n  content: \"\\f0ab\"; }\n\n.fa-arrow-circle-left:before {\n  content: \"\\f0a8\"; }\n\n.fa-arrow-circle-right:before {\n  content: \"\\f0a9\"; }\n\n.fa-arrow-circle-up:before {\n  content: \"\\f0aa\"; }\n\n.fa-arrow-down:before {\n  content: \"\\f063\"; }\n\n.fa-arrow-left:before {\n  content: \"\\f060\"; }\n\n.fa-arrow-right:before {\n  content: \"\\f061\"; }\n\n.fa-arrow-up:before {\n  content: \"\\f062\"; }\n\n.fa-arrows-alt:before {\n  content: \"\\f0b2\"; }\n\n.fa-arrows-alt-h:before {\n  content: \"\\f337\"; }\n\n.fa-arrows-alt-v:before {\n  content: \"\\f338\"; }\n\n.fa-artstation:before {\n  content: \"\\f77a\"; }\n\n.fa-assistive-listening-systems:before {\n  content: \"\\f2a2\"; }\n\n.fa-asterisk:before {\n  content: \"\\f069\"; }\n\n.fa-asymmetrik:before {\n  content: \"\\f372\"; }\n\n.fa-at:before {\n  content: \"\\f1fa\"; }\n\n.fa-atlas:before {\n  content: \"\\f558\"; }\n\n.fa-atlassian:before {\n  content: \"\\f77b\"; }\n\n.fa-atom:before {\n  content: \"\\f5d2\"; }\n\n.fa-audible:before {\n  content: \"\\f373\"; }\n\n.fa-audio-description:before {\n  content: \"\\f29e\"; }\n\n.fa-autoprefixer:before {\n  content: \"\\f41c\"; }\n\n.fa-avianex:before {\n  content: \"\\f374\"; }\n\n.fa-aviato:before {\n  content: \"\\f421\"; }\n\n.fa-award:before {\n  content: \"\\f559\"; }\n\n.fa-aws:before {\n  content: \"\\f375\"; }\n\n.fa-baby:before {\n  content: \"\\f77c\"; }\n\n.fa-baby-carriage:before {\n  content: \"\\f77d\"; }\n\n.fa-backspace:before {\n  content: \"\\f55a\"; }\n\n.fa-backward:before {\n  content: \"\\f04a\"; }\n\n.fa-bacon:before {\n  content: \"\\f7e5\"; }\n\n.fa-bahai:before {\n  content: \"\\f666\"; }\n\n.fa-balance-scale:before {\n  content: \"\\f24e\"; }\n\n.fa-balance-scale-left:before {\n  content: \"\\f515\"; }\n\n.fa-balance-scale-right:before {\n  content: \"\\f516\"; }\n\n.fa-ban:before {\n  content: \"\\f05e\"; }\n\n.fa-band-aid:before {\n  content: \"\\f462\"; }\n\n.fa-bandcamp:before {\n  content: \"\\f2d5\"; }\n\n.fa-barcode:before {\n  content: \"\\f02a\"; }\n\n.fa-bars:before {\n  content: \"\\f0c9\"; }\n\n.fa-baseball-ball:before {\n  content: \"\\f433\"; }\n\n.fa-basketball-ball:before {\n  content: \"\\f434\"; }\n\n.fa-bath:before {\n  content: \"\\f2cd\"; }\n\n.fa-battery-empty:before {\n  content: \"\\f244\"; }\n\n.fa-battery-full:before {\n  content: \"\\f240\"; }\n\n.fa-battery-half:before {\n  content: \"\\f242\"; }\n\n.fa-battery-quarter:before {\n  content: \"\\f243\"; }\n\n.fa-battery-three-quarters:before {\n  content: \"\\f241\"; }\n\n.fa-battle-net:before {\n  content: \"\\f835\"; }\n\n.fa-bed:before {\n  content: \"\\f236\"; }\n\n.fa-beer:before {\n  content: \"\\f0fc\"; }\n\n.fa-behance:before {\n  content: \"\\f1b4\"; }\n\n.fa-behance-square:before {\n  content: \"\\f1b5\"; }\n\n.fa-bell:before {\n  content: \"\\f0f3\"; }\n\n.fa-bell-slash:before {\n  content: \"\\f1f6\"; }\n\n.fa-bezier-curve:before {\n  content: \"\\f55b\"; }\n\n.fa-bible:before {\n  content: \"\\f647\"; }\n\n.fa-bicycle:before {\n  content: \"\\f206\"; }\n\n.fa-biking:before {\n  content: \"\\f84a\"; }\n\n.fa-bimobject:before {\n  content: \"\\f378\"; }\n\n.fa-binoculars:before {\n  content: \"\\f1e5\"; }\n\n.fa-biohazard:before {\n  content: \"\\f780\"; }\n\n.fa-birthday-cake:before {\n  content: \"\\f1fd\"; }\n\n.fa-bitbucket:before {\n  content: \"\\f171\"; }\n\n.fa-bitcoin:before {\n  content: \"\\f379\"; }\n\n.fa-bity:before {\n  content: \"\\f37a\"; }\n\n.fa-black-tie:before {\n  content: \"\\f27e\"; }\n\n.fa-blackberry:before {\n  content: \"\\f37b\"; }\n\n.fa-blender:before {\n  content: \"\\f517\"; }\n\n.fa-blender-phone:before {\n  content: \"\\f6b6\"; }\n\n.fa-blind:before {\n  content: \"\\f29d\"; }\n\n.fa-blog:before {\n  content: \"\\f781\"; }\n\n.fa-blogger:before {\n  content: \"\\f37c\"; }\n\n.fa-blogger-b:before {\n  content: \"\\f37d\"; }\n\n.fa-bluetooth:before {\n  content: \"\\f293\"; }\n\n.fa-bluetooth-b:before {\n  content: \"\\f294\"; }\n\n.fa-bold:before {\n  content: \"\\f032\"; }\n\n.fa-bolt:before {\n  content: \"\\f0e7\"; }\n\n.fa-bomb:before {\n  content: \"\\f1e2\"; }\n\n.fa-bone:before {\n  content: \"\\f5d7\"; }\n\n.fa-bong:before {\n  content: \"\\f55c\"; }\n\n.fa-book:before {\n  content: \"\\f02d\"; }\n\n.fa-book-dead:before {\n  content: \"\\f6b7\"; }\n\n.fa-book-medical:before {\n  content: \"\\f7e6\"; }\n\n.fa-book-open:before {\n  content: \"\\f518\"; }\n\n.fa-book-reader:before {\n  content: \"\\f5da\"; }\n\n.fa-bookmark:before {\n  content: \"\\f02e\"; }\n\n.fa-bootstrap:before {\n  content: \"\\f836\"; }\n\n.fa-border-all:before {\n  content: \"\\f84c\"; }\n\n.fa-border-none:before {\n  content: \"\\f850\"; }\n\n.fa-border-style:before {\n  content: \"\\f853\"; }\n\n.fa-bowling-ball:before {\n  content: \"\\f436\"; }\n\n.fa-box:before {\n  content: \"\\f466\"; }\n\n.fa-box-open:before {\n  content: \"\\f49e\"; }\n\n.fa-box-tissue:before {\n  content: \"\\f95b\"; }\n\n.fa-boxes:before {\n  content: \"\\f468\"; }\n\n.fa-braille:before {\n  content: \"\\f2a1\"; }\n\n.fa-brain:before {\n  content: \"\\f5dc\"; }\n\n.fa-bread-slice:before {\n  content: \"\\f7ec\"; }\n\n.fa-briefcase:before {\n  content: \"\\f0b1\"; }\n\n.fa-briefcase-medical:before {\n  content: \"\\f469\"; }\n\n.fa-broadcast-tower:before {\n  content: \"\\f519\"; }\n\n.fa-broom:before {\n  content: \"\\f51a\"; }\n\n.fa-brush:before {\n  content: \"\\f55d\"; }\n\n.fa-btc:before {\n  content: \"\\f15a\"; }\n\n.fa-buffer:before {\n  content: \"\\f837\"; }\n\n.fa-bug:before {\n  content: \"\\f188\"; }\n\n.fa-building:before {\n  content: \"\\f1ad\"; }\n\n.fa-bullhorn:before {\n  content: \"\\f0a1\"; }\n\n.fa-bullseye:before {\n  content: \"\\f140\"; }\n\n.fa-burn:before {\n  content: \"\\f46a\"; }\n\n.fa-buromobelexperte:before {\n  content: \"\\f37f\"; }\n\n.fa-bus:before {\n  content: \"\\f207\"; }\n\n.fa-bus-alt:before {\n  content: \"\\f55e\"; }\n\n.fa-business-time:before {\n  content: \"\\f64a\"; }\n\n.fa-buy-n-large:before {\n  content: \"\\f8a6\"; }\n\n.fa-buysellads:before {\n  content: \"\\f20d\"; }\n\n.fa-calculator:before {\n  content: \"\\f1ec\"; }\n\n.fa-calendar:before {\n  content: \"\\f133\"; }\n\n.fa-calendar-alt:before {\n  content: \"\\f073\"; }\n\n.fa-calendar-check:before {\n  content: \"\\f274\"; }\n\n.fa-calendar-day:before {\n  content: \"\\f783\"; }\n\n.fa-calendar-minus:before {\n  content: \"\\f272\"; }\n\n.fa-calendar-plus:before {\n  content: \"\\f271\"; }\n\n.fa-calendar-times:before {\n  content: \"\\f273\"; }\n\n.fa-calendar-week:before {\n  content: \"\\f784\"; }\n\n.fa-camera:before {\n  content: \"\\f030\"; }\n\n.fa-camera-retro:before {\n  content: \"\\f083\"; }\n\n.fa-campground:before {\n  content: \"\\f6bb\"; }\n\n.fa-canadian-maple-leaf:before {\n  content: \"\\f785\"; }\n\n.fa-candy-cane:before {\n  content: \"\\f786\"; }\n\n.fa-cannabis:before {\n  content: \"\\f55f\"; }\n\n.fa-capsules:before {\n  content: \"\\f46b\"; }\n\n.fa-car:before {\n  content: \"\\f1b9\"; }\n\n.fa-car-alt:before {\n  content: \"\\f5de\"; }\n\n.fa-car-battery:before {\n  content: \"\\f5df\"; }\n\n.fa-car-crash:before {\n  content: \"\\f5e1\"; }\n\n.fa-car-side:before {\n  content: \"\\f5e4\"; }\n\n.fa-caravan:before {\n  content: \"\\f8ff\"; }\n\n.fa-caret-down:before {\n  content: \"\\f0d7\"; }\n\n.fa-caret-left:before {\n  content: \"\\f0d9\"; }\n\n.fa-caret-right:before {\n  content: \"\\f0da\"; }\n\n.fa-caret-square-down:before {\n  content: \"\\f150\"; }\n\n.fa-caret-square-left:before {\n  content: \"\\f191\"; }\n\n.fa-caret-square-right:before {\n  content: \"\\f152\"; }\n\n.fa-caret-square-up:before {\n  content: \"\\f151\"; }\n\n.fa-caret-up:before {\n  content: \"\\f0d8\"; }\n\n.fa-carrot:before {\n  content: \"\\f787\"; }\n\n.fa-cart-arrow-down:before {\n  content: \"\\f218\"; }\n\n.fa-cart-plus:before {\n  content: \"\\f217\"; }\n\n.fa-cash-register:before {\n  content: \"\\f788\"; }\n\n.fa-cat:before {\n  content: \"\\f6be\"; }\n\n.fa-cc-amazon-pay:before {\n  content: \"\\f42d\"; }\n\n.fa-cc-amex:before {\n  content: \"\\f1f3\"; }\n\n.fa-cc-apple-pay:before {\n  content: \"\\f416\"; }\n\n.fa-cc-diners-club:before {\n  content: \"\\f24c\"; }\n\n.fa-cc-discover:before {\n  content: \"\\f1f2\"; }\n\n.fa-cc-jcb:before {\n  content: \"\\f24b\"; }\n\n.fa-cc-mastercard:before {\n  content: \"\\f1f1\"; }\n\n.fa-cc-paypal:before {\n  content: \"\\f1f4\"; }\n\n.fa-cc-stripe:before {\n  content: \"\\f1f5\"; }\n\n.fa-cc-visa:before {\n  content: \"\\f1f0\"; }\n\n.fa-centercode:before {\n  content: \"\\f380\"; }\n\n.fa-centos:before {\n  content: \"\\f789\"; }\n\n.fa-certificate:before {\n  content: \"\\f0a3\"; }\n\n.fa-chair:before {\n  content: \"\\f6c0\"; }\n\n.fa-chalkboard:before {\n  content: \"\\f51b\"; }\n\n.fa-chalkboard-teacher:before {\n  content: \"\\f51c\"; }\n\n.fa-charging-station:before {\n  content: \"\\f5e7\"; }\n\n.fa-chart-area:before {\n  content: \"\\f1fe\"; }\n\n.fa-chart-bar:before {\n  content: \"\\f080\"; }\n\n.fa-chart-line:before {\n  content: \"\\f201\"; }\n\n.fa-chart-pie:before {\n  content: \"\\f200\"; }\n\n.fa-check:before {\n  content: \"\\f00c\"; }\n\n.fa-check-circle:before {\n  content: \"\\f058\"; }\n\n.fa-check-double:before {\n  content: \"\\f560\"; }\n\n.fa-check-square:before {\n  content: \"\\f14a\"; }\n\n.fa-cheese:before {\n  content: \"\\f7ef\"; }\n\n.fa-chess:before {\n  content: \"\\f439\"; }\n\n.fa-chess-bishop:before {\n  content: \"\\f43a\"; }\n\n.fa-chess-board:before {\n  content: \"\\f43c\"; }\n\n.fa-chess-king:before {\n  content: \"\\f43f\"; }\n\n.fa-chess-knight:before {\n  content: \"\\f441\"; }\n\n.fa-chess-pawn:before {\n  content: \"\\f443\"; }\n\n.fa-chess-queen:before {\n  content: \"\\f445\"; }\n\n.fa-chess-rook:before {\n  content: \"\\f447\"; }\n\n.fa-chevron-circle-down:before {\n  content: \"\\f13a\"; }\n\n.fa-chevron-circle-left:before {\n  content: \"\\f137\"; }\n\n.fa-chevron-circle-right:before {\n  content: \"\\f138\"; }\n\n.fa-chevron-circle-up:before {\n  content: \"\\f139\"; }\n\n.fa-chevron-down:before {\n  content: \"\\f078\"; }\n\n.fa-chevron-left:before {\n  content: \"\\f053\"; }\n\n.fa-chevron-right:before {\n  content: \"\\f054\"; }\n\n.fa-chevron-up:before {\n  content: \"\\f077\"; }\n\n.fa-child:before {\n  content: \"\\f1ae\"; }\n\n.fa-chrome:before {\n  content: \"\\f268\"; }\n\n.fa-chromecast:before {\n  content: \"\\f838\"; }\n\n.fa-church:before {\n  content: \"\\f51d\"; }\n\n.fa-circle:before {\n  content: \"\\f111\"; }\n\n.fa-circle-notch:before {\n  content: \"\\f1ce\"; }\n\n.fa-city:before {\n  content: \"\\f64f\"; }\n\n.fa-clinic-medical:before {\n  content: \"\\f7f2\"; }\n\n.fa-clipboard:before {\n  content: \"\\f328\"; }\n\n.fa-clipboard-check:before {\n  content: \"\\f46c\"; }\n\n.fa-clipboard-list:before {\n  content: \"\\f46d\"; }\n\n.fa-clock:before {\n  content: \"\\f017\"; }\n\n.fa-clone:before {\n  content: \"\\f24d\"; }\n\n.fa-closed-captioning:before {\n  content: \"\\f20a\"; }\n\n.fa-cloud:before {\n  content: \"\\f0c2\"; }\n\n.fa-cloud-download-alt:before {\n  content: \"\\f381\"; }\n\n.fa-cloud-meatball:before {\n  content: \"\\f73b\"; }\n\n.fa-cloud-moon:before {\n  content: \"\\f6c3\"; }\n\n.fa-cloud-moon-rain:before {\n  content: \"\\f73c\"; }\n\n.fa-cloud-rain:before {\n  content: \"\\f73d\"; }\n\n.fa-cloud-showers-heavy:before {\n  content: \"\\f740\"; }\n\n.fa-cloud-sun:before {\n  content: \"\\f6c4\"; }\n\n.fa-cloud-sun-rain:before {\n  content: \"\\f743\"; }\n\n.fa-cloud-upload-alt:before {\n  content: \"\\f382\"; }\n\n.fa-cloudscale:before {\n  content: \"\\f383\"; }\n\n.fa-cloudsmith:before {\n  content: \"\\f384\"; }\n\n.fa-cloudversify:before {\n  content: \"\\f385\"; }\n\n.fa-cocktail:before {\n  content: \"\\f561\"; }\n\n.fa-code:before {\n  content: \"\\f121\"; }\n\n.fa-code-branch:before {\n  content: \"\\f126\"; }\n\n.fa-codepen:before {\n  content: \"\\f1cb\"; }\n\n.fa-codiepie:before {\n  content: \"\\f284\"; }\n\n.fa-coffee:before {\n  content: \"\\f0f4\"; }\n\n.fa-cog:before {\n  content: \"\\f013\"; }\n\n.fa-cogs:before {\n  content: \"\\f085\"; }\n\n.fa-coins:before {\n  content: \"\\f51e\"; }\n\n.fa-columns:before {\n  content: \"\\f0db\"; }\n\n.fa-comment:before {\n  content: \"\\f075\"; }\n\n.fa-comment-alt:before {\n  content: \"\\f27a\"; }\n\n.fa-comment-dollar:before {\n  content: \"\\f651\"; }\n\n.fa-comment-dots:before {\n  content: \"\\f4ad\"; }\n\n.fa-comment-medical:before {\n  content: \"\\f7f5\"; }\n\n.fa-comment-slash:before {\n  content: \"\\f4b3\"; }\n\n.fa-comments:before {\n  content: \"\\f086\"; }\n\n.fa-comments-dollar:before {\n  content: \"\\f653\"; }\n\n.fa-compact-disc:before {\n  content: \"\\f51f\"; }\n\n.fa-compass:before {\n  content: \"\\f14e\"; }\n\n.fa-compress:before {\n  content: \"\\f066\"; }\n\n.fa-compress-alt:before {\n  content: \"\\f422\"; }\n\n.fa-compress-arrows-alt:before {\n  content: \"\\f78c\"; }\n\n.fa-concierge-bell:before {\n  content: \"\\f562\"; }\n\n.fa-confluence:before {\n  content: \"\\f78d\"; }\n\n.fa-connectdevelop:before {\n  content: \"\\f20e\"; }\n\n.fa-contao:before {\n  content: \"\\f26d\"; }\n\n.fa-cookie:before {\n  content: \"\\f563\"; }\n\n.fa-cookie-bite:before {\n  content: \"\\f564\"; }\n\n.fa-copy:before {\n  content: \"\\f0c5\"; }\n\n.fa-copyright:before {\n  content: \"\\f1f9\"; }\n\n.fa-cotton-bureau:before {\n  content: \"\\f89e\"; }\n\n.fa-couch:before {\n  content: \"\\f4b8\"; }\n\n.fa-cpanel:before {\n  content: \"\\f388\"; }\n\n.fa-creative-commons:before {\n  content: \"\\f25e\"; }\n\n.fa-creative-commons-by:before {\n  content: \"\\f4e7\"; }\n\n.fa-creative-commons-nc:before {\n  content: \"\\f4e8\"; }\n\n.fa-creative-commons-nc-eu:before {\n  content: \"\\f4e9\"; }\n\n.fa-creative-commons-nc-jp:before {\n  content: \"\\f4ea\"; }\n\n.fa-creative-commons-nd:before {\n  content: \"\\f4eb\"; }\n\n.fa-creative-commons-pd:before {\n  content: \"\\f4ec\"; }\n\n.fa-creative-commons-pd-alt:before {\n  content: \"\\f4ed\"; }\n\n.fa-creative-commons-remix:before {\n  content: \"\\f4ee\"; }\n\n.fa-creative-commons-sa:before {\n  content: \"\\f4ef\"; }\n\n.fa-creative-commons-sampling:before {\n  content: \"\\f4f0\"; }\n\n.fa-creative-commons-sampling-plus:before {\n  content: \"\\f4f1\"; }\n\n.fa-creative-commons-share:before {\n  content: \"\\f4f2\"; }\n\n.fa-creative-commons-zero:before {\n  content: \"\\f4f3\"; }\n\n.fa-credit-card:before {\n  content: \"\\f09d\"; }\n\n.fa-critical-role:before {\n  content: \"\\f6c9\"; }\n\n.fa-crop:before {\n  content: \"\\f125\"; }\n\n.fa-crop-alt:before {\n  content: \"\\f565\"; }\n\n.fa-cross:before {\n  content: \"\\f654\"; }\n\n.fa-crosshairs:before {\n  content: \"\\f05b\"; }\n\n.fa-crow:before {\n  content: \"\\f520\"; }\n\n.fa-crown:before {\n  content: \"\\f521\"; }\n\n.fa-crutch:before {\n  content: \"\\f7f7\"; }\n\n.fa-css3:before {\n  content: \"\\f13c\"; }\n\n.fa-css3-alt:before {\n  content: \"\\f38b\"; }\n\n.fa-cube:before {\n  content: \"\\f1b2\"; }\n\n.fa-cubes:before {\n  content: \"\\f1b3\"; }\n\n.fa-cut:before {\n  content: \"\\f0c4\"; }\n\n.fa-cuttlefish:before {\n  content: \"\\f38c\"; }\n\n.fa-d-and-d:before {\n  content: \"\\f38d\"; }\n\n.fa-d-and-d-beyond:before {\n  content: \"\\f6ca\"; }\n\n.fa-dailymotion:before {\n  content: \"\\f952\"; }\n\n.fa-dashcube:before {\n  content: \"\\f210\"; }\n\n.fa-database:before {\n  content: \"\\f1c0\"; }\n\n.fa-deaf:before {\n  content: \"\\f2a4\"; }\n\n.fa-delicious:before {\n  content: \"\\f1a5\"; }\n\n.fa-democrat:before {\n  content: \"\\f747\"; }\n\n.fa-deploydog:before {\n  content: \"\\f38e\"; }\n\n.fa-deskpro:before {\n  content: \"\\f38f\"; }\n\n.fa-desktop:before {\n  content: \"\\f108\"; }\n\n.fa-dev:before {\n  content: \"\\f6cc\"; }\n\n.fa-deviantart:before {\n  content: \"\\f1bd\"; }\n\n.fa-dharmachakra:before {\n  content: \"\\f655\"; }\n\n.fa-dhl:before {\n  content: \"\\f790\"; }\n\n.fa-diagnoses:before {\n  content: \"\\f470\"; }\n\n.fa-diaspora:before {\n  content: \"\\f791\"; }\n\n.fa-dice:before {\n  content: \"\\f522\"; }\n\n.fa-dice-d20:before {\n  content: \"\\f6cf\"; }\n\n.fa-dice-d6:before {\n  content: \"\\f6d1\"; }\n\n.fa-dice-five:before {\n  content: \"\\f523\"; }\n\n.fa-dice-four:before {\n  content: \"\\f524\"; }\n\n.fa-dice-one:before {\n  content: \"\\f525\"; }\n\n.fa-dice-six:before {\n  content: \"\\f526\"; }\n\n.fa-dice-three:before {\n  content: \"\\f527\"; }\n\n.fa-dice-two:before {\n  content: \"\\f528\"; }\n\n.fa-digg:before {\n  content: \"\\f1a6\"; }\n\n.fa-digital-ocean:before {\n  content: \"\\f391\"; }\n\n.fa-digital-tachograph:before {\n  content: \"\\f566\"; }\n\n.fa-directions:before {\n  content: \"\\f5eb\"; }\n\n.fa-discord:before {\n  content: \"\\f392\"; }\n\n.fa-discourse:before {\n  content: \"\\f393\"; }\n\n.fa-disease:before {\n  content: \"\\f7fa\"; }\n\n.fa-divide:before {\n  content: \"\\f529\"; }\n\n.fa-dizzy:before {\n  content: \"\\f567\"; }\n\n.fa-dna:before {\n  content: \"\\f471\"; }\n\n.fa-dochub:before {\n  content: \"\\f394\"; }\n\n.fa-docker:before {\n  content: \"\\f395\"; }\n\n.fa-dog:before {\n  content: \"\\f6d3\"; }\n\n.fa-dollar-sign:before {\n  content: \"\\f155\"; }\n\n.fa-dolly:before {\n  content: \"\\f472\"; }\n\n.fa-dolly-flatbed:before {\n  content: \"\\f474\"; }\n\n.fa-donate:before {\n  content: \"\\f4b9\"; }\n\n.fa-door-closed:before {\n  content: \"\\f52a\"; }\n\n.fa-door-open:before {\n  content: \"\\f52b\"; }\n\n.fa-dot-circle:before {\n  content: \"\\f192\"; }\n\n.fa-dove:before {\n  content: \"\\f4ba\"; }\n\n.fa-download:before {\n  content: \"\\f019\"; }\n\n.fa-draft2digital:before {\n  content: \"\\f396\"; }\n\n.fa-drafting-compass:before {\n  content: \"\\f568\"; }\n\n.fa-dragon:before {\n  content: \"\\f6d5\"; }\n\n.fa-draw-polygon:before {\n  content: \"\\f5ee\"; }\n\n.fa-dribbble:before {\n  content: \"\\f17d\"; }\n\n.fa-dribbble-square:before {\n  content: \"\\f397\"; }\n\n.fa-dropbox:before {\n  content: \"\\f16b\"; }\n\n.fa-drum:before {\n  content: \"\\f569\"; }\n\n.fa-drum-steelpan:before {\n  content: \"\\f56a\"; }\n\n.fa-drumstick-bite:before {\n  content: \"\\f6d7\"; }\n\n.fa-drupal:before {\n  content: \"\\f1a9\"; }\n\n.fa-dumbbell:before {\n  content: \"\\f44b\"; }\n\n.fa-dumpster:before {\n  content: \"\\f793\"; }\n\n.fa-dumpster-fire:before {\n  content: \"\\f794\"; }\n\n.fa-dungeon:before {\n  content: \"\\f6d9\"; }\n\n.fa-dyalog:before {\n  content: \"\\f399\"; }\n\n.fa-earlybirds:before {\n  content: \"\\f39a\"; }\n\n.fa-ebay:before {\n  content: \"\\f4f4\"; }\n\n.fa-edge:before {\n  content: \"\\f282\"; }\n\n.fa-edit:before {\n  content: \"\\f044\"; }\n\n.fa-egg:before {\n  content: \"\\f7fb\"; }\n\n.fa-eject:before {\n  content: \"\\f052\"; }\n\n.fa-elementor:before {\n  content: \"\\f430\"; }\n\n.fa-ellipsis-h:before {\n  content: \"\\f141\"; }\n\n.fa-ellipsis-v:before {\n  content: \"\\f142\"; }\n\n.fa-ello:before {\n  content: \"\\f5f1\"; }\n\n.fa-ember:before {\n  content: \"\\f423\"; }\n\n.fa-empire:before {\n  content: \"\\f1d1\"; }\n\n.fa-envelope:before {\n  content: \"\\f0e0\"; }\n\n.fa-envelope-open:before {\n  content: \"\\f2b6\"; }\n\n.fa-envelope-open-text:before {\n  content: \"\\f658\"; }\n\n.fa-envelope-square:before {\n  content: \"\\f199\"; }\n\n.fa-envira:before {\n  content: \"\\f299\"; }\n\n.fa-equals:before {\n  content: \"\\f52c\"; }\n\n.fa-eraser:before {\n  content: \"\\f12d\"; }\n\n.fa-erlang:before {\n  content: \"\\f39d\"; }\n\n.fa-ethereum:before {\n  content: \"\\f42e\"; }\n\n.fa-ethernet:before {\n  content: \"\\f796\"; }\n\n.fa-etsy:before {\n  content: \"\\f2d7\"; }\n\n.fa-euro-sign:before {\n  content: \"\\f153\"; }\n\n.fa-evernote:before {\n  content: \"\\f839\"; }\n\n.fa-exchange-alt:before {\n  content: \"\\f362\"; }\n\n.fa-exclamation:before {\n  content: \"\\f12a\"; }\n\n.fa-exclamation-circle:before {\n  content: \"\\f06a\"; }\n\n.fa-exclamation-triangle:before {\n  content: \"\\f071\"; }\n\n.fa-expand:before {\n  content: \"\\f065\"; }\n\n.fa-expand-alt:before {\n  content: \"\\f424\"; }\n\n.fa-expand-arrows-alt:before {\n  content: \"\\f31e\"; }\n\n.fa-expeditedssl:before {\n  content: \"\\f23e\"; }\n\n.fa-external-link-alt:before {\n  content: \"\\f35d\"; }\n\n.fa-external-link-square-alt:before {\n  content: \"\\f360\"; }\n\n.fa-eye:before {\n  content: \"\\f06e\"; }\n\n.fa-eye-dropper:before {\n  content: \"\\f1fb\"; }\n\n.fa-eye-slash:before {\n  content: \"\\f070\"; }\n\n.fa-facebook:before {\n  content: \"\\f09a\"; }\n\n.fa-facebook-f:before {\n  content: \"\\f39e\"; }\n\n.fa-facebook-messenger:before {\n  content: \"\\f39f\"; }\n\n.fa-facebook-square:before {\n  content: \"\\f082\"; }\n\n.fa-fan:before {\n  content: \"\\f863\"; }\n\n.fa-fantasy-flight-games:before {\n  content: \"\\f6dc\"; }\n\n.fa-fast-backward:before {\n  content: \"\\f049\"; }\n\n.fa-fast-forward:before {\n  content: \"\\f050\"; }\n\n.fa-faucet:before {\n  content: \"\\f905\"; }\n\n.fa-fax:before {\n  content: \"\\f1ac\"; }\n\n.fa-feather:before {\n  content: \"\\f52d\"; }\n\n.fa-feather-alt:before {\n  content: \"\\f56b\"; }\n\n.fa-fedex:before {\n  content: \"\\f797\"; }\n\n.fa-fedora:before {\n  content: \"\\f798\"; }\n\n.fa-female:before {\n  content: \"\\f182\"; }\n\n.fa-fighter-jet:before {\n  content: \"\\f0fb\"; }\n\n.fa-figma:before {\n  content: \"\\f799\"; }\n\n.fa-file:before {\n  content: \"\\f15b\"; }\n\n.fa-file-alt:before {\n  content: \"\\f15c\"; }\n\n.fa-file-archive:before {\n  content: \"\\f1c6\"; }\n\n.fa-file-audio:before {\n  content: \"\\f1c7\"; }\n\n.fa-file-code:before {\n  content: \"\\f1c9\"; }\n\n.fa-file-contract:before {\n  content: \"\\f56c\"; }\n\n.fa-file-csv:before {\n  content: \"\\f6dd\"; }\n\n.fa-file-download:before {\n  content: \"\\f56d\"; }\n\n.fa-file-excel:before {\n  content: \"\\f1c3\"; }\n\n.fa-file-export:before {\n  content: \"\\f56e\"; }\n\n.fa-file-image:before {\n  content: \"\\f1c5\"; }\n\n.fa-file-import:before {\n  content: \"\\f56f\"; }\n\n.fa-file-invoice:before {\n  content: \"\\f570\"; }\n\n.fa-file-invoice-dollar:before {\n  content: \"\\f571\"; }\n\n.fa-file-medical:before {\n  content: \"\\f477\"; }\n\n.fa-file-medical-alt:before {\n  content: \"\\f478\"; }\n\n.fa-file-pdf:before {\n  content: \"\\f1c1\"; }\n\n.fa-file-powerpoint:before {\n  content: \"\\f1c4\"; }\n\n.fa-file-prescription:before {\n  content: \"\\f572\"; }\n\n.fa-file-signature:before {\n  content: \"\\f573\"; }\n\n.fa-file-upload:before {\n  content: \"\\f574\"; }\n\n.fa-file-video:before {\n  content: \"\\f1c8\"; }\n\n.fa-file-word:before {\n  content: \"\\f1c2\"; }\n\n.fa-fill:before {\n  content: \"\\f575\"; }\n\n.fa-fill-drip:before {\n  content: \"\\f576\"; }\n\n.fa-film:before {\n  content: \"\\f008\"; }\n\n.fa-filter:before {\n  content: \"\\f0b0\"; }\n\n.fa-fingerprint:before {\n  content: \"\\f577\"; }\n\n.fa-fire:before {\n  content: \"\\f06d\"; }\n\n.fa-fire-alt:before {\n  content: \"\\f7e4\"; }\n\n.fa-fire-extinguisher:before {\n  content: \"\\f134\"; }\n\n.fa-firefox:before {\n  content: \"\\f269\"; }\n\n.fa-firefox-browser:before {\n  content: \"\\f907\"; }\n\n.fa-first-aid:before {\n  content: \"\\f479\"; }\n\n.fa-first-order:before {\n  content: \"\\f2b0\"; }\n\n.fa-first-order-alt:before {\n  content: \"\\f50a\"; }\n\n.fa-firstdraft:before {\n  content: \"\\f3a1\"; }\n\n.fa-fish:before {\n  content: \"\\f578\"; }\n\n.fa-fist-raised:before {\n  content: \"\\f6de\"; }\n\n.fa-flag:before {\n  content: \"\\f024\"; }\n\n.fa-flag-checkered:before {\n  content: \"\\f11e\"; }\n\n.fa-flag-usa:before {\n  content: \"\\f74d\"; }\n\n.fa-flask:before {\n  content: \"\\f0c3\"; }\n\n.fa-flickr:before {\n  content: \"\\f16e\"; }\n\n.fa-flipboard:before {\n  content: \"\\f44d\"; }\n\n.fa-flushed:before {\n  content: \"\\f579\"; }\n\n.fa-fly:before {\n  content: \"\\f417\"; }\n\n.fa-folder:before {\n  content: \"\\f07b\"; }\n\n.fa-folder-minus:before {\n  content: \"\\f65d\"; }\n\n.fa-folder-open:before {\n  content: \"\\f07c\"; }\n\n.fa-folder-plus:before {\n  content: \"\\f65e\"; }\n\n.fa-font:before {\n  content: \"\\f031\"; }\n\n.fa-font-awesome:before {\n  content: \"\\f2b4\"; }\n\n.fa-font-awesome-alt:before {\n  content: \"\\f35c\"; }\n\n.fa-font-awesome-flag:before {\n  content: \"\\f425\"; }\n\n.fa-font-awesome-logo-full:before {\n  content: \"\\f4e6\"; }\n\n.fa-fonticons:before {\n  content: \"\\f280\"; }\n\n.fa-fonticons-fi:before {\n  content: \"\\f3a2\"; }\n\n.fa-football-ball:before {\n  content: \"\\f44e\"; }\n\n.fa-fort-awesome:before {\n  content: \"\\f286\"; }\n\n.fa-fort-awesome-alt:before {\n  content: \"\\f3a3\"; }\n\n.fa-forumbee:before {\n  content: \"\\f211\"; }\n\n.fa-forward:before {\n  content: \"\\f04e\"; }\n\n.fa-foursquare:before {\n  content: \"\\f180\"; }\n\n.fa-free-code-camp:before {\n  content: \"\\f2c5\"; }\n\n.fa-freebsd:before {\n  content: \"\\f3a4\"; }\n\n.fa-frog:before {\n  content: \"\\f52e\"; }\n\n.fa-frown:before {\n  content: \"\\f119\"; }\n\n.fa-frown-open:before {\n  content: \"\\f57a\"; }\n\n.fa-fulcrum:before {\n  content: \"\\f50b\"; }\n\n.fa-funnel-dollar:before {\n  content: \"\\f662\"; }\n\n.fa-futbol:before {\n  content: \"\\f1e3\"; }\n\n.fa-galactic-republic:before {\n  content: \"\\f50c\"; }\n\n.fa-galactic-senate:before {\n  content: \"\\f50d\"; }\n\n.fa-gamepad:before {\n  content: \"\\f11b\"; }\n\n.fa-gas-pump:before {\n  content: \"\\f52f\"; }\n\n.fa-gavel:before {\n  content: \"\\f0e3\"; }\n\n.fa-gem:before {\n  content: \"\\f3a5\"; }\n\n.fa-genderless:before {\n  content: \"\\f22d\"; }\n\n.fa-get-pocket:before {\n  content: \"\\f265\"; }\n\n.fa-gg:before {\n  content: \"\\f260\"; }\n\n.fa-gg-circle:before {\n  content: \"\\f261\"; }\n\n.fa-ghost:before {\n  content: \"\\f6e2\"; }\n\n.fa-gift:before {\n  content: \"\\f06b\"; }\n\n.fa-gifts:before {\n  content: \"\\f79c\"; }\n\n.fa-git:before {\n  content: \"\\f1d3\"; }\n\n.fa-git-alt:before {\n  content: \"\\f841\"; }\n\n.fa-git-square:before {\n  content: \"\\f1d2\"; }\n\n.fa-github:before {\n  content: \"\\f09b\"; }\n\n.fa-github-alt:before {\n  content: \"\\f113\"; }\n\n.fa-github-square:before {\n  content: \"\\f092\"; }\n\n.fa-gitkraken:before {\n  content: \"\\f3a6\"; }\n\n.fa-gitlab:before {\n  content: \"\\f296\"; }\n\n.fa-gitter:before {\n  content: \"\\f426\"; }\n\n.fa-glass-cheers:before {\n  content: \"\\f79f\"; }\n\n.fa-glass-martini:before {\n  content: \"\\f000\"; }\n\n.fa-glass-martini-alt:before {\n  content: \"\\f57b\"; }\n\n.fa-glass-whiskey:before {\n  content: \"\\f7a0\"; }\n\n.fa-glasses:before {\n  content: \"\\f530\"; }\n\n.fa-glide:before {\n  content: \"\\f2a5\"; }\n\n.fa-glide-g:before {\n  content: \"\\f2a6\"; }\n\n.fa-globe:before {\n  content: \"\\f0ac\"; }\n\n.fa-globe-africa:before {\n  content: \"\\f57c\"; }\n\n.fa-globe-americas:before {\n  content: \"\\f57d\"; }\n\n.fa-globe-asia:before {\n  content: \"\\f57e\"; }\n\n.fa-globe-europe:before {\n  content: \"\\f7a2\"; }\n\n.fa-gofore:before {\n  content: \"\\f3a7\"; }\n\n.fa-golf-ball:before {\n  content: \"\\f450\"; }\n\n.fa-goodreads:before {\n  content: \"\\f3a8\"; }\n\n.fa-goodreads-g:before {\n  content: \"\\f3a9\"; }\n\n.fa-google:before {\n  content: \"\\f1a0\"; }\n\n.fa-google-drive:before {\n  content: \"\\f3aa\"; }\n\n.fa-google-play:before {\n  content: \"\\f3ab\"; }\n\n.fa-google-plus:before {\n  content: \"\\f2b3\"; }\n\n.fa-google-plus-g:before {\n  content: \"\\f0d5\"; }\n\n.fa-google-plus-square:before {\n  content: \"\\f0d4\"; }\n\n.fa-google-wallet:before {\n  content: \"\\f1ee\"; }\n\n.fa-gopuram:before {\n  content: \"\\f664\"; }\n\n.fa-graduation-cap:before {\n  content: \"\\f19d\"; }\n\n.fa-gratipay:before {\n  content: \"\\f184\"; }\n\n.fa-grav:before {\n  content: \"\\f2d6\"; }\n\n.fa-greater-than:before {\n  content: \"\\f531\"; }\n\n.fa-greater-than-equal:before {\n  content: \"\\f532\"; }\n\n.fa-grimace:before {\n  content: \"\\f57f\"; }\n\n.fa-grin:before {\n  content: \"\\f580\"; }\n\n.fa-grin-alt:before {\n  content: \"\\f581\"; }\n\n.fa-grin-beam:before {\n  content: \"\\f582\"; }\n\n.fa-grin-beam-sweat:before {\n  content: \"\\f583\"; }\n\n.fa-grin-hearts:before {\n  content: \"\\f584\"; }\n\n.fa-grin-squint:before {\n  content: \"\\f585\"; }\n\n.fa-grin-squint-tears:before {\n  content: \"\\f586\"; }\n\n.fa-grin-stars:before {\n  content: \"\\f587\"; }\n\n.fa-grin-tears:before {\n  content: \"\\f588\"; }\n\n.fa-grin-tongue:before {\n  content: \"\\f589\"; }\n\n.fa-grin-tongue-squint:before {\n  content: \"\\f58a\"; }\n\n.fa-grin-tongue-wink:before {\n  content: \"\\f58b\"; }\n\n.fa-grin-wink:before {\n  content: \"\\f58c\"; }\n\n.fa-grip-horizontal:before {\n  content: \"\\f58d\"; }\n\n.fa-grip-lines:before {\n  content: \"\\f7a4\"; }\n\n.fa-grip-lines-vertical:before {\n  content: \"\\f7a5\"; }\n\n.fa-grip-vertical:before {\n  content: \"\\f58e\"; }\n\n.fa-gripfire:before {\n  content: \"\\f3ac\"; }\n\n.fa-grunt:before {\n  content: \"\\f3ad\"; }\n\n.fa-guitar:before {\n  content: \"\\f7a6\"; }\n\n.fa-gulp:before {\n  content: \"\\f3ae\"; }\n\n.fa-h-square:before {\n  content: \"\\f0fd\"; }\n\n.fa-hacker-news:before {\n  content: \"\\f1d4\"; }\n\n.fa-hacker-news-square:before {\n  content: \"\\f3af\"; }\n\n.fa-hackerrank:before {\n  content: \"\\f5f7\"; }\n\n.fa-hamburger:before {\n  content: \"\\f805\"; }\n\n.fa-hammer:before {\n  content: \"\\f6e3\"; }\n\n.fa-hamsa:before {\n  content: \"\\f665\"; }\n\n.fa-hand-holding:before {\n  content: \"\\f4bd\"; }\n\n.fa-hand-holding-heart:before {\n  content: \"\\f4be\"; }\n\n.fa-hand-holding-medical:before {\n  content: \"\\f95c\"; }\n\n.fa-hand-holding-usd:before {\n  content: \"\\f4c0\"; }\n\n.fa-hand-holding-water:before {\n  content: \"\\f4c1\"; }\n\n.fa-hand-lizard:before {\n  content: \"\\f258\"; }\n\n.fa-hand-middle-finger:before {\n  content: \"\\f806\"; }\n\n.fa-hand-paper:before {\n  content: \"\\f256\"; }\n\n.fa-hand-peace:before {\n  content: \"\\f25b\"; }\n\n.fa-hand-point-down:before {\n  content: \"\\f0a7\"; }\n\n.fa-hand-point-left:before {\n  content: \"\\f0a5\"; }\n\n.fa-hand-point-right:before {\n  content: \"\\f0a4\"; }\n\n.fa-hand-point-up:before {\n  content: \"\\f0a6\"; }\n\n.fa-hand-pointer:before {\n  content: \"\\f25a\"; }\n\n.fa-hand-rock:before {\n  content: \"\\f255\"; }\n\n.fa-hand-scissors:before {\n  content: \"\\f257\"; }\n\n.fa-hand-sparkles:before {\n  content: \"\\f95d\"; }\n\n.fa-hand-spock:before {\n  content: \"\\f259\"; }\n\n.fa-hands:before {\n  content: \"\\f4c2\"; }\n\n.fa-hands-helping:before {\n  content: \"\\f4c4\"; }\n\n.fa-hands-wash:before {\n  content: \"\\f95e\"; }\n\n.fa-handshake:before {\n  content: \"\\f2b5\"; }\n\n.fa-handshake-alt-slash:before {\n  content: \"\\f95f\"; }\n\n.fa-handshake-slash:before {\n  content: \"\\f960\"; }\n\n.fa-hanukiah:before {\n  content: \"\\f6e6\"; }\n\n.fa-hard-hat:before {\n  content: \"\\f807\"; }\n\n.fa-hashtag:before {\n  content: \"\\f292\"; }\n\n.fa-hat-cowboy:before {\n  content: \"\\f8c0\"; }\n\n.fa-hat-cowboy-side:before {\n  content: \"\\f8c1\"; }\n\n.fa-hat-wizard:before {\n  content: \"\\f6e8\"; }\n\n.fa-hdd:before {\n  content: \"\\f0a0\"; }\n\n.fa-head-side-cough:before {\n  content: \"\\f961\"; }\n\n.fa-head-side-cough-slash:before {\n  content: \"\\f962\"; }\n\n.fa-head-side-mask:before {\n  content: \"\\f963\"; }\n\n.fa-head-side-virus:before {\n  content: \"\\f964\"; }\n\n.fa-heading:before {\n  content: \"\\f1dc\"; }\n\n.fa-headphones:before {\n  content: \"\\f025\"; }\n\n.fa-headphones-alt:before {\n  content: \"\\f58f\"; }\n\n.fa-headset:before {\n  content: \"\\f590\"; }\n\n.fa-heart:before {\n  content: \"\\f004\"; }\n\n.fa-heart-broken:before {\n  content: \"\\f7a9\"; }\n\n.fa-heartbeat:before {\n  content: \"\\f21e\"; }\n\n.fa-helicopter:before {\n  content: \"\\f533\"; }\n\n.fa-highlighter:before {\n  content: \"\\f591\"; }\n\n.fa-hiking:before {\n  content: \"\\f6ec\"; }\n\n.fa-hippo:before {\n  content: \"\\f6ed\"; }\n\n.fa-hips:before {\n  content: \"\\f452\"; }\n\n.fa-hire-a-helper:before {\n  content: \"\\f3b0\"; }\n\n.fa-history:before {\n  content: \"\\f1da\"; }\n\n.fa-hockey-puck:before {\n  content: \"\\f453\"; }\n\n.fa-holly-berry:before {\n  content: \"\\f7aa\"; }\n\n.fa-home:before {\n  content: \"\\f015\"; }\n\n.fa-hooli:before {\n  content: \"\\f427\"; }\n\n.fa-hornbill:before {\n  content: \"\\f592\"; }\n\n.fa-horse:before {\n  content: \"\\f6f0\"; }\n\n.fa-horse-head:before {\n  content: \"\\f7ab\"; }\n\n.fa-hospital:before {\n  content: \"\\f0f8\"; }\n\n.fa-hospital-alt:before {\n  content: \"\\f47d\"; }\n\n.fa-hospital-symbol:before {\n  content: \"\\f47e\"; }\n\n.fa-hospital-user:before {\n  content: \"\\f80d\"; }\n\n.fa-hot-tub:before {\n  content: \"\\f593\"; }\n\n.fa-hotdog:before {\n  content: \"\\f80f\"; }\n\n.fa-hotel:before {\n  content: \"\\f594\"; }\n\n.fa-hotjar:before {\n  content: \"\\f3b1\"; }\n\n.fa-hourglass:before {\n  content: \"\\f254\"; }\n\n.fa-hourglass-end:before {\n  content: \"\\f253\"; }\n\n.fa-hourglass-half:before {\n  content: \"\\f252\"; }\n\n.fa-hourglass-start:before {\n  content: \"\\f251\"; }\n\n.fa-house-damage:before {\n  content: \"\\f6f1\"; }\n\n.fa-house-user:before {\n  content: \"\\f965\"; }\n\n.fa-houzz:before {\n  content: \"\\f27c\"; }\n\n.fa-hryvnia:before {\n  content: \"\\f6f2\"; }\n\n.fa-html5:before {\n  content: \"\\f13b\"; }\n\n.fa-hubspot:before {\n  content: \"\\f3b2\"; }\n\n.fa-i-cursor:before {\n  content: \"\\f246\"; }\n\n.fa-ice-cream:before {\n  content: \"\\f810\"; }\n\n.fa-icicles:before {\n  content: \"\\f7ad\"; }\n\n.fa-icons:before {\n  content: \"\\f86d\"; }\n\n.fa-id-badge:before {\n  content: \"\\f2c1\"; }\n\n.fa-id-card:before {\n  content: \"\\f2c2\"; }\n\n.fa-id-card-alt:before {\n  content: \"\\f47f\"; }\n\n.fa-ideal:before {\n  content: \"\\f913\"; }\n\n.fa-igloo:before {\n  content: \"\\f7ae\"; }\n\n.fa-image:before {\n  content: \"\\f03e\"; }\n\n.fa-images:before {\n  content: \"\\f302\"; }\n\n.fa-imdb:before {\n  content: \"\\f2d8\"; }\n\n.fa-inbox:before {\n  content: \"\\f01c\"; }\n\n.fa-indent:before {\n  content: \"\\f03c\"; }\n\n.fa-industry:before {\n  content: \"\\f275\"; }\n\n.fa-infinity:before {\n  content: \"\\f534\"; }\n\n.fa-info:before {\n  content: \"\\f129\"; }\n\n.fa-info-circle:before {\n  content: \"\\f05a\"; }\n\n.fa-instagram:before {\n  content: \"\\f16d\"; }\n\n.fa-instagram-square:before {\n  content: \"\\f955\"; }\n\n.fa-intercom:before {\n  content: \"\\f7af\"; }\n\n.fa-internet-explorer:before {\n  content: \"\\f26b\"; }\n\n.fa-invision:before {\n  content: \"\\f7b0\"; }\n\n.fa-ioxhost:before {\n  content: \"\\f208\"; }\n\n.fa-italic:before {\n  content: \"\\f033\"; }\n\n.fa-itch-io:before {\n  content: \"\\f83a\"; }\n\n.fa-itunes:before {\n  content: \"\\f3b4\"; }\n\n.fa-itunes-note:before {\n  content: \"\\f3b5\"; }\n\n.fa-java:before {\n  content: \"\\f4e4\"; }\n\n.fa-jedi:before {\n  content: \"\\f669\"; }\n\n.fa-jedi-order:before {\n  content: \"\\f50e\"; }\n\n.fa-jenkins:before {\n  content: \"\\f3b6\"; }\n\n.fa-jira:before {\n  content: \"\\f7b1\"; }\n\n.fa-joget:before {\n  content: \"\\f3b7\"; }\n\n.fa-joint:before {\n  content: \"\\f595\"; }\n\n.fa-joomla:before {\n  content: \"\\f1aa\"; }\n\n.fa-journal-whills:before {\n  content: \"\\f66a\"; }\n\n.fa-js:before {\n  content: \"\\f3b8\"; }\n\n.fa-js-square:before {\n  content: \"\\f3b9\"; }\n\n.fa-jsfiddle:before {\n  content: \"\\f1cc\"; }\n\n.fa-kaaba:before {\n  content: \"\\f66b\"; }\n\n.fa-kaggle:before {\n  content: \"\\f5fa\"; }\n\n.fa-key:before {\n  content: \"\\f084\"; }\n\n.fa-keybase:before {\n  content: \"\\f4f5\"; }\n\n.fa-keyboard:before {\n  content: \"\\f11c\"; }\n\n.fa-keycdn:before {\n  content: \"\\f3ba\"; }\n\n.fa-khanda:before {\n  content: \"\\f66d\"; }\n\n.fa-kickstarter:before {\n  content: \"\\f3bb\"; }\n\n.fa-kickstarter-k:before {\n  content: \"\\f3bc\"; }\n\n.fa-kiss:before {\n  content: \"\\f596\"; }\n\n.fa-kiss-beam:before {\n  content: \"\\f597\"; }\n\n.fa-kiss-wink-heart:before {\n  content: \"\\f598\"; }\n\n.fa-kiwi-bird:before {\n  content: \"\\f535\"; }\n\n.fa-korvue:before {\n  content: \"\\f42f\"; }\n\n.fa-landmark:before {\n  content: \"\\f66f\"; }\n\n.fa-language:before {\n  content: \"\\f1ab\"; }\n\n.fa-laptop:before {\n  content: \"\\f109\"; }\n\n.fa-laptop-code:before {\n  content: \"\\f5fc\"; }\n\n.fa-laptop-house:before {\n  content: \"\\f966\"; }\n\n.fa-laptop-medical:before {\n  content: \"\\f812\"; }\n\n.fa-laravel:before {\n  content: \"\\f3bd\"; }\n\n.fa-lastfm:before {\n  content: \"\\f202\"; }\n\n.fa-lastfm-square:before {\n  content: \"\\f203\"; }\n\n.fa-laugh:before {\n  content: \"\\f599\"; }\n\n.fa-laugh-beam:before {\n  content: \"\\f59a\"; }\n\n.fa-laugh-squint:before {\n  content: \"\\f59b\"; }\n\n.fa-laugh-wink:before {\n  content: \"\\f59c\"; }\n\n.fa-layer-group:before {\n  content: \"\\f5fd\"; }\n\n.fa-leaf:before {\n  content: \"\\f06c\"; }\n\n.fa-leanpub:before {\n  content: \"\\f212\"; }\n\n.fa-lemon:before {\n  content: \"\\f094\"; }\n\n.fa-less:before {\n  content: \"\\f41d\"; }\n\n.fa-less-than:before {\n  content: \"\\f536\"; }\n\n.fa-less-than-equal:before {\n  content: \"\\f537\"; }\n\n.fa-level-down-alt:before {\n  content: \"\\f3be\"; }\n\n.fa-level-up-alt:before {\n  content: \"\\f3bf\"; }\n\n.fa-life-ring:before {\n  content: \"\\f1cd\"; }\n\n.fa-lightbulb:before {\n  content: \"\\f0eb\"; }\n\n.fa-line:before {\n  content: \"\\f3c0\"; }\n\n.fa-link:before {\n  content: \"\\f0c1\"; }\n\n.fa-linkedin:before {\n  content: \"\\f08c\"; }\n\n.fa-linkedin-in:before {\n  content: \"\\f0e1\"; }\n\n.fa-linode:before {\n  content: \"\\f2b8\"; }\n\n.fa-linux:before {\n  content: \"\\f17c\"; }\n\n.fa-lira-sign:before {\n  content: \"\\f195\"; }\n\n.fa-list:before {\n  content: \"\\f03a\"; }\n\n.fa-list-alt:before {\n  content: \"\\f022\"; }\n\n.fa-list-ol:before {\n  content: \"\\f0cb\"; }\n\n.fa-list-ul:before {\n  content: \"\\f0ca\"; }\n\n.fa-location-arrow:before {\n  content: \"\\f124\"; }\n\n.fa-lock:before {\n  content: \"\\f023\"; }\n\n.fa-lock-open:before {\n  content: \"\\f3c1\"; }\n\n.fa-long-arrow-alt-down:before {\n  content: \"\\f309\"; }\n\n.fa-long-arrow-alt-left:before {\n  content: \"\\f30a\"; }\n\n.fa-long-arrow-alt-right:before {\n  content: \"\\f30b\"; }\n\n.fa-long-arrow-alt-up:before {\n  content: \"\\f30c\"; }\n\n.fa-low-vision:before {\n  content: \"\\f2a8\"; }\n\n.fa-luggage-cart:before {\n  content: \"\\f59d\"; }\n\n.fa-lungs:before {\n  content: \"\\f604\"; }\n\n.fa-lungs-virus:before {\n  content: \"\\f967\"; }\n\n.fa-lyft:before {\n  content: \"\\f3c3\"; }\n\n.fa-magento:before {\n  content: \"\\f3c4\"; }\n\n.fa-magic:before {\n  content: \"\\f0d0\"; }\n\n.fa-magnet:before {\n  content: \"\\f076\"; }\n\n.fa-mail-bulk:before {\n  content: \"\\f674\"; }\n\n.fa-mailchimp:before {\n  content: \"\\f59e\"; }\n\n.fa-male:before {\n  content: \"\\f183\"; }\n\n.fa-mandalorian:before {\n  content: \"\\f50f\"; }\n\n.fa-map:before {\n  content: \"\\f279\"; }\n\n.fa-map-marked:before {\n  content: \"\\f59f\"; }\n\n.fa-map-marked-alt:before {\n  content: \"\\f5a0\"; }\n\n.fa-map-marker:before {\n  content: \"\\f041\"; }\n\n.fa-map-marker-alt:before {\n  content: \"\\f3c5\"; }\n\n.fa-map-pin:before {\n  content: \"\\f276\"; }\n\n.fa-map-signs:before {\n  content: \"\\f277\"; }\n\n.fa-markdown:before {\n  content: \"\\f60f\"; }\n\n.fa-marker:before {\n  content: \"\\f5a1\"; }\n\n.fa-mars:before {\n  content: \"\\f222\"; }\n\n.fa-mars-double:before {\n  content: \"\\f227\"; }\n\n.fa-mars-stroke:before {\n  content: \"\\f229\"; }\n\n.fa-mars-stroke-h:before {\n  content: \"\\f22b\"; }\n\n.fa-mars-stroke-v:before {\n  content: \"\\f22a\"; }\n\n.fa-mask:before {\n  content: \"\\f6fa\"; }\n\n.fa-mastodon:before {\n  content: \"\\f4f6\"; }\n\n.fa-maxcdn:before {\n  content: \"\\f136\"; }\n\n.fa-mdb:before {\n  content: \"\\f8ca\"; }\n\n.fa-medal:before {\n  content: \"\\f5a2\"; }\n\n.fa-medapps:before {\n  content: \"\\f3c6\"; }\n\n.fa-medium:before {\n  content: \"\\f23a\"; }\n\n.fa-medium-m:before {\n  content: \"\\f3c7\"; }\n\n.fa-medkit:before {\n  content: \"\\f0fa\"; }\n\n.fa-medrt:before {\n  content: \"\\f3c8\"; }\n\n.fa-meetup:before {\n  content: \"\\f2e0\"; }\n\n.fa-megaport:before {\n  content: \"\\f5a3\"; }\n\n.fa-meh:before {\n  content: \"\\f11a\"; }\n\n.fa-meh-blank:before {\n  content: \"\\f5a4\"; }\n\n.fa-meh-rolling-eyes:before {\n  content: \"\\f5a5\"; }\n\n.fa-memory:before {\n  content: \"\\f538\"; }\n\n.fa-mendeley:before {\n  content: \"\\f7b3\"; }\n\n.fa-menorah:before {\n  content: \"\\f676\"; }\n\n.fa-mercury:before {\n  content: \"\\f223\"; }\n\n.fa-meteor:before {\n  content: \"\\f753\"; }\n\n.fa-microblog:before {\n  content: \"\\f91a\"; }\n\n.fa-microchip:before {\n  content: \"\\f2db\"; }\n\n.fa-microphone:before {\n  content: \"\\f130\"; }\n\n.fa-microphone-alt:before {\n  content: \"\\f3c9\"; }\n\n.fa-microphone-alt-slash:before {\n  content: \"\\f539\"; }\n\n.fa-microphone-slash:before {\n  content: \"\\f131\"; }\n\n.fa-microscope:before {\n  content: \"\\f610\"; }\n\n.fa-microsoft:before {\n  content: \"\\f3ca\"; }\n\n.fa-minus:before {\n  content: \"\\f068\"; }\n\n.fa-minus-circle:before {\n  content: \"\\f056\"; }\n\n.fa-minus-square:before {\n  content: \"\\f146\"; }\n\n.fa-mitten:before {\n  content: \"\\f7b5\"; }\n\n.fa-mix:before {\n  content: \"\\f3cb\"; }\n\n.fa-mixcloud:before {\n  content: \"\\f289\"; }\n\n.fa-mixer:before {\n  content: \"\\f956\"; }\n\n.fa-mizuni:before {\n  content: \"\\f3cc\"; }\n\n.fa-mobile:before {\n  content: \"\\f10b\"; }\n\n.fa-mobile-alt:before {\n  content: \"\\f3cd\"; }\n\n.fa-modx:before {\n  content: \"\\f285\"; }\n\n.fa-monero:before {\n  content: \"\\f3d0\"; }\n\n.fa-money-bill:before {\n  content: \"\\f0d6\"; }\n\n.fa-money-bill-alt:before {\n  content: \"\\f3d1\"; }\n\n.fa-money-bill-wave:before {\n  content: \"\\f53a\"; }\n\n.fa-money-bill-wave-alt:before {\n  content: \"\\f53b\"; }\n\n.fa-money-check:before {\n  content: \"\\f53c\"; }\n\n.fa-money-check-alt:before {\n  content: \"\\f53d\"; }\n\n.fa-monument:before {\n  content: \"\\f5a6\"; }\n\n.fa-moon:before {\n  content: \"\\f186\"; }\n\n.fa-mortar-pestle:before {\n  content: \"\\f5a7\"; }\n\n.fa-mosque:before {\n  content: \"\\f678\"; }\n\n.fa-motorcycle:before {\n  content: \"\\f21c\"; }\n\n.fa-mountain:before {\n  content: \"\\f6fc\"; }\n\n.fa-mouse:before {\n  content: \"\\f8cc\"; }\n\n.fa-mouse-pointer:before {\n  content: \"\\f245\"; }\n\n.fa-mug-hot:before {\n  content: \"\\f7b6\"; }\n\n.fa-music:before {\n  content: \"\\f001\"; }\n\n.fa-napster:before {\n  content: \"\\f3d2\"; }\n\n.fa-neos:before {\n  content: \"\\f612\"; }\n\n.fa-network-wired:before {\n  content: \"\\f6ff\"; }\n\n.fa-neuter:before {\n  content: \"\\f22c\"; }\n\n.fa-newspaper:before {\n  content: \"\\f1ea\"; }\n\n.fa-nimblr:before {\n  content: \"\\f5a8\"; }\n\n.fa-node:before {\n  content: \"\\f419\"; }\n\n.fa-node-js:before {\n  content: \"\\f3d3\"; }\n\n.fa-not-equal:before {\n  content: \"\\f53e\"; }\n\n.fa-notes-medical:before {\n  content: \"\\f481\"; }\n\n.fa-npm:before {\n  content: \"\\f3d4\"; }\n\n.fa-ns8:before {\n  content: \"\\f3d5\"; }\n\n.fa-nutritionix:before {\n  content: \"\\f3d6\"; }\n\n.fa-object-group:before {\n  content: \"\\f247\"; }\n\n.fa-object-ungroup:before {\n  content: \"\\f248\"; }\n\n.fa-odnoklassniki:before {\n  content: \"\\f263\"; }\n\n.fa-odnoklassniki-square:before {\n  content: \"\\f264\"; }\n\n.fa-oil-can:before {\n  content: \"\\f613\"; }\n\n.fa-old-republic:before {\n  content: \"\\f510\"; }\n\n.fa-om:before {\n  content: \"\\f679\"; }\n\n.fa-opencart:before {\n  content: \"\\f23d\"; }\n\n.fa-openid:before {\n  content: \"\\f19b\"; }\n\n.fa-opera:before {\n  content: \"\\f26a\"; }\n\n.fa-optin-monster:before {\n  content: \"\\f23c\"; }\n\n.fa-orcid:before {\n  content: \"\\f8d2\"; }\n\n.fa-osi:before {\n  content: \"\\f41a\"; }\n\n.fa-otter:before {\n  content: \"\\f700\"; }\n\n.fa-outdent:before {\n  content: \"\\f03b\"; }\n\n.fa-page4:before {\n  content: \"\\f3d7\"; }\n\n.fa-pagelines:before {\n  content: \"\\f18c\"; }\n\n.fa-pager:before {\n  content: \"\\f815\"; }\n\n.fa-paint-brush:before {\n  content: \"\\f1fc\"; }\n\n.fa-paint-roller:before {\n  content: \"\\f5aa\"; }\n\n.fa-palette:before {\n  content: \"\\f53f\"; }\n\n.fa-palfed:before {\n  content: \"\\f3d8\"; }\n\n.fa-pallet:before {\n  content: \"\\f482\"; }\n\n.fa-paper-plane:before {\n  content: \"\\f1d8\"; }\n\n.fa-paperclip:before {\n  content: \"\\f0c6\"; }\n\n.fa-parachute-box:before {\n  content: \"\\f4cd\"; }\n\n.fa-paragraph:before {\n  content: \"\\f1dd\"; }\n\n.fa-parking:before {\n  content: \"\\f540\"; }\n\n.fa-passport:before {\n  content: \"\\f5ab\"; }\n\n.fa-pastafarianism:before {\n  content: \"\\f67b\"; }\n\n.fa-paste:before {\n  content: \"\\f0ea\"; }\n\n.fa-patreon:before {\n  content: \"\\f3d9\"; }\n\n.fa-pause:before {\n  content: \"\\f04c\"; }\n\n.fa-pause-circle:before {\n  content: \"\\f28b\"; }\n\n.fa-paw:before {\n  content: \"\\f1b0\"; }\n\n.fa-paypal:before {\n  content: \"\\f1ed\"; }\n\n.fa-peace:before {\n  content: \"\\f67c\"; }\n\n.fa-pen:before {\n  content: \"\\f304\"; }\n\n.fa-pen-alt:before {\n  content: \"\\f305\"; }\n\n.fa-pen-fancy:before {\n  content: \"\\f5ac\"; }\n\n.fa-pen-nib:before {\n  content: \"\\f5ad\"; }\n\n.fa-pen-square:before {\n  content: \"\\f14b\"; }\n\n.fa-pencil-alt:before {\n  content: \"\\f303\"; }\n\n.fa-pencil-ruler:before {\n  content: \"\\f5ae\"; }\n\n.fa-penny-arcade:before {\n  content: \"\\f704\"; }\n\n.fa-people-arrows:before {\n  content: \"\\f968\"; }\n\n.fa-people-carry:before {\n  content: \"\\f4ce\"; }\n\n.fa-pepper-hot:before {\n  content: \"\\f816\"; }\n\n.fa-percent:before {\n  content: \"\\f295\"; }\n\n.fa-percentage:before {\n  content: \"\\f541\"; }\n\n.fa-periscope:before {\n  content: \"\\f3da\"; }\n\n.fa-person-booth:before {\n  content: \"\\f756\"; }\n\n.fa-phabricator:before {\n  content: \"\\f3db\"; }\n\n.fa-phoenix-framework:before {\n  content: \"\\f3dc\"; }\n\n.fa-phoenix-squadron:before {\n  content: \"\\f511\"; }\n\n.fa-phone:before {\n  content: \"\\f095\"; }\n\n.fa-phone-alt:before {\n  content: \"\\f879\"; }\n\n.fa-phone-slash:before {\n  content: \"\\f3dd\"; }\n\n.fa-phone-square:before {\n  content: \"\\f098\"; }\n\n.fa-phone-square-alt:before {\n  content: \"\\f87b\"; }\n\n.fa-phone-volume:before {\n  content: \"\\f2a0\"; }\n\n.fa-photo-video:before {\n  content: \"\\f87c\"; }\n\n.fa-php:before {\n  content: \"\\f457\"; }\n\n.fa-pied-piper:before {\n  content: \"\\f2ae\"; }\n\n.fa-pied-piper-alt:before {\n  content: \"\\f1a8\"; }\n\n.fa-pied-piper-hat:before {\n  content: \"\\f4e5\"; }\n\n.fa-pied-piper-pp:before {\n  content: \"\\f1a7\"; }\n\n.fa-pied-piper-square:before {\n  content: \"\\f91e\"; }\n\n.fa-piggy-bank:before {\n  content: \"\\f4d3\"; }\n\n.fa-pills:before {\n  content: \"\\f484\"; }\n\n.fa-pinterest:before {\n  content: \"\\f0d2\"; }\n\n.fa-pinterest-p:before {\n  content: \"\\f231\"; }\n\n.fa-pinterest-square:before {\n  content: \"\\f0d3\"; }\n\n.fa-pizza-slice:before {\n  content: \"\\f818\"; }\n\n.fa-place-of-worship:before {\n  content: \"\\f67f\"; }\n\n.fa-plane:before {\n  content: \"\\f072\"; }\n\n.fa-plane-arrival:before {\n  content: \"\\f5af\"; }\n\n.fa-plane-departure:before {\n  content: \"\\f5b0\"; }\n\n.fa-plane-slash:before {\n  content: \"\\f969\"; }\n\n.fa-play:before {\n  content: \"\\f04b\"; }\n\n.fa-play-circle:before {\n  content: \"\\f144\"; }\n\n.fa-playstation:before {\n  content: \"\\f3df\"; }\n\n.fa-plug:before {\n  content: \"\\f1e6\"; }\n\n.fa-plus:before {\n  content: \"\\f067\"; }\n\n.fa-plus-circle:before {\n  content: \"\\f055\"; }\n\n.fa-plus-square:before {\n  content: \"\\f0fe\"; }\n\n.fa-podcast:before {\n  content: \"\\f2ce\"; }\n\n.fa-poll:before {\n  content: \"\\f681\"; }\n\n.fa-poll-h:before {\n  content: \"\\f682\"; }\n\n.fa-poo:before {\n  content: \"\\f2fe\"; }\n\n.fa-poo-storm:before {\n  content: \"\\f75a\"; }\n\n.fa-poop:before {\n  content: \"\\f619\"; }\n\n.fa-portrait:before {\n  content: \"\\f3e0\"; }\n\n.fa-pound-sign:before {\n  content: \"\\f154\"; }\n\n.fa-power-off:before {\n  content: \"\\f011\"; }\n\n.fa-pray:before {\n  content: \"\\f683\"; }\n\n.fa-praying-hands:before {\n  content: \"\\f684\"; }\n\n.fa-prescription:before {\n  content: \"\\f5b1\"; }\n\n.fa-prescription-bottle:before {\n  content: \"\\f485\"; }\n\n.fa-prescription-bottle-alt:before {\n  content: \"\\f486\"; }\n\n.fa-print:before {\n  content: \"\\f02f\"; }\n\n.fa-procedures:before {\n  content: \"\\f487\"; }\n\n.fa-product-hunt:before {\n  content: \"\\f288\"; }\n\n.fa-project-diagram:before {\n  content: \"\\f542\"; }\n\n.fa-pump-medical:before {\n  content: \"\\f96a\"; }\n\n.fa-pump-soap:before {\n  content: \"\\f96b\"; }\n\n.fa-pushed:before {\n  content: \"\\f3e1\"; }\n\n.fa-puzzle-piece:before {\n  content: \"\\f12e\"; }\n\n.fa-python:before {\n  content: \"\\f3e2\"; }\n\n.fa-qq:before {\n  content: \"\\f1d6\"; }\n\n.fa-qrcode:before {\n  content: \"\\f029\"; }\n\n.fa-question:before {\n  content: \"\\f128\"; }\n\n.fa-question-circle:before {\n  content: \"\\f059\"; }\n\n.fa-quidditch:before {\n  content: \"\\f458\"; }\n\n.fa-quinscape:before {\n  content: \"\\f459\"; }\n\n.fa-quora:before {\n  content: \"\\f2c4\"; }\n\n.fa-quote-left:before {\n  content: \"\\f10d\"; }\n\n.fa-quote-right:before {\n  content: \"\\f10e\"; }\n\n.fa-quran:before {\n  content: \"\\f687\"; }\n\n.fa-r-project:before {\n  content: \"\\f4f7\"; }\n\n.fa-radiation:before {\n  content: \"\\f7b9\"; }\n\n.fa-radiation-alt:before {\n  content: \"\\f7ba\"; }\n\n.fa-rainbow:before {\n  content: \"\\f75b\"; }\n\n.fa-random:before {\n  content: \"\\f074\"; }\n\n.fa-raspberry-pi:before {\n  content: \"\\f7bb\"; }\n\n.fa-ravelry:before {\n  content: \"\\f2d9\"; }\n\n.fa-react:before {\n  content: \"\\f41b\"; }\n\n.fa-reacteurope:before {\n  content: \"\\f75d\"; }\n\n.fa-readme:before {\n  content: \"\\f4d5\"; }\n\n.fa-rebel:before {\n  content: \"\\f1d0\"; }\n\n.fa-receipt:before {\n  content: \"\\f543\"; }\n\n.fa-record-vinyl:before {\n  content: \"\\f8d9\"; }\n\n.fa-recycle:before {\n  content: \"\\f1b8\"; }\n\n.fa-red-river:before {\n  content: \"\\f3e3\"; }\n\n.fa-reddit:before {\n  content: \"\\f1a1\"; }\n\n.fa-reddit-alien:before {\n  content: \"\\f281\"; }\n\n.fa-reddit-square:before {\n  content: \"\\f1a2\"; }\n\n.fa-redhat:before {\n  content: \"\\f7bc\"; }\n\n.fa-redo:before {\n  content: \"\\f01e\"; }\n\n.fa-redo-alt:before {\n  content: \"\\f2f9\"; }\n\n.fa-registered:before {\n  content: \"\\f25d\"; }\n\n.fa-remove-format:before {\n  content: \"\\f87d\"; }\n\n.fa-renren:before {\n  content: \"\\f18b\"; }\n\n.fa-reply:before {\n  content: \"\\f3e5\"; }\n\n.fa-reply-all:before {\n  content: \"\\f122\"; }\n\n.fa-replyd:before {\n  content: \"\\f3e6\"; }\n\n.fa-republican:before {\n  content: \"\\f75e\"; }\n\n.fa-researchgate:before {\n  content: \"\\f4f8\"; }\n\n.fa-resolving:before {\n  content: \"\\f3e7\"; }\n\n.fa-restroom:before {\n  content: \"\\f7bd\"; }\n\n.fa-retweet:before {\n  content: \"\\f079\"; }\n\n.fa-rev:before {\n  content: \"\\f5b2\"; }\n\n.fa-ribbon:before {\n  content: \"\\f4d6\"; }\n\n.fa-ring:before {\n  content: \"\\f70b\"; }\n\n.fa-road:before {\n  content: \"\\f018\"; }\n\n.fa-robot:before {\n  content: \"\\f544\"; }\n\n.fa-rocket:before {\n  content: \"\\f135\"; }\n\n.fa-rocketchat:before {\n  content: \"\\f3e8\"; }\n\n.fa-rockrms:before {\n  content: \"\\f3e9\"; }\n\n.fa-route:before {\n  content: \"\\f4d7\"; }\n\n.fa-rss:before {\n  content: \"\\f09e\"; }\n\n.fa-rss-square:before {\n  content: \"\\f143\"; }\n\n.fa-ruble-sign:before {\n  content: \"\\f158\"; }\n\n.fa-ruler:before {\n  content: \"\\f545\"; }\n\n.fa-ruler-combined:before {\n  content: \"\\f546\"; }\n\n.fa-ruler-horizontal:before {\n  content: \"\\f547\"; }\n\n.fa-ruler-vertical:before {\n  content: \"\\f548\"; }\n\n.fa-running:before {\n  content: \"\\f70c\"; }\n\n.fa-rupee-sign:before {\n  content: \"\\f156\"; }\n\n.fa-sad-cry:before {\n  content: \"\\f5b3\"; }\n\n.fa-sad-tear:before {\n  content: \"\\f5b4\"; }\n\n.fa-safari:before {\n  content: \"\\f267\"; }\n\n.fa-salesforce:before {\n  content: \"\\f83b\"; }\n\n.fa-sass:before {\n  content: \"\\f41e\"; }\n\n.fa-satellite:before {\n  content: \"\\f7bf\"; }\n\n.fa-satellite-dish:before {\n  content: \"\\f7c0\"; }\n\n.fa-save:before {\n  content: \"\\f0c7\"; }\n\n.fa-schlix:before {\n  content: \"\\f3ea\"; }\n\n.fa-school:before {\n  content: \"\\f549\"; }\n\n.fa-screwdriver:before {\n  content: \"\\f54a\"; }\n\n.fa-scribd:before {\n  content: \"\\f28a\"; }\n\n.fa-scroll:before {\n  content: \"\\f70e\"; }\n\n.fa-sd-card:before {\n  content: \"\\f7c2\"; }\n\n.fa-search:before {\n  content: \"\\f002\"; }\n\n.fa-search-dollar:before {\n  content: \"\\f688\"; }\n\n.fa-search-location:before {\n  content: \"\\f689\"; }\n\n.fa-search-minus:before {\n  content: \"\\f010\"; }\n\n.fa-search-plus:before {\n  content: \"\\f00e\"; }\n\n.fa-searchengin:before {\n  content: \"\\f3eb\"; }\n\n.fa-seedling:before {\n  content: \"\\f4d8\"; }\n\n.fa-sellcast:before {\n  content: \"\\f2da\"; }\n\n.fa-sellsy:before {\n  content: \"\\f213\"; }\n\n.fa-server:before {\n  content: \"\\f233\"; }\n\n.fa-servicestack:before {\n  content: \"\\f3ec\"; }\n\n.fa-shapes:before {\n  content: \"\\f61f\"; }\n\n.fa-share:before {\n  content: \"\\f064\"; }\n\n.fa-share-alt:before {\n  content: \"\\f1e0\"; }\n\n.fa-share-alt-square:before {\n  content: \"\\f1e1\"; }\n\n.fa-share-square:before {\n  content: \"\\f14d\"; }\n\n.fa-shekel-sign:before {\n  content: \"\\f20b\"; }\n\n.fa-shield-alt:before {\n  content: \"\\f3ed\"; }\n\n.fa-shield-virus:before {\n  content: \"\\f96c\"; }\n\n.fa-ship:before {\n  content: \"\\f21a\"; }\n\n.fa-shipping-fast:before {\n  content: \"\\f48b\"; }\n\n.fa-shirtsinbulk:before {\n  content: \"\\f214\"; }\n\n.fa-shoe-prints:before {\n  content: \"\\f54b\"; }\n\n.fa-shopify:before {\n  content: \"\\f957\"; }\n\n.fa-shopping-bag:before {\n  content: \"\\f290\"; }\n\n.fa-shopping-basket:before {\n  content: \"\\f291\"; }\n\n.fa-shopping-cart:before {\n  content: \"\\f07a\"; }\n\n.fa-shopware:before {\n  content: \"\\f5b5\"; }\n\n.fa-shower:before {\n  content: \"\\f2cc\"; }\n\n.fa-shuttle-van:before {\n  content: \"\\f5b6\"; }\n\n.fa-sign:before {\n  content: \"\\f4d9\"; }\n\n.fa-sign-in-alt:before {\n  content: \"\\f2f6\"; }\n\n.fa-sign-language:before {\n  content: \"\\f2a7\"; }\n\n.fa-sign-out-alt:before {\n  content: \"\\f2f5\"; }\n\n.fa-signal:before {\n  content: \"\\f012\"; }\n\n.fa-signature:before {\n  content: \"\\f5b7\"; }\n\n.fa-sim-card:before {\n  content: \"\\f7c4\"; }\n\n.fa-simplybuilt:before {\n  content: \"\\f215\"; }\n\n.fa-sistrix:before {\n  content: \"\\f3ee\"; }\n\n.fa-sitemap:before {\n  content: \"\\f0e8\"; }\n\n.fa-sith:before {\n  content: \"\\f512\"; }\n\n.fa-skating:before {\n  content: \"\\f7c5\"; }\n\n.fa-sketch:before {\n  content: \"\\f7c6\"; }\n\n.fa-skiing:before {\n  content: \"\\f7c9\"; }\n\n.fa-skiing-nordic:before {\n  content: \"\\f7ca\"; }\n\n.fa-skull:before {\n  content: \"\\f54c\"; }\n\n.fa-skull-crossbones:before {\n  content: \"\\f714\"; }\n\n.fa-skyatlas:before {\n  content: \"\\f216\"; }\n\n.fa-skype:before {\n  content: \"\\f17e\"; }\n\n.fa-slack:before {\n  content: \"\\f198\"; }\n\n.fa-slack-hash:before {\n  content: \"\\f3ef\"; }\n\n.fa-slash:before {\n  content: \"\\f715\"; }\n\n.fa-sleigh:before {\n  content: \"\\f7cc\"; }\n\n.fa-sliders-h:before {\n  content: \"\\f1de\"; }\n\n.fa-slideshare:before {\n  content: \"\\f1e7\"; }\n\n.fa-smile:before {\n  content: \"\\f118\"; }\n\n.fa-smile-beam:before {\n  content: \"\\f5b8\"; }\n\n.fa-smile-wink:before {\n  content: \"\\f4da\"; }\n\n.fa-smog:before {\n  content: \"\\f75f\"; }\n\n.fa-smoking:before {\n  content: \"\\f48d\"; }\n\n.fa-smoking-ban:before {\n  content: \"\\f54d\"; }\n\n.fa-sms:before {\n  content: \"\\f7cd\"; }\n\n.fa-snapchat:before {\n  content: \"\\f2ab\"; }\n\n.fa-snapchat-ghost:before {\n  content: \"\\f2ac\"; }\n\n.fa-snapchat-square:before {\n  content: \"\\f2ad\"; }\n\n.fa-snowboarding:before {\n  content: \"\\f7ce\"; }\n\n.fa-snowflake:before {\n  content: \"\\f2dc\"; }\n\n.fa-snowman:before {\n  content: \"\\f7d0\"; }\n\n.fa-snowplow:before {\n  content: \"\\f7d2\"; }\n\n.fa-soap:before {\n  content: \"\\f96e\"; }\n\n.fa-socks:before {\n  content: \"\\f696\"; }\n\n.fa-solar-panel:before {\n  content: \"\\f5ba\"; }\n\n.fa-sort:before {\n  content: \"\\f0dc\"; }\n\n.fa-sort-alpha-down:before {\n  content: \"\\f15d\"; }\n\n.fa-sort-alpha-down-alt:before {\n  content: \"\\f881\"; }\n\n.fa-sort-alpha-up:before {\n  content: \"\\f15e\"; }\n\n.fa-sort-alpha-up-alt:before {\n  content: \"\\f882\"; }\n\n.fa-sort-amount-down:before {\n  content: \"\\f160\"; }\n\n.fa-sort-amount-down-alt:before {\n  content: \"\\f884\"; }\n\n.fa-sort-amount-up:before {\n  content: \"\\f161\"; }\n\n.fa-sort-amount-up-alt:before {\n  content: \"\\f885\"; }\n\n.fa-sort-down:before {\n  content: \"\\f0dd\"; }\n\n.fa-sort-numeric-down:before {\n  content: \"\\f162\"; }\n\n.fa-sort-numeric-down-alt:before {\n  content: \"\\f886\"; }\n\n.fa-sort-numeric-up:before {\n  content: \"\\f163\"; }\n\n.fa-sort-numeric-up-alt:before {\n  content: \"\\f887\"; }\n\n.fa-sort-up:before {\n  content: \"\\f0de\"; }\n\n.fa-soundcloud:before {\n  content: \"\\f1be\"; }\n\n.fa-sourcetree:before {\n  content: \"\\f7d3\"; }\n\n.fa-spa:before {\n  content: \"\\f5bb\"; }\n\n.fa-space-shuttle:before {\n  content: \"\\f197\"; }\n\n.fa-speakap:before {\n  content: \"\\f3f3\"; }\n\n.fa-speaker-deck:before {\n  content: \"\\f83c\"; }\n\n.fa-spell-check:before {\n  content: \"\\f891\"; }\n\n.fa-spider:before {\n  content: \"\\f717\"; }\n\n.fa-spinner:before {\n  content: \"\\f110\"; }\n\n.fa-splotch:before {\n  content: \"\\f5bc\"; }\n\n.fa-spotify:before {\n  content: \"\\f1bc\"; }\n\n.fa-spray-can:before {\n  content: \"\\f5bd\"; }\n\n.fa-square:before {\n  content: \"\\f0c8\"; }\n\n.fa-square-full:before {\n  content: \"\\f45c\"; }\n\n.fa-square-root-alt:before {\n  content: \"\\f698\"; }\n\n.fa-squarespace:before {\n  content: \"\\f5be\"; }\n\n.fa-stack-exchange:before {\n  content: \"\\f18d\"; }\n\n.fa-stack-overflow:before {\n  content: \"\\f16c\"; }\n\n.fa-stackpath:before {\n  content: \"\\f842\"; }\n\n.fa-stamp:before {\n  content: \"\\f5bf\"; }\n\n.fa-star:before {\n  content: \"\\f005\"; }\n\n.fa-star-and-crescent:before {\n  content: \"\\f699\"; }\n\n.fa-star-half:before {\n  content: \"\\f089\"; }\n\n.fa-star-half-alt:before {\n  content: \"\\f5c0\"; }\n\n.fa-star-of-david:before {\n  content: \"\\f69a\"; }\n\n.fa-star-of-life:before {\n  content: \"\\f621\"; }\n\n.fa-staylinked:before {\n  content: \"\\f3f5\"; }\n\n.fa-steam:before {\n  content: \"\\f1b6\"; }\n\n.fa-steam-square:before {\n  content: \"\\f1b7\"; }\n\n.fa-steam-symbol:before {\n  content: \"\\f3f6\"; }\n\n.fa-step-backward:before {\n  content: \"\\f048\"; }\n\n.fa-step-forward:before {\n  content: \"\\f051\"; }\n\n.fa-stethoscope:before {\n  content: \"\\f0f1\"; }\n\n.fa-sticker-mule:before {\n  content: \"\\f3f7\"; }\n\n.fa-sticky-note:before {\n  content: \"\\f249\"; }\n\n.fa-stop:before {\n  content: \"\\f04d\"; }\n\n.fa-stop-circle:before {\n  content: \"\\f28d\"; }\n\n.fa-stopwatch:before {\n  content: \"\\f2f2\"; }\n\n.fa-stopwatch-20:before {\n  content: \"\\f96f\"; }\n\n.fa-store:before {\n  content: \"\\f54e\"; }\n\n.fa-store-alt:before {\n  content: \"\\f54f\"; }\n\n.fa-store-alt-slash:before {\n  content: \"\\f970\"; }\n\n.fa-store-slash:before {\n  content: \"\\f971\"; }\n\n.fa-strava:before {\n  content: \"\\f428\"; }\n\n.fa-stream:before {\n  content: \"\\f550\"; }\n\n.fa-street-view:before {\n  content: \"\\f21d\"; }\n\n.fa-strikethrough:before {\n  content: \"\\f0cc\"; }\n\n.fa-stripe:before {\n  content: \"\\f429\"; }\n\n.fa-stripe-s:before {\n  content: \"\\f42a\"; }\n\n.fa-stroopwafel:before {\n  content: \"\\f551\"; }\n\n.fa-studiovinari:before {\n  content: \"\\f3f8\"; }\n\n.fa-stumbleupon:before {\n  content: \"\\f1a4\"; }\n\n.fa-stumbleupon-circle:before {\n  content: \"\\f1a3\"; }\n\n.fa-subscript:before {\n  content: \"\\f12c\"; }\n\n.fa-subway:before {\n  content: \"\\f239\"; }\n\n.fa-suitcase:before {\n  content: \"\\f0f2\"; }\n\n.fa-suitcase-rolling:before {\n  content: \"\\f5c1\"; }\n\n.fa-sun:before {\n  content: \"\\f185\"; }\n\n.fa-superpowers:before {\n  content: \"\\f2dd\"; }\n\n.fa-superscript:before {\n  content: \"\\f12b\"; }\n\n.fa-supple:before {\n  content: \"\\f3f9\"; }\n\n.fa-surprise:before {\n  content: \"\\f5c2\"; }\n\n.fa-suse:before {\n  content: \"\\f7d6\"; }\n\n.fa-swatchbook:before {\n  content: \"\\f5c3\"; }\n\n.fa-swift:before {\n  content: \"\\f8e1\"; }\n\n.fa-swimmer:before {\n  content: \"\\f5c4\"; }\n\n.fa-swimming-pool:before {\n  content: \"\\f5c5\"; }\n\n.fa-symfony:before {\n  content: \"\\f83d\"; }\n\n.fa-synagogue:before {\n  content: \"\\f69b\"; }\n\n.fa-sync:before {\n  content: \"\\f021\"; }\n\n.fa-sync-alt:before {\n  content: \"\\f2f1\"; }\n\n.fa-syringe:before {\n  content: \"\\f48e\"; }\n\n.fa-table:before {\n  content: \"\\f0ce\"; }\n\n.fa-table-tennis:before {\n  content: \"\\f45d\"; }\n\n.fa-tablet:before {\n  content: \"\\f10a\"; }\n\n.fa-tablet-alt:before {\n  content: \"\\f3fa\"; }\n\n.fa-tablets:before {\n  content: \"\\f490\"; }\n\n.fa-tachometer-alt:before {\n  content: \"\\f3fd\"; }\n\n.fa-tag:before {\n  content: \"\\f02b\"; }\n\n.fa-tags:before {\n  content: \"\\f02c\"; }\n\n.fa-tape:before {\n  content: \"\\f4db\"; }\n\n.fa-tasks:before {\n  content: \"\\f0ae\"; }\n\n.fa-taxi:before {\n  content: \"\\f1ba\"; }\n\n.fa-teamspeak:before {\n  content: \"\\f4f9\"; }\n\n.fa-teeth:before {\n  content: \"\\f62e\"; }\n\n.fa-teeth-open:before {\n  content: \"\\f62f\"; }\n\n.fa-telegram:before {\n  content: \"\\f2c6\"; }\n\n.fa-telegram-plane:before {\n  content: \"\\f3fe\"; }\n\n.fa-temperature-high:before {\n  content: \"\\f769\"; }\n\n.fa-temperature-low:before {\n  content: \"\\f76b\"; }\n\n.fa-tencent-weibo:before {\n  content: \"\\f1d5\"; }\n\n.fa-tenge:before {\n  content: \"\\f7d7\"; }\n\n.fa-terminal:before {\n  content: \"\\f120\"; }\n\n.fa-text-height:before {\n  content: \"\\f034\"; }\n\n.fa-text-width:before {\n  content: \"\\f035\"; }\n\n.fa-th:before {\n  content: \"\\f00a\"; }\n\n.fa-th-large:before {\n  content: \"\\f009\"; }\n\n.fa-th-list:before {\n  content: \"\\f00b\"; }\n\n.fa-the-red-yeti:before {\n  content: \"\\f69d\"; }\n\n.fa-theater-masks:before {\n  content: \"\\f630\"; }\n\n.fa-themeco:before {\n  content: \"\\f5c6\"; }\n\n.fa-themeisle:before {\n  content: \"\\f2b2\"; }\n\n.fa-thermometer:before {\n  content: \"\\f491\"; }\n\n.fa-thermometer-empty:before {\n  content: \"\\f2cb\"; }\n\n.fa-thermometer-full:before {\n  content: \"\\f2c7\"; }\n\n.fa-thermometer-half:before {\n  content: \"\\f2c9\"; }\n\n.fa-thermometer-quarter:before {\n  content: \"\\f2ca\"; }\n\n.fa-thermometer-three-quarters:before {\n  content: \"\\f2c8\"; }\n\n.fa-think-peaks:before {\n  content: \"\\f731\"; }\n\n.fa-thumbs-down:before {\n  content: \"\\f165\"; }\n\n.fa-thumbs-up:before {\n  content: \"\\f164\"; }\n\n.fa-thumbtack:before {\n  content: \"\\f08d\"; }\n\n.fa-ticket-alt:before {\n  content: \"\\f3ff\"; }\n\n.fa-times:before {\n  content: \"\\f00d\"; }\n\n.fa-times-circle:before {\n  content: \"\\f057\"; }\n\n.fa-tint:before {\n  content: \"\\f043\"; }\n\n.fa-tint-slash:before {\n  content: \"\\f5c7\"; }\n\n.fa-tired:before {\n  content: \"\\f5c8\"; }\n\n.fa-toggle-off:before {\n  content: \"\\f204\"; }\n\n.fa-toggle-on:before {\n  content: \"\\f205\"; }\n\n.fa-toilet:before {\n  content: \"\\f7d8\"; }\n\n.fa-toilet-paper:before {\n  content: \"\\f71e\"; }\n\n.fa-toilet-paper-slash:before {\n  content: \"\\f972\"; }\n\n.fa-toolbox:before {\n  content: \"\\f552\"; }\n\n.fa-tools:before {\n  content: \"\\f7d9\"; }\n\n.fa-tooth:before {\n  content: \"\\f5c9\"; }\n\n.fa-torah:before {\n  content: \"\\f6a0\"; }\n\n.fa-torii-gate:before {\n  content: \"\\f6a1\"; }\n\n.fa-tractor:before {\n  content: \"\\f722\"; }\n\n.fa-trade-federation:before {\n  content: \"\\f513\"; }\n\n.fa-trademark:before {\n  content: \"\\f25c\"; }\n\n.fa-traffic-light:before {\n  content: \"\\f637\"; }\n\n.fa-trailer:before {\n  content: \"\\f941\"; }\n\n.fa-train:before {\n  content: \"\\f238\"; }\n\n.fa-tram:before {\n  content: \"\\f7da\"; }\n\n.fa-transgender:before {\n  content: \"\\f224\"; }\n\n.fa-transgender-alt:before {\n  content: \"\\f225\"; }\n\n.fa-trash:before {\n  content: \"\\f1f8\"; }\n\n.fa-trash-alt:before {\n  content: \"\\f2ed\"; }\n\n.fa-trash-restore:before {\n  content: \"\\f829\"; }\n\n.fa-trash-restore-alt:before {\n  content: \"\\f82a\"; }\n\n.fa-tree:before {\n  content: \"\\f1bb\"; }\n\n.fa-trello:before {\n  content: \"\\f181\"; }\n\n.fa-tripadvisor:before {\n  content: \"\\f262\"; }\n\n.fa-trophy:before {\n  content: \"\\f091\"; }\n\n.fa-truck:before {\n  content: \"\\f0d1\"; }\n\n.fa-truck-loading:before {\n  content: \"\\f4de\"; }\n\n.fa-truck-monster:before {\n  content: \"\\f63b\"; }\n\n.fa-truck-moving:before {\n  content: \"\\f4df\"; }\n\n.fa-truck-pickup:before {\n  content: \"\\f63c\"; }\n\n.fa-tshirt:before {\n  content: \"\\f553\"; }\n\n.fa-tty:before {\n  content: \"\\f1e4\"; }\n\n.fa-tumblr:before {\n  content: \"\\f173\"; }\n\n.fa-tumblr-square:before {\n  content: \"\\f174\"; }\n\n.fa-tv:before {\n  content: \"\\f26c\"; }\n\n.fa-twitch:before {\n  content: \"\\f1e8\"; }\n\n.fa-twitter:before {\n  content: \"\\f099\"; }\n\n.fa-twitter-square:before {\n  content: \"\\f081\"; }\n\n.fa-typo3:before {\n  content: \"\\f42b\"; }\n\n.fa-uber:before {\n  content: \"\\f402\"; }\n\n.fa-ubuntu:before {\n  content: \"\\f7df\"; }\n\n.fa-uikit:before {\n  content: \"\\f403\"; }\n\n.fa-umbraco:before {\n  content: \"\\f8e8\"; }\n\n.fa-umbrella:before {\n  content: \"\\f0e9\"; }\n\n.fa-umbrella-beach:before {\n  content: \"\\f5ca\"; }\n\n.fa-underline:before {\n  content: \"\\f0cd\"; }\n\n.fa-undo:before {\n  content: \"\\f0e2\"; }\n\n.fa-undo-alt:before {\n  content: \"\\f2ea\"; }\n\n.fa-uniregistry:before {\n  content: \"\\f404\"; }\n\n.fa-unity:before {\n  content: \"\\f949\"; }\n\n.fa-universal-access:before {\n  content: \"\\f29a\"; }\n\n.fa-university:before {\n  content: \"\\f19c\"; }\n\n.fa-unlink:before {\n  content: \"\\f127\"; }\n\n.fa-unlock:before {\n  content: \"\\f09c\"; }\n\n.fa-unlock-alt:before {\n  content: \"\\f13e\"; }\n\n.fa-untappd:before {\n  content: \"\\f405\"; }\n\n.fa-upload:before {\n  content: \"\\f093\"; }\n\n.fa-ups:before {\n  content: \"\\f7e0\"; }\n\n.fa-usb:before {\n  content: \"\\f287\"; }\n\n.fa-user:before {\n  content: \"\\f007\"; }\n\n.fa-user-alt:before {\n  content: \"\\f406\"; }\n\n.fa-user-alt-slash:before {\n  content: \"\\f4fa\"; }\n\n.fa-user-astronaut:before {\n  content: \"\\f4fb\"; }\n\n.fa-user-check:before {\n  content: \"\\f4fc\"; }\n\n.fa-user-circle:before {\n  content: \"\\f2bd\"; }\n\n.fa-user-clock:before {\n  content: \"\\f4fd\"; }\n\n.fa-user-cog:before {\n  content: \"\\f4fe\"; }\n\n.fa-user-edit:before {\n  content: \"\\f4ff\"; }\n\n.fa-user-friends:before {\n  content: \"\\f500\"; }\n\n.fa-user-graduate:before {\n  content: \"\\f501\"; }\n\n.fa-user-injured:before {\n  content: \"\\f728\"; }\n\n.fa-user-lock:before {\n  content: \"\\f502\"; }\n\n.fa-user-md:before {\n  content: \"\\f0f0\"; }\n\n.fa-user-minus:before {\n  content: \"\\f503\"; }\n\n.fa-user-ninja:before {\n  content: \"\\f504\"; }\n\n.fa-user-nurse:before {\n  content: \"\\f82f\"; }\n\n.fa-user-plus:before {\n  content: \"\\f234\"; }\n\n.fa-user-secret:before {\n  content: \"\\f21b\"; }\n\n.fa-user-shield:before {\n  content: \"\\f505\"; }\n\n.fa-user-slash:before {\n  content: \"\\f506\"; }\n\n.fa-user-tag:before {\n  content: \"\\f507\"; }\n\n.fa-user-tie:before {\n  content: \"\\f508\"; }\n\n.fa-user-times:before {\n  content: \"\\f235\"; }\n\n.fa-users:before {\n  content: \"\\f0c0\"; }\n\n.fa-users-cog:before {\n  content: \"\\f509\"; }\n\n.fa-usps:before {\n  content: \"\\f7e1\"; }\n\n.fa-ussunnah:before {\n  content: \"\\f407\"; }\n\n.fa-utensil-spoon:before {\n  content: \"\\f2e5\"; }\n\n.fa-utensils:before {\n  content: \"\\f2e7\"; }\n\n.fa-vaadin:before {\n  content: \"\\f408\"; }\n\n.fa-vector-square:before {\n  content: \"\\f5cb\"; }\n\n.fa-venus:before {\n  content: \"\\f221\"; }\n\n.fa-venus-double:before {\n  content: \"\\f226\"; }\n\n.fa-venus-mars:before {\n  content: \"\\f228\"; }\n\n.fa-viacoin:before {\n  content: \"\\f237\"; }\n\n.fa-viadeo:before {\n  content: \"\\f2a9\"; }\n\n.fa-viadeo-square:before {\n  content: \"\\f2aa\"; }\n\n.fa-vial:before {\n  content: \"\\f492\"; }\n\n.fa-vials:before {\n  content: \"\\f493\"; }\n\n.fa-viber:before {\n  content: \"\\f409\"; }\n\n.fa-video:before {\n  content: \"\\f03d\"; }\n\n.fa-video-slash:before {\n  content: \"\\f4e2\"; }\n\n.fa-vihara:before {\n  content: \"\\f6a7\"; }\n\n.fa-vimeo:before {\n  content: \"\\f40a\"; }\n\n.fa-vimeo-square:before {\n  content: \"\\f194\"; }\n\n.fa-vimeo-v:before {\n  content: \"\\f27d\"; }\n\n.fa-vine:before {\n  content: \"\\f1ca\"; }\n\n.fa-virus:before {\n  content: \"\\f974\"; }\n\n.fa-virus-slash:before {\n  content: \"\\f975\"; }\n\n.fa-viruses:before {\n  content: \"\\f976\"; }\n\n.fa-vk:before {\n  content: \"\\f189\"; }\n\n.fa-vnv:before {\n  content: \"\\f40b\"; }\n\n.fa-voicemail:before {\n  content: \"\\f897\"; }\n\n.fa-volleyball-ball:before {\n  content: \"\\f45f\"; }\n\n.fa-volume-down:before {\n  content: \"\\f027\"; }\n\n.fa-volume-mute:before {\n  content: \"\\f6a9\"; }\n\n.fa-volume-off:before {\n  content: \"\\f026\"; }\n\n.fa-volume-up:before {\n  content: \"\\f028\"; }\n\n.fa-vote-yea:before {\n  content: \"\\f772\"; }\n\n.fa-vr-cardboard:before {\n  content: \"\\f729\"; }\n\n.fa-vuejs:before {\n  content: \"\\f41f\"; }\n\n.fa-walking:before {\n  content: \"\\f554\"; }\n\n.fa-wallet:before {\n  content: \"\\f555\"; }\n\n.fa-warehouse:before {\n  content: \"\\f494\"; }\n\n.fa-water:before {\n  content: \"\\f773\"; }\n\n.fa-wave-square:before {\n  content: \"\\f83e\"; }\n\n.fa-waze:before {\n  content: \"\\f83f\"; }\n\n.fa-weebly:before {\n  content: \"\\f5cc\"; }\n\n.fa-weibo:before {\n  content: \"\\f18a\"; }\n\n.fa-weight:before {\n  content: \"\\f496\"; }\n\n.fa-weight-hanging:before {\n  content: \"\\f5cd\"; }\n\n.fa-weixin:before {\n  content: \"\\f1d7\"; }\n\n.fa-whatsapp:before {\n  content: \"\\f232\"; }\n\n.fa-whatsapp-square:before {\n  content: \"\\f40c\"; }\n\n.fa-wheelchair:before {\n  content: \"\\f193\"; }\n\n.fa-whmcs:before {\n  content: \"\\f40d\"; }\n\n.fa-wifi:before {\n  content: \"\\f1eb\"; }\n\n.fa-wikipedia-w:before {\n  content: \"\\f266\"; }\n\n.fa-wind:before {\n  content: \"\\f72e\"; }\n\n.fa-window-close:before {\n  content: \"\\f410\"; }\n\n.fa-window-maximize:before {\n  content: \"\\f2d0\"; }\n\n.fa-window-minimize:before {\n  content: \"\\f2d1\"; }\n\n.fa-window-restore:before {\n  content: \"\\f2d2\"; }\n\n.fa-windows:before {\n  content: \"\\f17a\"; }\n\n.fa-wine-bottle:before {\n  content: \"\\f72f\"; }\n\n.fa-wine-glass:before {\n  content: \"\\f4e3\"; }\n\n.fa-wine-glass-alt:before {\n  content: \"\\f5ce\"; }\n\n.fa-wix:before {\n  content: \"\\f5cf\"; }\n\n.fa-wizards-of-the-coast:before {\n  content: \"\\f730\"; }\n\n.fa-wolf-pack-battalion:before {\n  content: \"\\f514\"; }\n\n.fa-won-sign:before {\n  content: \"\\f159\"; }\n\n.fa-wordpress:before {\n  content: \"\\f19a\"; }\n\n.fa-wordpress-simple:before {\n  content: \"\\f411\"; }\n\n.fa-wpbeginner:before {\n  content: \"\\f297\"; }\n\n.fa-wpexplorer:before {\n  content: \"\\f2de\"; }\n\n.fa-wpforms:before {\n  content: \"\\f298\"; }\n\n.fa-wpressr:before {\n  content: \"\\f3e4\"; }\n\n.fa-wrench:before {\n  content: \"\\f0ad\"; }\n\n.fa-x-ray:before {\n  content: \"\\f497\"; }\n\n.fa-xbox:before {\n  content: \"\\f412\"; }\n\n.fa-xing:before {\n  content: \"\\f168\"; }\n\n.fa-xing-square:before {\n  content: \"\\f169\"; }\n\n.fa-y-combinator:before {\n  content: \"\\f23b\"; }\n\n.fa-yahoo:before {\n  content: \"\\f19e\"; }\n\n.fa-yammer:before {\n  content: \"\\f840\"; }\n\n.fa-yandex:before {\n  content: \"\\f413\"; }\n\n.fa-yandex-international:before {\n  content: \"\\f414\"; }\n\n.fa-yarn:before {\n  content: \"\\f7e3\"; }\n\n.fa-yelp:before {\n  content: \"\\f1e9\"; }\n\n.fa-yen-sign:before {\n  content: \"\\f157\"; }\n\n.fa-yin-yang:before {\n  content: \"\\f6ad\"; }\n\n.fa-yoast:before {\n  content: \"\\f2b1\"; }\n\n.fa-youtube:before {\n  content: \"\\f167\"; }\n\n.fa-youtube-square:before {\n  content: \"\\f431\"; }\n\n.fa-zhihu:before {\n  content: \"\\f63f\"; }\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto; }\n@font-face {\n  font-family: 'Font Awesome 5 Brands';\n  font-style: normal;\n  font-weight: 400;\n  font-display: block;\n  src: url(\"../../../../fonts/fa-brands-400.eot\");\n  src: url(\"../../../../fonts/fa-brands-400.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../../fonts/fa-brands-400.woff2\") format(\"woff2\"), url(\"../../../../fonts/fa-brands-400.woff\") format(\"woff\"), url(\"../../../../fonts/fa-brands-400.ttf\") format(\"truetype\"), url(\"../../../../fonts/fa-brands-400.svg#fontawesome\") format(\"svg\"); }\n\n.fab {\n  font-family: 'Font Awesome 5 Brands';\n  font-weight: 400; }\n@font-face {\n  font-family: 'Font Awesome 5 Free';\n  font-style: normal;\n  font-weight: 400;\n  font-display: block;\n  src: url(\"../../../../fonts/fa-regular-400.eot\");\n  src: url(\"../../../../fonts/fa-regular-400.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../../fonts/fa-regular-400.woff2\") format(\"woff2\"), url(\"../../../../fonts/fa-regular-400.woff\") format(\"woff\"), url(\"../../../../fonts/fa-regular-400.ttf\") format(\"truetype\"), url(\"../../../../fonts/fa-regular-400.svg#fontawesome\") format(\"svg\"); }\n\n.far {\n  font-family: 'Font Awesome 5 Free';\n  font-weight: 400; }\n@font-face {\n  font-family: 'Font Awesome 5 Free';\n  font-style: normal;\n  font-weight: 900;\n  font-display: block;\n  src: url(\"../../../../fonts/fa-solid-900.eot\");\n  src: url(\"../../../../fonts/fa-solid-900.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../../fonts/fa-solid-900.woff2\") format(\"woff2\"), url(\"../../../../fonts/fa-solid-900.woff\") format(\"woff\"), url(\"../../../../fonts/fa-solid-900.ttf\") format(\"truetype\"), url(\"../../../../fonts/fa-solid-900.svg#fontawesome\") format(\"svg\"); }\n\n.fa,\n.fas {\n  font-family: 'Font Awesome 5 Free';\n  font-weight: 900; }\n","@charset \"UTF-8\";\n\n@font-face {\n  font-family: \"dripicons-v2\";\n  src: url(\"../../../../fonts/dripicons-v2.eot\");\n  src:url(\"../../../../fonts/dripicons-v2.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../../../../fonts/dripicons-v2.woff\") format(\"woff\"),\n    url(\"../../../../fonts/dripicons-v2.ttf\") format(\"truetype\"),\n    url(\"../../../../fonts/dripicons-v2.svg#dripicons-v2\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n\n}\n\n[data-icon]:before {\n  font-family: \"dripicons-v2\" !important;\n  content: attr(data-icon);\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n[class^=\"dripicons-\"]:before,\n[class*=\" dripicons-\"]:before {\n  font-family: \"dripicons-v2\" !important;\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.dripicons-alarm:before {\n  content: \"\\61\";\n}\n.dripicons-align-center:before {\n  content: \"\\62\";\n}\n.dripicons-align-justify:before {\n  content: \"\\63\";\n}\n.dripicons-align-left:before {\n  content: \"\\64\";\n}\n.dripicons-align-right:before {\n  content: \"\\65\";\n}\n.dripicons-anchor:before {\n  content: \"\\66\";\n}\n.dripicons-archive:before {\n  content: \"\\67\";\n}\n.dripicons-arrow-down:before {\n  content: \"\\68\";\n}\n.dripicons-arrow-left:before {\n  content: \"\\69\";\n}\n.dripicons-arrow-right:before {\n  content: \"\\6a\";\n}\n.dripicons-arrow-thin-down:before {\n  content: \"\\6b\";\n}\n.dripicons-arrow-thin-left:before {\n  content: \"\\6c\";\n}\n.dripicons-arrow-thin-right:before {\n  content: \"\\6d\";\n}\n.dripicons-arrow-thin-up:before {\n  content: \"\\6e\";\n}\n.dripicons-arrow-up:before {\n  content: \"\\6f\";\n}\n.dripicons-article:before {\n  content: \"\\70\";\n}\n.dripicons-backspace:before {\n  content: \"\\71\";\n}\n.dripicons-basket:before {\n  content: \"\\72\";\n}\n.dripicons-basketball:before {\n  content: \"\\73\";\n}\n.dripicons-battery-empty:before {\n  content: \"\\74\";\n}\n.dripicons-battery-full:before {\n  content: \"\\75\";\n}\n.dripicons-battery-low:before {\n  content: \"\\76\";\n}\n.dripicons-battery-medium:before {\n  content: \"\\77\";\n}\n.dripicons-bell:before {\n  content: \"\\78\";\n}\n.dripicons-blog:before {\n  content: \"\\79\";\n}\n.dripicons-bluetooth:before {\n  content: \"\\7a\";\n}\n.dripicons-bold:before {\n  content: \"\\41\";\n}\n.dripicons-bookmark:before {\n  content: \"\\42\";\n}\n.dripicons-bookmarks:before {\n  content: \"\\43\";\n}\n.dripicons-box:before {\n  content: \"\\44\";\n}\n.dripicons-briefcase:before {\n  content: \"\\45\";\n}\n.dripicons-brightness-low:before {\n  content: \"\\46\";\n}\n.dripicons-brightness-max:before {\n  content: \"\\47\";\n}\n.dripicons-brightness-medium:before {\n  content: \"\\48\";\n}\n.dripicons-broadcast:before {\n  content: \"\\49\";\n}\n.dripicons-browser:before {\n  content: \"\\4a\";\n}\n.dripicons-browser-upload:before {\n  content: \"\\4b\";\n}\n.dripicons-brush:before {\n  content: \"\\4c\";\n}\n.dripicons-calendar:before {\n  content: \"\\4d\";\n}\n.dripicons-camcorder:before {\n  content: \"\\4e\";\n}\n.dripicons-camera:before {\n  content: \"\\4f\";\n}\n.dripicons-card:before {\n  content: \"\\50\";\n}\n.dripicons-cart:before {\n  content: \"\\51\";\n}\n.dripicons-checklist:before {\n  content: \"\\52\";\n}\n.dripicons-checkmark:before {\n  content: \"\\53\";\n}\n.dripicons-chevron-down:before {\n  content: \"\\54\";\n}\n.dripicons-chevron-left:before {\n  content: \"\\55\";\n}\n.dripicons-chevron-right:before {\n  content: \"\\56\";\n}\n.dripicons-chevron-up:before {\n  content: \"\\57\";\n}\n.dripicons-clipboard:before {\n  content: \"\\58\";\n}\n.dripicons-clock:before {\n  content: \"\\59\";\n}\n.dripicons-clockwise:before {\n  content: \"\\5a\";\n}\n.dripicons-cloud:before {\n  content: \"\\30\";\n}\n.dripicons-cloud-download:before {\n  content: \"\\31\";\n}\n.dripicons-cloud-upload:before {\n  content: \"\\32\";\n}\n.dripicons-code:before {\n  content: \"\\33\";\n}\n.dripicons-contract:before {\n  content: \"\\34\";\n}\n.dripicons-contract-2:before {\n  content: \"\\35\";\n}\n.dripicons-conversation:before {\n  content: \"\\36\";\n}\n.dripicons-copy:before {\n  content: \"\\37\";\n}\n.dripicons-crop:before {\n  content: \"\\38\";\n}\n.dripicons-cross:before {\n  content: \"\\39\";\n}\n.dripicons-crosshair:before {\n  content: \"\\21\";\n}\n.dripicons-cutlery:before {\n  content: \"\\22\";\n}\n.dripicons-device-desktop:before {\n  content: \"\\23\";\n}\n.dripicons-device-mobile:before {\n  content: \"\\24\";\n}\n.dripicons-device-tablet:before {\n  content: \"\\25\";\n}\n.dripicons-direction:before {\n  content: \"\\26\";\n}\n.dripicons-disc:before {\n  content: \"\\27\";\n}\n.dripicons-document:before {\n  content: \"\\28\";\n}\n.dripicons-document-delete:before {\n  content: \"\\29\";\n}\n.dripicons-document-edit:before {\n  content: \"\\2a\";\n}\n.dripicons-document-new:before {\n  content: \"\\2b\";\n}\n.dripicons-document-remove:before {\n  content: \"\\2c\";\n}\n.dripicons-dot:before {\n  content: \"\\2d\";\n}\n.dripicons-dots-2:before {\n  content: \"\\2e\";\n}\n.dripicons-dots-3:before {\n  content: \"\\2f\";\n}\n.dripicons-download:before {\n  content: \"\\3a\";\n}\n.dripicons-duplicate:before {\n  content: \"\\3b\";\n}\n.dripicons-enter:before {\n  content: \"\\3c\";\n}\n.dripicons-exit:before {\n  content: \"\\3d\";\n}\n.dripicons-expand:before {\n  content: \"\\3e\";\n}\n.dripicons-expand-2:before {\n  content: \"\\3f\";\n}\n.dripicons-experiment:before {\n  content: \"\\40\";\n}\n.dripicons-export:before {\n  content: \"\\5b\";\n}\n.dripicons-feed:before {\n  content: \"\\5d\";\n}\n.dripicons-flag:before {\n  content: \"\\5e\";\n}\n.dripicons-flashlight:before {\n  content: \"\\5f\";\n}\n.dripicons-folder:before {\n  content: \"\\60\";\n}\n.dripicons-folder-open:before {\n  content: \"\\7b\";\n}\n.dripicons-forward:before {\n  content: \"\\7c\";\n}\n.dripicons-gaming:before {\n  content: \"\\7d\";\n}\n.dripicons-gear:before {\n  content: \"\\7e\";\n}\n.dripicons-graduation:before {\n  content: \"\\5c\";\n}\n.dripicons-graph-bar:before {\n  content: \"\\e000\";\n}\n.dripicons-graph-line:before {\n  content: \"\\e001\";\n}\n.dripicons-graph-pie:before {\n  content: \"\\e002\";\n}\n.dripicons-headset:before {\n  content: \"\\e003\";\n}\n.dripicons-heart:before {\n  content: \"\\e004\";\n}\n.dripicons-help:before {\n  content: \"\\e005\";\n}\n.dripicons-home:before {\n  content: \"\\e006\";\n}\n.dripicons-hourglass:before {\n  content: \"\\e007\";\n}\n.dripicons-inbox:before {\n  content: \"\\e008\";\n}\n.dripicons-information:before {\n  content: \"\\e009\";\n}\n.dripicons-italic:before {\n  content: \"\\e00a\";\n}\n.dripicons-jewel:before {\n  content: \"\\e00b\";\n}\n.dripicons-lifting:before {\n  content: \"\\e00c\";\n}\n.dripicons-lightbulb:before {\n  content: \"\\e00d\";\n}\n.dripicons-link:before {\n  content: \"\\e00e\";\n}\n.dripicons-link-broken:before {\n  content: \"\\e00f\";\n}\n.dripicons-list:before {\n  content: \"\\e010\";\n}\n.dripicons-loading:before {\n  content: \"\\e011\";\n}\n.dripicons-location:before {\n  content: \"\\e012\";\n}\n.dripicons-lock:before {\n  content: \"\\e013\";\n}\n.dripicons-lock-open:before {\n  content: \"\\e014\";\n}\n.dripicons-mail:before {\n  content: \"\\e015\";\n}\n.dripicons-map:before {\n  content: \"\\e016\";\n}\n.dripicons-media-loop:before {\n  content: \"\\e017\";\n}\n.dripicons-media-next:before {\n  content: \"\\e018\";\n}\n.dripicons-media-pause:before {\n  content: \"\\e019\";\n}\n.dripicons-media-play:before {\n  content: \"\\e01a\";\n}\n.dripicons-media-previous:before {\n  content: \"\\e01b\";\n}\n.dripicons-media-record:before {\n  content: \"\\e01c\";\n}\n.dripicons-media-shuffle:before {\n  content: \"\\e01d\";\n}\n.dripicons-media-stop:before {\n  content: \"\\e01e\";\n}\n.dripicons-medical:before {\n  content: \"\\e01f\";\n}\n.dripicons-menu:before {\n  content: \"\\e020\";\n}\n.dripicons-message:before {\n  content: \"\\e021\";\n}\n.dripicons-meter:before {\n  content: \"\\e022\";\n}\n.dripicons-microphone:before {\n  content: \"\\e023\";\n}\n.dripicons-minus:before {\n  content: \"\\e024\";\n}\n.dripicons-monitor:before {\n  content: \"\\e025\";\n}\n.dripicons-move:before {\n  content: \"\\e026\";\n}\n.dripicons-music:before {\n  content: \"\\e027\";\n}\n.dripicons-network-1:before {\n  content: \"\\e028\";\n}\n.dripicons-network-2:before {\n  content: \"\\e029\";\n}\n.dripicons-network-3:before {\n  content: \"\\e02a\";\n}\n.dripicons-network-4:before {\n  content: \"\\e02b\";\n}\n.dripicons-network-5:before {\n  content: \"\\e02c\";\n}\n.dripicons-pamphlet:before {\n  content: \"\\e02d\";\n}\n.dripicons-paperclip:before {\n  content: \"\\e02e\";\n}\n.dripicons-pencil:before {\n  content: \"\\e02f\";\n}\n.dripicons-phone:before {\n  content: \"\\e030\";\n}\n.dripicons-photo:before {\n  content: \"\\e031\";\n}\n.dripicons-photo-group:before {\n  content: \"\\e032\";\n}\n.dripicons-pill:before {\n  content: \"\\e033\";\n}\n.dripicons-pin:before {\n  content: \"\\e034\";\n}\n.dripicons-plus:before {\n  content: \"\\e035\";\n}\n.dripicons-power:before {\n  content: \"\\e036\";\n}\n.dripicons-preview:before {\n  content: \"\\e037\";\n}\n.dripicons-print:before {\n  content: \"\\e038\";\n}\n.dripicons-pulse:before {\n  content: \"\\e039\";\n}\n.dripicons-question:before {\n  content: \"\\e03a\";\n}\n.dripicons-reply:before {\n  content: \"\\e03b\";\n}\n.dripicons-reply-all:before {\n  content: \"\\e03c\";\n}\n.dripicons-return:before {\n  content: \"\\e03d\";\n}\n.dripicons-retweet:before {\n  content: \"\\e03e\";\n}\n.dripicons-rocket:before {\n  content: \"\\e03f\";\n}\n.dripicons-scale:before {\n  content: \"\\e040\";\n}\n.dripicons-search:before {\n  content: \"\\e041\";\n}\n.dripicons-shopping-bag:before {\n  content: \"\\e042\";\n}\n.dripicons-skip:before {\n  content: \"\\e043\";\n}\n.dripicons-stack:before {\n  content: \"\\e044\";\n}\n.dripicons-star:before {\n  content: \"\\e045\";\n}\n.dripicons-stopwatch:before {\n  content: \"\\e046\";\n}\n.dripicons-store:before {\n  content: \"\\e047\";\n}\n.dripicons-suitcase:before {\n  content: \"\\e048\";\n}\n.dripicons-swap:before {\n  content: \"\\e049\";\n}\n.dripicons-tag:before {\n  content: \"\\e04a\";\n}\n.dripicons-tag-delete:before {\n  content: \"\\e04b\";\n}\n.dripicons-tags:before {\n  content: \"\\e04c\";\n}\n.dripicons-thumbs-down:before {\n  content: \"\\e04d\";\n}\n.dripicons-thumbs-up:before {\n  content: \"\\e04e\";\n}\n.dripicons-ticket:before {\n  content: \"\\e04f\";\n}\n.dripicons-time-reverse:before {\n  content: \"\\e050\";\n}\n.dripicons-to-do:before {\n  content: \"\\e051\";\n}\n.dripicons-toggles:before {\n  content: \"\\e052\";\n}\n.dripicons-trash:before {\n  content: \"\\e053\";\n}\n.dripicons-trophy:before {\n  content: \"\\e054\";\n}\n.dripicons-upload:before {\n  content: \"\\e055\";\n}\n.dripicons-user:before {\n  content: \"\\e056\";\n}\n.dripicons-user-group:before {\n  content: \"\\e057\";\n}\n.dripicons-user-id:before {\n  content: \"\\e058\";\n}\n.dripicons-vibrate:before {\n  content: \"\\e059\";\n}\n.dripicons-view-apps:before {\n  content: \"\\e05a\";\n}\n.dripicons-view-list:before {\n  content: \"\\e05b\";\n}\n.dripicons-view-list-large:before {\n  content: \"\\e05c\";\n}\n.dripicons-view-thumb:before {\n  content: \"\\e05d\";\n}\n.dripicons-volume-full:before {\n  content: \"\\e05e\";\n}\n.dripicons-volume-low:before {\n  content: \"\\e05f\";\n}\n.dripicons-volume-medium:before {\n  content: \"\\e060\";\n}\n.dripicons-volume-off:before {\n  content: \"\\e061\";\n}\n.dripicons-wallet:before {\n  content: \"\\e062\";\n}\n.dripicons-warning:before {\n  content: \"\\e063\";\n}\n.dripicons-web:before {\n  content: \"\\e064\";\n}\n.dripicons-weight:before {\n  content: \"\\e065\";\n}\n.dripicons-wifi:before {\n  content: \"\\e066\";\n}\n.dripicons-wrong:before {\n  content: \"\\e067\";\n}\n.dripicons-zoom-in:before {\n  content: \"\\e068\";\n}\n.dripicons-zoom-out:before {\n  content: \"\\e069\";\n}\n","/*\n* Remix Icon v2.4.0\n* https://remixicon.com\n* https://github.com/Remix-Design/RemixIcon\n*\n* Copyright RemixIcon.com\n* Released under the Apache License Version 2.0\n*\n* Date: 2020-04-20\n*/\n@font-face {\n  font-family: \"remixicon\";\n  src: url('../../../../fonts/remixicon.eot?t=1587359857360'); /* IE9*/\n  src: url('../../../../fonts/remixicon.eot?t=1587359857360#iefix') format('embedded-opentype'), /* IE6-IE8 */\n  url(\"../../../../fonts/remixicon.woff2?t=1587359857360\") format(\"woff2\"),\n  url(\"../../../../fonts/remixicon.woff?t=1587359857360\") format(\"woff\"),\n  url('../../../../fonts/remixicon.ttf?t=1587359857360') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+*/\n  url('../../../../fonts/remixicon.svg?t=1587359857360#remixicon') format('svg'); /* iOS 4.1- */\n  font-display: swap;\n}\n\n[class^=\"ri-\"], [class*=\" ri-\"] {\n  font-family: 'remixicon' !important;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.ri-lg { font-size: 1.3333em; line-height: 0.75em; vertical-align: -.0667em; }\n.ri-xl { font-size: 1.5em; line-height: 0.6666em; vertical-align: -.075em; }\n.ri-xxs { font-size: .5em; }\n.ri-xs { font-size: .75em; }\n.ri-sm { font-size: .875em }\n.ri-1x { font-size: 1em; }\n.ri-2x { font-size: 2em; }\n.ri-3x { font-size: 3em; }\n.ri-4x { font-size: 4em; }\n.ri-5x { font-size: 5em; }\n.ri-6x { font-size: 6em; }\n.ri-7x { font-size: 7em; }\n.ri-8x { font-size: 8em; }\n.ri-9x { font-size: 9em; }\n.ri-10x { font-size: 10em; }\n.ri-fw { text-align: center; width: 1.25em; }\n\n.ri-4k-fill:before { content: \"\\ea01\"; }\n.ri-4k-line:before { content: \"\\ea02\"; }\n.ri-a-b:before { content: \"\\ea03\"; }\n.ri-account-box-fill:before { content: \"\\ea04\"; }\n.ri-account-box-line:before { content: \"\\ea05\"; }\n.ri-account-circle-fill:before { content: \"\\ea06\"; }\n.ri-account-circle-line:before { content: \"\\ea07\"; }\n.ri-account-pin-box-fill:before { content: \"\\ea08\"; }\n.ri-account-pin-box-line:before { content: \"\\ea09\"; }\n.ri-account-pin-circle-fill:before { content: \"\\ea0a\"; }\n.ri-account-pin-circle-line:before { content: \"\\ea0b\"; }\n.ri-add-box-fill:before { content: \"\\ea0c\"; }\n.ri-add-box-line:before { content: \"\\ea0d\"; }\n.ri-add-circle-fill:before { content: \"\\ea0e\"; }\n.ri-add-circle-line:before { content: \"\\ea0f\"; }\n.ri-add-fill:before { content: \"\\ea10\"; }\n.ri-add-line:before { content: \"\\ea11\"; }\n.ri-admin-fill:before { content: \"\\ea12\"; }\n.ri-admin-line:before { content: \"\\ea13\"; }\n.ri-advertisement-fill:before { content: \"\\ea14\"; }\n.ri-advertisement-line:before { content: \"\\ea15\"; }\n.ri-airplay-fill:before { content: \"\\ea16\"; }\n.ri-airplay-line:before { content: \"\\ea17\"; }\n.ri-alarm-fill:before { content: \"\\ea18\"; }\n.ri-alarm-line:before { content: \"\\ea19\"; }\n.ri-alarm-warning-fill:before { content: \"\\ea1a\"; }\n.ri-alarm-warning-line:before { content: \"\\ea1b\"; }\n.ri-album-fill:before { content: \"\\ea1c\"; }\n.ri-album-line:before { content: \"\\ea1d\"; }\n.ri-alert-fill:before { content: \"\\ea1e\"; }\n.ri-alert-line:before { content: \"\\ea1f\"; }\n.ri-aliens-fill:before { content: \"\\ea20\"; }\n.ri-aliens-line:before { content: \"\\ea21\"; }\n.ri-align-bottom:before { content: \"\\ea22\"; }\n.ri-align-center:before { content: \"\\ea23\"; }\n.ri-align-justify:before { content: \"\\ea24\"; }\n.ri-align-left:before { content: \"\\ea25\"; }\n.ri-align-right:before { content: \"\\ea26\"; }\n.ri-align-top:before { content: \"\\ea27\"; }\n.ri-align-vertically:before { content: \"\\ea28\"; }\n.ri-alipay-fill:before { content: \"\\ea29\"; }\n.ri-alipay-line:before { content: \"\\ea2a\"; }\n.ri-amazon-fill:before { content: \"\\ea2b\"; }\n.ri-amazon-line:before { content: \"\\ea2c\"; }\n.ri-anchor-fill:before { content: \"\\ea2d\"; }\n.ri-anchor-line:before { content: \"\\ea2e\"; }\n.ri-ancient-gate-fill:before { content: \"\\ea2f\"; }\n.ri-ancient-gate-line:before { content: \"\\ea30\"; }\n.ri-ancient-pavilion-fill:before { content: \"\\ea31\"; }\n.ri-ancient-pavilion-line:before { content: \"\\ea32\"; }\n.ri-android-fill:before { content: \"\\ea33\"; }\n.ri-android-line:before { content: \"\\ea34\"; }\n.ri-angularjs-fill:before { content: \"\\ea35\"; }\n.ri-angularjs-line:before { content: \"\\ea36\"; }\n.ri-anticlockwise-2-fill:before { content: \"\\ea37\"; }\n.ri-anticlockwise-2-line:before { content: \"\\ea38\"; }\n.ri-anticlockwise-fill:before { content: \"\\ea39\"; }\n.ri-anticlockwise-line:before { content: \"\\ea3a\"; }\n.ri-app-store-fill:before { content: \"\\ea3b\"; }\n.ri-app-store-line:before { content: \"\\ea3c\"; }\n.ri-apple-fill:before { content: \"\\ea3d\"; }\n.ri-apple-line:before { content: \"\\ea3e\"; }\n.ri-apps-2-fill:before { content: \"\\ea3f\"; }\n.ri-apps-2-line:before { content: \"\\ea40\"; }\n.ri-apps-fill:before { content: \"\\ea41\"; }\n.ri-apps-line:before { content: \"\\ea42\"; }\n.ri-archive-drawer-fill:before { content: \"\\ea43\"; }\n.ri-archive-drawer-line:before { content: \"\\ea44\"; }\n.ri-archive-fill:before { content: \"\\ea45\"; }\n.ri-archive-line:before { content: \"\\ea46\"; }\n.ri-arrow-down-circle-fill:before { content: \"\\ea47\"; }\n.ri-arrow-down-circle-line:before { content: \"\\ea48\"; }\n.ri-arrow-down-fill:before { content: \"\\ea49\"; }\n.ri-arrow-down-line:before { content: \"\\ea4a\"; }\n.ri-arrow-down-s-fill:before { content: \"\\ea4b\"; }\n.ri-arrow-down-s-line:before { content: \"\\ea4c\"; }\n.ri-arrow-drop-down-fill:before { content: \"\\ea4d\"; }\n.ri-arrow-drop-down-line:before { content: \"\\ea4e\"; }\n.ri-arrow-drop-left-fill:before { content: \"\\ea4f\"; }\n.ri-arrow-drop-left-line:before { content: \"\\ea50\"; }\n.ri-arrow-drop-right-fill:before { content: \"\\ea51\"; }\n.ri-arrow-drop-right-line:before { content: \"\\ea52\"; }\n.ri-arrow-drop-up-fill:before { content: \"\\ea53\"; }\n.ri-arrow-drop-up-line:before { content: \"\\ea54\"; }\n.ri-arrow-go-back-fill:before { content: \"\\ea55\"; }\n.ri-arrow-go-back-line:before { content: \"\\ea56\"; }\n.ri-arrow-go-forward-fill:before { content: \"\\ea57\"; }\n.ri-arrow-go-forward-line:before { content: \"\\ea58\"; }\n.ri-arrow-left-circle-fill:before { content: \"\\ea59\"; }\n.ri-arrow-left-circle-line:before { content: \"\\ea5a\"; }\n.ri-arrow-left-down-fill:before { content: \"\\ea5b\"; }\n.ri-arrow-left-down-line:before { content: \"\\ea5c\"; }\n.ri-arrow-left-fill:before { content: \"\\ea5d\"; }\n.ri-arrow-left-line:before { content: \"\\ea5e\"; }\n.ri-arrow-left-right-fill:before { content: \"\\ea5f\"; }\n.ri-arrow-left-right-line:before { content: \"\\ea60\"; }\n.ri-arrow-left-s-fill:before { content: \"\\ea61\"; }\n.ri-arrow-left-s-line:before { content: \"\\ea62\"; }\n.ri-arrow-left-up-fill:before { content: \"\\ea63\"; }\n.ri-arrow-left-up-line:before { content: \"\\ea64\"; }\n.ri-arrow-right-circle-fill:before { content: \"\\ea65\"; }\n.ri-arrow-right-circle-line:before { content: \"\\ea66\"; }\n.ri-arrow-right-down-fill:before { content: \"\\ea67\"; }\n.ri-arrow-right-down-line:before { content: \"\\ea68\"; }\n.ri-arrow-right-fill:before { content: \"\\ea69\"; }\n.ri-arrow-right-line:before { content: \"\\ea6a\"; }\n.ri-arrow-right-s-fill:before { content: \"\\ea6b\"; }\n.ri-arrow-right-s-line:before { content: \"\\ea6c\"; }\n.ri-arrow-right-up-fill:before { content: \"\\ea6d\"; }\n.ri-arrow-right-up-line:before { content: \"\\ea6e\"; }\n.ri-arrow-up-circle-fill:before { content: \"\\ea6f\"; }\n.ri-arrow-up-circle-line:before { content: \"\\ea70\"; }\n.ri-arrow-up-down-fill:before { content: \"\\ea71\"; }\n.ri-arrow-up-down-line:before { content: \"\\ea72\"; }\n.ri-arrow-up-fill:before { content: \"\\ea73\"; }\n.ri-arrow-up-line:before { content: \"\\ea74\"; }\n.ri-arrow-up-s-fill:before { content: \"\\ea75\"; }\n.ri-arrow-up-s-line:before { content: \"\\ea76\"; }\n.ri-artboard-2-fill:before { content: \"\\ea77\"; }\n.ri-artboard-2-line:before { content: \"\\ea78\"; }\n.ri-artboard-fill:before { content: \"\\ea79\"; }\n.ri-artboard-line:before { content: \"\\ea7a\"; }\n.ri-article-fill:before { content: \"\\ea7b\"; }\n.ri-article-line:before { content: \"\\ea7c\"; }\n.ri-aspect-ratio-fill:before { content: \"\\ea7d\"; }\n.ri-aspect-ratio-line:before { content: \"\\ea7e\"; }\n.ri-asterisk:before { content: \"\\ea7f\"; }\n.ri-at-fill:before { content: \"\\ea80\"; }\n.ri-at-line:before { content: \"\\ea81\"; }\n.ri-attachment-2:before { content: \"\\ea82\"; }\n.ri-attachment-fill:before { content: \"\\ea83\"; }\n.ri-attachment-line:before { content: \"\\ea84\"; }\n.ri-auction-fill:before { content: \"\\ea85\"; }\n.ri-auction-line:before { content: \"\\ea86\"; }\n.ri-award-fill:before { content: \"\\ea87\"; }\n.ri-award-line:before { content: \"\\ea88\"; }\n.ri-baidu-fill:before { content: \"\\ea89\"; }\n.ri-baidu-line:before { content: \"\\ea8a\"; }\n.ri-ball-pen-fill:before { content: \"\\ea8b\"; }\n.ri-ball-pen-line:before { content: \"\\ea8c\"; }\n.ri-bank-card-2-fill:before { content: \"\\ea8d\"; }\n.ri-bank-card-2-line:before { content: \"\\ea8e\"; }\n.ri-bank-card-fill:before { content: \"\\ea8f\"; }\n.ri-bank-card-line:before { content: \"\\ea90\"; }\n.ri-bank-fill:before { content: \"\\ea91\"; }\n.ri-bank-line:before { content: \"\\ea92\"; }\n.ri-bar-chart-2-fill:before { content: \"\\ea93\"; }\n.ri-bar-chart-2-line:before { content: \"\\ea94\"; }\n.ri-bar-chart-box-fill:before { content: \"\\ea95\"; }\n.ri-bar-chart-box-line:before { content: \"\\ea96\"; }\n.ri-bar-chart-fill:before { content: \"\\ea97\"; }\n.ri-bar-chart-grouped-fill:before { content: \"\\ea98\"; }\n.ri-bar-chart-grouped-line:before { content: \"\\ea99\"; }\n.ri-bar-chart-horizontal-fill:before { content: \"\\ea9a\"; }\n.ri-bar-chart-horizontal-line:before { content: \"\\ea9b\"; }\n.ri-bar-chart-line:before { content: \"\\ea9c\"; }\n.ri-barcode-box-fill:before { content: \"\\ea9d\"; }\n.ri-barcode-box-line:before { content: \"\\ea9e\"; }\n.ri-barcode-fill:before { content: \"\\ea9f\"; }\n.ri-barcode-line:before { content: \"\\eaa0\"; }\n.ri-barricade-fill:before { content: \"\\eaa1\"; }\n.ri-barricade-line:before { content: \"\\eaa2\"; }\n.ri-base-station-fill:before { content: \"\\eaa3\"; }\n.ri-base-station-line:before { content: \"\\eaa4\"; }\n.ri-basketball-fill:before { content: \"\\eaa5\"; }\n.ri-basketball-line:before { content: \"\\eaa6\"; }\n.ri-battery-2-charge-fill:before { content: \"\\eaa7\"; }\n.ri-battery-2-charge-line:before { content: \"\\eaa8\"; }\n.ri-battery-2-fill:before { content: \"\\eaa9\"; }\n.ri-battery-2-line:before { content: \"\\eaaa\"; }\n.ri-battery-charge-fill:before { content: \"\\eaab\"; }\n.ri-battery-charge-line:before { content: \"\\eaac\"; }\n.ri-battery-fill:before { content: \"\\eaad\"; }\n.ri-battery-line:before { content: \"\\eaae\"; }\n.ri-battery-low-fill:before { content: \"\\eaaf\"; }\n.ri-battery-low-line:before { content: \"\\eab0\"; }\n.ri-battery-saver-fill:before { content: \"\\eab1\"; }\n.ri-battery-saver-line:before { content: \"\\eab2\"; }\n.ri-battery-share-fill:before { content: \"\\eab3\"; }\n.ri-battery-share-line:before { content: \"\\eab4\"; }\n.ri-bear-smile-fill:before { content: \"\\eab5\"; }\n.ri-bear-smile-line:before { content: \"\\eab6\"; }\n.ri-behance-fill:before { content: \"\\eab7\"; }\n.ri-behance-line:before { content: \"\\eab8\"; }\n.ri-bell-fill:before { content: \"\\eab9\"; }\n.ri-bell-line:before { content: \"\\eaba\"; }\n.ri-bike-fill:before { content: \"\\eabb\"; }\n.ri-bike-line:before { content: \"\\eabc\"; }\n.ri-bilibili-fill:before { content: \"\\eabd\"; }\n.ri-bilibili-line:before { content: \"\\eabe\"; }\n.ri-bill-fill:before { content: \"\\eabf\"; }\n.ri-bill-line:before { content: \"\\eac0\"; }\n.ri-billiards-fill:before { content: \"\\eac1\"; }\n.ri-billiards-line:before { content: \"\\eac2\"; }\n.ri-bit-coin-fill:before { content: \"\\eac3\"; }\n.ri-bit-coin-line:before { content: \"\\eac4\"; }\n.ri-blaze-fill:before { content: \"\\eac5\"; }\n.ri-blaze-line:before { content: \"\\eac6\"; }\n.ri-bluetooth-connect-fill:before { content: \"\\eac7\"; }\n.ri-bluetooth-connect-line:before { content: \"\\eac8\"; }\n.ri-bluetooth-fill:before { content: \"\\eac9\"; }\n.ri-bluetooth-line:before { content: \"\\eaca\"; }\n.ri-blur-off-fill:before { content: \"\\eacb\"; }\n.ri-blur-off-line:before { content: \"\\eacc\"; }\n.ri-body-scan-fill:before { content: \"\\eacd\"; }\n.ri-body-scan-line:before { content: \"\\eace\"; }\n.ri-bold:before { content: \"\\eacf\"; }\n.ri-book-2-fill:before { content: \"\\ead0\"; }\n.ri-book-2-line:before { content: \"\\ead1\"; }\n.ri-book-3-fill:before { content: \"\\ead2\"; }\n.ri-book-3-line:before { content: \"\\ead3\"; }\n.ri-book-fill:before { content: \"\\ead4\"; }\n.ri-book-line:before { content: \"\\ead5\"; }\n.ri-book-mark-fill:before { content: \"\\ead6\"; }\n.ri-book-mark-line:before { content: \"\\ead7\"; }\n.ri-book-open-fill:before { content: \"\\ead8\"; }\n.ri-book-open-line:before { content: \"\\ead9\"; }\n.ri-book-read-fill:before { content: \"\\eada\"; }\n.ri-book-read-line:before { content: \"\\eadb\"; }\n.ri-booklet-fill:before { content: \"\\eadc\"; }\n.ri-booklet-line:before { content: \"\\eadd\"; }\n.ri-bookmark-2-fill:before { content: \"\\eade\"; }\n.ri-bookmark-2-line:before { content: \"\\eadf\"; }\n.ri-bookmark-3-fill:before { content: \"\\eae0\"; }\n.ri-bookmark-3-line:before { content: \"\\eae1\"; }\n.ri-bookmark-fill:before { content: \"\\eae2\"; }\n.ri-bookmark-line:before { content: \"\\eae3\"; }\n.ri-boxing-fill:before { content: \"\\eae4\"; }\n.ri-boxing-line:before { content: \"\\eae5\"; }\n.ri-braces-fill:before { content: \"\\eae6\"; }\n.ri-braces-line:before { content: \"\\eae7\"; }\n.ri-brackets-fill:before { content: \"\\eae8\"; }\n.ri-brackets-line:before { content: \"\\eae9\"; }\n.ri-briefcase-2-fill:before { content: \"\\eaea\"; }\n.ri-briefcase-2-line:before { content: \"\\eaeb\"; }\n.ri-briefcase-3-fill:before { content: \"\\eaec\"; }\n.ri-briefcase-3-line:before { content: \"\\eaed\"; }\n.ri-briefcase-4-fill:before { content: \"\\eaee\"; }\n.ri-briefcase-4-line:before { content: \"\\eaef\"; }\n.ri-briefcase-5-fill:before { content: \"\\eaf0\"; }\n.ri-briefcase-5-line:before { content: \"\\eaf1\"; }\n.ri-briefcase-fill:before { content: \"\\eaf2\"; }\n.ri-briefcase-line:before { content: \"\\eaf3\"; }\n.ri-bring-forward:before { content: \"\\eaf4\"; }\n.ri-bring-to-front:before { content: \"\\eaf5\"; }\n.ri-broadcast-fill:before { content: \"\\eaf6\"; }\n.ri-broadcast-line:before { content: \"\\eaf7\"; }\n.ri-brush-2-fill:before { content: \"\\eaf8\"; }\n.ri-brush-2-line:before { content: \"\\eaf9\"; }\n.ri-brush-3-fill:before { content: \"\\eafa\"; }\n.ri-brush-3-line:before { content: \"\\eafb\"; }\n.ri-brush-4-fill:before { content: \"\\eafc\"; }\n.ri-brush-4-line:before { content: \"\\eafd\"; }\n.ri-brush-fill:before { content: \"\\eafe\"; }\n.ri-brush-line:before { content: \"\\eaff\"; }\n.ri-bubble-chart-fill:before { content: \"\\eb00\"; }\n.ri-bubble-chart-line:before { content: \"\\eb01\"; }\n.ri-bug-2-fill:before { content: \"\\eb02\"; }\n.ri-bug-2-line:before { content: \"\\eb03\"; }\n.ri-bug-fill:before { content: \"\\eb04\"; }\n.ri-bug-line:before { content: \"\\eb05\"; }\n.ri-building-2-fill:before { content: \"\\eb06\"; }\n.ri-building-2-line:before { content: \"\\eb07\"; }\n.ri-building-3-fill:before { content: \"\\eb08\"; }\n.ri-building-3-line:before { content: \"\\eb09\"; }\n.ri-building-4-fill:before { content: \"\\eb0a\"; }\n.ri-building-4-line:before { content: \"\\eb0b\"; }\n.ri-building-fill:before { content: \"\\eb0c\"; }\n.ri-building-line:before { content: \"\\eb0d\"; }\n.ri-bus-2-fill:before { content: \"\\eb0e\"; }\n.ri-bus-2-line:before { content: \"\\eb0f\"; }\n.ri-bus-fill:before { content: \"\\eb10\"; }\n.ri-bus-line:before { content: \"\\eb11\"; }\n.ri-bus-wifi-fill:before { content: \"\\eb12\"; }\n.ri-bus-wifi-line:before { content: \"\\eb13\"; }\n.ri-cake-2-fill:before { content: \"\\eb14\"; }\n.ri-cake-2-line:before { content: \"\\eb15\"; }\n.ri-cake-3-fill:before { content: \"\\eb16\"; }\n.ri-cake-3-line:before { content: \"\\eb17\"; }\n.ri-cake-fill:before { content: \"\\eb18\"; }\n.ri-cake-line:before { content: \"\\eb19\"; }\n.ri-calculator-fill:before { content: \"\\eb1a\"; }\n.ri-calculator-line:before { content: \"\\eb1b\"; }\n.ri-calendar-2-fill:before { content: \"\\eb1c\"; }\n.ri-calendar-2-line:before { content: \"\\eb1d\"; }\n.ri-calendar-check-fill:before { content: \"\\eb1e\"; }\n.ri-calendar-check-line:before { content: \"\\eb1f\"; }\n.ri-calendar-event-fill:before { content: \"\\eb20\"; }\n.ri-calendar-event-line:before { content: \"\\eb21\"; }\n.ri-calendar-fill:before { content: \"\\eb22\"; }\n.ri-calendar-line:before { content: \"\\eb23\"; }\n.ri-calendar-todo-fill:before { content: \"\\eb24\"; }\n.ri-calendar-todo-line:before { content: \"\\eb25\"; }\n.ri-camera-2-fill:before { content: \"\\eb26\"; }\n.ri-camera-2-line:before { content: \"\\eb27\"; }\n.ri-camera-3-fill:before { content: \"\\eb28\"; }\n.ri-camera-3-line:before { content: \"\\eb29\"; }\n.ri-camera-fill:before { content: \"\\eb2a\"; }\n.ri-camera-lens-fill:before { content: \"\\eb2b\"; }\n.ri-camera-lens-line:before { content: \"\\eb2c\"; }\n.ri-camera-line:before { content: \"\\eb2d\"; }\n.ri-camera-off-fill:before { content: \"\\eb2e\"; }\n.ri-camera-off-line:before { content: \"\\eb2f\"; }\n.ri-camera-switch-fill:before { content: \"\\eb30\"; }\n.ri-camera-switch-line:before { content: \"\\eb31\"; }\n.ri-car-fill:before { content: \"\\eb32\"; }\n.ri-car-line:before { content: \"\\eb33\"; }\n.ri-car-washing-fill:before { content: \"\\eb34\"; }\n.ri-car-washing-line:before { content: \"\\eb35\"; }\n.ri-caravan-fill:before { content: \"\\eb36\"; }\n.ri-caravan-line:before { content: \"\\eb37\"; }\n.ri-cast-fill:before { content: \"\\eb38\"; }\n.ri-cast-line:before { content: \"\\eb39\"; }\n.ri-cellphone-fill:before { content: \"\\eb3a\"; }\n.ri-cellphone-line:before { content: \"\\eb3b\"; }\n.ri-celsius-fill:before { content: \"\\eb3c\"; }\n.ri-celsius-line:before { content: \"\\eb3d\"; }\n.ri-centos-fill:before { content: \"\\eb3e\"; }\n.ri-centos-line:before { content: \"\\eb3f\"; }\n.ri-character-recognition-fill:before { content: \"\\eb40\"; }\n.ri-character-recognition-line:before { content: \"\\eb41\"; }\n.ri-charging-pile-2-fill:before { content: \"\\eb42\"; }\n.ri-charging-pile-2-line:before { content: \"\\eb43\"; }\n.ri-charging-pile-fill:before { content: \"\\eb44\"; }\n.ri-charging-pile-line:before { content: \"\\eb45\"; }\n.ri-chat-1-fill:before { content: \"\\eb46\"; }\n.ri-chat-1-line:before { content: \"\\eb47\"; }\n.ri-chat-2-fill:before { content: \"\\eb48\"; }\n.ri-chat-2-line:before { content: \"\\eb49\"; }\n.ri-chat-3-fill:before { content: \"\\eb4a\"; }\n.ri-chat-3-line:before { content: \"\\eb4b\"; }\n.ri-chat-4-fill:before { content: \"\\eb4c\"; }\n.ri-chat-4-line:before { content: \"\\eb4d\"; }\n.ri-chat-check-fill:before { content: \"\\eb4e\"; }\n.ri-chat-check-line:before { content: \"\\eb4f\"; }\n.ri-chat-delete-fill:before { content: \"\\eb50\"; }\n.ri-chat-delete-line:before { content: \"\\eb51\"; }\n.ri-chat-download-fill:before { content: \"\\eb52\"; }\n.ri-chat-download-line:before { content: \"\\eb53\"; }\n.ri-chat-follow-up-fill:before { content: \"\\eb54\"; }\n.ri-chat-follow-up-line:before { content: \"\\eb55\"; }\n.ri-chat-forward-fill:before { content: \"\\eb56\"; }\n.ri-chat-forward-line:before { content: \"\\eb57\"; }\n.ri-chat-heart-fill:before { content: \"\\eb58\"; }\n.ri-chat-heart-line:before { content: \"\\eb59\"; }\n.ri-chat-history-fill:before { content: \"\\eb5a\"; }\n.ri-chat-history-line:before { content: \"\\eb5b\"; }\n.ri-chat-new-fill:before { content: \"\\eb5c\"; }\n.ri-chat-new-line:before { content: \"\\eb5d\"; }\n.ri-chat-off-fill:before { content: \"\\eb5e\"; }\n.ri-chat-off-line:before { content: \"\\eb5f\"; }\n.ri-chat-poll-fill:before { content: \"\\eb60\"; }\n.ri-chat-poll-line:before { content: \"\\eb61\"; }\n.ri-chat-private-fill:before { content: \"\\eb62\"; }\n.ri-chat-private-line:before { content: \"\\eb63\"; }\n.ri-chat-quote-fill:before { content: \"\\eb64\"; }\n.ri-chat-quote-line:before { content: \"\\eb65\"; }\n.ri-chat-settings-fill:before { content: \"\\eb66\"; }\n.ri-chat-settings-line:before { content: \"\\eb67\"; }\n.ri-chat-smile-2-fill:before { content: \"\\eb68\"; }\n.ri-chat-smile-2-line:before { content: \"\\eb69\"; }\n.ri-chat-smile-3-fill:before { content: \"\\eb6a\"; }\n.ri-chat-smile-3-line:before { content: \"\\eb6b\"; }\n.ri-chat-smile-fill:before { content: \"\\eb6c\"; }\n.ri-chat-smile-line:before { content: \"\\eb6d\"; }\n.ri-chat-upload-fill:before { content: \"\\eb6e\"; }\n.ri-chat-upload-line:before { content: \"\\eb6f\"; }\n.ri-chat-voice-fill:before { content: \"\\eb70\"; }\n.ri-chat-voice-line:before { content: \"\\eb71\"; }\n.ri-check-double-fill:before { content: \"\\eb72\"; }\n.ri-check-double-line:before { content: \"\\eb73\"; }\n.ri-check-fill:before { content: \"\\eb74\"; }\n.ri-check-line:before { content: \"\\eb75\"; }\n.ri-checkbox-blank-circle-fill:before { content: \"\\eb76\"; }\n.ri-checkbox-blank-circle-line:before { content: \"\\eb77\"; }\n.ri-checkbox-blank-fill:before { content: \"\\eb78\"; }\n.ri-checkbox-blank-line:before { content: \"\\eb79\"; }\n.ri-checkbox-circle-fill:before { content: \"\\eb7a\"; }\n.ri-checkbox-circle-line:before { content: \"\\eb7b\"; }\n.ri-checkbox-fill:before { content: \"\\eb7c\"; }\n.ri-checkbox-indeterminate-fill:before { content: \"\\eb7d\"; }\n.ri-checkbox-indeterminate-line:before { content: \"\\eb7e\"; }\n.ri-checkbox-line:before { content: \"\\eb7f\"; }\n.ri-checkbox-multiple-blank-fill:before { content: \"\\eb80\"; }\n.ri-checkbox-multiple-blank-line:before { content: \"\\eb81\"; }\n.ri-checkbox-multiple-fill:before { content: \"\\eb82\"; }\n.ri-checkbox-multiple-line:before { content: \"\\eb83\"; }\n.ri-china-railway-fill:before { content: \"\\eb84\"; }\n.ri-china-railway-line:before { content: \"\\eb85\"; }\n.ri-chrome-fill:before { content: \"\\eb86\"; }\n.ri-chrome-line:before { content: \"\\eb87\"; }\n.ri-clapperboard-fill:before { content: \"\\eb88\"; }\n.ri-clapperboard-line:before { content: \"\\eb89\"; }\n.ri-clipboard-fill:before { content: \"\\eb8a\"; }\n.ri-clipboard-line:before { content: \"\\eb8b\"; }\n.ri-clockwise-2-fill:before { content: \"\\eb8c\"; }\n.ri-clockwise-2-line:before { content: \"\\eb8d\"; }\n.ri-clockwise-fill:before { content: \"\\eb8e\"; }\n.ri-clockwise-line:before { content: \"\\eb8f\"; }\n.ri-close-circle-fill:before { content: \"\\eb90\"; }\n.ri-close-circle-line:before { content: \"\\eb91\"; }\n.ri-close-fill:before { content: \"\\eb92\"; }\n.ri-close-line:before { content: \"\\eb93\"; }\n.ri-cloud-fill:before { content: \"\\eb94\"; }\n.ri-cloud-line:before { content: \"\\eb95\"; }\n.ri-cloud-off-fill:before { content: \"\\eb96\"; }\n.ri-cloud-off-line:before { content: \"\\eb97\"; }\n.ri-cloud-windy-fill:before { content: \"\\eb98\"; }\n.ri-cloud-windy-line:before { content: \"\\eb99\"; }\n.ri-cloudy-2-fill:before { content: \"\\eb9a\"; }\n.ri-cloudy-2-line:before { content: \"\\eb9b\"; }\n.ri-cloudy-fill:before { content: \"\\eb9c\"; }\n.ri-cloudy-line:before { content: \"\\eb9d\"; }\n.ri-code-box-fill:before { content: \"\\eb9e\"; }\n.ri-code-box-line:before { content: \"\\eb9f\"; }\n.ri-code-fill:before { content: \"\\eba0\"; }\n.ri-code-line:before { content: \"\\eba1\"; }\n.ri-code-s-fill:before { content: \"\\eba2\"; }\n.ri-code-s-line:before { content: \"\\eba3\"; }\n.ri-code-s-slash-fill:before { content: \"\\eba4\"; }\n.ri-code-s-slash-line:before { content: \"\\eba5\"; }\n.ri-code-view:before { content: \"\\eba6\"; }\n.ri-codepen-fill:before { content: \"\\eba7\"; }\n.ri-codepen-line:before { content: \"\\eba8\"; }\n.ri-coin-fill:before { content: \"\\eba9\"; }\n.ri-coin-line:before { content: \"\\ebaa\"; }\n.ri-coins-fill:before { content: \"\\ebab\"; }\n.ri-coins-line:before { content: \"\\ebac\"; }\n.ri-command-fill:before { content: \"\\ebad\"; }\n.ri-command-line:before { content: \"\\ebae\"; }\n.ri-community-fill:before { content: \"\\ebaf\"; }\n.ri-community-line:before { content: \"\\ebb0\"; }\n.ri-compass-2-fill:before { content: \"\\ebb1\"; }\n.ri-compass-2-line:before { content: \"\\ebb2\"; }\n.ri-compass-3-fill:before { content: \"\\ebb3\"; }\n.ri-compass-3-line:before { content: \"\\ebb4\"; }\n.ri-compass-4-fill:before { content: \"\\ebb5\"; }\n.ri-compass-4-line:before { content: \"\\ebb6\"; }\n.ri-compass-discover-fill:before { content: \"\\ebb7\"; }\n.ri-compass-discover-line:before { content: \"\\ebb8\"; }\n.ri-compass-fill:before { content: \"\\ebb9\"; }\n.ri-compass-line:before { content: \"\\ebba\"; }\n.ri-compasses-2-fill:before { content: \"\\ebbb\"; }\n.ri-compasses-2-line:before { content: \"\\ebbc\"; }\n.ri-compasses-fill:before { content: \"\\ebbd\"; }\n.ri-compasses-line:before { content: \"\\ebbe\"; }\n.ri-computer-fill:before { content: \"\\ebbf\"; }\n.ri-computer-line:before { content: \"\\ebc0\"; }\n.ri-contacts-book-2-fill:before { content: \"\\ebc1\"; }\n.ri-contacts-book-2-line:before { content: \"\\ebc2\"; }\n.ri-contacts-book-fill:before { content: \"\\ebc3\"; }\n.ri-contacts-book-line:before { content: \"\\ebc4\"; }\n.ri-contacts-book-upload-fill:before { content: \"\\ebc5\"; }\n.ri-contacts-book-upload-line:before { content: \"\\ebc6\"; }\n.ri-contacts-fill:before { content: \"\\ebc7\"; }\n.ri-contacts-line:before { content: \"\\ebc8\"; }\n.ri-contrast-2-fill:before { content: \"\\ebc9\"; }\n.ri-contrast-2-line:before { content: \"\\ebca\"; }\n.ri-contrast-drop-2-fill:before { content: \"\\ebcb\"; }\n.ri-contrast-drop-2-line:before { content: \"\\ebcc\"; }\n.ri-contrast-drop-fill:before { content: \"\\ebcd\"; }\n.ri-contrast-drop-line:before { content: \"\\ebce\"; }\n.ri-contrast-fill:before { content: \"\\ebcf\"; }\n.ri-contrast-line:before { content: \"\\ebd0\"; }\n.ri-copper-coin-fill:before { content: \"\\ebd1\"; }\n.ri-copper-coin-line:before { content: \"\\ebd2\"; }\n.ri-copper-diamond-fill:before { content: \"\\ebd3\"; }\n.ri-copper-diamond-line:before { content: \"\\ebd4\"; }\n.ri-copyright-fill:before { content: \"\\ebd5\"; }\n.ri-copyright-line:before { content: \"\\ebd6\"; }\n.ri-coreos-fill:before { content: \"\\ebd7\"; }\n.ri-coreos-line:before { content: \"\\ebd8\"; }\n.ri-coupon-2-fill:before { content: \"\\ebd9\"; }\n.ri-coupon-2-line:before { content: \"\\ebda\"; }\n.ri-coupon-3-fill:before { content: \"\\ebdb\"; }\n.ri-coupon-3-line:before { content: \"\\ebdc\"; }\n.ri-coupon-4-fill:before { content: \"\\ebdd\"; }\n.ri-coupon-4-line:before { content: \"\\ebde\"; }\n.ri-coupon-5-fill:before { content: \"\\ebdf\"; }\n.ri-coupon-5-line:before { content: \"\\ebe0\"; }\n.ri-coupon-fill:before { content: \"\\ebe1\"; }\n.ri-coupon-line:before { content: \"\\ebe2\"; }\n.ri-cpu-fill:before { content: \"\\ebe3\"; }\n.ri-cpu-line:before { content: \"\\ebe4\"; }\n.ri-creative-commons-by-fill:before { content: \"\\ebe5\"; }\n.ri-creative-commons-by-line:before { content: \"\\ebe6\"; }\n.ri-creative-commons-fill:before { content: \"\\ebe7\"; }\n.ri-creative-commons-line:before { content: \"\\ebe8\"; }\n.ri-creative-commons-nc-fill:before { content: \"\\ebe9\"; }\n.ri-creative-commons-nc-line:before { content: \"\\ebea\"; }\n.ri-creative-commons-nd-fill:before { content: \"\\ebeb\"; }\n.ri-creative-commons-nd-line:before { content: \"\\ebec\"; }\n.ri-creative-commons-sa-fill:before { content: \"\\ebed\"; }\n.ri-creative-commons-sa-line:before { content: \"\\ebee\"; }\n.ri-creative-commons-zero-fill:before { content: \"\\ebef\"; }\n.ri-creative-commons-zero-line:before { content: \"\\ebf0\"; }\n.ri-criminal-fill:before { content: \"\\ebf1\"; }\n.ri-criminal-line:before { content: \"\\ebf2\"; }\n.ri-crop-2-fill:before { content: \"\\ebf3\"; }\n.ri-crop-2-line:before { content: \"\\ebf4\"; }\n.ri-crop-fill:before { content: \"\\ebf5\"; }\n.ri-crop-line:before { content: \"\\ebf6\"; }\n.ri-css3-fill:before { content: \"\\ebf7\"; }\n.ri-css3-line:before { content: \"\\ebf8\"; }\n.ri-cup-fill:before { content: \"\\ebf9\"; }\n.ri-cup-line:before { content: \"\\ebfa\"; }\n.ri-currency-fill:before { content: \"\\ebfb\"; }\n.ri-currency-line:before { content: \"\\ebfc\"; }\n.ri-cursor-fill:before { content: \"\\ebfd\"; }\n.ri-cursor-line:before { content: \"\\ebfe\"; }\n.ri-customer-service-2-fill:before { content: \"\\ebff\"; }\n.ri-customer-service-2-line:before { content: \"\\ec00\"; }\n.ri-customer-service-fill:before { content: \"\\ec01\"; }\n.ri-customer-service-line:before { content: \"\\ec02\"; }\n.ri-dashboard-fill:before { content: \"\\ec03\"; }\n.ri-dashboard-line:before { content: \"\\ec04\"; }\n.ri-database-2-fill:before { content: \"\\ec05\"; }\n.ri-database-2-line:before { content: \"\\ec06\"; }\n.ri-database-fill:before { content: \"\\ec07\"; }\n.ri-database-line:before { content: \"\\ec08\"; }\n.ri-delete-back-2-fill:before { content: \"\\ec09\"; }\n.ri-delete-back-2-line:before { content: \"\\ec0a\"; }\n.ri-delete-back-fill:before { content: \"\\ec0b\"; }\n.ri-delete-back-line:before { content: \"\\ec0c\"; }\n.ri-delete-bin-2-fill:before { content: \"\\ec0d\"; }\n.ri-delete-bin-2-line:before { content: \"\\ec0e\"; }\n.ri-delete-bin-3-fill:before { content: \"\\ec0f\"; }\n.ri-delete-bin-3-line:before { content: \"\\ec10\"; }\n.ri-delete-bin-4-fill:before { content: \"\\ec11\"; }\n.ri-delete-bin-4-line:before { content: \"\\ec12\"; }\n.ri-delete-bin-5-fill:before { content: \"\\ec13\"; }\n.ri-delete-bin-5-line:before { content: \"\\ec14\"; }\n.ri-delete-bin-6-fill:before { content: \"\\ec15\"; }\n.ri-delete-bin-6-line:before { content: \"\\ec16\"; }\n.ri-delete-bin-7-fill:before { content: \"\\ec17\"; }\n.ri-delete-bin-7-line:before { content: \"\\ec18\"; }\n.ri-delete-bin-fill:before { content: \"\\ec19\"; }\n.ri-delete-bin-line:before { content: \"\\ec1a\"; }\n.ri-device-fill:before { content: \"\\ec1b\"; }\n.ri-device-line:before { content: \"\\ec1c\"; }\n.ri-device-recover-fill:before { content: \"\\ec1d\"; }\n.ri-device-recover-line:before { content: \"\\ec1e\"; }\n.ri-dingding-fill:before { content: \"\\ec1f\"; }\n.ri-dingding-line:before { content: \"\\ec20\"; }\n.ri-direction-fill:before { content: \"\\ec21\"; }\n.ri-direction-line:before { content: \"\\ec22\"; }\n.ri-disc-fill:before { content: \"\\ec23\"; }\n.ri-disc-line:before { content: \"\\ec24\"; }\n.ri-discord-fill:before { content: \"\\ec25\"; }\n.ri-discord-line:before { content: \"\\ec26\"; }\n.ri-discuss-fill:before { content: \"\\ec27\"; }\n.ri-discuss-line:before { content: \"\\ec28\"; }\n.ri-disqus-fill:before { content: \"\\ec29\"; }\n.ri-disqus-line:before { content: \"\\ec2a\"; }\n.ri-divide-fill:before { content: \"\\ec2b\"; }\n.ri-divide-line:before { content: \"\\ec2c\"; }\n.ri-donut-chart-fill:before { content: \"\\ec2d\"; }\n.ri-donut-chart-line:before { content: \"\\ec2e\"; }\n.ri-door-lock-box-fill:before { content: \"\\ec2f\"; }\n.ri-door-lock-box-line:before { content: \"\\ec30\"; }\n.ri-door-lock-fill:before { content: \"\\ec31\"; }\n.ri-door-lock-line:before { content: \"\\ec32\"; }\n.ri-douban-fill:before { content: \"\\ec33\"; }\n.ri-douban-line:before { content: \"\\ec34\"; }\n.ri-double-quotes-l:before { content: \"\\ec35\"; }\n.ri-double-quotes-r:before { content: \"\\ec36\"; }\n.ri-download-2-fill:before { content: \"\\ec37\"; }\n.ri-download-2-line:before { content: \"\\ec38\"; }\n.ri-download-cloud-2-fill:before { content: \"\\ec39\"; }\n.ri-download-cloud-2-line:before { content: \"\\ec3a\"; }\n.ri-download-cloud-fill:before { content: \"\\ec3b\"; }\n.ri-download-cloud-line:before { content: \"\\ec3c\"; }\n.ri-download-fill:before { content: \"\\ec3d\"; }\n.ri-download-line:before { content: \"\\ec3e\"; }\n.ri-drag-drop-fill:before { content: \"\\ec3f\"; }\n.ri-drag-drop-line:before { content: \"\\ec40\"; }\n.ri-drag-move-2-fill:before { content: \"\\ec41\"; }\n.ri-drag-move-2-line:before { content: \"\\ec42\"; }\n.ri-drag-move-fill:before { content: \"\\ec43\"; }\n.ri-drag-move-line:before { content: \"\\ec44\"; }\n.ri-dribbble-fill:before { content: \"\\ec45\"; }\n.ri-dribbble-line:before { content: \"\\ec46\"; }\n.ri-drive-fill:before { content: \"\\ec47\"; }\n.ri-drive-line:before { content: \"\\ec48\"; }\n.ri-drizzle-fill:before { content: \"\\ec49\"; }\n.ri-drizzle-line:before { content: \"\\ec4a\"; }\n.ri-drop-fill:before { content: \"\\ec4b\"; }\n.ri-drop-line:before { content: \"\\ec4c\"; }\n.ri-dropbox-fill:before { content: \"\\ec4d\"; }\n.ri-dropbox-line:before { content: \"\\ec4e\"; }\n.ri-dual-sim-1-fill:before { content: \"\\ec4f\"; }\n.ri-dual-sim-1-line:before { content: \"\\ec50\"; }\n.ri-dual-sim-2-fill:before { content: \"\\ec51\"; }\n.ri-dual-sim-2-line:before { content: \"\\ec52\"; }\n.ri-dv-fill:before { content: \"\\ec53\"; }\n.ri-dv-line:before { content: \"\\ec54\"; }\n.ri-dvd-fill:before { content: \"\\ec55\"; }\n.ri-dvd-line:before { content: \"\\ec56\"; }\n.ri-e-bike-2-fill:before { content: \"\\ec57\"; }\n.ri-e-bike-2-line:before { content: \"\\ec58\"; }\n.ri-e-bike-fill:before { content: \"\\ec59\"; }\n.ri-e-bike-line:before { content: \"\\ec5a\"; }\n.ri-earth-fill:before { content: \"\\ec5b\"; }\n.ri-earth-line:before { content: \"\\ec5c\"; }\n.ri-earthquake-fill:before { content: \"\\ec5d\"; }\n.ri-earthquake-line:before { content: \"\\ec5e\"; }\n.ri-edge-fill:before { content: \"\\ec5f\"; }\n.ri-edge-line:before { content: \"\\ec60\"; }\n.ri-edit-2-fill:before { content: \"\\ec61\"; }\n.ri-edit-2-line:before { content: \"\\ec62\"; }\n.ri-edit-box-fill:before { content: \"\\ec63\"; }\n.ri-edit-box-line:before { content: \"\\ec64\"; }\n.ri-edit-circle-fill:before { content: \"\\ec65\"; }\n.ri-edit-circle-line:before { content: \"\\ec66\"; }\n.ri-edit-fill:before { content: \"\\ec67\"; }\n.ri-edit-line:before { content: \"\\ec68\"; }\n.ri-eject-fill:before { content: \"\\ec69\"; }\n.ri-eject-line:before { content: \"\\ec6a\"; }\n.ri-emotion-2-fill:before { content: \"\\ec6b\"; }\n.ri-emotion-2-line:before { content: \"\\ec6c\"; }\n.ri-emotion-fill:before { content: \"\\ec6d\"; }\n.ri-emotion-happy-fill:before { content: \"\\ec6e\"; }\n.ri-emotion-happy-line:before { content: \"\\ec6f\"; }\n.ri-emotion-laugh-fill:before { content: \"\\ec70\"; }\n.ri-emotion-laugh-line:before { content: \"\\ec71\"; }\n.ri-emotion-line:before { content: \"\\ec72\"; }\n.ri-emotion-normal-fill:before { content: \"\\ec73\"; }\n.ri-emotion-normal-line:before { content: \"\\ec74\"; }\n.ri-emotion-sad-fill:before { content: \"\\ec75\"; }\n.ri-emotion-sad-line:before { content: \"\\ec76\"; }\n.ri-emotion-unhappy-fill:before { content: \"\\ec77\"; }\n.ri-emotion-unhappy-line:before { content: \"\\ec78\"; }\n.ri-emphasis-cn:before { content: \"\\ec79\"; }\n.ri-emphasis:before { content: \"\\ec7a\"; }\n.ri-english-input:before { content: \"\\ec7b\"; }\n.ri-equalizer-fill:before { content: \"\\ec7c\"; }\n.ri-equalizer-line:before { content: \"\\ec7d\"; }\n.ri-eraser-fill:before { content: \"\\ec7e\"; }\n.ri-eraser-line:before { content: \"\\ec7f\"; }\n.ri-error-warning-fill:before { content: \"\\ec80\"; }\n.ri-error-warning-line:before { content: \"\\ec81\"; }\n.ri-evernote-fill:before { content: \"\\ec82\"; }\n.ri-evernote-line:before { content: \"\\ec83\"; }\n.ri-exchange-box-fill:before { content: \"\\ec84\"; }\n.ri-exchange-box-line:before { content: \"\\ec85\"; }\n.ri-exchange-cny-fill:before { content: \"\\ec86\"; }\n.ri-exchange-cny-line:before { content: \"\\ec87\"; }\n.ri-exchange-dollar-fill:before { content: \"\\ec88\"; }\n.ri-exchange-dollar-line:before { content: \"\\ec89\"; }\n.ri-exchange-fill:before { content: \"\\ec8a\"; }\n.ri-exchange-funds-fill:before { content: \"\\ec8b\"; }\n.ri-exchange-funds-line:before { content: \"\\ec8c\"; }\n.ri-exchange-line:before { content: \"\\ec8d\"; }\n.ri-external-link-fill:before { content: \"\\ec8e\"; }\n.ri-external-link-line:before { content: \"\\ec8f\"; }\n.ri-eye-2-fill:before { content: \"\\ec90\"; }\n.ri-eye-2-line:before { content: \"\\ec91\"; }\n.ri-eye-close-fill:before { content: \"\\ec92\"; }\n.ri-eye-close-line:before { content: \"\\ec93\"; }\n.ri-eye-fill:before { content: \"\\ec94\"; }\n.ri-eye-line:before { content: \"\\ec95\"; }\n.ri-eye-off-fill:before { content: \"\\ec96\"; }\n.ri-eye-off-line:before { content: \"\\ec97\"; }\n.ri-facebook-box-fill:before { content: \"\\ec98\"; }\n.ri-facebook-box-line:before { content: \"\\ec99\"; }\n.ri-facebook-circle-fill:before { content: \"\\ec9a\"; }\n.ri-facebook-circle-line:before { content: \"\\ec9b\"; }\n.ri-facebook-fill:before { content: \"\\ec9c\"; }\n.ri-facebook-line:before { content: \"\\ec9d\"; }\n.ri-fahrenheit-fill:before { content: \"\\ec9e\"; }\n.ri-fahrenheit-line:before { content: \"\\ec9f\"; }\n.ri-feedback-fill:before { content: \"\\eca0\"; }\n.ri-feedback-line:before { content: \"\\eca1\"; }\n.ri-file-2-fill:before { content: \"\\eca2\"; }\n.ri-file-2-line:before { content: \"\\eca3\"; }\n.ri-file-3-fill:before { content: \"\\eca4\"; }\n.ri-file-3-line:before { content: \"\\eca5\"; }\n.ri-file-4-fill:before { content: \"\\eca6\"; }\n.ri-file-4-line:before { content: \"\\eca7\"; }\n.ri-file-add-fill:before { content: \"\\eca8\"; }\n.ri-file-add-line:before { content: \"\\eca9\"; }\n.ri-file-chart-2-fill:before { content: \"\\ecaa\"; }\n.ri-file-chart-2-line:before { content: \"\\ecab\"; }\n.ri-file-chart-fill:before { content: \"\\ecac\"; }\n.ri-file-chart-line:before { content: \"\\ecad\"; }\n.ri-file-cloud-fill:before { content: \"\\ecae\"; }\n.ri-file-cloud-line:before { content: \"\\ecaf\"; }\n.ri-file-code-fill:before { content: \"\\ecb0\"; }\n.ri-file-code-line:before { content: \"\\ecb1\"; }\n.ri-file-copy-2-fill:before { content: \"\\ecb2\"; }\n.ri-file-copy-2-line:before { content: \"\\ecb3\"; }\n.ri-file-copy-fill:before { content: \"\\ecb4\"; }\n.ri-file-copy-line:before { content: \"\\ecb5\"; }\n.ri-file-damage-fill:before { content: \"\\ecb6\"; }\n.ri-file-damage-line:before { content: \"\\ecb7\"; }\n.ri-file-download-fill:before { content: \"\\ecb8\"; }\n.ri-file-download-line:before { content: \"\\ecb9\"; }\n.ri-file-edit-fill:before { content: \"\\ecba\"; }\n.ri-file-edit-line:before { content: \"\\ecbb\"; }\n.ri-file-excel-2-fill:before { content: \"\\ecbc\"; }\n.ri-file-excel-2-line:before { content: \"\\ecbd\"; }\n.ri-file-excel-fill:before { content: \"\\ecbe\"; }\n.ri-file-excel-line:before { content: \"\\ecbf\"; }\n.ri-file-fill:before { content: \"\\ecc0\"; }\n.ri-file-forbid-fill:before { content: \"\\ecc1\"; }\n.ri-file-forbid-line:before { content: \"\\ecc2\"; }\n.ri-file-gif-fill:before { content: \"\\ecc3\"; }\n.ri-file-gif-line:before { content: \"\\ecc4\"; }\n.ri-file-history-fill:before { content: \"\\ecc5\"; }\n.ri-file-history-line:before { content: \"\\ecc6\"; }\n.ri-file-hwp-fill:before { content: \"\\ecc7\"; }\n.ri-file-hwp-line:before { content: \"\\ecc8\"; }\n.ri-file-info-fill:before { content: \"\\ecc9\"; }\n.ri-file-info-line:before { content: \"\\ecca\"; }\n.ri-file-line:before { content: \"\\eccb\"; }\n.ri-file-list-2-fill:before { content: \"\\eccc\"; }\n.ri-file-list-2-line:before { content: \"\\eccd\"; }\n.ri-file-list-3-fill:before { content: \"\\ecce\"; }\n.ri-file-list-3-line:before { content: \"\\eccf\"; }\n.ri-file-list-fill:before { content: \"\\ecd0\"; }\n.ri-file-list-line:before { content: \"\\ecd1\"; }\n.ri-file-lock-fill:before { content: \"\\ecd2\"; }\n.ri-file-lock-line:before { content: \"\\ecd3\"; }\n.ri-file-mark-fill:before { content: \"\\ecd4\"; }\n.ri-file-mark-line:before { content: \"\\ecd5\"; }\n.ri-file-music-fill:before { content: \"\\ecd6\"; }\n.ri-file-music-line:before { content: \"\\ecd7\"; }\n.ri-file-paper-2-fill:before { content: \"\\ecd8\"; }\n.ri-file-paper-2-line:before { content: \"\\ecd9\"; }\n.ri-file-paper-fill:before { content: \"\\ecda\"; }\n.ri-file-paper-line:before { content: \"\\ecdb\"; }\n.ri-file-pdf-fill:before { content: \"\\ecdc\"; }\n.ri-file-pdf-line:before { content: \"\\ecdd\"; }\n.ri-file-ppt-2-fill:before { content: \"\\ecde\"; }\n.ri-file-ppt-2-line:before { content: \"\\ecdf\"; }\n.ri-file-ppt-fill:before { content: \"\\ece0\"; }\n.ri-file-ppt-line:before { content: \"\\ece1\"; }\n.ri-file-reduce-fill:before { content: \"\\ece2\"; }\n.ri-file-reduce-line:before { content: \"\\ece3\"; }\n.ri-file-search-fill:before { content: \"\\ece4\"; }\n.ri-file-search-line:before { content: \"\\ece5\"; }\n.ri-file-settings-fill:before { content: \"\\ece6\"; }\n.ri-file-settings-line:before { content: \"\\ece7\"; }\n.ri-file-shield-2-fill:before { content: \"\\ece8\"; }\n.ri-file-shield-2-line:before { content: \"\\ece9\"; }\n.ri-file-shield-fill:before { content: \"\\ecea\"; }\n.ri-file-shield-line:before { content: \"\\eceb\"; }\n.ri-file-shred-fill:before { content: \"\\ecec\"; }\n.ri-file-shred-line:before { content: \"\\eced\"; }\n.ri-file-text-fill:before { content: \"\\ecee\"; }\n.ri-file-text-line:before { content: \"\\ecef\"; }\n.ri-file-transfer-fill:before { content: \"\\ecf0\"; }\n.ri-file-transfer-line:before { content: \"\\ecf1\"; }\n.ri-file-unknow-fill:before { content: \"\\ecf2\"; }\n.ri-file-unknow-line:before { content: \"\\ecf3\"; }\n.ri-file-upload-fill:before { content: \"\\ecf4\"; }\n.ri-file-upload-line:before { content: \"\\ecf5\"; }\n.ri-file-user-fill:before { content: \"\\ecf6\"; }\n.ri-file-user-line:before { content: \"\\ecf7\"; }\n.ri-file-warning-fill:before { content: \"\\ecf8\"; }\n.ri-file-warning-line:before { content: \"\\ecf9\"; }\n.ri-file-word-2-fill:before { content: \"\\ecfa\"; }\n.ri-file-word-2-line:before { content: \"\\ecfb\"; }\n.ri-file-word-fill:before { content: \"\\ecfc\"; }\n.ri-file-word-line:before { content: \"\\ecfd\"; }\n.ri-file-zip-fill:before { content: \"\\ecfe\"; }\n.ri-file-zip-line:before { content: \"\\ecff\"; }\n.ri-film-fill:before { content: \"\\ed00\"; }\n.ri-film-line:before { content: \"\\ed01\"; }\n.ri-filter-2-fill:before { content: \"\\ed02\"; }\n.ri-filter-2-line:before { content: \"\\ed03\"; }\n.ri-filter-3-fill:before { content: \"\\ed04\"; }\n.ri-filter-3-line:before { content: \"\\ed05\"; }\n.ri-filter-fill:before { content: \"\\ed06\"; }\n.ri-filter-line:before { content: \"\\ed07\"; }\n.ri-find-replace-fill:before { content: \"\\ed08\"; }\n.ri-find-replace-line:before { content: \"\\ed09\"; }\n.ri-fingerprint-2-fill:before { content: \"\\ed0a\"; }\n.ri-fingerprint-2-line:before { content: \"\\ed0b\"; }\n.ri-fingerprint-fill:before { content: \"\\ed0c\"; }\n.ri-fingerprint-line:before { content: \"\\ed0d\"; }\n.ri-fire-fill:before { content: \"\\ed0e\"; }\n.ri-fire-line:before { content: \"\\ed0f\"; }\n.ri-firefox-fill:before { content: \"\\ed10\"; }\n.ri-firefox-line:before { content: \"\\ed11\"; }\n.ri-flag-2-fill:before { content: \"\\ed12\"; }\n.ri-flag-2-line:before { content: \"\\ed13\"; }\n.ri-flag-fill:before { content: \"\\ed14\"; }\n.ri-flag-line:before { content: \"\\ed15\"; }\n.ri-flashlight-fill:before { content: \"\\ed16\"; }\n.ri-flashlight-line:before { content: \"\\ed17\"; }\n.ri-flask-fill:before { content: \"\\ed18\"; }\n.ri-flask-line:before { content: \"\\ed19\"; }\n.ri-flight-land-fill:before { content: \"\\ed1a\"; }\n.ri-flight-land-line:before { content: \"\\ed1b\"; }\n.ri-flight-takeoff-fill:before { content: \"\\ed1c\"; }\n.ri-flight-takeoff-line:before { content: \"\\ed1d\"; }\n.ri-flood-fill:before { content: \"\\ed1e\"; }\n.ri-flood-line:before { content: \"\\ed1f\"; }\n.ri-flutter-fill:before { content: \"\\ed20\"; }\n.ri-flutter-line:before { content: \"\\ed21\"; }\n.ri-focus-2-fill:before { content: \"\\ed22\"; }\n.ri-focus-2-line:before { content: \"\\ed23\"; }\n.ri-focus-3-fill:before { content: \"\\ed24\"; }\n.ri-focus-3-line:before { content: \"\\ed25\"; }\n.ri-focus-fill:before { content: \"\\ed26\"; }\n.ri-focus-line:before { content: \"\\ed27\"; }\n.ri-foggy-fill:before { content: \"\\ed28\"; }\n.ri-foggy-line:before { content: \"\\ed29\"; }\n.ri-folder-2-fill:before { content: \"\\ed2a\"; }\n.ri-folder-2-line:before { content: \"\\ed2b\"; }\n.ri-folder-3-fill:before { content: \"\\ed2c\"; }\n.ri-folder-3-line:before { content: \"\\ed2d\"; }\n.ri-folder-4-fill:before { content: \"\\ed2e\"; }\n.ri-folder-4-line:before { content: \"\\ed2f\"; }\n.ri-folder-5-fill:before { content: \"\\ed30\"; }\n.ri-folder-5-line:before { content: \"\\ed31\"; }\n.ri-folder-add-fill:before { content: \"\\ed32\"; }\n.ri-folder-add-line:before { content: \"\\ed33\"; }\n.ri-folder-chart-2-fill:before { content: \"\\ed34\"; }\n.ri-folder-chart-2-line:before { content: \"\\ed35\"; }\n.ri-folder-chart-fill:before { content: \"\\ed36\"; }\n.ri-folder-chart-line:before { content: \"\\ed37\"; }\n.ri-folder-download-fill:before { content: \"\\ed38\"; }\n.ri-folder-download-line:before { content: \"\\ed39\"; }\n.ri-folder-fill:before { content: \"\\ed3a\"; }\n.ri-folder-forbid-fill:before { content: \"\\ed3b\"; }\n.ri-folder-forbid-line:before { content: \"\\ed3c\"; }\n.ri-folder-history-fill:before { content: \"\\ed3d\"; }\n.ri-folder-history-line:before { content: \"\\ed3e\"; }\n.ri-folder-info-fill:before { content: \"\\ed3f\"; }\n.ri-folder-info-line:before { content: \"\\ed40\"; }\n.ri-folder-keyhole-fill:before { content: \"\\ed41\"; }\n.ri-folder-keyhole-line:before { content: \"\\ed42\"; }\n.ri-folder-line:before { content: \"\\ed43\"; }\n.ri-folder-lock-fill:before { content: \"\\ed44\"; }\n.ri-folder-lock-line:before { content: \"\\ed45\"; }\n.ri-folder-music-fill:before { content: \"\\ed46\"; }\n.ri-folder-music-line:before { content: \"\\ed47\"; }\n.ri-folder-open-fill:before { content: \"\\ed48\"; }\n.ri-folder-open-line:before { content: \"\\ed49\"; }\n.ri-folder-received-fill:before { content: \"\\ed4a\"; }\n.ri-folder-received-line:before { content: \"\\ed4b\"; }\n.ri-folder-reduce-fill:before { content: \"\\ed4c\"; }\n.ri-folder-reduce-line:before { content: \"\\ed4d\"; }\n.ri-folder-settings-fill:before { content: \"\\ed4e\"; }\n.ri-folder-settings-line:before { content: \"\\ed4f\"; }\n.ri-folder-shared-fill:before { content: \"\\ed50\"; }\n.ri-folder-shared-line:before { content: \"\\ed51\"; }\n.ri-folder-shield-2-fill:before { content: \"\\ed52\"; }\n.ri-folder-shield-2-line:before { content: \"\\ed53\"; }\n.ri-folder-shield-fill:before { content: \"\\ed54\"; }\n.ri-folder-shield-line:before { content: \"\\ed55\"; }\n.ri-folder-transfer-fill:before { content: \"\\ed56\"; }\n.ri-folder-transfer-line:before { content: \"\\ed57\"; }\n.ri-folder-unknow-fill:before { content: \"\\ed58\"; }\n.ri-folder-unknow-line:before { content: \"\\ed59\"; }\n.ri-folder-upload-fill:before { content: \"\\ed5a\"; }\n.ri-folder-upload-line:before { content: \"\\ed5b\"; }\n.ri-folder-user-fill:before { content: \"\\ed5c\"; }\n.ri-folder-user-line:before { content: \"\\ed5d\"; }\n.ri-folder-warning-fill:before { content: \"\\ed5e\"; }\n.ri-folder-warning-line:before { content: \"\\ed5f\"; }\n.ri-folder-zip-fill:before { content: \"\\ed60\"; }\n.ri-folder-zip-line:before { content: \"\\ed61\"; }\n.ri-folders-fill:before { content: \"\\ed62\"; }\n.ri-folders-line:before { content: \"\\ed63\"; }\n.ri-font-color:before { content: \"\\ed64\"; }\n.ri-font-size-2:before { content: \"\\ed65\"; }\n.ri-font-size:before { content: \"\\ed66\"; }\n.ri-football-fill:before { content: \"\\ed67\"; }\n.ri-football-line:before { content: \"\\ed68\"; }\n.ri-footprint-fill:before { content: \"\\ed69\"; }\n.ri-footprint-line:before { content: \"\\ed6a\"; }\n.ri-forbid-2-fill:before { content: \"\\ed6b\"; }\n.ri-forbid-2-line:before { content: \"\\ed6c\"; }\n.ri-forbid-fill:before { content: \"\\ed6d\"; }\n.ri-forbid-line:before { content: \"\\ed6e\"; }\n.ri-format-clear:before { content: \"\\ed6f\"; }\n.ri-fridge-fill:before { content: \"\\ed70\"; }\n.ri-fridge-line:before { content: \"\\ed71\"; }\n.ri-fullscreen-exit-fill:before { content: \"\\ed72\"; }\n.ri-fullscreen-exit-line:before { content: \"\\ed73\"; }\n.ri-fullscreen-fill:before { content: \"\\ed74\"; }\n.ri-fullscreen-line:before { content: \"\\ed75\"; }\n.ri-function-fill:before { content: \"\\ed76\"; }\n.ri-function-line:before { content: \"\\ed77\"; }\n.ri-functions:before { content: \"\\ed78\"; }\n.ri-funds-box-fill:before { content: \"\\ed79\"; }\n.ri-funds-box-line:before { content: \"\\ed7a\"; }\n.ri-funds-fill:before { content: \"\\ed7b\"; }\n.ri-funds-line:before { content: \"\\ed7c\"; }\n.ri-gallery-fill:before { content: \"\\ed7d\"; }\n.ri-gallery-line:before { content: \"\\ed7e\"; }\n.ri-gallery-upload-fill:before { content: \"\\ed7f\"; }\n.ri-gallery-upload-line:before { content: \"\\ed80\"; }\n.ri-game-fill:before { content: \"\\ed81\"; }\n.ri-game-line:before { content: \"\\ed82\"; }\n.ri-gamepad-fill:before { content: \"\\ed83\"; }\n.ri-gamepad-line:before { content: \"\\ed84\"; }\n.ri-gas-station-fill:before { content: \"\\ed85\"; }\n.ri-gas-station-line:before { content: \"\\ed86\"; }\n.ri-gatsby-fill:before { content: \"\\ed87\"; }\n.ri-gatsby-line:before { content: \"\\ed88\"; }\n.ri-genderless-fill:before { content: \"\\ed89\"; }\n.ri-genderless-line:before { content: \"\\ed8a\"; }\n.ri-ghost-2-fill:before { content: \"\\ed8b\"; }\n.ri-ghost-2-line:before { content: \"\\ed8c\"; }\n.ri-ghost-fill:before { content: \"\\ed8d\"; }\n.ri-ghost-line:before { content: \"\\ed8e\"; }\n.ri-ghost-smile-fill:before { content: \"\\ed8f\"; }\n.ri-ghost-smile-line:before { content: \"\\ed90\"; }\n.ri-gift-2-fill:before { content: \"\\ed91\"; }\n.ri-gift-2-line:before { content: \"\\ed92\"; }\n.ri-gift-fill:before { content: \"\\ed93\"; }\n.ri-gift-line:before { content: \"\\ed94\"; }\n.ri-git-branch-fill:before { content: \"\\ed95\"; }\n.ri-git-branch-line:before { content: \"\\ed96\"; }\n.ri-git-commit-fill:before { content: \"\\ed97\"; }\n.ri-git-commit-line:before { content: \"\\ed98\"; }\n.ri-git-merge-fill:before { content: \"\\ed99\"; }\n.ri-git-merge-line:before { content: \"\\ed9a\"; }\n.ri-git-pull-request-fill:before { content: \"\\ed9b\"; }\n.ri-git-pull-request-line:before { content: \"\\ed9c\"; }\n.ri-git-repository-commits-fill:before { content: \"\\ed9d\"; }\n.ri-git-repository-commits-line:before { content: \"\\ed9e\"; }\n.ri-git-repository-fill:before { content: \"\\ed9f\"; }\n.ri-git-repository-line:before { content: \"\\eda0\"; }\n.ri-git-repository-private-fill:before { content: \"\\eda1\"; }\n.ri-git-repository-private-line:before { content: \"\\eda2\"; }\n.ri-github-fill:before { content: \"\\eda3\"; }\n.ri-github-line:before { content: \"\\eda4\"; }\n.ri-gitlab-fill:before { content: \"\\eda5\"; }\n.ri-gitlab-line:before { content: \"\\eda6\"; }\n.ri-global-fill:before { content: \"\\eda7\"; }\n.ri-global-line:before { content: \"\\eda8\"; }\n.ri-globe-fill:before { content: \"\\eda9\"; }\n.ri-globe-line:before { content: \"\\edaa\"; }\n.ri-goblet-fill:before { content: \"\\edab\"; }\n.ri-goblet-line:before { content: \"\\edac\"; }\n.ri-google-fill:before { content: \"\\edad\"; }\n.ri-google-line:before { content: \"\\edae\"; }\n.ri-google-play-fill:before { content: \"\\edaf\"; }\n.ri-google-play-line:before { content: \"\\edb0\"; }\n.ri-government-fill:before { content: \"\\edb1\"; }\n.ri-government-line:before { content: \"\\edb2\"; }\n.ri-gps-fill:before { content: \"\\edb3\"; }\n.ri-gps-line:before { content: \"\\edb4\"; }\n.ri-gradienter-fill:before { content: \"\\edb5\"; }\n.ri-gradienter-line:before { content: \"\\edb6\"; }\n.ri-grid-fill:before { content: \"\\edb7\"; }\n.ri-grid-line:before { content: \"\\edb8\"; }\n.ri-group-2-fill:before { content: \"\\edb9\"; }\n.ri-group-2-line:before { content: \"\\edba\"; }\n.ri-group-fill:before { content: \"\\edbb\"; }\n.ri-group-line:before { content: \"\\edbc\"; }\n.ri-guide-fill:before { content: \"\\edbd\"; }\n.ri-guide-line:before { content: \"\\edbe\"; }\n.ri-hail-fill:before { content: \"\\edbf\"; }\n.ri-hail-line:before { content: \"\\edc0\"; }\n.ri-hammer-fill:before { content: \"\\edc1\"; }\n.ri-hammer-line:before { content: \"\\edc2\"; }\n.ri-hand-coin-fill:before { content: \"\\edc3\"; }\n.ri-hand-coin-line:before { content: \"\\edc4\"; }\n.ri-hand-heart-fill:before { content: \"\\edc5\"; }\n.ri-hand-heart-line:before { content: \"\\edc6\"; }\n.ri-handbag-fill:before { content: \"\\edc7\"; }\n.ri-handbag-line:before { content: \"\\edc8\"; }\n.ri-hard-drive-2-fill:before { content: \"\\edc9\"; }\n.ri-hard-drive-2-line:before { content: \"\\edca\"; }\n.ri-hard-drive-fill:before { content: \"\\edcb\"; }\n.ri-hard-drive-line:before { content: \"\\edcc\"; }\n.ri-hashtag:before { content: \"\\edcd\"; }\n.ri-haze-2-fill:before { content: \"\\edce\"; }\n.ri-haze-2-line:before { content: \"\\edcf\"; }\n.ri-haze-fill:before { content: \"\\edd0\"; }\n.ri-haze-line:before { content: \"\\edd1\"; }\n.ri-hd-fill:before { content: \"\\edd2\"; }\n.ri-hd-line:before { content: \"\\edd3\"; }\n.ri-heading:before { content: \"\\edd4\"; }\n.ri-headphone-fill:before { content: \"\\edd5\"; }\n.ri-headphone-line:before { content: \"\\edd6\"; }\n.ri-heart-2-fill:before { content: \"\\edd7\"; }\n.ri-heart-2-line:before { content: \"\\edd8\"; }\n.ri-heart-add-fill:before { content: \"\\edd9\"; }\n.ri-heart-add-line:before { content: \"\\edda\"; }\n.ri-heart-fill:before { content: \"\\eddb\"; }\n.ri-heart-line:before { content: \"\\eddc\"; }\n.ri-hearts-fill:before { content: \"\\eddd\"; }\n.ri-hearts-line:before { content: \"\\edde\"; }\n.ri-heavy-showers-fill:before { content: \"\\eddf\"; }\n.ri-heavy-showers-line:before { content: \"\\ede0\"; }\n.ri-history-fill:before { content: \"\\ede1\"; }\n.ri-history-line:before { content: \"\\ede2\"; }\n.ri-home-2-fill:before { content: \"\\ede3\"; }\n.ri-home-2-line:before { content: \"\\ede4\"; }\n.ri-home-3-fill:before { content: \"\\ede5\"; }\n.ri-home-3-line:before { content: \"\\ede6\"; }\n.ri-home-4-fill:before { content: \"\\ede7\"; }\n.ri-home-4-line:before { content: \"\\ede8\"; }\n.ri-home-5-fill:before { content: \"\\ede9\"; }\n.ri-home-5-line:before { content: \"\\edea\"; }\n.ri-home-6-fill:before { content: \"\\edeb\"; }\n.ri-home-6-line:before { content: \"\\edec\"; }\n.ri-home-7-fill:before { content: \"\\eded\"; }\n.ri-home-7-line:before { content: \"\\edee\"; }\n.ri-home-8-fill:before { content: \"\\edef\"; }\n.ri-home-8-line:before { content: \"\\edf0\"; }\n.ri-home-fill:before { content: \"\\edf1\"; }\n.ri-home-gear-fill:before { content: \"\\edf2\"; }\n.ri-home-gear-line:before { content: \"\\edf3\"; }\n.ri-home-heart-fill:before { content: \"\\edf4\"; }\n.ri-home-heart-line:before { content: \"\\edf5\"; }\n.ri-home-line:before { content: \"\\edf6\"; }\n.ri-home-smile-2-fill:before { content: \"\\edf7\"; }\n.ri-home-smile-2-line:before { content: \"\\edf8\"; }\n.ri-home-smile-fill:before { content: \"\\edf9\"; }\n.ri-home-smile-line:before { content: \"\\edfa\"; }\n.ri-home-wifi-fill:before { content: \"\\edfb\"; }\n.ri-home-wifi-line:before { content: \"\\edfc\"; }\n.ri-honor-of-kings-fill:before { content: \"\\edfd\"; }\n.ri-honor-of-kings-line:before { content: \"\\edfe\"; }\n.ri-honour-fill:before { content: \"\\edff\"; }\n.ri-honour-line:before { content: \"\\ee00\"; }\n.ri-hospital-fill:before { content: \"\\ee01\"; }\n.ri-hospital-line:before { content: \"\\ee02\"; }\n.ri-hotel-bed-fill:before { content: \"\\ee03\"; }\n.ri-hotel-bed-line:before { content: \"\\ee04\"; }\n.ri-hotel-fill:before { content: \"\\ee05\"; }\n.ri-hotel-line:before { content: \"\\ee06\"; }\n.ri-hotspot-fill:before { content: \"\\ee07\"; }\n.ri-hotspot-line:before { content: \"\\ee08\"; }\n.ri-hq-fill:before { content: \"\\ee09\"; }\n.ri-hq-line:before { content: \"\\ee0a\"; }\n.ri-html5-fill:before { content: \"\\ee0b\"; }\n.ri-html5-line:before { content: \"\\ee0c\"; }\n.ri-ie-fill:before { content: \"\\ee0d\"; }\n.ri-ie-line:before { content: \"\\ee0e\"; }\n.ri-image-2-fill:before { content: \"\\ee0f\"; }\n.ri-image-2-line:before { content: \"\\ee10\"; }\n.ri-image-add-fill:before { content: \"\\ee11\"; }\n.ri-image-add-line:before { content: \"\\ee12\"; }\n.ri-image-fill:before { content: \"\\ee13\"; }\n.ri-image-line:before { content: \"\\ee14\"; }\n.ri-inbox-archive-fill:before { content: \"\\ee15\"; }\n.ri-inbox-archive-line:before { content: \"\\ee16\"; }\n.ri-inbox-fill:before { content: \"\\ee17\"; }\n.ri-inbox-line:before { content: \"\\ee18\"; }\n.ri-inbox-unarchive-fill:before { content: \"\\ee19\"; }\n.ri-inbox-unarchive-line:before { content: \"\\ee1a\"; }\n.ri-increase-decrease-fill:before { content: \"\\ee1b\"; }\n.ri-increase-decrease-line:before { content: \"\\ee1c\"; }\n.ri-indent-decrease:before { content: \"\\ee1d\"; }\n.ri-indent-increase:before { content: \"\\ee1e\"; }\n.ri-indeterminate-circle-fill:before { content: \"\\ee1f\"; }\n.ri-indeterminate-circle-line:before { content: \"\\ee20\"; }\n.ri-information-fill:before { content: \"\\ee21\"; }\n.ri-information-line:before { content: \"\\ee22\"; }\n.ri-input-cursor-move:before { content: \"\\ee23\"; }\n.ri-input-method-fill:before { content: \"\\ee24\"; }\n.ri-input-method-line:before { content: \"\\ee25\"; }\n.ri-instagram-fill:before { content: \"\\ee26\"; }\n.ri-instagram-line:before { content: \"\\ee27\"; }\n.ri-install-fill:before { content: \"\\ee28\"; }\n.ri-install-line:before { content: \"\\ee29\"; }\n.ri-invision-fill:before { content: \"\\ee2a\"; }\n.ri-invision-line:before { content: \"\\ee2b\"; }\n.ri-italic:before { content: \"\\ee2c\"; }\n.ri-kakao-talk-fill:before { content: \"\\ee2d\"; }\n.ri-kakao-talk-line:before { content: \"\\ee2e\"; }\n.ri-key-2-fill:before { content: \"\\ee2f\"; }\n.ri-key-2-line:before { content: \"\\ee30\"; }\n.ri-key-fill:before { content: \"\\ee31\"; }\n.ri-key-line:before { content: \"\\ee32\"; }\n.ri-keyboard-box-fill:before { content: \"\\ee33\"; }\n.ri-keyboard-box-line:before { content: \"\\ee34\"; }\n.ri-keyboard-fill:before { content: \"\\ee35\"; }\n.ri-keyboard-line:before { content: \"\\ee36\"; }\n.ri-keynote-fill:before { content: \"\\ee37\"; }\n.ri-keynote-line:before { content: \"\\ee38\"; }\n.ri-knife-blood-fill:before { content: \"\\ee39\"; }\n.ri-knife-blood-line:before { content: \"\\ee3a\"; }\n.ri-knife-fill:before { content: \"\\ee3b\"; }\n.ri-knife-line:before { content: \"\\ee3c\"; }\n.ri-landscape-fill:before { content: \"\\ee3d\"; }\n.ri-landscape-line:before { content: \"\\ee3e\"; }\n.ri-layout-2-fill:before { content: \"\\ee3f\"; }\n.ri-layout-2-line:before { content: \"\\ee40\"; }\n.ri-layout-3-fill:before { content: \"\\ee41\"; }\n.ri-layout-3-line:before { content: \"\\ee42\"; }\n.ri-layout-4-fill:before { content: \"\\ee43\"; }\n.ri-layout-4-line:before { content: \"\\ee44\"; }\n.ri-layout-5-fill:before { content: \"\\ee45\"; }\n.ri-layout-5-line:before { content: \"\\ee46\"; }\n.ri-layout-6-fill:before { content: \"\\ee47\"; }\n.ri-layout-6-line:before { content: \"\\ee48\"; }\n.ri-layout-bottom-2-fill:before { content: \"\\ee49\"; }\n.ri-layout-bottom-2-line:before { content: \"\\ee4a\"; }\n.ri-layout-bottom-fill:before { content: \"\\ee4b\"; }\n.ri-layout-bottom-line:before { content: \"\\ee4c\"; }\n.ri-layout-column-fill:before { content: \"\\ee4d\"; }\n.ri-layout-column-line:before { content: \"\\ee4e\"; }\n.ri-layout-fill:before { content: \"\\ee4f\"; }\n.ri-layout-grid-fill:before { content: \"\\ee50\"; }\n.ri-layout-grid-line:before { content: \"\\ee51\"; }\n.ri-layout-left-2-fill:before { content: \"\\ee52\"; }\n.ri-layout-left-2-line:before { content: \"\\ee53\"; }\n.ri-layout-left-fill:before { content: \"\\ee54\"; }\n.ri-layout-left-line:before { content: \"\\ee55\"; }\n.ri-layout-line:before { content: \"\\ee56\"; }\n.ri-layout-masonry-fill:before { content: \"\\ee57\"; }\n.ri-layout-masonry-line:before { content: \"\\ee58\"; }\n.ri-layout-right-2-fill:before { content: \"\\ee59\"; }\n.ri-layout-right-2-line:before { content: \"\\ee5a\"; }\n.ri-layout-right-fill:before { content: \"\\ee5b\"; }\n.ri-layout-right-line:before { content: \"\\ee5c\"; }\n.ri-layout-row-fill:before { content: \"\\ee5d\"; }\n.ri-layout-row-line:before { content: \"\\ee5e\"; }\n.ri-layout-top-2-fill:before { content: \"\\ee5f\"; }\n.ri-layout-top-2-line:before { content: \"\\ee60\"; }\n.ri-layout-top-fill:before { content: \"\\ee61\"; }\n.ri-layout-top-line:before { content: \"\\ee62\"; }\n.ri-leaf-fill:before { content: \"\\ee63\"; }\n.ri-leaf-line:before { content: \"\\ee64\"; }\n.ri-lifebuoy-fill:before { content: \"\\ee65\"; }\n.ri-lifebuoy-line:before { content: \"\\ee66\"; }\n.ri-lightbulb-fill:before { content: \"\\ee67\"; }\n.ri-lightbulb-flash-fill:before { content: \"\\ee68\"; }\n.ri-lightbulb-flash-line:before { content: \"\\ee69\"; }\n.ri-lightbulb-line:before { content: \"\\ee6a\"; }\n.ri-line-chart-fill:before { content: \"\\ee6b\"; }\n.ri-line-chart-line:before { content: \"\\ee6c\"; }\n.ri-line-fill:before { content: \"\\ee6d\"; }\n.ri-line-height:before { content: \"\\ee6e\"; }\n.ri-line-line:before { content: \"\\ee6f\"; }\n.ri-link-m:before { content: \"\\ee70\"; }\n.ri-link-unlink-m:before { content: \"\\ee71\"; }\n.ri-link-unlink:before { content: \"\\ee72\"; }\n.ri-link:before { content: \"\\ee73\"; }\n.ri-linkedin-box-fill:before { content: \"\\ee74\"; }\n.ri-linkedin-box-line:before { content: \"\\ee75\"; }\n.ri-linkedin-fill:before { content: \"\\ee76\"; }\n.ri-linkedin-line:before { content: \"\\ee77\"; }\n.ri-links-fill:before { content: \"\\ee78\"; }\n.ri-links-line:before { content: \"\\ee79\"; }\n.ri-list-check-2:before { content: \"\\ee7a\"; }\n.ri-list-check:before { content: \"\\ee7b\"; }\n.ri-list-ordered:before { content: \"\\ee7c\"; }\n.ri-list-settings-fill:before { content: \"\\ee7d\"; }\n.ri-list-settings-line:before { content: \"\\ee7e\"; }\n.ri-list-unordered:before { content: \"\\ee7f\"; }\n.ri-live-fill:before { content: \"\\ee80\"; }\n.ri-live-line:before { content: \"\\ee81\"; }\n.ri-loader-2-fill:before { content: \"\\ee82\"; }\n.ri-loader-2-line:before { content: \"\\ee83\"; }\n.ri-loader-3-fill:before { content: \"\\ee84\"; }\n.ri-loader-3-line:before { content: \"\\ee85\"; }\n.ri-loader-4-fill:before { content: \"\\ee86\"; }\n.ri-loader-4-line:before { content: \"\\ee87\"; }\n.ri-loader-5-fill:before { content: \"\\ee88\"; }\n.ri-loader-5-line:before { content: \"\\ee89\"; }\n.ri-loader-fill:before { content: \"\\ee8a\"; }\n.ri-loader-line:before { content: \"\\ee8b\"; }\n.ri-lock-2-fill:before { content: \"\\ee8c\"; }\n.ri-lock-2-line:before { content: \"\\ee8d\"; }\n.ri-lock-fill:before { content: \"\\ee8e\"; }\n.ri-lock-line:before { content: \"\\ee8f\"; }\n.ri-lock-password-fill:before { content: \"\\ee90\"; }\n.ri-lock-password-line:before { content: \"\\ee91\"; }\n.ri-lock-unlock-fill:before { content: \"\\ee92\"; }\n.ri-lock-unlock-line:before { content: \"\\ee93\"; }\n.ri-login-box-fill:before { content: \"\\ee94\"; }\n.ri-login-box-line:before { content: \"\\ee95\"; }\n.ri-login-circle-fill:before { content: \"\\ee96\"; }\n.ri-login-circle-line:before { content: \"\\ee97\"; }\n.ri-logout-box-fill:before { content: \"\\ee98\"; }\n.ri-logout-box-line:before { content: \"\\ee99\"; }\n.ri-logout-box-r-fill:before { content: \"\\ee9a\"; }\n.ri-logout-box-r-line:before { content: \"\\ee9b\"; }\n.ri-logout-circle-fill:before { content: \"\\ee9c\"; }\n.ri-logout-circle-line:before { content: \"\\ee9d\"; }\n.ri-logout-circle-r-fill:before { content: \"\\ee9e\"; }\n.ri-logout-circle-r-line:before { content: \"\\ee9f\"; }\n.ri-luggage-cart-fill:before { content: \"\\eea0\"; }\n.ri-luggage-cart-line:before { content: \"\\eea1\"; }\n.ri-luggage-deposit-fill:before { content: \"\\eea2\"; }\n.ri-luggage-deposit-line:before { content: \"\\eea3\"; }\n.ri-mac-fill:before { content: \"\\eea4\"; }\n.ri-mac-line:before { content: \"\\eea5\"; }\n.ri-macbook-fill:before { content: \"\\eea6\"; }\n.ri-macbook-line:before { content: \"\\eea7\"; }\n.ri-magic-fill:before { content: \"\\eea8\"; }\n.ri-magic-line:before { content: \"\\eea9\"; }\n.ri-mail-add-fill:before { content: \"\\eeaa\"; }\n.ri-mail-add-line:before { content: \"\\eeab\"; }\n.ri-mail-check-fill:before { content: \"\\eeac\"; }\n.ri-mail-check-line:before { content: \"\\eead\"; }\n.ri-mail-close-fill:before { content: \"\\eeae\"; }\n.ri-mail-close-line:before { content: \"\\eeaf\"; }\n.ri-mail-download-fill:before { content: \"\\eeb0\"; }\n.ri-mail-download-line:before { content: \"\\eeb1\"; }\n.ri-mail-fill:before { content: \"\\eeb2\"; }\n.ri-mail-forbid-fill:before { content: \"\\eeb3\"; }\n.ri-mail-forbid-line:before { content: \"\\eeb4\"; }\n.ri-mail-line:before { content: \"\\eeb5\"; }\n.ri-mail-lock-fill:before { content: \"\\eeb6\"; }\n.ri-mail-lock-line:before { content: \"\\eeb7\"; }\n.ri-mail-open-fill:before { content: \"\\eeb8\"; }\n.ri-mail-open-line:before { content: \"\\eeb9\"; }\n.ri-mail-send-fill:before { content: \"\\eeba\"; }\n.ri-mail-send-line:before { content: \"\\eebb\"; }\n.ri-mail-settings-fill:before { content: \"\\eebc\"; }\n.ri-mail-settings-line:before { content: \"\\eebd\"; }\n.ri-mail-star-fill:before { content: \"\\eebe\"; }\n.ri-mail-star-line:before { content: \"\\eebf\"; }\n.ri-mail-unread-fill:before { content: \"\\eec0\"; }\n.ri-mail-unread-line:before { content: \"\\eec1\"; }\n.ri-mail-volume-fill:before { content: \"\\eec2\"; }\n.ri-mail-volume-line:before { content: \"\\eec3\"; }\n.ri-map-2-fill:before { content: \"\\eec4\"; }\n.ri-map-2-line:before { content: \"\\eec5\"; }\n.ri-map-fill:before { content: \"\\eec6\"; }\n.ri-map-line:before { content: \"\\eec7\"; }\n.ri-map-pin-2-fill:before { content: \"\\eec8\"; }\n.ri-map-pin-2-line:before { content: \"\\eec9\"; }\n.ri-map-pin-3-fill:before { content: \"\\eeca\"; }\n.ri-map-pin-3-line:before { content: \"\\eecb\"; }\n.ri-map-pin-4-fill:before { content: \"\\eecc\"; }\n.ri-map-pin-4-line:before { content: \"\\eecd\"; }\n.ri-map-pin-5-fill:before { content: \"\\eece\"; }\n.ri-map-pin-5-line:before { content: \"\\eecf\"; }\n.ri-map-pin-add-fill:before { content: \"\\eed0\"; }\n.ri-map-pin-add-line:before { content: \"\\eed1\"; }\n.ri-map-pin-fill:before { content: \"\\eed2\"; }\n.ri-map-pin-line:before { content: \"\\eed3\"; }\n.ri-map-pin-range-fill:before { content: \"\\eed4\"; }\n.ri-map-pin-range-line:before { content: \"\\eed5\"; }\n.ri-map-pin-time-fill:before { content: \"\\eed6\"; }\n.ri-map-pin-time-line:before { content: \"\\eed7\"; }\n.ri-map-pin-user-fill:before { content: \"\\eed8\"; }\n.ri-map-pin-user-line:before { content: \"\\eed9\"; }\n.ri-mark-pen-fill:before { content: \"\\eeda\"; }\n.ri-mark-pen-line:before { content: \"\\eedb\"; }\n.ri-markdown-fill:before { content: \"\\eedc\"; }\n.ri-markdown-line:before { content: \"\\eedd\"; }\n.ri-markup-fill:before { content: \"\\eede\"; }\n.ri-markup-line:before { content: \"\\eedf\"; }\n.ri-mastercard-fill:before { content: \"\\eee0\"; }\n.ri-mastercard-line:before { content: \"\\eee1\"; }\n.ri-mastodon-fill:before { content: \"\\eee2\"; }\n.ri-mastodon-line:before { content: \"\\eee3\"; }\n.ri-medal-2-fill:before { content: \"\\eee4\"; }\n.ri-medal-2-line:before { content: \"\\eee5\"; }\n.ri-medal-fill:before { content: \"\\eee6\"; }\n.ri-medal-line:before { content: \"\\eee7\"; }\n.ri-medium-fill:before { content: \"\\eee8\"; }\n.ri-medium-line:before { content: \"\\eee9\"; }\n.ri-men-fill:before { content: \"\\eeea\"; }\n.ri-men-line:before { content: \"\\eeeb\"; }\n.ri-menu-2-fill:before { content: \"\\eeec\"; }\n.ri-menu-2-line:before { content: \"\\eeed\"; }\n.ri-menu-3-fill:before { content: \"\\eeee\"; }\n.ri-menu-3-line:before { content: \"\\eeef\"; }\n.ri-menu-4-fill:before { content: \"\\eef0\"; }\n.ri-menu-4-line:before { content: \"\\eef1\"; }\n.ri-menu-5-fill:before { content: \"\\eef2\"; }\n.ri-menu-5-line:before { content: \"\\eef3\"; }\n.ri-menu-add-fill:before { content: \"\\eef4\"; }\n.ri-menu-add-line:before { content: \"\\eef5\"; }\n.ri-menu-fill:before { content: \"\\eef6\"; }\n.ri-menu-line:before { content: \"\\eef7\"; }\n.ri-message-2-fill:before { content: \"\\eef8\"; }\n.ri-message-2-line:before { content: \"\\eef9\"; }\n.ri-message-3-fill:before { content: \"\\eefa\"; }\n.ri-message-3-line:before { content: \"\\eefb\"; }\n.ri-message-fill:before { content: \"\\eefc\"; }\n.ri-message-line:before { content: \"\\eefd\"; }\n.ri-messenger-fill:before { content: \"\\eefe\"; }\n.ri-messenger-line:before { content: \"\\eeff\"; }\n.ri-meteor-fill:before { content: \"\\ef00\"; }\n.ri-meteor-line:before { content: \"\\ef01\"; }\n.ri-mic-2-fill:before { content: \"\\ef02\"; }\n.ri-mic-2-line:before { content: \"\\ef03\"; }\n.ri-mic-fill:before { content: \"\\ef04\"; }\n.ri-mic-line:before { content: \"\\ef05\"; }\n.ri-mic-off-fill:before { content: \"\\ef06\"; }\n.ri-mic-off-line:before { content: \"\\ef07\"; }\n.ri-mickey-fill:before { content: \"\\ef08\"; }\n.ri-mickey-line:before { content: \"\\ef09\"; }\n.ri-mini-program-fill:before { content: \"\\ef0a\"; }\n.ri-mini-program-line:before { content: \"\\ef0b\"; }\n.ri-mist-fill:before { content: \"\\ef0c\"; }\n.ri-mist-line:before { content: \"\\ef0d\"; }\n.ri-money-cny-box-fill:before { content: \"\\ef0e\"; }\n.ri-money-cny-box-line:before { content: \"\\ef0f\"; }\n.ri-money-cny-circle-fill:before { content: \"\\ef10\"; }\n.ri-money-cny-circle-line:before { content: \"\\ef11\"; }\n.ri-money-dollar-box-fill:before { content: \"\\ef12\"; }\n.ri-money-dollar-box-line:before { content: \"\\ef13\"; }\n.ri-money-dollar-circle-fill:before { content: \"\\ef14\"; }\n.ri-money-dollar-circle-line:before { content: \"\\ef15\"; }\n.ri-money-euro-box-fill:before { content: \"\\ef16\"; }\n.ri-money-euro-box-line:before { content: \"\\ef17\"; }\n.ri-money-euro-circle-fill:before { content: \"\\ef18\"; }\n.ri-money-euro-circle-line:before { content: \"\\ef19\"; }\n.ri-money-pound-box-fill:before { content: \"\\ef1a\"; }\n.ri-money-pound-box-line:before { content: \"\\ef1b\"; }\n.ri-money-pound-circle-fill:before { content: \"\\ef1c\"; }\n.ri-money-pound-circle-line:before { content: \"\\ef1d\"; }\n.ri-moon-clear-fill:before { content: \"\\ef1e\"; }\n.ri-moon-clear-line:before { content: \"\\ef1f\"; }\n.ri-moon-cloudy-fill:before { content: \"\\ef20\"; }\n.ri-moon-cloudy-line:before { content: \"\\ef21\"; }\n.ri-moon-fill:before { content: \"\\ef22\"; }\n.ri-moon-foggy-fill:before { content: \"\\ef23\"; }\n.ri-moon-foggy-line:before { content: \"\\ef24\"; }\n.ri-moon-line:before { content: \"\\ef25\"; }\n.ri-more-2-fill:before { content: \"\\ef26\"; }\n.ri-more-2-line:before { content: \"\\ef27\"; }\n.ri-more-fill:before { content: \"\\ef28\"; }\n.ri-more-line:before { content: \"\\ef29\"; }\n.ri-motorbike-fill:before { content: \"\\ef2a\"; }\n.ri-motorbike-line:before { content: \"\\ef2b\"; }\n.ri-mouse-fill:before { content: \"\\ef2c\"; }\n.ri-mouse-line:before { content: \"\\ef2d\"; }\n.ri-movie-2-fill:before { content: \"\\ef2e\"; }\n.ri-movie-2-line:before { content: \"\\ef2f\"; }\n.ri-movie-fill:before { content: \"\\ef30\"; }\n.ri-movie-line:before { content: \"\\ef31\"; }\n.ri-music-2-fill:before { content: \"\\ef32\"; }\n.ri-music-2-line:before { content: \"\\ef33\"; }\n.ri-music-fill:before { content: \"\\ef34\"; }\n.ri-music-line:before { content: \"\\ef35\"; }\n.ri-mv-fill:before { content: \"\\ef36\"; }\n.ri-mv-line:before { content: \"\\ef37\"; }\n.ri-navigation-fill:before { content: \"\\ef38\"; }\n.ri-navigation-line:before { content: \"\\ef39\"; }\n.ri-netease-cloud-music-fill:before { content: \"\\ef3a\"; }\n.ri-netease-cloud-music-line:before { content: \"\\ef3b\"; }\n.ri-netflix-fill:before { content: \"\\ef3c\"; }\n.ri-netflix-line:before { content: \"\\ef3d\"; }\n.ri-newspaper-fill:before { content: \"\\ef3e\"; }\n.ri-newspaper-line:before { content: \"\\ef3f\"; }\n.ri-notification-2-fill:before { content: \"\\ef40\"; }\n.ri-notification-2-line:before { content: \"\\ef41\"; }\n.ri-notification-3-fill:before { content: \"\\ef42\"; }\n.ri-notification-3-line:before { content: \"\\ef43\"; }\n.ri-notification-4-fill:before { content: \"\\ef44\"; }\n.ri-notification-4-line:before { content: \"\\ef45\"; }\n.ri-notification-badge-fill:before { content: \"\\ef46\"; }\n.ri-notification-badge-line:before { content: \"\\ef47\"; }\n.ri-notification-fill:before { content: \"\\ef48\"; }\n.ri-notification-line:before { content: \"\\ef49\"; }\n.ri-notification-off-fill:before { content: \"\\ef4a\"; }\n.ri-notification-off-line:before { content: \"\\ef4b\"; }\n.ri-npmjs-fill:before { content: \"\\ef4c\"; }\n.ri-npmjs-line:before { content: \"\\ef4d\"; }\n.ri-number-0:before { content: \"\\ef4e\"; }\n.ri-number-1:before { content: \"\\ef4f\"; }\n.ri-number-2:before { content: \"\\ef50\"; }\n.ri-number-3:before { content: \"\\ef51\"; }\n.ri-number-4:before { content: \"\\ef52\"; }\n.ri-number-5:before { content: \"\\ef53\"; }\n.ri-number-6:before { content: \"\\ef54\"; }\n.ri-number-7:before { content: \"\\ef55\"; }\n.ri-number-8:before { content: \"\\ef56\"; }\n.ri-number-9:before { content: \"\\ef57\"; }\n.ri-numbers-fill:before { content: \"\\ef58\"; }\n.ri-numbers-line:before { content: \"\\ef59\"; }\n.ri-oil-fill:before { content: \"\\ef5a\"; }\n.ri-oil-line:before { content: \"\\ef5b\"; }\n.ri-omega:before { content: \"\\ef5c\"; }\n.ri-open-arm-fill:before { content: \"\\ef5d\"; }\n.ri-open-arm-line:before { content: \"\\ef5e\"; }\n.ri-open-source-fill:before { content: \"\\ef5f\"; }\n.ri-open-source-line:before { content: \"\\ef60\"; }\n.ri-opera-fill:before { content: \"\\ef61\"; }\n.ri-opera-line:before { content: \"\\ef62\"; }\n.ri-order-play-fill:before { content: \"\\ef63\"; }\n.ri-order-play-line:before { content: \"\\ef64\"; }\n.ri-outlet-2-fill:before { content: \"\\ef65\"; }\n.ri-outlet-2-line:before { content: \"\\ef66\"; }\n.ri-outlet-fill:before { content: \"\\ef67\"; }\n.ri-outlet-line:before { content: \"\\ef68\"; }\n.ri-page-separator:before { content: \"\\ef69\"; }\n.ri-pages-fill:before { content: \"\\ef6a\"; }\n.ri-pages-line:before { content: \"\\ef6b\"; }\n.ri-paint-brush-fill:before { content: \"\\ef6c\"; }\n.ri-paint-brush-line:before { content: \"\\ef6d\"; }\n.ri-paint-fill:before { content: \"\\ef6e\"; }\n.ri-paint-line:before { content: \"\\ef6f\"; }\n.ri-palette-fill:before { content: \"\\ef70\"; }\n.ri-palette-line:before { content: \"\\ef71\"; }\n.ri-pantone-fill:before { content: \"\\ef72\"; }\n.ri-pantone-line:before { content: \"\\ef73\"; }\n.ri-paragraph:before { content: \"\\ef74\"; }\n.ri-parent-fill:before { content: \"\\ef75\"; }\n.ri-parent-line:before { content: \"\\ef76\"; }\n.ri-parentheses-fill:before { content: \"\\ef77\"; }\n.ri-parentheses-line:before { content: \"\\ef78\"; }\n.ri-parking-box-fill:before { content: \"\\ef79\"; }\n.ri-parking-box-line:before { content: \"\\ef7a\"; }\n.ri-parking-fill:before { content: \"\\ef7b\"; }\n.ri-parking-line:before { content: \"\\ef7c\"; }\n.ri-passport-fill:before { content: \"\\ef7d\"; }\n.ri-passport-line:before { content: \"\\ef7e\"; }\n.ri-patreon-fill:before { content: \"\\ef7f\"; }\n.ri-patreon-line:before { content: \"\\ef80\"; }\n.ri-pause-circle-fill:before { content: \"\\ef81\"; }\n.ri-pause-circle-line:before { content: \"\\ef82\"; }\n.ri-pause-fill:before { content: \"\\ef83\"; }\n.ri-pause-line:before { content: \"\\ef84\"; }\n.ri-pause-mini-fill:before { content: \"\\ef85\"; }\n.ri-pause-mini-line:before { content: \"\\ef86\"; }\n.ri-paypal-fill:before { content: \"\\ef87\"; }\n.ri-paypal-line:before { content: \"\\ef88\"; }\n.ri-pen-nib-fill:before { content: \"\\ef89\"; }\n.ri-pen-nib-line:before { content: \"\\ef8a\"; }\n.ri-pencil-fill:before { content: \"\\ef8b\"; }\n.ri-pencil-line:before { content: \"\\ef8c\"; }\n.ri-pencil-ruler-2-fill:before { content: \"\\ef8d\"; }\n.ri-pencil-ruler-2-line:before { content: \"\\ef8e\"; }\n.ri-pencil-ruler-fill:before { content: \"\\ef8f\"; }\n.ri-pencil-ruler-line:before { content: \"\\ef90\"; }\n.ri-percent-fill:before { content: \"\\ef91\"; }\n.ri-percent-line:before { content: \"\\ef92\"; }\n.ri-phone-camera-fill:before { content: \"\\ef93\"; }\n.ri-phone-camera-line:before { content: \"\\ef94\"; }\n.ri-phone-fill:before { content: \"\\ef95\"; }\n.ri-phone-find-fill:before { content: \"\\ef96\"; }\n.ri-phone-find-line:before { content: \"\\ef97\"; }\n.ri-phone-line:before { content: \"\\ef98\"; }\n.ri-phone-lock-fill:before { content: \"\\ef99\"; }\n.ri-phone-lock-line:before { content: \"\\ef9a\"; }\n.ri-picture-in-picture-2-fill:before { content: \"\\ef9b\"; }\n.ri-picture-in-picture-2-line:before { content: \"\\ef9c\"; }\n.ri-picture-in-picture-exit-fill:before { content: \"\\ef9d\"; }\n.ri-picture-in-picture-exit-line:before { content: \"\\ef9e\"; }\n.ri-picture-in-picture-fill:before { content: \"\\ef9f\"; }\n.ri-picture-in-picture-line:before { content: \"\\efa0\"; }\n.ri-pie-chart-2-fill:before { content: \"\\efa1\"; }\n.ri-pie-chart-2-line:before { content: \"\\efa2\"; }\n.ri-pie-chart-box-fill:before { content: \"\\efa3\"; }\n.ri-pie-chart-box-line:before { content: \"\\efa4\"; }\n.ri-pie-chart-fill:before { content: \"\\efa5\"; }\n.ri-pie-chart-line:before { content: \"\\efa6\"; }\n.ri-pin-distance-fill:before { content: \"\\efa7\"; }\n.ri-pin-distance-line:before { content: \"\\efa8\"; }\n.ri-ping-pong-fill:before { content: \"\\efa9\"; }\n.ri-ping-pong-line:before { content: \"\\efaa\"; }\n.ri-pinterest-fill:before { content: \"\\efab\"; }\n.ri-pinterest-line:before { content: \"\\efac\"; }\n.ri-pinyin-input:before { content: \"\\efad\"; }\n.ri-pixelfed-fill:before { content: \"\\efae\"; }\n.ri-pixelfed-line:before { content: \"\\efaf\"; }\n.ri-plane-fill:before { content: \"\\efb0\"; }\n.ri-plane-line:before { content: \"\\efb1\"; }\n.ri-plant-fill:before { content: \"\\efb2\"; }\n.ri-plant-line:before { content: \"\\efb3\"; }\n.ri-play-circle-fill:before { content: \"\\efb4\"; }\n.ri-play-circle-line:before { content: \"\\efb5\"; }\n.ri-play-fill:before { content: \"\\efb6\"; }\n.ri-play-line:before { content: \"\\efb7\"; }\n.ri-play-list-add-fill:before { content: \"\\efb8\"; }\n.ri-play-list-add-line:before { content: \"\\efb9\"; }\n.ri-play-list-fill:before { content: \"\\efba\"; }\n.ri-play-list-line:before { content: \"\\efbb\"; }\n.ri-play-mini-fill:before { content: \"\\efbc\"; }\n.ri-play-mini-line:before { content: \"\\efbd\"; }\n.ri-playstation-fill:before { content: \"\\efbe\"; }\n.ri-playstation-line:before { content: \"\\efbf\"; }\n.ri-plug-2-fill:before { content: \"\\efc0\"; }\n.ri-plug-2-line:before { content: \"\\efc1\"; }\n.ri-plug-fill:before { content: \"\\efc2\"; }\n.ri-plug-line:before { content: \"\\efc3\"; }\n.ri-polaroid-2-fill:before { content: \"\\efc4\"; }\n.ri-polaroid-2-line:before { content: \"\\efc5\"; }\n.ri-polaroid-fill:before { content: \"\\efc6\"; }\n.ri-polaroid-line:before { content: \"\\efc7\"; }\n.ri-police-car-fill:before { content: \"\\efc8\"; }\n.ri-police-car-line:before { content: \"\\efc9\"; }\n.ri-price-tag-2-fill:before { content: \"\\efca\"; }\n.ri-price-tag-2-line:before { content: \"\\efcb\"; }\n.ri-price-tag-3-fill:before { content: \"\\efcc\"; }\n.ri-price-tag-3-line:before { content: \"\\efcd\"; }\n.ri-price-tag-fill:before { content: \"\\efce\"; }\n.ri-price-tag-line:before { content: \"\\efcf\"; }\n.ri-printer-cloud-fill:before { content: \"\\efd0\"; }\n.ri-printer-cloud-line:before { content: \"\\efd1\"; }\n.ri-printer-fill:before { content: \"\\efd2\"; }\n.ri-printer-line:before { content: \"\\efd3\"; }\n.ri-product-hunt-fill:before { content: \"\\efd4\"; }\n.ri-product-hunt-line:before { content: \"\\efd5\"; }\n.ri-profile-fill:before { content: \"\\efd6\"; }\n.ri-profile-line:before { content: \"\\efd7\"; }\n.ri-projector-2-fill:before { content: \"\\efd8\"; }\n.ri-projector-2-line:before { content: \"\\efd9\"; }\n.ri-projector-fill:before { content: \"\\efda\"; }\n.ri-projector-line:before { content: \"\\efdb\"; }\n.ri-pushpin-2-fill:before { content: \"\\efdc\"; }\n.ri-pushpin-2-line:before { content: \"\\efdd\"; }\n.ri-pushpin-fill:before { content: \"\\efde\"; }\n.ri-pushpin-line:before { content: \"\\efdf\"; }\n.ri-qq-fill:before { content: \"\\efe0\"; }\n.ri-qq-line:before { content: \"\\efe1\"; }\n.ri-qr-code-fill:before { content: \"\\efe2\"; }\n.ri-qr-code-line:before { content: \"\\efe3\"; }\n.ri-qr-scan-2-fill:before { content: \"\\efe4\"; }\n.ri-qr-scan-2-line:before { content: \"\\efe5\"; }\n.ri-qr-scan-fill:before { content: \"\\efe6\"; }\n.ri-qr-scan-line:before { content: \"\\efe7\"; }\n.ri-question-answer-fill:before { content: \"\\efe8\"; }\n.ri-question-answer-line:before { content: \"\\efe9\"; }\n.ri-question-fill:before { content: \"\\efea\"; }\n.ri-question-line:before { content: \"\\efeb\"; }\n.ri-questionnaire-fill:before { content: \"\\efec\"; }\n.ri-questionnaire-line:before { content: \"\\efed\"; }\n.ri-quill-pen-fill:before { content: \"\\efee\"; }\n.ri-quill-pen-line:before { content: \"\\efef\"; }\n.ri-radar-fill:before { content: \"\\eff0\"; }\n.ri-radar-line:before { content: \"\\eff1\"; }\n.ri-radio-2-fill:before { content: \"\\eff2\"; }\n.ri-radio-2-line:before { content: \"\\eff3\"; }\n.ri-radio-button-fill:before { content: \"\\eff4\"; }\n.ri-radio-button-line:before { content: \"\\eff5\"; }\n.ri-radio-fill:before { content: \"\\eff6\"; }\n.ri-radio-line:before { content: \"\\eff7\"; }\n.ri-rainbow-fill:before { content: \"\\eff8\"; }\n.ri-rainbow-line:before { content: \"\\eff9\"; }\n.ri-rainy-fill:before { content: \"\\effa\"; }\n.ri-rainy-line:before { content: \"\\effb\"; }\n.ri-reactjs-fill:before { content: \"\\effc\"; }\n.ri-reactjs-line:before { content: \"\\effd\"; }\n.ri-record-circle-fill:before { content: \"\\effe\"; }\n.ri-record-circle-line:before { content: \"\\efff\"; }\n.ri-record-mail-fill:before { content: \"\\f000\"; }\n.ri-record-mail-line:before { content: \"\\f001\"; }\n.ri-recycle-fill:before { content: \"\\f002\"; }\n.ri-recycle-line:before { content: \"\\f003\"; }\n.ri-red-packet-fill:before { content: \"\\f004\"; }\n.ri-red-packet-line:before { content: \"\\f005\"; }\n.ri-reddit-fill:before { content: \"\\f006\"; }\n.ri-reddit-line:before { content: \"\\f007\"; }\n.ri-refresh-fill:before { content: \"\\f008\"; }\n.ri-refresh-line:before { content: \"\\f009\"; }\n.ri-refund-2-fill:before { content: \"\\f00a\"; }\n.ri-refund-2-line:before { content: \"\\f00b\"; }\n.ri-refund-fill:before { content: \"\\f00c\"; }\n.ri-refund-line:before { content: \"\\f00d\"; }\n.ri-registered-fill:before { content: \"\\f00e\"; }\n.ri-registered-line:before { content: \"\\f00f\"; }\n.ri-remixicon-fill:before { content: \"\\f010\"; }\n.ri-remixicon-line:before { content: \"\\f011\"; }\n.ri-remote-control-2-fill:before { content: \"\\f012\"; }\n.ri-remote-control-2-line:before { content: \"\\f013\"; }\n.ri-remote-control-fill:before { content: \"\\f014\"; }\n.ri-remote-control-line:before { content: \"\\f015\"; }\n.ri-repeat-2-fill:before { content: \"\\f016\"; }\n.ri-repeat-2-line:before { content: \"\\f017\"; }\n.ri-repeat-fill:before { content: \"\\f018\"; }\n.ri-repeat-line:before { content: \"\\f019\"; }\n.ri-repeat-one-fill:before { content: \"\\f01a\"; }\n.ri-repeat-one-line:before { content: \"\\f01b\"; }\n.ri-reply-fill:before { content: \"\\f01c\"; }\n.ri-reply-line:before { content: \"\\f01d\"; }\n.ri-reserved-fill:before { content: \"\\f01e\"; }\n.ri-reserved-line:before { content: \"\\f01f\"; }\n.ri-restart-fill:before { content: \"\\f020\"; }\n.ri-restart-line:before { content: \"\\f021\"; }\n.ri-restaurant-2-fill:before { content: \"\\f022\"; }\n.ri-restaurant-2-line:before { content: \"\\f023\"; }\n.ri-restaurant-fill:before { content: \"\\f024\"; }\n.ri-restaurant-line:before { content: \"\\f025\"; }\n.ri-rewind-fill:before { content: \"\\f026\"; }\n.ri-rewind-line:before { content: \"\\f027\"; }\n.ri-rewind-mini-fill:before { content: \"\\f028\"; }\n.ri-rewind-mini-line:before { content: \"\\f029\"; }\n.ri-rhythm-fill:before { content: \"\\f02a\"; }\n.ri-rhythm-line:before { content: \"\\f02b\"; }\n.ri-riding-fill:before { content: \"\\f02c\"; }\n.ri-riding-line:before { content: \"\\f02d\"; }\n.ri-road-map-fill:before { content: \"\\f02e\"; }\n.ri-road-map-line:before { content: \"\\f02f\"; }\n.ri-roadster-fill:before { content: \"\\f030\"; }\n.ri-roadster-line:before { content: \"\\f031\"; }\n.ri-robot-fill:before { content: \"\\f032\"; }\n.ri-robot-line:before { content: \"\\f033\"; }\n.ri-rocket-2-fill:before { content: \"\\f034\"; }\n.ri-rocket-2-line:before { content: \"\\f035\"; }\n.ri-rocket-fill:before { content: \"\\f036\"; }\n.ri-rocket-line:before { content: \"\\f037\"; }\n.ri-rotate-lock-fill:before { content: \"\\f038\"; }\n.ri-rotate-lock-line:before { content: \"\\f039\"; }\n.ri-route-fill:before { content: \"\\f03a\"; }\n.ri-route-line:before { content: \"\\f03b\"; }\n.ri-router-fill:before { content: \"\\f03c\"; }\n.ri-router-line:before { content: \"\\f03d\"; }\n.ri-rss-fill:before { content: \"\\f03e\"; }\n.ri-rss-line:before { content: \"\\f03f\"; }\n.ri-ruler-2-fill:before { content: \"\\f040\"; }\n.ri-ruler-2-line:before { content: \"\\f041\"; }\n.ri-ruler-fill:before { content: \"\\f042\"; }\n.ri-ruler-line:before { content: \"\\f043\"; }\n.ri-run-fill:before { content: \"\\f044\"; }\n.ri-run-line:before { content: \"\\f045\"; }\n.ri-safari-fill:before { content: \"\\f046\"; }\n.ri-safari-line:before { content: \"\\f047\"; }\n.ri-safe-2-fill:before { content: \"\\f048\"; }\n.ri-safe-2-line:before { content: \"\\f049\"; }\n.ri-safe-fill:before { content: \"\\f04a\"; }\n.ri-safe-line:before { content: \"\\f04b\"; }\n.ri-sailboat-fill:before { content: \"\\f04c\"; }\n.ri-sailboat-line:before { content: \"\\f04d\"; }\n.ri-save-2-fill:before { content: \"\\f04e\"; }\n.ri-save-2-line:before { content: \"\\f04f\"; }\n.ri-save-3-fill:before { content: \"\\f050\"; }\n.ri-save-3-line:before { content: \"\\f051\"; }\n.ri-save-fill:before { content: \"\\f052\"; }\n.ri-save-line:before { content: \"\\f053\"; }\n.ri-scales-2-fill:before { content: \"\\f054\"; }\n.ri-scales-2-line:before { content: \"\\f055\"; }\n.ri-scales-fill:before { content: \"\\f056\"; }\n.ri-scales-line:before { content: \"\\f057\"; }\n.ri-scan-2-fill:before { content: \"\\f058\"; }\n.ri-scan-2-line:before { content: \"\\f059\"; }\n.ri-scan-fill:before { content: \"\\f05a\"; }\n.ri-scan-line:before { content: \"\\f05b\"; }\n.ri-scissors-2-fill:before { content: \"\\f05c\"; }\n.ri-scissors-2-line:before { content: \"\\f05d\"; }\n.ri-scissors-cut-fill:before { content: \"\\f05e\"; }\n.ri-scissors-cut-line:before { content: \"\\f05f\"; }\n.ri-scissors-fill:before { content: \"\\f060\"; }\n.ri-scissors-line:before { content: \"\\f061\"; }\n.ri-screenshot-2-fill:before { content: \"\\f062\"; }\n.ri-screenshot-2-line:before { content: \"\\f063\"; }\n.ri-screenshot-fill:before { content: \"\\f064\"; }\n.ri-screenshot-line:before { content: \"\\f065\"; }\n.ri-sd-card-fill:before { content: \"\\f066\"; }\n.ri-sd-card-line:before { content: \"\\f067\"; }\n.ri-sd-card-mini-fill:before { content: \"\\f068\"; }\n.ri-sd-card-mini-line:before { content: \"\\f069\"; }\n.ri-search-2-fill:before { content: \"\\f06a\"; }\n.ri-search-2-line:before { content: \"\\f06b\"; }\n.ri-search-eye-fill:before { content: \"\\f06c\"; }\n.ri-search-eye-line:before { content: \"\\f06d\"; }\n.ri-search-fill:before { content: \"\\f06e\"; }\n.ri-search-line:before { content: \"\\f06f\"; }\n.ri-secure-payment-fill:before { content: \"\\f070\"; }\n.ri-secure-payment-line:before { content: \"\\f071\"; }\n.ri-send-backward:before { content: \"\\f072\"; }\n.ri-send-plane-2-fill:before { content: \"\\f073\"; }\n.ri-send-plane-2-line:before { content: \"\\f074\"; }\n.ri-send-plane-fill:before { content: \"\\f075\"; }\n.ri-send-plane-line:before { content: \"\\f076\"; }\n.ri-send-to-back:before { content: \"\\f077\"; }\n.ri-sensor-fill:before { content: \"\\f078\"; }\n.ri-sensor-line:before { content: \"\\f079\"; }\n.ri-separator:before { content: \"\\f07a\"; }\n.ri-server-fill:before { content: \"\\f07b\"; }\n.ri-server-line:before { content: \"\\f07c\"; }\n.ri-service-fill:before { content: \"\\f07d\"; }\n.ri-service-line:before { content: \"\\f07e\"; }\n.ri-settings-2-fill:before { content: \"\\f07f\"; }\n.ri-settings-2-line:before { content: \"\\f080\"; }\n.ri-settings-3-fill:before { content: \"\\f081\"; }\n.ri-settings-3-line:before { content: \"\\f082\"; }\n.ri-settings-4-fill:before { content: \"\\f083\"; }\n.ri-settings-4-line:before { content: \"\\f084\"; }\n.ri-settings-5-fill:before { content: \"\\f085\"; }\n.ri-settings-5-line:before { content: \"\\f086\"; }\n.ri-settings-6-fill:before { content: \"\\f087\"; }\n.ri-settings-6-line:before { content: \"\\f088\"; }\n.ri-settings-fill:before { content: \"\\f089\"; }\n.ri-settings-line:before { content: \"\\f08a\"; }\n.ri-shape-2-fill:before { content: \"\\f08b\"; }\n.ri-shape-2-line:before { content: \"\\f08c\"; }\n.ri-shape-fill:before { content: \"\\f08d\"; }\n.ri-shape-line:before { content: \"\\f08e\"; }\n.ri-share-box-fill:before { content: \"\\f08f\"; }\n.ri-share-box-line:before { content: \"\\f090\"; }\n.ri-share-circle-fill:before { content: \"\\f091\"; }\n.ri-share-circle-line:before { content: \"\\f092\"; }\n.ri-share-fill:before { content: \"\\f093\"; }\n.ri-share-forward-2-fill:before { content: \"\\f094\"; }\n.ri-share-forward-2-line:before { content: \"\\f095\"; }\n.ri-share-forward-box-fill:before { content: \"\\f096\"; }\n.ri-share-forward-box-line:before { content: \"\\f097\"; }\n.ri-share-forward-fill:before { content: \"\\f098\"; }\n.ri-share-forward-line:before { content: \"\\f099\"; }\n.ri-share-line:before { content: \"\\f09a\"; }\n.ri-shield-cross-fill:before { content: \"\\f09b\"; }\n.ri-shield-cross-line:before { content: \"\\f09c\"; }\n.ri-shield-fill:before { content: \"\\f09d\"; }\n.ri-shield-flash-fill:before { content: \"\\f09e\"; }\n.ri-shield-flash-line:before { content: \"\\f09f\"; }\n.ri-shield-keyhole-fill:before { content: \"\\f0a0\"; }\n.ri-shield-keyhole-line:before { content: \"\\f0a1\"; }\n.ri-shield-line:before { content: \"\\f0a2\"; }\n.ri-shield-star-fill:before { content: \"\\f0a3\"; }\n.ri-shield-star-line:before { content: \"\\f0a4\"; }\n.ri-shield-user-fill:before { content: \"\\f0a5\"; }\n.ri-shield-user-line:before { content: \"\\f0a6\"; }\n.ri-ship-2-fill:before { content: \"\\f0a7\"; }\n.ri-ship-2-line:before { content: \"\\f0a8\"; }\n.ri-ship-fill:before { content: \"\\f0a9\"; }\n.ri-ship-line:before { content: \"\\f0aa\"; }\n.ri-shirt-fill:before { content: \"\\f0ab\"; }\n.ri-shirt-line:before { content: \"\\f0ac\"; }\n.ri-shopping-bag-2-fill:before { content: \"\\f0ad\"; }\n.ri-shopping-bag-2-line:before { content: \"\\f0ae\"; }\n.ri-shopping-bag-3-fill:before { content: \"\\f0af\"; }\n.ri-shopping-bag-3-line:before { content: \"\\f0b0\"; }\n.ri-shopping-bag-fill:before { content: \"\\f0b1\"; }\n.ri-shopping-bag-line:before { content: \"\\f0b2\"; }\n.ri-shopping-basket-2-fill:before { content: \"\\f0b3\"; }\n.ri-shopping-basket-2-line:before { content: \"\\f0b4\"; }\n.ri-shopping-basket-fill:before { content: \"\\f0b5\"; }\n.ri-shopping-basket-line:before { content: \"\\f0b6\"; }\n.ri-shopping-cart-2-fill:before { content: \"\\f0b7\"; }\n.ri-shopping-cart-2-line:before { content: \"\\f0b8\"; }\n.ri-shopping-cart-fill:before { content: \"\\f0b9\"; }\n.ri-shopping-cart-line:before { content: \"\\f0ba\"; }\n.ri-showers-fill:before { content: \"\\f0bb\"; }\n.ri-showers-line:before { content: \"\\f0bc\"; }\n.ri-shuffle-fill:before { content: \"\\f0bd\"; }\n.ri-shuffle-line:before { content: \"\\f0be\"; }\n.ri-shut-down-fill:before { content: \"\\f0bf\"; }\n.ri-shut-down-line:before { content: \"\\f0c0\"; }\n.ri-side-bar-fill:before { content: \"\\f0c1\"; }\n.ri-side-bar-line:before { content: \"\\f0c2\"; }\n.ri-signal-tower-fill:before { content: \"\\f0c3\"; }\n.ri-signal-tower-line:before { content: \"\\f0c4\"; }\n.ri-signal-wifi-1-fill:before { content: \"\\f0c5\"; }\n.ri-signal-wifi-1-line:before { content: \"\\f0c6\"; }\n.ri-signal-wifi-2-fill:before { content: \"\\f0c7\"; }\n.ri-signal-wifi-2-line:before { content: \"\\f0c8\"; }\n.ri-signal-wifi-3-fill:before { content: \"\\f0c9\"; }\n.ri-signal-wifi-3-line:before { content: \"\\f0ca\"; }\n.ri-signal-wifi-error-fill:before { content: \"\\f0cb\"; }\n.ri-signal-wifi-error-line:before { content: \"\\f0cc\"; }\n.ri-signal-wifi-fill:before { content: \"\\f0cd\"; }\n.ri-signal-wifi-line:before { content: \"\\f0ce\"; }\n.ri-signal-wifi-off-fill:before { content: \"\\f0cf\"; }\n.ri-signal-wifi-off-line:before { content: \"\\f0d0\"; }\n.ri-sim-card-2-fill:before { content: \"\\f0d1\"; }\n.ri-sim-card-2-line:before { content: \"\\f0d2\"; }\n.ri-sim-card-fill:before { content: \"\\f0d3\"; }\n.ri-sim-card-line:before { content: \"\\f0d4\"; }\n.ri-single-quotes-l:before { content: \"\\f0d5\"; }\n.ri-single-quotes-r:before { content: \"\\f0d6\"; }\n.ri-sip-fill:before { content: \"\\f0d7\"; }\n.ri-sip-line:before { content: \"\\f0d8\"; }\n.ri-skip-back-fill:before { content: \"\\f0d9\"; }\n.ri-skip-back-line:before { content: \"\\f0da\"; }\n.ri-skip-back-mini-fill:before { content: \"\\f0db\"; }\n.ri-skip-back-mini-line:before { content: \"\\f0dc\"; }\n.ri-skip-forward-fill:before { content: \"\\f0dd\"; }\n.ri-skip-forward-line:before { content: \"\\f0de\"; }\n.ri-skip-forward-mini-fill:before { content: \"\\f0df\"; }\n.ri-skip-forward-mini-line:before { content: \"\\f0e0\"; }\n.ri-skull-2-fill:before { content: \"\\f0e1\"; }\n.ri-skull-2-line:before { content: \"\\f0e2\"; }\n.ri-skull-fill:before { content: \"\\f0e3\"; }\n.ri-skull-line:before { content: \"\\f0e4\"; }\n.ri-skype-fill:before { content: \"\\f0e5\"; }\n.ri-skype-line:before { content: \"\\f0e6\"; }\n.ri-slack-fill:before { content: \"\\f0e7\"; }\n.ri-slack-line:before { content: \"\\f0e8\"; }\n.ri-slice-fill:before { content: \"\\f0e9\"; }\n.ri-slice-line:before { content: \"\\f0ea\"; }\n.ri-slideshow-2-fill:before { content: \"\\f0eb\"; }\n.ri-slideshow-2-line:before { content: \"\\f0ec\"; }\n.ri-slideshow-3-fill:before { content: \"\\f0ed\"; }\n.ri-slideshow-3-line:before { content: \"\\f0ee\"; }\n.ri-slideshow-4-fill:before { content: \"\\f0ef\"; }\n.ri-slideshow-4-line:before { content: \"\\f0f0\"; }\n.ri-slideshow-fill:before { content: \"\\f0f1\"; }\n.ri-slideshow-line:before { content: \"\\f0f2\"; }\n.ri-smartphone-fill:before { content: \"\\f0f3\"; }\n.ri-smartphone-line:before { content: \"\\f0f4\"; }\n.ri-snapchat-fill:before { content: \"\\f0f5\"; }\n.ri-snapchat-line:before { content: \"\\f0f6\"; }\n.ri-snowy-fill:before { content: \"\\f0f7\"; }\n.ri-snowy-line:before { content: \"\\f0f8\"; }\n.ri-sort-asc:before { content: \"\\f0f9\"; }\n.ri-sort-desc:before { content: \"\\f0fa\"; }\n.ri-sound-module-fill:before { content: \"\\f0fb\"; }\n.ri-sound-module-line:before { content: \"\\f0fc\"; }\n.ri-soundcloud-fill:before { content: \"\\f0fd\"; }\n.ri-soundcloud-line:before { content: \"\\f0fe\"; }\n.ri-space-ship-fill:before { content: \"\\f0ff\"; }\n.ri-space-ship-line:before { content: \"\\f100\"; }\n.ri-space:before { content: \"\\f101\"; }\n.ri-spam-2-fill:before { content: \"\\f102\"; }\n.ri-spam-2-line:before { content: \"\\f103\"; }\n.ri-spam-3-fill:before { content: \"\\f104\"; }\n.ri-spam-3-line:before { content: \"\\f105\"; }\n.ri-spam-fill:before { content: \"\\f106\"; }\n.ri-spam-line:before { content: \"\\f107\"; }\n.ri-speaker-2-fill:before { content: \"\\f108\"; }\n.ri-speaker-2-line:before { content: \"\\f109\"; }\n.ri-speaker-3-fill:before { content: \"\\f10a\"; }\n.ri-speaker-3-line:before { content: \"\\f10b\"; }\n.ri-speaker-fill:before { content: \"\\f10c\"; }\n.ri-speaker-line:before { content: \"\\f10d\"; }\n.ri-spectrum-fill:before { content: \"\\f10e\"; }\n.ri-spectrum-line:before { content: \"\\f10f\"; }\n.ri-speed-fill:before { content: \"\\f110\"; }\n.ri-speed-line:before { content: \"\\f111\"; }\n.ri-speed-mini-fill:before { content: \"\\f112\"; }\n.ri-speed-mini-line:before { content: \"\\f113\"; }\n.ri-spotify-fill:before { content: \"\\f114\"; }\n.ri-spotify-line:before { content: \"\\f115\"; }\n.ri-spy-fill:before { content: \"\\f116\"; }\n.ri-spy-line:before { content: \"\\f117\"; }\n.ri-stack-fill:before { content: \"\\f118\"; }\n.ri-stack-line:before { content: \"\\f119\"; }\n.ri-stack-overflow-fill:before { content: \"\\f11a\"; }\n.ri-stack-overflow-line:before { content: \"\\f11b\"; }\n.ri-stackshare-fill:before { content: \"\\f11c\"; }\n.ri-stackshare-line:before { content: \"\\f11d\"; }\n.ri-star-fill:before { content: \"\\f11e\"; }\n.ri-star-half-fill:before { content: \"\\f11f\"; }\n.ri-star-half-line:before { content: \"\\f120\"; }\n.ri-star-half-s-fill:before { content: \"\\f121\"; }\n.ri-star-half-s-line:before { content: \"\\f122\"; }\n.ri-star-line:before { content: \"\\f123\"; }\n.ri-star-s-fill:before { content: \"\\f124\"; }\n.ri-star-s-line:before { content: \"\\f125\"; }\n.ri-star-smile-fill:before { content: \"\\f126\"; }\n.ri-star-smile-line:before { content: \"\\f127\"; }\n.ri-steam-fill:before { content: \"\\f128\"; }\n.ri-steam-line:before { content: \"\\f129\"; }\n.ri-steering-2-fill:before { content: \"\\f12a\"; }\n.ri-steering-2-line:before { content: \"\\f12b\"; }\n.ri-steering-fill:before { content: \"\\f12c\"; }\n.ri-steering-line:before { content: \"\\f12d\"; }\n.ri-sticky-note-2-fill:before { content: \"\\f12e\"; }\n.ri-sticky-note-2-line:before { content: \"\\f12f\"; }\n.ri-sticky-note-fill:before { content: \"\\f130\"; }\n.ri-sticky-note-line:before { content: \"\\f131\"; }\n.ri-stock-fill:before { content: \"\\f132\"; }\n.ri-stock-line:before { content: \"\\f133\"; }\n.ri-stop-circle-fill:before { content: \"\\f134\"; }\n.ri-stop-circle-line:before { content: \"\\f135\"; }\n.ri-stop-fill:before { content: \"\\f136\"; }\n.ri-stop-line:before { content: \"\\f137\"; }\n.ri-stop-mini-fill:before { content: \"\\f138\"; }\n.ri-stop-mini-line:before { content: \"\\f139\"; }\n.ri-store-2-fill:before { content: \"\\f13a\"; }\n.ri-store-2-line:before { content: \"\\f13b\"; }\n.ri-store-3-fill:before { content: \"\\f13c\"; }\n.ri-store-3-line:before { content: \"\\f13d\"; }\n.ri-store-fill:before { content: \"\\f13e\"; }\n.ri-store-line:before { content: \"\\f13f\"; }\n.ri-strikethrough-2:before { content: \"\\f140\"; }\n.ri-strikethrough:before { content: \"\\f141\"; }\n.ri-subscript-2:before { content: \"\\f142\"; }\n.ri-subscript:before { content: \"\\f143\"; }\n.ri-subtract-fill:before { content: \"\\f144\"; }\n.ri-subtract-line:before { content: \"\\f145\"; }\n.ri-subway-fill:before { content: \"\\f146\"; }\n.ri-subway-line:before { content: \"\\f147\"; }\n.ri-subway-wifi-fill:before { content: \"\\f148\"; }\n.ri-subway-wifi-line:before { content: \"\\f149\"; }\n.ri-suitcase-2-fill:before { content: \"\\f14a\"; }\n.ri-suitcase-2-line:before { content: \"\\f14b\"; }\n.ri-suitcase-3-fill:before { content: \"\\f14c\"; }\n.ri-suitcase-3-line:before { content: \"\\f14d\"; }\n.ri-suitcase-fill:before { content: \"\\f14e\"; }\n.ri-suitcase-line:before { content: \"\\f14f\"; }\n.ri-sun-cloudy-fill:before { content: \"\\f150\"; }\n.ri-sun-cloudy-line:before { content: \"\\f151\"; }\n.ri-sun-fill:before { content: \"\\f152\"; }\n.ri-sun-foggy-fill:before { content: \"\\f153\"; }\n.ri-sun-foggy-line:before { content: \"\\f154\"; }\n.ri-sun-line:before { content: \"\\f155\"; }\n.ri-superscript-2:before { content: \"\\f156\"; }\n.ri-superscript:before { content: \"\\f157\"; }\n.ri-surround-sound-fill:before { content: \"\\f158\"; }\n.ri-surround-sound-line:before { content: \"\\f159\"; }\n.ri-survey-fill:before { content: \"\\f15a\"; }\n.ri-survey-line:before { content: \"\\f15b\"; }\n.ri-swap-box-fill:before { content: \"\\f15c\"; }\n.ri-swap-box-line:before { content: \"\\f15d\"; }\n.ri-swap-fill:before { content: \"\\f15e\"; }\n.ri-swap-line:before { content: \"\\f15f\"; }\n.ri-switch-fill:before { content: \"\\f160\"; }\n.ri-switch-line:before { content: \"\\f161\"; }\n.ri-sword-fill:before { content: \"\\f162\"; }\n.ri-sword-line:before { content: \"\\f163\"; }\n.ri-t-box-fill:before { content: \"\\f164\"; }\n.ri-t-box-line:before { content: \"\\f165\"; }\n.ri-t-shirt-2-fill:before { content: \"\\f166\"; }\n.ri-t-shirt-2-line:before { content: \"\\f167\"; }\n.ri-t-shirt-air-fill:before { content: \"\\f168\"; }\n.ri-t-shirt-air-line:before { content: \"\\f169\"; }\n.ri-t-shirt-fill:before { content: \"\\f16a\"; }\n.ri-t-shirt-line:before { content: \"\\f16b\"; }\n.ri-table-2:before { content: \"\\f16c\"; }\n.ri-table-alt-fill:before { content: \"\\f16d\"; }\n.ri-table-alt-line:before { content: \"\\f16e\"; }\n.ri-table-fill:before { content: \"\\f16f\"; }\n.ri-table-line:before { content: \"\\f170\"; }\n.ri-tablet-fill:before { content: \"\\f171\"; }\n.ri-tablet-line:before { content: \"\\f172\"; }\n.ri-takeaway-fill:before { content: \"\\f173\"; }\n.ri-takeaway-line:before { content: \"\\f174\"; }\n.ri-taobao-fill:before { content: \"\\f175\"; }\n.ri-taobao-line:before { content: \"\\f176\"; }\n.ri-tape-fill:before { content: \"\\f177\"; }\n.ri-tape-line:before { content: \"\\f178\"; }\n.ri-task-fill:before { content: \"\\f179\"; }\n.ri-task-line:before { content: \"\\f17a\"; }\n.ri-taxi-fill:before { content: \"\\f17b\"; }\n.ri-taxi-line:before { content: \"\\f17c\"; }\n.ri-taxi-wifi-fill:before { content: \"\\f17d\"; }\n.ri-taxi-wifi-line:before { content: \"\\f17e\"; }\n.ri-team-fill:before { content: \"\\f17f\"; }\n.ri-team-line:before { content: \"\\f180\"; }\n.ri-telegram-fill:before { content: \"\\f181\"; }\n.ri-telegram-line:before { content: \"\\f182\"; }\n.ri-temp-cold-fill:before { content: \"\\f183\"; }\n.ri-temp-cold-line:before { content: \"\\f184\"; }\n.ri-temp-hot-fill:before { content: \"\\f185\"; }\n.ri-temp-hot-line:before { content: \"\\f186\"; }\n.ri-terminal-box-fill:before { content: \"\\f187\"; }\n.ri-terminal-box-line:before { content: \"\\f188\"; }\n.ri-terminal-fill:before { content: \"\\f189\"; }\n.ri-terminal-line:before { content: \"\\f18a\"; }\n.ri-terminal-window-fill:before { content: \"\\f18b\"; }\n.ri-terminal-window-line:before { content: \"\\f18c\"; }\n.ri-text-direction-l:before { content: \"\\f18d\"; }\n.ri-text-direction-r:before { content: \"\\f18e\"; }\n.ri-text-spacing:before { content: \"\\f18f\"; }\n.ri-text-wrap:before { content: \"\\f190\"; }\n.ri-text:before { content: \"\\f191\"; }\n.ri-thumb-down-fill:before { content: \"\\f192\"; }\n.ri-thumb-down-line:before { content: \"\\f193\"; }\n.ri-thumb-up-fill:before { content: \"\\f194\"; }\n.ri-thumb-up-line:before { content: \"\\f195\"; }\n.ri-thunderstorms-fill:before { content: \"\\f196\"; }\n.ri-thunderstorms-line:before { content: \"\\f197\"; }\n.ri-ticket-2-fill:before { content: \"\\f198\"; }\n.ri-ticket-2-line:before { content: \"\\f199\"; }\n.ri-ticket-fill:before { content: \"\\f19a\"; }\n.ri-ticket-line:before { content: \"\\f19b\"; }\n.ri-time-fill:before { content: \"\\f19c\"; }\n.ri-time-line:before { content: \"\\f19d\"; }\n.ri-timer-2-fill:before { content: \"\\f19e\"; }\n.ri-timer-2-line:before { content: \"\\f19f\"; }\n.ri-timer-fill:before { content: \"\\f1a0\"; }\n.ri-timer-flash-fill:before { content: \"\\f1a1\"; }\n.ri-timer-flash-line:before { content: \"\\f1a2\"; }\n.ri-timer-line:before { content: \"\\f1a3\"; }\n.ri-todo-fill:before { content: \"\\f1a4\"; }\n.ri-todo-line:before { content: \"\\f1a5\"; }\n.ri-toggle-fill:before { content: \"\\f1a6\"; }\n.ri-toggle-line:before { content: \"\\f1a7\"; }\n.ri-tools-fill:before { content: \"\\f1a8\"; }\n.ri-tools-line:before { content: \"\\f1a9\"; }\n.ri-tornado-fill:before { content: \"\\f1aa\"; }\n.ri-tornado-line:before { content: \"\\f1ab\"; }\n.ri-trademark-fill:before { content: \"\\f1ac\"; }\n.ri-trademark-line:before { content: \"\\f1ad\"; }\n.ri-traffic-light-fill:before { content: \"\\f1ae\"; }\n.ri-traffic-light-line:before { content: \"\\f1af\"; }\n.ri-train-fill:before { content: \"\\f1b0\"; }\n.ri-train-line:before { content: \"\\f1b1\"; }\n.ri-train-wifi-fill:before { content: \"\\f1b2\"; }\n.ri-train-wifi-line:before { content: \"\\f1b3\"; }\n.ri-translate-2:before { content: \"\\f1b4\"; }\n.ri-translate:before { content: \"\\f1b5\"; }\n.ri-travesti-fill:before { content: \"\\f1b6\"; }\n.ri-travesti-line:before { content: \"\\f1b7\"; }\n.ri-treasure-map-fill:before { content: \"\\f1b8\"; }\n.ri-treasure-map-line:before { content: \"\\f1b9\"; }\n.ri-trello-fill:before { content: \"\\f1ba\"; }\n.ri-trello-line:before { content: \"\\f1bb\"; }\n.ri-trophy-fill:before { content: \"\\f1bc\"; }\n.ri-trophy-line:before { content: \"\\f1bd\"; }\n.ri-truck-fill:before { content: \"\\f1be\"; }\n.ri-truck-line:before { content: \"\\f1bf\"; }\n.ri-tumblr-fill:before { content: \"\\f1c0\"; }\n.ri-tumblr-line:before { content: \"\\f1c1\"; }\n.ri-tv-2-fill:before { content: \"\\f1c2\"; }\n.ri-tv-2-line:before { content: \"\\f1c3\"; }\n.ri-tv-fill:before { content: \"\\f1c4\"; }\n.ri-tv-line:before { content: \"\\f1c5\"; }\n.ri-twitch-fill:before { content: \"\\f1c6\"; }\n.ri-twitch-line:before { content: \"\\f1c7\"; }\n.ri-twitter-fill:before { content: \"\\f1c8\"; }\n.ri-twitter-line:before { content: \"\\f1c9\"; }\n.ri-typhoon-fill:before { content: \"\\f1ca\"; }\n.ri-typhoon-line:before { content: \"\\f1cb\"; }\n.ri-u-disk-fill:before { content: \"\\f1cc\"; }\n.ri-u-disk-line:before { content: \"\\f1cd\"; }\n.ri-ubuntu-fill:before { content: \"\\f1ce\"; }\n.ri-ubuntu-line:before { content: \"\\f1cf\"; }\n.ri-umbrella-fill:before { content: \"\\f1d0\"; }\n.ri-umbrella-line:before { content: \"\\f1d1\"; }\n.ri-underline:before { content: \"\\f1d2\"; }\n.ri-uninstall-fill:before { content: \"\\f1d3\"; }\n.ri-uninstall-line:before { content: \"\\f1d4\"; }\n.ri-unsplash-fill:before { content: \"\\f1d5\"; }\n.ri-unsplash-line:before { content: \"\\f1d6\"; }\n.ri-upload-2-fill:before { content: \"\\f1d7\"; }\n.ri-upload-2-line:before { content: \"\\f1d8\"; }\n.ri-upload-cloud-2-fill:before { content: \"\\f1d9\"; }\n.ri-upload-cloud-2-line:before { content: \"\\f1da\"; }\n.ri-upload-cloud-fill:before { content: \"\\f1db\"; }\n.ri-upload-cloud-line:before { content: \"\\f1dc\"; }\n.ri-upload-fill:before { content: \"\\f1dd\"; }\n.ri-upload-line:before { content: \"\\f1de\"; }\n.ri-user-2-fill:before { content: \"\\f1df\"; }\n.ri-user-2-line:before { content: \"\\f1e0\"; }\n.ri-user-3-fill:before { content: \"\\f1e1\"; }\n.ri-user-3-line:before { content: \"\\f1e2\"; }\n.ri-user-4-fill:before { content: \"\\f1e3\"; }\n.ri-user-4-line:before { content: \"\\f1e4\"; }\n.ri-user-5-fill:before { content: \"\\f1e5\"; }\n.ri-user-5-line:before { content: \"\\f1e6\"; }\n.ri-user-6-fill:before { content: \"\\f1e7\"; }\n.ri-user-6-line:before { content: \"\\f1e8\"; }\n.ri-user-add-fill:before { content: \"\\f1e9\"; }\n.ri-user-add-line:before { content: \"\\f1ea\"; }\n.ri-user-fill:before { content: \"\\f1eb\"; }\n.ri-user-follow-fill:before { content: \"\\f1ec\"; }\n.ri-user-follow-line:before { content: \"\\f1ed\"; }\n.ri-user-heart-fill:before { content: \"\\f1ee\"; }\n.ri-user-heart-line:before { content: \"\\f1ef\"; }\n.ri-user-line:before { content: \"\\f1f0\"; }\n.ri-user-location-fill:before { content: \"\\f1f1\"; }\n.ri-user-location-line:before { content: \"\\f1f2\"; }\n.ri-user-received-2-fill:before { content: \"\\f1f3\"; }\n.ri-user-received-2-line:before { content: \"\\f1f4\"; }\n.ri-user-received-fill:before { content: \"\\f1f5\"; }\n.ri-user-received-line:before { content: \"\\f1f6\"; }\n.ri-user-search-fill:before { content: \"\\f1f7\"; }\n.ri-user-search-line:before { content: \"\\f1f8\"; }\n.ri-user-settings-fill:before { content: \"\\f1f9\"; }\n.ri-user-settings-line:before { content: \"\\f1fa\"; }\n.ri-user-shared-2-fill:before { content: \"\\f1fb\"; }\n.ri-user-shared-2-line:before { content: \"\\f1fc\"; }\n.ri-user-shared-fill:before { content: \"\\f1fd\"; }\n.ri-user-shared-line:before { content: \"\\f1fe\"; }\n.ri-user-smile-fill:before { content: \"\\f1ff\"; }\n.ri-user-smile-line:before { content: \"\\f200\"; }\n.ri-user-star-fill:before { content: \"\\f201\"; }\n.ri-user-star-line:before { content: \"\\f202\"; }\n.ri-user-unfollow-fill:before { content: \"\\f203\"; }\n.ri-user-unfollow-line:before { content: \"\\f204\"; }\n.ri-user-voice-fill:before { content: \"\\f205\"; }\n.ri-user-voice-line:before { content: \"\\f206\"; }\n.ri-video-add-fill:before { content: \"\\f207\"; }\n.ri-video-add-line:before { content: \"\\f208\"; }\n.ri-video-chat-fill:before { content: \"\\f209\"; }\n.ri-video-chat-line:before { content: \"\\f20a\"; }\n.ri-video-download-fill:before { content: \"\\f20b\"; }\n.ri-video-download-line:before { content: \"\\f20c\"; }\n.ri-video-fill:before { content: \"\\f20d\"; }\n.ri-video-line:before { content: \"\\f20e\"; }\n.ri-video-upload-fill:before { content: \"\\f20f\"; }\n.ri-video-upload-line:before { content: \"\\f210\"; }\n.ri-vidicon-2-fill:before { content: \"\\f211\"; }\n.ri-vidicon-2-line:before { content: \"\\f212\"; }\n.ri-vidicon-fill:before { content: \"\\f213\"; }\n.ri-vidicon-line:before { content: \"\\f214\"; }\n.ri-vip-crown-2-fill:before { content: \"\\f215\"; }\n.ri-vip-crown-2-line:before { content: \"\\f216\"; }\n.ri-vip-crown-fill:before { content: \"\\f217\"; }\n.ri-vip-crown-line:before { content: \"\\f218\"; }\n.ri-vip-diamond-fill:before { content: \"\\f219\"; }\n.ri-vip-diamond-line:before { content: \"\\f21a\"; }\n.ri-vip-fill:before { content: \"\\f21b\"; }\n.ri-vip-line:before { content: \"\\f21c\"; }\n.ri-visa-fill:before { content: \"\\f21d\"; }\n.ri-visa-line:before { content: \"\\f21e\"; }\n.ri-voice-recognition-fill:before { content: \"\\f21f\"; }\n.ri-voice-recognition-line:before { content: \"\\f220\"; }\n.ri-voiceprint-fill:before { content: \"\\f221\"; }\n.ri-voiceprint-line:before { content: \"\\f222\"; }\n.ri-volume-down-fill:before { content: \"\\f223\"; }\n.ri-volume-down-line:before { content: \"\\f224\"; }\n.ri-volume-mute-fill:before { content: \"\\f225\"; }\n.ri-volume-mute-line:before { content: \"\\f226\"; }\n.ri-volume-off-vibrate-fill:before { content: \"\\f227\"; }\n.ri-volume-off-vibrate-line:before { content: \"\\f228\"; }\n.ri-volume-up-fill:before { content: \"\\f229\"; }\n.ri-volume-up-line:before { content: \"\\f22a\"; }\n.ri-volume-vibrate-fill:before { content: \"\\f22b\"; }\n.ri-volume-vibrate-line:before { content: \"\\f22c\"; }\n.ri-vuejs-fill:before { content: \"\\f22d\"; }\n.ri-vuejs-line:before { content: \"\\f22e\"; }\n.ri-walk-fill:before { content: \"\\f22f\"; }\n.ri-walk-line:before { content: \"\\f230\"; }\n.ri-wallet-2-fill:before { content: \"\\f231\"; }\n.ri-wallet-2-line:before { content: \"\\f232\"; }\n.ri-wallet-3-fill:before { content: \"\\f233\"; }\n.ri-wallet-3-line:before { content: \"\\f234\"; }\n.ri-wallet-fill:before { content: \"\\f235\"; }\n.ri-wallet-line:before { content: \"\\f236\"; }\n.ri-water-flash-fill:before { content: \"\\f237\"; }\n.ri-water-flash-line:before { content: \"\\f238\"; }\n.ri-webcam-fill:before { content: \"\\f239\"; }\n.ri-webcam-line:before { content: \"\\f23a\"; }\n.ri-wechat-2-fill:before { content: \"\\f23b\"; }\n.ri-wechat-2-line:before { content: \"\\f23c\"; }\n.ri-wechat-fill:before { content: \"\\f23d\"; }\n.ri-wechat-line:before { content: \"\\f23e\"; }\n.ri-wechat-pay-fill:before { content: \"\\f23f\"; }\n.ri-wechat-pay-line:before { content: \"\\f240\"; }\n.ri-weibo-fill:before { content: \"\\f241\"; }\n.ri-weibo-line:before { content: \"\\f242\"; }\n.ri-whatsapp-fill:before { content: \"\\f243\"; }\n.ri-whatsapp-line:before { content: \"\\f244\"; }\n.ri-wheelchair-fill:before { content: \"\\f245\"; }\n.ri-wheelchair-line:before { content: \"\\f246\"; }\n.ri-wifi-fill:before { content: \"\\f247\"; }\n.ri-wifi-line:before { content: \"\\f248\"; }\n.ri-wifi-off-fill:before { content: \"\\f249\"; }\n.ri-wifi-off-line:before { content: \"\\f24a\"; }\n.ri-window-2-fill:before { content: \"\\f24b\"; }\n.ri-window-2-line:before { content: \"\\f24c\"; }\n.ri-window-fill:before { content: \"\\f24d\"; }\n.ri-window-line:before { content: \"\\f24e\"; }\n.ri-windows-fill:before { content: \"\\f24f\"; }\n.ri-windows-line:before { content: \"\\f250\"; }\n.ri-windy-fill:before { content: \"\\f251\"; }\n.ri-windy-line:before { content: \"\\f252\"; }\n.ri-wireless-charging-fill:before { content: \"\\f253\"; }\n.ri-wireless-charging-line:before { content: \"\\f254\"; }\n.ri-women-fill:before { content: \"\\f255\"; }\n.ri-women-line:before { content: \"\\f256\"; }\n.ri-wubi-input:before { content: \"\\f257\"; }\n.ri-xbox-fill:before { content: \"\\f258\"; }\n.ri-xbox-line:before { content: \"\\f259\"; }\n.ri-xing-fill:before { content: \"\\f25a\"; }\n.ri-xing-line:before { content: \"\\f25b\"; }\n.ri-youtube-fill:before { content: \"\\f25c\"; }\n.ri-youtube-line:before { content: \"\\f25d\"; }\n.ri-zcool-fill:before { content: \"\\f25e\"; }\n.ri-zcool-line:before { content: \"\\f25f\"; }\n.ri-zhihu-fill:before { content: \"\\f260\"; }\n.ri-zhihu-line:before { content: \"\\f261\"; }\n.ri-zoom-in-fill:before { content: \"\\f262\"; }\n.ri-zoom-in-line:before { content: \"\\f263\"; }\n.ri-zoom-out-fill:before { content: \"\\f264\"; }\n.ri-zoom-out-line:before { content: \"\\f265\"; }\n\n","/*\nTemplate Name: Nazox -  Admin & Dashboard Template\nAuthor: Themesdesign\nVersion: 2.3.0\nContact: themesdesign.in@gmail.com\nFile: Custom Bootstrap Css File\n*/\n\n//Core files\n@import \"./node_modules/bootstrap/scss/functions\";\n\n// IMPORTANT: Set color-mode-type BEFORE Bootstrap variables load\n// This ensures Bootstrap uses data-bs-theme attribute instead of prefers-color-scheme\n$color-mode-type: data;\n\n@import \"./node_modules/bootstrap/scss/variables\";\n@import \"variables\";\n@import \"variables-dark\";\n@import \"./node_modules/bootstrap/scss/bootstrap\";\n\n@import \"custom/components/root\";\n@import \"custom/components/reboot\";\n@import \"custom/components/backgrounds\";\n@import \"custom/components/badge\";\n@import \"custom/components/buttons\";\n@import \"custom/components/breadcrumb\";\n@import \"custom/components/card\";\n@import \"custom/components/dropdown\";\n@import \"custom/components/nav\";\n@import \"custom/components/table\";\n@import \"custom/components/pagination\";\n@import \"custom/components/progress\";\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.3 (https://getbootstrap.com/)\n   * Copyright 2011-2024 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n\n//\n// custom-variables\n//\n\n// Vertical Sidebar - Default Light\n$sidebar-bg: var(--#{$prefix}sidebar-bg);\n$sidebar-menu-item-color: var(--#{$prefix}sidebar-menu-item-color);\n$sidebar-menu-sub-item-color: var(--#{$prefix}sidebar-menu-sub-item-color);\n$sidebar-menu-item-icon-color: var(--#{$prefix}sidebar-menu-item-icon-color);\n$sidebar-menu-item-hover-color: var(--#{$prefix}sidebar-menu-item-hover-color);\n$sidebar-menu-item-active-color: var(\n  --#{$prefix}sidebar-menu-item-active-color\n);\n$sidebar-width: 240px;\n$sidebar-collapsed-width: 70px;\n$sidebar-width-sm: 160px;\n\n// Vertical Sidebar - Dark\n$sidebar-dark-bg: var(--#{$prefix}sidebar-dark-bg); //2c313a\n$sidebar-dark-menu-item-color: var(--#{$prefix}sidebar-dark-menu-item-color);\n$sidebar-dark-menu-sub-item-color: var(\n  --#{$prefix}sidebar-dark-menu-sub-item-color\n);\n$sidebar-dark-menu-item-icon-color: var(\n  --#{$prefix}sidebar-dark-menu-item-icon-color\n);\n$sidebar-dark-menu-item-hover-color: var(\n  --#{$prefix}sidebar-dark-menu-item-hover-color\n);\n$sidebar-dark-menu-item-active-color: var(\n  --#{$prefix}sidebar-dark-menu-item-active-color\n);\n\n// Topbar - Deafult Light\n$header-height: 70px;\n$header-bg: var(--#{$prefix}header-bg);\n$header-item-color: var(--#{$prefix}header-item-color);\n\n// Topbar - Dark\n$header-dark-bg: var(--#{$prefix}header-dark-bg);\n$header-dark-item-color: #e9ecef;\n\n// Topbar - Colored\n$header-colored-bg: var(--#{$prefix}header-colored-bg);\n\n// Topbar Search\n$topbar-search-bg: var(--#{$prefix}topbar-search-bg);\n\n// Footer\n$footer-height: 60px;\n$footer-bg: var(--#{$prefix}footer-bg);\n$footer-color: #74788d;\n\n// Horizontal nav\n$topnav-bg: var(--#{$prefix}topnav-bg);\n\n$menu-item-color: var(--#{$prefix}menu-item-color);\n$menu-item-active-color: var(--#{$prefix}menu-item-active-color);\n\n// Right Sidebar\n$rightbar-width: 280px;\n\n// Display\n$display-none: none;\n$display-block: block;\n\n// Brand\n$navbar-brand-box-width: 240px;\n\n// Boxed layout width\n$boxed-layout-width: 1300px;\n$boxed-body-bg: var(--#{$prefix}boxed-body-bg);\n\n// Font Weight\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n\n// apex charts\n$apex-grid-color: $border-color;\n\n// table\n$table-head-bg: var(--#{$prefix}tertiary-bg);\n$table-dark-border-color: tint-color($gray-800, 7.5%);\n\n// Custom Font\n$font-family-secondary: \"Inter\", sans-serif;\n\n// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white: #fff;\n$gray-100: #faf8f8;\n$gray-200: #f7efef;\n$gray-300: #aaa9a9;\n$gray-400: #dad1ce;\n$gray-500: #bdbcad;\n$gray-600: #74788d;\n$gray-700: #2d3448;\n$gray-800: #252b3b;\n$gray-900: #212529;\n$black: #000;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900,\n);\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue: #5664d2;\n$indigo: #564ab1;\n$purple: #5664d2;\n$pink: #e83e8c;\n$red: #ff3d60;\n$orange: #f1734f;\n$yellow: #fcb92c;\n$green: #1cbb8c;\n$teal: #050505;\n$cyan: #4aa3ff;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\": $blue,\n  \"indigo\": $indigo,\n  \"purple\": $purple,\n  \"pink\": $pink,\n  \"red\": $red,\n  \"orange\": $orange,\n  \"yellow\": $yellow,\n  \"green\": $green,\n  \"teal\": $teal,\n  \"cyan\": $cyan,\n  \"black\": $black,\n  \"white\": $white,\n  \"gray\": $gray-600,\n  \"gray-dark\": $gray-800,\n);\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio: 1.7;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark: $black;\n$color-contrast-light: $white;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%);\n$blue-200: tint-color($blue, 60%);\n$blue-300: tint-color($blue, 40%);\n$blue-400: tint-color($blue, 20%);\n$blue-500: $blue;\n$blue-600: shade-color($blue, 20%);\n$blue-700: shade-color($blue, 40%);\n$blue-800: shade-color($blue, 60%);\n$blue-900: shade-color($blue, 80%);\n\n$indigo-100: tint-color($indigo, 80%);\n$indigo-200: tint-color($indigo, 60%);\n$indigo-300: tint-color($indigo, 40%);\n$indigo-400: tint-color($indigo, 20%);\n$indigo-500: $indigo;\n$indigo-600: shade-color($indigo, 20%);\n$indigo-700: shade-color($indigo, 40%);\n$indigo-800: shade-color($indigo, 60%);\n$indigo-900: shade-color($indigo, 80%);\n\n$purple-100: tint-color($purple, 80%);\n$purple-200: tint-color($purple, 60%);\n$purple-300: tint-color($purple, 40%);\n$purple-400: tint-color($purple, 20%);\n$purple-500: $purple;\n$purple-600: shade-color($purple, 20%);\n$purple-700: shade-color($purple, 40%);\n$purple-800: shade-color($purple, 60%);\n$purple-900: shade-color($purple, 80%);\n\n$pink-100: tint-color($pink, 80%);\n$pink-200: tint-color($pink, 60%);\n$pink-300: tint-color($pink, 40%);\n$pink-400: tint-color($pink, 20%);\n$pink-500: $pink;\n$pink-600: shade-color($pink, 20%);\n$pink-700: shade-color($pink, 40%);\n$pink-800: shade-color($pink, 60%);\n$pink-900: shade-color($pink, 80%);\n\n$red-100: tint-color($red, 80%);\n$red-200: tint-color($red, 60%);\n$red-300: tint-color($red, 40%);\n$red-400: tint-color($red, 20%);\n$red-500: $red;\n$red-600: shade-color($red, 20%);\n$red-700: shade-color($red, 40%);\n$red-800: shade-color($red, 60%);\n$red-900: shade-color($red, 80%);\n\n$orange-100: tint-color($orange, 80%);\n$orange-200: tint-color($orange, 60%);\n$orange-300: tint-color($orange, 40%);\n$orange-400: tint-color($orange, 20%);\n$orange-500: $orange;\n$orange-600: shade-color($orange, 20%);\n$orange-700: shade-color($orange, 40%);\n$orange-800: shade-color($orange, 60%);\n$orange-900: shade-color($orange, 80%);\n\n$yellow-100: tint-color($yellow, 80%);\n$yellow-200: tint-color($yellow, 60%);\n$yellow-300: tint-color($yellow, 40%);\n$yellow-400: tint-color($yellow, 20%);\n$yellow-500: $yellow;\n$yellow-600: shade-color($yellow, 20%);\n$yellow-700: shade-color($yellow, 40%);\n$yellow-800: shade-color($yellow, 60%);\n$yellow-900: shade-color($yellow, 80%);\n\n$green-100: tint-color($green, 80%);\n$green-200: tint-color($green, 60%);\n$green-300: tint-color($green, 40%);\n$green-400: tint-color($green, 20%);\n$green-500: $green;\n$green-600: shade-color($green, 20%);\n$green-700: shade-color($green, 40%);\n$green-800: shade-color($green, 60%);\n$green-900: shade-color($green, 80%);\n\n$teal-100: tint-color($teal, 80%);\n$teal-200: tint-color($teal, 60%);\n$teal-300: tint-color($teal, 40%);\n$teal-400: tint-color($teal, 20%);\n$teal-500: $teal;\n$teal-600: shade-color($teal, 20%);\n$teal-700: shade-color($teal, 40%);\n$teal-800: shade-color($teal, 60%);\n$teal-900: shade-color($teal, 80%);\n\n$cyan-100: tint-color($cyan, 80%);\n$cyan-200: tint-color($cyan, 60%);\n$cyan-300: tint-color($cyan, 40%);\n$cyan-400: tint-color($cyan, 20%);\n$cyan-500: $cyan;\n$cyan-600: shade-color($cyan, 20%);\n$cyan-700: shade-color($cyan, 40%);\n$cyan-800: shade-color($cyan, 60%);\n$cyan-900: shade-color($cyan, 80%);\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900,\n);\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900,\n);\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900,\n);\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900,\n);\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900,\n);\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900,\n);\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900,\n);\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900,\n);\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900,\n);\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900,\n);\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary: rgb(255, 90, 95);\n$secondary: #008489;\n$success: $green;\n$info: $cyan;\n$warning: $yellow;\n$danger: $red;\n$light: $gray-100;\n$dark: $gray-900;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\": $primary,\n  \"secondary\": $secondary,\n  \"success\": $success,\n  \"info\": $info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark,\n);\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis: shade-color($primary, 60%);\n$secondary-text-emphasis: shade-color($secondary, 60%);\n$success-text-emphasis: shade-color($success, 60%);\n$info-text-emphasis: shade-color($info, 60%);\n$warning-text-emphasis: shade-color($warning, 60%);\n$danger-text-emphasis: shade-color($danger, 60%);\n$light-text-emphasis: $gray-700;\n$dark-text-emphasis: $gray-700;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle: tint-color($primary, 80%);\n$secondary-bg-subtle: tint-color($secondary, 80%);\n$success-bg-subtle: tint-color($success, 80%);\n$info-bg-subtle: tint-color($info, 80%);\n$warning-bg-subtle: tint-color($warning, 80%);\n$danger-bg-subtle: tint-color($danger, 80%);\n$light-bg-subtle: mix($gray-100, $white);\n$dark-bg-subtle: $gray-400;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle: tint-color($primary, 60%);\n$secondary-border-subtle: tint-color($secondary, 60%);\n$success-border-subtle: tint-color($success, 60%);\n$info-border-subtle: tint-color($info, 60%);\n$warning-border-subtle: tint-color($warning, 60%);\n$danger-border-subtle: tint-color($danger, 60%);\n$light-border-subtle: $gray-200;\n$dark-border-subtle: $gray-500;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\")\n);\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret: false;\n$enable-rounded: true;\n$enable-shadows: false;\n$enable-gradients: false;\n$enable-transitions: true;\n$enable-reduced-motion: true;\n$enable-smooth-scroll: true;\n$enable-grid-classes: true;\n$enable-container-classes: true;\n$enable-cssgrid: false;\n$enable-button-pointers: true;\n$enable-rfs: true;\n$enable-validation-icons: true;\n$enable-negative-margins: true;\n$enable-deprecation-messages: true;\n$enable-important-utilities: true;\n\n$enable-dark-mode: true;\n$color-mode-type: data; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix: bs-; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix: $variable-prefix;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, 0.15), rgba($white, 0));\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem;\n$spacers: (\n  0: 0,\n  1: $spacer * 0.25,\n  2: $spacer * 0.5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n);\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%,\n);\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align: null;\n$body-color: $gray-900;\n$body-bg: #f1f5f7;\n\n$body-secondary-color: rgba($body-color, 0.75);\n$body-secondary-bg: $white;\n\n$body-tertiary-color: rgba($body-color, 0.5);\n$body-tertiary-bg: $gray-100;\n\n$body-emphasis-color: $black;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color: $secondary;\n$link-decoration: none;\n$link-shade-percentage: 20%;\n$link-hover-color: shift-color($link-color, $link-shade-percentage);\n$link-hover-decoration: underline;\n\n$stretched-link-pseudo-element: after;\n$stretched-link-z-index: 1;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap: 0.375rem;\n$icon-link-underline-offset: 0.25em;\n$icon-link-icon-size: 1em;\n$icon-link-icon-transition: 0.2s ease-in-out transform;\n$icon-link-icon-transform: translate3d(0.25em, 0, 0);\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom: 1rem;\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px,\n);\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px,\n);\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns: 12;\n$grid-gutter-width: 1.5rem;\n$grid-row-columns: 6;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width * 0.5;\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width: 1px;\n$border-widths: (\n  0: 0,\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px,\n);\n$border-style: solid;\n$border-color: $gray-300;\n$border-color-translucent: rgba($black, 0.175);\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius: 0.375rem;\n$border-radius-sm: 0.25rem;\n$border-radius-lg: 0.5rem;\n$border-radius-xl: 1rem;\n$border-radius-xxl: 2rem;\n$border-radius-pill: 50rem;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl: $border-radius-xxl; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow-sm: 0 1px 1px rgba($black, 0.05);\n$box-shadow: 0 2px 4px rgba($black, 0.08);\n$box-shadow-lg: 0 5px 12px rgba($black, 0.1);\n$box-shadow-inset: inset 0 1px 2px rgba($black, 0.075);\n// scss-docs-end box-shadow-variables\n\n$component-active-color: $white;\n$component-active-bg: $primary;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width: 0.25rem;\n$focus-ring-opacity: 0.25;\n$focus-ring-color: rgba($primary, $focus-ring-opacity);\n$focus-ring-blur: 0;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width: 0.3em;\n$caret-vertical-align: $caret-width * 0.85;\n$caret-spacing: $caret-width * 0.85;\n// scss-docs-end caret-variables\n\n$transition-base: all 0.2s ease-in-out;\n$transition-fade: opacity 0.15s linear;\n// scss-docs-start collapse-transition\n$transition-collapse: height 0.35s ease;\n$transition-collapse-width: width 0.35s ease;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%),\n);\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif: \"Nunito\", sans-serif;\n$font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas,\n  \"Liberation Mono\", \"Courier New\", monospace;\n// stylelint-enable value-keyword-case\n$font-family-base: var(--#{$prefix}font-sans-serif);\n$font-family-code: var(--#{$prefix}font-monospace);\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root: null;\n$font-size-base: 0.9rem; // Assumes the browser default, typically `16px`\n$font-size-sm: $font-size-base * 0.875;\n$font-size-lg: $font-size-base * 1.25;\n\n$font-weight-lighter: lighter;\n$font-weight-light: 300;\n$font-weight-normal: 400;\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n$font-weight-bold: 800;\n$font-weight-bolder: bolder;\n\n$font-weight-base: $font-weight-normal;\n\n$line-height-base: 1.5;\n$line-height-sm: 1.25;\n$line-height-lg: 2;\n\n$h1-font-size: $font-size-base * 2.5;\n$h2-font-size: $font-size-base * 2;\n$h3-font-size: $font-size-base * 1.75;\n$h4-font-size: $font-size-base * 1.5;\n$h5-font-size: $font-size-base * 1.25;\n$h6-font-size: $font-size-base;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size,\n);\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom: $spacer * 0.5;\n$headings-font-family: null;\n$headings-font-style: null;\n$headings-font-weight: 500;\n$headings-line-height: 1.2;\n$headings-color: $gray-800;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem,\n);\n\n$display-font-family: null;\n$display-font-style: null;\n$display-font-weight: 300;\n$display-line-height: $headings-line-height;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size: $font-size-base * 1.25;\n$lead-font-weight: 300;\n\n$small-font-size: 80%;\n\n$sub-sup-font-size: 0.75em;\n\n// fusv-disable\n$text-muted: var(--#{$prefix}secondary-color); // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size: $small-font-size;\n\n$blockquote-margin-y: $spacer;\n$blockquote-font-size: $font-size-base * 1.25;\n$blockquote-footer-color: $gray-600;\n$blockquote-footer-font-size: $small-font-size;\n\n$hr-margin-y: $spacer;\n$hr-color: rgba($black, 0.1);\n\n// fusv-disable\n$hr-bg-color: null; // Deprecated in v5.2.0\n$hr-height: null; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color: null; // Allows for inherited colors\n$hr-border-width: var(--#{$prefix}border-width);\n$hr-opacity: 0.7;\n\n// scss-docs-start vr-variables\n$vr-border-width: var(--#{$prefix}border-width);\n// scss-docs-end vr-variables\n\n$legend-margin-bottom: 0.5rem !default;\n$legend-font-size: 1.5rem !default;\n$legend-font-weight: null !default;\n\n$dt-font-weight: $font-weight-bold;\n\n$list-inline-padding: 0.5rem;\n\n$mark-padding: 0.2em;\n$mark-bg: #fcf8e3;\n$mark-color: $body-color;\n// scss-docs-end type-variables\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y: 0.75rem;\n$table-cell-padding-x: 0.75rem;\n$table-cell-padding-y-sm: 0.3rem;\n$table-cell-padding-x-sm: 0.3rem;\n\n$table-cell-vertical-align: top;\n\n$table-color: var(--#{$prefix}body-color);\n$table-bg: var(--#{$prefix}table-bg);\n$table-accent-bg: transparent;\n\n$table-th-font-weight: null;\n\n$table-striped-color: $table-color;\n$table-striped-bg-factor: 0.05;\n$table-striped-bg: rgba($black, $table-striped-bg-factor);\n\n$table-active-color: $table-color;\n$table-active-bg-factor: 0.1;\n$table-active-bg: rgba($black, $table-active-bg-factor);\n\n$table-hover-color: $table-color;\n$table-hover-bg-factor: 0.075;\n$table-hover-bg: rgba($black, $table-hover-bg-factor);\n\n$table-border-factor: 0.1;\n$table-border-width: var(--#{$prefix}border-width);\n$table-border-color: var(--#{$prefix}border-color);\n\n$table-striped-order: odd;\n$table-striped-columns-order: even;\n\n$table-group-separator-color: $border-color;\n\n$table-caption-color: var(--#{$prefix}secondary-color);\n\n$table-bg-scale: -80%;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\": shift-color($primary, $table-bg-scale),\n  \"secondary\": shift-color($secondary, $table-bg-scale),\n  \"success\": shift-color($success, $table-bg-scale),\n  \"info\": shift-color($info, $table-bg-scale),\n  \"warning\": shift-color($warning, $table-bg-scale),\n  \"danger\": shift-color($danger, $table-bg-scale),\n  \"light\": $gray-100,\n  \"dark\": $dark,\n);\n// scss-docs-end table-loop\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y: 0.47rem;\n$input-btn-padding-x: 0.75rem;\n$input-btn-font-family: null;\n$input-btn-font-size: $font-size-base;\n$input-btn-line-height: $line-height-base;\n\n$input-btn-focus-width: $focus-ring-width;\n$input-btn-focus-color-opacity: $focus-ring-opacity;\n$input-btn-focus-color: $focus-ring-color;\n$input-btn-focus-blur: $focus-ring-blur;\n$input-btn-focus-box-shadow: $focus-ring-box-shadow;\n\n$input-btn-padding-y-sm: 0.25rem;\n$input-btn-padding-x-sm: 0.5rem;\n$input-btn-font-size-sm: $font-size-sm;\n\n$input-btn-padding-y-lg: 0.5rem;\n$input-btn-padding-x-lg: 1rem;\n$input-btn-font-size-lg: $font-size-lg;\n\n$input-btn-border-width: var(--#{$prefix}border-width);\n// scss-docs-end input-btn-variables\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color: $white;\n$btn-padding-y: $input-btn-padding-y;\n$btn-padding-x: $input-btn-padding-x;\n$btn-font-family: $input-btn-font-family;\n$btn-font-size: $input-btn-font-size;\n$btn-line-height: $input-btn-line-height;\n$btn-white-space: null; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm: $input-btn-padding-y-sm;\n$btn-padding-x-sm: $input-btn-padding-x-sm;\n$btn-font-size-sm: $input-btn-font-size-sm;\n\n$btn-padding-y-lg: $input-btn-padding-y-lg;\n$btn-padding-x-lg: $input-btn-padding-x-lg;\n$btn-font-size-lg: $input-btn-font-size-lg;\n\n$btn-border-width: $input-btn-border-width;\n\n$btn-font-weight: $font-weight-normal;\n$btn-box-shadow: inset 0 1px 0 rgba($white, 0.15), 0 1px 1px rgba($black, 0.075);\n$btn-focus-width: $input-btn-focus-width;\n$btn-focus-box-shadow: $input-btn-focus-box-shadow;\n$btn-disabled-opacity: 0.65;\n$btn-active-box-shadow: inset 0 3px 5px rgba($black, 0.125);\n\n$btn-link-color: var(--#{$prefix}link-color);\n$btn-link-hover-color: var(--#{$prefix}link-hover-color);\n$btn-link-disabled-color: $gray-600;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius: var(--#{$prefix}border-radius);\n$btn-border-radius-sm: var(--#{$prefix}border-radius-sm);\n$btn-border-radius-lg: var(--#{$prefix}border-radius-lg);\n\n$btn-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n$btn-hover-bg-shade-amount: 15%;\n$btn-hover-bg-tint-amount: 15%;\n$btn-hover-border-shade-amount: 20%;\n$btn-hover-border-tint-amount: 10%;\n$btn-active-bg-shade-amount: 20%;\n$btn-active-bg-tint-amount: 20%;\n$btn-active-border-shade-amount: 25%;\n$btn-active-border-tint-amount: 10%;\n// scss-docs-end btn-variables\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top: 0.25rem;\n$form-text-font-size: $small-font-size;\n$form-text-font-style: null;\n$form-text-font-weight: null;\n$form-text-color: var(--#{$prefix}secondary-color);\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom: 0.5rem;\n$form-label-font-size: null;\n$form-label-font-style: null;\n$form-label-font-weight: null;\n$form-label-color: null;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y: $input-btn-padding-y;\n$input-padding-x: $input-btn-padding-x;\n$input-font-family: $input-btn-font-family;\n$input-font-size: $input-btn-font-size;\n$input-font-weight: $font-weight-base;\n$input-line-height: $input-btn-line-height;\n\n$input-padding-y-sm: $input-btn-padding-y-sm;\n$input-padding-x-sm: $input-btn-padding-x-sm;\n$input-font-size-sm: $input-btn-font-size-sm;\n\n$input-padding-y-lg: $input-btn-padding-y-lg;\n$input-padding-x-lg: $input-btn-padding-x-lg;\n$input-font-size-lg: $input-btn-font-size-lg;\n\n$input-bg: var(--#{$prefix}secondary-bg);\n$input-disabled-color: null;\n$input-disabled-bg: var(--#{$prefix}secondary-bg);\n$input-disabled-border-color: null;\n\n$input-color: var(--#{$prefix}body-color);\n$input-border-color: var(--#{$prefix}border-color-translucent);\n$input-border-width: $input-btn-border-width;\n$input-box-shadow: $box-shadow-inset;\n\n$input-border-radius: var(--#{$prefix}border-radius);\n$input-border-radius-sm: var(--#{$prefix}border-radius-sm);\n$input-border-radius-lg: var(--#{$prefix}border-radius-lg);\n\n$input-focus-bg: $input-bg;\n$input-focus-border-color: tint-color($component-active-bg, 50%);\n$input-focus-color: $input-color;\n$input-focus-width: $input-btn-focus-width;\n$input-focus-box-shadow: $input-btn-focus-box-shadow;\n\n$input-placeholder-color: var(--#{$prefix}secondary-color);\n$input-plaintext-color: var(--#{$prefix}body-color);\n\n$input-height-border: calc(\n  #{$input-border-width} * 2\n); // stylelint-disable-line function-disallowed-list\n\n$input-height-inner: add($input-line-height * 1em, $input-padding-y * 2);\n$input-height-inner-half: add($input-line-height * 0.5em, $input-padding-y);\n$input-height-inner-quarter: add(\n  $input-line-height * 0.25em,\n  $input-padding-y * 0.5\n);\n\n$input-height: add(\n  $input-line-height * 1em,\n  add($input-padding-y * 2, $input-height-border, false)\n);\n$input-height-sm: add(\n  $input-line-height * 1em,\n  add($input-padding-y-sm * 2, $input-height-border, false)\n);\n$input-height-lg: add(\n  $input-line-height * 1em,\n  add($input-padding-y-lg * 2, $input-height-border, false)\n);\n\n$input-transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n$form-color-width: 3rem;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width: 1em;\n$form-check-min-height: $font-size-base * $line-height-base;\n$form-check-padding-start: $form-check-input-width + 0.5em;\n$form-check-margin-bottom: 0.125rem;\n$form-check-label-color: null;\n$form-check-label-cursor: null;\n$form-check-transition: background-color 0.15s ease-in-out,\n  background-position 0.15s ease-in-out, border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out;\n\n$form-check-input-active-filter: brightness(90%);\n\n$form-check-input-bg: $input-bg;\n$form-check-input-border: var(--#{$prefix}border-width) solid\n  var(--#{$prefix}border-color-translucent);\n$form-check-input-border-radius: 0.25em;\n$form-check-radio-border-radius: 50%;\n$form-check-input-focus-border: $input-focus-border-color;\n$form-check-input-focus-box-shadow: $focus-ring-box-shadow;\n\n$form-check-input-checked-color: $component-active-color;\n$form-check-input-checked-bg-color: $component-active-bg;\n$form-check-input-checked-border-color: $form-check-input-checked-bg-color;\n$form-check-input-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\");\n$form-check-radio-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\");\n\n$form-check-input-indeterminate-color: $component-active-color;\n$form-check-input-indeterminate-bg-color: $component-active-bg;\n$form-check-input-indeterminate-border-color: $form-check-input-indeterminate-bg-color;\n$form-check-input-indeterminate-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\");\n\n$form-check-input-disabled-opacity: 0.5;\n$form-check-label-disabled-opacity: $form-check-input-disabled-opacity;\n$form-check-btn-check-disabled-opacity: $btn-disabled-opacity;\n\n$form-check-inline-margin-end: 1rem;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color: rgba($black, 0.25);\n$form-switch-width: 2em;\n$form-switch-padding-start: $form-switch-width + 0.5em;\n$form-switch-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\");\n$form-switch-border-radius: $form-switch-width;\n$form-switch-transition: background-position 0.15s ease-in-out;\n\n$form-switch-focus-color: $input-focus-border-color;\n$form-switch-focus-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\");\n\n$form-switch-checked-color: $component-active-color;\n$form-switch-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\");\n$form-switch-checked-bg-position: right center;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y: $input-padding-y;\n$input-group-addon-padding-x: $input-padding-x;\n$input-group-addon-font-weight: $input-font-weight;\n$input-group-addon-color: $input-color;\n$input-group-addon-bg: var(--#{$prefix}tertiary-bg);\n$input-group-addon-border-color: $input-border-color;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y: $input-padding-y;\n$form-select-padding-x: $input-padding-x;\n$form-select-font-family: $input-font-family;\n$form-select-font-size: $input-font-size;\n$form-select-indicator-padding: $form-select-padding-x * 3; // Extra padding for background-image\n$form-select-font-weight: $input-font-weight;\n$form-select-line-height: $input-line-height;\n$form-select-color: $input-color;\n$form-select-bg: $input-bg;\n$form-select-disabled-color: null;\n$form-select-disabled-bg: $input-disabled-bg;\n$form-select-disabled-border-color: $input-disabled-border-color;\n$form-select-bg-position: right $form-select-padding-x center;\n$form-select-bg-size: 16px 12px; // In pixels because image dimensions\n$form-select-indicator-color: $gray-800;\n$form-select-indicator: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\");\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 +\n  $form-select-indicator-padding;\n$form-select-feedback-icon-position: center right $form-select-indicator-padding;\n$form-select-feedback-icon-size: $input-height-inner-half\n  $input-height-inner-half;\n\n$form-select-border-width: $input-border-width;\n$form-select-border-color: $input-border-color;\n$form-select-border-radius: $input-border-radius;\n$form-select-box-shadow: $box-shadow-inset;\n\n$form-select-focus-border-color: $input-focus-border-color;\n$form-select-focus-width: $input-focus-width;\n$form-select-focus-box-shadow: 0 0 0 $form-select-focus-width\n  $input-btn-focus-color;\n\n$form-select-padding-y-sm: $input-padding-y-sm;\n$form-select-padding-x-sm: $input-padding-x-sm;\n$form-select-font-size-sm: $input-font-size-sm;\n$form-select-border-radius-sm: $input-border-radius-sm;\n\n$form-select-padding-y-lg: $input-padding-y-lg;\n$form-select-padding-x-lg: $input-padding-x-lg;\n$form-select-font-size-lg: $input-font-size-lg;\n$form-select-border-radius-lg: $input-border-radius-lg;\n$form-select-transition: $input-transition;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width: 100%;\n$form-range-track-height: 0.5rem;\n$form-range-track-cursor: pointer;\n$form-range-track-bg: var(--#{$prefix}tertiary-bg);\n$form-range-track-border-radius: 1rem;\n$form-range-track-box-shadow: $box-shadow-inset;\n\n$form-range-thumb-width: 1rem;\n$form-range-thumb-height: $form-range-thumb-width;\n$form-range-thumb-bg: $component-active-bg;\n$form-range-thumb-border: 0;\n$form-range-thumb-border-radius: 1rem;\n$form-range-thumb-box-shadow: 0 0.1rem 0.25rem rgba($black, 0.1);\n$form-range-thumb-focus-box-shadow: 0 0 0 1px $body-bg, $input-focus-box-shadow;\n$form-range-thumb-focus-box-shadow-width: $input-focus-width; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg: tint-color($component-active-bg, 70%);\n$form-range-thumb-disabled-bg: var(--#{$prefix}secondary-color);\n$form-range-thumb-transition: background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color: $input-color;\n$form-file-button-bg: var(--#{$prefix}tertiary-bg);\n$form-file-button-hover-bg: var(--#{$prefix}secondary-bg);\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height: add(3.5rem, $input-height-border);\n$form-floating-line-height: 1.25;\n$form-floating-padding-x: $input-padding-x;\n$form-floating-padding-y: 1rem;\n$form-floating-input-padding-t: 1.625rem;\n$form-floating-input-padding-b: 0.625rem;\n$form-floating-label-height: 1.5em;\n$form-floating-label-opacity: 0.65;\n$form-floating-label-transform: scale(0.85) translateY(-0.5rem)\n  translateX(0.15rem);\n$form-floating-label-disabled-color: $gray-600;\n$form-floating-transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top: $form-text-margin-top;\n$form-feedback-font-size: $form-text-font-size;\n$form-feedback-font-style: $form-text-font-style;\n$form-feedback-valid-color: $success;\n$form-feedback-invalid-color: $danger;\n\n$form-feedback-icon-valid-color: $form-feedback-valid-color;\n$form-feedback-icon-valid: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\");\n$form-feedback-icon-invalid-color: $form-feedback-invalid-color;\n$form-feedback-icon-invalid: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\");\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color: $form-feedback-valid-color;\n$form-valid-border-color: $form-feedback-valid-color;\n$form-invalid-color: $form-feedback-invalid-color;\n$form-invalid-border-color: $form-feedback-invalid-color;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width\n      rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width\n      rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  ),\n);\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown: 1000;\n$zindex-sticky: 1020;\n$zindex-fixed: 1030;\n$zindex-offcanvas-backdrop: 1040;\n$zindex-offcanvas: 1050;\n$zindex-modal-backdrop: 1050;\n$zindex-modal: 1060;\n$zindex-popover: 1070;\n$zindex-tooltip: 1080;\n$zindex-toast: 1090;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3,\n);\n// scss-docs-end zindex-levels-map\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y: 0.5rem;\n$nav-link-padding-x: 1rem;\n$nav-link-font-size: null;\n$nav-link-font-weight: null;\n$nav-link-color: var(--#{$prefix}link-color);\n$nav-link-hover-color: var(--#{$prefix}link-hover-color);\n$nav-link-transition: color 0.15s ease-in-out,\n  background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n$nav-link-disabled-color: var(--#{$prefix}secondary-color);\n$nav-link-focus-box-shadow: $focus-ring-box-shadow;\n\n$nav-tabs-border-color: var(--#{$prefix}border-color);\n$nav-tabs-border-width: var(--#{$prefix}border-width);\n$nav-tabs-border-radius: var(--#{$prefix}border-radius);\n$nav-tabs-link-hover-border-color: var(--#{$prefix}secondary-bg)\n  var(--#{$prefix}secondary-bg) $nav-tabs-border-color;\n$nav-tabs-link-active-color: var(--#{$prefix}emphasis-color);\n$nav-tabs-link-active-bg: var(--#{$prefix}secondary-bg);\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color)\n  var(--#{$prefix}border-color) $nav-tabs-link-active-bg;\n\n$nav-pills-border-radius: var(--#{$prefix}border-radius);\n$nav-pills-link-active-color: $component-active-color;\n$nav-pills-link-active-bg: $component-active-bg;\n\n$nav-underline-gap: 1rem;\n$nav-underline-border-width: 0.125rem;\n$nav-underline-link-active-color: var(--#{$prefix}emphasis-color);\n// scss-docs-end nav-variables\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y: $spacer * 0.5;\n$navbar-padding-x: null;\n\n$navbar-nav-link-padding-x: 0.5rem;\n\n$navbar-brand-font-size: $font-size-lg;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height: $font-size-base * $line-height-base + $nav-link-padding-y * 2;\n$navbar-brand-height: $navbar-brand-font-size * $line-height-base;\n$navbar-brand-padding-y: ($nav-link-height - $navbar-brand-height) * 0.5;\n$navbar-brand-margin-end: 1rem;\n\n$navbar-toggler-padding-y: 0.25rem;\n$navbar-toggler-padding-x: 0.75rem;\n$navbar-toggler-font-size: $font-size-lg;\n$navbar-toggler-border-radius: $btn-border-radius;\n$navbar-toggler-focus-width: $btn-focus-width;\n$navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n\n$navbar-light-color: rgba(var(--#{$prefix}emphasis-color-rgb), 0.65);\n$navbar-light-hover-color: rgba(var(--#{$prefix}emphasis-color-rgb), 0.8);\n$navbar-light-active-color: rgba(var(--#{$prefix}emphasis-color-rgb), 1);\n$navbar-light-disabled-color: rgba(var(--#{$prefix}emphasis-color-rgb), 0.3);\n$navbar-light-icon-color: rgba($body-color, 0.75);\n$navbar-light-toggler-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-light-toggler-border-color: rgba(\n  var(--#{$prefix}emphasis-color-rgb),\n  0.15\n);\n$navbar-light-brand-color: $navbar-light-active-color;\n$navbar-light-brand-hover-color: $navbar-light-active-color;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color: rgba($white, 0.55);\n$navbar-dark-hover-color: rgba($white, 0.75);\n$navbar-dark-active-color: $white;\n$navbar-dark-disabled-color: rgba($white, 0.25);\n$navbar-dark-toggler-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-dark-toggler-border-color: rgba($white, 0.1);\n$navbar-dark-brand-color: $navbar-dark-active-color;\n$navbar-dark-brand-hover-color: $navbar-dark-active-color;\n// scss-docs-end navbar-dark-variables\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width: 10rem;\n$dropdown-padding-x: 0;\n$dropdown-padding-y: 0.5rem;\n$dropdown-spacer: 0.125rem;\n$dropdown-font-size: $font-size-base;\n$dropdown-color: var(--#{$prefix}body-color);\n$dropdown-bg: var(--#{$prefix}secondary-bg);\n$dropdown-border-color: var(--#{$prefix}border-color);\n$dropdown-border-radius: var(--#{$prefix}border-radius);\n$dropdown-border-width: var(--#{$prefix}border-width);\n$dropdown-inner-border-radius: calc(\n  #{$dropdown-border-radius} - #{$dropdown-border-width}\n); // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg: $dropdown-border-color;\n$dropdown-divider-margin-y: $spacer * 0.5;\n$dropdown-box-shadow: 0 0.5rem 1rem rgba($black, 0.175);\n\n$dropdown-link-color: var(--#{$prefix}body-color);\n$dropdown-link-hover-color: $dropdown-link-color;\n$dropdown-link-hover-bg: var(--#{$prefix}tertiary-bg);\n\n$dropdown-link-active-color: var(--#{$prefix}secondary-color);\n$dropdown-link-active-bg: var(--#{$prefix}tertiary-bg);\n\n$dropdown-link-disabled-color: var(--#{$prefix}tertiary-color);\n\n$dropdown-item-padding-y: 0.35rem;\n$dropdown-item-padding-x: 1.5rem;\n\n$dropdown-header-color: $gray-600;\n$dropdown-header-padding-x: $dropdown-item-padding-x;\n$dropdown-header-padding-y: $dropdown-padding-y;\n// fusv-disable\n$dropdown-header-padding: $dropdown-header-padding-y $dropdown-header-padding-x; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color: $gray-300;\n$dropdown-dark-bg: $gray-800;\n$dropdown-dark-border-color: $dropdown-border-color;\n$dropdown-dark-divider-bg: $dropdown-divider-bg;\n$dropdown-dark-box-shadow: null;\n$dropdown-dark-link-color: $dropdown-dark-color;\n$dropdown-dark-link-hover-color: $white;\n$dropdown-dark-link-hover-bg: rgba($white, 0.15);\n$dropdown-dark-link-active-color: $dropdown-link-active-color;\n$dropdown-dark-link-active-bg: $dropdown-link-active-bg;\n$dropdown-dark-link-disabled-color: $gray-500;\n$dropdown-dark-header-color: $gray-500;\n// scss-docs-end dropdown-dark-variables\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y: 0.5rem;\n$pagination-padding-x: 0.75rem;\n$pagination-padding-y-sm: 0.25rem;\n$pagination-padding-x-sm: 0.5rem;\n$pagination-padding-y-lg: 0.75rem;\n$pagination-padding-x-lg: 1.5rem;\n\n$pagination-font-size: $font-size-base;\n\n$pagination-color: var(--#{$prefix}link-color);\n$pagination-bg: var(--#{$prefix}secondary-bg);\n$pagination-border-radius: var(--#{$prefix}border-radius);\n$pagination-border-width: var(--#{$prefix}border-width);\n$pagination-margin-start: calc(\n  #{$pagination-border-width} * -1\n); // stylelint-disable-line function-disallowed-list\n$pagination-border-color: var(--#{$prefix}border-color);\n\n$pagination-focus-color: var(--#{$prefix}link-hover-color);\n$pagination-focus-bg: var(--#{$prefix}secondary-bg);\n$pagination-focus-box-shadow: $focus-ring-box-shadow;\n$pagination-focus-outline: 0;\n\n$pagination-hover-color: var(--#{$prefix}link-hover-color);\n$pagination-hover-bg: var(--#{$prefix}tertiary-bg);\n$pagination-hover-border-color: var(\n  --#{$prefix}border-color\n); // Todo in v6: remove this?\n\n$pagination-active-color: $component-active-color;\n$pagination-active-bg: $component-active-bg;\n$pagination-active-border-color: $component-active-bg;\n\n$pagination-disabled-color: var(--#{$prefix}secondary-color);\n$pagination-disabled-bg: var(--#{$prefix}secondary-bg);\n$pagination-disabled-border-color: var(--#{$prefix}border-color);\n\n$pagination-transition: color 0.15s ease-in-out,\n  background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out;\n\n$pagination-border-radius-sm: var(--#{$prefix}border-radius-sm);\n$pagination-border-radius-lg: var(--#{$prefix}border-radius-lg);\n// scss-docs-end pagination-variables\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max: 0.5;\n$placeholder-opacity-min: 0.2;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y: 1.25rem;\n$card-spacer-x: 1.25rem;\n$card-title-spacer-y: $spacer * 0.5;\n$card-title-color: null;\n$card-subtitle-color: null;\n$card-border-width: var(--#{$prefix}border-width);\n$card-border-color: var(--#{$prefix}border-color);\n$card-border-radius: var(--#{$prefix}border-radius);\n$card-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n$card-inner-border-radius: subtract($card-border-radius, $card-border-width);\n$card-cap-padding-y: $card-spacer-y * 0.5;\n$card-cap-padding-x: $card-spacer-x;\n$card-cap-bg: rgba(var(--#{$prefix}body-color-rgb), 0.03);\n$card-cap-color: null;\n$card-height: null;\n$card-color: null;\n$card-bg: var(--#{$prefix}secondary-bg);\n$card-img-overlay-padding: $spacer;\n$card-group-margin: $grid-gutter-width * 0.5;\n$card-title-desc: $gray-600;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y: 1rem;\n$accordion-padding-x: 1.25rem;\n$accordion-color: var(--#{$prefix}body-color);\n$accordion-bg: var(--#{$prefix}secondary-bg);\n$accordion-border-width: var(--#{$prefix}border-width);\n$accordion-border-color: var(--#{$prefix}border-color-translucent);\n$accordion-border-radius: var(--#{$prefix}border-radius);\n$accordion-inner-border-radius: subtract(\n  $accordion-border-radius,\n  $accordion-border-width\n);\n\n$accordion-body-padding-y: $accordion-padding-y;\n$accordion-body-padding-x: $accordion-padding-x;\n\n$accordion-button-padding-y: $accordion-padding-y;\n$accordion-button-padding-x: $accordion-padding-x;\n$accordion-button-color: var(--#{$prefix}body-color);\n$accordion-button-bg: var(--#{$prefix}accordion-bg);\n$accordion-transition: $btn-transition, border-radius 0.15s ease;\n$accordion-button-active-bg: var(--#{$prefix}primary-bg-subtle);\n$accordion-button-active-color: var(--#{$prefix}primary-text-emphasis);\n\n$accordion-button-focus-border-color: $input-focus-border-color;\n$accordion-button-focus-box-shadow: $btn-focus-box-shadow;\n\n$accordion-icon-width: 1.25rem;\n$accordion-icon-color: $body-color;\n$accordion-icon-active-color: $primary-text-emphasis;\n$accordion-icon-transition: transform 0.2s ease-in-out;\n$accordion-icon-transform: rotate(-180deg);\n\n$accordion-button-icon: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n$accordion-button-active-icon: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size: $font-size-sm;\n$tooltip-max-width: 200px;\n$tooltip-color: var(--#{$prefix}body-bg);\n$tooltip-bg: var(--#{$prefix}emphasis-color);\n$tooltip-border-radius: var(--#{$prefix}border-radius);\n$tooltip-opacity: 0.9;\n$tooltip-padding-y: $spacer * 0.25;\n$tooltip-padding-x: $spacer * 0.5;\n$tooltip-margin: null; // TODO: remove this in v6\n\n$tooltip-arrow-width: 0.8rem;\n$tooltip-arrow-height: 0.4rem;\n// fusv-disable\n$tooltip-arrow-color: $tooltip-bg; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y: $tooltip-padding-y;\n$form-feedback-tooltip-padding-x: $tooltip-padding-x;\n$form-feedback-tooltip-font-size: $tooltip-font-size;\n$form-feedback-tooltip-line-height: null;\n$form-feedback-tooltip-opacity: $tooltip-opacity;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\n// scss-docs-end tooltip-feedback-variables\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size: $font-size-sm;\n$popover-bg: var(--#{$prefix}secondary-bg);\n$popover-max-width: 276px;\n$popover-border-width: var(--#{$prefix}border-width);\n$popover-border-color: var(--#{$prefix}border-color-translucent);\n$popover-border-radius: var(--#{$prefix}border-radius-lg);\n$popover-inner-border-radius: calc(\n  #{$popover-border-radius} - #{$popover-border-width}\n); // stylelint-disable-line function-disallowed-list\n$popover-box-shadow: $box-shadow;\n\n$popover-header-font-size: $font-size-base;\n$popover-header-bg: var(--#{$prefix}secondary-bg);\n$popover-header-color: var(--#{$prefix}headings-color);\n$popover-header-padding-y: 0.5rem;\n$popover-header-padding-x: 0.75rem;\n\n$popover-body-color: var(--#{$prefix}body-color);\n$popover-body-padding-y: $popover-header-padding-y;\n$popover-body-padding-x: $popover-header-padding-x;\n\n$popover-arrow-width: 1rem;\n$popover-arrow-height: 0.5rem;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color: $popover-bg;\n$popover-arrow-outer-color: var(--#{$prefix}border-color-translucent);\n// fusv-enable\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width: 350px;\n$toast-padding-x: 0.75rem;\n$toast-padding-y: 0.5rem;\n$toast-font-size: 0.875rem;\n$toast-color: null;\n$toast-background-color: rgba(var(--#{$prefix}body-bg-rgb), 0.85);\n$toast-border-width: var(--#{$prefix}border-width);\n$toast-border-color: var(--#{$prefix}border-color-translucent);\n$toast-border-radius: var(--#{$prefix}border-radius);\n$toast-box-shadow: var(--#{$prefix}box-shadow);\n$toast-spacing: $container-padding-x;\n\n$toast-header-color: var(--#{$prefix}secondary-color);\n$toast-header-background-color: rgba(var(--#{$prefix}body-bg-rgb), 0.85);\n$toast-header-border-color: $toast-border-color;\n// scss-docs-end toast-variables\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size: 0.75em;\n$badge-font-weight: $font-weight-bold;\n$badge-color: $white;\n$badge-padding-y: 0.35em;\n$badge-padding-x: 0.65em;\n$badge-border-radius: var(--#{$prefix}border-radius);\n// scss-docs-end badge-variables\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding: $spacer;\n\n$modal-footer-margin-between: 0.5rem;\n\n$modal-dialog-margin: 0.5rem;\n$modal-dialog-margin-y-sm-up: 1.75rem;\n\n$modal-title-line-height: $line-height-base;\n\n$modal-content-color: null;\n$modal-content-bg: var(--#{$prefix}secondary-bg);\n$modal-content-border-color: var(--#{$prefix}border-color);\n$modal-content-border-width: var(--#{$prefix}border-width);\n$modal-content-border-radius: var(--#{$prefix}border-radius-lg);\n$modal-content-inner-border-radius: subtract(\n  $modal-content-border-radius,\n  $modal-content-border-width\n);\n$modal-content-box-shadow-xs: $box-shadow-sm;\n$modal-content-box-shadow-sm-up: $box-shadow;\n\n$modal-backdrop-bg: $black;\n$modal-backdrop-opacity: 0.5;\n\n$modal-header-border-color: var(--#{$prefix}border-color);\n$modal-header-border-width: $modal-content-border-width;\n$modal-header-padding-y: $modal-inner-padding;\n$modal-header-padding-x: $modal-inner-padding;\n$modal-header-padding: $modal-header-padding-y $modal-header-padding-x; // Keep this for backwards compatibility\n\n$modal-footer-bg: null;\n$modal-footer-border-color: $modal-header-border-color;\n$modal-footer-border-width: $modal-header-border-width;\n\n$modal-sm: 300px;\n$modal-md: 500px;\n$modal-lg: 800px;\n$modal-xl: 1140px;\n\n$modal-fade-transform: translate(0, -50px);\n$modal-show-transform: none;\n$modal-transition: transform 0.3s ease-out;\n$modal-scale-transform: scale(1.02);\n// scss-docs-end modal-variables\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y: 0.75rem;\n$alert-padding-x: 1.25rem;\n$alert-margin-bottom: 1rem;\n$alert-border-radius: var(--#{$prefix}border-radius);\n$alert-link-font-weight: $font-weight-bold;\n$alert-border-width: var(--#{$prefix}border-width);\n$alert-bg-scale: -80%;\n$alert-border-scale: -70%;\n$alert-color-scale: 40%;\n$alert-dismissible-padding-r: $alert-padding-x * 3; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height: 1rem;\n$progress-font-size: $font-size-base * 0.75;\n$progress-bg: var(--#{$prefix}tertiary-bg);\n$progress-border-radius: var(--#{$prefix}border-radius);\n$progress-box-shadow: var(--#{$prefix}box-shadow-inset);\n$progress-bar-color: $white;\n$progress-bar-bg: $primary;\n$progress-bar-animation-timing: 1s linear infinite;\n$progress-bar-transition: width 0.6s ease;\n// scss-docs-end progress-variables\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color: var(--#{$prefix}body-color);\n$list-group-bg: var(--#{$prefix}secondary-bg);\n$list-group-border-color: var(--#{$prefix}border-color);\n$list-group-border-width: var(--#{$prefix}border-width);\n$list-group-border-radius: var(--#{$prefix}border-radius);\n\n$list-group-item-padding-y: 0.75rem;\n$list-group-item-padding-x: 1.25rem;\n// fusv-disable\n$list-group-item-bg-scale: -80%; // Deprecated in v5.3.0\n$list-group-item-color-scale: 40%; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg: var(--#{$prefix}tertiary-bg);\n$list-group-active-color: $component-active-color;\n$list-group-active-bg: $component-active-bg;\n$list-group-active-border-color: $list-group-active-bg;\n\n$list-group-disabled-color: var(--#{$prefix}secondary-color);\n$list-group-disabled-bg: $list-group-bg;\n\n$list-group-action-color: var(--#{$prefix}secondary-color);\n$list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n\n$list-group-action-active-color: var(--#{$prefix}body-color);\n$list-group-action-active-bg: var(--#{$prefix}secondary-bg);\n// scss-docs-end list-group-variables\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding: 0.25rem;\n$thumbnail-bg: var(--#{$prefix}body-bg);\n$thumbnail-border-width: var(--#{$prefix}border-width);\n$thumbnail-border-color: var(--#{$prefix}border-color);\n$thumbnail-border-radius: var(--#{$prefix}border-radius);\n$thumbnail-box-shadow: var(--#{$prefix}box-shadow-sm);\n// scss-docs-end thumbnail-variables\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size: $small-font-size;\n$figure-caption-color: $gray-600;\n// scss-docs-end figure-variables\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size: null;\n$breadcrumb-padding-y: 0.75rem;\n$breadcrumb-padding-x: 1rem;\n$breadcrumb-item-padding-x: 0.5rem;\n$breadcrumb-margin-bottom: 1rem;\n$breadcrumb-bg: null;\n$breadcrumb-divider-color: $gray-600;\n$breadcrumb-active-color: $gray-600;\n$breadcrumb-divider: quote(\"\\F0142\");\n$breadcrumb-divider-flipped: $breadcrumb-divider;\n$breadcrumb-border-radius: null;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color: $white;\n$carousel-control-width: 15%;\n$carousel-control-opacity: 0.5;\n$carousel-control-hover-opacity: 0.9;\n$carousel-control-transition: opacity 0.15s ease;\n\n$carousel-indicator-width: 30px;\n$carousel-indicator-height: 3px;\n$carousel-indicator-hit-area-height: 10px;\n$carousel-indicator-spacer: 3px;\n$carousel-indicator-opacity: 0.5;\n$carousel-indicator-active-bg: $white;\n$carousel-indicator-active-opacity: 1;\n$carousel-indicator-transition: opacity 0.6s ease;\n\n$carousel-caption-width: 70%;\n$carousel-caption-color: $white;\n$carousel-caption-padding-y: 1.25rem;\n$carousel-caption-spacer: 1.25rem;\n\n$carousel-control-icon-width: 2rem;\n\n$carousel-control-prev-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\");\n$carousel-control-next-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\");\n\n$carousel-transition-duration: 0.6s;\n$carousel-transition: transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg: $black;\n$carousel-dark-caption-color: $black;\n$carousel-dark-control-icon-filter: invert(1) grayscale(100);\n// scss-docs-end carousel-dark-variables\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width: 2rem;\n$spinner-height: $spinner-width;\n$spinner-vertical-align: -0.125em;\n$spinner-border-width: 0.25em;\n$spinner-animation-speed: 0.75s;\n\n$spinner-width-sm: 1rem;\n$spinner-height-sm: $spinner-width-sm;\n$spinner-border-width-sm: 0.2em;\n// scss-docs-end spinner-variables\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width: 1em;\n$btn-close-height: $btn-close-width;\n$btn-close-padding-x: 0.25em;\n$btn-close-padding-y: $btn-close-padding-x;\n$btn-close-color: $black;\n$btn-close-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\");\n$btn-close-bg-dark: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$black}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\n$btn-close-focus-shadow: none;\n$btn-close-opacity: 0.5;\n$btn-close-hover-opacity: 0.75;\n$btn-close-focus-opacity: 1;\n$btn-close-disabled-opacity: 0.25;\n$btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n// scss-docs-end close-variables\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y: $modal-inner-padding;\n$offcanvas-padding-x: $modal-inner-padding;\n$offcanvas-horizontal-width: 400px;\n$offcanvas-vertical-height: 30vh;\n$offcanvas-transition-duration: 0.3s;\n$offcanvas-border-color: $modal-content-border-color;\n$offcanvas-border-width: $modal-content-border-width;\n$offcanvas-title-line-height: $modal-title-line-height;\n$offcanvas-bg-color: var(--#{$prefix}secondary-bg);\n$offcanvas-color: var(--#{$prefix}body-color);\n$offcanvas-box-shadow: $modal-content-box-shadow-xs;\n$offcanvas-backdrop-bg: $modal-backdrop-bg;\n$offcanvas-backdrop-opacity: $modal-backdrop-opacity;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size: 87.5%;\n$code-color: $pink;\n\n$kbd-padding-y: 0.2rem;\n$kbd-padding-x: 0.4rem;\n$kbd-font-size: $code-font-size;\n$kbd-color: var(--#{$prefix}body-bg);\n$kbd-bg: var(--#{$prefix}body-color);\n$nested-kbd-font-weight: null; // Deprecated in v5.2.0, removing in v6\n\n$pre-color: $gray-900;\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-header .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n    // stylelint-enable selector-max-class\n\n    > .accordion-collapse {\n      @include border-radius(0);\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) calc(-.5 * var(--#{$prefix}offcanvas-padding-x)) calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","//\n// root.scss\n//\n\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root ==true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n\n//theme-light\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}header-bg: #ffffff;\n  --#{$prefix}header-item-color: #{$header-item-color};\n  --#{$prefix}header-item-sub-color: #{$text-muted};\n  --#{$prefix}header-height: 70px;\n\n  --#{$prefix}rightbar-width: 280px;\n\n  --#{$prefix}boxed-layout-width: 1300px;\n\n  --#{$prefix}footer-height: 60px;\n  --#{$prefix}footer-bg: #ffffff;\n\n  [data-topbar=\"light\"] {\n    --#{$prefix}topbar-search-bg: #f1f5f7;\n  }\n\n  --#{$prefix}header-dark-bg: #252b3b;\n\n  --#{$prefix}menu-item-color: #74788d;\n  --#{$prefix}menu-item-active-color: #5664d2;\n\n  // Topbar User\n  --#{$prefix}topbar-search-bg: #f1f5f712;\n\n  // Horizontal nav\n  --#{$prefix}topnav-bg: #{$white};\n  --#{$prefix}topnav-item-color: #{darken($gray-600, 10%)};\n  --#{$prefix}topnav-item-color-active: var(--#{$prefix}primary);\n\n  // twocolumn menu\n  --#{$prefix}twocolumn-menu-iconview-bg: #{$white};\n  --#{$prefix}twocolumn-menu-bg: #{$white};\n\n  --#{$prefix}header-item-color: #636e75;\n\n  --#{$prefix}boxed-body-bg: #dee7ec;\n\n  [data-topbar=\"dark\"] {\n    --#{$prefix}header-bg: #{$gray-800};\n    --#{$prefix}header-item-color: #{$gray-100};\n    --#{$prefix}header-dark-item-color: #e9ecef;\n  }\n\n  [data-topbar=\"colored\"] {\n    --#{$prefix}header-colored-bg: #556ee6;\n    --#{$prefix}topbar-search-bg: rgba(241, 245, 247, 0.071);\n    --#{$prefix}header-dark-item-color: #e9ecef;\n  }\n\n  [data-sidebar=\"colored\"] {\n    --#{$prefix}topbar-search-bg: #f1f5f7;\n  }\n\n  //sidebar vertical light\n  --#{$prefix}sidebar-bg: #ffffff;\n  --#{$prefix}sidebar-menu-item-color: #74788d;\n  --#{$prefix}sidebar-menu-sub-item-color: #7c8a96;\n  --#{$prefix}sidebar-menu-item-icon-color: #505d69;\n  --#{$prefix}sidebar-menu-item-hover-color: #383c40;\n  --#{$prefix}sidebar-menu-item-active-color: #556ee6;\n  --#{$prefix}sidebar-width: 240px;\n  --#{$prefix}sidebar-collapsed-width: 70px;\n  --#{$prefix}sidebar-width-sm: 160px;\n\n  [data-sidebar=\"light\"] {\n    --#{$prefix}sidebar-bg: #ffffff;\n    --#{$prefix}sidebar-menu-item-color: #74788d;\n    --#{$prefix}sidebar-menu-sub-item-color: #7c8a96;\n    --#{$prefix}sidebar-menu-item-icon-color: #505d69;\n    --#{$prefix}sidebar-menu-item-hover-color: #383c40;\n    --#{$prefix}sidebar-menu-item-active-color: #556ee6;\n  }\n\n  [data-sidebar=\"dark\"] {\n    --#{$prefix}sidebar-dark-bg: #252b3b; //2c313a\n    --#{$prefix}sidebar-dark-menu-item-color: #8590a5;\n    --#{$prefix}sidebar-dark-menu-sub-item-color: #8590a5;\n    --#{$prefix}sidebar-dark-menu-item-icon-color: #8590a5;\n    --#{$prefix}sidebar-dark-menu-item-hover-color: #d7e4ec;\n    --#{$prefix}sidebar-dark-menu-item-active-color: #d7e4ec;\n    --#{$prefix}topbar-search-bg: #f1f5f7;\n  }\n}\n\n//theme dark\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    // Body background - critical for the page container\n    --#{$prefix}body-bg: #171d37; // darkBg1\n    --#{$prefix}body-bg-rgb: 23, 29, 55;\n\n    --#{$prefix}light: #{$light-dark};\n    --#{$prefix}light-rgb: #{to-rgb($light-dark)};\n    --#{$prefix}dark: #{$light-dark};\n    --#{$prefix}dark-rgb: #{to-rgb($light-dark)};\n\n    // header\n    --#{$prefix}header-bg: #171d37; // darkBg1\n    --#{$prefix}header-dark-bg: #556ee6;\n    --#{$prefix}header-item-color: #919bae;\n    --#{$prefix}topbar-search-bg: #0e142f12; // darkBg2 with transparency\n\n    .table-light {\n      --#{$prefix}table-color: #{lighten($light-dark, 80%)};\n      --#{$prefix}table-bg: var(--#{$prefix}tertiary-bg);\n      --#{$prefix}table-border-color: var(--#{$prefix}border-color);\n      --#{$prefix}table-striped-bg: var(--#{$prefix}tertiary-bg);\n      --#{$prefix}table-striped-color: #{lighten($light-dark, 100%)};\n      --#{$prefix}table-active-bg: var(--#{$prefix}tertiary-bg);\n      --#{$prefix}table-active-color: #{lighten($light-dark, 100%)};\n      --#{$prefix}table-hover-bg: var(--#{$prefix}tertiary-bg);\n      --#{$prefix}table-hover-color: #{lighten($light-dark, 100%)};\n    }\n\n    &[data-topbar=\"colored\"] {\n      --#{$prefix}header-colored-bg: #556ee6;\n      --#{$prefix}topbar-search-bg: #0e142f12; // darkBg2 with transparency\n    }\n\n    &[data-topbar=\"light\"] {\n      --#{$prefix}topbar-search-bg: #0e142f; // darkBg2\n    }\n\n    &[data-sidebar=\"colored\"] {\n      --#{$prefix}topbar-search-bg: #0e142f; // darkBg2\n    }\n\n    // horizontal nav\n    --#{$prefix}topnav-bg: #171d37; // darkBg1\n\n    --#{$prefix}header-item-sub-color: #{$text-muted};\n    // footer\n    --#{$prefix}footer-bg: #0e142f; // darkBg2 - darker footer\n\n    --#{$prefix}boxed-body-bg: #171d37; // darkBg1\n\n    --#{$prefix}sidebar-bg: #ffffff;\n    --#{$prefix}sidebar-menu-item-color: #74788d;\n    --#{$prefix}sidebar-menu-sub-item-color: #7c8a96;\n    --#{$prefix}sidebar-menu-item-icon-color: #505d69;\n    --#{$prefix}sidebar-menu-item-hover-color: #d7e4ec;\n    --#{$prefix}sidebar-menu-item-active-color: #556ee6;\n\n    &[data-sidebar=\"dark\"] {\n      ---#{$prefix}sidebar-dark-bg: #252b3b; //2c313a\n      --#{$prefix}sidebar-dark-menu-item-color: #8590a5;\n      --#{$prefix}sidebar-dark-menu-sub-item-color: #8590a5;\n      --#{$prefix}sidebar-dark-menu-item-icon-color: #8590a5;\n      --#{$prefix}sidebar-dark-menu-item-hover-color: #d7e4ec;\n      --#{$prefix}sidebar-dark-menu-item-active-color: #d7e4ec;\n      --#{$prefix}topbar-search-bg: #2b3244;\n    }\n  }\n}\n","/* =============\n   General\n============= */\n\nhtml {\n  position: relative;\n  min-height: 100%;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: $font-family-secondary;\n}\n\na {\n  text-decoration: none !important;\n}\n\nlabel {\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n// blockquote\n\n.blockquote {\n  padding: 10px 20px;\n  border-left: 4px solid var(--#{$prefix}border-color);\n}\n\n.blockquote-reverse {\n  border-left: 0;\n  border-right: 4px solid var(--#{$prefix}border-color);\n  text-align: right;\n}\n\n// row\n\n.row {\n  > * {\n    position: relative;\n  }\n}\n\npre {\n  color: var(--#{$prefix}secondary-color);\n}\n","// \n// backgrounds.scss\n//\n\n\n@each $color,\n$value in $theme-colors {\n    .bg-soft-#{$color} {\n        background-color: rgba(($value), 0.25) !important;\n    }\n}\n","// \n// _badge.scss\n// \n\n\n.badge {\n  &[href] {\n    &:hover,\n    &:focus {\n      color: $white;\n    }\n  }\n}\n\n// Soft badge\n@mixin badge-variant-soft($bg) {\n  color: $bg;\n  background-color: rgba($bg, 0.18);\n\n  &[href] {\n    &:hover,\n    &:focus {\n      color: $bg;\n      text-decoration: none;\n      background-color: rgba($bg, 0.4);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .badge {\n  &.bg-#{$color} {\n    &[href] {\n      &:hover,\n      &:focus {\n        background-color: darken($value, 4%) !important;\n      }\n    }\n  }\n}\n\n.badge{\n  &.bg-light{\n    color: $body-color;\n\n    &[href] {\n      &:hover,\n      &:focus {\n        color: $body-color;\n      }\n    }\n  }\n}\n\n  .badge-soft-#{$color} {\n      @include badge-variant-soft($value);\n  }\n  \n}\n\n.rounded-pill{\n   padding-right: .6em;\n    padding-left: .6em;\n}\n\n// Dark badge\n\n.badge.bg-dark{\n  color: $light;\n}","//\n// _buttons.scss\n//\n\nbutton,\na {\n  outline: none !important;\n}\n\n.btn {\n  &:hover,\n  &:active,\n  &:focus,\n  &.active,\n  &.show {\n    border-color: transparent !important;\n  }\n}\n\n.btn-light {\n  border: 1px solid var(--#{$prefix}border-color);\n\n  &.active,\n  &:hover,\n  &:focus {\n    background-color: $gray-200;\n    border: 1px solid var(--#{$prefix}border-color);\n  }\n}\n\n.btn-check + .btn {\n  &:hover {\n    border-color: var(--#{$prefix}btn-border-color) !important;\n  }\n}\n\n// Rounded Buttons\n.btn-rounded {\n  border-radius: 30px;\n}\n\n.btn-dark,\n.btn-secondary {\n  color: $gray-200;\n}\n\n.btn-outline-light {\n  color: $gray-900;\n}\n\n// theme dark\n[data-bs-theme=\"dark\"] {\n  .btn-light {\n    color: $white !important;\n    background-color: var(--#{$prefix}light);\n    border-color: var(--#{$prefix}light);\n\n    &:hover {\n      color: $white !important;\n      background-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n      border-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n    }\n  }\n\n  .btn-check:focus + .btn-light,\n  .btn-check:focus + .btn-outline-light,\n  .btn-check:focus + .btn-soft-light,\n  .btn-light:focus,\n  .btn-outline-light:focus,\n  .btn-soft-light:focus {\n    color: $white !important;\n    background-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n    // border-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n  }\n\n  .btn-check:active + .btn-light,\n  .btn-check:active + .btn-outline-light,\n  .btn-check:active + .btn-soft-light,\n  .btn-check:checked + .btn-light,\n  .btn-check:checked + .btn-outline-light,\n  .btn-check:checked + .btn-soft-light,\n  .btn-light.active,\n  .btn-light:active,\n  .btn-outline-light.active,\n  .btn-outline-light:active,\n  .btn-soft-light.active,\n  .btn-soft-light:active,\n  .show > .btn-light.dropdown-toggle,\n  .show > .btn-outline-light.dropdown-toggle,\n  .show > .btn-soft-light.dropdown-toggle {\n    color: $white !important;\n    background-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n    // border-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n  }\n\n  // dark\n\n  .btn-dark {\n    color: $white;\n    background-color: var(--#{$prefix}dark);\n    border-color: var(--#{$prefix}dark);\n\n    &:hover {\n      background-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n      border-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n    }\n  }\n\n  .btn-check:focus + .btn-dark,\n  .btn-check:focus + .btn-outline-dark,\n  .btn-check:focus + .btn-soft-dark,\n  .btn-dark:focus,\n  .btn-outline-dark:focus,\n  .btn-soft-dark:focus {\n    color: $white;\n    background-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n    border-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n  }\n\n  .btn-check:active + .btn-dark,\n  .btn-check:active + .btn-outline-dark,\n  .btn-check:active + .btn-soft-dark,\n  .btn-check:checked + .btn-dark,\n  .btn-check:checked + .btn-outline-dark,\n  .btn-check:checked + .btn-soft-dark,\n  .btn-dark.active,\n  .btn-dark:active,\n  .btn-outline-dark.active,\n  .btn-outline-dark:active,\n  .btn-soft-dark.active,\n  .btn-soft-dark:active,\n  .show > .btn-dark.dropdown-toggle,\n  .show > .btn-outline-dark.dropdown-toggle,\n  .show > .btn-soft-dark.dropdown-toggle {\n    color: var(--#{$prefix}light);\n    background-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n    border-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n  }\n\n  // outline\n\n  .btn-outline-light {\n    color: $white !important;\n    border-color: var(--#{$prefix}light);\n\n    &:hover {\n      color: $white;\n      background-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n      border-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n    }\n  }\n\n  .btn-outline-dark {\n    color: $white !important;\n    border-color: var(--#{$prefix}dark);\n\n    &:hover {\n      color: var(--#{$prefix}light);\n      background-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n      border-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n    }\n  }\n\n  // soft\n\n  .btn-soft-light {\n    color: $white !important;\n    background-color: rgba(var(--#{$prefix}light-rgb), 0.1);\n\n    &:hover {\n      color: $white !important;\n      background-color: var(--#{$prefix}light);\n    }\n  }\n\n  .btn-soft-dark {\n    color: $white !important;\n    background-color: rgba(var(--#{$prefix}dark-rgb), 0.1);\n\n    &:hover {\n      color: var(--#{$prefix}light);\n      background-color: var(--#{$prefix}dark);\n    }\n  }\n}\n","\n// \n// breadcrumb.scss\n//\n\n\n// Breadcrumb item arrow\n.breadcrumb-item {\n    > a {\n        color: var(--#{$prefix}body-color);\n    }\n    +.breadcrumb-item {\n        &::before {\n            font-family: \"Material Design Icons\";\n        }\n    }\n}\n\n// RTL\n\n[dir=\"rtl\"] {\n    .breadcrumb-item {\n        +.breadcrumb-item {\n            padding-right: $breadcrumb-item-padding-x;\n\n            &::before {\n            font-family: \"Material Design Icons\";\n            padding-left: 0;\n                content: \"\\F0141\";\n            }\n        }\n    }\n\n}","// \n// _card.scss\n// \n\n.card {\n    margin-bottom: $grid-gutter-width;\n    box-shadow: $box-shadow;\n}\n\n.card-drop {\n    font-size: 20px;\n    line-height: 0;\n    color: inherit;\n}\n\n.card-title {\n    font-size: 15px;\n    margin: 0 0 7px 0;\n    font-weight: $font-weight-medium;\n}\n\n.card-title-desc {\n    color: $card-title-desc;\n    margin-bottom: 24px;\n}","// \n// _dropdown.scss\n// \n// \n.dropdown-menu {\n  box-shadow: $box-shadow-lg;\n  animation-name: DropDownSlide;\n  animation-duration: .3s;\n  animation-fill-mode: both;\n  margin: 0;\n  position: absolute;\n  z-index: 1000;\n\n  &.show {\n    top: 100%!important;\n  }\n}\n\n.dropdown-menu-end[style] {\n  left: auto!important;\n  right: 0!important;\n}\n\n.dropdown-menu[data-popper-placement^=right],.dropdown-menu[data-popper-placement^=top],.dropdown-menu[data-popper-placement^=left]{\n  top: auto !important;\n  animation: none !important;\n}\n\n@keyframes DropDownSlide {\n  100% {\n      transform: translateY(0)\n  }\n  0% {\n      transform: translateY(10px)\n  }\n}\n\n@media (min-width: 600px) {\n  .dropdown-menu-lg {\n    width: 320px;\n  }\n\n  .dropdown-menu-md {\n    width: 240px;\n  }\n}\n\n.dropdown-divider{\n  border-top-color: var(--#{$prefix}border-color);\n}\n\n// Dropdown Mega Menu\n\n.dropdown-mega {\n  position: static!important;\n}\n\n.dropdown-megamenu[style] {\n  padding: 20px;\n  left: 20px !important;\n  right: 20px !important;\n}\n\n// Dropdown size\n\n.dropdown-mega-menu-xl{\n  width: 40rem;\n}\n\n.dropdown-mega-menu-lg{\n  width: 26rem;\n}","// \n// _nav.scss\n// \n\n.nav-tabs,.nav-pills {\n  > li {\n      > a {\n          color: var(--#{$prefix}body-color);\n          font-weight: $font-weight-medium;\n      }\n  }\n}\n\n.nav-pills {\n  > a {\n      color:var(--#{$prefix}body-color);\n      font-weight: $font-weight-medium;\n  }\n}\n\n\n.nav-tabs-custom {\n  border-bottom: 2px solid var(--#{$prefix}border-color);\n\n  .nav-item {\n    position: relative;\n    color: $dark;\n    .nav-link {\n      border: none;\n\n      &::after {\n        content: \"\";\n        background: $primary;\n        height: 2px;\n        position: absolute;\n        width: 100%;\n        left: 0;\n        bottom: -1px;\n        transition: all 250ms ease 0s;\n        transform: scale(0);\n      }\n\n      &.active{\n        color: $primary;\n        &:after{\n          transform: scale(1);\n        }\n      }\n\n    }\n  }\n}\n\n\n// vertical nav\n\n.vertical-nav{\n  .nav{\n      .nav-link{\n          padding: 24px 16px;\n          text-align: center;\n          margin-bottom: 8px;\n          .nav-icon{\n              font-size: 24px;\n          }\n      }\n  }\n}","// \n// _table.scss\n// \n\n// .table {\n//   th {\n//       font-weight: $font-weight-bold;\n//   }\n// }\n\n// //Table centered\n// .table-centered {\n//   td,th {\n//       vertical-align: middle !important;\n//   }\n// }\n\n// .table-nowrap {\n//   th, td {\n//     white-space: nowrap;\n//   }\n// }\n\n// .table-bordered {\n//   border: $table-border-width solid $table-border-color;\n\n//   th,\n//   td {\n//     border: $table-border-width solid $table-border-color;\n//   }\n// }\n\n\n// .table-dark>:not(:last-child)>:last-child>*{\n//   border-bottom-color:  $table-dark-border-color;\n// }\n\n.table {\n  th {\n      font-weight: $table-th-font-weight;\n  }\n\n  .table-light {\n      color:var(--#{$prefix}body-color);\n      border-color: $table-border-color;\n      background-color: var(--#{$prefix}tertiary-bg) !important;\n  }\n}\n\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n}\n\n\n.table-dark>:not(:last-child)>:last-child>*{\n  border-bottom-color:  $table-dark-border-color;\n}\n\n.table-nowrap {\n  th,\n  td {\n      white-space: nowrap;\n  }\n}\n\n.table-responsive{\n  &::-webkit-scrollbar {\n    -webkit-appearance: none;\n  }\n\n  &::-webkit-scrollbar:vertical {\n    width: 12px;\n  }\n\n  &::-webkit-scrollbar:horizontal {\n    height: 9px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: rgba($dark, .2);\n    border-radius: 10px;\n    border: 2px solid $white;\n  }\n\n  &::-webkit-scrollbar-track {\n    border-radius: 10px;  \n    background-color: $white; \n  }\n}\n","// \n// _pagination.scss\n// \n\n// Pagination rounded (Custom)\n.pagination-rounded {\n    .page-link {\n        border-radius: 30px !important;\n        margin: 0 3px;\n        border: none;\n        text-align: center;\n        height: 35px;\n    }\n  }","// \n// _progress.scss\n// \n\n// Progress height small\n.progress-sm {\n  height: 5px;\n}\n\n\n// Progress height medium\n.progress-md {\n  height: 8px;\n}\n\n\n// Progress height large\n.progress-lg {\n  height: 12px;\n}\n\n// Progress height Extra large\n.progress-xl {\n  height: 16px;\n}\n\n.animated-progess{\n  position: relative;\n  .progress-bar {\n    position: relative;\n    border-radius: 6px;\n    animation: animate-positive 2s;\n  }\n}\n\n@keyframes animate-positive {\n  0% {\n      width: 0;\n  }\n}","//\n// Fonts\n//\n\n// Nunito - Google Font\n@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;600&display=swap');\n\n@font-face {\n    font-family: 'Inter';\n    font-style:  normal;\n    font-weight: 300;\n    font-display: swap;\n    src: url(\"../../../fonts/inter-light.woff2?v=3.13\") format(\"woff2\"),\n         url(\"../../../fonts/inter-light.woff?v=3.13\") format(\"woff\");\n}\n\n@font-face {\n    font-family: 'Inter';\n    font-style:  normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url(\"../../../fonts/inter-regular.woff2?v=3.13\") format(\"woff2\"),\n         url(\"../../../fonts/inter-regular.woff?v=3.13\") format(\"woff\");\n}\n\n@font-face {\n    font-family: 'Inter';\n    font-style:  normal;\n    font-weight: 500;\n    font-display: swap;\n    src: url(\"../../../fonts/inter-medium.woff2?v=3.13\") format(\"woff2\"),\n         url(\"../../../fonts/inter-medium.woff?v=3.13\") format(\"woff\");\n}\n\n@font-face {\n    font-family: 'Inter';\n    font-style:  normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url(\"../../../fonts/inter-bold.woff2?v=3.13\") format(\"woff2\"),\n         url(\"../../../fonts/inter-bold.woff?v=3.13\") format(\"woff\");\n}","//\n// _header.scss\n//\n\n#page-topbar {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1002;\n  background-color: var(--#{$prefix}header-bg);\n  box-shadow: $box-shadow;\n}\n\n.navbar-header {\n  display: flex;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 auto;\n  height: $header-height;\n  padding: 0 calc(#{$grid-gutter-width} / 2) 0 0;\n\n  .dropdown {\n    .show.header-item {\n      background-color: var(--#{$prefix}secondary-bg);\n    }\n  }\n}\n\n.navbar-brand-box {\n  padding: 0;\n  width: $navbar-brand-box-width;\n}\n\n.logo {\n  .logo-sm {\n    display: none;\n  }\n}\n\n.logo-light {\n  display: none;\n}\n\n/* Search */\n\n.app-search {\n  padding: calc(#{$header-height - 38px} / 2) 0;\n\n  .form-control {\n    border: none;\n    height: 38px;\n    padding-left: 40px;\n    padding-right: 20px;\n    background-color: $topbar-search-bg;\n    box-shadow: none;\n    border-radius: 30px;\n  }\n  span {\n    position: absolute;\n    z-index: 10;\n    font-size: 16px;\n    line-height: 38px;\n    left: 13px;\n    top: 0;\n    color: $gray-600;\n  }\n}\n\n// Mega menu\n\n.megamenu-list {\n  li {\n    position: relative;\n    padding: 5px 0px;\n    a {\n      color: $dropdown-color;\n    }\n  }\n}\n\n@media (max-width: 991px) {\n  .navbar-brand-box {\n    width: auto;\n  }\n\n  .logo {\n    span.logo-lg {\n      display: none;\n    }\n\n    span.logo-sm {\n      // display: inline-block;\n    }\n  }\n}\n\n.page-content {\n  padding: calc(#{$header-height} + #{$grid-gutter-width}) 0 $footer-height 0;\n}\n\n.header-item {\n  width: $header-height;\n  height: $header-height;\n  box-shadow: none !important;\n  color: var(--#{$prefix}header-item-color);\n  border: 0;\n  border-radius: 0px;\n\n  &:hover {\n    color: var(--#{$prefix}header-item-color);\n  }\n}\n\n.header-profile-user {\n  height: 36px;\n  width: 36px;\n  background-color: var(--#{$prefix}secondary-bg);\n  padding: 3px;\n}\n\n.user-dropdown {\n  .dropdown-item {\n    i {\n      display: inline-block;\n    }\n  }\n}\n\n.noti-icon {\n  i {\n    font-size: 22px;\n    color: var(--#{$prefix}header-item-color);\n  }\n\n  .noti-dot {\n    position: absolute;\n    display: inline-block;\n    height: 6px;\n    width: 6px;\n    background-color: $danger;\n    border-radius: 50%;\n    top: 20px;\n    right: 14px;\n  }\n}\n\n.notification-item {\n  .d-flex {\n    padding: 0.75rem 1rem;\n\n    &:hover {\n      background-color: var(--#{$prefix}tertiary-bg);\n    }\n  }\n}\n\n// Dropdown with Icons\n.dropdown-icon-item {\n  display: block;\n  border-radius: 3px;\n  line-height: 34px;\n  text-align: center;\n  padding: 15px 0 9px;\n  display: block;\n  border: 1px solid transparent;\n  color: $gray-600;\n\n  img {\n    height: 24px;\n  }\n\n  span {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &:hover {\n    border-color: var(--#{$prefix}border-color);\n  }\n}\n\n// Full Screen\n.fullscreen-enable {\n  [data-toggle=\"fullscreen\"] {\n    .ri-fullscreen-line:before {\n      content: \"\\ed73\";\n    }\n  }\n}\n\nbody[data-topbar=\"dark\"] {\n  #page-topbar {\n    background-color: var(--#{$prefix}header-dark-bg);\n  }\n  .navbar-header {\n    .dropdown {\n      .show.header-item {\n        background-color: rgba($white, 0.05);\n      }\n    }\n\n    .waves-effect .waves-ripple {\n      background: rgba($white, 0.4);\n    }\n  }\n\n  .header-item {\n    color: var(--#{$prefix}header-dark-item-color);\n\n    &:hover {\n      color: var(--#{$prefix}header-dark-item-color);\n    }\n  }\n\n  .header-profile-user {\n    background-color: rgba($white, 0.25);\n  }\n\n  .noti-icon {\n    i {\n      color: var(--#{$prefix}header-dark-item-color);\n    }\n  }\n\n  .logo-dark {\n    display: none;\n  }\n\n  .logo-light {\n    display: block;\n  }\n\n  .app-search {\n    .form-control {\n      background-color: var(--#{$prefix}topbar-search-bg);\n      color: $white;\n    }\n    span,\n    input.form-control::-webkit-input-placeholder {\n      color: rgba($white, 0.5);\n    }\n  }\n}\n\nbody[data-sidebar=\"dark\"] {\n  .navbar-brand-box {\n    background: var(--#{$prefix}sidebar-dark-bg);\n  }\n\n  .logo-dark {\n    display: none;\n  }\n\n  .logo-light {\n    display: block;\n  }\n}\n\n@media (max-width: 600px) {\n  .navbar-header {\n    .dropdown {\n      position: static;\n\n      .dropdown-menu {\n        left: 10px !important;\n        right: 10px !important;\n      }\n    }\n  }\n}\n\n@media (max-width: 380px) {\n  .navbar-brand-box {\n    display: none;\n  }\n}\n\nbody[data-layout=\"horizontal\"] {\n  .navbar-brand-box {\n    width: auto;\n  }\n  .page-content {\n    margin-top: $header-height;\n    padding: calc(55px + #{$grid-gutter-width}) calc(#{$grid-gutter-width} / 2)\n      $footer-height calc(#{$grid-gutter-width} / 2);\n  }\n}\n\n@media (max-width: 992px) {\n  body[data-layout=\"horizontal\"] {\n    .page-content {\n      margin-top: 15px;\n    }\n  }\n}\n\nbody[data-topbar=\"colored\"] {\n  #page-topbar {\n    background-color: var(--#{$prefix}header-colored-bg);\n  }\n  .navbar-header {\n    .dropdown {\n      .show.header-item {\n        background-color: rgba($white, 0.05);\n      }\n    }\n\n    .waves-effect .waves-ripple {\n      background: rgba($white, 0.4);\n    }\n  }\n\n  .header-item {\n    color: var(--#{$prefix}header-dark-item-color);\n\n    &:hover {\n      color: var(--#{$prefix}header-dark-item-color);\n    }\n  }\n\n  .header-profile-user {\n    background-color: rgba($white, 0.25);\n  }\n\n  .noti-icon {\n    i {\n      color: var(--#{$prefix}header-dark-item-color);\n    }\n  }\n\n  .logo-dark {\n    display: none;\n  }\n\n  .logo-light {\n    display: block;\n  }\n\n  .app-search {\n    .form-control {\n      background-color: var(--#{$prefix}topbar-search-bg);\n      color: $white;\n    }\n    span,\n    input.form-control::-webkit-input-placeholder {\n      color: rgba($white, 0.5);\n    }\n  }\n}\n","// \n// Page-title\n// \n\n.page-title-box {\n    padding-bottom: $grid-gutter-width;\n\n    .breadcrumb {\n        background-color: transparent;\n        padding: 0;\n    }\n\n    h4 {\n        font-size: 15px;\n        text-transform: uppercase;\n        font-weight: 600;\n    }\n}\n","// \n// _footer.scss\n// \n\n.footer {\n    bottom: 0;\n    padding: 20px calc(#{$grid-gutter-width} / 2);\n    position: absolute;\n    right: 0;\n    color: $footer-color;\n    left: $sidebar-width;\n    height: $footer-height;\n    box-shadow: $box-shadow;\n    background-color: $footer-bg;\n}\n\n@media (max-width: 992px) {\n    .footer {\n        left: 0;\n    }\n}\n\n// Enlarge menu\n.vertical-collpsed {\n    .footer {\n        left: $sidebar-collapsed-width;\n    }\n}\n\nbody[data-layout=\"horizontal\"] {\n    .footer {\n        left: 0 !important;\n    }  \n}","//\n// right-sidebar.scss\n//\n\n.right-bar {\n    background-color: $card-bg;\n    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);\n    display: block;\n    position: fixed;\n    transition: all 200ms ease-out;\n    width: $rightbar-width;\n    z-index: 9999;\n    float: right !important;\n    right: -($rightbar-width + 10px);\n    top: 0;\n    bottom: 0;\n\n    .right-bar-toggle {\n        background-color: lighten($dark, 7%);\n        height: 24px;\n        width: 24px;\n        line-height: 24px;\n        color: $gray-200;\n        text-align: center;\n        border-radius: 50%;\n\n        &:hover {\n            background-color: lighten($dark, 10%);\n        }\n    }\n}\n\n// Rightbar overlay\n.rightbar-overlay {\n    background-color: rgba($dark, 0.55);\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 9998;\n    transition: all .2s ease-out;\n}\n\n.right-bar-enabled {\n    .right-bar {\n        right: 0;\n    }\n    .rightbar-overlay {\n        display: block;\n    }\n}\n\n@include media-breakpoint-down(md) {\n    .right-bar {\n        overflow: auto;\n        .slimscroll-menu {\n            height: auto !important;\n        }\n    }\n}","//\n// _menu.scss\n// \n\n.metismenu {\n    margin: 0;\n\n    li {\n        display: block;\n        width: 100%;\n    }\n\n    .mm-collapse {\n        display: none;\n\n        &:not(.mm-show) {\n            display: none;\n        }\n\n        &.mm-show {\n            display: block\n        }\n    }\n\n    .mm-collapsing {\n        position: relative;\n        height: 0;\n        overflow: hidden;\n        transition-timing-function: ease;\n        transition-duration: .35s;\n        transition-property: height, visibility;\n    }\n}\n\n\n.vertical-menu {\n    width: $sidebar-width;\n    z-index: 1001;\n    background: var(--#{$prefix}sidebar-bg);\n    bottom: 0;\n    margin-top: 0;\n    position: fixed;\n    top: $header-height;\n    box-shadow: $box-shadow;\n}\n\n.main-content {\n    margin-left: $sidebar-width;\n    overflow: hidden;\n\n    .content {\n        padding: 0 15px 10px 15px;\n        margin-top: $header-height;\n    }\n}\n\n\n#sidebar-menu {\n    padding: 10px 0 30px 0;\n\n    .mm-active {\n        >.has-arrow {\n            &:after {\n                transform: rotate(-180deg);\n            }\n        }\n    }\n\n    .has-arrow {\n        &:after {\n            content: \"\\F0140\";\n            font-family: 'Material Design Icons';\n            display: block;\n            float: right;\n            transition: transform .2s;\n            font-size: 1rem;\n        }\n    }\n\n    ul {\n        li {\n            a {\n                display: block;\n                padding: .625rem 1.5rem;\n                color: var(--#{$prefix}sidebar-menu-item-color);\n                position: relative;\n                font-size: 13.3px;\n                transition: all .4s;\n                font-family: $font-family-secondary;\n                font-weight: 500;\n\n                i {\n                    display: inline-block;\n                    min-width: 1.5rem;\n                    padding-bottom: .125em;\n                    font-size: 1.1rem;\n                    line-height: 1.40625rem;\n                    vertical-align: middle;\n                    color: var(--#{$prefix}sidebar-menu-item-icon-color);\n                    transition: all .4s;\n                    opacity: .75;\n                }\n\n                &:hover {\n                    color:  var(--#{$prefix}sidebar-menu-item-hover-color);\n\n                    i {\n                        color:  var(--#{$prefix}sidebar-menu-item-hover-color);\n                    }\n                }\n            }\n\n            .badge {\n                margin-top: 4px;\n            }\n\n            ul.sub-menu {\n                padding: 0;\n\n                li {\n\n                    a {\n                        padding: .4rem 1.5rem .4rem 3.2rem;\n                        font-size: 13px;\n                        color:  var(--#{$prefix}sidebar-menu-sub-item-color);\n                    }\n\n                    ul.sub-menu {\n                        padding: 0;\n\n                        li {\n                            a {\n                                padding: .4rem 1.5rem .4rem 4.2rem;\n                                font-size: 13.5px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n    }\n}\n\n.menu-title {\n    padding: 12px 20px !important;\n    letter-spacing: .05em;\n    pointer-events: none;\n    cursor: default;\n    font-size: 11px;\n    text-transform: uppercase;\n    color: var(--#{$prefix}sidebar-menu-item-icon-color);\n    font-weight: $font-weight-semibold;\n    font-family: $font-family-secondary;\n    opacity: .5;\n}\n\n\n.mm-active {\n    color: var(--#{$prefix}sidebar-menu-item-active-color)  !important;\n    > a{\n        color: var(--#{$prefix}sidebar-menu-item-active-color)  !important;\n        i {\n            color: var(--#{$prefix}sidebar-menu-item-active-color)  !important;\n        }\n    }\n    > i {\n        color: var(--#{$prefix}sidebar-menu-item-active-color)  !important;\n    }\n    .active {\n        color: var(--#{$prefix}sidebar-menu-item-active-color)  !important;\n\n        i {\n            color: var(--#{$prefix}sidebar-menu-item-active-color)  !important;\n        }\n    }\n}\n\n@media (max-width: 992px) {\n    .vertical-menu {\n        display: none;\n    }\n\n    .main-content {\n        margin-left: 0 !important;\n    }\n\n    body.sidebar-enable {\n        .vertical-menu {\n            display: block;\n        }\n    }\n}\n\n// Enlarge menu\n.vertical-collpsed {\n\n    .main-content {\n        margin-left: $sidebar-collapsed-width;\n    }\n\n    .navbar-brand-box {\n        width: $sidebar-collapsed-width !important;\n    }\n\n    .logo {\n        span.logo-lg {\n            display: none;\n        }\n\n        span.logo-sm {\n            display: block;\n        }\n    }\n\n    // Side menu\n    .vertical-menu {\n        position: absolute;\n        width: $sidebar-collapsed-width !important;\n        z-index: 5;\n\n        .simplebar-mask,\n        .simplebar-content-wrapper {\n            overflow: visible !important;\n        }\n\n        .simplebar-scrollbar {\n            display: none !important;\n        }\n\n        .simplebar-offset {\n            bottom: 0 !important;\n        }\n\n        // Sidebar Menu\n        #sidebar-menu {\n\n            .menu-title,\n            .badge,\n            .collapse.in {\n                display: none !important;\n            }\n\n            .nav.collapse {\n                height: inherit !important;\n            }\n\n            .has-arrow {\n                &:after {\n                    display: none;\n                }\n            }\n\n            > ul {\n                > li {\n                    position: relative;\n                    white-space: nowrap;\n\n                    > a {\n                        padding: 15px 20px;\n                        min-height: 55px;\n                        transition: none;\n                        \n                        &:hover,\n                        &:active,\n                        &:focus {\n                            color:  var(--#{$prefix}sidebar-menu-item-hover-color);\n                        }\n\n                        i {\n                            font-size: 20px;\n                            margin-left: 4px;\n                        }\n\n                        span {\n                            display: none;\n                            padding-left: 25px;\n                        }\n                    }\n\n                    &:hover {\n                        > a {\n                            position: relative;\n                            width: calc(190px + #{$sidebar-collapsed-width});\n                            color: $primary;\n                            // background-color: darken($sidebar-bg, 4%);\n                            transition: none;\n\n                            i{\n                                color: $primary;\n                            }\n\n                            span {\n                                display: inline;\n                            }\n                        }\n\n                        >ul {\n                            display: block;\n                            left: $sidebar-collapsed-width;\n                            position: absolute;\n                            width: 190px;\n                            height: auto !important;\n                            box-shadow: 3px 5px 12px -4px rgba(18, 19, 21, 0.1);\n\n                            ul {\n                                box-shadow: 3px 5px 12px -4px rgba(18, 19, 21, 0.1);\n                            }\n\n                            a {\n                                box-shadow: none;\n                                padding: 8px 20px;\n                                position: relative;\n                                width: 190px;\n                                z-index: 6;\n                                color:  var(--#{$prefix}sidebar-menu-sub-item-color);\n\n                                &:hover {\n                                    color: var(--#{$prefix}sidebar-menu-item-hover-color);\n                                }\n                            }\n                        }\n                    }\n                }\n\n                ul {\n                    padding: 5px 0;\n                    z-index: 9999;\n                    display: none;\n                    background-color: var(--#{$prefix}sidebar-bg);\n\n                    li {\n                        &:hover {\n                            >ul {\n                                display: block;\n                                left: 190px;\n                                height: auto !important;\n                                margin-top: -36px;\n                                position: absolute;\n                                width: 190px;\n                            }\n                        }\n\n                        >a {\n                            span.pull-right {\n                                position: absolute;\n                                right: 20px;\n                                top: 12px;\n                                transform: rotate(270deg);\n                            }\n                        }\n                    }\n\n                    li.active {\n                        a {\n                            color: $gray-100;\n                        }\n                    }\n                }\n            }\n        }\n\n    }\n}\n\n\n\n\nbody[data-sidebar=\"dark\"] {\n    .vertical-menu {\n        background: var(--#{$prefix}sidebar-dark-bg);\n    }\n\n    #sidebar-menu {\n    \n        ul {\n            li {\n                a {\n                    color: var(--#{$prefix}sidebar-dark-menu-item-color);\n\n                    i {\n                        color: var(--#{$prefix}sidebar-dark-menu-item-color);\n                    }\n    \n                    &:hover {\n                        color: var(--#{$prefix}sidebar-dark-menu-item-hover-color);\n\n                        i {\n                            color: var(--#{$prefix}sidebar-dark-menu-item-hover-color);;\n                        }\n                    }\n                }\n\n                ul.sub-menu {\n                    li {\n\n                        a {\n                            color: var(--#{$prefix}sidebar-dark-menu-sub-item-color);\n\n                            &:hover {\n                                color: var(--#{$prefix}sidebar-dark-menu-item-hover-color);;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    // Enlarge menu\n    &.vertical-collpsed {\n        min-height: 1400px;\n\n        // Side menu\n        .vertical-menu {\n\n            // Sidebar Menu\n            #sidebar-menu {\n\n                > ul {\n                    > li {\n                        \n                        &:hover {\n                            > a {\n                                background-color: var(--#{$prefix}sidebar-dark-bg);\n                                color: var(--#{$prefix}sidebar-dark-menu-item-hover-color);;\n                                i{\n                                    color: var(--#{$prefix}sidebar-dark-menu-item-hover-color);;\n                                }\n                            }\n\n                            >ul {\n                                a{\n                                    color: var(--#{$prefix}sidebar-dark-menu-sub-item-color);\n                                    &:hover{\n                                        color:  var(--#{$prefix}sidebar-menu-item-hover-color);\n                                    }\n                                }\n                            }\n                        }\n                    }\n\n                    ul{\n                        background-color: var(--#{$prefix}secondary-bg);\n                    }\n                    \n                }\n\n                ul{\n\n                    >li{\n                        >a{\n                            &.mm-active{\n                                color:var(--#{$prefix}sidebar-dark-menu-item-active-color) !important;\n                            }\n                        }\n                    }\n\n                    li{\n                        li{\n                            &.mm-active, &.active {\n                               > a{\n                                    color:var(--#{$prefix}sidebar-menu-item-active-color) !important;\n                                }\n                            }\n\n                            a{\n                                &.mm-active, &.active {\n                                    color: var(--#{$prefix}sidebar-menu-item-active-color)  !important;\n                                }\n\n                                \n                            }\n                        }\n                    }\n                    \n                    \n                }\n            }\n\n\n        }\n    }\n    \n    .mm-active {\n        color: $sidebar-dark-menu-item-active-color !important;\n        > a{\n            color: $sidebar-dark-menu-item-active-color !important;\n            i {\n                color: $sidebar-dark-menu-item-active-color !important;\n            }\n        }\n        > i {\n            color: $sidebar-dark-menu-item-active-color !important;\n        }\n        .active {\n            color: $sidebar-dark-menu-item-active-color !important;\n\n            i {\n                color: $sidebar-dark-menu-item-active-color !important;\n            }\n        }\n    }\n\n    .menu-title {\n        color: var(--#{$prefix}sidebar-dark-menu-item-color);\n    }\n}\n\n\nbody[data-layout=\"horizontal\"] {\n    .main-content {\n        margin-left: 0 !important;\n    }\n}\n\n// Compact Sidebar\n\nbody[data-sidebar-size=\"small\"] {\n    .navbar-brand-box{\n        width: $sidebar-width-sm;\n\n        @media (max-width: 992px) {\n            width: auto;\n        }\n    }\n    .vertical-menu{\n        width: $sidebar-width-sm;\n        text-align: center;\n\n        .has-arrow:after,\n        .badge {\n            display: none !important;\n        }\n    }\n    .main-content {\n        margin-left: $sidebar-width-sm;\n    }\n    .footer {\n        left: $sidebar-width-sm;\n        @media (max-width: 991px){\n            left: 0;\n        }\n    }\n\n    #sidebar-menu {\n        ul li {\n            // &.menu-title{\n            //     background-color: lighten($sidebar-dark-bg, 2%);\n            // }\n            a{\n                i{\n                    display: block;\n                }\n            }\n            ul.sub-menu {\n                li {\n                    a{\n                        padding-left: 1.5rem;\n                    }\n\n                    ul.sub-menu {\n                        li {\n                            a{\n                                padding-left: 1.5rem;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.vertical-collpsed {\n        .main-content {\n            margin-left: $sidebar-collapsed-width;\n        }\n        .vertical-menu {\n            #sidebar-menu{\n                text-align: left;\n                >ul{\n                    >li{\n                        >a {\n                            i{\n                                display: inline-block;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .footer {\n            left: $sidebar-collapsed-width;\n        }\n    }\n}\n\n// Colored Sidebar\n\nbody[data-sidebar=\"colored\"] {\n    .vertical-menu {\n        background: $primary;\n    }\n    .navbar-brand-box{\n        background-color: $primary;\n        .logo-dark{\n            display: none;\n        }\n        .logo-light{\n            display: block;\n        }\n    }\n\n    #sidebar-menu {\n        ul {\n            li {\n                &.menu-title{\n                    color: rgba($white, 0.6);\n                }\n  \n                a{\n                    color: rgba($white, 0.6);\n                    i{\n                        color: rgba($white, 0.6);\n                    }\n                    &.waves-effect {\n                        .waves-ripple {\n                          background: rgba($white, 0.1);\n                        }\n                    }\n                }\n  \n                ul.sub-menu {\n                    li {\n                        a{\n                            color: rgba($white,.5);\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    // Enlarge menu\n    &.vertical-collpsed {\n        .vertical-menu {\n            #sidebar-menu{\n                >ul{\n                    >li{\n                        &:hover>a{\n                            background-color: lighten($primary, 2%);\n                            color: $white;\n                            i{\n                                color: $white;\n                            }\n                        }\n                       \n                    }\n                }\n\n                ul{\n\n                    >li{\n                        >a{\n                            &.mm-active{\n                                color: $sidebar-dark-menu-item-active-color !important;\n                            }\n                        }\n                    }\n\n                    li{\n                        li{\n                            &.mm-active, &.active {\n                               > a{\n                                    color: var(--#{$prefix}sidebar-menu-item-active-color)  !important;\n                                }\n                            }\n\n                            a{\n                                &.mm-active, &.active {\n                                    color: var(--#{$prefix}sidebar-menu-item-active-color)  !important;\n                                }\n\n                                \n                            }\n                        }\n                    }\n                    \n                    \n                }\n            }\n        }\n    }\n    \n    .mm-active {\n        color: $white !important;\n        > a{\n            color: $white !important;\n            i {\n                color: $white !important;\n            }\n        }\n        > i {\n            color: $white !important;\n        }\n        .active {\n            color: $white !important;\n\n            i {\n                color: $white !important;\n            }\n        }\n    }\n\n    .menu-title {\n        color: $white !important;\n    }\n}","// \n// _horizontal.scss\n// \n\n.topnav {\n    background: var(--#{$prefix}topnav-bg);\n    padding: 0 calc(#{$grid-gutter-width} / 2);\n    box-shadow: $box-shadow;\n    margin-top: $header-height;\n    position: fixed;\n    left: 0;\n    right: 0;\n    z-index: 100;\n\n    .topnav-menu {\n        margin: 0;\n        padding: 0;\n    }\n\n    .navbar-nav {\n\n        .nav-link {\n            font-size: 15px;\n            position: relative;\n            padding: 1rem 1.3rem;\n            color: $menu-item-color;\n            font-family: $font-family-secondary;\n\n            i {\n                font-size: 15px;\n                vertical-align: middle;\n                display: inline-block;\n            }\n\n            &:focus,\n            &:hover {\n                color: $menu-item-active-color;\n                background-color: transparent;\n            }\n        }\n\n        .dropdown-item {\n            color: $menu-item-color;\n\n            &.active,\n            &:hover {\n                color: $menu-item-active-color;\n            }\n        }\n\n        .nav-item {\n            .nav-link.active {\n                color: $menu-item-active-color;\n            }\n        }\n\n        .dropdown {\n            &.active {\n                >a {\n                    color: $menu-item-active-color;\n                    background-color: transparent;\n                }\n            }\n        }\n    }\n}\n\n@include media-breakpoint-up(xl) {\n\n    body[data-layout=\"horizontal\"] {\n\n        .container-fluid,\n        .navbar-header {\n            max-width: 85%;\n        }\n    }\n}\n\n@include media-breakpoint-up(lg) {\n    .topnav {\n        .navbar-nav {\n            .nav-item {\n                &:first-of-type {\n                    .nav-link {\n                        padding-left: 0;\n                    }\n                }\n            }\n        }\n\n        .dropdown-item {\n            padding: .5rem 1.5rem;\n            min-width: 180px;\n        }\n\n        .dropdown {\n            &.mega-dropdown {\n\n                // position: static;\n                .mega-dropdown-menu {\n                    left: 0px;\n                    right: auto;\n                }\n            }\n\n            .dropdown-menu {\n                margin-top: 0;\n                border-radius: 0 0 $dropdown-border-radius $dropdown-border-radius;\n\n                .arrow-down {\n                    &::after {\n                        right: 15px;\n                        transform: rotate(-135deg) translateY(-50%);\n                        position: absolute;\n                    }\n                }\n\n                .dropdown {\n                    .dropdown-menu {\n                        position: absolute;\n                        top: 0 !important;\n                        left: 100%;\n                        display: none\n                    }\n                }\n            }\n\n            &:hover {\n                >.dropdown-menu {\n                    display: block;\n                }\n            }\n        }\n\n        .dropdown:hover>.dropdown-menu>.dropdown:hover>.dropdown-menu {\n            display: block\n        }\n    }\n\n    .navbar-toggle {\n        display: none;\n    }\n}\n\n.arrow-down {\n    display: inline-block;\n\n    &:after {\n        border-color: initial;\n        border-style: solid;\n        border-width: 0 0 1px 1px;\n        content: \"\";\n        height: .4em;\n        display: inline-block;\n        right: 5px;\n        top: 50%;\n        margin-left: 10px;\n        transform: rotate(-45deg) translateY(-50%);\n        transform-origin: top;\n        transition: all .3s ease-out;\n        width: .4em;\n    }\n}\n\n\n@include media-breakpoint-down(xl) {\n    .topnav-menu {\n        .navbar-nav {\n            li {\n                &:last-of-type {\n                    .dropdown {\n                        .dropdown-menu {\n                            right: 100%;\n                            left: auto;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@include media-breakpoint-down(lg) {\n\n    .navbar-brand-box {\n        .logo-dark {\n            display: $display-block;\n\n            span.logo-sm {\n                display: $display-block;\n            }\n        }\n\n        .logo-light {\n            display: $display-none;\n        }\n    }\n\n    .topnav {\n        max-height: 360px;\n        overflow-y: auto;\n        padding: 0;\n\n        .navbar-nav {\n            .nav-link {\n                padding: 0.75rem 1.1rem;\n            }\n        }\n\n        .dropdown {\n            .dropdown-menu {\n                background-color: transparent;\n                border: none;\n                box-shadow: none;\n                padding-left: 15px;\n\n                &.dropdown-mega-menu-xl {\n                    width: auto;\n\n                    .row {\n                        margin: 0px;\n                    }\n                }\n            }\n\n            .dropdown-item {\n                position: relative;\n                background-color: transparent;\n\n                &.active,\n                &:active {\n                    color: $primary;\n                }\n            }\n        }\n\n        .arrow-down {\n            &::after {\n                right: 15px;\n                position: absolute;\n            }\n        }\n    }\n}\n\n\n@include media-breakpoint-up(lg) {\n\n    body[data-layout=\"horizontal\"][data-topbar=\"light\"] {\n        .navbar-brand-box {\n            .logo-dark {\n                display: $display-block;\n            }\n\n            .logo-light {\n                display: $display-none;\n            }\n        }\n\n        .topnav {\n            background-color: var(--#{$prefix}header-dark-bg);\n\n            .navbar-nav {\n\n                .nav-link {\n                    color: rgba($white, 0.6);\n\n                    &:focus,\n                    &:hover {\n                        color: rgba($white, 0.9);\n                    }\n                }\n\n                >.dropdown {\n                    &.active {\n                        >a {\n                            color: rgba($white, 0.9) !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n[data-bs-theme=\"dark\"][data-layout=\"horizontal\"][data-topbar=\"light\"] {\n    .navbar-brand-box {\n        .logo-dark {\n            display: $display-none;\n        }\n\n        .logo-light {\n            display: $display-block;\n        }\n    }\n}","// \n// _layouts.scss\n// \n\nbody[data-layout-size=\"boxed\"] {\n    background-color:var(--#{$prefix}boxed-body-bg);\n    #layout-wrapper {\n        background-color: var(--#{$prefix}body-bg);\n        max-width: $boxed-layout-width;\n        margin: 0 auto;\n        box-shadow: $box-shadow;\n    }\n\n    #page-topbar {\n        max-width: $boxed-layout-width;\n        margin: 0 auto;\n    }\n\n    .footer {\n        margin: 0 auto;\n        max-width: calc(#{$boxed-layout-width} - #{$sidebar-width});\n    }\n\n    &.vertical-collpsed {\n        .footer {\n            max-width: calc(#{$boxed-layout-width} - #{$sidebar-collapsed-width});\n        }\n    }\n}\n\n\n// Horizontal Boxed Layout\n\nbody[data-layout=\"horizontal\"][data-layout-size=\"boxed\"]{\n    .topnav{\n        max-width: $boxed-layout-width;\n        margin-left: auto;\n        margin-right: auto;\n    }\n}","\n/*!\n * Waves v0.7.6\n * http://fian.my.id/Waves \n * \n * Copyright 2014-2018 Alfiana E. Sibuea and other contributors \n * Released under the MIT license \n * https://github.com/fians/Waves/blob/master/LICENSE */\n .waves-effect {\n    position: relative;\n    cursor: pointer;\n    display: inline-block;\n    overflow: hidden;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n  }\n  .waves-effect .waves-ripple {\n    position: absolute;\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n    margin-top: -50px;\n    margin-left: -50px;\n    opacity: 0;\n    background: rgba(0, 0, 0, 0.2);\n    background: -webkit-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -o-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -moz-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    -webkit-transition: all 0.5s ease-out;\n    -moz-transition: all 0.5s ease-out;\n    -o-transition: all 0.5s ease-out;\n    transition: all 0.5s ease-out;\n    -webkit-transition-property: -webkit-transform, opacity;\n    -moz-transition-property: -moz-transform, opacity;\n    -o-transition-property: -o-transform, opacity;\n    transition-property: transform, opacity;\n    -webkit-transform: scale(0) translate(0, 0);\n    -moz-transform: scale(0) translate(0, 0);\n    -ms-transform: scale(0) translate(0, 0);\n    -o-transform: scale(0) translate(0, 0);\n    transform: scale(0) translate(0, 0);\n    pointer-events: none;\n  }\n  .waves-effect.waves-light .waves-ripple {\n    background: rgba(255, 255, 255, 0.4);\n    background: -webkit-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -o-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -moz-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n  }\n  .waves-effect.waves-classic .waves-ripple {\n    background: rgba(0, 0, 0, 0.2);\n  }\n  .waves-effect.waves-classic.waves-light .waves-ripple {\n    background: rgba(255, 255, 255, 0.4);\n  }\n  .waves-notransition {\n    -webkit-transition: none !important;\n    -moz-transition: none !important;\n    -o-transition: none !important;\n    transition: none !important;\n  }\n  .waves-button,\n  .waves-circle {\n    -webkit-transform: translateZ(0);\n    -moz-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    -o-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);\n  }\n  .waves-button,\n  .waves-button:hover,\n  .waves-button:visited,\n  .waves-button-input {\n    white-space: nowrap;\n    vertical-align: middle;\n    cursor: pointer;\n    border: none;\n    outline: none;\n    color: inherit;\n    background-color: rgba(0, 0, 0, 0);\n    font-size: 1em;\n    line-height: 1em;\n    text-align: center;\n    text-decoration: none;\n    z-index: 1;\n  }\n  .waves-button {\n    padding: 0.85em 1.1em;\n    border-radius: 0.2em;\n  }\n  .waves-button-input {\n    margin: 0;\n    padding: 0.85em 1.1em;\n  }\n  .waves-input-wrapper {\n    border-radius: 0.2em;\n    vertical-align: bottom;\n  }\n  .waves-input-wrapper.waves-button {\n    padding: 0;\n  }\n  .waves-input-wrapper .waves-button-input {\n    position: relative;\n    top: 0;\n    left: 0;\n    z-index: 1;\n  }\n  .waves-circle {\n    text-align: center;\n    width: 2.5em;\n    height: 2.5em;\n    line-height: 2.5em;\n    border-radius: 50%;\n  }\n  .waves-float {\n    -webkit-mask-image: none;\n    -webkit-box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n    box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n    -webkit-transition: all 300ms;\n    -moz-transition: all 300ms;\n    -o-transition: all 300ms;\n    transition: all 300ms;\n  }\n  .waves-float:active {\n    -webkit-box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\n  }\n  .waves-block {\n    display: block;\n  }\n\n.waves-effect.waves-light {\n    .waves-ripple {\n        background-color: rgba($white, 0.4);\n    }\n}\n\n.waves-effect.waves-primary {\n    .waves-ripple {\n        background-color: rgba($primary, 0.4);\n    }\n}\n.waves-effect.waves-success {\n    .waves-ripple {\n        background-color: rgba($success, 0.4);\n    }\n}\n.waves-effect.waves-info {\n    .waves-ripple {\n        background-color: rgba($info, 0.4);\n    }\n}\n.waves-effect.waves-warning {\n    .waves-ripple {\n        background-color: rgba($warning, 0.4);\n    }\n}\n.waves-effect.waves-danger {\n    .waves-ripple {\n        background-color: rgba($danger, 0.4);\n    }\n}","//\n// avatar.scss\n//\n\n.avatar-xs {\n  height: 2rem;\n  width: 2rem;\n}\n\n.avatar-sm {\n  height: 3rem;\n  width: 3rem;\n}\n\n.avatar-md {\n  height: 4.5rem;\n  width: 4.5rem;\n}\n\n.avatar-lg {\n  height: 6rem;\n  width: 6rem;\n}\n\n.avatar-xl {\n  height: 7.5rem;\n  width: 7.5rem;\n}\n\n.avatar-title {\n  align-items: center;\n  background-color: $primary;\n  color: $white;\n  display: flex;\n  font-weight: $font-weight-medium;\n  height: 100%;\n  justify-content: center;\n  width: 100%;\n}\n\n\n// avatar group\n.avatar-group {\n  padding-left: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  .avatar-group-item {\n    margin-left: -12px;\n    border: 2px solid $card-bg;\n    border-radius: 50%;\n    transition: all 0.2s;\n    &:hover{\n      position: relative;\n      transform: translateY(-2px);\n    }\n  }\n}","\n//\n// accordion.scss\n//\n\n.custom-accordion {\n    .card {\n        + .card {\n            margin-top: 0.5rem;\n        }\n    }\n\n    a {\n        &.collapsed {\n            i.accor-plus-icon {\n                &:before {\n                    content: \"\\F0415\";\n                }\n            }\n        }\n    }\n\n    .card-header{\n        border-radius: 7px;\n    }\n}\n\n.custom-accordion-arrow{\n    .card{\n        border: 1px solid var(--#{$prefix}border-color);\n        box-shadow: none;\n    }\n    .card-header{\n        padding-left: 45px;\n        position: relative;\n\n        .accor-arrow-icon{\n            position: absolute;\n            display: inline-block;\n            width: 24px;\n            height: 24px;\n            line-height: 24px;\n            font-size: 16px;\n            background-color: $primary;\n            color: $white;\n            border-radius: 50%;\n            text-align: center;\n            left: 10px;\n            top: 50%;\n            transform: translateY(-50%);\n        }\n    }\n\n    a {\n        &.collapsed {\n            i.accor-arrow-icon {\n                &:before {\n                    content: \"\\F0142\";\n                }\n            }\n        }\n    }\n}","//\n// _helper.scss\n//\n\n// Font Family\n.font-family-secondary {\n  font-family: $font-family-secondary;\n}\n\n.font-size-10 {\n  font-size: 10px !important;\n}\n\n.font-size-11 {\n  font-size: 11px !important;\n}\n\n.font-size-12 {\n  font-size: 12px !important;\n}\n\n.font-size-13 {\n  font-size: 13px !important;\n}\n\n.font-size-14 {\n  font-size: 14px !important;\n}\n\n.font-size-15 {\n  font-size: 15px !important;\n}\n\n.font-size-16 {\n  font-size: 16px !important;\n}\n\n.font-size-17 {\n  font-size: 17px !important;\n}\n\n.font-size-18 {\n  font-size: 18px !important;\n}\n\n.font-size-20 {\n  font-size: 20px !important;\n}\n\n.font-size-22 {\n  font-size: 22px !important;\n}\n\n.font-size-24 {\n  font-size: 24px !important;\n}\n\n// Social\n\n.social-list-item {\n  height: 2rem;\n  width: 2rem;\n  line-height: calc(2rem - 2px);\n  display: block;\n  border: 1px solid $gray-500;\n  border-radius: 50%;\n  color: $gray-500;\n  text-align: center;\n  transition: all 0.4s;\n\n  &:hover {\n    color: $gray-600;\n    background-color: $gray-200;\n  }\n}\n\n.w-xs {\n  min-width: 80px;\n}\n\n.w-sm {\n  min-width: 95px;\n}\n\n.w-md {\n  min-width: 110px;\n}\n\n.w-lg {\n  min-width: 140px;\n}\n\n.w-xl {\n  min-width: 160px;\n}\n\n// overlay\n\n.bg-overlay {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  top: 0;\n}\n\n// flex-1\n\n.flex-1 {\n  flex: 1;\n}\n\n// alert\n\n.alert-dismissible {\n  .btn-close {\n    font-size: 10px;\n    padding: $alert-padding-y * 1.4 $alert-padding-x;\n    background: transparent escape-svg($btn-close-bg-dark) center /\n      $btn-close-width auto no-repeat;\n  }\n}\n","// \n// preloader.scss\n//\n\n#preloader {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: $card-bg;\n    z-index: 9999;\n}\n\n#status {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translateY(-50%);\n    margin: -20px 0 0 -20px;\n}\n\n.spinner{\n    .spin-icon {\n        font-size: 56px;\n        color: $primary;\n        position: relative;\n        display: inline-block;\n        animation: spin 1.6s infinite linear;\n    }\n}\n\n@keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(359deg);\n    }\n}\n  ","//\n// Forms.scss\n//\n\n\n// checkbox input right\n\n.form-check-right{\n  padding-left: 0;\n  display: inline-block;\n  padding-right: $form-check-padding-start;;\n  .form-check-input{\n    float: right;\n    margin-left: 0;\n    margin-right: $form-check-padding-start * -1;\n  }\n  .form-check-label{\n    display: block;\n  }\n}\n\n.form-check{\n  position: relative;\n  text-align: left /*rtl: right*/;\n}\n\n\n.form-check-label{\n  cursor: pointer;\n  margin-bottom: 0;\n}","// \n// Widgets.scss\n// \n\n\n\n// activity widget\n\n.activity-wid{\n    margin-top: 8px;\n    margin-left: 16px;\n\n    .activity-list{\n        position: relative;\n        padding: 0 0 40px 30px;\n\n        &:before {\n            content: \"\";\n            border-left: 2px dashed rgba($primary,0.25);\n            position: absolute;\n            left: 0;\n            bottom: 0;\n            top: 32px\n        }\n        .activity-icon{\n            position: absolute;\n            left: -15px;\n            top: 0;\n            z-index: 9;\n        }\n\n        &:last-child{\n            padding-bottom: 0px;\n        }\n    }\n}","// \n// _demos.scss\n// \n\n// Demo Only\n.button-items {\n    margin-left: -8px;\n    margin-bottom: -12px;\n    \n    .btn {\n        margin-bottom: 12px;\n        margin-left: 8px;\n    }\n}\n\n// Lightbox \n\n.mfp-popup-form {\n    max-width: 1140px;\n}\n\n// Modals\n\n.bs-example-modal {\n    position: relative;\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n    z-index: 1;\n    display: block;\n  }\n\n\n// Icon demo ( Demo only )\n.icon-demo-content {\n  color: $gray-500;\n\n  i{\n    display: inline-block;\n    width: 40px;\n    height: 40px;\n    line-height: 36px;\n    font-size: 22px;\n    color: $gray-600;\n    border: 2px solid var(--#{$prefix}border-color);\n    border-radius: 4px;\n    transition: all 0.4s;\n    text-align: center;\n    margin-right: 16px;\n    vertical-align: middle;\n  }\n\n  .col-lg-4 {\n    margin-top: 24px;\n\n    &:hover {\n      i {\n        color: $white;\n        background-color: $primary;\n        border-color: $primary;\n      }\n    }\n  }\n}\n\n\n// Grid\n\n.grid-structure {\n    .grid-container {\n        background-color: $gray-100;\n        margin-top: 10px;\n        font-size: .8rem;\n        font-weight: $font-weight-medium;\n        padding: 10px 20px;\n    }\n}\n\n\n// card radio\n\n.card-radio{\n  background-color: $card-bg;\n  border: 2px solid $card-border-color;\n  border-radius: $border-radius;\n  padding: 1rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n\n  &:hover{\n    cursor: pointer;\n  }\n}\n\n.card-radio-label{\n  display: block;\n}\n\n\n.card-radio-input{\n  display: none;\n  &:checked + .card-radio {\n    border-color: $primary !important;\n  }\n}\n\n.navs-carousel{\n  .owl-nav{\n      margin-top: 16px;\n      button{\n          width: 30px;\n          height: 30px;\n          line-height: 28px !important;\n          font-size: 20px !important;\n          border-radius: 50% !important;\n          background-color: rgba($primary, 0.25) !important;\n          color: $primary !important;\n          margin: 4px 8px !important;\n      }\n  }\n}","// \n// print.scss\n//\n\n// Used invoice page\n@media print {\n    .vertical-menu,\n    .right-bar,\n    .page-title-box,\n    .navbar-header,\n    .footer {\n        display: none !important;\n    }\n    .card-body,\n    .main-content,\n    .right-bar,\n    .page-content,\n    body {\n        padding: 0;\n        margin: 0;\n    }\n\n    .card{\n        border: 0;\n    }\n}","[data-simplebar] {\n  position: relative;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: flex-start;\n}\n\n.simplebar-wrapper {\n  overflow: hidden;\n  width: inherit;\n  height: inherit;\n  max-width: inherit;\n  max-height: inherit;\n}\n\n.simplebar-mask {\n  direction: inherit;\n  position: absolute;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: auto !important;\n  height: auto !important;\n  z-index: 0;\n}\n\n.simplebar-offset {\n  direction: inherit !important;\n  box-sizing: inherit !important;\n  resize: none !important;\n  position: absolute;\n  top: 0;\n  left: 0 !important;\n  bottom: 0;\n  right: 0 !important;\n  padding: 0;\n  margin: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.simplebar-content-wrapper {\n  direction: inherit;\n  box-sizing: border-box !important;\n  position: relative;\n  display: block;\n  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\n  width: auto;\n  visibility: visible;\n  overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */\n  max-width: 100%; /* Not required for horizontal scroll to trigger */\n  max-height: 100%; /* Needed for vertical scroll to trigger */\n  scrollbar-width: none;\n  padding: 0px !important;\n}\n\n.simplebar-content-wrapper::-webkit-scrollbar,\n.simplebar-hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.simplebar-content:before,\n.simplebar-content:after {\n  content: ' ';\n  display: table;\n}\n\n.simplebar-placeholder {\n  max-height: 100%;\n  max-width: 100%;\n  width: 100%;\n  pointer-events: none;\n}\n\n.simplebar-height-auto-observer-wrapper {\n  box-sizing: inherit !important;\n  height: 100%;\n  width: 100%;\n  max-width: 1px;\n  position: relative;\n  float: left;\n  max-height: 1px;\n  overflow: hidden;\n  z-index: -1;\n  padding: 0;\n  margin: 0;\n  pointer-events: none;\n  flex-grow: inherit;\n  flex-shrink: 0;\n  flex-basis: 0;\n}\n\n.simplebar-height-auto-observer {\n  box-sizing: inherit;\n  display: block;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 1000%;\n  width: 1000%;\n  min-height: 1px;\n  min-width: 1px;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.simplebar-track {\n  z-index: 1;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-content {\n  pointer-events: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-track {\n  pointer-events: all;\n}\n\n.simplebar-scrollbar {\n  position: absolute;\n  right: 2px;\n  width: 6px;\n  min-height: 10px;\n}\n\n.simplebar-scrollbar:before {\n  position: absolute;\n  content: '';\n  background: #a2adb7;\n  border-radius: 7px;\n  left: 0;\n  right: 0;\n  opacity: 0;\n  transition: opacity 0.2s linear;\n}\n\n.simplebar-scrollbar.simplebar-visible:before {\n  /* When hovered, remove all transitions from drag handle */\n  opacity: 0.5;\n  transition: opacity 0s linear;\n}\n\n.simplebar-track.simplebar-vertical {\n  top: 0;\n  width: 11px;\n}\n\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\n  top: 2px;\n  bottom: 2px;\n}\n\n.simplebar-track.simplebar-horizontal {\n  left: 0;\n  height: 11px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\n  height: 100%;\n  left: 2px;\n  right: 2px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\n  right: auto;\n  left: 0;\n  top: 2px;\n  height: 7px;\n  min-height: 0;\n  min-width: 10px;\n  width: auto;\n}\n\n/* Rtl support */\n[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {\n  right: auto;\n  left: 0;\n}\n\n.hs-dummy-scrollbar-size {\n  direction: rtl;\n  position: fixed;\n  opacity: 0;\n  visibility: hidden;\n  height: 500px;\n  width: 500px;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n\n.simplebar-hide-scrollbar {\n  position: fixed;\n  left: 0;\n  visibility: hidden;\n  overflow-y: scroll;\n  scrollbar-width: none;\n}\n\n.custom-scroll {\n  height: 100%;\n}","// \n// calendar.scss\n//\n\n.fc-toolbar {\n  h2 {\n      font-size: 16px;\n      line-height: 30px;\n      text-transform: uppercase;\n  }\n}\n\n.fc {\n  th.fc-widget-header {\n      background: $light;\n      font-size: 13px;\n      line-height: 20px;\n      padding: 10px 0;\n      text-transform: uppercase;\n      font-weight: $font-weight-semibold;\n  }\n}\n\n.fc-unthemed{\n  .fc-content, \n  .fc-divider, \n  .fc-list-heading td, \n  .fc-list-view, \n  .fc-popover, \n  .fc-row, \n  tbody, \n  td, \n  th, \n  thead{\n      border-color: var(--#{$prefix}border-color);\n  }\n  td.fc-today {\n      background: lighten($gray-200, 4%);\n  }\n}\n\n.fc-button {\n  background: $card-bg;\n  border-color: var(--#{$prefix}border-color);\n  color: $gray-700;\n  text-transform: capitalize;\n  box-shadow: none;\n  padding: 6px 12px !important;\n  height: auto !important;\n}\n\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n  background-color: $primary;\n  color: $white;\n  text-shadow: none;\n}\n\n.fc-event {\n  border-radius: 2px;\n  border: none;\n  cursor: move;\n  font-size: 0.8125rem;\n  margin: 5px 7px;\n  padding: 5px 5px;\n  text-align: center;\n}\n\n#external-events .external-event {\n  text-align: left!important;\n  padding: 8px 16px;\n}\n\n.fc-event, .fc-event-dot{\n  background-color: $primary;\n}\n\n.fc-event .fc-content{\n  color: $white;\n}\n\n.fc {\n  .table-bordered {\n    td, th {\n      border-color:var(--#{$prefix}border-color);\n    }\n  }\n  \n  .fc-toolbar {\n    @media (max-width: 575.98px) {\n      display: block;\n    }\n    \n      h2 {\n          font-size: 16px;\n          line-height: 30px;\n          text-transform: uppercase;\n      }\n\n      @media (max-width: 767.98px) {\n\n          .fc-left,\n          .fc-right,\n          .fc-center {\n              float: none;\n              display: block;\n              text-align: center;\n              clear: both;\n              margin: 10px 0;\n          }\n\n          >*>* {\n              float: none;\n          }\n\n          .fc-today-button {\n              display: none;\n          }\n      }\n      \n      .btn {\n          text-transform: capitalize;\n      }\n\n  }\n}\n.fc-bootstrap .fc-today.alert-info{\n  background-color: var(--#{$prefix}tertiary-bg);\n}\n\n.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark {\n  background-color: $black !important;\n}\n\n// RTL\n[dir=\"rtl\"] .fc-header-toolbar {\n  direction: ltr !important;\n}\n\n[dir=\"rtl\"] .fc-toolbar>*>:not(:first-child) {\n  margin-left: .75em;\n}\n\n\n\n","\n//\n// colorpicker.scss\n//\n\n.sp-container{\n  background-color: $dropdown-bg;\n  button{\n    padding: .25rem .5rem;\n      font-size: .71094rem;\n      border-radius: .2rem;\n      font-weight: 400;\n      color: $dark;\n  \n      &.sp-palette-toggle{\n        background-color: $light;\n      }\n      \n      &.sp-choose{\n        background-color: $success;\n        margin-left: 5px;\n        margin-right: 0;\n      }\n  }\n}\n\n.sp-palette-container{\n  border-right: 1px solid var(--#{$prefix}border-color);\n}\n\n.sp-input{\n  background-color: $input-bg;\n  border-color: $input-border-color !important;\n  color: $input-color;\n  &:focus{\n    outline: none;\n  }\n}\n\n\n[dir=\"rtl\"]{\n\n  .sp-alpha{\n    direction: rtl;\n  }\n\n  .sp-original-input-container {\n    .sp-add-on{\n      border-top-right-radius: 0!important;\n      border-bottom-right-radius: 0!important;\n      border-top-left-radius: 4px!important;\n      border-bottom-left-radius: 4px!important\n    }\n  } \n\n  input.spectrum.with-add-on{\n    border: 1px solid $input-border-color;\n    border-left: 0;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-top-right-radius: $input-border-radius;\n    border-bottom-right-radius: $input-border-radius;\n\n  }\n}","//\n// session-timeout.scss\n//\n\n#session-timeout-dialog {\n    .close {\n        display: none;\n    }\n\n    .countdown-holder {\n        color: $danger;\n        font-weight: $font-weight-medium;\n    }\n\n    .btn-default {\n        background-color: $white;\n        color: $danger;\n        box-shadow: none;\n    }\n}","\n//\n// Round slider\n//\n\n.rs-control{\n  margin: 0px auto;\n}\n\n.rs-path-color{\n  background-color: $gray-300;\n}\n\n.rs-bg-color{\n  background-color: var(--#{$prefix}body-bg) !important;\n}\n\n.rs-border{\n  border-color: transparent;\n}\n\n.rs-handle{\n  background-color: $gray-700;\n}\n\n.rs-circle-border{\n  .rs-border{\n    border: 8px solid $gray-300;\n  }\n}\n\n.rs-disabled{\n  opacity: 1;\n}\n\n// Outer border\n\n.outer-border {\n  .rs-border{\n    border-width: 0px;\n    &.rs-outer  {\n      border: 14px solid $gray-300;\n  }\n  }\n  .rs-handle{\n    margin-left: 0 !important;\n  }\n  .rs-path-color{\n    background-color: transparent;\n  }\n}\n\n// Outer border dot\n\n.outer-border-dot {\n  .rs-border.rs-outer  {\n    border: 16px dotted;\n  }\n  .rs-handle{\n    margin-left: 0 !important;\n  }\n}\n\n@each $color,\n$value in $theme-colors {\n    .rs-range-#{$color} {\n        .rs-range-color{\n          background-color: $value;\n        }\n\n        .rs-handle-dot{\n          background-color: lighten(($value), 24%);\n          border-color: $value;\n          &:after{\n            background-color: $value;\n          }\n        }\n\n        &.rs-circle-border{\n          .rs-handle{\n            background-color: $value;\n          }\n        }\n\n        &.outer-border-dot {\n          .rs-border.rs-outer  {\n            border-color: lighten(($value), 24%);\n          }\n        }\n    }\n}\n\n// rs-handle-arrow\n\n.rs-handle-arrow{\n    .rs-handle  {\n      background-color: transparent;\n      border: 8px solid transparent;\n      border-right-color:$gray-700;\n      margin: -6px 0px 0px 14px !important;\n      border-width: 6px 104px 6px 4px;\n      &:before  {\n        display: block;\n        content: \" \";\n        position: absolute;\n        height: 22px;\n        width: 22px;\n        background:$gray-700;\n        right: -11px;\n        bottom: -11px;\n        border-radius: 100px;\n    }\n  }\n  \n}\n\n.rs-handle-arrow-dash{\n  .rs-handle  {\n    background-color: transparent;\n    border: 8px solid transparent;\n    border-right-color: $gray-700;\n    margin: -8px 0 0 14px !important;\n    &:before  {\n      display: block;\n      content: \" \";\n      position: absolute;\n      height: 12px;\n      width: 12px;\n      background: $gray-700;\n      right: -6px;\n      bottom: -6px;\n      border-radius: 100%;\n  }\n  &:after{\n    display: block;\n    content: \" \";\n    width: 80px;\n    position: absolute;\n    top: -1px;\n    right: 0px;\n    border-top: 2px dotted $gray-700\n  }\n}\n\n}","//\n// Range slider\n//\n\n.irs {\n    font-family: $font-family-base;\n}\n\n.irs--round {\n\n    .irs-bar,\n    .irs-to,\n    .irs-from,\n    .irs-single {\n        background: $primary !important;\n        font-size: 11px;\n    }\n\n    .irs-to,\n    .irs-from,\n    .irs-single {\n        &:before {\n            display: none;\n        }\n    }\n\n    .irs-line {\n        background: var(--#{$prefix}tertiary-bg);\n        border-color: var(--#{$prefix}border-color);\n    }\n\n    .irs-grid-text {\n        font-size: 11px;\n        color: $gray-500;\n    }\n\n    .irs-min,\n    .irs-max {\n        color: $gray-500;\n        background: var(--#{$prefix}tertiary-bg);\n        font-size: 11px;\n    }\n\n    .irs-handle {\n        border: 2px solid $primary;\n        width: 16px;\n        height: 16px;\n        top: 29px;\n        background-color: $card-bg !important;\n    }\n}","\n//\n//  Sweetalert2\n//\n\n.swal2-container {\n  .swal2-title{\n    font-size: 24px;\n    font-weight: $font-weight-medium;\n  }  \n}\n\n.swal2-content{\n  font-size: 16px;\n}\n\n.swal2-icon{\n  &.swal2-question{\n    border-color: $info;\n    color: $info;\n  }\n  &.swal2-success {\n    [class^=swal2-success-line]{\n      background-color: $success;\n    }\n\n    .swal2-success-ring{\n      border-color: rgba($success, 0.3);\n    }\n  }\n  &.swal2-warning{\n    border-color: $warning;\n    color: $warning;\n  }\n}\n\n.swal2-styled{\n  &:focus{\n    box-shadow: none;\n  }\n}\n\n.swal2-progress-steps {\n  .swal2-progress-step{\n    background: $primary;\n    &.swal2-active-progress-step{\n      background: $primary;\n      &~.swal2-progress-step, &~.swal2-progress-step-line{\n        background: rgba($primary, 0.3);\n      }\n    }\n  }\n\n  .swal2-progress-step-line{\n    background: $primary;\n  }\n}\n\n.swal2-loader{\n  border-color: $primary transparent $primary transparent;\n}\n\n.swal2-modal{\n  background-color: var(--#{$prefix}secondary-bg) !important;\n  color: var(--#{$prefix}body-color) !important;\n}\n.swal2-content{\n  background-color: var(--#{$prefix}secondary-bg) !important;\n    color: var(--#{$prefix}secondary-color) !important;\n}\n\n\n.swal2-title{\n  color: var(--#{$prefix}secondary-color) !important;\n}","\n//\n// Rating\n//\n\n.symbol{\n  border-color: $card-bg;\n}\n\n.rating-symbol-background, .rating-symbol-foreground {\n  font-size: 24px;\n}\n\n.rating-symbol-foreground {\n  top: 0px;\n}\n\n.rating-star{\n  > span{\n    display: inline-block;\n    vertical-align: middle;\n\n    &.badge{\n      margin-left: 4px;\n    }\n  }\n}","\n//\n// toastr.scss\n//\n\n\n/* =============\n   Notification\n============= */\n#toast-container {\n    > div {\n        box-shadow: $box-shadow;\n        opacity: 1;\n        &:hover {\n            box-shadow: $box-shadow;\n            opacity: 0.9;\n        }\n    }\n\n    &.toast-top-full-width, &.toast-bottom-full-width{\n        > div{\n          min-width: 96%;\n          margin: 4px auto;\n        }\n      }\n\n}\n\n\n@each $color, $value in $theme-colors {\n    .toast-#{$color} {\n        border: 2px solid $value !important;\n        background-color: rgba(($value), 0.8) !important;\n    }\n}\n\n\n// for error\n\n.toast-error {\n    background-color: rgba($danger,0.8);\n    border: 2px solid $danger;\n}\n\n.toastr-options{\n    padding: 24px;\n    background-color: var(--#{$prefix}tertiary-bg);\n    margin-bottom: 0;\n    border: 1px solid var(--#{$prefix}border-color);\n}","\n//\n// Parsley\n//\n\n.error {\n  color: $danger;\n}\n\n.parsley-error {\n  border-color: $danger;\n}\n\n.parsley-errors-list {\n  display: none;\n  margin: 0;\n  padding: 0;\n  &.filled {\n    display: block;\n  }\n  > li {\n    font-size: 12px;\n    list-style: none;\n    color: $danger;\n    margin-top: 5px;\n  }\n}","\n//\n// Select 2\n//\n\n.select2-container {\n  display: block;\n  .select2-selection--single {\n    background-color: $input-bg;\n    border: 1px solid $input-border-color;\n    height: 38px;\n    &:focus{\n      outline: none;\n    }\n\n    .select2-selection__rendered {\n      line-height: 36px;\n      padding-left: 12px;\n      color: $input-color;\n    }\n\n    .select2-selection__arrow {\n      height: 34px;\n      width: 34px;\n      right: 3px;\n\n      b{\n        border-color: $gray-500 transparent transparent transparent;\n        border-width: 6px 6px 0 6px;\n      }\n    }\n\n    .select2-selection__placeholder{\n      color: var(--#{$prefix}body-color);\n    }\n  }\n}\n\n.select2-container--open {\n  .select2-selection--single {\n\n    .select2-selection__arrow {\n\n      b{\n        border-color: transparent transparent $gray-500 transparent !important;\n        border-width: 0 6px 6px 6px !important;\n      }\n    }\n  }\n}\n\n.select2-container--default {\n  .select2-search--dropdown {\n      padding: 10px;\n      background-color: $dropdown-bg;\n      .select2-search__field {\n          border: 1px solid  $input-border-color;\n          background-color: $input-bg;\n          color: $gray-600;\n          outline: none;\n      }\n  }\n  .select2-results__option--highlighted[aria-selected] {\n      background-color: $primary;\n  }\n  .select2-results__option[aria-selected=true] {\n      background-color: $dropdown-link-active-bg;\n      color: $dropdown-link-active-color;\n      &:hover {\n          background-color: $primary;\n          color: $white;\n      }\n  }\n}\n\n.select2-results__option {\n  padding: 6px 12px;\n}\n\n.select2-dropdown {\n  border: 1px solid $dropdown-border-color;\n  background-color: $dropdown-bg;\n  box-shadow: $box-shadow;\n}\n\n.select2-search {\n  input{\n    border: 1px solid var(--#{$prefix}border-color);\n  }\n}\n\n.select2-container {\n  .select2-selection--multiple {\n    min-height: 38px;\n    background-color: $input-bg;\n    border: 1px solid $input-border-color !important;\n  \n    .select2-selection__rendered {\n      padding: 2px 10px;\n    }\n    .select2-search__field {\n      border: 0;\n      color: $input-color;\n      &::placeholder{\n          color: $input-color;\n      }\n  }\n    .select2-selection__choice {\n      background-color: var(--#{$prefix}tertiary-bg);\n      border: 1px solid var(--#{$prefix}border-color);\n      border-radius: 1px;\n      padding: 0 7px;\n    }\n  }\n}\n\n.select2-container--default{\n  &.select2-container--focus {\n    .select2-selection--multiple{\n      border-color: var(--#{$prefix}border-color);\n    }\n  }\n\n  .select2-results__group{\n    font-weight: $font-weight-semibold;\n  }\n}\n\n// ajax select\n\n.select2-result-repository__avatar{\n    float: left;\n    width: 60px;\n    margin-right: 10px;\n  img{\n    width: 100%;\n    height: auto;\n    border-radius: 2px;\n  }\n}\n\n.select2-result-repository__statistics{\n  margin-top: 7px;\n}\n\n.select2-result-repository__forks, \n.select2-result-repository__stargazers, \n.select2-result-repository__watchers{\n  display: inline-block;\n  font-size: 11px;\n  margin-right: 1em;\n  color: $gray-500;\n\n  .fa{\n    margin-right: 4px;\n\n    &.fa-flash{\n      &::before{\n        content: \"\\f0e7\";\n        font-family: 'Font Awesome 5 Free';\n      }\n    }\n  }\n}\n\n.select2-results__option--highlighted{\n  .select2-result-repository__forks, \n.select2-result-repository__stargazers, \n.select2-result-repository__watchers{\n  color: rgba($white, 0.8);\n}\n}\n\n.select2-result-repository__meta{\n  overflow: hidden;\n}\n\n\n// templating-select\n\n.img-flag{\n  margin-right: 7px;\n  height: 15px;\n  width: 18px;\n}\n\n\n","//\n//  Sweetalert2\n//\n\n/* CSS Switch */\ninput[switch] {\n  display: none;\n  + label {\n    font-size: 1em;\n    line-height: 1;\n    width: 56px;\n    height: 24px;\n    background-color: $gray-400;\n    background-image: none;\n    border-radius: 2rem;\n    padding: 0.16667rem;\n    cursor: pointer;\n    display: inline-block;\n    text-align: center;\n    position: relative;\n    font-weight: $font-weight-medium;\n    transition: all 0.1s ease-in-out;\n    &:before {\n      color: $dark;\n      content: attr(data-off-label);\n      display: block;\n      font-family: inherit;\n      font-weight: 500;\n      font-size: 12px;\n      line-height: 21px;\n      position: absolute;\n      right: 1px;\n      margin: 3px;\n      top: -2px;\n      text-align: center;\n      min-width: 1.66667rem;\n      overflow: hidden;\n      transition: all 0.1s ease-in-out;\n    }\n\n    &:after {\n      content: '';\n      position: absolute;\n      left: 3px;\n      background-color: $gray-200;\n      box-shadow: none;\n      border-radius: 2rem;\n      height: 20px;\n      width: 20px;\n      top: 2px;\n      transition: all 0.1s ease-in-out;\n    }\n  }\n\n  &:checked + label {\n    background-color: $primary;\n  }\n}\n\ninput[switch]:checked + label {\n  background-color: $primary;\n  &:before {\n    color: $white;\n    content: attr(data-on-label);\n    right: auto;\n    left: 3px;\n  }\n\n  &:after {\n    left: 33px;\n    background-color: $gray-200;\n  }\n}\n\ninput[switch=\"bool\"] + label {\n  background-color: $danger;\n}\ninput[switch=\"bool\"] + label:before,input[switch=\"bool\"]:checked + label:before,\ninput[switch=\"default\"]:checked + label:before{\n  color: $white;\n}\n\ninput[switch=\"bool\"]:checked + label {\n  background-color: $success;\n}\n\ninput[switch=\"default\"]:checked + label {\n  background-color: #a2a2a2;\n}\n\ninput[switch=\"primary\"]:checked + label {\n  background-color: $primary;\n}\n\ninput[switch=\"success\"]:checked + label {\n  background-color: $success;\n}\n\ninput[switch=\"info\"]:checked + label {\n  background-color: $info;\n}\n\ninput[switch=\"warning\"]:checked + label {\n  background-color: $warning;\n}\n\ninput[switch=\"danger\"]:checked + label {\n  background-color: $danger;\n}\n\ninput[switch=\"dark\"]:checked + label {\n  background-color: $dark;\n}\n\n.square-switch{\n  margin-right: 7px;\n  input[switch]+label, input[switch]+label:after{\n    border-radius: 4px;\n  }\n}","\n//\n// Datepicker\n//\n\n.datepicker {\n  border: 1px solid $gray-100;\n  padding: 8px;\n  z-index: 999 !important;\n  table{\n    tr{\n      th{\n        font-weight: 500;\n      }\n      td{\n        &.active, &.active:hover, .active.disabled, &.active.disabled:hover,\n        &.today,  &.today:hover, &.today.disabled, &.today.disabled:hover, \n        &.selected, &.selected:hover, &.selected.disabled, &.selected.disabled:hover{\n          background-color: $primary !important;\n          background-image: none;\n          box-shadow: none;\n          color: $white !important;\n        }\n\n        &.day.focused,\n        &.day:hover,\n        span.focused,\n        span:hover {\n            background: $gray-200;\n        }\n\n        &.new,\n        &.old,\n        span.new,\n        span.old {\n            color: $gray-500;\n            opacity: 0.6;\n        }\n\n        &.range, &.range.disabled, &.range.disabled:hover, &.range:hover{\n            background-color: $gray-300;\n        }\n      }\n    }\n  }\n}\n\n.table-condensed{\n  >thead>tr>th, >tbody>tr>td {\n    padding: 7px;\n  }\n}","\n//\n// Bootstrap touchspin\n//\n\n\n.bootstrap-touchspin{\n    &.input-group{\n      &>.input-group-prepend{\n        &>.btn, &>.input-group-text{\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n        }\n      }\n    }\n  \n    &.input-group{\n      &>.input-group-append{\n        &>.btn, &>.input-group-text{\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        }\n      }\n    }\n  }","//\n// datatable.scss\n\n\n.dataTables_wrapper {\n  &.container-fluid {\n    padding: 0;\n  }\n}\n\ndiv.dataTables_wrapper {\n  div.dataTables_filter {\n    text-align: right;\n\n    @media (max-width: 767px) {\n      text-align: center;\n    }\n\n\n    input {\n      margin-left: 0.5em;\n      margin-right: 0;\n    }\n  }\n}\n\n.datatable {\n  td {\n    &:focus {\n      outline: none;\n    }\n  }\n}\n\ndiv.table-responsive>div.dataTables_wrapper>div.row>div[class^=\"col-\"] {\n  &:first-child {\n    padding-left: 0;\n  }\n\n  &:last-child {\n    padding-right: 0;\n  }\n}\n\n\ntable.dataTable {\n  border-collapse: collapse !important;\n  margin-bottom: 15px !important;\n\n  // Change icons view\n  thead {\n\n    .sorting,\n    .sorting_asc,\n    .sorting_desc,\n    .sorting_asc_disabled,\n    .sorting_desc_disabled {\n      &:before {\n        left: auto;\n        right: 0.5rem;\n        content: \"\\F0360\";\n        font-family: \"Material Design Icons\";\n        font-size: 1rem;\n        top: 9px;\n\n\n      }\n\n      &:after {\n        left: auto;\n        right: 0.5em;\n        content: \"\\F035D\";\n        font-family: \"Material Design Icons\";\n        top: 15px;\n        font-size: 1rem;\n      }\n    }\n\n    tr {\n\n      th,\n      td {\n\n        &.sorting_asc,\n        &.sorting_desc,\n        &.sorting {\n          padding-left: 12px;\n          padding-right: 30px;\n        }\n      }\n    }\n  }\n\n  tbody {\n    // Multi select table\n\n    > tr.selected, >tr>.selected {\n        background-color: rgba($primary,.2);\n        \n        td {\n            border-color: rgba($primary,.2);\n            color: $primary;\n        }\n    }\n    td {\n        &:focus {\n            outline: none !important;\n        }\n    }\n    // Key Tables\n    th.focus,td.focus{\n        outline: 2px solid $primary !important;\n        outline-offset: -1px;\n        background-color: rgba($primary, 0.15);\n    }\n}\n}\n\n.dataTables_info {\n  font-weight: $font-weight-semibold;\n}\n\n\n// Responsive data table\ntable.dataTable.dtr-inline.collapsed {\n  >tbody {\n    >tr[role=row] {\n\n      >td,\n      >th {\n        &:first-child {\n          &:before {\n            box-shadow: $box-shadow-lg;\n            background-color: $success;\n            bottom: auto;\n          }\n        }\n      }\n    }\n\n    >tr.parent {\n\n      >td,\n      >th {\n        &:first-child {\n          &:before {\n            background-color: $danger;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Data Table copy button\ndiv.dt-button-info {\n  background-color: $primary;\n  border: none;\n  color: $white;\n  box-shadow: none;\n  border-radius: 3px;\n  text-align: center;\n  z-index: 21;\n\n  h2 {\n    border-bottom: none;\n    background-color: rgba($white, 0.2);\n    color: $white;\n  }\n}\n\n@include media-breakpoint-down(md) {\n\n  li.paginate_button.previous,\n  li.paginate_button.next {\n    display: inline-block;\n    font-size: 1.5rem;\n  }\n\n  li.paginate_button {\n    display: none;\n  }\n\n  .dataTables_paginate {\n    ul {\n      text-align: center;\n      display: block;\n      margin: $spacer 0 0 !important;\n    }\n  }\n\n  div.dt-buttons {\n    display: inline-table;\n    margin-bottom: $spacer;\n  }\n}\n\n// Active status\n.activate-select {\n  .sorting_1 {\n    background-color: $gray-100;\n  }\n}\n\n\n\n// datatable\n\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n}\n\n\n\n.table,\ntable {\n  &.dataTable {\n    &.dtr-inline.collapsed>tbody>tr>td {\n      position: relative;\n\n      &.dtr-control {\n        padding-left: 30px;\n\n        &:before {\n          top: 64%;\n          left: 5px;\n          height: 14px;\n          width: 14px;\n          margin-top: -14px;\n          display: block;\n          position: absolute;\n          color: $white;\n          border: 2px solid $white;\n          border-radius: 14px;\n          box-sizing: content-box;\n          text-align: center;\n          text-indent: 0 !important;\n          line-height: 12px;\n          content: '+';\n          background-color: $primary;\n        }\n      }\n    }\n  }\n}","//\n// Form editors.scss\n//\n\n// Tinymce\n\n.tox-tinymce {\n    border: 2px solid var(--#{$prefix}border-color) !important;\n}\n\n.tox {\n    .tox-statusbar {\n        border-top: 1px solid var(--#{$prefix}border-color) !important;\n    }\n\n    .tox-menubar,\n    .tox-edit-area__iframe,\n    .tox-statusbar {\n        background-color: var(--#{$prefix}secondary-bg) !important;\n        background: none !important;\n    }\n\n    .tox-mbtn {\n        color: var(--#{$prefix}body-color) !important;\n\n        &:hover:not(:disabled):not(.tox-mbtn--active) {\n            background-color: var(--#{$prefix}tertiary-bg) !important;\n        }\n    }\n\n    .tox-tbtn {\n        &:hover {\n            background-color: var(--#{$prefix}tertiary-bg) !important;\n        }\n    }\n\n    .tox-toolbar__primary {\n        border-color: var(--#{$prefix}border-color) !important;\n    }\n\n    .tox-toolbar,\n    .tox-toolbar__overflow,\n    .tox-toolbar__primary {\n        background: var(--#{$prefix}tertiary-bg) !important;\n    }\n\n    .tox-tbtn {\n        color: var(--#{$prefix}body-color) !important;\n\n        svg {\n            fill: var(--#{$prefix}body-color) !important;\n        }\n    }\n\n    .tox-statusbar a,\n    .tox-statusbar__path-item,\n    .tox-statusbar__wordcount {\n        color: var(--#{$prefix}body-color) !important;\n    }\n\n    &:not([dir=\"rtl\"]) .tox-toolbar__group:not(:last-of-type) {\n        border-right: 1px solid var(--#{$prefix}border-color) !important;\n    }\n}\n.tox-tinymce-aux {\n    z-index: 1050 !important;\n}\n\n.tox .tox-toolbar-overlord {\n    background-color: var(--#{$prefix}tertiary-bg) !important;\n}\n","\n//\n// Form-Upload\n//\n\n/* Dropzone */\n.dropzone {\n  min-height: 230px;\n  border: 2px dashed var(--#{$prefix}border-color);\n  background: $card-bg;\n  border-radius: 6px;\n\n  .dz-message {\n    font-size: 24px;\n    width: 100%;\n  }\n}\n\n.sp-colorize-container{\n  border: none !important;\n}","//\n// Form Wizard\n//\n\n// twitter-bs-wizard\n\n.twitter-bs-wizard {\n\n    .twitter-bs-wizard-nav {\n        position: relative;\n\n        &:before {\n            content: \"\";\n            width: 100%;\n            height: 2px;\n            background-color:var(--#{$prefix}border-color);\n            position: absolute;\n            left: 0;\n            top: 26px;\n        }\n\n        .step-number {\n            display: inline-block;\n            width: 38px;\n            height: 38px;\n            line-height: 34px;\n            border: 2px solid $primary;\n            color: $primary;\n            text-align: center;\n            border-radius: 50%;\n            position: relative;\n            background-color: $card-bg;\n\n            @media (max-width: 991.98px) {\n                display: block;\n                margin: 0 auto 8px !important;\n            }\n        }\n\n        .nav-link {\n            .step-title {\n                display: block;\n                margin-top: 8px;\n                font-weight: $font-weight-bold;\n\n                @media (max-width: 575.98px) {\n                    display: none;\n                }\n            }\n\n            &.active {\n                background-color: transparent;\n                color: var(--#{$prefix}body-color);\n\n                .step-number {\n                    background-color: $primary;\n                    color: $white;\n                }\n            }\n        }\n    }\n\n    .twitter-bs-wizard-pager-link {\n        padding-top: 24px;\n        padding-left: 0;\n        list-style: none;\n        margin-bottom: 0;\n\n        li {\n            display: inline-block;\n\n            a {\n                display: inline-block;\n                padding: .47rem .75rem;\n                background-color: $primary;\n                color: $white;\n                border-radius: .25rem;\n            }\n\n            &.disabled {\n                a {\n                    cursor: not-allowed;\n                    background-color: lighten($primary, 8%);\n                }\n            }\n\n            &.next {\n                float: right;\n            }\n        }\n    }\n}\n\n.twitter-bs-wizard-tab-content {\n    padding-top: 24px;\n    min-height: 262px;\n}","\n//\n// Responsive Table\n//\n\n.table-rep-plugin {\n  .btn-toolbar {\n    display: block;\n  }\n  .table-responsive {\n    border: none !important;\n  }\n  .btn-group{\n    .btn-default {\n      background-color: $light;\n      color: $dark;\n      border: 1px solid darken($light, 2%);\n      &.btn-primary {\n          background-color: $primary;\n          border-color: $primary;\n          color: $white;\n      }\n  }\n    &.pull-right {\n      float: right;\n      .dropdown-menu {\n        right: 0;\n        transform: none !important;\n        top: 100% !important;\n      }\n    }\n  }\n  tbody {\n    th {\n      font-size: 14px;\n      font-weight: normal;\n    }\n  }\n\n  .checkbox-row {\n    padding-left: 40px;\n    color: $dropdown-color !important;\n\n    &:hover{\n      background-color: lighten($gray-200, 2%) !important;\n    }\n\n    label {\n      display: inline-block;\n      padding-left: 5px;\n      position: relative;\n      &::before {\n        -o-transition: 0.3s ease-in-out;\n        -webkit-transition: 0.3s ease-in-out;\n        background-color: $white;\n        border-radius: 3px;\n        border: 1px solid $gray-300;\n        content: \"\";\n        display: inline-block;\n        height: 17px;\n        left: 0;\n        margin-left: -20px;\n        position: absolute;\n        transition: 0.3s ease-in-out;\n        width: 17px;\n        outline: none !important;\n      }\n      &::after {\n        color: $gray-200;\n        display: inline-block;\n        font-size: 11px;\n        height: 16px;\n        left: 0;\n        margin-left: -20px;\n        padding-left: 3px;\n        padding-top: 1px;\n        position: absolute;\n        top: -1px;\n        width: 16px;\n      }\n    }\n    input[type=\"checkbox\"] {\n      cursor: pointer;\n      opacity: 0;\n      z-index: 1;\n      outline: none !important;\n\n      &:disabled + label {\n        opacity: 0.65;\n      }\n    }\n    input[type=\"checkbox\"]:focus + label {\n      &::before {\n        outline-offset: -2px;\n        outline: none;\n      }\n    }\n    input[type=\"checkbox\"]:checked + label {\n      &::after {\n        content: \"\\f00c\";\n        font-family: 'Font Awesome 5 Free';\n        font-weight: 900;\n      }\n    }\n    input[type=\"checkbox\"]:disabled + label {\n      &::before {\n        background-color: $gray-100;\n        cursor: not-allowed;\n      }\n    }\n    input[type=\"checkbox\"]:checked + label {\n      &::before {\n        background-color: $primary;\n        border-color: $primary;\n      }\n      &::after {\n        color: $white;\n      }\n    }\n  }\n\n  .fixed-solution {\n    .sticky-table-header{\n      top: $header-height !important;\n      background-color: $primary;\n      table{\n        color: $white;\n      }\n    }\n  }\n}\n\nbody[data-layout=\"horizontal\"] {\n  @media (min-width: 992px) {\n    .fixed-solution {\n      .sticky-table-header{\n        top: $header-height + 50px !important;;\n      }\n    }\n  }\n}","//\n// _ckeditor.scss\n//\n\n.ck {\n    font-family: $font-family-base !important;\n\n    &.ck-reset_all, &.ck-reset_all *{\n        color: var(--#{$prefix}body-color) !important;\n    }\n    &.ck-toolbar{\n        background: var(--#{$prefix}secondary-bg)!important;\n    }\n\n    p {\n        margin-bottom: 0;\n    }\n\n    &.ck-toolbar {\n        border: 1px solid $input-border-color !important;\n\n        &.ck-toolbar_grouping>.ck-toolbar__items {\n            flex-wrap: wrap !important;\n        }\n\n        .ck.ck-toolbar__separator {\n            background: transparent !important;\n        }\n    }\n\n    &.ck-editor__main>.ck-editor__editable {\n        border-top: 0 !important;\n        background-color: var(--#{$prefix}secondary-bg) !important;\n        border-color: $input-border-color !important;\n        box-shadow: none !important;\n    }\n\n    &.ck-dropdown__panel{\n        background: var(--#{$prefix}secondary-bg) !important;\n        box-shadow: $box-shadow-lg;\n        animation-name: DropDownSlide;\n        animation-duration: .3s;\n        animation-fill-mode: both;\n        border-radius: $dropdown-border-radius;\n    }\n\n    &.ck-list {\n        background: var(--#{$prefix}secondary-bg) !important;\n    }\n\n    &.ck-dropdown {\n        .ck-dropdown__panel {\n            &.ck-dropdown__panel_ne,\n            &.ck-dropdown__panel_se {\n                left: 0;\n                right: auto !important;\n            }\n        }\n    }\n\n    &.ck-editor__editable_inline {\n        &[dir=ltr] {\n            text-align: left !important;\n        }\n    }\n\n    &.ck-dropdown__panel {\n        box-shadow: $dropdown-box-shadow !important;\n        border-radius: $dropdown-border-radius !important;\n        border: 1px solid $dropdown-border-color !important;\n    }\n}\n\n.ck.ck-button, \na.ck.ck-button{\n\n    &:focus, &:active{\n        box-shadow: none !important;\n        border: 1px solid var(--#{$prefix}light) !important;\n    }\n\n    &:not(.ck-disabled){\n        &:hover{\n            background: var(--#{$prefix}light) !important;\n        }\n    }\n\n    &.ck-on{\n        background: var(--#{$prefix}light) !important;\n    }\n}\n\n.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar, \n.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{\n    border-radius: $border-radius !important;\n    border-bottom-left-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n}\n\n.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, \n.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{\n    border-radius: $border-radius !important;\n    border-top-left-radius: 0 !important;\n    border-top-right-radius: 0 !important;\n}\n\n.ck-editor__editable {\n    min-height: 245px !important;\n}\n\n.ck[class*=ck-heading_heading] {\n    font-weight: $font-weight-medium !important;\n}\n\n.ck,\na.ck {\n    &.ck-button {\n        &.ck-on:not(.ck-disabled) {\n            &:hover,\n            &:active {\n                box-shadow: none !important;\n            }\n        }\n    }\n}\n\n.ck{\n    &.ck-tooltip{\n        .ck-tooltip__text {\n            background: $dark !important;\n            color: $light !important;\n        }\n    }\n\n    &.ck-input-text{\n        background: $input-bg !important;\n        border: 1px solid $input-border-color !important;\n        &:focus{\n            border: 1px solid $input-focus-border-color !important;\n            box-shadow: none !important;\n        }\n    }\n\n    &.ck-balloon-panel{\n        background: $dropdown-bg !important;\n        border: 1px solid $dropdown-border-color !important;\n\n        &[class*=arrow_n]{\n            &:after{\n                border-bottom-color: $dropdown-bg !important;\n            }\n\n            &::before{\n                border-bottom-color: $dropdown-border-color !important;\n            }\n        }\n    }\n}\n\n\n\n.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{\n    background: $dropdown-bg !important;\n}\n\n// ck-editor-reverse\n\n.ck-editor-reverse{\n    .ck-editor{\n      display: flex;\n      flex-direction: column-reverse;\n    }\n  \n    .ck{\n      &.ck-editor__main>.ck-editor__editable{\n        border: 1px solid $input-border-color !important;\n        border-bottom: 0 !important;\n      }\n    }\n  \n    .ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, \n    .ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{\n      border-radius: $border-radius !important;\n      border-bottom-left-radius: 0 !important;\n      border-bottom-right-radius: 0 !important;\n    }\n  \n    .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar, \n    .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{\n      border-radius: $border-radius !important;\n      border-top-left-radius: 0 !important;\n      border-top-right-radius: 0 !important;\n    }\n}\n\n[dir=\"rtl\"] {\n    .ck.ck-toolbar>.ck-toolbar__items {\n        flex-direction: row-reverse;\n    }\n}\n\n","\n//\n// Table editable\n//\n\n.table-edits{\n  input, select{\n    height: $input-height-sm;\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    border: 1px solid $input-border-color;\n    background-color: $input-bg;\n    color: $input-color;\n    border-radius: $input-border-radius;\n    &:focus{\n      outline: none;\n      border-color: $input-focus-border-color;\n    }\n  }\n}","\n//\n// apexcharts.scss\n//\n.apex-charts {\n    min-height: 10px !important;\n    text {\n        font-family: $font-family-base !important;\n        fill: $gray-500;\n    }\n    .apexcharts-canvas {\n        margin: 0 auto;\n    }\n}\n\n.apexcharts-tooltip{\n    background-color: var(--#{$prefix}card-bg) !important;\n    border: 1px solid var(--#{$prefix}border-color) !important;\n}\n.apexcharts-tooltip-title{\n    background-color: var(--#{$prefix}body-bg) !important;\n    border-bottom: 1px solid var(--#{$prefix}border-color) !important;\n}\n.apexcharts-tooltip-title,\n.apexcharts-tooltip-text {\n    font-family: $font-family-base !important;\n}\n\n.apexcharts-legend-series {\n    font-weight: $font-weight-medium;\n}\n\n.apexcharts-gridline {\n    pointer-events: none;\n    stroke: $apex-grid-color;\n}\n\n.apexcharts-legend-text {\n    color: $gray-600 !important;\n    font-family: $font-family-base !important;\n    font-size: 13px !important;\n}\n\n.apexcharts-pie-label {\n    fill: $white !important;\n}\n\n.apexcharts-yaxis,\n.apexcharts-xaxis {\n    text {\n        font-family: $font-family-base !important;\n        fill: $gray-500;\n    }\n}\n\n.apexcharts-grid-row{\n    stroke: var(--#{$prefix}border-color) !important;\n}\n\n.apexcharts-gridline{\n    stroke: var(--#{$prefix}border-color) !important;\n}","\n\n/* Flot chart */\n.flot-charts-height {\n  height: 320px;\n}\n\n.flotTip {\n  padding: 8px 12px;\n  background-color: rgba($dark, 0.9);\n  z-index: 100;\n  color: $gray-100;\n  box-shadow: $box-shadow;\n  border-radius: 4px;\n}\n\n.legendLabel{\n  color: $gray-500;\n}","//\n// sparkline.scss\n//\n\n.jqstooltip {\n  box-sizing: content-box;\n  width: auto !important;\n  height: auto !important;\n  background-color: $gray-800 !important;\n  box-shadow: $box-shadow-lg;\n  padding: 5px 10px !important;\n  border-radius: 3px;\n  border-color: $gray-900 !important;\n}\n\n.jqsfield {\n  color: $gray-200 !important;\n  font-size: 12px !important;\n  line-height: 18px !important;\n  font-family: $font-family-base !important;\n  font-weight: $font-weight-medium !important;\n}\n","\n//\n// Google map\n//\n\n.gmaps, .gmaps-panaroma {\n  height: 300px;\n  background: $gray-100;\n  border-radius: 3px;\n}\n\n.gmaps-overlay {\n  display: block;\n  text-align: center;\n  color: $white;\n  font-size: 16px;\n  line-height: 40px;\n  background: $primary;\n  border-radius: 4px;\n  padding: 10px 20px;\n}\n\n.gmaps-overlay_arrow {\n  left: 50%;\n  margin-left: -16px;\n  width: 0;\n  height: 0;\n  position: absolute;\n  &.above {\n    bottom: -15px;\n    border-left: 16px solid transparent;\n    border-right: 16px solid transparent;\n    border-top: 16px solid $primary;\n  }\n  &.below {\n    top: -15px;\n    border-left: 16px solid transparent;\n    border-right: 16px solid transparent;\n    border-bottom: 16px solid $primary;\n  }\n  \n}","//\n// vector-maps.scss\n//\n\n.jvectormap-label {\n    border: none;\n    background: $gray-800;\n    color: $gray-100;\n    font-family: $font-family-base;\n    font-size: $font-size-base;\n    padding: 5px 8px;\n}","//\n// x editable.scss\n//\n\n.editable-input{\n    .form-control{\n      display: inline-block;\n    }\n  }\n  \n  .editable-buttons{\n    margin-left: 7px;\n    .editable-cancel{\n      margin-left: 7px;\n    }\n  }","//\n// authentication.scss\n//\n\n.auth-body-bg {\n  background-color: $card-bg;\n}\n\n.authentication-bg {\n  background-image: url(\"../../../images/LoginPageVector.svg\");\n  height: 100%;\n  width: 100%;\n  padding-top: 64%;\n  background-size: contain;\n  background-repeat: no-repeat;\n\n  background-position: 50% 50%;\n  .bg-overlay {\n    //background-color: #292626;\n  }\n\n  @media (max-width: 991px) {\n    display: none;\n  }\n}\n\n.authentication-page-content {\n  height: 100vh;\n  display: flex;\n}\n\n.auth-form-group-custom {\n  position: relative;\n  .form-control {\n    height: 60px;\n    padding-top: 28px;\n    padding-left: 60px;\n  }\n\n  label {\n    position: absolute;\n    top: 7px;\n    left: 60px;\n  }\n\n  .auti-custom-input-icon {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 19px;\n    font-size: 24px;\n    color: $primary;\n  }\n}\n\n.auth-logo {\n  &.logo-light {\n    display: $display-none;\n  }\n  &.logo-dark {\n    display: $display-block;\n  }\n}\n\n[data-bs-theme=\"dark\"] {\n  .authentication-logo {\n    .logo-light {\n      display: block;\n    }\n    .logo-dark {\n      display: none;\n    }\n  }\n}\n","// \n// ecommerce.scss\n//\n\n// product\n\n.search-box{\n    .form-control{\n        border-radius: 30px;\n        padding-left: 40px;\n    }\n    .search-icon{\n        font-size: 16px;    \n        position: absolute;\n        left: 13px;\n        top: 0;\n        line-height: 38px;\n    }\n}\n\n\n.ecommerce {\n\n    .accordion-item {\n        border-bottom: 1px solid var(--#{$prefix}border-color);\n\n\n        .accordion-collapse {\n            border: 0;\n        }\n    }\n\n    button {\n        border: 0;\n        display: block;\n        color: var(--#{$prefix}body-color);\n        font-weight: $font-weight-medium;\n        padding: 8px 16px;\n\n        \n    }\n\n\n    button[data-bs-toggle=collapse].collapsed::after {\n        content: '\\F0415';\n    }\n\n    button[data-bs-toggle=collapse]::after {\n        content: '\\F0374';\n        display: block;\n        font-family: 'Material Design Icons';\n        font-size: 16px;\n        position: absolute;\n        right: 20px;\n        font-weight: $font-weight-medium;\n        top: 50%;\n        background-image: none;\n        transform: translateY(-50%);\n    }\n\n    .accordion-body {\n        padding: 8px 0;\n        border: 0;\n\n        li {\n            a {\n                display: block;\n                padding: 4px 16px;\n                color: var(--#{$prefix}body-color);\n            }\n\n            &.active {\n                a {\n                    color: $primary;\n                }\n            }\n        }\n    }\n\n}\n\n\n// Product Details\n\n.product-detai-imgs{\n    .nav{\n        .nav-link{\n            margin: 7px 0px;\n\n            &.active{\n                background-color: var(--#{$prefix}tertiary-bg);\n            }\n        }\n    }\n}\n\n.product-color{\n    a{\n        display: inline-block;\n        text-align: center;\n        color: var(--#{$prefix}body-color);\n\n        .product-color-item{\n            margin: 7px;\n            border: 2px solid var(--#{$prefix}border-color);\n            border-radius: 4px;\n        }\n        &.active, &:hover{\n            color: $primary;\n            .product-color-item{\n                border-color: $primary !important;\n            }\n        }\n    }\n}\n\n.ecommerce-sortby-list{\n    li{\n        color: var(--#{$prefix}body-color);\n        a{\n            color: var(--#{$prefix}body-color);\n            padding: 4px;\n        }\n\n        &.active{\n            a{\n                color: $primary;\n            }\n        }\n    }\n}\n\n.product-box{\n    padding: 24px;\n    border: 1px solid var(--#{$prefix}border-color);\n    transition: all 0.4s;\n    \n    &:hover{\n        box-shadow: $box-shadow;\n    }\n}\n\n.product-img{\n    position: relative;\n    \n    .product-ribbon{\n        position: absolute;\n        top: 0;\n        left: -24px;\n        padding: 6px 8px;\n        border-radius: 0px 30px 30px 0px;\n    }\n\n    .product-like{\n        position: absolute;\n        top: 0;\n        right: 0;\n        a{\n            display: inline-block;\n            width: 40px;\n            height: 40px;\n            border: 2px solid var(--#{$prefix}border-color);\n            line-height: 38px;\n            border-radius: 50%;\n            text-align: center;\n            color: $gray-500;\n        }\n    }\n}\n\n.product-detail{\n    .nav-pills{\n        .nav-link{\n            margin-bottom: 7px;\n            &.active{\n                background-color: var(--#{$prefix}tertiary-bg);\n            }\n\n\n            .tab-img{\n                width: 5rem;\n            }\n        }\n    }\n\n    .product-img{\n        border: 1px solid var(--#{$prefix}border-color);\n        padding: 24px;\n    }\n}\n\n.product-desc-list{\n    li{\n        padding: 4px 0px;\n    }\n}\n\n.product-review-link{\n    .list-inline-item{\n        a{\n            color: $gray-600;\n        }\n        &:not(:last-child){\n            margin-right: 14px;\n        }\n    }           \n}\n\n// ecommerce cart\n\n.product-cart-touchspin{\n    border: 1px solid var(--#{$prefix}border-color);\n    background-color: $input-bg;\n    border-radius: $border-radius;\n    .form-control{\n        border-color: transparent;\n        height: 32px\n    }\n    \n    .input-group-btn .btn{\n        background-color: transparent !important;\n        border-color: transparent !important;\n        color: $primary !important;\n        font-size: 16px;\n        padding: 3px 12px;\n        box-shadow: none;\n    }\n\n}\n\n// ecommerce checkout\n\n.shipping-address{\n    box-shadow: none;\n    &.active{\n        border-color: $primary !important;\n    }\n}","/* ==============\n  Email\n===================*/\n.email-leftbar {\n  width: 236px;\n  float: left;\n  padding: 20px;\n  border-radius: 5px;\n}\n\n.email-rightbar {\n  margin-left: 260px;\n}\n\n.chat-user-box {\n  p.user-title {\n    color: var(--#{$prefix}body-color);\n    font-weight: 600;\n  }\n  p {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 767px) {\n  .email-leftbar {\n    float: none;\n    width: 100%;\n  }\n  .email-rightbar {\n    margin: 0;\n  }\n}\n\n\n.mail-list {\n  a {\n    display: block;\n    color: $gray-600;\n    line-height: 24px;\n    padding: 8px 5px;\n    &.active {\n      color: $danger;\n      font-weight: 500;\n    }\n  }\n}\n\n.message-list {\n  display: block;\n  padding-left: 0;\n\n  li {\n    position: relative;\n    display: block;\n    height: 50px;\n    line-height: 50px;\n    cursor: default;\n    transition-duration: .3s;\n\n    a{\n      color: $gray-600;\n    }\n\n    &:hover {\n      background: var(--#{$prefix}tertiary-bg);\n      transition-duration: .05s;\n    }\n\n    .col-mail {\n      float: left;\n      position: relative;\n    }\n\n    .col-mail-1 {\n      width: 320px;\n\n      .star-toggle,\n      .checkbox-wrapper-mail,\n      .dot {\n        display: block;\n        float: left;\n      }\n\n      .dot {\n        border: 4px solid transparent;\n        border-radius: 100px;\n        margin: 22px 26px 0;\n        height: 0;\n        width: 0;\n        line-height: 0;\n        font-size: 0;\n      }\n\n      .checkbox-wrapper-mail {\n        margin: 15px 10px 0 20px;\n      }\n\n      .star-toggle {\n        margin-top: 18px;\n        margin-left: 5px;\n      }\n\n      .title {\n        position: absolute;\n        top: 0;\n        left: 110px;\n        right: 0;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n        margin-bottom: 0;\n      }\n    }\n\n    .col-mail-2 {\n      position: absolute;\n      top: 0;\n      left: 320px;\n      right: 0;\n      bottom: 0;\n\n      .subject,\n      .date {\n        position: absolute;\n        top: 0;\n      }\n\n      .subject {\n        left: 0;\n        right: 200px;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n      }\n\n      .date {\n        right: 0;\n        width: 170px;\n        padding-left: 80px;\n      }\n    }\n\n    &.active,\n    &.active:hover {\n      box-shadow: inset 3px 0 0 $primary;\n    }\n\n    \n  &.unread  {\n    background-color: var(--#{$prefix}tertiary-bg);\n    font-weight: 500;\n    color: var(--#{$prefix}body-color);\n      a{\n        color:var(--#{$prefix}body-color);\n        font-weight: 500;\n      }\n    }\n  }\n\n\n  .checkbox-wrapper-mail {\n    cursor: pointer;\n    height: 20px;\n    width: 20px;\n    position: relative;\n    display: inline-block;\n    box-shadow: inset 0 0 0 1px $gray-400;\n    border-radius: 1px;\n\n    input {\n      opacity: 0;\n      cursor: pointer;\n    }\n    input:checked ~ label {\n      opacity: 1;\n    }\n\n    label {\n      position: absolute;\n      height: 20px;\n      width: 20px;\n      left: 0;\n      cursor: pointer;\n      opacity: 0;\n      margin-bottom: 0;\n      transition-duration: .05s;\n      top: 0;\n      &:before {\n        content: \"\\F012C\";\n        font-family: \"Material Design Icons\";\n        top: 0;\n        height: 20px;\n        color: darken($dark,5%);\n        width: 20px;\n        position: absolute;\n        margin-top: -16px;\n        left: 4px;\n        font-size: 13px;\n      }\n    }\n  }\n}\n\n@media (max-width: 575.98px) { \n  .message-list li .col-mail-1 {\n      width: 200px;\n  }\n}","// \n// Chat.scss\n//\n\n.chat-leftsidebar {\n    background-color: $card-bg;\n    border-radius: $border-radius 0 0 $border-radius;\n    box-shadow: $box-shadow;\n\n    @media (min-width: 992px) {\n        min-width: 360px;\n    }\n\n\n    .chat-leftsidebar-nav {\n        .nav {\n            background-color: var(--#{$prefix}tertiary-bg);\n\n            .nav-link {\n                &.active {\n                    background-color: $card-bg;\n                    color: $primary;\n                }\n            }\n        }\n\n    }\n}\n\n.chat-noti-dropdown {\n    &.active {\n        &:before {\n            content: \"\";\n            position: absolute;\n            width: 8px;\n            height: 8px;\n            background-color: $danger;\n            border-radius: 50%;\n            right: 0;\n        }\n    }\n\n    .btn {\n        padding: 0px;\n        box-shadow: none;\n        font-size: 16px;\n    }\n}\n\n.chat-search-box {\n    .form-control {\n        border: 0;\n    }\n}\n\n.chat-list {\n    margin: 0;\n\n    li {\n        &.active {\n            a {\n                background-color: var(--#{$prefix}tertiary-bg);\n            }\n        }\n\n        a {\n            display: block;\n            padding: 14px 16px;\n            color: $gray-600;\n            transition: all 0.4s;\n            border-top: 1px solid var(--#{$prefix}border-color);\n            border-radius: 4px;\n\n            &:hover {\n                background-color: rgba(var(--#{$prefix}tertiary-bg), 0.7);\n            }\n        }\n\n        .user-img {\n            position: relative;\n\n            .user-status {\n                width: 10px;\n                height: 10px;\n                background-color: $gray-500;\n                border-radius: 50%;\n                border: 2px solid var(--#{$prefix}border-color);\n                position: absolute;\n                right: 0;\n                bottom: 0;\n\n\n            }\n\n            &.online {\n                .user-status {\n                    background-color: $success;\n                }\n            }\n\n            &.away {\n                .user-status {\n                    background-color: $warning;\n                }\n            }\n        }\n    }\n}\n\n.user-chat {\n    background-color: $card-bg;\n    box-shadow: $box-shadow;\n    .user-chat-border {\n        border-bottom: 1px solid var(--#{$prefix}border-color);\n    }\n}\n\n.user-chat-nav {\n    .dropdown {\n        .nav-btn {\n            height: 36px;\n            width: 36px;\n            line-height: 36px;\n            box-shadow: none;\n            padding: 0;\n            font-size: 20px;\n            border-radius: 50%;\n        }\n\n        .dropdown-menu {\n            box-shadow: $box-shadow;\n            border: 1px solid var(--#{$prefix}border-color);\n        }\n    }\n}\n\n\n.chat-conversation {\n    li {\n        clear: both;\n    }\n\n    .chat-avatar {\n        float: left;\n        margin-right: 8px;\n\n        img {\n            width: 36px;\n            height: 36px;\n            border-radius: 50%;\n        }\n    }\n\n    .chat-day-title {\n        position: relative;\n        text-align: center;\n        margin-bottom: 24px;\n        margin-top: 12px;\n\n        .title {\n            background-color: var(--#{$prefix}tertiary-bg);\n            position: relative;\n            z-index: 1;\n            padding: 3px 16px;\n            border-radius: 30px;\n        }\n\n        &:before {\n            content: \"\";\n            position: absolute;\n            width: 100%;\n            height: 1px;\n            left: 0;\n            right: 0;\n            background-color: var(--#{$prefix}border-color);\n            top: 10px;\n        }\n\n        .badge {\n            font-size: 12px;\n        }\n    }\n\n    .conversation-list {\n        margin-bottom: 24px;\n        display: inline-block;\n        position: relative;\n\n        .ctext-wrap {\n            overflow: hidden;\n\n            .conversation-name {\n                font-weight: $font-weight-semibold;\n                margin-bottom: 7px;\n            }\n        }\n\n        .ctext-wrap-content {\n            padding: 12px 16px;\n            background-color: $primary;\n            border-radius: $border-radius;\n            color: $white;\n        }\n\n        .chat-time {\n            margin-top: 7px;\n            font-size: 12px;\n            text-align: right;\n        }\n    }\n\n    .right {\n        .conversation-list {\n            float: right;\n\n            .conversation-name {\n                text-align: right;\n            }\n\n            .ctext-wrap-content {\n                background-color: var(--#{$prefix}tertiary-bg);\n                text-align: right;\n                color: $gray-600;\n            }\n\n            .chat-time {\n                text-align: left;\n            }\n\n        }\n\n    }\n\n}\n\n.chat-input-section {\n    background-color: $card-bg;\n    border-radius: $border-radius;\n}\n\n.chat-input {\n    background-color: var(--#{$prefix}tertiary-bg) !important;\n    border-color: var(--#{$prefix}border-color) !important;\n}\n\n.chat-input-links {\n    position: absolute;\n    left: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n\n    li {\n        a {\n            font-size: 16px;\n            line-height: 36px;\n            padding: 0px 4px;\n            display: inline-block;\n        }\n    }\n}\n\n.chat-send {\n    @media (max-width: 575.98px) {\n        min-width: auto;\n    }\n}","// \n// Task.scss\n//\n\n.task-box{\n  border: 1px solid var(--#{$prefix}border-color);\n  box-shadow: none;\n\n  .team{\n    .team-member{\n      margin-right: 6px;\n    }\n  }\n}\n\n.gu-transit {\n    border: 1px dashed var(--#{$prefix}border-color) !important;\n    background-color: $gray-200 !important;\n}\n","// \n// coming-soon.scss\n//\n\n.counter-number {\n    font-size: 24px;\n    font-weight: $font-weight-bold;\n    font-family: $font-family-secondary;\n    text-align: center;\n    display: flex;\n    span {\n        font-size: 14px;\n        font-weight: $font-weight-normal;\n        display: block;\n        padding-top: 5px;\n    }\n}\n\n.coming-box {\n    width: 25%;\n}\n\n.comingsoon-bg{\n    background-image: url(\"../../../images/comingsoon-bg.jpg\");\n}","// \n// timeline.scss\n//\n/************** vertical timeline **************/ \n\n.timeline{\n    position: relative;\n    margin-bottom: 30px;\n    &:before {\n        content: \"\";\n        position: absolute;\n        width: 3px;\n        top: 30px;\n        left: 0;\n        bottom: 0;\n        background-color: var(--#{$prefix}tertiary-bg);\n    }\n\n    .timeline-item{\n        display: flex;\n    }\n\n    .timeline-block{\n        width: 100%;\n    }\n\n    .time-show-btn{\n        margin-bottom: 30px;\n    }\n\n    .timeline-box{\n        margin: 20px 0;\n        position: relative;\n        margin-left: 45px;\n    }\n\n    .timeline-date{\n        display: inline-block;\n        padding: 4px 16px 4px 8px;\n        border-radius: 0px 30px 30px 0px;\n        background-color: $primary;\n        color: $white;\n        position: relative;\n        left: -30px;\n        \n        .circle-dot{\n            margin-right: 8px;\n        }\n    }\n\n    .timeline-icon {\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        background: $card-bg;\n        border-radius: 50%;\n        display: block;\n        border: 2px solid $primary;\n        left: -48px;\n        text-align: center;\n        top: 27px;\n        z-index: 9;\n        &:before {\n            content: \"\";\n            position: absolute;\n            height: 3px;\n            width: 20px;\n            background-color: var(--#{$prefix}tertiary-bg);\n            left: 12px;\n            top: 3px;\n        }\n    }\n\n    .timeline-album {\n        margin-top: 16px;\n        a {\n            display: inline-block;\n            margin-right: 5px;\n        }\n        img {\n            height: 40px;\n            width: auto;\n            border-radius: 4px;\n        }\n    }\n\n}\n\n@media (min-width: 768px) {\n\n    .timeline{\n\n        .timeline-block{\n            width: 50%;\n        }\n\n        &:before {\n            left: 50%;\n        }\n        .time-show-btn{\n            position: relative;\n            left: 67px;\n            text-align: right;\n        }\n    }\n\n    .timeline-item{\n        &::before {\n            content: \"\";\n            display: block;\n            width: 50%;\n        }\n\n        &.timeline-left{\n            text-align: right;\n            &::after {\n                content: \"\";\n                display: block;\n                width: 50%;\n            }\n\n            &::before {\n                display: none;\n            }\n        }\n\n        &.timeline-left{\n            .timeline-box{\n                margin-left: 0;\n                margin-right: 45px;\n            }\n\n            .timeline-date {\n                padding: 4px 8px 4px 16px;\n                border-radius: 30px 0px 0px 30px;\n                left: auto;\n                right: -30px;\n            \n                .circle-dot{\n                    float: right;\n                    margin-right: 0px;\n                    margin-left: 8px;\n                }\n            }\n\n            .timeline-icon{\n                left: auto;\n                right: -52px;\n                &::before{\n                    left: auto;\n                    right: 12px;\n                }\n            }\n\n        }\n    }\n}\n\n\n.left-timeline{\n    &::before{\n        left: 3px;\n    }\n    .timeline-item::before{\n        display: none;\n    }\n\n    .timeline-block{\n        width: 100%;\n    }\n\n    .timeline-icon{\n        left: -45px;\n    }\n}","// \n// Extras pages.scss\n//\n\n\n// pricing\n\n.pricing-nav-tabs{\n    display: inline-block;\n    background-color: $card-bg;\n    box-shadow: $box-shadow;\n    padding: 4px;\n    border-radius: 7px;\n    li{\n        display: inline-block;\n    }\n}\n\n\n.pricing-box{\n    .plan-features{\n        li{\n            padding: 7px 0px;\n        }\n    }\n}\n\n/*********************\n    Faqs\n**********************/ \n\n.faq-nav-tabs{\n    .nav-item{\n        margin: 0px 8px;\n    }\n    .nav-link{\n        text-align: center;\n        margin-bottom: 8px;\n        border: 2px solid var(--#{$prefix}border-color);\n        color: var(--#{$prefix}body-color);\n        .nav-icon{\n            font-size: 40px;\n            margin-bottom: 8px;\n            display: block;\n        }\n\n        &.active{\n            border-color: $primary;\n            background-color: transparent;\n            color: var(--#{$prefix}body-color);\n\n            .nav-icon{\n                color: $primary;\n            }\n        }\n    }\n}\n\n.text-error{\n    font-size: 120px;\n    @media (max-width: 575.98px) {\n        font-size: 86px;\n    }\n}\n\n.error-text{\n    color: $danger;\n    position: relative;\n\n    .error-img{\n        position: absolute;\n        width: 120px;\n        left: -15px;\n        right: 0;\n        bottom: 47px;\n\n        @media (max-width: 575.98px) {\n            width: 86px;\n            left: -12px;\n            bottom: 38px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
